webpackJsonp([3],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(3110);
	
	__webpack_require__(3436);
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import 'mapbox-gl/dist/mapbox-gl.css';
	
	module.exports = _angular2.default.module('market', [__webpack_require__(3073), __webpack_require__(2528), __webpack_require__(3439), __webpack_require__(977), __webpack_require__(642), __webpack_require__(3440), __webpack_require__(3441), __webpack_require__(3526), __webpack_require__(3528), __webpack_require__(3531), __webpack_require__(3540), __webpack_require__(3542), __webpack_require__(3552), __webpack_require__(3622)]).run(["$rootScope", "$state", "Session", "ngMeta", function ($rootScope, $state, Session, ngMeta) {
	  $rootScope.session = Session.info();
	
	  $rootScope.$on('$locationChangeSuccess', function () {
	    var location = window.location;
	
	    var adjustedPathname = {
	      '/homepage': '/'
	    }[location.pathname] || location.pathname;
	
	    // handles /homes/:slug/buy/contact
	    if ((0, _lodash.includes)(adjustedPathname, '/buy/contact')) {
	      adjustedPathname = adjustedPathname.replace('/buy/contact', '');
	    }
	
	    // page URL without query params, reasonable default
	    var href = location.protocol + '//' + location.host + adjustedPathname;
	
	    var canonicalTag = document.getElementById('canonical');
	    if (!canonicalTag) {
	      canonicalTag = document.createElement('link');
	      canonicalTag.rel = 'canonical';
	      canonicalTag.id = 'canonical';
	      document.getElementsByTagName('head')[0].appendChild(canonicalTag);
	    }
	    canonicalTag.href = href;
	  });
	  $rootScope.$on('$stateChangeError', function (e, to, toParams, from, fromParams, error) {
	    // without handling an error here, we render a blank page with no information for the user.
	    // instead, redirect to the 404 page if the homes slug is not found or else render the 500 page.
	    if (error && error.status === 404) {
	      window.location.href = '/404';
	    } else {
	      window.location.href = '/500';
	    }
	  });
	  $rootScope.$on('$stateChangeStart', function (evt, to, params) {
	    // use replaceState instead of pushState when redirecting
	    if (to.redirectTo) {
	      evt.preventDefault();
	      $state.go(to.redirectTo, params, { location: 'replace' });
	    }
	  });
	  ngMeta.init();
	}]).name;

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */
/***/ function(module, exports) {

	module.exports = function escape(url) {
	    if (typeof url !== 'string') {
	        return url
	    }
	    // If url is already wrapped in quotes, remove them
	    if (/^['"].*['"]$/.test(url)) {
	        url = url.slice(1, -1);
	    }
	    // Should url be wrapped?
	    // See https://drafts.csswg.org/css-values-3/#urls
	    if (/["'() \t\n]/.test(url)) {
	        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
	    }
	
	    return url
	}


/***/ },
/* 252 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function(useSourceMap) {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			return this.map(function (item) {
				var content = cssWithMappingToString(item, useSourceMap);
				if(item[2]) {
					return "@media " + item[2] + "{" + content + "}";
				} else {
					return content;
				}
			}).join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};
	
	function cssWithMappingToString(item, useSourceMap) {
		var content = item[1] || '';
		var cssMapping = item[3];
		if (!cssMapping) {
			return content;
		}
	
		if (useSourceMap && typeof btoa === 'function') {
			var sourceMapping = toComment(cssMapping);
			var sourceURLs = cssMapping.sources.map(function (source) {
				return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
			});
	
			return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
		}
	
		return [content].join('\n');
	}
	
	// Adapted from convert-source-map (MIT)
	function toComment(sourceMap) {
		// eslint-disable-next-line no-undef
		var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
		var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
	
		return '/*# ' + data + ' */';
	}


/***/ },
/* 253 */,
/* 254 */,
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@charset \"UTF-8\";\n\n/*!\n * Pikaday\n * Copyright © 2014 David Bushell | BSD & MIT license | http://dbushell.com/\n */\n\n.pika-single {\n    z-index: 9999;\n    display: block;\n    position: relative;\n    color: #333;\n    background: #fff;\n    border: 1px solid #ccc;\n    border-bottom-color: #bbb;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n/*\nclear child float (pika-lendar), using the famous micro clearfix hack\nhttp://nicolasgallagher.com/micro-clearfix-hack/\n*/\n.pika-single:before,\n.pika-single:after {\n    content: \" \";\n    display: table;\n}\n.pika-single:after { clear: both }\n.pika-single { *zoom: 1 }\n\n.pika-single.is-hidden {\n    display: none;\n}\n\n.pika-single.is-bound {\n    position: absolute;\n    box-shadow: 0 5px 15px -5px rgba(0,0,0,.5);\n}\n\n.pika-lendar {\n    float: left;\n    width: 240px;\n    margin: 8px;\n}\n\n.pika-title {\n    position: relative;\n    text-align: center;\n}\n\n.pika-label {\n    display: inline-block;\n    *display: inline;\n    position: relative;\n    z-index: 9999;\n    overflow: hidden;\n    margin: 0;\n    padding: 5px 3px;\n    font-size: 14px;\n    line-height: 20px;\n    font-weight: bold;\n    background-color: #fff;\n}\n.pika-title select {\n    cursor: pointer;\n    position: absolute;\n    z-index: 9998;\n    margin: 0;\n    left: 0;\n    top: 5px;\n    filter: alpha(opacity=0);\n    opacity: 0;\n}\n\n.pika-prev,\n.pika-next {\n    display: block;\n    cursor: pointer;\n    position: relative;\n    outline: none;\n    border: 0;\n    padding: 0;\n    width: 20px;\n    height: 30px;\n    color: rgba(0, 0, 0, 0);\n    white-space: nowrap;\n    overflow: hidden;\n    background-color: transparent;\n    background-position: center center;\n    background-repeat: no-repeat;\n    background-size: 75% 75%;\n    opacity: .5;\n    *position: absolute;\n    *top: 0;\n}\n\n.pika-prev:hover,\n.pika-next:hover {\n    opacity: 1;\n}\n\n.pika-prev,\n.is-rtl .pika-next {\n    float: left;\n    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAUklEQVR42u3VMQoAIBADQf8Pgj+OD9hG2CtONJB2ymQkKe0HbwAP0xucDiQWARITIDEBEnMgMQ8S8+AqBIl6kKgHiXqQqAeJepBo/z38J/U0uAHlaBkBl9I4GwAAAABJRU5ErkJggg==');\n    *left: 0;\n}\n\n.pika-next,\n.is-rtl .pika-prev {\n    float: right;\n    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAU0lEQVR42u3VOwoAMAgE0dwfAnNjU26bYkBCFGwfiL9VVWoO+BJ4Gf3gtsEKKoFBNTCoCAYVwaAiGNQGMUHMkjGbgjk2mIONuXo0nC8XnCf1JXgArVIZAQh5TKYAAAAASUVORK5CYII=');\n    *right: 0;\n}\n\n.pika-prev.is-disabled,\n.pika-next.is-disabled {\n    cursor: default;\n    opacity: .2;\n}\n\n.pika-select {\n    display: inline-block;\n    *display: inline;\n}\n\n.pika-table {\n    width: 100%;\n    border-collapse: collapse;\n    border-spacing: 0;\n    border: 0;\n}\n\n.pika-table th,\n.pika-table td {\n    width: 14.285714285714286%;\n    padding: 0;\n}\n\n.pika-table th {\n    color: #999;\n    font-size: 12px;\n    line-height: 25px;\n    font-weight: bold;\n    text-align: center;\n}\n\n.pika-button {\n    cursor: pointer;\n    display: block;\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    outline: none;\n    border: 0;\n    margin: 0;\n    width: 100%;\n    padding: 5px;\n    color: #666;\n    font-size: 12px;\n    line-height: 15px;\n    text-align: right;\n    background: #f5f5f5;\n}\n\n.pika-week {\n    font-size: 11px;\n    color: #999;\n}\n\n.is-today .pika-button {\n    color: #33aaff;\n    font-weight: bold;\n}\n\n.is-selected .pika-button {\n    color: #fff;\n    font-weight: bold;\n    background: #33aaff;\n    box-shadow: inset 0 1px 3px #178fe5;\n    border-radius: 3px;\n}\n\n.is-inrange .pika-button {\n    background: #D5E9F7;\n}\n\n.is-startrange .pika-button {\n    color: #fff;\n    background: #6CB31D;\n    box-shadow: none;\n    border-radius: 3px;\n}\n\n.is-endrange .pika-button {\n    color: #fff;\n    background: #33aaff;\n    box-shadow: none;\n    border-radius: 3px;\n}\n\n.is-disabled .pika-button,\n.is-outside-current-month .pika-button {\n    pointer-events: none;\n    cursor: default;\n    color: #999;\n    opacity: .3;\n}\n\n.pika-button:hover {\n    color: #fff;\n    background: #ff8000;\n    box-shadow: none;\n    border-radius: 3px;\n}\n\n/* styling for abbr */\n.pika-table abbr {\n    border-bottom: none;\n    cursor: help;\n}\n\n.pika-time-container {\n    clear: both;\n}\n\n.pika-time {\n    margin: 7px auto 7px;\n}\n\n.pika-time .pika-time-label {\n    font-weight: bold;\n    font-size: 11px;\n    color: #666;\n    padding-right: 0.33em;\n}\n", ""]);
	
	// exports


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "input[type=range]{width:300px}ul[rn-carousel]{overflow:hidden;padding:0;white-space:nowrap;position:relative;-webkit-perspective:1000px;-ms-perspective:1000px;perspective:1000px;-ms-touch-action:pan-y;touch-action:pan-y}ul[rn-carousel]>li{color:#000;-webkit-backface-visibility:hidden;-ms-backface-visibility:hidden;backface-visibility:hidden;overflow:visible;vertical-align:top;position:absolute;left:0;right:0;white-space:normal;padding:0;margin:0;list-style-type:none;width:100%;height:100%;display:inline-block}ul[rn-carousel-buffered]>li{display:none}ul[rn-carousel-transition=hexagon]{overflow:visible}div.rn-carousel-indicator span{cursor:pointer;color:#666}div.rn-carousel-indicator span.active{color:#fff}.rn-carousel-control{-webkit-transition:opacity .2s ease-out;transition:opacity .2s ease-out;font-size:2rem;position:absolute;top:40%;opacity:.75;cursor:pointer}.rn-carousel-control:hover{opacity:1}.rn-carousel-control.rn-carousel-control-prev{left:.5em}.rn-carousel-control.rn-carousel-control-prev:before{content:\"<\"}.rn-carousel-control.rn-carousel-control-next{right:.5em}.rn-carousel-control.rn-carousel-control-next:before{content:\">\"}", ""]);
	
	// exports


/***/ },
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Merge two attribute objects giving precedence
	 * to values in object `b`. Classes are special-cased
	 * allowing for arrays and merging/joining appropriately
	 * resulting in a string.
	 *
	 * @param {Object} a
	 * @param {Object} b
	 * @return {Object} a
	 * @api private
	 */
	
	exports.merge = function merge(a, b) {
	  if (arguments.length === 1) {
	    var attrs = a[0];
	    for (var i = 1; i < a.length; i++) {
	      attrs = merge(attrs, a[i]);
	    }
	    return attrs;
	  }
	  var ac = a['class'];
	  var bc = b['class'];
	
	  if (ac || bc) {
	    ac = ac || [];
	    bc = bc || [];
	    if (!Array.isArray(ac)) ac = [ac];
	    if (!Array.isArray(bc)) bc = [bc];
	    a['class'] = ac.concat(bc).filter(nulls);
	  }
	
	  for (var key in b) {
	    if (key != 'class') {
	      a[key] = b[key];
	    }
	  }
	
	  return a;
	};
	
	/**
	 * Filter null `val`s.
	 *
	 * @param {*} val
	 * @return {Boolean}
	 * @api private
	 */
	
	function nulls(val) {
	  return val != null && val !== '';
	}
	
	/**
	 * join array as classes.
	 *
	 * @param {*} val
	 * @return {String}
	 */
	exports.joinClasses = joinClasses;
	function joinClasses(val) {
	  return (Array.isArray(val) ? val.map(joinClasses) :
	    (val && typeof val === 'object') ? Object.keys(val).filter(function (key) { return val[key]; }) :
	    [val]).filter(nulls).join(' ');
	}
	
	/**
	 * Render the given classes.
	 *
	 * @param {Array} classes
	 * @param {Array.<Boolean>} escaped
	 * @return {String}
	 */
	exports.cls = function cls(classes, escaped) {
	  var buf = [];
	  for (var i = 0; i < classes.length; i++) {
	    if (escaped && escaped[i]) {
	      buf.push(exports.escape(joinClasses([classes[i]])));
	    } else {
	      buf.push(joinClasses(classes[i]));
	    }
	  }
	  var text = joinClasses(buf);
	  if (text.length) {
	    return ' class="' + text + '"';
	  } else {
	    return '';
	  }
	};
	
	
	exports.style = function (val) {
	  if (val && typeof val === 'object') {
	    return Object.keys(val).map(function (style) {
	      return style + ':' + val[style];
	    }).join(';');
	  } else {
	    return val;
	  }
	};
	/**
	 * Render the given attribute.
	 *
	 * @param {String} key
	 * @param {String} val
	 * @param {Boolean} escaped
	 * @param {Boolean} terse
	 * @return {String}
	 */
	exports.attr = function attr(key, val, escaped, terse) {
	  if (key === 'style') {
	    val = exports.style(val);
	  }
	  if ('boolean' == typeof val || null == val) {
	    if (val) {
	      return ' ' + (terse ? key : key + '="' + key + '"');
	    } else {
	      return '';
	    }
	  } else if (0 == key.indexOf('data') && 'string' != typeof val) {
	    if (JSON.stringify(val).indexOf('&') !== -1) {
	      console.warn('Since Jade 2.0.0, ampersands (`&`) in data attributes ' +
	                   'will be escaped to `&amp;`');
	    };
	    if (val && typeof val.toISOString === 'function') {
	      console.warn('Jade will eliminate the double quotes around dates in ' +
	                   'ISO form after 2.0.0');
	    }
	    return ' ' + key + "='" + JSON.stringify(val).replace(/'/g, '&apos;') + "'";
	  } else if (escaped) {
	    if (val && typeof val.toISOString === 'function') {
	      console.warn('Jade will stringify dates in ISO form after 2.0.0');
	    }
	    return ' ' + key + '="' + exports.escape(val) + '"';
	  } else {
	    if (val && typeof val.toISOString === 'function') {
	      console.warn('Jade will stringify dates in ISO form after 2.0.0');
	    }
	    return ' ' + key + '="' + val + '"';
	  }
	};
	
	/**
	 * Render the given attributes object.
	 *
	 * @param {Object} obj
	 * @param {Object} escaped
	 * @return {String}
	 */
	exports.attrs = function attrs(obj, terse){
	  var buf = [];
	
	  var keys = Object.keys(obj);
	
	  if (keys.length) {
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i]
	        , val = obj[key];
	
	      if ('class' == key) {
	        if (val = joinClasses(val)) {
	          buf.push(' ' + key + '="' + val + '"');
	        }
	      } else {
	        buf.push(exports.attr(key, val, false, terse));
	      }
	    }
	  }
	
	  return buf.join('');
	};
	
	/**
	 * Escape the given string of `html`.
	 *
	 * @param {String} html
	 * @return {String}
	 * @api private
	 */
	
	var jade_encode_html_rules = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;'
	};
	var jade_match_html = /[&<>"]/g;
	
	function jade_encode_char(c) {
	  return jade_encode_html_rules[c] || c;
	}
	
	exports.escape = jade_escape;
	function jade_escape(html){
	  var result = String(html).replace(jade_match_html, jade_encode_char);
	  if (result === '' + html) return html;
	  else return result;
	};
	
	/**
	 * Re-throw the given `err` in context to the
	 * the jade in `filename` at the given `lineno`.
	 *
	 * @param {Error} err
	 * @param {String} filename
	 * @param {String} lineno
	 * @api private
	 */
	
	exports.rethrow = function rethrow(err, filename, lineno, str){
	  if (!(err instanceof Error)) throw err;
	  if ((typeof window != 'undefined' || !filename) && !str) {
	    err.message += ' on line ' + lineno;
	    throw err;
	  }
	  try {
	    str = str || __webpack_require__(440).readFileSync(filename, 'utf8')
	  } catch (ex) {
	    rethrow(err, null, lineno)
	  }
	  var context = 3
	    , lines = str.split('\n')
	    , start = Math.max(lineno - context, 0)
	    , end = Math.min(lines.length, lineno + context);
	
	  // Error context
	  var context = lines.slice(start, end).map(function(line, i){
	    var curr = i + start + 1;
	    return (curr == lineno ? '  > ' : '    ')
	      + curr
	      + '| '
	      + line;
	  }).join('\n');
	
	  // Alter exception message
	  err.path = filename;
	  err.message = (filename || 'Jade') + ':' + lineno
	    + '\n' + context + '\n\n' + err.message;
	  throw err;
	};
	
	exports.DebugItem = function DebugItem(lineno, filename) {
	  this.lineno = lineno;
	  this.filename = filename;
	}


/***/ },
/* 440 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.tel', []).filter('tel', function () {
	  return function (value) {
	    var dotDelimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    if (!value) return '';
	
	    var numbers = value.toString().trim().replace(/\D/g, ''),
	        parts = [];
	
	    if (numbers[0] === '1') numbers = numbers.slice(1);
	
	    if (numbers.length === 0) return '';
	
	    parts.push(numbers.slice(0, 3));
	
	    if (numbers.length >= 4) {
	      if (dotDelimiter) {
	        parts.push('.');
	      } else {
	        parts.unshift('(');
	        parts.push(')');
	        parts.push(' ');
	      }
	      parts.push(numbers.slice(3, 6));
	
	      if (numbers.length >= 7) {
	        if (dotDelimiter) {
	          parts.push('.');
	        } else {
	          parts.push('-');
	        }
	        parts.push(numbers.slice(6, 10));
	      }
	    }
	
	    return parts.join('');
	  };
	}).name;

/***/ },
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(500);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.services.resource', [__webpack_require__(502), __webpack_require__(503)]).factory('odResource', ["$resourceInheritable", "toaster", function ($resourceInheritable, toaster) {
	  return function () {
	    var resource = $resourceInheritable.apply(this, arguments);
	    var toastMap = (0, _lodash.pickBy)((0, _lodash.mapValues)(arguments[2], 'toast'), _lodash.identity);
	
	    // On error, put the server response onto the model as `$errors`.
	    (0, _lodash.forIn)(resource, function (action, name) {
	      if (name !== 'bind') {
	        var toasts = toastMap[name];
	        resource[name] = function () {
	          toasts && toasts.wait && (toaster.clear(), toaster.wait(toasts.wait));
	          var result = action.apply(this, arguments);
	          result.$actionName = name;
	
	          var promise = result.$promise || result;
	          var model = result.$promise ? result : this;
	          promise.then(function success(response) {
	            var message = null;
	            if (response.message) {
	              if (_typeof(response.message) == 'object') {
	
	                message = response.message.join(",\n");
	              } else {
	                message = response.message;
	              }
	            }
	            toasts && toasts.success && (toaster.clear(), toaster.success(toasts.success, message)); // eslint-disable-line max-len
	          }, function error(response) {
	            model.$errors = response.data;
	            var errors = (0, _lodash.flatten)((0, _lodash.values)(response.data));
	            toasts && toasts.error && (toaster.clear(), toaster.error(toasts.error, errors.join(",\n"))); // eslint-disable-line max-len
	          });
	
	          return result;
	        };
	      }
	    });
	
	    return resource;
	  };
	}]).name;

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(501);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../css-loader/index.js!./toaster.min.css", function() {
				var newContent = require("!!../css-loader/index.js!./toaster.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/*!\r\n * Toastr\r\n * Version 2.0.1\r\n * Copyright 2012 John Papa and Hans Fjallemark.\r\n * All Rights Reserved.\r\n * Use, reproduction, distribution, and modification of this code is subject to the terms and\r\n * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php\r\n *\r\n * Author: John Papa and Hans Fjallemark\r\n * Project: https://github.com/CodeSeven/toastr\r\n */\r\n.toast-title{font-weight:700}.toast-message{-ms-word-wrap:break-word;word-wrap:break-word}.toast-message a,.toast-message label{color:#fff}.toast-message a:hover{color:#ccc;text-decoration:none}.toast-close-button{position:relative;right:-.3em;top:-.3em;float:right;font-size:20px;font-weight:700;color:#fff;-webkit-text-shadow:0 1px 0 #fff;text-shadow:0 1px 0 #fff;opacity:.8;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);filter:alpha(opacity=80)}.toast-close-button:focus,.toast-close-button:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.4;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=40);filter:alpha(opacity=40)}button.toast-close-button{padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.toast-top-full-width{top:0;right:0;width:100%}.toast-bottom-full-width{bottom:0;right:0;width:100%}.toast-top-left{top:12px;left:12px}.toast-top-center{top:12px}.toast-top-right{top:12px;right:12px}.toast-bottom-right{right:12px;bottom:12px}.toast-bottom-center{bottom:12px}.toast-bottom-left{bottom:12px;left:12px}.toast-center{top:45%}#toast-container{position:fixed;z-index:999999}#toast-container.toast-bottom-center,#toast-container.toast-center,#toast-container.toast-top-center{width:100%;pointer-events:none}#toast-container.toast-bottom-center>div,#toast-container.toast-center>div,#toast-container.toast-top-center>div{margin:auto;pointer-events:auto}#toast-container.toast-bottom-center>button,#toast-container.toast-center>button,#toast-container.toast-top-cente>button{pointer-events:auto}#toast-container *{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box}#toast-container>div{margin:0 0 6px;padding:15px 15px 15px 50px;width:300px;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;background-position:15px center;background-repeat:no-repeat;-moz-box-shadow:0 0 12px #999;-webkit-box-shadow:0 0 12px #999;box-shadow:0 0 12px #999;color:#fff;opacity:.8;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);filter:alpha(opacity=80)}#toast-container>:hover{-moz-box-shadow:0 0 12px #000;-webkit-box-shadow:0 0 12px #000;box-shadow:0 0 12px #000;opacity:1;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);filter:alpha(opacity=100);cursor:pointer}#toast-container>.toast-info{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=)!important}#toast-container>.toast-wait{background-image:url(data:image/gif;base64,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)!important}#toast-container>.toast-error{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=)!important}#toast-container>.toast-success{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==)!important}#toast-container>.toast-warning{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=)!important}#toast-container.toast-bottom-full-width>div,#toast-container.toast-top-full-width>div{width:96%;margin:auto}.toast{background-color:#030303}.toast-success{background-color:#51a351}.toast-error{background-color:#bd362f}.toast-info,.toast-wait{background-color:#2f96b4}.toast-warning{background-color:#f89406}@media all and (max-width:240px){#toast-container>div{padding:8px 8px 8px 50px;width:11em}#toast-container .toast-close-button{right:-.2em;top:-.2em}}@media all and (min-width:241px) and (max-width:480px){#toast-container>div{padding:8px 8px 8px 50px;width:18em}#toast-container .toast-close-button{right:-.2em;top:-.2em}}@media all and (min-width:481px) and (max-width:768px){#toast-container>div{padding:15px 15px 15px 50px;width:25em}}:not(.no-enter)#toast-container>div.ng-enter,:not(.no-leave)#toast-container>div.ng-leave{-webkit-transition:1000ms cubic-bezier(.25,.25,.75,.75) all;-moz-transition:1000ms cubic-bezier(.25,.25,.75,.75) all;-ms-transition:1000ms cubic-bezier(.25,.25,.75,.75) all;-o-transition:1000ms cubic-bezier(.25,.25,.75,.75) all;transition:1000ms cubic-bezier(.25,.25,.75,.75) all}:not(.no-enter)#toast-container>div.ng-enter.ng-enter-active,:not(.no-leave)#toast-container>div.ng-leave{opacity:.8}:not(.no-enter)#toast-container>div.ng-enter,:not(.no-leave)#toast-container>div.ng-leave.ng-leave-active{opacity:0}", ""]);
	
	// exports


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* eslint-disable */
	// This is a fork of
	// https://github.com/angular/angular.js/blob/v1.5.5/src/ngResource/resource.js
	// Specifically only to add support for inheritable resource classes.
	//
	// Look for lines commented with OPENDOOR.
	
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $resourceMinErr = _angular2.default.$$minErr('$resource');
	
	// Helper functions and regex to lookup a dotted path on an object
	// stopping at undefined/null.  The path must be composed of ASCII
	// identifiers (just like $parse)
	var MEMBER_NAME_REGEX = /^(\.[a-zA-Z_$@][0-9a-zA-Z_$@]*)+$/;
	
	function isValidDottedPath(path) {
	  return path != null && path !== '' && path !== 'hasOwnProperty' && MEMBER_NAME_REGEX.test('.' + path);
	}
	
	function lookupDottedPath(obj, path) {
	  if (!isValidDottedPath(path)) {
	    throw $resourceMinErr('badmember', 'Dotted member path "@{0}" is invalid.', path);
	  }
	  var keys = path.split('.');
	  for (var i = 0, ii = keys.length; i < ii && _angular2.default.isDefined(obj); i++) {
	    var key = keys[i];
	    obj = obj !== null ? obj[key] : undefined;
	  }
	  return obj;
	}
	
	/**
	 * Create a shallow copy of an object and clear other fields from the destination
	 */
	function shallowClearAndCopy(src, dst) {
	  dst = dst || {};
	
	  _angular2.default.forEach(dst, function (value, key) {
	    delete dst[key];
	  });
	
	  for (var key in src) {
	    if (src.hasOwnProperty(key) && !(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	      dst[key] = src[key];
	    }
	  }
	
	  return dst;
	}
	
	/**
	 * @ngdoc module
	 * @name ngResource
	 * @description
	 *
	 * # ngResource
	 *
	 * The `ngResource` module provides interaction support with RESTful services
	 * via the $resource service.
	 *
	 *
	 * <div doc-module-components="ngResource"></div>
	 *
	 * See {@link ngResource.$resource `$resource`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $resource
	 * @requires $http
	 * @requires ng.$log
	 * @requires $q
	 * @requires ng.$timeout
	 *
	 * @description
	 * A factory which creates a resource object that lets you interact with
	 * [RESTful](http://en.wikipedia.org/wiki/Representational_State_Transfer) server-side data sources.
	 *
	 * The returned resource object has action methods which provide high-level behaviors without
	 * the need to interact with the low level {@link ng.$http $http} service.
	 *
	 * Requires the {@link ngResource `ngResource`} module to be installed.
	 *
	 * By default, trailing slashes will be stripped from the calculated URLs,
	 * which can pose problems with server backends that do not expect that
	 * behavior.  This can be disabled by configuring the `$resourceProvider` like
	 * this:
	 *
	 * ```js
	     app.config(['$resourceProvider', function($resourceProvider) {
	       // Don't strip trailing slashes from calculated URLs
	       $resourceProvider.defaults.stripTrailingSlashes = false;
	     }]);
	 * ```
	 *
	 * @param {string} url A parameterized URL template with parameters prefixed by `:` as in
	 *   `/user/:username`. If you are using a URL with a port number (e.g.
	 *   `http://example.com:8080/api`), it will be respected.
	 *
	 *   If you are using a url with a suffix, just add the suffix, like this:
	 *   `$resource('http://example.com/resource.json')` or `$resource('http://example.com/:id.json')`
	 *   or even `$resource('http://example.com/resource/:resource_id.:format')`
	 *   If the parameter before the suffix is empty, :resource_id in this case, then the `/.` will be
	 *   collapsed down to a single `.`.  If you need this sequence to appear and not collapse then you
	 *   can escape it with `/\.`.
	 *
	 * @param {Object=} paramDefaults Default values for `url` parameters. These can be overridden in
	 *   `actions` methods. If a parameter value is a function, it will be executed every time
	 *   when a param value needs to be obtained for a request (unless the param was overridden).
	 *
	 *   Each key value in the parameter object is first bound to url template if present and then any
	 *   excess keys are appended to the url search query after the `?`.
	 *
	 *   Given a template `/path/:verb` and parameter `{verb:'greet', salutation:'Hello'}` results in
	 *   URL `/path/greet?salutation=Hello`.
	 *
	 *   If the parameter value is prefixed with `@` then the value for that parameter will be extracted
	 *   from the corresponding property on the `data` object (provided when calling an action method).
	 *   For example, if the `defaultParam` object is `{someParam: '@someProp'}` then the value of
	 *   `someParam` will be `data.someProp`.
	 *
	 * @param {Object.<Object>=} actions Hash with declaration of custom actions that should extend
	 *   the default set of resource actions. The declaration should be created in the format of {@link
	 *   ng.$http#usage $http.config}:
	 *
	 *       {action1: {method:?, params:?, isArray:?, headers:?, ...},
	 *        action2: {method:?, params:?, isArray:?, headers:?, ...},
	 *        ...}
	 *
	 *   Where:
	 *
	 *   - **`action`** – {string} – The name of action. This name becomes the name of the method on
	 *     your resource object.
	 *   - **`method`** – {string} – Case insensitive HTTP method (e.g. `GET`, `POST`, `PUT`,
	 *     `DELETE`, `JSONP`, etc).
	 *   - **`params`** – {Object=} – Optional set of pre-bound parameters for this action. If any of
	 *     the parameter value is a function, it will be executed every time when a param value needs to
	 *     be obtained for a request (unless the param was overridden).
	 *   - **`url`** – {string} – action specific `url` override. The url templating is supported just
	 *     like for the resource-level urls.
	 *   - **`isArray`** – {boolean=} – If true then the returned object for this action is an array,
	 *     see `returns` section.
	 *   - **`transformRequest`** –
	 *     `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	 *     transform function or an array of such functions. The transform function takes the http
	 *     request body and headers and returns its transformed (typically serialized) version.
	 *     By default, transformRequest will contain one function that checks if the request data is
	 *     an object and serializes to using `angular.toJson`. To prevent this behavior, set
	 *     `transformRequest` to an empty array: `transformRequest: []`
	 *   - **`transformResponse`** –
	 *     `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	 *     transform function or an array of such functions. The transform function takes the http
	 *     response body and headers and returns its transformed (typically deserialized) version.
	 *     By default, transformResponse will contain one function that checks if the response looks
	 *     like a JSON string and deserializes it using `angular.fromJson`. To prevent this behavior,
	 *     set `transformResponse` to an empty array: `transformResponse: []`
	 *   - **`cache`** – `{boolean|Cache}` – If true, a default $http cache will be used to cache the
	 *     GET request, otherwise if a cache instance built with
	 *     {@link ng.$cacheFactory $cacheFactory}, this cache will be used for
	 *     caching.
	 *   - **`timeout`** – `{number}` – timeout in milliseconds.<br />
	 *     **Note:** In contrast to {@link ng.$http#usage $http.config}, {@link ng.$q promises} are
	 *     **not** supported in $resource, because the same value would be used for multiple requests.
	 *     If you are looking for a way to cancel requests, you should use the `cancellable` option.
	 *   - **`cancellable`** – `{boolean}` – if set to true, the request made by a "non-instance" call
	 *     will be cancelled (if not already completed) by calling `$cancelRequest()` on the call's
	 *     return value. Calling `$cancelRequest()` for a non-cancellable or an already
	 *     completed/cancelled request will have no effect.<br />
	 *   - **`withCredentials`** - `{boolean}` - whether to set the `withCredentials` flag on the
	 *     XHR object. See
	 *     [requests with credentials](https://developer.mozilla.org/en/http_access_control#section_5)
	 *     for more information.
	 *   - **`responseType`** - `{string}` - see
	 *     [requestType](https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#responseType).
	 *   - **`interceptor`** - `{Object=}` - The interceptor object has two optional methods -
	 *     `response` and `responseError`. Both `response` and `responseError` interceptors get called
	 *     with `http response` object. See {@link ng.$http $http interceptors}.
	 *
	 * @param {Object} options Hash with custom settings that should extend the
	 *   default `$resourceProvider` behavior.  The supported options are:
	 *
	 *   - **`stripTrailingSlashes`** – {boolean} – If true then the trailing
	 *   slashes from any calculated URL will be stripped. (Defaults to true.)
	 *   - **`cancellable`** – {boolean} – If true, the request made by a "non-instance" call will be
	 *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return value.
	 *   This can be overwritten per action. (Defaults to false.)
	 *
	 * @returns {Object} A resource "class" object with methods for the default set of resource actions
	 *   optionally extended with custom `actions`. The default set contains these actions:
	 *   ```js
	 *   { 'get':    {method:'GET'},
	 *     'save':   {method:'POST'},
	 *     'query':  {method:'GET', isArray:true},
	 *     'remove': {method:'DELETE'},
	 *     'delete': {method:'DELETE'} };
	 *   ```
	 *
	 *   Calling these methods invoke an {@link ng.$http} with the specified http method,
	 *   destination and parameters. When the data is returned from the server then the object is an
	 *   instance of the resource class. The actions `save`, `remove` and `delete` are available on it
	 *   as  methods with the `$` prefix. This allows you to easily perform CRUD operations (create,
	 *   read, update, delete) on server-side data like this:
	 *   ```js
	 *   var User = $resource('/user/:userId', {userId:'@id'});
	 *   var user = User.get({userId:123}, function() {
	 *     user.abc = true;
	 *     user.$save();
	 *   });
	 *   ```
	 *
	 *   It is important to realize that invoking a $resource object method immediately returns an
	 *   empty reference (object or array depending on `isArray`). Once the data is returned from the
	 *   server the existing reference is populated with the actual data. This is a useful trick since
	 *   usually the resource is assigned to a model which is then rendered by the view. Having an empty
	 *   object results in no rendering, once the data arrives from the server then the object is
	 *   populated with the data and the view automatically re-renders itself showing the new data. This
	 *   means that in most cases one never has to write a callback function for the action methods.
	 *
	 *   The action methods on the class object or instance object can be invoked with the following
	 *   parameters:
	 *
	 *   - HTTP GET "class" actions: `Resource.action([parameters], [success], [error])`
	 *   - non-GET "class" actions: `Resource.action([parameters], postData, [success], [error])`
	 *   - non-GET instance actions:  `instance.$action([parameters], [success], [error])`
	 *
	 *
	 *   Success callback is called with (value, responseHeaders) arguments, where the value is
	 *   the populated resource instance or collection object. The error callback is called
	 *   with (httpResponse) argument.
	 *
	 *   Class actions return empty instance (with additional properties below).
	 *   Instance actions return promise of the action.
	 *
	 *   The Resource instances and collections have these additional properties:
	 *
	 *   - `$promise`: the {@link ng.$q promise} of the original server interaction that created this
	 *     instance or collection.
	 *
	 *     On success, the promise is resolved with the same resource instance or collection object,
	 *     updated with data from server. This makes it easy to use in
	 *     {@link ngRoute.$routeProvider resolve section of $routeProvider.when()} to defer view
	 *     rendering until the resource(s) are loaded.
	 *
	 *     On failure, the promise is rejected with the {@link ng.$http http response} object, without
	 *     the `resource` property.
	 *
	 *     If an interceptor object was provided, the promise will instead be resolved with the value
	 *     returned by the interceptor.
	 *
	 *   - `$resolved`: `true` after first server interaction is completed (either with success or
	 *      rejection), `false` before that. Knowing if the Resource has been resolved is useful in
	 *      data-binding.
	 *
	 *   The Resource instances and collections have these additional methods:
	 *
	 *   - `$cancelRequest`: If there is a cancellable, pending request related to the instance or
	 *      collection, calling this method will abort the request.
	 *
	 * @example
	 *
	 * # Credit card resource
	 *
	 * ```js
	     // Define CreditCard class
	     var CreditCard = $resource('/user/:userId/card/:cardId',
	      {userId:123, cardId:'@id'}, {
	       charge: {method:'POST', params:{charge:true}}
	      });
	
	     // We can retrieve a collection from the server
	     var cards = CreditCard.query(function() {
	       // GET: /user/123/card
	       // server returns: [ {id:456, number:'1234', name:'Smith'} ];
	
	       var card = cards[0];
	       // each item is an instance of CreditCard
	       expect(card instanceof CreditCard).toEqual(true);
	       card.name = "J. Smith";
	       // non GET methods are mapped onto the instances
	       card.$save();
	       // POST: /user/123/card/456 {id:456, number:'1234', name:'J. Smith'}
	       // server returns: {id:456, number:'1234', name: 'J. Smith'};
	
	       // our custom method is mapped as well.
	       card.$charge({amount:9.99});
	       // POST: /user/123/card/456?amount=9.99&charge=true {id:456, number:'1234', name:'J. Smith'}
	     });
	
	     // we can create an instance as well
	     var newCard = new CreditCard({number:'0123'});
	     newCard.name = "Mike Smith";
	     newCard.$save();
	     // POST: /user/123/card {number:'0123', name:'Mike Smith'}
	     // server returns: {id:789, number:'0123', name: 'Mike Smith'};
	     expect(newCard.id).toEqual(789);
	 * ```
	 *
	 * The object returned from this function execution is a resource "class" which has "static" method
	 * for each action in the definition.
	 *
	 * Calling these methods invoke `$http` on the `url` template with the given `method`, `params` and
	 * `headers`.
	 *
	 * @example
	 *
	 * # User resource
	 *
	 * When the data is returned from the server then the object is an instance of the resource type and
	 * all of the non-GET methods are available with `$` prefix. This allows you to easily support CRUD
	 * operations (create, read, update, delete) on server-side data.
	
	   ```js
	     var User = $resource('/user/:userId', {userId:'@id'});
	     User.get({userId:123}, function(user) {
	       user.abc = true;
	       user.$save();
	     });
	   ```
	 *
	 * It's worth noting that the success callback for `get`, `query` and other methods gets passed
	 * in the response that came from the server as well as $http header getter function, so one
	 * could rewrite the above example and get access to http headers as:
	 *
	   ```js
	     var User = $resource('/user/:userId', {userId:'@id'});
	     User.get({userId:123}, function(user, getResponseHeaders){
	       user.abc = true;
	       user.$save(function(user, putResponseHeaders) {
	         //user => saved user object
	         //putResponseHeaders => $http header getter
	       });
	     });
	   ```
	 *
	 * You can also access the raw `$http` promise via the `$promise` property on the object returned
	 *
	   ```
	     var User = $resource('/user/:userId', {userId:'@id'});
	     User.get({userId:123})
	         .$promise.then(function(user) {
	           $scope.user = user;
	         });
	   ```
	 *
	 * @example
	 *
	 * # Creating a custom 'PUT' request
	 *
	 * In this example we create a custom method on our resource to make a PUT request
	 * ```js
	 *    var app = angular.module('app', ['ngResource', 'ngRoute']);
	 *
	 *    // Some APIs expect a PUT request in the format URL/object/ID
	 *    // Here we are creating an 'update' method
	 *    app.factory('Notes', ['$resource', function($resource) {
	 *    return $resource('/notes/:id', null,
	 *        {
	 *            'update': { method:'PUT' }
	 *        });
	 *    }]);
	 *
	 *    // In our controller we get the ID from the URL using ngRoute and $routeParams
	 *    // We pass in $routeParams and our Notes factory along with $scope
	 *    app.controller('NotesCtrl', ['$scope', '$routeParams', 'Notes',
	                                      function($scope, $routeParams, Notes) {
	 *    // First get a note object from the factory
	 *    var note = Notes.get({ id:$routeParams.id });
	 *    $id = note.id;
	 *
	 *    // Now call update passing in the ID first then the object you are updating
	 *    Notes.update({ id:$id }, note);
	 *
	 *    // This will PUT /notes/ID with the note object in the request payload
	 *    }]);
	 * ```
	 *
	 * @example
	 *
	 * # Cancelling requests
	 *
	 * If an action's configuration specifies that it is cancellable, you can cancel the request related
	 * to an instance or collection (as long as it is a result of a "non-instance" call):
	 *
	   ```js
	     // ...defining the `Hotel` resource...
	     var Hotel = $resource('/api/hotel/:id', {id: '@id'}, {
	       // Let's make the `query()` method cancellable
	       query: {method: 'get', isArray: true, cancellable: true}
	     });
	
	     // ...somewhere in the PlanVacationController...
	     ...
	     this.onDestinationChanged = function onDestinationChanged(destination) {
	       // We don't care about any pending request for hotels
	       // in a different destination any more
	       this.availableHotels.$cancelRequest();
	
	       // Let's query for hotels in '<destination>'
	       // (calls: /api/hotel?location=<destination>)
	       this.availableHotels = Hotel.query({location: destination});
	     };
	   ```
	 *
	 */
	_angular2.default.module('resource-inheritable', ['ng']). // OPENDOOR
	provider('$resourceInheritable', function () {
	  // OPENDOOR
	  var PROTOCOL_AND_DOMAIN_REGEX = /^https?:\/\/[^\/]*/;
	  var provider = this;
	
	  this.defaults = {
	    // Strip slashes by default
	    stripTrailingSlashes: true,
	
	    // Default actions configuration
	    actions: {
	      'get': { method: 'GET' },
	      'save': { method: 'POST' },
	      'query': { method: 'GET', isArray: true },
	      'remove': { method: 'DELETE' },
	      'delete': { method: 'DELETE' }
	    }
	  };
	
	  this.$get = ['$http', '$log', '$q', '$timeout', function ($http, $log, $q, $timeout) {
	
	    var noop = _angular2.default.noop,
	        forEach = _angular2.default.forEach,
	        extend = _angular2.default.extend,
	        copy = _angular2.default.copy,
	        isFunction = _angular2.default.isFunction;
	
	    /**
	     * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	     * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set
	     * (pchar) allowed in path segments:
	     *    segment       = *pchar
	     *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	     *    pct-encoded   = "%" HEXDIG HEXDIG
	     *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	     *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	     *                     / "*" / "+" / "," / ";" / "="
	     */
	    function encodeUriSegment(val) {
	      return encodeUriQuery(val, true).replace(/%26/gi, '&').replace(/%3D/gi, '=').replace(/%2B/gi, '+');
	    }
	
	    /**
	     * This method is intended for encoding *key* or *value* parts of query component. We need a
	     * custom method because encodeURIComponent is too aggressive and encodes stuff that doesn't
	     * have to be encoded per http://tools.ietf.org/html/rfc3986:
	     *    query       = *( pchar / "/" / "?" )
	     *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	     *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	     *    pct-encoded   = "%" HEXDIG HEXDIG
	     *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	     *                     / "*" / "+" / "," / ";" / "="
	     */
	    function encodeUriQuery(val, pctEncodeSpaces) {
	      return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, pctEncodeSpaces ? '%20' : '+');
	    }
	
	    function Route(template, defaults) {
	      this.template = template;
	      this.defaults = extend({}, provider.defaults, defaults);
	      this.urlParams = {};
	    }
	
	    Route.prototype = {
	      setUrlParams: function setUrlParams(config, params, actionUrl) {
	        var self = this,
	            url = actionUrl || self.template,
	            val,
	            encodedVal,
	            protocolAndDomain = '';
	
	        var urlParams = self.urlParams = {};
	        forEach(url.split(/\W/), function (param) {
	          if (param === 'hasOwnProperty') {
	            throw $resourceMinErr('badname', "hasOwnProperty is not a valid parameter name.");
	          }
	          if (!new RegExp("^\\d+$").test(param) && param && new RegExp("(^|[^\\\\]):" + param + "(\\W|$)").test(url)) {
	            urlParams[param] = {
	              isQueryParamValue: new RegExp("\\?.*=:" + param + "(?:\\W|$)").test(url)
	            };
	          }
	        });
	        url = url.replace(/\\:/g, ':');
	        url = url.replace(PROTOCOL_AND_DOMAIN_REGEX, function (match) {
	          protocolAndDomain = match;
	          return '';
	        });
	
	        params = params || {};
	        forEach(self.urlParams, function (paramInfo, urlParam) {
	          val = params.hasOwnProperty(urlParam) ? params[urlParam] : self.defaults[urlParam];
	          if (_angular2.default.isDefined(val) && val !== null) {
	            if (paramInfo.isQueryParamValue) {
	              encodedVal = encodeUriQuery(val, true);
	            } else {
	              encodedVal = encodeUriSegment(val);
	            }
	            url = url.replace(new RegExp(":" + urlParam + "(\\W|$)", "g"), function (match, p1) {
	              return encodedVal + p1;
	            });
	          } else {
	            url = url.replace(new RegExp("(\/?):" + urlParam + "(\\W|$)", "g"), function (match, leadingSlashes, tail) {
	              if (tail.charAt(0) == '/') {
	                return tail;
	              } else {
	                return leadingSlashes + tail;
	              }
	            });
	          }
	        });
	
	        // strip trailing slashes and set the url (unless this behavior is specifically disabled)
	        if (self.defaults.stripTrailingSlashes) {
	          url = url.replace(/\/+$/, '') || '/';
	        }
	
	        // then replace collapse `/.` if found in the last URL path segment before the query
	        // E.g. `http://url.com/id./format?q=x` becomes `http://url.com/id.format?q=x`
	        url = url.replace(/\/\.(?=\w+($|\?))/, '.');
	        // replace escaped `/\.` with `/.`
	        config.url = protocolAndDomain + url.replace(/\/\\\./, '/.');
	
	        // set params - delegate param encoding to $http
	        forEach(params, function (value, key) {
	          if (!self.urlParams[key]) {
	            config.params = config.params || {};
	            config.params[key] = value;
	          }
	        });
	      }
	    };
	
	    function resourceFactory(url, paramDefaults, actions, options) {
	      var route = new Route(url, options);
	
	      actions = extend({}, provider.defaults.actions, actions);
	
	      function extractParams(data, actionParams) {
	        var ids = {};
	        actionParams = extend({}, paramDefaults, actionParams);
	        forEach(actionParams, function (value, key) {
	          if (isFunction(value)) {
	            value = value();
	          }
	          ids[key] = value && value.charAt && value.charAt(0) == '@' ? lookupDottedPath(data, value.substr(1)) : value;
	        });
	        return ids;
	      }
	
	      function defaultResponseInterceptor(response) {
	        return response.resource;
	      }
	
	      function Resource(value) {
	        shallowClearAndCopy(value || {}, this);
	      }
	
	      Resource.prototype.toJSON = function () {
	        var data = extend({}, this);
	        delete data.$promise;
	        delete data.$resolved;
	        return data;
	      };
	
	      forEach(actions, function (action, name) {
	        var hasBody = /^(POST|PUT|PATCH)$/i.test(action.method);
	        var numericTimeout = action.timeout;
	        var cancellable = _angular2.default.isDefined(action.cancellable) ? action.cancellable : options && _angular2.default.isDefined(options.cancellable) ? options.cancellable : provider.defaults.cancellable;
	
	        if (numericTimeout && !_angular2.default.isNumber(numericTimeout)) {
	          $log.debug('ngResource:\n' + '  Only numeric values are allowed as `timeout`.\n' + '  Promises are not supported in $resource, because the same value would ' + 'be used for multiple requests. If you are looking for a way to cancel ' + 'requests, you should use the `cancellable` option.');
	          delete action.timeout;
	          numericTimeout = null;
	        }
	
	        Resource[name] = function (a1, a2, a3, a4) {
	          var params = {},
	              data,
	              success,
	              error;
	
	          /* jshint -W086 */ /* (purposefully fall through case statements) */
	          switch (arguments.length) {
	            case 4:
	              error = a4;
	              success = a3;
	            //fallthrough
	            case 3:
	            case 2:
	              if (isFunction(a2)) {
	                if (isFunction(a1)) {
	                  success = a1;
	                  error = a2;
	                  break;
	                }
	
	                success = a2;
	                error = a3;
	                //fallthrough
	              } else {
	                params = a1;
	                data = a2;
	                success = a3;
	                break;
	              }
	            case 1:
	              if (isFunction(a1)) success = a1;else if (hasBody) data = a1;else params = a1;
	              break;
	            case 0:
	              break;
	            default:
	              throw $resourceMinErr('badargs', "Expected up to 4 arguments [params, data, success, error], got {0} arguments", arguments.length);
	          }
	          /* jshint +W086 */ /* (purposefully fall through case statements) */
	
	          var isInstanceCall = this instanceof Resource;
	          var Constructor = isInstanceCall ? this.constructor : this; // OPENDOOR
	          var value = isInstanceCall ? data : action.isArray ? [] : new Constructor(data); // OPENDOOR
	          var httpConfig = {};
	          var responseInterceptor = action.interceptor && action.interceptor.response || defaultResponseInterceptor;
	          var responseErrorInterceptor = action.interceptor && action.interceptor.responseError || undefined;
	          var timeoutDeferred;
	          var numericTimeoutPromise;
	
	          forEach(action, function (value, key) {
	            switch (key) {
	              default:
	                httpConfig[key] = copy(value);
	                break;
	              case 'params':
	              case 'isArray':
	              case 'interceptor':
	              case 'cancellable':
	                break;
	            }
	          });
	
	          if (!isInstanceCall && cancellable) {
	            timeoutDeferred = $q.defer();
	            httpConfig.timeout = timeoutDeferred.promise;
	
	            if (numericTimeout) {
	              numericTimeoutPromise = $timeout(timeoutDeferred.resolve, numericTimeout);
	            }
	          }
	
	          if (hasBody) httpConfig.data = data;
	          route.setUrlParams(httpConfig, extend({}, extractParams(data, action.params || {}), params), action.url);
	
	          var promise = $http(httpConfig).then(function (response) {
	            var data = response.data;
	
	            if (data) {
	              // Need to convert action.isArray to boolean in case it is undefined
	              // jshint -W018
	              if (_angular2.default.isArray(data) !== !!action.isArray) {
	                throw $resourceMinErr('badcfg', 'Error in resource configuration for action `{0}`. Expected response to ' + 'contain an {1} but got an {2} (Request: {3} {4})', name, action.isArray ? 'array' : 'object', _angular2.default.isArray(data) ? 'array' : 'object', httpConfig.method, httpConfig.url);
	              }
	              // jshint +W018
	              if (action.isArray) {
	                value.length = 0;
	                forEach(data, function (item) {
	                  if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === "object") {
	                    value.push(new Constructor(item)); // OPENDOOR
	                  } else {
	                    // Valid JSON values may be string literals, and these should not be converted
	                    // into objects. These items will not have access to the Resource prototype
	                    // methods, but unfortunately there
	                    value.push(item);
	                  }
	                });
	              } else {
	                var promise = value.$promise; // Save the promise
	                shallowClearAndCopy(data, value);
	                value.$promise = promise; // Restore the promise
	              }
	            }
	            response.resource = value;
	
	            return response;
	          }, function (response) {
	            (error || noop)(response);
	            return $q.reject(response);
	          });
	
	          promise['finally'](function () {
	            value.$resolved = true;
	            if (!isInstanceCall && cancellable) {
	              value.$cancelRequest = _angular2.default.noop;
	              $timeout.cancel(numericTimeoutPromise);
	              timeoutDeferred = numericTimeoutPromise = httpConfig.timeout = null;
	            }
	          });
	
	          promise = promise.then(function (response) {
	            var value = responseInterceptor(response);
	            (success || noop)(value, response.headers);
	            return value;
	          }, responseErrorInterceptor);
	
	          if (!isInstanceCall) {
	            // we are creating instance / collection
	            // - set the initial promise
	            // - return the instance / collection
	            value.$promise = promise;
	            value.$resolved = false;
	            if (cancellable) value.$cancelRequest = timeoutDeferred.resolve;
	
	            return value;
	          }
	
	          // instance call
	          return promise;
	        };
	
	        Resource.prototype['$' + name] = function (params, success, error) {
	          if (isFunction(params)) {
	            error = success;success = params;params = {};
	          }
	          var result = Resource[name].call(this, params, this, success, error);
	          return result.$promise || result;
	        };
	      });
	
	      Resource.bind = function (additionalParamDefaults) {
	        return resourceFactory(url, extend({}, paramDefaults, additionalParamDefaults), actions);
	      };
	
	      return Resource;
	    }
	
	    return resourceFactory;
	  }];
	});
	
	module.exports = 'resource-inheritable'; // OPENDOOR

/***/ },
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<iframe ng-src=\"{{modalCtrl.url}}\" class=\"document\"></iframe>");;return buf.join("");
	}

/***/ },
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (key) {
	  // From http://docs.aws.amazon.com/AmazonS3/latest/dev/UsingMetadata.html#object-key-guidelines-safe-characters
	  return key && key.replace(/[^0-9a-zA-Z!\-_.*'()]/g, '');
	};

/***/ },
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = tryClipboardCopy;
	function tryClipboardCopy() {
	  var success = false;
	
	  try {
	    success = document.execCommand('copy');
	  } catch (err) {
	    // ignore
	  }
	
	  return success;
	}

/***/ },
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.pretty', []).filter('pretty', function () {
	  return function (value) {
	    if (!(0, _lodash.isNil)(value)) return String(value).replace(/_/g, ' ');
	  };
	}).name;

/***/ },
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(641);
	module.exports = 'ngSanitize';


/***/ },
/* 641 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.5.5
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * # ngSanitize
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 *
	 * <div doc-module-components="ngSanitize"></div>
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   Sanitizes an html string by stripping all potentially dangerous tokens.
	 *
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to properly escaped html string. This means that no unsafe input can make
	 *   it into the returned string.
	 *
	 *   The whitelist for URL sanitization of attribute values is configured using the functions
	 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
	 *   `$compileProvider`}.
	 *
	 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getInnerHtml()).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $sanitizeProvider
	 *
	 * @description
	 * Creates and configures {@link $sanitize} instance.
	 */
	function $SanitizeProvider() {
	  var svgEnabled = false;
	
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    if (svgEnabled) {
	      angular.extend(validElements, svgElements);
	    }
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#enableSvg
	   * @kind function
	   *
	   * @description
	   * Enables a subset of svg to be supported by the sanitizer.
	   *
	   * <div class="alert alert-warning">
	   *   <p>By enabling this setting without taking other precautions, you might expose your
	   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
	   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
	   *   link). Such behavior can then result in phishing incidents.</p>
	   *
	   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
	   *   tags within the sanitized content:</p>
	   *
	   *   <br>
	   *
	   *   <pre><code>
	   *   .rootOfTheIncludedContent svg {
	   *     overflow: hidden !important;
	   *   }
	   *   </code></pre>
	   * </div>
	   *
	   * @param {boolean=} regexp New regexp to whitelist urls with.
	   * @returns {boolean|ng.$sanitizeProvider} Returns the currently configured value if called
	   *    without an argument or self for chaining otherwise.
	   */
	  this.enableSvg = function(enableSvg) {
	    if (angular.isDefined(enableSvg)) {
	      svgEnabled = enableSvg;
	      return this;
	    } else {
	      return svgEnabled;
	    }
	  };
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, angular.noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// Regular Expressions for parsing tags and attributes
	var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	  // Match everything outside of normal chars and " (quote character)
	  NON_ALPHANUMERIC_REGEXP = /([^\#-~ |!])/g;
	
	
	// Good source of info about elements and attributes
	// http://dev.w3.org/html5/spec/Overview.html#semantics
	// http://simon.html5.org/html-elements
	
	// Safe Void Elements - HTML5
	// http://dev.w3.org/html5/spec/Overview.html#void-elements
	var voidElements = toMap("area,br,col,hr,img,wbr");
	
	// Elements that you can, intentionally, leave open (and which close themselves)
	// http://dev.w3.org/html5/spec/Overview.html#optional-tags
	var optionalEndTagBlockElements = toMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
	    optionalEndTagInlineElements = toMap("rp,rt"),
	    optionalEndTagElements = angular.extend({},
	                                            optionalEndTagInlineElements,
	                                            optionalEndTagBlockElements);
	
	// Safe Block Elements - HTML5
	var blockElements = angular.extend({}, optionalEndTagBlockElements, toMap("address,article," +
	        "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," +
	        "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul"));
	
	// Inline Elements - HTML5
	var inlineElements = angular.extend({}, optionalEndTagInlineElements, toMap("a,abbr,acronym,b," +
	        "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," +
	        "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));
	
	// SVG Elements
	// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	// Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	// They can potentially allow for arbitrary javascript to be executed. See #11290
	var svgElements = toMap("circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph," +
	        "hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline," +
	        "radialGradient,rect,stop,svg,switch,text,title,tspan");
	
	// Blocked Elements (will be stripped)
	var blockedElements = toMap("script,style");
	
	var validElements = angular.extend({},
	                                   voidElements,
	                                   blockElements,
	                                   inlineElements,
	                                   optionalEndTagElements);
	
	//Attributes that have href and hence need to be sanitized
	var uriAttrs = toMap("background,cite,href,longdesc,src,xlink:href");
	
	var htmlAttrs = toMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
	    'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
	    'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
	    'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
	    'valign,value,vspace,width');
	
	// SVG attributes (without "id" and "name" attributes)
	// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	var svgAttrs = toMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	    'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
	    'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
	    'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
	    'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
	    'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
	    'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
	    'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
	    'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
	    'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
	    'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
	    'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
	    'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
	    'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
	    'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	var validAttrs = angular.extend({},
	                                uriAttrs,
	                                svgAttrs,
	                                htmlAttrs);
	
	function toMap(str, lowercaseKeys) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[lowercaseKeys ? angular.lowercase(items[i]) : items[i]] = true;
	  }
	  return obj;
	}
	
	var inertBodyElement;
	(function(window) {
	  var doc;
	  if (window.document && window.document.implementation) {
	    doc = window.document.implementation.createHTMLDocument("inert");
	  } else {
	    throw $sanitizeMinErr('noinert', "Can't create an inert html document");
	  }
	  var docElement = doc.documentElement || doc.getDocumentElement();
	  var bodyElements = docElement.getElementsByTagName('body');
	
	  // usually there should be only one body element in the document, but IE doesn't have any, so we need to create one
	  if (bodyElements.length === 1) {
	    inertBodyElement = bodyElements[0];
	  } else {
	    var html = doc.createElement('html');
	    inertBodyElement = doc.createElement('body');
	    html.appendChild(inertBodyElement);
	    doc.appendChild(html);
	  }
	})(window);
	
	/**
	 * @example
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 * @param {string} html string
	 * @param {object} handler
	 */
	function htmlParser(html, handler) {
	  if (html === null || html === undefined) {
	    html = '';
	  } else if (typeof html !== 'string') {
	    html = '' + html;
	  }
	  inertBodyElement.innerHTML = html;
	
	  //mXSS protection
	  var mXSSAttempts = 5;
	  do {
	    if (mXSSAttempts === 0) {
	      throw $sanitizeMinErr('uinput', "Failed to sanitize html because the input is unstable");
	    }
	    mXSSAttempts--;
	
	    // strip custom-namespaced attributes on IE<=11
	    if (window.document.documentMode) {
	      stripCustomNsAttrs(inertBodyElement);
	    }
	    html = inertBodyElement.innerHTML; //trigger mXSS
	    inertBodyElement.innerHTML = html;
	  } while (html !== inertBodyElement.innerHTML);
	
	  var node = inertBodyElement.firstChild;
	  while (node) {
	    switch (node.nodeType) {
	      case 1: // ELEMENT_NODE
	        handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
	        break;
	      case 3: // TEXT NODE
	        handler.chars(node.textContent);
	        break;
	    }
	
	    var nextNode;
	    if (!(nextNode = node.firstChild)) {
	      if (node.nodeType == 1) {
	        handler.end(node.nodeName.toLowerCase());
	      }
	      nextNode = node.nextSibling;
	      if (!nextNode) {
	        while (nextNode == null) {
	          node = node.parentNode;
	          if (node === inertBodyElement) break;
	          nextNode = node.nextSibling;
	          if (node.nodeType == 1) {
	            handler.end(node.nodeName.toLowerCase());
	          }
	        }
	      }
	    }
	    node = nextNode;
	  }
	
	  while (node = inertBodyElement.firstChild) {
	    inertBodyElement.removeChild(node);
	  }
	}
	
	function attrToMap(attrs) {
	  var map = {};
	  for (var i = 0, ii = attrs.length; i < ii; i++) {
	    var attr = attrs[i];
	    map[attr.name] = attr.value;
	  }
	  return map;
	}
	
	
	/**
	 * Escapes all potentially dangerous characters, so that the
	 * resulting string can be safely inserted into attribute or
	 * element text.
	 * @param value
	 * @returns {string} escaped text
	 */
	function encodeEntities(value) {
	  return value.
	    replace(/&/g, '&amp;').
	    replace(SURROGATE_PAIR_REGEXP, function(value) {
	      var hi = value.charCodeAt(0);
	      var low = value.charCodeAt(1);
	      return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	    }).
	    replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	      return '&#' + value.charCodeAt(0) + ';';
	    }).
	    replace(/</g, '&lt;').
	    replace(/>/g, '&gt;');
	}
	
	/**
	 * create an HTML/XML writer which writes to buffer
	 * @param {Array} buf use buf.join('') to get out sanitized html string
	 * @returns {object} in the form of {
	 *     start: function(tag, attrs) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * }
	 */
	function htmlSanitizeWriter(buf, uriValidator) {
	  var ignoreCurrentElement = false;
	  var out = angular.bind(buf, buf.push);
	  return {
	    start: function(tag, attrs) {
	      tag = angular.lowercase(tag);
	      if (!ignoreCurrentElement && blockedElements[tag]) {
	        ignoreCurrentElement = tag;
	      }
	      if (!ignoreCurrentElement && validElements[tag] === true) {
	        out('<');
	        out(tag);
	        angular.forEach(attrs, function(value, key) {
	          var lkey=angular.lowercase(key);
	          var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	          if (validAttrs[lkey] === true &&
	            (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	            out(' ');
	            out(key);
	            out('="');
	            out(encodeEntities(value));
	            out('"');
	          }
	        });
	        out('>');
	      }
	    },
	    end: function(tag) {
	      tag = angular.lowercase(tag);
	      if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
	        out('</');
	        out(tag);
	        out('>');
	      }
	      if (tag == ignoreCurrentElement) {
	        ignoreCurrentElement = false;
	      }
	    },
	    chars: function(chars) {
	      if (!ignoreCurrentElement) {
	        out(encodeEntities(chars));
	      }
	    }
	  };
	}
	
	
	/**
	 * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
	 * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
	 * to allow any of these custom attributes. This method strips them all.
	 *
	 * @param node Root element to process
	 */
	function stripCustomNsAttrs(node) {
	  if (node.nodeType === window.Node.ELEMENT_NODE) {
	    var attrs = node.attributes;
	    for (var i = 0, l = attrs.length; i < l; i++) {
	      var attrNode = attrs[i];
	      var attrName = attrNode.name.toLowerCase();
	      if (attrName === 'xmlns:ns1' || attrName.indexOf('ns1:') === 0) {
	        node.removeAttributeNode(attrNode);
	        i--;
	        l--;
	      }
	    }
	  }
	
	  var nextNode = node.firstChild;
	  if (nextNode) {
	    stripCustomNsAttrs(nextNode);
	  }
	
	  nextNode = node.nextSibling;
	  if (nextNode) {
	    stripCustomNsAttrs(nextNode);
	  }
	}
	
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);
	
	/* global sanitizeText: false */
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports `http/https/ftp/mailto` and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} target Window (`_blank|_self|_parent|_top`) or named frame to open links in.
	 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
	 *
	 *    Can be one of:
	 *
	 *    - `object`: A map of attributes
	 *    - `function`: Takes the url as a parameter and returns a map of attributes
	 *
	 *    If the map of attributes contains a value for `target`, it overrides the value of
	 *    the target parameter.
	 *
	 *
	 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <th>Filter</th>
	           <th>Source</th>
	           <th>Rendered</th>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="linky-custom-attributes">
	          <td>linky custom attributes</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="script.js">
	       angular.module('linkyExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.snippet =
	             'Pretty text with some links:\n'+
	             'http://angularjs.org/,\n'+
	             'mailto:us@somewhere.org,\n'+
	             'another@somewhere.org,\n'+
	             'and one more: ftp://127.0.0.1/.';
	           $scope.snippetWithSingleURL = 'http://angularjs.org/';
	         }]);
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	
	       it('should optionally add custom attributes', function() {
	        expect(element(by.id('linky-custom-attributes')).
	            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	      MAILTO_REGEXP = /^mailto:/i;
	
	  var linkyMinErr = angular.$$minErr('linky');
	  var isString = angular.isString;
	
	  return function(text, target, attributes) {
	    if (text == null || text === '') return text;
	    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);
	
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      var key;
	      html.push('<a ');
	      if (angular.isFunction(attributes)) {
	        attributes = attributes(url);
	      }
	      if (angular.isObject(attributes)) {
	        for (key in attributes) {
	          html.push(key + '="' + attributes[key] + '" ');
	        }
	      } else {
	        attributes = {};
	      }
	      if (angular.isDefined(target) && !('target' in attributes)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(643);
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _ravenJs = __webpack_require__(645);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	var _angular3 = __webpack_require__(653);
	
	var _angular4 = _interopRequireDefault(_angular3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global SENTRY_CONFIG:false */
	/* global RELEASE_SHA:false */
	var modules = [__webpack_require__(654), __webpack_require__(656), __webpack_require__(657), __webpack_require__(659), __webpack_require__(661), __webpack_require__(697), __webpack_require__(701), __webpack_require__(836), __webpack_require__(897), __webpack_require__(909), __webpack_require__(931), __webpack_require__(971)];
	
	var RAVEN_URL = window.odDeployType === 'admin' ? (({"default":{"web_frontend":"https://710cd7e09a4c4a459babc784a2458196@o117144.ingest.us.sentry.io/305357","web_dsn":"https://3091c2e21f9f42789506cbae2aaa5c5e@o117144.ingest.us.sentry.io/305352","admin_frontend":"https://431cc22deb11497babccfb3129a39916@o117144.ingest.us.sentry.io/5628904"},"qa":{"web_frontend":"https://710cd7e09a4c4a459babc784a2458196@o117144.ingest.us.sentry.io/305357","web_dsn":"https://3091c2e21f9f42789506cbae2aaa5c5e@o117144.ingest.us.sentry.io/305352","admin_frontend":"https://431cc22deb11497babccfb3129a39916@o117144.ingest.us.sentry.io/5628904"},"development":{"web_frontend":"https://710cd7e09a4c4a459babc784a2458196@o117144.ingest.us.sentry.io/305357","web_dsn":"https://3091c2e21f9f42789506cbae2aaa5c5e@o117144.ingest.us.sentry.io/305352","admin_frontend":"https://431cc22deb11497babccfb3129a39916@o117144.ingest.us.sentry.io/5628904"},"staging":{"web_frontend":"https://710cd7e09a4c4a459babc784a2458196@o117144.ingest.us.sentry.io/305357","admin_frontend":"https://431cc22deb11497babccfb3129a39916@o117144.ingest.us.sentry.io/5628904"},"production":{"web_frontend":"https://710cd7e09a4c4a459babc784a2458196@o117144.ingest.us.sentry.io/305357","admin_frontend":"https://431cc22deb11497babccfb3129a39916@o117144.ingest.us.sentry.io/5628904"}})[window.odRailsEnv] || {}).admin_frontend : (({"default":{"web_frontend":"https://710cd7e09a4c4a459babc784a2458196@o117144.ingest.us.sentry.io/305357","web_dsn":"https://3091c2e21f9f42789506cbae2aaa5c5e@o117144.ingest.us.sentry.io/305352","admin_frontend":"https://431cc22deb11497babccfb3129a39916@o117144.ingest.us.sentry.io/5628904"},"qa":{"web_frontend":"https://710cd7e09a4c4a459babc784a2458196@o117144.ingest.us.sentry.io/305357","web_dsn":"https://3091c2e21f9f42789506cbae2aaa5c5e@o117144.ingest.us.sentry.io/305352","admin_frontend":"https://431cc22deb11497babccfb3129a39916@o117144.ingest.us.sentry.io/5628904"},"development":{"web_frontend":"https://710cd7e09a4c4a459babc784a2458196@o117144.ingest.us.sentry.io/305357","web_dsn":"https://3091c2e21f9f42789506cbae2aaa5c5e@o117144.ingest.us.sentry.io/305352","admin_frontend":"https://431cc22deb11497babccfb3129a39916@o117144.ingest.us.sentry.io/5628904"},"staging":{"web_frontend":"https://710cd7e09a4c4a459babc784a2458196@o117144.ingest.us.sentry.io/305357","admin_frontend":"https://431cc22deb11497babccfb3129a39916@o117144.ingest.us.sentry.io/5628904"},"production":{"web_frontend":"https://710cd7e09a4c4a459babc784a2458196@o117144.ingest.us.sentry.io/305357","admin_frontend":"https://431cc22deb11497babccfb3129a39916@o117144.ingest.us.sentry.io/5628904"}})[window.odRailsEnv] || {}).web_frontend;
	
	if (RAVEN_URL) {
	  var ignoreErrors = [];
	  if (navigator.userAgent.match('CriOS')) {
	    // Error generated by a bug in auto-fill library from Chrome Mobile on iOS
	    // https://github.com/getsentry/sentry/issues/5267
	    ignoreErrors.push(/Blocked a frame with origin/);
	  }
	
	  _ravenJs2.default.config(RAVEN_URL, {
	    ignoreErrors: ignoreErrors,
	    environment: window.odRailsEnv,
	    shouldSendCallback: function shouldSendCallback(data) {
	      // Google Tag Manager buggy code (not maintained by us)
	      if (data.exception && data.exception.values && data.exception.values[0]) {
	        var value = data.exception.values[0].value;
	        if (value && /_cc11509/.test(value)) {
	          return false;
	        }
	      }
	      // Silences sentries for crawlers/prerender.io
	      var isPhantomJS = /PhantomJS/.test(window.navigator.userAgent);
	      // Silence sentries from Security scanner
	      var isSecurityScanner = "Netsparker (Security team)" == window.navigator.userAgent;
	
	      return !isPhantomJS && !isSecurityScanner;
	    }
	  }).setRelease(("d7adc15c16a4cce76f5a3b2ee23eed4441eb793d")).addPlugin(_angular4.default, _angular2.default).install();
	  modules.unshift(_angular4.default.moduleName);
	}
	
	module.exports = _angular2.default.module('common', modules).name;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(644);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/less-loader/lib/loader.js!./index.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/less-loader/lib/loader.js!./index.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	exports.i(__webpack_require__(255), "");
	
	// module
	exports.push([module.id, "od-comps-map,[od-comps-map]{display:block;height:320px}od-comps-map .leaflet-container,[od-comps-map] .leaflet-container{z-index:1}od-comps-map .price-icon,[od-comps-map] .price-icon{position:absolute;margin-top:-36px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;padding:8px;background-color:#fff;font-size:12px;font-weight:500}od-comps-map .price-icon:after,[od-comps-map] .price-icon:after{top:100%;left:50%;border:solid transparent;content:\"\";height:0;width:0;position:absolute;pointer-events:none;border-top-color:#fff;border-width:6px;margin-left:-6px}od-comps-map .price-icon.subject,[od-comps-map] .price-icon.subject{background-color:#1c85e8;color:#fff;margin-left:-60px;width:120px}od-comps-map .price-icon.subject .ellipsis,[od-comps-map] .price-icon.subject .ellipsis{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}od-comps-map .price-icon.subject:after,[od-comps-map] .price-icon.subject:after{border-top-color:#1c85e8}od-comps-map .price-icon.comp,[od-comps-map] .price-icon.comp{margin-left:-45px;width:90px;-webkit-box-shadow:0 0 5px rgba(0,0,0,0.2);box-shadow:0 0 5px rgba(0,0,0,0.2)}od-comps-map .price-icon .comp-label,[od-comps-map] .price-icon .comp-label{color:#1c85e8;margin-right:6px;font-size:10px;text-transform:uppercase}od-comps-map .price-icon.hover,[od-comps-map] .price-icon.hover{background-color:#318db4;color:#fff}od-comps-map .price-icon.hover:after,[od-comps-map] .price-icon.hover:after{border-top-color:#318db4}od-comps-map .price-icon.hover .comp-label,[od-comps-map] .price-icon.hover .comp-label{color:#fff}od-comps-map .marker-overlay,[od-comps-map] .marker-overlay{position:absolute;margin-top:-8px;padding-top:8px;z-index:0;font-size:12px;text-align:left}od-comps-map .marker-overlay img,[od-comps-map] .marker-overlay img{height:80px;max-width:100px;padding-right:12px;float:left}od-comps-map .marker-overlay .hover-details,[od-comps-map] .marker-overlay .hover-details{-webkit-box-shadow:0 0 2px 1px rgba(192,192,191,0.3);box-shadow:0 0 2px 1px rgba(192,192,191,0.3);visibility:hidden;opacity:0;line-height:150%;background:#fff;color:#595959;overflow:hidden;-webkit-border-radius:3px;border-radius:3px;height:80px;width:310px;margin-top:5px;-webkit-transform:translateY(5px);transform:translateY(5px);-webkit-transition:opacity ease-in-out .3s,-webkit-transform ease-in-out .3s;transition:opacity ease-in-out .3s,-webkit-transform ease-in-out .3s;transition:transform ease-in-out .3s,opacity ease-in-out .3s;transition:transform ease-in-out .3s,opacity ease-in-out .3s,-webkit-transform ease-in-out .3s}od-comps-map .marker-overlay .info,[od-comps-map] .marker-overlay .info{padding:12px;padding-top:.5em}od-comps-map .marker-overlay.hover,[od-comps-map] .marker-overlay.hover{z-index:2000}od-comps-map .marker-overlay.hover .hover-details,[od-comps-map] .marker-overlay.hover .hover-details{visibility:visible;opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}.pika-single button{min-width:0}.pika-single .pika-prev,.pika-single .pika-next{width:20px !important}.pika-single .pika-button{padding:5px !important}@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}.set-close-date-datepicker-pre-sign .is-disabled,.set-close-date-datepicker-post-sign .is-disabled{position:relative}.set-close-date-datepicker-pre-sign .is-disabled::after,.set-close-date-datepicker-post-sign .is-disabled::after{background-color:#fff;bottom:20px;-webkit-box-shadow:0 1px 5px 0 rgba(0,0,0,0.5);box-shadow:0 1px 5px 0 rgba(0,0,0,0.5);color:#9ba1a6;font-family:'Graphik',sans-serif;font-size:16px;left:35px;opacity:0;padding:0 10px;position:absolute;-webkit-transition:opacity .15s;transition:opacity .15s;visibility:hidden;width:200px;z-index:9999}.set-close-date-datepicker-pre-sign .is-disabled:hover::after,.set-close-date-datepicker-post-sign .is-disabled:hover::after{opacity:1;visibility:visible}.pika-single.set-close-date-datepicker-pre-sign .is-disabled::after{content:'This day is unavailable. If you need to close on this day, please contact your Home Advisor.'}.pika-single.set-close-date-datepicker-post-sign .is-disabled::after{content:'This day is unavailable. If you need to close on this day, please contact your Closing Manager.'}.photo-carousel .photo-carousel-container{position:relative;width:100%}.photo-carousel .photo-carousel-item{width:100%;height:100%}.photo-carousel .photo-carousel-control-mixin{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);background-color:rgba(255,255,255,0.5);width:50px;height:50px;opacity:1;color:white;cursor:pointer;-webkit-border-radius:50%;border-radius:50%;-webkit-transition:opacity .25s ease-in-out;transition:opacity .25s ease-in-out}.photo-carousel .photo-carousel-control-mixin .icon{fill:rgba(0,0,0,0.6);position:relative;top:13px;left:-15px}.photo-carousel .photo-carousel-control-mixin:hover{opacity:1}.photo-carousel .photo-carousel-next{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);background-color:rgba(255,255,255,0.5);width:50px;height:50px;opacity:1;color:white;cursor:pointer;-webkit-border-radius:50%;border-radius:50%;-webkit-transition:opacity .25s ease-in-out;transition:opacity .25s ease-in-out;right:10px;text-align:right}.photo-carousel .photo-carousel-next .icon{fill:rgba(0,0,0,0.6);position:relative;top:13px;left:-15px}.photo-carousel .photo-carousel-next:hover{opacity:1}.photo-carousel .photo-carousel-prev{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);background-color:rgba(255,255,255,0.5);width:50px;height:50px;opacity:1;color:white;cursor:pointer;-webkit-border-radius:50%;border-radius:50%;-webkit-transition:opacity .25s ease-in-out;transition:opacity .25s ease-in-out;left:10px}.photo-carousel .photo-carousel-prev .icon{fill:rgba(0,0,0,0.6);position:relative;top:13px;left:-15px}.photo-carousel .photo-carousel-prev:hover{opacity:1}.photo-carousel .photo-carousel-prev .icon{left:15px}.oc-details-map{height:320px}.oc-details-map .leaflet-container{z-index:1}.oc-details-map .price-icon{-webkit-border-radius:14px;border-radius:14px;margin-left:-50px;margin-top:-30px;padding:.3em 14px;width:100px;background-color:#1c85e8;color:#fff;font-weight:400;text-align:center}.oc-details-map .price-icon:after{top:100%;left:50%;border:solid transparent;content:\"\";height:0;width:0;position:absolute;pointer-events:none;border-top-color:#1c85e8;border-width:6px;margin-left:-6px}.oc-details-map .price-icon.hover{background-color:#318db4}.oc-details-map .price-icon.hover:after{border-top-color:#318db4}.oc-details-map .price-icon.subject{background-color:#0d67f8}.oc-details-map .price-icon.subject:after{border-top-color:#0d67f8}.oc-details-map .marker-overlay{position:absolute;margin-top:-8px;padding-top:8px;z-index:0;text-align:left}.oc-details-map .marker-overlay img{height:80px;max-width:100px;padding-right:12px;float:left}.oc-details-map .marker-overlay .hover-details{-webkit-box-shadow:0 0 2px 1px rgba(192,192,191,0.3);box-shadow:0 0 2px 1px rgba(192,192,191,0.3);visibility:hidden;opacity:0;line-height:150%;background:#fff;color:#595959;overflow:hidden;-webkit-border-radius:3px;border-radius:3px;height:80px;width:310px;margin-top:5px;-webkit-transform:translateY(5px);transform:translateY(5px);-webkit-transition:opacity ease-in-out .3s,-webkit-transform ease-in-out .3s;transition:opacity ease-in-out .3s,-webkit-transform ease-in-out .3s;transition:transform ease-in-out .3s,opacity ease-in-out .3s;transition:transform ease-in-out .3s,opacity ease-in-out .3s,-webkit-transform ease-in-out .3s}.oc-details-map .marker-overlay .info{padding:12px;padding-top:.5em}.oc-details-map .marker-overlay.hover{z-index:2000}.oc-details-map .marker-overlay.hover .hover-details{visibility:visible;opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}od-market-analysis-chart{display:block;font-size:14px}od-market-analysis-chart svg:not(:root){overflow:visible}od-market-analysis-chart .axis line,od-market-analysis-chart .axis path{fill:none;stroke:rgba(192,192,191,0.3);shape-rendering:crispEdges}od-market-analysis-chart .grid line{fill:none;stroke:rgba(192,192,191,0.3);shape-rendering:crispEdges}od-market-analysis-chart .grid path{display:none}od-market-analysis-chart path.line,od-market-analysis-chart .legend line{fill:none}od-market-analysis-chart path.line.postal_code,od-market-analysis-chart .legend line.postal_code{stroke:#1c85e8;stroke-width:3px}od-market-analysis-chart path.line.city,od-market-analysis-chart .legend line.city{stroke:#4e6373;stroke-dasharray:6,2}od-market-analysis-chart path.line.market,od-market-analysis-chart .legend line.market{stroke:#9ba1a6;stroke-dasharray:6,2}@-webkit-keyframes bounce{0%,20%,50%,80%,100%{-webkit-transform:translateY(0);transform:translateY(0)}40%{-webkit-transform:translateY(-20px);transform:translateY(-20px)}60%{-webkit-transform:translateY(-10px);transform:translateY(-10px)}}@keyframes bounce{0%,20%,50%,80%,100%{-webkit-transform:translateY(0);transform:translateY(0)}40%{-webkit-transform:translateY(-20px);transform:translateY(-20px)}60%{-webkit-transform:translateY(-10px);transform:translateY(-10px)}}@-webkit-keyframes in-progress-rotate{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes in-progress-rotate{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}img.tracking-pixel{width:1px;height:1px;border-style:none;position:absolute;top:-1000px;left:-1000px}.background-image,.background-image-top{background-size:cover;background-position:center;background-color:#f5f8fb;background-repeat:no-repeat}.background-image-top{background-position:center top}.od-xhr-progress{position:relative;-webkit-transition:all ease-in-out .1s;transition:all ease-in-out .1s}.od-xhr-progress:after{content:'';position:absolute;display:block;top:50%;left:50%;width:18px;height:18px;margin-top:-12px;margin-left:-12px;-webkit-border-radius:100%;border-radius:100%;border:solid 3px transparent;-webkit-animation:none;animation:none}.od-xhr-progress.in-progress{color:transparent}.od-xhr-progress.in-progress:hover{color:transparent}.od-xhr-progress.in-progress:after{z-index:2;border-color:#fff;border-bottom-color:transparent;-webkit-animation:in-progress-rotate .6s infinite linear;animation:in-progress-rotate .6s infinite linear}.od-xhr-progress.dark{position:relative;-webkit-transition:all ease-in-out .1s;transition:all ease-in-out .1s}.od-xhr-progress.dark:after{content:'';position:absolute;display:block;top:50%;left:50%;width:18px;height:18px;margin-top:-12px;margin-left:-12px;-webkit-border-radius:100%;border-radius:100%;border:solid 3px transparent;-webkit-animation:none;animation:none}.od-xhr-progress.dark.in-progress{color:transparent}.od-xhr-progress.dark.in-progress:hover{color:transparent}.od-xhr-progress.dark.in-progress:after{z-index:2;border-color:#9ba1a6;border-bottom-color:transparent;-webkit-animation:in-progress-rotate .6s infinite linear;animation:in-progress-rotate .6s infinite linear}.inline{display:inline-block !important}.compact{padding:0;margin:0}.pre{white-space:pre-line}.vw100{width:100vw}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}html.js [ng\\:cloak],html.js [ng-cloak],html.js [data-ng-cloak],html.js [x-ng-cloak],html.js .ng-cloak,html.js .x-ng-cloak{display:none !important}@media (min-width:480px){.hidden-xs-up{display:none !important}}@media (min-width:768px){.hidden-sm-up{display:none !important}}@media (min-width:992px){.hidden-md-up{display:none !important}}@media (min-width:1200px){.hidden-lg-up{display:none !important}}@media (max-width:479px){.hidden-xxs-down{display:none !important}}@media (max-width:767px){.hidden-xs-down{display:none !important}}@media (max-width:991px){.hidden-sm-down{display:none !important}}@media (max-width:1199px){.hidden-md-down{display:none !important}}@media (max-width:1200px){.hidden-lg-down{display:none !important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none !important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none !important}}.pager li{display:inline-block}.pager li .button{min-width:140px}.pager li+li{margin-left:5px}.text-space-between{margin-left:-2px;margin-right:-2px}.text-space-between>*{margin-left:2px;margin-right:2px}img.img-circle{-webkit-border-radius:100%;border-radius:100%}img.img-circle.large{width:90px;height:90px}img.img-circle.medium{width:70px;height:70px}img.img-circle.small{width:50px;height:50px}.oc-login-link .ng-enter,.oc-login-link .ng-leave,.oc-login-link .ng-animate{-webkit-transition:none !important;transition:none !important;-webkit-animation:none 0s;animation:none 0s}.cursor-pointer{cursor:pointer}.flex-center-content{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}.flex-right-content{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end}.flex-align-center{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}.flex-align-end{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:end;-webkit-align-items:flex-end;-ms-flex-align:end;align-items:flex-end}.flex-space-between-content{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.flex{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.flex-wrap{-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.flex-grow{-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1}", ""]);
	
	// exports


/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Enforces a single instance of the Raven client, and the
	 * main entry point for Raven. If you are a consumer of the
	 * Raven library, you SHOULD load this file (vs raven.js).
	 **/
	
	var RavenConstructor = __webpack_require__(646);
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	var _Raven = _window.Raven;
	
	var Raven = new RavenConstructor();
	
	/*
	 * Allow multiple versions of Raven to be installed.
	 * Strip Raven from the global context and returns the instance.
	 *
	 * @return {Raven}
	 */
	Raven.noConflict = function() {
	  _window.Raven = _Raven;
	  return Raven;
	};
	
	Raven.afterLoad();
	
	module.exports = Raven;
	
	/**
	 * DISCLAIMER:
	 *
	 * Expose `Client` constructor for cases where user want to track multiple "sub-applications" in one larger app.
	 * It's not meant to be used by a wide audience, so pleaaase make sure that you know what you're doing before using it.
	 * Accidentally calling `install` multiple times, may result in an unexpected behavior that's very hard to debug.
	 *
	 * It's called `Client' to be in-line with Raven Node implementation.
	 *
	 * HOWTO:
	 *
	 * import Raven from 'raven-js';
	 *
	 * const someAppReporter = new Raven.Client();
	 * const someOtherAppReporter = new Raven.Client();
	 *
	 * someAppReporter('__DSN__', {
	 *   ...config goes here
	 * });
	 *
	 * someOtherAppReporter('__OTHER_DSN__', {
	 *   ...config goes here
	 * });
	 *
	 * someAppReporter.captureMessage(...);
	 * someAppReporter.captureException(...);
	 * someAppReporter.captureBreadcrumb(...);
	 *
	 * someOtherAppReporter.captureMessage(...);
	 * someOtherAppReporter.captureException(...);
	 * someOtherAppReporter.captureBreadcrumb(...);
	 *
	 * It should "just work".
	 */
	module.exports.Client = RavenConstructor;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false */
	
	var TraceKit = __webpack_require__(647);
	var stringify = __webpack_require__(649);
	var md5 = __webpack_require__(650);
	var RavenConfigError = __webpack_require__(651);
	
	var utils = __webpack_require__(648);
	var isError = utils.isError;
	var isObject = utils.isObject;
	var isPlainObject = utils.isPlainObject;
	var isErrorEvent = utils.isErrorEvent;
	var isUndefined = utils.isUndefined;
	var isFunction = utils.isFunction;
	var isString = utils.isString;
	var isArray = utils.isArray;
	var isEmptyObject = utils.isEmptyObject;
	var each = utils.each;
	var objectMerge = utils.objectMerge;
	var truncate = utils.truncate;
	var objectFrozen = utils.objectFrozen;
	var hasKey = utils.hasKey;
	var joinRegExp = utils.joinRegExp;
	var urlencode = utils.urlencode;
	var uuid4 = utils.uuid4;
	var htmlTreeAsString = utils.htmlTreeAsString;
	var isSameException = utils.isSameException;
	var isSameStacktrace = utils.isSameStacktrace;
	var parseUrl = utils.parseUrl;
	var fill = utils.fill;
	var supportsFetch = utils.supportsFetch;
	var supportsReferrerPolicy = utils.supportsReferrerPolicy;
	var serializeKeysForMessage = utils.serializeKeysForMessage;
	var serializeException = utils.serializeException;
	var sanitize = utils.sanitize;
	
	var wrapConsoleMethod = __webpack_require__(652).wrapMethod;
	
	var dsnKeys = 'source protocol user pass host port path'.split(' '),
	  dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;
	
	function now() {
	  return +new Date();
	}
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	var _document = _window.document;
	var _navigator = _window.navigator;
	
	function keepOriginalCallback(original, callback) {
	  return isFunction(callback)
	    ? function(data) {
	        return callback(data, original);
	      }
	    : callback;
	}
	
	// First, check for JSON support
	// If there is no JSON, we no-op the core features of Raven
	// since JSON is required to encode the payload
	function Raven() {
	  this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
	  // Raven can run in contexts where there's no document (react-native)
	  this._hasDocument = !isUndefined(_document);
	  this._hasNavigator = !isUndefined(_navigator);
	  this._lastCapturedException = null;
	  this._lastData = null;
	  this._lastEventId = null;
	  this._globalServer = null;
	  this._globalKey = null;
	  this._globalProject = null;
	  this._globalContext = {};
	  this._globalOptions = {
	    // SENTRY_RELEASE can be injected by https://github.com/getsentry/sentry-webpack-plugin
	    release: _window.SENTRY_RELEASE && _window.SENTRY_RELEASE.id,
	    logger: 'javascript',
	    ignoreErrors: [],
	    ignoreUrls: [],
	    whitelistUrls: [],
	    includePaths: [],
	    headers: null,
	    collectWindowErrors: true,
	    captureUnhandledRejections: true,
	    maxMessageLength: 0,
	    // By default, truncates URL values to 250 chars
	    maxUrlLength: 250,
	    stackTraceLimit: 50,
	    autoBreadcrumbs: true,
	    instrument: true,
	    sampleRate: 1,
	    sanitizeKeys: []
	  };
	  this._fetchDefaults = {
	    method: 'POST',
	    keepalive: true,
	    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	    // https://caniuse.com/#feat=referrer-policy
	    // It doesn't. And it throw exception instead of ignoring this parameter...
	    // REF: https://github.com/getsentry/raven-js/issues/1233
	    referrerPolicy: supportsReferrerPolicy() ? 'origin' : ''
	  };
	  this._ignoreOnError = 0;
	  this._isRavenInstalled = false;
	  this._originalErrorStackTraceLimit = Error.stackTraceLimit;
	  // capture references to window.console *and* all its methods first
	  // before the console plugin has a chance to monkey patch
	  this._originalConsole = _window.console || {};
	  this._originalConsoleMethods = {};
	  this._plugins = [];
	  this._startTime = now();
	  this._wrappedBuiltIns = [];
	  this._breadcrumbs = [];
	  this._lastCapturedEvent = null;
	  this._keypressTimeout;
	  this._location = _window.location;
	  this._lastHref = this._location && this._location.href;
	  this._resetBackoff();
	
	  // eslint-disable-next-line guard-for-in
	  for (var method in this._originalConsole) {
	    this._originalConsoleMethods[method] = this._originalConsole[method];
	  }
	}
	
	/*
	 * The core Raven singleton
	 *
	 * @this {Raven}
	 */
	
	Raven.prototype = {
	  // Hardcode version string so that raven source can be loaded directly via
	  // webpack (using a build step causes webpack #1617). Grunt verifies that
	  // this value matches package.json during build.
	  //   See: https://github.com/getsentry/raven-js/issues/465
	  VERSION: '3.24.0',
	
	  debug: false,
	
	  TraceKit: TraceKit, // alias to TraceKit
	
	  /*
	     * Configure Raven with a DSN and extra options
	     *
	     * @param {string} dsn The public Sentry DSN
	     * @param {object} options Set of global options [optional]
	     * @return {Raven}
	     */
	  config: function(dsn, options) {
	    var self = this;
	
	    if (self._globalServer) {
	      this._logDebug('error', 'Error: Raven has already been configured');
	      return self;
	    }
	    if (!dsn) return self;
	
	    var globalOptions = self._globalOptions;
	
	    // merge in options
	    if (options) {
	      each(options, function(key, value) {
	        // tags and extra are special and need to be put into context
	        if (key === 'tags' || key === 'extra' || key === 'user') {
	          self._globalContext[key] = value;
	        } else {
	          globalOptions[key] = value;
	        }
	      });
	    }
	
	    self.setDSN(dsn);
	
	    // "Script error." is hard coded into browsers for errors that it can't read.
	    // this is the result of a script being pulled in from an external domain and CORS.
	    globalOptions.ignoreErrors.push(/^Script error\.?$/);
	    globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);
	
	    // join regexp rules into one big rule
	    globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
	    globalOptions.ignoreUrls = globalOptions.ignoreUrls.length
	      ? joinRegExp(globalOptions.ignoreUrls)
	      : false;
	    globalOptions.whitelistUrls = globalOptions.whitelistUrls.length
	      ? joinRegExp(globalOptions.whitelistUrls)
	      : false;
	    globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
	    globalOptions.maxBreadcrumbs = Math.max(
	      0,
	      Math.min(globalOptions.maxBreadcrumbs || 100, 100)
	    ); // default and hard limit is 100
	
	    var autoBreadcrumbDefaults = {
	      xhr: true,
	      console: true,
	      dom: true,
	      location: true,
	      sentry: true
	    };
	
	    var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
	    if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
	      autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
	    } else if (autoBreadcrumbs !== false) {
	      autoBreadcrumbs = autoBreadcrumbDefaults;
	    }
	    globalOptions.autoBreadcrumbs = autoBreadcrumbs;
	
	    var instrumentDefaults = {
	      tryCatch: true
	    };
	
	    var instrument = globalOptions.instrument;
	    if ({}.toString.call(instrument) === '[object Object]') {
	      instrument = objectMerge(instrumentDefaults, instrument);
	    } else if (instrument !== false) {
	      instrument = instrumentDefaults;
	    }
	    globalOptions.instrument = instrument;
	
	    TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;
	
	    // return for chaining
	    return self;
	  },
	
	  /*
	     * Installs a global window.onerror error handler
	     * to capture and report uncaught exceptions.
	     * At this point, install() is required to be called due
	     * to the way TraceKit is set up.
	     *
	     * @return {Raven}
	     */
	  install: function() {
	    var self = this;
	    if (self.isSetup() && !self._isRavenInstalled) {
	      TraceKit.report.subscribe(function() {
	        self._handleOnErrorStackInfo.apply(self, arguments);
	      });
	
	      if (self._globalOptions.captureUnhandledRejections) {
	        self._attachPromiseRejectionHandler();
	      }
	
	      self._patchFunctionToString();
	
	      if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
	        self._instrumentTryCatch();
	      }
	
	      if (self._globalOptions.autoBreadcrumbs) self._instrumentBreadcrumbs();
	
	      // Install all of the plugins
	      self._drainPlugins();
	
	      self._isRavenInstalled = true;
	    }
	
	    Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
	    return this;
	  },
	
	  /*
	     * Set the DSN (can be called multiple time unlike config)
	     *
	     * @param {string} dsn The public Sentry DSN
	     */
	  setDSN: function(dsn) {
	    var self = this,
	      uri = self._parseDSN(dsn),
	      lastSlash = uri.path.lastIndexOf('/'),
	      path = uri.path.substr(1, lastSlash);
	
	    self._dsn = dsn;
	    self._globalKey = uri.user;
	    self._globalSecret = uri.pass && uri.pass.substr(1);
	    self._globalProject = uri.path.substr(lastSlash + 1);
	
	    self._globalServer = self._getGlobalServer(uri);
	
	    self._globalEndpoint =
	      self._globalServer + '/' + path + 'api/' + self._globalProject + '/store/';
	
	    // Reset backoff state since we may be pointing at a
	    // new project/server
	    this._resetBackoff();
	  },
	
	  /*
	     * Wrap code within a context so Raven can capture errors
	     * reliably across domains that is executed immediately.
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The callback to be immediately executed within the context
	     * @param {array} args An array of arguments to be called with the callback [optional]
	     */
	  context: function(options, func, args) {
	    if (isFunction(options)) {
	      args = func || [];
	      func = options;
	      options = undefined;
	    }
	
	    return this.wrap(options, func).apply(this, args);
	  },
	
	  /*
	     * Wrap code within a context and returns back a new function to be executed
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The function to be wrapped in a new context
	     * @param {function} func A function to call before the try/catch wrapper [optional, private]
	     * @return {function} The newly wrapped functions with a context
	     */
	  wrap: function(options, func, _before) {
	    var self = this;
	    // 1 argument has been passed, and it's not a function
	    // so just return it
	    if (isUndefined(func) && !isFunction(options)) {
	      return options;
	    }
	
	    // options is optional
	    if (isFunction(options)) {
	      func = options;
	      options = undefined;
	    }
	
	    // At this point, we've passed along 2 arguments, and the second one
	    // is not a function either, so we'll just return the second argument.
	    if (!isFunction(func)) {
	      return func;
	    }
	
	    // We don't wanna wrap it twice!
	    try {
	      if (func.__raven__) {
	        return func;
	      }
	
	      // If this has already been wrapped in the past, return that
	      if (func.__raven_wrapper__) {
	        return func.__raven_wrapper__;
	      }
	    } catch (e) {
	      // Just accessing custom props in some Selenium environments
	      // can cause a "Permission denied" exception (see raven-js#495).
	      // Bail on wrapping and return the function as-is (defers to window.onerror).
	      return func;
	    }
	
	    function wrapped() {
	      var args = [],
	        i = arguments.length,
	        deep = !options || (options && options.deep !== false);
	
	      if (_before && isFunction(_before)) {
	        _before.apply(this, arguments);
	      }
	
	      // Recursively wrap all of a function's arguments that are
	      // functions themselves.
	      while (i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];
	
	      try {
	        // Attempt to invoke user-land function
	        // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
	        //       means Raven caught an error invoking your application code. This is
	        //       expected behavior and NOT indicative of a bug with Raven.js.
	        return func.apply(this, args);
	      } catch (e) {
	        self._ignoreNextOnError();
	        self.captureException(e, options);
	        throw e;
	      }
	    }
	
	    // copy over properties of the old function
	    for (var property in func) {
	      if (hasKey(func, property)) {
	        wrapped[property] = func[property];
	      }
	    }
	    wrapped.prototype = func.prototype;
	
	    func.__raven_wrapper__ = wrapped;
	    // Signal that this function has been wrapped/filled already
	    // for both debugging and to prevent it to being wrapped/filled twice
	    wrapped.__raven__ = true;
	    wrapped.__orig__ = func;
	
	    return wrapped;
	  },
	
	  /**
	   * Uninstalls the global error handler.
	   *
	   * @return {Raven}
	   */
	  uninstall: function() {
	    TraceKit.report.uninstall();
	
	    this._detachPromiseRejectionHandler();
	    this._unpatchFunctionToString();
	    this._restoreBuiltIns();
	    this._restoreConsole();
	
	    Error.stackTraceLimit = this._originalErrorStackTraceLimit;
	    this._isRavenInstalled = false;
	
	    return this;
	  },
	
	  /**
	   * Callback used for `unhandledrejection` event
	   *
	   * @param {PromiseRejectionEvent} event An object containing
	   *   promise: the Promise that was rejected
	   *   reason: the value with which the Promise was rejected
	   * @return void
	   */
	  _promiseRejectionHandler: function(event) {
	    this._logDebug('debug', 'Raven caught unhandled promise rejection:', event);
	    this.captureException(event.reason);
	  },
	
	  /**
	   * Installs the global promise rejection handler.
	   *
	   * @return {raven}
	   */
	  _attachPromiseRejectionHandler: function() {
	    this._promiseRejectionHandler = this._promiseRejectionHandler.bind(this);
	    _window.addEventListener &&
	      _window.addEventListener('unhandledrejection', this._promiseRejectionHandler);
	    return this;
	  },
	
	  /**
	   * Uninstalls the global promise rejection handler.
	   *
	   * @return {raven}
	   */
	  _detachPromiseRejectionHandler: function() {
	    _window.removeEventListener &&
	      _window.removeEventListener('unhandledrejection', this._promiseRejectionHandler);
	    return this;
	  },
	
	  /**
	   * Manually capture an exception and send it over to Sentry
	   *
	   * @param {error} ex An exception to be logged
	   * @param {object} options A specific set of options for this error [optional]
	   * @return {Raven}
	   */
	  captureException: function(ex, options) {
	    options = objectMerge({trimHeadFrames: 0}, options ? options : {});
	
	    if (isErrorEvent(ex) && ex.error) {
	      // If it is an ErrorEvent with `error` property, extract it to get actual Error
	      ex = ex.error;
	    } else if (isError(ex)) {
	      // we have a real Error object
	      ex = ex;
	    } else if (isPlainObject(ex)) {
	      // If it is plain Object, serialize it manually and extract options
	      // This will allow us to group events based on top-level keys
	      // which is much better than creating new group when any key/value change
	      options = this._getCaptureExceptionOptionsFromPlainObject(options, ex);
	      ex = new Error(options.message);
	    } else {
	      // If none of previous checks were valid, then it means that
	      // it's not a plain Object
	      // it's not a valid ErrorEvent (one with an error property)
	      // it's not an Error
	      // So bail out and capture it as a simple message:
	      return this.captureMessage(
	        ex,
	        objectMerge(options, {
	          stacktrace: true, // if we fall back to captureMessage, default to attempting a new trace
	          trimHeadFrames: options.trimHeadFrames + 1
	        })
	      );
	    }
	
	    // Store the raw exception object for potential debugging and introspection
	    this._lastCapturedException = ex;
	
	    // TraceKit.report will re-raise any exception passed to it,
	    // which means you have to wrap it in try/catch. Instead, we
	    // can wrap it here and only re-raise if TraceKit.report
	    // raises an exception different from the one we asked to
	    // report on.
	    try {
	      var stack = TraceKit.computeStackTrace(ex);
	      this._handleStackInfo(stack, options);
	    } catch (ex1) {
	      if (ex !== ex1) {
	        throw ex1;
	      }
	    }
	
	    return this;
	  },
	
	  _getCaptureExceptionOptionsFromPlainObject: function(currentOptions, ex) {
	    var exKeys = Object.keys(ex).sort();
	    var options = objectMerge(currentOptions, {
	      message:
	        'Non-Error exception captured with keys: ' + serializeKeysForMessage(exKeys),
	      fingerprint: [md5(exKeys)],
	      extra: currentOptions.extra || {}
	    });
	    options.extra.__serialized__ = serializeException(ex);
	
	    return options;
	  },
	
	  /*
	     * Manually send a message to Sentry
	     *
	     * @param {string} msg A plain message to be captured in Sentry
	     * @param {object} options A specific set of options for this message [optional]
	     * @return {Raven}
	     */
	  captureMessage: function(msg, options) {
	    // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
	    // early call; we'll error on the side of logging anything called before configuration since it's
	    // probably something you should see:
	    if (
	      !!this._globalOptions.ignoreErrors.test &&
	      this._globalOptions.ignoreErrors.test(msg)
	    ) {
	      return;
	    }
	
	    options = options || {};
	    msg = msg + ''; // Make sure it's actually a string
	
	    var data = objectMerge(
	      {
	        message: msg
	      },
	      options
	    );
	
	    var ex;
	    // Generate a "synthetic" stack trace from this point.
	    // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
	    //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
	    //       or if it catches a thrown object without a "stack" property.
	    try {
	      throw new Error(msg);
	    } catch (ex1) {
	      ex = ex1;
	    }
	
	    // null exception name so `Error` isn't prefixed to msg
	    ex.name = null;
	    var stack = TraceKit.computeStackTrace(ex);
	
	    // stack[0] is `throw new Error(msg)` call itself, we are interested in the frame that was just before that, stack[1]
	    var initialCall = isArray(stack.stack) && stack.stack[1];
	    var fileurl = (initialCall && initialCall.url) || '';
	
	    if (
	      !!this._globalOptions.ignoreUrls.test &&
	      this._globalOptions.ignoreUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    if (
	      !!this._globalOptions.whitelistUrls.test &&
	      !this._globalOptions.whitelistUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    if (this._globalOptions.stacktrace || (options && options.stacktrace)) {
	      // fingerprint on msg, not stack trace (legacy behavior, could be revisited)
	      data.fingerprint = data.fingerprint == null ? msg : data.fingerprint;
	
	      options = objectMerge(
	        {
	          trimHeadFrames: 0
	        },
	        options
	      );
	      // Since we know this is a synthetic trace, the top frame (this function call)
	      // MUST be from Raven.js, so mark it for trimming
	      // We add to the trim counter so that callers can choose to trim extra frames, such
	      // as utility functions.
	      options.trimHeadFrames += 1;
	
	      var frames = this._prepareFrames(stack, options);
	      data.stacktrace = {
	        // Sentry expects frames oldest to newest
	        frames: frames.reverse()
	      };
	    }
	
	    // Make sure that fingerprint is always wrapped in an array
	    if (data.fingerprint) {
	      data.fingerprint = isArray(data.fingerprint)
	        ? data.fingerprint
	        : [data.fingerprint];
	    }
	
	    // Fire away!
	    this._send(data);
	
	    return this;
	  },
	
	  captureBreadcrumb: function(obj) {
	    var crumb = objectMerge(
	      {
	        timestamp: now() / 1000
	      },
	      obj
	    );
	
	    if (isFunction(this._globalOptions.breadcrumbCallback)) {
	      var result = this._globalOptions.breadcrumbCallback(crumb);
	
	      if (isObject(result) && !isEmptyObject(result)) {
	        crumb = result;
	      } else if (result === false) {
	        return this;
	      }
	    }
	
	    this._breadcrumbs.push(crumb);
	    if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
	      this._breadcrumbs.shift();
	    }
	    return this;
	  },
	
	  addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
	    var pluginArgs = [].slice.call(arguments, 1);
	
	    this._plugins.push([plugin, pluginArgs]);
	    if (this._isRavenInstalled) {
	      this._drainPlugins();
	    }
	
	    return this;
	  },
	
	  /*
	     * Set/clear a user to be sent along with the payload.
	     *
	     * @param {object} user An object representing user data [optional]
	     * @return {Raven}
	     */
	  setUserContext: function(user) {
	    // Intentionally do not merge here since that's an unexpected behavior.
	    this._globalContext.user = user;
	
	    return this;
	  },
	
	  /*
	     * Merge extra attributes to be sent along with the payload.
	     *
	     * @param {object} extra An object representing extra data [optional]
	     * @return {Raven}
	     */
	  setExtraContext: function(extra) {
	    this._mergeContext('extra', extra);
	
	    return this;
	  },
	
	  /*
	     * Merge tags to be sent along with the payload.
	     *
	     * @param {object} tags An object representing tags [optional]
	     * @return {Raven}
	     */
	  setTagsContext: function(tags) {
	    this._mergeContext('tags', tags);
	
	    return this;
	  },
	
	  /*
	     * Clear all of the context.
	     *
	     * @return {Raven}
	     */
	  clearContext: function() {
	    this._globalContext = {};
	
	    return this;
	  },
	
	  /*
	     * Get a copy of the current context. This cannot be mutated.
	     *
	     * @return {object} copy of context
	     */
	  getContext: function() {
	    // lol javascript
	    return JSON.parse(stringify(this._globalContext));
	  },
	
	  /*
	     * Set environment of application
	     *
	     * @param {string} environment Typically something like 'production'.
	     * @return {Raven}
	     */
	  setEnvironment: function(environment) {
	    this._globalOptions.environment = environment;
	
	    return this;
	  },
	
	  /*
	     * Set release version of application
	     *
	     * @param {string} release Typically something like a git SHA to identify version
	     * @return {Raven}
	     */
	  setRelease: function(release) {
	    this._globalOptions.release = release;
	
	    return this;
	  },
	
	  /*
	     * Set the dataCallback option
	     *
	     * @param {function} callback The callback to run which allows the
	     *                            data blob to be mutated before sending
	     * @return {Raven}
	     */
	  setDataCallback: function(callback) {
	    var original = this._globalOptions.dataCallback;
	    this._globalOptions.dataCallback = keepOriginalCallback(original, callback);
	    return this;
	  },
	
	  /*
	     * Set the breadcrumbCallback option
	     *
	     * @param {function} callback The callback to run which allows filtering
	     *                            or mutating breadcrumbs
	     * @return {Raven}
	     */
	  setBreadcrumbCallback: function(callback) {
	    var original = this._globalOptions.breadcrumbCallback;
	    this._globalOptions.breadcrumbCallback = keepOriginalCallback(original, callback);
	    return this;
	  },
	
	  /*
	     * Set the shouldSendCallback option
	     *
	     * @param {function} callback The callback to run which allows
	     *                            introspecting the blob before sending
	     * @return {Raven}
	     */
	  setShouldSendCallback: function(callback) {
	    var original = this._globalOptions.shouldSendCallback;
	    this._globalOptions.shouldSendCallback = keepOriginalCallback(original, callback);
	    return this;
	  },
	
	  /**
	   * Override the default HTTP transport mechanism that transmits data
	   * to the Sentry server.
	   *
	   * @param {function} transport Function invoked instead of the default
	   *                             `makeRequest` handler.
	   *
	   * @return {Raven}
	   */
	  setTransport: function(transport) {
	    this._globalOptions.transport = transport;
	
	    return this;
	  },
	
	  /*
	     * Get the latest raw exception that was captured by Raven.
	     *
	     * @return {error}
	     */
	  lastException: function() {
	    return this._lastCapturedException;
	  },
	
	  /*
	     * Get the last event id
	     *
	     * @return {string}
	     */
	  lastEventId: function() {
	    return this._lastEventId;
	  },
	
	  /*
	     * Determine if Raven is setup and ready to go.
	     *
	     * @return {boolean}
	     */
	  isSetup: function() {
	    if (!this._hasJSON) return false; // needs JSON support
	    if (!this._globalServer) {
	      if (!this.ravenNotConfiguredError) {
	        this.ravenNotConfiguredError = true;
	        this._logDebug('error', 'Error: Raven has not been configured.');
	      }
	      return false;
	    }
	    return true;
	  },
	
	  afterLoad: function() {
	    // TODO: remove window dependence?
	
	    // Attempt to initialize Raven on load
	    var RavenConfig = _window.RavenConfig;
	    if (RavenConfig) {
	      this.config(RavenConfig.dsn, RavenConfig.config).install();
	    }
	  },
	
	  showReportDialog: function(options) {
	    if (
	      !_document // doesn't work without a document (React native)
	    )
	      return;
	
	    options = options || {};
	
	    var lastEventId = options.eventId || this.lastEventId();
	    if (!lastEventId) {
	      throw new RavenConfigError('Missing eventId');
	    }
	
	    var dsn = options.dsn || this._dsn;
	    if (!dsn) {
	      throw new RavenConfigError('Missing DSN');
	    }
	
	    var encode = encodeURIComponent;
	    var qs = '';
	    qs += '?eventId=' + encode(lastEventId);
	    qs += '&dsn=' + encode(dsn);
	
	    var user = options.user || this._globalContext.user;
	    if (user) {
	      if (user.name) qs += '&name=' + encode(user.name);
	      if (user.email) qs += '&email=' + encode(user.email);
	    }
	
	    var globalServer = this._getGlobalServer(this._parseDSN(dsn));
	
	    var script = _document.createElement('script');
	    script.async = true;
	    script.src = globalServer + '/api/embed/error-page/' + qs;
	    (_document.head || _document.body).appendChild(script);
	  },
	
	  /**** Private functions ****/
	  _ignoreNextOnError: function() {
	    var self = this;
	    this._ignoreOnError += 1;
	    setTimeout(function() {
	      // onerror should trigger before setTimeout
	      self._ignoreOnError -= 1;
	    });
	  },
	
	  _triggerEvent: function(eventType, options) {
	    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
	    var evt, key;
	
	    if (!this._hasDocument) return;
	
	    options = options || {};
	
	    eventType = 'raven' + eventType.substr(0, 1).toUpperCase() + eventType.substr(1);
	
	    if (_document.createEvent) {
	      evt = _document.createEvent('HTMLEvents');
	      evt.initEvent(eventType, true, true);
	    } else {
	      evt = _document.createEventObject();
	      evt.eventType = eventType;
	    }
	
	    for (key in options)
	      if (hasKey(options, key)) {
	        evt[key] = options[key];
	      }
	
	    if (_document.createEvent) {
	      // IE9 if standards
	      _document.dispatchEvent(evt);
	    } else {
	      // IE8 regardless of Quirks or Standards
	      // IE9 if quirks
	      try {
	        _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
	      } catch (e) {
	        // Do nothing
	      }
	    }
	  },
	
	  /**
	   * Wraps addEventListener to capture UI breadcrumbs
	   * @param evtName the event name (e.g. "click")
	   * @returns {Function}
	   * @private
	   */
	  _breadcrumbEventHandler: function(evtName) {
	    var self = this;
	    return function(evt) {
	      // reset keypress timeout; e.g. triggering a 'click' after
	      // a 'keypress' will reset the keypress debounce so that a new
	      // set of keypresses can be recorded
	      self._keypressTimeout = null;
	
	      // It's possible this handler might trigger multiple times for the same
	      // event (e.g. event propagation through node ancestors). Ignore if we've
	      // already captured the event.
	      if (self._lastCapturedEvent === evt) return;
	
	      self._lastCapturedEvent = evt;
	
	      // try/catch both:
	      // - accessing evt.target (see getsentry/raven-js#838, #768)
	      // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
	      //   can throw an exception in some circumstances.
	      var target;
	      try {
	        target = htmlTreeAsString(evt.target);
	      } catch (e) {
	        target = '<unknown>';
	      }
	
	      self.captureBreadcrumb({
	        category: 'ui.' + evtName, // e.g. ui.click, ui.input
	        message: target
	      });
	    };
	  },
	
	  /**
	   * Wraps addEventListener to capture keypress UI events
	   * @returns {Function}
	   * @private
	   */
	  _keypressEventHandler: function() {
	    var self = this,
	      debounceDuration = 1000; // milliseconds
	
	    // TODO: if somehow user switches keypress target before
	    //       debounce timeout is triggered, we will only capture
	    //       a single breadcrumb from the FIRST target (acceptable?)
	    return function(evt) {
	      var target;
	      try {
	        target = evt.target;
	      } catch (e) {
	        // just accessing event properties can throw an exception in some rare circumstances
	        // see: https://github.com/getsentry/raven-js/issues/838
	        return;
	      }
	      var tagName = target && target.tagName;
	
	      // only consider keypress events on actual input elements
	      // this will disregard keypresses targeting body (e.g. tabbing
	      // through elements, hotkeys, etc)
	      if (
	        !tagName ||
	        (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
	      )
	        return;
	
	      // record first keypress in a series, but ignore subsequent
	      // keypresses until debounce clears
	      var timeout = self._keypressTimeout;
	      if (!timeout) {
	        self._breadcrumbEventHandler('input')(evt);
	      }
	      clearTimeout(timeout);
	      self._keypressTimeout = setTimeout(function() {
	        self._keypressTimeout = null;
	      }, debounceDuration);
	    };
	  },
	
	  /**
	   * Captures a breadcrumb of type "navigation", normalizing input URLs
	   * @param to the originating URL
	   * @param from the target URL
	   * @private
	   */
	  _captureUrlChange: function(from, to) {
	    var parsedLoc = parseUrl(this._location.href);
	    var parsedTo = parseUrl(to);
	    var parsedFrom = parseUrl(from);
	
	    // because onpopstate only tells you the "new" (to) value of location.href, and
	    // not the previous (from) value, we need to track the value of the current URL
	    // state ourselves
	    this._lastHref = to;
	
	    // Use only the path component of the URL if the URL matches the current
	    // document (almost all the time when using pushState)
	    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
	      to = parsedTo.relative;
	    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
	      from = parsedFrom.relative;
	
	    this.captureBreadcrumb({
	      category: 'navigation',
	      data: {
	        to: to,
	        from: from
	      }
	    });
	  },
	
	  _patchFunctionToString: function() {
	    var self = this;
	    self._originalFunctionToString = Function.prototype.toString;
	    // eslint-disable-next-line no-extend-native
	    Function.prototype.toString = function() {
	      if (typeof this === 'function' && this.__raven__) {
	        return self._originalFunctionToString.apply(this.__orig__, arguments);
	      }
	      return self._originalFunctionToString.apply(this, arguments);
	    };
	  },
	
	  _unpatchFunctionToString: function() {
	    if (this._originalFunctionToString) {
	      // eslint-disable-next-line no-extend-native
	      Function.prototype.toString = this._originalFunctionToString;
	    }
	  },
	
	  /**
	   * Wrap timer functions and event targets to catch errors and provide
	   * better metadata.
	   */
	  _instrumentTryCatch: function() {
	    var self = this;
	
	    var wrappedBuiltIns = self._wrappedBuiltIns;
	
	    function wrapTimeFn(orig) {
	      return function(fn, t) {
	        // preserve arity
	        // Make a copy of the arguments to prevent deoptimization
	        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	        var args = new Array(arguments.length);
	        for (var i = 0; i < args.length; ++i) {
	          args[i] = arguments[i];
	        }
	        var originalCallback = args[0];
	        if (isFunction(originalCallback)) {
	          args[0] = self.wrap(originalCallback);
	        }
	
	        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
	        // also supports only two arguments and doesn't care what this is, so we
	        // can just call the original function directly.
	        if (orig.apply) {
	          return orig.apply(this, args);
	        } else {
	          return orig(args[0], args[1]);
	        }
	      };
	    }
	
	    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;
	
	    function wrapEventTarget(global) {
	      var proto = _window[global] && _window[global].prototype;
	      if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
	        fill(
	          proto,
	          'addEventListener',
	          function(orig) {
	            return function(evtName, fn, capture, secure) {
	              // preserve arity
	              try {
	                if (fn && fn.handleEvent) {
	                  fn.handleEvent = self.wrap(fn.handleEvent);
	                }
	              } catch (err) {
	                // can sometimes get 'Permission denied to access property "handle Event'
	              }
	
	              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
	              // so that we don't have more than one wrapper function
	              var before, clickHandler, keypressHandler;
	
	              if (
	                autoBreadcrumbs &&
	                autoBreadcrumbs.dom &&
	                (global === 'EventTarget' || global === 'Node')
	              ) {
	                // NOTE: generating multiple handlers per addEventListener invocation, should
	                //       revisit and verify we can just use one (almost certainly)
	                clickHandler = self._breadcrumbEventHandler('click');
	                keypressHandler = self._keypressEventHandler();
	                before = function(evt) {
	                  // need to intercept every DOM event in `before` argument, in case that
	                  // same wrapped method is re-used for different events (e.g. mousemove THEN click)
	                  // see #724
	                  if (!evt) return;
	
	                  var eventType;
	                  try {
	                    eventType = evt.type;
	                  } catch (e) {
	                    // just accessing event properties can throw an exception in some rare circumstances
	                    // see: https://github.com/getsentry/raven-js/issues/838
	                    return;
	                  }
	                  if (eventType === 'click') return clickHandler(evt);
	                  else if (eventType === 'keypress') return keypressHandler(evt);
	                };
	              }
	              return orig.call(
	                this,
	                evtName,
	                self.wrap(fn, undefined, before),
	                capture,
	                secure
	              );
	            };
	          },
	          wrappedBuiltIns
	        );
	        fill(
	          proto,
	          'removeEventListener',
	          function(orig) {
	            return function(evt, fn, capture, secure) {
	              try {
	                fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__ : fn);
	              } catch (e) {
	                // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
	              }
	              return orig.call(this, evt, fn, capture, secure);
	            };
	          },
	          wrappedBuiltIns
	        );
	      }
	    }
	
	    fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
	    fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
	    if (_window.requestAnimationFrame) {
	      fill(
	        _window,
	        'requestAnimationFrame',
	        function(orig) {
	          return function(cb) {
	            return orig(self.wrap(cb));
	          };
	        },
	        wrappedBuiltIns
	      );
	    }
	
	    // event targets borrowed from bugsnag-js:
	    // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
	    var eventTargets = [
	      'EventTarget',
	      'Window',
	      'Node',
	      'ApplicationCache',
	      'AudioTrackList',
	      'ChannelMergerNode',
	      'CryptoOperation',
	      'EventSource',
	      'FileReader',
	      'HTMLUnknownElement',
	      'IDBDatabase',
	      'IDBRequest',
	      'IDBTransaction',
	      'KeyOperation',
	      'MediaController',
	      'MessagePort',
	      'ModalWindow',
	      'Notification',
	      'SVGElementInstance',
	      'Screen',
	      'TextTrack',
	      'TextTrackCue',
	      'TextTrackList',
	      'WebSocket',
	      'WebSocketWorker',
	      'Worker',
	      'XMLHttpRequest',
	      'XMLHttpRequestEventTarget',
	      'XMLHttpRequestUpload'
	    ];
	    for (var i = 0; i < eventTargets.length; i++) {
	      wrapEventTarget(eventTargets[i]);
	    }
	  },
	
	  /**
	   * Instrument browser built-ins w/ breadcrumb capturing
	   *  - XMLHttpRequests
	   *  - DOM interactions (click/typing)
	   *  - window.location changes
	   *  - console
	   *
	   * Can be disabled or individually configured via the `autoBreadcrumbs` config option
	   */
	  _instrumentBreadcrumbs: function() {
	    var self = this;
	    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;
	
	    var wrappedBuiltIns = self._wrappedBuiltIns;
	
	    function wrapProp(prop, xhr) {
	      if (prop in xhr && isFunction(xhr[prop])) {
	        fill(xhr, prop, function(orig) {
	          return self.wrap(orig);
	        }); // intentionally don't track filled methods on XHR instances
	      }
	    }
	
	    if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
	      var xhrproto = _window.XMLHttpRequest && _window.XMLHttpRequest.prototype;
	      fill(
	        xhrproto,
	        'open',
	        function(origOpen) {
	          return function(method, url) {
	            // preserve arity
	
	            // if Sentry key appears in URL, don't capture
	            if (isString(url) && url.indexOf(self._globalKey) === -1) {
	              this.__raven_xhr = {
	                method: method,
	                url: url,
	                status_code: null
	              };
	            }
	
	            return origOpen.apply(this, arguments);
	          };
	        },
	        wrappedBuiltIns
	      );
	
	      fill(
	        xhrproto,
	        'send',
	        function(origSend) {
	          return function() {
	            // preserve arity
	            var xhr = this;
	
	            function onreadystatechangeHandler() {
	              if (xhr.__raven_xhr && xhr.readyState === 4) {
	                try {
	                  // touching statusCode in some platforms throws
	                  // an exception
	                  xhr.__raven_xhr.status_code = xhr.status;
	                } catch (e) {
	                  /* do nothing */
	                }
	
	                self.captureBreadcrumb({
	                  type: 'http',
	                  category: 'xhr',
	                  data: xhr.__raven_xhr
	                });
	              }
	            }
	
	            var props = ['onload', 'onerror', 'onprogress'];
	            for (var j = 0; j < props.length; j++) {
	              wrapProp(props[j], xhr);
	            }
	
	            if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
	              fill(
	                xhr,
	                'onreadystatechange',
	                function(orig) {
	                  return self.wrap(orig, undefined, onreadystatechangeHandler);
	                } /* intentionally don't track this instrumentation */
	              );
	            } else {
	              // if onreadystatechange wasn't actually set by the page on this xhr, we
	              // are free to set our own and capture the breadcrumb
	              xhr.onreadystatechange = onreadystatechangeHandler;
	            }
	
	            return origSend.apply(this, arguments);
	          };
	        },
	        wrappedBuiltIns
	      );
	    }
	
	    if (autoBreadcrumbs.xhr && supportsFetch()) {
	      fill(
	        _window,
	        'fetch',
	        function(origFetch) {
	          return function() {
	            // preserve arity
	            // Make a copy of the arguments to prevent deoptimization
	            // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	            var args = new Array(arguments.length);
	            for (var i = 0; i < args.length; ++i) {
	              args[i] = arguments[i];
	            }
	
	            var fetchInput = args[0];
	            var method = 'GET';
	            var url;
	
	            if (typeof fetchInput === 'string') {
	              url = fetchInput;
	            } else if ('Request' in _window && fetchInput instanceof _window.Request) {
	              url = fetchInput.url;
	              if (fetchInput.method) {
	                method = fetchInput.method;
	              }
	            } else {
	              url = '' + fetchInput;
	            }
	
	            // if Sentry key appears in URL, don't capture, as it's our own request
	            if (url.indexOf(self._globalKey) !== -1) {
	              return origFetch.apply(this, args);
	            }
	
	            if (args[1] && args[1].method) {
	              method = args[1].method;
	            }
	
	            var fetchData = {
	              method: method,
	              url: url,
	              status_code: null
	            };
	
	            return origFetch.apply(this, args).then(function(response) {
	              fetchData.status_code = response.status;
	
	              self.captureBreadcrumb({
	                type: 'http',
	                category: 'fetch',
	                data: fetchData
	              });
	
	              return response;
	            });
	          };
	        },
	        wrappedBuiltIns
	      );
	    }
	
	    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
	    // to the document. Do this before we instrument addEventListener.
	    if (autoBreadcrumbs.dom && this._hasDocument) {
	      if (_document.addEventListener) {
	        _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
	        _document.addEventListener('keypress', self._keypressEventHandler(), false);
	      } else {
	        // IE8 Compatibility
	        _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
	        _document.attachEvent('onkeypress', self._keypressEventHandler());
	      }
	    }
	
	    // record navigation (URL) changes
	    // NOTE: in Chrome App environment, touching history.pushState, *even inside
	    //       a try/catch block*, will cause Chrome to output an error to console.error
	    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
	    var chrome = _window.chrome;
	    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
	    var hasPushAndReplaceState =
	      !isChromePackagedApp &&
	      _window.history &&
	      history.pushState &&
	      history.replaceState;
	    if (autoBreadcrumbs.location && hasPushAndReplaceState) {
	      // TODO: remove onpopstate handler on uninstall()
	      var oldOnPopState = _window.onpopstate;
	      _window.onpopstate = function() {
	        var currentHref = self._location.href;
	        self._captureUrlChange(self._lastHref, currentHref);
	
	        if (oldOnPopState) {
	          return oldOnPopState.apply(this, arguments);
	        }
	      };
	
	      var historyReplacementFunction = function(origHistFunction) {
	        // note history.pushState.length is 0; intentionally not declaring
	        // params to preserve 0 arity
	        return function(/* state, title, url */) {
	          var url = arguments.length > 2 ? arguments[2] : undefined;
	
	          // url argument is optional
	          if (url) {
	            // coerce to string (this is what pushState does)
	            self._captureUrlChange(self._lastHref, url + '');
	          }
	
	          return origHistFunction.apply(this, arguments);
	        };
	      };
	
	      fill(history, 'pushState', historyReplacementFunction, wrappedBuiltIns);
	      fill(history, 'replaceState', historyReplacementFunction, wrappedBuiltIns);
	    }
	
	    if (autoBreadcrumbs.console && 'console' in _window && console.log) {
	      // console
	      var consoleMethodCallback = function(msg, data) {
	        self.captureBreadcrumb({
	          message: msg,
	          level: data.level,
	          category: 'console'
	        });
	      };
	
	      each(['debug', 'info', 'warn', 'error', 'log'], function(_, level) {
	        wrapConsoleMethod(console, level, consoleMethodCallback);
	      });
	    }
	  },
	
	  _restoreBuiltIns: function() {
	    // restore any wrapped builtins
	    var builtin;
	    while (this._wrappedBuiltIns.length) {
	      builtin = this._wrappedBuiltIns.shift();
	
	      var obj = builtin[0],
	        name = builtin[1],
	        orig = builtin[2];
	
	      obj[name] = orig;
	    }
	  },
	
	  _restoreConsole: function() {
	    // eslint-disable-next-line guard-for-in
	    for (var method in this._originalConsoleMethods) {
	      this._originalConsole[method] = this._originalConsoleMethods[method];
	    }
	  },
	
	  _drainPlugins: function() {
	    var self = this;
	
	    // FIX ME TODO
	    each(this._plugins, function(_, plugin) {
	      var installer = plugin[0];
	      var args = plugin[1];
	      installer.apply(self, [self].concat(args));
	    });
	  },
	
	  _parseDSN: function(str) {
	    var m = dsnPattern.exec(str),
	      dsn = {},
	      i = 7;
	
	    try {
	      while (i--) dsn[dsnKeys[i]] = m[i] || '';
	    } catch (e) {
	      throw new RavenConfigError('Invalid DSN: ' + str);
	    }
	
	    if (dsn.pass && !this._globalOptions.allowSecretKey) {
	      throw new RavenConfigError(
	        'Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key'
	      );
	    }
	
	    return dsn;
	  },
	
	  _getGlobalServer: function(uri) {
	    // assemble the endpoint from the uri pieces
	    var globalServer = '//' + uri.host + (uri.port ? ':' + uri.port : '');
	
	    if (uri.protocol) {
	      globalServer = uri.protocol + ':' + globalServer;
	    }
	    return globalServer;
	  },
	
	  _handleOnErrorStackInfo: function() {
	    // if we are intentionally ignoring errors via onerror, bail out
	    if (!this._ignoreOnError) {
	      this._handleStackInfo.apply(this, arguments);
	    }
	  },
	
	  _handleStackInfo: function(stackInfo, options) {
	    var frames = this._prepareFrames(stackInfo, options);
	
	    this._triggerEvent('handle', {
	      stackInfo: stackInfo,
	      options: options
	    });
	
	    this._processException(
	      stackInfo.name,
	      stackInfo.message,
	      stackInfo.url,
	      stackInfo.lineno,
	      frames,
	      options
	    );
	  },
	
	  _prepareFrames: function(stackInfo, options) {
	    var self = this;
	    var frames = [];
	    if (stackInfo.stack && stackInfo.stack.length) {
	      each(stackInfo.stack, function(i, stack) {
	        var frame = self._normalizeFrame(stack, stackInfo.url);
	        if (frame) {
	          frames.push(frame);
	        }
	      });
	
	      // e.g. frames captured via captureMessage throw
	      if (options && options.trimHeadFrames) {
	        for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
	          frames[j].in_app = false;
	        }
	      }
	    }
	    frames = frames.slice(0, this._globalOptions.stackTraceLimit);
	    return frames;
	  },
	
	  _normalizeFrame: function(frame, stackInfoUrl) {
	    // normalize the frames data
	    var normalized = {
	      filename: frame.url,
	      lineno: frame.line,
	      colno: frame.column,
	      function: frame.func || '?'
	    };
	
	    // Case when we don't have any information about the error
	    // E.g. throwing a string or raw object, instead of an `Error` in Firefox
	    // Generating synthetic error doesn't add any value here
	    //
	    // We should probably somehow let a user know that they should fix their code
	    if (!frame.url) {
	      normalized.filename = stackInfoUrl; // fallback to whole stacks url from onerror handler
	    }
	
	    normalized.in_app = !// determine if an exception came from outside of our app
	    // first we check the global includePaths list.
	    (
	      (!!this._globalOptions.includePaths.test &&
	        !this._globalOptions.includePaths.test(normalized.filename)) ||
	      // Now we check for fun, if the function name is Raven or TraceKit
	      /(Raven|TraceKit)\./.test(normalized['function']) ||
	      // finally, we do a last ditch effort and check for raven.min.js
	      /raven\.(min\.)?js$/.test(normalized.filename)
	    );
	
	    return normalized;
	  },
	
	  _processException: function(type, message, fileurl, lineno, frames, options) {
	    var prefixedMessage = (type ? type + ': ' : '') + (message || '');
	    if (
	      !!this._globalOptions.ignoreErrors.test &&
	      (this._globalOptions.ignoreErrors.test(message) ||
	        this._globalOptions.ignoreErrors.test(prefixedMessage))
	    ) {
	      return;
	    }
	
	    var stacktrace;
	
	    if (frames && frames.length) {
	      fileurl = frames[0].filename || fileurl;
	      // Sentry expects frames oldest to newest
	      // and JS sends them as newest to oldest
	      frames.reverse();
	      stacktrace = {frames: frames};
	    } else if (fileurl) {
	      stacktrace = {
	        frames: [
	          {
	            filename: fileurl,
	            lineno: lineno,
	            in_app: true
	          }
	        ]
	      };
	    }
	
	    if (
	      !!this._globalOptions.ignoreUrls.test &&
	      this._globalOptions.ignoreUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    if (
	      !!this._globalOptions.whitelistUrls.test &&
	      !this._globalOptions.whitelistUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    var data = objectMerge(
	      {
	        // sentry.interfaces.Exception
	        exception: {
	          values: [
	            {
	              type: type,
	              value: message,
	              stacktrace: stacktrace
	            }
	          ]
	        },
	        culprit: fileurl
	      },
	      options
	    );
	
	    // Fire away!
	    this._send(data);
	  },
	
	  _trimPacket: function(data) {
	    // For now, we only want to truncate the two different messages
	    // but this could/should be expanded to just trim everything
	    var max = this._globalOptions.maxMessageLength;
	    if (data.message) {
	      data.message = truncate(data.message, max);
	    }
	    if (data.exception) {
	      var exception = data.exception.values[0];
	      exception.value = truncate(exception.value, max);
	    }
	
	    var request = data.request;
	    if (request) {
	      if (request.url) {
	        request.url = truncate(request.url, this._globalOptions.maxUrlLength);
	      }
	      if (request.Referer) {
	        request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
	      }
	    }
	
	    if (data.breadcrumbs && data.breadcrumbs.values)
	      this._trimBreadcrumbs(data.breadcrumbs);
	
	    return data;
	  },
	
	  /**
	   * Truncate breadcrumb values (right now just URLs)
	   */
	  _trimBreadcrumbs: function(breadcrumbs) {
	    // known breadcrumb properties with urls
	    // TODO: also consider arbitrary prop values that start with (https?)?://
	    var urlProps = ['to', 'from', 'url'],
	      urlProp,
	      crumb,
	      data;
	
	    for (var i = 0; i < breadcrumbs.values.length; ++i) {
	      crumb = breadcrumbs.values[i];
	      if (
	        !crumb.hasOwnProperty('data') ||
	        !isObject(crumb.data) ||
	        objectFrozen(crumb.data)
	      )
	        continue;
	
	      data = objectMerge({}, crumb.data);
	      for (var j = 0; j < urlProps.length; ++j) {
	        urlProp = urlProps[j];
	        if (data.hasOwnProperty(urlProp) && data[urlProp]) {
	          data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
	        }
	      }
	      breadcrumbs.values[i].data = data;
	    }
	  },
	
	  _getHttpData: function() {
	    if (!this._hasNavigator && !this._hasDocument) return;
	    var httpData = {};
	
	    if (this._hasNavigator && _navigator.userAgent) {
	      httpData.headers = {
	        'User-Agent': navigator.userAgent
	      };
	    }
	
	    // Check in `window` instead of `document`, as we may be in ServiceWorker environment
	    if (_window.location && _window.location.href) {
	      httpData.url = _window.location.href;
	    }
	
	    if (this._hasDocument && _document.referrer) {
	      if (!httpData.headers) httpData.headers = {};
	      httpData.headers.Referer = _document.referrer;
	    }
	
	    return httpData;
	  },
	
	  _resetBackoff: function() {
	    this._backoffDuration = 0;
	    this._backoffStart = null;
	  },
	
	  _shouldBackoff: function() {
	    return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
	  },
	
	  /**
	   * Returns true if the in-process data payload matches the signature
	   * of the previously-sent data
	   *
	   * NOTE: This has to be done at this level because TraceKit can generate
	   *       data from window.onerror WITHOUT an exception object (IE8, IE9,
	   *       other old browsers). This can take the form of an "exception"
	   *       data object with a single frame (derived from the onerror args).
	   */
	  _isRepeatData: function(current) {
	    var last = this._lastData;
	
	    if (
	      !last ||
	      current.message !== last.message || // defined for captureMessage
	      current.culprit !== last.culprit // defined for captureException/onerror
	    )
	      return false;
	
	    // Stacktrace interface (i.e. from captureMessage)
	    if (current.stacktrace || last.stacktrace) {
	      return isSameStacktrace(current.stacktrace, last.stacktrace);
	    } else if (current.exception || last.exception) {
	      // Exception interface (i.e. from captureException/onerror)
	      return isSameException(current.exception, last.exception);
	    }
	
	    return true;
	  },
	
	  _setBackoffState: function(request) {
	    // If we are already in a backoff state, don't change anything
	    if (this._shouldBackoff()) {
	      return;
	    }
	
	    var status = request.status;
	
	    // 400 - project_id doesn't exist or some other fatal
	    // 401 - invalid/revoked dsn
	    // 429 - too many requests
	    if (!(status === 400 || status === 401 || status === 429)) return;
	
	    var retry;
	    try {
	      // If Retry-After is not in Access-Control-Expose-Headers, most
	      // browsers will throw an exception trying to access it
	      if (supportsFetch()) {
	        retry = request.headers.get('Retry-After');
	      } else {
	        retry = request.getResponseHeader('Retry-After');
	      }
	
	      // Retry-After is returned in seconds
	      retry = parseInt(retry, 10) * 1000;
	    } catch (e) {
	      /* eslint no-empty:0 */
	    }
	
	    this._backoffDuration = retry
	      ? // If Sentry server returned a Retry-After value, use it
	        retry
	      : // Otherwise, double the last backoff duration (starts at 1 sec)
	        this._backoffDuration * 2 || 1000;
	
	    this._backoffStart = now();
	  },
	
	  _send: function(data) {
	    var globalOptions = this._globalOptions;
	
	    var baseData = {
	        project: this._globalProject,
	        logger: globalOptions.logger,
	        platform: 'javascript'
	      },
	      httpData = this._getHttpData();
	
	    if (httpData) {
	      baseData.request = httpData;
	    }
	
	    // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
	    if (data.trimHeadFrames) delete data.trimHeadFrames;
	
	    data = objectMerge(baseData, data);
	
	    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
	    data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
	    data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);
	
	    // Send along our own collected metadata with extra
	    data.extra['session:duration'] = now() - this._startTime;
	
	    if (this._breadcrumbs && this._breadcrumbs.length > 0) {
	      // intentionally make shallow copy so that additions
	      // to breadcrumbs aren't accidentally sent in this request
	      data.breadcrumbs = {
	        values: [].slice.call(this._breadcrumbs, 0)
	      };
	    }
	
	    if (this._globalContext.user) {
	      // sentry.interfaces.User
	      data.user = this._globalContext.user;
	    }
	
	    // Include the environment if it's defined in globalOptions
	    if (globalOptions.environment) data.environment = globalOptions.environment;
	
	    // Include the release if it's defined in globalOptions
	    if (globalOptions.release) data.release = globalOptions.release;
	
	    // Include server_name if it's defined in globalOptions
	    if (globalOptions.serverName) data.server_name = globalOptions.serverName;
	
	    data = this._sanitizeData(data);
	
	    // Cleanup empty properties before sending them to the server
	    Object.keys(data).forEach(function(key) {
	      if (data[key] == null || data[key] === '' || isEmptyObject(data[key])) {
	        delete data[key];
	      }
	    });
	
	    if (isFunction(globalOptions.dataCallback)) {
	      data = globalOptions.dataCallback(data) || data;
	    }
	
	    // Why??????????
	    if (!data || isEmptyObject(data)) {
	      return;
	    }
	
	    // Check if the request should be filtered or not
	    if (
	      isFunction(globalOptions.shouldSendCallback) &&
	      !globalOptions.shouldSendCallback(data)
	    ) {
	      return;
	    }
	
	    // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
	    // so drop requests until "cool-off" period has elapsed.
	    if (this._shouldBackoff()) {
	      this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
	      return;
	    }
	
	    if (typeof globalOptions.sampleRate === 'number') {
	      if (Math.random() < globalOptions.sampleRate) {
	        this._sendProcessedPayload(data);
	      }
	    } else {
	      this._sendProcessedPayload(data);
	    }
	  },
	
	  _sanitizeData: function(data) {
	    return sanitize(data, this._globalOptions.sanitizeKeys);
	  },
	
	  _getUuid: function() {
	    return uuid4();
	  },
	
	  _sendProcessedPayload: function(data, callback) {
	    var self = this;
	    var globalOptions = this._globalOptions;
	
	    if (!this.isSetup()) return;
	
	    // Try and clean up the packet before sending by truncating long values
	    data = this._trimPacket(data);
	
	    // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
	    // but this would require copying an un-truncated copy of the data packet, which can be
	    // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
	    if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
	      this._logDebug('warn', 'Raven dropped repeat event: ', data);
	      return;
	    }
	
	    // Send along an event_id if not explicitly passed.
	    // This event_id can be used to reference the error within Sentry itself.
	    // Set lastEventId after we know the error should actually be sent
	    this._lastEventId = data.event_id || (data.event_id = this._getUuid());
	
	    // Store outbound payload after trim
	    this._lastData = data;
	
	    this._logDebug('debug', 'Raven about to send:', data);
	
	    var auth = {
	      sentry_version: '7',
	      sentry_client: 'raven-js/' + this.VERSION,
	      sentry_key: this._globalKey
	    };
	
	    if (this._globalSecret) {
	      auth.sentry_secret = this._globalSecret;
	    }
	
	    var exception = data.exception && data.exception.values[0];
	
	    // only capture 'sentry' breadcrumb is autoBreadcrumbs is truthy
	    if (
	      this._globalOptions.autoBreadcrumbs &&
	      this._globalOptions.autoBreadcrumbs.sentry
	    ) {
	      this.captureBreadcrumb({
	        category: 'sentry',
	        message: exception
	          ? (exception.type ? exception.type + ': ' : '') + exception.value
	          : data.message,
	        event_id: data.event_id,
	        level: data.level || 'error' // presume error unless specified
	      });
	    }
	
	    var url = this._globalEndpoint;
	    (globalOptions.transport || this._makeRequest).call(this, {
	      url: url,
	      auth: auth,
	      data: data,
	      options: globalOptions,
	      onSuccess: function success() {
	        self._resetBackoff();
	
	        self._triggerEvent('success', {
	          data: data,
	          src: url
	        });
	        callback && callback();
	      },
	      onError: function failure(error) {
	        self._logDebug('error', 'Raven transport failed to send: ', error);
	
	        if (error.request) {
	          self._setBackoffState(error.request);
	        }
	
	        self._triggerEvent('failure', {
	          data: data,
	          src: url
	        });
	        error = error || new Error('Raven send failed (no additional details provided)');
	        callback && callback(error);
	      }
	    });
	  },
	
	  _makeRequest: function(opts) {
	    // Auth is intentionally sent as part of query string (NOT as custom HTTP header) to avoid preflight CORS requests
	    var url = opts.url + '?' + urlencode(opts.auth);
	
	    var evaluatedHeaders = null;
	    var evaluatedFetchParameters = {};
	
	    if (opts.options.headers) {
	      evaluatedHeaders = this._evaluateHash(opts.options.headers);
	    }
	
	    if (opts.options.fetchParameters) {
	      evaluatedFetchParameters = this._evaluateHash(opts.options.fetchParameters);
	    }
	
	    if (supportsFetch()) {
	      evaluatedFetchParameters.body = stringify(opts.data);
	
	      var defaultFetchOptions = objectMerge({}, this._fetchDefaults);
	      var fetchOptions = objectMerge(defaultFetchOptions, evaluatedFetchParameters);
	
	      if (evaluatedHeaders) {
	        fetchOptions.headers = evaluatedHeaders;
	      }
	
	      return _window
	        .fetch(url, fetchOptions)
	        .then(function(response) {
	          if (response.ok) {
	            opts.onSuccess && opts.onSuccess();
	          } else {
	            var error = new Error('Sentry error code: ' + response.status);
	            // It's called request only to keep compatibility with XHR interface
	            // and not add more redundant checks in setBackoffState method
	            error.request = response;
	            opts.onError && opts.onError(error);
	          }
	        })
	        ['catch'](function() {
	          opts.onError &&
	            opts.onError(new Error('Sentry error code: network unavailable'));
	        });
	    }
	
	    var request = _window.XMLHttpRequest && new _window.XMLHttpRequest();
	    if (!request) return;
	
	    // if browser doesn't support CORS (e.g. IE7), we are out of luck
	    var hasCORS = 'withCredentials' in request || typeof XDomainRequest !== 'undefined';
	
	    if (!hasCORS) return;
	
	    if ('withCredentials' in request) {
	      request.onreadystatechange = function() {
	        if (request.readyState !== 4) {
	          return;
	        } else if (request.status === 200) {
	          opts.onSuccess && opts.onSuccess();
	        } else if (opts.onError) {
	          var err = new Error('Sentry error code: ' + request.status);
	          err.request = request;
	          opts.onError(err);
	        }
	      };
	    } else {
	      request = new XDomainRequest();
	      // xdomainrequest cannot go http -> https (or vice versa),
	      // so always use protocol relative
	      url = url.replace(/^https?:/, '');
	
	      // onreadystatechange not supported by XDomainRequest
	      if (opts.onSuccess) {
	        request.onload = opts.onSuccess;
	      }
	      if (opts.onError) {
	        request.onerror = function() {
	          var err = new Error('Sentry error code: XDomainRequest');
	          err.request = request;
	          opts.onError(err);
	        };
	      }
	    }
	
	    request.open('POST', url);
	
	    if (evaluatedHeaders) {
	      each(evaluatedHeaders, function(key, value) {
	        request.setRequestHeader(key, value);
	      });
	    }
	
	    request.send(stringify(opts.data));
	  },
	
	  _evaluateHash: function(hash) {
	    var evaluated = {};
	
	    for (var key in hash) {
	      if (hash.hasOwnProperty(key)) {
	        var value = hash[key];
	        evaluated[key] = typeof value === 'function' ? value() : value;
	      }
	    }
	
	    return evaluated;
	  },
	
	  _logDebug: function(level) {
	    if (this._originalConsoleMethods[level] && this.debug) {
	      // In IE<10 console methods do not have their own 'apply' method
	      Function.prototype.apply.call(
	        this._originalConsoleMethods[level],
	        this._originalConsole,
	        [].slice.call(arguments, 1)
	      );
	    }
	  },
	
	  _mergeContext: function(key, context) {
	    if (isUndefined(context)) {
	      delete this._globalContext[key];
	    } else {
	      this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
	    }
	  }
	};
	
	// Deprecations
	Raven.prototype.setUser = Raven.prototype.setUserContext;
	Raven.prototype.setReleaseContext = Raven.prototype.setRelease;
	
	module.exports = Raven;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var utils = __webpack_require__(648);
	
	/*
	 TraceKit - Cross brower stack traces
	
	 This was originally forked from github.com/occ/TraceKit, but has since been
	 largely re-written and is now maintained as part of raven-js.  Tests for
	 this are in test/vendor.
	
	 MIT license
	*/
	
	var TraceKit = {
	  collectWindowErrors: true,
	  debug: false
	};
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	// global reference to slice
	var _slice = [].slice;
	var UNKNOWN_FUNCTION = '?';
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
	var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
	
	function getLocationHref() {
	  if (typeof document === 'undefined' || document.location == null) return '';
	
	  return document.location.href;
	}
	
	/**
	 * TraceKit.report: cross-browser processing of unhandled exceptions
	 *
	 * Syntax:
	 *   TraceKit.report.subscribe(function(stackInfo) { ... })
	 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
	 *   TraceKit.report(exception)
	 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
	 *
	 * Supports:
	 *   - Firefox: full stack trace with line numbers, plus column number
	 *              on top frame; column number is not guaranteed
	 *   - Opera:   full stack trace with line and column numbers
	 *   - Chrome:  full stack trace with line and column numbers
	 *   - Safari:  line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *   - IE:      line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *
	 * In theory, TraceKit should work on all of the following versions:
	 *   - IE5.5+ (only 8.0 tested)
	 *   - Firefox 0.9+ (only 3.5+ tested)
	 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
	 *     Exceptions Have Stacktrace to be enabled in opera:config)
	 *   - Safari 3+ (only 4+ tested)
	 *   - Chrome 1+ (only 5+ tested)
	 *   - Konqueror 3.5+ (untested)
	 *
	 * Requires TraceKit.computeStackTrace.
	 *
	 * Tries to catch all unhandled exceptions and report them to the
	 * subscribed handlers. Please note that TraceKit.report will rethrow the
	 * exception. This is REQUIRED in order to get a useful stack trace in IE.
	 * If the exception does not reach the top of the browser, you will only
	 * get a stack trace from the point where TraceKit.report was called.
	 *
	 * Handlers receive a stackInfo object as described in the
	 * TraceKit.computeStackTrace docs.
	 */
	TraceKit.report = (function reportModuleWrapper() {
	  var handlers = [],
	    lastArgs = null,
	    lastException = null,
	    lastExceptionStack = null;
	
	  /**
	   * Add a crash handler.
	   * @param {Function} handler
	   */
	  function subscribe(handler) {
	    installGlobalHandler();
	    handlers.push(handler);
	  }
	
	  /**
	   * Remove a crash handler.
	   * @param {Function} handler
	   */
	  function unsubscribe(handler) {
	    for (var i = handlers.length - 1; i >= 0; --i) {
	      if (handlers[i] === handler) {
	        handlers.splice(i, 1);
	      }
	    }
	  }
	
	  /**
	   * Remove all crash handlers.
	   */
	  function unsubscribeAll() {
	    uninstallGlobalHandler();
	    handlers = [];
	  }
	
	  /**
	   * Dispatch stack information to all handlers.
	   * @param {Object.<string, *>} stack
	   */
	  function notifyHandlers(stack, isWindowError) {
	    var exception = null;
	    if (isWindowError && !TraceKit.collectWindowErrors) {
	      return;
	    }
	    for (var i in handlers) {
	      if (handlers.hasOwnProperty(i)) {
	        try {
	          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
	        } catch (inner) {
	          exception = inner;
	        }
	      }
	    }
	
	    if (exception) {
	      throw exception;
	    }
	  }
	
	  var _oldOnerrorHandler, _onErrorHandlerInstalled;
	
	  /**
	   * Ensures all global unhandled exceptions are recorded.
	   * Supported by Gecko and IE.
	   * @param {string} msg Error message.
	   * @param {string} url URL of script that generated the exception.
	   * @param {(number|string)} lineNo The line number at which the error
	   * occurred.
	   * @param {?(number|string)} colNo The column number at which the error
	   * occurred.
	   * @param {?Error} ex The actual Error object.
	   */
	  function traceKitWindowOnError(msg, url, lineNo, colNo, ex) {
	    var stack = null;
	    // If 'ex' is ErrorEvent, get real Error from inside
	    var exception = utils.isErrorEvent(ex) ? ex.error : ex;
	    // If 'msg' is ErrorEvent, get real message from inside
	    var message = utils.isErrorEvent(msg) ? msg.message : msg;
	
	    if (lastExceptionStack) {
	      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(
	        lastExceptionStack,
	        url,
	        lineNo,
	        message
	      );
	      processLastException();
	    } else if (exception && utils.isError(exception)) {
	      // non-string `exception` arg; attempt to extract stack trace
	
	      // New chrome and blink send along a real error object
	      // Let's just report that like a normal error.
	      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
	      stack = TraceKit.computeStackTrace(exception);
	      notifyHandlers(stack, true);
	    } else {
	      var location = {
	        url: url,
	        line: lineNo,
	        column: colNo
	      };
	
	      var name = undefined;
	      var groups;
	
	      if ({}.toString.call(message) === '[object String]') {
	        var groups = message.match(ERROR_TYPES_RE);
	        if (groups) {
	          name = groups[1];
	          message = groups[2];
	        }
	      }
	
	      location.func = UNKNOWN_FUNCTION;
	
	      stack = {
	        name: name,
	        message: message,
	        url: getLocationHref(),
	        stack: [location]
	      };
	      notifyHandlers(stack, true);
	    }
	
	    if (_oldOnerrorHandler) {
	      return _oldOnerrorHandler.apply(this, arguments);
	    }
	
	    return false;
	  }
	
	  function installGlobalHandler() {
	    if (_onErrorHandlerInstalled) {
	      return;
	    }
	    _oldOnerrorHandler = _window.onerror;
	    _window.onerror = traceKitWindowOnError;
	    _onErrorHandlerInstalled = true;
	  }
	
	  function uninstallGlobalHandler() {
	    if (!_onErrorHandlerInstalled) {
	      return;
	    }
	    _window.onerror = _oldOnerrorHandler;
	    _onErrorHandlerInstalled = false;
	    _oldOnerrorHandler = undefined;
	  }
	
	  function processLastException() {
	    var _lastExceptionStack = lastExceptionStack,
	      _lastArgs = lastArgs;
	    lastArgs = null;
	    lastExceptionStack = null;
	    lastException = null;
	    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
	  }
	
	  /**
	   * Reports an unhandled Error to TraceKit.
	   * @param {Error} ex
	   * @param {?boolean} rethrow If false, do not re-throw the exception.
	   * Only used for window.onerror to not cause an infinite loop of
	   * rethrowing.
	   */
	  function report(ex, rethrow) {
	    var args = _slice.call(arguments, 1);
	    if (lastExceptionStack) {
	      if (lastException === ex) {
	        return; // already caught by an inner catch block, ignore
	      } else {
	        processLastException();
	      }
	    }
	
	    var stack = TraceKit.computeStackTrace(ex);
	    lastExceptionStack = stack;
	    lastException = ex;
	    lastArgs = args;
	
	    // If the stack trace is incomplete, wait for 2 seconds for
	    // slow slow IE to see if onerror occurs or not before reporting
	    // this exception; otherwise, we will end up with an incomplete
	    // stack trace
	    setTimeout(function() {
	      if (lastException === ex) {
	        processLastException();
	      }
	    }, stack.incomplete ? 2000 : 0);
	
	    if (rethrow !== false) {
	      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
	    }
	  }
	
	  report.subscribe = subscribe;
	  report.unsubscribe = unsubscribe;
	  report.uninstall = unsubscribeAll;
	  return report;
	})();
	
	/**
	 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
	 *
	 * Syntax:
	 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
	 * Returns:
	 *   s.name              - exception name
	 *   s.message           - exception message
	 *   s.stack[i].url      - JavaScript or HTML file URL
	 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
	 *   s.stack[i].args     - arguments passed to the function, if known
	 *   s.stack[i].line     - line number, if known
	 *   s.stack[i].column   - column number, if known
	 *
	 * Supports:
	 *   - Firefox:  full stack trace with line numbers and unreliable column
	 *               number on top frame
	 *   - Opera 10: full stack trace with line and column numbers
	 *   - Opera 9-: full stack trace with line numbers
	 *   - Chrome:   full stack trace with line and column numbers
	 *   - Safari:   line and column number for the topmost stacktrace element
	 *               only
	 *   - IE:       no line numbers whatsoever
	 *
	 * Tries to guess names of anonymous functions by looking for assignments
	 * in the source code. In IE and Safari, we have to guess source file names
	 * by searching for function bodies inside all page scripts. This will not
	 * work for scripts that are loaded cross-domain.
	 * Here be dragons: some function names may be guessed incorrectly, and
	 * duplicate functions may be mismatched.
	 *
	 * TraceKit.computeStackTrace should only be used for tracing purposes.
	 * Logging of unhandled exceptions should be done with TraceKit.report,
	 * which builds on top of TraceKit.computeStackTrace and provides better
	 * IE support by utilizing the window.onerror event to retrieve information
	 * about the top of the stack.
	 *
	 * Note: In IE and Safari, no stack trace is recorded on the Error object,
	 * so computeStackTrace instead walks its *own* chain of callers.
	 * This means that:
	 *  * in Safari, some methods may be missing from the stack trace;
	 *  * in IE, the topmost function in the stack trace will always be the
	 *    caller of computeStackTrace.
	 *
	 * This is okay for tracing (because you are likely to be calling
	 * computeStackTrace from the function you want to be the topmost element
	 * of the stack trace anyway), but not okay for logging unhandled
	 * exceptions (because your catch block will likely be far away from the
	 * inner function that actually caused the exception).
	 *
	 */
	TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
	  // Contents of Exception in various browsers.
	  //
	  // SAFARI:
	  // ex.message = Can't find variable: qq
	  // ex.line = 59
	  // ex.sourceId = 580238192
	  // ex.sourceURL = http://...
	  // ex.expressionBeginOffset = 96
	  // ex.expressionCaretOffset = 98
	  // ex.expressionEndOffset = 98
	  // ex.name = ReferenceError
	  //
	  // FIREFOX:
	  // ex.message = qq is not defined
	  // ex.fileName = http://...
	  // ex.lineNumber = 59
	  // ex.columnNumber = 69
	  // ex.stack = ...stack trace... (see the example below)
	  // ex.name = ReferenceError
	  //
	  // CHROME:
	  // ex.message = qq is not defined
	  // ex.name = ReferenceError
	  // ex.type = not_defined
	  // ex.arguments = ['aa']
	  // ex.stack = ...stack trace...
	  //
	  // INTERNET EXPLORER:
	  // ex.message = ...
	  // ex.name = ReferenceError
	  //
	  // OPERA:
	  // ex.message = ...message... (see the example below)
	  // ex.name = ReferenceError
	  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
	  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
	
	  /**
	   * Computes stack trace information from the stack property.
	   * Chrome and Gecko use this property.
	   * @param {Error} ex
	   * @return {?Object.<string, *>} Stack trace information.
	   */
	  function computeStackTraceFromStackProp(ex) {
	    if (typeof ex.stack === 'undefined' || !ex.stack) return;
	
	    var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
	    var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx(?:-web)|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
	    // NOTE: blob urls are now supposed to always have an origin, therefore it's format
	    // which is `blob:http://url/path/with-some-uuid`, is matched by `blob.*?:\/` as well
	    var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
	    // Used to additionally parse URL/line/column from eval frames
	    var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
	    var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
	    var lines = ex.stack.split('\n');
	    var stack = [];
	    var submatch;
	    var parts;
	    var element;
	    var reference = /^(.*) is undefined$/.exec(ex.message);
	
	    for (var i = 0, j = lines.length; i < j; ++i) {
	      if ((parts = chrome.exec(lines[i]))) {
	        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
	        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
	        if (isEval && (submatch = chromeEval.exec(parts[2]))) {
	          // throw out eval line/column and use top-most line/column number
	          parts[2] = submatch[1]; // url
	          parts[3] = submatch[2]; // line
	          parts[4] = submatch[3]; // column
	        }
	        element = {
	          url: !isNative ? parts[2] : null,
	          func: parts[1] || UNKNOWN_FUNCTION,
	          args: isNative ? [parts[2]] : [],
	          line: parts[3] ? +parts[3] : null,
	          column: parts[4] ? +parts[4] : null
	        };
	      } else if ((parts = winjs.exec(lines[i]))) {
	        element = {
	          url: parts[2],
	          func: parts[1] || UNKNOWN_FUNCTION,
	          args: [],
	          line: +parts[3],
	          column: parts[4] ? +parts[4] : null
	        };
	      } else if ((parts = gecko.exec(lines[i]))) {
	        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
	        if (isEval && (submatch = geckoEval.exec(parts[3]))) {
	          // throw out eval line/column and use top-most line number
	          parts[3] = submatch[1];
	          parts[4] = submatch[2];
	          parts[5] = null; // no column when eval
	        } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
	          // FireFox uses this awesome columnNumber property for its top frame
	          // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	          // so adding 1
	          // NOTE: this hack doesn't work if top-most frame is eval
	          stack[0].column = ex.columnNumber + 1;
	        }
	        element = {
	          url: parts[3],
	          func: parts[1] || UNKNOWN_FUNCTION,
	          args: parts[2] ? parts[2].split(',') : [],
	          line: parts[4] ? +parts[4] : null,
	          column: parts[5] ? +parts[5] : null
	        };
	      } else {
	        continue;
	      }
	
	      if (!element.func && element.line) {
	        element.func = UNKNOWN_FUNCTION;
	      }
	
	      stack.push(element);
	    }
	
	    if (!stack.length) {
	      return null;
	    }
	
	    return {
	      name: ex.name,
	      message: ex.message,
	      url: getLocationHref(),
	      stack: stack
	    };
	  }
	
	  /**
	   * Adds information about the first frame to incomplete stack traces.
	   * Safari and IE require this to get complete data on the first frame.
	   * @param {Object.<string, *>} stackInfo Stack trace information from
	   * one of the compute* methods.
	   * @param {string} url The URL of the script that caused an error.
	   * @param {(number|string)} lineNo The line number of the script that
	   * caused an error.
	   * @param {string=} message The error generated by the browser, which
	   * hopefully contains the name of the object that caused the error.
	   * @return {boolean} Whether or not the stack information was
	   * augmented.
	   */
	  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
	    var initial = {
	      url: url,
	      line: lineNo
	    };
	
	    if (initial.url && initial.line) {
	      stackInfo.incomplete = false;
	
	      if (!initial.func) {
	        initial.func = UNKNOWN_FUNCTION;
	      }
	
	      if (stackInfo.stack.length > 0) {
	        if (stackInfo.stack[0].url === initial.url) {
	          if (stackInfo.stack[0].line === initial.line) {
	            return false; // already in stack trace
	          } else if (
	            !stackInfo.stack[0].line &&
	            stackInfo.stack[0].func === initial.func
	          ) {
	            stackInfo.stack[0].line = initial.line;
	            return false;
	          }
	        }
	      }
	
	      stackInfo.stack.unshift(initial);
	      stackInfo.partial = true;
	      return true;
	    } else {
	      stackInfo.incomplete = true;
	    }
	
	    return false;
	  }
	
	  /**
	   * Computes stack trace information by walking the arguments.caller
	   * chain at the time the exception occurred. This will cause earlier
	   * frames to be missed but is the only way to get any stack trace in
	   * Safari and IE. The top frame is restored by
	   * {@link augmentStackTraceWithInitialElement}.
	   * @param {Error} ex
	   * @return {?Object.<string, *>} Stack trace information.
	   */
	  function computeStackTraceByWalkingCallerChain(ex, depth) {
	    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
	      stack = [],
	      funcs = {},
	      recursion = false,
	      parts,
	      item,
	      source;
	
	    for (
	      var curr = computeStackTraceByWalkingCallerChain.caller;
	      curr && !recursion;
	      curr = curr.caller
	    ) {
	      if (curr === computeStackTrace || curr === TraceKit.report) {
	        // console.log('skipping internal function');
	        continue;
	      }
	
	      item = {
	        url: null,
	        func: UNKNOWN_FUNCTION,
	        line: null,
	        column: null
	      };
	
	      if (curr.name) {
	        item.func = curr.name;
	      } else if ((parts = functionName.exec(curr.toString()))) {
	        item.func = parts[1];
	      }
	
	      if (typeof item.func === 'undefined') {
	        try {
	          item.func = parts.input.substring(0, parts.input.indexOf('{'));
	        } catch (e) {}
	      }
	
	      if (funcs['' + curr]) {
	        recursion = true;
	      } else {
	        funcs['' + curr] = true;
	      }
	
	      stack.push(item);
	    }
	
	    if (depth) {
	      // console.log('depth is ' + depth);
	      // console.log('stack is ' + stack.length);
	      stack.splice(0, depth);
	    }
	
	    var result = {
	      name: ex.name,
	      message: ex.message,
	      url: getLocationHref(),
	      stack: stack
	    };
	    augmentStackTraceWithInitialElement(
	      result,
	      ex.sourceURL || ex.fileName,
	      ex.line || ex.lineNumber,
	      ex.message || ex.description
	    );
	    return result;
	  }
	
	  /**
	   * Computes a stack trace for an exception.
	   * @param {Error} ex
	   * @param {(string|number)=} depth
	   */
	  function computeStackTrace(ex, depth) {
	    var stack = null;
	    depth = depth == null ? 0 : +depth;
	
	    try {
	      stack = computeStackTraceFromStackProp(ex);
	      if (stack) {
	        return stack;
	      }
	    } catch (e) {
	      if (TraceKit.debug) {
	        throw e;
	      }
	    }
	
	    try {
	      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
	      if (stack) {
	        return stack;
	      }
	    } catch (e) {
	      if (TraceKit.debug) {
	        throw e;
	      }
	    }
	    return {
	      name: ex.name,
	      message: ex.message,
	      url: getLocationHref()
	    };
	  }
	
	  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
	  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
	
	  return computeStackTrace;
	})();
	
	module.exports = TraceKit;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var stringify = __webpack_require__(649);
	
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	function isObject(what) {
	  return typeof what === 'object' && what !== null;
	}
	
	// Yanked from https://git.io/vS8DV re-used under CC0
	// with some tiny modifications
	function isError(value) {
	  switch ({}.toString.call(value)) {
	    case '[object Error]':
	      return true;
	    case '[object Exception]':
	      return true;
	    case '[object DOMException]':
	      return true;
	    default:
	      return value instanceof Error;
	  }
	}
	
	function isErrorEvent(value) {
	  return supportsErrorEvent() && {}.toString.call(value) === '[object ErrorEvent]';
	}
	
	function isUndefined(what) {
	  return what === void 0;
	}
	
	function isFunction(what) {
	  return typeof what === 'function';
	}
	
	function isPlainObject(what) {
	  return Object.prototype.toString.call(what) === '[object Object]';
	}
	
	function isString(what) {
	  return Object.prototype.toString.call(what) === '[object String]';
	}
	
	function isArray(what) {
	  return Object.prototype.toString.call(what) === '[object Array]';
	}
	
	function isEmptyObject(what) {
	  if (!isPlainObject(what)) return false;
	
	  for (var _ in what) {
	    if (what.hasOwnProperty(_)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function supportsErrorEvent() {
	  try {
	    new ErrorEvent(''); // eslint-disable-line no-new
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function supportsFetch() {
	  if (!('fetch' in _window)) return false;
	
	  try {
	    new Headers(); // eslint-disable-line no-new
	    new Request(''); // eslint-disable-line no-new
	    new Response(); // eslint-disable-line no-new
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	// Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	// https://caniuse.com/#feat=referrer-policy
	// It doesn't. And it throw exception instead of ignoring this parameter...
	// REF: https://github.com/getsentry/raven-js/issues/1233
	function supportsReferrerPolicy() {
	  if (!supportsFetch()) return false;
	
	  try {
	    // eslint-disable-next-line no-new
	    new Request('pickleRick', {
	      referrerPolicy: 'origin'
	    });
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function supportsPromiseRejectionEvent() {
	  return typeof PromiseRejectionEvent === 'function';
	}
	
	function wrappedCallback(callback) {
	  function dataCallback(data, original) {
	    var normalizedData = callback(data) || data;
	    if (original) {
	      return original(normalizedData) || normalizedData;
	    }
	    return normalizedData;
	  }
	
	  return dataCallback;
	}
	
	function each(obj, callback) {
	  var i, j;
	
	  if (isUndefined(obj.length)) {
	    for (i in obj) {
	      if (hasKey(obj, i)) {
	        callback.call(null, i, obj[i]);
	      }
	    }
	  } else {
	    j = obj.length;
	    if (j) {
	      for (i = 0; i < j; i++) {
	        callback.call(null, i, obj[i]);
	      }
	    }
	  }
	}
	
	function objectMerge(obj1, obj2) {
	  if (!obj2) {
	    return obj1;
	  }
	  each(obj2, function(key, value) {
	    obj1[key] = value;
	  });
	  return obj1;
	}
	
	/**
	 * This function is only used for react-native.
	 * react-native freezes object that have already been sent over the
	 * js bridge. We need this function in order to check if the object is frozen.
	 * So it's ok that objectFrozen returns false if Object.isFrozen is not
	 * supported because it's not relevant for other "platforms". See related issue:
	 * https://github.com/getsentry/react-native-sentry/issues/57
	 */
	function objectFrozen(obj) {
	  if (!Object.isFrozen) {
	    return false;
	  }
	  return Object.isFrozen(obj);
	}
	
	function truncate(str, max) {
	  return !max || str.length <= max ? str : str.substr(0, max) + '\u2026';
	}
	
	/**
	 * hasKey, a better form of hasOwnProperty
	 * Example: hasKey(MainHostObject, property) === true/false
	 *
	 * @param {Object} host object to check property
	 * @param {string} key to check
	 */
	function hasKey(object, key) {
	  return Object.prototype.hasOwnProperty.call(object, key);
	}
	
	function joinRegExp(patterns) {
	  // Combine an array of regular expressions and strings into one large regexp
	  // Be mad.
	  var sources = [],
	    i = 0,
	    len = patterns.length,
	    pattern;
	
	  for (; i < len; i++) {
	    pattern = patterns[i];
	    if (isString(pattern)) {
	      // If it's a string, we need to escape it
	      // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
	      sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
	    } else if (pattern && pattern.source) {
	      // If it's a regexp already, we want to extract the source
	      sources.push(pattern.source);
	    }
	    // Intentionally skip other cases
	  }
	  return new RegExp(sources.join('|'), 'i');
	}
	
	function urlencode(o) {
	  var pairs = [];
	  each(o, function(key, value) {
	    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	  });
	  return pairs.join('&');
	}
	
	// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
	// intentionally using regex and not <a/> href parsing trick because React Native and other
	// environments where DOM might not be available
	function parseUrl(url) {
	  if (typeof url !== 'string') return {};
	  var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
	
	  // coerce to undefined values to empty string so we don't get 'undefined'
	  var query = match[6] || '';
	  var fragment = match[8] || '';
	  return {
	    protocol: match[2],
	    host: match[4],
	    path: match[5],
	    relative: match[5] + query + fragment // everything minus origin
	  };
	}
	function uuid4() {
	  var crypto = _window.crypto || _window.msCrypto;
	
	  if (!isUndefined(crypto) && crypto.getRandomValues) {
	    // Use window.crypto API if available
	    // eslint-disable-next-line no-undef
	    var arr = new Uint16Array(8);
	    crypto.getRandomValues(arr);
	
	    // set 4 in byte 7
	    arr[3] = (arr[3] & 0xfff) | 0x4000;
	    // set 2 most significant bits of byte 9 to '10'
	    arr[4] = (arr[4] & 0x3fff) | 0x8000;
	
	    var pad = function(num) {
	      var v = num.toString(16);
	      while (v.length < 4) {
	        v = '0' + v;
	      }
	      return v;
	    };
	
	    return (
	      pad(arr[0]) +
	      pad(arr[1]) +
	      pad(arr[2]) +
	      pad(arr[3]) +
	      pad(arr[4]) +
	      pad(arr[5]) +
	      pad(arr[6]) +
	      pad(arr[7])
	    );
	  } else {
	    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
	    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	      var r = (Math.random() * 16) | 0,
	        v = c === 'x' ? r : (r & 0x3) | 0x8;
	      return v.toString(16);
	    });
	  }
	}
	
	/**
	 * Given a child DOM element, returns a query-selector statement describing that
	 * and its ancestors
	 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
	 * @param elem
	 * @returns {string}
	 */
	function htmlTreeAsString(elem) {
	  /* eslint no-extra-parens:0*/
	  var MAX_TRAVERSE_HEIGHT = 5,
	    MAX_OUTPUT_LEN = 80,
	    out = [],
	    height = 0,
	    len = 0,
	    separator = ' > ',
	    sepLength = separator.length,
	    nextStr;
	
	  while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
	    nextStr = htmlElementAsString(elem);
	    // bail out if
	    // - nextStr is the 'html' element
	    // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
	    //   (ignore this limit if we are on the first iteration)
	    if (
	      nextStr === 'html' ||
	      (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)
	    ) {
	      break;
	    }
	
	    out.push(nextStr);
	
	    len += nextStr.length;
	    elem = elem.parentNode;
	  }
	
	  return out.reverse().join(separator);
	}
	
	/**
	 * Returns a simple, query-selector representation of a DOM element
	 * e.g. [HTMLElement] => input#foo.btn[name=baz]
	 * @param HTMLElement
	 * @returns {string}
	 */
	function htmlElementAsString(elem) {
	  var out = [],
	    className,
	    classes,
	    key,
	    attr,
	    i;
	
	  if (!elem || !elem.tagName) {
	    return '';
	  }
	
	  out.push(elem.tagName.toLowerCase());
	  if (elem.id) {
	    out.push('#' + elem.id);
	  }
	
	  className = elem.className;
	  if (className && isString(className)) {
	    classes = className.split(/\s+/);
	    for (i = 0; i < classes.length; i++) {
	      out.push('.' + classes[i]);
	    }
	  }
	  var attrWhitelist = ['type', 'name', 'title', 'alt'];
	  for (i = 0; i < attrWhitelist.length; i++) {
	    key = attrWhitelist[i];
	    attr = elem.getAttribute(key);
	    if (attr) {
	      out.push('[' + key + '="' + attr + '"]');
	    }
	  }
	  return out.join('');
	}
	
	/**
	 * Returns true if either a OR b is truthy, but not both
	 */
	function isOnlyOneTruthy(a, b) {
	  return !!(!!a ^ !!b);
	}
	
	/**
	 * Returns true if both parameters are undefined
	 */
	function isBothUndefined(a, b) {
	  return isUndefined(a) && isUndefined(b);
	}
	
	/**
	 * Returns true if the two input exception interfaces have the same content
	 */
	function isSameException(ex1, ex2) {
	  if (isOnlyOneTruthy(ex1, ex2)) return false;
	
	  ex1 = ex1.values[0];
	  ex2 = ex2.values[0];
	
	  if (ex1.type !== ex2.type || ex1.value !== ex2.value) return false;
	
	  // in case both stacktraces are undefined, we can't decide so default to false
	  if (isBothUndefined(ex1.stacktrace, ex2.stacktrace)) return false;
	
	  return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
	}
	
	/**
	 * Returns true if the two input stack trace interfaces have the same content
	 */
	function isSameStacktrace(stack1, stack2) {
	  if (isOnlyOneTruthy(stack1, stack2)) return false;
	
	  var frames1 = stack1.frames;
	  var frames2 = stack2.frames;
	
	  // Exit early if frame count differs
	  if (frames1.length !== frames2.length) return false;
	
	  // Iterate through every frame; bail out if anything differs
	  var a, b;
	  for (var i = 0; i < frames1.length; i++) {
	    a = frames1[i];
	    b = frames2[i];
	    if (
	      a.filename !== b.filename ||
	      a.lineno !== b.lineno ||
	      a.colno !== b.colno ||
	      a['function'] !== b['function']
	    )
	      return false;
	  }
	  return true;
	}
	
	/**
	 * Polyfill a method
	 * @param obj object e.g. `document`
	 * @param name method name present on object e.g. `addEventListener`
	 * @param replacement replacement function
	 * @param track {optional} record instrumentation to an array
	 */
	function fill(obj, name, replacement, track) {
	  if (obj == null) return;
	  var orig = obj[name];
	  obj[name] = replacement(orig);
	  obj[name].__raven__ = true;
	  obj[name].__orig__ = orig;
	  if (track) {
	    track.push([obj, name, orig]);
	  }
	}
	
	/**
	 * Join values in array
	 * @param input array of values to be joined together
	 * @param delimiter string to be placed in-between values
	 * @returns {string}
	 */
	function safeJoin(input, delimiter) {
	  if (!isArray(input)) return '';
	
	  var output = [];
	
	  for (var i = 0; i < input.length; i++) {
	    try {
	      output.push(String(input[i]));
	    } catch (e) {
	      output.push('[value cannot be serialized]');
	    }
	  }
	
	  return output.join(delimiter);
	}
	
	// Default Node.js REPL depth
	var MAX_SERIALIZE_EXCEPTION_DEPTH = 3;
	// 50kB, as 100kB is max payload size, so half sounds reasonable
	var MAX_SERIALIZE_EXCEPTION_SIZE = 50 * 1024;
	var MAX_SERIALIZE_KEYS_LENGTH = 40;
	
	function utf8Length(value) {
	  return ~-encodeURI(value).split(/%..|./).length;
	}
	
	function jsonSize(value) {
	  return utf8Length(JSON.stringify(value));
	}
	
	function serializeValue(value) {
	  var maxLength = 40;
	
	  if (typeof value === 'string') {
	    return value.length <= maxLength ? value : value.substr(0, maxLength - 1) + '\u2026';
	  } else if (
	    typeof value === 'number' ||
	    typeof value === 'boolean' ||
	    typeof value === 'undefined'
	  ) {
	    return value;
	  }
	
	  var type = Object.prototype.toString.call(value);
	
	  // Node.js REPL notation
	  if (type === '[object Object]') return '[Object]';
	  if (type === '[object Array]') return '[Array]';
	  if (type === '[object Function]')
	    return value.name ? '[Function: ' + value.name + ']' : '[Function]';
	
	  return value;
	}
	
	function serializeObject(value, depth) {
	  if (depth === 0) return serializeValue(value);
	
	  if (isPlainObject(value)) {
	    return Object.keys(value).reduce(function(acc, key) {
	      acc[key] = serializeObject(value[key], depth - 1);
	      return acc;
	    }, {});
	  } else if (Array.isArray(value)) {
	    return value.map(function(val) {
	      return serializeObject(val, depth - 1);
	    });
	  }
	
	  return serializeValue(value);
	}
	
	function serializeException(ex, depth, maxSize) {
	  if (!isPlainObject(ex)) return ex;
	
	  depth = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_DEPTH : depth;
	  maxSize = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_SIZE : maxSize;
	
	  var serialized = serializeObject(ex, depth);
	
	  if (jsonSize(stringify(serialized)) > maxSize) {
	    return serializeException(ex, depth - 1);
	  }
	
	  return serialized;
	}
	
	function serializeKeysForMessage(keys, maxLength) {
	  if (typeof keys === 'number' || typeof keys === 'string') return keys.toString();
	  if (!Array.isArray(keys)) return '';
	
	  keys = keys.filter(function(key) {
	    return typeof key === 'string';
	  });
	  if (keys.length === 0) return '[object has no keys]';
	
	  maxLength = typeof maxLength !== 'number' ? MAX_SERIALIZE_KEYS_LENGTH : maxLength;
	  if (keys[0].length >= maxLength) return keys[0];
	
	  for (var usedKeys = keys.length; usedKeys > 0; usedKeys--) {
	    var serialized = keys.slice(0, usedKeys).join(', ');
	    if (serialized.length > maxLength) continue;
	    if (usedKeys === keys.length) return serialized;
	    return serialized + '\u2026';
	  }
	
	  return '';
	}
	
	function sanitize(input, sanitizeKeys) {
	  if (!isArray(sanitizeKeys) || (isArray(sanitizeKeys) && sanitizeKeys.length === 0))
	    return input;
	
	  var sanitizeRegExp = joinRegExp(sanitizeKeys);
	  var sanitizeMask = '********';
	  var safeInput;
	
	  try {
	    safeInput = JSON.parse(stringify(input));
	  } catch (o_O) {
	    return input;
	  }
	
	  function sanitizeWorker(workerInput) {
	    if (isArray(workerInput)) {
	      return workerInput.map(function(val) {
	        return sanitizeWorker(val);
	      });
	    }
	
	    if (isPlainObject(workerInput)) {
	      return Object.keys(workerInput).reduce(function(acc, k) {
	        if (sanitizeRegExp.test(k)) {
	          acc[k] = sanitizeMask;
	        } else {
	          acc[k] = sanitizeWorker(workerInput[k]);
	        }
	        return acc;
	      }, {});
	    }
	
	    return workerInput;
	  }
	
	  return sanitizeWorker(safeInput);
	}
	
	module.exports = {
	  isObject: isObject,
	  isError: isError,
	  isErrorEvent: isErrorEvent,
	  isUndefined: isUndefined,
	  isFunction: isFunction,
	  isPlainObject: isPlainObject,
	  isString: isString,
	  isArray: isArray,
	  isEmptyObject: isEmptyObject,
	  supportsErrorEvent: supportsErrorEvent,
	  supportsFetch: supportsFetch,
	  supportsReferrerPolicy: supportsReferrerPolicy,
	  supportsPromiseRejectionEvent: supportsPromiseRejectionEvent,
	  wrappedCallback: wrappedCallback,
	  each: each,
	  objectMerge: objectMerge,
	  truncate: truncate,
	  objectFrozen: objectFrozen,
	  hasKey: hasKey,
	  joinRegExp: joinRegExp,
	  urlencode: urlencode,
	  uuid4: uuid4,
	  htmlTreeAsString: htmlTreeAsString,
	  htmlElementAsString: htmlElementAsString,
	  isSameException: isSameException,
	  isSameStacktrace: isSameStacktrace,
	  parseUrl: parseUrl,
	  fill: fill,
	  safeJoin: safeJoin,
	  serializeException: serializeException,
	  serializeKeysForMessage: serializeKeysForMessage,
	  sanitize: sanitize
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 649 */
/***/ function(module, exports) {

	/*
	 json-stringify-safe
	 Like JSON.stringify, but doesn't throw on circular references.
	
	 Originally forked from https://github.com/isaacs/json-stringify-safe
	 version 5.0.1 on 3/8/2017 and modified to handle Errors serialization
	 and IE8 compatibility. Tests for this are in test/vendor.
	
	 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
	*/
	
	exports = module.exports = stringify;
	exports.getSerialize = serializer;
	
	function indexOf(haystack, needle) {
	  for (var i = 0; i < haystack.length; ++i) {
	    if (haystack[i] === needle) return i;
	  }
	  return -1;
	}
	
	function stringify(obj, replacer, spaces, cycleReplacer) {
	  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
	}
	
	// https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
	function stringifyError(value) {
	  var err = {
	    // These properties are implemented as magical getters and don't show up in for in
	    stack: value.stack,
	    message: value.message,
	    name: value.name
	  };
	
	  for (var i in value) {
	    if (Object.prototype.hasOwnProperty.call(value, i)) {
	      err[i] = value[i];
	    }
	  }
	
	  return err;
	}
	
	function serializer(replacer, cycleReplacer) {
	  var stack = [];
	  var keys = [];
	
	  if (cycleReplacer == null) {
	    cycleReplacer = function(key, value) {
	      if (stack[0] === value) {
	        return '[Circular ~]';
	      }
	      return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']';
	    };
	  }
	
	  return function(key, value) {
	    if (stack.length > 0) {
	      var thisPos = indexOf(stack, this);
	      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
	      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
	
	      if (~indexOf(stack, value)) {
	        value = cycleReplacer.call(this, key, value);
	      }
	    } else {
	      stack.push(value);
	    }
	
	    return replacer == null
	      ? value instanceof Error ? stringifyError(value) : value
	      : replacer.call(this, key, value);
	  };
	}


/***/ },
/* 650 */
/***/ function(module, exports) {

	/*
	 * JavaScript MD5
	 * https://github.com/blueimp/JavaScript-MD5
	 *
	 * Copyright 2011, Sebastian Tschan
	 * https://blueimp.net
	 *
	 * Licensed under the MIT license:
	 * https://opensource.org/licenses/MIT
	 *
	 * Based on
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	/*
	* Add integers, wrapping at 2^32. This uses 16-bit operations internally
	* to work around bugs in some JS interpreters.
	*/
	function safeAdd(x, y) {
	  var lsw = (x & 0xffff) + (y & 0xffff);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xffff);
	}
	
	/*
	* Bitwise rotate a 32-bit number to the left.
	*/
	function bitRotateLeft(num, cnt) {
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	/*
	* These functions implement the four basic operations the algorithm uses.
	*/
	function md5cmn(q, a, b, x, s, t) {
	  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
	}
	function md5ff(a, b, c, d, x, s, t) {
	  return md5cmn((b & c) | (~b & d), a, b, x, s, t);
	}
	function md5gg(a, b, c, d, x, s, t) {
	  return md5cmn((b & d) | (c & ~d), a, b, x, s, t);
	}
	function md5hh(a, b, c, d, x, s, t) {
	  return md5cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5ii(a, b, c, d, x, s, t) {
	  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
	}
	
	/*
	* Calculate the MD5 of an array of little-endian words, and a bit length.
	*/
	function binlMD5(x, len) {
	  /* append padding */
	  x[len >> 5] |= 0x80 << (len % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var i;
	  var olda;
	  var oldb;
	  var oldc;
	  var oldd;
	  var a = 1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d = 271733878;
	
	  for (i = 0; i < x.length; i += 16) {
	    olda = a;
	    oldb = b;
	    oldc = c;
	    oldd = d;
	
	    a = md5ff(a, b, c, d, x[i], 7, -680876936);
	    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
	    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
	    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
	    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
	    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
	    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
	    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
	    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
	    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
	    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
	    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
	    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
	    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
	    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
	    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
	
	    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
	    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
	    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
	    b = md5gg(b, c, d, a, x[i], 20, -373897302);
	    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
	    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
	    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
	    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
	    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
	    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
	    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
	    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
	    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
	    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
	    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
	    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
	
	    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
	    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
	    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
	    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
	    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
	    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
	    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
	    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
	    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
	    d = md5hh(d, a, b, c, x[i], 11, -358537222);
	    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
	    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
	    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
	    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
	    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
	    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
	
	    a = md5ii(a, b, c, d, x[i], 6, -198630844);
	    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
	    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
	    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
	    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
	    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
	    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
	    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
	    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
	    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
	    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
	    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
	    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
	    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
	    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
	    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
	
	    a = safeAdd(a, olda);
	    b = safeAdd(b, oldb);
	    c = safeAdd(c, oldc);
	    d = safeAdd(d, oldd);
	  }
	  return [a, b, c, d];
	}
	
	/*
	* Convert an array of little-endian words to a string
	*/
	function binl2rstr(input) {
	  var i;
	  var output = '';
	  var length32 = input.length * 32;
	  for (i = 0; i < length32; i += 8) {
	    output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xff);
	  }
	  return output;
	}
	
	/*
	* Convert a raw string to an array of little-endian words
	* Characters >255 have their high-byte silently ignored.
	*/
	function rstr2binl(input) {
	  var i;
	  var output = [];
	  output[(input.length >> 2) - 1] = undefined;
	  for (i = 0; i < output.length; i += 1) {
	    output[i] = 0;
	  }
	  var length8 = input.length * 8;
	  for (i = 0; i < length8; i += 8) {
	    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << (i % 32);
	  }
	  return output;
	}
	
	/*
	* Calculate the MD5 of a raw string
	*/
	function rstrMD5(s) {
	  return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
	}
	
	/*
	* Calculate the HMAC-MD5, of a key and some data (raw strings)
	*/
	function rstrHMACMD5(key, data) {
	  var i;
	  var bkey = rstr2binl(key);
	  var ipad = [];
	  var opad = [];
	  var hash;
	  ipad[15] = opad[15] = undefined;
	  if (bkey.length > 16) {
	    bkey = binlMD5(bkey, key.length * 8);
	  }
	  for (i = 0; i < 16; i += 1) {
	    ipad[i] = bkey[i] ^ 0x36363636;
	    opad[i] = bkey[i] ^ 0x5c5c5c5c;
	  }
	  hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
	  return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
	}
	
	/*
	* Convert a raw string to a hex string
	*/
	function rstr2hex(input) {
	  var hexTab = '0123456789abcdef';
	  var output = '';
	  var x;
	  var i;
	  for (i = 0; i < input.length; i += 1) {
	    x = input.charCodeAt(i);
	    output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
	  }
	  return output;
	}
	
	/*
	* Encode a string as utf-8
	*/
	function str2rstrUTF8(input) {
	  return unescape(encodeURIComponent(input));
	}
	
	/*
	* Take string arguments and return either raw or hex encoded strings
	*/
	function rawMD5(s) {
	  return rstrMD5(str2rstrUTF8(s));
	}
	function hexMD5(s) {
	  return rstr2hex(rawMD5(s));
	}
	function rawHMACMD5(k, d) {
	  return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
	}
	function hexHMACMD5(k, d) {
	  return rstr2hex(rawHMACMD5(k, d));
	}
	
	function md5(string, key, raw) {
	  if (!key) {
	    if (!raw) {
	      return hexMD5(string);
	    }
	    return rawMD5(string);
	  }
	  if (!raw) {
	    return hexHMACMD5(key, string);
	  }
	  return rawHMACMD5(key, string);
	}
	
	module.exports = md5;


/***/ },
/* 651 */
/***/ function(module, exports) {

	function RavenConfigError(message) {
	  this.name = 'RavenConfigError';
	  this.message = message;
	}
	RavenConfigError.prototype = new Error();
	RavenConfigError.prototype.constructor = RavenConfigError;
	
	module.exports = RavenConfigError;


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(648);
	
	var wrapMethod = function(console, level, callback) {
	  var originalConsoleLevel = console[level];
	  var originalConsole = console;
	
	  if (!(level in console)) {
	    return;
	  }
	
	  var sentryLevel = level === 'warn' ? 'warning' : level;
	
	  console[level] = function() {
	    var args = [].slice.call(arguments);
	
	    var msg = utils.safeJoin(args, ' ');
	    var data = {level: sentryLevel, logger: 'console', extra: {arguments: args}};
	
	    if (level === 'assert') {
	      if (args[0] === false) {
	        // Default browsers message
	        msg =
	          'Assertion failed: ' + (utils.safeJoin(args.slice(1), ' ') || 'console.assert');
	        data.extra.arguments = args.slice(1);
	        callback && callback(msg, data);
	      }
	    } else {
	      callback && callback(msg, data);
	    }
	
	    // this fails for some browsers. :(
	    if (originalConsoleLevel) {
	      // IE9 doesn't allow calling apply on console functions directly
	      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
	      Function.prototype.apply.call(originalConsoleLevel, originalConsole, args);
	    }
	  };
	};
	
	module.exports = {
	  wrapMethod: wrapMethod
	};


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Angular.js plugin
	 *
	 * Provides an $exceptionHandler for Angular.js
	 */
	var wrappedCallback = __webpack_require__(648).wrappedCallback;
	
	// See https://github.com/angular/angular.js/blob/v1.4.7/src/minErr.js
	var angularPattern = /^\[((?:[$a-zA-Z0-9]+:)?(?:[$a-zA-Z0-9]+))\] (.*?)\n?(\S+)$/;
	var moduleName = 'ngRaven';
	
	function angularPlugin(Raven, angular) {
	  angular = angular || window.angular;
	
	  if (!angular) return;
	
	  function RavenProvider() {
	    this.$get = [
	      '$window',
	      function($window) {
	        return Raven;
	      }
	    ];
	  }
	
	  function ExceptionHandlerProvider($provide) {
	    $provide.decorator('$exceptionHandler', ['Raven', '$delegate', exceptionHandler]);
	  }
	
	  function exceptionHandler(R, $delegate) {
	    return function(ex, cause) {
	      R.captureException(ex, {
	        extra: {cause: cause}
	      });
	      $delegate(ex, cause);
	    };
	  }
	
	  angular
	    .module(moduleName, [])
	    .provider('Raven', RavenProvider)
	    .config(['$provide', ExceptionHandlerProvider]);
	
	  Raven.setDataCallback(
	    wrappedCallback(function(data) {
	      return angularPlugin._normalizeData(data);
	    })
	  );
	}
	
	angularPlugin._normalizeData = function(data) {
	  // We only care about mutating an exception
	  var exception = data.exception;
	  if (exception) {
	    exception = exception.values[0];
	    var matches = angularPattern.exec(exception.value);
	
	    if (matches) {
	      // This type now becomes something like: $rootScope:inprog
	      exception.type = matches[1];
	      exception.value = matches[2];
	
	      data.message = exception.type + ': ' + exception.value;
	      // auto set a new tag specifically for the angular error url
	      data.extra.angularDocs = matches[3].substr(0, 250);
	    }
	  }
	
	  return data;
	};
	
	angularPlugin.moduleName = moduleName;
	
	module.exports = angularPlugin;


/***/ },
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var humanizeDuration = __webpack_require__(658);
	var moment = __webpack_require__(517);
	
	/**
	 * angular-timer - v1.3.3 - 2015-06-15 3:07 PM
	 * https://github.com/siddii/angular-timer
	 *
	 * Copyright (c) 2015 Siddique Hameed
	 * Licensed MIT <https://github.com/siddii/angular-timer/blob/master/LICENSE.txt>
	 */
	var timerModule = angular.module('timer', [])
	  .directive('timer', ['$compile', function ($compile) {
	    return  {
	      restrict: 'EA',
	      replace: false,
	      scope: {
	        interval: '=interval',
	        startTimeAttr: '=startTime',
	        endTimeAttr: '=endTime',
	        countdownattr: '=countdown',
	        finishCallback: '&finishCallback',
	        autoStart: '&autoStart',
	        language: '@?',
	        fallback: '@?',
	        maxTimeUnit: '='
	      },
	      controller: ['$scope', '$element', '$attrs', '$timeout', 'I18nService', '$interpolate', 'progressBarService', function ($scope, $element, $attrs, $timeout, I18nService, $interpolate, progressBarService) {
	
	        // Checking for trim function since IE8 doesn't have it
	        // If not a function, create tirm with RegEx to mimic native trim
	        if (typeof String.prototype.trim !== 'function') {
	          String.prototype.trim = function () {
	            return this.replace(/^\s+|\s+$/g, '');
	          };
	        }
	
	        //angular 1.2 doesn't support attributes ending in "-start", so we're
	        //supporting both "autostart" and "auto-start" as a solution for
	        //backward and forward compatibility.
	        $scope.autoStart = $attrs.autoStart || $attrs.autostart;
	
	
	        $scope.language = $scope.language || 'en';
	        $scope.fallback = $scope.fallback || 'en';
	
	        //allow to change the language of the directive while already launched
	        $scope.$watch('language', function(newVal, oldVal) {
	          if(newVal !== undefined) {
	            i18nService.init(newVal, $scope.fallback);
	          }
	        });
	
	        //init momentJS i18n, default english
	        var i18nService = new I18nService();
	        i18nService.init($scope.language, $scope.fallback);
	
	        //progress bar
	        $scope.displayProgressBar = 0;
	        $scope.displayProgressActive = 'active'; //Bootstrap active effect for progress bar
	
	        if ($element.html().trim().length === 0) {
	          $element.append($compile('<span>' + $interpolate.startSymbol() + 'millis' + $interpolate.endSymbol() + '</span>')($scope));
	        } else {
	          $element.append($compile($element.contents())($scope));
	        }
	
	        $scope.startTime = null;
	        $scope.endTime = null;
	        $scope.timeoutId = null;
	        $scope.countdown = $scope.countdownattr && parseInt($scope.countdownattr, 10) >= 0 ? parseInt($scope.countdownattr, 10) : undefined;
	        $scope.isRunning = false;
	
	        $scope.$on('timer-start', function () {
	          $scope.start();
	        });
	
	        $scope.$on('timer-resume', function () {
	          $scope.resume();
	        });
	
	        $scope.$on('timer-stop', function () {
	          $scope.stop();
	        });
	
	        $scope.$on('timer-clear', function () {
	          $scope.clear();
	        });
	
	        $scope.$on('timer-reset', function () {
	          $scope.reset();
	        });
	
	        $scope.$on('timer-set-countdown', function (e, countdown) {
	          $scope.countdown = countdown;
	        });
	
	        function resetTimeout() {
	          if ($scope.timeoutId) {
	            clearTimeout($scope.timeoutId);
	          }
	        }
	
	        $scope.$watch('startTimeAttr', function(newValue, oldValue) {
	          if (newValue !== oldValue && $scope.isRunning) {
	            $scope.start();
	          }
	        });
	
	        $scope.$watch('endTimeAttr', function(newValue, oldValue) {
	          if (newValue !== oldValue && $scope.isRunning) {
	            $scope.start();
	          }
	        });
	
	        $scope.start = $element[0].start = function () {
	          $scope.startTime = $scope.startTimeAttr ? moment($scope.startTimeAttr) : moment();
	          $scope.endTime = $scope.endTimeAttr ? moment($scope.endTimeAttr) : null;
	          if (!$scope.countdown) {
	            $scope.countdown = $scope.countdownattr && parseInt($scope.countdownattr, 10) > 0 ? parseInt($scope.countdownattr, 10) : undefined;
	          }
	          resetTimeout();
	          tick();
	          $scope.isRunning = true;
	        };
	
	        $scope.resume = $element[0].resume = function () {
	          resetTimeout();
	          if ($scope.countdownattr) {
	            $scope.countdown += 1;
	          }
	          $scope.startTime = moment().diff((moment($scope.stoppedTime).diff(moment($scope.startTime))));
	          tick();
	          $scope.isRunning = true;
	        };
	
	        $scope.stop = $scope.pause = $element[0].stop = $element[0].pause = function () {
	          var timeoutId = $scope.timeoutId;
	          $scope.clear();
	          $scope.$emit('timer-stopped', {timeoutId: timeoutId, millis: $scope.millis, seconds: $scope.seconds, minutes: $scope.minutes, hours: $scope.hours, days: $scope.days});
	        };
	
	        $scope.clear = $element[0].clear = function () {
	          // same as stop but without the event being triggered
	          $scope.stoppedTime = moment();
	          resetTimeout();
	          $scope.timeoutId = null;
	          $scope.isRunning = false;
	        };
	
	        $scope.reset = $element[0].reset = function () {
	          $scope.startTime = $scope.startTimeAttr ? moment($scope.startTimeAttr) : moment();
	          $scope.endTime = $scope.endTimeAttr ? moment($scope.endTimeAttr) : null;
	          $scope.countdown = $scope.countdownattr && parseInt($scope.countdownattr, 10) > 0 ? parseInt($scope.countdownattr, 10) : undefined;
	          resetTimeout();
	          tick();
	          $scope.isRunning = false;
	          $scope.clear();
	        };
	
	        $element.bind('$destroy', function () {
	          resetTimeout();
	          $scope.isRunning = false;
	        });
	
	
	        function calculateTimeUnits() {
	          var timeUnits = {}; //will contains time with units
	
	          if ($attrs.startTime !== undefined){
	            $scope.millis = moment().diff(moment($scope.startTimeAttr));
	          }
	
	          timeUnits = i18nService.getTimeUnits($scope.millis);
	
	          // compute time values based on maxTimeUnit specification
	          if (!$scope.maxTimeUnit || $scope.maxTimeUnit === 'day') {
	            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
	            $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
	            $scope.hours = Math.floor((($scope.millis / (3600000)) % 24));
	            $scope.days = Math.floor((($scope.millis / (3600000)) / 24));
	            $scope.months = 0;
	            $scope.years = 0;
	          } else if ($scope.maxTimeUnit === 'second') {
	            $scope.seconds = Math.floor($scope.millis / 1000);
	            $scope.minutes = 0;
	            $scope.hours = 0;
	            $scope.days = 0;
	            $scope.months = 0;
	            $scope.years = 0;
	          } else if ($scope.maxTimeUnit === 'minute') {
	            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
	            $scope.minutes = Math.floor($scope.millis / 60000);
	            $scope.hours = 0;
	            $scope.days = 0;
	            $scope.months = 0;
	            $scope.years = 0;
	          } else if ($scope.maxTimeUnit === 'hour') {
	            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
	            $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
	            $scope.hours = Math.floor($scope.millis / 3600000);
	            $scope.days = 0;
	            $scope.months = 0;
	            $scope.years = 0;
	          } else if ($scope.maxTimeUnit === 'month') {
	            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
	            $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
	            $scope.hours = Math.floor((($scope.millis / (3600000)) % 24));
	            $scope.days = Math.floor((($scope.millis / (3600000)) / 24) % 30);
	            $scope.months = Math.floor((($scope.millis / (3600000)) / 24) / 30);
	            $scope.years = 0;
	          } else if ($scope.maxTimeUnit === 'year') {
	            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
	            $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
	            $scope.hours = Math.floor((($scope.millis / (3600000)) % 24));
	            $scope.days = Math.floor((($scope.millis / (3600000)) / 24) % 30);
	            $scope.months = Math.floor((($scope.millis / (3600000)) / 24 / 30) % 12);
	            $scope.years = Math.floor(($scope.millis / (3600000)) / 24 / 365);
	          }
	          // plural - singular unit decision (old syntax, for backwards compatibility and English only, could be deprecated!)
	          $scope.secondsS = ($scope.seconds === 1) ? '' : 's';
	          $scope.minutesS = ($scope.minutes === 1) ? '' : 's';
	          $scope.hoursS = ($scope.hours === 1) ? '' : 's';
	          $scope.daysS = ($scope.days === 1)? '' : 's';
	          $scope.monthsS = ($scope.months === 1)? '' : 's';
	          $scope.yearsS = ($scope.years === 1)? '' : 's';
	
	
	          // new plural-singular unit decision functions (for custom units and multilingual support)
	          $scope.secondUnit = timeUnits.seconds;
	          $scope.minuteUnit = timeUnits.minutes;
	          $scope.hourUnit = timeUnits.hours;
	          $scope.dayUnit = timeUnits.days;
	          $scope.monthUnit = timeUnits.months;
	          $scope.yearUnit = timeUnits.years;
	
	          //add leading zero if number is smaller than 10
	          $scope.sseconds = $scope.seconds < 10 ? '0' + $scope.seconds : $scope.seconds;
	          $scope.mminutes = $scope.minutes < 10 ? '0' + $scope.minutes : $scope.minutes;
	          $scope.hhours = $scope.hours < 10 ? '0' + $scope.hours : $scope.hours;
	          $scope.ddays = $scope.days < 10 ? '0' + $scope.days : $scope.days;
	          $scope.mmonths = $scope.months < 10 ? '0' + $scope.months : $scope.months;
	          $scope.yyears = $scope.years < 10 ? '0' + $scope.years : $scope.years;
	
	        }
	
	        //determine initial values of time units and add AddSeconds functionality
	        if ($scope.countdownattr) {
	          $scope.millis = $scope.countdownattr * 1000;
	
	          $scope.addCDSeconds = $element[0].addCDSeconds = function (extraSeconds) {
	            $scope.countdown += extraSeconds;
	            $scope.$digest();
	            if (!$scope.isRunning) {
	              $scope.start();
	            }
	          };
	
	          $scope.$on('timer-add-cd-seconds', function (e, extraSeconds) {
	            $timeout(function () {
	              $scope.addCDSeconds(extraSeconds);
	            });
	          });
	
	          $scope.$on('timer-set-countdown-seconds', function (e, countdownSeconds) {
	            if (!$scope.isRunning) {
	              $scope.clear();
	            }
	
	            $scope.countdown = countdownSeconds;
	            $scope.millis = countdownSeconds * 1000;
	            calculateTimeUnits();
	          });
	        } else {
	          $scope.millis = 0;
	        }
	        calculateTimeUnits();
	
	        var tick = function tick() {
	          var typeTimer = null; // countdown or endTimeAttr
	          $scope.millis = moment().diff($scope.startTime);
	          var adjustment = $scope.millis % 1000;
	
	          if ($scope.endTimeAttr) {
	            typeTimer = $scope.endTimeAttr;
	            $scope.millis = moment($scope.endTime).diff(moment());
	            adjustment = $scope.interval - $scope.millis % 1000;
	          }
	
	          if ($scope.countdownattr) {
	            typeTimer = $scope.countdownattr;
	            $scope.millis = $scope.countdown * 1000;
	          }
	
	          if ($scope.millis < 0) {
	            $scope.stop();
	            $scope.millis = 0;
	            calculateTimeUnits();
	            if($scope.finishCallback) {
	              $scope.$eval($scope.finishCallback);
	            }
	            return;
	          }
	          calculateTimeUnits();
	
	          //We are not using $timeout for a reason. Please read here - https://github.com/siddii/angular-timer/pull/5
	          $scope.timeoutId = setTimeout(function () {
	            tick();
	            $scope.$digest();
	          }, $scope.interval - adjustment);
	
	          $scope.$emit('timer-tick', {timeoutId: $scope.timeoutId, millis: $scope.millis});
	
	          if ($scope.countdown > 0) {
	            $scope.countdown--;
	          }
	          else if ($scope.countdown <= 0) {
	            $scope.stop();
	            if($scope.finishCallback) {
	              $scope.$eval($scope.finishCallback);
	            }
	          }
	
	          if(typeTimer !== null){
	            //calculate progress bar
	            $scope.progressBar = progressBarService.calculateProgressBar($scope.startTime, $scope.millis, $scope.endTime, $scope.countdownattr);
	
	            if($scope.progressBar === 100){
	              $scope.displayProgressActive = ''; //No more Bootstrap active effect
	            }
	          }
	        };
	
	        if ($scope.autoStart === undefined || $scope.autoStart === true) {
	          $scope.start();
	        }
	      }]
	    };
	    }]);
	
	/* commonjs package manager support (eg componentjs) */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
	  module.exports = timerModule;
	}
	
	var app = angular.module('timer');
	
	app.factory('I18nService', function() {
	
	    var I18nService = function() {};
	
	    I18nService.prototype.language = 'en';
	    I18nService.prototype.fallback = 'en';
	    I18nService.prototype.timeHumanizer = {};
	
	    I18nService.prototype.init = function init(lang, fallback) {
	        var supported_languages = humanizeDuration.getSupportedLanguages();
	
	        this.fallback = (fallback !== undefined) ? fallback : 'en';
	        if (supported_languages.indexOf(fallback) === -1) {
	            this.fallback = 'en';
	        }
	
	        this.language = lang;
	        if (supported_languages.indexOf(lang) === -1) {
	            this.language = this.fallback;
	        }
	
	        //moment init
	        moment.locale(this.language); //@TODO maybe to remove, it should be handle by the user's application itself, and not inside the directive
	
	        //human duration init, using it because momentjs does not allow accurate time (
	        // momentJS: a few moment ago, human duration : 4 seconds ago
	        this.timeHumanizer = humanizeDuration.humanizer({
	            language: this.language,
	            halfUnit:false
	        });
	    };
	
	    /**
	     * get time with units from momentJS i18n
	     * @param {int} millis
	     * @returns {{millis: string, seconds: string, minutes: string, hours: string, days: string, months: string, years: string}}
	     */
	    I18nService.prototype.getTimeUnits = function getTimeUnits(millis) {
	        var diffFromAlarm = Math.round(millis/1000) * 1000; //time in milliseconds, get rid of the last 3 ms value to avoid 2.12 seconds display
	
	        var time = {};
	
	        if (typeof this.timeHumanizer != 'undefined'){
	            time = {
	                'millis' : this.timeHumanizer(diffFromAlarm, { units: ["milliseconds"] }),
	                'seconds' : this.timeHumanizer(diffFromAlarm, { units: ["seconds"] }),
	                'minutes' : this.timeHumanizer(diffFromAlarm, { units: ["minutes", "seconds"] }) ,
	                'hours' : this.timeHumanizer(diffFromAlarm, { units: ["hours", "minutes", "seconds"] }) ,
	                'days' : this.timeHumanizer(diffFromAlarm, { units: ["days", "hours", "minutes", "seconds"] }) ,
	                'months' : this.timeHumanizer(diffFromAlarm, { units: ["months", "days", "hours", "minutes", "seconds"] }) ,
	                'years' : this.timeHumanizer(diffFromAlarm, { units: ["years", "months", "days", "hours", "minutes", "seconds"] })
	            };
	        }
	        else {
	            console.error('i18nService has not been initialized. You must call i18nService.init("en") for example');
	        }
	
	        return time;
	    };
	
	    return I18nService;
	});
	
	var app = angular.module('timer');
	
	app.factory('progressBarService', function() {
	
	  var ProgressBarService = function() {};
	
	  /**
	   * calculate the remaining time in a progress bar in percentage
	   * @param {momentjs} startValue in seconds
	   * @param {integer} currentCountdown, where are we in the countdown
	   * @param {integer} remainingTime, remaining milliseconds
	   * @param {integer} endTime, end time, can be undefined
	   * @param {integer} coutdown, original coutdown value, can be undefined
	   *
	   * joke : https://www.youtube.com/watch?v=gENVB6tjq_M
	   * @return {float} 0 --> 100
	   */
	  ProgressBarService.prototype.calculateProgressBar = function calculateProgressBar(startValue, remainingTime, endTimeAttr, coutdown) {
	    var displayProgressBar = 0,
	      endTimeValue,
	      initialCountdown;
	
	    remainingTime = remainingTime / 1000; //seconds
	
	
	    if(endTimeAttr !== null){
	      endTimeValue = moment(endTimeAttr);
	      initialCountdown = endTimeValue.diff(startValue, 'seconds');
	      displayProgressBar = remainingTime * 100 / initialCountdown;
	    }
	    else {
	      displayProgressBar = remainingTime * 100 / coutdown;
	    }
	
	    displayProgressBar = 100 - displayProgressBar; //To have 0 to 100 and not 100 to 0
	    displayProgressBar = Math.round(displayProgressBar * 10) / 10; //learn more why : http://stackoverflow.com/questions/588004/is-floating-point-math-broken
	
	    if(displayProgressBar > 100){ //security
	      displayProgressBar = 100;
	    }
	
	    return displayProgressBar;
	  };
	
	  return new ProgressBarService();
	});
	
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = "timer";

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;// HumanizeDuration.js - http://git.io/j0HgmQ
	
	(function(global) {
	  var languages = {
	    ar: {
	      y: function(c) { return ((c === 1) ? "سنة" : "سنوات"); },
	      mo: function(c) { return ((c === 1) ? "شهر" : "أشهر"); },
	      w: function(c) { return ((c === 1) ? "أسبوع" : "أسابيع"); },
	      d: function(c) { return ((c === 1) ? "يوم" : "أيام"); },
	      h: function(c) { return ((c === 1) ? "ساعة" : "ساعات"); },
	      m: function(c) { return ((c === 1) ? "دقيقة" : "دقائق"); },
	      s: function(c) { return ((c === 1) ? "ثانية" : "ثواني"); },
	      ms: function(c) { return ((c === 1) ? "جزء من الثانية" : "أجزاء من الثانية"); },
	      decimal: ","
	    },
	    ca: {
	      y: function(c) { return "any" + ((c !== 1) ? "s" : ""); },
	      mo: function(c) { return "mes" + ((c !== 1) ? "os" : ""); },
	      w: function(c) { return "setman" + ((c !== 1) ? "es" : "a"); },
	      d: function(c) { return "di" + ((c !== 1) ? "es" : "a"); },
	      h: function(c) { return "hor" + ((c !== 1) ? "es" : "a"); },
	      m: function(c) { return "minut" + ((c !== 1) ? "s" : ""); },
	      s: function(c) { return "segon" + ((c !== 1) ? "s" : ""); },
	      ms: function(c) { return "milisegon" + ((c !== 1) ? "s" : "" ); },
	      decimal: ","
	    },
	    da: {
	      y: "år",
	      mo: function(c) { return "måned" + ((c !== 1) ? "er" : ""); },
	      w: function(c) { return "uge" + ((c !== 1) ? "r" : ""); },
	      d: function(c) { return "dag" + ((c !== 1) ? "e" : ""); },
	      h: function(c) { return "time" + ((c !== 1) ? "r" : ""); },
	      m: function(c) { return "minut" + ((c !== 1) ? "ter" : ""); },
	      s: function(c) { return "sekund" + ((c !== 1) ? "er" : ""); },
	      ms: function(c) { return "millisekund" + ((c !== 1) ? "er" : ""); },
	      decimal: ","
	    },
	    de: {
	      y: function(c) { return "Jahr" + ((c !== 1) ? "e" : ""); },
	      mo: function(c) { return "Monat" + ((c !== 1) ? "e" : ""); },
	      w: function(c) { return "Woche" + ((c !== 1) ? "n" : ""); },
	      d: function(c) { return "Tag" + ((c !== 1) ? "e" : ""); },
	      h: function(c) { return "Stunde" + ((c !== 1) ? "n" : ""); },
	      m: function(c) { return "Minute" + ((c !== 1) ? "n" : ""); },
	      s: function(c) { return "Sekunde" + ((c !== 1) ? "n" : ""); },
	      ms: function(c) { return "Millisekunde" + ((c !== 1) ? "n" : ""); },
	      decimal: ","
	    },
	    en: {
	      y: function(c) { return "year" + ((c !== 1) ? "s" : ""); },
	      mo: function(c) { return "month" + ((c !== 1) ? "s" : ""); },
	      w: function(c) { return "week" + ((c !== 1) ? "s" : ""); },
	      d: function(c) { return "day" + ((c !== 1) ? "s" : ""); },
	      h: function(c) { return "hour" + ((c !== 1) ? "s" : ""); },
	      m: function(c) { return "minute" + ((c !== 1) ? "s" : ""); },
	      s: function(c) { return "second" + ((c !== 1) ? "s" : ""); },
	      ms: function(c) { return "millisecond" + ((c !== 1) ? "s" : ""); },
	      decimal: "."
	    },
	    es: {
	      y: function(c) { return "año" + ((c !== 1) ? "s" : ""); },
	      mo: function(c) { return "mes" + ((c !== 1) ? "es" : ""); },
	      w: function(c) { return "semana" + ((c !== 1) ? "s" : ""); },
	      d: function(c) { return "día" + ((c !== 1) ? "s" : ""); },
	      h: function(c) { return "hora" + ((c !== 1) ? "s" : ""); },
	      m: function(c) { return "minuto" + ((c !== 1) ? "s" : ""); },
	      s: function(c) { return "segundo" + ((c !== 1) ? "s" : ""); },
	      ms: function(c) { return "milisegundo" + ((c !== 1) ? "s" : "" ); },
	      decimal: ","
	    },
	    fr: {
	      y: function(c) { return "an" + ((c !== 1) ? "s" : ""); },
	      mo: "mois",
	      w: function(c) { return "semaine" + ((c !== 1) ? "s" : ""); },
	      d: function(c) { return "jour" + ((c !== 1) ? "s" : ""); },
	      h: function(c) { return "heure" + ((c !== 1) ? "s" : ""); },
	      m: function(c) { return "minute" + ((c !== 1) ? "s" : ""); },
	      s: function(c) { return "seconde" + ((c !== 1) ? "s" : ""); },
	      ms: function(c) { return "milliseconde" + ((c !== 1) ? "s" : ""); },
	      decimal: ","
	    },
	    gr: {
	      y: function(c) { return ((c === 1) ? "χρόνος" : "χρόνια"); },
	      mo: function(c) { return ((c === 1) ? "μήνας" : "μήνες"); },
	      w: function(c) { return ((c === 1) ? "εβδομάδα" : "εβδομάδες"); },
	      d: function(c) { return ((c === 1) ? "μέρα" : "μέρες"); },
	      h: function(c) { return ((c === 1) ? "ώρα" : "ώρες"); },
	      m: function(c) { return ((c === 1) ? "λεπτό" : "λεπτά"); },
	      s: function(c) { return ((c === 1) ? "δευτερόλεπτο" : "δευτερόλεπτα"); },
	      ms: function(c) { return ((c === 1) ? "χιλιοστό του δευτερολέπτου" : "χιλιοστά του δευτερολέπτου"); },
	      decimal: ","
	    },
	    hu: {
	      y: "év",
	      mo: "hónap",
	      w: "hét",
	      d: "nap",
	      h: "óra",
	      m: "perc",
	      s: "másodperc",
	      ms: "ezredmásodperc",
	      decimal: ","
	    },
	    it: {
	      y: function(c) { return "ann" + ((c !== 1) ? "i" : "o"); },
	      mo: function(c) { return "mes" + ((c !== 1) ? "i" : "e"); },
	      w: function(c) { return "settiman" + ((c !== 1) ? "e" : "a"); },
	      d: function(c) { return "giorn" + ((c !== 1) ? "i" : "o"); },
	      h: function(c) { return "or" + ((c !== 1) ? "e" : "a"); },
	      m: function(c) { return "minut" + ((c !== 1) ? "i" : "o"); },
	      s: function(c) { return "second" + ((c !== 1) ? "i" : "o"); },
	      ms: function(c) { return "millisecond" + ((c !== 1) ? "i" : "o" ); },
	      decimal: ","
	    },
	    ja: {
	      y: "年",
	      mo: "月",
	      w: "週",
	      d: "日",
	      h: "時間",
	      m: "分",
	      s: "秒",
	      ms: "ミリ秒",
	      decimal: "."
	    },
	    ko: {
	      y: "년",
	      mo: "개월",
	      w: "주일",
	      d: "일",
	      h: "시간",
	      m: "분",
	      s: "초",
	      ms: "밀리 초",
	      decimal: "."
	    },
	    nl: {
	      y: "jaar",
	      mo: function(c) { return (c === 1) ? "maand" : "maanden"; },
	      w: function(c) { return (c === 1) ? "week" : "weken"; },
	      d: function(c) { return (c === 1) ? "dag" : "dagen"; },
	      h: "uur",
	      m: function(c) { return (c === 1) ? "minuut" : "minuten"; },
	      s: function(c) { return (c === 1) ? "seconde" : "seconden"; },
	      ms: function(c) { return (c === 1) ? "milliseconde" : "milliseconden"; },
	      decimal: ","
	    },
	    no: {
	      y: "år",
	      mo: function(c) { return "måned" + ((c !== 1) ? "er" : ""); },
	      w: function(c) { return "uke" + ((c !== 1) ? "r" : ""); },
	      d: function(c) { return "dag" + ((c !== 1) ? "er" : ""); },
	      h: function(c) { return "time" + ((c !== 1) ? "r" : ""); },
	      m: function(c) { return "minutt" + ((c !== 1) ? "er" : ""); },
	      s: function(c) { return "sekund" + ((c !== 1) ? "er" : ""); },
	      ms: function(c) { return "millisekund" + ((c !== 1) ? "er" : ""); },
	      decimal: ","
	    },
	    pl: {
	      y: function(c) { return ["rok", "roku", "lata", "lat"][getPolishForm(c)]; },
	      mo: function(c) { return ["miesiąc", "miesiąca", "miesiące", "miesięcy"][getPolishForm(c)]; },
	      w: function(c) { return ["tydzień", "tygodnia", "tygodnie", "tygodni"][getPolishForm(c)]; },
	      d: function(c) { return ["dzień", "dnia", "dni", "dni"][getPolishForm(c)]; },
	      h: function(c) { return ["godzina", "godziny", "godziny", "godzin"][getPolishForm(c)]; },
	      m: function(c) { return ["minuta", "minuty", "minuty", "minut"][getPolishForm(c)]; },
	      s: function(c) { return ["sekunda", "sekundy", "sekundy", "sekund"][getPolishForm(c)]; },
	      ms: function(c) { return ["milisekunda", "milisekundy", "milisekundy", "milisekund"][getPolishForm(c)]; },
	      decimal: ","
	    },
	    pt: {
	      y: function(c) { return "ano" + ((c !== 1) ? "s" : ""); },
	      mo: function(c) { return (c !== 1) ? "meses" : "mês"; },
	      w: function(c) { return "semana" + ((c !== 1) ? "s" : ""); },
	      d: function(c) { return "dia" + ((c !== 1) ? "s" : ""); },
	      h: function(c) { return "hora" + ((c !== 1) ? "s" : ""); },
	      m: function(c) { return "minuto" + ((c !== 1) ? "s" : ""); },
	      s: function(c) { return "segundo" + ((c !== 1) ? "s" : ""); },
	      ms: function(c) { return "milissegundo" + ((c !== 1) ? "s" : ""); },
	      decimal: ","
	    },
	    ru: {
	      y: function(c) { return ["лет", "год", "года"][getSlavicForm(c)]; },
	      mo: function(c) { return ["месяцев", "месяц", "месяца"][getSlavicForm(c)]; },
	      w: function(c) { return ["недель", "неделя", "недели"][getSlavicForm(c)]; },
	      d: function(c) { return ["дней", "день", "дня"][getSlavicForm(c)]; },
	      h: function(c) { return ["часов", "час", "часа"][getSlavicForm(c)]; },
	      m: function(c) { return ["минут", "минута", "минуты"][getSlavicForm(c)]; },
	      s: function(c) { return ["секунд", "секунда", "секунды"][getSlavicForm(c)]; },
	      ms: function(c) { return ["миллисекунд", "миллисекунда", "миллисекунды"][getSlavicForm(c)]; },
	      decimal: ","
	    },
	    uk: {
	      y: function(c) { return ["років", "рік", "роки"][getSlavicForm(c)]; },
	      mo: function(c) { return ["місяців", "місяць", "місяці"][getSlavicForm(c)]; },
	      w: function(c) { return ["неділь", "неділя", "неділі"][getSlavicForm(c)]; },
	      d: function(c) { return ["днів", "день", "дні"][getSlavicForm(c)]; },
	      h: function(c) { return ["годин", "година", "години"][getSlavicForm(c)]; },
	      m: function(c) { return ["хвилин", "хвилина", "хвилини"][getSlavicForm(c)]; },
	      s: function(c) { return ["секунд", "секунда", "секунди"][getSlavicForm(c)]; },
	      ms: function(c) { return ["мілісекунд", "мілісекунда", "мілісекунди"][getSlavicForm(c)]; },
	      decimal: ","
	    },
	    sv: {
	      y: "år",
	      mo: function(c) { return "månad" + ((c !== 1) ? "er" : ""); },
	      w: function(c) { return "veck" + ((c !== 1) ? "or" : "a"); },
	      d: function(c) { return "dag" + ((c !== 1) ? "ar" : ""); },
	      h: function(c) { return "timm" + ((c !== 1) ? "ar" : "e"); },
	      m: function(c) { return "minut" + ((c !== 1) ? "er" : ""); },
	      s: function(c) { return "sekund" + ((c !== 1) ? "er" : ""); },
	      ms: function(c) { return "millisekund" + ((c !== 1) ? "er" : ""); },
	      decimal: ","
	    },
	    tr: {
	      y: "yıl",
	      mo: "ay",
	      w: "hafta",
	      d: "gün",
	      h: "saat",
	      m: "dakika",
	      s: "saniye",
	      ms: "milisaniye",
	      decimal: ","
	    },
	    zh_CN: {
	      y: "年",
	      mo: "个月",
	      w: "周",
	      d: "天",
	      h: "小时",
	      m: "分钟",
	      s: "秒",
	      ms: "毫秒",
	      decimal: "."
	    },
	    zh_TW: {
	      y: "年",
	      mo: "個月",
	      w: "周",
	      d: "天",
	      h: "小時",
	      m: "分鐘",
	      s: "秒",
	      ms: "毫秒",
	      decimal: "."
	    }
	  };
	
	  // You can create a humanizer, which returns a function with defaults
	  // parameters.
	  function humanizer(passedOptions) {
	    var result = function humanizer(ms, humanizerOptions) {
	      var options = extend({}, result, humanizerOptions || {});
	      return doHumanization(ms, options);
	    };
	
	    return extend(result, {
	      language: "en",
	      delimiter: ", ",
	      spacer: " ",
	      units: ["y", "mo", "w", "d", "h", "m", "s"],
	      languages: {},
	      round: false,
	      unitMeasures: {
	        y: 31557600000,
	        mo: 2629800000,
	        w: 604800000,
	        d: 86400000,
	        h: 3600000,
	        m: 60000,
	        s: 1000,
	        ms: 1
	      }
	    }, passedOptions);
	  }
	
	  // The main function is just a wrapper around a default humanizer.
	  var defaultHumanizer = humanizer({});
	  function humanizeDuration() {
	    return defaultHumanizer.apply(defaultHumanizer, arguments);
	  }
	
	  // doHumanization does the bulk of the work.
	  function doHumanization(ms, options) {
	
	    // Make sure we have a positive number.
	    // Has the nice sideffect of turning Number objects into primitives.
	    ms = Math.abs(ms);
	
	    var dictionary = options.languages[options.language] || languages[options.language];
	    if (!dictionary) {
	      throw new Error("No language " + dictionary + ".");
	    }
	
	    var result = [];
	
	    // Start at the top and keep removing units, bit by bit.
	    var unitName, unitMS, unitCount;
	    for (var i = 0, len = options.units.length; i < len; i++) {
	
	      unitName = options.units[i];
	      unitMS = options.unitMeasures[unitName];
	
	      // What's the number of full units we can fit?
	      if ((i + 1) === len) {
	        unitCount = ms / unitMS;
	        if (options.round) {
	          unitCount = Math.round(unitCount);
	        }
	      } else {
	        unitCount = Math.floor(ms / unitMS);
	      }
	
	      // Add the string.
	      if (unitCount) {
	        result.push(render(unitCount, unitName, dictionary, options));
	      }
	
	      // Do we have enough units?
	      if (options.largest && (options.largest <= result.length)) {
	        break;
	      }
	
	      // Remove what we just figured out.
	      ms -= unitCount * unitMS;
	
	    }
	
	    if (result.length) {
	      return result.join(options.delimiter);
	    } else {
	      return render(0, options.units[options.units.length - 1], dictionary, options);
	    }
	
	  }
	
	  function render(count, type, dictionary, options) {
	    var decimal;
	    if (options.decimal === void 0) {
	      decimal = dictionary.decimal;
	    } else {
	      decimal = options.decimal;
	    }
	
	    var countStr = count.toString().replace(".", decimal);
	
	    var dictionaryValue = dictionary[type];
	    var word;
	    if (typeof dictionaryValue === "function") {
	      word = dictionaryValue(count);
	    } else {
	      word = dictionaryValue;
	    }
	
	    return countStr + options.spacer + word;
	  }
	
	  function extend(destination) {
	    var source;
	    for (var i = 1; i < arguments.length; i++) {
	      source = arguments[i];
	      for (var prop in source) {
	        if (source.hasOwnProperty(prop)) {
	          destination[prop] = source[prop];
	        }
	      }
	    }
	    return destination;
	  }
	
	  // Internal helper function for Polish language.
	  function getPolishForm(c) {
	    if (c === 1) {
	      return 0;
	    } else if (Math.floor(c) !== c) {
	      return 1;
	    } else if (c % 10 >= 2 && c % 10 <= 4 && !(c % 100 > 10 && c % 100 < 20)) {
	      return 2;
	    } else {
	      return 3;
	    }
	  }
	
	  // Internal helper function for Russian and Ukranian languages.
	  function getSlavicForm(c) {
	    if (Math.floor(c) !== c) {
	      return 2;
	    } else if (c === 0 || (c >= 5 && c <= 20) || (c % 10 >= 5 && c % 10 <= 9) || (c % 10 === 0)) {
	      return 0;
	    } else if (c === 1 || c % 10 === 1) {
	      return 1;
	    } else if (c > 1) {
	      return 2;
	    } else {
	      return 0;
	    }
	  }
	
	  function getSupportedLanguages() {
	    var result = [];
	    for (var language in languages) {
	      if (languages.hasOwnProperty(language)) {
	        result.push(language);
	      }
	    }
	    return result;
	  }
	
	  humanizeDuration.humanizer = humanizer;
	  humanizeDuration.getSupportedLanguages = getSupportedLanguages;
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return humanizeDuration;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module !== "undefined" && module.exports) {
	    module.exports = humanizeDuration;
	  } else {
	    global.humanizeDuration = humanizeDuration;
	  }
	
	})(this);


/***/ },
/* 659 */,
/* 660 */,
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.components', [__webpack_require__(662), __webpack_require__(672), __webpack_require__(680), __webpack_require__(683), __webpack_require__(688), __webpack_require__(691), __webpack_require__(692), __webpack_require__(693), __webpack_require__(695)]).name;

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.components.human-schedules', [__webpack_require__(663), __webpack_require__(665), __webpack_require__(668), __webpack_require__(670)]).name;

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HUMAN_AVAILABILITY = void 0;
	
	module.exports = _angular2.default.module('common.components.human-schedules.availability-group', []).component('odHumansAvailabilityGroup', {
	  bindings: {
	    human: '=',
	    availabilities: '=',
	    availability: '='
	  },
	  template: __webpack_require__(664)(),
	  controller: function () {
	    // @ngInject
	    HumanAvailabilityGroupCtrl.$inject = ["HumanAvailability"];
	    function HumanAvailabilityGroupCtrl(HumanAvailability) {
	      _classCallCheck(this, HumanAvailabilityGroupCtrl);
	
	      HUMAN_AVAILABILITY = HumanAvailability;
	      this.resetNewGroup();
	    }
	
	    _createClass(HumanAvailabilityGroupCtrl, [{
	      key: 'resetNewGroup',
	      value: function resetNewGroup() {
	        this.newAvailability = new HUMAN_AVAILABILITY({
	          _editing: true,
	          human_id: this.human.id,
	          availability_windows_attributes: []
	        });
	      }
	    }, {
	      key: 'deleteAvailability',
	      value: function deleteAvailability(availability) {
	        var _this = this;
	
	        availability.$delete().then(function () {
	          (0, _lodash.pull)(_this.availabilities, availability);
	        });
	      }
	    }, {
	      key: 'saveAvailability',
	      value: function saveAvailability(availability, newAttributes) {
	        var _this2 = this;
	
	        var avail = new HUMAN_AVAILABILITY(newAttributes);
	        var meth = '$save';
	
	        if (avail.id) meth = '$update';
	
	        avail[meth](function () {
	          (0, _lodash.assign)(availability, avail);
	          availability._editing = false;
	
	          if (!(0, _lodash.includes)(_this2.availabilities, availability)) {
	            _this2.availabilities.push(availability);
	          }
	          _this2.resetNewGroup();
	        });
	      }
	    }]);
	
	    return HumanAvailabilityGroupCtrl;
	  }()
	}).name;

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"panel panel-default\"><div class=\"panel-heading\">Schedule Availability</div><od-edit-human-availability-group ng-if=\"$ctrl.newAvailability._editing\" human=\"$ctrl.human\" availability=\"$ctrl.newAvailability\" on-done=\"$ctrl.saveAvailability(availability, value)\" on-cancel=\"$ctrl.resetNewGroup()\" is-creator=\"true\"></od-edit-human-availability-group></div><div ng-if=\"$ctrl.availabilities.length\" ng-repeat=\"availability in $ctrl.availabilities | orderBy:[&quot;start_date&quot;,&quot;finish_date&quot;]\" class=\"panel panel-default\"><div class=\"panel-heading\">Availability</div><od-show-human-availability-group availability=\"availability\" ng-if=\"!availability._editing\" on-edit=\"availability._editing = true\" on-delete=\"$ctrl.deleteAvailability(availability)\"></od-show-human-availability-group><od-edit-human-availability-group availability=\"availability\" ng-if=\"availability._editing\" human=\"$ctrl.human\" on-done=\"$ctrl.saveAvailability(availability, value)\" on-cancel=\"availability._editing = false\" is-creator=\"false\"></od-edit-human-availability-group></div>");;return buf.join("");
	}

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	var _days_of_week = __webpack_require__(666);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('common.components.human-schedules.edit-availability', []).component('odEditHumanAvailabilityGroup', {
	  require: ['human', 'availability', 'onDone'],
	  bindings: {
	    human: '<',
	    availability: '<',
	    onDone: '&',
	    onCancel: '&',
	    isCreator: '<'
	  },
	  template: __webpack_require__(667)(),
	  controller: function () {
	    // @ngInject
	    EditHumanAvailabilityGroupController.$inject = ["AvailableTimes", "availableMarkets"];
	    function EditHumanAvailabilityGroupController(AvailableTimes, availableMarkets) {
	      _classCallCheck(this, EditHumanAvailabilityGroupController);
	
	      this.DAYS_OF_WEEK = _days_of_week.DAYS_OF_WEEK;
	      this.AVAILABLE_TIMES = AvailableTimes;
	      this.AVAILABLE_MARKETS = availableMarkets;
	    }
	
	    _createClass(EditHumanAvailabilityGroupController, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.reset();
	      }
	    }, {
	      key: '$onChanges',
	      value: function $onChanges(changes) {
	        if (changes.availability) {
	          var currentValue = changes.availability.currentValue;
	
	          if (!changes.availability.isFirstChange()) {
	            this.reset(currentValue);
	          }
	        }
	      }
	    }, {
	      key: 'reset',
	      value: function reset(availability) {
	        this.workingAvailability = (0, _lodash.cloneDeep)(availability || this.availability);
	
	        this.workingAvailability.availability_windows_attributes = this.workingAvailability.availability_windows_attributes || [];
	      }
	    }, {
	      key: 'addTime',
	      value: function addTime(dayOfWeek) {
	        this.workingAvailability.availability_windows_attributes.push({ 'day_of_week': dayOfWeek });
	      }
	    }, {
	      key: 'removeWindow',
	      value: function removeWindow(availability, windowAttrs) {
	        if (windowAttrs.id) {
	          windowAttrs._destroy = true;
	        } else {
	          (0, _lodash.pull)(this.workingAvailability.availability_windows_attributes, windowAttrs);
	        }
	      }
	    }, {
	      key: 'saveAvailability',
	      value: function saveAvailability() {
	        this.onDone({
	          availability: this.availability,
	          value: this.workingAvailability
	        });
	      }
	    }]);
	
	    return EditHumanAvailabilityGroupController;
	  }()
	}).name;

/***/ },
/* 666 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DayOfWeek = function DayOfWeek(name, abbr, number) {
	  _classCallCheck(this, DayOfWeek);
	
	  this.name = name;
	  this.abbr = abbr;
	  this.day_of_week = number;
	};
	
	var DAYS_OF_WEEK = exports.DAYS_OF_WEEK = [new DayOfWeek('Sunday', 'Sun', 0), new DayOfWeek('Monday', 'Mon', 1), new DayOfWeek('Tuesday', 'Tue', 2), new DayOfWeek('Wednesday', 'Wed', 3), new DayOfWeek('Thursday', 'Thur', 4), new DayOfWeek('Friday', 'Fri', 5), new DayOfWeek('Saturday', 'Sat', 6)];
	
	var DAYS_OF_WORK_WEEK = exports.DAYS_OF_WORK_WEEK = [new DayOfWeek('Monday', 'Mon', 1), new DayOfWeek('Tuesday', 'Tue', 2), new DayOfWeek('Wednesday', 'Wed', 3), new DayOfWeek('Thursday', 'Thur', 4), new DayOfWeek('Friday', 'Fri', 5)];

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div ng-form=\"availabilityForm\" class=\"form new-availability-window\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label>Since</label><input ng-model=\"$ctrl.workingAvailability.start_date\" placeholder=\"Always\" class=\"form-control pikaday\"></div></div><div class=\"col-xs-3\"><div class=\"form-group\"><label>Ends</label><input ng-model=\"$ctrl.workingAvailability.finish_date\" placeholder=\"Never\" class=\"form-control pikaday\"></div></div></div></div></div><table class=\"table days-of-week-table\"><thead><tr><th ng-repeat=\"day in $ctrl.DAYS_OF_WEEK\" class=\"day-of-week\">{{day.name}}</th></tr></thead><tbody><tr><td ng-repeat=\"day in $ctrl.DAYS_OF_WEEK\" class=\"day-of-week\"><div ng-repeat=\"window in $ctrl.workingAvailability.availability_windows_attributes | filter:{day_of_week: $index} | orderBy:[&quot;start_time&quot;]\" ng-if=\"!window._destroy\" class=\"availability-input\"><div class=\"form-group\"><label>Start Time</label><select ng-model=\"window.start_time\" ng-options=\"time as time for time in $ctrl.AVAILABLE_TIMES\" required class=\"form-control\"><option value=\"\" disabled>Start Time</option></select></div><div class=\"form-group\"><label>End Time</label><select ng-model=\"window.finish_time\" ng-options=\"time as time for time in $ctrl.AVAILABLE_TIMES\" required class=\"form-control\"><option value=\"\" disabled>Finish Time</option></select></div><div class=\"form-group\"><label>Market</label><select ng-model=\"window.market_id\" ng-options=\"market.id as market.name for market in $ctrl.AVAILABLE_MARKETS | orderBy:&quot;name&quot;\" class=\"form-control\"><option value=\"\">Any</option></select></div><button ng-click=\"$ctrl.removeWindow($ctrl.workingAvailability, window)\" class=\"btn btn-link no-padding\">Remove</button></div><button ng-click=\"$ctrl.addTime($index)\" class=\"btn btn-link no-padding\">+ Add Time</button></td></tr></tbody></table><ul class=\"action-bar\"><li><button ng-disabled=\"availabilityForm.$invalid\" ng-click=\"$ctrl.saveAvailability()\" class=\"btn btn-link\"><span class=\"emoji-wrapper\">✨</span><span ng-show=\"$ctrl.isCreator\">Schedule Availability</span><span ng-hide=\"$ctrl.isCreator\">Save Changes</span></button></li><li><button ng-click=\"$ctrl.onCancel()\" class=\"btn btn-link\"><span class=\"emoji-wrapper\">❌</span><span ng-show=\"$ctrl.isCreator\">Reset</span><span ng-hide=\"$ctrl.isCreator\">Cancel</span></button></li></ul>");;return buf.join("");
	}

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _days_of_week = __webpack_require__(666);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('common.components.human-schedules.show', []).component('odShowHumanAvailabilityGroup', {
	  bindings: {
	    availability: '<',
	    onEdit: '&',
	    onDelete: '&'
	  },
	  template: __webpack_require__(669)(),
	  controller:
	  // @ngInject
	  function ShowHumanAvailabilityGroupController() {
	    _classCallCheck(this, ShowHumanAvailabilityGroupController);
	
	    this.DAYS_OF_WEEK = _days_of_week.DAYS_OF_WEEK;
	    this.availabilityByDayOfWeek = (0, _lodash.groupBy)(this.availability.availability_windows_attributes, 'day_of_week');
	  }
	}).name;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-3\"><dl><dt>Since</dt><dd ng-if=\"$ctrl.availability.start_date\">{{$ctrl.availability.start_date | amDateFormat:'ddd, MMM D YYYY'}}</dd><dd ng-if=\"!$ctrl.availability.start_date\">Always</dd></dl></div><div class=\"col-sm-3\"><dl><dt>Ends</dt><dd ng-if=\"$ctrl.availability.finish_date\">{{$ctrl.availability.finish_date | amDateFormat:'ddd, MMM D YYYY'}}</dd><dd ng-if=\"!$ctrl.availability.finish_date\">Never</dd></dl></div></div></div><table class=\"table table-hover days-of-week-table\"><thead><tr><th ng-repeat=\"day in $ctrl.DAYS_OF_WEEK\" class=\"day-of-week\">{{day.name}}</th></tr></thead><tbody><tr><td ng-repeat=\"day in $ctrl.DAYS_OF_WEEK\" class=\"day-of-week\"><span ng-hide=\"$ctrl.availabilityByDayOfWeek[$index]\"><p class=\"text-muted\">None</p></span><span ng-repeat=\"availability in $ctrl.availabilityByDayOfWeek[$index]\"><p>{{availability.start_time}}—{{availability.finish_time}}</p><p ng-if=\"availability.market_name\">{{availability.market_name}}</p></span></td></tr></tbody></table><ul class=\"action-bar\"><li><button ng-click=\"$ctrl.onEdit({availability: $ctrl.availability})\" class=\"btn btn-link\"><span class=\"emoji-wrapper\">📝</span>Edit</button></li><li><button ng-click=\"$ctrl.onDelete({availability: $ctrl.availability})\" oc-confirm=\"Are you sure you want to delete this availability?\" class=\"btn btn-link\"><span class=\"emoji-wrapper\">❌\nDelete</span></button></li></ul>");;return buf.join("");
	}

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	var _momentTimezone = __webpack_require__(517);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ZONE_NAMES = ["America/Los_Angeles", "America/Phoenix", "America/Chicago", "America/New_York"];
	
	var FORMAT = 'YYYY-MM-DD H:mm a';
	var ZONES = ZONE_NAMES.map(function (z) {
	  return _momentTimezone2.default.tz.zone(z);
	});
	
	module.exports = _angular2.default.module('common.components.human-schedules.od-unavailabilities-table', []).directive('odUnavailabilitiesTable', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      human: '=',
	      unavailabilities: '='
	    },
	    template: __webpack_require__(671),
	    bindToController: true,
	    controllerAs: '$ctrl',
	    controller: UnavailabilitiesCtrl
	  };
	}).name;
	
	var UnavailabilitiesCtrl = function () {
	  // @ngInject
	  UnavailabilitiesCtrl.$inject = ["$scope", "AvailableTimes", "HumanUnavailability"];
	  function UnavailabilitiesCtrl($scope, AvailableTimes, HumanUnavailability) {
	    var _this = this;
	
	    _classCallCheck(this, UnavailabilitiesCtrl);
	
	    this.HumanUnavailability = HumanUnavailability;
	    this.TIMES = AvailableTimes;
	    this.ZONES = ZONES;
	
	    $scope.$watch('$ctrl.human.id', function () {
	      return _this.resetNewUnavailability();
	    });
	  }
	
	  _createClass(UnavailabilitiesCtrl, [{
	    key: 'deleteUnavailability',
	    value: function deleteUnavailability(unavailability) {
	      var _this2 = this;
	
	      unavailability.$delete().then(function () {
	        (0, _lodash.pull)(_this2.unavailabilities, unavailability);
	      });
	    }
	  }, {
	    key: 'resetNewUnavailability',
	    value: function resetNewUnavailability() {
	      if (!this.human) return;
	
	      this.newUnavailability = new this.HumanUnavailability({
	        human_id: this.human.id,
	        timezone: _momentTimezone2.default.tz.guess()
	      });
	    }
	  }, {
	    key: 'saveNewUnavailability',
	    value: function saveNewUnavailability() {
	      var _this3 = this;
	
	      var un = this.newUnavailability;
	
	      un.start_time = _momentTimezone2.default.tz(un._startDate + ' ' + un._startTime, FORMAT, un.timezone).toISOString();
	      un.finish_time = _momentTimezone2.default.tz(un._finishDate + ' ' + un._finishTime, FORMAT, un.timezone).toISOString();
	
	      un.$save().then(function () {
	        _this3.unavailabilities.push(un);
	        _this3.resetNewUnavailability();
	      });
	    }
	  }]);
	
	  return UnavailabilitiesCtrl;
	}();

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<table class=\"table table-hover\"><thead><tr><th colspan=\"2\">Start</th><th colspan=\"2\">End</th><th colspan=\"2\" class=\"text-right\">Actions</th></tr></thead><tbody><tr ng-repeat=\"unavailability in $ctrl.unavailabilities\"><td colspan=\"2\">{{unavailability.start_time | amTimezone:unavailability.timezone | amDateFormat:'ddd, MMM D YYYY'}} &nbsp;<small class=\"text-muted\">{{unavailability.start_time | amTimezone:unavailability.timezone | amDateFormat:'h:mm a (z)'}}</small></td><td colspan=\"2\">{{unavailability.finish_time | amTimezone:unavailability.timezone | amDateFormat:'ddd, MMM D YYYY'}} &nbsp;<small class=\"text-muted\">{{unavailability.finish_time | amTimezone:unavailability.timezone | amDateFormat:'h:mm a (z)'}}</small></td><td colspan=\"2\" class=\"text-right\"><button ng-click=\"$ctrl.deleteUnavailability(unavailability)\" class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody><tfoot><tr ng-form=\"newUnavailabilityForm\">   <td><input required placeholder=\"Start Date\" ng-model=\"$ctrl.newUnavailability._startDate\" class=\"form-control pikaday\"></td><td><select required ng-model=\"$ctrl.newUnavailability._startTime\" ng-options=\"time as time for time in $ctrl.TIMES\" class=\"form-control\"><option value=\"\" disabled=\"true\">Start Time</option></select></td><td><input required placeholder=\"End Date\" ng-model=\"$ctrl.newUnavailability._finishDate\" class=\"form-control pikaday\"></td><td><select required ng-model=\"$ctrl.newUnavailability._finishTime\" ng-options=\"time as time for time in $ctrl.TIMES\" class=\"form-control\"><option value=\"\" disabled=\"true\">End Time</option></select></td><td><select ng-model=\"$ctrl.newUnavailability.timezone\" ng-options=\"zone.name as (zone.name | pretty) for zone in $ctrl.ZONES | orderBy\" class=\"form-control\"></select></td><td><button ng-disabled=\"newUnavailabilityForm.$invalid\" ng-click=\"$ctrl.saveNewUnavailability()\" class=\"btn btn-primary\">Add Unavailability</button></td></tr></tfoot></table>");;return buf.join("");
	}

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _jsBeautify = __webpack_require__(673);
	
	var _jsBeautify2 = _interopRequireDefault(_jsBeautify);
	
	var _lodash = __webpack_require__(412);
	
	var _liveDemoBlock = __webpack_require__(677);
	
	var _liveDemoBlock2 = _interopRequireDefault(_liveDemoBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('common.components.live-demo-block', []).directive('liveDemoBlock', ["$compile", "$location", function ($compile, $location) {
	  var LiveDemoBlock = function () {
	    LiveDemoBlock.$inject = ["$element", "$scope"];
	    function LiveDemoBlock($element, $scope) {
	      var _this = this;
	
	      _classCallCheck(this, LiveDemoBlock);
	
	      this.demos = [];
	      this.liveSource = '';
	      this.liveResultElem = $element.find('live-demo-result');
	      this.iframeIsLoading = false;
	
	      this.iframe = Boolean($element[0].getAttribute('iframe'));
	
	      // Render the contents of this demo block into an iFrame.
	      // We want the iFrame to have the same CSS and JS as our host app, so we
	      // load the host app into the iFrame and then modify its contents later.
	      if (this.iframe) {
	        this.iframeIsLoading = true;
	        this.iframeElement = _angular2.default.element('<iframe class=\'live-demo-target\' src=\'' + $location.absUrl() + '\'></iframe>');
	        this.liveResultElem.append(this.iframeElement);
	
	        this.iframeElement.ready(function () {
	          $scope.$apply(function () {
	            // Clear out all div and main elements within the page we just
	            // loaded. We want to keep any scripts and CSS within body, so we
	            // can't clear the whole body tag out.
	            (0, _lodash.map)(_this.iframeElement.contents().find('body').children(), function (child) {
	              if (child.tagName.toLowerCase() === 'div' || child.tagName.toLowerCase() === 'main') {
	                child.remove();
	              }
	            });
	
	            // Make a new <main> tag to put our content in
	            _this.iframeElement.contents().find('body').append('<main></main>');
	
	            _this._handleSourceUpdate();
	            _this.iframeIsLoading = false;
	          });
	        });
	      }
	
	      this.scope = $scope;
	
	      $scope.$watch(function () {
	        return _this.liveSource;
	      }, function () {
	        _this.liveSourceNumRows = _this.liveSource.split('\n').length;
	        _this._handleSourceUpdate();
	      });
	    }
	
	    _createClass(LiveDemoBlock, [{
	      key: 'registerDemo',
	      value: function registerDemo(name, source) {
	        this.demos.push({
	          name: name,
	          source: _jsBeautify2.default.html(source),
	          selected: false
	        });
	
	        if (this.demos.length === 1) {
	          this.selectDemo(this.demos[0]);
	        }
	      }
	    }, {
	      key: 'selectDemo',
	      value: function selectDemo(demo) {
	        this.liveSource = demo.source;
	        this._handleSourceUpdate();
	      }
	    }, {
	      key: '_handleSourceUpdate',
	      value: function _handleSourceUpdate() {
	        var _this2 = this;
	
	        this.demos.forEach(function (demo) {
	          demo.selected = demo.source === _this2.liveSource;
	        });
	
	        if (this.iframe) {
	          this.iframeElement.contents().find('main').html(this.liveSource);
	        } else {
	          this.liveResultElem.empty().append($compile(this.liveSource)(this.scope));
	        }
	      }
	    }]);
	
	    return LiveDemoBlock;
	  }();
	
	  return {
	    restrict: 'EA',
	    controller: LiveDemoBlock,
	    bindToController: true,
	    controllerAs: 'liveDemoBlockCtrl',
	    transclude: true,
	    template: __webpack_require__(679)()
	  };
	}]).directive('liveDemo', function () {
	  return {
	    restrict: 'EA',
	    require: '^liveDemoBlock',
	    template: function template(elem, attrs) {
	      var source = elem[0].innerHTML.trim();
	      var spaces = (0, _lodash.chain)(source.split('\n')).map(function (line) {
	        return line.match(/^\s+/);
	      }).sortBy(function (spaces) {
	        return spaces ? spaces[0].length : 1000;
	      }).first();
	      attrs.$set('source', source.replace(new RegExp(spaces, 'g'), ''));
	      return '<div></div>';
	    },
	    scope: true,
	    link: function link(scope, elem, attrs, liveDemoBlock) {
	      liveDemoBlock.registerDemo(attrs.name, attrs.source);
	    }
	  };
	}).name;

/***/ },
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(678);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./live-demo-block.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./live-demo-block.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "live-demo-block,[live-demo-block]{display:block}live-demo-block .demo-area,[live-demo-block] .demo-area{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;border:1px solid #dedede;-webkit-border-radius:2px;border-radius:2px;-webkit-transition:height .5s;transition:height .5s}live-demo-block h5.area-label,[live-demo-block] h5.area-label{margin:16px 20px 6px 20px}live-demo-block .padded-area,[live-demo-block] .padded-area{padding:10px}live-demo-block .live-result,[live-demo-block] .live-result{position:relative;-webkit-flex-basis:50%;-ms-flex-preferred-size:50%;flex-basis:50%;overflow-x:scroll;border-right:1px solid #dedede;padding:10px}live-demo-block .live-result.iframe,[live-demo-block] .live-result.iframe{background-color:#70828f}live-demo-block .live-result.iframe h6,[live-demo-block] .live-result.iframe h6{color:#fff}live-demo-block .live-result.iframe-loading::before,[live-demo-block] .live-result.iframe-loading::before{content:'Loading iframe...';position:absolute;top:0;bottom:0;left:0;right:0;background-color:#70828f;color:#fff;padding:1em;z-index:5}live-demo-block .live-result iframe.live-demo-target,[live-demo-block] .live-result iframe.live-demo-target{background-color:#fff;width:100%;border:none;height:300px}live-demo-block .live-source,[live-demo-block] .live-source{background-color:#fafafa;-webkit-flex-basis:50%;-ms-flex-preferred-size:50%;flex-basis:50%;-webkit-box-flex:0;-webkit-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0}live-demo-block .live-source textarea,[live-demo-block] .live-source textarea{white-space:pre;word-wrap:normal;width:100%;resize:none;-webkit-box-shadow:none;box-shadow:none;padding-bottom:0}live-demo-block.no-padding .live-result,[live-demo-block].no-padding .live-result{padding:0}live-demo-block .vertical-demo-mixin .demo-area,[live-demo-block] .vertical-demo-mixin .demo-area{display:block}live-demo-block .vertical-demo-mixin .live-source,[live-demo-block] .vertical-demo-mixin .live-source{overflow:hidden}live-demo-block .vertical-demo-mixin .live-result,[live-demo-block] .vertical-demo-mixin .live-result{border-bottom:1px solid #dedede;border-right:none}@media (max-width:991px){live-demo-block .demo-area,[live-demo-block] .demo-area{display:block}live-demo-block .live-source,[live-demo-block] .live-source{overflow:hidden}live-demo-block .live-result,[live-demo-block] .live-result{border-bottom:1px solid #dedede;border-right:none}}live-demo-block.vertical .demo-area,[live-demo-block].vertical .demo-area{display:block}live-demo-block.vertical .live-source,[live-demo-block].vertical .live-source{overflow:hidden}live-demo-block.vertical .live-result,[live-demo-block].vertical .live-result{border-bottom:1px solid #dedede;border-right:none}live-demo-block.lighter-gray .live-result,[live-demo-block].lighter-gray .live-result{background-color:#dedede}", ""]);
	
	// exports


/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<!-- We have to make sure the contents of the block (the live-demo directives)--><!-- are added to the DOM, so their directives will trigger--><ng-transclude>ng-hide='true'</ng-transclude><ul class=\"nav nav-tabs\"><li ng-repeat=\"demo in liveDemoBlockCtrl.demos\" ng-class=\"{active: demo.selected}\"><a ng-click=\"liveDemoBlockCtrl.selectDemo(demo)\">{{demo.name}}</a></li></ul><div class=\"demo-area\"><div ng-class=\"{ 'iframe': liveDemoBlockCtrl.iframe, 'iframe-loading': liveDemoBlockCtrl.iframeIsLoading }\" class=\"live-result\"><h6 ng-if=\"liveDemoBlockCtrl.iframe\" class=\"prose\">iframe</h6><live-demo-result></live-demo-result></div><div class=\"live-source\"><h5 class=\"area-label\">Try it out:</h5><div class=\"padded-area\"><textarea ng-model=\"liveDemoBlockCtrl.liveSource\" rows=\"{{liveDemoBlockCtrl.liveSourceNumRows}}\"></textarea></div></div></div>");;return buf.join("");
	}

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Opendoor Carousel
	//
	// Allows navigation via scroll, touch, and next/previous buttons.
	//
	// Items can be lazily loaded. The carousel simply "notifies" the items to tell
	// them to load, and expects the item itself to handle loading. The carousel
	// sets `scope().lazyLoad` on the od-carousel-item elements to notify them to
	// load.
	//
	// To use, create the following hierarchy:
	// od-carousel                (defines next/prev functions on the scope)
	//   od-carousel-container    (necessary to handle scroll events)
	//     od-carousel-item       (any number of these, ng-repeat, etc all work)
	//
	// The carousel only supports direct children in the hierarchy for now, for
	// performance and to allow nesting carousels.
	//
	// To add next/previous buttons, put them anywhere within od-carousel. Style
	// od-carousel-container to take up the space you want.
	
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	var _odCarousel = __webpack_require__(681);
	
	var _odCarousel2 = _interopRequireDefault(_odCarousel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('common.directives.od-carousel', []).directive('odCarousel', ["$window", "$timeout", "$mediaQuery", function ($window, $timeout, $mediaQuery) {
	  var OdCarousel = function () {
	    OdCarousel.$inject = ["$element", "$scope"];
	    function OdCarousel($element, $scope) {
	      var _this = this;
	
	      _classCallCheck(this, OdCarousel);
	
	      this.$element = $element;
	      this.$scope = $scope;
	
	      // Current slide position, initially 0. Can be non-integer to represent
	      // being "between" slides.
	      this.currentPosition = 0;
	
	      // Always an integer
	      this.currentIndex = 0;
	
	      // Target slide position, null unless mid-animation after prev/next
	      // buttons are clicked. Can be non-integer to represent being "between"
	      // slides. We need this so that if the user clicks "next" three times
	      // very quickly, we can keep updating the target position.
	      this.targetPosition = null;
	
	      // Array of carouselItem objects. Must be rebuilt whenever new
	      // od-carousel-item elements are added to the DOM.
	      //
	      // Each object should have the following properties:
	      //   angularEl: Angular element wrapping the DOM od-carousel-item element
	      //   width: Width of the item, computed from the DOM
	      //   offsetLeft: Total distance (width) from left of all carousel items
	      this.carouselItems = [];
	
	      // Reference to the container, to get/set scrollLeft setting.
	      this.odCarouselContainer = null;
	
	      var windowEl = _angular2.default.element($window);
	      var lastWindowWidth = $window.innerWidth;
	      var onWindowResize = function onWindowResize() {
	        var windowWidth = $window.innerWidth;
	        if (windowWidth === lastWindowWidth) {
	          return;
	        }
	        lastWindowWidth = windowWidth;
	        _this.debouncedRebuild();
	      };
	
	      windowEl.on('resize', onWindowResize);
	      $scope.$on('$destroy', function () {
	        windowEl.off('resize', onWindowResize);
	      });
	
	      this.debouncedRebuild = (0, _lodash.debounce)(this._rebuild.bind(this), 100, { leading: true });
	
	      this.throttledLoadImages = (0, _lodash.throttle)(this._loadImages.bind(this), 100);
	    }
	
	    // Search for all od-carousel-item elements and rebuild a representation of
	    // the carousel.
	    //
	    // Private - call `debouncedRebuild` instead to ensure good performance.
	
	
	    _createClass(OdCarousel, [{
	      key: '_rebuild',
	      value: function _rebuild() {
	        var _this2 = this;
	
	        var el = this.$element[0];
	        var containerEl = this.getChildrenByElementOrAttribute(el, 'od-carousel-container')[0];
	        var itemElements = this.getChildrenByElementOrAttribute(containerEl, 'od-carousel-item');
	
	        // Use reduce so that we can set `offsetLeft` based on the previous
	        // element. Return an array of objects, one per carousel-item
	        this.carouselItems = (0, _lodash.reduce)(itemElements, function (acc, itemEl) {
	          var width = _this2.getElementWidth(itemEl);
	          var offsetLeft = 0;
	          if (acc.length > 0) {
	            offsetLeft = (0, _lodash.last)(acc).offsetLeft + (0, _lodash.last)(acc).width;
	          }
	          acc.push({
	            angularEl: _angular2.default.element(itemEl),
	            width: width,
	            offsetLeft: offsetLeft
	          });
	          return acc;
	        }, []);
	
	        this.odCarouselContainer = _angular2.default.element(containerEl);
	        this.odCarouselContainer.scrollLeft(0);
	
	        this.throttledLoadImages();
	      }
	
	      // Lazy load the current item, and two items to the left and right.
	      //
	      // Uses the `scope().lazyLoad` pattern to delegate the loading to the
	      // carousel item.
	      //
	      // Private - call `throttledLoadImages` instead to ensure good performance.
	
	    }, {
	      key: '_loadImages',
	      value: function _loadImages() {
	        var _this3 = this;
	
	        // We use $timeout() instead of $scope.$apply because this function will be
	        // called as soon as the page starts to render, and will sometimes conflict
	        // with a $digest that is already in progress.
	        //
	        // $timeout has the same effect as $scope.$apply, but runs in the next
	        // cycle and therefore doesn't conflict with the initial $digest.
	        $timeout(function () {
	          // Load only one image until the carousel starts being used
	          if (_this3.currentPosition === 0 && _this3.carouselItems.length >= 1) {
	            _this3.tryLazyLoadingElement(_this3.carouselItems[0].angularEl);
	            return;
	          }
	
	          var minIndex = Math.max(0, _this3.currentIndex - 2);
	          var maxIndex = Math.min(_this3.currentIndex + 2, _this3.carouselItems.length - 1);
	          for (var i = minIndex; i <= maxIndex; i++) {
	            _this3.tryLazyLoadingElement(_this3.carouselItems[i].angularEl);
	          }
	        });
	      }
	    }, {
	      key: 'tryLazyLoadingElement',
	      value: function tryLazyLoadingElement(angularEl) {
	        if (angularEl.scope()) {
	          angularEl.scope().lazyLoad = true;
	        }
	      }
	    }, {
	      key: 'next',
	      value: function next(e) {
	        if (e) {
	          e.preventDefault();
	          e.stopPropagation();
	        }
	        this.targetPosition = this.targetPosition || this.currentPosition;
	        this.targetPosition = Math.min(Math.floor(this.targetPosition) + 1, this.carouselItems.length - 1);
	
	        this.scrollToIndex(this.targetPosition);
	      }
	    }, {
	      key: 'prev',
	      value: function prev(e) {
	        if (e) {
	          e.preventDefault();
	          e.stopPropagation();
	        }
	        this.targetPosition = this.targetPosition || this.currentPosition;
	        this.targetPosition = Math.max(Math.ceil(this.targetPosition) - 1, 0);
	
	        this.scrollToIndex(this.targetPosition);
	      }
	    }, {
	      key: 'scrollToIndex',
	      value: function scrollToIndex(index) {
	        var _this4 = this;
	
	        var animateTransition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        if (this.odCarouselContainer) {
	          // Different animation functions look good on different size screens.
	          // On desktop, it's hard to watch a slow, full-screen-width slide
	          // animation.
	          var transitionFunction = void 0;
	          var transitionDuration = void 0;
	          // $mediaQuery('xs') should work here, but doesn't
	          if (animateTransition || !$mediaQuery('gt-xs')) {
	            // We use an easing function that starts the animation at full speed,
	            // but eases at the end. This looks good compared to other animations
	            // when you click next/prev many times in a row, and is consistent
	            // with swipe UX on mobile.
	            transitionFunction = function transitionFunction(t) {
	              return t * (2 - t);
	            };
	            transitionDuration = 500;
	          } else {
	            // No transition on desktop; it's just disorienting
	            transitionFunction = function transitionFunction(t) {
	              return t;
	            };
	            transitionDuration = 0;
	          }
	          this.odCarouselContainer.scrollTo(this.carouselItems[index].offsetLeft, 0, transitionDuration, transitionFunction).then(function () {
	            _this4.targetPosition = null;
	          });
	        }
	      }
	
	      // Update this.currentPosition and this.currentIndex
	
	    }, {
	      key: 'updateCurrentPosition',
	      value: function updateCurrentPosition() {
	        if (!this.odCarouselContainer) {
	          return 0;
	        }
	
	        var scrollLeft = this.odCarouselContainer.scrollLeft();
	        var currentPosition = (0, _lodash.findIndex)(this.carouselItems, function (item) {
	          return scrollLeft <= item.offsetLeft;
	        });
	        // this can happen on scrolling on the way to the end very quickly
	        if (currentPosition === -1) {
	          currentPosition = this.carouselItems.length - 1;
	        }
	        if (scrollLeft < this.carouselItems[currentPosition].offsetLeft) {
	          currentPosition -= 0.5;
	        }
	
	        this.currentPosition = currentPosition;
	        this.currentIndex = Math.floor(currentPosition);
	      }
	    }, {
	      key: 'getElementWidth',
	      value: function getElementWidth(el) {
	        return parseInt($window.getComputedStyle(el).width);
	      }
	
	      // Find child DOM elements that either have `name` as their tag name (e.g.
	      // <child-element>) or as an attribute (e.g. <div child-element>).
	      // Parallel to angular's `restrict: 'EA'`.
	
	    }, {
	      key: 'getChildrenByElementOrAttribute',
	      value: function getChildrenByElementOrAttribute(el, name) {
	        return (0, _lodash.filter)(el.children, function (child) {
	          return child.tagName.toLowerCase() === name.toLowerCase() || child.getAttribute(name) !== null;
	        });
	      }
	    }, {
	      key: 'onScroll',
	      value: function onScroll() {
	        this.updateCurrentPosition();
	        this.throttledLoadImages();
	      }
	
	      // Trigger this from the carousel-item every time a new item is added -
	      // e.g. by ng-repeat.
	
	    }, {
	      key: 'carouselItemAdded',
	      value: function carouselItemAdded() {
	        this.debouncedRebuild();
	      }
	    }]);
	
	    return OdCarousel;
	  }();
	
	  return {
	    restrict: 'EA',
	    controller: OdCarousel,
	    require: 'odCarousel',
	    bindToController: true,
	    controllerAs: 'carouselCtrl',
	    scope: true
	  };
	}]).directive('odCarouselContainer', function () {
	  return {
	    restrict: 'EA',
	    require: '^odCarousel',
	
	    controller: function () {
	      OdCarouselContainer.$inject = ["$element"];
	      function OdCarouselContainer($element) {
	        _classCallCheck(this, OdCarouselContainer);
	
	        var isScrollSnapSupported = 'scrollSnapType' in document.documentElement.style || 'webkitScrollSnapType' in document.documentElement.style;
	        var isTouchSupported = 'ontouchmove' in window;
	
	        // only activate for touch + no scroll snap
	        if (!isTouchSupported || isScrollSnapSupported) {
	          return;
	        }
	
	        // HACK: Hardcoded to full-width carousels, will need to be refactored
	        // to use more generally.
	        this.$element = $element;
	        this.width = this.$element.prop('offsetWidth');
	        this.x0 = this.x = this.$element.scrollLeft();
	        this.t = null;
	        this.v = 0;
	
	        this.$element.css('overflow', 'hidden').on('touchstart', this.onTouchStart.bind(this)).on('touchmove', this.onTouchMove.bind(this)).on('touchend', this.onTouchEnd.bind(this));
	      }
	
	      _createClass(OdCarouselContainer, [{
	        key: 'getCoordinates',
	        value: function getCoordinates(e) {
	          var touches = e.touches && e.touches.length ? e.touches : [e];
	          e = e.changedTouches && e.changedTouches[0] || e.originalEvent && e.originalEvent.changedTouches && e.originalEvent.changedTouches[0] || touches[0].originalEvent || touches[0];
	
	          return { x: e.clientX, y: e.clientY };
	        }
	      }, {
	        key: 'onTouchStart',
	        value: function onTouchStart(e) {
	          this.x0 = this.$element.scrollLeft();
	          this.touch0 = this.getCoordinates(e);
	          this.children = this.$element.children();
	        }
	      }, {
	        key: 'onTouchMove',
	        value: function onTouchMove(e) {
	          // Bail out if movement is vertical
	          var touch = this.getCoordinates(e);
	          var dx = Math.abs(touch.x - this.touch0.x);
	          var dy = Math.abs(touch.y - this.touch0.y);
	          if (dy > dx) {
	            return;
	          }
	
	          e.preventDefault();
	
	          // "Scroll" content with hardware acceleration
	          var x = this.touch0.x - touch.x;
	          this.children.css('webkitTransform', 'translate3d(' + -x + 'px,0,0)');
	
	          // Track instantaneous velocity by watching position over time.
	          var t = Date.now();
	          var dt = t - this.t;
	
	          // Too short/noisy of a sample duration; wait for another.
	          if (dt < 8) {
	            return;
	          }
	
	          this.v = (x - this.x) / dt;
	          this.x = x;
	          this.t = t;
	        }
	
	        // Take over scrolling to coast to a snap point based on velocity at the
	        // end of the swipe
	
	      }, {
	        key: 'onTouchEnd',
	        value: function onTouchEnd(e) {
	          // Calculate snap position
	          var x = this.x0 + this.touch0.x - this.getCoordinates(e).x;
	          var xf = Math.round((x + this.v * 200) / this.width) * this.width;
	          xf = this.constrain(xf, this.x0 - this.width, this.x0 + this.width);
	
	          // Minimum speed is 1.
	          if (Math.abs(this.v) < 1) {
	            this.v = xf > x ? 1 : -1;
	          }
	
	          // Calculate duration of coast
	          this.dt = (xf - x) / this.v;
	          var a = (Math.abs(this.v) - 1) / 3;
	
	          // Un-"scroll" the children and actually scroll the content
	          this.children.css('webkitTransform', 'translate3d(0,0,0)');
	          this.$element.scrollLeft(x);
	          // Easing function: https://www.desmos.com/calculator/r270p2ri1m
	          this.$element.scrollLeft(xf, this.dt, function (t) {
	            return Math.min((a - 1) * (t - 1) * (t - 1) + 1, 1);
	          });
	        }
	      }, {
	        key: 'constrain',
	        value: function constrain(x, min, max) {
	          return Math.min(Math.max(x, min), max);
	        }
	      }]);
	
	      return OdCarouselContainer;
	    }(),
	
	    link: function link(scope, elem, attrs, odCarousel) {
	      elem.on('scroll', (0, _lodash.throttle)(function () {
	        odCarousel.onScroll();
	      }, 10));
	    }
	  };
	})
	
	// Every time a new od-carousel-item is detected, we need to notify od-carousel
	// so it can rebuild. This will happen e.g. if ng-repeat creates additional
	// carousel items, but also if you create more carousel-items at any time!
	.directive('odCarouselItem', function () {
	  return {
	    restrict: 'EA',
	    require: '^odCarousel',
	    link: function link(scope, elem, attrs, odCarousel) {
	      odCarousel.carouselItemAdded();
	    },
	
	    scope: true
	  };
	}).name;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(682);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-carousel.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-carousel.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "od-carousel,[od-carousel]{display:block;position:relative}od-carousel od-carousel-container,[od-carousel] od-carousel-container,od-carousel [od-carousel-container],[od-carousel] [od-carousel-container]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;overflow-x:scroll;overflow-y:hidden;-webkit-overflow-scrolling:touch;-webkit-scroll-snap-type:mandatory;-ms-scroll-snap-type:mandatory;scroll-snap-type:mandatory;-webkit-scroll-snap-points-x:repeat(100%);-ms-scroll-snap-points-x:repeat(100%);scroll-snap-points-x:repeat(100%)}od-carousel od-carousel-container::-webkit-scrollbar,[od-carousel] od-carousel-container::-webkit-scrollbar,od-carousel [od-carousel-container]::-webkit-scrollbar,[od-carousel] [od-carousel-container]::-webkit-scrollbar{height:0 !important}od-carousel od-carousel-container od-carousel-item,[od-carousel] od-carousel-container od-carousel-item,od-carousel [od-carousel-container] od-carousel-item,[od-carousel] [od-carousel-container] od-carousel-item,od-carousel od-carousel-container [od-carousel-item],[od-carousel] od-carousel-container [od-carousel-item],od-carousel [od-carousel-container] [od-carousel-item],[od-carousel] [od-carousel-container] [od-carousel-item]{display:block;-webkit-box-flex:0;-webkit-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0}", ""]);
	
	// exports


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FORMAT = 'YYYY-MM-DD';
	
	module.exports = _angular2.default.module('common.components.od-flip-dates', [__webpack_require__(569), __webpack_require__(684), __webpack_require__(685)]).component('odFlipDates', {
	  require: { flipDatesCtrl: '^odFlipDatesContainer' },
	  template: __webpack_require__(687)(),
	  controller: function () {
	    function OdFlipDatesCtrl() {
	      _classCallCheck(this, OdFlipDatesCtrl);
	    }
	
	    _createClass(OdFlipDatesCtrl, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.FORMAT = this.flipDatesCtrl.format || FORMAT;
	      }
	    }]);
	
	    return OdFlipDatesCtrl;
	  }()
	}).name;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.sorted-keys', []).filter('sortedKeys', function () {
	  return function (object) {
	    return (0, _lodash.keys)(object).sort();
	  };
	}).name;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.titlecase', [__webpack_require__(686)]).filter('titlecase', ["wordcaseFilter", function (wordcaseFilter) {
	  return function (input) {
	    if (typeof input === 'number') {
	      input = String(input);
	    } else if (typeof input !== 'string') {
	      return '';
	    }
	
	    return wordcaseFilter(input).replace(/\w\S*/g, function (word) {
	      return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
	    });
	  };
	}]).name;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// converts snake/kebab case to words
	module.exports = _angular2.default.module('common.filters.wordcase', []).filter('wordcase', function () {
	  return function (input) {
	    if (!input) return '';
	    return input.replace(/[-_\s]+/g, ' ');
	  };
	}).name;

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<table ng-if=\"$ctrl.flipDatesCtrl.flipDates\"><div class=\"table-hover\"><tbody><tr ng-repeat=\"key in $ctrl.flipDatesCtrl.flipDates | sortedKeys\" ng-if=\"$ctrl.flipDatesCtrl.flipDates[key] &amp;&amp; key !== &quot;id&quot;\"><th>{{key | pretty | titlecase}}</th><td>{{$ctrl.flipDatesCtrl.flipDates[key] | amDateFormat:$ctrl.FORMAT}}</td></tr></tbody></div></table>");;return buf.join("");
	}

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('common.components.od-flip-dates-container', [__webpack_require__(689)]).component('odFlipDatesContainer', {
	  transclude: true,
	  bindings: {
	    flipId: '<',
	    format: '<'
	  },
	  template: __webpack_require__(690)(),
	  controller: function () {
	    controller.$inject = ["FlipDates"];
	    function controller(FlipDates) {
	      _classCallCheck(this, controller);
	
	      this.FlipDates = FlipDates;
	      this.isLoaded = false;
	    }
	
	    _createClass(controller, [{
	      key: '$onChanges',
	      value: function $onChanges(changes) {
	        var _this = this;
	
	        var _changes$flipId = changes.flipId,
	            currentValue = _changes$flipId.currentValue,
	            previousValue = _changes$flipId.previousValue;
	
	        if (currentValue && currentValue !== previousValue) {
	          this.isLoaded = false;
	
	          this.FlipDates.fetchDates(currentValue).then(function (flipDates) {
	            _this.flipDates = flipDates;
	            _this.isLoaded = true;
	          });
	        }
	      }
	    }]);
	
	    return controller;
	  }()
	}).name;

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.services.flipDates', []).factory('FlipDates', ["$http", function ($http) {
	  return {
	    fetchDates: function fetchDates(flipId) {
	      return $http.get('/api/v1/flips/' + flipId + '/dates').then(function (resp) {
	        return resp.data;
	      });
	    }
	  };
	}]).name;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div ng-if=\"!$ctrl.isLoaded\" class=\"loading-spinner in-progress\"></div><div ng-transclude ng-if=\"$ctrl.isLoaded\"><od-flip-dates></od-flip-dates></div>");;return buf.join("");
	}

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _d = __webpack_require__(608);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var margin = {
	  top: 0.5,
	  right: 50.5,
	  bottom: 25.5,
	  left: 0.5
	};
	
	function extent(data, fn) {
	  return [_d2.default.min(data, function (series) {
	    return _d2.default.min(series, fn);
	  }), _d2.default.max(data, function (series) {
	    return _d2.default.max(series, fn);
	  })];
	}
	
	module.exports = _angular2.default.module('common.components.od-market-analysis-chart', []).component('odMarketAnalysisChart', {
	  bindings: {
	    statistic: '@',
	    postalCode: '@',
	    market: '@',
	    marketLabel: '@',
	    smoothing: '@',
	    format: '&' // callback function
	  },
	  controller: function () {
	    controller.$inject = ["$scope", "$element", "$window", "$q"];
	    function controller($scope, $element, $window, $q) {
	      var _this = this;
	
	      _classCallCheck(this, controller);
	
	      this.series = [];
	      var windowEl = _angular2.default.element($window);
	      $q.all((0, _lodash.map)(this.series, '$promise')).then(this.smooth.bind(this)).then(function () {
	        _this.svg = _d2.default.select($element[0]).append('svg');
	        _this.x = _d2.default.time.scale().domain(extent(_this.series, function (d) {
	          return d[0];
	        }));
	        _this.y = _d2.default.scale.linear().domain([0, extent(_this.series, function (d) {
	          return d[1];
	        })[1]]).nice();
	        _this.line = _d2.default.svg.line().interpolate('linear').defined(function (d) {
	          return d[1];
	        }).interpolate('cardinal').tension(0.8).x(function (d) {
	          return _this.x(d[0]);
	        }).y(function (d) {
	          return _this.y(d[1]);
	        });
	
	        var onWindowResize = function onWindowResize() {
	          _this.resize($element.prop('offsetWidth'));
	        };
	        windowEl.on('resize', onWindowResize);
	        $scope.$on('$destroy', function () {
	          windowEl.off('resize', onWindowResize);
	        });
	
	        onWindowResize();
	      });
	    }
	
	    _createClass(controller, [{
	      key: 'resize',
	      value: function resize(width) {
	        if (this.width === width) return;
	
	        this.width = width;
	        this.height = Math.round(this.width * 0.4);
	        this.draw();
	      }
	    }, {
	      key: 'smooth',
	      value: function smooth(series) {
	        if (!this.smoothing) return;
	
	        // https://en.wikipedia.org/wiki/Exponential_smoothing#The_exponential_moving_average
	        var a = Number(this.smoothing);
	        (0, _lodash.forEach)(series, function (series) {
	          (0, _lodash.forEach)(series, function (d, i, data) {
	            if (i > 0 && d[1] !== null && data[i - 1][1] !== null) {
	              d[1] = a * d[1] + (1 - a) * data[i - 1][1];
	            }
	          });
	        });
	      }
	    }, {
	      key: 'draw',
	      value: function draw() {
	        var _this2 = this;
	
	        this.svg.attr('width', this.width).attr('height', this.height);
	        this.chart = this.chart || this.svg.append('g').attr('class', 'chart').attr('transform', 'translate(' + margin.left + ', ' + margin.top + ')');
	
	        var width = this.width - margin.left - margin.right;
	        var height = this.height - margin.top - margin.bottom;
	
	        // y-axis
	        this.y.range([height, 0]);
	        var yAxis = _d2.default.svg.axis().scale(this.y).orient('right').ticks(4).tickFormat(function (d) {
	          return _this2.format({ value: d }) || d;
	        });
	        this.yAxisGroup = this.yAxisGroup || this.chart.append('g').attr('class', 'y axis');
	        this.yAxisGroup.attr('transform', 'translate(' + width + ', 0)').call(yAxis);
	        // y grid lines
	        var yGrid = yAxis.tickSize(width, 0, 0).tickFormat('');
	        this.yGridGroup = this.yGridGroup || this.chart.append('g').attr('class', 'y grid');
	        this.yGridGroup.call(yGrid);
	
	        // x-axis
	        this.x.range([0, width]);
	        var xAxis = _d2.default.svg.axis().scale(this.x).orient('bottom').ticks(5).tickFormat(_d2.default.time.format('%Y'));
	        this.xAxisGroup = this.xAxisGroup || this.chart.append('g').attr('class', 'x axis');
	        this.xAxisGroup.attr('transform', 'translate(0, ' + height + ')').call(xAxis);
	
	        // legend
	        var legendWidth = 80;
	        var legendTranslation = margin.left + width - legendWidth * this.series.length;
	        this.legend = this.legend || this.svg.append('g').attr('class', 'legend');
	        this.legend.attr('transform', 'translate(' + legendTranslation + ', -12)');
	        var legends = this.legend.selectAll('g').data(this.series).enter().append('g').attr('transform', function (area, i) {
	          return 'translate(' + i * legendWidth + ', 0)';
	        });
	        legends.append('line').attr('class', function (d) {
	          return d.entity_type;
	        }).attr('x2', 20).attr('y2', 0);
	        legends.append('text').attr('x', 23).attr('dy', '.32em').text(function (d) {
	          if (d.entity_type === 'market') {
	            return _this2.marketLabel;
	          } else {
	            return (0, _lodash.startCase)(d.entity_id);
	          }
	        });
	
	        // lines
	        var linePaths = this.chart.selectAll('path.line').data(this.series);
	        linePaths.enter().append('path').attr('class', function (d) {
	          return 'line ' + d.entity_type;
	        });
	        linePaths.attr('d', function (area) {
	          return _this2.line(area);
	        });
	      }
	    }]);
	
	    return controller;
	  }()
	}).name;

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// see documentation on od-properties-navigation-container
	module.exports = _angular2.default.module('common.components.od-properties-navigation-node', []).component('odPropertiesNavigationNode', {
	  transclude: true,
	  template: '<div ng-transclude />',
	  require: {
	    parentNode: '?^^odPropertiesNavigationNode'
	  },
	  bindings: {
	    onSetVisibility: '&',
	    parentRefs: '=refs'
	  },
	  controller: function () {
	    function controller() {
	      _classCallCheck(this, controller);
	    }
	
	    _createClass(controller, [{
	      key: '$onInit',
	
	      // make parent menu layer aware of this menu layer
	      value: function $onInit() {
	        if (this.parentNode) {
	          this.parentRefs.parentNode = this.parentNode;
	          this.parentNode.setChildNode(this);
	        }
	
	        this.parentRefs.node = this;
	      }
	
	      // this happens when all the children menu components have been inserted into the DOM,
	      // so if this is the leaf menu layer, it should show itself
	
	    }, {
	      key: '$postLink',
	      value: function $postLink() {
	        if (!this.childNode) {
	          this.onSetVisibility({
	            isVisible: true
	          });
	        }
	      }
	    }, {
	      key: 'setChildNode',
	      value: function setChildNode(childNode) {
	        this.parentRefs.childNode = this.childNode = childNode;
	        this.onSetVisibility({
	          isVisible: false
	        });
	      }
	    }, {
	      key: 'goUpOneLevel',
	      value: function goUpOneLevel() {
	        this.onSetVisibility({
	          isVisible: false
	        });
	        this.parentNode.onSetVisibility({
	          isVisible: true
	        });
	      }
	
	      // if we go to an active link, it may be the current leaf or a parent of the current leaf
	
	    }, {
	      key: 'goToActive',
	      value: function goToActive() {
	        // go down one level unless we're at the current leaf
	        if (!this.childNode) {
	          return;
	        }
	
	        this.onSetVisibility({
	          isVisible: false
	        });
	        this.childNode.onSetVisibility({
	          isVisible: true
	        });
	      }
	    }]);
	
	    return controller;
	  }()
	}).name;

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// NOTE(ed): This abstraction hasn't been thought out. It's only used in one place right now.
	
	// onChange is a callback expected to take a state param.
	// An example of an onChange handler is handleSwitchChange = (state) => this.state = state;
	
	// By default, leftValue is false and rightValue is true,
	// and false shows up as "No", true shows up as "Yes" by default.
	// To override the description, pass a template by transclusion using the switchLeftButton and
	// switchRightButton slots.
	module.exports = _angular2.default.module('common.components.od-three-state-switch', []).component('odThreeStateSwitch', {
	  transclude: {
	    left: '?switchLeftButton',
	    right: '?switchRightButton'
	  },
	  bindings: {
	    leftValue: '<?',
	    rightValue: '<?',
	    nullable: '<?',
	    state: '<?',
	    onChange: '&?'
	  },
	  template: __webpack_require__(694)(),
	  controller: function () {
	    function controller() {
	      _classCallCheck(this, controller);
	    }
	
	    _createClass(controller, [{
	      key: '$onChanges',
	      value: function $onChanges() {
	        this.leftValueOrDefault = this.leftValue === undefined ? false : this.leftValue;
	        this.rightValueOrDefault = this.rightValue === undefined ? true : this.rightValue;
	
	        this.isLeftOn = this.leftValueOrDefault === this.state;
	        this.isRightOn = this.rightValueOrDefault === this.state;
	
	        this.leftDescription = this.leftValueOrDefault === true ? 'Yes' : this.leftValueOrDefault === false ? 'No' : this.leftValue;
	        this.rightDescription = this.rightValueOrDefault === true ? 'Yes' : this.rightValueOrDefault === false ? 'No' : this.rightValue;
	      }
	    }, {
	      key: 'handleClickLeft',
	      value: function handleClickLeft() {
	        if (this.nullable && this.isLeftOn) {
	          this.onChange({ state: null });
	        } else {
	          this.onChange({ state: this.leftValueOrDefault });
	        }
	      }
	    }, {
	      key: 'handleClickRight',
	      value: function handleClickRight() {
	        if (this.nullable && this.isRightOn) {
	          this.onChange({ state: null });
	        } else {
	          this.onChange({ state: this.rightValueOrDefault });
	        }
	      }
	    }]);
	
	    return controller;
	  }()
	}).name;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"btn-group btn-group-xs\"><button ng-click=\"$ctrl.handleClickLeft()\" ng-class=\"$ctrl.isLeftOn ? &quot;btn-success&quot; : &quot;btn-default&quot;\" class=\"btn\"><div ng-transclude=\"left\">{{$ctrl.leftValue}}</div></button><button ng-click=\"$ctrl.handleClickRight()\" ng-class=\"$ctrl.isRightOn ? &quot;btn-danger&quot; : &quot;btn-default&quot;\" class=\"btn\"><div ng-transclude=\"right\">{{$ctrl.rightValue}}</div></button></div>");;return buf.join("");
	}

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('common.components.od-document-preview', []).component('odDocumentPreview', {
	  bindings: {
	    documentItem: '<'
	  },
	  template: __webpack_require__(696)(),
	  controller: function () {
	    controller.$inject = ["$uibModal"];
	    function controller($uibModal) {
	      _classCallCheck(this, controller);
	
	      this.$uibModal = $uibModal;
	    }
	
	    _createClass(controller, [{
	      key: 'showPreviewModal',
	      value: function showPreviewModal() {
	        var documentItem = this.documentItem;
	
	        return this.$uibModal.open({
	          size: 'lg',
	          template: __webpack_require__(513)(),
	          windowClass: 'document-preview-modal',
	          controllerAs: 'modalCtrl',
	          controller: /*@ngInject*/["$uibModalInstance", "$sce", function controller($uibModalInstance, $sce) {
	            _classCallCheck(this, controller);
	
	            this.$uibModalInstance = $uibModalInstance;
	            this.url = $sce.trustAsResourceUrl(documentItem.url + '?response-content-disposition-type=inline');
	          }]
	        });
	      }
	    }]);
	
	    return controller;
	  }()
	}).name;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<p><a href=\"#\" ng-click=\"$ctrl.showPreviewModal()\" class=\"text-muted\">{{ $ctrl.documentItem.document_type | titlecase }}</a></p>");;return buf.join("");
	}

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.controllers', [__webpack_require__(698), __webpack_require__(699), __webpack_require__(700)]).name;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// A common controller shared between the market and admin style guides.
	//
	// Handles keeping track of the tree of styleguide modules, via scroll and
	// resize handlers. Also provides functions to scroll the window to any module.
	//
	// To use: use `resolve` to define the following properties:
	//   * `moduleTree`
	//   * `moduleListContainerId` (the scrolling container that has the full list
	//      of rendered modules in the full-list view of the styleguide. Or `null`
	//      to use the full-page/document scroll instead.)
	//   * `moduleScrollOffsetTop` (extra amount to scroll when jumping to a module
	//      in the list, just for aesthetics)
	//
	// This controller will then dependency-inject those properties and make use of
	// them. It will transform `moduleTree` and expose it to be used by the
	// templates, for example.
	module.exports = _angular2.default.module('common.controllers.style-list', []).controller('commonStyleListCtrl', function () {
	  _class.$inject = ["moduleTree", "moduleListContainerId", "moduleScrollOffsetTop", "$scope", "$stateParams", "$location", "$anchorScroll", "$document"];
	  function _class(moduleTree, moduleListContainerId, moduleScrollOffsetTop, $scope, $stateParams, $location, $anchorScroll, $document) {
	    var _this = this;
	
	    _classCallCheck(this, _class);
	
	    if (moduleListContainerId) {
	      this.listContainerEl = _angular2.default.element(document.getElementById(moduleListContainerId));
	    } else {
	      this.listContainerEl = $document;
	    }
	
	    this.moduleScrollOffsetTop = moduleScrollOffsetTop;
	
	    this.moduleTree = moduleTree;
	    this.groupNames = (0, _lodash.keys)(this.moduleTree);
	    this.flatModuleNames = (0, _lodash.chain)(this.groupNames).map(function (groupName) {
	      return [groupName].concat(_this.moduleTree[groupName]);
	    }).flatten().value();
	
	    this.moduleParents = {};
	    this.groupNames.forEach(function (groupName) {
	      _this.moduleParents[groupName] = groupName;
	      _this.moduleTree[groupName].forEach(function (moduleName) {
	        _this.moduleParents[moduleName] = groupName;
	      });
	    });
	
	    this.selectedModuleName = null;
	    this.expandedGroupName = null;
	
	    // On scroll, we check how our scroll position compares to the module
	    // offsets, so that we can display our position in the right navbar.
	    var throttledOnScroll = (0, _lodash.throttle)(function () {
	      _this.selectedModuleName = _this.getSelectedModuleName();
	      _this.expandedGroupName = _this.moduleParents[_this.selectedModuleName];
	
	      $scope.$digest();
	    }, 10);
	
	    // Every now and then on scroll, we recompute the module offsets from the
	    // top of the page. This is just in case their heights changed (e.g. if you
	    // selected a different example that took up more height), so that we can
	    // continue to track the position on scroll.
	    var debouncedRebuild = (0, _lodash.debounce)(function () {
	      _this.recomputeOffsets();
	    }, 300, { leading: true });
	
	    this.listContainerEl.on('scroll', throttledOnScroll);
	    this.listContainerEl.on('scroll', debouncedRebuild);
	    $scope.$on('$destroy', function () {
	      _this.listContainerEl.off('scroll', throttledOnScroll);
	      _this.listContainerEl.off('scroll', debouncedRebuild);
	    });
	
	    this.recomputeOffsets();
	  }
	
	  _createClass(_class, [{
	    key: 'scrollToAnchor',
	    value: function scrollToAnchor(anchor) {
	      // It's important to recompute the module offsets from the top of the page
	      // at the last minute, in case they changed (e.g. due to late rendering)
	      // but you didn't scroll. This is particularly important for the buttons at
	      // the top of the page.
	      this.recomputeOffsets();
	      var offset = (0, _lodash.find)(this.moduleOffsets, { name: anchor }).offset || 0;
	
	      // Scroll a little extra to make sure the sidebar displays us as "in" the
	      // section we scrolled to
	      this.listContainerEl.scrollTop(offset + 4);
	    }
	
	    // Special case for when the `listContainerEl` is `$document`, which doesn't
	    // have a `getBoundingClientRect` function
	
	  }, {
	    key: 'getListContainerTopOffset',
	    value: function getListContainerTopOffset() {
	      if (this.listContainerEl[0].getBoundingClientRect) {
	        return this.listContainerEl[0].getBoundingClientRect().top;
	      } else {
	        return 0;
	      }
	    }
	
	    // Returns a list of { name, offset } for the flattened list of modules
	
	  }, {
	    key: 'recomputeOffsets',
	    value: function recomputeOffsets() {
	      var _this2 = this;
	
	      this.moduleOffsets = (0, _lodash.map)(this.flatModuleNames, function (moduleName) {
	        var moduleEl = document.getElementById(moduleName);
	        var offsetFromPageTop = null;
	        if (moduleEl) {
	          offsetFromPageTop = moduleEl.getBoundingClientRect().top - _this2.getListContainerTopOffset() + _this2.listContainerEl.scrollTop() + _this2.moduleScrollOffsetTop;
	        }
	        return {
	          name: moduleName,
	          offset: offsetFromPageTop
	        };
	      });
	      // For performance reasons, calculate this on rebuild so we can search
	      // through it using _.sortedIndex
	      // TODO(lodash-4): Use sortedIndexBy and remove this array.
	      this.moduleOffsetsNumArray = this.moduleOffsets.map(function (moduleOffset) {
	        return moduleOffset.offset;
	      });
	    }
	  }, {
	    key: 'getSelectedModuleName',
	    value: function getSelectedModuleName() {
	      var scrollTop = this.listContainerEl.scrollTop();
	      // First module index after the current scroll position
	      // TODO(lodash-4): Use sortedIndexBy
	      var firstModuleIndex = (0, _lodash.sortedIndex)(this.moduleOffsetsNumArray, scrollTop);
	
	      // Subtract 1 and constrain to (0, length - 1)
	      firstModuleIndex = Math.min(Math.max(firstModuleIndex - 1, 0), this.moduleOffsets.length - 1);
	      return this.flatModuleNames[firstModuleIndex];
	    }
	  }]);
	
	  return _class;
	}()).name;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// A common controller shared between the market and admin style guides.
	//
	// Sets mock / dummy data that can be used to show off data-driven components
	// in the styleguide.
	//
	// To use: use `resolve` to define a property called `mocks`, which should be a
	// map from the name of a mock to a static object containing mock data. The
	// controller will make each of these mocks available on itself.
	//
	// For example, if you resolve `mocks = { 'abc': 'xyz' }` and use
	// `controllerAs: 'styleMocks'`, then you can access your mock via
	// `styleMocks.abc`.
	module.exports = _angular2.default.module('common.controllers.style-mocks', []).controller('commonStyleMocksCtrl', function () {
	  _class.$inject = ["mocks"];
	  function _class(mocks) {
	    var _this = this;
	
	    _classCallCheck(this, _class);
	
	    // Make all the mocks available on the controller so they can be easily
	    // accessed from templates
	    (0, _lodash.keys)(mocks).forEach(function (mockName) {
	      _this[mockName] = mocks[mockName];
	    });
	  }
	
	  return _class;
	}()).name;

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// A common controller shared between the market and admin style guides.
	//
	// Uses the URL ($stateParams) to determine which module is being viewed in
	// isolation, and sets that on the scope. This allows us to use the same
	// template for the list view and single/isolated views of each module in the
	// styleguide.
	module.exports = _angular2.default.module('common.controllers.style-single', []).controller('commonStyleSingleCtrl', function () {
	  _class.$inject = ["$stateParams", "$scope"];
	  function _class($stateParams, $scope) {
	    _classCallCheck(this, _class);
	
	    if ($stateParams.moduleName) {
	      $scope.moduleName = $stateParams.moduleName;
	    } else {
	      // TODO(azirbel): Handle module not found?
	    }
	  }
	
	  return _class;
	}()).name;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives', [__webpack_require__(702), __webpack_require__(703), __webpack_require__(704), __webpack_require__(705), __webpack_require__(707), __webpack_require__(708), __webpack_require__(709), __webpack_require__(710), __webpack_require__(711), __webpack_require__(712), __webpack_require__(713), __webpack_require__(714), __webpack_require__(715), __webpack_require__(776), __webpack_require__(786), __webpack_require__(787), __webpack_require__(789), __webpack_require__(790), __webpack_require__(791), __webpack_require__(793), __webpack_require__(796), __webpack_require__(799), __webpack_require__(800), __webpack_require__(801), __webpack_require__(805), __webpack_require__(808), __webpack_require__(809), __webpack_require__(812), __webpack_require__(815), __webpack_require__(819), __webpack_require__(820), __webpack_require__(822), __webpack_require__(824), __webpack_require__(826), __webpack_require__(827), __webpack_require__(828), __webpack_require__(829), __webpack_require__(830), __webpack_require__(831), __webpack_require__(833), __webpack_require__(834), __webpack_require__(835)]).name;

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.comma-number', []).directive('type', ["numberFilter", "formattedCursorPosition", function typeCommaNumber(numberFilter, formattedCursorPosition) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function link(scope, element, attrs, ngModel) {
	      if (attrs.type !== 'commaNumber' || !ngModel) return;
	
	      var precision = parseInt(attrs.precision || 0);
	
	      // String with commas -> Number
	      ngModel.$parsers.push(function (oldValue) {
	        if (!oldValue) return null;
	
	        var numbers = oldValue.toString().trim().replace(/[^\d\.]/g, '');
	        var hasDecimal = numbers[numbers.length - 1] === '.';
	
	        var newValue = numberFilter(numbers, precision);
	        if (precision) {
	          newValue = newValue.replace(/\.?0+$/, '');
	          if (hasDecimal) newValue += '.';
	        }
	
	        var oldCursorPosition = element[0].selectionStart;
	        var newCursorPosition = formattedCursorPosition(oldCursorPosition, oldValue, newValue);
	        element.val(newValue);
	        ngModel.$setViewValue(newValue);
	        ngModel.$commitViewValue();
	        element[0].setSelectionRange(newCursorPosition, newCursorPosition);
	
	        // Ensure that the model is a well typed Number
	        return numbers === '.' ? 0 : Number(numbers);
	      });
	
	      // Number -> String with commas
	      ngModel.$formatters.push(function (value) {
	        if ((0, _lodash.isNil)(value)) return;
	
	        value = numberFilter(value, precision);
	        if (precision) value = value.replace(/\.?0+$/, '');
	        return value;
	      });
	    }
	  };
	}]).name;

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.confirm', []).directive('ocConfirm', function () {
	  return {
	    restrict: 'A',
	    priority: -1,
	    link: function link(scope, elem, attrs) {
	      elem.on('click', function (e) {
	        if (attrs.ocConfirm && !confirm(attrs.ocConfirm)) {
	          e.stopImmediatePropagation();
	          e.preventDefault();
	        }
	      });
	    }
	  };
	}).name;

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.convert-to-number', []).directive('convertToNumber', function () {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function link(scope, element, attrs, ngModel) {
	      ngModel.$parsers.push(function (val) {
	        return parseInt(val, 10);
	      });
	      ngModel.$formatters.push(function (val) {
	        return '' + val;
	      });
	    }
	  };
	}).name;

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.currency', [__webpack_require__(706)]).directive('type', ["currencyFilter", "formattedCursorPosition", function typeCurrency(currencyFilter, formattedCursorPosition) {
	  var currencyTypeReg = /^currency(:(\d))?$/;
	
	  function dollarFilter(value, decimals, hasDecimals) {
	    if (!value && value !== 0) return '';
	    if (value === '-') return '$-';
	
	    // Limit to max of 12 numbers
	    var numbers = value.toString().trim().replace(/[^\d\.\-]/g, '').slice(0, 12);
	    var formatted = currencyFilter(numbers * 100, decimals);
	
	    // We need to be able to type the decimals. If we leave it up to the filter and decimal count
	    // We have weird things happen
	    if (hasDecimals && formatted.indexOf('.') === -1) {
	      return formatted + '.';
	    } else {
	      return formatted;
	    }
	  }
	
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function link(scope, element, attrs, ngModel) {
	      var match = attrs.type.match(currencyTypeReg);
	
	      if (!match || !ngModel) return;
	
	      var maxDecimals = parseInt((match[2] || '').toString(), 10) || 0;
	
	      // String Dollars -> Number Cents
	      ngModel.$parsers.push(function (oldValue) {
	        if (!oldValue) return null;
	
	        var numbers = oldValue.toString().trim().replace(/[^\d\.\-]/g, ''),
	            decimalIndex = numbers.indexOf('.'),
	            decimals = 0,
	            currentDecimals,
	            hasDecimals,
	            numericValue;
	
	        if (decimalIndex > -1) {
	          hasDecimals = maxDecimals > 0;
	          currentDecimals = numbers.length - 1 - decimalIndex;
	
	          if (currentDecimals > maxDecimals) {
	            decimals = maxDecimals;
	          } else {
	            decimals = currentDecimals;
	          }
	        }
	
	        var newValue = dollarFilter(numbers, decimals, hasDecimals);
	
	        var oldCursorPosition = element[0].selectionStart;
	        var newCursorPosition = formattedCursorPosition(oldCursorPosition, oldValue, newValue);
	        element.val(newValue);
	        ngModel.$setViewValue(newValue);
	        ngModel.$commitViewValue(newValue);
	        element[0].setSelectionRange(newCursorPosition, newCursorPosition);
	
	        numericValue = Math.round(parseFloat(numbers) * 100);
	        if (isNaN(numericValue)) numericValue = null;
	        return numericValue;
	      });
	
	      // Number Cents -> String Dollars
	      ngModel.$formatters.push(function (value) {
	        if (!value && value !== 0) return;
	        return dollarFilter(value / 100, maxDecimals);
	      });
	    }
	  };
	}]).name;

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.currency', []).filter('currency', ["numberFilter", function (numberFilter) {
	  return function (cents, decimals) {
	    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '—';
	    var symbol = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '$';
	
	    if (cents !== null && isFinite(cents)) {
	      if (decimals === -3) {
	        return symbol + numberFilter(cents / 100000, 0) + 'K';
	      } else {
	        return symbol + numberFilter(cents / 100, decimals || 0);
	      }
	    } else {
	      return defaultValue;
	    }
	  };
	}]).name;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.decimal-to-percent', []).directive('type', function () {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function link(scope, element, attrs, ngModel) {
	      if (attrs.type !== 'decimal-to-percent' || !ngModel) return;
	
	      //  number -> decimal (3 -> .03)
	      ngModel.$parsers.push(function (value) {
	        if (!value) return null;
	        return value / 100.0;
	      });
	
	      // decimal -> number (.03 -> 3)
	      ngModel.$formatters.push(function (value) {
	        if (!value && value !== 0) return null;
	        return (value * 100.0).toFixed(2);
	      });
	    }
	  };
	}).name;

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global L:false */
	module.exports = _angular2.default.module('common.directives.details-map', [__webpack_require__(706), __webpack_require__(654)]).directive('ocDetailsMap', ["currencyFilter", "MapboxConfig", "$animate", "$compile", "$templateRequest", function (currencyFilter, MapboxConfig, $animate, $compile, $templateRequest) {
	  // eslint-disable-line max-len
	  var overlayTemplate = $templateRequest('/templates/common/directives/details_map_marker.html');
	
	  return {
	    restrict: 'C',
	    scope: {
	      ngModel: '=',
	      hover: '=?',
	      subjectAddress: '=',
	      subjectPrice: '='
	    },
	    link: function link(scope, element, attrs) {
	      var map = null,
	          subjectPosition = null,
	          markers = {},
	          container = element.append('<div>').find('div').css({ 'height': '100%' }),
	          overlay = element.css({ position: 'relative' }).append('<div class="overlay-container">').find('div').next().css({ 'height': '100%', position: 'absolute', top: 0 }); // eslint-disable-line max-len
	
	      scope.$watchGroup([attrs.ngModel, attrs.subjectAddress, attrs.subjectPrice], function () {
	        rebuildMap();
	      });
	
	      function rebuildMap() {
	        var listings = scope.ngModel,
	            subjectAddress = scope.subjectAddress,
	            subjectPrice = scope.subjectPrice;
	        if (!listings || !subjectAddress || !subjectPrice) return;
	
	        // Clear out any remnants
	        container[0].innerHTML = '';
	        overlay[0].innerHTML = '';
	
	        subjectPosition = [parseFloat(subjectAddress.latitude), parseFloat(subjectAddress.longitude)]; // eslint-disable-line max-len
	        L.mapbox.accessToken = MapboxConfig.accessToken;
	        L.mapbox.config.FORCE_HTTPS = true;
	        map = L.mapbox.map(element.children()[0], MapboxConfig.defaultMap, {
	          attributionControl: { compact: true },
	          boxZoom: false,
	          center: subjectPosition,
	          doubleClickZoom: false,
	          dragging: false,
	          keyboard: false,
	          scrollWheelZoom: false,
	          touchZoom: false,
	          zoom: 14,
	          zoomControl: false
	        });
	        map.on('viewreset', function () {
	          (0, _lodash.forEach)((0, _lodash.values)(markers), positionMarkerOverlay);
	        });
	        map.on('move', function () {
	          (0, _lodash.forEach)((0, _lodash.values)(markers), positionMarkerOverlay);
	        });
	
	        var pinLayer = makeCompLayer().addTo(map),
	            compGeoJson = [];
	
	        var subjectGeoJson = makePriceMarker(subjectPosition, null, subjectPrice);
	        compGeoJson.push(subjectGeoJson);
	
	        (0, _lodash.forEach)((0, _lodash.compact)(listings), function (listing) {
	          if (!listing.coordinates) return;
	
	          var position = [listing.coordinates.lat, listing.coordinates.lng];
	          var marker = makePriceMarker(position, listing, listing.price_cents);
	          compGeoJson.push(marker);
	        });
	
	        pinLayer.setGeoJSON({
	          type: 'FeatureCollection',
	          features: compGeoJson
	        });
	        map.fitBounds(pinLayer.getBounds(), {
	          animate: false,
	          paddingBottomRight: [50, 10],
	          paddingTopLeft: [50, 30]
	        });
	      }
	
	      // We want the pin overlays/popups to display outside of the edges of the
	      // map and not be hidden by the map container's `overflow: hidden`. As
	      // such, the overlays need to exist in a different part of the DOM and be
	      // positioned using this method.
	      function positionMarkerOverlay(marker) {
	        var listing = marker.feature.properties.listing,
	            point = map.latLngToContainerPoint(listing.coordinates);
	        if (point && marker.div) {
	          marker.div.style.left = point.x + 'px';
	          marker.div.style.top = point.y + 'px';
	        }
	      }
	
	      function makeCompLayer() {
	        var pinLayer = L.mapbox.featureLayer();
	        pinLayer.overlay = overlay;
	        pinLayer.on('layeradd', function (e) {
	          var marker = e.layer,
	              feature = marker.feature,
	              listing = feature.properties.listing;
	
	          marker.hoverOn = function () {
	            var iconOpts = (0, _lodash.merge)({}, feature.properties.icon, {
	              className: feature.properties.icon.className + ' hover'
	            });
	            marker.setIcon(L.divIcon(iconOpts));
	            marker.setZIndexOffset(2000);
	            if (marker.div) $animate.addClass(marker.div, 'hover');
	          };
	
	          marker.hoverOff = function () {
	            marker.setIcon(L.divIcon(feature.properties.icon));
	            marker.setZIndexOffset(null); // null is required here, not undefined
	            if (marker.div) $animate.removeClass(marker.div, 'hover');
	          };
	
	          marker.onmouseenter = function () {
	            scope.$apply(function () {
	              if (listing) scope.hover = listing.listing_id;
	            });
	          };
	
	          marker.onmouseleave = function () {
	            scope.$apply(function () {
	              scope.hover = null;
	            });
	          };
	
	          if (!marker.div && listing) {
	            markers[listing.listing_id] = marker;
	            overlayTemplate.then(function (template) {
	              var compileScope = scope.$new(true);
	              compileScope.listing = listing;
	              marker.div = $compile(template)(compileScope)[0];
	
	              marker.div.addEventListener('mouseenter', marker.onmouseenter);
	              marker.div.addEventListener('mouseleave', marker.onmouseleave);
	
	              pinLayer.overlay.append(marker.div);
	              marker.div.style.marginLeft = -marker.div.offsetWidth / 2 + 'px';
	              positionMarkerOverlay(marker);
	            });
	          }
	
	          if (feature.properties.isSubject) marker.setZIndexOffset(1000); // put subject on top of all other markers
	
	          marker.setIcon(L.divIcon(feature.properties.icon));
	        });
	
	        pinLayer.on('mouseover', function (e) {
	          var marker = e.layer;
	          marker.hoverOn();
	          marker.onmouseenter();
	        });
	        pinLayer.on('mouseout', function (e) {
	          var marker = e.layer;
	          marker.hoverOff();
	          marker.onmouseleave();
	        });
	
	        return pinLayer;
	      }
	
	      function makePriceMarker(latlon, listing, price) {
	        var className = 'price-icon';
	        if (!listing) className += ' subject';
	
	        return {
	          'type': 'Feature',
	          'geometry': {
	            'type': 'Point',
	            'coordinates': [latlon[1], latlon[0]]
	          },
	          'properties': {
	            'icon': {
	              'className': className,
	              'html': currencyFilter(price),
	              'iconSize': null
	            },
	            'listing': listing,
	            'isSubject': !listing
	          }
	        };
	      }
	
	      scope.$watch('hover', function (listing, previous) {
	        if (markers[previous]) markers[previous].hoverOff();
	
	        if (markers[listing]) markers[listing].hoverOn();
	      });
	    }
	  };
	}]).name;

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.dropdown_multiselect', []).directive('ocDropdownMultiselect', function () {
	  return {
	    restrict: 'C',
	    scope: {
	      providedModel: '=',
	      options: '=',
	      orderBy: '@',
	      dropdownAlign: '@',
	      onChange: '&',
	      // Can be 'medium' or 'small', defaults to 'small'
	      size: '@'
	    },
	    templateUrl: '/templates/common/directives/dropdown_multiselect.html',
	    controller: ["$scope", "dropdownLabel", function controller($scope, dropdownLabel) {
	      $scope.dropdownLabel = dropdownLabel;
	    }]
	  };
	}).name;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.empty-to-null', []).directive('emptyToNull', function emptyToNull() {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function link(scope, element, attrs, ctrl) {
	      ctrl.$parsers.push(function (viewValue) {
	        if (viewValue === '') {
	          return null;
	        }
	        return viewValue;
	      });
	    }
	  };
	}).name;

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.icon', []).directive('icon', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    template: '<svg class="icon"><use xlink:href="{{href}}"></use></svg>',
	    replace: true,
	    link: function link(scope, element, attrs) {
	      element.addClass(attrs.name);
	      scope.href = '#' + attrs.name;
	    }
	  };
	}).name;

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.image-background', []).directive('imageBackground', ["imageUrlFilter", function (imageUrlFilter) {
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attrs) {
	      var imageUrl = imageUrlFilter(attrs.imageBackground);
	      element.css({ 'background-image': 'url(' + imageUrl + ')' });
	    }
	  };
	}]).name;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// A lightweight alternative to http://sroze.github.io/ngInfiniteScroll/, but
	// doesn't use jQuery.
	//
	// Usage:
	// infinite-scroll="triggerFn()" threshold="300"
	//
	// Params:
	//   infinite-scroll: The callback function to call when scrolled to the
	//     bottom of the element
	//   threshold: Trigger when within this distance of the bottom of the element
	//
	// Uses transclusion to create a child element, which will look like:
	//   <div infinite-scroll-container> ... </div>
	// This container should be full/unconstrained height, so that scrolling
	// happens within the infinite-scroll element.
	module.exports = _angular2.default.module('common.directives.infinite-scroll', []).directive('infiniteScroll', function () {
	  return {
	    restrict: 'A',
	    transclude: true,
	    template: '<div infinite-scroll-container><ng-transclude></ng-transclude></div>',
	    link: function link(scope, element, attrs) {
	      var offset = parseInt(attrs.threshold) || 0;
	      var containerElement = _angular2.default.element(element.children()[0]);
	
	      var throttledOnScroll = (0, _lodash.throttle)(function () {
	        if (element.scrollTop() + element.prop('offsetHeight') + offset >= containerElement.prop('offsetHeight')) {
	          scope.$apply(attrs.infiniteScroll);
	        }
	      }, 10);
	
	      element.on('scroll', throttledOnScroll);
	      scope.$on('$destroy', function () {
	        element.off('scroll', throttledOnScroll);
	      });
	    }
	  };
	}).name;

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.inject-to-transclusion-scope', []).directive('injectToTransclusionScope', function () {
	  return {
	    restrict: 'A',
	    scope: {
	      injectToTransclusionScope: '<',
	      injectAs: '@?'
	    },
	    link: function link(scope, iElement, iAttrs, $ctrl, transcludeFn) {
	      var variableName = scope.injectAs || 'option';
	      transcludeFn(function (clone, transclusionScope) {
	        scope.$watch('injectToTransclusionScope', function (value) {
	          transclusionScope[variableName] = value;
	        });
	        iElement.empty();
	        iElement.append(clone);
	        iElement.on('$destroy', function () {
	          return transclusionScope.$destroy();
	        });
	      });
	    }
	  };
	}).name;

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	var _sanitizeS3Key = __webpack_require__(524);
	
	var _sanitizeS3Key2 = _interopRequireDefault(_sanitizeS3Key);
	
	var _nodeUuid = __webpack_require__(716);
	
	var _nodeUuid2 = _interopRequireDefault(_nodeUuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('common.directives.inline-uploads', [__webpack_require__(771), __webpack_require__(773)]).directive('ocInlineUploads', function () {
	  return {
	    restrict: 'EA',
	    scope: {
	      fileBuffer: '=?',
	      deleteable: '=',
	      deleteWithIcon: '=',
	      documentType: '@?',
	      documentableId: '=',
	      documentableType: '@',
	      flipId: '=',
	      kind: '@?',
	      picableId: '=',
	      picableType: '@',
	      thumbnailAction: '&?',
	      uploadable: '=',
	      uploads: '='
	    },
	    bindToController: true,
	    template: __webpack_require__(774),
	    controller: InlineUploadsCtrl,
	    controllerAs: 'inlineUploadsCtrl'
	  };
	}).name;
	
	var InlineUploadsCtrl = function () {
	  // @ngInject
	  InlineUploadsCtrl.$inject = ["Document", "Photo", "S3", "Upload", "$uibModal", "$scope"];
	  function InlineUploadsCtrl(Document, Photo, S3, Upload, $uibModal, $scope) {
	    var _this = this;
	
	    _classCallCheck(this, InlineUploadsCtrl);
	
	    this.Document = Document;
	    this.Photo = Photo;
	    this.S3 = S3;
	    this.Upload = Upload;
	    this.$uibModal = $uibModal;
	    this.$scope = $scope;
	
	    this.type = this.picableId || (0, _lodash.get)(this, 'uploads[0].picable_id') || (0, _lodash.get)(this, 'uploads[0].picableId') ? 'photo' : 'document';
	    this.uploadMethod = this.type === 'photo' ? 'processPhoto' : 'processDocument';
	    if (this.type === 'photo') {
	      this.accept = 'image/*';
	    } else if (this.documentableType == 'Invoice') {
	      this.accept = 'application/pdf';
	    } else {
	      this.accept = '*';
	    }
	
	    this.loadingRadius = 15;
	
	    if (this.type == 'document' && !this.thumbnailAction) {
	      if (this.deleteable) {
	        this.actionType = 'docDelete';
	      } else {
	        this.actionType = 'docDownload';
	      }
	    } else {
	      this.actionType = 'default';
	    }
	
	    $scope.$watch('inlineUploadsCtrl.files', function (files) {
	      (0, _lodash.forEach)(files, function (file) {
	        return _this.process(file);
	      });
	    });
	    $scope.$watchCollection('inlineUploadsCtrl.fileBuffer', function (files) {
	      (0, _lodash.forEach)(files, function (file) {
	        return _this.process(file);
	      });
	    });
	  }
	
	  _createClass(InlineUploadsCtrl, [{
	    key: 'isRealPhoto',
	    value: function isRealPhoto(upload) {
	      return (upload.picable_id || upload.picableId) && !upload.non_photo_file;
	    }
	  }, {
	    key: 'isFileStoredInPhoto',
	    value: function isFileStoredInPhoto(upload) {
	      return (upload.picable_id || upload.picableId) && upload.non_photo_file;
	    }
	  }, {
	    key: 'clickUploadAction',
	    value: function clickUploadAction(upload) {
	      if (this.thumbnailAction) {
	        this.thumbnailAction({ upload: upload });
	      } else if (this.deleteable && !this.deleteWithIcon) {
	        this.removeUpload(upload);
	      } else {
	        this.showPhotoModal();
	      }
	    }
	  }, {
	    key: 'showPhotoModal',
	    value: function showPhotoModal() {
	      var newScope = this.$scope.$new({}, this.$scope);
	      newScope.photos = this.uploads;
	
	      this.$uibModal.open({
	        template: __webpack_require__(775)(),
	        controller: ModalCtrl,
	        scope: newScope,
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'removeUpload',
	    value: function removeUpload(upload) {
	      var _this2 = this;
	
	      var uploadClass = this.type === 'photo' ? this.Photo : this.Document;
	      var uploadInstance = new uploadClass(upload);
	
	      uploadInstance.$delete({
	        documentable_type: upload.documentable_type,
	        documentable_id: upload.documentable_id,
	        picable_type: upload.picable_type,
	        picable_id: upload.picable_id
	      }, function () {
	        (0, _lodash.pull)(_this2.uploads, upload);
	      });
	    }
	  }, {
	    key: 'process',
	    value: function process(file) {
	      var _this3 = this;
	
	      if (!file) return null;
	
	      var newObj = this[this.uploadMethod](file);
	      newObj.name = file.name;
	      var key = newObj.key;
	      this.uploads.push(newObj);
	
	      this.Upload.upload({
	        url: this.S3.rootUrl,
	        method: 'POST',
	        file: file,
	        fields: {
	          key: newObj.key,
	          AWSAccessKeyId: this.S3.AWSAccessKeyId,
	          acl: 'public-read',
	          policy: this.S3.publicReadPolicy,
	          signature: this.S3.publicReadSignature,
	          'Content-Type': file.type || 'application/octet-stream'
	        }
	      }).progress(function (progress) {
	        newObj.progress = Math.floor(progress.loaded / progress.total * 100);
	      }).success(function () {
	        newObj.$save().then(function () {
	          var url = _this3.type === 'photo' ? 'photo_url' : 'url';
	          newObj[url] = newObj[url] || _this3.S3.rootUrl + key;
	          delete newObj.key;
	        });
	      });
	    }
	  }, {
	    key: 'processPhoto',
	    value: function processPhoto(file) {
	      var sanitizedFileName = (0, _sanitizeS3Key2.default)(file.name);
	      var key = ['uploads', 'photos', this.picableType, this.picableId, _nodeUuid2.default.v4() + '-' + sanitizedFileName].join('/');
	      return new this.Photo({
	        picable_type: this.picableType,
	        picable_id: this.picableId,
	        process: 0,
	        key: key,
	        kind: this.kind
	      });
	    }
	  }, {
	    key: 'processDocument',
	    value: function processDocument(file) {
	      var sanitizedFileName = (0, _sanitizeS3Key2.default)(file.name);
	      var key = ['uploads', 'documents', this.documentableType, this.documentableId, Date.now() + '-' + sanitizedFileName].join('/');
	
	      return new this.Document({
	        document_type: this.documentType,
	        documentable_type: this.documentableType,
	        documentable_id: this.documentableId,
	        flip_id: this.flipId,
	        process: 0,
	        key: key,
	        kind: this.kind
	      });
	    }
	  }]);
	
	  return InlineUploadsCtrl;
	}();
	
	var ModalCtrl =
	// @ngInject
	["$uibModalInstance", "$scope", function ModalCtrl($uibModalInstance, $scope) {
	  _classCallCheck(this, ModalCtrl);
	
	  $scope.modalClose = function () {
	    return $uibModalInstance.dismiss();
	  };
	}];

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Buffer) {//     uuid.js
	//
	//     Copyright (c) 2010-2012 Robert Kieffer
	//     MIT License - http://opensource.org/licenses/mit-license.php
	
	/*global window, require, define */
	(function(_window) {
	  'use strict';
	
	  // Unique ID creation requires a high quality random # generator.  We feature
	  // detect to determine the best RNG source, normalizing to a function that
	  // returns 128-bits of randomness, since that's what's usually required
	  var _rng, _mathRNG, _nodeRNG, _whatwgRNG, _previousRoot;
	
	  function setupBrowser() {
	    // Allow for MSIE11 msCrypto
	    var _crypto = _window.crypto || _window.msCrypto;
	
	    if (!_rng && _crypto && _crypto.getRandomValues) {
	      // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
	      //
	      // Moderately fast, high quality
	      try {
	        var _rnds8 = new Uint8Array(16);
	        _whatwgRNG = _rng = function whatwgRNG() {
	          _crypto.getRandomValues(_rnds8);
	          return _rnds8;
	        };
	        _rng();
	      } catch(e) {}
	    }
	
	    if (!_rng) {
	      // Math.random()-based (RNG)
	      //
	      // If all else fails, use Math.random().  It's fast, but is of unspecified
	      // quality.
	      var  _rnds = new Array(16);
	      _mathRNG = _rng = function() {
	        for (var i = 0, r; i < 16; i++) {
	          if ((i & 0x03) === 0) { r = Math.random() * 0x100000000; }
	          _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	        }
	
	        return _rnds;
	      };
	      if ('undefined' !== typeof console && console.warn) {
	        console.warn("[SECURITY] node-uuid: crypto not usable, falling back to insecure Math.random()");
	      }
	    }
	  }
	
	  function setupNode() {
	    // Node.js crypto-based RNG - http://nodejs.org/docs/v0.6.2/api/crypto.html
	    //
	    // Moderately fast, high quality
	    if (true) {
	      try {
	        var _rb = __webpack_require__(721).randomBytes;
	        _nodeRNG = _rng = _rb && function() {return _rb(16);};
	        _rng();
	      } catch(e) {}
	    }
	  }
	
	  if (_window) {
	    setupBrowser();
	  } else {
	    setupNode();
	  }
	
	  // Buffer class to use
	  var BufferClass = ('function' === typeof Buffer) ? Buffer : Array;
	
	  // Maps for number <-> hex string conversion
	  var _byteToHex = [];
	  var _hexToByte = {};
	  for (var i = 0; i < 256; i++) {
	    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
	    _hexToByte[_byteToHex[i]] = i;
	  }
	
	  // **`parse()` - Parse a UUID into it's component bytes**
	  function parse(s, buf, offset) {
	    var i = (buf && offset) || 0, ii = 0;
	
	    buf = buf || [];
	    s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
	      if (ii < 16) { // Don't overflow!
	        buf[i + ii++] = _hexToByte[oct];
	      }
	    });
	
	    // Zero out remaining bytes if string was short
	    while (ii < 16) {
	      buf[i + ii++] = 0;
	    }
	
	    return buf;
	  }
	
	  // **`unparse()` - Convert UUID byte array (ala parse()) into a string**
	  function unparse(buf, offset) {
	    var i = offset || 0, bth = _byteToHex;
	    return  bth[buf[i++]] + bth[buf[i++]] +
	            bth[buf[i++]] + bth[buf[i++]] + '-' +
	            bth[buf[i++]] + bth[buf[i++]] + '-' +
	            bth[buf[i++]] + bth[buf[i++]] + '-' +
	            bth[buf[i++]] + bth[buf[i++]] + '-' +
	            bth[buf[i++]] + bth[buf[i++]] +
	            bth[buf[i++]] + bth[buf[i++]] +
	            bth[buf[i++]] + bth[buf[i++]];
	  }
	
	  // **`v1()` - Generate time-based UUID**
	  //
	  // Inspired by https://github.com/LiosK/UUID.js
	  // and http://docs.python.org/library/uuid.html
	
	  // random #'s we need to init node and clockseq
	  var _seedBytes = _rng();
	
	  // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	  var _nodeId = [
	    _seedBytes[0] | 0x01,
	    _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
	  ];
	
	  // Per 4.2.2, randomize (14 bit) clockseq
	  var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;
	
	  // Previous uuid creation time
	  var _lastMSecs = 0, _lastNSecs = 0;
	
	  // See https://github.com/broofa/node-uuid for API details
	  function v1(options, buf, offset) {
	    var i = buf && offset || 0;
	    var b = buf || [];
	
	    options = options || {};
	
	    var clockseq = (options.clockseq != null) ? options.clockseq : _clockseq;
	
	    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	    var msecs = (options.msecs != null) ? options.msecs : new Date().getTime();
	
	    // Per 4.2.1.2, use count of uuid's generated during the current clock
	    // cycle to simulate higher resolution clock
	    var nsecs = (options.nsecs != null) ? options.nsecs : _lastNSecs + 1;
	
	    // Time since last uuid creation (in msecs)
	    var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	    // Per 4.2.1.2, Bump clockseq on clock regression
	    if (dt < 0 && options.clockseq == null) {
	      clockseq = clockseq + 1 & 0x3fff;
	    }
	
	    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	    // time interval
	    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs == null) {
	      nsecs = 0;
	    }
	
	    // Per 4.2.1.2 Throw error if too many uuids are requested
	    if (nsecs >= 10000) {
	      throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	    }
	
	    _lastMSecs = msecs;
	    _lastNSecs = nsecs;
	    _clockseq = clockseq;
	
	    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	    msecs += 12219292800000;
	
	    // `time_low`
	    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	    b[i++] = tl >>> 24 & 0xff;
	    b[i++] = tl >>> 16 & 0xff;
	    b[i++] = tl >>> 8 & 0xff;
	    b[i++] = tl & 0xff;
	
	    // `time_mid`
	    var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	    b[i++] = tmh >>> 8 & 0xff;
	    b[i++] = tmh & 0xff;
	
	    // `time_high_and_version`
	    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	    b[i++] = tmh >>> 16 & 0xff;
	
	    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	    b[i++] = clockseq >>> 8 | 0x80;
	
	    // `clock_seq_low`
	    b[i++] = clockseq & 0xff;
	
	    // `node`
	    var node = options.node || _nodeId;
	    for (var n = 0; n < 6; n++) {
	      b[i + n] = node[n];
	    }
	
	    return buf ? buf : unparse(b);
	  }
	
	  // **`v4()` - Generate random UUID**
	
	  // See https://github.com/broofa/node-uuid for API details
	  function v4(options, buf, offset) {
	    // Deprecated - 'format' argument, as supported in v1.2
	    var i = buf && offset || 0;
	
	    if (typeof(options) === 'string') {
	      buf = (options === 'binary') ? new BufferClass(16) : null;
	      options = null;
	    }
	    options = options || {};
	
	    var rnds = options.random || (options.rng || _rng)();
	
	    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	    rnds[6] = (rnds[6] & 0x0f) | 0x40;
	    rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	    // Copy bytes to buffer, if provided
	    if (buf) {
	      for (var ii = 0; ii < 16; ii++) {
	        buf[i + ii] = rnds[ii];
	      }
	    }
	
	    return buf || unparse(rnds);
	  }
	
	  // Export public API
	  var uuid = v4;
	  uuid.v1 = v1;
	  uuid.v4 = v4;
	  uuid.parse = parse;
	  uuid.unparse = unparse;
	  uuid.BufferClass = BufferClass;
	  uuid._rng = _rng;
	  uuid._mathRNG = _mathRNG;
	  uuid._nodeRNG = _nodeRNG;
	  uuid._whatwgRNG = _whatwgRNG;
	
	  if (('undefined' !== typeof module) && module.exports) {
	    // Publish as node.js module
	    module.exports = uuid;
	  } else if (true) {
	    // Publish as AMD module
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {return uuid;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	
	  } else {
	    // Publish as global (in browsers)
	    _previousRoot = _window.uuid;
	
	    // **`noConflict()` - (browser only) to reset global 'uuid' var**
	    uuid.noConflict = function() {
	      _window.uuid = _previousRoot;
	      return uuid;
	    };
	
	    _window.uuid = uuid;
	  }
	})('undefined' !== typeof window ? window : null);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(717).Buffer))

/***/ },
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<ul class=\"list-inline uploads\"><li ng-repeat=\"upload in inlineUploadsCtrl.uploads | orderBy:[&quot;position&quot;, &quot;id&quot;]\" class=\"upload-container\"><div ng-if=\"upload.key\" round-progress=\"\" current=\"upload.progress\" color=\"green\" bgcolor=\"#eaeaea\" radius=\"{{ inlineUploadsCtrl.loadingRadius }}\" stroke=\"2\" class=\"upload-progress\"></div><a ng-if=\"!upload.key &amp;&amp; inlineUploadsCtrl.actionType == &quot;default&quot;\" ng-click=\"inlineUploadsCtrl.clickUploadAction(upload)\"><img ng-if=\"inlineUploadsCtrl.isRealPhoto(upload)\" ng-src=\"{{ upload.photo_url }}\" style=\"width: 30px; height: 30px;\"><span ng-if=\"upload.documentable_id\" class=\"glyphicon glyphicon-file document-icon\"></span></a><span ng-if=\"inlineUploadsCtrl.isFileStoredInPhoto(upload)\"><a href=\"{{ upload.photo_url }}\" target=\"_blank\" uib-tooltip=\"Download {{ upload.original_filename }}\">{{ upload.original_filename }}</a></span><a ng-if=\"!upload.key &amp;&amp; inlineUploadsCtrl.actionType == &quot;docDownload&quot;\" href=\"{{ upload.url }}\" target=\"_blank\" uib-tooltip=\"Download {{ upload.name }}\"><span class=\"glyphicon glyphicon-file document-icon\"></span></a><a ng-if=\"!upload.key &amp;&amp; inlineUploadsCtrl.deleteable &amp;&amp; inlineUploadsCtrl.deleteWithIcon\" ng-click=\"inlineUploadsCtrl.removeUpload(upload)\" oc-confirm=\"Are you sure you want to delete?\" uib-tooltip=\"Delete {{ upload.name }}\"><span class=\"glyphicon glyphicon-trash trash-icon\"></span></a></li><li ng-if=\"inlineUploadsCtrl.uploadable\"><div ngf-drop ngf-select ng-model=\"inlineUploadsCtrl.files\" ngf-drag-over-class=\"file-drop\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" ngf-accept=\"inlineUploadsCtrl.accept\" class=\"upload-drop-box\"><i class=\"material-icons\">add</i></div></li></ul>");;return buf.join("");
	}

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"modal-header\"><h4>Photos</h4></div><div class=\"modal-body\"><div ng-model=\"photos\" oc-photos=\"true\" not-writable=\"true\" prevent-delete=\"true\"></div></div><div class=\"modal-footer\"><button ng-click=\"modalClose()\" class=\"btn btn-warning\">Close</button></div>");;return buf.join("");
	}

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.inspections', [__webpack_require__(777), __webpack_require__(784)]).name;

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	var _moment = __webpack_require__(519);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _inspectionRepairItemForm = __webpack_require__(778);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('admin.directives.inspection_panel', [__webpack_require__(779), __webpack_require__(780), __webpack_require__(781), __webpack_require__(782)]).directive('ocInspectionPanel', ["InspectionReport", "InspectionRepairItem", "InspectorRoleToDocumentType", "AvailableTimes", function (InspectionReport, InspectionRepairItem, InspectorRoleToDocumentType, AvailableTimes) {
	  return {
	    restrict: 'E',
	    scope: {
	      flip: '=',
	      address: '=',
	      inspection: '=',
	      workOrders: '<',
	      workOrderCostItems: '<',
	      onDelete: '&'
	    },
	    template: __webpack_require__(783)(),
	    bindToController: true,
	    controllerAs: '$ctrl',
	    controller: function () {
	      controller.$inject = ["InspectorRoleToDocumentType"];
	      function controller(InspectorRoleToDocumentType) {
	        _classCallCheck(this, controller);
	
	        this.AVAILABLE_TIMES = AvailableTimes;
	
	        this.InspectorRoleToDocumentType = InspectorRoleToDocumentType;
	        this.resetInspectionRepairItem();
	        this.onDeleteRepairItem = function (report, item) {
	          return (0, _lodash.pull)(report.inspection_repair_items, item);
	        };
	      }
	
	      _createClass(controller, [{
	        key: 'activateInspection',
	        value: function activateInspection() {
	          this.inspection.$activate();
	        }
	      }, {
	        key: 'resetInspectionRepairItem',
	        value: function resetInspectionRepairItem() {
	          this.newInspectionRepairItemForm = new _inspectionRepairItemForm.InspectionRepairItemForm();
	        }
	      }, {
	        key: 'addInspectionTimezone',
	        value: function addInspectionTimezone(time) {
	          return time + ' ' + _moment2.default.tz(this.inspection.timezone).zoneAbbr();
	        }
	      }, {
	        key: 'createRepairItem',
	        value: function createRepairItem(inspectionReport) {
	          var _this = this;
	
	          var newInspectionRepairItem = new InspectionRepairItem({
	            inspection_id: this.inspection.id,
	            inspection_report_id: inspectionReport.id
	          });
	          this.newInspectionRepairItemForm.toInspectionRepairItem(newInspectionRepairItem);
	          newInspectionRepairItem.$save(function () {
	            inspectionReport.inspection_repair_items.push(newInspectionRepairItem);
	            _this.resetInspectionRepairItem();
	          });
	        }
	      }, {
	        key: 'removeInspectionReport',
	        value: function removeInspectionReport(inspectionReport) {
	          var _this2 = this;
	
	          // If the inspection report has not been saved yet just yank it
	          // out of the collection
	          if (!inspectionReport.id) {
	            (0, _lodash.pull)(this.inspection.inspection_reports, inspectionReport);
	            return;
	          }
	
	          var report = new InspectionReport(inspectionReport);
	          report.inspection_id = this.inspection.id;
	
	          report.$delete(function () {
	            (0, _lodash.pull)(_this2.inspection.inspection_reports, inspectionReport);
	          });
	        }
	      }, {
	        key: 'submitInspectionReport',
	        value: function submitInspectionReport(inspectionReport) {
	          var _this3 = this;
	
	          var report = new InspectionReport(inspectionReport);
	          report.inspection_id = this.inspection.id;
	          report.$submit(function () {
	            _this3.inspection.$get();
	          });
	        }
	      }, {
	        key: 'updateInspection',
	        value: function updateInspection() {
	          return this.inspection.$update();
	        }
	      }, {
	        key: 'deleteInspection',
	        value: function deleteInspection() {
	          var _this4 = this;
	
	          this.inspection.$delete().then(function () {
	            return _this4.onDelete();
	          });
	        }
	      }]);
	
	      return controller;
	    }()
	  };
	}]).name;

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InspectionRepairItemForm = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(412);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var InspectionRepairItemForm = exports.InspectionRepairItemForm = function () {
	  function InspectionRepairItemForm(inspectionRepairItem) {
	    var _this = this;
	
	    _classCallCheck(this, InspectionRepairItemForm);
	
	    this.HANDLED_ATTRIBUTES = ['description', 'repair_issue', 'account', 'required'];
	
	    this.handleAccountChange = function (account) {
	      if (_this.account !== account) {
	        _this.repair_issue = null;
	        _this.account = account;
	      }
	    };
	
	    this.handleRepairIssueChange = function (repairIssue) {
	      if (_this.repair_issue !== repairIssue) {
	        _this.repair_issue = repairIssue;
	      }
	    };
	
	    this.HANDLED_ATTRIBUTES.forEach(function (attr) {
	      _this[attr] = inspectionRepairItem ? inspectionRepairItem[attr] : null;
	    });
	  }
	
	  // used for UI user actions
	
	
	  // used for UI user actions
	
	
	  _createClass(InspectionRepairItemForm, [{
	    key: 'toInspectionRepairItem',
	    value: function toInspectionRepairItem(iri) {
	      (0, _lodash.assign)(iri, (0, _lodash.pick)(this, this.HANDLED_ATTRIBUTES));
	    }
	  }]);
	
	  return InspectionRepairItemForm;
	}();

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = _angular2.default.module('admin.models.inspection_report', [__webpack_require__(499)]).factory('InspectionReport', ["odResource", function (odResource) {
	
	  var Resource = odResource('/admin/inspection_reports/:id/:path', {
	    id: '@id'
	  }, {
	    'get': { method: 'GET' },
	    'query': { method: 'GET', isArray: true },
	    'remove': { method: 'DELETE' },
	    'delete': { method: 'DELETE' }
	  });
	
	  var InspectionReport = function (_Resource) {
	    _inherits(InspectionReport, _Resource);
	
	    function InspectionReport(data) {
	      _classCallCheck(this, InspectionReport);
	
	      return _possibleConstructorReturn(this, (InspectionReport.__proto__ || Object.getPrototypeOf(InspectionReport)).call(this, data));
	    }
	
	    _createClass(InspectionReport, [{
	      key: 'isQc',
	      get: function get() {
	        return this.inspection_kind === 'quality_control';
	      }
	    }, {
	      key: 'isQcOrSelfQc',
	      get: function get() {
	        return this.isQc || this.isSelfQc;
	      }
	    }, {
	      key: 'isSelfQc',
	      get: function get() {
	        return this.inspection_kind === 'self_quality_control';
	      }
	    }]);
	
	    return InspectionReport;
	  }(Resource);
	
	  return InspectionReport;
	}]).name;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('admin.models.inspection_repair_item', []).factory('InspectionRepairItem', ["odResource", function (odResource) {
	  return odResource('/admin/inspection_repair_items/:id/:path', {
	    id: '@id'
	  }, {
	    unaccepted: {
	      method: 'GET',
	      isArray: true,
	      params: { path: 'unaccepted' }
	    },
	    save: {
	      method: 'POST',
	      toast: {
	        success: 'Inspection repair item created',
	        error: 'Failed to create inspection repair item'
	      }
	    },
	    deny: {
	      method: 'PATCH',
	      params: { path: 'deny' },
	      toast: {
	        success: 'Inspection repair item denied',
	        error: 'Failed to deny inspection repair item'
	      }
	    }
	  });
	}]).name;

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var minutes = ['00', '15', '30', '45'];
	
	var visitingHours = (0, _lodash.range)(8, 19);
	
	var visitingTimes = visitingHours.map(function (hour) {
	  return minutes.map(function (min) {
	    return (hour % 12 || 12) + ':' + min + ' ' + (hour < 12 ? 'AM' : 'PM');
	  });
	});
	
	var VISITING_TIMES = (0, _lodash.concat)((0, _lodash.flatten)(visitingTimes), '7:00 PM');
	
	var ALL_TIMES = (0, _lodash.flatten)((0, _lodash.map)((0, _lodash.range)(0, 23), function (hour) {
	  return (0, _lodash.map)(['00', '15', '30', '45'], function (min) {
	    return (hour % 12 || 12) + ':' + min + ' ' + (hour < 12 ? 'AM' : 'PM');
	  });
	}));
	
	var AVAILABLE_TIMES = ALL_TIMES;
	
	module.exports = _angular2.default.module('common.services.times', []).constant('AvailableTimes', AVAILABLE_TIMES).constant('AllTimes', ALL_TIMES).constant('VisitingTimes', VISITING_TIMES).name;

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.in', []).filter('in', function () {
	  return function (string, array) {
	    return (0, _lodash.includes)(array, string);
	  };
	}).name;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<uib-tabset><uib-tab heading=\"Summary\"><div class=\"panel-body\"><dl class=\"row\"><div class=\"col-xs-2\"><dt>Date</dt><dd ng-if=\"$ctrl.inspection.isDeletable\"><input ng-model=\"$ctrl.inspection.inspection_date\" required class=\"pikaday form-control\"></dd><dd ng-if=\"!$ctrl.inspection.isDeletable\">{{ $ctrl.inspection.inspection_date | amDateFormat:'ddd, MMM D YYYY' }}</dd></div><div class=\"col-xs-2\"><dt>Start Time</dt><dd ng-if=\"$ctrl.inspection.isDeletable\"><select ng-model=\"$ctrl.inspection.start_time\" ng-options=\"$ctrl.addInspectionTimezone(time) for time in ::$ctrl.AVAILABLE_TIMES track by time\" required class=\"form-control\"></select></dd><dd ng-if=\"!$ctrl.inspection.isDeletable\">{{$ctrl.addInspectionTimezone($ctrl.inspection.start_time)}}</dd></div><div class=\"col-xs-2\"><dt>Finish Time</dt><dd ng-if=\"$ctrl.inspection.isDeletable\"><select ng-model=\"$ctrl.inspection.finish_time\" ng-options=\"$ctrl.addInspectionTimezone(time) for time in ::$ctrl.AVAILABLE_TIMES track by time\" required class=\"form-control\"></select></dd><dd ng-if=\"!$ctrl.inspection.isDeletable\">{{$ctrl.addInspectionTimezone($ctrl.inspection.finish_time)}}</dd></div><div ng-show=\"$ctrl.inspection.draftReports.length\" class=\"col-xs-6\"><dt>Waiting on</dt><dd><span ng-repeat=\"report in $ctrl.inspection.draftReports\" class=\"comma-list\">{{report.human.full_name}}</span></dd></div></dl></div><div ng-repeat=\"report in $ctrl.inspection.inspection_reports | filter:{state: &quot;submitted&quot;}:true | orderBy:&quot;id&quot;\"><table class=\"table table-hover\"><tbody><tr><td colspan=\"3\"><h5 class=\"text-muted no-margin\">{{ report.role | pretty | titlecase }} • {{ report.human.full_name | pretty | titlecase }}</h5></td></tr><tr><td>Documents</td><td colspan=\"2\"><oc-inline-uploads documentable-id=\"report.id\" documentable-type=\"InspectionReport\" flip-id=\"$ctrl.inspection.flip_id\" thumbnail-size=\"30x30\" uploadable=\"report.state !== &quot;submitted&quot;\" uploads=\"report.documents\"></oc-inline-uploads></td></tr><tr ng-if=\"!report.inspection_repair_items.length\"><td colspan=\"3\"><div class=\"text-muted\">Nothing found</div></td></tr><tr ng-repeat=\"repairItem in report.inspection_repair_items | orderBy:&quot;id&quot;\" oc-inspection-repair-item inspection-report=\"report\" inspection-repair-item=\"repairItem\" editable=\"false\" on-delete=\"$ctrl.onDeleteRepairItem\"></tr></tbody></table></div><div ng-show=\"$ctrl.inspection.isDeletable\" class=\"row\"><div class=\"col-sm-12\"><ul class=\"action-bar\"><li ng-if=\"$ctrl.inspection.id &amp;&amp; $ctrl.inspection.state === &quot;draft&quot;\"><button ng-click=\"$ctrl.activateInspection()\" class=\"btn btn-link\"><span class=\"emoji-wrapper\">🏃</span>Activate Inspection</button></li><li><button ng-click=\"$ctrl.updateInspection()\" class=\"btn btn-link\"><span class=\"emoji-wrapper\">✅</span>Save Inspection</button></li><li><button ng-click=\"$ctrl.deleteInspection()\" class=\"btn btn-link\"><span class=\"emoji-wrapper\">❌</span>Cancel Inspection</button></li></ul></div></div></uib-tab><uib-tab ng-repeat=\"report in $ctrl.inspection.inspection_reports | orderBy:&quot;id&quot;\"><uib-tab-heading>{{report.role | titlecase}}</uib-tab-heading><div class=\"panel-body\"><dl class=\"row\"><div class=\"col-xs-4\"><dt>Inspector</dt><dd>{{report.human.full_name}}</dd></div><div class=\"col-xs-4\"><dt>Scheduled Date</dt><dd>{{ $ctrl.inspection.inspection_date | amTimezone:$ctrl.inspection.address.timezone | amDateFormat:'ddd, MMM D YYYY' }}</dd></div><div ng-show=\"report.state === &quot;submitted&quot;\" class=\"col-xs-4\"><dt>Submitted Date</dt><dd>{{ report.submitted_at | amTimezone:$ctrl.inspection.address.timezone | amDateFormat:'ddd, MMM D YYYY [at] h:mm A z' }}</dd></div></dl><div ng-if=\"report.role === &quot;valuator&quot;\" class=\"row\"><div class=\"col-xs-4\">Valuation</div><div class=\"col-xs-4\">{{report.valuation_state | state}}</div><div class=\"col-xs-4\"><a ng-show=\"report.valuation_id\" ng-href=\"/valuations/{{report.valuation_id}}\" target=\"_self\">Visit Valuation</a></div></div><div ng-if=\"report.sherlock_external_id\" class=\"row\"><div class=\"col-xs-4\">Assessment</div><div class=\"col-xs-4\">{{report.state | state}}</div><div class=\"col-xs-4\"><div ng-if=\"report.state !== &quot;submitted&quot;\" class=\"text-muted\">Not ready for display</div><a href ng-if=\"report.state === &quot;submitted&quot;\" ng-click=\"report._expandAssessment = !report._expandAssessment\">Show report</a></div></div><div ng-if=\"report.sherlock_external_id &amp;&amp; report._expandAssessment\" class=\"row\"><assessment-container address-token=\"$ctrl.inspection.address.address_token\" class=\"small-margin-top\"></assessment-container></div></div><div class=\"row\"><div class=\"col-sm-12\"><div ng-if=\"!report.sherlock_external_id\" class=\"text-muted\">Documents and Repair Items</div><div ng-if=\"report.sherlock_external_id\" class=\"text-muted\">Repair Items</div></div></div><table ng-if=\"report.role !== &quot;valuator&quot;\" class=\"table table-hover\"><tbody><tr ng-if=\"!report.sherlock_external_id\"><td>Documents</td><td><oc-inline-uploads deleteable=\"report._editing_documents\" delete_with_icon=\"true\" document-type=\"{{$ctrl.InspectorRoleToDocumentType.getDocumentTypeForInspectionReport(report)}}\" documentable-id=\"report.id\" documentable-type=\"InspectionReport\" flip-id=\"$ctrl.inspection.flip_id\" thumbnail-size=\"30x30\" uploadable=\"report.state !== &quot;submitted&quot;\" uploads=\"report.documents\"></oc-inline-uploads></td><td><div ng-show=\"report.state !== &quot;submitted&quot;\"><div ng-hide=\"report._editing_documents\"><button ng-click=\"report._editing_documents = true\" class=\"btn btn-xs btn-default\"><span class=\"glyphicon glyphicon-pencil\"></span></button></div><div ng-show=\"report._editing_documents\"><button ng-click=\"report._editing_documents = false\" class=\"btn btn-xs btn-default\"><span class=\"glyphicon glyphicon-check\"></span></button></div></div></td></tr><tr ng-repeat=\"repairItem in report.inspection_repair_items | orderBy:&quot;id&quot;\" oc-inspection-repair-item inspection-report=\"report\" inspection-repair-item=\"repairItem\" editable=\"report.state !== &quot;submitted&quot; &amp;&amp; !report.sherlock_external_id\" on-delete=\"$ctrl.onDeleteRepairItem\"></tr></tbody></table><div ng-if=\"report.role !== &quot;valuator&quot; &amp;&amp; report.state !== &quot;submitted&quot; &amp;&amp; !report.sherlock_external_id\" class=\"panel-footer\"><form name=\"addNewRepairItemForm\" class=\"form\"><div class=\"row\"><div class=\"col-sm-3\"><od-account-chooser account=\"$ctrl.newInspectionRepairItemForm.account\" accounting-bucket=\"&quot;repairs&quot;\" hide-account=\"true\" on-account-change=\"$ctrl.newInspectionRepairItemForm.handleAccountChange(account)\" required></od-account-chooser></div><div class=\"col-sm-3\"><od-repair-issue-chooser account=\"$ctrl.newInspectionRepairItemForm.account\" repair-issue=\"$ctrl.newInspectionRepairItemForm.repair_issue\" on-change=\"$ctrl.newInspectionRepairItemForm.handleRepairIssueChange(repairIssue)\" required></od-repair-issue-chooser></div><div class=\"col-sm-4\"><div class=\"form-group\"><input ng-model=\"$ctrl.newInspectionRepairItemForm.description\" placeholder=\"Write a description (ex. the kitchen drain is leaking)\" required class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><button ng-click=\"$ctrl.createRepairItem(report)\" ng-disabled=\"addNewRepairItemForm.$invalid\" class=\"btn btn-primary\">Add Item</button></div></div></div></form><div ng-show=\"report.state !== &quot;submitted&quot;\" class=\"row\"><div class=\"col-sm-12\"><ul class=\"action-bar\"><li><button ng-click=\"$ctrl.submitInspectionReport(report)\" class=\"btn btn-link\"><span class=\"emoji-wrapper\">📬</span>Submit Inspection</button></li><li><button ng-click=\"$ctrl.removeInspectionReport(report)\" class=\"btn btn-link\"><span class=\"emoji-wrapper\">❌</span>Remove Inspector</button></li></ul></div></div></div></uib-tab><uib-tab ng-show=\"$ctrl.inspection.isQcOrSelfQc &amp;&amp; $ctrl.inspection.inspection_reports.length\" ng-init=\"report = $ctrl.inspection.inspectorReport\"><div ng-show=\"report.state !== &quot;submitted&quot;\" class=\"row\"><div class=\"col-sm-12\"><ul class=\"action-bar\"><li><button ng-click=\"$ctrl.submitInspectionReport(report)\" class=\"btn btn-link\"><span class=\"emoji-wrapper\">📬</span>Submit Inspection</button></li><li><button ng-click=\"$ctrl.removeInspectionReport(report)\" class=\"btn btn-link\"><span class=\"emoji-wrapper\">❌</span>Remove Inspector</button></li></ul></div></div></uib-tab></uib-tabset>");;return buf.join("");
	}

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	var _inspectionRepairItemForm = __webpack_require__(778);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('admin.directives.inspection_repair_item', []).directive('ocInspectionRepairItem', function () {
	  return {
	    restrict: 'EA',
	    scope: {
	      inspectionRepairItem: '=',
	      onDelete: '=',
	      editable: '='
	    },
	    template: __webpack_require__(785),
	    bindToController: true,
	    controller: 'inspectionRepairItemCtrl',
	    controllerAs: 'inspectionRepairItemCtrl'
	  };
	}).controller('inspectionRepairItemCtrl', function () {
	  _class.$inject = ["InspectionRepairItem"];
	  function _class(InspectionRepairItem) {
	    _classCallCheck(this, _class);
	
	    this.InspectionRepairItem = InspectionRepairItem;
	    this.inspectionRepairItem._editing = !this.inspectionRepairItem.id;
	  }
	
	  _createClass(_class, [{
	    key: '$onChanges',
	    value: function $onChanges() {
	      this.initForm();
	    }
	  }, {
	    key: 'initForm',
	    value: function initForm() {
	      // NOTE(edward): it's only safe to modify top level primitives on the form
	      // if we could revert then we wouldn't have to worry about this. could also maybe use merge
	      // assign(this.form, this.inspectionRepairItem);
	      // this.editing = false;
	
	      // NOTE(edward): not copying everything because photos are out of scope
	      this.form = new _inspectionRepairItemForm.InspectionRepairItemForm(this.inspectionRepairItem);
	    }
	  }, {
	    key: 'createOrUpdate',
	    value: function createOrUpdate() {
	      var _this = this;
	
	      var iri = new this.InspectionRepairItem(this.inspectionRepairItem);
	      this.form.toInspectionRepairItem(iri);
	      var action = iri.id ? '$update' : '$save';
	      iri[action]().then(function () {
	        delete _this.inspectionRepairItem._editing;
	        (0, _lodash.assign)(_this.inspectionRepairItem, iri);
	        _this.initForm();
	      }, function () {
	        return _this.inspectionRepairItem._editing = true;
	      });
	    }
	  }, {
	    key: 'deleteItem',
	    value: function deleteItem() {
	      var _this2 = this;
	
	      var iri = new this.InspectionRepairItem(this.inspectionRepairItem);
	      iri.$delete(function () {
	        return _this2.onDelete(_this2.inspectionRepairItem);
	      });
	    }
	  }, {
	    key: 'doneEditing',
	    value: function doneEditing() {
	      this.initForm();
	      delete this.inspectionRepairItem._editing;
	    }
	  }]);
	
	  return _class;
	}()).name;

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<td class=\"col-sm-3\"><od-account-chooser account=\"inspectionRepairItemCtrl.form.account\" accounting-bucket=\"&quot;repairs&quot;\" disabled=\"!inspectionRepairItemCtrl.inspectionRepairItem._editing\" hide-account=\"true\" placeholder=\"Choose Location / System\" on-account-change=\"inspectionRepairItemCtrl.form.handleAccountChange(account)\" required></od-account-chooser><od-repair-issue-chooser account=\"inspectionRepairItemCtrl.form.account\" repair-issue=\"inspectionRepairItemCtrl.form.repair_issue\" on-change=\"inspectionRepairItemCtrl.form.handleRepairIssueChange(repairIssue)\" required disabled=\"!inspectionRepairItemCtrl.inspectionRepairItem._editing\"></od-repair-issue-chooser></td><td class=\"col-sm-4\"><span ng-hide=\"inspectionRepairItemCtrl.inspectionRepairItem._editing\">{{ inspectionRepairItemCtrl.form.description }}</span><div ng-show=\"inspectionRepairItemCtrl.inspectionRepairItem._editing\" class=\"form-group\"><input ng-model=\"inspectionRepairItemCtrl.form.description\" class=\"form-control\"></div></td><td class=\"col-sm-3\"><oc-inline-uploads ng-if=\"inspectionRepairItemCtrl.inspectionRepairItem.id\" deleteable=\"inspectionRepairItemCtrl.inspectionRepairItem._editing\" picable-id=\"inspectionRepairItemCtrl.inspectionRepairItem.id\" picable-type=\"InspectionRepairItem\" thumbnail-size=\"30x30\" uploadable=\"inspectionRepairItemCtrl.editable\" uploads=\"inspectionRepairItemCtrl.inspectionRepairItem.photos\"></oc-inline-uploads></td><td class=\"col-sm-2\"><div ng-if=\"inspectionRepairItemCtrl.editable\"><div ng-if=\"!inspectionRepairItemCtrl.inspectionRepairItem._editing\"><button ng-click=\"inspectionRepairItemCtrl.inspectionRepairItem._editing = true\" class=\"btn btn-xs btn-default\"><span class=\"glyphicon glyphicon-pencil\"></span></button>&nbsp;<button ng-click=\"inspectionRepairItemCtrl.deleteItem()\" class=\"btn btn-xs btn-default\"><span class=\"glyphicon glyphicon-trash\"></span></button></div><div ng-if=\"inspectionRepairItemCtrl.inspectionRepairItem._editing\"><button ng-click=\"inspectionRepairItemCtrl.createOrUpdate()\" class=\"btn btn-xs btn-default\"><span class=\"glyphicon glyphicon-check\"></span></button><button ng-click=\"inspectionRepairItemCtrl.doneEditing()\" class=\"btn btn-xs btn-default\"><span class=\"glyphicon glyphicon-remove\"></span></button></div></div></td>");;return buf.join("");
	}

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.isolate-form', []).directive('isolateForm', function () {
	  return {
	    restrict: 'A',
	    require: '?form',
	    link: function link(scope, element, attrs, formController) {
	      if (!formController) {
	        return;
	      }
	      var parentForm = formController.$$parentForm; // Note this uses private API
	      if (!parentForm) {
	        return;
	      }
	
	      // Remove this form from parent controller
	      parentForm.$removeControl(formController);
	    }
	  };
	}).name; // from http://stackoverflow.com/a/37481846

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.login-link', []).directive('ocLoginLink', ["$window", "$rootScope", function ocLoginLink($window, $rootScope) {
	  return {
	    restrict: 'EC',
	    template: __webpack_require__(788)(),
	    link: function link(scope) {
	      scope.session = $rootScope.session;
	
	      scope.login = function () {
	        $window.location.href = '/login';
	      };
	
	      scope.logout = function () {
	        scope.session.$logout().then(function () {
	          window.location.href = '/';
	        });
	      };
	    }
	  };
	}]).name;

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<a ng-hide=\"session.human\" ng-click=\"login()\" href=\"\">Sign in</a><a ng-show=\"session.human\" ng-click=\"logout()\" href=\"\" title=\"{{session.human.full_name}} · {{session.human.email}}\">Sign out</a>");;return buf.join("");
	}

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.min-max', []).directive('odMin', function () {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function link(scope, element, attrs, ngModel) {
	      var min = attrs.odMin;
	
	      ngModel.$parsers.push(function (value) {
	        if (!value) return null;
	
	        var floatValue = parseFloat(value, 10);
	        ngModel.$setValidity('min', floatValue >= min);
	
	        return value;
	      });
	    }
	  };
	}).directive('odMax', function () {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function link(scope, element, attrs, ngModel) {
	      var max = attrs.odMax;
	
	      ngModel.$parsers.push(function (value) {
	        if (!value) return null;
	
	        var floatValue = parseFloat(value, 10);
	        ngModel.$setValidity('max', floatValue <= max);
	
	        return value;
	      });
	    }
	  };
	}).name;

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.number-range', []).directive('type', function typeNumberRange() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function link(scope, element, attrs, ngModel) {
	      if (attrs.type !== 'numberRange' || !ngModel) return;
	
	      var min = attrs.min;
	      var max = attrs.max;
	
	      ngModel.$parsers.push(function (value) {
	        if (!value) return null;
	
	        var floatValue = parseFloat(value);
	        if (floatValue > max) value = max;
	        if (floatValue < min) value = min;
	
	        element.val(value);
	        ngModel.$setViewValue(value);
	        ngModel.$commitViewValue(value);
	
	        return value;
	      });
	    }
	  };
	}).name;

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global L:false */
	module.exports = _angular2.default.module('common.directives.od-comps-map', [__webpack_require__(706), __webpack_require__(792), __webpack_require__(654)]).directive('odCompsMap', ["currencyFilter", "letterizeFilter", "MapboxConfig", "$animate", "$mediaQuery", function (currencyFilter, letterizeFilter, MapboxConfig, $animate, $mediaQuery) {
	  // eslint-disable-line max-len
	  return {
	    restrict: 'EA',
	    scope: {
	      ngModel: '=',
	      hoveredCompIndex: '=?',
	      subjectAddress: '=',
	      subdivision: '='
	    },
	    link: function link(scope, element, attrs) {
	      var map = null,
	          subjectPosition = null,
	          markers = {},
	          container = element.append('<div>').find('div').css({ 'height': '100%' });
	
	      scope.$watchGroup([attrs.ngModel, attrs.subjectAddress], function () {
	        rebuildMap();
	      });
	
	      function rebuildMap() {
	        var comps = scope.ngModel,
	            subjectAddress = scope.subjectAddress,
	            subdivision = scope.subdivision;
	        if (!comps || !subjectAddress) return;
	
	        // Clear out any remnants
	        container[0].innerHTML = '';
	
	        subjectPosition = [parseFloat(subjectAddress.latitude), parseFloat(subjectAddress.longitude)]; // eslint-disable-line max-len
	        L.mapbox.accessToken = MapboxConfig.accessToken;
	        L.mapbox.config.FORCE_HTTPS = true;
	        map = L.mapbox.map(element.children()[0], MapboxConfig.defaultMap, {
	          attributionControl: { compact: true },
	          boxZoom: false,
	          center: subjectPosition,
	          doubleClickZoom: true,
	          dragging: false,
	          keyboard: false,
	          scrollWheelZoom: false,
	          tap: false,
	          touchZoom: true,
	          zoom: 14,
	          zoomControl: false
	        });
	
	        if ($mediaQuery('gt-xs')) {
	          map.dragging.enable();
	          if (map.tap) {
	            // doesn't exist on non-touch devices
	            map.tap.enable();
	          }
	          new L.Control.Zoom().addTo(map);
	        }
	
	        var subdivisionLayer = L.mapbox.featureLayer().addTo(map);
	        subdivisionLayer.setGeoJSON({
	          type: 'FeatureCollection',
	          features: [{
	            type: 'Feature',
	            properties: {
	              'stroke': 'black',
	              'stroke-opacity': 0.5,
	              'fill': 'black',
	              'fill-opacity': 0.1
	            },
	            geometry: subdivision
	          }]
	        });
	
	        var pinLayer = makeCompLayer().addTo(map),
	            compGeoJson = [];
	
	        var subjectMarkerContents = '<span class=\'ellipsis\'>' + subjectAddress.street + '</span>';
	        var subjectGeoJson = makeMarker(subjectPosition, subjectMarkerContents);
	        compGeoJson.push(subjectGeoJson);
	
	        (0, _lodash.forEach)((0, _lodash.compact)(comps), function (comp, compIndex) {
	          var lat = (0, _lodash.get)(comp, ['address', 'latitude']) || (0, _lodash.get)(comp, ['address_info', 'address', 'latitude']) || (0, _lodash.get)(comp, ['listing', 'coordinates', 'lat']);
	          var lng = (0, _lodash.get)(comp, ['address', 'longitude']) || (0, _lodash.get)(comp, ['address_info', 'address', 'longitude']) || (0, _lodash.get)(comp, ['listing', 'coordinates', 'lng']);
	          var priceCents = (0, _lodash.get)(comp, ['listing_data', 'price_cents']) || (0, _lodash.get)(comp, ['listing', 'price_cents']);
	
	          if (!lat || !lng) return;
	
	          // Don't show comp markers if in the same area as subject location (e.g. for condo comps)
	          if ((0, _lodash.round)(lat, 3) === (0, _lodash.round)(subjectAddress.latitude, 3) && (0, _lodash.round)(lng, 3) === (0, _lodash.round)(subjectAddress.longitude, 3)) return;
	
	          var marker = makeMarker([lat, lng], '' + currencyFilter(priceCents, -3), // i.e. $400K
	          comp, compIndex);
	          compGeoJson.push(marker);
	        });
	
	        pinLayer.setGeoJSON({
	          type: 'FeatureCollection',
	          features: compGeoJson
	        });
	        map.fitBounds(pinLayer.getBounds(), {
	          animate: false,
	          paddingBottomRight: [50, 30],
	          paddingTopLeft: [50, 50]
	        });
	      }
	
	      function makeCompLayer() {
	        var pinLayer = L.mapbox.featureLayer();
	        pinLayer.on('layeradd', function (e) {
	          var marker = e.layer,
	              feature = marker.feature,
	              comp = feature.properties.comp,
	              compIndex = feature.properties.compIndex;
	
	          marker.hoverOn = function () {
	            var iconOpts = (0, _lodash.merge)({}, feature.properties.icon, {
	              className: feature.properties.icon.className + ' hover'
	            });
	            marker.setIcon(L.divIcon(iconOpts));
	            marker.setZIndexOffset(2000);
	            if (marker.div) $animate.addClass(marker.div, 'hover');
	          };
	
	          marker.hoverOff = function () {
	            marker.setIcon(L.divIcon(feature.properties.icon));
	            marker.setZIndexOffset(null); // null is required here, not undefined
	            if (marker.div) $animate.removeClass(marker.div, 'hover');
	          };
	
	          marker.onmouseenter = function () {
	            scope.$apply(function () {
	              if (compIndex) scope.hoveredCompIndex = compIndex;
	            });
	          };
	
	          marker.onmouseleave = function () {
	            scope.$apply(function () {
	              scope.hoveredCompIndex = null;
	            });
	          };
	
	          if (!marker.div && comp) {
	            markers[compIndex] = marker;
	          }
	
	          if (feature.properties.isSubject) marker.setZIndexOffset(1000); // put subject on top of all other markers
	
	          marker.setIcon(L.divIcon(feature.properties.icon));
	        });
	
	        pinLayer.on('mouseover', function (e) {
	          var marker = e.layer;
	          marker.hoverOn();
	          marker.onmouseenter();
	        });
	        pinLayer.on('mouseout', function (e) {
	          var marker = e.layer;
	          marker.hoverOff();
	          marker.onmouseleave();
	        });
	
	        return pinLayer;
	      }
	
	      function makeMarker(latlon, text, comp, compIndex) {
	        var className = 'price-icon';
	        className += comp ? ' comp' : ' subject';
	
	        var html = text;
	        var compLabel = letterizeFilter(compIndex);
	        if (compLabel) {
	          html = '<span class=\'comp-label\'>' + compLabel + '</span>' + html;
	        }
	
	        return {
	          'type': 'Feature',
	          'geometry': {
	            'type': 'Point',
	            'coordinates': [latlon[1], latlon[0]]
	          },
	          'properties': {
	            'icon': {
	              'className': className,
	              'html': html,
	              'iconSize': null
	            },
	            'comp': comp,
	            'compIndex': compIndex,
	            'isSubject': !comp
	          }
	        };
	      }
	
	      scope.$watch('hoveredCompIndex', function (newCompIndex, previous) {
	        if (markers[previous]) markers[previous].hoverOff();
	
	        if (markers[newCompIndex]) markers[newCompIndex].hoverOn();
	      });
	    }
	  };
	}]).name;

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Convert a number to a letter, for enumerating with letters.
	// 0 -> 'A'
	// 1 -> 'B'
	// ...
	module.exports = _angular2.default.module('common.filters.letterize', []).filter('letterize', function () {
	  return function (number) {
	    if (number < 0 || number >= 26) {
	      return '-';
	    }
	    return String.fromCharCode(97 + number);
	  };
	}).name;

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	var _odLazyElement = __webpack_require__(794);
	
	var _odLazyElement2 = _interopRequireDefault(_odLazyElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// TODO(azirbel): This badly needs tests. I'm not even sure it's working
	// anymore.
	
	// od-lazy-element
	//
	// An element that sets `lazyLoad=true` on its own scope once you scroll near
	// it. "Near it" means within 100vh of it.
	module.exports = _angular2.default.module('common.directives.od-lazy-element', []).directive('odLazyElement', ["$window", "$document", "$timeout", function ($window, $document, $timeout) {
	  var OdLazyElement = function () {
	    OdLazyElement.$inject = ["$element", "$scope"];
	    function OdLazyElement($element, $scope) {
	      var _this = this;
	
	      _classCallCheck(this, OdLazyElement);
	
	      this.$element = $element;
	      this.$scope = $scope;
	
	      var windowEl = _angular2.default.element($window);
	      var throttledOnScroll = (0, _lodash.throttle)(function () {
	        _this.onScroll();
	      }, 10);
	      var debouncedRebuild = (0, _lodash.debounce)(function () {
	        _this.rebuild();
	      }, 300, { leading: true });
	
	      // Extra rebuilds during scroll so we can still recover if other things
	      // on the page change during scroll. Sneaky elements could appear, ng-if
	      // could pull things in and out of the DOM, etc.
	      windowEl.on('scroll', throttledOnScroll);
	      windowEl.on('scroll', debouncedRebuild);
	      windowEl.on('resize', debouncedRebuild);
	      $scope.$on('$destroy', function () {
	        windowEl.off('scroll', throttledOnScroll);
	        windowEl.off('scroll', debouncedRebuild);
	        windowEl.off('resize', debouncedRebuild);
	      });
	
	      // Make sure the internal state is at least initialized
	      this.rebuild();
	
	      // Update the internal state correctly, once the DOM is actually ready
	      $timeout(function () {
	        _this.rebuild();
	        _this.onScroll();
	      });
	    }
	
	    _createClass(OdLazyElement, [{
	      key: 'rebuild',
	      value: function rebuild() {
	        // Only need to lazy-load once.
	        if (this.$scope.lazyLoad) {
	          return;
	        }
	
	        this.distanceFromTopOfPage = this.$element[0].getBoundingClientRect().top + $window.scrollY;
	        this.viewportHeight = $window.innerHeight;
	      }
	    }, {
	      key: 'onScroll',
	      value: function onScroll() {
	        // Only need to lazy-load once.
	        if (this.$scope.lazyLoad) {
	          return;
	        }
	
	        if ($window.scrollY + this.viewportHeight * 2 >= this.distanceFromTopOfPage) {
	          this.$scope.lazyLoad = true;
	
	          // HACK
	          this.$scope.$digest();
	        }
	      }
	    }]);
	
	    return OdLazyElement;
	  }();
	
	  return {
	    restrict: 'EA',
	    controller: OdLazyElement,
	    bindToController: true,
	    controllerAs: 'lazyElementCtrl',
	    scope: true
	  };
	}]).name;

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(795);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-lazy-element.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-lazy-element.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "od-lazy-element,[od-lazy-element]{display:block}", ""]);
	
	// exports


/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _odPhotoTooltip = __webpack_require__(797);
	
	var _odPhotoTooltip2 = _interopRequireDefault(_odPhotoTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.od-photo-tooltip', []).directive('odPhotoTooltip', function () {
	  return {
	    restrict: 'EA',
	    scope: {
	      photo: '@'
	    },
	    templateUrl: '/templates/common/directives/od-photo-tooltip.html'
	  };
	}).name;

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(798);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-photo-tooltip.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-photo-tooltip.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "od-photo-tooltip .thumbnail,[od-photo-tooltip] .thumbnail{max-height:40px;max-width:60px}od-photo-tooltip od-tooltip-hover img,[od-photo-tooltip] od-tooltip-hover img{display:block;max-width:224px;max-height:224px}", ""]);
	
	// exports


/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DISPLAY_MODES = ['logos-only', 'expanded'];
	
	module.exports = _angular2.default.module('common.directives.od-press', []).directive('odPress', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      mode: '@?'
	    },
	    templateUrl: '/templates/common/directives/od-press.html',
	    bindToController: true,
	    controllerAs: 'odPressCtrl',
	    controller: function controller() {
	      _classCallCheck(this, controller);
	
	      if (!(0, _lodash.includes)(DISPLAY_MODES, this.mode)) {
	        this.mode = 'expanded';
	      }
	    }
	  };
	}).name;

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// od-scroll-stay is an attribute that goes on a scroll container which
	// contains an `ngRepeat`. Its value should be set to the same collection which
	// the `ngRepeat` expression watches. When the collection changes, this
	// directive adjusts the `scrollTop` of the container so that the addition or
	// removal of the `ngRepeat`ed elements appears to not scroll.
	//
	// <ul
	//   od-scroll-stay="items"
	//   style="overflow: scroll; height: 100px;"
	//   ng-init="items = [0, 1, 2, 3]">
	//   <li ng-repeat="item in items" style="height: 50px;">{{item}}</li>
	// </ul>
	// <button ng-click="items.unshift(items.length)">Prepend an item</button>
	// The list doesn't move as elements are added to the top.
	module.exports = _angular2.default.module('common.directives.od-scroll-stay', []).directive('odScrollStay', function () {
	  return {
	    restrict: 'A',
	    controller: function () {
	      controller.$inject = ["$element", "$attrs"];
	      function controller($element, $attrs) {
	        _classCallCheck(this, controller);
	
	        this.$element = $element;
	        this.collection = $attrs.odScrollStay;
	      }
	
	      _createClass(controller, [{
	        key: 'offset',
	        value: function offset(height) {
	          this.$element.prop('scrollTop', this.$element.prop('scrollTop') + height);
	        }
	      }]);
	
	      return controller;
	    }()
	  };
	}).directive('ngRepeat', function () {
	  return {
	    restrict: 'A',
	    require: '?^^odScrollStay',
	    link: function link(scope, elem, attrs, odScrollStay) {
	      if (!odScrollStay) return;
	
	      // based on https://github.com/angular/angular.js/blob/v1.4.8/src/ng/directive/ngRepeat.js#L349 // eslint-disable-line max-len
	      var collection = attrs.ngRepeat.match(/in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/)[1]; // eslint-disable-line max-len
	      if (collection === odScrollStay.collection) {
	        scope.$evalAsync(function () {
	          odScrollStay.offset(+elem.prop('offsetHeight'));
	        });
	        scope.$on('$destroy', function () {
	          odScrollStay.offset(-elem.prop('offsetHeight'));
	        });
	      }
	    }
	  };
	}).name;

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	var _odSneakyElement = __webpack_require__(802);
	
	var _odSneakyElement2 = _interopRequireDefault(_odSneakyElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var VALID_MODES = ['height', 'fade-in', 'fade-out'];
	
	// od-sneaky-element
	//
	// An element that is hidden until you scroll past a certain point on the page.
	//
	// That point on the page is configurable and can be relative to some other
	// element (specified by an id), or to the page itself.
	//
	// Once you scroll past this point, the sneaky element will slowly come into
	// view. We set the `height` property of <sneaky-element> progressively, and
	// use `overflow:hidden`, so that it "animates" into view as you scroll rather
	// than appearing all at once.
	//
	// More information, and a live demo, is available on the style guide.
	// http://opendoor.com/style
	//
	// Usage:
	//   <sneaky-element> ... </sneaky-element>
	//
	// Parameters:
	//   relative-element-id: Set to the id (not class) of another element on the
	//     page to set the scroll breakpoint relative to the bottom of that
	//     element. Lets you show the <sneaky-element> once another element on the
	//     page has scrolled out of view.
	//   scroll-parent-id: Set to the id (not class) of the element's scroll parent
	//     (the outer element within which the scrollbar appears). If left blank,
	//     defaults to window; otherwise the top-buffer and relative-element offset
	//     will be measured relative to the scroll-parent's current vertical scroll.
	//   top-buffer: Adjust the scroll breakpoint up or down. For example, set to
	//     40 if you want the sneaky element to come into view when the user has
	//     scrolled 40px PAST the relative element or top of page. Set to -40 if
	//     you want the sneaky element to come into view when the use has scrolled
	//     to 40px above the relative element or top of page.
	//   mode: "height"|"fade-in"|"fade-out": what to do when the scroll breakpoint
	//     is reached. Use "height" to animate the height from 0 to full height,
	//     "fade-in" to fade in using opacity, or "fade-out" to fade out using
	//     opacity.
	//   stay-open: If set to `true`, then the height of the sneaky element will
	//     only increase (so it won't collapse again when the user scrolls back
	//     up). Only supports "height" mode.
	module.exports = _angular2.default.module('common.directives.od-sneaky-element', []).directive('odSneakyElement', ["$window", "$document", function ($window, $document) {
	  var OdSneakyElement = function () {
	    OdSneakyElement.$inject = ["$element", "$scope"];
	    function OdSneakyElement($element, $scope) {
	      var _this = this;
	
	      _classCallCheck(this, OdSneakyElement);
	
	      // Component parameters
	      // ----------------------------------------------------------------------
	      this.topBuffer = 0;
	      this.stayOpen = false;
	      this.relativeElementId = null;
	      if (!(0, _lodash.includes)(VALID_MODES, this.mode)) {
	        this.mode = 'height';
	      }
	
	      // Setup
	      // ----------------------------------------------------------------------
	      this.$element = $element;
	      this.currentHeight = null;
	
	      var scrollParent = void 0;
	      if (this.scrollParentId) {
	        var scrollParentEl = $document[0].getElementById(this.scrollParentId);
	        scrollParent = _angular2.default.element(scrollParentEl);
	      } else {
	        scrollParent = _angular2.default.element($window);
	      }
	      var throttledOnScroll = (0, _lodash.throttle)(function () {
	        _this.updateSneakyElement();
	      }, 10);
	      var debouncedRebuild = (0, _lodash.debounce)(function () {
	        _this.rebuild();
	        _this.updateSneakyElement();
	      }, 300, { leading: true });
	
	      scrollParent.on('scroll', throttledOnScroll);
	      scrollParent.on('scroll', debouncedRebuild);
	      scrollParent.on('resize', debouncedRebuild);
	      $scope.$on('$destroy', function () {
	        scrollParent.off('scroll', throttledOnScroll);
	        scrollParent.off('scroll', debouncedRebuild);
	        scrollParent.off('resize', debouncedRebuild);
	      });
	      this.scrollParent = scrollParent;
	
	      // Will be updated by rebuild
	      this.scrollBreakpoint = null;
	      this.innerHeight = null;
	      this.rebuild();
	
	      this.updateSneakyElement();
	    }
	
	    // We don't want to recompute the sneakyElement inner height, or the
	    // position of the relative element, very often (because those operations
	    // are expensive). So we do it in a rebuild function and debounce it.
	
	
	    _createClass(OdSneakyElement, [{
	      key: 'rebuild',
	      value: function rebuild() {
	        this.scrollBreakpoint = this.getScrollBreakpoint();
	        this.innerHeight = this.getInnerHeight();
	      }
	    }, {
	      key: 'getCurrentScroll',
	      value: function getCurrentScroll() {
	        return this.scrollParentId ? this.scrollParent.scrollTop() : $window.scrollY;
	      }
	    }, {
	      key: 'getElementHeight',
	      value: function getElementHeight(el) {
	        return parseInt($window.getComputedStyle(el).height);
	      }
	    }, {
	      key: 'getInnerHeight',
	      value: function getInnerHeight() {
	        // We can rely on having one child because the directive uses
	        // transclusion to wrap its contents with a .sneaky-element-inner div.
	        return this.getElementHeight(this.$element.children()[0]);
	      }
	
	      // Determine the offset from the top of the page at which the sneaky
	      // element should start to come into view.
	
	    }, {
	      key: 'getScrollBreakpoint',
	      value: function getScrollBreakpoint() {
	        var breakpoint = Number(this.topBuffer);
	        if (this.relativeElementId) {
	          var relativeElement = $document[0].getElementById(this.relativeElementId);
	          if (relativeElement) {
	            // We just want to add the height of the element to the distance it
	            // is from the top of the page. Sadly, angular's `offsetTop` isn't
	            // the same as jQuery's, and returns the offset from the containing
	            // element. We need the offset from the top of the page. So we have
	            // to add `scrollY` to the distance from the top of the page.
	            //
	            // See http://stackoverflow.com/a/18953277
	            breakpoint += relativeElement.getBoundingClientRect().top + this.getCurrentScroll() + this.getElementHeight(relativeElement);
	          }
	        }
	        return breakpoint;
	      }
	    }, {
	      key: 'updateSneakyElement',
	      value: function updateSneakyElement() {
	        if (this.mode === 'height') {
	          this.setSneakyElementHeight();
	        } else if (this.mode === 'fade-in' || this.mode === 'fade-out') {
	          this.setSneakyElementOpacity();
	        }
	      }
	    }, {
	      key: 'setSneakyElementHeight',
	      value: function setSneakyElementHeight() {
	        var unboundedSneakyElementHeight = this.getCurrentScroll() - this.scrollBreakpoint;
	        var innerHeight = this.innerHeight;
	        var sneakyElementHeight = Math.max(0, Math.min(unboundedSneakyElementHeight, innerHeight));
	
	        if (this.stayOpen) {
	          sneakyElementHeight = (0, _lodash.max)([sneakyElementHeight, this.currentHeight]);
	        }
	
	        if (sneakyElementHeight !== this.currentHeight) {
	          this.$element.css('height', sneakyElementHeight + 'px');
	          this.currentHeight = sneakyElementHeight;
	        }
	      }
	    }, {
	      key: 'setSneakyElementOpacity',
	      value: function setSneakyElementOpacity() {
	        var isPastBreakpoint = this.getCurrentScroll() > this.scrollBreakpoint;
	        var isVisible = this.mode === 'fade-in' && isPastBreakpoint || this.mode === 'fade-out' && !isPastBreakpoint;
	
	        this.$element.css('opacity', isVisible ? 1 : 0);
	      }
	    }]);
	
	    return OdSneakyElement;
	  }();
	
	  return {
	    restrict: 'EA',
	    transclude: true,
	    template: __webpack_require__(804)(),
	    controller: OdSneakyElement,
	    bindToController: true,
	    controllerAs: 'sneakyElementCtrl',
	    scope: {
	      relativeElementId: '@?',
	      scrollParentId: '@?',
	      topBuffer: '@?',
	      mode: '@?',
	      stayOpen: '<?'
	    }
	  };
	}]).name;

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(803);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-sneaky-element.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-sneaky-element.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "od-sneaky-element,[od-sneaky-element]{display:block;overflow:hidden}od-sneaky-element[mode^=\"fade\"],[od-sneaky-element][mode^=\"fade\"]{overflow:visible;opacity:0;-webkit-transition:.15s ease-out opacity;transition:.15s ease-out opacity}", ""]);
	
	// exports


/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"sneaky-element-inner\"><ng-transclude></ng-transclude></div>");;return buf.join("");
	}

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	var _odStarRating = __webpack_require__(806);
	
	var _odStarRating2 = _interopRequireDefault(_odStarRating);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ICON_SETS = {
	  blue: {
	    hover: 'star-hover',
	    selected: 'star-filled-blue',
	    default: 'star-empty'
	  },
	  gold: {
	    hover: 'star-filled-gold',
	    selected: 'star-filled-gold',
	    default: 'star-empty-grey'
	  }
	};
	
	module.exports = _angular2.default.module('common.directives.od-star-rating', []).component('odStarRating', {
	  bindings: {
	    ngModel: '=',
	    ngChange: '&?',
	    numStarsStr: '@?numStars',
	    iconSet: '@?', // Choose from ICON_SETS above
	    frozen: '<?' // Prevent editing. `true` or `false`, defaults to `false`
	  },
	  templateUrl: '/templates/common/directives/od-star-rating.html',
	  controller: function () {
	    controller.$inject = ["$timeout"];
	    function controller($timeout) {
	      _classCallCheck(this, controller);
	
	      this.ICON_SETS = ICON_SETS;
	      this.$timeout = $timeout;
	
	      this.numStars = parseInt(this.numStarsStr, 10) || 5;
	      this.starNumbers = (0, _lodash.range)(1, this.numStars + 1);
	      this.hoveredStarNumber = null;
	      if ((0, _lodash.isEmpty)(this.iconSet)) {
	        this.iconSet = 'blue';
	      } else if (!ICON_SETS[this.iconSet]) {
	        throw 'Invalid icon set "' + this.iconSet + '" provided to od-star-rating.';
	      }
	    }
	
	    _createClass(controller, [{
	      key: 'onMouseover',
	      value: function onMouseover(hoveredStarNumber) {
	        if (this.frozen) {
	          return;
	        }
	
	        this.hoveredStarNumber = hoveredStarNumber;
	      }
	    }, {
	      key: 'updateModel',
	      value: function updateModel(newValue) {
	        var _this = this;
	
	        if (this.frozen) {
	          return;
	        }
	
	        this.ngModel = newValue;
	
	        if (this.ngChange) {
	          // This is hack to prevent ngChange from being fired before the
	          // $scope.$apply can finish propagating the new value. The best
	          // alternative seems to be http://stackoverflow.com/a/34001183, but
	          // this didn't work for me, and http://stackoverflow.com/a/25973789
	          // is a possibly-even-worse-hack using scope.$eval.
	          this.$timeout(function () {
	            _this.ngChange();
	          });
	        }
	      }
	    }]);
	
	    return controller;
	  }()
	}).name;

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(807);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-star-rating.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-star-rating.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "od-star-rating{display:block}od-star-rating .star-label{display:inline-block;width:25px;height:25px;cursor:pointer}od-star-rating .star-label svg{width:25px;height:25px}od-star-rating .star-label+.star-label{margin-left:10px}od-star-rating.small .star-label{width:15px;height:15px}od-star-rating.small .star-label svg{width:15px;height:15px}od-star-rating.small .star-label+.star-label{margin-left:5px}od-star-rating .frozen .star-label{cursor:auto}", ""]);
	
	// exports


/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO(angular-1.4): This directive would be AMAZING if it came with some
	// default testimonials out of theo box. This is easy in angular 1.4 with
	// optional transclusion. All we have to do is put the default testimonials
	// within the `ng-transclude` in `od-testimonial-block.html.slim`, and they
	// will be a fallback if no testimonials are passed in.
	//
	// Unfortunately, doing this before Angular 1.4 results in double-registration
	// bugs that confuse the carousel. It's probably possible to hack around, but
	// I'd rather wait for now.
	//
	// TODO(azirbel): Auto-advance to next quote automatically, at a set interval.
	// Unfortunately, this is a bit hard because our carousels aren't circular.
	module.exports = _angular2.default.module('common.directives.od-testimonial-block', []).directive('odTestimonialBlock', function () {
	  return {
	    restrict: 'EA',
	    scope: {},
	    templateUrl: '/templates/common/directives/od-testimonial-block.html',
	    transclude: true
	  };
	}).directive('odTestimonial', function () {
	  return {
	    restrict: 'EA',
	    require: '^odCarousel',
	    scope: {
	      byline: '@'
	    },
	    templateUrl: '/templates/common/directives/od-testimonial.html',
	    transclude: true,
	    link: function link(scope, elem, attrs, odCarousel) {
	      elem[0].setAttribute('od-carousel-item', true);
	      odCarousel.debouncedRebuild();
	    }
	  };
	}).name;

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _odTooltip = __webpack_require__(810);
	
	var _odTooltip2 = _interopRequireDefault(_odTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Reasons this is complex and requires JS:
	// * Hover state is easy, but to support mobile, we should show/hide on click
	// * If we show the tooltip on click, then we should make sure it's easy to
	//   dismiss by clicking anywhere else on the screen.
	// * If we want to get fancy (we might want to later), we could position the
	//  tooltip to the top/right/bottom/left depending on how much space is left on
	//  the screen.
	module.exports = _angular2.default.module('common.directives.od-tooltip', []).directive('odTooltip', ["$window", "$mediaQuery", function ($window, $mediaQuery) {
	  return {
	    restrict: 'EA',
	    scope: true,
	    transclude: true,
	    templateUrl: '/templates/common/directives/od-tooltip.html',
	    link: function link(scope, elem) {
	      var hoverEl = elem.find('od-tooltip-hover');
	      if (hoverEl.length < 1) {
	        throw 'od-tooltip must have child od-tooltip-hover element';
	      }
	
	      var windowEl = _angular2.default.element($window);
	      scope.isTooltipShown = false;
	
	      if (elem.hasClass('help-text')) {
	        scope.showQuestionMark = true;
	      }
	
	      scope.setHoverPosition = function () {
	        var rect = elem[0].getBoundingClientRect();
	        if ($mediaQuery('gt-xs')) {
	          hoverEl.css({
	            left: rect.left + rect.width / 2 + 'px',
	            top: rect.top - 6 + 'px'
	          });
	        } else {
	          hoverEl.css({
	            left: '10px',
	            right: '10px',
	            width: 'initial',
	            top: rect.top - 6 + 'px'
	          });
	        }
	      };
	
	      scope.showTooltip = function () {
	        scope.isTooltipShown = true;
	        windowEl.on('scroll', scope.setHoverPosition);
	      };
	
	      scope.hideTooltip = function () {
	        scope.isTooltipShown = false;
	        windowEl.off('scroll', scope.setHoverPosition);
	      };
	
	      scope.$on('$destroy', scope.hideTooltip);
	    }
	  };
	}]).name;

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(811);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-tooltip.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-tooltip.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "od-tooltip,[od-tooltip]{display:inline-block;-webkit-transition:all .2s ease;transition:all .2s ease}od-tooltip .question-mark,[od-tooltip] .question-mark{margin-left:3px}od-tooltip .tooltip-container,[od-tooltip] .tooltip-container{position:relative;cursor:pointer;-webkit-transition:all .2s ease;transition:all .2s ease}od-tooltip .tooltip-container.hover od-tooltip-hover,[od-tooltip] .tooltip-container.hover od-tooltip-hover{display:block}@media (min-width:992px){od-tooltip .tooltip-container:hover od-tooltip-hover,[od-tooltip] .tooltip-container:hover od-tooltip-hover{display:block}}od-tooltip .tooltip-click-cover,[od-tooltip] .tooltip-click-cover{position:fixed;left:0;top:0;right:0;bottom:0;z-index:999}od-tooltip od-tooltip-hover,[od-tooltip] od-tooltip-hover,od-tooltip [od-tooltip-hover],[od-tooltip] [od-tooltip-hover]{display:none;z-index:1000;position:fixed;-webkit-transform:translate(-50%, -100%);transform:translate(-50%, -100%)}od-tooltip od-tooltip-hover.dark,[od-tooltip] od-tooltip-hover.dark,od-tooltip [od-tooltip-hover].dark,[od-tooltip] [od-tooltip-hover].dark{background:#3d4143;color:#fff;font-size:12px;-webkit-border-radius:3px;border-radius:3px;padding:1em;border:0}@media (max-width:767px){od-tooltip od-tooltip-hover,[od-tooltip] od-tooltip-hover,od-tooltip [od-tooltip-hover],[od-tooltip] [od-tooltip-hover]{-webkit-transform:translate(0, -100%);transform:translate(0, -100%)}}", ""]);
	
	// exports


/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	var _parseUrlParams = __webpack_require__(813);
	
	var _parseUrlParams2 = _interopRequireDefault(_parseUrlParams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.pager', []).directive('ocPager', function () {
	  function changePage(toPage) {
	    var link = (0, _lodash.find)(this.paginator.links, { rel: toPage });
	    var params = (0, _parseUrlParams2.default)(link.href);
	
	    this.paginator.page = params.page;
	    if (this.onPage) {
	      this.onPage(params, link);
	    } else {
	      this.paginator['$' + toPage]();
	    }
	  }
	
	  return {
	    restrict: 'C',
	    scope: {
	      paginator: '=',
	      onPage: '=?'
	    },
	    template: __webpack_require__(814)(),
	    link: function link(scope) {
	      scope.changePage = changePage;
	    }
	  };
	}).name;

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (url) {
	  try {
	    var searchParams = new URL(url).searchParams;
	    var urlParams = {};
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var pair = _step.value;
	
	        urlParams[pair[0]] = pair[1];
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return urlParams;
	  } catch (e) {
	    return (0, _lodash.chain)((0, _lodash.replace)(url, /^.*?\?/, '').split('&')).map(function (p) {
	      return p.split('=');
	    }).forEach(function (p) {
	      p[1] = decodeURIComponent(p[1]).replace(/\+/g, ' ');
	    }).fromPairs().value();
	  }
	};
	
	var _lodash = __webpack_require__(412);

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<nav><ul class=\"pager\"><li ng-show=\"paginator.mode === &quot;replace&quot;\" ng-class=\"{disabled: (!paginator.$prev || paginator.reqInProgress)}\"><a href=\"#\" ng-click=\"changePage(&quot;prev&quot;)\" class=\"button\">Previous </a></li><li ng-show=\"paginator.mode === &quot;replace&quot;\" ng-class=\"{disabled: (!paginator.$next || paginator.reqInProgress)}\"><a href=\"#\" ng-click=\"changePage(&quot;next&quot;)\" class=\"button\">Next </a></li><li ng-show=\"paginator.mode === &quot;append&quot;\" ng-class=\"{disabled: (!paginator.$next || paginator.reqInProgress)}\"><a href=\"#\" ng-click=\"changePage(&quot;next&quot;)\" class=\"button\">More </a></li></ul></nav>");;return buf.join("");
	}

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FLOAT = 'float';
	var INTEGER = 'integer';
	
	module.exports = _angular2.default.module('common.directives.percent', [__webpack_require__(816)]).directive('type', ["percentageFilter", function (percentageFilter) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function link(scope, element, attrs, ngModel) {
	      if (attrs.type !== 'percent' || !ngModel) return;
	
	      var type = (0, _lodash.has)(attrs, 'integerPercent') ? INTEGER : FLOAT;
	
	      // String Percent -> Decimal Percent
	      ngModel.$parsers.push(function (value) {
	        if (!value) return null;
	
	        if (type == FLOAT) {
	          var percent = parseFloat(value);
	          if (isNaN(percent)) {
	            return 0;
	          } else {
	            return percent / 100;
	          }
	        } else {
	          var _percent = parseInt(value, 10);
	          if (isNaN(_percent)) {
	            return 0;
	          } else {
	            return _percent;
	          }
	        }
	      });
	
	      // Decimal Percent -> String Percent
	      ngModel.$formatters.push(function (value) {
	        if (!value && value !== 0) return null;
	        if (type == INTEGER) value = value / 100;
	        return percentageFilter(value, 2);
	      });
	    }
	  };
	}]).name;

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.percentage', [__webpack_require__(817), __webpack_require__(818)]).filter('percentage', ["trimmedNumberFilter", "isBlank", function (trimmedNumberFilter, isBlank) {
	  return function (num, fractionSize, options) {
	    if (isBlank(num)) return '—';
	    var result = trimmedNumberFilter(num * 100, fractionSize) + '%';
	
	    options = options || {};
	    if (options.alwaysShowSign && num >= 0) result = '+' + result;
	    if (options.dashForZero && num === 0) result = '—';
	
	    return result;
	  };
	}]).name;

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.trimmed-number', []).filter('trimmedNumber', ["numberFilter", function (numberFilter) {
	  return function (num, fractionSize) {
	    if (num === undefined || num === null || num === '' || num === Infinity) return numberFilter(num);
	
	    num = num.toFixed(fractionSize);
	
	    if (num.indexOf('.') !== -1) num = num.replace(/\.?0+$/, "");
	
	    if (num === '-0') num = '0';
	
	    return num;
	  };
	}]).name;

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.services.blank', []).factory('isBlank', function () {
	  return function (val) {
	    return val === undefined || val === Infinity || val === null || val === '' || (0, _lodash.isNaN)(val);
	  };
	}).name;

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.percent-int', []).directive('type', function () {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function link(scope, element, attrs, ngModel) {
	      if (attrs.type !== 'percent-int' || !ngModel) return;
	
	      // String Percent -> Int Percent
	      ngModel.$parsers.push(function (value) {
	        if (!value) return null;
	
	        return parseInt(value);
	      });
	
	      // Int Percent -> String Percent
	      ngModel.$formatters.push(function (value) {
	        if (!value && value !== 0) return null;
	        return value + '%';
	      });
	    }
	  };
	}).name;

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	var _sanitizeS3Key = __webpack_require__(524);
	
	var _sanitizeS3Key2 = _interopRequireDefault(_sanitizeS3Key);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.photos', [__webpack_require__(771), __webpack_require__(773), __webpack_require__(821)]).directive('ocPhotos', ["Upload", "S3", "Photo", "$sce", function (Upload, S3, Photo, $sce) {
	  return {
	    restrict: 'ACE',
	    scope: {
	      ngModel: '=',
	      picableType: '@',
	      picableId: '=',
	      kind: '@?',
	      live: '=',
	      notWritable: '=',
	      preventDelete: '=',
	      downloadable: '<?',
	      photos: '=ngModel',
	      isVendor: '<?'
	    },
	    controller: ["$scope", function controller($scope) {
	      $scope.carouselIndex = 0;
	
	      $scope.files = { list: [] };
	
	      $scope.downloadResource = downloadResource;
	
	      function forceDownload(blob, filename) {
	        var anchor = document.createElement('a');
	        anchor.download = filename;
	        anchor.href = blob;
	        // For Firefox https://stackoverflow.com/a/32226068
	        document.body.appendChild(anchor);
	        anchor.click();
	        anchor.remove();
	      }
	
	      // Current blob size limit is around 500MB for browsers
	      function downloadResource(url, filename) {
	        if (!filename) filename = url.split('\\').pop().split('/').pop().split('?').shift();
	
	        window.fetch(url, {
	          headers: new Headers({
	            'Origin': location.origin
	          }),
	          mode: 'cors',
	          cache: 'no-store'
	        }).then(function (response) {
	          return response.blob();
	        }).then(function (blob) {
	          var blobUrl = window.URL.createObjectURL(blob);
	          forceDownload(blobUrl, filename);
	        }).catch(function (e) {
	          return console.error(e);
	        });
	      }
	    }],
	    templateUrl: '/templates/common/directives/photos.html',
	    require: 'ngModel',
	    link: function link(scope, element, attrs, ngModelController) {
	
	      scope.$watch('files.list', function (files) {
	        var startingPhotoCount = scope.ngModel.length;
	        (0, _lodash.forEach)(files, function (file, index) {
	          process(file, startingPhotoCount + index);
	        });
	      });
	
	      scope.$watch('photos', function () {
	        // reset the index when the entire collection of photos changes
	        scope.carouselIndex = 0;
	      });
	
	      function process(file, position) {
	        if (!file) {
	          return null;
	        }
	
	        if (!file.type.includes('image')) {
	          window.alert('Uploaded file ' + file.name + ' has type ' + file.type + ', which is not an image.');
	          return null;
	        }
	        var sanitizedFileName = (0, _sanitizeS3Key2.default)(file.name);
	        var key = ['uploads', 'photos', scope.picableType, scope.picableId, Date.now() + '-' + sanitizedFileName].join('/');
	        var newPhoto = new Photo({
	          picable_type: scope.picableType,
	          picable_id: scope.picableId,
	          process: 0,
	          key: key,
	          kind: scope.kind,
	          position: position
	        });
	        ngModelController.$setValidity(key, false);
	        scope.ngModel.push(newPhoto);
	
	        Upload.upload({
	          url: S3.rootUrl,
	          method: 'POST',
	          file: file,
	          fields: {
	            key: newPhoto.key,
	            AWSAccessKeyId: S3.AWSAccessKeyId,
	            acl: 'public-read',
	            policy: S3.publicReadPolicy,
	            signature: S3.publicReadSignature,
	            'Content-Type': file.type || 'application/octet-stream'
	          }
	        }).progress(function (progress) {
	          newPhoto.progress = Math.floor(progress.loaded / progress.total * 100);
	        }).success(function () {
	          if (scope.live) {
	            newPhoto.$save().then(function () {
	              ngModelController.$setValidity(key, true);
	              newPhoto.photo_url = newPhoto.photo_url || S3.rootUrl + key;
	            });
	          } else {
	            newPhoto.photo_url = newPhoto.photo_url || S3.rootUrl + key;
	            newPhoto.uploadComplete = true;
	            ngModelController.$setValidity(key, true);
	          }
	        });
	      }
	
	      scope.deletedPhotosPresent = false;
	
	      scope.reorder = function (image, toPosition) {
	        if (!scope.live) return;
	        var workingImage = image;
	        if (!image.$reorder) workingImage = new Photo(image);
	
	        workingImage.move_to_position = toPosition;
	
	        workingImage.$reorder().then(function () {
	          image.position = toPosition;
	        });
	      };
	
	      scope.destroy = function (image) {
	        if (scope.preventDelete) return;
	        if (!scope.live) {
	          if (image.id) {
	            image._destroy = '1';
	          } else {
	            var idx = scope.ngModel.indexOf(image);
	            scope.ngModel.splice(idx, 1);
	          }
	        } else {
	          var workingImage = image;
	          if (!image.$delete) workingImage = new Photo(image);
	
	          workingImage.$delete().then(function () {
	            var idx = scope.ngModel.indexOf(image);
	            if (idx > -1) scope.ngModel.splice(idx, 1);
	          });
	        }
	      };
	
	      scope.areDeletedPhotosPresent = function () {
	        return scope.ngModel.find(function (lp) {
	          return lp._destroy === '1';
	        });
	      };
	
	      scope.deleteAll = function () {
	        scope.ngModel.forEach(function (lp) {
	          return lp._destroy = '1';
	        });
	        scope.deletedPhotosPresent = scope.areDeletedPhotosPresent();
	      };
	
	      scope.unDeleteAll = function () {
	        scope.ngModel.forEach(function (lp) {
	          return delete lp['_destroy'];
	        });
	        scope.deletedPhotosPresent = scope.areDeletedPhotosPresent();
	      };
	
	      scope.downloadLink = $sce.trustAsResourceUrl('/' + (scope.isVendor ? 'vendor' : 'admin') + '/photos/download_zip?picable_type=' + scope.picableType + '&picable_id=' + scope.picableId //eslint-disable-line max-len
	      );
	    }
	  };
	}]).name;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(729)))

/***/ },
/* 821 */,
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _pikadayTime = __webpack_require__(823);
	
	var _pikadayTime2 = _interopRequireDefault(_pikadayTime);
	
	var _momentTimezone = __webpack_require__(517);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.pikaday', []).directive('pikaday', function typePikaday() {
	  if (typeof _pikadayTime2.default === 'undefined') {
	    console.warn('pikaday directive requires the Pikaday library.');
	    return {};
	  }
	
	  return {
	    restrict: 'C',
	    scope: {
	      ngModel: '=',
	      minDate: '=?',
	      maxDate: '=?',
	      showTime: '<?',
	      timeIsNow: '<?',
	      disableDay: '=?',
	      defaultDate: '=?',
	      onSelect: '&?',
	      theme: '=?'
	    },
	    require: 'ngModel',
	    link: function link(scope, element, attrs, ngModel) {
	      var minDate = scope.minDate && (0, _momentTimezone2.default)(scope.minDate).toDate();
	      var maxDate = scope.maxDate && (0, _momentTimezone2.default)(scope.maxDate).toDate();
	      var defaultDate = scope.defaultDate && (0, _momentTimezone2.default)(scope.defaultDate).toDate() || minDate;
	      var showTime = scope.showTime || false;
	      var timeIsNow = scope.timeIsNow;
	      var formatString = attrs.format || (showTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD');
	      var pickadayOptions = {
	        field: element[0],
	        defaultDate: defaultDate,
	        setDefaultDate: !!scope.defaultDate,
	        showTime: showTime,
	        incrementMinuteBy: 15,
	        minDate: minDate,
	        maxDate: maxDate,
	        format: formatString,
	        theme: scope.theme
	      };
	
	      if (scope.onSelect) {
	        pickadayOptions.onSelect = function (date) {
	          scope.onSelect({ date: date });
	        };
	      }
	
	      if (scope.disableDay) {
	        pickadayOptions.disableDayFn = scope.disableDay;
	      }
	
	      var pikaday = new _pikadayTime2.default(pickadayOptions);
	
	      var time = null;
	      var dt = null;
	
	      ngModel.$formatters.push(function (value) {
	        if (!value) return;
	
	        if (showTime) {
	          if (timeIsNow !== false) {
	            dt = (0, _momentTimezone2.default)(pikaday.getMoment());
	          } else {
	            dt = (0, _momentTimezone2.default)(value);
	          }
	        } else {
	          dt = (0, _momentTimezone2.default)(value);
	          time = (0, _momentTimezone2.default)(value);
	          pikaday.setMoment(dt.toDate());
	        }
	        return dt.format(formatString);
	      });
	
	      ngModel.$parsers.push(function (value) {
	        if (time && time.format('HH:mm:ss') !== '00:00:00') {
	          return (0, _momentTimezone2.default)(value).hour(time.hour()).minute(time.minute()).second(time.second()).toDate(); // eslint-disable-line max-len
	        } else {
	          return value;
	        }
	      });
	    }
	  };
	}).name;

/***/ },
/* 823 */,
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global google:false */
	module.exports = _angular2.default.module('common.directives.place-autocomplete', []).directive('odPlaceAutocomplete', ["Analytics", function (Analytics) {
	  if (typeof google === 'undefined' || !(google.maps && google.maps.places)) {
	    console.warn('od-place-autocomplete requires Google Places JavaScript API.');
	    return {};
	  }
	
	  var autocomplete = new google.maps.places.AutocompleteService(),
	      places = new google.maps.places.PlacesService(document.createElement('div'));
	  return {
	    restrict: 'C', // od-place-autocomplete matches only class name
	    scope: { ngModel: '=' }, // isolate scope
	    template: __webpack_require__(825)(),
	    link: function link(scope, element, attrs) {
	      scope.results = [];
	      scope.buttonText = attrs.buttonText;
	      element.toggleClass('with-button', !!scope.buttonText);
	
	      // Fires from the button if one is present
	      scope.fire = function () {
	        select(selected || scope.results[0]);
	      };
	
	      scope.addressErrors = false;
	      // copy placeholder attribute over to input
	      var addressAttemptCount = 0,
	          input = element.find('input').attr('placeholder', attrs.placeholder);
	
	      // focus the input on autofocus
	      if ('autofocus' in attrs) input[0].focus();
	
	      // on input change, query google
	      var lastQuery;
	      scope.$watch('query', function (query) {
	        if (!query) return scope.results = [];
	        if (selected && selected.description === query) return;
	
	        // Remove commas from query because they hurt our matches
	        query = query.replace(/,/g, '');
	        lastQuery = query;
	
	        autocomplete.getPlacePredictions({
	          input: query,
	          types: ['geocode'],
	          componentRestrictions: { country: 'us' }
	        }, function (results) {
	          _angular2.default.forEach(results, function (result) {
	            result.description = result.description.replace(', United States', '');
	          });
	          scope.$apply(function () {
	            // try to decode what google is returning to filter to only street
	            // addresses that we can probably use.
	            var hasValidAddressType = function hasValidAddressType(types) {
	              return types.includes('street_address') || types.includes('premise');
	            };
	            scope.results = (0, _lodash.filter)(results, function (result) {
	              return result.terms.length >= 5 && hasValidAddressType(result.types) || result.terms.length === 4 && result.terms[0].value.match(/^\d+\S*\s\S+\s/);
	            });
	          });
	        });
	      });
	
	      // key bindings for selection
	      var key = { left: 37, up: 38, right: 39, down: 40, tab: 9, enter: 13, esc: 27 },
	          selectedIndex = -1,
	          selected = null;
	      scope.keydown = function (e) {
	        if (input.hasClass('ng-pristine')) return;
	        if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) return;
	
	        switch (e.keyCode) {
	          case key.down:
	            selectedIndex++;
	            if (selectedIndex >= scope.results.length) selectedIndex = -1;
	            break;
	          case key.up:
	            selectedIndex--;
	            if (selectedIndex < -1) selectedIndex = scope.results.length - 1;
	            break;
	          case key.esc:
	            scope.results = [];
	            break;
	          case key.enter:
	          case key.tab:
	            select(selected || scope.results[0]);
	            break;
	          default:
	            return;
	        }
	
	        if (!(e.keyCode === key.enter || e.keyCode === key.tab)) e.preventDefault();
	
	        // unselect previous
	        if (selected) delete selected.selected;
	
	        selected = scope.results[selectedIndex];
	        if (selected) {
	          selected.selected = true;
	          scope.query = selected.description;
	        } else if (selectedIndex === -1) {
	          scope.query = lastQuery;
	        }
	      };
	
	      // click to select
	      scope.click = function (result) {
	        scope.query = result.description;
	        select(result);
	      };
	
	      scope.$watch('results', function (results) {
	        if (!results || results.length === 0) selectedIndex = -1;
	      });
	
	      function select(result) {
	        if (!result) {
	          // we couldn't find that address
	          scope.addressErrors = true;
	          Analytics.event('address_search', 'submit', 'failed_address_attempt', { eventValue: ++addressAttemptCount }); // eslint-disable-line max-len
	        } else {
	          places.getDetails(result, function (place) {
	            var REQUIRED_COMPONENTS = ['street_number', 'route', 'locality', 'administrative_area_level_1', 'postal_code'],
	                // eslint-disable-line max-len
	            foundComponents = (0, _lodash.flatten)((0, _lodash.map)(place.address_components, 'types'));
	
	            scope.$apply(function () {
	
	              scope.addressErrors = (0, _lodash.difference)(REQUIRED_COMPONENTS, foundComponents).length;
	              if (scope.addressErrors) {
	                selected = undefined;
	                element.find('input')[0].select();
	              } else {
	                place.query = lastQuery;
	                scope.ngModel = place;
	              }
	            });
	          });
	
	          selected = result;
	          scope.results = [];
	        }
	      }
	    }
	  };
	}]).name;

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<input type=\"text\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" ng-model=\"query\" ng-model-options=\"{ debounce: 100 }\" ng-keydown=\"keydown($event)\"><a href=\"#\" ng-click=\"fire()\" ng-show=\"buttonText\" class=\"od-xhr-progress button submit white\">{{buttonText}}</a><ul ng-show=\"results[0]\"><li ng-repeat=\"result in results\" ng-class=\"{ selected: result.selected }\" ng-click=\"click(result)\">{{result.description}}</li></ul><small ng-show=\"addressErrors\" class=\"inline-error\">We couldn't find that address. Try without zip codes or unit numbers. Or try our &nbsp;<a href=\"#\" ng-click=\"$parent.goToManualEntry()\">simplified form.</a></small>");;return buf.join("");
	}

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// NOTE(ed): This directive is used to bring in one-way data from the redux store.
	// In react-redux we would use selectors in mapStateToThis (mapStateToProps), which would have
	// this component's props (ownProps.)
	// Unfortunately, mapStateToThis from ngRedux does not provide the component's props.
	// So the one-way dependencies from angular and ngRedux need to be combined together in $onChanges.
	// To simplify this, @visnup and @ed wrote this directive to bring in redux dependencies as
	// angular one-way bindings.
	//
	// In the below example, workOrders is one-way bound onto the component. redux-mapping values are
	// relative to the state root.
	// od-draft-inspection-form(
	//   address='$ctrl.address'
	//   flip='$ctrl.flip'
	//   inspections='$ctrl.inspections'
	//   inspection='$ctrl.inspection'
	//   renovation-id='$ctrl.renovationId'
	//   kind='{{kind}}'
	//   redux-mapping='{ \
	//     workOrders: "entities.workOrders", \
	//   }'
	//
	// Debugging tips: inspect the element you have this directive on, get its scope, and check
	// `reduxMapping` - angular.element($0).scope().reduxMapping
	
	module.exports = _angular2.default.module('common.directives.redux-mapping', []).directive('reduxMapping', ["$compile", "$ngRedux", "$parse", function ($compile, $ngRedux, $parse) {
	  return {
	    restrict: 'A',
	    compile: function compile(iElement, iAttrs) {
	      var cget = (0, _lodash.curry)(_lodash.get);
	      var reduxMapping = $parse(iAttrs.reduxMapping)();
	      (0, _lodash.mapKeys)(reduxMapping, function (_, key) {
	        return iAttrs.$set(key, 'reduxMapping.' + key);
	      });
	
	      return function (scope) {
	        scope.reduxMapping = {};
	        var mapStateToThis = function mapStateToThis(state) {
	          return (0, _lodash.mapValues)(reduxMapping, cget(state));
	        };
	        var reduxUnsubscribe = $ngRedux.connect(mapStateToThis)(scope.reduxMapping);
	        scope.$on("destroy", reduxUnsubscribe);
	      };
	    }
	  };
	}]).name;

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.render-once', []).directive('renderOnce', function () {
	  return {
	    restrict: 'A',
	    link: function link(scope) {
	      scope.$evalAsync(function () {
	        scope.$destroy();
	      });
	    }
	  };
	}).name;

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.select-all-on-focus', []).directive('selectAllOnFocus', function () {
	  return function (scope, element) {
	    element.bind('focus', function () {
	      this.select();
	    });
	  };
	}).name;

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _momentTimezone = __webpack_require__(517);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.service_account_indicators', []).directive('ocServiceAccountIndicators', function () {
	  var GLYPS = {
	    electricity: ['glyphicon', 'glyphicon-flash'],
	    water: ['glyphicon', 'glyphicon-tint'],
	    gas: ['glyphicon', 'glyphicon-fire'],
	    insurance: ['glyphicon', 'glyphicon-folder-close']
	  };
	
	  return {
	    restrict: 'C',
	    scope: {
	      accountTypes: '=',
	      accounts: '='
	    },
	    templateUrl: '/templates/common/directives/service_account_indicators.html',
	    controller: ["$scope", "titlecaseFilter", function controller($scope, titlecaseFilter) {
	      $scope.$watchCollection('accounts', updateIndicators);
	      $scope.$watchCollection('accountTypes', updateIndicators);
	
	      function updateIndicators() {
	        var accounts = $scope.accounts,
	            types = $scope.accountTypes;
	
	        if (!accounts || !types) return;
	
	        $scope.indicators = (0, _lodash.map)(types, function (type) {
	          var classes = [].concat(GLYPS[type] || []);
	          var account = (0, _lodash.find)($scope.accounts, { kind: type });
	          if (!account || account.deactivated || !account.activation_date) {
	            classes.push('inactive');
	          } else if (account.currently_active) {
	            classes.push('currently-active');
	          } else {
	            classes.push('scheduled');
	          }
	
	          return {
	            type: type,
	            account: account,
	            classes: classes,
	            popover: popoverText(account)
	          };
	        });
	      }
	
	      function popoverText(account) {
	        if (!account) return 'Not scheduled';
	        var kind = titlecaseFilter(account.kind);
	        var str = '';
	        if (account.deactivated) {
	          str = kind + ' deactivated on ' + (0, _momentTimezone2.default)(account.deactivation_date).format('MMM D');
	        } else if (account.currently_active) {
	          str = kind + ' is on';
	        } else if (account.activation_date && !account.currently_active) {
	          str = kind + ' scheduled for ' + (0, _momentTimezone2.default)(account.activation_date).format('MMM D');
	        } else {
	          str = kind + ' not scheduled';
	        }
	        return str;
	      }
	    }]
	  };
	}).name;

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.table-frozen', []).directive('tableFrozen', ["$window", function ($window) {
	  function TableCtrl() {
	    this.elements = [];
	    this.freezeLater = (0, _lodash.debounce)(this.freeze);
	  }
	
	  TableCtrl.prototype.add = function (elem) {
	    this.elements.push(elem);
	    this.unfreeze();
	    this.freezeLater();
	  };
	
	  TableCtrl.prototype.unfreeze = function () {
	    (0, _lodash.forEach)(this.elements, function (elem) {
	      if (elem.hasClass('col-frozen-last')) {
	        elem.next().css('padding-left', null);
	      }
	
	      elem.css({ position: null, width: null });
	      elem.removeClass('col-frozen-last');
	    });
	  };
	
	  TableCtrl.prototype.freeze = function () {
	    this.unfreeze();
	
	    var rows = [];
	    var columns = [];
	
	    (0, _lodash.forEach)(this.elements, function (elem) {
	      var tr = elem.parent(),
	          i = (0, _lodash.indexOf)(tr.children(), elem[0]);
	
	      rows.push(tr);
	      (columns[i] = columns[i] || []).push(elem);
	    });
	
	    (0, _lodash.forEach)((0, _lodash.uniq)(rows), function (row) {
	      var height = { height: row.prop('offsetHeight') + 'px' };
	      row.css(height);
	
	      (0, _lodash.forEach)(row.children(), function (elem) {
	        elem = _angular2.default.element(elem);
	        if (elem.hasClass('col-frozen')) {
	          elem.css(height);
	        }
	      });
	    });
	
	    var left = 0;
	    (0, _lodash.forEach)(columns, function (elems) {
	      elems.width = (0, _lodash.reduce)(elems, function (maxWidth, elem) {
	        var width = elem.prop('offsetWidth');
	        return Math.max(width, maxWidth);
	      }, 0);
	
	      elems.left = left;
	      left += elems.width;
	
	      (0, _lodash.forEach)(elems, function (elem) {
	        elem.css({ position: 'absolute', width: elems.width + 'px' });
	
	        var next = elem.next();
	        if (next.hasClass('col-frozen')) {
	          next.css('left', elems.left + elems.width + 'px');
	        } else {
	          var padding = parseInt($window.getComputedStyle(next[0]).paddingLeft);
	          next.css('padding-left', padding + elems.left + elems.width + 'px');
	          elem.addClass('col-frozen-last');
	        }
	      });
	    });
	  };
	
	  return {
	    restrict: 'AC',
	    controller: TableCtrl
	  };
	}]).directive('colFrozen', function () {
	  return {
	    restrict: 'AC',
	    require: '^tableFrozen',
	    link: function link(scope, elem, attrs, tableCtrl) {
	      scope.$evalAsync(function () {
	        tableCtrl.add(elem);
	      });
	    }
	  };
	}).name;

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.table-sortable', []).directive('tableSortable', ["$parse", function ($parse) {
	  return {
	    restrict: 'C',
	    controller: ["$scope", function controller($scope) {
	      this.sort = function (key) {
	        if (!$scope.onSort || $scope.onSort($scope, { key: key, asc: this.orderKey() !== key })) {
	          $scope.$apply(function () {
	            $scope.orderKey = ($scope.orderKey === key ? '-' : '') + key;
	          });
	        }
	      };
	
	      this.orderKey = function () {
	        return $scope.orderKey;
	      };
	    }],
	    link: function link(scope, element, attrs) {
	      scope.orderKey = scope.$eval(attrs.defaultSort);
	      scope.onSort = attrs.onSort ? $parse(attrs.onSort) : null;
	    }
	  };
	}]).directive('sort', function () {
	  return {
	    restrict: 'A',
	    require: '?^tableSortable',
	    scope: {},
	    transclude: true,
	    template: __webpack_require__(832)(),
	    link: function link(scope, element, attrs, sortController) {
	      if (sortController) {
	        scope.sortColumn = attrs.sort;
	        scope.orderKey = sortController.orderKey;
	
	        element.on('click', function () {
	          sortController.sort(attrs.sort);
	        });
	      }
	    }
	  };
	}).name;

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<span class=\"cursor-pointer\"><ng-transclude></ng-transclude><span ng-if=\"orderKey() === &quot;-&quot; + sortColumn\"><span class=\"dropup\">&nbsp;<span class=\"caret\"></span></span></span><span ng-if=\"orderKey() === sortColumn\">&nbsp;<span class=\"caret\"></span></span></span>");;return buf.join("");
	}

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.tel', [__webpack_require__(450)]).directive('type', ["telFilter", "formattedCursorPosition", function typeTel(telFilter, formattedCursorPosition) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function link(scope, element, attrs, ngModel) {
	      if (attrs.type !== 'tel' || !ngModel) return;
	
	      // view -> model
	      ngModel.$parsers.push(function (oldValue) {
	        var numbers = oldValue.toString().trim().replace(/\D/g, '');
	        if (numbers[0] === '1') {
	          numbers = numbers.slice(1);
	        }
	        numbers = numbers.slice(0, 10);
	
	        var newValue = telFilter(numbers);
	        var oldCursorPosition = element[0].selectionStart;
	        var newCursorPosition = formattedCursorPosition(oldCursorPosition, oldValue, newValue);
	
	        element.val(newValue);
	        ngModel.$setViewValue(newValue);
	        ngModel.$commitViewValue(newValue);
	        element[0].setSelectionRange(newCursorPosition, newCursorPosition);
	
	        return numbers;
	      });
	
	      // model -> view
	      ngModel.$formatters.push(function (value) {
	        if (!value) return;
	
	        return telFilter(value.toString().replace(/^\+?1\s*/, ''));
	      });
	
	      // validate the phone number (validation will be used by the form that
	      // contains the <input type="tel"> element)
	      ngModel.$validators.validPhoneNumberPattern = function (value) {
	        return !value || /\d{3}[2-9]\d{6}/.test(value);
	      };
	    }
	  };
	}]).name;

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.title', []).directive('title', ["$document", "$timeout", function ($document, $timeout) {
	  var title = _angular2.default.element($document[0].querySelector('title')).clone();
	
	  function syncTitle() {
	    // $timeout is needed to get pushState + history + title to play correctly
	    // together. otherwise, the browser ends up recording weird page titles in
	    // history for some reason.
	    $timeout(function () {
	      $document[0].title = title.text();
	    });
	  }
	
	  return {
	    restrict: 'E',
	    transclude: true,
	    link: function link(scope, elem, attrs, controller, transclude) {
	      transclude(function (clone, scope) {
	        if (attrs.$attr && attrs.$attr.prepend) {
	          title.prepend(clone);
	        } else {
	          title.append(clone);
	        }
	        scope.$on('$destroy', function () {
	          clone.remove();
	          syncTitle();
	        });
	
	        scope.$watch(function () {
	          return clone.text();
	        }, function (current) {
	          if (current.indexOf('{{') === -1) // prevent unwanted/early updates
	            syncTitle();
	        });
	      });
	    }
	  };
	}]).name;

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.directives.xhr-progress', []).directive('odXhrProgress', ["$rootScope", function ($rootScope) {
	  return {
	    restrict: 'C',
	    link: function link(scope, element, attrs) {
	      // watch for xhr progress
	
	      function turnOnProgressFilter() {
	        $rootScope.originatingXhrScope = scope;
	      }
	
	      _angular2.default.element(element).on('click', turnOnProgressFilter);
	
	      scope.$on('$destroy', function () {
	        _angular2.default.element(element).off('click', turnOnProgressFilter);
	      });
	
	      scope.$watch('scopeXhrRequestInProgress', function (progress) {
	        var disabled = !!progress || !!scope.$eval(attrs.ngDisabled);
	        element.prop('disabled', disabled);
	        element.toggleClass('in-progress', !!progress);
	      });
	    }
	  };
	}]).factory('XhrProgress', ["$q", "$rootScope", function ($q, $rootScope) {
	  var trackedRequests = {};
	
	  function randomString(length) {
	    return Math.round(Math.pow(36, length + 1) - Math.random() * Math.pow(36, length)).toString(36).slice(1); // eslint-disable-line max-len
	  }
	
	  function handleTrackedResponse(config) {
	    if (!config) return;
	
	    var originatingScope = trackedRequests[config.odRequestId];
	    delete trackedRequests[config.odRequestId];
	
	    if (!originatingScope) return;
	    originatingScope.scopeXhrRequestInProgress = false;
	  }
	
	  return {
	    request: function request(config) {
	      config.odRequestId = randomString(64);
	      var originatingScope = $rootScope.originatingXhrScope;
	      delete $rootScope.originatingXhrScope;
	
	      if (originatingScope) {
	        trackedRequests[config.odRequestId] = originatingScope;
	        originatingScope.scopeXhrRequestInProgress = true;
	      }
	
	      $rootScope.xhrProgress = ($rootScope.xhrProgress || 0) + 1;
	      return config;
	    },
	
	    requestError: function requestError(rejection) {
	      handleTrackedResponse(rejection.config);
	      $rootScope.xhrProgress--;
	      return $q.reject(rejection);
	    },
	
	    response: function response(_response) {
	      handleTrackedResponse(_response.config);
	      $rootScope.xhrProgress--;
	      return _response;
	    },
	
	    responseError: function responseError(rejection) {
	      handleTrackedResponse(rejection.config);
	      $rootScope.xhrProgress--;
	      return $q.reject(rejection);
	    }
	  };
	}]).config(["$httpProvider", function ($httpProvider) {
	  $httpProvider.interceptors.push('XhrProgress');
	}]).name;

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters', [__webpack_require__(837), __webpack_require__(838), __webpack_require__(839), __webpack_require__(840), __webpack_require__(841), __webpack_require__(843), __webpack_require__(845), __webpack_require__(846), __webpack_require__(847), __webpack_require__(706), __webpack_require__(848), __webpack_require__(849), __webpack_require__(850), __webpack_require__(851), __webpack_require__(852), __webpack_require__(853), __webpack_require__(854), __webpack_require__(855), __webpack_require__(856), __webpack_require__(857), __webpack_require__(858), __webpack_require__(782), __webpack_require__(859), __webpack_require__(860), __webpack_require__(861), __webpack_require__(862), __webpack_require__(792), __webpack_require__(863), __webpack_require__(864), __webpack_require__(865), __webpack_require__(866), __webpack_require__(867), __webpack_require__(868), __webpack_require__(869), __webpack_require__(870), __webpack_require__(871), __webpack_require__(872), __webpack_require__(873), __webpack_require__(816), __webpack_require__(874), __webpack_require__(569), __webpack_require__(875), __webpack_require__(876), __webpack_require__(878), __webpack_require__(879), __webpack_require__(880), __webpack_require__(684), __webpack_require__(881), __webpack_require__(882), __webpack_require__(883), __webpack_require__(884), __webpack_require__(885), __webpack_require__(886), __webpack_require__(887), __webpack_require__(450), __webpack_require__(888), __webpack_require__(685), __webpack_require__(817), __webpack_require__(889), __webpack_require__(890), __webpack_require__(891), __webpack_require__(892), __webpack_require__(893), __webpack_require__(894), __webpack_require__(686), __webpack_require__(895), __webpack_require__(896)]).name;

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.abs', []).filter('abs', function () {
	  return function (input) {
	    return (0, _lodash.isNumber)(input) ? Math.abs(input) : input;
	  };
	}).name;

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.address', []).filter('address', function () {
	  return function (address) {
	    var joiner = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ', ';
	
	    if (!address) return "";
	
	    return (0, _lodash.compact)([address.street1, address.street2, address.city, address.state, address.postal_code]).join(joiner);
	  };
	}).name;

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.any', []).filter('any', function () {
	  return function (input) {
	    return !(0, _lodash.isEmpty)(input);
	  };
	}).name;

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.arrayDiff', []).filter('arrayDiff', function () {
	  return _lodash.difference;
	}).name;

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.assignee-photo', [__webpack_require__(842)]).filter('assigneePhoto', ["Assignee", function (Assignee) {
	  return function (human) {
	    var id = (typeof human === 'undefined' ? 'undefined' : _typeof(human)) === 'object' && human ? human.id : human;
	    return (Assignee[id] || Assignee[null]).image;
	  };
	}]).name;

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.models.assignee', ['server.common-constants']).factory('Assignee', ["$http", function ($http) {
	  var assigneeList = {
	    null: {
	      full_name: '',
	      email: 'contact@opendoor.com',
	      image: 'https://images.opendoor.com/source/s3/imgdrop-production/64d254e6888e45d9a688f7d5f19a674c.jpg?service=web'
	    }
	  };
	
	  Object.defineProperty(assigneeList, '$promise', { value: $http.get('/api/v1/assignees') });
	  assigneeList.$promise.then(function (response) {
	    (0, _lodash.forEach)(response.data, function (obj) {
	      assigneeList[obj.id] = obj;
	    });
	  });
	
	  return assigneeList;
	}]).name;

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _standardizeBathroomCount = __webpack_require__(844);
	
	var _standardizeBathroomCount2 = _interopRequireDefault(_standardizeBathroomCount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Convert bathroom count into more standard representation
	// e.g. 2.3 baths (2 full, 3 half) -> 3.5 baths
	module.exports = _angular2.default.module('common.filters.bathroom-count', []).filter('bathroomCount', function () {
	  return _standardizeBathroomCount2.default;
	}).name;

/***/ },
/* 844 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = standardizeBathroomCounts;
	/*
	  Hacky temporary function to convert different bathroom representations
	  (e.g. 2.1, 2.2, 2.25, 2.5, 2.75) to an easier to understand standard.
	  This function preserves half bathrooms that are inputted as 0.5,
	  rounds quarter bathrooms from 0.25 to 0.5, rounds three quarter bathrooms
	  from 0.75 to 1, and converts half bathrooms from 0.1 to 0.5.
	
	  Long term fix is to sanitize and standardize the data that we ingest
	  from seller inputs and MLS into a common format on the backend.
	*/
	function standardizeBathroomCounts(bathrooms) {
	  var fullBaths = Math.floor(bathrooms);
	  var partialBaths = +(bathrooms - fullBaths).toFixed(2);
	  var additionalBaths = 0;
	  switch (partialBaths) {
	    case 0.25:
	    case 0.5:
	      additionalBaths = 0.5;
	      break;
	    case 0.75:
	      additionalBaths = 1;
	      break;
	    default:
	      additionalBaths = partialBaths * 5;
	  }
	  return +(fullBaths + additionalBaths).toFixed(2);
	}

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.bytes', []).filter('bytes', function () {
	  return function (bytes, precision) {
	    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
	    if (typeof precision === 'undefined') precision = 1;
	    var units = ['bytes', 'kb', 'mb', 'gb', 'tb', 'pb'],
	        number = Math.floor(Math.log(bytes) / Math.log(1024));
	    return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
	  };
	}).name;

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.capitalize', []).filter('capitalize', function () {
	  return _lodash.capitalize;
	}).name;

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.contains', []).filter('contains', function () {
	  return _lodash.includes;
	}).name;

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.customer', [__webpack_require__(450)]).filter('customer', ["telFilter", function (telFilter) {
	  return function (customer) {
	    return customer.full_name || (customer.primary_email_data || {}).value || telFilter((customer.primary_phone_number_data || {}).value) || telFilter(customer.mobile_phone_number) || 'Unknown Customer';
	  };
	}]).name;

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _momentTimezone = __webpack_require__(517);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.days-from-now', []).filter('daysFromNow', function () {
	  return function (m) {
	    var days = (0, _momentTimezone2.default)().diff((0, _momentTimezone2.default)(m), 'days');
	    var pluralizedDay = Math.abs(days) == 1 ? 'day' : 'days';
	    var suffix = '';
	    var prefix = '';
	    if (days != 0) {
	      if (days < 0) {
	        suffix = '';
	        prefix = 'in';
	      } else if (days > 0) {
	        suffix = 'ago';
	        prefix = '';
	      }
	    }
	    return [prefix, Math.abs(days), pluralizedDay, suffix].join(' ').trim();
	  };
	}).name;

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	var _momentTimezone = __webpack_require__(517);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OFF_MARKET_STATUSES = ['canceled', 'cancelled', 'expired', 'temp_off_market'];
	
	module.exports = _angular2.default.module('common.filters.days-on-market', []).filter('daysOnMarket', function () {
	  return function (listing) {
	    if (!listing) return;
	
	    if (listing.close_date) {
	      return (0, _momentTimezone2.default)(listing.close_date).diff((0, _momentTimezone2.default)(listing.list_date), 'days');
	    } else if ((0, _lodash.includes)(OFF_MARKET_STATUSES, (0, _lodash.snakeCase)(listing.listing_status))) {
	      return (0, _momentTimezone2.default)(listing.status_change_date).diff((0, _momentTimezone2.default)(listing.list_date), 'days');
	    } else {
	      return (0, _momentTimezone2.default)().diff((0, _momentTimezone2.default)(listing.list_date), 'days');
	    }
	  };
	}).name;

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.display-owner-name', []).filter('displayOwnerName', function () {
	  return function (value) {
	    if (!value) return;
	    return value.replace(/,/g, ', ').toLowerCase();
	  };
	}).name;

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.duration', []).filter('duration', function () {
	  return function (durationInMinutes) {
	    durationInMinutes = parseInt(durationInMinutes);
	
	    if (durationInMinutes < 60) {
	      return durationInMinutes + ' minutes';
	    }
	
	    var numHours = Math.round(durationInMinutes / 60);
	    if (numHours < 24) {
	      return numHours + ' ' + (numHours === 1 ? "hour" : "hours");
	    }
	
	    var numDays = Math.round(durationInMinutes / 60 / 24);
	    if (numDays < 7) {
	      return numDays + ' ' + (numDays === 1 ? "day" : "days");
	    }
	
	    var numWeeks = Math.round(durationInMinutes / 60 / 24 / 7);
	    return numWeeks + ' ' + (numWeeks === 1 ? "week" : "weeks");
	  };
	}).name;

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.features', []).filter('features', function () {
	  return function (features, other_text) {
	    var featureString = features || '';
	    if ((0, _lodash.isArray)(features)) {
	      featureString = features.join(', ');
	    } else if ((0, _lodash.isObject)(features) && !(0, _lodash.isString)(features)) {
	      var selected_features = Object.keys((0, _lodash.pickBy)(features));
	
	      // special case "other" to pull out actual reason, IE (other=>true, other_text=>"dragons")
	      if (features.other) {
	        (0, _lodash.pull)(selected_features, "other");
	        selected_features.push(other_text || "other (unspecified)");
	      }
	
	      featureString = selected_features.join(', ');
	    }
	    return featureString.replace(/_/g, ' ');
	  };
	}).name;

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.firstName', []).filter('firstName', function () {
	  return function (input) {
	    if (!(0, _lodash.isString)(input)) return input;
	    var parts = input.trim().split(' ');
	    return (0, _lodash.startCase)(parts[0]);
	  };
	}).name;

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CDN_BASE = 'https://images.opendoor.com/source/s3/imgdrop-production';
	
	module.exports = _angular2.default.module('common.filters.image-url', []).filter('imageUrl', function () {
	  return function (fileAndParams) {
	    if (!fileAndParams) return;
	    var filename = fileAndParams.split('?')[0];
	    return CDN_BASE + '/' + filename + '?service=web';
	  };
	}).name;

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.implied-price-cents', []).filter('impliedPriceCents', function () {
	  return function (comp) {
	    return comp.listing.price_cents + (0, _lodash.sum)((0, _lodash.map)(comp.comp_adjustments, 'amount_cents'));
	  };
	}).name;

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.implied-price-per-sqft', [__webpack_require__(856)]).filter('impliedPricePerSqFt', ["impliedPriceCentsFilter", function (impliedPriceCentsFilter) {
	  return function (comp, lead) {
	    return impliedPriceCentsFilter(comp) / lead.dwellings_detail.sq_ft;
	  };
	}]).name;

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.implied-price-percentage-change', []).filter('impliedPricePercentageChange', ["impliedPriceCentsFilter", function (impliedPriceCentsFilter) {
	  return function (comp) {
	    var impliedPrice = impliedPriceCentsFilter(comp);
	    return (impliedPrice - comp.listing.price_cents) / comp.listing.price_cents;
	  };
	}]).name;

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.isNil', []).filter('isNil', function () {
	  return _lodash.isNil;
	}).name;

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.join', []).filter('join', function () {
	  return function (input, delimeter) {
	    delimeter = delimeter || ', ';
	
	    if (Array.isArray(input)) {
	      return input.join(delimeter);
	    } else {
	      return input;
	    }
	  };
	}).name;

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.kebabcase', []).filter('kebabcase', function () {
	  return function (value) {
	    if (!(0, _lodash.isNil)(value)) return (0, _lodash.kebabCase)(String(value));
	  };
	}).name;

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.length', []).filter('length', function () {
	  return function (input) {
	    if ((0, _lodash.isArray)(input)) {
	      return input.length;
	    } else if ((0, _lodash.isObject)(input)) {
	      return (0, _lodash.keys)(input).length;
	    }
	  };
	}).name;

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.listing-display-address', []).filter('listingDisplayAddress', function () {
	  return function (listing) {
	    if (listing.flip_state === 'contingencies_released') {
	      return listing.address.street.replace(/^\d+/, '').replace(/#.*$/, '');
	    } else {
	      return listing.address.street;
	    }
	  };
	}).name;

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DISPLAY_STATE_TO_LISTING_STATE = {
	  'upcoming': 'Coming Soon'
	};
	
	module.exports = _angular2.default.module('common.filters.listing-state', []).filter('listingState', ["capitalizeFilter", function (capitalizeFilter) {
	  return function (displayState) {
	    return capitalizeFilter(DISPLAY_STATE_TO_LISTING_STATE[displayState] || displayState);
	  };
	}]).name;

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.lodash-filter', []).filter('lodashFilter', function () {
	  return _lodash.filter;
	}).name;

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.map', []).filter('map', function () {
	  return _lodash.map;
	}).name;

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.min-selected', []).filter('minSelected', function () {
	  return function (value, min) {
	    return (0, _lodash.filter)(value, function (v) {
	      return v;
	    }).length < min;
	  };
	}).name;

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.moment-to-date', []).filter('momentToDate', function () {
	  return function (m) {
	    return m.toDate();
	  };
	}).name;

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _momentTimezone = __webpack_require__(517);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.moment-from-now', []).filter('momentFromNow', function () {
	  return function (m) {
	    return (0, _momentTimezone2.default)(m).fromNow();
	  };
	}).name;

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.newlines', []).filter('newlines', ["$sce", function ($sce) {
	  return function (text) {
	    if (!text) return null;
	    return $sce.trustAsHtml(text.replace(/\n/g, '<br />'));
	  };
	}]).name;

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.none-selected', []).filter('noneSelected', function () {
	  return function (value) {
	    return (0, _lodash.every)(value, function (v) {
	      return !v;
	    });
	  };
	}).name;

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('admin.filters.noop', []).filter('noop', function () {
	  return function (value) {
	    return value;
	  };
	}).name;

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.order-object-by', []).filter('orderObjectBy', ["orderByFilter", function (orderByFilter) {
	  return function (object, expression, reverse) {
	    return orderByFilter((0, _lodash.values)(object), expression, reverse);
	  };
	}]).name;

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.pluralize', []).filter('pluralize', function () {
	  return function (count, singular, plural) {
	    var showCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	    var noun = void 0;
	
	    if (Math.abs(count) === 1) {
	      noun = singular;
	    } else {
	      noun = plural;
	    }
	
	    if (showCount) {
	      return count + ' ' + noun;
	    } else {
	      return noun;
	    }
	  };
	}).name;

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.readable-list', []).filter('readableList', function () {
	  return function (list) {
	    switch ((list || []).length) {
	      case 0:
	        return '';
	      case 1:
	        return String(list[0]);
	      case 2:
	        return list.join(' and ');
	      default:
	        return list.slice(0, -1).join(', ') + ', and ' + (0, _lodash.last)(list);
	    }
	  };
	}).name;

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(877);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Distance = window.Distance;
	
	module.exports = _angular2.default.module('common.filters.relative-distance', []).filter('distance', function () {
	  return function (from, to) {
	    if (from && from.latitude && from.longitude && to && to.latitude && to.longitude) {
	      var fromObj = { lat: from.latitude, lon: from.longitude };
	      var toObj = { lat: to.latitude, lon: to.longitude };
	      return Distance.between(fromObj, toObj).human_readable_in_units('miles').toString();
	    } else {
	      return '- miles';
	    }
	  };
	}).name;

/***/ },
/* 877 */,
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.shortName', []).filter('shortName', function () {
	  return function (input) {
	    if (!(0, _lodash.isString)(input)) return input;
	    var parts = input.trim().split(' ');
	    if (parts.length > 1) {
	      return (0, _lodash.startCase)(parts[0] + ' ' + parts[parts.length - 1][0]);
	    }
	    return (0, _lodash.startCase)(parts[0]);
	  };
	}).name;

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.sign', []).filter('sign', function () {
	  return function (input) {
	    if (input < 0) {
	      return '-';
	    } else if (input > 0) {
	      return '+';
	    } else {
	      return '';
	    }
	  };
	}).name;

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.some', []).filter('some', function () {
	  return _lodash.some;
	}).name;

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.split', []).filter('split', function () {
	  return function (value, delimeter) {
	    delimeter = delimeter || '.';
	    return value.toString().split(delimeter);
	  };
	}).name;

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.status-date', []).filter('statusDate', function () {
	  return function (listing) {
	    if (listing) {
	      switch ((0, _lodash.snakeCase)(listing.listing_status)) {
	        case 'active':
	          return listing.list_date;
	        case 'pending':
	          return listing.pending_date;
	        case 'closed':
	          return listing.close_date;
	        case 'cancelled':
	          return listing.cancel_date;
	        case 'expired':
	          return listing.expiration_date;
	        case 'temp_off_market':
	          return listing.temp_off_market_date;
	      }
	    }
	    return null;
	  };
	}).name;

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.street', []).filter('street', function () {
	  return function (listing) {
	    if (!listing) return;
	
	    var street = listing.street1;
	    if (listing.unit || listing.unit === '0') {
	      street += ' #' + listing.unit;
	    }
	
	    return street;
	  };
	}).name;

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function stringifyState(filters) {
	  if (filters.active && filters.upcoming && filters.pending && filters.sold || filters.active && filters.upcoming && !filters.pending && !filters.sold) {
	    return '';
	  }
	  var stateStrings = [filters.active ? 'For sale' : undefined, filters.pending ? 'Pending' : undefined, filters.sold ? 'Sold' : undefined];
	
	  return (0, _lodash.reject)(stateStrings, _lodash.isUndefined).join(' and ');
	}
	
	// Price is stored in cents - we want to convert to thousands of dollars
	function stringifyPrice(filters) {
	  var minThousands = Math.round(filters.min_price / 100000) || undefined;
	  var maxThousands = Math.round(filters.max_price / 100000) || undefined;
	  if (minThousands && maxThousands) {
	    return '$' + minThousands + 'K\u2013$' + maxThousands + 'K';
	  } else if (minThousands) {
	    return '$' + minThousands + 'K+';
	  } else if (maxThousands) {
	    return '<$' + maxThousands + 'K';
	  }
	  return '';
	}
	
	function stringifyBedrooms(filters) {
	  if (filters.min_bedrooms) {
	    return filters.min_bedrooms + '+ beds';
	  }
	  return '';
	}
	
	function stringifyBathrooms(filters) {
	  if (filters.min_bathrooms) {
	    return filters.min_bathrooms + '+ baths';
	  }
	  return '';
	}
	
	function stringifySquareFeet(filters) {
	  if (filters.min_sq_ft) {
	    return filters.min_sq_ft + 'ft\xB2+';
	  }
	  return '';
	}
	
	function stringifyPool(filters) {
	  if (filters.pool && filters.pool !== "Any") {
	    return filters.pool.toLowerCase() + ' pool';
	  }
	}
	
	function stringifyParking(filters) {
	  if (filters.min_parking) {
	    return filters.min_parking + '+ parking spaces';
	  }
	  return '';
	}
	
	// Turns a filter object into a string
	module.exports = _angular2.default.module('common.filters.stringify-filters', []).filter('stringifyFilters', function () {
	  return function (filters) {
	    return (0, _lodash.reject)([stringifyState(filters), stringifyPrice(filters), stringifyBedrooms(filters), stringifyBathrooms(filters), stringifyPool(filters), stringifyParking(filters), stringifySquareFeet(filters)], _lodash.isEmpty).join(', ') || 'All listings';
	  };
	}).name;

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PARKING = {
	  'garage_attached': { order: 1, text: 'Attached Garage' },
	  'garage_detached': { order: 2, text: 'Detached Garage' },
	  'carport': { order: 3, text: 'Carport' },
	  'off_street': { order: 4, text: 'Off Street' },
	  'rv': { order: 5, text: 'RV' },
	  'tandem': { order: 6, text: 'Tandem' },
	  'on_street': { order: 7, text: 'Street Parking' }
	};
	
	function parkingOrder(parkingType) {
	  return PARKING[parkingType].order;
	}
	
	function parkingText(parkingType) {
	  return PARKING[parkingType].text;
	}
	
	// Turns the parking types array into a string
	module.exports = _angular2.default.module('common.filters.stringify-parking-types', []).filter('stringifyParkingTypes', function () {
	  return function (parkingTypes) {
	    return (0, _lodash.chain)(parkingTypes).sortBy(parkingOrder).map(parkingText).join(', ').value();
	  };
	}).name;

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function stringifyPrivate(poolTypes) {
	  var result = '';
	  if ((0, _lodash.includes)(poolTypes, 'private')) {
	    result = 'Private Pool';
	    if ((0, _lodash.includes)(poolTypes, 'private_spa')) {
	      result += ' with Spa';
	    }
	  } else if ((0, _lodash.includes)(poolTypes, 'private_spa')) {
	    result = 'Private Spa';
	  }
	  if (result && (0, _lodash.includes)(poolTypes, 'above_ground')) {
	    result = 'Above Ground ' + result;
	  }
	  return result;
	}
	
	function stringifyCommunity(poolTypes) {
	  if ((0, _lodash.includes)(poolTypes, 'community')) {
	    return 'Community Pool';
	  }
	  return '';
	}
	
	function stringifyShort(poolTypes) {
	  var pools = (0, _lodash.intersection)(poolTypes, ['private', 'community']);
	  if (pools.length) {
	    return (0, _lodash.map)(pools, _lodash.capitalize).sort().reverse().join(' and ');
	  }
	  if ((0, _lodash.includes)(poolTypes, 'private_spa')) {
	    return 'Spa only';
	  }
	  return 'None';
	}
	
	// Turns the pooltype array into a string
	module.exports = _angular2.default.module('common.filters.stringify-pool-types', []).filter('stringifyPoolTypes', function () {
	  return function (poolTypes, short) {
	    if (!poolTypes.length) {
	      return 'None';
	    } else {
	      if (short === 'short') {
	        return stringifyShort(poolTypes);
	      }
	      return (0, _lodash.reject)([stringifyPrivate(poolTypes), stringifyCommunity(poolTypes)], _lodash.isEmpty).join(' and '); // eslint-disable-line max-len
	    }
	  };
	}).name;

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.sum', []).filter('sum', function () {
	  return _lodash.sum;
	}).name;

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.tel-href', []).filter('telhref', function () {
	  return function (value) {
	    if (!value) return '';
	
	    var number = value.toString().trim().replace(/\D/g, '');
	    if (number[0] !== '1') number = '1' + number;
	    return 'tel://' + number;
	  };
	}).name;

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _momentTimezone = __webpack_require__(517);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.tz_format', []).filter('tzFormat', function () {
	  return function (string, format, timezone) {
	    return _momentTimezone2.default.tz(string, timezone).format(format);
	  };
	}).name;

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.uniqBy', []).filter('uniqBy', function () {
	  return _lodash.uniqBy;
	}).name;

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.url-encode', []).filter('urlEncode', function () {
	  return function (input) {
	    return window.encodeURIComponent(input);
	  };
	}).name;

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Filter to allow using a dynamic filter name (i.e. in an ng-repeat list where different
	// items use different filters)
	module.exports = _angular2.default.module('common.filters.use-filter', []).filter('useFilter', ["$filter", function ($filter) {
	  return function (value, childFilterArgs) {
	    var args = childFilterArgs.split(':');
	    var filter = $filter(args.shift());
	    args.unshift(value);
	    return filter.apply(null, args);
	  };
	}]).name;

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.valuation-route', []).filter('valuationRoute', function () {
	  function calculateToolVersion(valuation, defaultVersion) {
	    return valuation.tool_version ? valuation.tool_version : defaultVersion;
	  }
	
	  return function (valuation) {
	    var defaultVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
	
	    var toolVersion = calculateToolVersion(valuation, defaultVersion);
	    if (toolVersion === 4) {
	      return 'https://surveyor.apps.opendoor.com/web-valuation/' + valuation.id;
	    }
	    return '';
	  };
	}).name;

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.values', []).filter('values', function () {
	  return _lodash.values;
	}).name;

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _momentTimezone = __webpack_require__(517);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.years-old', []).filter('yearsOld', function () {
	  return function (year) {
	    if (!year) return;
	    return (0, _momentTimezone2.default)().year() - year;
	  };
	}).name;

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.filters.yes_no', []).filter('yesNo', function () {
	  return function (value) {
	    if (value === undefined || value === null) return '—';
	    return value ? 'Yes' : 'No';
	  };
	}).name;

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.models', [__webpack_require__(842), __webpack_require__(898), __webpack_require__(901), __webpack_require__(902), __webpack_require__(903), __webpack_require__(905), __webpack_require__(906), __webpack_require__(907), __webpack_require__(908)]).name;

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.models.human', [__webpack_require__(899)]).factory('Human', ["$resource", function ($resource) {
	  return $resource('/api/v1/me', { id: '@id' }, {
	    me: { method: 'GET' },
	    update: {
	      method: 'PUT',
	      url: '/api/v1/humans/:id'
	    },
	    remoteSignOut: {
	      method: 'GET',
	      url: '/session/remote-sign-out'
	    },
	    register: {
	      method: 'POST',
	      url: '/register'
	    },
	    acceptInvite: {
	      method: 'POST',
	      url: '/api/v1/invites/:invitation_token/accept'
	    },
	    viewInvite: {
	      method: 'GET',
	      url: '/api/v1/invites/:invitation_token'
	    }
	  });
	}]).name;

/***/ },
/* 899 */,
/* 900 */,
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.models.humanAvailability', [__webpack_require__(899)]).factory('HumanAvailability', ["odResource", function (odResource) {
	  return odResource('/api/v1/humans/:human_id/availabilities/:id', {
	    human_id: '@human_id',
	    id: '@id'
	  }, {
	    update: {
	      method: 'PATCH',
	      toast: {
	        error: 'Failed to update availability',
	        success: 'Updated availability'
	      }
	    },
	    save: {
	      method: 'POST',
	      toast: {
	        error: 'Failed to save availability',
	        success: 'Successfully scheduled availability'
	      }
	    }
	  });
	}]).name;

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.models.humanUnavailability', [__webpack_require__(899)]).factory('HumanUnavailability', ["odResource", function (odResource) {
	  return odResource('/api/v1/humans/:human_id/unavailabilities/:id', {
	    human_id: '@human_id',
	    id: '@id'
	  }, {
	    save: {
	      method: 'POST',
	      toast: {
	        success: 'Created availability exception',
	        error: 'Could not create availability exception'
	      }
	    },
	    delete: {
	      method: 'DELETE',
	      toast: {
	        success: 'Removed availablility exception',
	        error: 'Coule not remove availability exception'
	      }
	    }
	
	  });
	}]).name;

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _parseListingConcession = __webpack_require__(904);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.models.listing', [__webpack_require__(499)]).factory('Listing', ["Addresses", "odResource", function (Addresses, odResource) {
	  return odResource(Addresses.BASE_DWELLINGS_URL + '/search', null, {
	    query: {
	      method: 'POST',
	      isArray: true,
	      toast: { wait: 'Loading…' },
	      transformResponse: function transformResponse(data) {
	        if (!data) data = "[]"; // in tests the data doesn't come back
	        var listings = _angular2.default.fromJson(data);
	        return listings.map(function (listing) {
	          listing.price = listing.close_price || listing.list_price;
	          listing.price_cents = listing.price * 100;
	          listing.price_cents_per_sq_ft = listing.price_cents / listing.sq_ft;
	          listing.coordinates = { lat: listing['lat'], lng: listing['lng'] };
	          return addConcessionsFields(listing);
	        });
	      }
	    }
	  });
	
	  function addConcessionsFields(listing) {
	    // Adds {buyer, seller}_concession_{amont_cents, percentage} to listing if available
	    return _extends({}, listing, (0, _parseListingConcession.parseConcessions)(listing, 'buyer'), (0, _parseListingConcession.parseConcessions)(listing, 'seller'));
	  }
	}]).name;

/***/ },
/* 904 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseConcessions = parseConcessions;
	exports.parseNetConcessionAmountCents = parseNetConcessionAmountCents;
	function parseConcessions(listing, actor) {
	  var amount = +listing[actor + '_concession_amount'],
	      unit = listing[actor + '_concession_unit'],
	      closePrice = +listing.close_price,
	      concessions = {};
	
	  if (amount && unit && closePrice) {
	    var formattedAmountField = actor + '_concession_amount_cents',
	        formattedAmountPercentage = actor + '_concession_percentage';
	
	    if (unit === '$') {
	      concessions[formattedAmountField] = amount * 100;
	      concessions[formattedAmountPercentage] = amount / closePrice;
	    } else if (unit === '%') {
	      concessions[formattedAmountField] = amount * closePrice;
	      concessions[formattedAmountPercentage] = amount;
	    }
	  }
	
	  return concessions;
	}
	
	function parseNetConcessionAmountCents(listing) {
	  var sellerConcessions = parseConcessions(listing, 'seller'),
	      buyerConcessions = parseConcessions(listing, 'buyer');
	  return (sellerConcessions.seller_concession_amount_cents || 0) - (buyerConcessions.buyer_concession_amount_cents || 0);
	}

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.models.responser', []).factory('Responser', ["$http", function ($http) {
	  return {
	    appendTransform: function appendTransform(fn) {
	      var defaults = $http.defaults.transformResponse;
	      defaults = _angular2.default.isArray(defaults) ? defaults : [defaults];
	
	      return defaults.concat(fn);
	    }
	  };
	}]).name;

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.models.session', [__webpack_require__(899), __webpack_require__(898), __webpack_require__(905)]).factory('Session', ["$resource", "$http", "Human", "Responser", function ($resource, $http, Human, Responser) {
	  var transformer = Responser.appendTransform(function (result) {
	    return { logged_in: !!result.id, human: new Human(result) };
	  });
	
	  var Session = $resource('/api/v1/me', {}, {
	    info: {
	      method: 'GET',
	      url: '/session/info',
	      transformResponse: Responser.appendTransform(function (result) {
	        if (result && result.human) result.human = new Human(result.human);
	        return result;
	      })
	    },
	    me: {
	      method: 'GET',
	      url: '/api/v1/me',
	      transformResponse: transformer
	    },
	    login: {
	      method: 'POST',
	      url: '/login',
	      transformResponse: transformer
	    },
	    logout: {
	      method: 'DELETE',
	      url: '/logout',
	      transformResponse: function transformResponse() {
	        return {};
	      } // clear the credential
	    }
	  });
	
	  return Session;
	}]).name;

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.models.subscription', [__webpack_require__(899)]).factory('Subscription', ["$resource", function ($resource) {
	  return $resource('/api/v1/subscriptions');
	}]).name;

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable no-unused-vars */
	
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('common.models.ugm-summary', []).factory('ugmSummary', function () {
	  var UgmCategory = function () {
	    function UgmCategory(name, fields) {
	      _classCallCheck(this, UgmCategory);
	
	      this.name = name;
	      this.fields = fields;
	    }
	
	    _createClass(UgmCategory, [{
	      key: 'getTotal',
	      value: function getTotal(uea, offer, isAtUnderwriting) {
	        return (0, _lodash.sumBy)(this.fields, function (field) {
	          return field.value(uea, offer, isAtUnderwriting);
	        });
	      }
	    }]);
	
	    return UgmCategory;
	  }();
	
	  return [new UgmCategory('Opendoor Fee', [{
	    name: 'Opendoor Fee',
	    value: function value(uea, offer, isAtUnderwriting) {
	      return (0, _lodash.toNumber)(isAtUnderwriting ? uea.underwriting_fee_cost_cents : offer.fee_cost_cents);
	    }
	  }]), new UgmCategory('Accuracy Gain/Loss', [{
	    name: 'ARV',
	    value: function value(uea, offer, isAtUnderwriting) {
	      return (0, _lodash.toNumber)(isAtUnderwriting ? uea.uw_post_repair_valuation_cents : offer.post_repairs_valuation_cents);
	    }
	  }, {
	    name: 'Purchase Price',
	    value: function value(uea, offer, isAtUnderwriting) {
	      return -(0, _lodash.toNumber)(isAtUnderwriting ? uea.underwriting_recorded_price_cents : offer.recorded_price_cents);
	    }
	  }, {
	    // Broken out so that we do not bias underwriters with a resale price higher than their
	    // submitted ARV.
	    name: 'Val Cost (Val Gain, RBP)',
	    value: function value(uea, offer, isAtUnderwriting) {
	      return (0, _lodash.toNumber)(uea.cost_valuation_cents);
	    }
	  }, {
	    name: 'Seller Credit',
	    // Exclude Repair credits here because it's counted separately.
	    value: function value(uea, offer, isAtUnderwriting) {
	      return (0, _lodash.toNumber)(uea.addendum_unit_total_cents - uea.credit_repairs_cents);
	    }
	  }, {
	    name: 'Seller Marketing Cost',
	    value: function value(uea, offer, isAtUnderwriting) {
	      return (0, _lodash.toNumber)(uea.cost_seller_marketing_cents);
	    }
	  }, {
	    name: 'Renovation Costs',
	    value: function value(uea, offer, isAtUnderwriting) {
	      return (0, _lodash.toNumber)(uea.cost_renovations_cents);
	    }
	  }]), new UgmCategory('Net Repair Gain/Loss', [{
	    name: 'Repair Credits',
	    value: function value(uea, offer, isAtUnderwriting) {
	      return (0, _lodash.toNumber)(uea.credit_repairs_cents);
	    }
	  }, {
	    name: 'Repair Costs',
	    value: function value(uea, offer, isAtUnderwriting) {
	      return (0, _lodash.toNumber)(uea.cost_repairs_cents);
	    }
	  }, {
	    name: 'BRN',
	    value: function value(uea, offer, isAtUnderwriting) {
	      return (0, _lodash.toNumber)(uea.cost_brn_cents);
	    }
	  }]), new UgmCategory('Holding Costs', [{
	    name: 'Holding Costs',
	    value: function value(uea, offer, isAtUnderwriting) {
	      return (0, _lodash.toNumber)(uea.cost_holding_cents);
	    }
	  }]), new UgmCategory('Transaction Costs', [{
	    name: 'Acquisition Costs',
	    value: function value(uea, offer, isAtUnderwriting) {
	      return (0, _lodash.toNumber)(uea.cost_acquisition_cents);
	    }
	  }, {
	    name: 'Resale Costs',
	    value: function value(uea, offer, isAtUnderwriting) {
	      return (0, _lodash.toNumber)(uea.cost_resale_cents);
	    }
	  }]), new UgmCategory('Resale Broker Commissions', [{
	    name: 'Resale Broker Commissions',
	    value: function value(uea, offer, isAtUnderwriting) {
	      return (0, _lodash.toNumber)(uea.cost_resale_broker_commissions_cents);
	    }
	  }])];
	}).name;

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.services', [__webpack_require__(910), __webpack_require__(911), __webpack_require__(912), __webpack_require__(914), __webpack_require__(915), __webpack_require__(916), __webpack_require__(689), __webpack_require__(917), __webpack_require__(918), __webpack_require__(919), __webpack_require__(920), __webpack_require__(921), __webpack_require__(922), __webpack_require__(499), __webpack_require__(502), __webpack_require__(923), __webpack_require__(924), __webpack_require__(925), __webpack_require__(926), __webpack_require__(781), __webpack_require__(927), __webpack_require__(929), __webpack_require__(930)]).name;

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.services.accounting-buckets-by-kind', []).factory('accountingBucketsByKind', ["allAvailableAccounts", function (allAvailableAccounts) {
	  var sortedAccountingBuckets = (0, _lodash.sortBy)(allAvailableAccounts, 'account');
	  var groupedAccountingBuckets = (0, _lodash.groupBy)(sortedAccountingBuckets, function (acc) {
	    return acc.account.split('.')[0];
	  });
	  return groupedAccountingBuckets;
	}]).name;

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('admin.services.address-client', ['server.common-constants']).factory('AddressClient', ["Addresses", "$http", "$q", function (Addresses, $http, $q) {
	  var ADDRESS_URI = Addresses.BASE_DWELLINGS_URL + '/api/v1/addresses/';
	  var TRANSACTION_COUNT_URI = Addresses.BASE_DWELLINGS_URL + '/api/v1/agents/transaction_count';
	  var INFO_SUFFIX = 'info';
	  var INFO_PARAMS = ['address_token', 'street1', 'unit', 'city', 'state', 'postal_code'];
	
	  var transformResponse = function transformResponse(httpPromise) {
	    return httpPromise.then(function (result) {
	      return result.data;
	    }).catch(function (err) {
	      if (err.status === 404) {
	        return {};
	      }
	      return $q.reject(err);
	    });
	  };
	
	  var AddressClient = function () {
	    function AddressClient() {
	      _classCallCheck(this, AddressClient);
	    }
	
	    _createClass(AddressClient, [{
	      key: 'info',
	      value: function info(address) {
	        var params = { params: (0, _lodash.pick)(address, INFO_PARAMS) };
	        return transformResponse($http.get(ADDRESS_URI + INFO_SUFFIX, params));
	      }
	    }, {
	      key: 'transactionCount',
	      value: function transactionCount(phone_number, email, startDate, endDate) {
	        var params = { phone_number: phone_number, email: email, start: startDate, end: endDate };
	        return transformResponse($http.get(TRANSACTION_COUNT_URI, { params: params }));
	      }
	    }]);
	
	    return AddressClient;
	  }();
	
	  return new AddressClient();
	}]).name;

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _ravenJs = __webpack_require__(645);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	var _isQuotaExceededError = __webpack_require__(913);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapQuotaError = function wrapQuotaError(cb) {
	  try {
	    cb();
	  } catch (e) {
	    if (!(0, _isQuotaExceededError.isQuotaExceededError)(e)) {
	      _ravenJs2.default.captureException(e);
	    }
	  }
	}; /* global ga:false  */
	
	
	module.exports = _angular2.default.module('common.services.analytics', [__webpack_require__(600)]).factory('Analytics', ["$rootScope", "$http", "Segment", function ($rootScope, $http, Segment) {
	  return {
	    event: function event(category, action, label, extra) {
	      wrapQuotaError(function () {
	        // https://developers.google.com/analytics/devguides/collection/analyticsjs/events
	        if (typeof ga === 'function') {
	          ga('send', 'event', category, action, label, extra);
	        }
	      });
	
	      wrapQuotaError(function () {
	        // https://segment.com/docs/spec/track/
	        Segment.track(label, extra);
	      });
	
	      wrapQuotaError(function () {
	        // https://support.google.com/tagmanager/answer/6106961?hl=en
	        window.dataLayer = window.dataLayer || [];
	        window.dataLayer.push({ event: category + '.' + action + '.' + label, extra: extra });
	      });
	    },
	    aliasAndIdentify: function aliasAndIdentify(id) {
	      Segment.identify(id);
	    },
	    register: function register(traits) {
	      if (typeof ga === 'function') {
	        ga('set', traits);
	      }
	
	      Segment.identify(traits);
	    }
	  };
	}]).run(["$rootScope", "Analytics", function ($rootScope, Analytics) {
	  $rootScope.$on('$stateChangeSuccess', function (e, to) {
	    var remove = $rootScope.$on('$viewContentLoaded', function () {
	      Analytics.event('state', 'change', to.name);
	      remove();
	    });
	  });
	}]).name;

/***/ },
/* 913 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// http://crocodillon.com/blog/always-catch-localstorage-security-and-quota-exceeded-errors
	// https://opendoor.atlassian.net/browse/BUGS-174
	var isQuotaExceededError = exports.isQuotaExceededError = function isQuotaExceededError(e) {
	  var quotaExceeded = false;
	  if (e) {
	    if (e.code) {
	      switch (e.code) {
	        case 22:
	          quotaExceeded = true;
	          break;
	        case 1014:
	          // Firefox
	          if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
	            quotaExceeded = true;
	          }
	          break;
	      }
	    } else if (e.number === -2147024882) {
	      // Internet Explorer 8
	      quotaExceeded = true;
	    }
	  }
	  return quotaExceeded;
	};

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NO_REDIRECT_STATES = ['account', 'offer.account', 'offer.invitee', 'offer.login', 'humans.login', 'humans.account'];
	
	module.exports = _angular2.default.module('common.services.auth-handler', []).factory('AuthHandler', ["$q", "$injector", "$rootScope", function ($q, $injector, $rootScope) {
	  return {
	    responseError: function responseError(rejection) {
	      if ($rootScope.inloginSignupModal) {
	        // no-op
	        return $q.reject(rejection);
	      }
	      if (rejection.status === 401) {
	        var currentState = $injector.get('$state').$current.name;
	        if (!(0, _lodash.includes)(NO_REDIRECT_STATES, currentState)) {
	          window.location = '/login';
	        }
	      }
	      return $q.reject(rejection);
	    }
	  };
	}]).config(["$httpProvider", function ($httpProvider) {
	  $httpProvider.interceptors.push('AuthHandler');
	}]).name;

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.services.autocomplete-to-address', []).factory('autocompleteToAddress', function () {
	  return function (autocomplete, address) {
	    address = address || {};
	
	    _angular2.default.forEach(autocomplete.address_components, function (component) {
	      switch (component.types[0]) {
	        case 'street_number':
	          address.street1 = component.short_name;
	          break;
	        case 'route':
	          address.street1 += ' ' + component.short_name;
	          break;
	        case 'locality':
	          address.city = component.long_name;
	          break;
	        case 'administrative_area_level_1':
	          address.state = component.short_name;
	          break;
	        case 'postal_code':
	          address.postal_code = component.short_name;
	          break;
	        default:
	      }
	    });
	
	    address.latitude = autocomplete.geometry.location.lat();
	    address.longitude = autocomplete.geometry.location.lng();
	
	    return address;
	  };
	}).name;

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.services.dropdown_label', []).factory('dropdownLabel', function () {
	  return function dropdownLabel(setFilter, options) {
	    var active = (0, _lodash.filter)(options, function (option) {
	      return setFilter[option.value];
	    });
	
	    switch (active.length) {
	      case 0:
	      case options.length:
	        return 'Any';
	      case 1:
	        return active[0].name;
	      default:
	        return 'Multiple…';
	    }
	  };
	}).name;

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.services.formatted-cursor-position', []).factory('formattedCursorPosition', function () {
	  return function (oldCursorPosition, oldValue, newValue) {
	    // Move the cursor as far right as possible such that it will have the same
	    // number of digits to its left as before
	    var beforeCursorText = oldValue.toString().substr(0, oldCursorPosition);
	    var beforeCursorDigitCount = beforeCursorText.replace(/\D/g, '').length;
	    var cursorPositionRegex = new RegExp('^\\D*(\\d\\D*){' + beforeCursorDigitCount + '}');
	    var match = newValue.match(cursorPositionRegex);
	
	    return match ? match[0].length : newValue.length;
	  };
	}).name;

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.services.hoa-frequencies', []).factory('HOA_FREQUENCIES', function () {
	  return ['One-off', 'Monthly', 'Quarterly', 'Semi-Annually', 'Annually'];
	}).name;

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var INSPECTOR_ROLE_TO_DOCUMENT_TYPE_MAPPING = {
	  'foundation': 'inspection_report_foundation',
	  'hvac': 'inspection_report_hvac',
	  'inspector': 'inspection_report_general',
	  'other': 'inspection_report_other',
	  'pool': 'inspection_report_pool',
	  'roof': 'inspection_report_roof',
	  'termite': 'inspection_report_termite',
	  'plumbing': 'inspection_report_plumbing',
	  'electrical': 'inspection_report_electrical'
	};
	
	module.exports = _angular2.default.module('common.services.inspector_role_to_document_type', []).service('InspectorRoleToDocumentType', function () {
	  function _class() {
	    _classCallCheck(this, _class);
	  }
	
	  _createClass(_class, [{
	    key: 'getDocumentTypeForInspectionReport',
	    value: function getDocumentTypeForInspectionReport(inspectionReport) {
	      return INSPECTOR_ROLE_TO_DOCUMENT_TYPE_MAPPING[inspectionReport.role] || 'misc';
	    }
	  }]);
	
	  return _class;
	}()).name;

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// A clone of https://material.angularjs.org/latest/api/service/$mdMedia
	
	// Breakpoints from `common/variables.less`
	var MEDIA = {
	  'xxs': '(max-width: 479px)',
	  'gt-xxs': '(min-width: 480px)',
	  'xs': '(min-width: 480px) and (max-width: 767px)',
	  'gt-xs': '(min-width: 768px)',
	  'sm': '(min-width: 768px) and (max-width: 991px)',
	  'gt-sm': '(min-width: 992px)',
	  'md': '(min-width: 992px) and (max-width: 1199px)',
	  'gt-md': '(min-width: 1200px)',
	  'lg': '(min-width: 1200px)'
	};
	
	var MEDIA_PRIORITY = ['lg', 'gt-md', 'md', 'gt-sm', 'sm', 'gt-xs', 'xs', 'gt-xxs', 'xxs'];
	
	module.exports = _angular2.default.module('common.services.media-query', []).factory('$mediaQuery', ["$rootScope", "$window", function mediaQueryFactory($rootScope, $window) {
	  var queries = {};
	  var mqls = {};
	  var results = {};
	  var normalizeCache = {};
	
	  $mediaQuery.getResponsiveAttribute = getResponsiveAttribute;
	  $mediaQuery.getQuery = getQuery;
	  $mediaQuery.watchResponsiveAttributes = watchResponsiveAttributes;
	
	  return $mediaQuery;
	
	  function $mediaQuery(query) {
	    var validated = queries[query];
	    if (_angular2.default.isUndefined(validated)) {
	      validated = queries[query] = validate(query);
	    }
	
	    var result = results[validated];
	    if (_angular2.default.isUndefined(result)) {
	      result = add(validated);
	    }
	
	    return result;
	  }
	
	  function validate(query) {
	    return MEDIA[query] || (query.charAt(0) !== '(' ? '(' + query + ')' : query);
	  }
	
	  function add(query) {
	    var result = mqls[query];
	    if (!result) {
	      result = mqls[query] = $window.matchMedia(query);
	    }
	
	    result.addListener(onQueryChange);
	    return results[result.media] = !!result.matches;
	  }
	
	  function onQueryChange(query) {
	    $rootScope.$evalAsync(function () {
	      results[query.media] = !!query.matches;
	    });
	  }
	
	  function getQuery(name) {
	    return mqls[name];
	  }
	
	  function getResponsiveAttribute(attrs, attrName) {
	    for (var i = 0; i < MEDIA_PRIORITY.length; i++) {
	      var mediaName = MEDIA_PRIORITY[i];
	      if (!mqls[queries[mediaName]].matches) {
	        continue;
	      }
	
	      var normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
	      if (attrs[normalizedName]) {
	        return attrs[normalizedName];
	      }
	    }
	
	    // fallback on unprefixed
	    return attrs[getNormalizedName(attrs, attrName)];
	  }
	
	  function watchResponsiveAttributes(attrNames, attrs, watchFn) {
	    var unwatchFns = [];
	    attrNames.forEach(function (attrName) {
	      var normalizedName = getNormalizedName(attrs, attrName);
	      if (_angular2.default.isDefined(attrs[normalizedName])) {
	        unwatchFns.push(attrs.$observe(normalizedName, _angular2.default.bind(void 0, watchFn, null)));
	      }
	
	      for (var mediaName in MEDIA) {
	        normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
	        if (_angular2.default.isDefined(attrs[normalizedName])) {
	          unwatchFns.push(attrs.$observe(normalizedName, _angular2.default.bind(void 0, watchFn, mediaName)));
	        }
	      }
	    });
	
	    return function unwatch() {
	      unwatchFns.forEach(function (fn) {
	        fn();
	      });
	    };
	  }
	
	  // Improves performance dramatically
	  function getNormalizedName(attrs, attrName) {
	    return normalizeCache[attrName] || (normalizeCache[attrName] = attrs.$normalize(attrName));
	  }
	}]).run(["$rootScope", "$mediaQuery", function ($rootScope, $mediaQuery) {
	  $rootScope.$mediaQuery = $mediaQuery;
	}]).name;

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _parseUrlParams = __webpack_require__(813);
	
	var _parseUrlParams2 = _interopRequireDefault(_parseUrlParams);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.services.paginate', []).factory('paginate', ["$http", function ($http) {
	  var REL_REG = /rel=['"](.*?)["']/,
	      HREF_REG = /<(.*?)>/,
	      REPLACE = 'replace',
	      APPEND = 'append',
	      // eslint-disable-line no-unused-vars
	  GREEDY = 'greedy';
	
	  return function (paginatorMode, resourceParams, itemTransformFn) {
	    return function (results, headerFn) {
	      if (_angular2.default.isArray(results) && results.length) {
	        var klass = results[0].constructor;
	        results.$paginator = new Paginator(klass, results, headerFn(), paginatorMode, resourceParams, itemTransformFn);
	      } else {
	        delete results.$paginator;
	        return results;
	      }
	    };
	  };
	
	  // paginator mode replace || append. Only use append if you're doing a more link
	  //
	  // @example
	  //   Valuator.for_valuator({id: 5}, paginate()); // replaces
	  //   Lead.summaries({}, paginate('append'));
	  //
	  //   leads.$paginator.$next
	  //   leads.$paginator.$next()
	  function Paginator(klass, values, headers, paginatorMode, resourceParams, itemTransformFn) {
	    this.mode = paginatorMode || REPLACE;
	    this.klass = klass;
	    this.actionName = values.$actionName;
	    this.values = values;
	    this.resourceParams = resourceParams || {};
	    this.page = 1;
	    this.itemTransformFn = itemTransformFn;
	    this.reqInProgress = false;
	
	    // mutable transformation since results.$paginator.values === results
	    if (itemTransformFn) {
	      values.forEach(function (item, index) {
	        values[index] = itemTransformFn(item);
	      });
	    }
	
	    updateFromHeaders.call(this, headers);
	
	    if (paginatorMode === GREEDY) {
	      greedyCrawler.call(this);
	    }
	
	    this.greedyCrawler = greedyCrawler.bind(this);
	  }
	
	  function updateFromHeaders(headers) {
	    this.total = headers['x-total'];
	    this.perPage = headers['x-per-page'];
	    addLinkAccessors.call(this, parseLinkHeaders(headers.link));
	  }
	
	  function greedyCrawler() {
	    var _this = this;
	
	    if (!this.$next) {
	      return Promise.resolve();
	    }
	    return this.$next().then(function () {
	      return greedyCrawler.call(_this);
	    });
	  }
	
	  function addLinkAccessors(links) {
	    this.links = links;
	    if (!links) return;
	
	    links.forEach(function (link) {
	      this['$' + link.rel] = followLinkFactory.call(this, link);
	    }, this);
	  }
	
	  function removeLinkAccessors() {
	    if (!this.links) return;
	
	    this.links.forEach(function (link) {
	      delete this['$' + link.rel];
	    }, this);
	
	    delete this.links;
	  }
	
	  function updateValues(data, headers) {
	    var _this2 = this;
	
	    removeLinkAccessors.call(this);
	    updateFromHeaders.call(this, headers);
	    if (this.mode === REPLACE) this.values.splice(0, this.values.length);
	
	    var newValues = data.map(function (point) {
	      var item = new _this2.klass(point);
	      if (_this2.itemTransformFn) {
	        return _this2.itemTransformFn(item);
	      }
	      return item;
	    });
	
	    Array.prototype.push.apply(this.values, newValues);
	    return data;
	  }
	
	  function followLinkFactory(link) {
	    var _this3 = this;
	
	    if (this.actionName) {
	      return function () {
	        // prevent dup requests
	        if (_this3.reqInProgress) {
	          return;
	        }
	        _this3.reqInProgress = true;
	
	        var params = (0, _lodash.merge)({}, link.params, _this3.resourceParams);
	        return _this3.klass[_this3.actionName](params, function (data, headers) {
	          _this3.reqInProgress = false;
	          return updateValues.call(_this3, data, headers());
	        }).$promise;
	      };
	    }
	
	    return function () {
	      // prevent dup requests
	      if (_this3.reqInProgress) {
	        return;
	      }
	      _this3.reqInProgress = true;
	
	      return $http.get(link.href).then(function (data, status, headers) {
	        _this3.reqInProgress = false;
	        return updateValues.call(_this3, data, headers());
	      });
	    };
	  }
	
	  function parseLinkHeaders(strings) {
	    var links = [];
	    if (!strings) return links;
	
	    var parts = strings.split(',');
	    var rel, href;
	
	    parts.forEach(function (part) {
	      rel = part.match(REL_REG);
	      href = part.match(HREF_REG);
	      if (!rel || !href) return;
	
	      var urlParams = (0, _parseUrlParams2.default)(href[1]);
	      links.push({ rel: rel[1], href: href[1], params: urlParams });
	    });
	    return links;
	  }
	}]).name;

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.services.renovation_service_account_types', []).value('renovationServiceAccountTypes', ['internet', 'electricity', 'water', 'gas', 'sewage', 'trash']).name;

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.services.subtotal', []).value('subtotal', function (adjustments) {
	  return (0, _lodash.sumBy)(adjustments, 'amount_cents');
	}).name;

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.services.third-party-library-integrations', [__webpack_require__(600)]).factory('optimizely', function () {
	  window.optimizely = window.optimizely || [];
	  return window.optimizely;
	}).run(["$rootScope", "$document", "$window", "optimizely", function ($rootScope, $document, $window, optimizely) {
	  var remove = void 0;
	  $rootScope.$on('$stateChangeSuccess', function (e, to) {
	    // Remove any previous `$viewContentLoaded` event listeners on $rootScope on the next state
	    // change so that it won't grow indefinitely. We don't want to remove it right after the first
	    // $viewContentLoaded event is fired because multiple get fired on each state change and we
	    // need to catch the last one to ensure Optimizely has all the content to modify.
	    if (remove) {
	      remove();
	    }
	
	    remove = $rootScope.$on('$viewContentLoaded', function () {
	      optimizely.push(['activate']);
	    });
	
	    // Instead of initializing Branch on page load and relying solely on it recognizing URL changes
	    // to show or hide the banner, we determine ourselves whether to remove or initialize it on
	    // every `$stateChangeSuccess`.
	    var BRANCH_CLIENT_SIDE_KEY = 'key_live_nhwpsaI8sYEkp1XQUKyyEafdDBesEuk2';
	    var branchBanner = $document[0].getElementById('branch-banner-iframe');
	
	    // need to disable for homes.show.prelisting,
	    // but it needs to skip homes.show as well, which is prelisting's parent state
	    // page doesn't render during the transition to homes.show.prelisting,
	    // so to.name != 'homes.show.prelisting' alone doesn't prevent branchBanner showing up,
	    // and we should proactively prevent adding the iframe in homes.show
	    if (to && to.name.match(/^homes\./) && to.name != 'homes.show' && to.name != 'homes.show.prelisting') {
	      if ($window.branch && !branchBanner) {
	        $window.branch.init(BRANCH_CLIENT_SIDE_KEY);
	      }
	    } else if (branchBanner) {
	      $document[0].body.removeChild(branchBanner);
	    }
	  });
	}]).name;

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('common.services.segment', []).service('Segment', function () {
	  function _class() {
	    _classCallCheck(this, _class);
	  }
	
	  _createClass(_class, [{
	    key: 'identify',
	    value: function identify(id) {
	      if (!window.segment) {
	        this.logUndefined();
	        return;
	      }
	
	      window.segment.identify(id);
	    }
	  }, {
	    key: 'track',
	    value: function track(eventName) {
	      var eventProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (!window.segment) {
	        this.logUndefined();
	        return;
	      }
	
	      var formattedEventProperties = _extends({
	        screen: {
	          height: window.screen.height,
	          width: window.screen.width
	        }
	      }, eventProperties);
	
	      if (window.segmentChannel) {
	        formattedEventProperties.channel = window.segmentChannel;
	      }
	
	      window.segment.track(eventName, formattedEventProperties);
	    }
	
	    // If you pass one argument, it's assumed to be the page name.
	    // If you pass two, the first is the category and the second is the name.
	
	  }, {
	    key: 'page',
	    value: function page(categoryOrName, name) {
	      if (!window.segment) {
	        this.logUndefined();
	        return;
	      }
	
	      window.segment.page(categoryOrName, name);
	    }
	  }, {
	    key: 'logUndefined',
	    value: function logUndefined() {
	      console.warn('Segment is not defined!!!');
	    }
	  }]);
	
	  return _class;
	}()).name;

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Adds a $timeout helper to $rootScope to be used in views to evalulate
	// expressions after a given timeout. Useful for creating things after a delay:
	//
	// tab(heading='Map' select='$timeout("map=true")')
	//   ov-comparables-map(
	//     valuation='valuations_show.valuation'
	//     address='valuations_show.valuation.address'
	//     listings='[valuations_show_adjustments.comp.listing]'
	//     ng-if='map'
	//   )
	module.exports = _angular2.default.module('common.services.timeout', []).run(["$rootScope", "$timeout", function ($rootScope, $timeout) {
	  $rootScope.$timeout = function (expression, delay) {
	    var _this = this;
	
	    $timeout(function () {
	      _this.$eval(expression);
	    }, delay);
	  };
	}]).name;

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _workCalendar = __webpack_require__(928);
	
	var _workCalendar2 = _interopRequireDefault(_workCalendar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.services.weekday-work-calendar', []).factory('weekdayWorkCalendar', function () {
	  var opts = {
	    workdays: 'mon..fri',
	    holidays: ['1/1', '7/4', '12/25']
	  };
	  return new _workCalendar2.default(opts);
	}).name;

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _momentTimezone = __webpack_require__(517);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	    DEFAULT_WORKDAYS = 'Mon..Sat';
	var dayLookup = {};
	
	/**
	 * Provides helper functions for working with working days.
	 *
	 * Specify the days of week to consider 'working' and add any holidays.
	 *
	 * example: Set working days
	 * { workdays: 'mon..sat' } // monday through saturday (including saturday)
	 * { workdays: ['mon', 'tue', 'wed', thur'] } // monday through thursday
	 * { workdays: ['Monday', 'Wednesday', 'Friday'] // just as it says
	 *
	 * Use these as an argument when constructing the work calendar
	 * new WorkCalendar({ workdays: 'mon..sat'});
	 *
	 * example: Set holidays
	 *
	 * Holidays can be set as month/day pairs, or functions
	 * { holidays: ['12/25', 1/1'] }
	 * { holidays: [function(date) { return findMyHolidays(date); }] }
	 *
	 * A day is considered a holiday if any of the specified holidays are true
	 *
	 * new WorkCalendar({workdays: 'mon..fri', holidays: ['1/1']});
	 *
	 * Do some calculations!
	 *
	 * // true if the date falls on a workday
	 * workCalendar.isWorkday(someDate);
	 * // Today if today is a workday. Otherwise rolls forward till it finds one.
	 * workCalendar.closestWorkday(someDate, 5);
	 * // never today, rolls forward till it finds the next N workdays
	 * workCalendar.workdaysAfter(someDate, 5);
	 * // never today, rolls backward till it finds the previous N workdays
	 * workCalendar.workdaysBefore(someDate, 5);
	 **/
	function WorkCalendar(config) {
	  config = config || {};
	  this.workdays = parseWorkdays(config.workdays);
	  this.holidays = parseHolidays(config.holidays);
	}
	
	WorkCalendar.prototype.isWorkday = function (date) {
	  if (isUnset(date)) return false;
	  date = asDateTime(date);
	
	  var day = date.getDate && date.getDate() || date.day && date.day();
	
	  // Check if this is a holday
	  if (this.workdays.indexOf(day) < 0) return false;
	  return !this.isHoliday(date);
	};
	
	WorkCalendar.prototype.isHoliday = function (date) {
	  for (var i = 0; i < this.holidays.length; i++) {
	    if (this.holidays[i](date)) return true;
	  }
	  return false;
	};
	
	WorkCalendar.prototype.closestWorkday = function (date) {
	  if (isUnset(date)) return undefined;
	  date = asDateTime(date);
	
	  if (this.isWorkday(date)) return date;
	  return rollForwardWorkday(date, this);
	};
	
	WorkCalendar.prototype.workdaysAfter = function (date, days) {
	  if (isUnset(date)) return undefined;
	  date = asDateTime(date);
	
	  for (var i = 0; i < days; i++) {
	    date = rollForwardWorkday(date, this);
	  }
	
	  if (!this.isWorkday(date)) date = rollForwardWorkday(date, this);
	  return date;
	};
	
	WorkCalendar.prototype.workdaysBefore = function (date, days) {
	  if (isUnset(date)) return undefined;
	  date = asDateTime(date);
	
	  for (var i = 0; i < days; i++) {
	    date = rollBackWorkday(date, this);
	  }
	
	  if (!this.isWorkday(date)) date = rollBackWorkday(date, this);
	  return date;
	};
	
	// Utility functions
	function rollForwardWorkday(date, calendar) {
	  date = asDateTime(date);
	  do {
	    date = addDay(date);
	  } while (!calendar.isWorkday(date));
	  return date;
	}
	
	function rollBackWorkday(date, calendar) {
	  date = asDateTime(date);
	  do {
	    date = subtractDay(date);
	  } while (!calendar.isWorkday(date));
	  return date;
	}
	
	function isUnset(value) {
	  return value === null || value === undefined || isNaN(value);
	}
	
	function asDateTime(thing) {
	  if (typeof _momentTimezone2.default !== 'undefined') {
	    return (0, _momentTimezone2.default)(thing).clone();
	  } else {
	    if (typeof thing === 'string') {
	      return new Date(Date.parse(thing));
	    } else {
	      return new Date(thing);
	    }
	  }
	}
	
	function addDay(date) {
	  if (typeof _momentTimezone2.default !== 'undefined') {
	    return (0, _momentTimezone2.default)(date).add(1, 'day');
	  } else {
	    return new Date(date.getTime() + 24 * 60 * 60 * 1000);
	  }
	}
	
	function subtractDay(date) {
	  if (typeof _momentTimezone2.default !== 'undefined') {
	    return (0, _momentTimezone2.default)(date).subtract(1, 'day');
	  } else {
	    return new Date(date.getTime() - 24 * 60 * 60 * 1000);
	  }
	}
	
	// Lookup the day index. Memoized to prevent molasis
	function dayIdxLookup(stringOrNumber) {
	  if (dayLookup[stringOrNumber]) return dayLookup[stringOrNumber];
	  if (stringOrNumber === undefined) return undefined;
	  if (stringOrNumber === null) return undefined;
	  if (DAYS[stringOrNumber]) return dayLookup[stringOrNumber] = stringOrNumber;
	
	  var i = 0,
	      day,
	      found = false;
	  for (; i < DAYS.length; i++) {
	    day = DAYS[i];
	    found = day.toLowerCase().indexOf(stringOrNumber.toString().toLowerCase()) === 0;
	    if (found) break;
	  }
	  if (found) return dayLookup[stringOrNumber] = i;
	}
	
	// Parses the workdays as provided in the WorkCalendar constructor
	// @param workdays - String describing range. e.g. 'mon..sat' -> Monday through Saturday
	// @param workdays - Array(Day Names) - An array of day names that should be considered 'work days'
	function parseWorkdays(workdays) {
	  if (!workdays) workdays = DEFAULT_WORKDAYS;
	
	  if (Array.isArray(workdays)) {
	    return workdays.map(function (day) {
	      return dayIdxLookup(day);
	    });
	  }
	
	  // mon..sat
	  var range = workdays.split('..'),
	      start = dayIdxLookup(range[0]),
	      finish = dayIdxLookup(range[1]);
	
	  if (isUnset(start) || isUnset(finish)) {
	    var msg = "Could not parse calendar dates";
	    console.error(msg, workdays);
	    throw msg;
	  } else {
	    var days = [];
	    for (var i = start; i <= finish; i++) {
	      days.push(0 + i);
	    }
	    return days;
	  }
	}
	
	function parseHolidays(holidays) {
	  var hols = [];
	
	  (holidays || []).forEach(function (specOrFunction) {
	    if (typeof specOrFunction === 'function') {
	      hols.push(specOrFunction);
	    } else {
	      var parts = specOrFunction.split('/').map(function (i) {
	        return parseInt(i, 10);
	      });
	      hols.push(function (date) {
	        var month = date.month ? date.month() : date.getMonth() + 1,
	            day = date.date ? date.date() : date.getDate();
	        return !!(month === parts[0] && day === parts[1]);
	      });
	    }
	  });
	  return hols;
	}
	
	exports.default = WorkCalendar;

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _workCalendar = __webpack_require__(928);
	
	var _workCalendar2 = _interopRequireDefault(_workCalendar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.services.work-calendar', []).factory('defaultWorkCalendar', function () {
	  var opts = {
	    workdays: 'sun..sat',
	    holidays: ['1/1', '7/4', '12/25']
	  };
	  return new _workCalendar2.default(opts);
	}).name;

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _moment = __webpack_require__(519);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.services.work-order-starting', []).factory('workOrderStarting', function () {
	  var service = {};
	
	  service.tooEarlyToStartWork = function (workOrder) {
	    if (!workOrder) return 'true';
	    if (workOrder.kind !== 'renovation') return false;
	    if (!workOrder.earliest_start_date) return false;
	    var earliestStart = (0, _moment2.default)(workOrder.earliest_start_date);
	    return earliestStart.isAfter((0, _moment2.default)());
	  };
	
	  service.canStartWork = function (workOrder) {
	    if (!workOrder) return false;
	    if (workOrder.state !== 'budget_approved') return false;
	    return !service.tooEarlyToStartWork(workOrder);
	  };
	  return service;
	}).name;

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.values', [__webpack_require__(932), __webpack_require__(933), __webpack_require__(969), __webpack_require__(970)]).name;

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.values.inspector-crews', []).value('inspectorCrews', [{ name: 'General', crew: 'inspectors', inspectorRole: 'inspector' }, { name: 'Electrical', crew: 'inspector_electrical', inspectorRole: 'electrical' }, { name: 'Estimator', crew: 'estimator', inspectorRole: 'estimator' }, { name: 'Foundation', crew: 'inspector_foundation', inspectorRole: 'foundation' }, { name: 'HVAC', crew: 'inspector_hvac', inspectorRole: 'hvac' }, { name: 'Land Surveying', crew: 'inspector_land_surveying', inspectorRole: 'land_surveying' }, {
	  name: 'Living Area Measurement',
	  crew: 'inspector_living_area_measurement',
	  inspectorRole: 'living_area_measurement'
	}, {
	  name: 'Mold Remediation',
	  crew: 'inspector_mold_remediation',
	  inspectorRole: 'mold_remediation'
	}, {
	  name: 'Odor Remediation',
	  crew: 'inspector_odor_remediation',
	  inspectorRole: 'odor_remediation'
	}, { name: 'Plumbing', crew: 'inspector_plumbing', inspectorRole: 'plumbing' }, { name: 'Pool', crew: 'inspector_pool', inspectorRole: 'pool' }, { name: 'Radon', crew: 'inspector_radon', inspectorRole: 'radon' }, { name: 'Roof', crew: 'inspector_roof', inspectorRole: 'roof' }, { name: 'Septic & Sewer', crew: 'inspector_septic', inspectorRole: 'septic' }, { name: 'Structural', crew: 'inspector_structural', inspectorRole: 'structural' }, { name: 'Termite', crew: 'inspector_termite', inspectorRole: 'termite' }, { name: 'Valuation', crew: 'inspector_valuation', inspectorRole: 'valuator' }, { name: 'Wells', crew: 'inspector_wells', inspectorRole: 'wells' }]).name;

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(934);
	
	__webpack_require__(965);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// installs window.L
	module.exports = _angular2.default.module('common.values.mapbox', []).value('MapboxConfig', {
	  // Public token; meant to be exposed client-side.
	  // URL restrictions are configured in the Mapbox admin panel.
	  accessToken: 'pk.eyJ1Ijoib3BlbmRvb3IiLCJhIjoiY21tNDNwdmE4MDZsaDJvcG4zYXE4c254NyJ9.5PjzJ7pYIrbodyh1USA5ag', // eslint-disable-line max-len
	  defaultMap: 'mapbox.satellite'
	}).name;

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var leaflet = __webpack_require__(935);
	
	__webpack_require__(937);
	
	module.exports = leaflet;


/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = window.L = __webpack_require__(936);


/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 Leaflet, a JavaScript library for mobile-friendly interactive maps. http://leafletjs.com
	 (c) 2010-2013, Vladimir Agafonkin
	 (c) 2010-2011, CloudMade
	*/
	(function (window, document, undefined) {
	var oldL = window.L,
	    L = {};
	
	L.version = '0.7.7';
	
	// define Leaflet for Node module pattern loaders, including Browserify
	if (typeof module === 'object' && typeof module.exports === 'object') {
		module.exports = L;
	
	// define Leaflet as an AMD module
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (L), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	// define Leaflet as a global L variable, saving the original L to restore later if needed
	
	L.noConflict = function () {
		window.L = oldL;
		return this;
	};
	
	window.L = L;
	
	
	/*
	 * L.Util contains various utility functions used throughout Leaflet code.
	 */
	
	L.Util = {
		extend: function (dest) { // (Object[, Object, ...]) ->
			var sources = Array.prototype.slice.call(arguments, 1),
			    i, j, len, src;
	
			for (j = 0, len = sources.length; j < len; j++) {
				src = sources[j] || {};
				for (i in src) {
					if (src.hasOwnProperty(i)) {
						dest[i] = src[i];
					}
				}
			}
			return dest;
		},
	
		bind: function (fn, obj) { // (Function, Object) -> Function
			var args = arguments.length > 2 ? Array.prototype.slice.call(arguments, 2) : null;
			return function () {
				return fn.apply(obj, args || arguments);
			};
		},
	
		stamp: (function () {
			var lastId = 0,
			    key = '_leaflet_id';
			return function (obj) {
				obj[key] = obj[key] || ++lastId;
				return obj[key];
			};
		}()),
	
		invokeEach: function (obj, method, context) {
			var i, args;
	
			if (typeof obj === 'object') {
				args = Array.prototype.slice.call(arguments, 3);
	
				for (i in obj) {
					method.apply(context, [i, obj[i]].concat(args));
				}
				return true;
			}
	
			return false;
		},
	
		limitExecByInterval: function (fn, time, context) {
			var lock, execOnUnlock;
	
			return function wrapperFn() {
				var args = arguments;
	
				if (lock) {
					execOnUnlock = true;
					return;
				}
	
				lock = true;
	
				setTimeout(function () {
					lock = false;
	
					if (execOnUnlock) {
						wrapperFn.apply(context, args);
						execOnUnlock = false;
					}
				}, time);
	
				fn.apply(context, args);
			};
		},
	
		falseFn: function () {
			return false;
		},
	
		formatNum: function (num, digits) {
			var pow = Math.pow(10, digits || 5);
			return Math.round(num * pow) / pow;
		},
	
		trim: function (str) {
			return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
		},
	
		splitWords: function (str) {
			return L.Util.trim(str).split(/\s+/);
		},
	
		setOptions: function (obj, options) {
			obj.options = L.extend({}, obj.options, options);
			return obj.options;
		},
	
		getParamString: function (obj, existingUrl, uppercase) {
			var params = [];
			for (var i in obj) {
				params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
			}
			return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
		},
		template: function (str, data) {
			return str.replace(/\{ *([\w_]+) *\}/g, function (str, key) {
				var value = data[key];
				if (value === undefined) {
					throw new Error('No value provided for variable ' + str);
				} else if (typeof value === 'function') {
					value = value(data);
				}
				return value;
			});
		},
	
		isArray: Array.isArray || function (obj) {
			return (Object.prototype.toString.call(obj) === '[object Array]');
		},
	
		emptyImageUrl: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='
	};
	
	(function () {
	
		// inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	
		function getPrefixed(name) {
			var i, fn,
			    prefixes = ['webkit', 'moz', 'o', 'ms'];
	
			for (i = 0; i < prefixes.length && !fn; i++) {
				fn = window[prefixes[i] + name];
			}
	
			return fn;
		}
	
		var lastTime = 0;
	
		function timeoutDefer(fn) {
			var time = +new Date(),
			    timeToCall = Math.max(0, 16 - (time - lastTime));
	
			lastTime = time + timeToCall;
			return window.setTimeout(fn, timeToCall);
		}
	
		var requestFn = window.requestAnimationFrame ||
		        getPrefixed('RequestAnimationFrame') || timeoutDefer;
	
		var cancelFn = window.cancelAnimationFrame ||
		        getPrefixed('CancelAnimationFrame') ||
		        getPrefixed('CancelRequestAnimationFrame') ||
		        function (id) { window.clearTimeout(id); };
	
	
		L.Util.requestAnimFrame = function (fn, context, immediate, element) {
			fn = L.bind(fn, context);
	
			if (immediate && requestFn === timeoutDefer) {
				fn();
			} else {
				return requestFn.call(window, fn, element);
			}
		};
	
		L.Util.cancelAnimFrame = function (id) {
			if (id) {
				cancelFn.call(window, id);
			}
		};
	
	}());
	
	// shortcuts for most used utility functions
	L.extend = L.Util.extend;
	L.bind = L.Util.bind;
	L.stamp = L.Util.stamp;
	L.setOptions = L.Util.setOptions;
	
	
	/*
	 * L.Class powers the OOP facilities of the library.
	 * Thanks to John Resig and Dean Edwards for inspiration!
	 */
	
	L.Class = function () {};
	
	L.Class.extend = function (props) {
	
		// extended class with the new prototype
		var NewClass = function () {
	
			// call the constructor
			if (this.initialize) {
				this.initialize.apply(this, arguments);
			}
	
			// call all constructor hooks
			if (this._initHooks) {
				this.callInitHooks();
			}
		};
	
		// instantiate class without calling constructor
		var F = function () {};
		F.prototype = this.prototype;
	
		var proto = new F();
		proto.constructor = NewClass;
	
		NewClass.prototype = proto;
	
		//inherit parent's statics
		for (var i in this) {
			if (this.hasOwnProperty(i) && i !== 'prototype') {
				NewClass[i] = this[i];
			}
		}
	
		// mix static properties into the class
		if (props.statics) {
			L.extend(NewClass, props.statics);
			delete props.statics;
		}
	
		// mix includes into the prototype
		if (props.includes) {
			L.Util.extend.apply(null, [proto].concat(props.includes));
			delete props.includes;
		}
	
		// merge options
		if (props.options && proto.options) {
			props.options = L.extend({}, proto.options, props.options);
		}
	
		// mix given properties into the prototype
		L.extend(proto, props);
	
		proto._initHooks = [];
	
		var parent = this;
		// jshint camelcase: false
		NewClass.__super__ = parent.prototype;
	
		// add method for calling all hooks
		proto.callInitHooks = function () {
	
			if (this._initHooksCalled) { return; }
	
			if (parent.prototype.callInitHooks) {
				parent.prototype.callInitHooks.call(this);
			}
	
			this._initHooksCalled = true;
	
			for (var i = 0, len = proto._initHooks.length; i < len; i++) {
				proto._initHooks[i].call(this);
			}
		};
	
		return NewClass;
	};
	
	
	// method for adding properties to prototype
	L.Class.include = function (props) {
		L.extend(this.prototype, props);
	};
	
	// merge new default options to the Class
	L.Class.mergeOptions = function (options) {
		L.extend(this.prototype.options, options);
	};
	
	// add a constructor hook
	L.Class.addInitHook = function (fn) { // (Function) || (String, args...)
		var args = Array.prototype.slice.call(arguments, 1);
	
		var init = typeof fn === 'function' ? fn : function () {
			this[fn].apply(this, args);
		};
	
		this.prototype._initHooks = this.prototype._initHooks || [];
		this.prototype._initHooks.push(init);
	};
	
	
	/*
	 * L.Mixin.Events is used to add custom events functionality to Leaflet classes.
	 */
	
	var eventsKey = '_leaflet_events';
	
	L.Mixin = {};
	
	L.Mixin.Events = {
	
		addEventListener: function (types, fn, context) { // (String, Function[, Object]) or (Object[, Object])
	
			// types can be a map of types/handlers
			if (L.Util.invokeEach(types, this.addEventListener, this, fn, context)) { return this; }
	
			var events = this[eventsKey] = this[eventsKey] || {},
			    contextId = context && context !== this && L.stamp(context),
			    i, len, event, type, indexKey, indexLenKey, typeIndex;
	
			// types can be a string of space-separated words
			types = L.Util.splitWords(types);
	
			for (i = 0, len = types.length; i < len; i++) {
				event = {
					action: fn,
					context: context || this
				};
				type = types[i];
	
				if (contextId) {
					// store listeners of a particular context in a separate hash (if it has an id)
					// gives a major performance boost when removing thousands of map layers
	
					indexKey = type + '_idx';
					indexLenKey = indexKey + '_len';
	
					typeIndex = events[indexKey] = events[indexKey] || {};
	
					if (!typeIndex[contextId]) {
						typeIndex[contextId] = [];
	
						// keep track of the number of keys in the index to quickly check if it's empty
						events[indexLenKey] = (events[indexLenKey] || 0) + 1;
					}
	
					typeIndex[contextId].push(event);
	
	
				} else {
					events[type] = events[type] || [];
					events[type].push(event);
				}
			}
	
			return this;
		},
	
		hasEventListeners: function (type) { // (String) -> Boolean
			var events = this[eventsKey];
			return !!events && ((type in events && events[type].length > 0) ||
			                    (type + '_idx' in events && events[type + '_idx_len'] > 0));
		},
	
		removeEventListener: function (types, fn, context) { // ([String, Function, Object]) or (Object[, Object])
	
			if (!this[eventsKey]) {
				return this;
			}
	
			if (!types) {
				return this.clearAllEventListeners();
			}
	
			if (L.Util.invokeEach(types, this.removeEventListener, this, fn, context)) { return this; }
	
			var events = this[eventsKey],
			    contextId = context && context !== this && L.stamp(context),
			    i, len, type, listeners, j, indexKey, indexLenKey, typeIndex, removed;
	
			types = L.Util.splitWords(types);
	
			for (i = 0, len = types.length; i < len; i++) {
				type = types[i];
				indexKey = type + '_idx';
				indexLenKey = indexKey + '_len';
	
				typeIndex = events[indexKey];
	
				if (!fn) {
					// clear all listeners for a type if function isn't specified
					delete events[type];
					delete events[indexKey];
					delete events[indexLenKey];
	
				} else {
					listeners = contextId && typeIndex ? typeIndex[contextId] : events[type];
	
					if (listeners) {
						for (j = listeners.length - 1; j >= 0; j--) {
							if ((listeners[j].action === fn) && (!context || (listeners[j].context === context))) {
								removed = listeners.splice(j, 1);
								// set the old action to a no-op, because it is possible
								// that the listener is being iterated over as part of a dispatch
								removed[0].action = L.Util.falseFn;
							}
						}
	
						if (context && typeIndex && (listeners.length === 0)) {
							delete typeIndex[contextId];
							events[indexLenKey]--;
						}
					}
				}
			}
	
			return this;
		},
	
		clearAllEventListeners: function () {
			delete this[eventsKey];
			return this;
		},
	
		fireEvent: function (type, data) { // (String[, Object])
			if (!this.hasEventListeners(type)) {
				return this;
			}
	
			var event = L.Util.extend({}, data, { type: type, target: this });
	
			var events = this[eventsKey],
			    listeners, i, len, typeIndex, contextId;
	
			if (events[type]) {
				// make sure adding/removing listeners inside other listeners won't cause infinite loop
				listeners = events[type].slice();
	
				for (i = 0, len = listeners.length; i < len; i++) {
					listeners[i].action.call(listeners[i].context, event);
				}
			}
	
			// fire event for the context-indexed listeners as well
			typeIndex = events[type + '_idx'];
	
			for (contextId in typeIndex) {
				listeners = typeIndex[contextId].slice();
	
				if (listeners) {
					for (i = 0, len = listeners.length; i < len; i++) {
						listeners[i].action.call(listeners[i].context, event);
					}
				}
			}
	
			return this;
		},
	
		addOneTimeEventListener: function (types, fn, context) {
	
			if (L.Util.invokeEach(types, this.addOneTimeEventListener, this, fn, context)) { return this; }
	
			var handler = L.bind(function () {
				this
				    .removeEventListener(types, fn, context)
				    .removeEventListener(types, handler, context);
			}, this);
	
			return this
			    .addEventListener(types, fn, context)
			    .addEventListener(types, handler, context);
		}
	};
	
	L.Mixin.Events.on = L.Mixin.Events.addEventListener;
	L.Mixin.Events.off = L.Mixin.Events.removeEventListener;
	L.Mixin.Events.once = L.Mixin.Events.addOneTimeEventListener;
	L.Mixin.Events.fire = L.Mixin.Events.fireEvent;
	
	
	/*
	 * L.Browser handles different browser and feature detections for internal Leaflet use.
	 */
	
	(function () {
	
		var ie = 'ActiveXObject' in window,
			ielt9 = ie && !document.addEventListener,
	
		    // terrible browser detection to work around Safari / iOS / Android browser bugs
		    ua = navigator.userAgent.toLowerCase(),
		    webkit = ua.indexOf('webkit') !== -1,
		    chrome = ua.indexOf('chrome') !== -1,
		    phantomjs = ua.indexOf('phantom') !== -1,
		    android = ua.indexOf('android') !== -1,
		    android23 = ua.search('android [23]') !== -1,
			gecko = ua.indexOf('gecko') !== -1,
	
		    mobile = typeof orientation !== undefined + '',
		    msPointer = !window.PointerEvent && window.MSPointerEvent,
			pointer = (window.PointerEvent && window.navigator.pointerEnabled) ||
					  msPointer,
		    retina = ('devicePixelRatio' in window && window.devicePixelRatio > 1) ||
		             ('matchMedia' in window && window.matchMedia('(min-resolution:144dpi)') &&
		              window.matchMedia('(min-resolution:144dpi)').matches),
	
		    doc = document.documentElement,
		    ie3d = ie && ('transition' in doc.style),
		    webkit3d = ('WebKitCSSMatrix' in window) && ('m11' in new window.WebKitCSSMatrix()) && !android23,
		    gecko3d = 'MozPerspective' in doc.style,
		    opera3d = 'OTransition' in doc.style,
		    any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d || opera3d) && !phantomjs;
	
		var touch = !window.L_NO_TOUCH && !phantomjs && (pointer || 'ontouchstart' in window ||
			(window.DocumentTouch && document instanceof window.DocumentTouch));
	
		L.Browser = {
			ie: ie,
			ielt9: ielt9,
			webkit: webkit,
			gecko: gecko && !webkit && !window.opera && !ie,
	
			android: android,
			android23: android23,
	
			chrome: chrome,
	
			ie3d: ie3d,
			webkit3d: webkit3d,
			gecko3d: gecko3d,
			opera3d: opera3d,
			any3d: any3d,
	
			mobile: mobile,
			mobileWebkit: mobile && webkit,
			mobileWebkit3d: mobile && webkit3d,
			mobileOpera: mobile && window.opera,
	
			touch: touch,
			msPointer: msPointer,
			pointer: pointer,
	
			retina: retina
		};
	
	}());
	
	
	/*
	 * L.Point represents a point with x and y coordinates.
	 */
	
	L.Point = function (/*Number*/ x, /*Number*/ y, /*Boolean*/ round) {
		this.x = (round ? Math.round(x) : x);
		this.y = (round ? Math.round(y) : y);
	};
	
	L.Point.prototype = {
	
		clone: function () {
			return new L.Point(this.x, this.y);
		},
	
		// non-destructive, returns a new point
		add: function (point) {
			return this.clone()._add(L.point(point));
		},
	
		// destructive, used directly for performance in situations where it's safe to modify existing point
		_add: function (point) {
			this.x += point.x;
			this.y += point.y;
			return this;
		},
	
		subtract: function (point) {
			return this.clone()._subtract(L.point(point));
		},
	
		_subtract: function (point) {
			this.x -= point.x;
			this.y -= point.y;
			return this;
		},
	
		divideBy: function (num) {
			return this.clone()._divideBy(num);
		},
	
		_divideBy: function (num) {
			this.x /= num;
			this.y /= num;
			return this;
		},
	
		multiplyBy: function (num) {
			return this.clone()._multiplyBy(num);
		},
	
		_multiplyBy: function (num) {
			this.x *= num;
			this.y *= num;
			return this;
		},
	
		round: function () {
			return this.clone()._round();
		},
	
		_round: function () {
			this.x = Math.round(this.x);
			this.y = Math.round(this.y);
			return this;
		},
	
		floor: function () {
			return this.clone()._floor();
		},
	
		_floor: function () {
			this.x = Math.floor(this.x);
			this.y = Math.floor(this.y);
			return this;
		},
	
		distanceTo: function (point) {
			point = L.point(point);
	
			var x = point.x - this.x,
			    y = point.y - this.y;
	
			return Math.sqrt(x * x + y * y);
		},
	
		equals: function (point) {
			point = L.point(point);
	
			return point.x === this.x &&
			       point.y === this.y;
		},
	
		contains: function (point) {
			point = L.point(point);
	
			return Math.abs(point.x) <= Math.abs(this.x) &&
			       Math.abs(point.y) <= Math.abs(this.y);
		},
	
		toString: function () {
			return 'Point(' +
			        L.Util.formatNum(this.x) + ', ' +
			        L.Util.formatNum(this.y) + ')';
		}
	};
	
	L.point = function (x, y, round) {
		if (x instanceof L.Point) {
			return x;
		}
		if (L.Util.isArray(x)) {
			return new L.Point(x[0], x[1]);
		}
		if (x === undefined || x === null) {
			return x;
		}
		return new L.Point(x, y, round);
	};
	
	
	/*
	 * L.Bounds represents a rectangular area on the screen in pixel coordinates.
	 */
	
	L.Bounds = function (a, b) { //(Point, Point) or Point[]
		if (!a) { return; }
	
		var points = b ? [a, b] : a;
	
		for (var i = 0, len = points.length; i < len; i++) {
			this.extend(points[i]);
		}
	};
	
	L.Bounds.prototype = {
		// extend the bounds to contain the given point
		extend: function (point) { // (Point)
			point = L.point(point);
	
			if (!this.min && !this.max) {
				this.min = point.clone();
				this.max = point.clone();
			} else {
				this.min.x = Math.min(point.x, this.min.x);
				this.max.x = Math.max(point.x, this.max.x);
				this.min.y = Math.min(point.y, this.min.y);
				this.max.y = Math.max(point.y, this.max.y);
			}
			return this;
		},
	
		getCenter: function (round) { // (Boolean) -> Point
			return new L.Point(
			        (this.min.x + this.max.x) / 2,
			        (this.min.y + this.max.y) / 2, round);
		},
	
		getBottomLeft: function () { // -> Point
			return new L.Point(this.min.x, this.max.y);
		},
	
		getTopRight: function () { // -> Point
			return new L.Point(this.max.x, this.min.y);
		},
	
		getSize: function () {
			return this.max.subtract(this.min);
		},
	
		contains: function (obj) { // (Bounds) or (Point) -> Boolean
			var min, max;
	
			if (typeof obj[0] === 'number' || obj instanceof L.Point) {
				obj = L.point(obj);
			} else {
				obj = L.bounds(obj);
			}
	
			if (obj instanceof L.Bounds) {
				min = obj.min;
				max = obj.max;
			} else {
				min = max = obj;
			}
	
			return (min.x >= this.min.x) &&
			       (max.x <= this.max.x) &&
			       (min.y >= this.min.y) &&
			       (max.y <= this.max.y);
		},
	
		intersects: function (bounds) { // (Bounds) -> Boolean
			bounds = L.bounds(bounds);
	
			var min = this.min,
			    max = this.max,
			    min2 = bounds.min,
			    max2 = bounds.max,
			    xIntersects = (max2.x >= min.x) && (min2.x <= max.x),
			    yIntersects = (max2.y >= min.y) && (min2.y <= max.y);
	
			return xIntersects && yIntersects;
		},
	
		isValid: function () {
			return !!(this.min && this.max);
		}
	};
	
	L.bounds = function (a, b) { // (Bounds) or (Point, Point) or (Point[])
		if (!a || a instanceof L.Bounds) {
			return a;
		}
		return new L.Bounds(a, b);
	};
	
	
	/*
	 * L.Transformation is an utility class to perform simple point transformations through a 2d-matrix.
	 */
	
	L.Transformation = function (a, b, c, d) {
		this._a = a;
		this._b = b;
		this._c = c;
		this._d = d;
	};
	
	L.Transformation.prototype = {
		transform: function (point, scale) { // (Point, Number) -> Point
			return this._transform(point.clone(), scale);
		},
	
		// destructive transform (faster)
		_transform: function (point, scale) {
			scale = scale || 1;
			point.x = scale * (this._a * point.x + this._b);
			point.y = scale * (this._c * point.y + this._d);
			return point;
		},
	
		untransform: function (point, scale) {
			scale = scale || 1;
			return new L.Point(
			        (point.x / scale - this._b) / this._a,
			        (point.y / scale - this._d) / this._c);
		}
	};
	
	
	/*
	 * L.DomUtil contains various utility functions for working with DOM.
	 */
	
	L.DomUtil = {
		get: function (id) {
			return (typeof id === 'string' ? document.getElementById(id) : id);
		},
	
		getStyle: function (el, style) {
	
			var value = el.style[style];
	
			if (!value && el.currentStyle) {
				value = el.currentStyle[style];
			}
	
			if ((!value || value === 'auto') && document.defaultView) {
				var css = document.defaultView.getComputedStyle(el, null);
				value = css ? css[style] : null;
			}
	
			return value === 'auto' ? null : value;
		},
	
		getViewportOffset: function (element) {
	
			var top = 0,
			    left = 0,
			    el = element,
			    docBody = document.body,
			    docEl = document.documentElement,
			    pos;
	
			do {
				top  += el.offsetTop  || 0;
				left += el.offsetLeft || 0;
	
				//add borders
				top += parseInt(L.DomUtil.getStyle(el, 'borderTopWidth'), 10) || 0;
				left += parseInt(L.DomUtil.getStyle(el, 'borderLeftWidth'), 10) || 0;
	
				pos = L.DomUtil.getStyle(el, 'position');
	
				if (el.offsetParent === docBody && pos === 'absolute') { break; }
	
				if (pos === 'fixed') {
					top  += docBody.scrollTop  || docEl.scrollTop  || 0;
					left += docBody.scrollLeft || docEl.scrollLeft || 0;
					break;
				}
	
				if (pos === 'relative' && !el.offsetLeft) {
					var width = L.DomUtil.getStyle(el, 'width'),
					    maxWidth = L.DomUtil.getStyle(el, 'max-width'),
					    r = el.getBoundingClientRect();
	
					if (width !== 'none' || maxWidth !== 'none') {
						left += r.left + el.clientLeft;
					}
	
					//calculate full y offset since we're breaking out of the loop
					top += r.top + (docBody.scrollTop  || docEl.scrollTop  || 0);
	
					break;
				}
	
				el = el.offsetParent;
	
			} while (el);
	
			el = element;
	
			do {
				if (el === docBody) { break; }
	
				top  -= el.scrollTop  || 0;
				left -= el.scrollLeft || 0;
	
				el = el.parentNode;
			} while (el);
	
			return new L.Point(left, top);
		},
	
		documentIsLtr: function () {
			if (!L.DomUtil._docIsLtrCached) {
				L.DomUtil._docIsLtrCached = true;
				L.DomUtil._docIsLtr = L.DomUtil.getStyle(document.body, 'direction') === 'ltr';
			}
			return L.DomUtil._docIsLtr;
		},
	
		create: function (tagName, className, container) {
	
			var el = document.createElement(tagName);
			el.className = className;
	
			if (container) {
				container.appendChild(el);
			}
	
			return el;
		},
	
		hasClass: function (el, name) {
			if (el.classList !== undefined) {
				return el.classList.contains(name);
			}
			var className = L.DomUtil._getClass(el);
			return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
		},
	
		addClass: function (el, name) {
			if (el.classList !== undefined) {
				var classes = L.Util.splitWords(name);
				for (var i = 0, len = classes.length; i < len; i++) {
					el.classList.add(classes[i]);
				}
			} else if (!L.DomUtil.hasClass(el, name)) {
				var className = L.DomUtil._getClass(el);
				L.DomUtil._setClass(el, (className ? className + ' ' : '') + name);
			}
		},
	
		removeClass: function (el, name) {
			if (el.classList !== undefined) {
				el.classList.remove(name);
			} else {
				L.DomUtil._setClass(el, L.Util.trim((' ' + L.DomUtil._getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
			}
		},
	
		_setClass: function (el, name) {
			if (el.className.baseVal === undefined) {
				el.className = name;
			} else {
				// in case of SVG element
				el.className.baseVal = name;
			}
		},
	
		_getClass: function (el) {
			return el.className.baseVal === undefined ? el.className : el.className.baseVal;
		},
	
		setOpacity: function (el, value) {
	
			if ('opacity' in el.style) {
				el.style.opacity = value;
	
			} else if ('filter' in el.style) {
	
				var filter = false,
				    filterName = 'DXImageTransform.Microsoft.Alpha';
	
				// filters collection throws an error if we try to retrieve a filter that doesn't exist
				try {
					filter = el.filters.item(filterName);
				} catch (e) {
					// don't set opacity to 1 if we haven't already set an opacity,
					// it isn't needed and breaks transparent pngs.
					if (value === 1) { return; }
				}
	
				value = Math.round(value * 100);
	
				if (filter) {
					filter.Enabled = (value !== 100);
					filter.Opacity = value;
				} else {
					el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
				}
			}
		},
	
		testProp: function (props) {
	
			var style = document.documentElement.style;
	
			for (var i = 0; i < props.length; i++) {
				if (props[i] in style) {
					return props[i];
				}
			}
			return false;
		},
	
		getTranslateString: function (point) {
			// on WebKit browsers (Chrome/Safari/iOS Safari/Android) using translate3d instead of translate
			// makes animation smoother as it ensures HW accel is used. Firefox 13 doesn't care
			// (same speed either way), Opera 12 doesn't support translate3d
	
			var is3d = L.Browser.webkit3d,
			    open = 'translate' + (is3d ? '3d' : '') + '(',
			    close = (is3d ? ',0' : '') + ')';
	
			return open + point.x + 'px,' + point.y + 'px' + close;
		},
	
		getScaleString: function (scale, origin) {
	
			var preTranslateStr = L.DomUtil.getTranslateString(origin.add(origin.multiplyBy(-1 * scale))),
			    scaleStr = ' scale(' + scale + ') ';
	
			return preTranslateStr + scaleStr;
		},
	
		setPosition: function (el, point, disable3D) { // (HTMLElement, Point[, Boolean])
	
			// jshint camelcase: false
			el._leaflet_pos = point;
	
			if (!disable3D && L.Browser.any3d) {
				el.style[L.DomUtil.TRANSFORM] =  L.DomUtil.getTranslateString(point);
			} else {
				el.style.left = point.x + 'px';
				el.style.top = point.y + 'px';
			}
		},
	
		getPosition: function (el) {
			// this method is only used for elements previously positioned using setPosition,
			// so it's safe to cache the position for performance
	
			// jshint camelcase: false
			return el._leaflet_pos;
		}
	};
	
	
	// prefix style property names
	
	L.DomUtil.TRANSFORM = L.DomUtil.testProp(
	        ['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform']);
	
	// webkitTransition comes first because some browser versions that drop vendor prefix don't do
	// the same for the transitionend event, in particular the Android 4.1 stock browser
	
	L.DomUtil.TRANSITION = L.DomUtil.testProp(
	        ['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);
	
	L.DomUtil.TRANSITION_END =
	        L.DomUtil.TRANSITION === 'webkitTransition' || L.DomUtil.TRANSITION === 'OTransition' ?
	        L.DomUtil.TRANSITION + 'End' : 'transitionend';
	
	(function () {
	    if ('onselectstart' in document) {
	        L.extend(L.DomUtil, {
	            disableTextSelection: function () {
	                L.DomEvent.on(window, 'selectstart', L.DomEvent.preventDefault);
	            },
	
	            enableTextSelection: function () {
	                L.DomEvent.off(window, 'selectstart', L.DomEvent.preventDefault);
	            }
	        });
	    } else {
	        var userSelectProperty = L.DomUtil.testProp(
	            ['userSelect', 'WebkitUserSelect', 'OUserSelect', 'MozUserSelect', 'msUserSelect']);
	
	        L.extend(L.DomUtil, {
	            disableTextSelection: function () {
	                if (userSelectProperty) {
	                    var style = document.documentElement.style;
	                    this._userSelect = style[userSelectProperty];
	                    style[userSelectProperty] = 'none';
	                }
	            },
	
	            enableTextSelection: function () {
	                if (userSelectProperty) {
	                    document.documentElement.style[userSelectProperty] = this._userSelect;
	                    delete this._userSelect;
	                }
	            }
	        });
	    }
	
		L.extend(L.DomUtil, {
			disableImageDrag: function () {
				L.DomEvent.on(window, 'dragstart', L.DomEvent.preventDefault);
			},
	
			enableImageDrag: function () {
				L.DomEvent.off(window, 'dragstart', L.DomEvent.preventDefault);
			}
		});
	})();
	
	
	/*
	 * L.LatLng represents a geographical point with latitude and longitude coordinates.
	 */
	
	L.LatLng = function (lat, lng, alt) { // (Number, Number, Number)
		lat = parseFloat(lat);
		lng = parseFloat(lng);
	
		if (isNaN(lat) || isNaN(lng)) {
			throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
		}
	
		this.lat = lat;
		this.lng = lng;
	
		if (alt !== undefined) {
			this.alt = parseFloat(alt);
		}
	};
	
	L.extend(L.LatLng, {
		DEG_TO_RAD: Math.PI / 180,
		RAD_TO_DEG: 180 / Math.PI,
		MAX_MARGIN: 1.0E-9 // max margin of error for the "equals" check
	});
	
	L.LatLng.prototype = {
		equals: function (obj) { // (LatLng) -> Boolean
			if (!obj) { return false; }
	
			obj = L.latLng(obj);
	
			var margin = Math.max(
			        Math.abs(this.lat - obj.lat),
			        Math.abs(this.lng - obj.lng));
	
			return margin <= L.LatLng.MAX_MARGIN;
		},
	
		toString: function (precision) { // (Number) -> String
			return 'LatLng(' +
			        L.Util.formatNum(this.lat, precision) + ', ' +
			        L.Util.formatNum(this.lng, precision) + ')';
		},
	
		// Haversine distance formula, see http://en.wikipedia.org/wiki/Haversine_formula
		// TODO move to projection code, LatLng shouldn't know about Earth
		distanceTo: function (other) { // (LatLng) -> Number
			other = L.latLng(other);
	
			var R = 6378137, // earth radius in meters
			    d2r = L.LatLng.DEG_TO_RAD,
			    dLat = (other.lat - this.lat) * d2r,
			    dLon = (other.lng - this.lng) * d2r,
			    lat1 = this.lat * d2r,
			    lat2 = other.lat * d2r,
			    sin1 = Math.sin(dLat / 2),
			    sin2 = Math.sin(dLon / 2);
	
			var a = sin1 * sin1 + sin2 * sin2 * Math.cos(lat1) * Math.cos(lat2);
	
			return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		},
	
		wrap: function (a, b) { // (Number, Number) -> LatLng
			var lng = this.lng;
	
			a = a || -180;
			b = b ||  180;
	
			lng = (lng + b) % (b - a) + (lng < a || lng === b ? b : a);
	
			return new L.LatLng(this.lat, lng);
		}
	};
	
	L.latLng = function (a, b) { // (LatLng) or ([Number, Number]) or (Number, Number)
		if (a instanceof L.LatLng) {
			return a;
		}
		if (L.Util.isArray(a)) {
			if (typeof a[0] === 'number' || typeof a[0] === 'string') {
				return new L.LatLng(a[0], a[1], a[2]);
			} else {
				return null;
			}
		}
		if (a === undefined || a === null) {
			return a;
		}
		if (typeof a === 'object' && 'lat' in a) {
			return new L.LatLng(a.lat, 'lng' in a ? a.lng : a.lon);
		}
		if (b === undefined) {
			return null;
		}
		return new L.LatLng(a, b);
	};
	
	
	
	/*
	 * L.LatLngBounds represents a rectangular area on the map in geographical coordinates.
	 */
	
	L.LatLngBounds = function (southWest, northEast) { // (LatLng, LatLng) or (LatLng[])
		if (!southWest) { return; }
	
		var latlngs = northEast ? [southWest, northEast] : southWest;
	
		for (var i = 0, len = latlngs.length; i < len; i++) {
			this.extend(latlngs[i]);
		}
	};
	
	L.LatLngBounds.prototype = {
		// extend the bounds to contain the given point or bounds
		extend: function (obj) { // (LatLng) or (LatLngBounds)
			if (!obj) { return this; }
	
			var latLng = L.latLng(obj);
			if (latLng !== null) {
				obj = latLng;
			} else {
				obj = L.latLngBounds(obj);
			}
	
			if (obj instanceof L.LatLng) {
				if (!this._southWest && !this._northEast) {
					this._southWest = new L.LatLng(obj.lat, obj.lng);
					this._northEast = new L.LatLng(obj.lat, obj.lng);
				} else {
					this._southWest.lat = Math.min(obj.lat, this._southWest.lat);
					this._southWest.lng = Math.min(obj.lng, this._southWest.lng);
	
					this._northEast.lat = Math.max(obj.lat, this._northEast.lat);
					this._northEast.lng = Math.max(obj.lng, this._northEast.lng);
				}
			} else if (obj instanceof L.LatLngBounds) {
				this.extend(obj._southWest);
				this.extend(obj._northEast);
			}
			return this;
		},
	
		// extend the bounds by a percentage
		pad: function (bufferRatio) { // (Number) -> LatLngBounds
			var sw = this._southWest,
			    ne = this._northEast,
			    heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio,
			    widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
	
			return new L.LatLngBounds(
			        new L.LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
			        new L.LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
		},
	
		getCenter: function () { // -> LatLng
			return new L.LatLng(
			        (this._southWest.lat + this._northEast.lat) / 2,
			        (this._southWest.lng + this._northEast.lng) / 2);
		},
	
		getSouthWest: function () {
			return this._southWest;
		},
	
		getNorthEast: function () {
			return this._northEast;
		},
	
		getNorthWest: function () {
			return new L.LatLng(this.getNorth(), this.getWest());
		},
	
		getSouthEast: function () {
			return new L.LatLng(this.getSouth(), this.getEast());
		},
	
		getWest: function () {
			return this._southWest.lng;
		},
	
		getSouth: function () {
			return this._southWest.lat;
		},
	
		getEast: function () {
			return this._northEast.lng;
		},
	
		getNorth: function () {
			return this._northEast.lat;
		},
	
		contains: function (obj) { // (LatLngBounds) or (LatLng) -> Boolean
			if (typeof obj[0] === 'number' || obj instanceof L.LatLng) {
				obj = L.latLng(obj);
			} else {
				obj = L.latLngBounds(obj);
			}
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2, ne2;
	
			if (obj instanceof L.LatLngBounds) {
				sw2 = obj.getSouthWest();
				ne2 = obj.getNorthEast();
			} else {
				sw2 = ne2 = obj;
			}
	
			return (sw2.lat >= sw.lat) && (ne2.lat <= ne.lat) &&
			       (sw2.lng >= sw.lng) && (ne2.lng <= ne.lng);
		},
	
		intersects: function (bounds) { // (LatLngBounds)
			bounds = L.latLngBounds(bounds);
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2 = bounds.getSouthWest(),
			    ne2 = bounds.getNorthEast(),
	
			    latIntersects = (ne2.lat >= sw.lat) && (sw2.lat <= ne.lat),
			    lngIntersects = (ne2.lng >= sw.lng) && (sw2.lng <= ne.lng);
	
			return latIntersects && lngIntersects;
		},
	
		toBBoxString: function () {
			return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(',');
		},
	
		equals: function (bounds) { // (LatLngBounds)
			if (!bounds) { return false; }
	
			bounds = L.latLngBounds(bounds);
	
			return this._southWest.equals(bounds.getSouthWest()) &&
			       this._northEast.equals(bounds.getNorthEast());
		},
	
		isValid: function () {
			return !!(this._southWest && this._northEast);
		}
	};
	
	//TODO International date line?
	
	L.latLngBounds = function (a, b) { // (LatLngBounds) or (LatLng, LatLng)
		if (!a || a instanceof L.LatLngBounds) {
			return a;
		}
		return new L.LatLngBounds(a, b);
	};
	
	
	/*
	 * L.Projection contains various geographical projections used by CRS classes.
	 */
	
	L.Projection = {};
	
	
	/*
	 * Spherical Mercator is the most popular map projection, used by EPSG:3857 CRS used by default.
	 */
	
	L.Projection.SphericalMercator = {
		MAX_LATITUDE: 85.0511287798,
	
		project: function (latlng) { // (LatLng) -> Point
			var d = L.LatLng.DEG_TO_RAD,
			    max = this.MAX_LATITUDE,
			    lat = Math.max(Math.min(max, latlng.lat), -max),
			    x = latlng.lng * d,
			    y = lat * d;
	
			y = Math.log(Math.tan((Math.PI / 4) + (y / 2)));
	
			return new L.Point(x, y);
		},
	
		unproject: function (point) { // (Point, Boolean) -> LatLng
			var d = L.LatLng.RAD_TO_DEG,
			    lng = point.x * d,
			    lat = (2 * Math.atan(Math.exp(point.y)) - (Math.PI / 2)) * d;
	
			return new L.LatLng(lat, lng);
		}
	};
	
	
	/*
	 * Simple equirectangular (Plate Carree) projection, used by CRS like EPSG:4326 and Simple.
	 */
	
	L.Projection.LonLat = {
		project: function (latlng) {
			return new L.Point(latlng.lng, latlng.lat);
		},
	
		unproject: function (point) {
			return new L.LatLng(point.y, point.x);
		}
	};
	
	
	/*
	 * L.CRS is a base object for all defined CRS (Coordinate Reference Systems) in Leaflet.
	 */
	
	L.CRS = {
		latLngToPoint: function (latlng, zoom) { // (LatLng, Number) -> Point
			var projectedPoint = this.projection.project(latlng),
			    scale = this.scale(zoom);
	
			return this.transformation._transform(projectedPoint, scale);
		},
	
		pointToLatLng: function (point, zoom) { // (Point, Number[, Boolean]) -> LatLng
			var scale = this.scale(zoom),
			    untransformedPoint = this.transformation.untransform(point, scale);
	
			return this.projection.unproject(untransformedPoint);
		},
	
		project: function (latlng) {
			return this.projection.project(latlng);
		},
	
		scale: function (zoom) {
			return 256 * Math.pow(2, zoom);
		},
	
		getSize: function (zoom) {
			var s = this.scale(zoom);
			return L.point(s, s);
		}
	};
	
	
	/*
	 * A simple CRS that can be used for flat non-Earth maps like panoramas or game maps.
	 */
	
	L.CRS.Simple = L.extend({}, L.CRS, {
		projection: L.Projection.LonLat,
		transformation: new L.Transformation(1, 0, -1, 0),
	
		scale: function (zoom) {
			return Math.pow(2, zoom);
		}
	});
	
	
	/*
	 * L.CRS.EPSG3857 (Spherical Mercator) is the most common CRS for web mapping
	 * and is used by Leaflet by default.
	 */
	
	L.CRS.EPSG3857 = L.extend({}, L.CRS, {
		code: 'EPSG:3857',
	
		projection: L.Projection.SphericalMercator,
		transformation: new L.Transformation(0.5 / Math.PI, 0.5, -0.5 / Math.PI, 0.5),
	
		project: function (latlng) { // (LatLng) -> Point
			var projectedPoint = this.projection.project(latlng),
			    earthRadius = 6378137;
			return projectedPoint.multiplyBy(earthRadius);
		}
	});
	
	L.CRS.EPSG900913 = L.extend({}, L.CRS.EPSG3857, {
		code: 'EPSG:900913'
	});
	
	
	/*
	 * L.CRS.EPSG4326 is a CRS popular among advanced GIS specialists.
	 */
	
	L.CRS.EPSG4326 = L.extend({}, L.CRS, {
		code: 'EPSG:4326',
	
		projection: L.Projection.LonLat,
		transformation: new L.Transformation(1 / 360, 0.5, -1 / 360, 0.5)
	});
	
	
	/*
	 * L.Map is the central class of the API - it is used to create a map.
	 */
	
	L.Map = L.Class.extend({
	
		includes: L.Mixin.Events,
	
		options: {
			crs: L.CRS.EPSG3857,
	
			/*
			center: LatLng,
			zoom: Number,
			layers: Array,
			*/
	
			fadeAnimation: L.DomUtil.TRANSITION && !L.Browser.android23,
			trackResize: true,
			markerZoomAnimation: L.DomUtil.TRANSITION && L.Browser.any3d
		},
	
		initialize: function (id, options) { // (HTMLElement or String, Object)
			options = L.setOptions(this, options);
	
	
			this._initContainer(id);
			this._initLayout();
	
			// hack for https://github.com/Leaflet/Leaflet/issues/1980
			this._onResize = L.bind(this._onResize, this);
	
			this._initEvents();
	
			if (options.maxBounds) {
				this.setMaxBounds(options.maxBounds);
			}
	
			if (options.center && options.zoom !== undefined) {
				this.setView(L.latLng(options.center), options.zoom, {reset: true});
			}
	
			this._handlers = [];
	
			this._layers = {};
			this._zoomBoundLayers = {};
			this._tileLayersNum = 0;
	
			this.callInitHooks();
	
			this._addLayers(options.layers);
		},
	
	
		// public methods that modify map state
	
		// replaced by animation-powered implementation in Map.PanAnimation.js
		setView: function (center, zoom) {
			zoom = zoom === undefined ? this.getZoom() : zoom;
			this._resetView(L.latLng(center), this._limitZoom(zoom));
			return this;
		},
	
		setZoom: function (zoom, options) {
			if (!this._loaded) {
				this._zoom = this._limitZoom(zoom);
				return this;
			}
			return this.setView(this.getCenter(), zoom, {zoom: options});
		},
	
		zoomIn: function (delta, options) {
			return this.setZoom(this._zoom + (delta || 1), options);
		},
	
		zoomOut: function (delta, options) {
			return this.setZoom(this._zoom - (delta || 1), options);
		},
	
		setZoomAround: function (latlng, zoom, options) {
			var scale = this.getZoomScale(zoom),
			    viewHalf = this.getSize().divideBy(2),
			    containerPoint = latlng instanceof L.Point ? latlng : this.latLngToContainerPoint(latlng),
	
			    centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
			    newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
	
			return this.setView(newCenter, zoom, {zoom: options});
		},
	
		fitBounds: function (bounds, options) {
	
			options = options || {};
			bounds = bounds.getBounds ? bounds.getBounds() : L.latLngBounds(bounds);
	
			var paddingTL = L.point(options.paddingTopLeft || options.padding || [0, 0]),
			    paddingBR = L.point(options.paddingBottomRight || options.padding || [0, 0]),
	
			    zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
	
			zoom = (options.maxZoom) ? Math.min(options.maxZoom, zoom) : zoom;
	
			var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2),
	
			    swPoint = this.project(bounds.getSouthWest(), zoom),
			    nePoint = this.project(bounds.getNorthEast(), zoom),
			    center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
	
			return this.setView(center, zoom, options);
		},
	
		fitWorld: function (options) {
			return this.fitBounds([[-90, -180], [90, 180]], options);
		},
	
		panTo: function (center, options) { // (LatLng)
			return this.setView(center, this._zoom, {pan: options});
		},
	
		panBy: function (offset) { // (Point)
			// replaced with animated panBy in Map.PanAnimation.js
			this.fire('movestart');
	
			this._rawPanBy(L.point(offset));
	
			this.fire('move');
			return this.fire('moveend');
		},
	
		setMaxBounds: function (bounds) {
			bounds = L.latLngBounds(bounds);
	
			this.options.maxBounds = bounds;
	
			if (!bounds) {
				return this.off('moveend', this._panInsideMaxBounds, this);
			}
	
			if (this._loaded) {
				this._panInsideMaxBounds();
			}
	
			return this.on('moveend', this._panInsideMaxBounds, this);
		},
	
		panInsideBounds: function (bounds, options) {
			var center = this.getCenter(),
				newCenter = this._limitCenter(center, this._zoom, bounds);
	
			if (center.equals(newCenter)) { return this; }
	
			return this.panTo(newCenter, options);
		},
	
		addLayer: function (layer) {
			// TODO method is too big, refactor
	
			var id = L.stamp(layer);
	
			if (this._layers[id]) { return this; }
	
			this._layers[id] = layer;
	
			// TODO getMaxZoom, getMinZoom in ILayer (instead of options)
			if (layer.options && (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom))) {
				this._zoomBoundLayers[id] = layer;
				this._updateZoomLevels();
			}
	
			// TODO looks ugly, refactor!!!
			if (this.options.zoomAnimation && L.TileLayer && (layer instanceof L.TileLayer)) {
				this._tileLayersNum++;
				this._tileLayersToLoad++;
				layer.on('load', this._onTileLayerLoad, this);
			}
	
			if (this._loaded) {
				this._layerAdd(layer);
			}
	
			return this;
		},
	
		removeLayer: function (layer) {
			var id = L.stamp(layer);
	
			if (!this._layers[id]) { return this; }
	
			if (this._loaded) {
				layer.onRemove(this);
			}
	
			delete this._layers[id];
	
			if (this._loaded) {
				this.fire('layerremove', {layer: layer});
			}
	
			if (this._zoomBoundLayers[id]) {
				delete this._zoomBoundLayers[id];
				this._updateZoomLevels();
			}
	
			// TODO looks ugly, refactor
			if (this.options.zoomAnimation && L.TileLayer && (layer instanceof L.TileLayer)) {
				this._tileLayersNum--;
				this._tileLayersToLoad--;
				layer.off('load', this._onTileLayerLoad, this);
			}
	
			return this;
		},
	
		hasLayer: function (layer) {
			if (!layer) { return false; }
	
			return (L.stamp(layer) in this._layers);
		},
	
		eachLayer: function (method, context) {
			for (var i in this._layers) {
				method.call(context, this._layers[i]);
			}
			return this;
		},
	
		invalidateSize: function (options) {
			if (!this._loaded) { return this; }
	
			options = L.extend({
				animate: false,
				pan: true
			}, options === true ? {animate: true} : options);
	
			var oldSize = this.getSize();
			this._sizeChanged = true;
			this._initialCenter = null;
	
			var newSize = this.getSize(),
			    oldCenter = oldSize.divideBy(2).round(),
			    newCenter = newSize.divideBy(2).round(),
			    offset = oldCenter.subtract(newCenter);
	
			if (!offset.x && !offset.y) { return this; }
	
			if (options.animate && options.pan) {
				this.panBy(offset);
	
			} else {
				if (options.pan) {
					this._rawPanBy(offset);
				}
	
				this.fire('move');
	
				if (options.debounceMoveend) {
					clearTimeout(this._sizeTimer);
					this._sizeTimer = setTimeout(L.bind(this.fire, this, 'moveend'), 200);
				} else {
					this.fire('moveend');
				}
			}
	
			return this.fire('resize', {
				oldSize: oldSize,
				newSize: newSize
			});
		},
	
		// TODO handler.addTo
		addHandler: function (name, HandlerClass) {
			if (!HandlerClass) { return this; }
	
			var handler = this[name] = new HandlerClass(this);
	
			this._handlers.push(handler);
	
			if (this.options[name]) {
				handler.enable();
			}
	
			return this;
		},
	
		remove: function () {
			if (this._loaded) {
				this.fire('unload');
			}
	
			this._initEvents('off');
	
			try {
				// throws error in IE6-8
				delete this._container._leaflet;
			} catch (e) {
				this._container._leaflet = undefined;
			}
	
			this._clearPanes();
			if (this._clearControlPos) {
				this._clearControlPos();
			}
	
			this._clearHandlers();
	
			return this;
		},
	
	
		// public methods for getting map state
	
		getCenter: function () { // (Boolean) -> LatLng
			this._checkIfLoaded();
	
			if (this._initialCenter && !this._moved()) {
				return this._initialCenter;
			}
			return this.layerPointToLatLng(this._getCenterLayerPoint());
		},
	
		getZoom: function () {
			return this._zoom;
		},
	
		getBounds: function () {
			var bounds = this.getPixelBounds(),
			    sw = this.unproject(bounds.getBottomLeft()),
			    ne = this.unproject(bounds.getTopRight());
	
			return new L.LatLngBounds(sw, ne);
		},
	
		getMinZoom: function () {
			return this.options.minZoom === undefined ?
				(this._layersMinZoom === undefined ? 0 : this._layersMinZoom) :
				this.options.minZoom;
		},
	
		getMaxZoom: function () {
			return this.options.maxZoom === undefined ?
				(this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom) :
				this.options.maxZoom;
		},
	
		getBoundsZoom: function (bounds, inside, padding) { // (LatLngBounds[, Boolean, Point]) -> Number
			bounds = L.latLngBounds(bounds);
	
			var zoom = this.getMinZoom() - (inside ? 1 : 0),
			    maxZoom = this.getMaxZoom(),
			    size = this.getSize(),
	
			    nw = bounds.getNorthWest(),
			    se = bounds.getSouthEast(),
	
			    zoomNotFound = true,
			    boundsSize;
	
			padding = L.point(padding || [0, 0]);
	
			do {
				zoom++;
				boundsSize = this.project(se, zoom).subtract(this.project(nw, zoom)).add(padding);
				zoomNotFound = !inside ? size.contains(boundsSize) : boundsSize.x < size.x || boundsSize.y < size.y;
	
			} while (zoomNotFound && zoom <= maxZoom);
	
			if (zoomNotFound && inside) {
				return null;
			}
	
			return inside ? zoom : zoom - 1;
		},
	
		getSize: function () {
			if (!this._size || this._sizeChanged) {
				this._size = new L.Point(
					this._container.clientWidth,
					this._container.clientHeight);
	
				this._sizeChanged = false;
			}
			return this._size.clone();
		},
	
		getPixelBounds: function () {
			var topLeftPoint = this._getTopLeftPoint();
			return new L.Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
		},
	
		getPixelOrigin: function () {
			this._checkIfLoaded();
			return this._initialTopLeftPoint;
		},
	
		getPanes: function () {
			return this._panes;
		},
	
		getContainer: function () {
			return this._container;
		},
	
	
		// TODO replace with universal implementation after refactoring projections
	
		getZoomScale: function (toZoom) {
			var crs = this.options.crs;
			return crs.scale(toZoom) / crs.scale(this._zoom);
		},
	
		getScaleZoom: function (scale) {
			return this._zoom + (Math.log(scale) / Math.LN2);
		},
	
	
		// conversion methods
	
		project: function (latlng, zoom) { // (LatLng[, Number]) -> Point
			zoom = zoom === undefined ? this._zoom : zoom;
			return this.options.crs.latLngToPoint(L.latLng(latlng), zoom);
		},
	
		unproject: function (point, zoom) { // (Point[, Number]) -> LatLng
			zoom = zoom === undefined ? this._zoom : zoom;
			return this.options.crs.pointToLatLng(L.point(point), zoom);
		},
	
		layerPointToLatLng: function (point) { // (Point)
			var projectedPoint = L.point(point).add(this.getPixelOrigin());
			return this.unproject(projectedPoint);
		},
	
		latLngToLayerPoint: function (latlng) { // (LatLng)
			var projectedPoint = this.project(L.latLng(latlng))._round();
			return projectedPoint._subtract(this.getPixelOrigin());
		},
	
		containerPointToLayerPoint: function (point) { // (Point)
			return L.point(point).subtract(this._getMapPanePos());
		},
	
		layerPointToContainerPoint: function (point) { // (Point)
			return L.point(point).add(this._getMapPanePos());
		},
	
		containerPointToLatLng: function (point) {
			var layerPoint = this.containerPointToLayerPoint(L.point(point));
			return this.layerPointToLatLng(layerPoint);
		},
	
		latLngToContainerPoint: function (latlng) {
			return this.layerPointToContainerPoint(this.latLngToLayerPoint(L.latLng(latlng)));
		},
	
		mouseEventToContainerPoint: function (e) { // (MouseEvent)
			return L.DomEvent.getMousePosition(e, this._container);
		},
	
		mouseEventToLayerPoint: function (e) { // (MouseEvent)
			return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
		},
	
		mouseEventToLatLng: function (e) { // (MouseEvent)
			return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
		},
	
	
		// map initialization methods
	
		_initContainer: function (id) {
			var container = this._container = L.DomUtil.get(id);
	
			if (!container) {
				throw new Error('Map container not found.');
			} else if (container._leaflet) {
				throw new Error('Map container is already initialized.');
			}
	
			container._leaflet = true;
		},
	
		_initLayout: function () {
			var container = this._container;
	
			L.DomUtil.addClass(container, 'leaflet-container' +
				(L.Browser.touch ? ' leaflet-touch' : '') +
				(L.Browser.retina ? ' leaflet-retina' : '') +
				(L.Browser.ielt9 ? ' leaflet-oldie' : '') +
				(this.options.fadeAnimation ? ' leaflet-fade-anim' : ''));
	
			var position = L.DomUtil.getStyle(container, 'position');
	
			if (position !== 'absolute' && position !== 'relative' && position !== 'fixed') {
				container.style.position = 'relative';
			}
	
			this._initPanes();
	
			if (this._initControlPos) {
				this._initControlPos();
			}
		},
	
		_initPanes: function () {
			var panes = this._panes = {};
	
			this._mapPane = panes.mapPane = this._createPane('leaflet-map-pane', this._container);
	
			this._tilePane = panes.tilePane = this._createPane('leaflet-tile-pane', this._mapPane);
			panes.objectsPane = this._createPane('leaflet-objects-pane', this._mapPane);
			panes.shadowPane = this._createPane('leaflet-shadow-pane');
			panes.overlayPane = this._createPane('leaflet-overlay-pane');
			panes.markerPane = this._createPane('leaflet-marker-pane');
			panes.popupPane = this._createPane('leaflet-popup-pane');
	
			var zoomHide = ' leaflet-zoom-hide';
	
			if (!this.options.markerZoomAnimation) {
				L.DomUtil.addClass(panes.markerPane, zoomHide);
				L.DomUtil.addClass(panes.shadowPane, zoomHide);
				L.DomUtil.addClass(panes.popupPane, zoomHide);
			}
		},
	
		_createPane: function (className, container) {
			return L.DomUtil.create('div', className, container || this._panes.objectsPane);
		},
	
		_clearPanes: function () {
			this._container.removeChild(this._mapPane);
		},
	
		_addLayers: function (layers) {
			layers = layers ? (L.Util.isArray(layers) ? layers : [layers]) : [];
	
			for (var i = 0, len = layers.length; i < len; i++) {
				this.addLayer(layers[i]);
			}
		},
	
	
		// private methods that modify map state
	
		_resetView: function (center, zoom, preserveMapOffset, afterZoomAnim) {
	
			var zoomChanged = (this._zoom !== zoom);
	
			if (!afterZoomAnim) {
				this.fire('movestart');
	
				if (zoomChanged) {
					this.fire('zoomstart');
				}
			}
	
			this._zoom = zoom;
			this._initialCenter = center;
	
			this._initialTopLeftPoint = this._getNewTopLeftPoint(center);
	
			if (!preserveMapOffset) {
				L.DomUtil.setPosition(this._mapPane, new L.Point(0, 0));
			} else {
				this._initialTopLeftPoint._add(this._getMapPanePos());
			}
	
			this._tileLayersToLoad = this._tileLayersNum;
	
			var loading = !this._loaded;
			this._loaded = true;
	
			this.fire('viewreset', {hard: !preserveMapOffset});
	
			if (loading) {
				this.fire('load');
				this.eachLayer(this._layerAdd, this);
			}
	
			this.fire('move');
	
			if (zoomChanged || afterZoomAnim) {
				this.fire('zoomend');
			}
	
			this.fire('moveend', {hard: !preserveMapOffset});
		},
	
		_rawPanBy: function (offset) {
			L.DomUtil.setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
		},
	
		_getZoomSpan: function () {
			return this.getMaxZoom() - this.getMinZoom();
		},
	
		_updateZoomLevels: function () {
			var i,
				minZoom = Infinity,
				maxZoom = -Infinity,
				oldZoomSpan = this._getZoomSpan();
	
			for (i in this._zoomBoundLayers) {
				var layer = this._zoomBoundLayers[i];
				if (!isNaN(layer.options.minZoom)) {
					minZoom = Math.min(minZoom, layer.options.minZoom);
				}
				if (!isNaN(layer.options.maxZoom)) {
					maxZoom = Math.max(maxZoom, layer.options.maxZoom);
				}
			}
	
			if (i === undefined) { // we have no tilelayers
				this._layersMaxZoom = this._layersMinZoom = undefined;
			} else {
				this._layersMaxZoom = maxZoom;
				this._layersMinZoom = minZoom;
			}
	
			if (oldZoomSpan !== this._getZoomSpan()) {
				this.fire('zoomlevelschange');
			}
		},
	
		_panInsideMaxBounds: function () {
			this.panInsideBounds(this.options.maxBounds);
		},
	
		_checkIfLoaded: function () {
			if (!this._loaded) {
				throw new Error('Set map center and zoom first.');
			}
		},
	
		// map events
	
		_initEvents: function (onOff) {
			if (!L.DomEvent) { return; }
	
			onOff = onOff || 'on';
	
			L.DomEvent[onOff](this._container, 'click', this._onMouseClick, this);
	
			var events = ['dblclick', 'mousedown', 'mouseup', 'mouseenter',
			              'mouseleave', 'mousemove', 'contextmenu'],
			    i, len;
	
			for (i = 0, len = events.length; i < len; i++) {
				L.DomEvent[onOff](this._container, events[i], this._fireMouseEvent, this);
			}
	
			if (this.options.trackResize) {
				L.DomEvent[onOff](window, 'resize', this._onResize, this);
			}
		},
	
		_onResize: function () {
			L.Util.cancelAnimFrame(this._resizeRequest);
			this._resizeRequest = L.Util.requestAnimFrame(
			        function () { this.invalidateSize({debounceMoveend: true}); }, this, false, this._container);
		},
	
		_onMouseClick: function (e) {
			if (!this._loaded || (!e._simulated &&
			        ((this.dragging && this.dragging.moved()) ||
			         (this.boxZoom  && this.boxZoom.moved()))) ||
			            L.DomEvent._skipped(e)) { return; }
	
			this.fire('preclick');
			this._fireMouseEvent(e);
		},
	
		_fireMouseEvent: function (e) {
			if (!this._loaded || L.DomEvent._skipped(e)) { return; }
	
			var type = e.type;
	
			type = (type === 'mouseenter' ? 'mouseover' : (type === 'mouseleave' ? 'mouseout' : type));
	
			if (!this.hasEventListeners(type)) { return; }
	
			if (type === 'contextmenu') {
				L.DomEvent.preventDefault(e);
			}
	
			var containerPoint = this.mouseEventToContainerPoint(e),
			    layerPoint = this.containerPointToLayerPoint(containerPoint),
			    latlng = this.layerPointToLatLng(layerPoint);
	
			this.fire(type, {
				latlng: latlng,
				layerPoint: layerPoint,
				containerPoint: containerPoint,
				originalEvent: e
			});
		},
	
		_onTileLayerLoad: function () {
			this._tileLayersToLoad--;
			if (this._tileLayersNum && !this._tileLayersToLoad) {
				this.fire('tilelayersload');
			}
		},
	
		_clearHandlers: function () {
			for (var i = 0, len = this._handlers.length; i < len; i++) {
				this._handlers[i].disable();
			}
		},
	
		whenReady: function (callback, context) {
			if (this._loaded) {
				callback.call(context || this, this);
			} else {
				this.on('load', callback, context);
			}
			return this;
		},
	
		_layerAdd: function (layer) {
			layer.onAdd(this);
			this.fire('layeradd', {layer: layer});
		},
	
	
		// private methods for getting map state
	
		_getMapPanePos: function () {
			return L.DomUtil.getPosition(this._mapPane);
		},
	
		_moved: function () {
			var pos = this._getMapPanePos();
			return pos && !pos.equals([0, 0]);
		},
	
		_getTopLeftPoint: function () {
			return this.getPixelOrigin().subtract(this._getMapPanePos());
		},
	
		_getNewTopLeftPoint: function (center, zoom) {
			var viewHalf = this.getSize()._divideBy(2);
			// TODO round on display, not calculation to increase precision?
			return this.project(center, zoom)._subtract(viewHalf)._round();
		},
	
		_latLngToNewLayerPoint: function (latlng, newZoom, newCenter) {
			var topLeft = this._getNewTopLeftPoint(newCenter, newZoom).add(this._getMapPanePos());
			return this.project(latlng, newZoom)._subtract(topLeft);
		},
	
		// layer point of the current center
		_getCenterLayerPoint: function () {
			return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
		},
	
		// offset of the specified place to the current center in pixels
		_getCenterOffset: function (latlng) {
			return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
		},
	
		// adjust center for view to get inside bounds
		_limitCenter: function (center, zoom, bounds) {
	
			if (!bounds) { return center; }
	
			var centerPoint = this.project(center, zoom),
			    viewHalf = this.getSize().divideBy(2),
			    viewBounds = new L.Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)),
			    offset = this._getBoundsOffset(viewBounds, bounds, zoom);
	
			return this.unproject(centerPoint.add(offset), zoom);
		},
	
		// adjust offset for view to get inside bounds
		_limitOffset: function (offset, bounds) {
			if (!bounds) { return offset; }
	
			var viewBounds = this.getPixelBounds(),
			    newBounds = new L.Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
	
			return offset.add(this._getBoundsOffset(newBounds, bounds));
		},
	
		// returns offset needed for pxBounds to get inside maxBounds at a specified zoom
		_getBoundsOffset: function (pxBounds, maxBounds, zoom) {
			var nwOffset = this.project(maxBounds.getNorthWest(), zoom).subtract(pxBounds.min),
			    seOffset = this.project(maxBounds.getSouthEast(), zoom).subtract(pxBounds.max),
	
			    dx = this._rebound(nwOffset.x, -seOffset.x),
			    dy = this._rebound(nwOffset.y, -seOffset.y);
	
			return new L.Point(dx, dy);
		},
	
		_rebound: function (left, right) {
			return left + right > 0 ?
				Math.round(left - right) / 2 :
				Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
		},
	
		_limitZoom: function (zoom) {
			var min = this.getMinZoom(),
			    max = this.getMaxZoom();
	
			return Math.max(min, Math.min(max, zoom));
		}
	});
	
	L.map = function (id, options) {
		return new L.Map(id, options);
	};
	
	
	/*
	 * Mercator projection that takes into account that the Earth is not a perfect sphere.
	 * Less popular than spherical mercator; used by projections like EPSG:3395.
	 */
	
	L.Projection.Mercator = {
		MAX_LATITUDE: 85.0840591556,
	
		R_MINOR: 6356752.314245179,
		R_MAJOR: 6378137,
	
		project: function (latlng) { // (LatLng) -> Point
			var d = L.LatLng.DEG_TO_RAD,
			    max = this.MAX_LATITUDE,
			    lat = Math.max(Math.min(max, latlng.lat), -max),
			    r = this.R_MAJOR,
			    r2 = this.R_MINOR,
			    x = latlng.lng * d * r,
			    y = lat * d,
			    tmp = r2 / r,
			    eccent = Math.sqrt(1.0 - tmp * tmp),
			    con = eccent * Math.sin(y);
	
			con = Math.pow((1 - con) / (1 + con), eccent * 0.5);
	
			var ts = Math.tan(0.5 * ((Math.PI * 0.5) - y)) / con;
			y = -r * Math.log(ts);
	
			return new L.Point(x, y);
		},
	
		unproject: function (point) { // (Point, Boolean) -> LatLng
			var d = L.LatLng.RAD_TO_DEG,
			    r = this.R_MAJOR,
			    r2 = this.R_MINOR,
			    lng = point.x * d / r,
			    tmp = r2 / r,
			    eccent = Math.sqrt(1 - (tmp * tmp)),
			    ts = Math.exp(- point.y / r),
			    phi = (Math.PI / 2) - 2 * Math.atan(ts),
			    numIter = 15,
			    tol = 1e-7,
			    i = numIter,
			    dphi = 0.1,
			    con;
	
			while ((Math.abs(dphi) > tol) && (--i > 0)) {
				con = eccent * Math.sin(phi);
				dphi = (Math.PI / 2) - 2 * Math.atan(ts *
				            Math.pow((1.0 - con) / (1.0 + con), 0.5 * eccent)) - phi;
				phi += dphi;
			}
	
			return new L.LatLng(phi * d, lng);
		}
	};
	
	
	
	L.CRS.EPSG3395 = L.extend({}, L.CRS, {
		code: 'EPSG:3395',
	
		projection: L.Projection.Mercator,
	
		transformation: (function () {
			var m = L.Projection.Mercator,
			    r = m.R_MAJOR,
			    scale = 0.5 / (Math.PI * r);
	
			return new L.Transformation(scale, 0.5, -scale, 0.5);
		}())
	});
	
	
	/*
	 * L.TileLayer is used for standard xyz-numbered tile layers.
	 */
	
	L.TileLayer = L.Class.extend({
		includes: L.Mixin.Events,
	
		options: {
			minZoom: 0,
			maxZoom: 18,
			tileSize: 256,
			subdomains: 'abc',
			errorTileUrl: '',
			attribution: '',
			zoomOffset: 0,
			opacity: 1,
			/*
			maxNativeZoom: null,
			zIndex: null,
			tms: false,
			continuousWorld: false,
			noWrap: false,
			zoomReverse: false,
			detectRetina: false,
			reuseTiles: false,
			bounds: false,
			*/
			unloadInvisibleTiles: L.Browser.mobile,
			updateWhenIdle: L.Browser.mobile
		},
	
		initialize: function (url, options) {
			options = L.setOptions(this, options);
	
			// detecting retina displays, adjusting tileSize and zoom levels
			if (options.detectRetina && L.Browser.retina && options.maxZoom > 0) {
	
				options.tileSize = Math.floor(options.tileSize / 2);
				options.zoomOffset++;
	
				if (options.minZoom > 0) {
					options.minZoom--;
				}
				this.options.maxZoom--;
			}
	
			if (options.bounds) {
				options.bounds = L.latLngBounds(options.bounds);
			}
	
			this._url = url;
	
			var subdomains = this.options.subdomains;
	
			if (typeof subdomains === 'string') {
				this.options.subdomains = subdomains.split('');
			}
		},
	
		onAdd: function (map) {
			this._map = map;
			this._animated = map._zoomAnimated;
	
			// create a container div for tiles
			this._initContainer();
	
			// set up events
			map.on({
				'viewreset': this._reset,
				'moveend': this._update
			}, this);
	
			if (this._animated) {
				map.on({
					'zoomanim': this._animateZoom,
					'zoomend': this._endZoomAnim
				}, this);
			}
	
			if (!this.options.updateWhenIdle) {
				this._limitedUpdate = L.Util.limitExecByInterval(this._update, 150, this);
				map.on('move', this._limitedUpdate, this);
			}
	
			this._reset();
			this._update();
		},
	
		addTo: function (map) {
			map.addLayer(this);
			return this;
		},
	
		onRemove: function (map) {
			this._container.parentNode.removeChild(this._container);
	
			map.off({
				'viewreset': this._reset,
				'moveend': this._update
			}, this);
	
			if (this._animated) {
				map.off({
					'zoomanim': this._animateZoom,
					'zoomend': this._endZoomAnim
				}, this);
			}
	
			if (!this.options.updateWhenIdle) {
				map.off('move', this._limitedUpdate, this);
			}
	
			this._container = null;
			this._map = null;
		},
	
		bringToFront: function () {
			var pane = this._map._panes.tilePane;
	
			if (this._container) {
				pane.appendChild(this._container);
				this._setAutoZIndex(pane, Math.max);
			}
	
			return this;
		},
	
		bringToBack: function () {
			var pane = this._map._panes.tilePane;
	
			if (this._container) {
				pane.insertBefore(this._container, pane.firstChild);
				this._setAutoZIndex(pane, Math.min);
			}
	
			return this;
		},
	
		getAttribution: function () {
			return this.options.attribution;
		},
	
		getContainer: function () {
			return this._container;
		},
	
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
	
			if (this._map) {
				this._updateOpacity();
			}
	
			return this;
		},
	
		setZIndex: function (zIndex) {
			this.options.zIndex = zIndex;
			this._updateZIndex();
	
			return this;
		},
	
		setUrl: function (url, noRedraw) {
			this._url = url;
	
			if (!noRedraw) {
				this.redraw();
			}
	
			return this;
		},
	
		redraw: function () {
			if (this._map) {
				this._reset({hard: true});
				this._update();
			}
			return this;
		},
	
		_updateZIndex: function () {
			if (this._container && this.options.zIndex !== undefined) {
				this._container.style.zIndex = this.options.zIndex;
			}
		},
	
		_setAutoZIndex: function (pane, compare) {
	
			var layers = pane.children,
			    edgeZIndex = -compare(Infinity, -Infinity), // -Infinity for max, Infinity for min
			    zIndex, i, len;
	
			for (i = 0, len = layers.length; i < len; i++) {
	
				if (layers[i] !== this._container) {
					zIndex = parseInt(layers[i].style.zIndex, 10);
	
					if (!isNaN(zIndex)) {
						edgeZIndex = compare(edgeZIndex, zIndex);
					}
				}
			}
	
			this.options.zIndex = this._container.style.zIndex =
			        (isFinite(edgeZIndex) ? edgeZIndex : 0) + compare(1, -1);
		},
	
		_updateOpacity: function () {
			var i,
			    tiles = this._tiles;
	
			if (L.Browser.ielt9) {
				for (i in tiles) {
					L.DomUtil.setOpacity(tiles[i], this.options.opacity);
				}
			} else {
				L.DomUtil.setOpacity(this._container, this.options.opacity);
			}
		},
	
		_initContainer: function () {
			var tilePane = this._map._panes.tilePane;
	
			if (!this._container) {
				this._container = L.DomUtil.create('div', 'leaflet-layer');
	
				this._updateZIndex();
	
				if (this._animated) {
					var className = 'leaflet-tile-container';
	
					this._bgBuffer = L.DomUtil.create('div', className, this._container);
					this._tileContainer = L.DomUtil.create('div', className, this._container);
	
				} else {
					this._tileContainer = this._container;
				}
	
				tilePane.appendChild(this._container);
	
				if (this.options.opacity < 1) {
					this._updateOpacity();
				}
			}
		},
	
		_reset: function (e) {
			for (var key in this._tiles) {
				this.fire('tileunload', {tile: this._tiles[key]});
			}
	
			this._tiles = {};
			this._tilesToLoad = 0;
	
			if (this.options.reuseTiles) {
				this._unusedTiles = [];
			}
	
			this._tileContainer.innerHTML = '';
	
			if (this._animated && e && e.hard) {
				this._clearBgBuffer();
			}
	
			this._initContainer();
		},
	
		_getTileSize: function () {
			var map = this._map,
			    zoom = map.getZoom() + this.options.zoomOffset,
			    zoomN = this.options.maxNativeZoom,
			    tileSize = this.options.tileSize;
	
			if (zoomN && zoom > zoomN) {
				tileSize = Math.round(map.getZoomScale(zoom) / map.getZoomScale(zoomN) * tileSize);
			}
	
			return tileSize;
		},
	
		_update: function () {
	
			if (!this._map) { return; }
	
			var map = this._map,
			    bounds = map.getPixelBounds(),
			    zoom = map.getZoom(),
			    tileSize = this._getTileSize();
	
			if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
				return;
			}
	
			var tileBounds = L.bounds(
			        bounds.min.divideBy(tileSize)._floor(),
			        bounds.max.divideBy(tileSize)._floor());
	
			this._addTilesFromCenterOut(tileBounds);
	
			if (this.options.unloadInvisibleTiles || this.options.reuseTiles) {
				this._removeOtherTiles(tileBounds);
			}
		},
	
		_addTilesFromCenterOut: function (bounds) {
			var queue = [],
			    center = bounds.getCenter();
	
			var j, i, point;
	
			for (j = bounds.min.y; j <= bounds.max.y; j++) {
				for (i = bounds.min.x; i <= bounds.max.x; i++) {
					point = new L.Point(i, j);
	
					if (this._tileShouldBeLoaded(point)) {
						queue.push(point);
					}
				}
			}
	
			var tilesToLoad = queue.length;
	
			if (tilesToLoad === 0) { return; }
	
			// load tiles in order of their distance to center
			queue.sort(function (a, b) {
				return a.distanceTo(center) - b.distanceTo(center);
			});
	
			var fragment = document.createDocumentFragment();
	
			// if its the first batch of tiles to load
			if (!this._tilesToLoad) {
				this.fire('loading');
			}
	
			this._tilesToLoad += tilesToLoad;
	
			for (i = 0; i < tilesToLoad; i++) {
				this._addTile(queue[i], fragment);
			}
	
			this._tileContainer.appendChild(fragment);
		},
	
		_tileShouldBeLoaded: function (tilePoint) {
			if ((tilePoint.x + ':' + tilePoint.y) in this._tiles) {
				return false; // already loaded
			}
	
			var options = this.options;
	
			if (!options.continuousWorld) {
				var limit = this._getWrapTileNum();
	
				// don't load if exceeds world bounds
				if ((options.noWrap && (tilePoint.x < 0 || tilePoint.x >= limit.x)) ||
					tilePoint.y < 0 || tilePoint.y >= limit.y) { return false; }
			}
	
			if (options.bounds) {
				var tileSize = this._getTileSize(),
				    nwPoint = tilePoint.multiplyBy(tileSize),
				    sePoint = nwPoint.add([tileSize, tileSize]),
				    nw = this._map.unproject(nwPoint),
				    se = this._map.unproject(sePoint);
	
				// TODO temporary hack, will be removed after refactoring projections
				// https://github.com/Leaflet/Leaflet/issues/1618
				if (!options.continuousWorld && !options.noWrap) {
					nw = nw.wrap();
					se = se.wrap();
				}
	
				if (!options.bounds.intersects([nw, se])) { return false; }
			}
	
			return true;
		},
	
		_removeOtherTiles: function (bounds) {
			var kArr, x, y, key;
	
			for (key in this._tiles) {
				kArr = key.split(':');
				x = parseInt(kArr[0], 10);
				y = parseInt(kArr[1], 10);
	
				// remove tile if it's out of bounds
				if (x < bounds.min.x || x > bounds.max.x || y < bounds.min.y || y > bounds.max.y) {
					this._removeTile(key);
				}
			}
		},
	
		_removeTile: function (key) {
			var tile = this._tiles[key];
	
			this.fire('tileunload', {tile: tile, url: tile.src});
	
			if (this.options.reuseTiles) {
				L.DomUtil.removeClass(tile, 'leaflet-tile-loaded');
				this._unusedTiles.push(tile);
	
			} else if (tile.parentNode === this._tileContainer) {
				this._tileContainer.removeChild(tile);
			}
	
			// for https://github.com/CloudMade/Leaflet/issues/137
			if (!L.Browser.android) {
				tile.onload = null;
				tile.src = L.Util.emptyImageUrl;
			}
	
			delete this._tiles[key];
		},
	
		_addTile: function (tilePoint, container) {
			var tilePos = this._getTilePos(tilePoint);
	
			// get unused tile - or create a new tile
			var tile = this._getTile();
	
			/*
			Chrome 20 layouts much faster with top/left (verify with timeline, frames)
			Android 4 browser has display issues with top/left and requires transform instead
			(other browsers don't currently care) - see debug/hacks/jitter.html for an example
			*/
			L.DomUtil.setPosition(tile, tilePos, L.Browser.chrome);
	
			this._tiles[tilePoint.x + ':' + tilePoint.y] = tile;
	
			this._loadTile(tile, tilePoint);
	
			if (tile.parentNode !== this._tileContainer) {
				container.appendChild(tile);
			}
		},
	
		_getZoomForUrl: function () {
	
			var options = this.options,
			    zoom = this._map.getZoom();
	
			if (options.zoomReverse) {
				zoom = options.maxZoom - zoom;
			}
	
			zoom += options.zoomOffset;
	
			return options.maxNativeZoom ? Math.min(zoom, options.maxNativeZoom) : zoom;
		},
	
		_getTilePos: function (tilePoint) {
			var origin = this._map.getPixelOrigin(),
			    tileSize = this._getTileSize();
	
			return tilePoint.multiplyBy(tileSize).subtract(origin);
		},
	
		// image-specific code (override to implement e.g. Canvas or SVG tile layer)
	
		getTileUrl: function (tilePoint) {
			return L.Util.template(this._url, L.extend({
				s: this._getSubdomain(tilePoint),
				z: tilePoint.z,
				x: tilePoint.x,
				y: tilePoint.y
			}, this.options));
		},
	
		_getWrapTileNum: function () {
			var crs = this._map.options.crs,
			    size = crs.getSize(this._map.getZoom());
			return size.divideBy(this._getTileSize())._floor();
		},
	
		_adjustTilePoint: function (tilePoint) {
	
			var limit = this._getWrapTileNum();
	
			// wrap tile coordinates
			if (!this.options.continuousWorld && !this.options.noWrap) {
				tilePoint.x = ((tilePoint.x % limit.x) + limit.x) % limit.x;
			}
	
			if (this.options.tms) {
				tilePoint.y = limit.y - tilePoint.y - 1;
			}
	
			tilePoint.z = this._getZoomForUrl();
		},
	
		_getSubdomain: function (tilePoint) {
			var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
			return this.options.subdomains[index];
		},
	
		_getTile: function () {
			if (this.options.reuseTiles && this._unusedTiles.length > 0) {
				var tile = this._unusedTiles.pop();
				this._resetTile(tile);
				return tile;
			}
			return this._createTile();
		},
	
		// Override if data stored on a tile needs to be cleaned up before reuse
		_resetTile: function (/*tile*/) {},
	
		_createTile: function () {
			var tile = L.DomUtil.create('img', 'leaflet-tile');
			tile.style.width = tile.style.height = this._getTileSize() + 'px';
			tile.galleryimg = 'no';
	
			tile.onselectstart = tile.onmousemove = L.Util.falseFn;
	
			if (L.Browser.ielt9 && this.options.opacity !== undefined) {
				L.DomUtil.setOpacity(tile, this.options.opacity);
			}
			// without this hack, tiles disappear after zoom on Chrome for Android
			// https://github.com/Leaflet/Leaflet/issues/2078
			if (L.Browser.mobileWebkit3d) {
				tile.style.WebkitBackfaceVisibility = 'hidden';
			}
			return tile;
		},
	
		_loadTile: function (tile, tilePoint) {
			tile._layer  = this;
			tile.onload  = this._tileOnLoad;
			tile.onerror = this._tileOnError;
	
			this._adjustTilePoint(tilePoint);
			tile.src     = this.getTileUrl(tilePoint);
	
			this.fire('tileloadstart', {
				tile: tile,
				url: tile.src
			});
		},
	
		_tileLoaded: function () {
			this._tilesToLoad--;
	
			if (this._animated) {
				L.DomUtil.addClass(this._tileContainer, 'leaflet-zoom-animated');
			}
	
			if (!this._tilesToLoad) {
				this.fire('load');
	
				if (this._animated) {
					// clear scaled tiles after all new tiles are loaded (for performance)
					clearTimeout(this._clearBgBufferTimer);
					this._clearBgBufferTimer = setTimeout(L.bind(this._clearBgBuffer, this), 500);
				}
			}
		},
	
		_tileOnLoad: function () {
			var layer = this._layer;
	
			//Only if we are loading an actual image
			if (this.src !== L.Util.emptyImageUrl) {
				L.DomUtil.addClass(this, 'leaflet-tile-loaded');
	
				layer.fire('tileload', {
					tile: this,
					url: this.src
				});
			}
	
			layer._tileLoaded();
		},
	
		_tileOnError: function () {
			var layer = this._layer;
	
			layer.fire('tileerror', {
				tile: this,
				url: this.src
			});
	
			var newUrl = layer.options.errorTileUrl;
			if (newUrl) {
				this.src = newUrl;
			}
	
			layer._tileLoaded();
		}
	});
	
	L.tileLayer = function (url, options) {
		return new L.TileLayer(url, options);
	};
	
	
	/*
	 * L.TileLayer.WMS is used for putting WMS tile layers on the map.
	 */
	
	L.TileLayer.WMS = L.TileLayer.extend({
	
		defaultWmsParams: {
			service: 'WMS',
			request: 'GetMap',
			version: '1.1.1',
			layers: '',
			styles: '',
			format: 'image/jpeg',
			transparent: false
		},
	
		initialize: function (url, options) { // (String, Object)
	
			this._url = url;
	
			var wmsParams = L.extend({}, this.defaultWmsParams),
			    tileSize = options.tileSize || this.options.tileSize;
	
			if (options.detectRetina && L.Browser.retina) {
				wmsParams.width = wmsParams.height = tileSize * 2;
			} else {
				wmsParams.width = wmsParams.height = tileSize;
			}
	
			for (var i in options) {
				// all keys that are not TileLayer options go to WMS params
				if (!this.options.hasOwnProperty(i) && i !== 'crs') {
					wmsParams[i] = options[i];
				}
			}
	
			this.wmsParams = wmsParams;
	
			L.setOptions(this, options);
		},
	
		onAdd: function (map) {
	
			this._crs = this.options.crs || map.options.crs;
	
			this._wmsVersion = parseFloat(this.wmsParams.version);
	
			var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
			this.wmsParams[projectionKey] = this._crs.code;
	
			L.TileLayer.prototype.onAdd.call(this, map);
		},
	
		getTileUrl: function (tilePoint) { // (Point, Number) -> String
	
			var map = this._map,
			    tileSize = this.options.tileSize,
	
			    nwPoint = tilePoint.multiplyBy(tileSize),
			    sePoint = nwPoint.add([tileSize, tileSize]),
	
			    nw = this._crs.project(map.unproject(nwPoint, tilePoint.z)),
			    se = this._crs.project(map.unproject(sePoint, tilePoint.z)),
			    bbox = this._wmsVersion >= 1.3 && this._crs === L.CRS.EPSG4326 ?
			        [se.y, nw.x, nw.y, se.x].join(',') :
			        [nw.x, se.y, se.x, nw.y].join(','),
	
			    url = L.Util.template(this._url, {s: this._getSubdomain(tilePoint)});
	
			return url + L.Util.getParamString(this.wmsParams, url, true) + '&BBOX=' + bbox;
		},
	
		setParams: function (params, noRedraw) {
	
			L.extend(this.wmsParams, params);
	
			if (!noRedraw) {
				this.redraw();
			}
	
			return this;
		}
	});
	
	L.tileLayer.wms = function (url, options) {
		return new L.TileLayer.WMS(url, options);
	};
	
	
	/*
	 * L.TileLayer.Canvas is a class that you can use as a base for creating
	 * dynamically drawn Canvas-based tile layers.
	 */
	
	L.TileLayer.Canvas = L.TileLayer.extend({
		options: {
			async: false
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
		},
	
		redraw: function () {
			if (this._map) {
				this._reset({hard: true});
				this._update();
			}
	
			for (var i in this._tiles) {
				this._redrawTile(this._tiles[i]);
			}
			return this;
		},
	
		_redrawTile: function (tile) {
			this.drawTile(tile, tile._tilePoint, this._map._zoom);
		},
	
		_createTile: function () {
			var tile = L.DomUtil.create('canvas', 'leaflet-tile');
			tile.width = tile.height = this.options.tileSize;
			tile.onselectstart = tile.onmousemove = L.Util.falseFn;
			return tile;
		},
	
		_loadTile: function (tile, tilePoint) {
			tile._layer = this;
			tile._tilePoint = tilePoint;
	
			this._redrawTile(tile);
	
			if (!this.options.async) {
				this.tileDrawn(tile);
			}
		},
	
		drawTile: function (/*tile, tilePoint*/) {
			// override with rendering code
		},
	
		tileDrawn: function (tile) {
			this._tileOnLoad.call(tile);
		}
	});
	
	
	L.tileLayer.canvas = function (options) {
		return new L.TileLayer.Canvas(options);
	};
	
	
	/*
	 * L.ImageOverlay is used to overlay images over the map (to specific geographical bounds).
	 */
	
	L.ImageOverlay = L.Class.extend({
		includes: L.Mixin.Events,
	
		options: {
			opacity: 1
		},
	
		initialize: function (url, bounds, options) { // (String, LatLngBounds, Object)
			this._url = url;
			this._bounds = L.latLngBounds(bounds);
	
			L.setOptions(this, options);
		},
	
		onAdd: function (map) {
			this._map = map;
	
			if (!this._image) {
				this._initImage();
			}
	
			map._panes.overlayPane.appendChild(this._image);
	
			map.on('viewreset', this._reset, this);
	
			if (map.options.zoomAnimation && L.Browser.any3d) {
				map.on('zoomanim', this._animateZoom, this);
			}
	
			this._reset();
		},
	
		onRemove: function (map) {
			map.getPanes().overlayPane.removeChild(this._image);
	
			map.off('viewreset', this._reset, this);
	
			if (map.options.zoomAnimation) {
				map.off('zoomanim', this._animateZoom, this);
			}
		},
	
		addTo: function (map) {
			map.addLayer(this);
			return this;
		},
	
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
			this._updateOpacity();
			return this;
		},
	
		// TODO remove bringToFront/bringToBack duplication from TileLayer/Path
		bringToFront: function () {
			if (this._image) {
				this._map._panes.overlayPane.appendChild(this._image);
			}
			return this;
		},
	
		bringToBack: function () {
			var pane = this._map._panes.overlayPane;
			if (this._image) {
				pane.insertBefore(this._image, pane.firstChild);
			}
			return this;
		},
	
		setUrl: function (url) {
			this._url = url;
			this._image.src = this._url;
		},
	
		getAttribution: function () {
			return this.options.attribution;
		},
	
		_initImage: function () {
			this._image = L.DomUtil.create('img', 'leaflet-image-layer');
	
			if (this._map.options.zoomAnimation && L.Browser.any3d) {
				L.DomUtil.addClass(this._image, 'leaflet-zoom-animated');
			} else {
				L.DomUtil.addClass(this._image, 'leaflet-zoom-hide');
			}
	
			this._updateOpacity();
	
			//TODO createImage util method to remove duplication
			L.extend(this._image, {
				galleryimg: 'no',
				onselectstart: L.Util.falseFn,
				onmousemove: L.Util.falseFn,
				onload: L.bind(this._onImageLoad, this),
				src: this._url
			});
		},
	
		_animateZoom: function (e) {
			var map = this._map,
			    image = this._image,
			    scale = map.getZoomScale(e.zoom),
			    nw = this._bounds.getNorthWest(),
			    se = this._bounds.getSouthEast(),
	
			    topLeft = map._latLngToNewLayerPoint(nw, e.zoom, e.center),
			    size = map._latLngToNewLayerPoint(se, e.zoom, e.center)._subtract(topLeft),
			    origin = topLeft._add(size._multiplyBy((1 / 2) * (1 - 1 / scale)));
	
			image.style[L.DomUtil.TRANSFORM] =
			        L.DomUtil.getTranslateString(origin) + ' scale(' + scale + ') ';
		},
	
		_reset: function () {
			var image   = this._image,
			    topLeft = this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
			    size = this._map.latLngToLayerPoint(this._bounds.getSouthEast())._subtract(topLeft);
	
			L.DomUtil.setPosition(image, topLeft);
	
			image.style.width  = size.x + 'px';
			image.style.height = size.y + 'px';
		},
	
		_onImageLoad: function () {
			this.fire('load');
		},
	
		_updateOpacity: function () {
			L.DomUtil.setOpacity(this._image, this.options.opacity);
		}
	});
	
	L.imageOverlay = function (url, bounds, options) {
		return new L.ImageOverlay(url, bounds, options);
	};
	
	
	/*
	 * L.Icon is an image-based icon class that you can use with L.Marker for custom markers.
	 */
	
	L.Icon = L.Class.extend({
		options: {
			/*
			iconUrl: (String) (required)
			iconRetinaUrl: (String) (optional, used for retina devices if detected)
			iconSize: (Point) (can be set through CSS)
			iconAnchor: (Point) (centered by default, can be set in CSS with negative margins)
			popupAnchor: (Point) (if not specified, popup opens in the anchor point)
			shadowUrl: (String) (no shadow by default)
			shadowRetinaUrl: (String) (optional, used for retina devices if detected)
			shadowSize: (Point)
			shadowAnchor: (Point)
			*/
			className: ''
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
		},
	
		createIcon: function (oldIcon) {
			return this._createIcon('icon', oldIcon);
		},
	
		createShadow: function (oldIcon) {
			return this._createIcon('shadow', oldIcon);
		},
	
		_createIcon: function (name, oldIcon) {
			var src = this._getIconUrl(name);
	
			if (!src) {
				if (name === 'icon') {
					throw new Error('iconUrl not set in Icon options (see the docs).');
				}
				return null;
			}
	
			var img;
			if (!oldIcon || oldIcon.tagName !== 'IMG') {
				img = this._createImg(src);
			} else {
				img = this._createImg(src, oldIcon);
			}
			this._setIconStyles(img, name);
	
			return img;
		},
	
		_setIconStyles: function (img, name) {
			var options = this.options,
			    size = L.point(options[name + 'Size']),
			    anchor;
	
			if (name === 'shadow') {
				anchor = L.point(options.shadowAnchor || options.iconAnchor);
			} else {
				anchor = L.point(options.iconAnchor);
			}
	
			if (!anchor && size) {
				anchor = size.divideBy(2, true);
			}
	
			img.className = 'leaflet-marker-' + name + ' ' + options.className;
	
			if (anchor) {
				img.style.marginLeft = (-anchor.x) + 'px';
				img.style.marginTop  = (-anchor.y) + 'px';
			}
	
			if (size) {
				img.style.width  = size.x + 'px';
				img.style.height = size.y + 'px';
			}
		},
	
		_createImg: function (src, el) {
			el = el || document.createElement('img');
			el.src = src;
			return el;
		},
	
		_getIconUrl: function (name) {
			if (L.Browser.retina && this.options[name + 'RetinaUrl']) {
				return this.options[name + 'RetinaUrl'];
			}
			return this.options[name + 'Url'];
		}
	});
	
	L.icon = function (options) {
		return new L.Icon(options);
	};
	
	
	/*
	 * L.Icon.Default is the blue marker icon used by default in Leaflet.
	 */
	
	L.Icon.Default = L.Icon.extend({
	
		options: {
			iconSize: [25, 41],
			iconAnchor: [12, 41],
			popupAnchor: [1, -34],
	
			shadowSize: [41, 41]
		},
	
		_getIconUrl: function (name) {
			var key = name + 'Url';
	
			if (this.options[key]) {
				return this.options[key];
			}
	
			if (L.Browser.retina && name === 'icon') {
				name += '-2x';
			}
	
			var path = L.Icon.Default.imagePath;
	
			if (!path) {
				throw new Error('Couldn\'t autodetect L.Icon.Default.imagePath, set it manually.');
			}
	
			return path + '/marker-' + name + '.png';
		}
	});
	
	L.Icon.Default.imagePath = (function () {
		var scripts = document.getElementsByTagName('script'),
		    leafletRe = /[\/^]leaflet[\-\._]?([\w\-\._]*)\.js\??/;
	
		var i, len, src, matches, path;
	
		for (i = 0, len = scripts.length; i < len; i++) {
			src = scripts[i].src;
			matches = src.match(leafletRe);
	
			if (matches) {
				path = src.split(leafletRe)[0];
				return (path ? path + '/' : '') + 'images';
			}
		}
	}());
	
	
	/*
	 * L.Marker is used to display clickable/draggable icons on the map.
	 */
	
	L.Marker = L.Class.extend({
	
		includes: L.Mixin.Events,
	
		options: {
			icon: new L.Icon.Default(),
			title: '',
			alt: '',
			clickable: true,
			draggable: false,
			keyboard: true,
			zIndexOffset: 0,
			opacity: 1,
			riseOnHover: false,
			riseOffset: 250
		},
	
		initialize: function (latlng, options) {
			L.setOptions(this, options);
			this._latlng = L.latLng(latlng);
		},
	
		onAdd: function (map) {
			this._map = map;
	
			map.on('viewreset', this.update, this);
	
			this._initIcon();
			this.update();
			this.fire('add');
	
			if (map.options.zoomAnimation && map.options.markerZoomAnimation) {
				map.on('zoomanim', this._animateZoom, this);
			}
		},
	
		addTo: function (map) {
			map.addLayer(this);
			return this;
		},
	
		onRemove: function (map) {
			if (this.dragging) {
				this.dragging.disable();
			}
	
			this._removeIcon();
			this._removeShadow();
	
			this.fire('remove');
	
			map.off({
				'viewreset': this.update,
				'zoomanim': this._animateZoom
			}, this);
	
			this._map = null;
		},
	
		getLatLng: function () {
			return this._latlng;
		},
	
		setLatLng: function (latlng) {
			this._latlng = L.latLng(latlng);
	
			this.update();
	
			return this.fire('move', { latlng: this._latlng });
		},
	
		setZIndexOffset: function (offset) {
			this.options.zIndexOffset = offset;
			this.update();
	
			return this;
		},
	
		setIcon: function (icon) {
	
			this.options.icon = icon;
	
			if (this._map) {
				this._initIcon();
				this.update();
			}
	
			if (this._popup) {
				this.bindPopup(this._popup);
			}
	
			return this;
		},
	
		update: function () {
			if (this._icon) {
				this._setPos(this._map.latLngToLayerPoint(this._latlng).round());
			}
			return this;
		},
	
		_initIcon: function () {
			var options = this.options,
			    map = this._map,
			    animation = (map.options.zoomAnimation && map.options.markerZoomAnimation),
			    classToAdd = animation ? 'leaflet-zoom-animated' : 'leaflet-zoom-hide';
	
			var icon = options.icon.createIcon(this._icon),
				addIcon = false;
	
			// if we're not reusing the icon, remove the old one and init new one
			if (icon !== this._icon) {
				if (this._icon) {
					this._removeIcon();
				}
				addIcon = true;
	
				if (options.title) {
					icon.title = options.title;
				}
	
				if (options.alt) {
					icon.alt = options.alt;
				}
			}
	
			L.DomUtil.addClass(icon, classToAdd);
	
			if (options.keyboard) {
				icon.tabIndex = '0';
			}
	
			this._icon = icon;
	
			this._initInteraction();
	
			if (options.riseOnHover) {
				L.DomEvent
					.on(icon, 'mouseover', this._bringToFront, this)
					.on(icon, 'mouseout', this._resetZIndex, this);
			}
	
			var newShadow = options.icon.createShadow(this._shadow),
				addShadow = false;
	
			if (newShadow !== this._shadow) {
				this._removeShadow();
				addShadow = true;
			}
	
			if (newShadow) {
				L.DomUtil.addClass(newShadow, classToAdd);
			}
			this._shadow = newShadow;
	
	
			if (options.opacity < 1) {
				this._updateOpacity();
			}
	
	
			var panes = this._map._panes;
	
			if (addIcon) {
				panes.markerPane.appendChild(this._icon);
			}
	
			if (newShadow && addShadow) {
				panes.shadowPane.appendChild(this._shadow);
			}
		},
	
		_removeIcon: function () {
			if (this.options.riseOnHover) {
				L.DomEvent
				    .off(this._icon, 'mouseover', this._bringToFront)
				    .off(this._icon, 'mouseout', this._resetZIndex);
			}
	
			this._map._panes.markerPane.removeChild(this._icon);
	
			this._icon = null;
		},
	
		_removeShadow: function () {
			if (this._shadow) {
				this._map._panes.shadowPane.removeChild(this._shadow);
			}
			this._shadow = null;
		},
	
		_setPos: function (pos) {
			L.DomUtil.setPosition(this._icon, pos);
	
			if (this._shadow) {
				L.DomUtil.setPosition(this._shadow, pos);
			}
	
			this._zIndex = pos.y + this.options.zIndexOffset;
	
			this._resetZIndex();
		},
	
		_updateZIndex: function (offset) {
			this._icon.style.zIndex = this._zIndex + offset;
		},
	
		_animateZoom: function (opt) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
	
			this._setPos(pos);
		},
	
		_initInteraction: function () {
	
			if (!this.options.clickable) { return; }
	
			// TODO refactor into something shared with Map/Path/etc. to DRY it up
	
			var icon = this._icon,
			    events = ['dblclick', 'mousedown', 'mouseover', 'mouseout', 'contextmenu'];
	
			L.DomUtil.addClass(icon, 'leaflet-clickable');
			L.DomEvent.on(icon, 'click', this._onMouseClick, this);
			L.DomEvent.on(icon, 'keypress', this._onKeyPress, this);
	
			for (var i = 0; i < events.length; i++) {
				L.DomEvent.on(icon, events[i], this._fireMouseEvent, this);
			}
	
			if (L.Handler.MarkerDrag) {
				this.dragging = new L.Handler.MarkerDrag(this);
	
				if (this.options.draggable) {
					this.dragging.enable();
				}
			}
		},
	
		_onMouseClick: function (e) {
			var wasDragged = this.dragging && this.dragging.moved();
	
			if (this.hasEventListeners(e.type) || wasDragged) {
				L.DomEvent.stopPropagation(e);
			}
	
			if (wasDragged) { return; }
	
			if ((!this.dragging || !this.dragging._enabled) && this._map.dragging && this._map.dragging.moved()) { return; }
	
			this.fire(e.type, {
				originalEvent: e,
				latlng: this._latlng
			});
		},
	
		_onKeyPress: function (e) {
			if (e.keyCode === 13) {
				this.fire('click', {
					originalEvent: e,
					latlng: this._latlng
				});
			}
		},
	
		_fireMouseEvent: function (e) {
	
			this.fire(e.type, {
				originalEvent: e,
				latlng: this._latlng
			});
	
			// TODO proper custom event propagation
			// this line will always be called if marker is in a FeatureGroup
			if (e.type === 'contextmenu' && this.hasEventListeners(e.type)) {
				L.DomEvent.preventDefault(e);
			}
			if (e.type !== 'mousedown') {
				L.DomEvent.stopPropagation(e);
			} else {
				L.DomEvent.preventDefault(e);
			}
		},
	
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
			if (this._map) {
				this._updateOpacity();
			}
	
			return this;
		},
	
		_updateOpacity: function () {
			L.DomUtil.setOpacity(this._icon, this.options.opacity);
			if (this._shadow) {
				L.DomUtil.setOpacity(this._shadow, this.options.opacity);
			}
		},
	
		_bringToFront: function () {
			this._updateZIndex(this.options.riseOffset);
		},
	
		_resetZIndex: function () {
			this._updateZIndex(0);
		}
	});
	
	L.marker = function (latlng, options) {
		return new L.Marker(latlng, options);
	};
	
	
	/*
	 * L.DivIcon is a lightweight HTML-based icon class (as opposed to the image-based L.Icon)
	 * to use with L.Marker.
	 */
	
	L.DivIcon = L.Icon.extend({
		options: {
			iconSize: [12, 12], // also can be set through CSS
			/*
			iconAnchor: (Point)
			popupAnchor: (Point)
			html: (String)
			bgPos: (Point)
			*/
			className: 'leaflet-div-icon',
			html: false
		},
	
		createIcon: function (oldIcon) {
			var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
			    options = this.options;
	
			if (options.html !== false) {
				div.innerHTML = options.html;
			} else {
				div.innerHTML = '';
			}
	
			if (options.bgPos) {
				div.style.backgroundPosition =
				        (-options.bgPos.x) + 'px ' + (-options.bgPos.y) + 'px';
			}
	
			this._setIconStyles(div, 'icon');
			return div;
		},
	
		createShadow: function () {
			return null;
		}
	});
	
	L.divIcon = function (options) {
		return new L.DivIcon(options);
	};
	
	
	/*
	 * L.Popup is used for displaying popups on the map.
	 */
	
	L.Map.mergeOptions({
		closePopupOnClick: true
	});
	
	L.Popup = L.Class.extend({
		includes: L.Mixin.Events,
	
		options: {
			minWidth: 50,
			maxWidth: 300,
			// maxHeight: null,
			autoPan: true,
			closeButton: true,
			offset: [0, 7],
			autoPanPadding: [5, 5],
			// autoPanPaddingTopLeft: null,
			// autoPanPaddingBottomRight: null,
			keepInView: false,
			className: '',
			zoomAnimation: true
		},
	
		initialize: function (options, source) {
			L.setOptions(this, options);
	
			this._source = source;
			this._animated = L.Browser.any3d && this.options.zoomAnimation;
			this._isOpen = false;
		},
	
		onAdd: function (map) {
			this._map = map;
	
			if (!this._container) {
				this._initLayout();
			}
	
			var animFade = map.options.fadeAnimation;
	
			if (animFade) {
				L.DomUtil.setOpacity(this._container, 0);
			}
			map._panes.popupPane.appendChild(this._container);
	
			map.on(this._getEvents(), this);
	
			this.update();
	
			if (animFade) {
				L.DomUtil.setOpacity(this._container, 1);
			}
	
			this.fire('open');
	
			map.fire('popupopen', {popup: this});
	
			if (this._source) {
				this._source.fire('popupopen', {popup: this});
			}
		},
	
		addTo: function (map) {
			map.addLayer(this);
			return this;
		},
	
		openOn: function (map) {
			map.openPopup(this);
			return this;
		},
	
		onRemove: function (map) {
			map._panes.popupPane.removeChild(this._container);
	
			L.Util.falseFn(this._container.offsetWidth); // force reflow
	
			map.off(this._getEvents(), this);
	
			if (map.options.fadeAnimation) {
				L.DomUtil.setOpacity(this._container, 0);
			}
	
			this._map = null;
	
			this.fire('close');
	
			map.fire('popupclose', {popup: this});
	
			if (this._source) {
				this._source.fire('popupclose', {popup: this});
			}
		},
	
		getLatLng: function () {
			return this._latlng;
		},
	
		setLatLng: function (latlng) {
			this._latlng = L.latLng(latlng);
			if (this._map) {
				this._updatePosition();
				this._adjustPan();
			}
			return this;
		},
	
		getContent: function () {
			return this._content;
		},
	
		setContent: function (content) {
			this._content = content;
			this.update();
			return this;
		},
	
		update: function () {
			if (!this._map) { return; }
	
			this._container.style.visibility = 'hidden';
	
			this._updateContent();
			this._updateLayout();
			this._updatePosition();
	
			this._container.style.visibility = '';
	
			this._adjustPan();
		},
	
		_getEvents: function () {
			var events = {
				viewreset: this._updatePosition
			};
	
			if (this._animated) {
				events.zoomanim = this._zoomAnimation;
			}
			if ('closeOnClick' in this.options ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
				events.preclick = this._close;
			}
			if (this.options.keepInView) {
				events.moveend = this._adjustPan;
			}
	
			return events;
		},
	
		_close: function () {
			if (this._map) {
				this._map.closePopup(this);
			}
		},
	
		_initLayout: function () {
			var prefix = 'leaflet-popup',
				containerClass = prefix + ' ' + this.options.className + ' leaflet-zoom-' +
				        (this._animated ? 'animated' : 'hide'),
				container = this._container = L.DomUtil.create('div', containerClass),
				closeButton;
	
			if (this.options.closeButton) {
				closeButton = this._closeButton =
				        L.DomUtil.create('a', prefix + '-close-button', container);
				closeButton.href = '#close';
				closeButton.innerHTML = '&#215;';
				L.DomEvent.disableClickPropagation(closeButton);
	
				L.DomEvent.on(closeButton, 'click', this._onCloseButtonClick, this);
			}
	
			var wrapper = this._wrapper =
			        L.DomUtil.create('div', prefix + '-content-wrapper', container);
			L.DomEvent.disableClickPropagation(wrapper);
	
			this._contentNode = L.DomUtil.create('div', prefix + '-content', wrapper);
	
			L.DomEvent.disableScrollPropagation(this._contentNode);
			L.DomEvent.on(wrapper, 'contextmenu', L.DomEvent.stopPropagation);
	
			this._tipContainer = L.DomUtil.create('div', prefix + '-tip-container', container);
			this._tip = L.DomUtil.create('div', prefix + '-tip', this._tipContainer);
		},
	
		_updateContent: function () {
			if (!this._content) { return; }
	
			if (typeof this._content === 'string') {
				this._contentNode.innerHTML = this._content;
			} else {
				while (this._contentNode.hasChildNodes()) {
					this._contentNode.removeChild(this._contentNode.firstChild);
				}
				this._contentNode.appendChild(this._content);
			}
			this.fire('contentupdate');
		},
	
		_updateLayout: function () {
			var container = this._contentNode,
			    style = container.style;
	
			style.width = '';
			style.whiteSpace = 'nowrap';
	
			var width = container.offsetWidth;
			width = Math.min(width, this.options.maxWidth);
			width = Math.max(width, this.options.minWidth);
	
			style.width = (width + 1) + 'px';
			style.whiteSpace = '';
	
			style.height = '';
	
			var height = container.offsetHeight,
			    maxHeight = this.options.maxHeight,
			    scrolledClass = 'leaflet-popup-scrolled';
	
			if (maxHeight && height > maxHeight) {
				style.height = maxHeight + 'px';
				L.DomUtil.addClass(container, scrolledClass);
			} else {
				L.DomUtil.removeClass(container, scrolledClass);
			}
	
			this._containerWidth = this._container.offsetWidth;
		},
	
		_updatePosition: function () {
			if (!this._map) { return; }
	
			var pos = this._map.latLngToLayerPoint(this._latlng),
			    animated = this._animated,
			    offset = L.point(this.options.offset);
	
			if (animated) {
				L.DomUtil.setPosition(this._container, pos);
			}
	
			this._containerBottom = -offset.y - (animated ? 0 : pos.y);
			this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x + (animated ? 0 : pos.x);
	
			// bottom position the popup in case the height of the popup changes (images loading etc)
			this._container.style.bottom = this._containerBottom + 'px';
			this._container.style.left = this._containerLeft + 'px';
		},
	
		_zoomAnimation: function (opt) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center);
	
			L.DomUtil.setPosition(this._container, pos);
		},
	
		_adjustPan: function () {
			if (!this.options.autoPan) { return; }
	
			var map = this._map,
			    containerHeight = this._container.offsetHeight,
			    containerWidth = this._containerWidth,
	
			    layerPos = new L.Point(this._containerLeft, -containerHeight - this._containerBottom);
	
			if (this._animated) {
				layerPos._add(L.DomUtil.getPosition(this._container));
			}
	
			var containerPos = map.layerPointToContainerPoint(layerPos),
			    padding = L.point(this.options.autoPanPadding),
			    paddingTL = L.point(this.options.autoPanPaddingTopLeft || padding),
			    paddingBR = L.point(this.options.autoPanPaddingBottomRight || padding),
			    size = map.getSize(),
			    dx = 0,
			    dy = 0;
	
			if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
				dx = containerPos.x + containerWidth - size.x + paddingBR.x;
			}
			if (containerPos.x - dx - paddingTL.x < 0) { // left
				dx = containerPos.x - paddingTL.x;
			}
			if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
				dy = containerPos.y + containerHeight - size.y + paddingBR.y;
			}
			if (containerPos.y - dy - paddingTL.y < 0) { // top
				dy = containerPos.y - paddingTL.y;
			}
	
			if (dx || dy) {
				map
				    .fire('autopanstart')
				    .panBy([dx, dy]);
			}
		},
	
		_onCloseButtonClick: function (e) {
			this._close();
			L.DomEvent.stop(e);
		}
	});
	
	L.popup = function (options, source) {
		return new L.Popup(options, source);
	};
	
	
	L.Map.include({
		openPopup: function (popup, latlng, options) { // (Popup) or (String || HTMLElement, LatLng[, Object])
			this.closePopup();
	
			if (!(popup instanceof L.Popup)) {
				var content = popup;
	
				popup = new L.Popup(options)
				    .setLatLng(latlng)
				    .setContent(content);
			}
			popup._isOpen = true;
	
			this._popup = popup;
			return this.addLayer(popup);
		},
	
		closePopup: function (popup) {
			if (!popup || popup === this._popup) {
				popup = this._popup;
				this._popup = null;
			}
			if (popup) {
				this.removeLayer(popup);
				popup._isOpen = false;
			}
			return this;
		}
	});
	
	
	/*
	 * Popup extension to L.Marker, adding popup-related methods.
	 */
	
	L.Marker.include({
		openPopup: function () {
			if (this._popup && this._map && !this._map.hasLayer(this._popup)) {
				this._popup.setLatLng(this._latlng);
				this._map.openPopup(this._popup);
			}
	
			return this;
		},
	
		closePopup: function () {
			if (this._popup) {
				this._popup._close();
			}
			return this;
		},
	
		togglePopup: function () {
			if (this._popup) {
				if (this._popup._isOpen) {
					this.closePopup();
				} else {
					this.openPopup();
				}
			}
			return this;
		},
	
		bindPopup: function (content, options) {
			var anchor = L.point(this.options.icon.options.popupAnchor || [0, 0]);
	
			anchor = anchor.add(L.Popup.prototype.options.offset);
	
			if (options && options.offset) {
				anchor = anchor.add(options.offset);
			}
	
			options = L.extend({offset: anchor}, options);
	
			if (!this._popupHandlersAdded) {
				this
				    .on('click', this.togglePopup, this)
				    .on('remove', this.closePopup, this)
				    .on('move', this._movePopup, this);
				this._popupHandlersAdded = true;
			}
	
			if (content instanceof L.Popup) {
				L.setOptions(content, options);
				this._popup = content;
				content._source = this;
			} else {
				this._popup = new L.Popup(options, this)
					.setContent(content);
			}
	
			return this;
		},
	
		setPopupContent: function (content) {
			if (this._popup) {
				this._popup.setContent(content);
			}
			return this;
		},
	
		unbindPopup: function () {
			if (this._popup) {
				this._popup = null;
				this
				    .off('click', this.togglePopup, this)
				    .off('remove', this.closePopup, this)
				    .off('move', this._movePopup, this);
				this._popupHandlersAdded = false;
			}
			return this;
		},
	
		getPopup: function () {
			return this._popup;
		},
	
		_movePopup: function (e) {
			this._popup.setLatLng(e.latlng);
		}
	});
	
	
	/*
	 * L.LayerGroup is a class to combine several layers into one so that
	 * you can manipulate the group (e.g. add/remove it) as one layer.
	 */
	
	L.LayerGroup = L.Class.extend({
		initialize: function (layers) {
			this._layers = {};
	
			var i, len;
	
			if (layers) {
				for (i = 0, len = layers.length; i < len; i++) {
					this.addLayer(layers[i]);
				}
			}
		},
	
		addLayer: function (layer) {
			var id = this.getLayerId(layer);
	
			this._layers[id] = layer;
	
			if (this._map) {
				this._map.addLayer(layer);
			}
	
			return this;
		},
	
		removeLayer: function (layer) {
			var id = layer in this._layers ? layer : this.getLayerId(layer);
	
			if (this._map && this._layers[id]) {
				this._map.removeLayer(this._layers[id]);
			}
	
			delete this._layers[id];
	
			return this;
		},
	
		hasLayer: function (layer) {
			if (!layer) { return false; }
	
			return (layer in this._layers || this.getLayerId(layer) in this._layers);
		},
	
		clearLayers: function () {
			this.eachLayer(this.removeLayer, this);
			return this;
		},
	
		invoke: function (methodName) {
			var args = Array.prototype.slice.call(arguments, 1),
			    i, layer;
	
			for (i in this._layers) {
				layer = this._layers[i];
	
				if (layer[methodName]) {
					layer[methodName].apply(layer, args);
				}
			}
	
			return this;
		},
	
		onAdd: function (map) {
			this._map = map;
			this.eachLayer(map.addLayer, map);
		},
	
		onRemove: function (map) {
			this.eachLayer(map.removeLayer, map);
			this._map = null;
		},
	
		addTo: function (map) {
			map.addLayer(this);
			return this;
		},
	
		eachLayer: function (method, context) {
			for (var i in this._layers) {
				method.call(context, this._layers[i]);
			}
			return this;
		},
	
		getLayer: function (id) {
			return this._layers[id];
		},
	
		getLayers: function () {
			var layers = [];
	
			for (var i in this._layers) {
				layers.push(this._layers[i]);
			}
			return layers;
		},
	
		setZIndex: function (zIndex) {
			return this.invoke('setZIndex', zIndex);
		},
	
		getLayerId: function (layer) {
			return L.stamp(layer);
		}
	});
	
	L.layerGroup = function (layers) {
		return new L.LayerGroup(layers);
	};
	
	
	/*
	 * L.FeatureGroup extends L.LayerGroup by introducing mouse events and additional methods
	 * shared between a group of interactive layers (like vectors or markers).
	 */
	
	L.FeatureGroup = L.LayerGroup.extend({
		includes: L.Mixin.Events,
	
		statics: {
			EVENTS: 'click dblclick mouseover mouseout mousemove contextmenu popupopen popupclose'
		},
	
		addLayer: function (layer) {
			if (this.hasLayer(layer)) {
				return this;
			}
	
			if ('on' in layer) {
				layer.on(L.FeatureGroup.EVENTS, this._propagateEvent, this);
			}
	
			L.LayerGroup.prototype.addLayer.call(this, layer);
	
			if (this._popupContent && layer.bindPopup) {
				layer.bindPopup(this._popupContent, this._popupOptions);
			}
	
			return this.fire('layeradd', {layer: layer});
		},
	
		removeLayer: function (layer) {
			if (!this.hasLayer(layer)) {
				return this;
			}
			if (layer in this._layers) {
				layer = this._layers[layer];
			}
	
			if ('off' in layer) {
				layer.off(L.FeatureGroup.EVENTS, this._propagateEvent, this);
			}
	
			L.LayerGroup.prototype.removeLayer.call(this, layer);
	
			if (this._popupContent) {
				this.invoke('unbindPopup');
			}
	
			return this.fire('layerremove', {layer: layer});
		},
	
		bindPopup: function (content, options) {
			this._popupContent = content;
			this._popupOptions = options;
			return this.invoke('bindPopup', content, options);
		},
	
		openPopup: function (latlng) {
			// open popup on the first layer
			for (var id in this._layers) {
				this._layers[id].openPopup(latlng);
				break;
			}
			return this;
		},
	
		setStyle: function (style) {
			return this.invoke('setStyle', style);
		},
	
		bringToFront: function () {
			return this.invoke('bringToFront');
		},
	
		bringToBack: function () {
			return this.invoke('bringToBack');
		},
	
		getBounds: function () {
			var bounds = new L.LatLngBounds();
	
			this.eachLayer(function (layer) {
				bounds.extend(layer instanceof L.Marker ? layer.getLatLng() : layer.getBounds());
			});
	
			return bounds;
		},
	
		_propagateEvent: function (e) {
			e = L.extend({
				layer: e.target,
				target: this
			}, e);
			this.fire(e.type, e);
		}
	});
	
	L.featureGroup = function (layers) {
		return new L.FeatureGroup(layers);
	};
	
	
	/*
	 * L.Path is a base class for rendering vector paths on a map. Inherited by Polyline, Circle, etc.
	 */
	
	L.Path = L.Class.extend({
		includes: [L.Mixin.Events],
	
		statics: {
			// how much to extend the clip area around the map view
			// (relative to its size, e.g. 0.5 is half the screen in each direction)
			// set it so that SVG element doesn't exceed 1280px (vectors flicker on dragend if it is)
			CLIP_PADDING: (function () {
				var max = L.Browser.mobile ? 1280 : 2000,
				    target = (max / Math.max(window.outerWidth, window.outerHeight) - 1) / 2;
				return Math.max(0, Math.min(0.5, target));
			})()
		},
	
		options: {
			stroke: true,
			color: '#0033ff',
			dashArray: null,
			lineCap: null,
			lineJoin: null,
			weight: 5,
			opacity: 0.5,
	
			fill: false,
			fillColor: null, //same as color by default
			fillOpacity: 0.2,
	
			clickable: true
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
		},
	
		onAdd: function (map) {
			this._map = map;
	
			if (!this._container) {
				this._initElements();
				this._initEvents();
			}
	
			this.projectLatlngs();
			this._updatePath();
	
			if (this._container) {
				this._map._pathRoot.appendChild(this._container);
			}
	
			this.fire('add');
	
			map.on({
				'viewreset': this.projectLatlngs,
				'moveend': this._updatePath
			}, this);
		},
	
		addTo: function (map) {
			map.addLayer(this);
			return this;
		},
	
		onRemove: function (map) {
			map._pathRoot.removeChild(this._container);
	
			// Need to fire remove event before we set _map to null as the event hooks might need the object
			this.fire('remove');
			this._map = null;
	
			if (L.Browser.vml) {
				this._container = null;
				this._stroke = null;
				this._fill = null;
			}
	
			map.off({
				'viewreset': this.projectLatlngs,
				'moveend': this._updatePath
			}, this);
		},
	
		projectLatlngs: function () {
			// do all projection stuff here
		},
	
		setStyle: function (style) {
			L.setOptions(this, style);
	
			if (this._container) {
				this._updateStyle();
			}
	
			return this;
		},
	
		redraw: function () {
			if (this._map) {
				this.projectLatlngs();
				this._updatePath();
			}
			return this;
		}
	});
	
	L.Map.include({
		_updatePathViewport: function () {
			var p = L.Path.CLIP_PADDING,
			    size = this.getSize(),
			    panePos = L.DomUtil.getPosition(this._mapPane),
			    min = panePos.multiplyBy(-1)._subtract(size.multiplyBy(p)._round()),
			    max = min.add(size.multiplyBy(1 + p * 2)._round());
	
			this._pathViewport = new L.Bounds(min, max);
		}
	});
	
	
	/*
	 * Extends L.Path with SVG-specific rendering code.
	 */
	
	L.Path.SVG_NS = 'http://www.w3.org/2000/svg';
	
	L.Browser.svg = !!(document.createElementNS && document.createElementNS(L.Path.SVG_NS, 'svg').createSVGRect);
	
	L.Path = L.Path.extend({
		statics: {
			SVG: L.Browser.svg
		},
	
		bringToFront: function () {
			var root = this._map._pathRoot,
			    path = this._container;
	
			if (path && root.lastChild !== path) {
				root.appendChild(path);
			}
			return this;
		},
	
		bringToBack: function () {
			var root = this._map._pathRoot,
			    path = this._container,
			    first = root.firstChild;
	
			if (path && first !== path) {
				root.insertBefore(path, first);
			}
			return this;
		},
	
		getPathString: function () {
			// form path string here
		},
	
		_createElement: function (name) {
			return document.createElementNS(L.Path.SVG_NS, name);
		},
	
		_initElements: function () {
			this._map._initPathRoot();
			this._initPath();
			this._initStyle();
		},
	
		_initPath: function () {
			this._container = this._createElement('g');
	
			this._path = this._createElement('path');
	
			if (this.options.className) {
				L.DomUtil.addClass(this._path, this.options.className);
			}
	
			this._container.appendChild(this._path);
		},
	
		_initStyle: function () {
			if (this.options.stroke) {
				this._path.setAttribute('stroke-linejoin', 'round');
				this._path.setAttribute('stroke-linecap', 'round');
			}
			if (this.options.fill) {
				this._path.setAttribute('fill-rule', 'evenodd');
			}
			if (this.options.pointerEvents) {
				this._path.setAttribute('pointer-events', this.options.pointerEvents);
			}
			if (!this.options.clickable && !this.options.pointerEvents) {
				this._path.setAttribute('pointer-events', 'none');
			}
			this._updateStyle();
		},
	
		_updateStyle: function () {
			if (this.options.stroke) {
				this._path.setAttribute('stroke', this.options.color);
				this._path.setAttribute('stroke-opacity', this.options.opacity);
				this._path.setAttribute('stroke-width', this.options.weight);
				if (this.options.dashArray) {
					this._path.setAttribute('stroke-dasharray', this.options.dashArray);
				} else {
					this._path.removeAttribute('stroke-dasharray');
				}
				if (this.options.lineCap) {
					this._path.setAttribute('stroke-linecap', this.options.lineCap);
				}
				if (this.options.lineJoin) {
					this._path.setAttribute('stroke-linejoin', this.options.lineJoin);
				}
			} else {
				this._path.setAttribute('stroke', 'none');
			}
			if (this.options.fill) {
				this._path.setAttribute('fill', this.options.fillColor || this.options.color);
				this._path.setAttribute('fill-opacity', this.options.fillOpacity);
			} else {
				this._path.setAttribute('fill', 'none');
			}
		},
	
		_updatePath: function () {
			var str = this.getPathString();
			if (!str) {
				// fix webkit empty string parsing bug
				str = 'M0 0';
			}
			this._path.setAttribute('d', str);
		},
	
		// TODO remove duplication with L.Map
		_initEvents: function () {
			if (this.options.clickable) {
				if (L.Browser.svg || !L.Browser.vml) {
					L.DomUtil.addClass(this._path, 'leaflet-clickable');
				}
	
				L.DomEvent.on(this._container, 'click', this._onMouseClick, this);
	
				var events = ['dblclick', 'mousedown', 'mouseover',
				              'mouseout', 'mousemove', 'contextmenu'];
				for (var i = 0; i < events.length; i++) {
					L.DomEvent.on(this._container, events[i], this._fireMouseEvent, this);
				}
			}
		},
	
		_onMouseClick: function (e) {
			if (this._map.dragging && this._map.dragging.moved()) { return; }
	
			this._fireMouseEvent(e);
		},
	
		_fireMouseEvent: function (e) {
			if (!this._map || !this.hasEventListeners(e.type)) { return; }
	
			var map = this._map,
			    containerPoint = map.mouseEventToContainerPoint(e),
			    layerPoint = map.containerPointToLayerPoint(containerPoint),
			    latlng = map.layerPointToLatLng(layerPoint);
	
			this.fire(e.type, {
				latlng: latlng,
				layerPoint: layerPoint,
				containerPoint: containerPoint,
				originalEvent: e
			});
	
			if (e.type === 'contextmenu') {
				L.DomEvent.preventDefault(e);
			}
			if (e.type !== 'mousemove') {
				L.DomEvent.stopPropagation(e);
			}
		}
	});
	
	L.Map.include({
		_initPathRoot: function () {
			if (!this._pathRoot) {
				this._pathRoot = L.Path.prototype._createElement('svg');
				this._panes.overlayPane.appendChild(this._pathRoot);
	
				if (this.options.zoomAnimation && L.Browser.any3d) {
					L.DomUtil.addClass(this._pathRoot, 'leaflet-zoom-animated');
	
					this.on({
						'zoomanim': this._animatePathZoom,
						'zoomend': this._endPathZoom
					});
				} else {
					L.DomUtil.addClass(this._pathRoot, 'leaflet-zoom-hide');
				}
	
				this.on('moveend', this._updateSvgViewport);
				this._updateSvgViewport();
			}
		},
	
		_animatePathZoom: function (e) {
			var scale = this.getZoomScale(e.zoom),
			    offset = this._getCenterOffset(e.center)._multiplyBy(-scale)._add(this._pathViewport.min);
	
			this._pathRoot.style[L.DomUtil.TRANSFORM] =
			        L.DomUtil.getTranslateString(offset) + ' scale(' + scale + ') ';
	
			this._pathZooming = true;
		},
	
		_endPathZoom: function () {
			this._pathZooming = false;
		},
	
		_updateSvgViewport: function () {
	
			if (this._pathZooming) {
				// Do not update SVGs while a zoom animation is going on otherwise the animation will break.
				// When the zoom animation ends we will be updated again anyway
				// This fixes the case where you do a momentum move and zoom while the move is still ongoing.
				return;
			}
	
			this._updatePathViewport();
	
			var vp = this._pathViewport,
			    min = vp.min,
			    max = vp.max,
			    width = max.x - min.x,
			    height = max.y - min.y,
			    root = this._pathRoot,
			    pane = this._panes.overlayPane;
	
			// Hack to make flicker on drag end on mobile webkit less irritating
			if (L.Browser.mobileWebkit) {
				pane.removeChild(root);
			}
	
			L.DomUtil.setPosition(root, min);
			root.setAttribute('width', width);
			root.setAttribute('height', height);
			root.setAttribute('viewBox', [min.x, min.y, width, height].join(' '));
	
			if (L.Browser.mobileWebkit) {
				pane.appendChild(root);
			}
		}
	});
	
	
	/*
	 * Popup extension to L.Path (polylines, polygons, circles), adding popup-related methods.
	 */
	
	L.Path.include({
	
		bindPopup: function (content, options) {
	
			if (content instanceof L.Popup) {
				this._popup = content;
			} else {
				if (!this._popup || options) {
					this._popup = new L.Popup(options, this);
				}
				this._popup.setContent(content);
			}
	
			if (!this._popupHandlersAdded) {
				this
				    .on('click', this._openPopup, this)
				    .on('remove', this.closePopup, this);
	
				this._popupHandlersAdded = true;
			}
	
			return this;
		},
	
		unbindPopup: function () {
			if (this._popup) {
				this._popup = null;
				this
				    .off('click', this._openPopup)
				    .off('remove', this.closePopup);
	
				this._popupHandlersAdded = false;
			}
			return this;
		},
	
		openPopup: function (latlng) {
	
			if (this._popup) {
				// open the popup from one of the path's points if not specified
				latlng = latlng || this._latlng ||
				         this._latlngs[Math.floor(this._latlngs.length / 2)];
	
				this._openPopup({latlng: latlng});
			}
	
			return this;
		},
	
		closePopup: function () {
			if (this._popup) {
				this._popup._close();
			}
			return this;
		},
	
		_openPopup: function (e) {
			this._popup.setLatLng(e.latlng);
			this._map.openPopup(this._popup);
		}
	});
	
	
	/*
	 * Vector rendering for IE6-8 through VML.
	 * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
	 */
	
	L.Browser.vml = !L.Browser.svg && (function () {
		try {
			var div = document.createElement('div');
			div.innerHTML = '<v:shape adj="1"/>';
	
			var shape = div.firstChild;
			shape.style.behavior = 'url(#default#VML)';
	
			return shape && (typeof shape.adj === 'object');
	
		} catch (e) {
			return false;
		}
	}());
	
	L.Path = L.Browser.svg || !L.Browser.vml ? L.Path : L.Path.extend({
		statics: {
			VML: true,
			CLIP_PADDING: 0.02
		},
	
		_createElement: (function () {
			try {
				document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
				return function (name) {
					return document.createElement('<lvml:' + name + ' class="lvml">');
				};
			} catch (e) {
				return function (name) {
					return document.createElement(
					        '<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
				};
			}
		}()),
	
		_initPath: function () {
			var container = this._container = this._createElement('shape');
	
			L.DomUtil.addClass(container, 'leaflet-vml-shape' +
				(this.options.className ? ' ' + this.options.className : ''));
	
			if (this.options.clickable) {
				L.DomUtil.addClass(container, 'leaflet-clickable');
			}
	
			container.coordsize = '1 1';
	
			this._path = this._createElement('path');
			container.appendChild(this._path);
	
			this._map._pathRoot.appendChild(container);
		},
	
		_initStyle: function () {
			this._updateStyle();
		},
	
		_updateStyle: function () {
			var stroke = this._stroke,
			    fill = this._fill,
			    options = this.options,
			    container = this._container;
	
			container.stroked = options.stroke;
			container.filled = options.fill;
	
			if (options.stroke) {
				if (!stroke) {
					stroke = this._stroke = this._createElement('stroke');
					stroke.endcap = 'round';
					container.appendChild(stroke);
				}
				stroke.weight = options.weight + 'px';
				stroke.color = options.color;
				stroke.opacity = options.opacity;
	
				if (options.dashArray) {
					stroke.dashStyle = L.Util.isArray(options.dashArray) ?
					    options.dashArray.join(' ') :
					    options.dashArray.replace(/( *, *)/g, ' ');
				} else {
					stroke.dashStyle = '';
				}
				if (options.lineCap) {
					stroke.endcap = options.lineCap.replace('butt', 'flat');
				}
				if (options.lineJoin) {
					stroke.joinstyle = options.lineJoin;
				}
	
			} else if (stroke) {
				container.removeChild(stroke);
				this._stroke = null;
			}
	
			if (options.fill) {
				if (!fill) {
					fill = this._fill = this._createElement('fill');
					container.appendChild(fill);
				}
				fill.color = options.fillColor || options.color;
				fill.opacity = options.fillOpacity;
	
			} else if (fill) {
				container.removeChild(fill);
				this._fill = null;
			}
		},
	
		_updatePath: function () {
			var style = this._container.style;
	
			style.display = 'none';
			this._path.v = this.getPathString() + ' '; // the space fixes IE empty path string bug
			style.display = '';
		}
	});
	
	L.Map.include(L.Browser.svg || !L.Browser.vml ? {} : {
		_initPathRoot: function () {
			if (this._pathRoot) { return; }
	
			var root = this._pathRoot = document.createElement('div');
			root.className = 'leaflet-vml-container';
			this._panes.overlayPane.appendChild(root);
	
			this.on('moveend', this._updatePathViewport);
			this._updatePathViewport();
		}
	});
	
	
	/*
	 * Vector rendering for all browsers that support canvas.
	 */
	
	L.Browser.canvas = (function () {
		return !!document.createElement('canvas').getContext;
	}());
	
	L.Path = (L.Path.SVG && !window.L_PREFER_CANVAS) || !L.Browser.canvas ? L.Path : L.Path.extend({
		statics: {
			//CLIP_PADDING: 0.02, // not sure if there's a need to set it to a small value
			CANVAS: true,
			SVG: false
		},
	
		redraw: function () {
			if (this._map) {
				this.projectLatlngs();
				this._requestUpdate();
			}
			return this;
		},
	
		setStyle: function (style) {
			L.setOptions(this, style);
	
			if (this._map) {
				this._updateStyle();
				this._requestUpdate();
			}
			return this;
		},
	
		onRemove: function (map) {
			map
			    .off('viewreset', this.projectLatlngs, this)
			    .off('moveend', this._updatePath, this);
	
			if (this.options.clickable) {
				this._map.off('click', this._onClick, this);
				this._map.off('mousemove', this._onMouseMove, this);
			}
	
			this._requestUpdate();
			
			this.fire('remove');
			this._map = null;
		},
	
		_requestUpdate: function () {
			if (this._map && !L.Path._updateRequest) {
				L.Path._updateRequest = L.Util.requestAnimFrame(this._fireMapMoveEnd, this._map);
			}
		},
	
		_fireMapMoveEnd: function () {
			L.Path._updateRequest = null;
			this.fire('moveend');
		},
	
		_initElements: function () {
			this._map._initPathRoot();
			this._ctx = this._map._canvasCtx;
		},
	
		_updateStyle: function () {
			var options = this.options;
	
			if (options.stroke) {
				this._ctx.lineWidth = options.weight;
				this._ctx.strokeStyle = options.color;
			}
			if (options.fill) {
				this._ctx.fillStyle = options.fillColor || options.color;
			}
	
			if (options.lineCap) {
				this._ctx.lineCap = options.lineCap;
			}
			if (options.lineJoin) {
				this._ctx.lineJoin = options.lineJoin;
			}
		},
	
		_drawPath: function () {
			var i, j, len, len2, point, drawMethod;
	
			this._ctx.beginPath();
	
			for (i = 0, len = this._parts.length; i < len; i++) {
				for (j = 0, len2 = this._parts[i].length; j < len2; j++) {
					point = this._parts[i][j];
					drawMethod = (j === 0 ? 'move' : 'line') + 'To';
	
					this._ctx[drawMethod](point.x, point.y);
				}
				// TODO refactor ugly hack
				if (this instanceof L.Polygon) {
					this._ctx.closePath();
				}
			}
		},
	
		_checkIfEmpty: function () {
			return !this._parts.length;
		},
	
		_updatePath: function () {
			if (this._checkIfEmpty()) { return; }
	
			var ctx = this._ctx,
			    options = this.options;
	
			this._drawPath();
			ctx.save();
			this._updateStyle();
	
			if (options.fill) {
				ctx.globalAlpha = options.fillOpacity;
				ctx.fill(options.fillRule || 'evenodd');
			}
	
			if (options.stroke) {
				ctx.globalAlpha = options.opacity;
				ctx.stroke();
			}
	
			ctx.restore();
	
			// TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
		},
	
		_initEvents: function () {
			if (this.options.clickable) {
				this._map.on('mousemove', this._onMouseMove, this);
				this._map.on('click dblclick contextmenu', this._fireMouseEvent, this);
			}
		},
	
		_fireMouseEvent: function (e) {
			if (this._containsPoint(e.layerPoint)) {
				this.fire(e.type, e);
			}
		},
	
		_onMouseMove: function (e) {
			if (!this._map || this._map._animatingZoom) { return; }
	
			// TODO don't do on each move
			if (this._containsPoint(e.layerPoint)) {
				this._ctx.canvas.style.cursor = 'pointer';
				this._mouseInside = true;
				this.fire('mouseover', e);
	
			} else if (this._mouseInside) {
				this._ctx.canvas.style.cursor = '';
				this._mouseInside = false;
				this.fire('mouseout', e);
			}
		}
	});
	
	L.Map.include((L.Path.SVG && !window.L_PREFER_CANVAS) || !L.Browser.canvas ? {} : {
		_initPathRoot: function () {
			var root = this._pathRoot,
			    ctx;
	
			if (!root) {
				root = this._pathRoot = document.createElement('canvas');
				root.style.position = 'absolute';
				ctx = this._canvasCtx = root.getContext('2d');
	
				ctx.lineCap = 'round';
				ctx.lineJoin = 'round';
	
				this._panes.overlayPane.appendChild(root);
	
				if (this.options.zoomAnimation) {
					this._pathRoot.className = 'leaflet-zoom-animated';
					this.on('zoomanim', this._animatePathZoom);
					this.on('zoomend', this._endPathZoom);
				}
				this.on('moveend', this._updateCanvasViewport);
				this._updateCanvasViewport();
			}
		},
	
		_updateCanvasViewport: function () {
			// don't redraw while zooming. See _updateSvgViewport for more details
			if (this._pathZooming) { return; }
			this._updatePathViewport();
	
			var vp = this._pathViewport,
			    min = vp.min,
			    size = vp.max.subtract(min),
			    root = this._pathRoot;
	
			//TODO check if this works properly on mobile webkit
			L.DomUtil.setPosition(root, min);
			root.width = size.x;
			root.height = size.y;
			root.getContext('2d').translate(-min.x, -min.y);
		}
	});
	
	
	/*
	 * L.LineUtil contains different utility functions for line segments
	 * and polylines (clipping, simplification, distances, etc.)
	 */
	
	/*jshint bitwise:false */ // allow bitwise operations for this file
	
	L.LineUtil = {
	
		// Simplify polyline with vertex reduction and Douglas-Peucker simplification.
		// Improves rendering performance dramatically by lessening the number of points to draw.
	
		simplify: function (/*Point[]*/ points, /*Number*/ tolerance) {
			if (!tolerance || !points.length) {
				return points.slice();
			}
	
			var sqTolerance = tolerance * tolerance;
	
			// stage 1: vertex reduction
			points = this._reducePoints(points, sqTolerance);
	
			// stage 2: Douglas-Peucker simplification
			points = this._simplifyDP(points, sqTolerance);
	
			return points;
		},
	
		// distance from a point to a segment between two points
		pointToSegmentDistance:  function (/*Point*/ p, /*Point*/ p1, /*Point*/ p2) {
			return Math.sqrt(this._sqClosestPointOnSegment(p, p1, p2, true));
		},
	
		closestPointOnSegment: function (/*Point*/ p, /*Point*/ p1, /*Point*/ p2) {
			return this._sqClosestPointOnSegment(p, p1, p2);
		},
	
		// Douglas-Peucker simplification, see http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm
		_simplifyDP: function (points, sqTolerance) {
	
			var len = points.length,
			    ArrayConstructor = typeof Uint8Array !== undefined + '' ? Uint8Array : Array,
			    markers = new ArrayConstructor(len);
	
			markers[0] = markers[len - 1] = 1;
	
			this._simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
	
			var i,
			    newPoints = [];
	
			for (i = 0; i < len; i++) {
				if (markers[i]) {
					newPoints.push(points[i]);
				}
			}
	
			return newPoints;
		},
	
		_simplifyDPStep: function (points, markers, sqTolerance, first, last) {
	
			var maxSqDist = 0,
			    index, i, sqDist;
	
			for (i = first + 1; i <= last - 1; i++) {
				sqDist = this._sqClosestPointOnSegment(points[i], points[first], points[last], true);
	
				if (sqDist > maxSqDist) {
					index = i;
					maxSqDist = sqDist;
				}
			}
	
			if (maxSqDist > sqTolerance) {
				markers[index] = 1;
	
				this._simplifyDPStep(points, markers, sqTolerance, first, index);
				this._simplifyDPStep(points, markers, sqTolerance, index, last);
			}
		},
	
		// reduce points that are too close to each other to a single point
		_reducePoints: function (points, sqTolerance) {
			var reducedPoints = [points[0]];
	
			for (var i = 1, prev = 0, len = points.length; i < len; i++) {
				if (this._sqDist(points[i], points[prev]) > sqTolerance) {
					reducedPoints.push(points[i]);
					prev = i;
				}
			}
			if (prev < len - 1) {
				reducedPoints.push(points[len - 1]);
			}
			return reducedPoints;
		},
	
		// Cohen-Sutherland line clipping algorithm.
		// Used to avoid rendering parts of a polyline that are not currently visible.
	
		clipSegment: function (a, b, bounds, useLastCode) {
			var codeA = useLastCode ? this._lastCode : this._getBitCode(a, bounds),
			    codeB = this._getBitCode(b, bounds),
	
			    codeOut, p, newCode;
	
			// save 2nd code to avoid calculating it on the next segment
			this._lastCode = codeB;
	
			while (true) {
				// if a,b is inside the clip window (trivial accept)
				if (!(codeA | codeB)) {
					return [a, b];
				// if a,b is outside the clip window (trivial reject)
				} else if (codeA & codeB) {
					return false;
				// other cases
				} else {
					codeOut = codeA || codeB;
					p = this._getEdgeIntersection(a, b, codeOut, bounds);
					newCode = this._getBitCode(p, bounds);
	
					if (codeOut === codeA) {
						a = p;
						codeA = newCode;
					} else {
						b = p;
						codeB = newCode;
					}
				}
			}
		},
	
		_getEdgeIntersection: function (a, b, code, bounds) {
			var dx = b.x - a.x,
			    dy = b.y - a.y,
			    min = bounds.min,
			    max = bounds.max;
	
			if (code & 8) { // top
				return new L.Point(a.x + dx * (max.y - a.y) / dy, max.y);
			} else if (code & 4) { // bottom
				return new L.Point(a.x + dx * (min.y - a.y) / dy, min.y);
			} else if (code & 2) { // right
				return new L.Point(max.x, a.y + dy * (max.x - a.x) / dx);
			} else if (code & 1) { // left
				return new L.Point(min.x, a.y + dy * (min.x - a.x) / dx);
			}
		},
	
		_getBitCode: function (/*Point*/ p, bounds) {
			var code = 0;
	
			if (p.x < bounds.min.x) { // left
				code |= 1;
			} else if (p.x > bounds.max.x) { // right
				code |= 2;
			}
			if (p.y < bounds.min.y) { // bottom
				code |= 4;
			} else if (p.y > bounds.max.y) { // top
				code |= 8;
			}
	
			return code;
		},
	
		// square distance (to avoid unnecessary Math.sqrt calls)
		_sqDist: function (p1, p2) {
			var dx = p2.x - p1.x,
			    dy = p2.y - p1.y;
			return dx * dx + dy * dy;
		},
	
		// return closest point on segment or distance to that point
		_sqClosestPointOnSegment: function (p, p1, p2, sqDist) {
			var x = p1.x,
			    y = p1.y,
			    dx = p2.x - x,
			    dy = p2.y - y,
			    dot = dx * dx + dy * dy,
			    t;
	
			if (dot > 0) {
				t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
	
				if (t > 1) {
					x = p2.x;
					y = p2.y;
				} else if (t > 0) {
					x += dx * t;
					y += dy * t;
				}
			}
	
			dx = p.x - x;
			dy = p.y - y;
	
			return sqDist ? dx * dx + dy * dy : new L.Point(x, y);
		}
	};
	
	
	/*
	 * L.Polyline is used to display polylines on a map.
	 */
	
	L.Polyline = L.Path.extend({
		initialize: function (latlngs, options) {
			L.Path.prototype.initialize.call(this, options);
	
			this._latlngs = this._convertLatLngs(latlngs);
		},
	
		options: {
			// how much to simplify the polyline on each zoom level
			// more = better performance and smoother look, less = more accurate
			smoothFactor: 1.0,
			noClip: false
		},
	
		projectLatlngs: function () {
			this._originalPoints = [];
	
			for (var i = 0, len = this._latlngs.length; i < len; i++) {
				this._originalPoints[i] = this._map.latLngToLayerPoint(this._latlngs[i]);
			}
		},
	
		getPathString: function () {
			for (var i = 0, len = this._parts.length, str = ''; i < len; i++) {
				str += this._getPathPartStr(this._parts[i]);
			}
			return str;
		},
	
		getLatLngs: function () {
			return this._latlngs;
		},
	
		setLatLngs: function (latlngs) {
			this._latlngs = this._convertLatLngs(latlngs);
			return this.redraw();
		},
	
		addLatLng: function (latlng) {
			this._latlngs.push(L.latLng(latlng));
			return this.redraw();
		},
	
		spliceLatLngs: function () { // (Number index, Number howMany)
			var removed = [].splice.apply(this._latlngs, arguments);
			this._convertLatLngs(this._latlngs, true);
			this.redraw();
			return removed;
		},
	
		closestLayerPoint: function (p) {
			var minDistance = Infinity, parts = this._parts, p1, p2, minPoint = null;
	
			for (var j = 0, jLen = parts.length; j < jLen; j++) {
				var points = parts[j];
				for (var i = 1, len = points.length; i < len; i++) {
					p1 = points[i - 1];
					p2 = points[i];
					var sqDist = L.LineUtil._sqClosestPointOnSegment(p, p1, p2, true);
					if (sqDist < minDistance) {
						minDistance = sqDist;
						minPoint = L.LineUtil._sqClosestPointOnSegment(p, p1, p2);
					}
				}
			}
			if (minPoint) {
				minPoint.distance = Math.sqrt(minDistance);
			}
			return minPoint;
		},
	
		getBounds: function () {
			return new L.LatLngBounds(this.getLatLngs());
		},
	
		_convertLatLngs: function (latlngs, overwrite) {
			var i, len, target = overwrite ? latlngs : [];
	
			for (i = 0, len = latlngs.length; i < len; i++) {
				if (L.Util.isArray(latlngs[i]) && typeof latlngs[i][0] !== 'number') {
					return;
				}
				target[i] = L.latLng(latlngs[i]);
			}
			return target;
		},
	
		_initEvents: function () {
			L.Path.prototype._initEvents.call(this);
		},
	
		_getPathPartStr: function (points) {
			var round = L.Path.VML;
	
			for (var j = 0, len2 = points.length, str = '', p; j < len2; j++) {
				p = points[j];
				if (round) {
					p._round();
				}
				str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
			}
			return str;
		},
	
		_clipPoints: function () {
			var points = this._originalPoints,
			    len = points.length,
			    i, k, segment;
	
			if (this.options.noClip) {
				this._parts = [points];
				return;
			}
	
			this._parts = [];
	
			var parts = this._parts,
			    vp = this._map._pathViewport,
			    lu = L.LineUtil;
	
			for (i = 0, k = 0; i < len - 1; i++) {
				segment = lu.clipSegment(points[i], points[i + 1], vp, i);
				if (!segment) {
					continue;
				}
	
				parts[k] = parts[k] || [];
				parts[k].push(segment[0]);
	
				// if segment goes out of screen, or it's the last one, it's the end of the line part
				if ((segment[1] !== points[i + 1]) || (i === len - 2)) {
					parts[k].push(segment[1]);
					k++;
				}
			}
		},
	
		// simplify each clipped part of the polyline
		_simplifyPoints: function () {
			var parts = this._parts,
			    lu = L.LineUtil;
	
			for (var i = 0, len = parts.length; i < len; i++) {
				parts[i] = lu.simplify(parts[i], this.options.smoothFactor);
			}
		},
	
		_updatePath: function () {
			if (!this._map) { return; }
	
			this._clipPoints();
			this._simplifyPoints();
	
			L.Path.prototype._updatePath.call(this);
		}
	});
	
	L.polyline = function (latlngs, options) {
		return new L.Polyline(latlngs, options);
	};
	
	
	/*
	 * L.PolyUtil contains utility functions for polygons (clipping, etc.).
	 */
	
	/*jshint bitwise:false */ // allow bitwise operations here
	
	L.PolyUtil = {};
	
	/*
	 * Sutherland-Hodgeman polygon clipping algorithm.
	 * Used to avoid rendering parts of a polygon that are not currently visible.
	 */
	L.PolyUtil.clipPolygon = function (points, bounds) {
		var clippedPoints,
		    edges = [1, 4, 2, 8],
		    i, j, k,
		    a, b,
		    len, edge, p,
		    lu = L.LineUtil;
	
		for (i = 0, len = points.length; i < len; i++) {
			points[i]._code = lu._getBitCode(points[i], bounds);
		}
	
		// for each edge (left, bottom, right, top)
		for (k = 0; k < 4; k++) {
			edge = edges[k];
			clippedPoints = [];
	
			for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
				a = points[i];
				b = points[j];
	
				// if a is inside the clip window
				if (!(a._code & edge)) {
					// if b is outside the clip window (a->b goes out of screen)
					if (b._code & edge) {
						p = lu._getEdgeIntersection(b, a, edge, bounds);
						p._code = lu._getBitCode(p, bounds);
						clippedPoints.push(p);
					}
					clippedPoints.push(a);
	
				// else if b is inside the clip window (a->b enters the screen)
				} else if (!(b._code & edge)) {
					p = lu._getEdgeIntersection(b, a, edge, bounds);
					p._code = lu._getBitCode(p, bounds);
					clippedPoints.push(p);
				}
			}
			points = clippedPoints;
		}
	
		return points;
	};
	
	
	/*
	 * L.Polygon is used to display polygons on a map.
	 */
	
	L.Polygon = L.Polyline.extend({
		options: {
			fill: true
		},
	
		initialize: function (latlngs, options) {
			L.Polyline.prototype.initialize.call(this, latlngs, options);
			this._initWithHoles(latlngs);
		},
	
		_initWithHoles: function (latlngs) {
			var i, len, hole;
			if (latlngs && L.Util.isArray(latlngs[0]) && (typeof latlngs[0][0] !== 'number')) {
				this._latlngs = this._convertLatLngs(latlngs[0]);
				this._holes = latlngs.slice(1);
	
				for (i = 0, len = this._holes.length; i < len; i++) {
					hole = this._holes[i] = this._convertLatLngs(this._holes[i]);
					if (hole[0].equals(hole[hole.length - 1])) {
						hole.pop();
					}
				}
			}
	
			// filter out last point if its equal to the first one
			latlngs = this._latlngs;
	
			if (latlngs.length >= 2 && latlngs[0].equals(latlngs[latlngs.length - 1])) {
				latlngs.pop();
			}
		},
	
		projectLatlngs: function () {
			L.Polyline.prototype.projectLatlngs.call(this);
	
			// project polygon holes points
			// TODO move this logic to Polyline to get rid of duplication
			this._holePoints = [];
	
			if (!this._holes) { return; }
	
			var i, j, len, len2;
	
			for (i = 0, len = this._holes.length; i < len; i++) {
				this._holePoints[i] = [];
	
				for (j = 0, len2 = this._holes[i].length; j < len2; j++) {
					this._holePoints[i][j] = this._map.latLngToLayerPoint(this._holes[i][j]);
				}
			}
		},
	
		setLatLngs: function (latlngs) {
			if (latlngs && L.Util.isArray(latlngs[0]) && (typeof latlngs[0][0] !== 'number')) {
				this._initWithHoles(latlngs);
				return this.redraw();
			} else {
				return L.Polyline.prototype.setLatLngs.call(this, latlngs);
			}
		},
	
		_clipPoints: function () {
			var points = this._originalPoints,
			    newParts = [];
	
			this._parts = [points].concat(this._holePoints);
	
			if (this.options.noClip) { return; }
	
			for (var i = 0, len = this._parts.length; i < len; i++) {
				var clipped = L.PolyUtil.clipPolygon(this._parts[i], this._map._pathViewport);
				if (clipped.length) {
					newParts.push(clipped);
				}
			}
	
			this._parts = newParts;
		},
	
		_getPathPartStr: function (points) {
			var str = L.Polyline.prototype._getPathPartStr.call(this, points);
			return str + (L.Browser.svg ? 'z' : 'x');
		}
	});
	
	L.polygon = function (latlngs, options) {
		return new L.Polygon(latlngs, options);
	};
	
	
	/*
	 * Contains L.MultiPolyline and L.MultiPolygon layers.
	 */
	
	(function () {
		function createMulti(Klass) {
	
			return L.FeatureGroup.extend({
	
				initialize: function (latlngs, options) {
					this._layers = {};
					this._options = options;
					this.setLatLngs(latlngs);
				},
	
				setLatLngs: function (latlngs) {
					var i = 0,
					    len = latlngs.length;
	
					this.eachLayer(function (layer) {
						if (i < len) {
							layer.setLatLngs(latlngs[i++]);
						} else {
							this.removeLayer(layer);
						}
					}, this);
	
					while (i < len) {
						this.addLayer(new Klass(latlngs[i++], this._options));
					}
	
					return this;
				},
	
				getLatLngs: function () {
					var latlngs = [];
	
					this.eachLayer(function (layer) {
						latlngs.push(layer.getLatLngs());
					});
	
					return latlngs;
				}
			});
		}
	
		L.MultiPolyline = createMulti(L.Polyline);
		L.MultiPolygon = createMulti(L.Polygon);
	
		L.multiPolyline = function (latlngs, options) {
			return new L.MultiPolyline(latlngs, options);
		};
	
		L.multiPolygon = function (latlngs, options) {
			return new L.MultiPolygon(latlngs, options);
		};
	}());
	
	
	/*
	 * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
	 */
	
	L.Rectangle = L.Polygon.extend({
		initialize: function (latLngBounds, options) {
			L.Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
		},
	
		setBounds: function (latLngBounds) {
			this.setLatLngs(this._boundsToLatLngs(latLngBounds));
		},
	
		_boundsToLatLngs: function (latLngBounds) {
			latLngBounds = L.latLngBounds(latLngBounds);
			return [
				latLngBounds.getSouthWest(),
				latLngBounds.getNorthWest(),
				latLngBounds.getNorthEast(),
				latLngBounds.getSouthEast()
			];
		}
	});
	
	L.rectangle = function (latLngBounds, options) {
		return new L.Rectangle(latLngBounds, options);
	};
	
	
	/*
	 * L.Circle is a circle overlay (with a certain radius in meters).
	 */
	
	L.Circle = L.Path.extend({
		initialize: function (latlng, radius, options) {
			L.Path.prototype.initialize.call(this, options);
	
			this._latlng = L.latLng(latlng);
			this._mRadius = radius;
		},
	
		options: {
			fill: true
		},
	
		setLatLng: function (latlng) {
			this._latlng = L.latLng(latlng);
			return this.redraw();
		},
	
		setRadius: function (radius) {
			this._mRadius = radius;
			return this.redraw();
		},
	
		projectLatlngs: function () {
			var lngRadius = this._getLngRadius(),
			    latlng = this._latlng,
			    pointLeft = this._map.latLngToLayerPoint([latlng.lat, latlng.lng - lngRadius]);
	
			this._point = this._map.latLngToLayerPoint(latlng);
			this._radius = Math.max(this._point.x - pointLeft.x, 1);
		},
	
		getBounds: function () {
			var lngRadius = this._getLngRadius(),
			    latRadius = (this._mRadius / 40075017) * 360,
			    latlng = this._latlng;
	
			return new L.LatLngBounds(
			        [latlng.lat - latRadius, latlng.lng - lngRadius],
			        [latlng.lat + latRadius, latlng.lng + lngRadius]);
		},
	
		getLatLng: function () {
			return this._latlng;
		},
	
		getPathString: function () {
			var p = this._point,
			    r = this._radius;
	
			if (this._checkIfEmpty()) {
				return '';
			}
	
			if (L.Browser.svg) {
				return 'M' + p.x + ',' + (p.y - r) +
				       'A' + r + ',' + r + ',0,1,1,' +
				       (p.x - 0.1) + ',' + (p.y - r) + ' z';
			} else {
				p._round();
				r = Math.round(r);
				return 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r + ' 0,' + (65535 * 360);
			}
		},
	
		getRadius: function () {
			return this._mRadius;
		},
	
		// TODO Earth hardcoded, move into projection code!
	
		_getLatRadius: function () {
			return (this._mRadius / 40075017) * 360;
		},
	
		_getLngRadius: function () {
			return this._getLatRadius() / Math.cos(L.LatLng.DEG_TO_RAD * this._latlng.lat);
		},
	
		_checkIfEmpty: function () {
			if (!this._map) {
				return false;
			}
			var vp = this._map._pathViewport,
			    r = this._radius,
			    p = this._point;
	
			return p.x - r > vp.max.x || p.y - r > vp.max.y ||
			       p.x + r < vp.min.x || p.y + r < vp.min.y;
		}
	});
	
	L.circle = function (latlng, radius, options) {
		return new L.Circle(latlng, radius, options);
	};
	
	
	/*
	 * L.CircleMarker is a circle overlay with a permanent pixel radius.
	 */
	
	L.CircleMarker = L.Circle.extend({
		options: {
			radius: 10,
			weight: 2
		},
	
		initialize: function (latlng, options) {
			L.Circle.prototype.initialize.call(this, latlng, null, options);
			this._radius = this.options.radius;
		},
	
		projectLatlngs: function () {
			this._point = this._map.latLngToLayerPoint(this._latlng);
		},
	
		_updateStyle : function () {
			L.Circle.prototype._updateStyle.call(this);
			this.setRadius(this.options.radius);
		},
	
		setLatLng: function (latlng) {
			L.Circle.prototype.setLatLng.call(this, latlng);
			if (this._popup && this._popup._isOpen) {
				this._popup.setLatLng(latlng);
			}
			return this;
		},
	
		setRadius: function (radius) {
			this.options.radius = this._radius = radius;
			return this.redraw();
		},
	
		getRadius: function () {
			return this._radius;
		}
	});
	
	L.circleMarker = function (latlng, options) {
		return new L.CircleMarker(latlng, options);
	};
	
	
	/*
	 * Extends L.Polyline to be able to manually detect clicks on Canvas-rendered polylines.
	 */
	
	L.Polyline.include(!L.Path.CANVAS ? {} : {
		_containsPoint: function (p, closed) {
			var i, j, k, len, len2, dist, part,
			    w = this.options.weight / 2;
	
			if (L.Browser.touch) {
				w += 10; // polyline click tolerance on touch devices
			}
	
			for (i = 0, len = this._parts.length; i < len; i++) {
				part = this._parts[i];
				for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
					if (!closed && (j === 0)) {
						continue;
					}
	
					dist = L.LineUtil.pointToSegmentDistance(p, part[k], part[j]);
	
					if (dist <= w) {
						return true;
					}
				}
			}
			return false;
		}
	});
	
	
	/*
	 * Extends L.Polygon to be able to manually detect clicks on Canvas-rendered polygons.
	 */
	
	L.Polygon.include(!L.Path.CANVAS ? {} : {
		_containsPoint: function (p) {
			var inside = false,
			    part, p1, p2,
			    i, j, k,
			    len, len2;
	
			// TODO optimization: check if within bounds first
	
			if (L.Polyline.prototype._containsPoint.call(this, p, true)) {
				// click on polygon border
				return true;
			}
	
			// ray casting algorithm for detecting if point is in polygon
	
			for (i = 0, len = this._parts.length; i < len; i++) {
				part = this._parts[i];
	
				for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
					p1 = part[j];
					p2 = part[k];
	
					if (((p1.y > p.y) !== (p2.y > p.y)) &&
							(p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
						inside = !inside;
					}
				}
			}
	
			return inside;
		}
	});
	
	
	/*
	 * Extends L.Circle with Canvas-specific code.
	 */
	
	L.Circle.include(!L.Path.CANVAS ? {} : {
		_drawPath: function () {
			var p = this._point;
			this._ctx.beginPath();
			this._ctx.arc(p.x, p.y, this._radius, 0, Math.PI * 2, false);
		},
	
		_containsPoint: function (p) {
			var center = this._point,
			    w2 = this.options.stroke ? this.options.weight / 2 : 0;
	
			return (p.distanceTo(center) <= this._radius + w2);
		}
	});
	
	
	/*
	 * CircleMarker canvas specific drawing parts.
	 */
	
	L.CircleMarker.include(!L.Path.CANVAS ? {} : {
		_updateStyle: function () {
			L.Path.prototype._updateStyle.call(this);
		}
	});
	
	
	/*
	 * L.GeoJSON turns any GeoJSON data into a Leaflet layer.
	 */
	
	L.GeoJSON = L.FeatureGroup.extend({
	
		initialize: function (geojson, options) {
			L.setOptions(this, options);
	
			this._layers = {};
	
			if (geojson) {
				this.addData(geojson);
			}
		},
	
		addData: function (geojson) {
			var features = L.Util.isArray(geojson) ? geojson : geojson.features,
			    i, len, feature;
	
			if (features) {
				for (i = 0, len = features.length; i < len; i++) {
					// Only add this if geometry or geometries are set and not null
					feature = features[i];
					if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
						this.addData(features[i]);
					}
				}
				return this;
			}
	
			var options = this.options;
	
			if (options.filter && !options.filter(geojson)) { return; }
	
			var layer = L.GeoJSON.geometryToLayer(geojson, options.pointToLayer, options.coordsToLatLng, options);
			layer.feature = L.GeoJSON.asFeature(geojson);
	
			layer.defaultOptions = layer.options;
			this.resetStyle(layer);
	
			if (options.onEachFeature) {
				options.onEachFeature(geojson, layer);
			}
	
			return this.addLayer(layer);
		},
	
		resetStyle: function (layer) {
			var style = this.options.style;
			if (style) {
				// reset any custom styles
				L.Util.extend(layer.options, layer.defaultOptions);
	
				this._setLayerStyle(layer, style);
			}
		},
	
		setStyle: function (style) {
			this.eachLayer(function (layer) {
				this._setLayerStyle(layer, style);
			}, this);
		},
	
		_setLayerStyle: function (layer, style) {
			if (typeof style === 'function') {
				style = style(layer.feature);
			}
			if (layer.setStyle) {
				layer.setStyle(style);
			}
		}
	});
	
	L.extend(L.GeoJSON, {
		geometryToLayer: function (geojson, pointToLayer, coordsToLatLng, vectorOptions) {
			var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
			    coords = geometry.coordinates,
			    layers = [],
			    latlng, latlngs, i, len;
	
			coordsToLatLng = coordsToLatLng || this.coordsToLatLng;
	
			switch (geometry.type) {
			case 'Point':
				latlng = coordsToLatLng(coords);
				return pointToLayer ? pointToLayer(geojson, latlng) : new L.Marker(latlng);
	
			case 'MultiPoint':
				for (i = 0, len = coords.length; i < len; i++) {
					latlng = coordsToLatLng(coords[i]);
					layers.push(pointToLayer ? pointToLayer(geojson, latlng) : new L.Marker(latlng));
				}
				return new L.FeatureGroup(layers);
	
			case 'LineString':
				latlngs = this.coordsToLatLngs(coords, 0, coordsToLatLng);
				return new L.Polyline(latlngs, vectorOptions);
	
			case 'Polygon':
				if (coords.length === 2 && !coords[1].length) {
					throw new Error('Invalid GeoJSON object.');
				}
				latlngs = this.coordsToLatLngs(coords, 1, coordsToLatLng);
				return new L.Polygon(latlngs, vectorOptions);
	
			case 'MultiLineString':
				latlngs = this.coordsToLatLngs(coords, 1, coordsToLatLng);
				return new L.MultiPolyline(latlngs, vectorOptions);
	
			case 'MultiPolygon':
				latlngs = this.coordsToLatLngs(coords, 2, coordsToLatLng);
				return new L.MultiPolygon(latlngs, vectorOptions);
	
			case 'GeometryCollection':
				for (i = 0, len = geometry.geometries.length; i < len; i++) {
	
					layers.push(this.geometryToLayer({
						geometry: geometry.geometries[i],
						type: 'Feature',
						properties: geojson.properties
					}, pointToLayer, coordsToLatLng, vectorOptions));
				}
				return new L.FeatureGroup(layers);
	
			default:
				throw new Error('Invalid GeoJSON object.');
			}
		},
	
		coordsToLatLng: function (coords) { // (Array[, Boolean]) -> LatLng
			return new L.LatLng(coords[1], coords[0], coords[2]);
		},
	
		coordsToLatLngs: function (coords, levelsDeep, coordsToLatLng) { // (Array[, Number, Function]) -> Array
			var latlng, i, len,
			    latlngs = [];
	
			for (i = 0, len = coords.length; i < len; i++) {
				latlng = levelsDeep ?
				        this.coordsToLatLngs(coords[i], levelsDeep - 1, coordsToLatLng) :
				        (coordsToLatLng || this.coordsToLatLng)(coords[i]);
	
				latlngs.push(latlng);
			}
	
			return latlngs;
		},
	
		latLngToCoords: function (latlng) {
			var coords = [latlng.lng, latlng.lat];
	
			if (latlng.alt !== undefined) {
				coords.push(latlng.alt);
			}
			return coords;
		},
	
		latLngsToCoords: function (latLngs) {
			var coords = [];
	
			for (var i = 0, len = latLngs.length; i < len; i++) {
				coords.push(L.GeoJSON.latLngToCoords(latLngs[i]));
			}
	
			return coords;
		},
	
		getFeature: function (layer, newGeometry) {
			return layer.feature ? L.extend({}, layer.feature, {geometry: newGeometry}) : L.GeoJSON.asFeature(newGeometry);
		},
	
		asFeature: function (geoJSON) {
			if (geoJSON.type === 'Feature') {
				return geoJSON;
			}
	
			return {
				type: 'Feature',
				properties: {},
				geometry: geoJSON
			};
		}
	});
	
	var PointToGeoJSON = {
		toGeoJSON: function () {
			return L.GeoJSON.getFeature(this, {
				type: 'Point',
				coordinates: L.GeoJSON.latLngToCoords(this.getLatLng())
			});
		}
	};
	
	L.Marker.include(PointToGeoJSON);
	L.Circle.include(PointToGeoJSON);
	L.CircleMarker.include(PointToGeoJSON);
	
	L.Polyline.include({
		toGeoJSON: function () {
			return L.GeoJSON.getFeature(this, {
				type: 'LineString',
				coordinates: L.GeoJSON.latLngsToCoords(this.getLatLngs())
			});
		}
	});
	
	L.Polygon.include({
		toGeoJSON: function () {
			var coords = [L.GeoJSON.latLngsToCoords(this.getLatLngs())],
			    i, len, hole;
	
			coords[0].push(coords[0][0]);
	
			if (this._holes) {
				for (i = 0, len = this._holes.length; i < len; i++) {
					hole = L.GeoJSON.latLngsToCoords(this._holes[i]);
					hole.push(hole[0]);
					coords.push(hole);
				}
			}
	
			return L.GeoJSON.getFeature(this, {
				type: 'Polygon',
				coordinates: coords
			});
		}
	});
	
	(function () {
		function multiToGeoJSON(type) {
			return function () {
				var coords = [];
	
				this.eachLayer(function (layer) {
					coords.push(layer.toGeoJSON().geometry.coordinates);
				});
	
				return L.GeoJSON.getFeature(this, {
					type: type,
					coordinates: coords
				});
			};
		}
	
		L.MultiPolyline.include({toGeoJSON: multiToGeoJSON('MultiLineString')});
		L.MultiPolygon.include({toGeoJSON: multiToGeoJSON('MultiPolygon')});
	
		L.LayerGroup.include({
			toGeoJSON: function () {
	
				var geometry = this.feature && this.feature.geometry,
					jsons = [],
					json;
	
				if (geometry && geometry.type === 'MultiPoint') {
					return multiToGeoJSON('MultiPoint').call(this);
				}
	
				var isGeometryCollection = geometry && geometry.type === 'GeometryCollection';
	
				this.eachLayer(function (layer) {
					if (layer.toGeoJSON) {
						json = layer.toGeoJSON();
						jsons.push(isGeometryCollection ? json.geometry : L.GeoJSON.asFeature(json));
					}
				});
	
				if (isGeometryCollection) {
					return L.GeoJSON.getFeature(this, {
						geometries: jsons,
						type: 'GeometryCollection'
					});
				}
	
				return {
					type: 'FeatureCollection',
					features: jsons
				};
			}
		});
	}());
	
	L.geoJson = function (geojson, options) {
		return new L.GeoJSON(geojson, options);
	};
	
	
	/*
	 * L.DomEvent contains functions for working with DOM events.
	 */
	
	L.DomEvent = {
		/* inspired by John Resig, Dean Edwards and YUI addEvent implementations */
		addListener: function (obj, type, fn, context) { // (HTMLElement, String, Function[, Object])
	
			var id = L.stamp(fn),
			    key = '_leaflet_' + type + id,
			    handler, originalHandler, newType;
	
			if (obj[key]) { return this; }
	
			handler = function (e) {
				return fn.call(context || obj, e || L.DomEvent._getEvent());
			};
	
			if (L.Browser.pointer && type.indexOf('touch') === 0) {
				return this.addPointerListener(obj, type, handler, id);
			}
			if (L.Browser.touch && (type === 'dblclick') && this.addDoubleTapListener) {
				this.addDoubleTapListener(obj, handler, id);
			}
	
			if ('addEventListener' in obj) {
	
				if (type === 'mousewheel') {
					obj.addEventListener('DOMMouseScroll', handler, false);
					obj.addEventListener(type, handler, false);
	
				} else if ((type === 'mouseenter') || (type === 'mouseleave')) {
	
					originalHandler = handler;
					newType = (type === 'mouseenter' ? 'mouseover' : 'mouseout');
	
					handler = function (e) {
						if (!L.DomEvent._checkMouse(obj, e)) { return; }
						return originalHandler(e);
					};
	
					obj.addEventListener(newType, handler, false);
	
				} else if (type === 'click' && L.Browser.android) {
					originalHandler = handler;
					handler = function (e) {
						return L.DomEvent._filterClick(e, originalHandler);
					};
	
					obj.addEventListener(type, handler, false);
				} else {
					obj.addEventListener(type, handler, false);
				}
	
			} else if ('attachEvent' in obj) {
				obj.attachEvent('on' + type, handler);
			}
	
			obj[key] = handler;
	
			return this;
		},
	
		removeListener: function (obj, type, fn) {  // (HTMLElement, String, Function)
	
			var id = L.stamp(fn),
			    key = '_leaflet_' + type + id,
			    handler = obj[key];
	
			if (!handler) { return this; }
	
			if (L.Browser.pointer && type.indexOf('touch') === 0) {
				this.removePointerListener(obj, type, id);
			} else if (L.Browser.touch && (type === 'dblclick') && this.removeDoubleTapListener) {
				this.removeDoubleTapListener(obj, id);
	
			} else if ('removeEventListener' in obj) {
	
				if (type === 'mousewheel') {
					obj.removeEventListener('DOMMouseScroll', handler, false);
					obj.removeEventListener(type, handler, false);
	
				} else if ((type === 'mouseenter') || (type === 'mouseleave')) {
					obj.removeEventListener((type === 'mouseenter' ? 'mouseover' : 'mouseout'), handler, false);
				} else {
					obj.removeEventListener(type, handler, false);
				}
			} else if ('detachEvent' in obj) {
				obj.detachEvent('on' + type, handler);
			}
	
			obj[key] = null;
	
			return this;
		},
	
		stopPropagation: function (e) {
	
			if (e.stopPropagation) {
				e.stopPropagation();
			} else {
				e.cancelBubble = true;
			}
			L.DomEvent._skipped(e);
	
			return this;
		},
	
		disableScrollPropagation: function (el) {
			var stop = L.DomEvent.stopPropagation;
	
			return L.DomEvent
				.on(el, 'mousewheel', stop)
				.on(el, 'MozMousePixelScroll', stop);
		},
	
		disableClickPropagation: function (el) {
			var stop = L.DomEvent.stopPropagation;
	
			for (var i = L.Draggable.START.length - 1; i >= 0; i--) {
				L.DomEvent.on(el, L.Draggable.START[i], stop);
			}
	
			return L.DomEvent
				.on(el, 'click', L.DomEvent._fakeStop)
				.on(el, 'dblclick', stop);
		},
	
		preventDefault: function (e) {
	
			if (e.preventDefault) {
				e.preventDefault();
			} else {
				e.returnValue = false;
			}
			return this;
		},
	
		stop: function (e) {
			return L.DomEvent
				.preventDefault(e)
				.stopPropagation(e);
		},
	
		getMousePosition: function (e, container) {
			if (!container) {
				return new L.Point(e.clientX, e.clientY);
			}
	
			var rect = container.getBoundingClientRect();
	
			return new L.Point(
				e.clientX - rect.left - container.clientLeft,
				e.clientY - rect.top - container.clientTop);
		},
	
		getWheelDelta: function (e) {
	
			var delta = 0;
	
			if (e.wheelDelta) {
				delta = e.wheelDelta / 120;
			}
			if (e.detail) {
				delta = -e.detail / 3;
			}
			return delta;
		},
	
		_skipEvents: {},
	
		_fakeStop: function (e) {
			// fakes stopPropagation by setting a special event flag, checked/reset with L.DomEvent._skipped(e)
			L.DomEvent._skipEvents[e.type] = true;
		},
	
		_skipped: function (e) {
			var skipped = this._skipEvents[e.type];
			// reset when checking, as it's only used in map container and propagates outside of the map
			this._skipEvents[e.type] = false;
			return skipped;
		},
	
		// check if element really left/entered the event target (for mouseenter/mouseleave)
		_checkMouse: function (el, e) {
	
			var related = e.relatedTarget;
	
			if (!related) { return true; }
	
			try {
				while (related && (related !== el)) {
					related = related.parentNode;
				}
			} catch (err) {
				return false;
			}
			return (related !== el);
		},
	
		_getEvent: function () { // evil magic for IE
			/*jshint noarg:false */
			var e = window.event;
			if (!e) {
				var caller = arguments.callee.caller;
				while (caller) {
					e = caller['arguments'][0];
					if (e && window.Event === e.constructor) {
						break;
					}
					caller = caller.caller;
				}
			}
			return e;
		},
	
		// this is a horrible workaround for a bug in Android where a single touch triggers two click events
		_filterClick: function (e, handler) {
			var timeStamp = (e.timeStamp || e.originalEvent.timeStamp),
				elapsed = L.DomEvent._lastClick && (timeStamp - L.DomEvent._lastClick);
	
			// are they closer together than 500ms yet more than 100ms?
			// Android typically triggers them ~300ms apart while multiple listeners
			// on the same event should be triggered far faster;
			// or check if click is simulated on the element, and if it is, reject any non-simulated events
	
			if ((elapsed && elapsed > 100 && elapsed < 500) || (e.target._simulatedClick && !e._simulated)) {
				L.DomEvent.stop(e);
				return;
			}
			L.DomEvent._lastClick = timeStamp;
	
			return handler(e);
		}
	};
	
	L.DomEvent.on = L.DomEvent.addListener;
	L.DomEvent.off = L.DomEvent.removeListener;
	
	
	/*
	 * L.Draggable allows you to add dragging capabilities to any element. Supports mobile devices too.
	 */
	
	L.Draggable = L.Class.extend({
		includes: L.Mixin.Events,
	
		statics: {
			START: L.Browser.touch ? ['touchstart', 'mousedown'] : ['mousedown'],
			END: {
				mousedown: 'mouseup',
				touchstart: 'touchend',
				pointerdown: 'touchend',
				MSPointerDown: 'touchend'
			},
			MOVE: {
				mousedown: 'mousemove',
				touchstart: 'touchmove',
				pointerdown: 'touchmove',
				MSPointerDown: 'touchmove'
			}
		},
	
		initialize: function (element, dragStartTarget) {
			this._element = element;
			this._dragStartTarget = dragStartTarget || element;
		},
	
		enable: function () {
			if (this._enabled) { return; }
	
			for (var i = L.Draggable.START.length - 1; i >= 0; i--) {
				L.DomEvent.on(this._dragStartTarget, L.Draggable.START[i], this._onDown, this);
			}
	
			this._enabled = true;
		},
	
		disable: function () {
			if (!this._enabled) { return; }
	
			for (var i = L.Draggable.START.length - 1; i >= 0; i--) {
				L.DomEvent.off(this._dragStartTarget, L.Draggable.START[i], this._onDown, this);
			}
	
			this._enabled = false;
			this._moved = false;
		},
	
		_onDown: function (e) {
			this._moved = false;
	
			if (e.shiftKey || ((e.which !== 1) && (e.button !== 1) && !e.touches)) { return; }
	
			L.DomEvent.stopPropagation(e);
	
			if (L.Draggable._disabled) { return; }
	
			L.DomUtil.disableImageDrag();
			L.DomUtil.disableTextSelection();
	
			if (this._moving) { return; }
	
			var first = e.touches ? e.touches[0] : e;
	
			this._startPoint = new L.Point(first.clientX, first.clientY);
			this._startPos = this._newPos = L.DomUtil.getPosition(this._element);
	
			L.DomEvent
			    .on(document, L.Draggable.MOVE[e.type], this._onMove, this)
			    .on(document, L.Draggable.END[e.type], this._onUp, this);
		},
	
		_onMove: function (e) {
			if (e.touches && e.touches.length > 1) {
				this._moved = true;
				return;
			}
	
			var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
			    newPoint = new L.Point(first.clientX, first.clientY),
			    offset = newPoint.subtract(this._startPoint);
	
			if (!offset.x && !offset.y) { return; }
			if (L.Browser.touch && Math.abs(offset.x) + Math.abs(offset.y) < 3) { return; }
	
			L.DomEvent.preventDefault(e);
	
			if (!this._moved) {
				this.fire('dragstart');
	
				this._moved = true;
				this._startPos = L.DomUtil.getPosition(this._element).subtract(offset);
	
				L.DomUtil.addClass(document.body, 'leaflet-dragging');
				this._lastTarget = e.target || e.srcElement;
				L.DomUtil.addClass(this._lastTarget, 'leaflet-drag-target');
			}
	
			this._newPos = this._startPos.add(offset);
			this._moving = true;
	
			L.Util.cancelAnimFrame(this._animRequest);
			this._animRequest = L.Util.requestAnimFrame(this._updatePosition, this, true, this._dragStartTarget);
		},
	
		_updatePosition: function () {
			this.fire('predrag');
			L.DomUtil.setPosition(this._element, this._newPos);
			this.fire('drag');
		},
	
		_onUp: function () {
			L.DomUtil.removeClass(document.body, 'leaflet-dragging');
	
			if (this._lastTarget) {
				L.DomUtil.removeClass(this._lastTarget, 'leaflet-drag-target');
				this._lastTarget = null;
			}
	
			for (var i in L.Draggable.MOVE) {
				L.DomEvent
				    .off(document, L.Draggable.MOVE[i], this._onMove)
				    .off(document, L.Draggable.END[i], this._onUp);
			}
	
			L.DomUtil.enableImageDrag();
			L.DomUtil.enableTextSelection();
	
			if (this._moved && this._moving) {
				// ensure drag is not fired after dragend
				L.Util.cancelAnimFrame(this._animRequest);
	
				this.fire('dragend', {
					distance: this._newPos.distanceTo(this._startPos)
				});
			}
	
			this._moving = false;
		}
	});
	
	
	/*
		L.Handler is a base class for handler classes that are used internally to inject
		interaction features like dragging to classes like Map and Marker.
	*/
	
	L.Handler = L.Class.extend({
		initialize: function (map) {
			this._map = map;
		},
	
		enable: function () {
			if (this._enabled) { return; }
	
			this._enabled = true;
			this.addHooks();
		},
	
		disable: function () {
			if (!this._enabled) { return; }
	
			this._enabled = false;
			this.removeHooks();
		},
	
		enabled: function () {
			return !!this._enabled;
		}
	});
	
	
	/*
	 * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
	 */
	
	L.Map.mergeOptions({
		dragging: true,
	
		inertia: !L.Browser.android23,
		inertiaDeceleration: 3400, // px/s^2
		inertiaMaxSpeed: Infinity, // px/s
		inertiaThreshold: L.Browser.touch ? 32 : 18, // ms
		easeLinearity: 0.25,
	
		// TODO refactor, move to CRS
		worldCopyJump: false
	});
	
	L.Map.Drag = L.Handler.extend({
		addHooks: function () {
			if (!this._draggable) {
				var map = this._map;
	
				this._draggable = new L.Draggable(map._mapPane, map._container);
	
				this._draggable.on({
					'dragstart': this._onDragStart,
					'drag': this._onDrag,
					'dragend': this._onDragEnd
				}, this);
	
				if (map.options.worldCopyJump) {
					this._draggable.on('predrag', this._onPreDrag, this);
					map.on('viewreset', this._onViewReset, this);
	
					map.whenReady(this._onViewReset, this);
				}
			}
			this._draggable.enable();
		},
	
		removeHooks: function () {
			this._draggable.disable();
		},
	
		moved: function () {
			return this._draggable && this._draggable._moved;
		},
	
		_onDragStart: function () {
			var map = this._map;
	
			if (map._panAnim) {
				map._panAnim.stop();
			}
	
			map
			    .fire('movestart')
			    .fire('dragstart');
	
			if (map.options.inertia) {
				this._positions = [];
				this._times = [];
			}
		},
	
		_onDrag: function () {
			if (this._map.options.inertia) {
				var time = this._lastTime = +new Date(),
				    pos = this._lastPos = this._draggable._newPos;
	
				this._positions.push(pos);
				this._times.push(time);
	
				if (time - this._times[0] > 200) {
					this._positions.shift();
					this._times.shift();
				}
			}
	
			this._map
			    .fire('move')
			    .fire('drag');
		},
	
		_onViewReset: function () {
			// TODO fix hardcoded Earth values
			var pxCenter = this._map.getSize()._divideBy(2),
			    pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);
	
			this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
			this._worldWidth = this._map.project([0, 180]).x;
		},
	
		_onPreDrag: function () {
			// TODO refactor to be able to adjust map pane position after zoom
			var worldWidth = this._worldWidth,
			    halfWidth = Math.round(worldWidth / 2),
			    dx = this._initialWorldOffset,
			    x = this._draggable._newPos.x,
			    newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx,
			    newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx,
			    newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
	
			this._draggable._newPos.x = newX;
		},
	
		_onDragEnd: function (e) {
			var map = this._map,
			    options = map.options,
			    delay = +new Date() - this._lastTime,
	
			    noInertia = !options.inertia || delay > options.inertiaThreshold || !this._positions[0];
	
			map.fire('dragend', e);
	
			if (noInertia) {
				map.fire('moveend');
	
			} else {
	
				var direction = this._lastPos.subtract(this._positions[0]),
				    duration = (this._lastTime + delay - this._times[0]) / 1000,
				    ease = options.easeLinearity,
	
				    speedVector = direction.multiplyBy(ease / duration),
				    speed = speedVector.distanceTo([0, 0]),
	
				    limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
				    limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),
	
				    decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease),
				    offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
	
				if (!offset.x || !offset.y) {
					map.fire('moveend');
	
				} else {
					offset = map._limitOffset(offset, map.options.maxBounds);
	
					L.Util.requestAnimFrame(function () {
						map.panBy(offset, {
							duration: decelerationDuration,
							easeLinearity: ease,
							noMoveStart: true
						});
					});
				}
			}
		}
	});
	
	L.Map.addInitHook('addHandler', 'dragging', L.Map.Drag);
	
	
	/*
	 * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
	 */
	
	L.Map.mergeOptions({
		doubleClickZoom: true
	});
	
	L.Map.DoubleClickZoom = L.Handler.extend({
		addHooks: function () {
			this._map.on('dblclick', this._onDoubleClick, this);
		},
	
		removeHooks: function () {
			this._map.off('dblclick', this._onDoubleClick, this);
		},
	
		_onDoubleClick: function (e) {
			var map = this._map,
			    zoom = map.getZoom() + (e.originalEvent.shiftKey ? -1 : 1);
	
			if (map.options.doubleClickZoom === 'center') {
				map.setZoom(zoom);
			} else {
				map.setZoomAround(e.containerPoint, zoom);
			}
		}
	});
	
	L.Map.addInitHook('addHandler', 'doubleClickZoom', L.Map.DoubleClickZoom);
	
	
	/*
	 * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
	 */
	
	L.Map.mergeOptions({
		scrollWheelZoom: true
	});
	
	L.Map.ScrollWheelZoom = L.Handler.extend({
		addHooks: function () {
			L.DomEvent.on(this._map._container, 'mousewheel', this._onWheelScroll, this);
			L.DomEvent.on(this._map._container, 'MozMousePixelScroll', L.DomEvent.preventDefault);
			this._delta = 0;
		},
	
		removeHooks: function () {
			L.DomEvent.off(this._map._container, 'mousewheel', this._onWheelScroll);
			L.DomEvent.off(this._map._container, 'MozMousePixelScroll', L.DomEvent.preventDefault);
		},
	
		_onWheelScroll: function (e) {
			var delta = L.DomEvent.getWheelDelta(e);
	
			this._delta += delta;
			this._lastMousePos = this._map.mouseEventToContainerPoint(e);
	
			if (!this._startTime) {
				this._startTime = +new Date();
			}
	
			var left = Math.max(40 - (+new Date() - this._startTime), 0);
	
			clearTimeout(this._timer);
			this._timer = setTimeout(L.bind(this._performZoom, this), left);
	
			L.DomEvent.preventDefault(e);
			L.DomEvent.stopPropagation(e);
		},
	
		_performZoom: function () {
			var map = this._map,
			    delta = this._delta,
			    zoom = map.getZoom();
	
			delta = delta > 0 ? Math.ceil(delta) : Math.floor(delta);
			delta = Math.max(Math.min(delta, 4), -4);
			delta = map._limitZoom(zoom + delta) - zoom;
	
			this._delta = 0;
			this._startTime = null;
	
			if (!delta) { return; }
	
			if (map.options.scrollWheelZoom === 'center') {
				map.setZoom(zoom + delta);
			} else {
				map.setZoomAround(this._lastMousePos, zoom + delta);
			}
		}
	});
	
	L.Map.addInitHook('addHandler', 'scrollWheelZoom', L.Map.ScrollWheelZoom);
	
	
	/*
	 * Extends the event handling code with double tap support for mobile browsers.
	 */
	
	L.extend(L.DomEvent, {
	
		_touchstart: L.Browser.msPointer ? 'MSPointerDown' : L.Browser.pointer ? 'pointerdown' : 'touchstart',
		_touchend: L.Browser.msPointer ? 'MSPointerUp' : L.Browser.pointer ? 'pointerup' : 'touchend',
	
		// inspired by Zepto touch code by Thomas Fuchs
		addDoubleTapListener: function (obj, handler, id) {
			var last,
			    doubleTap = false,
			    delay = 250,
			    touch,
			    pre = '_leaflet_',
			    touchstart = this._touchstart,
			    touchend = this._touchend,
			    trackedTouches = [];
	
			function onTouchStart(e) {
				var count;
	
				if (L.Browser.pointer) {
					trackedTouches.push(e.pointerId);
					count = trackedTouches.length;
				} else {
					count = e.touches.length;
				}
				if (count > 1) {
					return;
				}
	
				var now = Date.now(),
					delta = now - (last || now);
	
				touch = e.touches ? e.touches[0] : e;
				doubleTap = (delta > 0 && delta <= delay);
				last = now;
			}
	
			function onTouchEnd(e) {
				if (L.Browser.pointer) {
					var idx = trackedTouches.indexOf(e.pointerId);
					if (idx === -1) {
						return;
					}
					trackedTouches.splice(idx, 1);
				}
	
				if (doubleTap) {
					if (L.Browser.pointer) {
						// work around .type being readonly with MSPointer* events
						var newTouch = { },
							prop;
	
						// jshint forin:false
						for (var i in touch) {
							prop = touch[i];
							if (typeof prop === 'function') {
								newTouch[i] = prop.bind(touch);
							} else {
								newTouch[i] = prop;
							}
						}
						touch = newTouch;
					}
					touch.type = 'dblclick';
					handler(touch);
					last = null;
				}
			}
			obj[pre + touchstart + id] = onTouchStart;
			obj[pre + touchend + id] = onTouchEnd;
	
			// on pointer we need to listen on the document, otherwise a drag starting on the map and moving off screen
			// will not come through to us, so we will lose track of how many touches are ongoing
			var endElement = L.Browser.pointer ? document.documentElement : obj;
	
			obj.addEventListener(touchstart, onTouchStart, false);
			endElement.addEventListener(touchend, onTouchEnd, false);
	
			if (L.Browser.pointer) {
				endElement.addEventListener(L.DomEvent.POINTER_CANCEL, onTouchEnd, false);
			}
	
			return this;
		},
	
		removeDoubleTapListener: function (obj, id) {
			var pre = '_leaflet_';
	
			obj.removeEventListener(this._touchstart, obj[pre + this._touchstart + id], false);
			(L.Browser.pointer ? document.documentElement : obj).removeEventListener(
			        this._touchend, obj[pre + this._touchend + id], false);
	
			if (L.Browser.pointer) {
				document.documentElement.removeEventListener(L.DomEvent.POINTER_CANCEL, obj[pre + this._touchend + id],
					false);
			}
	
			return this;
		}
	});
	
	
	/*
	 * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
	 */
	
	L.extend(L.DomEvent, {
	
		//static
		POINTER_DOWN: L.Browser.msPointer ? 'MSPointerDown' : 'pointerdown',
		POINTER_MOVE: L.Browser.msPointer ? 'MSPointerMove' : 'pointermove',
		POINTER_UP: L.Browser.msPointer ? 'MSPointerUp' : 'pointerup',
		POINTER_CANCEL: L.Browser.msPointer ? 'MSPointerCancel' : 'pointercancel',
	
		_pointers: [],
		_pointerDocumentListener: false,
	
		// Provides a touch events wrapper for (ms)pointer events.
		// Based on changes by veproza https://github.com/CloudMade/Leaflet/pull/1019
		//ref http://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
	
		addPointerListener: function (obj, type, handler, id) {
	
			switch (type) {
			case 'touchstart':
				return this.addPointerListenerStart(obj, type, handler, id);
			case 'touchend':
				return this.addPointerListenerEnd(obj, type, handler, id);
			case 'touchmove':
				return this.addPointerListenerMove(obj, type, handler, id);
			default:
				throw 'Unknown touch event type';
			}
		},
	
		addPointerListenerStart: function (obj, type, handler, id) {
			var pre = '_leaflet_',
			    pointers = this._pointers;
	
			var cb = function (e) {
				if (e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
					L.DomEvent.preventDefault(e);
				}
	
				var alreadyInArray = false;
				for (var i = 0; i < pointers.length; i++) {
					if (pointers[i].pointerId === e.pointerId) {
						alreadyInArray = true;
						break;
					}
				}
				if (!alreadyInArray) {
					pointers.push(e);
				}
	
				e.touches = pointers.slice();
				e.changedTouches = [e];
	
				handler(e);
			};
	
			obj[pre + 'touchstart' + id] = cb;
			obj.addEventListener(this.POINTER_DOWN, cb, false);
	
			// need to also listen for end events to keep the _pointers list accurate
			// this needs to be on the body and never go away
			if (!this._pointerDocumentListener) {
				var internalCb = function (e) {
					for (var i = 0; i < pointers.length; i++) {
						if (pointers[i].pointerId === e.pointerId) {
							pointers.splice(i, 1);
							break;
						}
					}
				};
				//We listen on the documentElement as any drags that end by moving the touch off the screen get fired there
				document.documentElement.addEventListener(this.POINTER_UP, internalCb, false);
				document.documentElement.addEventListener(this.POINTER_CANCEL, internalCb, false);
	
				this._pointerDocumentListener = true;
			}
	
			return this;
		},
	
		addPointerListenerMove: function (obj, type, handler, id) {
			var pre = '_leaflet_',
			    touches = this._pointers;
	
			function cb(e) {
	
				// don't fire touch moves when mouse isn't down
				if ((e.pointerType === e.MSPOINTER_TYPE_MOUSE || e.pointerType === 'mouse') && e.buttons === 0) { return; }
	
				for (var i = 0; i < touches.length; i++) {
					if (touches[i].pointerId === e.pointerId) {
						touches[i] = e;
						break;
					}
				}
	
				e.touches = touches.slice();
				e.changedTouches = [e];
	
				handler(e);
			}
	
			obj[pre + 'touchmove' + id] = cb;
			obj.addEventListener(this.POINTER_MOVE, cb, false);
	
			return this;
		},
	
		addPointerListenerEnd: function (obj, type, handler, id) {
			var pre = '_leaflet_',
			    touches = this._pointers;
	
			var cb = function (e) {
				for (var i = 0; i < touches.length; i++) {
					if (touches[i].pointerId === e.pointerId) {
						touches.splice(i, 1);
						break;
					}
				}
	
				e.touches = touches.slice();
				e.changedTouches = [e];
	
				handler(e);
			};
	
			obj[pre + 'touchend' + id] = cb;
			obj.addEventListener(this.POINTER_UP, cb, false);
			obj.addEventListener(this.POINTER_CANCEL, cb, false);
	
			return this;
		},
	
		removePointerListener: function (obj, type, id) {
			var pre = '_leaflet_',
			    cb = obj[pre + type + id];
	
			switch (type) {
			case 'touchstart':
				obj.removeEventListener(this.POINTER_DOWN, cb, false);
				break;
			case 'touchmove':
				obj.removeEventListener(this.POINTER_MOVE, cb, false);
				break;
			case 'touchend':
				obj.removeEventListener(this.POINTER_UP, cb, false);
				obj.removeEventListener(this.POINTER_CANCEL, cb, false);
				break;
			}
	
			return this;
		}
	});
	
	
	/*
	 * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
	 */
	
	L.Map.mergeOptions({
		touchZoom: L.Browser.touch && !L.Browser.android23,
		bounceAtZoomLimits: true
	});
	
	L.Map.TouchZoom = L.Handler.extend({
		addHooks: function () {
			L.DomEvent.on(this._map._container, 'touchstart', this._onTouchStart, this);
		},
	
		removeHooks: function () {
			L.DomEvent.off(this._map._container, 'touchstart', this._onTouchStart, this);
		},
	
		_onTouchStart: function (e) {
			var map = this._map;
	
			if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) { return; }
	
			var p1 = map.mouseEventToLayerPoint(e.touches[0]),
			    p2 = map.mouseEventToLayerPoint(e.touches[1]),
			    viewCenter = map._getCenterLayerPoint();
	
			this._startCenter = p1.add(p2)._divideBy(2);
			this._startDist = p1.distanceTo(p2);
	
			this._moved = false;
			this._zooming = true;
	
			this._centerOffset = viewCenter.subtract(this._startCenter);
	
			if (map._panAnim) {
				map._panAnim.stop();
			}
	
			L.DomEvent
			    .on(document, 'touchmove', this._onTouchMove, this)
			    .on(document, 'touchend', this._onTouchEnd, this);
	
			L.DomEvent.preventDefault(e);
		},
	
		_onTouchMove: function (e) {
			var map = this._map;
	
			if (!e.touches || e.touches.length !== 2 || !this._zooming) { return; }
	
			var p1 = map.mouseEventToLayerPoint(e.touches[0]),
			    p2 = map.mouseEventToLayerPoint(e.touches[1]);
	
			this._scale = p1.distanceTo(p2) / this._startDist;
			this._delta = p1._add(p2)._divideBy(2)._subtract(this._startCenter);
	
			if (this._scale === 1) { return; }
	
			if (!map.options.bounceAtZoomLimits) {
				if ((map.getZoom() === map.getMinZoom() && this._scale < 1) ||
				    (map.getZoom() === map.getMaxZoom() && this._scale > 1)) { return; }
			}
	
			if (!this._moved) {
				L.DomUtil.addClass(map._mapPane, 'leaflet-touching');
	
				map
				    .fire('movestart')
				    .fire('zoomstart');
	
				this._moved = true;
			}
	
			L.Util.cancelAnimFrame(this._animRequest);
			this._animRequest = L.Util.requestAnimFrame(
			        this._updateOnMove, this, true, this._map._container);
	
			L.DomEvent.preventDefault(e);
		},
	
		_updateOnMove: function () {
			var map = this._map,
			    origin = this._getScaleOrigin(),
			    center = map.layerPointToLatLng(origin),
			    zoom = map.getScaleZoom(this._scale);
	
			map._animateZoom(center, zoom, this._startCenter, this._scale, this._delta, false, true);
		},
	
		_onTouchEnd: function () {
			if (!this._moved || !this._zooming) {
				this._zooming = false;
				return;
			}
	
			var map = this._map;
	
			this._zooming = false;
			L.DomUtil.removeClass(map._mapPane, 'leaflet-touching');
			L.Util.cancelAnimFrame(this._animRequest);
	
			L.DomEvent
			    .off(document, 'touchmove', this._onTouchMove)
			    .off(document, 'touchend', this._onTouchEnd);
	
			var origin = this._getScaleOrigin(),
			    center = map.layerPointToLatLng(origin),
	
			    oldZoom = map.getZoom(),
			    floatZoomDelta = map.getScaleZoom(this._scale) - oldZoom,
			    roundZoomDelta = (floatZoomDelta > 0 ?
			            Math.ceil(floatZoomDelta) : Math.floor(floatZoomDelta)),
	
			    zoom = map._limitZoom(oldZoom + roundZoomDelta),
			    scale = map.getZoomScale(zoom) / this._scale;
	
			map._animateZoom(center, zoom, origin, scale);
		},
	
		_getScaleOrigin: function () {
			var centerOffset = this._centerOffset.subtract(this._delta).divideBy(this._scale);
			return this._startCenter.add(centerOffset);
		}
	});
	
	L.Map.addInitHook('addHandler', 'touchZoom', L.Map.TouchZoom);
	
	
	/*
	 * L.Map.Tap is used to enable mobile hacks like quick taps and long hold.
	 */
	
	L.Map.mergeOptions({
		tap: true,
		tapTolerance: 15
	});
	
	L.Map.Tap = L.Handler.extend({
		addHooks: function () {
			L.DomEvent.on(this._map._container, 'touchstart', this._onDown, this);
		},
	
		removeHooks: function () {
			L.DomEvent.off(this._map._container, 'touchstart', this._onDown, this);
		},
	
		_onDown: function (e) {
			if (!e.touches) { return; }
	
			L.DomEvent.preventDefault(e);
	
			this._fireClick = true;
	
			// don't simulate click or track longpress if more than 1 touch
			if (e.touches.length > 1) {
				this._fireClick = false;
				clearTimeout(this._holdTimeout);
				return;
			}
	
			var first = e.touches[0],
			    el = first.target;
	
			this._startPos = this._newPos = new L.Point(first.clientX, first.clientY);
	
			// if touching a link, highlight it
			if (el.tagName && el.tagName.toLowerCase() === 'a') {
				L.DomUtil.addClass(el, 'leaflet-active');
			}
	
			// simulate long hold but setting a timeout
			this._holdTimeout = setTimeout(L.bind(function () {
				if (this._isTapValid()) {
					this._fireClick = false;
					this._onUp();
					this._simulateEvent('contextmenu', first);
				}
			}, this), 1000);
	
			L.DomEvent
				.on(document, 'touchmove', this._onMove, this)
				.on(document, 'touchend', this._onUp, this);
		},
	
		_onUp: function (e) {
			clearTimeout(this._holdTimeout);
	
			L.DomEvent
				.off(document, 'touchmove', this._onMove, this)
				.off(document, 'touchend', this._onUp, this);
	
			if (this._fireClick && e && e.changedTouches) {
	
				var first = e.changedTouches[0],
				    el = first.target;
	
				if (el && el.tagName && el.tagName.toLowerCase() === 'a') {
					L.DomUtil.removeClass(el, 'leaflet-active');
				}
	
				// simulate click if the touch didn't move too much
				if (this._isTapValid()) {
					this._simulateEvent('click', first);
				}
			}
		},
	
		_isTapValid: function () {
			return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
		},
	
		_onMove: function (e) {
			var first = e.touches[0];
			this._newPos = new L.Point(first.clientX, first.clientY);
		},
	
		_simulateEvent: function (type, e) {
			var simulatedEvent = document.createEvent('MouseEvents');
	
			simulatedEvent._simulated = true;
			e.target._simulatedClick = true;
	
			simulatedEvent.initMouseEvent(
			        type, true, true, window, 1,
			        e.screenX, e.screenY,
			        e.clientX, e.clientY,
			        false, false, false, false, 0, null);
	
			e.target.dispatchEvent(simulatedEvent);
		}
	});
	
	if (L.Browser.touch && !L.Browser.pointer) {
		L.Map.addInitHook('addHandler', 'tap', L.Map.Tap);
	}
	
	
	/*
	 * L.Handler.ShiftDragZoom is used to add shift-drag zoom interaction to the map
	  * (zoom to a selected bounding box), enabled by default.
	 */
	
	L.Map.mergeOptions({
		boxZoom: true
	});
	
	L.Map.BoxZoom = L.Handler.extend({
		initialize: function (map) {
			this._map = map;
			this._container = map._container;
			this._pane = map._panes.overlayPane;
			this._moved = false;
		},
	
		addHooks: function () {
			L.DomEvent.on(this._container, 'mousedown', this._onMouseDown, this);
		},
	
		removeHooks: function () {
			L.DomEvent.off(this._container, 'mousedown', this._onMouseDown);
			this._moved = false;
		},
	
		moved: function () {
			return this._moved;
		},
	
		_onMouseDown: function (e) {
			this._moved = false;
	
			if (!e.shiftKey || ((e.which !== 1) && (e.button !== 1))) { return false; }
	
			L.DomUtil.disableTextSelection();
			L.DomUtil.disableImageDrag();
	
			this._startLayerPoint = this._map.mouseEventToLayerPoint(e);
	
			L.DomEvent
			    .on(document, 'mousemove', this._onMouseMove, this)
			    .on(document, 'mouseup', this._onMouseUp, this)
			    .on(document, 'keydown', this._onKeyDown, this);
		},
	
		_onMouseMove: function (e) {
			if (!this._moved) {
				this._box = L.DomUtil.create('div', 'leaflet-zoom-box', this._pane);
				L.DomUtil.setPosition(this._box, this._startLayerPoint);
	
				//TODO refactor: move cursor to styles
				this._container.style.cursor = 'crosshair';
				this._map.fire('boxzoomstart');
			}
	
			var startPoint = this._startLayerPoint,
			    box = this._box,
	
			    layerPoint = this._map.mouseEventToLayerPoint(e),
			    offset = layerPoint.subtract(startPoint),
	
			    newPos = new L.Point(
			        Math.min(layerPoint.x, startPoint.x),
			        Math.min(layerPoint.y, startPoint.y));
	
			L.DomUtil.setPosition(box, newPos);
	
			this._moved = true;
	
			// TODO refactor: remove hardcoded 4 pixels
			box.style.width  = (Math.max(0, Math.abs(offset.x) - 4)) + 'px';
			box.style.height = (Math.max(0, Math.abs(offset.y) - 4)) + 'px';
		},
	
		_finish: function () {
			if (this._moved) {
				this._pane.removeChild(this._box);
				this._container.style.cursor = '';
			}
	
			L.DomUtil.enableTextSelection();
			L.DomUtil.enableImageDrag();
	
			L.DomEvent
			    .off(document, 'mousemove', this._onMouseMove)
			    .off(document, 'mouseup', this._onMouseUp)
			    .off(document, 'keydown', this._onKeyDown);
		},
	
		_onMouseUp: function (e) {
	
			this._finish();
	
			var map = this._map,
			    layerPoint = map.mouseEventToLayerPoint(e);
	
			if (this._startLayerPoint.equals(layerPoint)) { return; }
	
			var bounds = new L.LatLngBounds(
			        map.layerPointToLatLng(this._startLayerPoint),
			        map.layerPointToLatLng(layerPoint));
	
			map.fitBounds(bounds);
	
			map.fire('boxzoomend', {
				boxZoomBounds: bounds
			});
		},
	
		_onKeyDown: function (e) {
			if (e.keyCode === 27) {
				this._finish();
			}
		}
	});
	
	L.Map.addInitHook('addHandler', 'boxZoom', L.Map.BoxZoom);
	
	
	/*
	 * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
	 */
	
	L.Map.mergeOptions({
		keyboard: true,
		keyboardPanOffset: 80,
		keyboardZoomOffset: 1
	});
	
	L.Map.Keyboard = L.Handler.extend({
	
		keyCodes: {
			left:    [37],
			right:   [39],
			down:    [40],
			up:      [38],
			zoomIn:  [187, 107, 61, 171],
			zoomOut: [189, 109, 173]
		},
	
		initialize: function (map) {
			this._map = map;
	
			this._setPanOffset(map.options.keyboardPanOffset);
			this._setZoomOffset(map.options.keyboardZoomOffset);
		},
	
		addHooks: function () {
			var container = this._map._container;
	
			// make the container focusable by tabbing
			if (container.tabIndex === -1) {
				container.tabIndex = '0';
			}
	
			L.DomEvent
			    .on(container, 'focus', this._onFocus, this)
			    .on(container, 'blur', this._onBlur, this)
			    .on(container, 'mousedown', this._onMouseDown, this);
	
			this._map
			    .on('focus', this._addHooks, this)
			    .on('blur', this._removeHooks, this);
		},
	
		removeHooks: function () {
			this._removeHooks();
	
			var container = this._map._container;
	
			L.DomEvent
			    .off(container, 'focus', this._onFocus, this)
			    .off(container, 'blur', this._onBlur, this)
			    .off(container, 'mousedown', this._onMouseDown, this);
	
			this._map
			    .off('focus', this._addHooks, this)
			    .off('blur', this._removeHooks, this);
		},
	
		_onMouseDown: function () {
			if (this._focused) { return; }
	
			var body = document.body,
			    docEl = document.documentElement,
			    top = body.scrollTop || docEl.scrollTop,
			    left = body.scrollLeft || docEl.scrollLeft;
	
			this._map._container.focus();
	
			window.scrollTo(left, top);
		},
	
		_onFocus: function () {
			this._focused = true;
			this._map.fire('focus');
		},
	
		_onBlur: function () {
			this._focused = false;
			this._map.fire('blur');
		},
	
		_setPanOffset: function (pan) {
			var keys = this._panKeys = {},
			    codes = this.keyCodes,
			    i, len;
	
			for (i = 0, len = codes.left.length; i < len; i++) {
				keys[codes.left[i]] = [-1 * pan, 0];
			}
			for (i = 0, len = codes.right.length; i < len; i++) {
				keys[codes.right[i]] = [pan, 0];
			}
			for (i = 0, len = codes.down.length; i < len; i++) {
				keys[codes.down[i]] = [0, pan];
			}
			for (i = 0, len = codes.up.length; i < len; i++) {
				keys[codes.up[i]] = [0, -1 * pan];
			}
		},
	
		_setZoomOffset: function (zoom) {
			var keys = this._zoomKeys = {},
			    codes = this.keyCodes,
			    i, len;
	
			for (i = 0, len = codes.zoomIn.length; i < len; i++) {
				keys[codes.zoomIn[i]] = zoom;
			}
			for (i = 0, len = codes.zoomOut.length; i < len; i++) {
				keys[codes.zoomOut[i]] = -zoom;
			}
		},
	
		_addHooks: function () {
			L.DomEvent.on(document, 'keydown', this._onKeyDown, this);
		},
	
		_removeHooks: function () {
			L.DomEvent.off(document, 'keydown', this._onKeyDown, this);
		},
	
		_onKeyDown: function (e) {
			var key = e.keyCode,
			    map = this._map;
	
			if (key in this._panKeys) {
	
				if (map._panAnim && map._panAnim._inProgress) { return; }
	
				map.panBy(this._panKeys[key]);
	
				if (map.options.maxBounds) {
					map.panInsideBounds(map.options.maxBounds);
				}
	
			} else if (key in this._zoomKeys) {
				map.setZoom(map.getZoom() + this._zoomKeys[key]);
	
			} else {
				return;
			}
	
			L.DomEvent.stop(e);
		}
	});
	
	L.Map.addInitHook('addHandler', 'keyboard', L.Map.Keyboard);
	
	
	/*
	 * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
	 */
	
	L.Handler.MarkerDrag = L.Handler.extend({
		initialize: function (marker) {
			this._marker = marker;
		},
	
		addHooks: function () {
			var icon = this._marker._icon;
			if (!this._draggable) {
				this._draggable = new L.Draggable(icon, icon);
			}
	
			this._draggable
				.on('dragstart', this._onDragStart, this)
				.on('drag', this._onDrag, this)
				.on('dragend', this._onDragEnd, this);
			this._draggable.enable();
			L.DomUtil.addClass(this._marker._icon, 'leaflet-marker-draggable');
		},
	
		removeHooks: function () {
			this._draggable
				.off('dragstart', this._onDragStart, this)
				.off('drag', this._onDrag, this)
				.off('dragend', this._onDragEnd, this);
	
			this._draggable.disable();
			L.DomUtil.removeClass(this._marker._icon, 'leaflet-marker-draggable');
		},
	
		moved: function () {
			return this._draggable && this._draggable._moved;
		},
	
		_onDragStart: function () {
			this._marker
			    .closePopup()
			    .fire('movestart')
			    .fire('dragstart');
		},
	
		_onDrag: function () {
			var marker = this._marker,
			    shadow = marker._shadow,
			    iconPos = L.DomUtil.getPosition(marker._icon),
			    latlng = marker._map.layerPointToLatLng(iconPos);
	
			// update shadow position
			if (shadow) {
				L.DomUtil.setPosition(shadow, iconPos);
			}
	
			marker._latlng = latlng;
	
			marker
			    .fire('move', {latlng: latlng})
			    .fire('drag');
		},
	
		_onDragEnd: function (e) {
			this._marker
			    .fire('moveend')
			    .fire('dragend', e);
		}
	});
	
	
	/*
	 * L.Control is a base class for implementing map controls. Handles positioning.
	 * All other controls extend from this class.
	 */
	
	L.Control = L.Class.extend({
		options: {
			position: 'topright'
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
		},
	
		getPosition: function () {
			return this.options.position;
		},
	
		setPosition: function (position) {
			var map = this._map;
	
			if (map) {
				map.removeControl(this);
			}
	
			this.options.position = position;
	
			if (map) {
				map.addControl(this);
			}
	
			return this;
		},
	
		getContainer: function () {
			return this._container;
		},
	
		addTo: function (map) {
			this._map = map;
	
			var container = this._container = this.onAdd(map),
			    pos = this.getPosition(),
			    corner = map._controlCorners[pos];
	
			L.DomUtil.addClass(container, 'leaflet-control');
	
			if (pos.indexOf('bottom') !== -1) {
				corner.insertBefore(container, corner.firstChild);
			} else {
				corner.appendChild(container);
			}
	
			return this;
		},
	
		removeFrom: function (map) {
			var pos = this.getPosition(),
			    corner = map._controlCorners[pos];
	
			corner.removeChild(this._container);
			this._map = null;
	
			if (this.onRemove) {
				this.onRemove(map);
			}
	
			return this;
		},
	
		_refocusOnMap: function () {
			if (this._map) {
				this._map.getContainer().focus();
			}
		}
	});
	
	L.control = function (options) {
		return new L.Control(options);
	};
	
	
	// adds control-related methods to L.Map
	
	L.Map.include({
		addControl: function (control) {
			control.addTo(this);
			return this;
		},
	
		removeControl: function (control) {
			control.removeFrom(this);
			return this;
		},
	
		_initControlPos: function () {
			var corners = this._controlCorners = {},
			    l = 'leaflet-',
			    container = this._controlContainer =
			            L.DomUtil.create('div', l + 'control-container', this._container);
	
			function createCorner(vSide, hSide) {
				var className = l + vSide + ' ' + l + hSide;
	
				corners[vSide + hSide] = L.DomUtil.create('div', className, container);
			}
	
			createCorner('top', 'left');
			createCorner('top', 'right');
			createCorner('bottom', 'left');
			createCorner('bottom', 'right');
		},
	
		_clearControlPos: function () {
			this._container.removeChild(this._controlContainer);
		}
	});
	
	
	/*
	 * L.Control.Zoom is used for the default zoom buttons on the map.
	 */
	
	L.Control.Zoom = L.Control.extend({
		options: {
			position: 'topleft',
			zoomInText: '+',
			zoomInTitle: 'Zoom in',
			zoomOutText: '-',
			zoomOutTitle: 'Zoom out'
		},
	
		onAdd: function (map) {
			var zoomName = 'leaflet-control-zoom',
			    container = L.DomUtil.create('div', zoomName + ' leaflet-bar');
	
			this._map = map;
	
			this._zoomInButton  = this._createButton(
			        this.options.zoomInText, this.options.zoomInTitle,
			        zoomName + '-in',  container, this._zoomIn,  this);
			this._zoomOutButton = this._createButton(
			        this.options.zoomOutText, this.options.zoomOutTitle,
			        zoomName + '-out', container, this._zoomOut, this);
	
			this._updateDisabled();
			map.on('zoomend zoomlevelschange', this._updateDisabled, this);
	
			return container;
		},
	
		onRemove: function (map) {
			map.off('zoomend zoomlevelschange', this._updateDisabled, this);
		},
	
		_zoomIn: function (e) {
			this._map.zoomIn(e.shiftKey ? 3 : 1);
		},
	
		_zoomOut: function (e) {
			this._map.zoomOut(e.shiftKey ? 3 : 1);
		},
	
		_createButton: function (html, title, className, container, fn, context) {
			var link = L.DomUtil.create('a', className, container);
			link.innerHTML = html;
			link.href = '#';
			link.title = title;
	
			var stop = L.DomEvent.stopPropagation;
	
			L.DomEvent
			    .on(link, 'click', stop)
			    .on(link, 'mousedown', stop)
			    .on(link, 'dblclick', stop)
			    .on(link, 'click', L.DomEvent.preventDefault)
			    .on(link, 'click', fn, context)
			    .on(link, 'click', this._refocusOnMap, context);
	
			return link;
		},
	
		_updateDisabled: function () {
			var map = this._map,
				className = 'leaflet-disabled';
	
			L.DomUtil.removeClass(this._zoomInButton, className);
			L.DomUtil.removeClass(this._zoomOutButton, className);
	
			if (map._zoom === map.getMinZoom()) {
				L.DomUtil.addClass(this._zoomOutButton, className);
			}
			if (map._zoom === map.getMaxZoom()) {
				L.DomUtil.addClass(this._zoomInButton, className);
			}
		}
	});
	
	L.Map.mergeOptions({
		zoomControl: true
	});
	
	L.Map.addInitHook(function () {
		if (this.options.zoomControl) {
			this.zoomControl = new L.Control.Zoom();
			this.addControl(this.zoomControl);
		}
	});
	
	L.control.zoom = function (options) {
		return new L.Control.Zoom(options);
	};
	
	
	
	/*
	 * L.Control.Attribution is used for displaying attribution on the map (added by default).
	 */
	
	L.Control.Attribution = L.Control.extend({
		options: {
			position: 'bottomright',
			prefix: '<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
	
			this._attributions = {};
		},
	
		onAdd: function (map) {
			this._container = L.DomUtil.create('div', 'leaflet-control-attribution');
			L.DomEvent.disableClickPropagation(this._container);
	
			for (var i in map._layers) {
				if (map._layers[i].getAttribution) {
					this.addAttribution(map._layers[i].getAttribution());
				}
			}
			
			map
			    .on('layeradd', this._onLayerAdd, this)
			    .on('layerremove', this._onLayerRemove, this);
	
			this._update();
	
			return this._container;
		},
	
		onRemove: function (map) {
			map
			    .off('layeradd', this._onLayerAdd)
			    .off('layerremove', this._onLayerRemove);
	
		},
	
		setPrefix: function (prefix) {
			this.options.prefix = prefix;
			this._update();
			return this;
		},
	
		addAttribution: function (text) {
			if (!text) { return; }
	
			if (!this._attributions[text]) {
				this._attributions[text] = 0;
			}
			this._attributions[text]++;
	
			this._update();
	
			return this;
		},
	
		removeAttribution: function (text) {
			if (!text) { return; }
	
			if (this._attributions[text]) {
				this._attributions[text]--;
				this._update();
			}
	
			return this;
		},
	
		_update: function () {
			if (!this._map) { return; }
	
			var attribs = [];
	
			for (var i in this._attributions) {
				if (this._attributions[i]) {
					attribs.push(i);
				}
			}
	
			var prefixAndAttribs = [];
	
			if (this.options.prefix) {
				prefixAndAttribs.push(this.options.prefix);
			}
			if (attribs.length) {
				prefixAndAttribs.push(attribs.join(', '));
			}
	
			this._container.innerHTML = prefixAndAttribs.join(' | ');
		},
	
		_onLayerAdd: function (e) {
			if (e.layer.getAttribution) {
				this.addAttribution(e.layer.getAttribution());
			}
		},
	
		_onLayerRemove: function (e) {
			if (e.layer.getAttribution) {
				this.removeAttribution(e.layer.getAttribution());
			}
		}
	});
	
	L.Map.mergeOptions({
		attributionControl: true
	});
	
	L.Map.addInitHook(function () {
		if (this.options.attributionControl) {
			this.attributionControl = (new L.Control.Attribution()).addTo(this);
		}
	});
	
	L.control.attribution = function (options) {
		return new L.Control.Attribution(options);
	};
	
	
	/*
	 * L.Control.Scale is used for displaying metric/imperial scale on the map.
	 */
	
	L.Control.Scale = L.Control.extend({
		options: {
			position: 'bottomleft',
			maxWidth: 100,
			metric: true,
			imperial: true,
			updateWhenIdle: false
		},
	
		onAdd: function (map) {
			this._map = map;
	
			var className = 'leaflet-control-scale',
			    container = L.DomUtil.create('div', className),
			    options = this.options;
	
			this._addScales(options, className, container);
	
			map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
			map.whenReady(this._update, this);
	
			return container;
		},
	
		onRemove: function (map) {
			map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
		},
	
		_addScales: function (options, className, container) {
			if (options.metric) {
				this._mScale = L.DomUtil.create('div', className + '-line', container);
			}
			if (options.imperial) {
				this._iScale = L.DomUtil.create('div', className + '-line', container);
			}
		},
	
		_update: function () {
			var bounds = this._map.getBounds(),
			    centerLat = bounds.getCenter().lat,
			    halfWorldMeters = 6378137 * Math.PI * Math.cos(centerLat * Math.PI / 180),
			    dist = halfWorldMeters * (bounds.getNorthEast().lng - bounds.getSouthWest().lng) / 180,
	
			    size = this._map.getSize(),
			    options = this.options,
			    maxMeters = 0;
	
			if (size.x > 0) {
				maxMeters = dist * (options.maxWidth / size.x);
			}
	
			this._updateScales(options, maxMeters);
		},
	
		_updateScales: function (options, maxMeters) {
			if (options.metric && maxMeters) {
				this._updateMetric(maxMeters);
			}
	
			if (options.imperial && maxMeters) {
				this._updateImperial(maxMeters);
			}
		},
	
		_updateMetric: function (maxMeters) {
			var meters = this._getRoundNum(maxMeters);
	
			this._mScale.style.width = this._getScaleWidth(meters / maxMeters) + 'px';
			this._mScale.innerHTML = meters < 1000 ? meters + ' m' : (meters / 1000) + ' km';
		},
	
		_updateImperial: function (maxMeters) {
			var maxFeet = maxMeters * 3.2808399,
			    scale = this._iScale,
			    maxMiles, miles, feet;
	
			if (maxFeet > 5280) {
				maxMiles = maxFeet / 5280;
				miles = this._getRoundNum(maxMiles);
	
				scale.style.width = this._getScaleWidth(miles / maxMiles) + 'px';
				scale.innerHTML = miles + ' mi';
	
			} else {
				feet = this._getRoundNum(maxFeet);
	
				scale.style.width = this._getScaleWidth(feet / maxFeet) + 'px';
				scale.innerHTML = feet + ' ft';
			}
		},
	
		_getScaleWidth: function (ratio) {
			return Math.round(this.options.maxWidth * ratio) - 10;
		},
	
		_getRoundNum: function (num) {
			var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
			    d = num / pow10;
	
			d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
	
			return pow10 * d;
		}
	});
	
	L.control.scale = function (options) {
		return new L.Control.Scale(options);
	};
	
	
	/*
	 * L.Control.Layers is a control to allow users to switch between different layers on the map.
	 */
	
	L.Control.Layers = L.Control.extend({
		options: {
			collapsed: true,
			position: 'topright',
			autoZIndex: true
		},
	
		initialize: function (baseLayers, overlays, options) {
			L.setOptions(this, options);
	
			this._layers = {};
			this._lastZIndex = 0;
			this._handlingClick = false;
	
			for (var i in baseLayers) {
				this._addLayer(baseLayers[i], i);
			}
	
			for (i in overlays) {
				this._addLayer(overlays[i], i, true);
			}
		},
	
		onAdd: function (map) {
			this._initLayout();
			this._update();
	
			map
			    .on('layeradd', this._onLayerChange, this)
			    .on('layerremove', this._onLayerChange, this);
	
			return this._container;
		},
	
		onRemove: function (map) {
			map
			    .off('layeradd', this._onLayerChange, this)
			    .off('layerremove', this._onLayerChange, this);
		},
	
		addBaseLayer: function (layer, name) {
			this._addLayer(layer, name);
			this._update();
			return this;
		},
	
		addOverlay: function (layer, name) {
			this._addLayer(layer, name, true);
			this._update();
			return this;
		},
	
		removeLayer: function (layer) {
			var id = L.stamp(layer);
			delete this._layers[id];
			this._update();
			return this;
		},
	
		_initLayout: function () {
			var className = 'leaflet-control-layers',
			    container = this._container = L.DomUtil.create('div', className);
	
			//Makes this work on IE10 Touch devices by stopping it from firing a mouseout event when the touch is released
			container.setAttribute('aria-haspopup', true);
	
			if (!L.Browser.touch) {
				L.DomEvent
					.disableClickPropagation(container)
					.disableScrollPropagation(container);
			} else {
				L.DomEvent.on(container, 'click', L.DomEvent.stopPropagation);
			}
	
			var form = this._form = L.DomUtil.create('form', className + '-list');
	
			if (this.options.collapsed) {
				if (!L.Browser.android) {
					L.DomEvent
					    .on(container, 'mouseover', this._expand, this)
					    .on(container, 'mouseout', this._collapse, this);
				}
				var link = this._layersLink = L.DomUtil.create('a', className + '-toggle', container);
				link.href = '#';
				link.title = 'Layers';
	
				if (L.Browser.touch) {
					L.DomEvent
					    .on(link, 'click', L.DomEvent.stop)
					    .on(link, 'click', this._expand, this);
				}
				else {
					L.DomEvent.on(link, 'focus', this._expand, this);
				}
				//Work around for Firefox android issue https://github.com/Leaflet/Leaflet/issues/2033
				L.DomEvent.on(form, 'click', function () {
					setTimeout(L.bind(this._onInputClick, this), 0);
				}, this);
	
				this._map.on('click', this._collapse, this);
				// TODO keyboard accessibility
			} else {
				this._expand();
			}
	
			this._baseLayersList = L.DomUtil.create('div', className + '-base', form);
			this._separator = L.DomUtil.create('div', className + '-separator', form);
			this._overlaysList = L.DomUtil.create('div', className + '-overlays', form);
	
			container.appendChild(form);
		},
	
		_addLayer: function (layer, name, overlay) {
			var id = L.stamp(layer);
	
			this._layers[id] = {
				layer: layer,
				name: name,
				overlay: overlay
			};
	
			if (this.options.autoZIndex && layer.setZIndex) {
				this._lastZIndex++;
				layer.setZIndex(this._lastZIndex);
			}
		},
	
		_update: function () {
			if (!this._container) {
				return;
			}
	
			this._baseLayersList.innerHTML = '';
			this._overlaysList.innerHTML = '';
	
			var baseLayersPresent = false,
			    overlaysPresent = false,
			    i, obj;
	
			for (i in this._layers) {
				obj = this._layers[i];
				this._addItem(obj);
				overlaysPresent = overlaysPresent || obj.overlay;
				baseLayersPresent = baseLayersPresent || !obj.overlay;
			}
	
			this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
		},
	
		_onLayerChange: function (e) {
			var obj = this._layers[L.stamp(e.layer)];
	
			if (!obj) { return; }
	
			if (!this._handlingClick) {
				this._update();
			}
	
			var type = obj.overlay ?
				(e.type === 'layeradd' ? 'overlayadd' : 'overlayremove') :
				(e.type === 'layeradd' ? 'baselayerchange' : null);
	
			if (type) {
				this._map.fire(type, obj);
			}
		},
	
		// IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
		_createRadioElement: function (name, checked) {
	
			var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"';
			if (checked) {
				radioHtml += ' checked="checked"';
			}
			radioHtml += '/>';
	
			var radioFragment = document.createElement('div');
			radioFragment.innerHTML = radioHtml;
	
			return radioFragment.firstChild;
		},
	
		_addItem: function (obj) {
			var label = document.createElement('label'),
			    input,
			    checked = this._map.hasLayer(obj.layer);
	
			if (obj.overlay) {
				input = document.createElement('input');
				input.type = 'checkbox';
				input.className = 'leaflet-control-layers-selector';
				input.defaultChecked = checked;
			} else {
				input = this._createRadioElement('leaflet-base-layers', checked);
			}
	
			input.layerId = L.stamp(obj.layer);
	
			L.DomEvent.on(input, 'click', this._onInputClick, this);
	
			var name = document.createElement('span');
			name.innerHTML = ' ' + obj.name;
	
			label.appendChild(input);
			label.appendChild(name);
	
			var container = obj.overlay ? this._overlaysList : this._baseLayersList;
			container.appendChild(label);
	
			return label;
		},
	
		_onInputClick: function () {
			var i, input, obj,
			    inputs = this._form.getElementsByTagName('input'),
			    inputsLen = inputs.length;
	
			this._handlingClick = true;
	
			for (i = 0; i < inputsLen; i++) {
				input = inputs[i];
				obj = this._layers[input.layerId];
	
				if (input.checked && !this._map.hasLayer(obj.layer)) {
					this._map.addLayer(obj.layer);
	
				} else if (!input.checked && this._map.hasLayer(obj.layer)) {
					this._map.removeLayer(obj.layer);
				}
			}
	
			this._handlingClick = false;
	
			this._refocusOnMap();
		},
	
		_expand: function () {
			L.DomUtil.addClass(this._container, 'leaflet-control-layers-expanded');
		},
	
		_collapse: function () {
			this._container.className = this._container.className.replace(' leaflet-control-layers-expanded', '');
		}
	});
	
	L.control.layers = function (baseLayers, overlays, options) {
		return new L.Control.Layers(baseLayers, overlays, options);
	};
	
	
	/*
	 * L.PosAnimation is used by Leaflet internally for pan animations.
	 */
	
	L.PosAnimation = L.Class.extend({
		includes: L.Mixin.Events,
	
		run: function (el, newPos, duration, easeLinearity) { // (HTMLElement, Point[, Number, Number])
			this.stop();
	
			this._el = el;
			this._inProgress = true;
			this._newPos = newPos;
	
			this.fire('start');
	
			el.style[L.DomUtil.TRANSITION] = 'all ' + (duration || 0.25) +
			        's cubic-bezier(0,0,' + (easeLinearity || 0.5) + ',1)';
	
			L.DomEvent.on(el, L.DomUtil.TRANSITION_END, this._onTransitionEnd, this);
			L.DomUtil.setPosition(el, newPos);
	
			// toggle reflow, Chrome flickers for some reason if you don't do this
			L.Util.falseFn(el.offsetWidth);
	
			// there's no native way to track value updates of transitioned properties, so we imitate this
			this._stepTimer = setInterval(L.bind(this._onStep, this), 50);
		},
	
		stop: function () {
			if (!this._inProgress) { return; }
	
			// if we just removed the transition property, the element would jump to its final position,
			// so we need to make it stay at the current position
	
			L.DomUtil.setPosition(this._el, this._getPos());
			this._onTransitionEnd();
			L.Util.falseFn(this._el.offsetWidth); // force reflow in case we are about to start a new animation
		},
	
		_onStep: function () {
			var stepPos = this._getPos();
			if (!stepPos) {
				this._onTransitionEnd();
				return;
			}
			// jshint camelcase: false
			// make L.DomUtil.getPosition return intermediate position value during animation
			this._el._leaflet_pos = stepPos;
	
			this.fire('step');
		},
	
		// you can't easily get intermediate values of properties animated with CSS3 Transitions,
		// we need to parse computed style (in case of transform it returns matrix string)
	
		_transformRe: /([-+]?(?:\d*\.)?\d+)\D*, ([-+]?(?:\d*\.)?\d+)\D*\)/,
	
		_getPos: function () {
			var left, top, matches,
			    el = this._el,
			    style = window.getComputedStyle(el);
	
			if (L.Browser.any3d) {
				matches = style[L.DomUtil.TRANSFORM].match(this._transformRe);
				if (!matches) { return; }
				left = parseFloat(matches[1]);
				top  = parseFloat(matches[2]);
			} else {
				left = parseFloat(style.left);
				top  = parseFloat(style.top);
			}
	
			return new L.Point(left, top, true);
		},
	
		_onTransitionEnd: function () {
			L.DomEvent.off(this._el, L.DomUtil.TRANSITION_END, this._onTransitionEnd, this);
	
			if (!this._inProgress) { return; }
			this._inProgress = false;
	
			this._el.style[L.DomUtil.TRANSITION] = '';
	
			// jshint camelcase: false
			// make sure L.DomUtil.getPosition returns the final position value after animation
			this._el._leaflet_pos = this._newPos;
	
			clearInterval(this._stepTimer);
	
			this.fire('step').fire('end');
		}
	
	});
	
	
	/*
	 * Extends L.Map to handle panning animations.
	 */
	
	L.Map.include({
	
		setView: function (center, zoom, options) {
	
			zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
			center = this._limitCenter(L.latLng(center), zoom, this.options.maxBounds);
			options = options || {};
	
			if (this._panAnim) {
				this._panAnim.stop();
			}
	
			if (this._loaded && !options.reset && options !== true) {
	
				if (options.animate !== undefined) {
					options.zoom = L.extend({animate: options.animate}, options.zoom);
					options.pan = L.extend({animate: options.animate}, options.pan);
				}
	
				// try animating pan or zoom
				var animated = (this._zoom !== zoom) ?
					this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) :
					this._tryAnimatedPan(center, options.pan);
	
				if (animated) {
					// prevent resize handler call, the view will refresh after animation anyway
					clearTimeout(this._sizeTimer);
					return this;
				}
			}
	
			// animation didn't start, just reset the map view
			this._resetView(center, zoom);
	
			return this;
		},
	
		panBy: function (offset, options) {
			offset = L.point(offset).round();
			options = options || {};
	
			if (!offset.x && !offset.y) {
				return this;
			}
	
			if (!this._panAnim) {
				this._panAnim = new L.PosAnimation();
	
				this._panAnim.on({
					'step': this._onPanTransitionStep,
					'end': this._onPanTransitionEnd
				}, this);
			}
	
			// don't fire movestart if animating inertia
			if (!options.noMoveStart) {
				this.fire('movestart');
			}
	
			// animate pan unless animate: false specified
			if (options.animate !== false) {
				L.DomUtil.addClass(this._mapPane, 'leaflet-pan-anim');
	
				var newPos = this._getMapPanePos().subtract(offset);
				this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
			} else {
				this._rawPanBy(offset);
				this.fire('move').fire('moveend');
			}
	
			return this;
		},
	
		_onPanTransitionStep: function () {
			this.fire('move');
		},
	
		_onPanTransitionEnd: function () {
			L.DomUtil.removeClass(this._mapPane, 'leaflet-pan-anim');
			this.fire('moveend');
		},
	
		_tryAnimatedPan: function (center, options) {
			// difference between the new and current centers in pixels
			var offset = this._getCenterOffset(center)._floor();
	
			// don't animate too far unless animate: true specified in options
			if ((options && options.animate) !== true && !this.getSize().contains(offset)) { return false; }
	
			this.panBy(offset, options);
	
			return true;
		}
	});
	
	
	/*
	 * L.PosAnimation fallback implementation that powers Leaflet pan animations
	 * in browsers that don't support CSS3 Transitions.
	 */
	
	L.PosAnimation = L.DomUtil.TRANSITION ? L.PosAnimation : L.PosAnimation.extend({
	
		run: function (el, newPos, duration, easeLinearity) { // (HTMLElement, Point[, Number, Number])
			this.stop();
	
			this._el = el;
			this._inProgress = true;
			this._duration = duration || 0.25;
			this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
	
			this._startPos = L.DomUtil.getPosition(el);
			this._offset = newPos.subtract(this._startPos);
			this._startTime = +new Date();
	
			this.fire('start');
	
			this._animate();
		},
	
		stop: function () {
			if (!this._inProgress) { return; }
	
			this._step();
			this._complete();
		},
	
		_animate: function () {
			// animation loop
			this._animId = L.Util.requestAnimFrame(this._animate, this);
			this._step();
		},
	
		_step: function () {
			var elapsed = (+new Date()) - this._startTime,
			    duration = this._duration * 1000;
	
			if (elapsed < duration) {
				this._runFrame(this._easeOut(elapsed / duration));
			} else {
				this._runFrame(1);
				this._complete();
			}
		},
	
		_runFrame: function (progress) {
			var pos = this._startPos.add(this._offset.multiplyBy(progress));
			L.DomUtil.setPosition(this._el, pos);
	
			this.fire('step');
		},
	
		_complete: function () {
			L.Util.cancelAnimFrame(this._animId);
	
			this._inProgress = false;
			this.fire('end');
		},
	
		_easeOut: function (t) {
			return 1 - Math.pow(1 - t, this._easeOutPower);
		}
	});
	
	
	/*
	 * Extends L.Map to handle zoom animations.
	 */
	
	L.Map.mergeOptions({
		zoomAnimation: true,
		zoomAnimationThreshold: 4
	});
	
	if (L.DomUtil.TRANSITION) {
	
		L.Map.addInitHook(function () {
			// don't animate on browsers without hardware-accelerated transitions or old Android/Opera
			this._zoomAnimated = this.options.zoomAnimation && L.DomUtil.TRANSITION &&
					L.Browser.any3d && !L.Browser.android23 && !L.Browser.mobileOpera;
	
			// zoom transitions run with the same duration for all layers, so if one of transitionend events
			// happens after starting zoom animation (propagating to the map pane), we know that it ended globally
			if (this._zoomAnimated) {
				L.DomEvent.on(this._mapPane, L.DomUtil.TRANSITION_END, this._catchTransitionEnd, this);
			}
		});
	}
	
	L.Map.include(!L.DomUtil.TRANSITION ? {} : {
	
		_catchTransitionEnd: function (e) {
			if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) {
				this._onZoomTransitionEnd();
			}
		},
	
		_nothingToAnimate: function () {
			return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
		},
	
		_tryAnimatedZoom: function (center, zoom, options) {
	
			if (this._animatingZoom) { return true; }
	
			options = options || {};
	
			// don't animate if disabled, not supported or zoom difference is too large
			if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() ||
			        Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) { return false; }
	
			// offset is the pixel coords of the zoom origin relative to the current center
			var scale = this.getZoomScale(zoom),
			    offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale),
				origin = this._getCenterLayerPoint()._add(offset);
	
			// don't animate if the zoom origin isn't within one screen from the current center, unless forced
			if (options.animate !== true && !this.getSize().contains(offset)) { return false; }
	
			this
			    .fire('movestart')
			    .fire('zoomstart');
	
			this._animateZoom(center, zoom, origin, scale, null, true);
	
			return true;
		},
	
		_animateZoom: function (center, zoom, origin, scale, delta, backwards, forTouchZoom) {
	
			if (!forTouchZoom) {
				this._animatingZoom = true;
			}
	
			// put transform transition on all layers with leaflet-zoom-animated class
			L.DomUtil.addClass(this._mapPane, 'leaflet-zoom-anim');
	
			// remember what center/zoom to set after animation
			this._animateToCenter = center;
			this._animateToZoom = zoom;
	
			// disable any dragging during animation
			if (L.Draggable) {
				L.Draggable._disabled = true;
			}
	
			L.Util.requestAnimFrame(function () {
				this.fire('zoomanim', {
					center: center,
					zoom: zoom,
					origin: origin,
					scale: scale,
					delta: delta,
					backwards: backwards
				});
				// horrible hack to work around a Chrome bug https://github.com/Leaflet/Leaflet/issues/3689
				setTimeout(L.bind(this._onZoomTransitionEnd, this), 250);
			}, this);
		},
	
		_onZoomTransitionEnd: function () {
			if (!this._animatingZoom) { return; }
	
			this._animatingZoom = false;
	
			L.DomUtil.removeClass(this._mapPane, 'leaflet-zoom-anim');
	
			L.Util.requestAnimFrame(function () {
				this._resetView(this._animateToCenter, this._animateToZoom, true, true);
	
				if (L.Draggable) {
					L.Draggable._disabled = false;
				}
			}, this);
		}
	});
	
	
	/*
		Zoom animation logic for L.TileLayer.
	*/
	
	L.TileLayer.include({
		_animateZoom: function (e) {
			if (!this._animating) {
				this._animating = true;
				this._prepareBgBuffer();
			}
	
			var bg = this._bgBuffer,
			    transform = L.DomUtil.TRANSFORM,
			    initialTransform = e.delta ? L.DomUtil.getTranslateString(e.delta) : bg.style[transform],
			    scaleStr = L.DomUtil.getScaleString(e.scale, e.origin);
	
			bg.style[transform] = e.backwards ?
					scaleStr + ' ' + initialTransform :
					initialTransform + ' ' + scaleStr;
		},
	
		_endZoomAnim: function () {
			var front = this._tileContainer,
			    bg = this._bgBuffer;
	
			front.style.visibility = '';
			front.parentNode.appendChild(front); // Bring to fore
	
			// force reflow
			L.Util.falseFn(bg.offsetWidth);
	
			var zoom = this._map.getZoom();
			if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
				this._clearBgBuffer();
			}
	
			this._animating = false;
		},
	
		_clearBgBuffer: function () {
			var map = this._map;
	
			if (map && !map._animatingZoom && !map.touchZoom._zooming) {
				this._bgBuffer.innerHTML = '';
				this._bgBuffer.style[L.DomUtil.TRANSFORM] = '';
			}
		},
	
		_prepareBgBuffer: function () {
	
			var front = this._tileContainer,
			    bg = this._bgBuffer;
	
			// if foreground layer doesn't have many tiles but bg layer does,
			// keep the existing bg layer and just zoom it some more
	
			var bgLoaded = this._getLoadedTilesPercentage(bg),
			    frontLoaded = this._getLoadedTilesPercentage(front);
	
			if (bg && bgLoaded > 0.5 && frontLoaded < 0.5) {
	
				front.style.visibility = 'hidden';
				this._stopLoadingImages(front);
				return;
			}
	
			// prepare the buffer to become the front tile pane
			bg.style.visibility = 'hidden';
			bg.style[L.DomUtil.TRANSFORM] = '';
	
			// switch out the current layer to be the new bg layer (and vice-versa)
			this._tileContainer = bg;
			bg = this._bgBuffer = front;
	
			this._stopLoadingImages(bg);
	
			//prevent bg buffer from clearing right after zoom
			clearTimeout(this._clearBgBufferTimer);
		},
	
		_getLoadedTilesPercentage: function (container) {
			var tiles = container.getElementsByTagName('img'),
			    i, len, count = 0;
	
			for (i = 0, len = tiles.length; i < len; i++) {
				if (tiles[i].complete) {
					count++;
				}
			}
			return count / len;
		},
	
		// stops loading all tiles in the background layer
		_stopLoadingImages: function (container) {
			var tiles = Array.prototype.slice.call(container.getElementsByTagName('img')),
			    i, len, tile;
	
			for (i = 0, len = tiles.length; i < len; i++) {
				tile = tiles[i];
	
				if (!tile.complete) {
					tile.onload = L.Util.falseFn;
					tile.onerror = L.Util.falseFn;
					tile.src = L.Util.emptyImageUrl;
	
					tile.parentNode.removeChild(tile);
				}
			}
		}
	});
	
	
	/*
	 * Provides L.Map with convenient shortcuts for using browser geolocation features.
	 */
	
	L.Map.include({
		_defaultLocateOptions: {
			watch: false,
			setView: false,
			maxZoom: Infinity,
			timeout: 10000,
			maximumAge: 0,
			enableHighAccuracy: false
		},
	
		locate: function (/*Object*/ options) {
	
			options = this._locateOptions = L.extend(this._defaultLocateOptions, options);
	
			if (!navigator.geolocation) {
				this._handleGeolocationError({
					code: 0,
					message: 'Geolocation not supported.'
				});
				return this;
			}
	
			var onResponse = L.bind(this._handleGeolocationResponse, this),
				onError = L.bind(this._handleGeolocationError, this);
	
			if (options.watch) {
				this._locationWatchId =
				        navigator.geolocation.watchPosition(onResponse, onError, options);
			} else {
				navigator.geolocation.getCurrentPosition(onResponse, onError, options);
			}
			return this;
		},
	
		stopLocate: function () {
			if (navigator.geolocation) {
				navigator.geolocation.clearWatch(this._locationWatchId);
			}
			if (this._locateOptions) {
				this._locateOptions.setView = false;
			}
			return this;
		},
	
		_handleGeolocationError: function (error) {
			var c = error.code,
			    message = error.message ||
			            (c === 1 ? 'permission denied' :
			            (c === 2 ? 'position unavailable' : 'timeout'));
	
			if (this._locateOptions.setView && !this._loaded) {
				this.fitWorld();
			}
	
			this.fire('locationerror', {
				code: c,
				message: 'Geolocation error: ' + message + '.'
			});
		},
	
		_handleGeolocationResponse: function (pos) {
			var lat = pos.coords.latitude,
			    lng = pos.coords.longitude,
			    latlng = new L.LatLng(lat, lng),
	
			    latAccuracy = 180 * pos.coords.accuracy / 40075017,
			    lngAccuracy = latAccuracy / Math.cos(L.LatLng.DEG_TO_RAD * lat),
	
			    bounds = L.latLngBounds(
			            [lat - latAccuracy, lng - lngAccuracy],
			            [lat + latAccuracy, lng + lngAccuracy]),
	
			    options = this._locateOptions;
	
			if (options.setView) {
				var zoom = Math.min(this.getBoundsZoom(bounds), options.maxZoom);
				this.setView(latlng, zoom);
			}
	
			var data = {
				latlng: latlng,
				bounds: bounds,
				timestamp: pos.timestamp
			};
	
			for (var i in pos.coords) {
				if (typeof pos.coords[i] === 'number') {
					data[i] = pos.coords[i];
				}
			}
	
			this.fire('locationfound', data);
		}
	});
	
	
	}(window, document));

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var geocoderControl = __webpack_require__(938),
	    gridControl = __webpack_require__(948),
	    featureLayer = __webpack_require__(952),
	    legendControl = __webpack_require__(955),
	    shareControl = __webpack_require__(956),
	    tileLayer = __webpack_require__(958),
	    infoControl = __webpack_require__(959),
	    map = __webpack_require__(960),
	    gridLayer = __webpack_require__(961),
	    styleLayer = __webpack_require__(964);
	
	L.mapbox = module.exports = {
	    VERSION: __webpack_require__(944).version,
	    geocoder: __webpack_require__(939),
	    marker: __webpack_require__(953),
	    simplestyle: __webpack_require__(954),
	    tileLayer: tileLayer.tileLayer,
	    TileLayer: tileLayer.TileLayer,
	    styleLayer: styleLayer.styleLayer,
	    StyleLayer: styleLayer.StyleLayer,
	    infoControl: infoControl.infoControl,
	    InfoControl: infoControl.InfoControl,
	    shareControl: shareControl.shareControl,
	    ShareControl: shareControl.ShareControl,
	    legendControl: legendControl.legendControl,
	    LegendControl: legendControl.LegendControl,
	    geocoderControl: geocoderControl.geocoderControl,
	    GeocoderControl: geocoderControl.GeocoderControl,
	    gridControl: gridControl.gridControl,
	    GridControl: gridControl.GridControl,
	    gridLayer: gridLayer.gridLayer,
	    GridLayer: gridLayer.GridLayer,
	    featureLayer: featureLayer.featureLayer,
	    FeatureLayer: featureLayer.FeatureLayer,
	    map: map.map,
	    Map: map.Map,
	    config: __webpack_require__(943),
	    sanitize: __webpack_require__(950),
	    template: __webpack_require__(949).to_html,
	    feedback: __webpack_require__(945)
	};
	
	
	// Hardcode image path, because Leaflet's autodetection
	// fails, because mapbox.js is not named leaflet.js
	window.L.Icon.Default.imagePath =
	    // Detect bad-news protocols like file:// and hardcode
	    // to https if they're detected.
	    ((document.location.protocol === 'https:' ||
	    document.location.protocol === 'http:') ? '' : 'https:') +
	    '//api.tiles.mapbox.com/mapbox.js/' + 'v' +
	    __webpack_require__(944).version + '/images';


/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var geocoder = __webpack_require__(939),
	    util = __webpack_require__(941);
	
	var GeocoderControl = L.Control.extend({
	    includes: L.Mixin.Events,
	
	    options: {
	        proximity: true,
	        position: 'topleft',
	        pointZoom: 16,
	        keepOpen: false,
	        autocomplete: false,
	        queryOptions: {}
	    },
	
	    initialize: function(_, options) {
	        L.Util.setOptions(this, options);
	        this.setURL(_);
	        this._updateSubmit = L.bind(this._updateSubmit, this);
	        this._updateAutocomplete = L.bind(this._updateAutocomplete, this);
	        this._chooseResult = L.bind(this._chooseResult, this);
	    },
	
	    setURL: function(_) {
	        this.geocoder = geocoder(_, {
	            accessToken: this.options.accessToken
	        });
	        return this;
	    },
	
	    getURL: function() {
	        return this.geocoder.getURL();
	    },
	
	    setID: function(_) {
	        return this.setURL(_);
	    },
	
	    setTileJSON: function(_) {
	        return this.setURL(_.geocoder);
	    },
	
	    _toggle: function(e) {
	        if (e) L.DomEvent.stop(e);
	        if (L.DomUtil.hasClass(this._container, 'active')) {
	            L.DomUtil.removeClass(this._container, 'active');
	            this._results.innerHTML = '';
	            this._input.blur();
	        } else {
	            L.DomUtil.addClass(this._container, 'active');
	            this._input.focus();
	            this._input.select();
	        }
	    },
	
	    _closeIfOpen: function() {
	        if (L.DomUtil.hasClass(this._container, 'active') &&
	            !this.options.keepOpen) {
	            L.DomUtil.removeClass(this._container, 'active');
	            this._results.innerHTML = '';
	            this._input.blur();
	        }
	    },
	
	    onAdd: function(map) {
	
	        var container = L.DomUtil.create('div', 'leaflet-control-mapbox-geocoder leaflet-bar leaflet-control'),
	            link = L.DomUtil.create('a', 'leaflet-control-mapbox-geocoder-toggle mapbox-icon mapbox-icon-geocoder', container),
	            results = L.DomUtil.create('div', 'leaflet-control-mapbox-geocoder-results', container),
	            wrap = L.DomUtil.create('div', 'leaflet-control-mapbox-geocoder-wrap', container),
	            form = L.DomUtil.create('form', 'leaflet-control-mapbox-geocoder-form', wrap),
	            input = L.DomUtil.create('input', '', form);
	
	        link.href = '#';
	        link.innerHTML = '&nbsp;';
	
	        input.type = 'text';
	        input.setAttribute('placeholder', 'Search');
	
	        L.DomEvent.addListener(form, 'submit', this._geocode, this);
	        L.DomEvent.addListener(input, 'keyup', this._autocomplete, this);
	        L.DomEvent.disableClickPropagation(container);
	
	        this._map = map;
	        this._results = results;
	        this._input = input;
	        this._form = form;
	
	        if (this.options.keepOpen) {
	            L.DomUtil.addClass(container, 'active');
	        } else {
	            this._map.on('click', this._closeIfOpen, this);
	            L.DomEvent.addListener(link, 'click', this._toggle, this);
	        }
	
	        return container;
	    },
	
	    _updateSubmit: function(err, resp) {
	        L.DomUtil.removeClass(this._container, 'searching');
	        this._results.innerHTML = '';
	        if (err || !resp) {
	            this.fire('error', {error: err});
	        } else {
	            var features = [];
	            if (resp.results && resp.results.features) {
	                features = resp.results.features;
	            }
	            if (features.length === 1) {
	                this.fire('autoselect', { feature: features[0] });
	                this.fire('found', {results: resp.results});
	                this._chooseResult(features[0]);
	                this._closeIfOpen();
	            } else if (features.length > 1) {
	                this.fire('found', {results: resp.results});
	                this._displayResults(features);
	            } else {
	                this.fire('notfound');
	                this._displayResults(features);
	            }
	        }
	    },
	
	    _updateAutocomplete: function(err, resp) {
	        this._results.innerHTML = '';
	        if (err || !resp) {
	            this.fire('error', {error: err});
	        } else {
	            var features = [];
	            if (resp.results && resp.results.features) {
	                features = resp.results.features;
	            }
	            if (features.length) {
	                this.fire('found', {results: resp.results});
	            } else {
	                this.fire('notfound');
	            }
	            this._displayResults(features);
	        }
	    },
	
	    _displayResults: function(features) {
	        for (var i = 0, l = Math.min(features.length, 5); i < l; i++) {
	            var feature = features[i];
	            var name = feature.place_name;
	            if (!name.length) continue;
	
	            var r = L.DomUtil.create('a', '', this._results);
	            var text = ('innerText' in r) ? 'innerText' : 'textContent';
	            r[text] = name;
	            r.setAttribute('title', name);
	            r.href = '#';
	
	            (L.bind(function(feature) {
	                L.DomEvent.addListener(r, 'click', function(e) {
	                    this._chooseResult(feature);
	                    L.DomEvent.stop(e);
	                    this.fire('select', { feature: feature });
	                }, this);
	            }, this))(feature);
	        }
	        if (features.length > 5) {
	            var outof = L.DomUtil.create('span', '', this._results);
	            outof.innerHTML = 'Top 5 of ' + features.length + '  results';
	        }
	    },
	
	    _chooseResult: function(result) {
	        if (result.bbox) {
	            this._map.fitBounds(util.lbounds(result.bbox));
	        } else if (result.center) {
	            this._map.setView([result.center[1], result.center[0]], (this._map.getZoom() === undefined) ?
	                this.options.pointZoom :
	                Math.max(this._map.getZoom(), this.options.pointZoom));
	        }
	    },
	
	    _geocode: function(e) {
	        L.DomEvent.preventDefault(e);
	        if (this._input.value === '') return this._updateSubmit();
	        L.DomUtil.addClass(this._container, 'searching');
	        this.geocoder.query(L.Util.extend({
	            query: this._input.value,
	            proximity: this.options.proximity ? this._map.getCenter() : false
	        }, this.options.queryOptions), this._updateSubmit);
	    },
	
	    _autocomplete: function() {
	        if (!this.options.autocomplete) return;
	        if (this._input.value === '') return this._updateAutocomplete();
	        this.geocoder.query(L.Util.extend({
	            query: this._input.value,
	            proximity: this.options.proximity ? this._map.getCenter() : false
	        }, this.options.queryOptions), this._updateAutocomplete);
	    }
	});
	
	module.exports.GeocoderControl = GeocoderControl;
	
	module.exports.geocoderControl = function(_, options) {
	    return new GeocoderControl(_, options);
	};


/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isArray = __webpack_require__(940),
	    util = __webpack_require__(941),
	    format_url = __webpack_require__(942),
	    feedback = __webpack_require__(945),
	    request = __webpack_require__(946);
	
	// Low-level geocoding interface - wraps specific API calls and their
	// return values.
	module.exports = function(url, options) {
	    if (!options) options = {};
	    var geocoder = {};
	
	    util.strict(url, 'string');
	
	    if (url.indexOf('/') === -1) {
	        url = format_url('/geocoding/v5/' + url + '/{query}.json', options.accessToken, 5);
	    }
	
	    function roundTo(latLng, precision) {
	        var mult = Math.pow(10, precision);
	        latLng.lat = Math.round(latLng.lat * mult) / mult;
	        latLng.lng = Math.round(latLng.lng * mult) / mult;
	        return latLng;
	    }
	
	    geocoder.getURL = function() {
	        return url;
	    };
	
	    geocoder.queryURL = function(_) {
	        var isObject = !(isArray(_) || typeof _ === 'string'),
	            query = isObject ? _.query : _;
	
	        if (isArray(query)) {
	            var parts = [];
	            for (var i = 0; i < query.length; i++) {
	                parts[i] = encodeURIComponent(query[i]);
	            }
	            query = parts.join(';');
	        } else {
	            query = encodeURIComponent(query);
	        }
	
	        feedback.record({ geocoding: query });
	
	        var url = L.Util.template(geocoder.getURL(), {query: query});
	
	        if (isObject) {
	            if (_.types) {
	                if (isArray(_.types)) {
	                    url += '&types=' + _.types.join();
	                } else {
	                    url += '&types=' + _.types;
	                }
	            }
	
	            if (_.country) {
	                if (isArray(_.country)) {
	                    url += '&country=' + _.country.join();
	                } else {
	                    url += '&country=' + _.country;
	                }
	            }
	
	            if (_.proximity) {
	                var proximity = roundTo(L.latLng(_.proximity), 3);
	                url += '&proximity=' + proximity.lng + ',' + proximity.lat;
	            }
	
	            if (typeof _.autocomplete === 'boolean') {
	                url += '&autocomplete=' + _.autocomplete;
	            }
	        }
	
	        return url;
	    };
	
	    geocoder.query = function(_, callback) {
	        util.strict(callback, 'function');
	
	        request(geocoder.queryURL(_), function(err, json) {
	            if (json && (json.length || json.features)) {
	                var res = {
	                    results: json
	                };
	                if (json.features && json.features.length) {
	                    res.latlng = [
	                        json.features[0].center[1],
	                        json.features[0].center[0]];
	
	                    if (json.features[0].bbox) {
	                        res.bounds = json.features[0].bbox;
	                        res.lbounds = util.lbounds(res.bounds);
	                    }
	                }
	                callback(null, res);
	            } else callback(err || true);
	        });
	
	        return geocoder;
	    };
	
	    // a reverse geocode:
	    //
	    //  geocoder.reverseQuery([80, 20])
	    geocoder.reverseQuery = function(_, callback) {
	        var q = '';
	
	        // sort through different ways people represent lat and lon pairs
	        function normalize(x) {
	            var latLng;
	            if (x.lat !== undefined && x.lng !== undefined) {
	                latLng = L.latLng(x.lat, x.lng);
	            } else if (x.lat !== undefined && x.lon !== undefined) {
	                latLng = L.latLng(x.lat, x.lon);
	            } else {
	                latLng = L.latLng(x[1], x[0]);
	            }
	            latLng = roundTo(latLng, 5);
	            return latLng.lng + ',' + latLng.lat;
	        }
	
	        if (_.length && _[0].length) {
	            for (var i = 0, pts = []; i < _.length; i++) {
	                pts.push(normalize(_[i]));
	            }
	            q = pts.join(';');
	        } else {
	            q = normalize(_);
	        }
	
	        request(geocoder.queryURL(q), function(err, json) {
	            callback(err, json);
	        });
	
	        return geocoder;
	    };
	
	    return geocoder;
	};


/***/ },
/* 940 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 941 */
/***/ function(module, exports) {

	'use strict';
	
	function contains(item, list) {
	    if (!list || !list.length) return false;
	    for (var i = 0; i < list.length; i++) {
	        if (list[i] === item) return true;
	    }
	    return false;
	}
	
	module.exports = {
	    idUrl: function(_, t) {
	        if (_.indexOf('/') === -1) t.loadID(_);
	        else t.loadURL(_);
	    },
	    log: function(_) {
	        if (typeof console === 'object' &&
	            typeof console.error === 'function') {
	            console.error(_);
	        }
	    },
	    strict: function(_, type) {
	        if (typeof _ !== type) {
	            throw new Error('Invalid argument: ' + type + ' expected');
	        }
	    },
	    strict_instance: function(_, klass, name) {
	        if (!(_ instanceof klass)) {
	            throw new Error('Invalid argument: ' + name + ' expected');
	        }
	    },
	    strict_oneof: function(_, values) {
	        if (!contains(_, values)) {
	            throw new Error('Invalid argument: ' + _ + ' given, valid values are ' +
	                values.join(', '));
	        }
	    },
	    strip_tags: function(_) {
	        return _.replace(/<[^<]+>/g, '');
	    },
	    lbounds: function(_) {
	        // leaflet-compatible bounds, since leaflet does not do geojson
	        return new L.LatLngBounds([[_[1], _[0]], [_[3], _[2]]]);
	    }
	};


/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var config = __webpack_require__(943),
	    version = __webpack_require__(944).version;
	
	module.exports = function(path, accessToken) {
	    accessToken = accessToken || L.mapbox.accessToken;
	
	    if (!accessToken && config.REQUIRE_ACCESS_TOKEN) {
	        throw new Error('An API access token is required to use Mapbox.js. ' +
	            'See https://www.mapbox.com/mapbox.js/api/v' + version + '/api-access-tokens/');
	    }
	
	    var url = (document.location.protocol === 'https:' || config.FORCE_HTTPS) ? config.HTTPS_URL : config.HTTP_URL;
	    url = url.replace(/\/v4$/, '');
	    url += path;
	
	    if (config.REQUIRE_ACCESS_TOKEN) {
	        if (accessToken[0] === 's') {
	            throw new Error('Use a public access token (pk.*) with Mapbox.js, not a secret access token (sk.*). ' +
	                'See https://www.mapbox.com/mapbox.js/api/v' + version + '/api-access-tokens/');
	        }
	
	        url += url.indexOf('?') !== -1 ? '&access_token=' : '?access_token=';
	        url += accessToken;
	    }
	
	    return url;
	};
	
	module.exports.tileJSON = function(urlOrMapID, accessToken) {
	
	    if (urlOrMapID.indexOf('mapbox://styles') === 0) {
	        throw new Error('Styles created with Mapbox Studio need to be used with ' +
	            'L.mapbox.styleLayer, not L.mapbox.tileLayer');
	    }
	
	    if (urlOrMapID.indexOf('/') !== -1)
	        return urlOrMapID;
	
	    var url = module.exports('/v4/' + urlOrMapID + '.json', accessToken);
	
	    // TileJSON requests need a secure flag appended to their URLs so
	    // that the server knows to send SSL-ified resource references.
	    if (url.indexOf('https') === 0)
	        url += '&secure';
	
	    return url;
	};
	
	
	module.exports.style = function(styleURL, accessToken) {
	    if (styleURL.indexOf('mapbox://styles/') === -1) throw new Error('Incorrectly formatted Mapbox style at ' + styleURL);
	
	    var ownerIDStyle = styleURL.split('mapbox://styles/')[1];
	    var url = module.exports('/styles/v1/' + ownerIDStyle, accessToken)
	        .replace('http://', 'https://');
	
	    return url;
	};


/***/ },
/* 943 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    HTTP_URL: 'http://a.tiles.mapbox.com/v4',
	    HTTPS_URL: 'https://a.tiles.mapbox.com/v4',
	    FORCE_HTTPS: false,
	    REQUIRE_ACCESS_TOKEN: true
	};


/***/ },
/* 944 */
/***/ function(module, exports) {

	module.exports = {
		"author": "Mapbox",
		"name": "mapbox.js",
		"description": "mapbox javascript api",
		"version": "2.4.0",
		"homepage": "http://mapbox.com/",
		"repository": {
			"type": "git",
			"url": "git://github.com/mapbox/mapbox.js.git"
		},
		"main": "src/index.js",
		"dependencies": {
			"corslite": "0.0.6",
			"isarray": "0.0.1",
			"leaflet": "0.7.7",
			"mustache": "2.2.1",
			"sanitize-caja": "0.1.3"
		},
		"scripts": {
			"test": "eslint --no-eslintrc -c .eslintrc src && mocha-phantomjs test/index.html"
		},
		"license": "BSD-3-Clause",
		"devDependencies": {
			"browserify": "^13.0.0",
			"clean-css": "~2.0.7",
			"eslint": "^0.23.0",
			"expect.js": "0.3.1",
			"happen": "0.1.3",
			"leaflet-fullscreen": "0.0.4",
			"leaflet-hash": "0.2.1",
			"marked": "~0.3.0",
			"minifyify": "^6.1.0",
			"minimist": "0.0.5",
			"mocha": "2.4.5",
			"mocha-phantomjs": "4.0.2",
			"sinon": "1.10.2"
		},
		"optionalDependencies": {},
		"engines": {
			"node": "*"
		}
	};

/***/ },
/* 945 */
/***/ function(module, exports) {

	'use strict';
	
	var Feedback = L.Class.extend({
	    includes: L.Mixin.Events,
	    data: {},
	    record: function(data) {
	        L.extend(this.data, data);
	        this.fire('change');
	    }
	});
	
	module.exports = new Feedback();


/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var corslite = __webpack_require__(947),
	    strict = __webpack_require__(941).strict,
	    config = __webpack_require__(943);
	
	var protocol = /^(https?:)?(?=\/\/(.|api)\.tiles\.mapbox\.com\/)/;
	
	module.exports = function(url, callback) {
	    strict(url, 'string');
	    strict(callback, 'function');
	
	    url = url.replace(protocol, function(match, protocol) {
	        if (!('withCredentials' in new window.XMLHttpRequest())) {
	            // XDomainRequest in use; doesn't support cross-protocol requests
	            return document.location.protocol;
	        } else if (protocol === 'https:' || document.location.protocol === 'https:' || config.FORCE_HTTPS) {
	            return 'https:';
	        } else {
	            return 'http:';
	        }
	    });
	
	    function onload(err, resp) {
	        if (!err && resp) {
	            resp = JSON.parse(resp.responseText);
	        }
	        callback(err, resp);
	    }
	
	    return corslite(url, onload);
	};


/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	function corslite(url, callback, cors) {
	    var sent = false;
	
	    if (typeof window.XMLHttpRequest === 'undefined') {
	        return callback(Error('Browser not supported'));
	    }
	
	    if (typeof cors === 'undefined') {
	        var m = url.match(/^\s*https?:\/\/[^\/]*/);
	        cors = m && (m[0] !== location.protocol + '//' + location.domain +
	                (location.port ? ':' + location.port : ''));
	    }
	
	    var x = new window.XMLHttpRequest();
	
	    function isSuccessful(status) {
	        return status >= 200 && status < 300 || status === 304;
	    }
	
	    if (cors && !('withCredentials' in x)) {
	        // IE8-9
	        x = new window.XDomainRequest();
	
	        // Ensure callback is never called synchronously, i.e., before
	        // x.send() returns (this has been observed in the wild).
	        // See https://github.com/mapbox/mapbox.js/issues/472
	        var original = callback;
	        callback = function() {
	            if (sent) {
	                original.apply(this, arguments);
	            } else {
	                var that = this, args = arguments;
	                setTimeout(function() {
	                    original.apply(that, args);
	                }, 0);
	            }
	        }
	    }
	
	    function loaded() {
	        if (
	            // XDomainRequest
	            x.status === undefined ||
	            // modern browsers
	            isSuccessful(x.status)) callback.call(x, null, x);
	        else callback.call(x, x, null);
	    }
	
	    // Both `onreadystatechange` and `onload` can fire. `onreadystatechange`
	    // has [been supported for longer](http://stackoverflow.com/a/9181508/229001).
	    if ('onload' in x) {
	        x.onload = loaded;
	    } else {
	        x.onreadystatechange = function readystate() {
	            if (x.readyState === 4) {
	                loaded();
	            }
	        };
	    }
	
	    // Call the callback with the XMLHttpRequest object as an error and prevent
	    // it from ever being called again by reassigning it to `noop`
	    x.onerror = function error(evt) {
	        // XDomainRequest provides no evt parameter
	        callback.call(this, evt || true, null);
	        callback = function() { };
	    };
	
	    // IE9 must have onprogress be set to a unique function.
	    x.onprogress = function() { };
	
	    x.ontimeout = function(evt) {
	        callback.call(this, evt, null);
	        callback = function() { };
	    };
	
	    x.onabort = function(evt) {
	        callback.call(this, evt, null);
	        callback = function() { };
	    };
	
	    // GET is the only supported HTTP Verb by XDomainRequest and is the
	    // only one supported here.
	    x.open('GET', url, true);
	
	    // Send the request. Sending data is not supported.
	    x.send(null);
	    sent = true;
	
	    return x;
	}
	
	if (true) module.exports = corslite;


/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(941),
	    Mustache = __webpack_require__(949);
	
	var GridControl = L.Control.extend({
	
	    options: {
	        pinnable: true,
	        follow: false,
	        sanitizer: __webpack_require__(950),
	        touchTeaser: true,
	        location: true
	    },
	
	    _currentContent: '',
	
	    // pinned means that this control is on a feature and the user has likely
	    // clicked. pinned will not become false unless the user clicks off
	    // of the feature onto another or clicks x
	    _pinned: false,
	
	    initialize: function(_, options) {
	        L.Util.setOptions(this, options);
	        util.strict_instance(_, L.Class, 'L.mapbox.gridLayer');
	        this._layer = _;
	    },
	
	    setTemplate: function(template) {
	        util.strict(template, 'string');
	        this.options.template = template;
	        return this;
	    },
	
	    _template: function(format, data) {
	        if (!data) return;
	        var template = this.options.template || this._layer.getTileJSON().template;
	        if (template) {
	            var d = {};
	            d['__' + format + '__'] = true;
	            return this.options.sanitizer(
	                Mustache.to_html(template, L.extend(d, data)));
	        }
	    },
	
	    // change the content of the tooltip HTML if it has changed, otherwise
	    // noop
	    _show: function(content, o) {
	        if (content === this._currentContent) return;
	
	        this._currentContent = content;
	
	        if (this.options.follow) {
	            this._popup.setContent(content)
	                .setLatLng(o.latLng);
	            if (this._map._popup !== this._popup) this._popup.openOn(this._map);
	        } else {
	            this._container.style.display = 'block';
	            this._contentWrapper.innerHTML = content;
	        }
	    },
	
	    hide: function() {
	        this._pinned = false;
	        this._currentContent = '';
	
	        this._map.closePopup();
	        this._container.style.display = 'none';
	        this._contentWrapper.innerHTML = '';
	
	        L.DomUtil.removeClass(this._container, 'closable');
	
	        return this;
	    },
	
	    _mouseover: function(o) {
	        if (o.data) {
	            L.DomUtil.addClass(this._map._container, 'map-clickable');
	        } else {
	            L.DomUtil.removeClass(this._map._container, 'map-clickable');
	        }
	
	        if (this._pinned) return;
	
	        var content = this._template('teaser', o.data);
	        if (content) {
	            this._show(content, o);
	        } else {
	            this.hide();
	        }
	    },
	
	    _mousemove: function(o) {
	        if (this._pinned) return;
	        if (!this.options.follow) return;
	
	        this._popup.setLatLng(o.latLng);
	    },
	
	    _navigateTo: function(url) {
	        window.top.location.href = url;
	    },
	
	    _click: function(o) {
	
	        var location_formatted = this._template('location', o.data);
	        if (this.options.location && location_formatted &&
	            location_formatted.search(/^https?:/) === 0) {
	            return this._navigateTo(this._template('location', o.data));
	        }
	
	        if (!this.options.pinnable) return;
	
	        var content = this._template('full', o.data);
	
	        if (!content && this.options.touchTeaser && L.Browser.touch) {
	            content = this._template('teaser', o.data);
	        }
	
	        if (content) {
	            L.DomUtil.addClass(this._container, 'closable');
	            this._pinned = true;
	            this._show(content, o);
	        } else if (this._pinned) {
	            L.DomUtil.removeClass(this._container, 'closable');
	            this._pinned = false;
	            this.hide();
	        }
	    },
	
	    _onPopupClose: function() {
	        this._currentContent = null;
	        this._pinned = false;
	    },
	
	    _createClosebutton: function(container, fn) {
	        var link = L.DomUtil.create('a', 'close', container);
	
	        link.innerHTML = 'close';
	        link.href = '#';
	        link.title = 'close';
	
	        L.DomEvent
	            .on(link, 'click', L.DomEvent.stopPropagation)
	            .on(link, 'mousedown', L.DomEvent.stopPropagation)
	            .on(link, 'dblclick', L.DomEvent.stopPropagation)
	            .on(link, 'click', L.DomEvent.preventDefault)
	            .on(link, 'click', fn, this);
	
	        return link;
	    },
	
	    onAdd: function(map) {
	        this._map = map;
	
	        var className = 'leaflet-control-grid map-tooltip',
	            container = L.DomUtil.create('div', className),
	            contentWrapper = L.DomUtil.create('div', 'map-tooltip-content');
	
	        // hide the container element initially
	        container.style.display = 'none';
	        this._createClosebutton(container, this.hide);
	        container.appendChild(contentWrapper);
	
	        this._contentWrapper = contentWrapper;
	        this._popup = new L.Popup({ autoPan: false, closeOnClick: false });
	
	        map.on('popupclose', this._onPopupClose, this);
	
	        L.DomEvent
	            .disableClickPropagation(container)
	            // allow people to scroll tooltips with mousewheel
	            .addListener(container, 'mousewheel', L.DomEvent.stopPropagation);
	
	        this._layer
	            .on('mouseover', this._mouseover, this)
	            .on('mousemove', this._mousemove, this)
	            .on('click', this._click, this);
	
	        return container;
	    },
	
	    onRemove: function (map) {
	
	        map.off('popupclose', this._onPopupClose, this);
	
	        this._layer
	            .off('mouseover', this._mouseover, this)
	            .off('mousemove', this._mousemove, this)
	            .off('click', this._click, this);
	    }
	});
	
	module.exports.GridControl = GridControl;
	
	module.exports.gridControl = function(_, options) {
	    return new GridControl(_, options);
	};


/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * mustache.js - Logic-less {{mustache}} templates with JavaScript
	 * http://github.com/janl/mustache.js
	 */
	
	/*global define: false Mustache: true*/
	
	(function defineMustache (global, factory) {
	  if (typeof exports === 'object' && exports && typeof exports.nodeName !== 'string') {
	    factory(exports); // CommonJS
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // AMD
	  } else {
	    global.Mustache = {};
	    factory(global.Mustache); // script, wsh, asp
	  }
	}(this, function mustacheFactory (mustache) {
	
	  var objectToString = Object.prototype.toString;
	  var isArray = Array.isArray || function isArrayPolyfill (object) {
	    return objectToString.call(object) === '[object Array]';
	  };
	
	  function isFunction (object) {
	    return typeof object === 'function';
	  }
	
	  /**
	   * More correct typeof string handling array
	   * which normally returns typeof 'object'
	   */
	  function typeStr (obj) {
	    return isArray(obj) ? 'array' : typeof obj;
	  }
	
	  function escapeRegExp (string) {
	    return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
	  }
	
	  /**
	   * Null safe way of checking whether or not an object,
	   * including its prototype, has a given property
	   */
	  function hasProperty (obj, propName) {
	    return obj != null && typeof obj === 'object' && (propName in obj);
	  }
	
	  // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
	  // See https://github.com/janl/mustache.js/issues/189
	  var regExpTest = RegExp.prototype.test;
	  function testRegExp (re, string) {
	    return regExpTest.call(re, string);
	  }
	
	  var nonSpaceRe = /\S/;
	  function isWhitespace (string) {
	    return !testRegExp(nonSpaceRe, string);
	  }
	
	  var entityMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '/': '&#x2F;',
	    '`': '&#x60;',
	    '=': '&#x3D;'
	  };
	
	  function escapeHtml (string) {
	    return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap (s) {
	      return entityMap[s];
	    });
	  }
	
	  var whiteRe = /\s*/;
	  var spaceRe = /\s+/;
	  var equalsRe = /\s*=/;
	  var curlyRe = /\s*\}/;
	  var tagRe = /#|\^|\/|>|\{|&|=|!/;
	
	  /**
	   * Breaks up the given `template` string into a tree of tokens. If the `tags`
	   * argument is given here it must be an array with two string values: the
	   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
	   * course, the default is to use mustaches (i.e. mustache.tags).
	   *
	   * A token is an array with at least 4 elements. The first element is the
	   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
	   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
	   * all text that appears outside a symbol this element is "text".
	   *
	   * The second element of a token is its "value". For mustache tags this is
	   * whatever else was inside the tag besides the opening symbol. For text tokens
	   * this is the text itself.
	   *
	   * The third and fourth elements of the token are the start and end indices,
	   * respectively, of the token in the original template.
	   *
	   * Tokens that are the root node of a subtree contain two more elements: 1) an
	   * array of tokens in the subtree and 2) the index in the original template at
	   * which the closing tag for that section begins.
	   */
	  function parseTemplate (template, tags) {
	    if (!template)
	      return [];
	
	    var sections = [];     // Stack to hold section tokens
	    var tokens = [];       // Buffer to hold the tokens
	    var spaces = [];       // Indices of whitespace tokens on the current line
	    var hasTag = false;    // Is there a {{tag}} on the current line?
	    var nonSpace = false;  // Is there a non-space char on the current line?
	
	    // Strips all whitespace tokens array for the current line
	    // if there was a {{#tag}} on it and otherwise only space.
	    function stripSpace () {
	      if (hasTag && !nonSpace) {
	        while (spaces.length)
	          delete tokens[spaces.pop()];
	      } else {
	        spaces = [];
	      }
	
	      hasTag = false;
	      nonSpace = false;
	    }
	
	    var openingTagRe, closingTagRe, closingCurlyRe;
	    function compileTags (tagsToCompile) {
	      if (typeof tagsToCompile === 'string')
	        tagsToCompile = tagsToCompile.split(spaceRe, 2);
	
	      if (!isArray(tagsToCompile) || tagsToCompile.length !== 2)
	        throw new Error('Invalid tags: ' + tagsToCompile);
	
	      openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
	      closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
	      closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
	    }
	
	    compileTags(tags || mustache.tags);
	
	    var scanner = new Scanner(template);
	
	    var start, type, value, chr, token, openSection;
	    while (!scanner.eos()) {
	      start = scanner.pos;
	
	      // Match any text between tags.
	      value = scanner.scanUntil(openingTagRe);
	
	      if (value) {
	        for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
	          chr = value.charAt(i);
	
	          if (isWhitespace(chr)) {
	            spaces.push(tokens.length);
	          } else {
	            nonSpace = true;
	          }
	
	          tokens.push([ 'text', chr, start, start + 1 ]);
	          start += 1;
	
	          // Check for whitespace on the current line.
	          if (chr === '\n')
	            stripSpace();
	        }
	      }
	
	      // Match the opening tag.
	      if (!scanner.scan(openingTagRe))
	        break;
	
	      hasTag = true;
	
	      // Get the tag type.
	      type = scanner.scan(tagRe) || 'name';
	      scanner.scan(whiteRe);
	
	      // Get the tag value.
	      if (type === '=') {
	        value = scanner.scanUntil(equalsRe);
	        scanner.scan(equalsRe);
	        scanner.scanUntil(closingTagRe);
	      } else if (type === '{') {
	        value = scanner.scanUntil(closingCurlyRe);
	        scanner.scan(curlyRe);
	        scanner.scanUntil(closingTagRe);
	        type = '&';
	      } else {
	        value = scanner.scanUntil(closingTagRe);
	      }
	
	      // Match the closing tag.
	      if (!scanner.scan(closingTagRe))
	        throw new Error('Unclosed tag at ' + scanner.pos);
	
	      token = [ type, value, start, scanner.pos ];
	      tokens.push(token);
	
	      if (type === '#' || type === '^') {
	        sections.push(token);
	      } else if (type === '/') {
	        // Check section nesting.
	        openSection = sections.pop();
	
	        if (!openSection)
	          throw new Error('Unopened section "' + value + '" at ' + start);
	
	        if (openSection[1] !== value)
	          throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
	      } else if (type === 'name' || type === '{' || type === '&') {
	        nonSpace = true;
	      } else if (type === '=') {
	        // Set the tags for the next time around.
	        compileTags(value);
	      }
	    }
	
	    // Make sure there are no open sections when we're done.
	    openSection = sections.pop();
	
	    if (openSection)
	      throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
	
	    return nestTokens(squashTokens(tokens));
	  }
	
	  /**
	   * Combines the values of consecutive text tokens in the given `tokens` array
	   * to a single token.
	   */
	  function squashTokens (tokens) {
	    var squashedTokens = [];
	
	    var token, lastToken;
	    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
	      token = tokens[i];
	
	      if (token) {
	        if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
	          lastToken[1] += token[1];
	          lastToken[3] = token[3];
	        } else {
	          squashedTokens.push(token);
	          lastToken = token;
	        }
	      }
	    }
	
	    return squashedTokens;
	  }
	
	  /**
	   * Forms the given array of `tokens` into a nested tree structure where
	   * tokens that represent a section have two additional items: 1) an array of
	   * all tokens that appear in that section and 2) the index in the original
	   * template that represents the end of that section.
	   */
	  function nestTokens (tokens) {
	    var nestedTokens = [];
	    var collector = nestedTokens;
	    var sections = [];
	
	    var token, section;
	    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
	      token = tokens[i];
	
	      switch (token[0]) {
	        case '#':
	        case '^':
	          collector.push(token);
	          sections.push(token);
	          collector = token[4] = [];
	          break;
	        case '/':
	          section = sections.pop();
	          section[5] = token[2];
	          collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
	          break;
	        default:
	          collector.push(token);
	      }
	    }
	
	    return nestedTokens;
	  }
	
	  /**
	   * A simple string scanner that is used by the template parser to find
	   * tokens in template strings.
	   */
	  function Scanner (string) {
	    this.string = string;
	    this.tail = string;
	    this.pos = 0;
	  }
	
	  /**
	   * Returns `true` if the tail is empty (end of string).
	   */
	  Scanner.prototype.eos = function eos () {
	    return this.tail === '';
	  };
	
	  /**
	   * Tries to match the given regular expression at the current position.
	   * Returns the matched text if it can match, the empty string otherwise.
	   */
	  Scanner.prototype.scan = function scan (re) {
	    var match = this.tail.match(re);
	
	    if (!match || match.index !== 0)
	      return '';
	
	    var string = match[0];
	
	    this.tail = this.tail.substring(string.length);
	    this.pos += string.length;
	
	    return string;
	  };
	
	  /**
	   * Skips all text until the given regular expression can be matched. Returns
	   * the skipped string, which is the entire tail if no match can be made.
	   */
	  Scanner.prototype.scanUntil = function scanUntil (re) {
	    var index = this.tail.search(re), match;
	
	    switch (index) {
	      case -1:
	        match = this.tail;
	        this.tail = '';
	        break;
	      case 0:
	        match = '';
	        break;
	      default:
	        match = this.tail.substring(0, index);
	        this.tail = this.tail.substring(index);
	    }
	
	    this.pos += match.length;
	
	    return match;
	  };
	
	  /**
	   * Represents a rendering context by wrapping a view object and
	   * maintaining a reference to the parent context.
	   */
	  function Context (view, parentContext) {
	    this.view = view;
	    this.cache = { '.': this.view };
	    this.parent = parentContext;
	  }
	
	  /**
	   * Creates a new context using the given view with this context
	   * as the parent.
	   */
	  Context.prototype.push = function push (view) {
	    return new Context(view, this);
	  };
	
	  /**
	   * Returns the value of the given name in this context, traversing
	   * up the context hierarchy if the value is absent in this context's view.
	   */
	  Context.prototype.lookup = function lookup (name) {
	    var cache = this.cache;
	
	    var value;
	    if (cache.hasOwnProperty(name)) {
	      value = cache[name];
	    } else {
	      var context = this, names, index, lookupHit = false;
	
	      while (context) {
	        if (name.indexOf('.') > 0) {
	          value = context.view;
	          names = name.split('.');
	          index = 0;
	
	          /**
	           * Using the dot notion path in `name`, we descend through the
	           * nested objects.
	           *
	           * To be certain that the lookup has been successful, we have to
	           * check if the last object in the path actually has the property
	           * we are looking for. We store the result in `lookupHit`.
	           *
	           * This is specially necessary for when the value has been set to
	           * `undefined` and we want to avoid looking up parent contexts.
	           **/
	          while (value != null && index < names.length) {
	            if (index === names.length - 1)
	              lookupHit = hasProperty(value, names[index]);
	
	            value = value[names[index++]];
	          }
	        } else {
	          value = context.view[name];
	          lookupHit = hasProperty(context.view, name);
	        }
	
	        if (lookupHit)
	          break;
	
	        context = context.parent;
	      }
	
	      cache[name] = value;
	    }
	
	    if (isFunction(value))
	      value = value.call(this.view);
	
	    return value;
	  };
	
	  /**
	   * A Writer knows how to take a stream of tokens and render them to a
	   * string, given a context. It also maintains a cache of templates to
	   * avoid the need to parse the same template twice.
	   */
	  function Writer () {
	    this.cache = {};
	  }
	
	  /**
	   * Clears all cached templates in this writer.
	   */
	  Writer.prototype.clearCache = function clearCache () {
	    this.cache = {};
	  };
	
	  /**
	   * Parses and caches the given `template` and returns the array of tokens
	   * that is generated from the parse.
	   */
	  Writer.prototype.parse = function parse (template, tags) {
	    var cache = this.cache;
	    var tokens = cache[template];
	
	    if (tokens == null)
	      tokens = cache[template] = parseTemplate(template, tags);
	
	    return tokens;
	  };
	
	  /**
	   * High-level method that is used to render the given `template` with
	   * the given `view`.
	   *
	   * The optional `partials` argument may be an object that contains the
	   * names and templates of partials that are used in the template. It may
	   * also be a function that is used to load partial templates on the fly
	   * that takes a single argument: the name of the partial.
	   */
	  Writer.prototype.render = function render (template, view, partials) {
	    var tokens = this.parse(template);
	    var context = (view instanceof Context) ? view : new Context(view);
	    return this.renderTokens(tokens, context, partials, template);
	  };
	
	  /**
	   * Low-level method that renders the given array of `tokens` using
	   * the given `context` and `partials`.
	   *
	   * Note: The `originalTemplate` is only ever used to extract the portion
	   * of the original template that was contained in a higher-order section.
	   * If the template doesn't use higher-order sections, this argument may
	   * be omitted.
	   */
	  Writer.prototype.renderTokens = function renderTokens (tokens, context, partials, originalTemplate) {
	    var buffer = '';
	
	    var token, symbol, value;
	    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
	      value = undefined;
	      token = tokens[i];
	      symbol = token[0];
	
	      if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate);
	      else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate);
	      else if (symbol === '>') value = this.renderPartial(token, context, partials, originalTemplate);
	      else if (symbol === '&') value = this.unescapedValue(token, context);
	      else if (symbol === 'name') value = this.escapedValue(token, context);
	      else if (symbol === 'text') value = this.rawValue(token);
	
	      if (value !== undefined)
	        buffer += value;
	    }
	
	    return buffer;
	  };
	
	  Writer.prototype.renderSection = function renderSection (token, context, partials, originalTemplate) {
	    var self = this;
	    var buffer = '';
	    var value = context.lookup(token[1]);
	
	    // This function is used to render an arbitrary template
	    // in the current context by higher-order sections.
	    function subRender (template) {
	      return self.render(template, context, partials);
	    }
	
	    if (!value) return;
	
	    if (isArray(value)) {
	      for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
	        buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate);
	      }
	    } else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') {
	      buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate);
	    } else if (isFunction(value)) {
	      if (typeof originalTemplate !== 'string')
	        throw new Error('Cannot use higher-order sections without the original template');
	
	      // Extract the portion of the original template that the section contains.
	      value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
	
	      if (value != null)
	        buffer += value;
	    } else {
	      buffer += this.renderTokens(token[4], context, partials, originalTemplate);
	    }
	    return buffer;
	  };
	
	  Writer.prototype.renderInverted = function renderInverted (token, context, partials, originalTemplate) {
	    var value = context.lookup(token[1]);
	
	    // Use JavaScript's definition of falsy. Include empty arrays.
	    // See https://github.com/janl/mustache.js/issues/186
	    if (!value || (isArray(value) && value.length === 0))
	      return this.renderTokens(token[4], context, partials, originalTemplate);
	  };
	
	  Writer.prototype.renderPartial = function renderPartial (token, context, partials) {
	    if (!partials) return;
	
	    var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
	    if (value != null)
	      return this.renderTokens(this.parse(value), context, partials, value);
	  };
	
	  Writer.prototype.unescapedValue = function unescapedValue (token, context) {
	    var value = context.lookup(token[1]);
	    if (value != null)
	      return value;
	  };
	
	  Writer.prototype.escapedValue = function escapedValue (token, context) {
	    var value = context.lookup(token[1]);
	    if (value != null)
	      return mustache.escape(value);
	  };
	
	  Writer.prototype.rawValue = function rawValue (token) {
	    return token[1];
	  };
	
	  mustache.name = 'mustache.js';
	  mustache.version = '2.2.1';
	  mustache.tags = [ '{{', '}}' ];
	
	  // All high-level mustache.* functions use this writer.
	  var defaultWriter = new Writer();
	
	  /**
	   * Clears all cached templates in the default writer.
	   */
	  mustache.clearCache = function clearCache () {
	    return defaultWriter.clearCache();
	  };
	
	  /**
	   * Parses and caches the given template in the default writer and returns the
	   * array of tokens it contains. Doing this ahead of time avoids the need to
	   * parse templates on the fly as they are rendered.
	   */
	  mustache.parse = function parse (template, tags) {
	    return defaultWriter.parse(template, tags);
	  };
	
	  /**
	   * Renders the `template` with the given `view` and `partials` using the
	   * default writer.
	   */
	  mustache.render = function render (template, view, partials) {
	    if (typeof template !== 'string') {
	      throw new TypeError('Invalid template! Template should be a "string" ' +
	                          'but "' + typeStr(template) + '" was given as the first ' +
	                          'argument for mustache#render(template, view, partials)');
	    }
	
	    return defaultWriter.render(template, view, partials);
	  };
	
	  // This is here for backwards compatibility with 0.4.x.,
	  /*eslint-disable */ // eslint wants camel cased function name
	  mustache.to_html = function to_html (template, view, partials, send) {
	    /*eslint-enable*/
	
	    var result = mustache.render(template, view, partials);
	
	    if (isFunction(send)) {
	      send(result);
	    } else {
	      return result;
	    }
	  };
	
	  // Export the escaping function so that the user may override it.
	  // See https://github.com/janl/mustache.js/issues/244
	  mustache.escape = escapeHtml;
	
	  // Export these mainly for testing, but also for advanced usage.
	  mustache.Scanner = Scanner;
	  mustache.Context = Context;
	  mustache.Writer = Writer;
	
	}));


/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	var html_sanitize = __webpack_require__(951);
	
	module.exports = function(_) {
	    if (!_) return '';
	    return html_sanitize(_, cleanUrl, cleanId);
	};
	
	// https://bugzilla.mozilla.org/show_bug.cgi?id=255107
	function cleanUrl(url) {
	    'use strict';
	    if (/^https?/.test(url.getScheme())) return url.toString();
	    if (/^mailto?/.test(url.getScheme())) return url.toString();
	    if ('data' == url.getScheme() && /^image/.test(url.getPath())) {
	        return url.toString();
	    }
	}
	
	function cleanId(id) { return id; }


/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	
	// Copyright (C) 2010 Google Inc.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	//      http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	
	/**
	 * @fileoverview
	 * Implements RFC 3986 for parsing/formatting URIs.
	 *
	 * @author mikesamuel@gmail.com
	 * \@provides URI
	 * \@overrides window
	 */
	
	var URI = (function () {
	
	/**
	 * creates a uri from the string form.  The parser is relaxed, so special
	 * characters that aren't escaped but don't cause ambiguities will not cause
	 * parse failures.
	 *
	 * @return {URI|null}
	 */
	function parse(uriStr) {
	  var m = ('' + uriStr).match(URI_RE_);
	  if (!m) { return null; }
	  return new URI(
	      nullIfAbsent(m[1]),
	      nullIfAbsent(m[2]),
	      nullIfAbsent(m[3]),
	      nullIfAbsent(m[4]),
	      nullIfAbsent(m[5]),
	      nullIfAbsent(m[6]),
	      nullIfAbsent(m[7]));
	}
	
	
	/**
	 * creates a uri from the given parts.
	 *
	 * @param scheme {string} an unencoded scheme such as "http" or null
	 * @param credentials {string} unencoded user credentials or null
	 * @param domain {string} an unencoded domain name or null
	 * @param port {number} a port number in [1, 32768].
	 *    -1 indicates no port, as does null.
	 * @param path {string} an unencoded path
	 * @param query {Array.<string>|string|null} a list of unencoded cgi
	 *   parameters where even values are keys and odds the corresponding values
	 *   or an unencoded query.
	 * @param fragment {string} an unencoded fragment without the "#" or null.
	 * @return {URI}
	 */
	function create(scheme, credentials, domain, port, path, query, fragment) {
	  var uri = new URI(
	      encodeIfExists2(scheme, URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_),
	      encodeIfExists2(
	          credentials, URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_),
	      encodeIfExists(domain),
	      port > 0 ? port.toString() : null,
	      encodeIfExists2(path, URI_DISALLOWED_IN_PATH_),
	      null,
	      encodeIfExists(fragment));
	  if (query) {
	    if ('string' === typeof query) {
	      uri.setRawQuery(query.replace(/[^?&=0-9A-Za-z_\-~.%]/g, encodeOne));
	    } else {
	      uri.setAllParameters(query);
	    }
	  }
	  return uri;
	}
	function encodeIfExists(unescapedPart) {
	  if ('string' == typeof unescapedPart) {
	    return encodeURIComponent(unescapedPart);
	  }
	  return null;
	};
	/**
	 * if unescapedPart is non null, then escapes any characters in it that aren't
	 * valid characters in a url and also escapes any special characters that
	 * appear in extra.
	 *
	 * @param unescapedPart {string}
	 * @param extra {RegExp} a character set of characters in [\01-\177].
	 * @return {string|null} null iff unescapedPart == null.
	 */
	function encodeIfExists2(unescapedPart, extra) {
	  if ('string' == typeof unescapedPart) {
	    return encodeURI(unescapedPart).replace(extra, encodeOne);
	  }
	  return null;
	};
	/** converts a character in [\01-\177] to its url encoded equivalent. */
	function encodeOne(ch) {
	  var n = ch.charCodeAt(0);
	  return '%' + '0123456789ABCDEF'.charAt((n >> 4) & 0xf) +
	      '0123456789ABCDEF'.charAt(n & 0xf);
	}
	
	/**
	 * {@updoc
	 *  $ normPath('foo/./bar')
	 *  # 'foo/bar'
	 *  $ normPath('./foo')
	 *  # 'foo'
	 *  $ normPath('foo/.')
	 *  # 'foo'
	 *  $ normPath('foo//bar')
	 *  # 'foo/bar'
	 * }
	 */
	function normPath(path) {
	  return path.replace(/(^|\/)\.(?:\/|$)/g, '$1').replace(/\/{2,}/g, '/');
	}
	
	var PARENT_DIRECTORY_HANDLER = new RegExp(
	    ''
	    // A path break
	    + '(/|^)'
	    // followed by a non .. path element
	    // (cannot be . because normPath is used prior to this RegExp)
	    + '(?:[^./][^/]*|\\.{2,}(?:[^./][^/]*)|\\.{3,}[^/]*)'
	    // followed by .. followed by a path break.
	    + '/\\.\\.(?:/|$)');
	
	var PARENT_DIRECTORY_HANDLER_RE = new RegExp(PARENT_DIRECTORY_HANDLER);
	
	var EXTRA_PARENT_PATHS_RE = /^(?:\.\.\/)*(?:\.\.$)?/;
	
	/**
	 * Normalizes its input path and collapses all . and .. sequences except for
	 * .. sequences that would take it above the root of the current parent
	 * directory.
	 * {@updoc
	 *  $ collapse_dots('foo/../bar')
	 *  # 'bar'
	 *  $ collapse_dots('foo/./bar')
	 *  # 'foo/bar'
	 *  $ collapse_dots('foo/../bar/./../../baz')
	 *  # 'baz'
	 *  $ collapse_dots('../foo')
	 *  # '../foo'
	 *  $ collapse_dots('../foo').replace(EXTRA_PARENT_PATHS_RE, '')
	 *  # 'foo'
	 * }
	 */
	function collapse_dots(path) {
	  if (path === null) { return null; }
	  var p = normPath(path);
	  // Only /../ left to flatten
	  var r = PARENT_DIRECTORY_HANDLER_RE;
	  // We replace with $1 which matches a / before the .. because this
	  // guarantees that:
	  // (1) we have at most 1 / between the adjacent place,
	  // (2) always have a slash if there is a preceding path section, and
	  // (3) we never turn a relative path into an absolute path.
	  for (var q; (q = p.replace(r, '$1')) != p; p = q) {};
	  return p;
	}
	
	/**
	 * resolves a relative url string to a base uri.
	 * @return {URI}
	 */
	function resolve(baseUri, relativeUri) {
	  // there are several kinds of relative urls:
	  // 1. //foo - replaces everything from the domain on.  foo is a domain name
	  // 2. foo - replaces the last part of the path, the whole query and fragment
	  // 3. /foo - replaces the the path, the query and fragment
	  // 4. ?foo - replace the query and fragment
	  // 5. #foo - replace the fragment only
	
	  var absoluteUri = baseUri.clone();
	  // we satisfy these conditions by looking for the first part of relativeUri
	  // that is not blank and applying defaults to the rest
	
	  var overridden = relativeUri.hasScheme();
	
	  if (overridden) {
	    absoluteUri.setRawScheme(relativeUri.getRawScheme());
	  } else {
	    overridden = relativeUri.hasCredentials();
	  }
	
	  if (overridden) {
	    absoluteUri.setRawCredentials(relativeUri.getRawCredentials());
	  } else {
	    overridden = relativeUri.hasDomain();
	  }
	
	  if (overridden) {
	    absoluteUri.setRawDomain(relativeUri.getRawDomain());
	  } else {
	    overridden = relativeUri.hasPort();
	  }
	
	  var rawPath = relativeUri.getRawPath();
	  var simplifiedPath = collapse_dots(rawPath);
	  if (overridden) {
	    absoluteUri.setPort(relativeUri.getPort());
	    simplifiedPath = simplifiedPath
	        && simplifiedPath.replace(EXTRA_PARENT_PATHS_RE, '');
	  } else {
	    overridden = !!rawPath;
	    if (overridden) {
	      // resolve path properly
	      if (simplifiedPath.charCodeAt(0) !== 0x2f /* / */) {  // path is relative
	        var absRawPath = collapse_dots(absoluteUri.getRawPath() || '')
	            .replace(EXTRA_PARENT_PATHS_RE, '');
	        var slash = absRawPath.lastIndexOf('/') + 1;
	        simplifiedPath = collapse_dots(
	            (slash ? absRawPath.substring(0, slash) : '')
	            + collapse_dots(rawPath))
	            .replace(EXTRA_PARENT_PATHS_RE, '');
	      }
	    } else {
	      simplifiedPath = simplifiedPath
	          && simplifiedPath.replace(EXTRA_PARENT_PATHS_RE, '');
	      if (simplifiedPath !== rawPath) {
	        absoluteUri.setRawPath(simplifiedPath);
	      }
	    }
	  }
	
	  if (overridden) {
	    absoluteUri.setRawPath(simplifiedPath);
	  } else {
	    overridden = relativeUri.hasQuery();
	  }
	
	  if (overridden) {
	    absoluteUri.setRawQuery(relativeUri.getRawQuery());
	  } else {
	    overridden = relativeUri.hasFragment();
	  }
	
	  if (overridden) {
	    absoluteUri.setRawFragment(relativeUri.getRawFragment());
	  }
	
	  return absoluteUri;
	}
	
	/**
	 * a mutable URI.
	 *
	 * This class contains setters and getters for the parts of the URI.
	 * The <tt>getXYZ</tt>/<tt>setXYZ</tt> methods return the decoded part -- so
	 * <code>uri.parse('/foo%20bar').getPath()</code> will return the decoded path,
	 * <tt>/foo bar</tt>.
	 *
	 * <p>The raw versions of fields are available too.
	 * <code>uri.parse('/foo%20bar').getRawPath()</code> will return the raw path,
	 * <tt>/foo%20bar</tt>.  Use the raw setters with care, since
	 * <code>URI::toString</code> is not guaranteed to return a valid url if a
	 * raw setter was used.
	 *
	 * <p>All setters return <tt>this</tt> and so may be chained, a la
	 * <code>uri.parse('/foo').setFragment('part').toString()</code>.
	 *
	 * <p>You should not use this constructor directly -- please prefer the factory
	 * functions {@link uri.parse}, {@link uri.create}, {@link uri.resolve}
	 * instead.</p>
	 *
	 * <p>The parameters are all raw (assumed to be properly escaped) parts, and
	 * any (but not all) may be null.  Undefined is not allowed.</p>
	 *
	 * @constructor
	 */
	function URI(
	    rawScheme,
	    rawCredentials, rawDomain, port,
	    rawPath, rawQuery, rawFragment) {
	  this.scheme_ = rawScheme;
	  this.credentials_ = rawCredentials;
	  this.domain_ = rawDomain;
	  this.port_ = port;
	  this.path_ = rawPath;
	  this.query_ = rawQuery;
	  this.fragment_ = rawFragment;
	  /**
	   * @type {Array|null}
	   */
	  this.paramCache_ = null;
	}
	
	/** returns the string form of the url. */
	URI.prototype.toString = function () {
	  var out = [];
	  if (null !== this.scheme_) { out.push(this.scheme_, ':'); }
	  if (null !== this.domain_) {
	    out.push('//');
	    if (null !== this.credentials_) { out.push(this.credentials_, '@'); }
	    out.push(this.domain_);
	    if (null !== this.port_) { out.push(':', this.port_.toString()); }
	  }
	  if (null !== this.path_) { out.push(this.path_); }
	  if (null !== this.query_) { out.push('?', this.query_); }
	  if (null !== this.fragment_) { out.push('#', this.fragment_); }
	  return out.join('');
	};
	
	URI.prototype.clone = function () {
	  return new URI(this.scheme_, this.credentials_, this.domain_, this.port_,
	                 this.path_, this.query_, this.fragment_);
	};
	
	URI.prototype.getScheme = function () {
	  // HTML5 spec does not require the scheme to be lowercased but
	  // all common browsers except Safari lowercase the scheme.
	  return this.scheme_ && decodeURIComponent(this.scheme_).toLowerCase();
	};
	URI.prototype.getRawScheme = function () {
	  return this.scheme_;
	};
	URI.prototype.setScheme = function (newScheme) {
	  this.scheme_ = encodeIfExists2(
	      newScheme, URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_);
	  return this;
	};
	URI.prototype.setRawScheme = function (newScheme) {
	  this.scheme_ = newScheme ? newScheme : null;
	  return this;
	};
	URI.prototype.hasScheme = function () {
	  return null !== this.scheme_;
	};
	
	
	URI.prototype.getCredentials = function () {
	  return this.credentials_ && decodeURIComponent(this.credentials_);
	};
	URI.prototype.getRawCredentials = function () {
	  return this.credentials_;
	};
	URI.prototype.setCredentials = function (newCredentials) {
	  this.credentials_ = encodeIfExists2(
	      newCredentials, URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_);
	
	  return this;
	};
	URI.prototype.setRawCredentials = function (newCredentials) {
	  this.credentials_ = newCredentials ? newCredentials : null;
	  return this;
	};
	URI.prototype.hasCredentials = function () {
	  return null !== this.credentials_;
	};
	
	
	URI.prototype.getDomain = function () {
	  return this.domain_ && decodeURIComponent(this.domain_);
	};
	URI.prototype.getRawDomain = function () {
	  return this.domain_;
	};
	URI.prototype.setDomain = function (newDomain) {
	  return this.setRawDomain(newDomain && encodeURIComponent(newDomain));
	};
	URI.prototype.setRawDomain = function (newDomain) {
	  this.domain_ = newDomain ? newDomain : null;
	  // Maintain the invariant that paths must start with a slash when the URI
	  // is not path-relative.
	  return this.setRawPath(this.path_);
	};
	URI.prototype.hasDomain = function () {
	  return null !== this.domain_;
	};
	
	
	URI.prototype.getPort = function () {
	  return this.port_ && decodeURIComponent(this.port_);
	};
	URI.prototype.setPort = function (newPort) {
	  if (newPort) {
	    newPort = Number(newPort);
	    if (newPort !== (newPort & 0xffff)) {
	      throw new Error('Bad port number ' + newPort);
	    }
	    this.port_ = '' + newPort;
	  } else {
	    this.port_ = null;
	  }
	  return this;
	};
	URI.prototype.hasPort = function () {
	  return null !== this.port_;
	};
	
	
	URI.prototype.getPath = function () {
	  return this.path_ && decodeURIComponent(this.path_);
	};
	URI.prototype.getRawPath = function () {
	  return this.path_;
	};
	URI.prototype.setPath = function (newPath) {
	  return this.setRawPath(encodeIfExists2(newPath, URI_DISALLOWED_IN_PATH_));
	};
	URI.prototype.setRawPath = function (newPath) {
	  if (newPath) {
	    newPath = String(newPath);
	    this.path_ = 
	      // Paths must start with '/' unless this is a path-relative URL.
	      (!this.domain_ || /^\//.test(newPath)) ? newPath : '/' + newPath;
	  } else {
	    this.path_ = null;
	  }
	  return this;
	};
	URI.prototype.hasPath = function () {
	  return null !== this.path_;
	};
	
	
	URI.prototype.getQuery = function () {
	  // From http://www.w3.org/Addressing/URL/4_URI_Recommentations.html
	  // Within the query string, the plus sign is reserved as shorthand notation
	  // for a space.
	  return this.query_ && decodeURIComponent(this.query_).replace(/\+/g, ' ');
	};
	URI.prototype.getRawQuery = function () {
	  return this.query_;
	};
	URI.prototype.setQuery = function (newQuery) {
	  this.paramCache_ = null;
	  this.query_ = encodeIfExists(newQuery);
	  return this;
	};
	URI.prototype.setRawQuery = function (newQuery) {
	  this.paramCache_ = null;
	  this.query_ = newQuery ? newQuery : null;
	  return this;
	};
	URI.prototype.hasQuery = function () {
	  return null !== this.query_;
	};
	
	/**
	 * sets the query given a list of strings of the form
	 * [ key0, value0, key1, value1, ... ].
	 *
	 * <p><code>uri.setAllParameters(['a', 'b', 'c', 'd']).getQuery()</code>
	 * will yield <code>'a=b&c=d'</code>.
	 */
	URI.prototype.setAllParameters = function (params) {
	  if (typeof params === 'object') {
	    if (!(params instanceof Array)
	        && (params instanceof Object
	            || Object.prototype.toString.call(params) !== '[object Array]')) {
	      var newParams = [];
	      var i = -1;
	      for (var k in params) {
	        var v = params[k];
	        if ('string' === typeof v) {
	          newParams[++i] = k;
	          newParams[++i] = v;
	        }
	      }
	      params = newParams;
	    }
	  }
	  this.paramCache_ = null;
	  var queryBuf = [];
	  var separator = '';
	  for (var j = 0; j < params.length;) {
	    var k = params[j++];
	    var v = params[j++];
	    queryBuf.push(separator, encodeURIComponent(k.toString()));
	    separator = '&';
	    if (v) {
	      queryBuf.push('=', encodeURIComponent(v.toString()));
	    }
	  }
	  this.query_ = queryBuf.join('');
	  return this;
	};
	URI.prototype.checkParameterCache_ = function () {
	  if (!this.paramCache_) {
	    var q = this.query_;
	    if (!q) {
	      this.paramCache_ = [];
	    } else {
	      var cgiParams = q.split(/[&\?]/);
	      var out = [];
	      var k = -1;
	      for (var i = 0; i < cgiParams.length; ++i) {
	        var m = cgiParams[i].match(/^([^=]*)(?:=(.*))?$/);
	        // From http://www.w3.org/Addressing/URL/4_URI_Recommentations.html
	        // Within the query string, the plus sign is reserved as shorthand
	        // notation for a space.
	        out[++k] = decodeURIComponent(m[1]).replace(/\+/g, ' ');
	        out[++k] = decodeURIComponent(m[2] || '').replace(/\+/g, ' ');
	      }
	      this.paramCache_ = out;
	    }
	  }
	};
	/**
	 * sets the values of the named cgi parameters.
	 *
	 * <p>So, <code>uri.parse('foo?a=b&c=d&e=f').setParameterValues('c', ['new'])
	 * </code> yields <tt>foo?a=b&c=new&e=f</tt>.</p>
	 *
	 * @param key {string}
	 * @param values {Array.<string>} the new values.  If values is a single string
	 *   then it will be treated as the sole value.
	 */
	URI.prototype.setParameterValues = function (key, values) {
	  // be nice and avoid subtle bugs where [] operator on string performs charAt
	  // on some browsers and crashes on IE
	  if (typeof values === 'string') {
	    values = [ values ];
	  }
	
	  this.checkParameterCache_();
	  var newValueIndex = 0;
	  var pc = this.paramCache_;
	  var params = [];
	  for (var i = 0, k = 0; i < pc.length; i += 2) {
	    if (key === pc[i]) {
	      if (newValueIndex < values.length) {
	        params.push(key, values[newValueIndex++]);
	      }
	    } else {
	      params.push(pc[i], pc[i + 1]);
	    }
	  }
	  while (newValueIndex < values.length) {
	    params.push(key, values[newValueIndex++]);
	  }
	  this.setAllParameters(params);
	  return this;
	};
	URI.prototype.removeParameter = function (key) {
	  return this.setParameterValues(key, []);
	};
	/**
	 * returns the parameters specified in the query part of the uri as a list of
	 * keys and values like [ key0, value0, key1, value1, ... ].
	 *
	 * @return {Array.<string>}
	 */
	URI.prototype.getAllParameters = function () {
	  this.checkParameterCache_();
	  return this.paramCache_.slice(0, this.paramCache_.length);
	};
	/**
	 * returns the value<b>s</b> for a given cgi parameter as a list of decoded
	 * query parameter values.
	 * @return {Array.<string>}
	 */
	URI.prototype.getParameterValues = function (paramNameUnescaped) {
	  this.checkParameterCache_();
	  var values = [];
	  for (var i = 0; i < this.paramCache_.length; i += 2) {
	    if (paramNameUnescaped === this.paramCache_[i]) {
	      values.push(this.paramCache_[i + 1]);
	    }
	  }
	  return values;
	};
	/**
	 * returns a map of cgi parameter names to (non-empty) lists of values.
	 * @return {Object.<string,Array.<string>>}
	 */
	URI.prototype.getParameterMap = function (paramNameUnescaped) {
	  this.checkParameterCache_();
	  var paramMap = {};
	  for (var i = 0; i < this.paramCache_.length; i += 2) {
	    var key = this.paramCache_[i++],
	      value = this.paramCache_[i++];
	    if (!(key in paramMap)) {
	      paramMap[key] = [value];
	    } else {
	      paramMap[key].push(value);
	    }
	  }
	  return paramMap;
	};
	/**
	 * returns the first value for a given cgi parameter or null if the given
	 * parameter name does not appear in the query string.
	 * If the given parameter name does appear, but has no '<tt>=</tt>' following
	 * it, then the empty string will be returned.
	 * @return {string|null}
	 */
	URI.prototype.getParameterValue = function (paramNameUnescaped) {
	  this.checkParameterCache_();
	  for (var i = 0; i < this.paramCache_.length; i += 2) {
	    if (paramNameUnescaped === this.paramCache_[i]) {
	      return this.paramCache_[i + 1];
	    }
	  }
	  return null;
	};
	
	URI.prototype.getFragment = function () {
	  return this.fragment_ && decodeURIComponent(this.fragment_);
	};
	URI.prototype.getRawFragment = function () {
	  return this.fragment_;
	};
	URI.prototype.setFragment = function (newFragment) {
	  this.fragment_ = newFragment ? encodeURIComponent(newFragment) : null;
	  return this;
	};
	URI.prototype.setRawFragment = function (newFragment) {
	  this.fragment_ = newFragment ? newFragment : null;
	  return this;
	};
	URI.prototype.hasFragment = function () {
	  return null !== this.fragment_;
	};
	
	function nullIfAbsent(matchPart) {
	  return ('string' == typeof matchPart) && (matchPart.length > 0)
	         ? matchPart
	         : null;
	}
	
	
	
	
	/**
	 * a regular expression for breaking a URI into its component parts.
	 *
	 * <p>http://www.gbiv.com/protocols/uri/rfc/rfc3986.html#RFC2234 says
	 * As the "first-match-wins" algorithm is identical to the "greedy"
	 * disambiguation method used by POSIX regular expressions, it is natural and
	 * commonplace to use a regular expression for parsing the potential five
	 * components of a URI reference.
	 *
	 * <p>The following line is the regular expression for breaking-down a
	 * well-formed URI reference into its components.
	 *
	 * <pre>
	 * ^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?
	 *  12            3  4          5       6  7        8 9
	 * </pre>
	 *
	 * <p>The numbers in the second line above are only to assist readability; they
	 * indicate the reference points for each subexpression (i.e., each paired
	 * parenthesis). We refer to the value matched for subexpression <n> as $<n>.
	 * For example, matching the above expression to
	 * <pre>
	 *     http://www.ics.uci.edu/pub/ietf/uri/#Related
	 * </pre>
	 * results in the following subexpression matches:
	 * <pre>
	 *    $1 = http:
	 *    $2 = http
	 *    $3 = //www.ics.uci.edu
	 *    $4 = www.ics.uci.edu
	 *    $5 = /pub/ietf/uri/
	 *    $6 = <undefined>
	 *    $7 = <undefined>
	 *    $8 = #Related
	 *    $9 = Related
	 * </pre>
	 * where <undefined> indicates that the component is not present, as is the
	 * case for the query component in the above example. Therefore, we can
	 * determine the value of the five components as
	 * <pre>
	 *    scheme    = $2
	 *    authority = $4
	 *    path      = $5
	 *    query     = $7
	 *    fragment  = $9
	 * </pre>
	 *
	 * <p>msamuel: I have modified the regular expression slightly to expose the
	 * credentials, domain, and port separately from the authority.
	 * The modified version yields
	 * <pre>
	 *    $1 = http              scheme
	 *    $2 = <undefined>       credentials -\
	 *    $3 = www.ics.uci.edu   domain       | authority
	 *    $4 = <undefined>       port        -/
	 *    $5 = /pub/ietf/uri/    path
	 *    $6 = <undefined>       query without ?
	 *    $7 = Related           fragment without #
	 * </pre>
	 */
	var URI_RE_ = new RegExp(
	      "^" +
	      "(?:" +
	        "([^:/?#]+)" +         // scheme
	      ":)?" +
	      "(?://" +
	        "(?:([^/?#]*)@)?" +    // credentials
	        "([^/?#:@]*)" +        // domain
	        "(?::([0-9]+))?" +     // port
	      ")?" +
	      "([^?#]+)?" +            // path
	      "(?:\\?([^#]*))?" +      // query
	      "(?:#(.*))?" +           // fragment
	      "$"
	      );
	
	var URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_ = /[#\/\?@]/g;
	var URI_DISALLOWED_IN_PATH_ = /[\#\?]/g;
	
	URI.parse = parse;
	URI.create = create;
	URI.resolve = resolve;
	URI.collapse_dots = collapse_dots;  // Visible for testing.
	
	// lightweight string-based api for loadModuleMaker
	URI.utils = {
	  mimeTypeOf: function (uri) {
	    var uriObj = parse(uri);
	    if (/\.html$/.test(uriObj.getPath())) {
	      return 'text/html';
	    } else {
	      return 'application/javascript';
	    }
	  },
	  resolve: function (base, uri) {
	    if (base) {
	      return resolve(parse(base), parse(uri)).toString();
	    } else {
	      return '' + uri;
	    }
	  }
	};
	
	
	return URI;
	})();
	
	// Copyright Google Inc.
	// Licensed under the Apache Licence Version 2.0
	// Autogenerated at Mon Feb 25 13:05:42 EST 2013
	// @overrides window
	// @provides html4
	var html4 = {};
	html4.atype = {
	  'NONE': 0,
	  'URI': 1,
	  'URI_FRAGMENT': 11,
	  'SCRIPT': 2,
	  'STYLE': 3,
	  'HTML': 12,
	  'ID': 4,
	  'IDREF': 5,
	  'IDREFS': 6,
	  'GLOBAL_NAME': 7,
	  'LOCAL_NAME': 8,
	  'CLASSES': 9,
	  'FRAME_TARGET': 10,
	  'MEDIA_QUERY': 13
	};
	html4[ 'atype' ] = html4.atype;
	html4.ATTRIBS = {
	  '*::class': 9,
	  '*::dir': 0,
	  '*::draggable': 0,
	  '*::hidden': 0,
	  '*::id': 4,
	  '*::inert': 0,
	  '*::itemprop': 0,
	  '*::itemref': 6,
	  '*::itemscope': 0,
	  '*::lang': 0,
	  '*::onblur': 2,
	  '*::onchange': 2,
	  '*::onclick': 2,
	  '*::ondblclick': 2,
	  '*::onfocus': 2,
	  '*::onkeydown': 2,
	  '*::onkeypress': 2,
	  '*::onkeyup': 2,
	  '*::onload': 2,
	  '*::onmousedown': 2,
	  '*::onmousemove': 2,
	  '*::onmouseout': 2,
	  '*::onmouseover': 2,
	  '*::onmouseup': 2,
	  '*::onreset': 2,
	  '*::onscroll': 2,
	  '*::onselect': 2,
	  '*::onsubmit': 2,
	  '*::onunload': 2,
	  '*::spellcheck': 0,
	  '*::style': 3,
	  '*::title': 0,
	  '*::translate': 0,
	  'a::accesskey': 0,
	  'a::coords': 0,
	  'a::href': 1,
	  'a::hreflang': 0,
	  'a::name': 7,
	  'a::onblur': 2,
	  'a::onfocus': 2,
	  'a::shape': 0,
	  'a::tabindex': 0,
	  'a::target': 10,
	  'a::type': 0,
	  'area::accesskey': 0,
	  'area::alt': 0,
	  'area::coords': 0,
	  'area::href': 1,
	  'area::nohref': 0,
	  'area::onblur': 2,
	  'area::onfocus': 2,
	  'area::shape': 0,
	  'area::tabindex': 0,
	  'area::target': 10,
	  'audio::controls': 0,
	  'audio::loop': 0,
	  'audio::mediagroup': 5,
	  'audio::muted': 0,
	  'audio::preload': 0,
	  'bdo::dir': 0,
	  'blockquote::cite': 1,
	  'br::clear': 0,
	  'button::accesskey': 0,
	  'button::disabled': 0,
	  'button::name': 8,
	  'button::onblur': 2,
	  'button::onfocus': 2,
	  'button::tabindex': 0,
	  'button::type': 0,
	  'button::value': 0,
	  'canvas::height': 0,
	  'canvas::width': 0,
	  'caption::align': 0,
	  'col::align': 0,
	  'col::char': 0,
	  'col::charoff': 0,
	  'col::span': 0,
	  'col::valign': 0,
	  'col::width': 0,
	  'colgroup::align': 0,
	  'colgroup::char': 0,
	  'colgroup::charoff': 0,
	  'colgroup::span': 0,
	  'colgroup::valign': 0,
	  'colgroup::width': 0,
	  'command::checked': 0,
	  'command::command': 5,
	  'command::disabled': 0,
	  'command::icon': 1,
	  'command::label': 0,
	  'command::radiogroup': 0,
	  'command::type': 0,
	  'data::value': 0,
	  'del::cite': 1,
	  'del::datetime': 0,
	  'details::open': 0,
	  'dir::compact': 0,
	  'div::align': 0,
	  'dl::compact': 0,
	  'fieldset::disabled': 0,
	  'font::color': 0,
	  'font::face': 0,
	  'font::size': 0,
	  'form::accept': 0,
	  'form::action': 1,
	  'form::autocomplete': 0,
	  'form::enctype': 0,
	  'form::method': 0,
	  'form::name': 7,
	  'form::novalidate': 0,
	  'form::onreset': 2,
	  'form::onsubmit': 2,
	  'form::target': 10,
	  'h1::align': 0,
	  'h2::align': 0,
	  'h3::align': 0,
	  'h4::align': 0,
	  'h5::align': 0,
	  'h6::align': 0,
	  'hr::align': 0,
	  'hr::noshade': 0,
	  'hr::size': 0,
	  'hr::width': 0,
	  'iframe::align': 0,
	  'iframe::frameborder': 0,
	  'iframe::height': 0,
	  'iframe::marginheight': 0,
	  'iframe::marginwidth': 0,
	  'iframe::width': 0,
	  'img::align': 0,
	  'img::alt': 0,
	  'img::border': 0,
	  'img::height': 0,
	  'img::hspace': 0,
	  'img::ismap': 0,
	  'img::name': 7,
	  'img::src': 1,
	  'img::usemap': 11,
	  'img::vspace': 0,
	  'img::width': 0,
	  'input::accept': 0,
	  'input::accesskey': 0,
	  'input::align': 0,
	  'input::alt': 0,
	  'input::autocomplete': 0,
	  'input::checked': 0,
	  'input::disabled': 0,
	  'input::inputmode': 0,
	  'input::ismap': 0,
	  'input::list': 5,
	  'input::max': 0,
	  'input::maxlength': 0,
	  'input::min': 0,
	  'input::multiple': 0,
	  'input::name': 8,
	  'input::onblur': 2,
	  'input::onchange': 2,
	  'input::onfocus': 2,
	  'input::onselect': 2,
	  'input::placeholder': 0,
	  'input::readonly': 0,
	  'input::required': 0,
	  'input::size': 0,
	  'input::src': 1,
	  'input::step': 0,
	  'input::tabindex': 0,
	  'input::type': 0,
	  'input::usemap': 11,
	  'input::value': 0,
	  'ins::cite': 1,
	  'ins::datetime': 0,
	  'label::accesskey': 0,
	  'label::for': 5,
	  'label::onblur': 2,
	  'label::onfocus': 2,
	  'legend::accesskey': 0,
	  'legend::align': 0,
	  'li::type': 0,
	  'li::value': 0,
	  'map::name': 7,
	  'menu::compact': 0,
	  'menu::label': 0,
	  'menu::type': 0,
	  'meter::high': 0,
	  'meter::low': 0,
	  'meter::max': 0,
	  'meter::min': 0,
	  'meter::value': 0,
	  'ol::compact': 0,
	  'ol::reversed': 0,
	  'ol::start': 0,
	  'ol::type': 0,
	  'optgroup::disabled': 0,
	  'optgroup::label': 0,
	  'option::disabled': 0,
	  'option::label': 0,
	  'option::selected': 0,
	  'option::value': 0,
	  'output::for': 6,
	  'output::name': 8,
	  'p::align': 0,
	  'pre::width': 0,
	  'progress::max': 0,
	  'progress::min': 0,
	  'progress::value': 0,
	  'q::cite': 1,
	  'select::autocomplete': 0,
	  'select::disabled': 0,
	  'select::multiple': 0,
	  'select::name': 8,
	  'select::onblur': 2,
	  'select::onchange': 2,
	  'select::onfocus': 2,
	  'select::required': 0,
	  'select::size': 0,
	  'select::tabindex': 0,
	  'source::type': 0,
	  'table::align': 0,
	  'table::bgcolor': 0,
	  'table::border': 0,
	  'table::cellpadding': 0,
	  'table::cellspacing': 0,
	  'table::frame': 0,
	  'table::rules': 0,
	  'table::summary': 0,
	  'table::width': 0,
	  'tbody::align': 0,
	  'tbody::char': 0,
	  'tbody::charoff': 0,
	  'tbody::valign': 0,
	  'td::abbr': 0,
	  'td::align': 0,
	  'td::axis': 0,
	  'td::bgcolor': 0,
	  'td::char': 0,
	  'td::charoff': 0,
	  'td::colspan': 0,
	  'td::headers': 6,
	  'td::height': 0,
	  'td::nowrap': 0,
	  'td::rowspan': 0,
	  'td::scope': 0,
	  'td::valign': 0,
	  'td::width': 0,
	  'textarea::accesskey': 0,
	  'textarea::autocomplete': 0,
	  'textarea::cols': 0,
	  'textarea::disabled': 0,
	  'textarea::inputmode': 0,
	  'textarea::name': 8,
	  'textarea::onblur': 2,
	  'textarea::onchange': 2,
	  'textarea::onfocus': 2,
	  'textarea::onselect': 2,
	  'textarea::placeholder': 0,
	  'textarea::readonly': 0,
	  'textarea::required': 0,
	  'textarea::rows': 0,
	  'textarea::tabindex': 0,
	  'textarea::wrap': 0,
	  'tfoot::align': 0,
	  'tfoot::char': 0,
	  'tfoot::charoff': 0,
	  'tfoot::valign': 0,
	  'th::abbr': 0,
	  'th::align': 0,
	  'th::axis': 0,
	  'th::bgcolor': 0,
	  'th::char': 0,
	  'th::charoff': 0,
	  'th::colspan': 0,
	  'th::headers': 6,
	  'th::height': 0,
	  'th::nowrap': 0,
	  'th::rowspan': 0,
	  'th::scope': 0,
	  'th::valign': 0,
	  'th::width': 0,
	  'thead::align': 0,
	  'thead::char': 0,
	  'thead::charoff': 0,
	  'thead::valign': 0,
	  'tr::align': 0,
	  'tr::bgcolor': 0,
	  'tr::char': 0,
	  'tr::charoff': 0,
	  'tr::valign': 0,
	  'track::default': 0,
	  'track::kind': 0,
	  'track::label': 0,
	  'track::srclang': 0,
	  'ul::compact': 0,
	  'ul::type': 0,
	  'video::controls': 0,
	  'video::height': 0,
	  'video::loop': 0,
	  'video::mediagroup': 5,
	  'video::muted': 0,
	  'video::poster': 1,
	  'video::preload': 0,
	  'video::width': 0
	};
	html4[ 'ATTRIBS' ] = html4.ATTRIBS;
	html4.eflags = {
	  'OPTIONAL_ENDTAG': 1,
	  'EMPTY': 2,
	  'CDATA': 4,
	  'RCDATA': 8,
	  'UNSAFE': 16,
	  'FOLDABLE': 32,
	  'SCRIPT': 64,
	  'STYLE': 128,
	  'VIRTUALIZED': 256
	};
	html4[ 'eflags' ] = html4.eflags;
	// these are bitmasks of the eflags above.
	html4.ELEMENTS = {
	  'a': 0,
	  'abbr': 0,
	  'acronym': 0,
	  'address': 0,
	  'applet': 272,
	  'area': 2,
	  'article': 0,
	  'aside': 0,
	  'audio': 0,
	  'b': 0,
	  'base': 274,
	  'basefont': 274,
	  'bdi': 0,
	  'bdo': 0,
	  'big': 0,
	  'blockquote': 0,
	  'body': 305,
	  'br': 2,
	  'button': 0,
	  'canvas': 0,
	  'caption': 0,
	  'center': 0,
	  'cite': 0,
	  'code': 0,
	  'col': 2,
	  'colgroup': 1,
	  'command': 2,
	  'data': 0,
	  'datalist': 0,
	  'dd': 1,
	  'del': 0,
	  'details': 0,
	  'dfn': 0,
	  'dialog': 272,
	  'dir': 0,
	  'div': 0,
	  'dl': 0,
	  'dt': 1,
	  'em': 0,
	  'fieldset': 0,
	  'figcaption': 0,
	  'figure': 0,
	  'font': 0,
	  'footer': 0,
	  'form': 0,
	  'frame': 274,
	  'frameset': 272,
	  'h1': 0,
	  'h2': 0,
	  'h3': 0,
	  'h4': 0,
	  'h5': 0,
	  'h6': 0,
	  'head': 305,
	  'header': 0,
	  'hgroup': 0,
	  'hr': 2,
	  'html': 305,
	  'i': 0,
	  'iframe': 16,
	  'img': 2,
	  'input': 2,
	  'ins': 0,
	  'isindex': 274,
	  'kbd': 0,
	  'keygen': 274,
	  'label': 0,
	  'legend': 0,
	  'li': 1,
	  'link': 274,
	  'map': 0,
	  'mark': 0,
	  'menu': 0,
	  'meta': 274,
	  'meter': 0,
	  'nav': 0,
	  'nobr': 0,
	  'noembed': 276,
	  'noframes': 276,
	  'noscript': 276,
	  'object': 272,
	  'ol': 0,
	  'optgroup': 0,
	  'option': 1,
	  'output': 0,
	  'p': 1,
	  'param': 274,
	  'pre': 0,
	  'progress': 0,
	  'q': 0,
	  's': 0,
	  'samp': 0,
	  'script': 84,
	  'section': 0,
	  'select': 0,
	  'small': 0,
	  'source': 2,
	  'span': 0,
	  'strike': 0,
	  'strong': 0,
	  'style': 148,
	  'sub': 0,
	  'summary': 0,
	  'sup': 0,
	  'table': 0,
	  'tbody': 1,
	  'td': 1,
	  'textarea': 8,
	  'tfoot': 1,
	  'th': 1,
	  'thead': 1,
	  'time': 0,
	  'title': 280,
	  'tr': 1,
	  'track': 2,
	  'tt': 0,
	  'u': 0,
	  'ul': 0,
	  'var': 0,
	  'video': 0,
	  'wbr': 2
	};
	html4[ 'ELEMENTS' ] = html4.ELEMENTS;
	html4.ELEMENT_DOM_INTERFACES = {
	  'a': 'HTMLAnchorElement',
	  'abbr': 'HTMLElement',
	  'acronym': 'HTMLElement',
	  'address': 'HTMLElement',
	  'applet': 'HTMLAppletElement',
	  'area': 'HTMLAreaElement',
	  'article': 'HTMLElement',
	  'aside': 'HTMLElement',
	  'audio': 'HTMLAudioElement',
	  'b': 'HTMLElement',
	  'base': 'HTMLBaseElement',
	  'basefont': 'HTMLBaseFontElement',
	  'bdi': 'HTMLElement',
	  'bdo': 'HTMLElement',
	  'big': 'HTMLElement',
	  'blockquote': 'HTMLQuoteElement',
	  'body': 'HTMLBodyElement',
	  'br': 'HTMLBRElement',
	  'button': 'HTMLButtonElement',
	  'canvas': 'HTMLCanvasElement',
	  'caption': 'HTMLTableCaptionElement',
	  'center': 'HTMLElement',
	  'cite': 'HTMLElement',
	  'code': 'HTMLElement',
	  'col': 'HTMLTableColElement',
	  'colgroup': 'HTMLTableColElement',
	  'command': 'HTMLCommandElement',
	  'data': 'HTMLElement',
	  'datalist': 'HTMLDataListElement',
	  'dd': 'HTMLElement',
	  'del': 'HTMLModElement',
	  'details': 'HTMLDetailsElement',
	  'dfn': 'HTMLElement',
	  'dialog': 'HTMLDialogElement',
	  'dir': 'HTMLDirectoryElement',
	  'div': 'HTMLDivElement',
	  'dl': 'HTMLDListElement',
	  'dt': 'HTMLElement',
	  'em': 'HTMLElement',
	  'fieldset': 'HTMLFieldSetElement',
	  'figcaption': 'HTMLElement',
	  'figure': 'HTMLElement',
	  'font': 'HTMLFontElement',
	  'footer': 'HTMLElement',
	  'form': 'HTMLFormElement',
	  'frame': 'HTMLFrameElement',
	  'frameset': 'HTMLFrameSetElement',
	  'h1': 'HTMLHeadingElement',
	  'h2': 'HTMLHeadingElement',
	  'h3': 'HTMLHeadingElement',
	  'h4': 'HTMLHeadingElement',
	  'h5': 'HTMLHeadingElement',
	  'h6': 'HTMLHeadingElement',
	  'head': 'HTMLHeadElement',
	  'header': 'HTMLElement',
	  'hgroup': 'HTMLElement',
	  'hr': 'HTMLHRElement',
	  'html': 'HTMLHtmlElement',
	  'i': 'HTMLElement',
	  'iframe': 'HTMLIFrameElement',
	  'img': 'HTMLImageElement',
	  'input': 'HTMLInputElement',
	  'ins': 'HTMLModElement',
	  'isindex': 'HTMLUnknownElement',
	  'kbd': 'HTMLElement',
	  'keygen': 'HTMLKeygenElement',
	  'label': 'HTMLLabelElement',
	  'legend': 'HTMLLegendElement',
	  'li': 'HTMLLIElement',
	  'link': 'HTMLLinkElement',
	  'map': 'HTMLMapElement',
	  'mark': 'HTMLElement',
	  'menu': 'HTMLMenuElement',
	  'meta': 'HTMLMetaElement',
	  'meter': 'HTMLMeterElement',
	  'nav': 'HTMLElement',
	  'nobr': 'HTMLElement',
	  'noembed': 'HTMLElement',
	  'noframes': 'HTMLElement',
	  'noscript': 'HTMLElement',
	  'object': 'HTMLObjectElement',
	  'ol': 'HTMLOListElement',
	  'optgroup': 'HTMLOptGroupElement',
	  'option': 'HTMLOptionElement',
	  'output': 'HTMLOutputElement',
	  'p': 'HTMLParagraphElement',
	  'param': 'HTMLParamElement',
	  'pre': 'HTMLPreElement',
	  'progress': 'HTMLProgressElement',
	  'q': 'HTMLQuoteElement',
	  's': 'HTMLElement',
	  'samp': 'HTMLElement',
	  'script': 'HTMLScriptElement',
	  'section': 'HTMLElement',
	  'select': 'HTMLSelectElement',
	  'small': 'HTMLElement',
	  'source': 'HTMLSourceElement',
	  'span': 'HTMLSpanElement',
	  'strike': 'HTMLElement',
	  'strong': 'HTMLElement',
	  'style': 'HTMLStyleElement',
	  'sub': 'HTMLElement',
	  'summary': 'HTMLElement',
	  'sup': 'HTMLElement',
	  'table': 'HTMLTableElement',
	  'tbody': 'HTMLTableSectionElement',
	  'td': 'HTMLTableDataCellElement',
	  'textarea': 'HTMLTextAreaElement',
	  'tfoot': 'HTMLTableSectionElement',
	  'th': 'HTMLTableHeaderCellElement',
	  'thead': 'HTMLTableSectionElement',
	  'time': 'HTMLTimeElement',
	  'title': 'HTMLTitleElement',
	  'tr': 'HTMLTableRowElement',
	  'track': 'HTMLTrackElement',
	  'tt': 'HTMLElement',
	  'u': 'HTMLElement',
	  'ul': 'HTMLUListElement',
	  'var': 'HTMLElement',
	  'video': 'HTMLVideoElement',
	  'wbr': 'HTMLElement'
	};
	html4[ 'ELEMENT_DOM_INTERFACES' ] = html4.ELEMENT_DOM_INTERFACES;
	html4.ueffects = {
	  'NOT_LOADED': 0,
	  'SAME_DOCUMENT': 1,
	  'NEW_DOCUMENT': 2
	};
	html4[ 'ueffects' ] = html4.ueffects;
	html4.URIEFFECTS = {
	  'a::href': 2,
	  'area::href': 2,
	  'blockquote::cite': 0,
	  'command::icon': 1,
	  'del::cite': 0,
	  'form::action': 2,
	  'img::src': 1,
	  'input::src': 1,
	  'ins::cite': 0,
	  'q::cite': 0,
	  'video::poster': 1
	};
	html4[ 'URIEFFECTS' ] = html4.URIEFFECTS;
	html4.ltypes = {
	  'UNSANDBOXED': 2,
	  'SANDBOXED': 1,
	  'DATA': 0
	};
	html4[ 'ltypes' ] = html4.ltypes;
	html4.LOADERTYPES = {
	  'a::href': 2,
	  'area::href': 2,
	  'blockquote::cite': 2,
	  'command::icon': 1,
	  'del::cite': 2,
	  'form::action': 2,
	  'img::src': 1,
	  'input::src': 1,
	  'ins::cite': 2,
	  'q::cite': 2,
	  'video::poster': 1
	};
	html4[ 'LOADERTYPES' ] = html4.LOADERTYPES;
	
	// Copyright (C) 2006 Google Inc.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	//      http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	
	/**
	 * @fileoverview
	 * An HTML sanitizer that can satisfy a variety of security policies.
	 *
	 * <p>
	 * The HTML sanitizer is built around a SAX parser and HTML element and
	 * attributes schemas.
	 *
	 * If the cssparser is loaded, inline styles are sanitized using the
	 * css property and value schemas.  Else they are remove during
	 * sanitization.
	 *
	 * If it exists, uses parseCssDeclarations, sanitizeCssProperty,  cssSchema
	 *
	 * @author mikesamuel@gmail.com
	 * @author jasvir@gmail.com
	 * \@requires html4, URI
	 * \@overrides window
	 * \@provides html, html_sanitize
	 */
	
	// The Turkish i seems to be a non-issue, but abort in case it is.
	if ('I'.toLowerCase() !== 'i') { throw 'I/i problem'; }
	
	/**
	 * \@namespace
	 */
	var html = (function(html4) {
	
	  // For closure compiler
	  var parseCssDeclarations, sanitizeCssProperty, cssSchema;
	  if ('undefined' !== typeof window) {
	    parseCssDeclarations = window['parseCssDeclarations'];
	    sanitizeCssProperty = window['sanitizeCssProperty'];
	    cssSchema = window['cssSchema'];
	  }
	
	  // The keys of this object must be 'quoted' or JSCompiler will mangle them!
	  // This is a partial list -- lookupEntity() uses the host browser's parser
	  // (when available) to implement full entity lookup.
	  // Note that entities are in general case-sensitive; the uppercase ones are
	  // explicitly defined by HTML5 (presumably as compatibility).
	  var ENTITIES = {
	    'lt': '<',
	    'LT': '<',
	    'gt': '>',
	    'GT': '>',
	    'amp': '&',
	    'AMP': '&',
	    'quot': '"',
	    'apos': '\'',
	    'nbsp': '\240'
	  };
	
	  // Patterns for types of entity/character reference names.
	  var decimalEscapeRe = /^#(\d+)$/;
	  var hexEscapeRe = /^#x([0-9A-Fa-f]+)$/;
	  // contains every entity per http://www.w3.org/TR/2011/WD-html5-20110113/named-character-references.html
	  var safeEntityNameRe = /^[A-Za-z][A-za-z0-9]+$/;
	  // Used as a hook to invoke the browser's entity parsing. <textarea> is used
	  // because its content is parsed for entities but not tags.
	  // TODO(kpreid): This retrieval is a kludge and leads to silent loss of
	  // functionality if the document isn't available.
	  var entityLookupElement =
	      ('undefined' !== typeof window && window['document'])
	          ? window['document'].createElement('textarea') : null;
	  /**
	   * Decodes an HTML entity.
	   *
	   * {\@updoc
	   * $ lookupEntity('lt')
	   * # '<'
	   * $ lookupEntity('GT')
	   * # '>'
	   * $ lookupEntity('amp')
	   * # '&'
	   * $ lookupEntity('nbsp')
	   * # '\xA0'
	   * $ lookupEntity('apos')
	   * # "'"
	   * $ lookupEntity('quot')
	   * # '"'
	   * $ lookupEntity('#xa')
	   * # '\n'
	   * $ lookupEntity('#10')
	   * # '\n'
	   * $ lookupEntity('#x0a')
	   * # '\n'
	   * $ lookupEntity('#010')
	   * # '\n'
	   * $ lookupEntity('#x00A')
	   * # '\n'
	   * $ lookupEntity('Pi')      // Known failure
	   * # '\u03A0'
	   * $ lookupEntity('pi')      // Known failure
	   * # '\u03C0'
	   * }
	   *
	   * @param {string} name the content between the '&' and the ';'.
	   * @return {string} a single unicode code-point as a string.
	   */
	  function lookupEntity(name) {
	    // TODO: entity lookup as specified by HTML5 actually depends on the
	    // presence of the ";".
	    if (ENTITIES.hasOwnProperty(name)) { return ENTITIES[name]; }
	    var m = name.match(decimalEscapeRe);
	    if (m) {
	      return String.fromCharCode(parseInt(m[1], 10));
	    } else if (!!(m = name.match(hexEscapeRe))) {
	      return String.fromCharCode(parseInt(m[1], 16));
	    } else if (entityLookupElement && safeEntityNameRe.test(name)) {
	      entityLookupElement.innerHTML = '&' + name + ';';
	      var text = entityLookupElement.textContent;
	      ENTITIES[name] = text;
	      return text;
	    } else {
	      return '&' + name + ';';
	    }
	  }
	
	  function decodeOneEntity(_, name) {
	    return lookupEntity(name);
	  }
	
	  var nulRe = /\0/g;
	  function stripNULs(s) {
	    return s.replace(nulRe, '');
	  }
	
	  var ENTITY_RE_1 = /&(#[0-9]+|#[xX][0-9A-Fa-f]+|\w+);/g;
	  var ENTITY_RE_2 = /^(#[0-9]+|#[xX][0-9A-Fa-f]+|\w+);/;
	  /**
	   * The plain text of a chunk of HTML CDATA which possibly containing.
	   *
	   * {\@updoc
	   * $ unescapeEntities('')
	   * # ''
	   * $ unescapeEntities('hello World!')
	   * # 'hello World!'
	   * $ unescapeEntities('1 &lt; 2 &amp;&AMP; 4 &gt; 3&#10;')
	   * # '1 < 2 && 4 > 3\n'
	   * $ unescapeEntities('&lt;&lt <- unfinished entity&gt;')
	   * # '<&lt <- unfinished entity>'
	   * $ unescapeEntities('/foo?bar=baz&copy=true')  // & often unescaped in URLS
	   * # '/foo?bar=baz&copy=true'
	   * $ unescapeEntities('pi=&pi;&#x3c0;, Pi=&Pi;\u03A0') // FIXME: known failure
	   * # 'pi=\u03C0\u03c0, Pi=\u03A0\u03A0'
	   * }
	   *
	   * @param {string} s a chunk of HTML CDATA.  It must not start or end inside
	   *     an HTML entity.
	   */
	  function unescapeEntities(s) {
	    return s.replace(ENTITY_RE_1, decodeOneEntity);
	  }
	
	  var ampRe = /&/g;
	  var looseAmpRe = /&([^a-z#]|#(?:[^0-9x]|x(?:[^0-9a-f]|$)|$)|$)/gi;
	  var ltRe = /[<]/g;
	  var gtRe = />/g;
	  var quotRe = /\"/g;
	
	  /**
	   * Escapes HTML special characters in attribute values.
	   *
	   * {\@updoc
	   * $ escapeAttrib('')
	   * # ''
	   * $ escapeAttrib('"<<&==&>>"')  // Do not just escape the first occurrence.
	   * # '&#34;&lt;&lt;&amp;&#61;&#61;&amp;&gt;&gt;&#34;'
	   * $ escapeAttrib('Hello <World>!')
	   * # 'Hello &lt;World&gt;!'
	   * }
	   */
	  function escapeAttrib(s) {
	    return ('' + s).replace(ampRe, '&amp;').replace(ltRe, '&lt;')
	        .replace(gtRe, '&gt;').replace(quotRe, '&#34;');
	  }
	
	  /**
	   * Escape entities in RCDATA that can be escaped without changing the meaning.
	   * {\@updoc
	   * $ normalizeRCData('1 < 2 &&amp; 3 > 4 &amp;& 5 &lt; 7&8')
	   * # '1 &lt; 2 &amp;&amp; 3 &gt; 4 &amp;&amp; 5 &lt; 7&amp;8'
	   * }
	   */
	  function normalizeRCData(rcdata) {
	    return rcdata
	        .replace(looseAmpRe, '&amp;$1')
	        .replace(ltRe, '&lt;')
	        .replace(gtRe, '&gt;');
	  }
	
	  // TODO(felix8a): validate sanitizer regexs against the HTML5 grammar at
	  // http://www.whatwg.org/specs/web-apps/current-work/multipage/syntax.html
	  // http://www.whatwg.org/specs/web-apps/current-work/multipage/parsing.html
	  // http://www.whatwg.org/specs/web-apps/current-work/multipage/tokenization.html
	  // http://www.whatwg.org/specs/web-apps/current-work/multipage/tree-construction.html
	
	  // We initially split input so that potentially meaningful characters
	  // like '<' and '>' are separate tokens, using a fast dumb process that
	  // ignores quoting.  Then we walk that token stream, and when we see a
	  // '<' that's the start of a tag, we use ATTR_RE to extract tag
	  // attributes from the next token.  That token will never have a '>'
	  // character.  However, it might have an unbalanced quote character, and
	  // when we see that, we combine additional tokens to balance the quote.
	
	  var ATTR_RE = new RegExp(
	    '^\\s*' +
	    '([-.:\\w]+)' +             // 1 = Attribute name
	    '(?:' + (
	      '\\s*(=)\\s*' +           // 2 = Is there a value?
	      '(' + (                   // 3 = Attribute value
	        // TODO(felix8a): maybe use backref to match quotes
	        '(\")[^\"]*(\"|$)' +    // 4, 5 = Double-quoted string
	        '|' +
	        '(\')[^\']*(\'|$)' +    // 6, 7 = Single-quoted string
	        '|' +
	        // Positive lookahead to prevent interpretation of
	        // <foo a= b=c> as <foo a='b=c'>
	        // TODO(felix8a): might be able to drop this case
	        '(?=[a-z][-\\w]*\\s*=)' +
	        '|' +
	        // Unquoted value that isn't an attribute name
	        // (since we didn't match the positive lookahead above)
	        '[^\"\'\\s]*' ) +
	      ')' ) +
	    ')?',
	    'i');
	
	  // false on IE<=8, true on most other browsers
	  var splitWillCapture = ('a,b'.split(/(,)/).length === 3);
	
	  // bitmask for tags with special parsing, like <script> and <textarea>
	  var EFLAGS_TEXT = html4.eflags['CDATA'] | html4.eflags['RCDATA'];
	
	  /**
	   * Given a SAX-like event handler, produce a function that feeds those
	   * events and a parameter to the event handler.
	   *
	   * The event handler has the form:{@code
	   * {
	   *   // Name is an upper-case HTML tag name.  Attribs is an array of
	   *   // alternating upper-case attribute names, and attribute values.  The
	   *   // attribs array is reused by the parser.  Param is the value passed to
	   *   // the saxParser.
	   *   startTag: function (name, attribs, param) { ... },
	   *   endTag:   function (name, param) { ... },
	   *   pcdata:   function (text, param) { ... },
	   *   rcdata:   function (text, param) { ... },
	   *   cdata:    function (text, param) { ... },
	   *   startDoc: function (param) { ... },
	   *   endDoc:   function (param) { ... }
	   * }}
	   *
	   * @param {Object} handler a record containing event handlers.
	   * @return {function(string, Object)} A function that takes a chunk of HTML
	   *     and a parameter.  The parameter is passed on to the handler methods.
	   */
	  function makeSaxParser(handler) {
	    // Accept quoted or unquoted keys (Closure compat)
	    var hcopy = {
	      cdata: handler.cdata || handler['cdata'],
	      comment: handler.comment || handler['comment'],
	      endDoc: handler.endDoc || handler['endDoc'],
	      endTag: handler.endTag || handler['endTag'],
	      pcdata: handler.pcdata || handler['pcdata'],
	      rcdata: handler.rcdata || handler['rcdata'],
	      startDoc: handler.startDoc || handler['startDoc'],
	      startTag: handler.startTag || handler['startTag']
	    };
	    return function(htmlText, param) {
	      return parse(htmlText, hcopy, param);
	    };
	  }
	
	  // Parsing strategy is to split input into parts that might be lexically
	  // meaningful (every ">" becomes a separate part), and then recombine
	  // parts if we discover they're in a different context.
	
	  // TODO(felix8a): Significant performance regressions from -legacy,
	  // tested on
	  //    Chrome 18.0
	  //    Firefox 11.0
	  //    IE 6, 7, 8, 9
	  //    Opera 11.61
	  //    Safari 5.1.3
	  // Many of these are unusual patterns that are linearly slower and still
	  // pretty fast (eg 1ms to 5ms), so not necessarily worth fixing.
	
	  // TODO(felix8a): "<script> && && && ... <\/script>" is slower on all
	  // browsers.  The hotspot is htmlSplit.
	
	  // TODO(felix8a): "<p title='>>>>...'><\/p>" is slower on all browsers.
	  // This is partly htmlSplit, but the hotspot is parseTagAndAttrs.
	
	  // TODO(felix8a): "<a><\/a><a><\/a>..." is slower on IE9.
	  // "<a>1<\/a><a>1<\/a>..." is faster, "<a><\/a>2<a><\/a>2..." is faster.
	
	  // TODO(felix8a): "<p<p<p..." is slower on IE[6-8]
	
	  var continuationMarker = {};
	  function parse(htmlText, handler, param) {
	    var m, p, tagName;
	    var parts = htmlSplit(htmlText);
	    var state = {
	      noMoreGT: false,
	      noMoreEndComments: false
	    };
	    parseCPS(handler, parts, 0, state, param);
	  }
	
	  function continuationMaker(h, parts, initial, state, param) {
	    return function () {
	      parseCPS(h, parts, initial, state, param);
	    };
	  }
	
	  function parseCPS(h, parts, initial, state, param) {
	    try {
	      if (h.startDoc && initial == 0) { h.startDoc(param); }
	      var m, p, tagName;
	      for (var pos = initial, end = parts.length; pos < end;) {
	        var current = parts[pos++];
	        var next = parts[pos];
	        switch (current) {
	        case '&':
	          if (ENTITY_RE_2.test(next)) {
	            if (h.pcdata) {
	              h.pcdata('&' + next, param, continuationMarker,
	                continuationMaker(h, parts, pos, state, param));
	            }
	            pos++;
	          } else {
	            if (h.pcdata) { h.pcdata("&amp;", param, continuationMarker,
	                continuationMaker(h, parts, pos, state, param));
	            }
	          }
	          break;
	        case '<\/':
	          if (m = /^([-\w:]+)[^\'\"]*/.exec(next)) {
	            if (m[0].length === next.length && parts[pos + 1] === '>') {
	              // fast case, no attribute parsing needed
	              pos += 2;
	              tagName = m[1].toLowerCase();
	              if (h.endTag) {
	                h.endTag(tagName, param, continuationMarker,
	                  continuationMaker(h, parts, pos, state, param));
	              }
	            } else {
	              // slow case, need to parse attributes
	              // TODO(felix8a): do we really care about misparsing this?
	              pos = parseEndTag(
	                parts, pos, h, param, continuationMarker, state);
	            }
	          } else {
	            if (h.pcdata) {
	              h.pcdata('&lt;/', param, continuationMarker,
	                continuationMaker(h, parts, pos, state, param));
	            }
	          }
	          break;
	        case '<':
	          if (m = /^([-\w:]+)\s*\/?/.exec(next)) {
	            if (m[0].length === next.length && parts[pos + 1] === '>') {
	              // fast case, no attribute parsing needed
	              pos += 2;
	              tagName = m[1].toLowerCase();
	              if (h.startTag) {
	                h.startTag(tagName, [], param, continuationMarker,
	                  continuationMaker(h, parts, pos, state, param));
	              }
	              // tags like <script> and <textarea> have special parsing
	              var eflags = html4.ELEMENTS[tagName];
	              if (eflags & EFLAGS_TEXT) {
	                var tag = { name: tagName, next: pos, eflags: eflags };
	                pos = parseText(
	                  parts, tag, h, param, continuationMarker, state);
	              }
	            } else {
	              // slow case, need to parse attributes
	              pos = parseStartTag(
	                parts, pos, h, param, continuationMarker, state);
	            }
	          } else {
	            if (h.pcdata) {
	              h.pcdata('&lt;', param, continuationMarker,
	                continuationMaker(h, parts, pos, state, param));
	            }
	          }
	          break;
	        case '<\!--':
	          // The pathological case is n copies of '<\!--' without '-->', and
	          // repeated failure to find '-->' is quadratic.  We avoid that by
	          // remembering when search for '-->' fails.
	          if (!state.noMoreEndComments) {
	            // A comment <\!--x--> is split into three tokens:
	            //   '<\!--', 'x--', '>'
	            // We want to find the next '>' token that has a preceding '--'.
	            // pos is at the 'x--'.
	            for (p = pos + 1; p < end; p++) {
	              if (parts[p] === '>' && /--$/.test(parts[p - 1])) { break; }
	            }
	            if (p < end) {
	              if (h.comment) {
	                var comment = parts.slice(pos, p).join('');
	                h.comment(
	                  comment.substr(0, comment.length - 2), param,
	                  continuationMarker,
	                  continuationMaker(h, parts, p + 1, state, param));
	              }
	              pos = p + 1;
	            } else {
	              state.noMoreEndComments = true;
	            }
	          }
	          if (state.noMoreEndComments) {
	            if (h.pcdata) {
	              h.pcdata('&lt;!--', param, continuationMarker,
	                continuationMaker(h, parts, pos, state, param));
	            }
	          }
	          break;
	        case '<\!':
	          if (!/^\w/.test(next)) {
	            if (h.pcdata) {
	              h.pcdata('&lt;!', param, continuationMarker,
	                continuationMaker(h, parts, pos, state, param));
	            }
	          } else {
	            // similar to noMoreEndComment logic
	            if (!state.noMoreGT) {
	              for (p = pos + 1; p < end; p++) {
	                if (parts[p] === '>') { break; }
	              }
	              if (p < end) {
	                pos = p + 1;
	              } else {
	                state.noMoreGT = true;
	              }
	            }
	            if (state.noMoreGT) {
	              if (h.pcdata) {
	                h.pcdata('&lt;!', param, continuationMarker,
	                  continuationMaker(h, parts, pos, state, param));
	              }
	            }
	          }
	          break;
	        case '<?':
	          // similar to noMoreEndComment logic
	          if (!state.noMoreGT) {
	            for (p = pos + 1; p < end; p++) {
	              if (parts[p] === '>') { break; }
	            }
	            if (p < end) {
	              pos = p + 1;
	            } else {
	              state.noMoreGT = true;
	            }
	          }
	          if (state.noMoreGT) {
	            if (h.pcdata) {
	              h.pcdata('&lt;?', param, continuationMarker,
	                continuationMaker(h, parts, pos, state, param));
	            }
	          }
	          break;
	        case '>':
	          if (h.pcdata) {
	            h.pcdata("&gt;", param, continuationMarker,
	              continuationMaker(h, parts, pos, state, param));
	          }
	          break;
	        case '':
	          break;
	        default:
	          if (h.pcdata) {
	            h.pcdata(current, param, continuationMarker,
	              continuationMaker(h, parts, pos, state, param));
	          }
	          break;
	        }
	      }
	      if (h.endDoc) { h.endDoc(param); }
	    } catch (e) {
	      if (e !== continuationMarker) { throw e; }
	    }
	  }
	
	  // Split str into parts for the html parser.
	  function htmlSplit(str) {
	    // can't hoist this out of the function because of the re.exec loop.
	    var re = /(<\/|<\!--|<[!?]|[&<>])/g;
	    str += '';
	    if (splitWillCapture) {
	      return str.split(re);
	    } else {
	      var parts = [];
	      var lastPos = 0;
	      var m;
	      while ((m = re.exec(str)) !== null) {
	        parts.push(str.substring(lastPos, m.index));
	        parts.push(m[0]);
	        lastPos = m.index + m[0].length;
	      }
	      parts.push(str.substring(lastPos));
	      return parts;
	    }
	  }
	
	  function parseEndTag(parts, pos, h, param, continuationMarker, state) {
	    var tag = parseTagAndAttrs(parts, pos);
	    // drop unclosed tags
	    if (!tag) { return parts.length; }
	    if (h.endTag) {
	      h.endTag(tag.name, param, continuationMarker,
	        continuationMaker(h, parts, pos, state, param));
	    }
	    return tag.next;
	  }
	
	  function parseStartTag(parts, pos, h, param, continuationMarker, state) {
	    var tag = parseTagAndAttrs(parts, pos);
	    // drop unclosed tags
	    if (!tag) { return parts.length; }
	    if (h.startTag) {
	      h.startTag(tag.name, tag.attrs, param, continuationMarker,
	        continuationMaker(h, parts, tag.next, state, param));
	    }
	    // tags like <script> and <textarea> have special parsing
	    if (tag.eflags & EFLAGS_TEXT) {
	      return parseText(parts, tag, h, param, continuationMarker, state);
	    } else {
	      return tag.next;
	    }
	  }
	
	  var endTagRe = {};
	
	  // Tags like <script> and <textarea> are flagged as CDATA or RCDATA,
	  // which means everything is text until we see the correct closing tag.
	  function parseText(parts, tag, h, param, continuationMarker, state) {
	    var end = parts.length;
	    if (!endTagRe.hasOwnProperty(tag.name)) {
	      endTagRe[tag.name] = new RegExp('^' + tag.name + '(?:[\\s\\/]|$)', 'i');
	    }
	    var re = endTagRe[tag.name];
	    var first = tag.next;
	    var p = tag.next + 1;
	    for (; p < end; p++) {
	      if (parts[p - 1] === '<\/' && re.test(parts[p])) { break; }
	    }
	    if (p < end) { p -= 1; }
	    var buf = parts.slice(first, p).join('');
	    if (tag.eflags & html4.eflags['CDATA']) {
	      if (h.cdata) {
	        h.cdata(buf, param, continuationMarker,
	          continuationMaker(h, parts, p, state, param));
	      }
	    } else if (tag.eflags & html4.eflags['RCDATA']) {
	      if (h.rcdata) {
	        h.rcdata(normalizeRCData(buf), param, continuationMarker,
	          continuationMaker(h, parts, p, state, param));
	      }
	    } else {
	      throw new Error('bug');
	    }
	    return p;
	  }
	
	  // at this point, parts[pos-1] is either "<" or "<\/".
	  function parseTagAndAttrs(parts, pos) {
	    var m = /^([-\w:]+)/.exec(parts[pos]);
	    var tag = {};
	    tag.name = m[1].toLowerCase();
	    tag.eflags = html4.ELEMENTS[tag.name];
	    var buf = parts[pos].substr(m[0].length);
	    // Find the next '>'.  We optimistically assume this '>' is not in a
	    // quoted context, and further down we fix things up if it turns out to
	    // be quoted.
	    var p = pos + 1;
	    var end = parts.length;
	    for (; p < end; p++) {
	      if (parts[p] === '>') { break; }
	      buf += parts[p];
	    }
	    if (end <= p) { return void 0; }
	    var attrs = [];
	    while (buf !== '') {
	      m = ATTR_RE.exec(buf);
	      if (!m) {
	        // No attribute found: skip garbage
	        buf = buf.replace(/^[\s\S][^a-z\s]*/, '');
	
	      } else if ((m[4] && !m[5]) || (m[6] && !m[7])) {
	        // Unterminated quote: slurp to the next unquoted '>'
	        var quote = m[4] || m[6];
	        var sawQuote = false;
	        var abuf = [buf, parts[p++]];
	        for (; p < end; p++) {
	          if (sawQuote) {
	            if (parts[p] === '>') { break; }
	          } else if (0 <= parts[p].indexOf(quote)) {
	            sawQuote = true;
	          }
	          abuf.push(parts[p]);
	        }
	        // Slurp failed: lose the garbage
	        if (end <= p) { break; }
	        // Otherwise retry attribute parsing
	        buf = abuf.join('');
	        continue;
	
	      } else {
	        // We have an attribute
	        var aName = m[1].toLowerCase();
	        var aValue = m[2] ? decodeValue(m[3]) : '';
	        attrs.push(aName, aValue);
	        buf = buf.substr(m[0].length);
	      }
	    }
	    tag.attrs = attrs;
	    tag.next = p + 1;
	    return tag;
	  }
	
	  function decodeValue(v) {
	    var q = v.charCodeAt(0);
	    if (q === 0x22 || q === 0x27) { // " or '
	      v = v.substr(1, v.length - 2);
	    }
	    return unescapeEntities(stripNULs(v));
	  }
	
	  /**
	   * Returns a function that strips unsafe tags and attributes from html.
	   * @param {function(string, Array.<string>): ?Array.<string>} tagPolicy
	   *     A function that takes (tagName, attribs[]), where tagName is a key in
	   *     html4.ELEMENTS and attribs is an array of alternating attribute names
	   *     and values.  It should return a record (as follows), or null to delete
	   *     the element.  It's okay for tagPolicy to modify the attribs array,
	   *     but the same array is reused, so it should not be held between calls.
	   *     Record keys:
	   *        attribs: (required) Sanitized attributes array.
	   *        tagName: Replacement tag name.
	   * @return {function(string, Array)} A function that sanitizes a string of
	   *     HTML and appends result strings to the second argument, an array.
	   */
	  function makeHtmlSanitizer(tagPolicy) {
	    var stack;
	    var ignoring;
	    var emit = function (text, out) {
	      if (!ignoring) { out.push(text); }
	    };
	    return makeSaxParser({
	      'startDoc': function(_) {
	        stack = [];
	        ignoring = false;
	      },
	      'startTag': function(tagNameOrig, attribs, out) {
	        if (ignoring) { return; }
	        if (!html4.ELEMENTS.hasOwnProperty(tagNameOrig)) { return; }
	        var eflagsOrig = html4.ELEMENTS[tagNameOrig];
	        if (eflagsOrig & html4.eflags['FOLDABLE']) {
	          return;
	        }
	
	        var decision = tagPolicy(tagNameOrig, attribs);
	        if (!decision) {
	          ignoring = !(eflagsOrig & html4.eflags['EMPTY']);
	          return;
	        } else if (typeof decision !== 'object') {
	          throw new Error('tagPolicy did not return object (old API?)');
	        }
	        if ('attribs' in decision) {
	          attribs = decision['attribs'];
	        } else {
	          throw new Error('tagPolicy gave no attribs');
	        }
	        var eflagsRep;
	        var tagNameRep;
	        if ('tagName' in decision) {
	          tagNameRep = decision['tagName'];
	          eflagsRep = html4.ELEMENTS[tagNameRep];
	        } else {
	          tagNameRep = tagNameOrig;
	          eflagsRep = eflagsOrig;
	        }
	        // TODO(mikesamuel): relying on tagPolicy not to insert unsafe
	        // attribute names.
	
	        // If this is an optional-end-tag element and either this element or its
	        // previous like sibling was rewritten, then insert a close tag to
	        // preserve structure.
	        if (eflagsOrig & html4.eflags['OPTIONAL_ENDTAG']) {
	          var onStack = stack[stack.length - 1];
	          if (onStack && onStack.orig === tagNameOrig &&
	              (onStack.rep !== tagNameRep || tagNameOrig !== tagNameRep)) {
	                out.push('<\/', onStack.rep, '>');
	          }
	        }
	
	        if (!(eflagsOrig & html4.eflags['EMPTY'])) {
	          stack.push({orig: tagNameOrig, rep: tagNameRep});
	        }
	
	        out.push('<', tagNameRep);
	        for (var i = 0, n = attribs.length; i < n; i += 2) {
	          var attribName = attribs[i],
	              value = attribs[i + 1];
	          if (value !== null && value !== void 0) {
	            out.push(' ', attribName, '="', escapeAttrib(value), '"');
	          }
	        }
	        out.push('>');
	
	        if ((eflagsOrig & html4.eflags['EMPTY'])
	            && !(eflagsRep & html4.eflags['EMPTY'])) {
	          // replacement is non-empty, synthesize end tag
	          out.push('<\/', tagNameRep, '>');
	        }
	      },
	      'endTag': function(tagName, out) {
	        if (ignoring) {
	          ignoring = false;
	          return;
	        }
	        if (!html4.ELEMENTS.hasOwnProperty(tagName)) { return; }
	        var eflags = html4.ELEMENTS[tagName];
	        if (!(eflags & (html4.eflags['EMPTY'] | html4.eflags['FOLDABLE']))) {
	          var index;
	          if (eflags & html4.eflags['OPTIONAL_ENDTAG']) {
	            for (index = stack.length; --index >= 0;) {
	              var stackElOrigTag = stack[index].orig;
	              if (stackElOrigTag === tagName) { break; }
	              if (!(html4.ELEMENTS[stackElOrigTag] &
	                    html4.eflags['OPTIONAL_ENDTAG'])) {
	                // Don't pop non optional end tags looking for a match.
	                return;
	              }
	            }
	          } else {
	            for (index = stack.length; --index >= 0;) {
	              if (stack[index].orig === tagName) { break; }
	            }
	          }
	          if (index < 0) { return; }  // Not opened.
	          for (var i = stack.length; --i > index;) {
	            var stackElRepTag = stack[i].rep;
	            if (!(html4.ELEMENTS[stackElRepTag] &
	                  html4.eflags['OPTIONAL_ENDTAG'])) {
	              out.push('<\/', stackElRepTag, '>');
	            }
	          }
	          if (index < stack.length) {
	            tagName = stack[index].rep;
	          }
	          stack.length = index;
	          out.push('<\/', tagName, '>');
	        }
	      },
	      'pcdata': emit,
	      'rcdata': emit,
	      'cdata': emit,
	      'endDoc': function(out) {
	        for (; stack.length; stack.length--) {
	          out.push('<\/', stack[stack.length - 1].rep, '>');
	        }
	      }
	    });
	  }
	
	  var ALLOWED_URI_SCHEMES = /^(?:https?|mailto|data)$/i;
	
	  function safeUri(uri, effect, ltype, hints, naiveUriRewriter) {
	    if (!naiveUriRewriter) { return null; }
	    try {
	      var parsed = URI.parse('' + uri);
	      if (parsed) {
	        if (!parsed.hasScheme() ||
	            ALLOWED_URI_SCHEMES.test(parsed.getScheme())) {
	          var safe = naiveUriRewriter(parsed, effect, ltype, hints);
	          return safe ? safe.toString() : null;
	        }
	      }
	    } catch (e) {
	      return null;
	    }
	    return null;
	  }
	
	  function log(logger, tagName, attribName, oldValue, newValue) {
	    if (!attribName) {
	      logger(tagName + " removed", {
	        change: "removed",
	        tagName: tagName
	      });
	    }
	    if (oldValue !== newValue) {
	      var changed = "changed";
	      if (oldValue && !newValue) {
	        changed = "removed";
	      } else if (!oldValue && newValue)  {
	        changed = "added";
	      }
	      logger(tagName + "." + attribName + " " + changed, {
	        change: changed,
	        tagName: tagName,
	        attribName: attribName,
	        oldValue: oldValue,
	        newValue: newValue
	      });
	    }
	  }
	
	  function lookupAttribute(map, tagName, attribName) {
	    var attribKey;
	    attribKey = tagName + '::' + attribName;
	    if (map.hasOwnProperty(attribKey)) {
	      return map[attribKey];
	    }
	    attribKey = '*::' + attribName;
	    if (map.hasOwnProperty(attribKey)) {
	      return map[attribKey];
	    }
	    return void 0;
	  }
	  function getAttributeType(tagName, attribName) {
	    return lookupAttribute(html4.ATTRIBS, tagName, attribName);
	  }
	  function getLoaderType(tagName, attribName) {
	    return lookupAttribute(html4.LOADERTYPES, tagName, attribName);
	  }
	  function getUriEffect(tagName, attribName) {
	    return lookupAttribute(html4.URIEFFECTS, tagName, attribName);
	  }
	
	  /**
	   * Sanitizes attributes on an HTML tag.
	   * @param {string} tagName An HTML tag name in lowercase.
	   * @param {Array.<?string>} attribs An array of alternating names and values.
	   * @param {?function(?string): ?string} opt_naiveUriRewriter A transform to
	   *     apply to URI attributes; it can return a new string value, or null to
	   *     delete the attribute.  If unspecified, URI attributes are deleted.
	   * @param {function(?string): ?string} opt_nmTokenPolicy A transform to apply
	   *     to attributes containing HTML names, element IDs, and space-separated
	   *     lists of classes; it can return a new string value, or null to delete
	   *     the attribute.  If unspecified, these attributes are kept unchanged.
	   * @return {Array.<?string>} The sanitized attributes as a list of alternating
	   *     names and values, where a null value means to omit the attribute.
	   */
	  function sanitizeAttribs(tagName, attribs,
	    opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger) {
	    // TODO(felix8a): it's obnoxious that domado duplicates much of this
	    // TODO(felix8a): maybe consistently enforce constraints like target=
	    for (var i = 0; i < attribs.length; i += 2) {
	      var attribName = attribs[i];
	      var value = attribs[i + 1];
	      var oldValue = value;
	      var atype = null, attribKey;
	      if ((attribKey = tagName + '::' + attribName,
	           html4.ATTRIBS.hasOwnProperty(attribKey)) ||
	          (attribKey = '*::' + attribName,
	           html4.ATTRIBS.hasOwnProperty(attribKey))) {
	        atype = html4.ATTRIBS[attribKey];
	      }
	      if (atype !== null) {
	        switch (atype) {
	          case html4.atype['NONE']: break;
	          case html4.atype['SCRIPT']:
	            value = null;
	            if (opt_logger) {
	              log(opt_logger, tagName, attribName, oldValue, value);
	            }
	            break;
	          case html4.atype['STYLE']:
	            if ('undefined' === typeof parseCssDeclarations) {
	              value = null;
	              if (opt_logger) {
	                log(opt_logger, tagName, attribName, oldValue, value);
		      }
	              break;
	            }
	            var sanitizedDeclarations = [];
	            parseCssDeclarations(
	                value,
	                {
	                  declaration: function (property, tokens) {
	                    var normProp = property.toLowerCase();
	                    var schema = cssSchema[normProp];
	                    if (!schema) {
	                      return;
	                    }
	                    sanitizeCssProperty(
	                        normProp, schema, tokens,
	                        opt_naiveUriRewriter
	                        ? function (url) {
	                            return safeUri(
	                                url, html4.ueffects.SAME_DOCUMENT,
	                                html4.ltypes.SANDBOXED,
	                                {
	                                  "TYPE": "CSS",
	                                  "CSS_PROP": normProp
	                                }, opt_naiveUriRewriter);
	                          }
	                        : null);
	                    sanitizedDeclarations.push(property + ': ' + tokens.join(' '));
	                  }
	                });
	            value = sanitizedDeclarations.length > 0 ?
	              sanitizedDeclarations.join(' ; ') : null;
	            if (opt_logger) {
	              log(opt_logger, tagName, attribName, oldValue, value);
	            }
	            break;
	          case html4.atype['ID']:
	          case html4.atype['IDREF']:
	          case html4.atype['IDREFS']:
	          case html4.atype['GLOBAL_NAME']:
	          case html4.atype['LOCAL_NAME']:
	          case html4.atype['CLASSES']:
	            value = opt_nmTokenPolicy ? opt_nmTokenPolicy(value) : value;
	            if (opt_logger) {
	              log(opt_logger, tagName, attribName, oldValue, value);
	            }
	            break;
	          case html4.atype['URI']:
	            value = safeUri(value,
	              getUriEffect(tagName, attribName),
	              getLoaderType(tagName, attribName),
	              {
	                "TYPE": "MARKUP",
	                "XML_ATTR": attribName,
	                "XML_TAG": tagName
	              }, opt_naiveUriRewriter);
	              if (opt_logger) {
	              log(opt_logger, tagName, attribName, oldValue, value);
	            }
	            break;
	          case html4.atype['URI_FRAGMENT']:
	            if (value && '#' === value.charAt(0)) {
	              value = value.substring(1);  // remove the leading '#'
	              value = opt_nmTokenPolicy ? opt_nmTokenPolicy(value) : value;
	              if (value !== null && value !== void 0) {
	                value = '#' + value;  // restore the leading '#'
	              }
	            } else {
	              value = null;
	            }
	            if (opt_logger) {
	              log(opt_logger, tagName, attribName, oldValue, value);
	            }
	            break;
	          default:
	            value = null;
	            if (opt_logger) {
	              log(opt_logger, tagName, attribName, oldValue, value);
	            }
	            break;
	        }
	      } else {
	        value = null;
	        if (opt_logger) {
	          log(opt_logger, tagName, attribName, oldValue, value);
	        }
	      }
	      attribs[i + 1] = value;
	    }
	    return attribs;
	  }
	
	  /**
	   * Creates a tag policy that omits all tags marked UNSAFE in html4-defs.js
	   * and applies the default attribute sanitizer with the supplied policy for
	   * URI attributes and NMTOKEN attributes.
	   * @param {?function(?string): ?string} opt_naiveUriRewriter A transform to
	   *     apply to URI attributes.  If not given, URI attributes are deleted.
	   * @param {function(?string): ?string} opt_nmTokenPolicy A transform to apply
	   *     to attributes containing HTML names, element IDs, and space-separated
	   *     lists of classes.  If not given, such attributes are left unchanged.
	   * @return {function(string, Array.<?string>)} A tagPolicy suitable for
	   *     passing to html.sanitize.
	   */
	  function makeTagPolicy(
	    opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger) {
	    return function(tagName, attribs) {
	      if (!(html4.ELEMENTS[tagName] & html4.eflags['UNSAFE'])) {
	        return {
	          'attribs': sanitizeAttribs(tagName, attribs,
	            opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger)
	        };
	      } else {
	        if (opt_logger) {
	          log(opt_logger, tagName, undefined, undefined, undefined);
	        }
	      }
	    };
	  }
	
	  /**
	   * Sanitizes HTML tags and attributes according to a given policy.
	   * @param {string} inputHtml The HTML to sanitize.
	   * @param {function(string, Array.<?string>)} tagPolicy A function that
	   *     decides which tags to accept and sanitizes their attributes (see
	   *     makeHtmlSanitizer above for details).
	   * @return {string} The sanitized HTML.
	   */
	  function sanitizeWithPolicy(inputHtml, tagPolicy) {
	    var outputArray = [];
	    makeHtmlSanitizer(tagPolicy)(inputHtml, outputArray);
	    return outputArray.join('');
	  }
	
	  /**
	   * Strips unsafe tags and attributes from HTML.
	   * @param {string} inputHtml The HTML to sanitize.
	   * @param {?function(?string): ?string} opt_naiveUriRewriter A transform to
	   *     apply to URI attributes.  If not given, URI attributes are deleted.
	   * @param {function(?string): ?string} opt_nmTokenPolicy A transform to apply
	   *     to attributes containing HTML names, element IDs, and space-separated
	   *     lists of classes.  If not given, such attributes are left unchanged.
	   */
	  function sanitize(inputHtml,
	    opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger) {
	    var tagPolicy = makeTagPolicy(
	      opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger);
	    return sanitizeWithPolicy(inputHtml, tagPolicy);
	  }
	
	  // Export both quoted and unquoted names for Closure linkage.
	  var html = {};
	  html.escapeAttrib = html['escapeAttrib'] = escapeAttrib;
	  html.makeHtmlSanitizer = html['makeHtmlSanitizer'] = makeHtmlSanitizer;
	  html.makeSaxParser = html['makeSaxParser'] = makeSaxParser;
	  html.makeTagPolicy = html['makeTagPolicy'] = makeTagPolicy;
	  html.normalizeRCData = html['normalizeRCData'] = normalizeRCData;
	  html.sanitize = html['sanitize'] = sanitize;
	  html.sanitizeAttribs = html['sanitizeAttribs'] = sanitizeAttribs;
	  html.sanitizeWithPolicy = html['sanitizeWithPolicy'] = sanitizeWithPolicy;
	  html.unescapeEntities = html['unescapeEntities'] = unescapeEntities;
	  return html;
	})(html4);
	
	var html_sanitize = html['sanitize'];
	
	// Loosen restrictions of Caja's
	// html-sanitizer to allow for styling
	html4.ATTRIBS['*::style'] = 0;
	html4.ELEMENTS['style'] = 0;
	html4.ATTRIBS['a::target'] = 0;
	html4.ELEMENTS['video'] = 0;
	html4.ATTRIBS['video::src'] = 0;
	html4.ATTRIBS['video::poster'] = 0;
	html4.ATTRIBS['video::controls'] = 0;
	html4.ELEMENTS['audio'] = 0;
	html4.ATTRIBS['audio::src'] = 0;
	html4.ATTRIBS['video::autoplay'] = 0;
	html4.ATTRIBS['video::controls'] = 0;
	
	if (true) {
	    module.exports = html_sanitize;
	}


/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(941),
	    format_url = __webpack_require__(942),
	    request = __webpack_require__(946),
	    marker = __webpack_require__(953),
	    simplestyle = __webpack_require__(954);
	
	// # featureLayer
	//
	// A layer of features, loaded from Mapbox or else. Adds the ability
	// to reset features, filter them, and load them from a GeoJSON URL.
	var FeatureLayer = L.FeatureGroup.extend({
	    options: {
	        filter: function() { return true; },
	        sanitizer: __webpack_require__(950),
	        style: simplestyle.style,
	        popupOptions: { closeButton: false }
	    },
	
	    initialize: function(_, options) {
	        L.setOptions(this, options);
	
	        this._layers = {};
	
	        if (typeof _ === 'string') {
	            util.idUrl(_, this);
	        // javascript object of TileJSON data
	        } else if (_ && typeof _ === 'object') {
	            this.setGeoJSON(_);
	        }
	    },
	
	    setGeoJSON: function(_) {
	        this._geojson = _;
	        this.clearLayers();
	        this._initialize(_);
	        return this;
	    },
	
	    getGeoJSON: function() {
	        return this._geojson;
	    },
	
	    loadURL: function(url) {
	        if (this._request && 'abort' in this._request) this._request.abort();
	        this._request = request(url, L.bind(function(err, json) {
	            this._request = null;
	            if (err && err.type !== 'abort') {
	                util.log('could not load features at ' + url);
	                this.fire('error', {error: err});
	            } else if (json) {
	                this.setGeoJSON(json);
	                this.fire('ready');
	            }
	        }, this));
	        return this;
	    },
	
	    loadID: function(id) {
	        return this.loadURL(format_url('/v4/' + id + '/features.json', this.options.accessToken));
	    },
	
	    setFilter: function(_) {
	        this.options.filter = _;
	        if (this._geojson) {
	            this.clearLayers();
	            this._initialize(this._geojson);
	        }
	        return this;
	    },
	
	    getFilter: function() {
	        return this.options.filter;
	    },
	
	    _initialize: function(json) {
	        var features = L.Util.isArray(json) ? json : json.features,
	            i, len;
	
	        if (features) {
	            for (i = 0, len = features.length; i < len; i++) {
	                // Only add this if geometry or geometries are set and not null
	                if (features[i].geometries || features[i].geometry || features[i].features) {
	                    this._initialize(features[i]);
	                }
	            }
	        } else if (this.options.filter(json)) {
	
	            var opts = {accessToken: this.options.accessToken},
	                pointToLayer = this.options.pointToLayer || function(feature, latlon) {
	                  return marker.style(feature, latlon, opts);
	                },
	                layer = L.GeoJSON.geometryToLayer(json, pointToLayer),
	                popupHtml = marker.createPopup(json, this.options.sanitizer),
	                style = this.options.style,
	                defaultStyle = style === simplestyle.style;
	
	            if (style && 'setStyle' in layer &&
	                // if the style method is the simplestyle default, then
	                // never style L.Circle or L.CircleMarker because
	                // simplestyle has no rules over them, only over geometry
	                // primitives directly from GeoJSON
	                (!(defaultStyle && (layer instanceof L.Circle ||
	                  layer instanceof L.CircleMarker)))) {
	                if (typeof style === 'function') {
	                    style = style(json);
	                }
	                layer.setStyle(style);
	            }
	
	            layer.feature = json;
	
	            if (popupHtml) {
	                layer.bindPopup(popupHtml, this.options.popupOptions);
	            }
	
	            this.addLayer(layer);
	        }
	    }
	});
	
	module.exports.FeatureLayer = FeatureLayer;
	
	module.exports.featureLayer = function(_, options) {
	    return new FeatureLayer(_, options);
	};


/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var format_url = __webpack_require__(942),
	    util = __webpack_require__(941),
	    sanitize = __webpack_require__(950);
	
	// mapbox-related markers functionality
	// provide an icon from mapbox's simple-style spec and hosted markers
	// service
	function icon(fp, options) {
	    fp = fp || {};
	
	    var sizes = {
	            small: [20, 50],
	            medium: [30, 70],
	            large: [35, 90]
	        },
	        size = fp['marker-size'] || 'medium',
	        symbol = ('marker-symbol' in fp && fp['marker-symbol'] !== '') ? '-' + fp['marker-symbol'] : '',
	        color = (fp['marker-color'] || '7e7e7e').replace('#', '');
	
	    return L.icon({
	        iconUrl: format_url('/v4/marker/' +
	            'pin-' + size.charAt(0) + symbol + '+' + color +
	            // detect and use retina markers, which are x2 resolution
	            (L.Browser.retina ? '@2x' : '') + '.png', options && options.accessToken),
	        iconSize: sizes[size],
	        iconAnchor: [sizes[size][0] / 2, sizes[size][1] / 2],
	        popupAnchor: [0, -sizes[size][1] / 2]
	    });
	}
	
	// a factory that provides markers for Leaflet from Mapbox's
	// [simple-style specification](https://github.com/mapbox/simplestyle-spec)
	// and [Markers API](http://mapbox.com/developers/api/#markers).
	function style(f, latlon, options) {
	    return L.marker(latlon, {
	        icon: icon(f.properties, options),
	        title: util.strip_tags(
	            sanitize((f.properties && f.properties.title) || ''))
	    });
	}
	
	// Sanitize and format properties of a GeoJSON Feature object in order
	// to form the HTML string used as the argument for `L.createPopup`
	function createPopup(f, sanitizer) {
	    if (!f || !f.properties) return '';
	    var popup = '';
	
	    if (f.properties.title) {
	        popup += '<div class="marker-title">' + f.properties.title + '</div>';
	    }
	
	    if (f.properties.description) {
	        popup += '<div class="marker-description">' + f.properties.description + '</div>';
	    }
	
	    return (sanitizer || sanitize)(popup);
	}
	
	module.exports = {
	    icon: icon,
	    style: style,
	    createPopup: createPopup
	};


/***/ },
/* 954 */
/***/ function(module, exports) {

	'use strict';
	
	// an implementation of the simplestyle spec for polygon and linestring features
	// https://github.com/mapbox/simplestyle-spec
	var defaults = {
	    stroke: '#555555',
	    'stroke-width': 2,
	    'stroke-opacity': 1,
	    fill: '#555555',
	    'fill-opacity': 0.5
	};
	
	var mapping = [
	    ['stroke', 'color'],
	    ['stroke-width', 'weight'],
	    ['stroke-opacity', 'opacity'],
	    ['fill', 'fillColor'],
	    ['fill-opacity', 'fillOpacity']
	];
	
	function fallback(a, b) {
	    var c = {};
	    for (var k in b) {
	        if (a[k] === undefined) c[k] = b[k];
	        else c[k] = a[k];
	    }
	    return c;
	}
	
	function remap(a) {
	    var d = {};
	    for (var i = 0; i < mapping.length; i++) {
	        d[mapping[i][1]] = a[mapping[i][0]];
	    }
	    return d;
	}
	
	function style(feature) {
	    return remap(fallback(feature.properties || {}, defaults));
	}
	
	module.exports = {
	    style: style,
	    defaults: defaults
	};


/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var LegendControl = L.Control.extend({
	
	    options: {
	        position: 'bottomright',
	        sanitizer: __webpack_require__(950)
	    },
	
	    initialize: function(options) {
	        L.setOptions(this, options);
	        this._legends = {};
	    },
	
	    onAdd: function() {
	        this._container = L.DomUtil.create('div', 'map-legends wax-legends');
	        L.DomEvent.disableClickPropagation(this._container);
	
	        this._update();
	
	        return this._container;
	    },
	
	    addLegend: function(text) {
	        if (!text) { return this; }
	
	        if (!this._legends[text]) {
	            this._legends[text] = 0;
	        }
	
	        this._legends[text]++;
	        return this._update();
	    },
	
	    removeLegend: function(text) {
	        if (!text) { return this; }
	        if (this._legends[text]) this._legends[text]--;
	        return this._update();
	    },
	
	    _update: function() {
	        if (!this._map) { return this; }
	
	        this._container.innerHTML = '';
	        var hide = 'none';
	
	        for (var i in this._legends) {
	            if (this._legends.hasOwnProperty(i) && this._legends[i]) {
	                var div = L.DomUtil.create('div', 'map-legend wax-legend', this._container);
	                div.innerHTML = this.options.sanitizer(i);
	                hide = 'block';
	            }
	        }
	
	        // hide the control entirely unless there is at least one legend;
	        // otherwise there will be a small grey blemish on the map.
	        this._container.style.display = hide;
	
	        return this;
	    }
	});
	
	module.exports.LegendControl = LegendControl;
	
	module.exports.legendControl = function(options) {
	    return new LegendControl(options);
	};


/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var format_url = __webpack_require__(942);
	
	var ShareControl = L.Control.extend({
	    includes: [__webpack_require__(957)],
	
	    options: {
	        position: 'topleft',
	        url: ''
	    },
	
	    initialize: function(_, options) {
	        L.setOptions(this, options);
	        this._loadTileJSON(_);
	    },
	
	    _setTileJSON: function(json) {
	        this._tilejson = json;
	    },
	
	    onAdd: function(map) {
	        this._map = map;
	
	        var container = L.DomUtil.create('div', 'leaflet-control-mapbox-share leaflet-bar');
	        var link = L.DomUtil.create('a', 'mapbox-share mapbox-icon mapbox-icon-share', container);
	        link.href = '#';
	
	        this._modal = L.DomUtil.create('div', 'mapbox-modal', this._map._container);
	        this._mask = L.DomUtil.create('div', 'mapbox-modal-mask', this._modal);
	        this._content = L.DomUtil.create('div', 'mapbox-modal-content', this._modal);
	
	        L.DomEvent.addListener(link, 'click', this._shareClick, this);
	        L.DomEvent.disableClickPropagation(container);
	
	        this._map.on('mousedown', this._clickOut, this);
	
	        return container;
	    },
	
	    _clickOut: function(e) {
	        if (this._sharing) {
	            L.DomEvent.preventDefault(e);
	            L.DomUtil.removeClass(this._modal, 'active');
	            this._content.innerHTML = '';
	            this._sharing = null;
	            return;
	        }
	    },
	
	    _shareClick: function(e) {
	        L.DomEvent.stop(e);
	        if (this._sharing) return this._clickOut(e);
	
	        var tilejson = this._tilejson || this._map._tilejson || {},
	            url = encodeURIComponent(this.options.url || tilejson.webpage || window.location),
	            name = encodeURIComponent(tilejson.name),
	            image = format_url('/v4/' + tilejson.id + '/' + this._map.getCenter().lng + ',' + this._map.getCenter().lat + ',' + this._map.getZoom() + '/600x600.png', this.options.accessToken),
	            embed = format_url('/v4/' + tilejson.id + '.html', this.options.accessToken),
	            twitterURL = '//twitter.com/intent/tweet?status=' + name + ' ' + url,
	            facebookURL = '//www.facebook.com/sharer.php?u=' + url + '&t=' + name,
	            pinterestURL = '//www.pinterest.com/pin/create/button/?url=' + url + '&media=' + image + '&description=' + name,
	            embedValue = '<iframe width="100%" height="500px" frameBorder="0" src="' + embed + '"></iframe>',
	            embedLabel = 'Copy and paste this <strong>HTML code</strong> into documents to embed this map on web pages.';
	
	        function createShareButton(buttonClass, href, socialMediaName) {
	            var elem = document.createElement('a');
	            elem.setAttribute('class', buttonClass);
	            elem.setAttribute('href', href);
	            elem.setAttribute('target', '_blank');
	            socialMediaName = document.createTextNode(socialMediaName);
	            elem.appendChild(socialMediaName);
	
	            return elem;
	        }
	
	        L.DomUtil.addClass(this._modal, 'active');
	
	        this._sharing = L.DomUtil.create('div', 'mapbox-modal-body', this._content);
	
	        var twitterButton = createShareButton('mapbox-button mapbox-button-icon mapbox-icon-twitter', twitterURL, 'Twitter');
	        var facebookButton = createShareButton('mapbox-button mapbox-button-icon mapbox-icon-facebook', facebookURL, 'Facebook');
	        var pinterestButton = createShareButton('mapbox-button mapbox-button-icon mapbox-icon-pinterest', pinterestURL, 'Pinterest');
	
	        var shareHeader = document.createElement('h3');
	        var shareText = document.createTextNode('Share this map');
	        shareHeader.appendChild(shareText);
	
	        var shareButtons = document.createElement('div');
	        shareButtons.setAttribute('class', 'mapbox-share-buttons');
	        shareButtons.appendChild(facebookButton);
	        shareButtons.appendChild(twitterButton);
	        shareButtons.appendChild(pinterestButton);
	
	        this._sharing.appendChild(shareHeader);
	        this._sharing.appendChild(shareButtons);
	
	        var input = L.DomUtil.create('input', 'mapbox-embed', this._sharing);
	        input.type = 'text';
	        input.value = embedValue;
	
	        var label = L.DomUtil.create('label', 'mapbox-embed-description', this._sharing);
	        label.innerHTML = embedLabel;
	
	        var close = L.DomUtil.create('a', 'leaflet-popup-close-button', this._sharing);
	        close.href = '#';
	
	        L.DomEvent.disableClickPropagation(this._sharing);
	        L.DomEvent.addListener(close, 'click', this._clickOut, this);
	        L.DomEvent.addListener(input, 'click', function(e) {
	            e.target.focus();
	            e.target.select();
	        });
	    }
	});
	
	module.exports.ShareControl = ShareControl;
	
	module.exports.shareControl = function(_, options) {
	    return new ShareControl(_, options);
	};


/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var request = __webpack_require__(946),
	    format_url = __webpack_require__(942),
	    util = __webpack_require__(941);
	
	module.exports = {
	    _loadTileJSON: function(_) {
	        if (typeof _ === 'string') {
	            _ = format_url.tileJSON(_, this.options && this.options.accessToken);
	            request(_, L.bind(function(err, json) {
	                if (err) {
	                    util.log('could not load TileJSON at ' + _);
	                    this.fire('error', {error: err});
	                } else if (json) {
	                    this._setTileJSON(json);
	                    this.fire('ready');
	                }
	            }, this));
	        } else if (_ && typeof _ === 'object') {
	            this._setTileJSON(_);
	        }
	    }
	};


/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(941);
	var formatPattern = /\.((?:png|jpg)\d*)(?=$|\?)/;
	
	var TileLayer = L.TileLayer.extend({
	    includes: [__webpack_require__(957)],
	
	    options: {
	        sanitizer: __webpack_require__(950)
	    },
	
	    // http://mapbox.com/developers/api/#image_quality
	    formats: [
	        'png', 'jpg',
	        // PNG
	        'png32', 'png64', 'png128', 'png256',
	        // JPG
	        'jpg70', 'jpg80', 'jpg90'],
	
	    scalePrefix: '@2x.',
	
	    initialize: function(_, options) {
	        L.TileLayer.prototype.initialize.call(this, undefined, options);
	
	        this._tilejson = {};
	
	        if (options && options.format) {
	            util.strict_oneof(options.format, this.formats);
	        }
	
	        this._loadTileJSON(_);
	    },
	
	    setFormat: function(_) {
	        util.strict(_, 'string');
	        this.options.format = _;
	        this.redraw();
	        return this;
	    },
	
	    // disable the setUrl function, which is not available on mapbox tilelayers
	    setUrl: null,
	
	    _setTileJSON: function(json) {
	        util.strict(json, 'object');
	
	        this.options.format = this.options.format ||
	            json.tiles[0].match(formatPattern)[1];
	
	        L.extend(this.options, {
	            tiles: json.tiles,
	            attribution: this.options.sanitizer(json.attribution),
	            minZoom: json.minzoom || 0,
	            maxZoom: json.maxzoom || 18,
	            tms: json.scheme === 'tms',
	            bounds: json.bounds && util.lbounds(json.bounds)
	        });
	
	        this._tilejson = json;
	        this.redraw();
	        return this;
	    },
	
	    getTileJSON: function() {
	        return this._tilejson;
	    },
	
	    // this is an exception to mapbox.js naming rules because it's called
	    // by `L.map`
	    getTileUrl: function(tilePoint) {
	        var tiles = this.options.tiles,
	            index = Math.floor(Math.abs(tilePoint.x + tilePoint.y) % tiles.length),
	            url = tiles[index];
	
	        var templated = L.Util.template(url, tilePoint);
	        if (!templated) {
	            return templated;
	        } else {
	            return templated.replace(formatPattern,
	                (L.Browser.retina ? this.scalePrefix : '.') + this.options.format);
	        }
	    },
	
	    // TileJSON.TileLayers are added to the map immediately, so that they get
	    // the desired z-index, but do not update until the TileJSON has been loaded.
	    _update: function() {
	        if (this.options.tiles) {
	            L.TileLayer.prototype._update.call(this);
	        }
	    }
	});
	
	module.exports.TileLayer = TileLayer;
	
	module.exports.tileLayer = function(_, options) {
	    return new TileLayer(_, options);
	};


/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var InfoControl = L.Control.extend({
	    options: {
	        position: 'bottomright',
	        sanitizer: __webpack_require__(950)
	    },
	
	    initialize: function(options) {
	        L.setOptions(this, options);
	        this._info = {};
	        console.warn('infoControl has been deprecated and will be removed in mapbox.js v3.0.0. Use the default attribution control instead, which is now responsive.');
	    },
	
	    onAdd: function(map) {
	        this._container = L.DomUtil.create('div', 'mapbox-control-info mapbox-small');
	        this._content = L.DomUtil.create('div', 'map-info-container', this._container);
	
	        var link = L.DomUtil.create('a', 'mapbox-info-toggle mapbox-icon mapbox-icon-info', this._container);
	        link.href = '#';
	
	        L.DomEvent.addListener(link, 'click', this._showInfo, this);
	        L.DomEvent.disableClickPropagation(this._container);
	
	        for (var i in map._layers) {
	            if (map._layers[i].getAttribution) {
	                this.addInfo(map._layers[i].getAttribution());
	            }
	        }
	
	        map
	            .on('layeradd', this._onLayerAdd, this)
	            .on('layerremove', this._onLayerRemove, this);
	
	        this._update();
	        return this._container;
	    },
	
	    onRemove: function(map) {
	        map
	            .off('layeradd', this._onLayerAdd, this)
	            .off('layerremove', this._onLayerRemove, this);
	    },
	
	    addInfo: function(text) {
	        if (!text) return this;
	        if (!this._info[text]) this._info[text] = 0;
	        this._info[text] = true;
	        return this._update();
	    },
	
	    removeInfo: function (text) {
	        if (!text) return this;
	        if (this._info[text]) this._info[text] = false;
	        return this._update();
	    },
	
	    _showInfo: function(e) {
	        L.DomEvent.preventDefault(e);
	        if (this._active === true) return this._hidecontent();
	
	        L.DomUtil.addClass(this._container, 'active');
	        this._active = true;
	        this._update();
	    },
	
	    _hidecontent: function() {
	        this._content.innerHTML = '';
	        this._active = false;
	        L.DomUtil.removeClass(this._container, 'active');
	        return;
	    },
	
	    _update: function() {
	        if (!this._map) { return this; }
	        this._content.innerHTML = '';
	        var hide = 'none';
	        var info = [];
	
	        for (var i in this._info) {
	            if (this._info.hasOwnProperty(i) && this._info[i]) {
	                info.push(this.options.sanitizer(i));
	                hide = 'block';
	            }
	        }
	
	        this._content.innerHTML += info.join(' | ');
	
	        // If there are no results in _info then hide this.
	        this._container.style.display = hide;
	        return this;
	    },
	
	    _onLayerAdd: function(e) {
	        if (e.layer.getAttribution && e.layer.getAttribution()) {
	            this.addInfo(e.layer.getAttribution());
	        } else if ('on' in e.layer && e.layer.getAttribution) {
	            e.layer.on('ready', L.bind(function() {
	                this.addInfo(e.layer.getAttribution());
	            }, this));
	        }
	    },
	
	    _onLayerRemove: function (e) {
	        if (e.layer.getAttribution) {
	            this.removeInfo(e.layer.getAttribution());
	        }
	    }
	});
	
	module.exports.InfoControl = InfoControl;
	
	module.exports.infoControl = function(options) {
	    return new InfoControl(options);
	};


/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var tileLayer = __webpack_require__(958).tileLayer,
	    featureLayer = __webpack_require__(952).featureLayer,
	    gridLayer = __webpack_require__(961).gridLayer,
	    gridControl = __webpack_require__(948).gridControl,
	    infoControl = __webpack_require__(959).infoControl,
	    shareControl = __webpack_require__(956).shareControl,
	    legendControl = __webpack_require__(955).legendControl,
	    mapboxLogoControl = __webpack_require__(963).mapboxLogoControl,
	    feedback = __webpack_require__(945);
	
	function withAccessToken(options, accessToken) {
	    if (!accessToken || options.accessToken)
	        return options;
	    return L.extend({accessToken: accessToken}, options);
	}
	
	var LMap = L.Map.extend({
	    includes: [__webpack_require__(957)],
	
	    options: {
	        tileLayer: {},
	        featureLayer: {},
	        gridLayer: {},
	        legendControl: {},
	        gridControl: {},
	        infoControl: false,
	        shareControl: false,
	        sanitizer: __webpack_require__(950)
	    },
	
	    _tilejson: {},
	
	    initialize: function(element, _, options) {
	
	        L.Map.prototype.initialize.call(this, element,
	            L.extend({}, L.Map.prototype.options, options));
	
	        // Disable the default 'Leaflet' text
	        if (this.attributionControl) {
	            this.attributionControl.setPrefix('');
	
	            var compact = this.options.attributionControl.compact;
	            // Set a compact display if map container width is < 640 or
	            // compact is set to `true` in attributionControl options.
	            if (compact || (compact !== false && this._container.offsetWidth <= 640)) {
	                L.DomUtil.addClass(this.attributionControl._container, 'leaflet-compact-attribution');
	            }
	
	            if (compact === undefined) {
	                this.on('resize', function() {
	                    if (this._container.offsetWidth > 640) {
	                        L.DomUtil.removeClass(this.attributionControl._container, 'leaflet-compact-attribution');
	                    } else {
	                        L.DomUtil.addClass(this.attributionControl._container, 'leaflet-compact-attribution');
	                    }
	                });
	            }
	        }
	
	        if (this.options.tileLayer) {
	            this.tileLayer = tileLayer(undefined,
	                withAccessToken(this.options.tileLayer, this.options.accessToken));
	            this.addLayer(this.tileLayer);
	        }
	
	        if (this.options.featureLayer) {
	            this.featureLayer = featureLayer(undefined,
	                withAccessToken(this.options.featureLayer, this.options.accessToken));
	            this.addLayer(this.featureLayer);
	        }
	
	        if (this.options.gridLayer) {
	            this.gridLayer = gridLayer(undefined,
	                withAccessToken(this.options.gridLayer, this.options.accessToken));
	            this.addLayer(this.gridLayer);
	        }
	
	        if (this.options.gridLayer && this.options.gridControl) {
	            this.gridControl = gridControl(this.gridLayer, this.options.gridControl);
	            this.addControl(this.gridControl);
	        }
	
	        if (this.options.infoControl) {
	            this.infoControl = infoControl(this.options.infoControl);
	            this.addControl(this.infoControl);
	        }
	
	        if (this.options.legendControl) {
	            this.legendControl = legendControl(this.options.legendControl);
	            this.addControl(this.legendControl);
	        }
	
	        if (this.options.shareControl) {
	            this.shareControl = shareControl(undefined,
	                withAccessToken(this.options.shareControl, this.options.accessToken));
	            this.addControl(this.shareControl);
	        }
	
	        this._mapboxLogoControl = mapboxLogoControl(this.options.mapboxLogoControl);
	        this.addControl(this._mapboxLogoControl);
	
	        this._loadTileJSON(_);
	
	        this.on('layeradd', this._onLayerAdd, this)
	            .on('layerremove', this._onLayerRemove, this)
	            .on('moveend', this._updateMapFeedbackLink, this);
	
	        this.whenReady(function () {
	            feedback.on('change', this._updateMapFeedbackLink, this);
	        });
	
	        this.on('unload', function () {
	            feedback.off('change', this._updateMapFeedbackLink, this);
	        });
	    },
	
	    // use a javascript object of tilejson data to configure this layer
	    _setTileJSON: function(_) {
	        this._tilejson = _;
	        this._initialize(_);
	        return this;
	    },
	
	    getTileJSON: function() {
	        return this._tilejson;
	    },
	
	    _initialize: function(json) {
	        if (this.tileLayer) {
	            this.tileLayer._setTileJSON(json);
	            this._updateLayer(this.tileLayer);
	        }
	
	        if (this.featureLayer && !this.featureLayer.getGeoJSON() && json.data && json.data[0]) {
	            this.featureLayer.loadURL(json.data[0]);
	        }
	
	        if (this.gridLayer) {
	            this.gridLayer._setTileJSON(json);
	            this._updateLayer(this.gridLayer);
	        }
	
	        if (this.infoControl && json.attribution) {
	            this.infoControl.addInfo(this.options.sanitizer(json.attribution));
	            this._updateMapFeedbackLink();
	        }
	
	        if (this.legendControl && json.legend) {
	            this.legendControl.addLegend(json.legend);
	        }
	
	        if (this.shareControl) {
	            this.shareControl._setTileJSON(json);
	        }
	
	        this._mapboxLogoControl._setTileJSON(json);
	
	        if (!this._loaded && json.center) {
	            var zoom = this.getZoom() !== undefined ? this.getZoom() : json.center[2],
	                center = L.latLng(json.center[1], json.center[0]);
	
	            this.setView(center, zoom);
	        }
	    },
	
	    _updateMapFeedbackLink: function() {
	        if (!this._controlContainer.getElementsByClassName) return;
	        var link = this._controlContainer.getElementsByClassName('mapbox-improve-map');
	        if (link.length && this._loaded) {
	            var center = this.getCenter().wrap();
	            var tilejson = this._tilejson || {};
	            var id = tilejson.id || '';
	
	            var hash = '#' + id + '/' +
	                center.lng.toFixed(3) + '/' +
	                center.lat.toFixed(3) + '/' +
	                this.getZoom();
	
	            for (var key in feedback.data) {
	                hash += '/' + key + '=' + feedback.data[key];
	            }
	
	            for (var i = 0; i < link.length; i++) {
	                link[i].hash = hash;
	            }
	        }
	    },
	
	    _onLayerAdd: function(e) {
	        if ('on' in e.layer) {
	            e.layer.on('ready', this._onLayerReady, this);
	        }
	        window.setTimeout(L.bind(this._updateMapFeedbackLink, this), 0); // Update after attribution control resets the HTML.
	    },
	
	    _onLayerRemove: function(e) {
	        if ('on' in e.layer) {
	            e.layer.off('ready', this._onLayerReady, this);
	        }
	        window.setTimeout(L.bind(this._updateMapFeedbackLink, this), 0); // Update after attribution control resets the HTML.
	    },
	
	    _onLayerReady: function(e) {
	        this._updateLayer(e.target);
	    },
	
	    _updateLayer: function(layer) {
	        if (!layer.options) return;
	
	        if (this.infoControl && this._loaded) {
	            this.infoControl.addInfo(layer.options.infoControl);
	        }
	
	        if (this.attributionControl && this._loaded && layer.getAttribution) {
	            this.attributionControl.addAttribution(layer.getAttribution());
	        }
	
	        if (!(L.stamp(layer) in this._zoomBoundLayers) &&
	                (layer.options.maxZoom || layer.options.minZoom)) {
	            this._zoomBoundLayers[L.stamp(layer)] = layer;
	        }
	
	        this._updateMapFeedbackLink();
	        this._updateZoomLevels();
	    }
	});
	
	module.exports.Map = LMap;
	
	module.exports.map = function(element, _, options) {
	    return new LMap(element, _, options);
	};


/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(941),
	    request = __webpack_require__(946),
	    grid = __webpack_require__(962);
	
	// forked from danzel/L.UTFGrid
	var GridLayer = L.Class.extend({
	    includes: [L.Mixin.Events, __webpack_require__(957)],
	
	    options: {
	        template: function() { return ''; }
	    },
	
	    _mouseOn: null,
	    _tilejson: {},
	    _cache: {},
	
	    initialize: function(_, options) {
	        L.Util.setOptions(this, options);
	        this._loadTileJSON(_);
	    },
	
	    _setTileJSON: function(json) {
	        util.strict(json, 'object');
	
	        L.extend(this.options, {
	            grids: json.grids,
	            minZoom: json.minzoom,
	            maxZoom: json.maxzoom,
	            bounds: json.bounds && util.lbounds(json.bounds)
	        });
	
	        this._tilejson = json;
	        this._cache = {};
	        this._update();
	
	        return this;
	    },
	
	    getTileJSON: function() {
	        return this._tilejson;
	    },
	
	    active: function() {
	        return !!(this._map && this.options.grids && this.options.grids.length);
	    },
	
	    addTo: function (map) {
	        map.addLayer(this);
	        return this;
	    },
	
	    onAdd: function(map) {
	        this._map = map;
	        this._update();
	
	        this._map
	            .on('click', this._click, this)
	            .on('mousemove', this._move, this)
	            .on('moveend', this._update, this);
	    },
	
	    onRemove: function() {
	        this._map
	            .off('click', this._click, this)
	            .off('mousemove', this._move, this)
	            .off('moveend', this._update, this);
	    },
	
	    getData: function(latlng, callback) {
	        if (!this.active()) return;
	
	        var map = this._map,
	            point = map.project(latlng.wrap()),
	            tileSize = 256,
	            resolution = 4,
	            x = Math.floor(point.x / tileSize),
	            y = Math.floor(point.y / tileSize),
	            max = map.options.crs.scale(map.getZoom()) / tileSize;
	
	        x = (x + max) % max;
	        y = (y + max) % max;
	
	        this._getTile(map.getZoom(), x, y, function(grid) {
	            var gridX = Math.floor((point.x - (x * tileSize)) / resolution),
	                gridY = Math.floor((point.y - (y * tileSize)) / resolution);
	
	            callback(grid(gridX, gridY));
	        });
	
	        return this;
	    },
	
	    _click: function(e) {
	        this.getData(e.latlng, L.bind(function(data) {
	            this.fire('click', {
	                latLng: e.latlng,
	                data: data
	            });
	        }, this));
	    },
	
	    _move: function(e) {
	        this.getData(e.latlng, L.bind(function(data) {
	            if (data !== this._mouseOn) {
	                if (this._mouseOn) {
	                    this.fire('mouseout', {
	                        latLng: e.latlng,
	                        data: this._mouseOn
	                    });
	                }
	
	                this.fire('mouseover', {
	                    latLng: e.latlng,
	                    data: data
	                });
	
	                this._mouseOn = data;
	            } else {
	                this.fire('mousemove', {
	                    latLng: e.latlng,
	                    data: data
	                });
	            }
	        }, this));
	    },
	
	    _getTileURL: function(tilePoint) {
	        var urls = this.options.grids,
	            index = (tilePoint.x + tilePoint.y) % urls.length,
	            url = urls[index];
	
	        return L.Util.template(url, tilePoint);
	    },
	
	    // Load up all required json grid files
	    _update: function() {
	        if (!this.active()) return;
	
	        var bounds = this._map.getPixelBounds(),
	            z = this._map.getZoom(),
	            tileSize = 256;
	
	        if (z > this.options.maxZoom || z < this.options.minZoom) return;
	
	        var tileBounds = L.bounds(
	                bounds.min.divideBy(tileSize)._floor(),
	                bounds.max.divideBy(tileSize)._floor()),
	            max = this._map.options.crs.scale(z) / tileSize;
	
	        for (var x = tileBounds.min.x; x <= tileBounds.max.x; x++) {
	            for (var y = tileBounds.min.y; y <= tileBounds.max.y; y++) {
	                // x wrapped
	                this._getTile(z, ((x % max) + max) % max, ((y % max) + max) % max);
	            }
	        }
	    },
	
	    _getTile: function(z, x, y, callback) {
	        var key = z + '_' + x + '_' + y,
	            tilePoint = L.point(x, y);
	
	        tilePoint.z = z;
	
	        if (!this._tileShouldBeLoaded(tilePoint)) {
	            return;
	        }
	
	        if (key in this._cache) {
	            if (!callback) return;
	
	            if (typeof this._cache[key] === 'function') {
	                callback(this._cache[key]); // Already loaded
	            } else {
	                this._cache[key].push(callback); // Pending
	            }
	
	            return;
	        }
	
	        this._cache[key] = [];
	
	        if (callback) {
	            this._cache[key].push(callback);
	        }
	
	        request(this._getTileURL(tilePoint), L.bind(function(err, json) {
	            var callbacks = this._cache[key];
	            this._cache[key] = grid(json);
	            for (var i = 0; i < callbacks.length; ++i) {
	                callbacks[i](this._cache[key]);
	            }
	        }, this));
	    },
	
	    _tileShouldBeLoaded: function(tilePoint) {
	        if (tilePoint.z > this.options.maxZoom || tilePoint.z < this.options.minZoom) {
	            return false;
	        }
	
	        if (this.options.bounds) {
	            var tileSize = 256,
	                nwPoint = tilePoint.multiplyBy(tileSize),
	                sePoint = nwPoint.add(new L.Point(tileSize, tileSize)),
	                nw = this._map.unproject(nwPoint),
	                se = this._map.unproject(sePoint),
	                bounds = new L.LatLngBounds([nw, se]);
	
	            if (!this.options.bounds.intersects(bounds)) {
	                return false;
	            }
	        }
	
	        return true;
	    }
	});
	
	module.exports.GridLayer = GridLayer;
	
	module.exports.gridLayer = function(_, options) {
	    return new GridLayer(_, options);
	};


/***/ },
/* 962 */
/***/ function(module, exports) {

	'use strict';
	
	function utfDecode(c) {
	    if (c >= 93) c--;
	    if (c >= 35) c--;
	    return c - 32;
	}
	
	module.exports = function(data) {
	    return function(x, y) {
	        if (!data) return;
	        var idx = utfDecode(data.grid[y].charCodeAt(x)),
	            key = data.keys[idx];
	        return data.data[key];
	    };
	};


/***/ },
/* 963 */
/***/ function(module, exports) {

	'use strict';
	
	var MapboxLogoControl = L.Control.extend({
	
	    options: {
	        position: 'bottomleft'
	    },
	
	    initialize: function(options) {
	        L.setOptions(this, options);
	    },
	
	    onAdd: function() {
	        this._container = L.DomUtil.create('div', 'mapbox-logo');
	        return this._container;
	    },
	
	    _setTileJSON: function(json) {
	        // Check if account referenced by the accessToken
	        // is asscociated with the Mapbox Logo
	        // as determined by mapbox-maps.
	        if (json.mapbox_logo) {
	            L.DomUtil.addClass(this._container, 'mapbox-logo-true');
	        }
	    }
	});
	
	module.exports.MapboxLogoControl = MapboxLogoControl;
	
	module.exports.mapboxLogoControl = function(options) {
	    return new MapboxLogoControl(options);
	};


/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(941);
	var format_url = __webpack_require__(942);
	var request = __webpack_require__(946);
	
	var StyleLayer = L.TileLayer.extend({
	
	    options: {
	        sanitizer: __webpack_require__(950)
	    },
	
	    initialize: function(_, options) {
	        L.TileLayer.prototype.initialize.call(this, undefined, options);
	
	        this.options.tiles = this._formatTileURL(_);
	        this.options.tileSize = 512;
	        this.options.zoomOffset = -1;
	        this.options.tms = false;
	
	        this._getAttribution(_);
	    },
	
	    _getAttribution: function(_) {
	        var styleURL = format_url.style(_, this.options && this.options.accessToken);
	        request(styleURL, L.bind(function(err, style) {
	            if (err) {
	                util.log('could not load Mapbox style at ' + styleURL);
	                this.fire('error', {error: err});
	            }
	            var sources = [];
	            for (var id in style.sources) {
	                var source = style.sources[id].url.split('mapbox://')[1];
	                sources.push(source);
	            }
	            request(format_url.tileJSON(sources.join(), this.options.accessToken), L.bind(function(err, json) {
	                if (err) {
	                    util.log('could not load TileJSON at ' + _);
	                    this.fire('error', {error: err});
	                } else if (json) {
	                    util.strict(json, 'object');
	
	                    this.options.attribution = this.options.sanitizer(json.attribution);
	
	                    this._tilejson = json;
	                    this.fire('ready');
	                }
	            }, this));
	        }, this));
	    },
	
	    // disable the setUrl function, which is not available on mapbox tilelayers
	    setUrl: null,
	
	    _formatTileURL: function(style) {
	        var retina = L.Browser.retina ? '@2x' : '';
	        if (typeof style === 'string') {
	            if (style.indexOf('mapbox://styles/') === -1) {
	                util.log('Incorrectly formatted Mapbox style at ' + style);
	                this.fire('error');
	            }
	            var ownerIDStyle = style.split('mapbox://styles/')[1];
	            return format_url('/styles/v1/' + ownerIDStyle + '/tiles/{z}/{x}/{y}' + retina, this.options.accessToken);
	        } else if (typeof style === 'object') {
	            return format_url('/styles/v1/' + style.owner + '/' + style.id + '/tiles/{z}/{x}/{y}' + retina, this.options.accessToken);
	        }
	    },
	
	    // this is an exception to mapbox.js naming rules because it's called
	    // by `L.map`
	    getTileUrl: function(tilePoint) {
	        var templated = L.Util.template(this.options.tiles, tilePoint);
	        return templated;
	    }
	});
	
	module.exports.StyleLayer = StyleLayer;
	
	module.exports.styleLayer = function(_, options) {
	    return new StyleLayer(_, options);
	};


/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(966);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(251);
	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/* general typography */\n.leaflet-container {\n  background:#fff;\n  font:12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  color:#404040;\n  color:rgba(0,0,0,0.75);\n  outline:0;\n  overflow:hidden;\n  -ms-touch-action:none;\n  }\n\n.leaflet-container *,\n.leaflet-container *:after,\n.leaflet-container *:before {\n  -webkit-box-sizing:border-box;\n     -moz-box-sizing:border-box;\n          box-sizing:border-box;\n  }\n\n.leaflet-container h1,\n.leaflet-container h2,\n.leaflet-container h3,\n.leaflet-container h4,\n.leaflet-container h5,\n.leaflet-container h6,\n.leaflet-container p {\n  font-size:15px;\n  line-height:20px;\n  margin:0 0 10px;\n  }\n\n.leaflet-container .marker-description img {\n  margin-bottom: 10px;\n  }\n\n.leaflet-container a {\n  color:#3887BE;\n  font-weight:normal;\n  text-decoration:none;\n  }\n  .leaflet-container a:hover      { color:#63b6e5; }\n  .leaflet-container.dark a       { color:#63b6e5; }\n  .leaflet-container.dark a:hover { color:#8fcaec; }\n\n.leaflet-container.dark .mapbox-button,\n.leaflet-container .mapbox-button {\n  background-color:#3887be;\n  display:inline-block;\n  height:40px;\n  line-height:40px;\n  text-decoration:none;\n  color:#fff;\n  font-size:12px;\n  white-space:nowrap;\n  text-overflow:ellipsis;\n  }\n  .leaflet-container.dark .mapbox-button:hover,\n  .leaflet-container .mapbox-button:hover {\n    color:#fff;\n    background-color:#3bb2d0;\n    }\n\n/* Base Leaflet\n------------------------------------------------------- */\n.leaflet-map-pane,\n.leaflet-tile,\n.leaflet-marker-icon,\n.leaflet-marker-shadow,\n.leaflet-tile-pane,\n.leaflet-tile-container,\n.leaflet-overlay-pane,\n.leaflet-shadow-pane,\n.leaflet-marker-pane,\n.leaflet-popup-pane,\n.leaflet-overlay-pane svg,\n.leaflet-zoom-box,\n.leaflet-image-layer,\n.leaflet-layer {\n  position:absolute;\n  left:0;\n  top:0;\n  }\n\n.leaflet-tile,\n.leaflet-marker-icon,\n.leaflet-marker-shadow {\n  -webkit-user-drag:none;\n  -webkit-user-select:none;\n     -moz-user-select:none;\n          user-select:none;\n  }\n.leaflet-marker-icon,\n.leaflet-marker-shadow {\n  display: block;\n  }\n\n.leaflet-tile {\n  filter:inherit;\n  visibility:hidden;\n  }\n.leaflet-tile-loaded {\n  visibility:inherit;\n  }\n.leaflet-zoom-box {\n  width:0;\n  height:0;\n  }\n\n.leaflet-tile-pane    { z-index:2; }\n.leaflet-objects-pane { z-index:3; }\n.leaflet-overlay-pane { z-index:4; }\n.leaflet-shadow-pane  { z-index:5; }\n.leaflet-marker-pane  { z-index:6; }\n.leaflet-popup-pane   { z-index:7; }\n\n.leaflet-control {\n  position:relative;\n  z-index:7;\n  pointer-events:auto;\n  float:left;\n  clear:both;\n  }\n  .leaflet-right .leaflet-control   { float:right; }\n  .leaflet-top .leaflet-control     { margin-top:10px; }\n  .leaflet-bottom .leaflet-control  { margin-bottom:10px; }\n  .leaflet-left .leaflet-control    { margin-left:10px; }\n  .leaflet-right .leaflet-control   { margin-right:10px; }\n\n.leaflet-top,\n.leaflet-bottom {\n  position:absolute;\n  z-index:1000;\n  pointer-events:none;\n  }\n  .leaflet-top    { top:0; }\n  .leaflet-right  { right:0; }\n  .leaflet-bottom { bottom:0; }\n  .leaflet-left   { left:0; }\n\n/* zoom and fade animations */\n.leaflet-fade-anim .leaflet-tile,\n.leaflet-fade-anim .leaflet-popup {\n  opacity:0;\n  -webkit-transition:opacity 0.2s linear;\n     -moz-transition:opacity 0.2s linear;\n       -o-transition:opacity 0.2s linear;\n          transition:opacity 0.2s linear;\n  }\n  .leaflet-fade-anim .leaflet-tile-loaded,\n  .leaflet-fade-anim .leaflet-map-pane .leaflet-popup {\n    opacity:1;\n    }\n\n.leaflet-zoom-anim .leaflet-zoom-animated {\n  -webkit-transition:-webkit-transform 0.25s cubic-bezier(0,0,0.25,1);\n     -moz-transition:   -moz-transform 0.25s cubic-bezier(0,0,0.25,1);\n       -o-transition:     -o-transform 0.25s cubic-bezier(0,0,0.25,1);\n          transition:        transform 0.25s cubic-bezier(0,0,0.25,1);\n  }\n.leaflet-zoom-anim .leaflet-tile,\n.leaflet-pan-anim .leaflet-tile,\n.leaflet-touching .leaflet-zoom-animated {\n  -webkit-transition:none;\n     -moz-transition:none;\n       -o-transition:none;\n          transition:none;\n  }\n.leaflet-zoom-anim .leaflet-zoom-hide { visibility: hidden; }\n\n/* cursors */\n.leaflet-container {\n  cursor:-webkit-grab;\n  cursor:   -moz-grab;\n  }\n.leaflet-overlay-pane path,\n.leaflet-marker-icon,\n.leaflet-container.map-clickable,\n.leaflet-container.leaflet-clickable {\n  cursor:pointer;\n  }\n.leaflet-popup-pane,\n.leaflet-control {\n  cursor:auto;\n  }\n.leaflet-dragging,\n.leaflet-dragging .map-clickable,\n.leaflet-dragging .leaflet-clickable,\n.leaflet-dragging .leaflet-container {\n  cursor:move;\n  cursor:-webkit-grabbing;\n  cursor:   -moz-grabbing;\n  }\n\n.leaflet-zoom-box {\n  background:#fff;\n  border:2px dotted #202020;\n  opacity:0.5;\n  }\n\n/* general toolbar styles */\n.leaflet-control-layers,\n.leaflet-bar {\n  background-color:#fff;\n  border:1px solid #999;\n  border-color:rgba(0,0,0,0.4);\n  border-radius:3px;\n  box-shadow:none;\n  }\n.leaflet-bar a,\n.leaflet-bar a:hover {\n  color:#404040;\n  color:rgba(0,0,0,0.75);\n  border-bottom:1px solid #ddd;\n  border-bottom-color:rgba(0,0,0,0.10);\n  }\n  .leaflet-bar a:hover,\n  .leaflet-bar a:active {\n    background-color:#f8f8f8;\n    cursor:pointer;\n    }\n  .leaflet-bar a:hover:first-child {\n    border-radius:3px 3px 0 0;\n    }\n  .leaflet-bar a:hover:last-child {\n    border-bottom:none;\n    border-radius:0 0 3px 3px;\n    }\n  .leaflet-bar a:hover:only-of-type {\n    border-radius:3px;\n    }\n\n.leaflet-bar .leaflet-disabled {\n  cursor:default;\n  opacity:0.75;\n  }\n.leaflet-control-zoom-in,\n.leaflet-control-zoom-out {\n  display:block;\n  content:'';\n  text-indent:-999em;\n  }\n\n.leaflet-control-layers .leaflet-control-layers-list,\n.leaflet-control-layers-expanded .leaflet-control-layers-toggle {\n  display:none;\n  }\n  .leaflet-control-layers-expanded .leaflet-control-layers-list {\n    display:block;\n    position:relative;\n    }\n\n.leaflet-control-layers-expanded {\n  background:#fff;\n  padding:6px 10px 6px 6px;\n  color:#404040;\n  color:rgba(0,0,0,0.75);\n  }\n.leaflet-control-layers-selector {\n  margin-top:2px;\n  position:relative;\n  top:1px;\n  }\n.leaflet-control-layers label {\n  display: block;\n  }\n.leaflet-control-layers-separator {\n  height:0;\n  border-top:1px solid #ddd;\n  border-top-color:rgba(0,0,0,0.10);\n  margin:5px -10px 5px -6px;\n  }\n\n.leaflet-container .leaflet-control-attribution {\n  background-color:rgba(255,255,255,0.5);\n  margin:0;\n  box-shadow:none;\n  }\n  .leaflet-container .leaflet-control-attribution a,\n  .leaflet-container .map-info-container a {\n    color:#404040;\n    }\n    .leaflet-control-attribution a:hover,\n    .map-info-container a:hover {\n      color:inherit;\n      text-decoration:underline;\n      }\n\n.leaflet-control-attribution,\n.leaflet-control-scale-line {\n  padding:0 5px;\n  }\n  .leaflet-left .leaflet-control-scale    { margin-left:5px; }\n  .leaflet-bottom .leaflet-control-scale  { margin-bottom:5px; }\n\n/* Used for smaller map containers & triggered by container size */\n.leaflet-container .leaflet-control-attribution.leaflet-compact-attribution { margin:10px; }\n.leaflet-container .leaflet-control-attribution.leaflet-compact-attribution {\n  background:#fff;\n  border-radius:3px 13px 13px 3px;\n  padding:3px 31px 3px 3px;\n  visibility:hidden;\n  }\n  .leaflet-control-attribution.leaflet-compact-attribution:hover {\n    visibility:visible;\n    }\n\n.leaflet-control-attribution.leaflet-compact-attribution:after {\n  content:'';\n  background-color:#fff;\n  background-color:rgba(255,255,255,0.5);\n  background-position:0 -78px;\n  border-radius:50%;\n  position:absolute;\n  display:inline-block;\n  width:26px;\n  height:26px;\n  vertical-align:middle;\n  bottom:0;\n  z-index:1;\n  visibility:visible;\n  cursor:pointer;\n  }\n  .leaflet-control-attribution.leaflet-compact-attribution:hover:after { background-color:#fff; }\n\n.leaflet-right .leaflet-control-attribution.leaflet-compact-attribution:after { right:0; }\n.leaflet-left .leaflet-control-attribution.leaflet-compact-attribution:after { left:0; }\n\n.leaflet-control-scale-line {\n  background-color:rgba(255,255,255,0.5);\n  border:1px solid #999;\n  border-color:rgba(0,0,0,0.4);\n  border-top:none;\n  padding:2px 5px 1px;\n  white-space:nowrap;\n  overflow:hidden;\n  }\n  .leaflet-control-scale-line:not(:first-child) {\n    border-top:2px solid #ddd;\n    border-top-color:rgba(0,0,0,0.10);\n    border-bottom:none;\n    margin-top:-2px;\n    }\n  .leaflet-control-scale-line:not(:first-child):not(:last-child) {\n    border-bottom:2px solid #777;\n    }\n\n/* popup */\n.leaflet-popup {\n  position:absolute;\n  text-align:center;\n  pointer-events:none;\n  }\n.leaflet-popup-content-wrapper {\n  padding:1px;\n  text-align:left;\n  pointer-events:all;\n  }\n.leaflet-popup-content {\n  padding:10px 10px 15px;\n  margin:0;\n  line-height:inherit;\n  }\n  .leaflet-popup-close-button + .leaflet-popup-content-wrapper .leaflet-popup-content {\n    padding-top:15px;\n    }\n\n.leaflet-popup-tip-container {\n  width:20px;\n  height:20px;\n  margin:0 auto;\n  position:relative;\n  }\n.leaflet-popup-tip {\n  width:0;\n\theight:0;\n  margin:0;\n\tborder-left:10px solid transparent;\n\tborder-right:10px solid transparent;\n\tborder-top:10px solid #fff;\n  box-shadow:none;\n  }\n.leaflet-popup-close-button {\n  text-indent:-999em;\n  position:absolute;\n  top:0;right:0;\n  pointer-events:all;\n  }\n  .leaflet-popup-close-button:hover {\n    background-color:#f8f8f8;\n    }\n\n.leaflet-popup-scrolled {\n  overflow:auto;\n  border-bottom:1px solid #ddd;\n  border-top:1px solid #ddd;\n  }\n\n/* div icon */\n.leaflet-div-icon {\n  background:#fff;\n  border:1px solid #999;\n  border-color:rgba(0,0,0,0.4);\n  }\n.leaflet-editing-icon {\n  border-radius:3px;\n  }\n\n/* Leaflet + Mapbox\n------------------------------------------------------- */\n.leaflet-bar a,\n.mapbox-icon,\n.map-tooltip.closable .close,\n.leaflet-control-layers-toggle,\n.leaflet-popup-close-button,\n.mapbox-button-icon:before {\n  content:'';\n  display:inline-block;\n  width:26px;\n  height:26px;\n  vertical-align:middle;\n  background-repeat:no-repeat;\n  }\n.leaflet-bar a {\n  display:block;\n  }\n\n.leaflet-control-attribution:after,\n.leaflet-control-zoom-in,\n.leaflet-control-zoom-out,\n.leaflet-popup-close-button,\n.leaflet-control-layers-toggle,\n.leaflet-container.dark .map-tooltip .close,\n.map-tooltip .close,\n.mapbox-icon {\n  opacity: .75;\n  background-image:url(" + escape(__webpack_require__(967)) + ");\n  background-repeat:no-repeat;\n  background-size:26px 260px;\n  }\n  .leaflet-container.dark .leaflet-control-attribution:after,\n  .mapbox-button-icon:before,\n  .leaflet-container.dark .leaflet-control-zoom-in,\n  .leaflet-container.dark .leaflet-control-zoom-out,\n  .leaflet-container.dark .leaflet-control-layers-toggle,\n  .leaflet-container.dark .mapbox-icon {\n    opacity: 1;\n    background-image:url(" + escape(__webpack_require__(968)) + ");\n    background-size:26px 260px;\n    }\n  .leaflet-bar .leaflet-control-zoom-in                 { background-position:0 0; }\n  .leaflet-bar .leaflet-control-zoom-out                { background-position:0 -26px; }\n  .map-tooltip.closable .close,\n  .leaflet-popup-close-button {\n    background-position:-3px -55px;\n    width:20px;\n    height:20px;\n    border-radius:0 3px 0 0;\n    }\n  .mapbox-icon-info                                     { background-position:0 -78px; }\n  .leaflet-control-layers-toggle                        { background-position:0 -104px; }\n  .mapbox-icon.mapbox-icon-share:before, .mapbox-icon.mapbox-icon-share         { background-position:0 -130px; }\n  .mapbox-icon.mapbox-icon-geocoder:before, .mapbox-icon.mapbox-icon-geocoder   { background-position:0 -156px; }\n  .mapbox-icon-facebook:before, .mapbox-icon-facebook   { background-position:0 -182px; }\n  .mapbox-icon-twitter:before, .mapbox-icon-twitter     { background-position:0 -208px; }\n  .mapbox-icon-pinterest:before, .mapbox-icon-pinterest { background-position:0 -234px; }\n\n.leaflet-popup-content-wrapper,\n.map-legends,\n.map-tooltip {\n  background:#fff;\n  border-radius:3px;\n  box-shadow:0 1px 2px rgba(0,0,0,0.10);\n  }\n.map-legends,\n.map-tooltip {\n  max-width:300px;\n  }\n.map-legends .map-legend {\n  padding:10px;\n  }\n.map-tooltip {\n  z-index:999999;\n  padding:10px;\n  min-width:180px;\n  max-height:400px;\n  overflow:auto;\n  opacity:1;\n  -webkit-transition:opacity 150ms;\n     -moz-transition:opacity 150ms;\n       -o-transition:opacity 150ms;\n          transition:opacity 150ms;\n  }\n\n.map-tooltip .close {\n  text-indent:-999em;\n  overflow:hidden;\n  display:none;\n  }\n  .map-tooltip.closable .close {\n    position:absolute;\n    top:0;right:0;\n    border-radius:3px;\n    }\n    .map-tooltip.closable .close:active  {\n      background-color:#f8f8f8;\n      }\n\n.leaflet-control-interaction {\n  position:absolute;\n  top:10px;\n  right:10px;\n  width:300px;\n  }\n.leaflet-popup-content .marker-title {\n  font-weight:bold;\n  }\n.leaflet-control .mapbox-button {\n  background-color:#fff;\n  border:1px solid #ddd;\n  border-color:rgba(0,0,0,0.10);\n  padding:5px 10px;\n  border-radius:3px;\n  }\n\n/* Share modal\n------------------------------------------------------- */\n.mapbox-modal > div {\n  position:absolute;\n  top:0;\n  left:0;\n  width:100%;\n  height:100%;\n  z-index:-1;\n  overflow-y:auto;\n  }\n  .mapbox-modal.active > div {\n    z-index:99999;\n    transition:all .2s, z-index 0 0;\n    }\n\n.mapbox-modal .mapbox-modal-mask {\n  background:rgba(0,0,0,0.5);\n  opacity:0;\n  }\n  .mapbox-modal.active .mapbox-modal-mask { opacity:1; }\n\n.mapbox-modal .mapbox-modal-content {\n  -webkit-transform:translateY(-100%);\n     -moz-transform:translateY(-100%);\n      -ms-transform:translateY(-100%);\n          transform:translateY(-100%);\n  }\n  .mapbox-modal.active .mapbox-modal-content {\n    -webkit-transform:translateY(0);\n       -moz-transform:translateY(0);\n        -ms-transform:translateY(0);\n            transform:translateY(0);\n    }\n\n.mapbox-modal-body {\n  position:relative;\n  background:#fff;\n  padding:20px;\n  z-index:1000;\n  width:50%;\n  margin:20px 0 20px 25%;\n  }\n.mapbox-share-buttons {\n  margin:0 0 20px;\n  }\n.mapbox-share-buttons a {\n  width:33.3333%;\n  border-left:1px solid #fff;\n  text-align:center;\n  border-radius:0;\n  }\n  .mapbox-share-buttons a:last-child  { border-radius:0 3px 3px 0; }\n  .mapbox-share-buttons a:first-child { border:none; border-radius:3px 0 0 3px; }\n\n.mapbox-modal input {\n  width:100%;\n  height:40px;\n  padding:10px;\n  border:1px solid #ddd;\n  border-color:rgba(0,0,0,0.10);\n  color:rgba(0,0,0,0.5);\n  }\n\n/* Info Control\n------------------------------------------------------- */\n.leaflet-control.mapbox-control-info {\n  margin:5px 30px 10px 10px;\n  min-height:26px;\n  }\n  .leaflet-right .leaflet-control.mapbox-control-info {\n    margin:5px 10px 10px 30px;\n    }\n\n.mapbox-info-toggle {\n  background-color:#fff;\n  background-color:rgba(255,255,255,0.5);\n  border-radius:50%;\n  position:absolute;\n  bottom:0;left:0;\n  z-index:1;\n  }\n  .leaflet-right .mapbox-control-info .mapbox-info-toggle  { left:auto; right:0; }\n  .mapbox-info-toggle:hover { background-color:#fff; }\n\n.map-info-container {\n  background:#fff;\n  padding:3px 5px 3px 27px;\n  display:none;\n  position:relative;\n  bottom:0;left:0;\n  border-radius:13px 3px 3px 13px;\n  }\n  .leaflet-right .map-info-container {\n    left:auto;\n    right:0;\n    padding:3px 27px 3px 5px;\n    border-radius:3px 13px 13px 3px;\n    }\n\n.mapbox-control-info.active .map-info-container { display:inline-block; }\n.leaflet-container .mapbox-improve-map { font-weight:bold; }\n\n/* Geocoder\n------------------------------------------------------- */\n.leaflet-control-mapbox-geocoder {\n  position:relative;\n  }\n.leaflet-control-mapbox-geocoder.searching {\n  opacity:0.75;\n  }\n.leaflet-control-mapbox-geocoder .leaflet-control-mapbox-geocoder-wrap {\n  background:#fff;\n  position:absolute;\n  border:1px solid #999;\n  border-color:rgba(0,0,0,0.4);\n  overflow:hidden;\n  left:26px;\n  height:28px;\n  width:0;\n  top:-1px;\n  border-radius:0 3px 3px 0;\n  opacity:0;\n  -webkit-transition:opacity 100ms;\n     -moz-transition:opacity 100ms;\n       -o-transition:opacity 100ms;\n          transition:opacity 100ms;\n  }\n.leaflet-control-mapbox-geocoder.active .leaflet-control-mapbox-geocoder-wrap {\n  width:180px;\n  opacity:1;\n  }\n.leaflet-bar .leaflet-control-mapbox-geocoder-toggle,\n.leaflet-bar .leaflet-control-mapbox-geocoder-toggle:hover {\n  border-bottom:none;\n  }\n.leaflet-control-mapbox-geocoder-toggle {\n  border-radius:3px;\n  }\n.leaflet-control-mapbox-geocoder.active,\n.leaflet-control-mapbox-geocoder.active .leaflet-control-mapbox-geocoder-toggle {\n  border-top-right-radius:0;\n  border-bottom-right-radius:0;\n  }\n.leaflet-control-mapbox-geocoder .leaflet-control-mapbox-geocoder-form input {\n  background:transparent;\n  border:0;\n  width:180px;\n  padding:0 0 0 10px;\n  height:26px;\n  outline:none;\n  }\n.leaflet-control-mapbox-geocoder-results {\n  width:180px;\n  position:absolute;\n  left:26px;\n  top:25px;\n  border-radius:0 0 3px 3px;\n  }\n  .leaflet-control-mapbox-geocoder.active .leaflet-control-mapbox-geocoder-results {\n    background:#fff;\n    border:1px solid #999;\n    border-color:rgba(0,0,0,0.4);\n    }\n.leaflet-control-mapbox-geocoder-results a,\n.leaflet-control-mapbox-geocoder-results span {\n  padding:0 10px;\n  text-overflow:ellipsis;\n  white-space:nowrap;\n  display:block;\n  width:100%;\n  font-size:12px;\n  line-height:26px;\n  text-align:left;\n  overflow:hidden;\n  }\n  .leaflet-container.dark .leaflet-control .leaflet-control-mapbox-geocoder-results a:hover,\n  .leaflet-control-mapbox-geocoder-results a:hover {\n    background:#f8f8f8;\n    opacity:1;\n    }\n\n.leaflet-right .leaflet-control-mapbox-geocoder-wrap,\n.leaflet-right .leaflet-control-mapbox-geocoder-results {\n  left:auto;\n  right:26px;\n  }\n.leaflet-right .leaflet-control-mapbox-geocoder-wrap {\n  border-radius:3px 0 0 3px;\n  }\n.leaflet-right .leaflet-control-mapbox-geocoder.active,\n.leaflet-right .leaflet-control-mapbox-geocoder.active .leaflet-control-mapbox-geocoder-toggle {\n  border-radius:0 3px 3px 0;\n  }\n\n.leaflet-bottom .leaflet-control-mapbox-geocoder-results {\n  top:auto;\n  bottom:25px;\n  border-radius:3px 3px 0 0;\n  }\n\n/* Mapbox Logo\n------------------------------------------------------- */\n.mapbox-logo-true:before {\n  content:'';\n  display:inline-block;\n  width:61px;\n  height:19px;\n  vertical-align:middle;\n}\n.mapbox-logo-true {\n  background-repeat:no-repeat;\n  background-size:61px 19px;\n  background-image:url('data:image/svg+xml;charset=utf-8;base64,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');\n}\n\n/* Dark Theme\n------------------------------------------------------- */\n.leaflet-container.dark .leaflet-bar {\n  background-color:#404040;\n  border-color:#202020;\n  border-color:rgba(0,0,0,0.75);\n  }\n  .leaflet-container.dark .leaflet-bar a {\n    color:#404040;\n    border-color:rgba(0,0,0,0.5);\n    }\n  .leaflet-container.dark .leaflet-bar a:active,\n  .leaflet-container.dark .leaflet-bar a:hover {\n    background-color:#505050;\n    }\n\n.leaflet-container.dark .leaflet-control-attribution:after,\n.leaflet-container.dark .mapbox-info-toggle,\n.leaflet-container.dark .map-info-container,\n.leaflet-container.dark .leaflet-control-attribution {\n  background-color:rgba(0,0,0,0.5);\n  color:#f8f8f8;\n  }\n  .leaflet-container.dark .leaflet-control-attribution a,\n  .leaflet-container.dark .leaflet-control-attribution a:hover,\n  .leaflet-container.dark .map-info-container a,\n  .leaflet-container.dark .map-info-container a:hover {\n    color:#fff;\n    }\n\n.leaflet-container.dark .leaflet-control-attribution:hover:after {\n  background-color:#000;\n  }\n.leaflet-container.dark .leaflet-control-layers-list span {\n  color:#f8f8f8;\n  }\n.leaflet-container.dark .leaflet-control-layers-separator {\n  border-top-color:rgba(255,255,255,0.10);\n  }\n.leaflet-container.dark .leaflet-bar a.leaflet-disabled,\n.leaflet-container.dark .leaflet-control .mapbox-button.disabled {\n  background-color:#252525;\n  color:#404040;\n  }\n.leaflet-container.dark .leaflet-control-mapbox-geocoder > div {\n  border-color:#202020;\n  border-color:rgba(0,0,0,0.75);\n  }\n  .leaflet-container.dark .leaflet-control .leaflet-control-mapbox-geocoder-results a {\n    border-color:#ddd #202020;\n    border-color:rgba(0,0,0,0.10) rgba(0,0,0,0.75);\n    }\n  .leaflet-container.dark .leaflet-control .leaflet-control-mapbox-geocoder-results span {\n    border-color:#202020;\n    border-color:rgba(0,0,0,0.75);\n    }\n\n/* Larger Screens\n------------------------------------------------------- */\n@media only screen and (max-width:800px) {\n.mapbox-modal-body {\n  width:83.3333%;\n  margin-left:8.3333%;\n  }\n}\n\n/* Smaller Screens\n------------------------------------------------------- */\n@media only screen and (max-width:640px) {\n.mapbox-modal-body {\n  width:100%;\n  height:100%;\n  margin:0;\n  }\n}\n\n/* Print\n------------------------------------------------------- */\n@media print { .mapbox-improve-map { display:none; } }\n\n/* Browser Fixes\n------------------------------------------------------- */\n/* VML support for IE8 */\n.leaflet-vml-shape { width:1px; height:1px; }\n.lvml { behavior:url(#default#VML); display:inline-block; position:absolute; }\n/* Map is broken in FF if you have max-width: 100% on tiles */\n.leaflet-container img.leaflet-tile { max-width:none !important; }\n/* Markers are broken in FF/IE if you have max-width: 100% on marker images */\n.leaflet-container img.leaflet-marker-icon { max-width:none; }\n/* Stupid Android 2 doesn't understand \"max-width: none\" properly */\n.leaflet-container img.leaflet-image-layer { max-width:15000px !important; }\n/* workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=888319 */\n.leaflet-overlay-pane svg { -moz-user-select:none; }\n/* Older IEs don't support the translateY property for display animation */\n.leaflet-oldie .mapbox-modal .mapbox-modal-content        { display:none; }\n.leaflet-oldie .mapbox-modal.active .mapbox-modal-content { display:block; }\n.map-tooltip { width:280px\\8; /* < IE9 */ }\n\n/* < IE8 */\n.leaflet-oldie .leaflet-control-zoom-in,\n.leaflet-oldie .leaflet-control-zoom-out,\n.leaflet-oldie .leaflet-popup-close-button,\n.leaflet-oldie .leaflet-control-layers-toggle,\n.leaflet-oldie .leaflet-container.dark .map-tooltip .close,\n.leaflet-oldie .map-tooltip .close,\n.leaflet-oldie .mapbox-icon {\n  background-image:url('data:image/png;base64,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');\n}\n.leaflet-oldie .mapbox-button-icon:before,\n.leaflet-oldie .leaflet-container.dark .leaflet-control-zoom-in,\n.leaflet-oldie .leaflet-container.dark .leaflet-control-zoom-out,\n.leaflet-oldie .leaflet-container.dark .leaflet-control-layers-toggle,\n.leaflet-oldie .leaflet-container.dark .mapbox-icon {\n  background-image:url('data:image/png;base64,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');\n}\n\n.leaflet-oldie .mapbox-logo-true {\n  background-image: none;\n}\n", ""]);
	
	// exports


/***/ },
/* 967 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAIICAMAAAAWgT0mAAAAYFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD6T+iNAAAAIHRSTlMAt/+ANr7Y9FEgxEDr+0cCF12ufA2Z4yhyCEyMZ1Wgzz2snYUAAASxSURBVHgB7dyH0qLMFoXh5aIFRVoQAUUE7v8uj5R+dMmRZmuN9U/YT4WJL2EDPRGhlPqbrMgV3sWbfzxa0aF0hpz4ViQ/PL24gkdDKaWUUr81pb+H/d0ppZRSSgXB5OuShgwmXxdFDKZflVeukVeukVeyZlLJG1e55quRO7zvDkI+cvnFld9G37hhpY/G55RSSikTrMMoCteBgdQm5CjcQGIb80m8xaJdwolkt9hYcsouVNuELyRb+Ljz2QN7d17euXGEG458MwznohCzDPl8eI7BnICzAsxZc9Zackru8JZOKuLcIBj92iicj0LRIHAjGkQwiUQjN/OR+bW3kfyG/fzRkD+E8sf9CwuLbAmTL5ZfWJbllFJKpSnelB3yJMkPGcTMMbYc0MZHg2XFpqz4pCo3BTxO57XlC3Z9PmEOPX5ttD2vIr4Qrc5beNSX/x/EpYbjn8dkAsLJe2fthM2+xgv1vgl904tW1+1kOtdVJBh52Ozqxy52TSi/TlF+3W6veaTXSa/Tf3adfh9KKaWKmKOPKngEHAVPlaRx1XLEaYSDOHJNa2URHNfIItfYQyyNXNOiiKWRazBUwsg1QyWLXDMoRNHeNUEAxxsV8diQgSwaqnsD3kgjFHu8ETl/TTT1nSjgSwGE1aT5+ymllDLHvKryo4Fc0fGhKyBkKo4qA5FiaMpLll3KoSog0ZHVDhjsKrKDgCE5NPeKpMGyI1liVJJHLMvJC0YXMseyiswwysjqkyj55PD6TwZRfmvk04sbfnAbkcHbN6yr5I9G6CrZQ5j0pUHgKrk/pZJHrpI3rnpqlFJKBZwRyBtRRY9vR/1xs9uU70XnFDftW1EHvB3Z4oMoxM2hf28QOW5CiiN3SvyLIjioPohqfhCdPokuf8HINQrmI/ES6yJfo5RS6vdWmPaUYkFdPH2rsSSTA+pDV2PWJS7gmp53ccQr5jV0FRqOmrbFrDVZ7XFXW/6wdl379nTTZRgYOr4GFw7sapMCLZ0TPOqYd1Gfd3QyeLQm5As2hceKEV+o4HPkSzl8ioqvXOFlkheNzeC37SJOdVgQxAkn7AkLjOVUiUXttOprLDvlER1GJ4i0CUeJgUC6i+lUy/sxQddHdGxTSM6ntBxF3Qky2bXJ+ygJV+WlhlJKqd9Dapr7e6mNSSFTnxOOknMNgU3FJ9Xmo78qDrCg4wudaD+2L68mM9emF+xrwwF7gx/XaOlF6rrijT2mALJ9a2oA2zVvqhpzzhxchh3c86b4+a3ZGTPS5HHW2YoPYfF4tzpJfW+hVwWQk4zc4Drfe+jN4zhasjLYJxxkwIE3je/N+h3QkwcAJR/fPvnerQ9J2gJpRJv9XLMhT63nlfeIZAWcyHjcMfdA4fu8gOR+Dtl9s3XEwQkwvih+bLmiHSbNwfC1lp7D6x632YEsgOM48qNvEEfeJMPxhQDyn1NKK9/I9xz0pwvLIfrZ0ZW+i4ueA2uHOcP0tF16v4s9txEOfNhiYDIAxYreGxZp5f4Y0xQYbEMuPBrYWA5yoLDh2ZhzHgk+zeD8cyybd5aW5nGTlpKFxVWWPCGtJPtxTM8CB9li6aRnIBQvy05x7OLE/QKg1G/ifyZmTPT8xDL0AAAAAElFTkSuQmCC"

/***/ },
/* 968 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAIICAMAAAAWgT0mAAAAYFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////98JRy6AAAAIHRSTlMAt/+ANr7Y9FEgxEDr+0cCF12ufA2Z4yhyCEyMZ1Wgzz2snYUAAASxSURBVHgB7dyH0qLMFoXh5aIFRVoQAUUE7v8uj5R+dMmRZmuN9U/YT4WJL2EDPRGhlPqbrMgV3sWbfzxa0aF0hpz4ViQ/PL24gkdDKaWUUr81pb+H/d0ppZRSSgXB5OuShgwmXxdFDKZflVeukVeukVeyZlLJG1e55quRO7zvDkI+cvnFld9G37hhpY/G55RSSikTrMMoCteBgdQm5CjcQGIb80m8xaJdwolkt9hYcsouVNuELyRb+Ljz2QN7d17euXGEG458MwznohCzDPl8eI7BnICzAsxZc9Zackru8JZOKuLcIBj92iicj0LRIHAjGkQwiUQjN/OR+bW3kfyG/fzRkD+E8sf9CwuLbAmTL5ZfWJbllFJKpSnelB3yJMkPGcTMMbYc0MZHg2XFpqz4pCo3BTxO57XlC3Z9PmEOPX5ttD2vIr4Qrc5beNSX/x/EpYbjn8dkAsLJe2fthM2+xgv1vgl904tW1+1kOtdVJBh52Ozqxy52TSi/TlF+3W6veaTXSa/Tf3adfh9KKaWKmKOPKngEHAVPlaRx1XLEaYSDOHJNa2URHNfIItfYQyyNXNOiiKWRazBUwsg1QyWLXDMoRNHeNUEAxxsV8diQgSwaqnsD3kgjFHu8ETl/TTT1nSjgSwGE1aT5+ymllDLHvKryo4Fc0fGhKyBkKo4qA5FiaMpLll3KoSog0ZHVDhjsKrKDgCE5NPeKpMGyI1liVJJHLMvJC0YXMseyiswwysjqkyj55PD6TwZRfmvk04sbfnAbkcHbN6yr5I9G6CrZQ5j0pUHgKrk/pZJHrpI3rnpqlFJKBZwRyBtRRY9vR/1xs9uU70XnFDftW1EHvB3Z4oMoxM2hf28QOW5CiiN3SvyLIjioPohqfhCdPokuf8HINQrmI/ES6yJfo5RS6vdWmPaUYkFdPH2rsSSTA+pDV2PWJS7gmp53ccQr5jV0FRqOmrbFrDVZ7XFXW/6wdl379nTTZRgYOr4GFw7sapMCLZ0TPOqYd1Gfd3QyeLQm5As2hceKEV+o4HPkSzl8ioqvXOFlkheNzeC37SJOdVgQxAkn7AkLjOVUiUXttOprLDvlER1GJ4i0CUeJgUC6i+lUy/sxQddHdGxTSM6ntBxF3Qky2bXJ+ygJV+WlhlJKqd9Dapr7e6mNSSFTnxOOknMNgU3FJ9Xmo78qDrCg4wudaD+2L68mM9emF+xrwwF7gx/XaOlF6rrijT2mALJ9a2oA2zVvqhpzzhxchh3c86b4+a3ZGTPS5HHW2YoPYfF4tzpJfW+hVwWQk4zc4Drfe+jN4zhasjLYJxxkwIE3je/N+h3QkwcAJR/fPvnerQ9J2gJpRJv9XLMhT63nlfeIZAWcyHjcMfdA4fu8gOR+Dtl9s3XEwQkwvih+bLmiHSbNwfC1lp7D6x632YEsgOM48qNvEEfeJMPxhQDyn1NKK9/I9xz0pwvLIfrZ0ZW+i4ueA2uHOcP0tF16v4s9txEOfNhiYDIAxYreGxZp5f4Y0xQYbEMuPBrYWA5yoLDh2ZhzHgk+zeD8cyybd5aW5nGTlpKFxVWWPCGtJPtxTM8CB9li6aRnIBQvy05x7OLE/QKg1G/ifyZmTPT8xDL0AAAAAElFTkSuQmCC"

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _moment = __webpack_require__(519);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.values.timezone', []).factory('timezone', function () {
	  return _moment2.default.tz.guess();
	}).name;

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EXPERIMENT = 'EXPERIMENT';
	var FOUNDATION = 'FOUNDATION';
	var INITIAL = 'INITIAL';
	var MIS_SCOPE = 'MIS_SCOPE';
	var OTHER = 'OTHER';
	var OVER_CAPACITY = 'OVER_CAPACITY';
	var PERMIT = 'PERMIT';
	var MATERIAL_SOURCING = 'MATERIAL_SOURCING';
	var REWORK = 'REWORK';
	var TARGET_CHANGE = 'TARGET_CHANGE';
	var UTILITY = 'UTILITY';
	var VENDOR_DELAYS = 'VENDOR_DELAYS';
	var WEATHER = 'WEATHER';
	
	var Reason = function Reason(reason, description) {
	  _classCallCheck(this, Reason);
	
	  this.reason = reason;
	  this.description = description;
	};
	
	module.exports = _angular2.default.module('common.values.work-order-time-estimate-types', []).factory('VENDOR_TIME_ESTIMATE_REASONS', function () {
	  return [new Reason(MIS_SCOPE, 'The original scope was incorrect, so the reno manager had to add time for the revised scope.'), new Reason(OVER_CAPACITY, 'The work will be late because resources are stretched too thin.'), new Reason(PERMIT, 'City permit delay for trade work.'), new Reason(MATERIAL_SOURCING, 'Sourcing of raw materials has caused delays.'), new Reason(REWORK, "Work didn't pass QA and must be fixed"), new Reason(TARGET_CHANGE, 'The work order target dates have changed so updating the estimate with that in mind.'), new Reason(UTILITY, 'Utility issues have delayed work'), new Reason(WEATHER, "The weather wasn't good enough to do work."), new Reason(OTHER, '')];
	}).factory('WORK_ORDER_TIME_REASONS', function () {
	  return [new Reason(INITIAL, 'The initial time item'), new Reason(MIS_SCOPE, 'The original scope was incorrect, so the reno manager had to add time for the revised scope.'), new Reason(VENDOR_DELAYS, 'Miscellaneous vendor delays, such as truck issues, equipment delays, poor staffing.'), new Reason(REWORK, "The vendor's work didn't pass EQC and/or didn't reach a HQ score of 100."), new Reason(WEATHER, "The weather wasn't good enough to do work."), new Reason(UTILITY, "Utilities weren't on, so the vendor was unable to work."), new Reason(PERMIT, 'City permit delay for trade work.'), new Reason(FOUNDATION, 'Foundation needed work.'), new Reason(EXPERIMENT, "There is an experiment that's causing delay, e.g. REIT project that puts reno on pause."), new Reason(TARGET_CHANGE, 'COE or LCO changed, pushing out the earliest start date.'), new Reason(OTHER, '')];
	}).factory('vendorTimeReasonDescription', ["VENDOR_TIME_ESTIMATE_REASONS", function (VENDOR_TIME_ESTIMATE_REASONS) {
	  return function (reason) {
	    if (!reason) return undefined;
	    var rsn = (0, _lodash.find)(VENDOR_TIME_ESTIMATE_REASONS, { reason: reason });
	    if (rsn) {
	      return rsn.description;
	    } else {
	      return undefined;
	    }
	  };
	}]).factory('workOrderTimeReasonDescription', ["WORK_ORDER_TIME_REASONS", function (WORK_ORDER_TIME_REASONS) {
	  return function (reason) {
	    if (!reason) return undefined;
	    var rsn = (0, _lodash.find)(WORK_ORDER_TIME_REASONS, { reason: reason });
	    if (rsn) {
	      return rsn.description;
	    } else {
	      return undefined;
	    }
	  };
	}]).name;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.routes', [__webpack_require__(600), __webpack_require__(972), __webpack_require__(973)]).config(["$locationProvider", "$urlMatcherFactoryProvider", function ($locationProvider, $urlMatcherFactoryProvider) {
	  // Fancy pushstate
	  $locationProvider.html5Mode({
	    enabled: true,
	    requireBase: false
	  });
	
	  // Allow trailing slashes
	  $urlMatcherFactoryProvider.strictMode(false);
	}]).run(["$rootScope", "$state", "$document", "Segment", function ($rootScope, $state, $document, Segment) {
	  $rootScope.$state = $state;
	
	  $rootScope.$on('$stateChangeStart', function (e, to, params) {
	    $rootScope.viewContentLoaded = false;
	
	    Segment.page(to.name);
	
	    // redirectTo
	    if (to.redirectTo) {
	      e.preventDefault();
	      if (_typeof(to.redirectTo) === 'object') {
	        var state = (0, _lodash.keys)(to.redirectTo)[0];
	        $state.go(state, (0, _lodash.merge)({}, params, to.redirectTo[state]));
	      } else if (typeof to.redirectTo === 'function') {
	        $state.go(to.redirectTo(), params);
	      } else {
	        $state.go(to.redirectTo, params);
	      }
	    }
	  });
	
	  $rootScope.$on('$stateChangeSuccess', function (e, to) {
	    // scrollTarget
	    if (to.hasOwnProperty('scrollTarget')) {
	      if (to.scrollTarget) {
	        var target = $document[0].querySelector(to.scrollTarget);
	        $document.scrollTo(_angular2.default.element(target));
	      }
	    } else {
	      $document.scrollTo(0, 0);
	    }
	
	    var remove = $rootScope.$on('$viewContentLoaded', function () {
	      $rootScope.viewContentLoaded = true;
	      remove();
	    });
	  });
	
	  $rootScope.$on('$stateChangeError', function (e, to, toParams, from, fromParams, error) {
	    throw error;
	  });
	}]).name;

/***/ },
/* 972 */,
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('common.rails', []).config(["$httpProvider", function ($httpProvider) {
	  // Play nicely with Rails
	  $httpProvider.defaults.headers.common['Accept'] = 'application/json';
	  $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-Token';
	  if (window.odDeployType) {
	    $httpProvider.defaults.xsrfCookieName = 'XSRF-G-TOKEN';
	  }
	}]).name;

/***/ },
/* 974 */,
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(976);
	module.exports = 'ui.bootstrap';


/***/ },
/* 976 */
/***/ function(module, exports) {

	/*
	 * angular-ui-bootstrap
	 * http://angular-ui.github.io/bootstrap/
	
	 * Version: 0.14.3 - 2015-10-23
	 * License: MIT
	 */
	angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.position","ui.bootstrap.datepicker","ui.bootstrap.dropdown","ui.bootstrap.stackedMap","ui.bootstrap.modal","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]);
	angular.module("ui.bootstrap.tpls", ["template/accordion/accordion-group.html","template/accordion/accordion.html","template/alert/alert.html","template/carousel/carousel.html","template/carousel/slide.html","template/datepicker/datepicker.html","template/datepicker/day.html","template/datepicker/month.html","template/datepicker/popup.html","template/datepicker/year.html","template/modal/backdrop.html","template/modal/window.html","template/pagination/pager.html","template/pagination/pagination.html","template/tooltip/tooltip-html-popup.html","template/tooltip/tooltip-popup.html","template/tooltip/tooltip-template-popup.html","template/popover/popover-html.html","template/popover/popover-template.html","template/popover/popover.html","template/progressbar/bar.html","template/progressbar/progress.html","template/progressbar/progressbar.html","template/rating/rating.html","template/tabs/tab.html","template/tabs/tabset.html","template/timepicker/timepicker.html","template/typeahead/typeahead-match.html","template/typeahead/typeahead-popup.html"]);
	angular.module('ui.bootstrap.collapse', [])
	
	  .directive('uibCollapse', ['$animate', '$injector', function($animate, $injector) {
	    var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
	    return {
	      link: function(scope, element, attrs) {
	        function expand() {
	          element.removeClass('collapse')
	            .addClass('collapsing')
	            .attr('aria-expanded', true)
	            .attr('aria-hidden', false);
	
	          if ($animateCss) {
	            $animateCss(element, {
	              addClass: 'in',
	              easing: 'ease',
	              to: { height: element[0].scrollHeight + 'px' }
	            }).start().finally(expandDone);
	          } else {
	            $animate.addClass(element, 'in', {
	              to: { height: element[0].scrollHeight + 'px' }
	            }).then(expandDone);
	          }
	        }
	
	        function expandDone() {
	          element.removeClass('collapsing')
	            .addClass('collapse')
	            .css({height: 'auto'});
	        }
	
	        function collapse() {
	          if (!element.hasClass('collapse') && !element.hasClass('in')) {
	            return collapseDone();
	          }
	
	          element
	            // IMPORTANT: The height must be set before adding "collapsing" class.
	            // Otherwise, the browser attempts to animate from height 0 (in
	            // collapsing class) to the given height here.
	            .css({height: element[0].scrollHeight + 'px'})
	            // initially all panel collapse have the collapse class, this removal
	            // prevents the animation from jumping to collapsed state
	            .removeClass('collapse')
	            .addClass('collapsing')
	            .attr('aria-expanded', false)
	            .attr('aria-hidden', true);
	
	          if ($animateCss) {
	            $animateCss(element, {
	              removeClass: 'in',
	              to: {height: '0'}
	            }).start().finally(collapseDone);
	          } else {
	            $animate.removeClass(element, 'in', {
	              to: {height: '0'}
	            }).then(collapseDone);
	          }
	        }
	
	        function collapseDone() {
	          element.css({height: '0'}); // Required so that collapse works when animation is disabled
	          element.removeClass('collapsing')
	            .addClass('collapse');
	        }
	
	        scope.$watch(attrs.uibCollapse, function(shouldCollapse) {
	          if (shouldCollapse) {
	            collapse();
	          } else {
	            expand();
	          }
	        });
	      }
	    };
	  }]);
	
	/* Deprecated collapse below */
	
	angular.module('ui.bootstrap.collapse')
	
	  .value('$collapseSuppressWarning', false)
	
	  .directive('collapse', ['$animate', '$injector', '$log', '$collapseSuppressWarning', function($animate, $injector, $log, $collapseSuppressWarning) {
	    var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
	    return {
	      link: function(scope, element, attrs) {
	        if (!$collapseSuppressWarning) {
	          $log.warn('collapse is now deprecated. Use uib-collapse instead.');
	        }
	
	        function expand() {
	          element.removeClass('collapse')
	            .addClass('collapsing')
	            .attr('aria-expanded', true)
	            .attr('aria-hidden', false);
	
	          if ($animateCss) {
	            $animateCss(element, {
	              easing: 'ease',
	              to: { height: element[0].scrollHeight + 'px' }
	            }).start().done(expandDone);
	          } else {
	            $animate.animate(element, {}, {
	              height: element[0].scrollHeight + 'px'
	            }).then(expandDone);
	          }
	        }
	
	        function expandDone() {
	          element.removeClass('collapsing')
	            .addClass('collapse in')
	            .css({height: 'auto'});
	        }
	
	        function collapse() {
	          if (!element.hasClass('collapse') && !element.hasClass('in')) {
	            return collapseDone();
	          }
	
	          element
	            // IMPORTANT: The height must be set before adding "collapsing" class.
	            // Otherwise, the browser attempts to animate from height 0 (in
	            // collapsing class) to the given height here.
	            .css({height: element[0].scrollHeight + 'px'})
	            // initially all panel collapse have the collapse class, this removal
	            // prevents the animation from jumping to collapsed state
	            .removeClass('collapse in')
	            .addClass('collapsing')
	            .attr('aria-expanded', false)
	            .attr('aria-hidden', true);
	
	          if ($animateCss) {
	            $animateCss(element, {
	              to: {height: '0'}
	            }).start().done(collapseDone);
	          } else {
	            $animate.animate(element, {}, {
	              height: '0'
	            }).then(collapseDone);
	          }
	        }
	
	        function collapseDone() {
	          element.css({height: '0'}); // Required so that collapse works when animation is disabled
	          element.removeClass('collapsing')
	            .addClass('collapse');
	        }
	
	        scope.$watch(attrs.collapse, function(shouldCollapse) {
	          if (shouldCollapse) {
	            collapse();
	          } else {
	            expand();
	          }
	        });
	      }
	    };
	  }]);
	
	angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse'])
	
	.constant('uibAccordionConfig', {
	  closeOthers: true
	})
	
	.controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function($scope, $attrs, accordionConfig) {
	  // This array keeps track of the accordion groups
	  this.groups = [];
	
	  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
	  this.closeOthers = function(openGroup) {
	    var closeOthers = angular.isDefined($attrs.closeOthers) ?
	      $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
	    if (closeOthers) {
	      angular.forEach(this.groups, function(group) {
	        if (group !== openGroup) {
	          group.isOpen = false;
	        }
	      });
	    }
	  };
	
	  // This is called from the accordion-group directive to add itself to the accordion
	  this.addGroup = function(groupScope) {
	    var that = this;
	    this.groups.push(groupScope);
	
	    groupScope.$on('$destroy', function(event) {
	      that.removeGroup(groupScope);
	    });
	  };
	
	  // This is called from the accordion-group directive when to remove itself
	  this.removeGroup = function(group) {
	    var index = this.groups.indexOf(group);
	    if (index !== -1) {
	      this.groups.splice(index, 1);
	    }
	  };
	
	}])
	
	// The accordion directive simply sets up the directive controller
	// and adds an accordion CSS class to itself element.
	.directive('uibAccordion', function() {
	  return {
	    controller: 'UibAccordionController',
	    controllerAs: 'accordion',
	    transclude: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/accordion/accordion.html';
	    }
	  };
	})
	
	// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
	.directive('uibAccordionGroup', function() {
	  return {
	    require: '^uibAccordion',         // We need this directive to be inside an accordion
	    transclude: true,              // It transcludes the contents of the directive into the template
	    replace: true,                // The element containing the directive will be replaced with the template
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/accordion/accordion-group.html';
	    },
	    scope: {
	      heading: '@',               // Interpolate the heading attribute onto this scope
	      isOpen: '=?',
	      isDisabled: '=?'
	    },
	    controller: function() {
	      this.setHeading = function(element) {
	        this.heading = element;
	      };
	    },
	    link: function(scope, element, attrs, accordionCtrl) {
	      accordionCtrl.addGroup(scope);
	
	      scope.openClass = attrs.openClass || 'panel-open';
	      scope.panelClass = attrs.panelClass;
	      scope.$watch('isOpen', function(value) {
	        element.toggleClass(scope.openClass, !!value);
	        if (value) {
	          accordionCtrl.closeOthers(scope);
	        }
	      });
	
	      scope.toggleOpen = function($event) {
	        if (!scope.isDisabled) {
	          if (!$event || $event.which === 32) {
	            scope.isOpen = !scope.isOpen;
	          }
	        }
	      };
	    }
	  };
	})
	
	// Use accordion-heading below an accordion-group to provide a heading containing HTML
	.directive('uibAccordionHeading', function() {
	  return {
	    transclude: true,   // Grab the contents to be used as the heading
	    template: '',       // In effect remove this element!
	    replace: true,
	    require: '^uibAccordionGroup',
	    link: function(scope, element, attrs, accordionGroupCtrl, transclude) {
	      // Pass the heading to the accordion-group controller
	      // so that it can be transcluded into the right place in the template
	      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
	      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
	    }
	  };
	})
	
	// Use in the accordion-group template to indicate where you want the heading to be transcluded
	// You must provide the property on the accordion-group controller that will hold the transcluded element
	.directive('uibAccordionTransclude', function() {
	  return {
	    require: ['?^uibAccordionGroup', '?^accordionGroup'],
	    link: function(scope, element, attrs, controller) {
	      controller = controller[0] ? controller[0] : controller[1]; // Delete after we remove deprecation
	      scope.$watch(function() { return controller[attrs.uibAccordionTransclude]; }, function(heading) {
	        if (heading) {
	          element.find('span').html('');
	          element.find('span').append(heading);
	        }
	      });
	    }
	  };
	});
	
	/* Deprecated accordion below */
	
	angular.module('ui.bootstrap.accordion')
	
	  .value('$accordionSuppressWarning', false)
	
	  .controller('AccordionController', ['$scope', '$attrs', '$controller', '$log', '$accordionSuppressWarning', function($scope, $attrs, $controller, $log, $accordionSuppressWarning) {
	    if (!$accordionSuppressWarning) {
	      $log.warn('AccordionController is now deprecated. Use UibAccordionController instead.');
	    }
	
	    angular.extend(this, $controller('UibAccordionController', {
	      $scope: $scope,
	      $attrs: $attrs
	    }));
	  }])
	
	  .directive('accordion', ['$log', '$accordionSuppressWarning', function($log, $accordionSuppressWarning) {
	    return {
	      restrict: 'EA',
	      controller: 'AccordionController',
	      controllerAs: 'accordion',
	      transclude: true,
	      replace: false,
	      templateUrl: function(element, attrs) {
	        return attrs.templateUrl || 'template/accordion/accordion.html';
	      },
	      link: function() {
	        if (!$accordionSuppressWarning) {
	          $log.warn('accordion is now deprecated. Use uib-accordion instead.');
	        }
	      }
	    };
	  }])
	
	  .directive('accordionGroup', ['$log', '$accordionSuppressWarning', function($log, $accordionSuppressWarning) {
	    return {
	      require: '^accordion',         // We need this directive to be inside an accordion
	      restrict: 'EA',
	      transclude: true,              // It transcludes the contents of the directive into the template
	      replace: true,                // The element containing the directive will be replaced with the template
	      templateUrl: function(element, attrs) {
	        return attrs.templateUrl || 'template/accordion/accordion-group.html';
	      },
	      scope: {
	        heading: '@',               // Interpolate the heading attribute onto this scope
	        isOpen: '=?',
	        isDisabled: '=?'
	      },
	      controller: function() {
	        this.setHeading = function(element) {
	          this.heading = element;
	        };
	      },
	      link: function(scope, element, attrs, accordionCtrl) {
	        if (!$accordionSuppressWarning) {
	          $log.warn('accordion-group is now deprecated. Use uib-accordion-group instead.');
	        }
	
	        accordionCtrl.addGroup(scope);
	
	        scope.openClass = attrs.openClass || 'panel-open';
	        scope.panelClass = attrs.panelClass;
	        scope.$watch('isOpen', function(value) {
	          element.toggleClass(scope.openClass, !!value);
	          if (value) {
	            accordionCtrl.closeOthers(scope);
	          }
	        });
	
	        scope.toggleOpen = function($event) {
	          if (!scope.isDisabled) {
	            if (!$event || $event.which === 32) {
	              scope.isOpen = !scope.isOpen;
	            }
	          }
	        };
	      }
	    };
	  }])
	
	  .directive('accordionHeading', ['$log', '$accordionSuppressWarning', function($log, $accordionSuppressWarning) {
	    return {
	      restrict: 'EA',
	      transclude: true,   // Grab the contents to be used as the heading
	      template: '',       // In effect remove this element!
	      replace: true,
	      require: '^accordionGroup',
	      link: function(scope, element, attr, accordionGroupCtrl, transclude) {
	        if (!$accordionSuppressWarning) {
	          $log.warn('accordion-heading is now deprecated. Use uib-accordion-heading instead.');
	        }
	        // Pass the heading to the accordion-group controller
	        // so that it can be transcluded into the right place in the template
	        // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
	        accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
	      }
	    };
	  }])
	
	  .directive('accordionTransclude', ['$log', '$accordionSuppressWarning', function($log, $accordionSuppressWarning) {
	    return {
	      require: '^accordionGroup',
	      link: function(scope, element, attr, controller) {
	        if (!$accordionSuppressWarning) {
	          $log.warn('accordion-transclude is now deprecated. Use uib-accordion-transclude instead.');
	        }
	
	        scope.$watch(function() { return controller[attr.accordionTransclude]; }, function(heading) {
	          if (heading) {
	            element.find('span').html('');
	            element.find('span').append(heading);
	          }
	        });
	      }
	    };
	  }]);
	
	
	angular.module('ui.bootstrap.alert', [])
	
	.controller('UibAlertController', ['$scope', '$attrs', '$interpolate', '$timeout', function($scope, $attrs, $interpolate, $timeout) {
	  $scope.closeable = !!$attrs.close;
	
	  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ?
	    $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;
	
	  if (dismissOnTimeout) {
	    $timeout(function() {
	      $scope.close();
	    }, parseInt(dismissOnTimeout, 10));
	  }
	}])
	
	.directive('uibAlert', function() {
	  return {
	    controller: 'UibAlertController',
	    controllerAs: 'alert',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/alert/alert.html';
	    },
	    transclude: true,
	    replace: true,
	    scope: {
	      type: '@',
	      close: '&'
	    }
	  };
	});
	
	/* Deprecated alert below */
	
	angular.module('ui.bootstrap.alert')
	
	  .value('$alertSuppressWarning', false)
	
	  .controller('AlertController', ['$scope', '$attrs', '$controller', '$log', '$alertSuppressWarning', function($scope, $attrs, $controller, $log, $alertSuppressWarning) {
	    if (!$alertSuppressWarning) {
	      $log.warn('AlertController is now deprecated. Use UibAlertController instead.');
	    }
	
	    angular.extend(this, $controller('UibAlertController', {
	      $scope: $scope,
	      $attrs: $attrs
	    }));
	  }])
	
	  .directive('alert', ['$log', '$alertSuppressWarning', function($log, $alertSuppressWarning) {
	    return {
	      controller: 'AlertController',
	      controllerAs: 'alert',
	      templateUrl: function(element, attrs) {
	        return attrs.templateUrl || 'template/alert/alert.html';
	      },
	      transclude: true,
	      replace: true,
	      scope: {
	        type: '@',
	        close: '&'
	      },
	      link: function() {
	        if (!$alertSuppressWarning) {
	          $log.warn('alert is now deprecated. Use uib-alert instead.');
	        }
	      }
	    };
	  }]);
	
	angular.module('ui.bootstrap.buttons', [])
	
	.constant('uibButtonConfig', {
	  activeClass: 'active',
	  toggleEvent: 'click'
	})
	
	.controller('UibButtonsController', ['uibButtonConfig', function(buttonConfig) {
	  this.activeClass = buttonConfig.activeClass || 'active';
	  this.toggleEvent = buttonConfig.toggleEvent || 'click';
	}])
	
	.directive('uibBtnRadio', function() {
	  return {
	    require: ['uibBtnRadio', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'buttons',
	    link: function(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      element.find('input').css({display: 'none'});
	
	      //model -> UI
	      ngModelCtrl.$render = function() {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function() {
	        if (attrs.disabled) {
	          return;
	        }
	
	        var isActive = element.hasClass(buttonsCtrl.activeClass);
	
	        if (!isActive || angular.isDefined(attrs.uncheckable)) {
	          scope.$apply(function() {
	            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
	            ngModelCtrl.$render();
	          });
	        }
	      });
	    }
	  };
	})
	
	.directive('uibBtnCheckbox', function() {
	  return {
	    require: ['uibBtnCheckbox', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'button',
	    link: function(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      element.find('input').css({display: 'none'});
	
	      function getTrueValue() {
	        return getCheckboxValue(attrs.btnCheckboxTrue, true);
	      }
	
	      function getFalseValue() {
	        return getCheckboxValue(attrs.btnCheckboxFalse, false);
	      }
	
	      function getCheckboxValue(attribute, defaultValue) {
	        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
	      }
	
	      //model -> UI
	      ngModelCtrl.$render = function() {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function() {
	        if (attrs.disabled) {
	          return;
	        }
	
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
	          ngModelCtrl.$render();
	        });
	      });
	    }
	  };
	});
	
	/* Deprecated buttons below */
	
	angular.module('ui.bootstrap.buttons')
	
	  .value('$buttonsSuppressWarning', false)
	
	  .controller('ButtonsController', ['$controller', '$log', '$buttonsSuppressWarning', function($controller, $log, $buttonsSuppressWarning) {
	    if (!$buttonsSuppressWarning) {
	      $log.warn('ButtonsController is now deprecated. Use UibButtonsController instead.');
	    }
	
	    angular.extend(this, $controller('UibButtonsController'));
	  }])
	
	  .directive('btnRadio', ['$log', '$buttonsSuppressWarning', function($log, $buttonsSuppressWarning) {
	    return {
	      require: ['btnRadio', 'ngModel'],
	      controller: 'ButtonsController',
	      controllerAs: 'buttons',
	      link: function(scope, element, attrs, ctrls) {
	        if (!$buttonsSuppressWarning) {
	          $log.warn('btn-radio is now deprecated. Use uib-btn-radio instead.');
	        }
	
	        var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	        element.find('input').css({display: 'none'});
	
	        //model -> UI
	        ngModelCtrl.$render = function() {
	          element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.btnRadio)));
	        };
	
	        //ui->model
	        element.bind(buttonsCtrl.toggleEvent, function() {
	          if (attrs.disabled) {
	            return;
	          }
	
	          var isActive = element.hasClass(buttonsCtrl.activeClass);
	
	          if (!isActive || angular.isDefined(attrs.uncheckable)) {
	            scope.$apply(function() {
	              ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.btnRadio));
	              ngModelCtrl.$render();
	            });
	          }
	        });
	      }
	    };
	  }])
	
	  .directive('btnCheckbox', ['$document', '$log', '$buttonsSuppressWarning', function($document, $log, $buttonsSuppressWarning) {
	    return {
	      require: ['btnCheckbox', 'ngModel'],
	      controller: 'ButtonsController',
	      controllerAs: 'button',
	      link: function(scope, element, attrs, ctrls) {
	        if (!$buttonsSuppressWarning) {
	          $log.warn('btn-checkbox is now deprecated. Use uib-btn-checkbox instead.');
	        }
	
	        var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	        element.find('input').css({display: 'none'});
	
	        function getTrueValue() {
	          return getCheckboxValue(attrs.btnCheckboxTrue, true);
	        }
	
	        function getFalseValue() {
	          return getCheckboxValue(attrs.btnCheckboxFalse, false);
	        }
	
	        function getCheckboxValue(attributeValue, defaultValue) {
	          var val = scope.$eval(attributeValue);
	          return angular.isDefined(val) ? val : defaultValue;
	        }
	
	        //model -> UI
	        ngModelCtrl.$render = function() {
	          element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
	        };
	
	        //ui->model
	        element.bind(buttonsCtrl.toggleEvent, function() {
	          if (attrs.disabled) {
	            return;
	          }
	
	          scope.$apply(function() {
	            ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
	            ngModelCtrl.$render();
	          });
	        });
	
	        //accessibility
	        element.on('keypress', function(e) {
	          if (attrs.disabled || e.which !== 32 || $document[0].activeElement !== element[0]) {
	            return;
	          }
	
	          scope.$apply(function() {
	            ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
	            ngModelCtrl.$render();
	          });
	        });
	      }
	    };
	  }]);
	
	
	/**
	 * @ngdoc overview
	 * @name ui.bootstrap.carousel
	 *
	 * @description
	 * AngularJS version of an image carousel.
	 *
	 */
	angular.module('ui.bootstrap.carousel', [])
	
	.controller('UibCarouselController', ['$scope', '$element', '$interval', '$animate', function($scope, $element, $interval, $animate) {
	  var self = this,
	    slides = self.slides = $scope.slides = [],
	    NEW_ANIMATE = angular.version.minor >= 4,
	    NO_TRANSITION = 'uib-noTransition',
	    SLIDE_DIRECTION = 'uib-slideDirection',
	    currentIndex = -1,
	    currentInterval, isPlaying;
	  self.currentSlide = null;
	
	  var destroyed = false;
	  /* direction: "prev" or "next" */
	  self.select = $scope.select = function(nextSlide, direction) {
	    var nextIndex = $scope.indexOfSlide(nextSlide);
	    //Decide direction if it's not given
	    if (direction === undefined) {
	      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
	    }
	    //Prevent this user-triggered transition from occurring if there is already one in progress
	    if (nextSlide && nextSlide !== self.currentSlide && !$scope.$currentTransition) {
	      goNext(nextSlide, nextIndex, direction);
	    }
	  };
	
	  function goNext(slide, index, direction) {
	    // Scope has been destroyed, stop here.
	    if (destroyed) { return; }
	
	    angular.extend(slide, {direction: direction, active: true});
	    angular.extend(self.currentSlide || {}, {direction: direction, active: false});
	    if ($animate.enabled() && !$scope.noTransition && !$scope.$currentTransition &&
	      slide.$element && self.slides.length > 1) {
	      slide.$element.data(SLIDE_DIRECTION, slide.direction);
	      if (self.currentSlide && self.currentSlide.$element) {
	        self.currentSlide.$element.data(SLIDE_DIRECTION, slide.direction);
	      }
	
	      $scope.$currentTransition = true;
	      if (NEW_ANIMATE) {
	        $animate.on('addClass', slide.$element, function(element, phase) {
	          if (phase === 'close') {
	            $scope.$currentTransition = null;
	            $animate.off('addClass', element);
	          }
	        });
	      } else {
	        slide.$element.one('$animate:close', function closeFn() {
	          $scope.$currentTransition = null;
	        });
	      }
	    }
	
	    self.currentSlide = slide;
	    currentIndex = index;
	
	    //every time you change slides, reset the timer
	    restartTimer();
	  }
	
	  $scope.$on('$destroy', function() {
	    destroyed = true;
	  });
	
	  function getSlideByIndex(index) {
	    if (angular.isUndefined(slides[index].index)) {
	      return slides[index];
	    }
	    var i, len = slides.length;
	    for (i = 0; i < slides.length; ++i) {
	      if (slides[i].index == index) {
	        return slides[i];
	      }
	    }
	  }
	
	  self.getCurrentIndex = function() {
	    if (self.currentSlide && angular.isDefined(self.currentSlide.index)) {
	      return +self.currentSlide.index;
	    }
	    return currentIndex;
	  };
	
	  /* Allow outside people to call indexOf on slides array */
	  $scope.indexOfSlide = function(slide) {
	    return angular.isDefined(slide.index) ? +slide.index : slides.indexOf(slide);
	  };
	
	  $scope.next = function() {
	    var newIndex = (self.getCurrentIndex() + 1) % slides.length;
	
	    if (newIndex === 0 && $scope.noWrap()) {
	      $scope.pause();
	      return;
	    }
	
	    return self.select(getSlideByIndex(newIndex), 'next');
	  };
	
	  $scope.prev = function() {
	    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;
	
	    if ($scope.noWrap() && newIndex === slides.length - 1) {
	      $scope.pause();
	      return;
	    }
	
	    return self.select(getSlideByIndex(newIndex), 'prev');
	  };
	
	  $scope.isActive = function(slide) {
	     return self.currentSlide === slide;
	  };
	
	  $scope.$watch('interval', restartTimer);
	  $scope.$watchCollection('slides', resetTransition);
	  $scope.$on('$destroy', resetTimer);
	
	  function restartTimer() {
	    resetTimer();
	    var interval = +$scope.interval;
	    if (!isNaN(interval) && interval > 0) {
	      currentInterval = $interval(timerFn, interval);
	    }
	  }
	
	  function resetTimer() {
	    if (currentInterval) {
	      $interval.cancel(currentInterval);
	      currentInterval = null;
	    }
	  }
	
	  function timerFn() {
	    var interval = +$scope.interval;
	    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
	      $scope.next();
	    } else {
	      $scope.pause();
	    }
	  }
	
	  function resetTransition(slides) {
	    if (!slides.length) {
	      $scope.$currentTransition = null;
	    }
	  }
	
	  $scope.play = function() {
	    if (!isPlaying) {
	      isPlaying = true;
	      restartTimer();
	    }
	  };
	  $scope.pause = function() {
	    if (!$scope.noPause) {
	      isPlaying = false;
	      resetTimer();
	    }
	  };
	
	  self.addSlide = function(slide, element) {
	    slide.$element = element;
	    slides.push(slide);
	    //if this is the first slide or the slide is set to active, select it
	    if (slides.length === 1 || slide.active) {
	      self.select(slides[slides.length - 1]);
	      if (slides.length === 1) {
	        $scope.play();
	      }
	    } else {
	      slide.active = false;
	    }
	  };
	
	  self.removeSlide = function(slide) {
	    if (angular.isDefined(slide.index)) {
	      slides.sort(function(a, b) {
	        return +a.index > +b.index;
	      });
	    }
	    //get the index of the slide inside the carousel
	    var index = slides.indexOf(slide);
	    slides.splice(index, 1);
	    if (slides.length > 0 && slide.active) {
	      if (index >= slides.length) {
	        self.select(slides[index - 1]);
	      } else {
	        self.select(slides[index]);
	      }
	    } else if (currentIndex > index) {
	      currentIndex--;
	    }
	
	    //clean the currentSlide when no more slide
	    if (slides.length === 0) {
	      self.currentSlide = null;
	    }
	  };
	
	  $scope.$watch('noTransition', function(noTransition) {
	    $element.data(NO_TRANSITION, noTransition);
	  });
	
	}])
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.carousel.directive:carousel
	 * @restrict EA
	 *
	 * @description
	 * Carousel is the outer container for a set of image 'slides' to showcase.
	 *
	 * @param {number=} interval The time, in milliseconds, that it will take the carousel to go to the next slide.
	 * @param {boolean=} noTransition Whether to disable transitions on the carousel.
	 * @param {boolean=} noPause Whether to disable pausing on the carousel (by default, the carousel interval pauses on hover).
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <uib-carousel>
	      <uib-slide>
	        <img src="http://placekitten.com/150/150" style="margin:auto;">
	        <div class="carousel-caption">
	          <p>Beautiful!</p>
	        </div>
	      </uib-slide>
	      <uib-slide>
	        <img src="http://placekitten.com/100/150" style="margin:auto;">
	        <div class="carousel-caption">
	          <p>D'aww!</p>
	        </div>
	      </uib-slide>
	    </uib-carousel>
	  </file>
	  <file name="demo.css">
	    .carousel-indicators {
	      top: auto;
	      bottom: 15px;
	    }
	  </file>
	</example>
	 */
	.directive('uibCarousel', [function() {
	  return {
	    transclude: true,
	    replace: true,
	    controller: 'UibCarouselController',
	    controllerAs: 'carousel',
	    require: 'carousel',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/carousel/carousel.html';
	    },
	    scope: {
	      interval: '=',
	      noTransition: '=',
	      noPause: '=',
	      noWrap: '&'
	    }
	  };
	}])
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.carousel.directive:slide
	 * @restrict EA
	 *
	 * @description
	 * Creates a slide inside a {@link ui.bootstrap.carousel.directive:carousel carousel}.  Must be placed as a child of a carousel element.
	 *
	 * @param {boolean=} active Model binding, whether or not this slide is currently active.
	 * @param {number=} index The index of the slide. The slides will be sorted by this parameter.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	<div ng-controller="CarouselDemoCtrl">
	  <uib-carousel>
	    <uib-slide ng-repeat="slide in slides" active="slide.active" index="$index">
	      <img ng-src="{{slide.image}}" style="margin:auto;">
	      <div class="carousel-caption">
	        <h4>Slide {{$index}}</h4>
	        <p>{{slide.text}}</p>
	      </div>
	    </uib-slide>
	  </uib-carousel>
	  Interval, in milliseconds: <input type="number" ng-model="myInterval">
	  <br />Enter a negative number to stop the interval.
	</div>
	  </file>
	  <file name="script.js">
	function CarouselDemoCtrl($scope) {
	  $scope.myInterval = 5000;
	}
	  </file>
	  <file name="demo.css">
	    .carousel-indicators {
	      top: auto;
	      bottom: 15px;
	    }
	  </file>
	</example>
	*/
	
	.directive('uibSlide', function() {
	  return {
	    require: '^uibCarousel',
	    restrict: 'EA',
	    transclude: true,
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/carousel/slide.html';
	    },
	    scope: {
	      active: '=?',
	      actual: '=?',
	      index: '=?'
	    },
	    link: function (scope, element, attrs, carouselCtrl) {
	      carouselCtrl.addSlide(scope, element);
	      //when the scope is destroyed then remove the slide from the current slides array
	      scope.$on('$destroy', function() {
	        carouselCtrl.removeSlide(scope);
	      });
	
	      scope.$watch('active', function(active) {
	        if (active) {
	          carouselCtrl.select(scope);
	        }
	      });
	    }
	  };
	})
	
	.animation('.item', [
	         '$injector', '$animate',
	function ($injector, $animate) {
	  var NO_TRANSITION = 'uib-noTransition',
	    SLIDE_DIRECTION = 'uib-slideDirection',
	    $animateCss = null;
	
	  if ($injector.has('$animateCss')) {
	    $animateCss = $injector.get('$animateCss');
	  }
	
	  function removeClass(element, className, callback) {
	    element.removeClass(className);
	    if (callback) {
	      callback();
	    }
	  }
	
	  return {
	    beforeAddClass: function(element, className, done) {
	      // Due to transclusion, noTransition property is on parent's scope
	      if (className == 'active' && element.parent() && element.parent().parent() &&
	          !element.parent().parent().data(NO_TRANSITION)) {
	        var stopped = false;
	        var direction = element.data(SLIDE_DIRECTION);
	        var directionClass = direction == 'next' ? 'left' : 'right';
	        var removeClassFn = removeClass.bind(this, element,
	          directionClass + ' ' + direction, done);
	        element.addClass(direction);
	
	        if ($animateCss) {
	          $animateCss(element, {addClass: directionClass})
	            .start()
	            .done(removeClassFn);
	        } else {
	          $animate.addClass(element, directionClass).then(function () {
	            if (!stopped) {
	              removeClassFn();
	            }
	            done();
	          });
	        }
	
	        return function () {
	          stopped = true;
	        };
	      }
	      done();
	    },
	    beforeRemoveClass: function (element, className, done) {
	      // Due to transclusion, noTransition property is on parent's scope
	      if (className === 'active' && element.parent() && element.parent().parent() &&
	          !element.parent().parent().data(NO_TRANSITION)) {
	        var stopped = false;
	        var direction = element.data(SLIDE_DIRECTION);
	        var directionClass = direction == 'next' ? 'left' : 'right';
	        var removeClassFn = removeClass.bind(this, element, directionClass, done);
	
	        if ($animateCss) {
	          $animateCss(element, {addClass: directionClass})
	            .start()
	            .done(removeClassFn);
	        } else {
	          $animate.addClass(element, directionClass).then(function() {
	            if (!stopped) {
	              removeClassFn();
	            }
	            done();
	          });
	        }
	        return function() {
	          stopped = true;
	        };
	      }
	      done();
	    }
	  };
	}]);
	
	/* deprecated carousel below */
	
	angular.module('ui.bootstrap.carousel')
	
	.value('$carouselSuppressWarning', false)
	
	.controller('CarouselController', ['$scope', '$element', '$controller', '$log', '$carouselSuppressWarning', function($scope, $element, $controller, $log, $carouselSuppressWarning) {
	  if (!$carouselSuppressWarning) {
	    $log.warn('CarouselController is now deprecated. Use UibCarouselController instead.');
	  }
	
	  angular.extend(this, $controller('UibCarouselController', {
	    $scope: $scope,
	    $element: $element
	  }));
	}])
	
	.directive('carousel', ['$log', '$carouselSuppressWarning', function($log, $carouselSuppressWarning) {
	  return {
	    transclude: true,
	    replace: true,
	    controller: 'CarouselController',
	    controllerAs: 'carousel',
	    require: 'carousel',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/carousel/carousel.html';
	    },
	    scope: {
	      interval: '=',
	      noTransition: '=',
	      noPause: '=',
	      noWrap: '&'
	    },
	    link: function() {
	      if (!$carouselSuppressWarning) {
	        $log.warn('carousel is now deprecated. Use uib-carousel instead.');
	      }
	    }
	  };
	}])
	
	.directive('slide', ['$log', '$carouselSuppressWarning', function($log, $carouselSuppressWarning) {
	  return {
	    require: '^carousel',
	    transclude: true,
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/carousel/slide.html';
	    },
	    scope: {
	      active: '=?',
	      actual: '=?',
	      index: '=?'
	    },
	    link: function (scope, element, attrs, carouselCtrl) {
	      if (!$carouselSuppressWarning) {
	        $log.warn('slide is now deprecated. Use uib-slide instead.');
	      }
	
	      carouselCtrl.addSlide(scope, element);
	      //when the scope is destroyed then remove the slide from the current slides array
	      scope.$on('$destroy', function() {
	        carouselCtrl.removeSlide(scope);
	      });
	
	      scope.$watch('active', function(active) {
	        if (active) {
	          carouselCtrl.select(scope);
	        }
	      });
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.dateparser', [])
	
	.service('uibDateParser', ['$log', '$locale', 'orderByFilter', function($log, $locale, orderByFilter) {
	  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
	  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	  var localeId;
	  var formatCodeToRegex;
	
	  this.init = function() {
	    localeId = $locale.id;
	
	    this.parsers = {};
	
	    formatCodeToRegex = {
	      'yyyy': {
	        regex: '\\d{4}',
	        apply: function(value) { this.year = +value; }
	      },
	      'yy': {
	        regex: '\\d{2}',
	        apply: function(value) { this.year = +value + 2000; }
	      },
	      'y': {
	        regex: '\\d{1,4}',
	        apply: function(value) { this.year = +value; }
	      },
	      'MMMM': {
	        regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
	        apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); }
	      },
	      'MMM': {
	        regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
	        apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); }
	      },
	      'MM': {
	        regex: '0[1-9]|1[0-2]',
	        apply: function(value) { this.month = value - 1; }
	      },
	      'M': {
	        regex: '[1-9]|1[0-2]',
	        apply: function(value) { this.month = value - 1; }
	      },
	      'dd': {
	        regex: '[0-2][0-9]{1}|3[0-1]{1}',
	        apply: function(value) { this.date = +value; }
	      },
	      'd': {
	        regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
	        apply: function(value) { this.date = +value; }
	      },
	      'EEEE': {
	        regex: $locale.DATETIME_FORMATS.DAY.join('|')
	      },
	      'EEE': {
	        regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|')
	      },
	      'HH': {
	        regex: '(?:0|1)[0-9]|2[0-3]',
	        apply: function(value) { this.hours = +value; }
	      },
	      'hh': {
	        regex: '0[0-9]|1[0-2]',
	        apply: function(value) { this.hours = +value; }
	      },
	      'H': {
	        regex: '1?[0-9]|2[0-3]',
	        apply: function(value) { this.hours = +value; }
	      },
	      'h': {
	        regex: '[0-9]|1[0-2]',
	        apply: function(value) { this.hours = +value; }
	      },
	      'mm': {
	        regex: '[0-5][0-9]',
	        apply: function(value) { this.minutes = +value; }
	      },
	      'm': {
	        regex: '[0-9]|[1-5][0-9]',
	        apply: function(value) { this.minutes = +value; }
	      },
	      'sss': {
	        regex: '[0-9][0-9][0-9]',
	        apply: function(value) { this.milliseconds = +value; }
	      },
	      'ss': {
	        regex: '[0-5][0-9]',
	        apply: function(value) { this.seconds = +value; }
	      },
	      's': {
	        regex: '[0-9]|[1-5][0-9]',
	        apply: function(value) { this.seconds = +value; }
	      },
	      'a': {
	        regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
	        apply: function(value) {
	          if (this.hours === 12) {
	            this.hours = 0;
	          }
	
	          if (value === 'PM') {
	            this.hours += 12;
	          }
	        }
	      }
	    };
	  };
	
	  this.init();
	
	  function createParser(format) {
	    var map = [], regex = format.split('');
	
	    angular.forEach(formatCodeToRegex, function(data, code) {
	      var index = format.indexOf(code);
	
	      if (index > -1) {
	        format = format.split('');
	
	        regex[index] = '(' + data.regex + ')';
	        format[index] = '$'; // Custom symbol to define consumed part of format
	        for (var i = index + 1, n = index + code.length; i < n; i++) {
	          regex[i] = '';
	          format[i] = '$';
	        }
	        format = format.join('');
	
	        map.push({ index: index, apply: data.apply });
	      }
	    });
	
	    return {
	      regex: new RegExp('^' + regex.join('') + '$'),
	      map: orderByFilter(map, 'index')
	    };
	  }
	
	  this.parse = function(input, format, baseDate) {
	    if (!angular.isString(input) || !format) {
	      return input;
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');
	
	    if ($locale.id !== localeId) {
	      this.init();
	    }
	
	    if (!this.parsers[format]) {
	      this.parsers[format] = createParser(format);
	    }
	
	    var parser = this.parsers[format],
	        regex = parser.regex,
	        map = parser.map,
	        results = input.match(regex);
	
	    if (results && results.length) {
	      var fields, dt;
	      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
	        fields = {
	          year: baseDate.getFullYear(),
	          month: baseDate.getMonth(),
	          date: baseDate.getDate(),
	          hours: baseDate.getHours(),
	          minutes: baseDate.getMinutes(),
	          seconds: baseDate.getSeconds(),
	          milliseconds: baseDate.getMilliseconds()
	        };
	      } else {
	        if (baseDate) {
	          $log.warn('dateparser:', 'baseDate is not a valid date');
	        }
	        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
	      }
	
	      for (var i = 1, n = results.length; i < n; i++) {
	        var mapper = map[i-1];
	        if (mapper.apply) {
	          mapper.apply.call(fields, results[i]);
	        }
	      }
	
	      if (isValid(fields.year, fields.month, fields.date)) {
	        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
	          dt = new Date(baseDate);
	          dt.setFullYear(fields.year, fields.month, fields.date,
	            fields.hours, fields.minutes, fields.seconds,
	            fields.milliseconds || 0);
	        } else {
	          dt = new Date(fields.year, fields.month, fields.date,
	            fields.hours, fields.minutes, fields.seconds,
	            fields.milliseconds || 0);
	        }
	      }
	
	      return dt;
	    }
	  };
	
	  // Check if date is valid for specific month (and year for February).
	  // Month: 0 = Jan, 1 = Feb, etc
	  function isValid(year, month, date) {
	    if (date < 1) {
	      return false;
	    }
	
	    if (month === 1 && date > 28) {
	      return date === 29 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
	    }
	
	    if (month === 3 || month === 5 || month === 8 || month === 10) {
	      return date < 31;
	    }
	
	    return true;
	  }
	}]);
	
	/* Deprecated dateparser below */
	
	angular.module('ui.bootstrap.dateparser')
	
	.value('$dateParserSuppressWarning', false)
	
	.service('dateParser', ['$log', '$dateParserSuppressWarning', 'uibDateParser', function($log, $dateParserSuppressWarning, uibDateParser) {
	  if (!$dateParserSuppressWarning) {
	    $log.warn('dateParser is now deprecated. Use uibDateParser instead.');
	  }
	
	  angular.extend(this, uibDateParser);
	}]);
	
	angular.module('ui.bootstrap.position', [])
	
	/**
	 * A set of utility methods that can be use to retrieve position of DOM elements.
	 * It is meant to be used where we need to absolute-position DOM elements in
	 * relation to other, existing elements (this is the case for tooltips, popovers,
	 * typeahead suggestions etc.).
	 */
	  .factory('$uibPosition', ['$document', '$window', function($document, $window) {
	    function getStyle(el, cssprop) {
	      if (el.currentStyle) { //IE
	        return el.currentStyle[cssprop];
	      } else if ($window.getComputedStyle) {
	        return $window.getComputedStyle(el)[cssprop];
	      }
	      // finally try and get inline style
	      return el.style[cssprop];
	    }
	
	    /**
	     * Checks if a given element is statically positioned
	     * @param element - raw DOM element
	     */
	    function isStaticPositioned(element) {
	      return (getStyle(element, 'position') || 'static' ) === 'static';
	    }
	
	    /**
	     * returns the closest, non-statically positioned parentOffset of a given element
	     * @param element
	     */
	    var parentOffsetEl = function(element) {
	      var docDomEl = $document[0];
	      var offsetParent = element.offsetParent || docDomEl;
	      while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent) ) {
	        offsetParent = offsetParent.offsetParent;
	      }
	      return offsetParent || docDomEl;
	    };
	
	    return {
	      /**
	       * Provides read-only equivalent of jQuery's position function:
	       * http://api.jquery.com/position/
	       */
	      position: function(element) {
	        var elBCR = this.offset(element);
	        var offsetParentBCR = { top: 0, left: 0 };
	        var offsetParentEl = parentOffsetEl(element[0]);
	        if (offsetParentEl != $document[0]) {
	          offsetParentBCR = this.offset(angular.element(offsetParentEl));
	          offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
	          offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
	        }
	
	        var boundingClientRect = element[0].getBoundingClientRect();
	        return {
	          width: boundingClientRect.width || element.prop('offsetWidth'),
	          height: boundingClientRect.height || element.prop('offsetHeight'),
	          top: elBCR.top - offsetParentBCR.top,
	          left: elBCR.left - offsetParentBCR.left
	        };
	      },
	
	      /**
	       * Provides read-only equivalent of jQuery's offset function:
	       * http://api.jquery.com/offset/
	       */
	      offset: function(element) {
	        var boundingClientRect = element[0].getBoundingClientRect();
	        return {
	          width: boundingClientRect.width || element.prop('offsetWidth'),
	          height: boundingClientRect.height || element.prop('offsetHeight'),
	          top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
	          left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
	        };
	      },
	
	      /**
	       * Provides coordinates for the targetEl in relation to hostEl
	       */
	      positionElements: function(hostEl, targetEl, positionStr, appendToBody) {
	        var positionStrParts = positionStr.split('-');
	        var pos0 = positionStrParts[0], pos1 = positionStrParts[1] || 'center';
	
	        var hostElPos,
	          targetElWidth,
	          targetElHeight,
	          targetElPos;
	
	        hostElPos = appendToBody ? this.offset(hostEl) : this.position(hostEl);
	
	        targetElWidth = targetEl.prop('offsetWidth');
	        targetElHeight = targetEl.prop('offsetHeight');
	
	        var shiftWidth = {
	          center: function() {
	            return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
	          },
	          left: function() {
	            return hostElPos.left;
	          },
	          right: function() {
	            return hostElPos.left + hostElPos.width;
	          }
	        };
	
	        var shiftHeight = {
	          center: function() {
	            return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
	          },
	          top: function() {
	            return hostElPos.top;
	          },
	          bottom: function() {
	            return hostElPos.top + hostElPos.height;
	          }
	        };
	
	        switch (pos0) {
	          case 'right':
	            targetElPos = {
	              top: shiftHeight[pos1](),
	              left: shiftWidth[pos0]()
	            };
	            break;
	          case 'left':
	            targetElPos = {
	              top: shiftHeight[pos1](),
	              left: hostElPos.left - targetElWidth
	            };
	            break;
	          case 'bottom':
	            targetElPos = {
	              top: shiftHeight[pos0](),
	              left: shiftWidth[pos1]()
	            };
	            break;
	          default:
	            targetElPos = {
	              top: hostElPos.top - targetElHeight,
	              left: shiftWidth[pos1]()
	            };
	            break;
	        }
	
	        return targetElPos;
	      }
	    };
	  }]);
	
	/* Deprecated position below */
	
	angular.module('ui.bootstrap.position')
	
	.value('$positionSuppressWarning', false)
	
	.service('$position', ['$log', '$positionSuppressWarning', '$uibPosition', function($log, $positionSuppressWarning, $uibPosition) {
	  if (!$positionSuppressWarning) {
	    $log.warn('$position is now deprecated. Use $uibPosition instead.');
	  }
	
	  angular.extend(this, $uibPosition);
	}]);
	
	angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.position'])
	
	.value('$datepickerSuppressError', false)
	
	.constant('uibDatepickerConfig', {
	  formatDay: 'dd',
	  formatMonth: 'MMMM',
	  formatYear: 'yyyy',
	  formatDayHeader: 'EEE',
	  formatDayTitle: 'MMMM yyyy',
	  formatMonthTitle: 'yyyy',
	  datepickerMode: 'day',
	  minMode: 'day',
	  maxMode: 'year',
	  showWeeks: true,
	  startingDay: 0,
	  yearRange: 20,
	  minDate: null,
	  maxDate: null,
	  shortcutPropagation: false
	})
	
	.controller('UibDatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerSuppressError', function($scope, $attrs, $parse, $interpolate, $log, dateFilter, datepickerConfig, $datepickerSuppressError) {
	  var self = this,
	      ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl;
	
	  // Modes chain
	  this.modes = ['day', 'month', 'year'];
	
	  // Configuration attributes
	  angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle',
	                   'showWeeks', 'startingDay', 'yearRange', 'shortcutPropagation'], function(key, index) {
	    self[key] = angular.isDefined($attrs[key]) ? (index < 6 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key])) : datepickerConfig[key];
	  });
	
	  // Watchable date attributes
	  angular.forEach(['minDate', 'maxDate'], function(key) {
	    if ($attrs[key]) {
	      $scope.$parent.$watch($parse($attrs[key]), function(value) {
	        self[key] = value ? new Date(value) : null;
	        self.refreshView();
	      });
	    } else {
	      self[key] = datepickerConfig[key] ? new Date(datepickerConfig[key]) : null;
	    }
	  });
	
	  angular.forEach(['minMode', 'maxMode'], function(key) {
	    if ($attrs[key]) {
	      $scope.$parent.$watch($parse($attrs[key]), function(value) {
	        self[key] = angular.isDefined(value) ? value : $attrs[key];
	        $scope[key] = self[key];
	        if ((key == 'minMode' && self.modes.indexOf($scope.datepickerMode) < self.modes.indexOf(self[key])) || (key == 'maxMode' && self.modes.indexOf($scope.datepickerMode) > self.modes.indexOf(self[key]))) {
	          $scope.datepickerMode = self[key];
	        }
	      });
	    } else {
	      self[key] = datepickerConfig[key] || null;
	      $scope[key] = self[key];
	    }
	  });
	
	  $scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;
	  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
	
	  if (angular.isDefined($attrs.initDate)) {
	    this.activeDate = $scope.$parent.$eval($attrs.initDate) || new Date();
	    $scope.$parent.$watch($attrs.initDate, function(initDate) {
	      if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
	        self.activeDate = initDate;
	        self.refreshView();
	      }
	    });
	  } else {
	    this.activeDate = new Date();
	  }
	
	  $scope.isActive = function(dateObject) {
	    if (self.compare(dateObject.date, self.activeDate) === 0) {
	      $scope.activeDateId = dateObject.uid;
	      return true;
	    }
	    return false;
	  };
	
	  this.init = function(ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	
	    ngModelCtrl.$render = function() {
	      self.render();
	    };
	  };
	
	  this.render = function() {
	    if (ngModelCtrl.$viewValue) {
	      var date = new Date(ngModelCtrl.$viewValue),
	          isValid = !isNaN(date);
	
	      if (isValid) {
	        this.activeDate = date;
	      } else if (!$datepickerSuppressError) {
	        $log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	      }
	    }
	    this.refreshView();
	  };
	
	  this.refreshView = function() {
	    if (this.element) {
	      this._refreshView();
	
	      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	      ngModelCtrl.$setValidity('dateDisabled', !date || (this.element && !this.isDisabled(date)));
	    }
	  };
	
	  this.createDateObject = function(date, format) {
	    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	    return {
	      date: date,
	      label: dateFilter(date, format),
	      selected: model && this.compare(date, model) === 0,
	      disabled: this.isDisabled(date),
	      current: this.compare(date, new Date()) === 0,
	      customClass: this.customClass(date)
	    };
	  };
	
	  this.isDisabled = function(date) {
	    return ((this.minDate && this.compare(date, this.minDate) < 0) || (this.maxDate && this.compare(date, this.maxDate) > 0) || ($attrs.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode})));
	  };
	
	  this.customClass = function(date) {
	    return $scope.customClass({date: date, mode: $scope.datepickerMode});
	  };
	
	  // Split array into smaller arrays
	  this.split = function(arr, size) {
	    var arrays = [];
	    while (arr.length > 0) {
	      arrays.push(arr.splice(0, size));
	    }
	    return arrays;
	  };
	
	  $scope.select = function(date) {
	    if ($scope.datepickerMode === self.minMode) {
	      var dt = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : new Date(0, 0, 0, 0, 0, 0, 0);
	      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	      ngModelCtrl.$setViewValue(dt);
	      ngModelCtrl.$render();
	    } else {
	      self.activeDate = date;
	      $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) - 1];
	    }
	  };
	
	  $scope.move = function(direction) {
	    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
	        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
	    self.activeDate.setFullYear(year, month, 1);
	    self.refreshView();
	  };
	
	  $scope.toggleMode = function(direction) {
	    direction = direction || 1;
	
	    if (($scope.datepickerMode === self.maxMode && direction === 1) || ($scope.datepickerMode === self.minMode && direction === -1)) {
	      return;
	    }
	
	    $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) + direction];
	  };
	
	  // Key event mapper
	  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };
	
	  var focusElement = function() {
	    self.element[0].focus();
	  };
	
	  // Listen for focus requests from popup directive
	  $scope.$on('uib:datepicker.focus', focusElement);
	
	  $scope.keydown = function(evt) {
	    var key = $scope.keys[evt.which];
	
	    if (!key || evt.shiftKey || evt.altKey) {
	      return;
	    }
	
	    evt.preventDefault();
	    if (!self.shortcutPropagation) {
	      evt.stopPropagation();
	    }
	
	    if (key === 'enter' || key === 'space') {
	      if (self.isDisabled(self.activeDate)) {
	        return; // do nothing
	      }
	      $scope.select(self.activeDate);
	    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
	      $scope.toggleMode(key === 'up' ? 1 : -1);
	    } else {
	      self.handleKeyDown(key, evt);
	      self.refreshView();
	    }
	  };
	}])
	
	.controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
	  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	  this.step = { months: 1 };
	  this.element = $element;
	  function getDaysInMonth(year, month) {
	    return ((month === 1) && (year % 4 === 0) && ((year % 100 !== 0) || (year % 400 === 0))) ? 29 : DAYS_IN_MONTH[month];
	  }
	
	  this.init = function(ctrl) {
	    angular.extend(ctrl, this);
	    scope.showWeeks = ctrl.showWeeks;
	    ctrl.refreshView();
	  };
	
	  this.getDates = function(startDate, n) {
	    var dates = new Array(n), current = new Date(startDate), i = 0, date;
	    while (i < n) {
	      date = new Date(current);
	      dates[i++] = date;
	      current.setDate(current.getDate() + 1);
	    }
	    return dates;
	  };
	
	  this._refreshView = function() {
	    var year = this.activeDate.getFullYear(),
	      month = this.activeDate.getMonth(),
	      firstDayOfMonth = new Date(this.activeDate);
	
	    firstDayOfMonth.setFullYear(year, month, 1);
	
	    var difference = this.startingDay - firstDayOfMonth.getDay(),
	      numDisplayedFromPreviousMonth = (difference > 0) ? 7 - difference : - difference,
	      firstDate = new Date(firstDayOfMonth);
	
	    if (numDisplayedFromPreviousMonth > 0) {
	      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
	    }
	
	    // 42 is the number of days on a six-month calendar
	    var days = this.getDates(firstDate, 42);
	    for (var i = 0; i < 42; i ++) {
	      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
	        secondary: days[i].getMonth() !== month,
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.labels = new Array(7);
	    for (var j = 0; j < 7; j++) {
	      scope.labels[j] = {
	        abbr: dateFilter(days[j].date, this.formatDayHeader),
	        full: dateFilter(days[j].date, 'EEEE')
	      };
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
	    scope.rows = this.split(days, 7);
	
	    if (scope.showWeeks) {
	      scope.weekNumbers = [];
	      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
	          numWeeks = scope.rows.length;
	      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
	        scope.weekNumbers.push(
	          getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
	      }
	    }
	  };
	
	  this.compare = function(date1, date2) {
	    return (new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate()));
	  };
	
	  function getISO8601WeekNumber(date) {
	    var checkDate = new Date(date);
	    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
	    var time = checkDate.getTime();
	    checkDate.setMonth(0); // Compare with Jan 1
	    checkDate.setDate(1);
	    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	  }
	
	  this.handleKeyDown = function(key, evt) {
	    var date = this.activeDate.getDate();
	
	    if (key === 'left') {
	      date = date - 1;   // up
	    } else if (key === 'up') {
	      date = date - 7;   // down
	    } else if (key === 'right') {
	      date = date + 1;   // down
	    } else if (key === 'down') {
	      date = date + 7;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var month = this.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
	      this.activeDate.setMonth(month, 1);
	      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
	    } else if (key === 'home') {
	      date = 1;
	    } else if (key === 'end') {
	      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
	    }
	    this.activeDate.setDate(date);
	  };
	}])
	
	.controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
	  this.step = { years: 1 };
	  this.element = $element;
	
	  this.init = function(ctrl) {
	    angular.extend(ctrl, this);
	    ctrl.refreshView();
	  };
	
	  this._refreshView = function() {
	    var months = new Array(12),
	        year = this.activeDate.getFullYear(),
	        date;
	
	    for (var i = 0; i < 12; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(year, i, 1);
	      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
	    scope.rows = this.split(months, 3);
	  };
	
	  this.compare = function(date1, date2) {
	    return new Date(date1.getFullYear(), date1.getMonth()) - new Date(date2.getFullYear(), date2.getMonth());
	  };
	
	  this.handleKeyDown = function(key, evt) {
	    var date = this.activeDate.getMonth();
	
	    if (key === 'left') {
	      date = date - 1;   // up
	    } else if (key === 'up') {
	      date = date - 3;   // down
	    } else if (key === 'right') {
	      date = date + 1;   // down
	    } else if (key === 'down') {
	      date = date + 3;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var year = this.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
	      this.activeDate.setFullYear(year);
	    } else if (key === 'home') {
	      date = 0;
	    } else if (key === 'end') {
	      date = 11;
	    }
	    this.activeDate.setMonth(date);
	  };
	}])
	
	.controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
	  var range;
	  this.element = $element;
	
	  function getStartingYear(year) {
	    return parseInt((year - 1) / range, 10) * range + 1;
	  }
	
	  this.yearpickerInit = function() {
	    range = this.yearRange;
	    this.step = { years: range };
	  };
	
	  this._refreshView = function() {
	    var years = new Array(range), date;
	
	    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(start + i, 0, 1);
	      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = [years[0].label, years[range - 1].label].join(' - ');
	    scope.rows = this.split(years, 5);
	  };
	
	  this.compare = function(date1, date2) {
	    return date1.getFullYear() - date2.getFullYear();
	  };
	
	  this.handleKeyDown = function(key, evt) {
	    var date = this.activeDate.getFullYear();
	
	    if (key === 'left') {
	      date = date - 1;   // up
	    } else if (key === 'up') {
	      date = date - 5;   // down
	    } else if (key === 'right') {
	      date = date + 1;   // down
	    } else if (key === 'down') {
	      date = date + 5;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      date += (key === 'pageup' ? - 1 : 1) * this.step.years;
	    } else if (key === 'home') {
	      date = getStartingYear(this.activeDate.getFullYear());
	    } else if (key === 'end') {
	      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
	    }
	    this.activeDate.setFullYear(date);
	  };
	}])
	
	.directive('uibDatepicker', function() {
	  return {
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/datepicker/datepicker.html';
	    },
	    scope: {
	      datepickerMode: '=?',
	      dateDisabled: '&',
	      customClass: '&',
	      shortcutPropagation: '&?'
	    },
	    require: ['uibDatepicker', '^ngModel'],
	    controller: 'UibDatepickerController',
	    controllerAs: 'datepicker',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      datepickerCtrl.init(ngModelCtrl);
	    }
	  };
	})
	
	.directive('uibDaypicker', function() {
	  return {
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/datepicker/day.html';
	    },
	    require: ['^?uibDatepicker', 'uibDaypicker', '^?datepicker'],
	    controller: 'UibDaypickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0] || ctrls[2],
	        daypickerCtrl = ctrls[1];
	
	      daypickerCtrl.init(datepickerCtrl);
	    }
	  };
	})
	
	.directive('uibMonthpicker', function() {
	  return {
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/datepicker/month.html';
	    },
	    require: ['^?uibDatepicker', 'uibMonthpicker', '^?datepicker'],
	    controller: 'UibMonthpickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0] || ctrls[2],
	        monthpickerCtrl = ctrls[1];
	
	      monthpickerCtrl.init(datepickerCtrl);
	    }
	  };
	})
	
	.directive('uibYearpicker', function() {
	  return {
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/datepicker/year.html';
	    },
	    require: ['^?uibDatepicker', 'uibYearpicker', '^?datepicker'],
	    controller: 'UibYearpickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var ctrl = ctrls[0] || ctrls[2];
	      angular.extend(ctrl, ctrls[1]);
	      ctrl.yearpickerInit();
	
	      ctrl.refreshView();
	    }
	  };
	})
	
	.constant('uibDatepickerPopupConfig', {
	  datepickerPopup: 'yyyy-MM-dd',
	  datepickerPopupTemplateUrl: 'template/datepicker/popup.html',
	  datepickerTemplateUrl: 'template/datepicker/datepicker.html',
	  html5Types: {
	    date: 'yyyy-MM-dd',
	    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
	    'month': 'yyyy-MM'
	  },
	  currentText: 'Today',
	  clearText: 'Clear',
	  closeText: 'Done',
	  closeOnDateSelection: true,
	  appendToBody: false,
	  showButtonBar: true,
	  onOpenFocus: true
	})
	
	.controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout',
	function(scope, element, attrs, $compile, $parse, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout) {
	  var self = this;
	  var cache = {},
	    isHtml5DateInput = false;
	  var dateFormat, closeOnDateSelection, appendToBody, onOpenFocus,
	    datepickerPopupTemplateUrl, datepickerTemplateUrl, popupEl, datepickerEl,
	    ngModel, $popup;
	
	  scope.watchData = {};
	
	  this.init = function(_ngModel_) {
	    ngModel = _ngModel_;
	    closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ? scope.$parent.$eval(attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection;
	    appendToBody = angular.isDefined(attrs.datepickerAppendToBody) ? scope.$parent.$eval(attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody;
	    onOpenFocus = angular.isDefined(attrs.onOpenFocus) ? scope.$parent.$eval(attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
	    datepickerPopupTemplateUrl = angular.isDefined(attrs.datepickerPopupTemplateUrl) ? attrs.datepickerPopupTemplateUrl : datepickerPopupConfig.datepickerPopupTemplateUrl;
	    datepickerTemplateUrl = angular.isDefined(attrs.datepickerTemplateUrl) ? attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
	
	    scope.showButtonBar = angular.isDefined(attrs.showButtonBar) ? scope.$parent.$eval(attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;
	
	    if (datepickerPopupConfig.html5Types[attrs.type]) {
	      dateFormat = datepickerPopupConfig.html5Types[attrs.type];
	      isHtml5DateInput = true;
	    } else {
	      dateFormat = attrs.datepickerPopup || attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
	      attrs.$observe('uibDatepickerPopup', function(value, oldValue) {
	          var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
	          // Invalidate the $modelValue to ensure that formatters re-run
	          // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
	          if (newDateFormat !== dateFormat) {
	            dateFormat = newDateFormat;
	            ngModel.$modelValue = null;
	
	            if (!dateFormat) {
	              throw new Error('uibDatepickerPopup must have a date format specified.');
	            }
	          }
	      });
	    }
	
	    if (!dateFormat) {
	      throw new Error('uibDatepickerPopup must have a date format specified.');
	    }
	
	    if (isHtml5DateInput && attrs.datepickerPopup) {
	      throw new Error('HTML5 date input types do not support custom formats.');
	    }
	
	    // popup element used to display calendar
	    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');
	    popupEl.attr({
	      'ng-model': 'date',
	      'ng-change': 'dateSelection(date)',
	      'template-url': datepickerPopupTemplateUrl
	    });
	
	    // datepicker element
	    datepickerEl = angular.element(popupEl.children()[0]);
	    datepickerEl.attr('template-url', datepickerTemplateUrl);
	
	    if (isHtml5DateInput) {
	      if (attrs.type === 'month') {
	        datepickerEl.attr('datepicker-mode', '"month"');
	        datepickerEl.attr('min-mode', 'month');
	      }
	    }
	
	    if (attrs.datepickerOptions) {
	      var options = scope.$parent.$eval(attrs.datepickerOptions);
	      if (options && options.initDate) {
	        scope.initDate = options.initDate;
	        datepickerEl.attr('init-date', 'initDate');
	        delete options.initDate;
	      }
	      angular.forEach(options, function(value, option) {
	        datepickerEl.attr(cameltoDash(option), value);
	      });
	    }
	
	    angular.forEach(['minMode', 'maxMode', 'minDate', 'maxDate', 'datepickerMode', 'initDate', 'shortcutPropagation'], function(key) {
	      if (attrs[key]) {
	        var getAttribute = $parse(attrs[key]);
	        scope.$parent.$watch(getAttribute, function(value) {
	          scope.watchData[key] = value;
	          if (key === 'minDate' || key === 'maxDate') {
	            cache[key] = new Date(value);
	          }
	        });
	        datepickerEl.attr(cameltoDash(key), 'watchData.' + key);
	
	        // Propagate changes from datepicker to outside
	        if (key === 'datepickerMode') {
	          var setAttribute = getAttribute.assign;
	          scope.$watch('watchData.' + key, function(value, oldvalue) {
	            if (angular.isFunction(setAttribute) && value !== oldvalue) {
	              setAttribute(scope.$parent, value);
	            }
	          });
	        }
	      }
	    });
	    if (attrs.dateDisabled) {
	      datepickerEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
	    }
	
	    if (attrs.showWeeks) {
	      datepickerEl.attr('show-weeks', attrs.showWeeks);
	    }
	
	    if (attrs.customClass) {
	      datepickerEl.attr('custom-class', 'customClass({ date: date, mode: mode })');
	    }
	
	    if (!isHtml5DateInput) {
	      // Internal API to maintain the correct ng-invalid-[key] class
	      ngModel.$$parserName = 'date';
	      ngModel.$validators.date = validator;
	      ngModel.$parsers.unshift(parseDate);
	      ngModel.$formatters.push(function(value) {
	        scope.date = value;
	        return ngModel.$isEmpty(value) ? value : dateFilter(value, dateFormat);
	      });
	    } else {
	      ngModel.$formatters.push(function(value) {
	        scope.date = value;
	        return value;
	      });
	    }
	
	    // Detect changes in the view from the text box
	    ngModel.$viewChangeListeners.push(function() {
	      scope.date = dateParser.parse(ngModel.$viewValue, dateFormat, scope.date);
	    });
	
	    element.bind('keydown', inputKeydownBind);
	
	    $popup = $compile(popupEl)(scope);
	    // Prevent jQuery cache memory leak (template is now redundant after linking)
	    popupEl.remove();
	
	    if (appendToBody) {
	      $document.find('body').append($popup);
	    } else {
	      element.after($popup);
	    }
	
	    scope.$on('$destroy', function() {
	      if (scope.isOpen === true) {
	        if (!$rootScope.$$phase) {
	          scope.$apply(function() {
	            scope.isOpen = false;
	          });
	        }
	      }
	
	      $popup.remove();
	      element.unbind('keydown', inputKeydownBind);
	      $document.unbind('click', documentClickBind);
	    });
	  };
	
	  scope.getText = function(key) {
	    return scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
	  };
	
	  scope.isDisabled = function(date) {
	    if (date === 'today') {
	      date = new Date();
	    }
	
	    return ((scope.watchData.minDate && scope.compare(date, cache.minDate) < 0) ||
	      (scope.watchData.maxDate && scope.compare(date, cache.maxDate) > 0));
	  };
	
	  scope.compare = function(date1, date2) {
	    return (new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate()));
	  };
	
	  // Inner change
	  scope.dateSelection = function(dt) {
	    if (angular.isDefined(dt)) {
	      scope.date = dt;
	    }
	    var date = scope.date ? dateFilter(scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
	    element.val(date);
	    ngModel.$setViewValue(date);
	
	    if (closeOnDateSelection) {
	      scope.isOpen = false;
	      element[0].focus();
	    }
	  };
	
	  scope.keydown = function(evt) {
	    if (evt.which === 27) {
	      scope.isOpen = false;
	      element[0].focus();
	    }
	  };
	
	  scope.select = function(date) {
	    if (date === 'today') {
	      var today = new Date();
	      if (angular.isDate(scope.date)) {
	        date = new Date(scope.date);
	        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
	      } else {
	        date = new Date(today.setHours(0, 0, 0, 0));
	      }
	    }
	    scope.dateSelection(date);
	  };
	
	  scope.close = function() {
	    scope.isOpen = false;
	    element[0].focus();
	  };
	
	  scope.$watch('isOpen', function(value) {
	    if (value) {
	      scope.position = appendToBody ? $position.offset(element) : $position.position(element);
	      scope.position.top = scope.position.top + element.prop('offsetHeight');
	
	      $timeout(function() {
	        if (onOpenFocus) {
	          scope.$broadcast('uib:datepicker.focus');
	        }
	        $document.bind('click', documentClickBind);
	      }, 0, false);
	    } else {
	      $document.unbind('click', documentClickBind);
	    }
	  });
	
	  function cameltoDash(string) {
	    return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
	  }
	
	  function parseDate(viewValue) {
	    if (angular.isNumber(viewValue)) {
	      // presumably timestamp to date object
	      viewValue = new Date(viewValue);
	    }
	
	    if (!viewValue) {
	      return null;
	    } else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
	      return viewValue;
	    } else if (angular.isString(viewValue)) {
	      var date = dateParser.parse(viewValue, dateFormat, scope.date);
	      if (isNaN(date)) {
	        return undefined;
	      } else {
	        return date;
	      }
	    } else {
	      return undefined;
	    }
	  }
	
	  function validator(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	
	    if (!attrs.ngRequired && !value) {
	      return true;
	    }
	
	    if (angular.isNumber(value)) {
	      value = new Date(value);
	    }
	    if (!value) {
	      return true;
	    } else if (angular.isDate(value) && !isNaN(value)) {
	      return true;
	    } else if (angular.isString(value)) {
	      var date = dateParser.parse(value, dateFormat);
	      return !isNaN(date);
	    } else {
	      return false;
	    }
	  }
	
	  function documentClickBind(event) {
	    var popup = $popup[0];
	    var dpContainsTarget = element[0].contains(event.target);
	    // The popup node may not be an element node
	    // In some browsers (IE) only element nodes have the 'contains' function
	    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
	    if (scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
	      scope.$apply(function() {
	        scope.isOpen = false;
	      });
	    }
	  }
	
	  function inputKeydownBind(evt) {
	    if (evt.which === 27 && scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      scope.$apply(function() {
	        scope.isOpen = false;
	      });
	      element[0].focus();
	    } else if (evt.which === 40 && !scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      scope.$apply(function() {
	        scope.isOpen = true;
	      });
	    }
	  }
	}])
	
	.directive('uibDatepickerPopup', function() {
	  return {
	    require: ['ngModel', 'uibDatepickerPopup'],
	    controller: 'UibDatepickerPopupController',
	    scope: {
	      isOpen: '=?',
	      currentText: '@',
	      clearText: '@',
	      closeText: '@',
	      dateDisabled: '&',
	      customClass: '&'
	    },
	    link: function(scope, element, attrs, ctrls) {
	      var ngModel = ctrls[0],
	        ctrl = ctrls[1];
	
	      ctrl.init(ngModel);
	    }
	  };
	})
	
	.directive('uibDatepickerPopupWrap', function() {
	  return {
	    replace: true,
	    transclude: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/datepicker/popup.html';
	    }
	  };
	});
	
	/* Deprecated datepicker below */
	
	angular.module('ui.bootstrap.datepicker')
	
	.value('$datepickerSuppressWarning', false)
	
	.controller('DatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerSuppressError', '$datepickerSuppressWarning', function($scope, $attrs, $parse, $interpolate, $log, dateFilter, datepickerConfig, $datepickerSuppressError, $datepickerSuppressWarning) {
	  if (!$datepickerSuppressWarning) {
	    $log.warn('DatepickerController is now deprecated. Use UibDatepickerController instead.');
	  }
	
	  var self = this,
	    ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl;
	
	  this.modes = ['day', 'month', 'year'];
	
	  angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle',
	    'showWeeks', 'startingDay', 'yearRange', 'shortcutPropagation'], function(key, index) {
	    self[key] = angular.isDefined($attrs[key]) ? (index < 6 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key])) : datepickerConfig[key];
	  });
	
	  angular.forEach(['minDate', 'maxDate'], function(key) {
	    if ($attrs[key]) {
	      $scope.$parent.$watch($parse($attrs[key]), function(value) {
	        self[key] = value ? new Date(value) : null;
	        self.refreshView();
	      });
	    } else {
	      self[key] = datepickerConfig[key] ? new Date(datepickerConfig[key]) : null;
	    }
	  });
	
	  angular.forEach(['minMode', 'maxMode'], function(key) {
	    if ($attrs[key]) {
	      $scope.$parent.$watch($parse($attrs[key]), function(value) {
	        self[key] = angular.isDefined(value) ? value : $attrs[key];
	        $scope[key] = self[key];
	        if ((key == 'minMode' && self.modes.indexOf($scope.datepickerMode) < self.modes.indexOf(self[key])) || (key == 'maxMode' && self.modes.indexOf($scope.datepickerMode) > self.modes.indexOf(self[key]))) {
	          $scope.datepickerMode = self[key];
	        }
	      });
	    } else {
	      self[key] = datepickerConfig[key] || null;
	      $scope[key] = self[key];
	    }
	  });
	
	  $scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;
	  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
	
	  if (angular.isDefined($attrs.initDate)) {
	    this.activeDate = $scope.$parent.$eval($attrs.initDate) || new Date();
	    $scope.$parent.$watch($attrs.initDate, function(initDate) {
	      if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
	        self.activeDate = initDate;
	        self.refreshView();
	      }
	    });
	  } else {
	    this.activeDate = new Date();
	  }
	
	  $scope.isActive = function(dateObject) {
	    if (self.compare(dateObject.date, self.activeDate) === 0) {
	      $scope.activeDateId = dateObject.uid;
	      return true;
	    }
	    return false;
	  };
	
	  this.init = function(ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	
	    ngModelCtrl.$render = function() {
	      self.render();
	    };
	  };
	
	  this.render = function() {
	    if (ngModelCtrl.$viewValue) {
	      var date = new Date(ngModelCtrl.$viewValue),
	        isValid = !isNaN(date);
	
	      if (isValid) {
	        this.activeDate = date;
	      } else if (!$datepickerSuppressError) {
	        $log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	      }
	    }
	    this.refreshView();
	  };
	
	  this.refreshView = function() {
	    if (this.element) {
	      this._refreshView();
	
	      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	      ngModelCtrl.$setValidity('dateDisabled', !date || (this.element && !this.isDisabled(date)));
	    }
	  };
	
	  this.createDateObject = function(date, format) {
	    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	    return {
	      date: date,
	      label: dateFilter(date, format),
	      selected: model && this.compare(date, model) === 0,
	      disabled: this.isDisabled(date),
	      current: this.compare(date, new Date()) === 0,
	      customClass: this.customClass(date)
	    };
	  };
	
	  this.isDisabled = function(date) {
	    return ((this.minDate && this.compare(date, this.minDate) < 0) || (this.maxDate && this.compare(date, this.maxDate) > 0) || ($attrs.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode})));
	  };
	
	  this.customClass = function(date) {
	    return $scope.customClass({date: date, mode: $scope.datepickerMode});
	  };
	
	  // Split array into smaller arrays
	  this.split = function(arr, size) {
	    var arrays = [];
	    while (arr.length > 0) {
	      arrays.push(arr.splice(0, size));
	    }
	    return arrays;
	  };
	
	  this.fixTimeZone = function(date) {
	    var hours = date.getHours();
	    date.setHours(hours === 23 ? hours + 2 : 0);
	  };
	
	  $scope.select = function(date) {
	    if ($scope.datepickerMode === self.minMode) {
	      var dt = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : new Date(0, 0, 0, 0, 0, 0, 0);
	      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	      ngModelCtrl.$setViewValue(dt);
	      ngModelCtrl.$render();
	    } else {
	      self.activeDate = date;
	      $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) - 1];
	    }
	  };
	
	  $scope.move = function(direction) {
	    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
	      month = self.activeDate.getMonth() + direction * (self.step.months || 0);
	    self.activeDate.setFullYear(year, month, 1);
	    self.refreshView();
	  };
	
	  $scope.toggleMode = function(direction) {
	    direction = direction || 1;
	
	    if (($scope.datepickerMode === self.maxMode && direction === 1) || ($scope.datepickerMode === self.minMode && direction === -1)) {
	      return;
	    }
	
	    $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) + direction];
	  };
	
	  // Key event mapper
	  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };
	
	  var focusElement = function() {
	    self.element[0].focus();
	  };
	
	  $scope.$on('uib:datepicker.focus', focusElement);
	
	  $scope.keydown = function(evt) {
	    var key = $scope.keys[evt.which];
	
	    if (!key || evt.shiftKey || evt.altKey) {
	      return;
	    }
	
	    evt.preventDefault();
	    if (!self.shortcutPropagation) {
	      evt.stopPropagation();
	    }
	
	    if (key === 'enter' || key === 'space') {
	      if (self.isDisabled(self.activeDate)) {
	        return; // do nothing
	      }
	      $scope.select(self.activeDate);
	    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
	      $scope.toggleMode(key === 'up' ? 1 : -1);
	    } else {
	      self.handleKeyDown(key, evt);
	      self.refreshView();
	    }
	  };
	}])
	
	.directive('datepicker', ['$log', '$datepickerSuppressWarning', function($log, $datepickerSuppressWarning) {
	  return {
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/datepicker/datepicker.html';
	    },
	    scope: {
	      datepickerMode: '=?',
	      dateDisabled: '&',
	      customClass: '&',
	      shortcutPropagation: '&?'
	    },
	    require: ['datepicker', '^ngModel'],
	    controller: 'DatepickerController',
	    controllerAs: 'datepicker',
	    link: function(scope, element, attrs, ctrls) {
	      if (!$datepickerSuppressWarning) {
	        $log.warn('datepicker is now deprecated. Use uib-datepicker instead.');
	      }
	
	      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      datepickerCtrl.init(ngModelCtrl);
	    }
	  };
	}])
	
	.directive('daypicker', ['$log', '$datepickerSuppressWarning', function($log, $datepickerSuppressWarning) {
	  return {
	    replace: true,
	    templateUrl: 'template/datepicker/day.html',
	    require: ['^datepicker', 'daypicker'],
	    controller: 'UibDaypickerController',
	    link: function(scope, element, attrs, ctrls) {
	      if (!$datepickerSuppressWarning) {
	        $log.warn('daypicker is now deprecated. Use uib-daypicker instead.');
	      }
	
	      var datepickerCtrl = ctrls[0],
	        daypickerCtrl = ctrls[1];
	
	      daypickerCtrl.init(datepickerCtrl);
	    }
	  };
	}])
	
	.directive('monthpicker', ['$log', '$datepickerSuppressWarning', function($log, $datepickerSuppressWarning) {
	  return {
	    replace: true,
	    templateUrl: 'template/datepicker/month.html',
	    require: ['^datepicker', 'monthpicker'],
	    controller: 'UibMonthpickerController',
	    link: function(scope, element, attrs, ctrls) {
	      if (!$datepickerSuppressWarning) {
	        $log.warn('monthpicker is now deprecated. Use uib-monthpicker instead.');
	      }
	
	      var datepickerCtrl = ctrls[0],
	        monthpickerCtrl = ctrls[1];
	
	      monthpickerCtrl.init(datepickerCtrl);
	    }
	  };
	}])
	
	.directive('yearpicker', ['$log', '$datepickerSuppressWarning', function($log, $datepickerSuppressWarning) {
	  return {
	    replace: true,
	    templateUrl: 'template/datepicker/year.html',
	    require: ['^datepicker', 'yearpicker'],
	    controller: 'UibYearpickerController',
	    link: function(scope, element, attrs, ctrls) {
	      if (!$datepickerSuppressWarning) {
	        $log.warn('yearpicker is now deprecated. Use uib-yearpicker instead.');
	      }
	
	      var ctrl = ctrls[0];
	      angular.extend(ctrl, ctrls[1]);
	      ctrl.yearpickerInit();
	
	      ctrl.refreshView();
	    }
	  };
	}])
	
	.directive('datepickerPopup', ['$log', '$datepickerSuppressWarning', function($log, $datepickerSuppressWarning) {
	  return {
	    require: ['ngModel', 'datepickerPopup'],
	    controller: 'UibDatepickerPopupController',
	    scope: {
	      isOpen: '=?',
	      currentText: '@',
	      clearText: '@',
	      closeText: '@',
	      dateDisabled: '&',
	      customClass: '&'
	    },
	    link: function(scope, element, attrs, ctrls) {
	      if (!$datepickerSuppressWarning) {
	        $log.warn('datepicker-popup is now deprecated. Use uib-datepicker-popup instead.');
	      }
	
	      var ngModel = ctrls[0],
	        ctrl = ctrls[1];
	
	      ctrl.init(ngModel);
	    }
	  };
	}])
	
	.directive('datepickerPopupWrap', ['$log', '$datepickerSuppressWarning', function($log, $datepickerSuppressWarning) {
	  return {
	    replace: true,
	    transclude: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/datepicker/popup.html';
	    },
	    link: function() {
	      if (!$datepickerSuppressWarning) {
	        $log.warn('datepicker-popup-wrap is now deprecated. Use uib-datepicker-popup-wrap instead.');
	      }
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.position'])
	
	.constant('uibDropdownConfig', {
	  openClass: 'open'
	})
	
	.service('uibDropdownService', ['$document', '$rootScope', function($document, $rootScope) {
	  var openScope = null;
	
	  this.open = function(dropdownScope) {
	    if (!openScope) {
	      $document.bind('click', closeDropdown);
	      $document.bind('keydown', keybindFilter);
	    }
	
	    if (openScope && openScope !== dropdownScope) {
	      openScope.isOpen = false;
	    }
	
	    openScope = dropdownScope;
	  };
	
	  this.close = function(dropdownScope) {
	    if (openScope === dropdownScope) {
	      openScope = null;
	      $document.unbind('click', closeDropdown);
	      $document.unbind('keydown', keybindFilter);
	    }
	  };
	
	  var closeDropdown = function(evt) {
	    // This method may still be called during the same mouse event that
	    // unbound this event handler. So check openScope before proceeding.
	    if (!openScope) { return; }
	
	    if (evt && openScope.getAutoClose() === 'disabled')  { return ; }
	
	    var toggleElement = openScope.getToggleElement();
	    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    if (evt && openScope.getAutoClose() === 'outsideClick' &&
	      dropdownElement && dropdownElement[0].contains(evt.target)) {
	      return;
	    }
	
	    openScope.isOpen = false;
	
	    if (!$rootScope.$$phase) {
	      openScope.$apply();
	    }
	  };
	
	  var keybindFilter = function(evt) {
	    if (evt.which === 27) {
	      openScope.focusToggleElement();
	      closeDropdown();
	    } else if (openScope.isKeynavEnabled() && /(38|40)/.test(evt.which) && openScope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      openScope.focusDropdownEntry(evt.which);
	    }
	  };
	}])
	
	.controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
	  var self = this,
	    scope = $scope.$new(), // create a child scope so we are not polluting original one
	    templateScope,
	    openClass = dropdownConfig.openClass,
	    getIsOpen,
	    setIsOpen = angular.noop,
	    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
	    appendToBody = false,
	    keynavEnabled =false,
	    selectedOption = null;
	
	
	  $element.addClass('dropdown');
	
	  this.init = function() {
	    if ($attrs.isOpen) {
	      getIsOpen = $parse($attrs.isOpen);
	      setIsOpen = getIsOpen.assign;
	
	      $scope.$watch(getIsOpen, function(value) {
	        scope.isOpen = !!value;
	      });
	    }
	
	    appendToBody = angular.isDefined($attrs.dropdownAppendToBody);
	    keynavEnabled = angular.isDefined($attrs.uibKeyboardNav);
	
	    if (appendToBody && self.dropdownMenu) {
	      $document.find('body').append(self.dropdownMenu);
	      $element.on('$destroy', function handleDestroyEvent() {
	        self.dropdownMenu.remove();
	      });
	    }
	  };
	
	  this.toggle = function(open) {
	    return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
	  };
	
	  // Allow other directives to watch status
	  this.isOpen = function() {
	    return scope.isOpen;
	  };
	
	  scope.getToggleElement = function() {
	    return self.toggleElement;
	  };
	
	  scope.getAutoClose = function() {
	    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
	  };
	
	  scope.getElement = function() {
	    return $element;
	  };
	
	  scope.isKeynavEnabled = function() {
	    return keynavEnabled;
	  };
	
	  scope.focusDropdownEntry = function(keyCode) {
	    var elems = self.dropdownMenu ? //If append to body is used.
	      (angular.element(self.dropdownMenu).find('a')) :
	      (angular.element($element).find('ul').eq(0).find('a'));
	
	    switch (keyCode) {
	      case (40): {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = 0;
	        } else {
	          self.selectedOption = (self.selectedOption === elems.length - 1 ?
	            self.selectedOption :
	            self.selectedOption + 1);
	        }
	        break;
	      }
	      case (38): {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = elems.length - 1;
	        } else {
	          self.selectedOption = self.selectedOption === 0 ?
	            0 : self.selectedOption - 1;
	        }
	        break;
	      }
	    }
	    elems[self.selectedOption].focus();
	  };
	
	  scope.getDropdownElement = function() {
	    return self.dropdownMenu;
	  };
	
	  scope.focusToggleElement = function() {
	    if (self.toggleElement) {
	      self.toggleElement[0].focus();
	    }
	  };
	
	  scope.$watch('isOpen', function(isOpen, wasOpen) {
	    if (appendToBody && self.dropdownMenu) {
	      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true);
	      var css = {
	        top: pos.top + 'px',
	        display: isOpen ? 'block' : 'none'
	      };
	
	      var rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
	      if (!rightalign) {
	        css.left = pos.left + 'px';
	        css.right = 'auto';
	      } else {
	        css.left = 'auto';
	        css.right = (window.innerWidth - (pos.left + $element.prop('offsetWidth'))) + 'px';
	      }
	
	      self.dropdownMenu.css(css);
	    }
	
	    $animate[isOpen ? 'addClass' : 'removeClass']($element, openClass).then(function() {
	      if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
	        toggleInvoker($scope, { open: !!isOpen });
	      }
	    });
	
	    if (isOpen) {
	      if (self.dropdownMenuTemplateUrl) {
	        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
	          templateScope = scope.$new();
	          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
	            var newEl = dropdownElement;
	            self.dropdownMenu.replaceWith(newEl);
	            self.dropdownMenu = newEl;
	          });
	        });
	      }
	
	      scope.focusToggleElement();
	      uibDropdownService.open(scope);
	    } else {
	      if (self.dropdownMenuTemplateUrl) {
	        if (templateScope) {
	          templateScope.$destroy();
	        }
	        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
	        self.dropdownMenu.replaceWith(newEl);
	        self.dropdownMenu = newEl;
	      }
	
	      uibDropdownService.close(scope);
	      self.selectedOption = null;
	    }
	
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen($scope, isOpen);
	    }
	  });
	
	  $scope.$on('$locationChangeSuccess', function() {
	    if (scope.getAutoClose() !== 'disabled') {
	      scope.isOpen = false;
	    }
	  });
	
	  var offDestroy = $scope.$on('$destroy', function() {
	    scope.$destroy();
	  });
	  scope.$on('$destroy', offDestroy);
	}])
	
	.directive('uibDropdown', function() {
	  return {
	    controller: 'UibDropdownController',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      dropdownCtrl.init();
	    }
	  };
	})
	
	.directive('uibDropdownMenu', function() {
	  return {
	    restrict: 'AC',
	    require: '?^uibDropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
	        return;
	      }
	
	      element.addClass('dropdown-menu');
	
	      var tplUrl = attrs.templateUrl;
	      if (tplUrl) {
	        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
	      }
	
	      if (!dropdownCtrl.dropdownMenu) {
	        dropdownCtrl.dropdownMenu = element;
	      }
	    }
	  };
	})
	
	.directive('uibKeyboardNav', function() {
	  return {
	    restrict: 'A',
	    require: '?^uibDropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      element.bind('keydown', function(e) {
	        if ([38, 40].indexOf(e.which) !== -1) {
	          e.preventDefault();
	          e.stopPropagation();
	
	          var elems = dropdownCtrl.dropdownMenu.find('a');
	
	          switch (e.which) {
	            case (40): { // Down
	              if (!angular.isNumber(dropdownCtrl.selectedOption)) {
	                dropdownCtrl.selectedOption = 0;
	              } else {
	                dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === elems.length -1 ?
	                  dropdownCtrl.selectedOption : dropdownCtrl.selectedOption + 1;
	              }
	              break;
	            }
	            case (38): { // Up
	              if (!angular.isNumber(dropdownCtrl.selectedOption)) {
	                dropdownCtrl.selectedOption = elems.length - 1;
	              } else {
	                dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === 0 ?
	                  0 : dropdownCtrl.selectedOption - 1;
	              }
	              break;
	            }
	          }
	          elems[dropdownCtrl.selectedOption].focus();
	        }
	      });
	    }
	  };
	})
	
	.directive('uibDropdownToggle', function() {
	  return {
	    require: '?^uibDropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl) {
	        return;
	      }
	
	      element.addClass('dropdown-toggle');
	
	      dropdownCtrl.toggleElement = element;
	
	      var toggleDropdown = function(event) {
	        event.preventDefault();
	
	        if (!element.hasClass('disabled') && !attrs.disabled) {
	          scope.$apply(function() {
	            dropdownCtrl.toggle();
	          });
	        }
	      };
	
	      element.bind('click', toggleDropdown);
	
	      // WAI-ARIA
	      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
	      scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
	        element.attr('aria-expanded', !!isOpen);
	      });
	
	      scope.$on('$destroy', function() {
	        element.unbind('click', toggleDropdown);
	      });
	    }
	  };
	});
	
	/* Deprecated dropdown below */
	
	angular.module('ui.bootstrap.dropdown')
	
	.value('$dropdownSuppressWarning', false)
	
	.service('dropdownService', ['$log', '$dropdownSuppressWarning', 'uibDropdownService', function($log, $dropdownSuppressWarning, uibDropdownService) {
	  if (!$dropdownSuppressWarning) {
	    $log.warn('dropdownService is now deprecated. Use uibDropdownService instead.');
	  }
	
	  angular.extend(this, uibDropdownService);
	}])
	
	.controller('DropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', '$log', '$dropdownSuppressWarning', function($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest, $log, $dropdownSuppressWarning) {
	  if (!$dropdownSuppressWarning) {
	    $log.warn('DropdownController is now deprecated. Use UibDropdownController instead.');
	  }
	
	  var self = this,
	    scope = $scope.$new(), // create a child scope so we are not polluting original one
	    templateScope,
	    openClass = dropdownConfig.openClass,
	    getIsOpen,
	    setIsOpen = angular.noop,
	    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
	    appendToBody = false,
	    keynavEnabled =false,
	    selectedOption = null;
	
	
	  $element.addClass('dropdown');
	
	  this.init = function() {
	    if ($attrs.isOpen) {
	      getIsOpen = $parse($attrs.isOpen);
	      setIsOpen = getIsOpen.assign;
	
	      $scope.$watch(getIsOpen, function(value) {
	        scope.isOpen = !!value;
	      });
	    }
	
	    appendToBody = angular.isDefined($attrs.dropdownAppendToBody);
	    keynavEnabled = angular.isDefined($attrs.uibKeyboardNav);
	
	    if (appendToBody && self.dropdownMenu) {
	      $document.find('body').append(self.dropdownMenu);
	      $element.on('$destroy', function handleDestroyEvent() {
	        self.dropdownMenu.remove();
	      });
	    }
	  };
	
	  this.toggle = function(open) {
	    return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
	  };
	
	  // Allow other directives to watch status
	  this.isOpen = function() {
	    return scope.isOpen;
	  };
	
	  scope.getToggleElement = function() {
	    return self.toggleElement;
	  };
	
	  scope.getAutoClose = function() {
	    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
	  };
	
	  scope.getElement = function() {
	    return $element;
	  };
	
	  scope.isKeynavEnabled = function() {
	    return keynavEnabled;
	  };
	
	  scope.focusDropdownEntry = function(keyCode) {
	    var elems = self.dropdownMenu ? //If append to body is used.
	      (angular.element(self.dropdownMenu).find('a')) :
	      (angular.element($element).find('ul').eq(0).find('a'));
	
	    switch (keyCode) {
	      case (40): {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = 0;
	        } else {
	          self.selectedOption = (self.selectedOption === elems.length -1 ?
	            self.selectedOption :
	          self.selectedOption + 1);
	        }
	        break;
	      }
	      case (38): {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = elems.length - 1;
	        } else {
	          self.selectedOption = self.selectedOption === 0 ?
	            0 : self.selectedOption - 1;
	        }
	        break;
	      }
	    }
	    elems[self.selectedOption].focus();
	  };
	
	  scope.getDropdownElement = function() {
	    return self.dropdownMenu;
	  };
	
	  scope.focusToggleElement = function() {
	    if (self.toggleElement) {
	      self.toggleElement[0].focus();
	    }
	  };
	
	  scope.$watch('isOpen', function(isOpen, wasOpen) {
	    if (appendToBody && self.dropdownMenu) {
	      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true);
	      var css = {
	        top: pos.top + 'px',
	        display: isOpen ? 'block' : 'none'
	      };
	
	      var rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
	      if (!rightalign) {
	        css.left = pos.left + 'px';
	        css.right = 'auto';
	      } else {
	        css.left = 'auto';
	        css.right = (window.innerWidth - (pos.left + $element.prop('offsetWidth'))) + 'px';
	      }
	
	      self.dropdownMenu.css(css);
	    }
	
	    $animate[isOpen ? 'addClass' : 'removeClass']($element, openClass).then(function() {
	      if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
	        toggleInvoker($scope, { open: !!isOpen });
	      }
	    });
	
	    if (isOpen) {
	      if (self.dropdownMenuTemplateUrl) {
	        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
	          templateScope = scope.$new();
	          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
	            var newEl = dropdownElement;
	            self.dropdownMenu.replaceWith(newEl);
	            self.dropdownMenu = newEl;
	          });
	        });
	      }
	
	      scope.focusToggleElement();
	      uibDropdownService.open(scope);
	    } else {
	      if (self.dropdownMenuTemplateUrl) {
	        if (templateScope) {
	          templateScope.$destroy();
	        }
	        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
	        self.dropdownMenu.replaceWith(newEl);
	        self.dropdownMenu = newEl;
	      }
	
	      uibDropdownService.close(scope);
	      self.selectedOption = null;
	    }
	
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen($scope, isOpen);
	    }
	  });
	
	  $scope.$on('$locationChangeSuccess', function() {
	    if (scope.getAutoClose() !== 'disabled') {
	      scope.isOpen = false;
	    }
	  });
	
	  var offDestroy = $scope.$on('$destroy', function() {
	    scope.$destroy();
	  });
	  scope.$on('$destroy', offDestroy);
	}])
	
	.directive('dropdown', ['$log', '$dropdownSuppressWarning', function($log, $dropdownSuppressWarning) {
	  return {
	    controller: 'DropdownController',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!$dropdownSuppressWarning) {
	        $log.warn('dropdown is now deprecated. Use uib-dropdown instead.');
	      }
	
	      dropdownCtrl.init();
	    }
	  };
	}])
	
	.directive('dropdownMenu', ['$log', '$dropdownSuppressWarning', function($log, $dropdownSuppressWarning) {
	  return {
	    restrict: 'AC',
	    require: '?^dropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
	        return;
	      }
	
	      if (!$dropdownSuppressWarning) {
	        $log.warn('dropdown-menu is now deprecated. Use uib-dropdown-menu instead.');
	      }
	
	      element.addClass('dropdown-menu');
	
	      var tplUrl = attrs.templateUrl;
	      if (tplUrl) {
	        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
	      }
	
	      if (!dropdownCtrl.dropdownMenu) {
	        dropdownCtrl.dropdownMenu = element;
	      }
	    }
	  };
	}])
	
	.directive('keyboardNav', ['$log', '$dropdownSuppressWarning', function($log, $dropdownSuppressWarning) {
	  return {
	    restrict: 'A',
	    require: '?^dropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!$dropdownSuppressWarning) {
	        $log.warn('keyboard-nav is now deprecated. Use uib-keyboard-nav instead.');
	      }
	
	      element.bind('keydown', function(e) {
	        if ([38, 40].indexOf(e.which) !== -1) {
	          e.preventDefault();
	          e.stopPropagation();
	
	          var elems = dropdownCtrl.dropdownMenu.find('a');
	
	          switch (e.which) {
	            case (40): { // Down
	              if (!angular.isNumber(dropdownCtrl.selectedOption)) {
	                dropdownCtrl.selectedOption = 0;
	              } else {
	                dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === elems.length -1 ?
	                  dropdownCtrl.selectedOption : dropdownCtrl.selectedOption + 1;
	              }
	              break;
	            }
	            case (38): { // Up
	              if (!angular.isNumber(dropdownCtrl.selectedOption)) {
	                dropdownCtrl.selectedOption = elems.length - 1;
	              } else {
	                dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === 0 ?
	                  0 : dropdownCtrl.selectedOption - 1;
	              }
	              break;
	            }
	          }
	          elems[dropdownCtrl.selectedOption].focus();
	        }
	      });
	    }
	  };
	}])
	
	.directive('dropdownToggle', ['$log', '$dropdownSuppressWarning', function($log, $dropdownSuppressWarning) {
	  return {
	    require: '?^dropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!$dropdownSuppressWarning) {
	        $log.warn('dropdown-toggle is now deprecated. Use uib-dropdown-toggle instead.');
	      }
	
	      if (!dropdownCtrl) {
	        return;
	      }
	
	      element.addClass('dropdown-toggle');
	
	      dropdownCtrl.toggleElement = element;
	
	      var toggleDropdown = function(event) {
	        event.preventDefault();
	
	        if (!element.hasClass('disabled') && !attrs.disabled) {
	          scope.$apply(function() {
	            dropdownCtrl.toggle();
	          });
	        }
	      };
	
	      element.bind('click', toggleDropdown);
	
	      // WAI-ARIA
	      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
	      scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
	        element.attr('aria-expanded', !!isOpen);
	      });
	
	      scope.$on('$destroy', function() {
	        element.unbind('click', toggleDropdown);
	      });
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.stackedMap', [])
	/**
	 * A helper, internal data structure that acts as a map but also allows getting / removing
	 * elements in the LIFO order
	 */
	  .factory('$$stackedMap', function() {
	    return {
	      createNew: function() {
	        var stack = [];
	
	        return {
	          add: function(key, value) {
	            stack.push({
	              key: key,
	              value: value
	            });
	          },
	          get: function(key) {
	            for (var i = 0; i < stack.length; i++) {
	              if (key == stack[i].key) {
	                return stack[i];
	              }
	            }
	          },
	          keys: function() {
	            var keys = [];
	            for (var i = 0; i < stack.length; i++) {
	              keys.push(stack[i].key);
	            }
	            return keys;
	          },
	          top: function() {
	            return stack[stack.length - 1];
	          },
	          remove: function(key) {
	            var idx = -1;
	            for (var i = 0; i < stack.length; i++) {
	              if (key == stack[i].key) {
	                idx = i;
	                break;
	              }
	            }
	            return stack.splice(idx, 1)[0];
	          },
	          removeTop: function() {
	            return stack.splice(stack.length - 1, 1)[0];
	          },
	          length: function() {
	            return stack.length;
	          }
	        };
	      }
	    };
	  });
	angular.module('ui.bootstrap.modal', ['ui.bootstrap.stackedMap'])
	/**
	 * A helper, internal data structure that stores all references attached to key
	 */
	  .factory('$$multiMap', function() {
	    return {
	      createNew: function() {
	        var map = {};
	
	        return {
	          entries: function() {
	            return Object.keys(map).map(function(key) {
	              return {
	                key: key,
	                value: map[key]
	              };
	            });
	          },
	          get: function(key) {
	            return map[key];
	          },
	          hasKey: function(key) {
	            return !!map[key];
	          },
	          keys: function() {
	            return Object.keys(map);
	          },
	          put: function(key, value) {
	            if (!map[key]) {
	              map[key] = [];
	            }
	
	            map[key].push(value);
	          },
	          remove: function(key, value) {
	            var values = map[key];
	
	            if (!values) {
	              return;
	            }
	
	            var idx = values.indexOf(value);
	
	            if (idx !== -1) {
	              values.splice(idx, 1);
	            }
	
	            if (!values.length) {
	              delete map[key];
	            }
	          }
	        };
	      }
	    };
	  })
	
	/**
	 * A helper directive for the $modal service. It creates a backdrop element.
	 */
	  .directive('uibModalBackdrop', [
	           '$animate', '$injector', '$uibModalStack',
	  function($animate ,  $injector,   $modalStack) {
	    var $animateCss = null;
	
	    if ($injector.has('$animateCss')) {
	      $animateCss = $injector.get('$animateCss');
	    }
	
	    return {
	      replace: true,
	      templateUrl: 'template/modal/backdrop.html',
	      compile: function(tElement, tAttrs) {
	        tElement.addClass(tAttrs.backdropClass);
	        return linkFn;
	      }
	    };
	
	    function linkFn(scope, element, attrs) {
	      // Temporary fix for prefixing
	      element.addClass('modal-backdrop');
	
	      if (attrs.modalInClass) {
	        if ($animateCss) {
	          $animateCss(element, {
	            addClass: attrs.modalInClass
	          }).start();
	        } else {
	          $animate.addClass(element, attrs.modalInClass);
	        }
	
	        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	          var done = setIsAsync();
	          if ($animateCss) {
	            $animateCss(element, {
	              removeClass: attrs.modalInClass
	            }).start().then(done);
	          } else {
	            $animate.removeClass(element, attrs.modalInClass).then(done);
	          }
	        });
	      }
	    }
	  }])
	
	  .directive('uibModalWindow', [
	           '$uibModalStack', '$q', '$animate', '$injector',
	  function($modalStack ,  $q ,  $animate,   $injector) {
	    var $animateCss = null;
	
	    if ($injector.has('$animateCss')) {
	      $animateCss = $injector.get('$animateCss');
	    }
	
	    return {
	      scope: {
	        index: '@'
	      },
	      replace: true,
	      transclude: true,
	      templateUrl: function(tElement, tAttrs) {
	        return tAttrs.templateUrl || 'template/modal/window.html';
	      },
	      link: function(scope, element, attrs) {
	        element.addClass(attrs.windowClass || '');
	        element.addClass(attrs.windowTopClass || '');
	        scope.size = attrs.size;
	
	        scope.close = function(evt) {
	          var modal = $modalStack.getTop();
	          if (modal && modal.value.backdrop && modal.value.backdrop !== 'static' && (evt.target === evt.currentTarget)) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            $modalStack.dismiss(modal.key, 'backdrop click');
	          }
	        };
	
	        // moved from template to fix issue #2280
	        element.on('click', scope.close);
	
	        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
	        // We can detect that by using this property in the template associated with this directive and then use
	        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
	        scope.$isRendered = true;
	
	        // Deferred object that will be resolved when this modal is render.
	        var modalRenderDeferObj = $q.defer();
	        // Observe function will be called on next digest cycle after compilation, ensuring that the DOM is ready.
	        // In order to use this way of finding whether DOM is ready, we need to observe a scope property used in modal's template.
	        attrs.$observe('modalRender', function(value) {
	          if (value == 'true') {
	            modalRenderDeferObj.resolve();
	          }
	        });
	
	        modalRenderDeferObj.promise.then(function() {
	          var animationPromise = null;
	
	          if (attrs.modalInClass) {
	            if ($animateCss) {
	              animationPromise = $animateCss(element, {
	                addClass: attrs.modalInClass
	              }).start();
	            } else {
	              animationPromise = $animate.addClass(element, attrs.modalInClass);
	            }
	
	            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	              var done = setIsAsync();
	              if ($animateCss) {
	                $animateCss(element, {
	                  removeClass: attrs.modalInClass
	                }).start().then(done);
	              } else {
	                $animate.removeClass(element, attrs.modalInClass).then(done);
	              }
	            });
	          }
	
	
	          $q.when(animationPromise).then(function() {
	            var inputWithAutofocus = element[0].querySelector('[autofocus]');
	            /**
	             * Auto-focusing of a freshly-opened modal element causes any child elements
	             * with the autofocus attribute to lose focus. This is an issue on touch
	             * based devices which will show and then hide the onscreen keyboard.
	             * Attempts to refocus the autofocus element via JavaScript will not reopen
	             * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	             * the modal element if the modal does not contain an autofocus element.
	             */
	            if (inputWithAutofocus) {
	              inputWithAutofocus.focus();
	            } else {
	              element[0].focus();
	            }
	          });
	
	          // Notify {@link $modalStack} that modal is rendered.
	          var modal = $modalStack.getTop();
	          if (modal) {
	            $modalStack.modalRendered(modal.key);
	          }
	        });
	      }
	    };
	  }])
	
	  .directive('uibModalAnimationClass', function() {
	    return {
	      compile: function(tElement, tAttrs) {
	        if (tAttrs.modalAnimation) {
	          tElement.addClass(tAttrs.uibModalAnimationClass);
	        }
	      }
	    };
	  })
	
	  .directive('uibModalTransclude', function() {
	    return {
	      link: function($scope, $element, $attrs, controller, $transclude) {
	        $transclude($scope.$parent, function(clone) {
	          $element.empty();
	          $element.append(clone);
	        });
	      }
	    };
	  })
	
	  .factory('$uibModalStack', [
	             '$animate', '$timeout', '$document', '$compile', '$rootScope',
	             '$q',
	             '$injector',
	             '$$multiMap',
	             '$$stackedMap',
	    function($animate ,  $timeout ,  $document ,  $compile ,  $rootScope ,
	              $q,
	              $injector,
	              $$multiMap,
	              $$stackedMap) {
	      var $animateCss = null;
	
	      if ($injector.has('$animateCss')) {
	        $animateCss = $injector.get('$animateCss');
	      }
	
	      var OPENED_MODAL_CLASS = 'modal-open';
	
	      var backdropDomEl, backdropScope;
	      var openedWindows = $$stackedMap.createNew();
	      var openedClasses = $$multiMap.createNew();
	      var $modalStack = {
	        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
	      };
	
	      //Modal focus behavior
	      var focusableElementList;
	      var focusIndex = 0;
	      var tababbleSelector = 'a[href], area[href], input:not([disabled]), ' +
	        'button:not([disabled]),select:not([disabled]), textarea:not([disabled]), ' +
	        'iframe, object, embed, *[tabindex], *[contenteditable=true]';
	
	      function backdropIndex() {
	        var topBackdropIndex = -1;
	        var opened = openedWindows.keys();
	        for (var i = 0; i < opened.length; i++) {
	          if (openedWindows.get(opened[i]).value.backdrop) {
	            topBackdropIndex = i;
	          }
	        }
	        return topBackdropIndex;
	      }
	
	      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
	        if (backdropScope) {
	          backdropScope.index = newBackdropIndex;
	        }
	      });
	
	      function removeModalWindow(modalInstance, elementToReceiveFocus) {
	        var body = $document.find('body').eq(0);
	        var modalWindow = openedWindows.get(modalInstance).value;
	
	        //clean up the stack
	        openedWindows.remove(modalInstance);
	
	        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
	          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
	          openedClasses.remove(modalBodyClass, modalInstance);
	          body.toggleClass(modalBodyClass, openedClasses.hasKey(modalBodyClass));
	          toggleTopWindowClass(true);
	        });
	        checkRemoveBackdrop();
	
	        //move focus to specified element if available, or else to body
	        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
	          elementToReceiveFocus.focus();
	        } else {
	          body.focus();
	        }
	      }
	
	      // Add or remove "windowTopClass" from the top window in the stack
	      function toggleTopWindowClass(toggleSwitch) {
	        var modalWindow;
	
	        if (openedWindows.length() > 0) {
	          modalWindow = openedWindows.top().value;
	          modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
	        }
	      }
	
	      function checkRemoveBackdrop() {
	        //remove backdrop if no longer needed
	        if (backdropDomEl && backdropIndex() == -1) {
	          var backdropScopeRef = backdropScope;
	          removeAfterAnimate(backdropDomEl, backdropScope, function() {
	            backdropScopeRef = null;
	          });
	          backdropDomEl = undefined;
	          backdropScope = undefined;
	        }
	      }
	
	      function removeAfterAnimate(domEl, scope, done) {
	        var asyncDeferred;
	        var asyncPromise = null;
	        var setIsAsync = function() {
	          if (!asyncDeferred) {
	            asyncDeferred = $q.defer();
	            asyncPromise = asyncDeferred.promise;
	          }
	
	          return function asyncDone() {
	            asyncDeferred.resolve();
	          };
	        };
	        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);
	
	        // Note that it's intentional that asyncPromise might be null.
	        // That's when setIsAsync has not been called during the
	        // NOW_CLOSING_EVENT broadcast.
	        return $q.when(asyncPromise).then(afterAnimating);
	
	        function afterAnimating() {
	          if (afterAnimating.done) {
	            return;
	          }
	          afterAnimating.done = true;
	
	          if ($animateCss) {
	            $animateCss(domEl, {
	              event: 'leave'
	            }).start().then(function() {
	              domEl.remove();
	            });
	          } else {
	            $animate.leave(domEl);
	          }
	          scope.$destroy();
	          if (done) {
	            done();
	          }
	        }
	      }
	
	      $document.bind('keydown', function(evt) {
	        if (evt.isDefaultPrevented()) {
	          return evt;
	        }
	
	        var modal = openedWindows.top();
	        if (modal && modal.value.keyboard) {
	          switch (evt.which) {
	            case 27: {
	              evt.preventDefault();
	              $rootScope.$apply(function() {
	                $modalStack.dismiss(modal.key, 'escape key press');
	              });
	              break;
	            }
	            case 9: {
	              $modalStack.loadFocusElementList(modal);
	              var focusChanged = false;
	              if (evt.shiftKey) {
	                if ($modalStack.isFocusInFirstItem(evt)) {
	                  focusChanged = $modalStack.focusLastFocusableElement();
	                }
	              } else {
	                if ($modalStack.isFocusInLastItem(evt)) {
	                  focusChanged = $modalStack.focusFirstFocusableElement();
	                }
	              }
	
	              if (focusChanged) {
	                evt.preventDefault();
	                evt.stopPropagation();
	              }
	              break;
	            }
	          }
	        }
	      });
	
	      $modalStack.open = function(modalInstance, modal) {
	        var modalOpener = $document[0].activeElement,
	          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;
	
	        toggleTopWindowClass(false);
	
	        openedWindows.add(modalInstance, {
	          deferred: modal.deferred,
	          renderDeferred: modal.renderDeferred,
	          modalScope: modal.scope,
	          backdrop: modal.backdrop,
	          keyboard: modal.keyboard,
	          openedClass: modal.openedClass,
	          windowTopClass: modal.windowTopClass
	        });
	
	        openedClasses.put(modalBodyClass, modalInstance);
	
	        var body = $document.find('body').eq(0),
	            currBackdropIndex = backdropIndex();
	
	        if (currBackdropIndex >= 0 && !backdropDomEl) {
	          backdropScope = $rootScope.$new(true);
	          backdropScope.index = currBackdropIndex;
	          var angularBackgroundDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
	          angularBackgroundDomEl.attr('backdrop-class', modal.backdropClass);
	          if (modal.animation) {
	            angularBackgroundDomEl.attr('modal-animation', 'true');
	          }
	          backdropDomEl = $compile(angularBackgroundDomEl)(backdropScope);
	          body.append(backdropDomEl);
	        }
	
	        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
	        angularDomEl.attr({
	          'template-url': modal.windowTemplateUrl,
	          'window-class': modal.windowClass,
	          'window-top-class': modal.windowTopClass,
	          'size': modal.size,
	          'index': openedWindows.length() - 1,
	          'animate': 'animate'
	        }).html(modal.content);
	        if (modal.animation) {
	          angularDomEl.attr('modal-animation', 'true');
	        }
	
	        var modalDomEl = $compile(angularDomEl)(modal.scope);
	        openedWindows.top().value.modalDomEl = modalDomEl;
	        openedWindows.top().value.modalOpener = modalOpener;
	        body.append(modalDomEl);
	        body.addClass(modalBodyClass);
	
	        $modalStack.clearFocusListCache();
	      };
	
	      function broadcastClosing(modalWindow, resultOrReason, closing) {
	        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
	      }
	
	      $modalStack.close = function(modalInstance, result) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.resolve(result);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	        return !modalWindow;
	      };
	
	      $modalStack.dismiss = function(modalInstance, reason) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.reject(reason);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	        return !modalWindow;
	      };
	
	      $modalStack.dismissAll = function(reason) {
	        var topModal = this.getTop();
	        while (topModal && this.dismiss(topModal.key, reason)) {
	          topModal = this.getTop();
	        }
	      };
	
	      $modalStack.getTop = function() {
	        return openedWindows.top();
	      };
	
	      $modalStack.modalRendered = function(modalInstance) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow) {
	          modalWindow.value.renderDeferred.resolve();
	        }
	      };
	
	      $modalStack.focusFirstFocusableElement = function() {
	        if (focusableElementList.length > 0) {
	          focusableElementList[0].focus();
	          return true;
	        }
	        return false;
	      };
	      $modalStack.focusLastFocusableElement = function() {
	        if (focusableElementList.length > 0) {
	          focusableElementList[focusableElementList.length - 1].focus();
	          return true;
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInFirstItem = function(evt) {
	        if (focusableElementList.length > 0) {
	          return (evt.target || evt.srcElement) == focusableElementList[0];
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInLastItem = function(evt) {
	        if (focusableElementList.length > 0) {
	          return (evt.target || evt.srcElement) == focusableElementList[focusableElementList.length - 1];
	        }
	        return false;
	      };
	
	      $modalStack.clearFocusListCache = function() {
	        focusableElementList = [];
	        focusIndex = 0;
	      };
	
	      $modalStack.loadFocusElementList = function(modalWindow) {
	        if (focusableElementList === undefined || !focusableElementList.length) {
	          if (modalWindow) {
	            var modalDomE1 = modalWindow.value.modalDomEl;
	            if (modalDomE1 && modalDomE1.length) {
	              focusableElementList = modalDomE1[0].querySelectorAll(tababbleSelector);
	            }
	          }
	        }
	      };
	
	      return $modalStack;
	    }])
	
	  .provider('$uibModal', function() {
	    var $modalProvider = {
	      options: {
	        animation: true,
	        backdrop: true, //can also be false or 'static'
	        keyboard: true
	      },
	      $get: ['$injector', '$rootScope', '$q', '$templateRequest', '$controller', '$uibModalStack', '$modalSuppressWarning', '$log',
	        function ($injector, $rootScope, $q, $templateRequest, $controller, $modalStack, $modalSuppressWarning, $log) {
	          var $modal = {};
	
	          function getTemplatePromise(options) {
	            return options.template ? $q.when(options.template) :
	              $templateRequest(angular.isFunction(options.templateUrl) ? (options.templateUrl)() : options.templateUrl);
	          }
	
	          function getResolvePromises(resolves) {
	            var promisesArr = [];
	            angular.forEach(resolves, function(value) {
	              if (angular.isFunction(value) || angular.isArray(value)) {
	                promisesArr.push($q.when($injector.invoke(value)));
	              } else if (angular.isString(value)) {
	                promisesArr.push($q.when($injector.get(value)));
	              } else {
	                promisesArr.push($q.when(value));
	              }
	            });
	            return promisesArr;
	          }
	
	          var promiseChain = null;
	          $modal.getPromiseChain = function() {
	            return promiseChain;
	          };
	
	          $modal.open = function(modalOptions) {
	            var modalResultDeferred = $q.defer();
	            var modalOpenedDeferred = $q.defer();
	            var modalRenderDeferred = $q.defer();
	
	            //prepare an instance of a modal to be injected into controllers and returned to a caller
	            var modalInstance = {
	              result: modalResultDeferred.promise,
	              opened: modalOpenedDeferred.promise,
	              rendered: modalRenderDeferred.promise,
	              close: function (result) {
	                return $modalStack.close(modalInstance, result);
	              },
	              dismiss: function (reason) {
	                return $modalStack.dismiss(modalInstance, reason);
	              }
	            };
	
	            //merge and clean up options
	            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
	            modalOptions.resolve = modalOptions.resolve || {};
	
	            //verify options
	            if (!modalOptions.template && !modalOptions.templateUrl) {
	              throw new Error('One of template or templateUrl options is required.');
	            }
	
	            var templateAndResolvePromise =
	              $q.all([getTemplatePromise(modalOptions)].concat(getResolvePromises(modalOptions.resolve)));
	
	            function resolveWithTemplate() {
	              return templateAndResolvePromise;
	            }
	
	            // Wait for the resolution of the existing promise chain.
	            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
	            // Then add to $modalStack and resolve opened.
	            // Finally clean up the chain variable if no subsequent modal has overwritten it.
	            var samePromise;
	            samePromise = promiseChain = $q.all([promiseChain])
	              .then(resolveWithTemplate, resolveWithTemplate)
	              .then(function resolveSuccess(tplAndVars) {
	
	                var modalScope = (modalOptions.scope || $rootScope).$new();
	                modalScope.$close = modalInstance.close;
	                modalScope.$dismiss = modalInstance.dismiss;
	
	                modalScope.$on('$destroy', function() {
	                  if (!modalScope.$$uibDestructionScheduled) {
	                    modalScope.$dismiss('$uibUnscheduledDestruction');
	                  }
	                });
	
	                var ctrlInstance, ctrlLocals = {};
	                var resolveIter = 1;
	
	                //controllers
	                if (modalOptions.controller) {
	                  ctrlLocals.$scope = modalScope;
	                  ctrlLocals.$uibModalInstance = modalInstance;
	                  Object.defineProperty(ctrlLocals, '$modalInstance', {
	                    get: function() {
	                      if (!$modalSuppressWarning) {
	                        $log.warn('$modalInstance is now deprecated. Use $uibModalInstance instead.');
	                      }
	
	                      return modalInstance;
	                    }
	                  });
	                  angular.forEach(modalOptions.resolve, function(value, key) {
	                    ctrlLocals[key] = tplAndVars[resolveIter++];
	                  });
	
	                  ctrlInstance = $controller(modalOptions.controller, ctrlLocals);
	                  if (modalOptions.controllerAs) {
	                    if (modalOptions.bindToController) {
	                      angular.extend(ctrlInstance, modalScope);
	                    }
	
	                    modalScope[modalOptions.controllerAs] = ctrlInstance;
	                  }
	                }
	
	                $modalStack.open(modalInstance, {
	                  scope: modalScope,
	                  deferred: modalResultDeferred,
	                  renderDeferred: modalRenderDeferred,
	                  content: tplAndVars[0],
	                  animation: modalOptions.animation,
	                  backdrop: modalOptions.backdrop,
	                  keyboard: modalOptions.keyboard,
	                  backdropClass: modalOptions.backdropClass,
	                  windowTopClass: modalOptions.windowTopClass,
	                  windowClass: modalOptions.windowClass,
	                  windowTemplateUrl: modalOptions.windowTemplateUrl,
	                  size: modalOptions.size,
	                  openedClass: modalOptions.openedClass
	                });
	                modalOpenedDeferred.resolve(true);
	
	            }, function resolveError(reason) {
	              modalOpenedDeferred.reject(reason);
	              modalResultDeferred.reject(reason);
	            })
	            .finally(function() {
	              if (promiseChain === samePromise) {
	                promiseChain = null;
	              }
	            });
	
	            return modalInstance;
	          };
	
	          return $modal;
	        }
	      ]
	    };
	
	    return $modalProvider;
	  });
	
	/* deprecated modal below */
	
	angular.module('ui.bootstrap.modal')
	
	  .value('$modalSuppressWarning', false)
	
	  /**
	   * A helper directive for the $modal service. It creates a backdrop element.
	   */
	  .directive('modalBackdrop', [
	    '$animate', '$injector', '$modalStack', '$log', '$modalSuppressWarning',
	    function($animate ,  $injector,   $modalStack, $log, $modalSuppressWarning) {
	      var $animateCss = null;
	
	      if ($injector.has('$animateCss')) {
	        $animateCss = $injector.get('$animateCss');
	      }
	
	      return {
	        replace: true,
	        templateUrl: 'template/modal/backdrop.html',
	        compile: function(tElement, tAttrs) {
	          tElement.addClass(tAttrs.backdropClass);
	          return linkFn;
	        }
	      };
	
	      function linkFn(scope, element, attrs) {
	        if (!$modalSuppressWarning) {
	          $log.warn('modal-backdrop is now deprecated. Use uib-modal-backdrop instead.');
	        }
	        element.addClass('modal-backdrop');
	
	        if (attrs.modalInClass) {
	          if ($animateCss) {
	            $animateCss(element, {
	              addClass: attrs.modalInClass
	            }).start();
	          } else {
	            $animate.addClass(element, attrs.modalInClass);
	          }
	
	          scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	            var done = setIsAsync();
	            if ($animateCss) {
	              $animateCss(element, {
	                removeClass: attrs.modalInClass
	              }).start().then(done);
	            } else {
	              $animate.removeClass(element, attrs.modalInClass).then(done);
	            }
	          });
	        }
	      }
	    }])
	
	  .directive('modalWindow', [
	    '$modalStack', '$q', '$animate', '$injector', '$log', '$modalSuppressWarning',
	    function($modalStack ,  $q ,  $animate,   $injector, $log, $modalSuppressWarning) {
	      var $animateCss = null;
	
	      if ($injector.has('$animateCss')) {
	        $animateCss = $injector.get('$animateCss');
	      }
	
	      return {
	        scope: {
	          index: '@'
	        },
	        replace: true,
	        transclude: true,
	        templateUrl: function(tElement, tAttrs) {
	          return tAttrs.templateUrl || 'template/modal/window.html';
	        },
	        link: function(scope, element, attrs) {
	          if (!$modalSuppressWarning) {
	            $log.warn('modal-window is now deprecated. Use uib-modal-window instead.');
	          }
	          element.addClass(attrs.windowClass || '');
	          element.addClass(attrs.windowTopClass || '');
	          scope.size = attrs.size;
	
	          scope.close = function(evt) {
	            var modal = $modalStack.getTop();
	            if (modal && modal.value.backdrop && modal.value.backdrop !== 'static' && (evt.target === evt.currentTarget)) {
	              evt.preventDefault();
	              evt.stopPropagation();
	              $modalStack.dismiss(modal.key, 'backdrop click');
	            }
	          };
	
	          // moved from template to fix issue #2280
	          element.on('click', scope.close);
	
	          // This property is only added to the scope for the purpose of detecting when this directive is rendered.
	          // We can detect that by using this property in the template associated with this directive and then use
	          // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
	          scope.$isRendered = true;
	
	          // Deferred object that will be resolved when this modal is render.
	          var modalRenderDeferObj = $q.defer();
	          // Observe function will be called on next digest cycle after compilation, ensuring that the DOM is ready.
	          // In order to use this way of finding whether DOM is ready, we need to observe a scope property used in modal's template.
	          attrs.$observe('modalRender', function(value) {
	            if (value == 'true') {
	              modalRenderDeferObj.resolve();
	            }
	          });
	
	          modalRenderDeferObj.promise.then(function() {
	            var animationPromise = null;
	
	            if (attrs.modalInClass) {
	              if ($animateCss) {
	                animationPromise = $animateCss(element, {
	                  addClass: attrs.modalInClass
	                }).start();
	              } else {
	                animationPromise = $animate.addClass(element, attrs.modalInClass);
	              }
	
	              scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	                var done = setIsAsync();
	                if ($animateCss) {
	                  $animateCss(element, {
	                    removeClass: attrs.modalInClass
	                  }).start().then(done);
	                } else {
	                  $animate.removeClass(element, attrs.modalInClass).then(done);
	                }
	              });
	            }
	
	
	            $q.when(animationPromise).then(function() {
	              var inputWithAutofocus = element[0].querySelector('[autofocus]');
	              /**
	               * Auto-focusing of a freshly-opened modal element causes any child elements
	               * with the autofocus attribute to lose focus. This is an issue on touch
	               * based devices which will show and then hide the onscreen keyboard.
	               * Attempts to refocus the autofocus element via JavaScript will not reopen
	               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	               * the modal element if the modal does not contain an autofocus element.
	               */
	              if (inputWithAutofocus) {
	                inputWithAutofocus.focus();
	              } else {
	                element[0].focus();
	              }
	            });
	
	            // Notify {@link $modalStack} that modal is rendered.
	            var modal = $modalStack.getTop();
	            if (modal) {
	              $modalStack.modalRendered(modal.key);
	            }
	          });
	        }
	      };
	    }])
	
	  .directive('modalAnimationClass', [
	    '$log', '$modalSuppressWarning',
	    function ($log, $modalSuppressWarning) {
	      return {
	        compile: function(tElement, tAttrs) {
	          if (!$modalSuppressWarning) {
	            $log.warn('modal-animation-class is now deprecated. Use uib-modal-animation-class instead.');
	          }
	          if (tAttrs.modalAnimation) {
	            tElement.addClass(tAttrs.modalAnimationClass);
	          }
	        }
	      };
	    }])
	
	  .directive('modalTransclude', [
	    '$log', '$modalSuppressWarning',
	    function ($log, $modalSuppressWarning) {
	    return {
	      link: function($scope, $element, $attrs, controller, $transclude) {
	        if (!$modalSuppressWarning) {
	          $log.warn('modal-transclude is now deprecated. Use uib-modal-transclude instead.');
	        }
	        $transclude($scope.$parent, function(clone) {
	          $element.empty();
	          $element.append(clone);
	        });
	      }
	    };
	  }])
	
	  .service('$modalStack', [
	    '$animate', '$timeout', '$document', '$compile', '$rootScope',
	    '$q',
	    '$injector',
	    '$$multiMap',
	    '$$stackedMap',
	    '$uibModalStack',
	    '$log',
	    '$modalSuppressWarning',
	    function($animate ,  $timeout ,  $document ,  $compile ,  $rootScope ,
	             $q,
	             $injector,
	             $$multiMap,
	             $$stackedMap,
	             $uibModalStack,
	             $log,
	             $modalSuppressWarning) {
	      if (!$modalSuppressWarning) {
	        $log.warn('$modalStack is now deprecated. Use $uibModalStack instead.');
	      }
	
	      angular.extend(this, $uibModalStack);
	    }])
	
	  .provider('$modal', ['$uibModalProvider', function($uibModalProvider) {
	    angular.extend(this, $uibModalProvider);
	
	    this.$get = ['$injector', '$log', '$modalSuppressWarning',
	      function ($injector, $log, $modalSuppressWarning) {
	        if (!$modalSuppressWarning) {
	          $log.warn('$modal is now deprecated. Use $uibModal instead.');
	        }
	
	        return $injector.invoke($uibModalProvider.$get);
	      }];
	  }]);
	
	angular.module('ui.bootstrap.pagination', [])
	.controller('UibPaginationController', ['$scope', '$attrs', '$parse', function($scope, $attrs, $parse) {
	  var self = this,
	      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
	      setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
	
	  this.init = function(ngModelCtrl_, config) {
	    ngModelCtrl = ngModelCtrl_;
	    this.config = config;
	
	    ngModelCtrl.$render = function() {
	      self.render();
	    };
	
	    if ($attrs.itemsPerPage) {
	      $scope.$parent.$watch($parse($attrs.itemsPerPage), function(value) {
	        self.itemsPerPage = parseInt(value, 10);
	        $scope.totalPages = self.calculateTotalPages();
	      });
	    } else {
	      this.itemsPerPage = config.itemsPerPage;
	    }
	
	    $scope.$watch('totalItems', function() {
	      $scope.totalPages = self.calculateTotalPages();
	    });
	
	    $scope.$watch('totalPages', function(value) {
	      setNumPages($scope.$parent, value); // Readonly variable
	
	      if ( $scope.page > value ) {
	        $scope.selectPage(value);
	      } else {
	        ngModelCtrl.$render();
	      }
	    });
	  };
	
	  this.calculateTotalPages = function() {
	    var totalPages = this.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / this.itemsPerPage);
	    return Math.max(totalPages || 0, 1);
	  };
	
	  this.render = function() {
	    $scope.page = parseInt(ngModelCtrl.$viewValue, 10) || 1;
	  };
	
	  $scope.selectPage = function(page, evt) {
	    if (evt) {
	      evt.preventDefault();
	    }
	
	    var clickAllowed = !$scope.ngDisabled || !evt;
	    if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
	      if (evt && evt.target) {
	        evt.target.blur();
	      }
	      ngModelCtrl.$setViewValue(page);
	      ngModelCtrl.$render();
	    }
	  };
	
	  $scope.getText = function(key) {
	    return $scope[key + 'Text'] || self.config[key + 'Text'];
	  };
	
	  $scope.noPrevious = function() {
	    return $scope.page === 1;
	  };
	
	  $scope.noNext = function() {
	    return $scope.page === $scope.totalPages;
	  };
	}])
	
	.constant('uibPaginationConfig', {
	  itemsPerPage: 10,
	  boundaryLinks: false,
	  directionLinks: true,
	  firstText: 'First',
	  previousText: 'Previous',
	  nextText: 'Next',
	  lastText: 'Last',
	  rotate: true
	})
	
	.directive('uibPagination', ['$parse', 'uibPaginationConfig', function($parse, paginationConfig) {
	  return {
	    restrict: 'EA',
	    scope: {
	      totalItems: '=',
	      firstText: '@',
	      previousText: '@',
	      nextText: '@',
	      lastText: '@',
	      ngDisabled:'='
	    },
	    require: ['uibPagination', '?ngModel'],
	    controller: 'UibPaginationController',
	    controllerAs: 'pagination',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/pagination/pagination.html';
	    },
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      // Setup configuration parameters
	      var maxSize = angular.isDefined(attrs.maxSize) ? scope.$parent.$eval(attrs.maxSize) : paginationConfig.maxSize,
	          rotate = angular.isDefined(attrs.rotate) ? scope.$parent.$eval(attrs.rotate) : paginationConfig.rotate;
	      scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : paginationConfig.boundaryLinks;
	      scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : paginationConfig.directionLinks;
	
	      paginationCtrl.init(ngModelCtrl, paginationConfig);
	
	      if (attrs.maxSize) {
	        scope.$parent.$watch($parse(attrs.maxSize), function(value) {
	          maxSize = parseInt(value, 10);
	          paginationCtrl.render();
	        });
	      }
	
	      // Create page object used in template
	      function makePage(number, text, isActive) {
	        return {
	          number: number,
	          text: text,
	          active: isActive
	        };
	      }
	
	      function getPages(currentPage, totalPages) {
	        var pages = [];
	
	        // Default page limits
	        var startPage = 1, endPage = totalPages;
	        var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;
	
	        // recompute if maxSize
	        if (isMaxSized) {
	          if (rotate) {
	            // Current page is displayed in the middle of the visible ones
	            startPage = Math.max(currentPage - Math.floor(maxSize/2), 1);
	            endPage   = startPage + maxSize - 1;
	
	            // Adjust if limit is exceeded
	            if (endPage > totalPages) {
	              endPage   = totalPages;
	              startPage = endPage - maxSize + 1;
	            }
	          } else {
	            // Visible pages are paginated with maxSize
	            startPage = ((Math.ceil(currentPage / maxSize) - 1) * maxSize) + 1;
	
	            // Adjust last page if limit is exceeded
	            endPage = Math.min(startPage + maxSize - 1, totalPages);
	          }
	        }
	
	        // Add page number links
	        for (var number = startPage; number <= endPage; number++) {
	          var page = makePage(number, number, number === currentPage);
	          pages.push(page);
	        }
	
	        // Add links to move between page sets
	        if (isMaxSized && ! rotate) {
	          if (startPage > 1) {
	            var previousPageSet = makePage(startPage - 1, '...', false);
	            pages.unshift(previousPageSet);
	          }
	
	          if (endPage < totalPages) {
	            var nextPageSet = makePage(endPage + 1, '...', false);
	            pages.push(nextPageSet);
	          }
	        }
	
	        return pages;
	      }
	
	      var originalRender = paginationCtrl.render;
	      paginationCtrl.render = function() {
	        originalRender();
	        if (scope.page > 0 && scope.page <= scope.totalPages) {
	          scope.pages = getPages(scope.page, scope.totalPages);
	        }
	      };
	    }
	  };
	}])
	
	.constant('uibPagerConfig', {
	  itemsPerPage: 10,
	  previousText: '« Previous',
	  nextText: 'Next »',
	  align: true
	})
	
	.directive('uibPager', ['uibPagerConfig', function(pagerConfig) {
	  return {
	    restrict: 'EA',
	    scope: {
	      totalItems: '=',
	      previousText: '@',
	      nextText: '@',
	      ngDisabled: '='
	    },
	    require: ['uibPager', '?ngModel'],
	    controller: 'UibPaginationController',
	    controllerAs: 'pagination',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/pagination/pager.html';
	    },
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      scope.align = angular.isDefined(attrs.align) ? scope.$parent.$eval(attrs.align) : pagerConfig.align;
	      paginationCtrl.init(ngModelCtrl, pagerConfig);
	    }
	  };
	}]);
	
	/* Deprecated Pagination Below */
	
	angular.module('ui.bootstrap.pagination')
	.value('$paginationSuppressWarning', false)
	.controller('PaginationController', ['$scope', '$attrs', '$parse', '$log', '$paginationSuppressWarning', function($scope, $attrs, $parse, $log, $paginationSuppressWarning) {
	  if (!$paginationSuppressWarning) {
	    $log.warn('PaginationController is now deprecated. Use UibPaginationController instead.');
	  }
	
	  var self = this,
	    ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
	    setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
	
	  this.init = function(ngModelCtrl_, config) {
	    ngModelCtrl = ngModelCtrl_;
	    this.config = config;
	
	    ngModelCtrl.$render = function() {
	      self.render();
	    };
	
	    if ($attrs.itemsPerPage) {
	      $scope.$parent.$watch($parse($attrs.itemsPerPage), function(value) {
	        self.itemsPerPage = parseInt(value, 10);
	        $scope.totalPages = self.calculateTotalPages();
	      });
	    } else {
	      this.itemsPerPage = config.itemsPerPage;
	    }
	
	    $scope.$watch('totalItems', function() {
	      $scope.totalPages = self.calculateTotalPages();
	    });
	
	    $scope.$watch('totalPages', function(value) {
	      setNumPages($scope.$parent, value); // Readonly variable
	
	      if ( $scope.page > value ) {
	        $scope.selectPage(value);
	      } else {
	        ngModelCtrl.$render();
	      }
	    });
	  };
	
	  this.calculateTotalPages = function() {
	    var totalPages = this.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / this.itemsPerPage);
	    return Math.max(totalPages || 0, 1);
	  };
	
	  this.render = function() {
	    $scope.page = parseInt(ngModelCtrl.$viewValue, 10) || 1;
	  };
	
	  $scope.selectPage = function(page, evt) {
	    if (evt) {
	      evt.preventDefault();
	    }
	
	    var clickAllowed = !$scope.ngDisabled || !evt;
	    if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
	      if (evt && evt.target) {
	        evt.target.blur();
	      }
	      ngModelCtrl.$setViewValue(page);
	      ngModelCtrl.$render();
	    }
	  };
	
	  $scope.getText = function(key) {
	    return $scope[key + 'Text'] || self.config[key + 'Text'];
	  };
	
	  $scope.noPrevious = function() {
	    return $scope.page === 1;
	  };
	
	  $scope.noNext = function() {
	    return $scope.page === $scope.totalPages;
	  };
	}])
	.directive('pagination', ['$parse', 'uibPaginationConfig', '$log', '$paginationSuppressWarning', function($parse, paginationConfig, $log, $paginationSuppressWarning) {
	  return {
	    restrict: 'EA',
	    scope: {
	      totalItems: '=',
	      firstText: '@',
	      previousText: '@',
	      nextText: '@',
	      lastText: '@',
	      ngDisabled:'='
	    },
	    require: ['pagination', '?ngModel'],
	    controller: 'PaginationController',
	    controllerAs: 'pagination',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/pagination/pagination.html';
	    },
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      if (!$paginationSuppressWarning) {
	        $log.warn('pagination is now deprecated. Use uib-pagination instead.');
	      }
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      // Setup configuration parameters
	      var maxSize = angular.isDefined(attrs.maxSize) ? scope.$parent.$eval(attrs.maxSize) : paginationConfig.maxSize,
	          rotate = angular.isDefined(attrs.rotate) ? scope.$parent.$eval(attrs.rotate) : paginationConfig.rotate;
	      scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : paginationConfig.boundaryLinks;
	      scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : paginationConfig.directionLinks;
	
	      paginationCtrl.init(ngModelCtrl, paginationConfig);
	
	      if (attrs.maxSize) {
	        scope.$parent.$watch($parse(attrs.maxSize), function(value) {
	          maxSize = parseInt(value, 10);
	          paginationCtrl.render();
	        });
	      }
	
	      // Create page object used in template
	      function makePage(number, text, isActive) {
	        return {
	          number: number,
	          text: text,
	          active: isActive
	        };
	      }
	
	      function getPages(currentPage, totalPages) {
	        var pages = [];
	
	        // Default page limits
	        var startPage = 1, endPage = totalPages;
	        var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;
	
	        // recompute if maxSize
	        if (isMaxSized) {
	          if (rotate) {
	            // Current page is displayed in the middle of the visible ones
	            startPage = Math.max(currentPage - Math.floor(maxSize/2), 1);
	            endPage   = startPage + maxSize - 1;
	
	            // Adjust if limit is exceeded
	            if (endPage > totalPages) {
	              endPage   = totalPages;
	              startPage = endPage - maxSize + 1;
	            }
	          } else {
	            // Visible pages are paginated with maxSize
	            startPage = ((Math.ceil(currentPage / maxSize) - 1) * maxSize) + 1;
	
	            // Adjust last page if limit is exceeded
	            endPage = Math.min(startPage + maxSize - 1, totalPages);
	          }
	        }
	
	        // Add page number links
	        for (var number = startPage; number <= endPage; number++) {
	          var page = makePage(number, number, number === currentPage);
	          pages.push(page);
	        }
	
	        // Add links to move between page sets
	        if (isMaxSized && ! rotate) {
	          if (startPage > 1) {
	            var previousPageSet = makePage(startPage - 1, '...', false);
	            pages.unshift(previousPageSet);
	          }
	
	          if (endPage < totalPages) {
	            var nextPageSet = makePage(endPage + 1, '...', false);
	            pages.push(nextPageSet);
	          }
	        }
	
	        return pages;
	      }
	
	      var originalRender = paginationCtrl.render;
	      paginationCtrl.render = function() {
	        originalRender();
	        if (scope.page > 0 && scope.page <= scope.totalPages) {
	          scope.pages = getPages(scope.page, scope.totalPages);
	        }
	      };
	    }
	  };
	}])
	
	.directive('pager', ['uibPagerConfig', '$log', '$paginationSuppressWarning', function(pagerConfig, $log, $paginationSuppressWarning) {
	  return {
	    restrict: 'EA',
	    scope: {
	      totalItems: '=',
	      previousText: '@',
	      nextText: '@',
	      ngDisabled: '='
	    },
	    require: ['pager', '?ngModel'],
	    controller: 'PaginationController',
	    controllerAs: 'pagination',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/pagination/pager.html';
	    },
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      if (!$paginationSuppressWarning) {
	        $log.warn('pager is now deprecated. Use uib-pager instead.');
	      }
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      scope.align = angular.isDefined(attrs.align) ? scope.$parent.$eval(attrs.align) : pagerConfig.align;
	      paginationCtrl.init(ngModelCtrl, pagerConfig);
	    }
	  };
	}]);
	
	/**
	 * The following features are still outstanding: animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, html tooltips, and selector delegation.
	 */
	angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])
	
	/**
	 * The $tooltip service creates tooltip- and popover-like directives as well as
	 * houses global options for them.
	 */
	.provider('$uibTooltip', function() {
	  // The default options tooltip and popover.
	  var defaultOptions = {
	    placement: 'top',
	    animation: true,
	    popupDelay: 0,
	    popupCloseDelay: 0,
	    useContentExp: false
	  };
	
	  // Default hide triggers for each show trigger
	  var triggerMap = {
	    'mouseenter': 'mouseleave',
	    'click': 'click',
	    'focus': 'blur',
	    'none': ''
	  };
	
	  // The options specified to the provider globally.
	  var globalOptions = {};
	
	  /**
	   * `options({})` allows global configuration of all tooltips in the
	   * application.
	   *
	   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
	   *     // place tooltips left instead of top by default
	   *     $tooltipProvider.options( { placement: 'left' } );
	   *   });
	   */
		this.options = function(value) {
			angular.extend(globalOptions, value);
		};
	
	  /**
	   * This allows you to extend the set of trigger mappings available. E.g.:
	   *
	   *   $tooltipProvider.setTriggers( 'openTrigger': 'closeTrigger' );
	   */
	  this.setTriggers = function setTriggers(triggers) {
	    angular.extend(triggerMap, triggers);
	  };
	
	  /**
	   * This is a helper function for translating camel-case to snake-case.
	   */
	  function snake_case(name) {
	    var regexp = /[A-Z]/g;
	    var separator = '-';
	    return name.replace(regexp, function(letter, pos) {
	      return (pos ? separator : '') + letter.toLowerCase();
	    });
	  }
	
	  /**
	   * Returns the actual instance of the $tooltip service.
	   * TODO support multiple triggers
	   */
	  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
	    var openedTooltips = $$stackedMap.createNew();
	    $document.on('keypress', function(e) {
	      if (e.which === 27) {
	        var last = openedTooltips.top();
	        if (last) {
	          last.value.close();
	          openedTooltips.removeTop();
	          last = null;
	        }
	      }
	    });
	
	    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
	      options = angular.extend({}, defaultOptions, globalOptions, options);
	
	      /**
	       * Returns an object of show and hide triggers.
	       *
	       * If a trigger is supplied,
	       * it is used to show the tooltip; otherwise, it will use the `trigger`
	       * option passed to the `$tooltipProvider.options` method; else it will
	       * default to the trigger supplied to this directive factory.
	       *
	       * The hide trigger is based on the show trigger. If the `trigger` option
	       * was passed to the `$tooltipProvider.options` method, it will use the
	       * mapped trigger from `triggerMap` or the passed trigger if the map is
	       * undefined; otherwise, it uses the `triggerMap` value of the show
	       * trigger; else it will just use the show trigger.
	       */
	      function getTriggers(trigger) {
	        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
	        var hide = show.map(function(trigger) {
	          return triggerMap[trigger] || trigger;
	        });
	        return {
	          show: show,
	          hide: hide
	        };
	      }
	
	      var directiveName = snake_case(ttType);
	
	      var startSym = $interpolate.startSymbol();
	      var endSym = $interpolate.endSymbol();
	      var template =
	        '<div '+ directiveName + '-popup '+
	          'title="' + startSym + 'title' + endSym + '" '+
	          (options.useContentExp ?
	            'content-exp="contentExp()" ' :
	            'content="' + startSym + 'content' + endSym + '" ') +
	          'placement="' + startSym + 'placement' + endSym + '" '+
	          'popup-class="' + startSym + 'popupClass' + endSym + '" '+
	          'animation="animation" ' +
	          'is-open="isOpen"' +
	          'origin-scope="origScope" ' +
	          'style="visibility: hidden; display: block; top: -9999px; left: -9999px;"' +
	          '>' +
	        '</div>';
	
	      return {
	        compile: function(tElem, tAttrs) {
	          var tooltipLinker = $compile(template);
	
	          return function link(scope, element, attrs, tooltipCtrl) {
	            var tooltip;
	            var tooltipLinkedScope;
	            var transitionTimeout;
	            var showTimeout;
	            var hideTimeout;
	            var positionTimeout;
	            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
	            var triggers = getTriggers(undefined);
	            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
	            var ttScope = scope.$new(true);
	            var repositionScheduled = false;
	            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
	            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
	            var observers = [];
	
	            var positionTooltip = function() {
	              // check if tooltip exists and is not empty
	              if (!tooltip || !tooltip.html()) { return; }
	
	              if (!positionTimeout) {
	                positionTimeout = $timeout(function() {
	                  // Reset the positioning.
	                  tooltip.css({ top: 0, left: 0 });
	
	                  // Now set the calculated positioning.
	                  var ttCss = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
	                  ttCss.top += 'px';
	                  ttCss.left += 'px';
	                  ttCss.visibility = 'visible';
	                  tooltip.css(ttCss);
	
	                  positionTimeout = null;
	                }, 0, false);
	              }
	            };
	
	            // Set up the correct scope to allow transclusion later
	            ttScope.origScope = scope;
	
	            // By default, the tooltip is not open.
	            // TODO add ability to start tooltip opened
	            ttScope.isOpen = false;
	            openedTooltips.add(ttScope, {
	              close: hide
	            });
	
	            function toggleTooltipBind() {
	              if (!ttScope.isOpen) {
	                showTooltipBind();
	              } else {
	                hideTooltipBind();
	              }
	            }
	
	            // Show the tooltip with delay if specified, otherwise show it immediately
	            function showTooltipBind() {
	              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
	                return;
	              }
	
	              cancelHide();
	              prepareTooltip();
	
	              if (ttScope.popupDelay) {
	                // Do nothing if the tooltip was already scheduled to pop-up.
	                // This happens if show is triggered multiple times before any hide is triggered.
	                if (!showTimeout) {
	                  showTimeout = $timeout(show, ttScope.popupDelay, false);
	                }
	              } else {
	                show();
	              }
	            }
	
	            function hideTooltipBind() {
	              cancelShow();
	
	              if (ttScope.popupCloseDelay) {
	                if (!hideTimeout) {
	                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
	                }
	              } else {
	                hide();
	              }
	            }
	
	            // Show the tooltip popup element.
	            function show() {
	              cancelShow();
	              cancelHide();
	
	              // Don't show empty tooltips.
	              if (!ttScope.content) {
	                return angular.noop;
	              }
	
	              createTooltip();
	
	              // And show the tooltip.
	              ttScope.$evalAsync(function() {
	                ttScope.isOpen = true;
	                assignIsOpen(true);
	                positionTooltip();
	              });
	            }
	
	            function cancelShow() {
	              if (showTimeout) {
	                $timeout.cancel(showTimeout);
	                showTimeout = null;
	              }
	
	              if (positionTimeout) {
	                $timeout.cancel(positionTimeout);
	                positionTimeout = null;
	              }
	            }
	
	            // Hide the tooltip popup element.
	            function hide() {
	              cancelShow();
	              cancelHide();
	
	              if (!ttScope) {
	                return;
	              }
	
	              // First things first: we don't show it anymore.
	              ttScope.$evalAsync(function() {
	                ttScope.isOpen = false;
	                assignIsOpen(false);
	                // And now we remove it from the DOM. However, if we have animation, we
	                // need to wait for it to expire beforehand.
	                // FIXME: this is a placeholder for a port of the transitions library.
	                // The fade transition in TWBS is 150ms.
	                if (ttScope.animation) {
	                  if (!transitionTimeout) {
	                    transitionTimeout = $timeout(removeTooltip, 150, false);
	                  }
	                } else {
	                  removeTooltip();
	                }
	              });
	            }
	
	            function cancelHide() {
	              if (hideTimeout) {
	                $timeout.cancel(hideTimeout);
	                hideTimeout = null;
	              }
	              if (transitionTimeout) {
	                $timeout.cancel(transitionTimeout);
	                transitionTimeout = null;
	              }
	            }
	
	            function createTooltip() {
	              // There can only be one tooltip element per directive shown at once.
	              if (tooltip) {
	                return;
	              }
	
	              tooltipLinkedScope = ttScope.$new();
	              tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
	                if (appendToBody) {
	                  $document.find('body').append(tooltip);
	                } else {
	                  element.after(tooltip);
	                }
	              });
	
	              prepObservers();
	            }
	
	            function removeTooltip() {
	              unregisterObservers();
	
	              transitionTimeout = null;
	              if (tooltip) {
	                tooltip.remove();
	                tooltip = null;
	              }
	              if (tooltipLinkedScope) {
	                tooltipLinkedScope.$destroy();
	                tooltipLinkedScope = null;
	              }
	            }
	
	            /**
	             * Set the inital scope values. Once
	             * the tooltip is created, the observers
	             * will be added to keep things in synch.
	             */
	            function prepareTooltip() {
	              ttScope.title = attrs[prefix + 'Title'];
	              if (contentParse) {
	                ttScope.content = contentParse(scope);
	              } else {
	                ttScope.content = attrs[ttType];
	              }
	
	              ttScope.popupClass = attrs[prefix + 'Class'];
	              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
	
	              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
	              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
	              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
	              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
	            }
	
	            function assignIsOpen(isOpen) {
	              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
	                isOpenParse.assign(scope, isOpen);
	              }
	            }
	
	            ttScope.contentExp = function() {
	              return ttScope.content;
	            };
	
	            /**
	             * Observe the relevant attributes.
	             */
	            attrs.$observe('disabled', function(val) {
	              if (val) {
	                cancelShow();
	              }
	
	              if (val && ttScope.isOpen) {
	                hide();
	              }
	            });
	
	            if (isOpenParse) {
	              scope.$watch(isOpenParse, function(val) {
	                /*jshint -W018 */
	                if (ttScope && !val === ttScope.isOpen) {
	                  toggleTooltipBind();
	                }
	                /*jshint +W018 */
	              });
	            }
	
	            function prepObservers() {
	              observers.length = 0;
	
	              if (contentParse) {
	                observers.push(
	                  scope.$watch(contentParse, function(val) {
	                    ttScope.content = val;
	                    if (!val && ttScope.isOpen) {
	                      hide();
	                    }
	                  })
	                );
	
	                observers.push(
	                  tooltipLinkedScope.$watch(function() {
	                    if (!repositionScheduled) {
	                      repositionScheduled = true;
	                      tooltipLinkedScope.$$postDigest(function() {
	                        repositionScheduled = false;
	                        if (ttScope && ttScope.isOpen) {
	                          positionTooltip();
	                        }
	                      });
	                    }
	                  })
	                );
	              } else {
	                observers.push(
	                  attrs.$observe(ttType, function(val) {
	                    ttScope.content = val;
	                    if (!val && ttScope.isOpen) {
	                      hide();
	                    } else {
	                      positionTooltip();
	                    }
	                  })
	                );
	              }
	
	              observers.push(
	                attrs.$observe(prefix + 'Title', function(val) {
	                  ttScope.title = val;
	                  if (ttScope.isOpen) {
	                    positionTooltip();
	                  }
	                })
	              );
	
	              observers.push(
	                attrs.$observe(prefix + 'Placement', function(val) {
	                  ttScope.placement = val ? val : options.placement;
	                  if (ttScope.isOpen) {
	                    positionTooltip();
	                  }
	                })
	              );
	            }
	
	            function unregisterObservers() {
	              if (observers.length) {
	                angular.forEach(observers, function(observer) {
	                  observer();
	                });
	                observers.length = 0;
	              }
	            }
	
	            var unregisterTriggers = function() {
	              triggers.show.forEach(function(trigger) {
	                element.unbind(trigger, showTooltipBind);
	              });
	              triggers.hide.forEach(function(trigger) {
	                trigger.split(' ').forEach(function(hideTrigger) {
	                  element[0].removeEventListener(hideTrigger, hideTooltipBind);
	                });
	              });
	            };
	
	            function prepTriggers() {
	              var val = attrs[prefix + 'Trigger'];
	              unregisterTriggers();
	
	              triggers = getTriggers(val);
	
	              if (triggers.show !== 'none') {
	                triggers.show.forEach(function(trigger, idx) {
	                  // Using raw addEventListener due to jqLite/jQuery bug - #4060
	                  if (trigger === triggers.hide[idx]) {
	                    element[0].addEventListener(trigger, toggleTooltipBind);
	                  } else if (trigger) {
	                    element[0].addEventListener(trigger, showTooltipBind);
	                    triggers.hide[idx].split(' ').forEach(function(trigger) {
	                      element[0].addEventListener(trigger, hideTooltipBind);
	                    });
	                  }
	
	                  element.on('keypress', function(e) {
	                    if (e.which === 27) {
	                      hideTooltipBind();
	                    }
	                  });
	                });
	              }
	            }
	
	            prepTriggers();
	
	            var animation = scope.$eval(attrs[prefix + 'Animation']);
	            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;
	
	            var appendToBodyVal = scope.$eval(attrs[prefix + 'AppendToBody']);
	            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;
	
	            // if a tooltip is attached to <body> we need to remove it on
	            // location change as its parent scope will probably not be destroyed
	            // by the change.
	            if (appendToBody) {
	              scope.$on('$locationChangeSuccess', function closeTooltipOnLocationChangeSuccess() {
	                if (ttScope.isOpen) {
	                  hide();
	                }
	              });
	            }
	
	            // Make sure tooltip is destroyed and removed.
	            scope.$on('$destroy', function onDestroyTooltip() {
	              cancelShow();
	              cancelHide();
	              unregisterTriggers();
	              removeTooltip();
	              openedTooltips.remove(ttScope);
	              ttScope = null;
	            });
	          };
	        }
	      };
	    };
	  }];
	})
	
	// This is mostly ngInclude code but with a custom scope
	.directive('uibTooltipTemplateTransclude', [
	         '$animate', '$sce', '$compile', '$templateRequest',
	function ($animate ,  $sce ,  $compile ,  $templateRequest) {
	  return {
	    link: function(scope, elem, attrs) {
	      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);
	
	      var changeCounter = 0,
	        currentScope,
	        previousElement,
	        currentElement;
	
	      var cleanupLastIncludeContent = function() {
	        if (previousElement) {
	          previousElement.remove();
	          previousElement = null;
	        }
	
	        if (currentScope) {
	          currentScope.$destroy();
	          currentScope = null;
	        }
	
	        if (currentElement) {
	          $animate.leave(currentElement).then(function() {
	            previousElement = null;
	          });
	          previousElement = currentElement;
	          currentElement = null;
	        }
	      };
	
	      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function(src) {
	        var thisChangeId = ++changeCounter;
	
	        if (src) {
	          //set the 2nd param to true to ignore the template request error so that the inner
	          //contents and scope can be cleaned up.
	          $templateRequest(src, true).then(function(response) {
	            if (thisChangeId !== changeCounter) { return; }
	            var newScope = origScope.$new();
	            var template = response;
	
	            var clone = $compile(template)(newScope, function(clone) {
	              cleanupLastIncludeContent();
	              $animate.enter(clone, elem);
	            });
	
	            currentScope = newScope;
	            currentElement = clone;
	
	            currentScope.$emit('$includeContentLoaded', src);
	          }, function() {
	            if (thisChangeId === changeCounter) {
	              cleanupLastIncludeContent();
	              scope.$emit('$includeContentError', src);
	            }
	          });
	          scope.$emit('$includeContentRequested', src);
	        } else {
	          cleanupLastIncludeContent();
	        }
	      });
	
	      scope.$on('$destroy', cleanupLastIncludeContent);
	    }
	  };
	}])
	
	/**
	 * Note that it's intentional that these classes are *not* applied through $animate.
	 * They must not be animated as they're expected to be present on the tooltip on
	 * initialization.
	 */
	.directive('uibTooltipClasses', function() {
	  return {
	    restrict: 'A',
	    link: function(scope, element, attrs) {
	      if (scope.placement) {
	        element.addClass(scope.placement);
	      }
	
	      if (scope.popupClass) {
	        element.addClass(scope.popupClass);
	      }
	
	      if (scope.animation()) {
	        element.addClass(attrs.tooltipAnimationClass);
	      }
	    }
	  };
	})
	
	.directive('uibTooltipPopup', function() {
	  return {
	    replace: true,
	    scope: { content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/tooltip/tooltip-popup.html',
	    link: function(scope, element) {
	      element.addClass('tooltip');
	    }
	  };
	})
	
	.directive('uibTooltip', [ '$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
	}])
	
	.directive('uibTooltipTemplatePopup', function() {
	  return {
	    replace: true,
	    scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
	      originScope: '&' },
	    templateUrl: 'template/tooltip/tooltip-template-popup.html',
	    link: function(scope, element) {
	      element.addClass('tooltip');
	    }
	  };
	})
	
	.directive('uibTooltipTemplate', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibTooltipHtmlPopup', function() {
	  return {
	    replace: true,
	    scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/tooltip/tooltip-html-popup.html',
	    link: function(scope, element) {
	      element.addClass('tooltip');
	    }
	  };
	})
	
	.directive('uibTooltipHtml', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}]);
	
	/* Deprecated tooltip below */
	
	angular.module('ui.bootstrap.tooltip')
	
	.value('$tooltipSuppressWarning', false)
	
	.provider('$tooltip', ['$uibTooltipProvider', function($uibTooltipProvider) {
	  angular.extend(this, $uibTooltipProvider);
	
	  this.$get = ['$log', '$tooltipSuppressWarning', '$injector', function($log, $tooltipSuppressWarning, $injector) {
	    if (!$tooltipSuppressWarning) {
	      $log.warn('$tooltip is now deprecated. Use $uibTooltip instead.');
	    }
	
	    return $injector.invoke($uibTooltipProvider.$get);
	  }];
	}])
	
	// This is mostly ngInclude code but with a custom scope
	.directive('tooltipTemplateTransclude', [
	         '$animate', '$sce', '$compile', '$templateRequest', '$log', '$tooltipSuppressWarning',
	function ($animate ,  $sce ,  $compile ,  $templateRequest,   $log,   $tooltipSuppressWarning) {
	  return {
	    link: function(scope, elem, attrs) {
	      if (!$tooltipSuppressWarning) {
	        $log.warn('tooltip-template-transclude is now deprecated. Use uib-tooltip-template-transclude instead.');
	      }
	
	      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);
	
	      var changeCounter = 0,
	        currentScope,
	        previousElement,
	        currentElement;
	
	      var cleanupLastIncludeContent = function() {
	        if (previousElement) {
	          previousElement.remove();
	          previousElement = null;
	        }
	        if (currentScope) {
	          currentScope.$destroy();
	          currentScope = null;
	        }
	        if (currentElement) {
	          $animate.leave(currentElement).then(function() {
	            previousElement = null;
	          });
	          previousElement = currentElement;
	          currentElement = null;
	        }
	      };
	
	      scope.$watch($sce.parseAsResourceUrl(attrs.tooltipTemplateTransclude), function(src) {
	        var thisChangeId = ++changeCounter;
	
	        if (src) {
	          //set the 2nd param to true to ignore the template request error so that the inner
	          //contents and scope can be cleaned up.
	          $templateRequest(src, true).then(function(response) {
	            if (thisChangeId !== changeCounter) { return; }
	            var newScope = origScope.$new();
	            var template = response;
	
	            var clone = $compile(template)(newScope, function(clone) {
	              cleanupLastIncludeContent();
	              $animate.enter(clone, elem);
	            });
	
	            currentScope = newScope;
	            currentElement = clone;
	
	            currentScope.$emit('$includeContentLoaded', src);
	          }, function() {
	            if (thisChangeId === changeCounter) {
	              cleanupLastIncludeContent();
	              scope.$emit('$includeContentError', src);
	            }
	          });
	          scope.$emit('$includeContentRequested', src);
	        } else {
	          cleanupLastIncludeContent();
	        }
	      });
	
	      scope.$on('$destroy', cleanupLastIncludeContent);
	    }
	  };
	}])
	
	.directive('tooltipClasses', ['$log', '$tooltipSuppressWarning', function($log, $tooltipSuppressWarning) {
	  return {
	    restrict: 'A',
	    link: function(scope, element, attrs) {
	      if (!$tooltipSuppressWarning) {
	        $log.warn('tooltip-classes is now deprecated. Use uib-tooltip-classes instead.');
	      }
	
	      if (scope.placement) {
	        element.addClass(scope.placement);
	      }
	      if (scope.popupClass) {
	        element.addClass(scope.popupClass);
	      }
	      if (scope.animation()) {
	        element.addClass(attrs.tooltipAnimationClass);
	      }
	    }
	  };
	}])
	
	.directive('tooltipPopup', ['$log', '$tooltipSuppressWarning', function($log, $tooltipSuppressWarning) {
	  return {
	    replace: true,
	    scope: { content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/tooltip/tooltip-popup.html',
	    link: function(scope, element) {
	      if (!$tooltipSuppressWarning) {
	        $log.warn('tooltip-popup is now deprecated. Use uib-tooltip-popup instead.');
	      }
	
	      element.addClass('tooltip');
	    }
	  };
	}])
	
	.directive('tooltip', ['$tooltip', function($tooltip) {
	  return $tooltip('tooltip', 'tooltip', 'mouseenter');
	}])
	
	.directive('tooltipTemplatePopup', ['$log', '$tooltipSuppressWarning', function($log, $tooltipSuppressWarning) {
	  return {
	    replace: true,
	    scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
	      originScope: '&' },
	    templateUrl: 'template/tooltip/tooltip-template-popup.html',
	    link: function(scope, element) {
	      if (!$tooltipSuppressWarning) {
	        $log.warn('tooltip-template-popup is now deprecated. Use uib-tooltip-template-popup instead.');
	      }
	
	      element.addClass('tooltip');
	    }
	  };
	}])
	
	.directive('tooltipTemplate', ['$tooltip', function($tooltip) {
	  return $tooltip('tooltipTemplate', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}])
	
	.directive('tooltipHtmlPopup', ['$log', '$tooltipSuppressWarning', function($log, $tooltipSuppressWarning) {
	  return {
	    replace: true,
	    scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/tooltip/tooltip-html-popup.html',
	    link: function(scope, element) {
	      if (!$tooltipSuppressWarning) {
	        $log.warn('tooltip-html-popup is now deprecated. Use uib-tooltip-html-popup instead.');
	      }
	
	      element.addClass('tooltip');
	    }
	  };
	}])
	
	.directive('tooltipHtml', ['$tooltip', function($tooltip) {
	  return $tooltip('tooltipHtml', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}]);
	
	/**
	 * The following features are still outstanding: popup delay, animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, and selector delegatation.
	 */
	angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip'])
	
	.directive('uibPopoverTemplatePopup', function() {
	  return {
	    replace: true,
	    scope: { title: '@', contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
	      originScope: '&' },
	    templateUrl: 'template/popover/popover-template.html',
	    link: function(scope, element) {
	      element.addClass('popover');
	    }
	  };
	})
	
	.directive('uibPopoverTemplate', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibPopoverHtmlPopup', function() {
	  return {
	    replace: true,
	    scope: { contentExp: '&', title: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/popover/popover-html.html',
	    link: function(scope, element) {
	      element.addClass('popover');
	    }
	  };
	})
	
	.directive('uibPopoverHtml', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibPopoverPopup', function() {
	  return {
	    replace: true,
	    scope: { title: '@', content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/popover/popover.html',
	    link: function(scope, element) {
	      element.addClass('popover');
	    }
	  };
	})
	
	.directive('uibPopover', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibPopover', 'popover', 'click');
	}]);
	
	/* Deprecated popover below */
	
	angular.module('ui.bootstrap.popover')
	
	.value('$popoverSuppressWarning', false)
	
	.directive('popoverTemplatePopup', ['$log', '$popoverSuppressWarning', function($log, $popoverSuppressWarning) {
	  return {
	    replace: true,
	    scope: { title: '@', contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
	      originScope: '&' },
	    templateUrl: 'template/popover/popover-template.html',
	    link: function(scope, element) {
	      if (!$popoverSuppressWarning) {
	        $log.warn('popover-template-popup is now deprecated. Use uib-popover-template-popup instead.');
	      }
	
	      element.addClass('popover');
	    }
	  };
	}])
	
	.directive('popoverTemplate', ['$tooltip', function($tooltip) {
	  return $tooltip('popoverTemplate', 'popover', 'click', {
	    useContentExp: true
	  });
	}])
	
	.directive('popoverHtmlPopup', ['$log', '$popoverSuppressWarning', function($log, $popoverSuppressWarning) {
	  return {
	    replace: true,
	    scope: { contentExp: '&', title: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/popover/popover-html.html',
	    link: function(scope, element) {
	      if (!$popoverSuppressWarning) {
	        $log.warn('popover-html-popup is now deprecated. Use uib-popover-html-popup instead.');
	      }
	
	      element.addClass('popover');
	    }
	  };
	}])
	
	.directive('popoverHtml', ['$tooltip', function($tooltip) {
	  return $tooltip('popoverHtml', 'popover', 'click', {
	    useContentExp: true
	  });
	}])
	
	.directive('popoverPopup', ['$log', '$popoverSuppressWarning', function($log, $popoverSuppressWarning) {
	  return {
	    replace: true,
	    scope: { title: '@', content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/popover/popover.html',
	    link: function(scope, element) {
	      if (!$popoverSuppressWarning) {
	        $log.warn('popover-popup is now deprecated. Use uib-popover-popup instead.');
	      }
	
	      element.addClass('popover');
	    }
	  };
	}])
	
	.directive('popover', ['$tooltip', function($tooltip) {
	
	  return $tooltip('popover', 'popover', 'click');
	}]);
	
	angular.module('ui.bootstrap.progressbar', [])
	
	.constant('uibProgressConfig', {
	  animate: true,
	  max: 100
	})
	
	.controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function($scope, $attrs, progressConfig) {
	  var self = this,
	      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;
	
	  this.bars = [];
	  $scope.max = angular.isDefined($scope.max) ? $scope.max : progressConfig.max;
	
	  this.addBar = function(bar, element, attrs) {
	    if (!animate) {
	      element.css({'transition': 'none'});
	    }
	
	    this.bars.push(bar);
	
	    bar.max = $scope.max;
	    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';
	
	    bar.$watch('value', function(value) {
	      bar.recalculatePercentage();
	    });
	
	    bar.recalculatePercentage = function() {
	      var totalPercentage = self.bars.reduce(function(total, bar) {
	        bar.percent = +(100 * bar.value / bar.max).toFixed(2);
	        return total + bar.percent;
	      }, 0);
	
	      if (totalPercentage > 100) {
	        bar.percent -= totalPercentage - 100;
	      }
	    };
	
	    bar.$on('$destroy', function() {
	      element = null;
	      self.removeBar(bar);
	    });
	  };
	
	  this.removeBar = function(bar) {
	    this.bars.splice(this.bars.indexOf(bar), 1);
	    this.bars.forEach(function (bar) {
	      bar.recalculatePercentage();
	    });
	  };
	
	  $scope.$watch('max', function(max) {
	    self.bars.forEach(function(bar) {
	      bar.max = $scope.max;
	      bar.recalculatePercentage();
	    });
	  });
	}])
	
	.directive('uibProgress', function() {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'UibProgressController',
	    require: 'uibProgress',
	    scope: {
	      max: '=?'
	    },
	    templateUrl: 'template/progressbar/progress.html'
	  };
	})
	
	.directive('uibBar', function() {
	  return {
	    replace: true,
	    transclude: true,
	    require: '^uibProgress',
	    scope: {
	      value: '=',
	      type: '@'
	    },
	    templateUrl: 'template/progressbar/bar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, element, attrs);
	    }
	  };
	})
	
	.directive('uibProgressbar', function() {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'UibProgressController',
	    scope: {
	      value: '=',
	      max: '=?',
	      type: '@'
	    },
	    templateUrl: 'template/progressbar/progressbar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, angular.element(element.children()[0]), {title: attrs.title});
	    }
	  };
	});
	
	/* Deprecated progressbar below */
	
	angular.module('ui.bootstrap.progressbar')
	
	.value('$progressSuppressWarning', false)
	
	.controller('ProgressController', ['$scope', '$attrs', 'uibProgressConfig', '$log', '$progressSuppressWarning', function($scope, $attrs, progressConfig, $log, $progressSuppressWarning) {
	  if (!$progressSuppressWarning) {
	    $log.warn('ProgressController is now deprecated. Use UibProgressController instead.');
	  }
	
	  var self = this,
	    animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;
	
	  this.bars = [];
	  $scope.max = angular.isDefined($scope.max) ? $scope.max : progressConfig.max;
	
	  this.addBar = function(bar, element, attrs) {
	    if (!animate) {
	      element.css({'transition': 'none'});
	    }
	
	    this.bars.push(bar);
	
	    bar.max = $scope.max;
	    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';
	
	    bar.$watch('value', function(value) {
	      bar.recalculatePercentage();
	    });
	
	    bar.recalculatePercentage = function() {
	      bar.percent = +(100 * bar.value / bar.max).toFixed(2);
	
	      var totalPercentage = self.bars.reduce(function(total, bar) {
	        return total + bar.percent;
	      }, 0);
	
	      if (totalPercentage > 100) {
	        bar.percent -= totalPercentage - 100;
	      }
	    };
	
	    bar.$on('$destroy', function() {
	      element = null;
	      self.removeBar(bar);
	    });
	  };
	
	  this.removeBar = function(bar) {
	    this.bars.splice(this.bars.indexOf(bar), 1);
	  };
	
	  $scope.$watch('max', function(max) {
	    self.bars.forEach(function(bar) {
	      bar.max = $scope.max;
	      bar.recalculatePercentage();
	    });
	  });
	}])
	
	.directive('progress', ['$log', '$progressSuppressWarning', function($log, $progressSuppressWarning) {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'ProgressController',
	    require: 'progress',
	    scope: {
	      max: '=?',
	      title: '@?'
	    },
	    templateUrl: 'template/progressbar/progress.html',
	    link: function() {
	      if (!$progressSuppressWarning) {
	        $log.warn('progress is now deprecated. Use uib-progress instead.');
	      }
	    }
	  };
	}])
	
	.directive('bar', ['$log', '$progressSuppressWarning', function($log, $progressSuppressWarning) {
	  return {
	    replace: true,
	    transclude: true,
	    require: '^progress',
	    scope: {
	      value: '=',
	      type: '@'
	    },
	    templateUrl: 'template/progressbar/bar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      if (!$progressSuppressWarning) {
	        $log.warn('bar is now deprecated. Use uib-bar instead.');
	      }
	      progressCtrl.addBar(scope, element);
	    }
	  };
	}])
	
	.directive('progressbar', ['$log', '$progressSuppressWarning', function($log, $progressSuppressWarning) {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'ProgressController',
	    scope: {
	      value: '=',
	      max: '=?',
	      type: '@'
	    },
	    templateUrl: 'template/progressbar/progressbar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      if (!$progressSuppressWarning) {
	        $log.warn('progressbar is now deprecated. Use uib-progressbar instead.');
	      }
	      progressCtrl.addBar(scope, angular.element(element.children()[0]), {title: attrs.title});
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.rating', [])
	
	.constant('uibRatingConfig', {
	  max: 5,
	  stateOn: null,
	  stateOff: null,
	  titles : ['one', 'two', 'three', 'four', 'five']
	})
	
	.controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function($scope, $attrs, ratingConfig) {
	  var ngModelCtrl  = { $setViewValue: angular.noop };
	
	  this.init = function(ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    ngModelCtrl.$formatters.push(function(value) {
	      if (angular.isNumber(value) && value << 0 !== value) {
	        value = Math.round(value);
	      }
	      return value;
	    });
	
	    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
	    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
	    var tmpTitles = angular.isDefined($attrs.titles)  ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles ;
	    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
	      tmpTitles : ratingConfig.titles;
	
	    var ratingStates = angular.isDefined($attrs.ratingStates) ?
	      $scope.$parent.$eval($attrs.ratingStates) :
	      new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
	    $scope.range = this.buildTemplateObjects(ratingStates);
	  };
	
	  this.buildTemplateObjects = function(states) {
	    for (var i = 0, n = states.length; i < n; i++) {
	      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
	    }
	    return states;
	  };
	
	  this.getTitle = function(index) {
	    if (index >= this.titles.length) {
	      return index + 1;
	    } else {
	      return this.titles[index];
	    }
	  };
	
	  $scope.rate = function(value) {
	    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
	      ngModelCtrl.$setViewValue(ngModelCtrl.$viewValue === value ? 0 : value);
	      ngModelCtrl.$render();
	    }
	  };
	
	  $scope.enter = function(value) {
	    if (!$scope.readonly) {
	      $scope.value = value;
	    }
	    $scope.onHover({value: value});
	  };
	
	  $scope.reset = function() {
	    $scope.value = ngModelCtrl.$viewValue;
	    $scope.onLeave();
	  };
	
	  $scope.onKeydown = function(evt) {
	    if (/(37|38|39|40)/.test(evt.which)) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
	    }
	  };
	
	  this.render = function() {
	    $scope.value = ngModelCtrl.$viewValue;
	  };
	}])
	
	.directive('uibRating', function() {
	  return {
	    require: ['uibRating', 'ngModel'],
	    scope: {
	      readonly: '=?',
	      onHover: '&',
	      onLeave: '&'
	    },
	    controller: 'UibRatingController',
	    templateUrl: 'template/rating/rating.html',
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	      ratingCtrl.init(ngModelCtrl);
	    }
	  };
	});
	
	/* Deprecated rating below */
	
	angular.module('ui.bootstrap.rating')
	
	.value('$ratingSuppressWarning', false)
	
	.controller('RatingController', ['$scope', '$attrs', '$controller', '$log', '$ratingSuppressWarning', function($scope, $attrs, $controller, $log, $ratingSuppressWarning) {
	  if (!$ratingSuppressWarning) {
	    $log.warn('RatingController is now deprecated. Use UibRatingController instead.');
	  }
	
	  angular.extend(this, $controller('UibRatingController', {
	    $scope: $scope,
	    $attrs: $attrs
	  }));
	}])
	
	.directive('rating', ['$log', '$ratingSuppressWarning', function($log, $ratingSuppressWarning) {
	  return {
	    require: ['rating', 'ngModel'],
	    scope: {
	      readonly: '=?',
	      onHover: '&',
	      onLeave: '&'
	    },
	    controller: 'RatingController',
	    templateUrl: 'template/rating/rating.html',
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      if (!$ratingSuppressWarning) {
	        $log.warn('rating is now deprecated. Use uib-rating instead.');
	      }
	      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	      ratingCtrl.init(ngModelCtrl);
	    }
	  };
	}]);
	
	
	/**
	 * @ngdoc overview
	 * @name ui.bootstrap.tabs
	 *
	 * @description
	 * AngularJS version of the tabs directive.
	 */
	
	angular.module('ui.bootstrap.tabs', [])
	
	.controller('UibTabsetController', ['$scope', function ($scope) {
	  var ctrl = this,
	      tabs = ctrl.tabs = $scope.tabs = [];
	
	  ctrl.select = function(selectedTab) {
	    angular.forEach(tabs, function(tab) {
	      if (tab.active && tab !== selectedTab) {
	        tab.active = false;
	        tab.onDeselect();
	        selectedTab.selectCalled = false;
	      }
	    });
	    selectedTab.active = true;
	    // only call select if it has not already been called
	    if (!selectedTab.selectCalled) {
	      selectedTab.onSelect();
	      selectedTab.selectCalled = true;
	    }
	  };
	
	  ctrl.addTab = function addTab(tab) {
	    tabs.push(tab);
	    // we can't run the select function on the first tab
	    // since that would select it twice
	    if (tabs.length === 1 && tab.active !== false) {
	      tab.active = true;
	    } else if (tab.active) {
	      ctrl.select(tab);
	    } else {
	      tab.active = false;
	    }
	  };
	
	  ctrl.removeTab = function removeTab(tab) {
	    var index = tabs.indexOf(tab);
	    //Select a new tab if the tab to be removed is selected and not destroyed
	    if (tab.active && tabs.length > 1 && !destroyed) {
	      //If this is the last tab, select the previous tab. else, the next tab.
	      var newActiveIndex = index == tabs.length - 1 ? index - 1 : index + 1;
	      ctrl.select(tabs[newActiveIndex]);
	    }
	    tabs.splice(index, 1);
	  };
	
	  var destroyed;
	  $scope.$on('$destroy', function() {
	    destroyed = true;
	  });
	}])
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.tabs.directive:tabset
	 * @restrict EA
	 *
	 * @description
	 * Tabset is the outer container for the tabs directive
	 *
	 * @param {boolean=} vertical Whether or not to use vertical styling for the tabs.
	 * @param {boolean=} justified Whether or not to use justified styling for the tabs.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <uib-tabset>
	      <uib-tab heading="Tab 1"><b>First</b> Content!</uib-tab>
	      <uib-tab heading="Tab 2"><i>Second</i> Content!</uib-tab>
	    </uib-tabset>
	    <hr />
	    <uib-tabset vertical="true">
	      <uib-tab heading="Vertical Tab 1"><b>First</b> Vertical Content!</uib-tab>
	      <uib-tab heading="Vertical Tab 2"><i>Second</i> Vertical Content!</uib-tab>
	    </uib-tabset>
	    <uib-tabset justified="true">
	      <uib-tab heading="Justified Tab 1"><b>First</b> Justified Content!</uib-tab>
	      <uib-tab heading="Justified Tab 2"><i>Second</i> Justified Content!</uib-tab>
	    </uib-tabset>
	  </file>
	</example>
	 */
	.directive('uibTabset', function() {
	  return {
	    restrict: 'EA',
	    transclude: true,
	    replace: true,
	    scope: {
	      type: '@'
	    },
	    controller: 'UibTabsetController',
	    templateUrl: 'template/tabs/tabset.html',
	    link: function(scope, element, attrs) {
	      scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
	      scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
	    }
	  };
	})
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.tabs.directive:tab
	 * @restrict EA
	 *
	 * @param {string=} heading The visible heading, or title, of the tab. Set HTML headings with {@link ui.bootstrap.tabs.directive:tabHeading tabHeading}.
	 * @param {string=} select An expression to evaluate when the tab is selected.
	 * @param {boolean=} active A binding, telling whether or not this tab is selected.
	 * @param {boolean=} disabled A binding, telling whether or not this tab is disabled.
	 *
	 * @description
	 * Creates a tab with a heading and content. Must be placed within a {@link ui.bootstrap.tabs.directive:tabset tabset}.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <div ng-controller="TabsDemoCtrl">
	      <button class="btn btn-small" ng-click="items[0].active = true">
	        Select item 1, using active binding
	      </button>
	      <button class="btn btn-small" ng-click="items[1].disabled = !items[1].disabled">
	        Enable/disable item 2, using disabled binding
	      </button>
	      <br />
	      <uib-tabset>
	        <uib-tab heading="Tab 1">First Tab</uib-tab>
	        <uib-tab select="alertMe()">
	          <uib-tab-heading><i class="icon-bell"></i> Alert me!</tab-heading>
	          Second Tab, with alert callback and html heading!
	        </uib-tab>
	        <uib-tab ng-repeat="item in items"
	          heading="{{item.title}}"
	          disabled="item.disabled"
	          active="item.active">
	          {{item.content}}
	        </uib-tab>
	      </uib-tabset>
	    </div>
	  </file>
	  <file name="script.js">
	    function TabsDemoCtrl($scope) {
	      $scope.items = [
	        { title:"Dynamic Title 1", content:"Dynamic Item 0" },
	        { title:"Dynamic Title 2", content:"Dynamic Item 1", disabled: true }
	      ];
	
	      $scope.alertMe = function() {
	        setTimeout(function() {
	          alert("You've selected the alert tab!");
	        });
	      };
	    };
	  </file>
	</example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.tabs.directive:tabHeading
	 * @restrict EA
	 *
	 * @description
	 * Creates an HTML heading for a {@link ui.bootstrap.tabs.directive:tab tab}. Must be placed as a child of a tab element.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <uib-tabset>
	      <uib-tab>
	        <uib-tab-heading><b>HTML</b> in my titles?!</tab-heading>
	        And some content, too!
	      </uib-tab>
	      <uib-tab>
	        <uib-tab-heading><i class="icon-heart"></i> Icon heading?!?</tab-heading>
	        That's right.
	      </uib-tab>
	    </uib-tabset>
	  </file>
	</example>
	 */
	.directive('uibTab', ['$parse', function($parse) {
	  return {
	    require: '^uibTabset',
	    restrict: 'EA',
	    replace: true,
	    templateUrl: 'template/tabs/tab.html',
	    transclude: true,
	    scope: {
	      active: '=?',
	      heading: '@',
	      onSelect: '&select', //This callback is called in contentHeadingTransclude
	                          //once it inserts the tab's content into the dom
	      onDeselect: '&deselect'
	    },
	    controller: function() {
	      //Empty controller so other directives can require being 'under' a tab
	    },
	    link: function(scope, elm, attrs, tabsetCtrl, transclude) {
	      scope.$watch('active', function(active) {
	        if (active) {
	          tabsetCtrl.select(scope);
	        }
	      });
	
	      scope.disabled = false;
	      if (attrs.disable) {
	        scope.$parent.$watch($parse(attrs.disable), function(value) {
	          scope.disabled = !! value;
	        });
	      }
	
	      scope.select = function() {
	        if (!scope.disabled) {
	          scope.active = true;
	        }
	      };
	
	      tabsetCtrl.addTab(scope);
	      scope.$on('$destroy', function() {
	        tabsetCtrl.removeTab(scope);
	      });
	
	      //We need to transclude later, once the content container is ready.
	      //when this link happens, we're inside a tab heading.
	      scope.$transcludeFn = transclude;
	    }
	  };
	}])
	
	.directive('uibTabHeadingTransclude', function() {
	  return {
	    restrict: 'A',
	    require: ['?^uibTab', '?^tab'], // TODO: change to '^uibTab' after deprecation removal
	    link: function(scope, elm) {
	      scope.$watch('headingElement', function updateHeadingElement(heading) {
	        if (heading) {
	          elm.html('');
	          elm.append(heading);
	        }
	      });
	    }
	  };
	})
	
	.directive('uibTabContentTransclude', function() {
	  return {
	    restrict: 'A',
	    require: ['?^uibTabset', '?^tabset'], // TODO: change to '^uibTabset' after deprecation removal
	    link: function(scope, elm, attrs) {
	      var tab = scope.$eval(attrs.uibTabContentTransclude);
	
	      //Now our tab is ready to be transcluded: both the tab heading area
	      //and the tab content area are loaded.  Transclude 'em both.
	      tab.$transcludeFn(tab.$parent, function(contents) {
	        angular.forEach(contents, function(node) {
	          if (isTabHeading(node)) {
	            //Let tabHeadingTransclude know.
	            tab.headingElement = node;
	          } else {
	            elm.append(node);
	          }
	        });
	      });
	    }
	  };
	
	  function isTabHeading(node) {
	    return node.tagName && (
	      node.hasAttribute('tab-heading') || // TODO: remove after deprecation removal
	      node.hasAttribute('data-tab-heading') || // TODO: remove after deprecation removal
	      node.hasAttribute('x-tab-heading') || // TODO: remove after deprecation removal
	      node.hasAttribute('uib-tab-heading') ||
	      node.hasAttribute('data-uib-tab-heading') ||
	      node.hasAttribute('x-uib-tab-heading') ||
	      node.tagName.toLowerCase() === 'tab-heading' || // TODO: remove after deprecation removal
	      node.tagName.toLowerCase() === 'data-tab-heading' || // TODO: remove after deprecation removal
	      node.tagName.toLowerCase() === 'x-tab-heading' || // TODO: remove after deprecation removal
	      node.tagName.toLowerCase() === 'uib-tab-heading' ||
	      node.tagName.toLowerCase() === 'data-uib-tab-heading' ||
	      node.tagName.toLowerCase() === 'x-uib-tab-heading'
	    );
	  }
	});
	
	/* deprecated tabs below */
	
	angular.module('ui.bootstrap.tabs')
	
	  .value('$tabsSuppressWarning', false)
	
	  .controller('TabsetController', ['$scope', '$controller', '$log', '$tabsSuppressWarning', function($scope, $controller, $log, $tabsSuppressWarning) {
	    if (!$tabsSuppressWarning) {
	      $log.warn('TabsetController is now deprecated. Use UibTabsetController instead.');
	    }
	
	    angular.extend(this, $controller('UibTabsetController', {
	      $scope: $scope
	    }));
	  }])
	
	  .directive('tabset', ['$log', '$tabsSuppressWarning', function($log, $tabsSuppressWarning) {
	    return {
	      restrict: 'EA',
	      transclude: true,
	      replace: true,
	      scope: {
	        type: '@'
	      },
	      controller: 'TabsetController',
	      templateUrl: 'template/tabs/tabset.html',
	      link: function(scope, element, attrs) {
	
	        if (!$tabsSuppressWarning) {
	          $log.warn('tabset is now deprecated. Use uib-tabset instead.');
	        }
	        scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
	        scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
	      }
	    };
	  }])
	
	  .directive('tab', ['$parse', '$log', '$tabsSuppressWarning', function($parse, $log, $tabsSuppressWarning) {
	    return {
	      require: '^tabset',
	      restrict: 'EA',
	      replace: true,
	      templateUrl: 'template/tabs/tab.html',
	      transclude: true,
	      scope: {
	        active: '=?',
	        heading: '@',
	        onSelect: '&select', //This callback is called in contentHeadingTransclude
	        //once it inserts the tab's content into the dom
	        onDeselect: '&deselect'
	      },
	      controller: function() {
	        //Empty controller so other directives can require being 'under' a tab
	      },
	      link: function(scope, elm, attrs, tabsetCtrl, transclude) {
	        if (!$tabsSuppressWarning) {
	          $log.warn('tab is now deprecated. Use uib-tab instead.');
	        }
	
	        scope.$watch('active', function(active) {
	          if (active) {
	            tabsetCtrl.select(scope);
	          }
	        });
	
	        scope.disabled = false;
	        if (attrs.disable) {
	          scope.$parent.$watch($parse(attrs.disable), function(value) {
	            scope.disabled = !!value;
	          });
	        }
	
	        scope.select = function() {
	          if (!scope.disabled) {
	            scope.active = true;
	          }
	        };
	
	        tabsetCtrl.addTab(scope);
	        scope.$on('$destroy', function() {
	          tabsetCtrl.removeTab(scope);
	        });
	
	        //We need to transclude later, once the content container is ready.
	        //when this link happens, we're inside a tab heading.
	        scope.$transcludeFn = transclude;
	      }
	    };
	  }])
	
	  .directive('tabHeadingTransclude', ['$log', '$tabsSuppressWarning', function($log, $tabsSuppressWarning) {
	    return {
	      restrict: 'A',
	      require: '^tab',
	      link: function(scope, elm) {
	        if (!$tabsSuppressWarning) {
	          $log.warn('tab-heading-transclude is now deprecated. Use uib-tab-heading-transclude instead.');
	        }
	
	        scope.$watch('headingElement', function updateHeadingElement(heading) {
	          if (heading) {
	            elm.html('');
	            elm.append(heading);
	          }
	        });
	      }
	    };
	  }])
	
	  .directive('tabContentTransclude', ['$log', '$tabsSuppressWarning', function($log, $tabsSuppressWarning) {
	    return {
	      restrict: 'A',
	      require: '^tabset',
	      link: function(scope, elm, attrs) {
	        if (!$tabsSuppressWarning) {
	          $log.warn('tab-content-transclude is now deprecated. Use uib-tab-content-transclude instead.');
	        }
	
	        var tab = scope.$eval(attrs.tabContentTransclude);
	
	        //Now our tab is ready to be transcluded: both the tab heading area
	        //and the tab content area are loaded.  Transclude 'em both.
	        tab.$transcludeFn(tab.$parent, function(contents) {
	          angular.forEach(contents, function(node) {
	            if (isTabHeading(node)) {
	              //Let tabHeadingTransclude know.
	              tab.headingElement = node;
	            }
	            else {
	              elm.append(node);
	            }
	          });
	        });
	      }
	    };
	
	    function isTabHeading(node) {
	      return node.tagName && (
	          node.hasAttribute('tab-heading') ||
	          node.hasAttribute('data-tab-heading') ||
	          node.hasAttribute('x-tab-heading') ||
	          node.tagName.toLowerCase() === 'tab-heading' ||
	          node.tagName.toLowerCase() === 'data-tab-heading' ||
	          node.tagName.toLowerCase() === 'x-tab-heading'
	        );
	    }
	  }]);
	
	angular.module('ui.bootstrap.timepicker', [])
	
	.constant('uibTimepickerConfig', {
	  hourStep: 1,
	  minuteStep: 1,
	  showMeridian: true,
	  meridians: null,
	  readonlyInput: false,
	  mousewheel: true,
	  arrowkeys: true,
	  showSpinners: true
	})
	
	.controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
	  var selected = new Date(),
	      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
	      meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS;
	
	  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
	  $element.removeAttr('tabindex');
	
	  this.init = function(ngModelCtrl_, inputs) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    ngModelCtrl.$formatters.unshift(function(modelValue) {
	      return modelValue ? new Date(modelValue) : null;
	    });
	
	    var hoursInputEl = inputs.eq(0),
	        minutesInputEl = inputs.eq(1);
	
	    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;
	    if (mousewheel) {
	      this.setupMousewheelEvents(hoursInputEl, minutesInputEl);
	    }
	
	    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
	    if (arrowkeys) {
	      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl);
	    }
	
	    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
	    this.setupInputEvents(hoursInputEl, minutesInputEl);
	  };
	
	  var hourStep = timepickerConfig.hourStep;
	  if ($attrs.hourStep) {
	    $scope.$parent.$watch($parse($attrs.hourStep), function(value) {
	      hourStep = parseInt(value, 10);
	    });
	  }
	
	  var minuteStep = timepickerConfig.minuteStep;
	  if ($attrs.minuteStep) {
	    $scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
	      minuteStep = parseInt(value, 10);
	    });
	  }
	
	  var min;
	  $scope.$parent.$watch($parse($attrs.min), function(value) {
	    var dt = new Date(value);
	    min = isNaN(dt) ? undefined : dt;
	  });
	
	  var max;
	  $scope.$parent.$watch($parse($attrs.max), function(value) {
	    var dt = new Date(value);
	    max = isNaN(dt) ? undefined : dt;
	  });
	
	  $scope.noIncrementHours = function() {
	    var incrementedSelected = addMinutes(selected, hourStep * 60);
	    return incrementedSelected > max ||
	      (incrementedSelected < selected && incrementedSelected < min);
	  };
	
	  $scope.noDecrementHours = function() {
	    var decrementedSelected = addMinutes(selected, -hourStep * 60);
	    return decrementedSelected < min ||
	      (decrementedSelected > selected && decrementedSelected > max);
	  };
	
	  $scope.noIncrementMinutes = function() {
	    var incrementedSelected = addMinutes(selected, minuteStep);
	    return incrementedSelected > max ||
	      (incrementedSelected < selected && incrementedSelected < min);
	  };
	
	  $scope.noDecrementMinutes = function() {
	    var decrementedSelected = addMinutes(selected, -minuteStep);
	    return decrementedSelected < min ||
	      (decrementedSelected > selected && decrementedSelected > max);
	  };
	
	  $scope.noToggleMeridian = function() {
	    if (selected.getHours() < 13) {
	      return addMinutes(selected, 12 * 60) > max;
	    } else {
	      return addMinutes(selected, -12 * 60) < min;
	    }
	  };
	
	  // 12H / 24H mode
	  $scope.showMeridian = timepickerConfig.showMeridian;
	  if ($attrs.showMeridian) {
	    $scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
	      $scope.showMeridian = !!value;
	
	      if (ngModelCtrl.$error.time) {
	        // Evaluate from template
	        var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
	        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	          selected.setHours(hours);
	          refresh();
	        }
	      } else {
	        updateTemplate();
	      }
	    });
	  }
	
	  // Get $scope.hours in 24H mode if valid
	  function getHoursFromTemplate() {
	    var hours = parseInt($scope.hours, 10);
	    var valid = $scope.showMeridian ? (hours > 0 && hours < 13) : (hours >= 0 && hours < 24);
	    if (!valid) {
	      return undefined;
	    }
	
	    if ($scope.showMeridian) {
	      if (hours === 12) {
	        hours = 0;
	      }
	      if ($scope.meridian === meridians[1]) {
	        hours = hours + 12;
	      }
	    }
	    return hours;
	  }
	
	  function getMinutesFromTemplate() {
	    var minutes = parseInt($scope.minutes, 10);
	    return (minutes >= 0 && minutes < 60) ? minutes : undefined;
	  }
	
	  function pad(value) {
	    return (angular.isDefined(value) && value.toString().length < 2) ? '0' + value : value.toString();
	  }
	
	  // Respond on mousewheel spin
	  this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl) {
	    var isScrollingUp = function(e) {
	      if (e.originalEvent) {
	        e = e.originalEvent;
	      }
	      //pick correct delta variable depending on event
	      var delta = (e.wheelDelta) ? e.wheelDelta : -e.deltaY;
	      return (e.detail || delta > 0);
	    };
	
	    hoursInputEl.bind('mousewheel wheel', function(e) {
	      $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
	      e.preventDefault();
	    });
	
	    minutesInputEl.bind('mousewheel wheel', function(e) {
	      $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
	      e.preventDefault();
	    });
	
	  };
	
	  // Respond on up/down arrowkeys
	  this.setupArrowkeyEvents = function(hoursInputEl, minutesInputEl) {
	    hoursInputEl.bind('keydown', function(e) {
	      if (e.which === 38) { // up
	        e.preventDefault();
	        $scope.incrementHours();
	        $scope.$apply();
	      } else if (e.which === 40) { // down
	        e.preventDefault();
	        $scope.decrementHours();
	        $scope.$apply();
	      }
	    });
	
	    minutesInputEl.bind('keydown', function(e) {
	      if (e.which === 38) { // up
	        e.preventDefault();
	        $scope.incrementMinutes();
	        $scope.$apply();
	      } else if (e.which === 40) { // down
	        e.preventDefault();
	        $scope.decrementMinutes();
	        $scope.$apply();
	      }
	    });
	  };
	
	  this.setupInputEvents = function(hoursInputEl, minutesInputEl) {
	    if ($scope.readonlyInput) {
	      $scope.updateHours = angular.noop;
	      $scope.updateMinutes = angular.noop;
	      return;
	    }
	
	    var invalidate = function(invalidHours, invalidMinutes) {
	      ngModelCtrl.$setViewValue(null);
	      ngModelCtrl.$setValidity('time', false);
	      if (angular.isDefined(invalidHours)) {
	        $scope.invalidHours = invalidHours;
	      }
	      if (angular.isDefined(invalidMinutes)) {
	        $scope.invalidMinutes = invalidMinutes;
	      }
	    };
	
	    $scope.updateHours = function() {
	      var hours = getHoursFromTemplate(),
	        minutes = getMinutesFromTemplate();
	
	      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	        selected.setHours(hours);
	        if (selected < min || selected > max) {
	          invalidate(true);
	        } else {
	          refresh('h');
	        }
	      } else {
	        invalidate(true);
	      }
	    };
	
	    hoursInputEl.bind('blur', function(e) {
	      if (!$scope.invalidHours && $scope.hours < 10) {
	        $scope.$apply(function() {
	          $scope.hours = pad($scope.hours);
	        });
	      }
	    });
	
	    $scope.updateMinutes = function() {
	      var minutes = getMinutesFromTemplate(),
	        hours = getHoursFromTemplate();
	
	      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	        selected.setMinutes(minutes);
	        if (selected < min || selected > max) {
	          invalidate(undefined, true);
	        } else {
	          refresh('m');
	        }
	      } else {
	        invalidate(undefined, true);
	      }
	    };
	
	    minutesInputEl.bind('blur', function(e) {
	      if (!$scope.invalidMinutes && $scope.minutes < 10) {
	        $scope.$apply(function() {
	          $scope.minutes = pad($scope.minutes);
	        });
	      }
	    });
	
	  };
	
	  this.render = function() {
	    var date = ngModelCtrl.$viewValue;
	
	    if (isNaN(date)) {
	      ngModelCtrl.$setValidity('time', false);
	      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	    } else {
	      if (date) {
	        selected = date;
	      }
	
	      if (selected < min || selected > max) {
	        ngModelCtrl.$setValidity('time', false);
	        $scope.invalidHours = true;
	        $scope.invalidMinutes = true;
	      } else {
	        makeValid();
	      }
	      updateTemplate();
	    }
	  };
	
	  // Call internally when we know that model is valid.
	  function refresh(keyboardChange) {
	    makeValid();
	    ngModelCtrl.$setViewValue(new Date(selected));
	    updateTemplate(keyboardChange);
	  }
	
	  function makeValid() {
	    ngModelCtrl.$setValidity('time', true);
	    $scope.invalidHours = false;
	    $scope.invalidMinutes = false;
	  }
	
	  function updateTemplate(keyboardChange) {
	    var hours = selected.getHours(), minutes = selected.getMinutes();
	
	    if ($scope.showMeridian) {
	      hours = (hours === 0 || hours === 12) ? 12 : hours % 12; // Convert 24 to 12 hour system
	    }
	
	    $scope.hours = keyboardChange === 'h' ? hours : pad(hours);
	    if (keyboardChange !== 'm') {
	      $scope.minutes = pad(minutes);
	    }
	    $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	  }
	
	  function addMinutes(date, minutes) {
	    var dt = new Date(date.getTime() + minutes * 60000);
	    var newDate = new Date(date);
	    newDate.setHours(dt.getHours(), dt.getMinutes());
	    return newDate;
	  }
	
	  function addMinutesToSelected(minutes) {
	    selected = addMinutes(selected, minutes);
	    refresh();
	  }
	
	  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
	    $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;
	
	  $scope.incrementHours = function() {
	    if (!$scope.noIncrementHours()) {
	      addMinutesToSelected(hourStep * 60);
	    }
	  };
	
	  $scope.decrementHours = function() {
	    if (!$scope.noDecrementHours()) {
	      addMinutesToSelected(-hourStep * 60);
	    }
	  };
	
	  $scope.incrementMinutes = function() {
	    if (!$scope.noIncrementMinutes()) {
	      addMinutesToSelected(minuteStep);
	    }
	  };
	
	  $scope.decrementMinutes = function() {
	    if (!$scope.noDecrementMinutes()) {
	      addMinutesToSelected(-minuteStep);
	    }
	  };
	
	  $scope.toggleMeridian = function() {
	    if (!$scope.noToggleMeridian()) {
	      addMinutesToSelected(12 * 60 * (selected.getHours() < 12 ? 1 : -1));
	    }
	  };
	}])
	
	.directive('uibTimepicker', function() {
	  return {
	    restrict: 'EA',
	    require: ['uibTimepicker', '?^ngModel'],
	    controller: 'UibTimepickerController',
	    controllerAs: 'timepicker',
	    replace: true,
	    scope: {},
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/timepicker/timepicker.html';
	    },
	    link: function(scope, element, attrs, ctrls) {
	      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (ngModelCtrl) {
	        timepickerCtrl.init(ngModelCtrl, element.find('input'));
	      }
	    }
	  };
	});
	
	/* Deprecated timepicker below */
	
	angular.module('ui.bootstrap.timepicker')
	
	.value('$timepickerSuppressWarning', false)
	
	.controller('TimepickerController', ['$scope', '$element', '$attrs', '$controller', '$log', '$timepickerSuppressWarning', function($scope, $element, $attrs, $controller, $log, $timepickerSuppressWarning) {
	  if (!$timepickerSuppressWarning) {
	    $log.warn('TimepickerController is now deprecated. Use UibTimepickerController instead.');
	  }
	
	  angular.extend(this, $controller('UibTimepickerController', {
	    $scope: $scope,
	    $element: $element,
	    $attrs: $attrs
	  }));
	}])
	
	.directive('timepicker', ['$log', '$timepickerSuppressWarning', function($log, $timepickerSuppressWarning) {
	  return {
	    restrict: 'EA',
	    require: ['timepicker', '?^ngModel'],
	    controller: 'TimepickerController',
	    controllerAs: 'timepicker',
	    replace: true,
	    scope: {},
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/timepicker/timepicker.html';
	    },
	    link: function(scope, element, attrs, ctrls) {
	      if (!$timepickerSuppressWarning) {
	        $log.warn('timepicker is now deprecated. Use uib-timepicker instead.');
	      }
	      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (ngModelCtrl) {
	        timepickerCtrl.init(ngModelCtrl, element.find('input'));
	      }
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.position'])
	
	/**
	 * A helper service that can parse typeahead's syntax (string provided by users)
	 * Extracted to a separate service for ease of unit testing
	 */
	  .factory('uibTypeaheadParser', ['$parse', function($parse) {
	    //                      00000111000000000000022200000000000000003333333333333330000000000044000
	    var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
	    return {
	      parse: function(input) {
	        var match = input.match(TYPEAHEAD_REGEXP);
	        if (!match) {
	          throw new Error(
	            'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
	              ' but got "' + input + '".');
	        }
	
	        return {
	          itemName: match[3],
	          source: $parse(match[4]),
	          viewMapper: $parse(match[2] || match[1]),
	          modelMapper: $parse(match[1])
	        };
	      }
	    };
	  }])
	
	  .controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$uibPosition', 'uibTypeaheadParser',
	    function(originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $position, typeaheadParser) {
	    var HOT_KEYS = [9, 13, 27, 38, 40];
	    var eventDebounceTime = 200;
	    var modelCtrl, ngModelOptions;
	    //SUPPORTED ATTRIBUTES (OPTIONS)
	
	    //minimal no of characters that needs to be entered before typeahead kicks-in
	    var minLength = originalScope.$eval(attrs.typeaheadMinLength);
	    if (!minLength && minLength !== 0) {
	      minLength = 1;
	    }
	
	    //minimal wait time after last character typed before typeahead kicks-in
	    var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;
	
	    //should it restrict model values to the ones selected from the popup only?
	    var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
	
	    //binding to a variable that indicates if matches are being retrieved asynchronously
	    var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;
	
	    //a callback executed when a match is selected
	    var onSelectCallback = $parse(attrs.typeaheadOnSelect);
	
	    //should it select highlighted popup value when losing focus?
	    var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;
	
	    //binding to a variable that indicates if there were no results after the query is completed
	    var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;
	
	    var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;
	
	    var appendToBody =  attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;
	
	    var appendToElementId =  attrs.typeaheadAppendToElementId || false;
	
	    var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;
	
	    //If input matches an item of the list exactly, select it automatically
	    var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;
	
	    //INTERNAL VARIABLES
	
	    //model setter executed upon match selection
	    var parsedModel = $parse(attrs.ngModel);
	    var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
	    var $setModelValue = function(scope, newValue) {
	      if (angular.isFunction(parsedModel(originalScope)) &&
	        ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) {
	        return invokeModelSetter(scope, {$$$p: newValue});
	      } else {
	        return parsedModel.assign(scope, newValue);
	      }
	    };
	
	    //expressions used by typeahead
	    var parserResult = typeaheadParser.parse(attrs.uibTypeahead);
	
	    var hasFocus;
	
	    //Used to avoid bug in iOS webview where iOS keyboard does not fire
	    //mousedown & mouseup events
	    //Issue #3699
	    var selected;
	
	    //create a child scope for the typeahead directive so we are not polluting original scope
	    //with typeahead-specific data (matches, query etc.)
	    var scope = originalScope.$new();
	    var offDestroy = originalScope.$on('$destroy', function() {
	      scope.$destroy();
	    });
	    scope.$on('$destroy', offDestroy);
	
	    // WAI-ARIA
	    var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	    element.attr({
	      'aria-autocomplete': 'list',
	      'aria-expanded': false,
	      'aria-owns': popupId
	    });
	
	    //pop-up element used to display matches
	    var popUpEl = angular.element('<div uib-typeahead-popup></div>');
	    popUpEl.attr({
	      id: popupId,
	      matches: 'matches',
	      active: 'activeIdx',
	      select: 'select(activeIdx)',
	      'move-in-progress': 'moveInProgress',
	      query: 'query',
	      position: 'position'
	    });
	    //custom item template
	    if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
	      popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
	    }
	
	    if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
	      popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
	    }
	
	    var resetMatches = function() {
	      scope.matches = [];
	      scope.activeIdx = -1;
	      element.attr('aria-expanded', false);
	    };
	
	    var getMatchId = function(index) {
	      return popupId + '-option-' + index;
	    };
	
	    // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
	    // This attribute is added or removed automatically when the `activeIdx` changes.
	    scope.$watch('activeIdx', function(index) {
	      if (index < 0) {
	        element.removeAttr('aria-activedescendant');
	      } else {
	        element.attr('aria-activedescendant', getMatchId(index));
	      }
	    });
	
	    var inputIsExactMatch = function(inputValue, index) {
	      if (scope.matches.length > index && inputValue) {
	        return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
	      }
	
	      return false;
	    };
	
	    var getMatchesAsync = function(inputValue) {
	      var locals = {$viewValue: inputValue};
	      isLoadingSetter(originalScope, true);
	      isNoResultsSetter(originalScope, false);
	      $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
	        //it might happen that several async queries were in progress if a user were typing fast
	        //but we are interested only in responses that correspond to the current view value
	        var onCurrentRequest = (inputValue === modelCtrl.$viewValue);
	        if (onCurrentRequest && hasFocus) {
	          if (matches && matches.length > 0) {
	            scope.activeIdx = focusFirst ? 0 : -1;
	            isNoResultsSetter(originalScope, false);
	            scope.matches.length = 0;
	
	            //transform labels
	            for (var i = 0; i < matches.length; i++) {
	              locals[parserResult.itemName] = matches[i];
	              scope.matches.push({
	                id: getMatchId(i),
	                label: parserResult.viewMapper(scope, locals),
	                model: matches[i]
	              });
	            }
	
	            scope.query = inputValue;
	            //position pop-up with matches - we need to re-calculate its position each time we are opening a window
	            //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
	            //due to other elements being rendered
	            recalculatePosition();
	
	            element.attr('aria-expanded', true);
	
	            //Select the single remaining option if user input matches
	            if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
	              scope.select(0);
	            }
	          } else {
	            resetMatches();
	            isNoResultsSetter(originalScope, true);
	          }
	        }
	        if (onCurrentRequest) {
	          isLoadingSetter(originalScope, false);
	        }
	      }, function() {
	        resetMatches();
	        isLoadingSetter(originalScope, false);
	        isNoResultsSetter(originalScope, true);
	      });
	    };
	
	    // bind events only if appendToBody params exist - performance feature
	    if (appendToBody) {
	      angular.element($window).bind('resize', fireRecalculating);
	      $document.find('body').bind('scroll', fireRecalculating);
	    }
	
	    // Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
	    var timeoutEventPromise;
	
	    // Default progress type
	    scope.moveInProgress = false;
	
	    function fireRecalculating() {
	      if (!scope.moveInProgress) {
	        scope.moveInProgress = true;
	        scope.$digest();
	      }
	
	      // Cancel previous timeout
	      if (timeoutEventPromise) {
	        $timeout.cancel(timeoutEventPromise);
	      }
	
	      // Debounced executing recalculate after events fired
	      timeoutEventPromise = $timeout(function() {
	        // if popup is visible
	        if (scope.matches.length) {
	          recalculatePosition();
	        }
	
	        scope.moveInProgress = false;
	      }, eventDebounceTime);
	    }
	
	    // recalculate actual position and set new values to scope
	    // after digest loop is popup in right position
	    function recalculatePosition() {
	      scope.position = appendToBody ? $position.offset(element) : $position.position(element);
	      scope.position.top += element.prop('offsetHeight');
	    }
	
	    //we need to propagate user's query so we can higlight matches
	    scope.query = undefined;
	
	    //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
	    var timeoutPromise;
	
	    var scheduleSearchWithTimeout = function(inputValue) {
	      timeoutPromise = $timeout(function() {
	        getMatchesAsync(inputValue);
	      }, waitTime);
	    };
	
	    var cancelPreviousTimeout = function() {
	      if (timeoutPromise) {
	        $timeout.cancel(timeoutPromise);
	      }
	    };
	
	    resetMatches();
	
	    scope.select = function(activeIdx) {
	      //called from within the $digest() cycle
	      var locals = {};
	      var model, item;
	
	      selected = true;
	      locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
	      model = parserResult.modelMapper(originalScope, locals);
	      $setModelValue(originalScope, model);
	      modelCtrl.$setValidity('editable', true);
	      modelCtrl.$setValidity('parse', true);
	
	      onSelectCallback(originalScope, {
	        $item: item,
	        $model: model,
	        $label: parserResult.viewMapper(originalScope, locals)
	      });
	
	      resetMatches();
	
	      //return focus to the input element if a match was selected via a mouse click event
	      // use timeout to avoid $rootScope:inprog error
	      if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
	        $timeout(function() { element[0].focus(); }, 0, false);
	      }
	    };
	
	    //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
	    element.bind('keydown', function(evt) {
	      //typeahead is open and an "interesting" key was pressed
	      if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
	        return;
	      }
	
	      // if there's nothing selected (i.e. focusFirst) and enter or tab is hit, clear the results
	      if (scope.activeIdx === -1 && (evt.which === 9 || evt.which === 13)) {
	        resetMatches();
	        scope.$digest();
	        return;
	      }
	
	      evt.preventDefault();
	
	      if (evt.which === 40) {
	        scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
	        scope.$digest();
	      } else if (evt.which === 38) {
	        scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
	        scope.$digest();
	      } else if (evt.which === 13 || evt.which === 9) {
	        scope.$apply(function () {
	          scope.select(scope.activeIdx);
	        });
	      } else if (evt.which === 27) {
	        evt.stopPropagation();
	
	        resetMatches();
	        scope.$digest();
	      }
	    });
	
	    element.bind('blur', function() {
	      if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
	        selected = true;
	        scope.$apply(function() {
	          scope.select(scope.activeIdx);
	        });
	      }
	      hasFocus = false;
	      selected = false;
	    });
	
	    // Keep reference to click handler to unbind it.
	    var dismissClickHandler = function(evt) {
	      // Issue #3973
	      // Firefox treats right click as a click on document
	      if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
	        resetMatches();
	        if (!$rootScope.$$phase) {
	          scope.$digest();
	        }
	      }
	    };
	
	    $document.bind('click', dismissClickHandler);
	
	    originalScope.$on('$destroy', function() {
	      $document.unbind('click', dismissClickHandler);
	      if (appendToBody || appendToElementId) {
	        $popup.remove();
	      }
	
	      if (appendToBody) {
	        angular.element($window).unbind('resize', fireRecalculating);
	        $document.find('body').unbind('scroll', fireRecalculating);
	      }
	      // Prevent jQuery cache memory leak
	      popUpEl.remove();
	    });
	
	    var $popup = $compile(popUpEl)(scope);
	
	    if (appendToBody) {
	      $document.find('body').append($popup);
	    } else if (appendToElementId !== false) {
	      angular.element($document[0].getElementById(appendToElementId)).append($popup);
	    } else {
	      element.after($popup);
	    }
	
	    this.init = function(_modelCtrl, _ngModelOptions) {
	      modelCtrl = _modelCtrl;
	      ngModelOptions = _ngModelOptions;
	
	      //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
	      //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
	      modelCtrl.$parsers.unshift(function(inputValue) {
	        hasFocus = true;
	
	        if (minLength === 0 || inputValue && inputValue.length >= minLength) {
	          if (waitTime > 0) {
	            cancelPreviousTimeout();
	            scheduleSearchWithTimeout(inputValue);
	          } else {
	            getMatchesAsync(inputValue);
	          }
	        } else {
	          isLoadingSetter(originalScope, false);
	          cancelPreviousTimeout();
	          resetMatches();
	        }
	
	        if (isEditable) {
	          return inputValue;
	        } else {
	          if (!inputValue) {
	            // Reset in case user had typed something previously.
	            modelCtrl.$setValidity('editable', true);
	            return null;
	          } else {
	            modelCtrl.$setValidity('editable', false);
	            return undefined;
	          }
	        }
	      });
	
	      modelCtrl.$formatters.push(function(modelValue) {
	        var candidateViewValue, emptyViewValue;
	        var locals = {};
	
	        // The validity may be set to false via $parsers (see above) if
	        // the model is restricted to selected values. If the model
	        // is set manually it is considered to be valid.
	        if (!isEditable) {
	          modelCtrl.$setValidity('editable', true);
	        }
	
	        if (inputFormatter) {
	          locals.$model = modelValue;
	          return inputFormatter(originalScope, locals);
	        } else {
	          //it might happen that we don't have enough info to properly render input value
	          //we need to check for this situation and simply return model value if we can't apply custom formatting
	          locals[parserResult.itemName] = modelValue;
	          candidateViewValue = parserResult.viewMapper(originalScope, locals);
	          locals[parserResult.itemName] = undefined;
	          emptyViewValue = parserResult.viewMapper(originalScope, locals);
	
	          return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
	        }
	      });
	    };
	  }])
	
	  .directive('uibTypeahead', function() {
	    return {
	      controller: 'UibTypeaheadController',
	      require: ['ngModel', '^?ngModelOptions', 'uibTypeahead'],
	      link: function(originalScope, element, attrs, ctrls) {
	        ctrls[2].init(ctrls[0], ctrls[1]);
	      }
	    };
	  })
	
	  .directive('uibTypeaheadPopup', function() {
	    return {
	      scope: {
	        matches: '=',
	        query: '=',
	        active: '=',
	        position: '&',
	        moveInProgress: '=',
	        select: '&'
	      },
	      replace: true,
	      templateUrl: function(element, attrs) {
	        return attrs.popupTemplateUrl || 'template/typeahead/typeahead-popup.html';
	      },
	      link: function(scope, element, attrs) {
	        scope.templateUrl = attrs.templateUrl;
	
	        scope.isOpen = function() {
	          return scope.matches.length > 0;
	        };
	
	        scope.isActive = function(matchIdx) {
	          return scope.active == matchIdx;
	        };
	
	        scope.selectActive = function(matchIdx) {
	          scope.active = matchIdx;
	        };
	
	        scope.selectMatch = function(activeIdx) {
	          scope.select({activeIdx:activeIdx});
	        };
	      }
	    };
	  })
	
	  .directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function($templateRequest, $compile, $parse) {
	    return {
	      scope: {
	        index: '=',
	        match: '=',
	        query: '='
	      },
	      link:function(scope, element, attrs) {
	        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'template/typeahead/typeahead-match.html';
	        $templateRequest(tplUrl).then(function(tplContent) {
	          $compile(tplContent.trim())(scope, function(clonedElement) {
	            element.replaceWith(clonedElement);
	          });
	        });
	      }
	    };
	  }])
	
	  .filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function($sce, $injector, $log) {
	    var isSanitizePresent;
	    isSanitizePresent = $injector.has('$sanitize');
	
	    function escapeRegexp(queryToEscape) {
	      // Regex: capture the whole query string and replace it with the string that will be used to match
	      // the results, for example if the capture is "a" the result will be \a
	      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	    }
	
	    function containsHtml(matchItem) {
	      return /<.*>/g.test(matchItem);
	    }
	
	    return function(matchItem, query) {
	      if (!isSanitizePresent && containsHtml(matchItem)) {
	        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
	      }
	      matchItem = query? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
	      if (!isSanitizePresent) {
	        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
	      }
	      return matchItem;
	    };
	  }]);
	
	/* Deprecated typeahead below */
	  
	angular.module('ui.bootstrap.typeahead')
	  .value('$typeaheadSuppressWarning', false)
	  .service('typeaheadParser', ['$parse', 'uibTypeaheadParser', '$log', '$typeaheadSuppressWarning', function($parse, uibTypeaheadParser, $log, $typeaheadSuppressWarning) {
	    if (!$typeaheadSuppressWarning) {
	      $log.warn('typeaheadParser is now deprecated. Use uibTypeaheadParser instead.');
	    }
	
	    return uibTypeaheadParser;
	  }])
	
	  .directive('typeahead', ['$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$uibPosition', 'typeaheadParser', '$log', '$typeaheadSuppressWarning',
	    function($compile, $parse, $q, $timeout, $document, $window, $rootScope, $position, typeaheadParser, $log, $typeaheadSuppressWarning) {
	    var HOT_KEYS = [9, 13, 27, 38, 40];
	    var eventDebounceTime = 200;
	    return {
	      require: ['ngModel', '^?ngModelOptions'],
	      link: function(originalScope, element, attrs, ctrls) {
	        if (!$typeaheadSuppressWarning) {
	          $log.warn('typeahead is now deprecated. Use uib-typeahead instead.');
	        }
	        var modelCtrl = ctrls[0];
	        var ngModelOptions = ctrls[1];
	        //SUPPORTED ATTRIBUTES (OPTIONS)
	
	        //minimal no of characters that needs to be entered before typeahead kicks-in
	        var minLength = originalScope.$eval(attrs.typeaheadMinLength);
	        if (!minLength && minLength !== 0) {
	          minLength = 1;
	        }
	
	        //minimal wait time after last character typed before typeahead kicks-in
	        var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;
	
	        //should it restrict model values to the ones selected from the popup only?
	        var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
	
	        //binding to a variable that indicates if matches are being retrieved asynchronously
	        var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;
	
	        //a callback executed when a match is selected
	        var onSelectCallback = $parse(attrs.typeaheadOnSelect);
	
	        //should it select highlighted popup value when losing focus?
	        var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;
	
	        //binding to a variable that indicates if there were no results after the query is completed
	        var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;
	
	        var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;
	
	        var appendToBody =  attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;
	
	        var appendToElementId =  attrs.typeaheadAppendToElementId || false;
	
	        var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;
	
	        //If input matches an item of the list exactly, select it automatically
	        var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;
	
	        //INTERNAL VARIABLES
	
	        //model setter executed upon match selection
	        var parsedModel = $parse(attrs.ngModel);
	        var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
	        var $setModelValue = function(scope, newValue) {
	          if (angular.isFunction(parsedModel(originalScope)) &&
	            ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) {
	            return invokeModelSetter(scope, {$$$p: newValue});
	          } else {
	            return parsedModel.assign(scope, newValue);
	          }
	        };
	
	        //expressions used by typeahead
	        var parserResult = typeaheadParser.parse(attrs.typeahead);
	
	        var hasFocus;
	
	        //Used to avoid bug in iOS webview where iOS keyboard does not fire
	        //mousedown & mouseup events
	        //Issue #3699
	        var selected;
	
	        //create a child scope for the typeahead directive so we are not polluting original scope
	        //with typeahead-specific data (matches, query etc.)
	        var scope = originalScope.$new();
	        var offDestroy = originalScope.$on('$destroy', function() {
				    scope.$destroy();
	        });
	        scope.$on('$destroy', offDestroy);
	
	        // WAI-ARIA
	        var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	        element.attr({
	          'aria-autocomplete': 'list',
	          'aria-expanded': false,
	          'aria-owns': popupId
	        });
	
	        //pop-up element used to display matches
	        var popUpEl = angular.element('<div typeahead-popup></div>');
	        popUpEl.attr({
	          id: popupId,
	          matches: 'matches',
	          active: 'activeIdx',
	          select: 'select(activeIdx)',
	          'move-in-progress': 'moveInProgress',
	          query: 'query',
	          position: 'position'
	        });
	        //custom item template
	        if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
	          popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
	        }
	
	        if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
	          popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
	        }
	
	        var resetMatches = function() {
	          scope.matches = [];
	          scope.activeIdx = -1;
	          element.attr('aria-expanded', false);
	        };
	
	        var getMatchId = function(index) {
	          return popupId + '-option-' + index;
	        };
	
	        // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
	        // This attribute is added or removed automatically when the `activeIdx` changes.
	        scope.$watch('activeIdx', function(index) {
	          if (index < 0) {
	            element.removeAttr('aria-activedescendant');
	          } else {
	            element.attr('aria-activedescendant', getMatchId(index));
	          }
	        });
	
	        var inputIsExactMatch = function(inputValue, index) {
	          if (scope.matches.length > index && inputValue) {
	            return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
	          }
	
	          return false;
	        };
	
	        var getMatchesAsync = function(inputValue) {
	          var locals = {$viewValue: inputValue};
	          isLoadingSetter(originalScope, true);
	          isNoResultsSetter(originalScope, false);
	          $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
	            //it might happen that several async queries were in progress if a user were typing fast
	            //but we are interested only in responses that correspond to the current view value
	            var onCurrentRequest = (inputValue === modelCtrl.$viewValue);
	            if (onCurrentRequest && hasFocus) {
	              if (matches && matches.length > 0) {
	                scope.activeIdx = focusFirst ? 0 : -1;
	                isNoResultsSetter(originalScope, false);
	                scope.matches.length = 0;
	
	                //transform labels
	                for (var i = 0; i < matches.length; i++) {
	                  locals[parserResult.itemName] = matches[i];
	                  scope.matches.push({
	                    id: getMatchId(i),
	                    label: parserResult.viewMapper(scope, locals),
	                    model: matches[i]
	                  });
	                }
	
	                scope.query = inputValue;
	                //position pop-up with matches - we need to re-calculate its position each time we are opening a window
	                //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
	                //due to other elements being rendered
	                recalculatePosition();
	
	                element.attr('aria-expanded', true);
	
	                //Select the single remaining option if user input matches
	                if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
	                  scope.select(0);
	                }
	              } else {
	                resetMatches();
	                isNoResultsSetter(originalScope, true);
	              }
	            }
	            if (onCurrentRequest) {
	              isLoadingSetter(originalScope, false);
	            }
	          }, function() {
	            resetMatches();
	            isLoadingSetter(originalScope, false);
	            isNoResultsSetter(originalScope, true);
	          });
	        };
	
	        // bind events only if appendToBody params exist - performance feature
	        if (appendToBody) {
	          angular.element($window).bind('resize', fireRecalculating);
	          $document.find('body').bind('scroll', fireRecalculating);
	        }
	
	        // Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
	        var timeoutEventPromise;
	
	        // Default progress type
	        scope.moveInProgress = false;
	
	        function fireRecalculating() {
	          if (!scope.moveInProgress) {
	            scope.moveInProgress = true;
	            scope.$digest();
	          }
	
	          // Cancel previous timeout
	          if (timeoutEventPromise) {
	            $timeout.cancel(timeoutEventPromise);
	          }
	
	          // Debounced executing recalculate after events fired
	          timeoutEventPromise = $timeout(function() {
	            // if popup is visible
	            if (scope.matches.length) {
	              recalculatePosition();
	            }
	
	            scope.moveInProgress = false;
	          }, eventDebounceTime);
	        }
	
	        // recalculate actual position and set new values to scope
	        // after digest loop is popup in right position
	        function recalculatePosition() {
	          scope.position = appendToBody ? $position.offset(element) : $position.position(element);
	          scope.position.top += element.prop('offsetHeight');
	        }
	
	        resetMatches();
	
	        //we need to propagate user's query so we can higlight matches
	        scope.query = undefined;
	
	        //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
	        var timeoutPromise;
	
	        var scheduleSearchWithTimeout = function(inputValue) {
	          timeoutPromise = $timeout(function() {
	            getMatchesAsync(inputValue);
	          }, waitTime);
	        };
	
	        var cancelPreviousTimeout = function() {
	          if (timeoutPromise) {
	            $timeout.cancel(timeoutPromise);
	          }
	        };
	
	        //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
	        //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
	        modelCtrl.$parsers.unshift(function(inputValue) {
	          hasFocus = true;
	
	          if (minLength === 0 || inputValue && inputValue.length >= minLength) {
	            if (waitTime > 0) {
	              cancelPreviousTimeout();
	              scheduleSearchWithTimeout(inputValue);
	            } else {
	              getMatchesAsync(inputValue);
	            }
	          } else {
	            isLoadingSetter(originalScope, false);
	            cancelPreviousTimeout();
	            resetMatches();
	          }
	
	          if (isEditable) {
	            return inputValue;
	          } else {
	            if (!inputValue) {
	              // Reset in case user had typed something previously.
	              modelCtrl.$setValidity('editable', true);
	              return null;
	            } else {
	              modelCtrl.$setValidity('editable', false);
	              return undefined;
	            }
	          }
	        });
	
	        modelCtrl.$formatters.push(function(modelValue) {
	          var candidateViewValue, emptyViewValue;
	          var locals = {};
	
	          // The validity may be set to false via $parsers (see above) if
	          // the model is restricted to selected values. If the model
	          // is set manually it is considered to be valid.
	          if (!isEditable) {
	            modelCtrl.$setValidity('editable', true);
	          }
	
	          if (inputFormatter) {
	            locals.$model = modelValue;
	            return inputFormatter(originalScope, locals);
	          } else {
	            //it might happen that we don't have enough info to properly render input value
	            //we need to check for this situation and simply return model value if we can't apply custom formatting
	            locals[parserResult.itemName] = modelValue;
	            candidateViewValue = parserResult.viewMapper(originalScope, locals);
	            locals[parserResult.itemName] = undefined;
	            emptyViewValue = parserResult.viewMapper(originalScope, locals);
	
	            return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
	          }
	        });
	
	        scope.select = function(activeIdx) {
	          //called from within the $digest() cycle
	          var locals = {};
	          var model, item;
	
	          selected = true;
	          locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
	          model = parserResult.modelMapper(originalScope, locals);
	          $setModelValue(originalScope, model);
	          modelCtrl.$setValidity('editable', true);
	          modelCtrl.$setValidity('parse', true);
	
	          onSelectCallback(originalScope, {
	            $item: item,
	            $model: model,
	            $label: parserResult.viewMapper(originalScope, locals)
	          });
	
	          resetMatches();
	
	          //return focus to the input element if a match was selected via a mouse click event
	          // use timeout to avoid $rootScope:inprog error
	          if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
	            $timeout(function() { element[0].focus(); }, 0, false);
	          }
	        };
	
	        //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
	        element.bind('keydown', function(evt) {
	          //typeahead is open and an "interesting" key was pressed
	          if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
	            return;
	          }
	
	          // if there's nothing selected (i.e. focusFirst) and enter or tab is hit, clear the results
	          if (scope.activeIdx === -1 && (evt.which === 9 || evt.which === 13)) {
	            resetMatches();
	            scope.$digest();
	            return;
	          }
	
	          evt.preventDefault();
	
	          if (evt.which === 40) {
	            scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
	            scope.$digest();
	          } else if (evt.which === 38) {
	            scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
	            scope.$digest();
	          } else if (evt.which === 13 || evt.which === 9) {
	            scope.$apply(function () {
	              scope.select(scope.activeIdx);
	            });
	          } else if (evt.which === 27) {
	            evt.stopPropagation();
	
	            resetMatches();
	            scope.$digest();
	          }
	        });
	
	        element.bind('blur', function() {
	          if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
	            selected = true;
	            scope.$apply(function() {
	              scope.select(scope.activeIdx);
	            });
	          }
	          hasFocus = false;
	          selected = false;
	        });
	
	        // Keep reference to click handler to unbind it.
	        var dismissClickHandler = function(evt) {
	          // Issue #3973
	          // Firefox treats right click as a click on document
	          if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
	            resetMatches();
	            if (!$rootScope.$$phase) {
	              scope.$digest();
	            }
	          }
	        };
	
	        $document.bind('click', dismissClickHandler);
	
	        originalScope.$on('$destroy', function() {
	          $document.unbind('click', dismissClickHandler);
	          if (appendToBody || appendToElementId) {
	            $popup.remove();
	          }
	
	          if (appendToBody) {
	            angular.element($window).unbind('resize', fireRecalculating);
	            $document.find('body').unbind('scroll', fireRecalculating);
	          }
	          // Prevent jQuery cache memory leak
	          popUpEl.remove();
	        });
	
	        var $popup = $compile(popUpEl)(scope);
	
	        if (appendToBody) {
	          $document.find('body').append($popup);
	        } else if (appendToElementId !== false) {
	          angular.element($document[0].getElementById(appendToElementId)).append($popup);
	        } else {
	          element.after($popup);
	        }
	      }
	    };
	  }])
	  
	  .directive('typeaheadPopup', ['$typeaheadSuppressWarning', '$log', function($typeaheadSuppressWarning, $log) {
	    return {
	      scope: {
	        matches: '=',
	        query: '=',
	        active: '=',
	        position: '&',
	        moveInProgress: '=',
	        select: '&'
	      },
	      replace: true,
	      templateUrl: function(element, attrs) {
	        return attrs.popupTemplateUrl || 'template/typeahead/typeahead-popup.html';
	      },
	      link: function(scope, element, attrs) {
	        
	        if (!$typeaheadSuppressWarning) {
	          $log.warn('typeahead-popup is now deprecated. Use uib-typeahead-popup instead.');
	        }
	        scope.templateUrl = attrs.templateUrl;
	
	        scope.isOpen = function() {
	          return scope.matches.length > 0;
	        };
	
	        scope.isActive = function(matchIdx) {
	          return scope.active == matchIdx;
	        };
	
	        scope.selectActive = function(matchIdx) {
	          scope.active = matchIdx;
	        };
	
	        scope.selectMatch = function(activeIdx) {
	          scope.select({activeIdx:activeIdx});
	        };
	      }
	    };
	  }])
	  
	  .directive('typeaheadMatch', ['$templateRequest', '$compile', '$parse', '$typeaheadSuppressWarning', '$log', function($templateRequest, $compile, $parse, $typeaheadSuppressWarning, $log) {
	    return {
	      restrict: 'EA',
	      scope: {
	        index: '=',
	        match: '=',
	        query: '='
	      },
	      link:function(scope, element, attrs) {
	        if (!$typeaheadSuppressWarning) {
	          $log.warn('typeahead-match is now deprecated. Use uib-typeahead-match instead.');
	        }
	
	        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'template/typeahead/typeahead-match.html';
	        $templateRequest(tplUrl).then(function(tplContent) {
	          $compile(tplContent.trim())(scope, function(clonedElement) {
	            element.replaceWith(clonedElement);
	          });
	        });
	      }
	    };
	  }])
	  
	  .filter('typeaheadHighlight', ['$sce', '$injector', '$log', '$typeaheadSuppressWarning', function($sce, $injector, $log, $typeaheadSuppressWarning) {
	    var isSanitizePresent;
	    isSanitizePresent = $injector.has('$sanitize');
	
	    function escapeRegexp(queryToEscape) {
	      // Regex: capture the whole query string and replace it with the string that will be used to match
	      // the results, for example if the capture is "a" the result will be \a
	      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	    }
	
	    function containsHtml(matchItem) {
	      return /<.*>/g.test(matchItem);
	    }
	
	    return function(matchItem, query) {
	      if (!$typeaheadSuppressWarning) {
	        $log.warn('typeaheadHighlight is now deprecated. Use uibTypeaheadHighlight instead.');
	      }
	
	      if (!isSanitizePresent && containsHtml(matchItem)) {
	        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
	      }
	
	      matchItem = query? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
	      if (!isSanitizePresent) {
	        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
	      }
	
	      return matchItem;
	    };
	  }]);
	
	angular.module("template/accordion/accordion-group.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/accordion/accordion-group.html",
	    "<div class=\"panel {{panelClass || 'panel-default'}}\">\n" +
	    "  <div class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
	    "    <h4 class=\"panel-title\">\n" +
	    "      <a href tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\"><span ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
	    "    </h4>\n" +
	    "  </div>\n" +
	    "  <div class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
	    "	  <div class=\"panel-body\" ng-transclude></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/accordion/accordion.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/accordion/accordion.html",
	    "<div class=\"panel-group\" ng-transclude></div>");
	}]);
	
	angular.module("template/alert/alert.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/alert/alert.html",
	    "<div class=\"alert\" ng-class=\"['alert-' + (type || 'warning'), closeable ? 'alert-dismissible' : null]\" role=\"alert\">\n" +
	    "    <button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
	    "        <span aria-hidden=\"true\">&times;</span>\n" +
	    "        <span class=\"sr-only\">Close</span>\n" +
	    "    </button>\n" +
	    "    <div ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/carousel/carousel.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/carousel/carousel.html",
	    "<div ng-mouseenter=\"pause()\" ng-mouseleave=\"play()\" class=\"carousel\" ng-swipe-right=\"prev()\" ng-swipe-left=\"next()\">\n" +
	    "  <div class=\"carousel-inner\" ng-transclude></div>\n" +
	    "  <a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-show=\"slides.length > 1\">\n" +
	    "    <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
	    "    <span class=\"sr-only\">previous</span>\n" +
	    "  </a>\n" +
	    "  <a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-show=\"slides.length > 1\">\n" +
	    "    <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
	    "    <span class=\"sr-only\">next</span>\n" +
	    "  </a>\n" +
	    "  <ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
	    "    <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" +
	    "      <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" +
	    "    </li>\n" +
	    "  </ol>\n" +
	    "</div>");
	}]);
	
	angular.module("template/carousel/slide.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/carousel/slide.html",
	    "<div ng-class=\"{\n" +
	    "    'active': active\n" +
	    "  }\" class=\"item text-center\" ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/datepicker.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/datepicker.html",
	    "<div ng-switch=\"datepickerMode\" role=\"application\" ng-keydown=\"keydown($event)\">\n" +
	    "  <uib-daypicker ng-switch-when=\"day\" tabindex=\"0\"></uib-daypicker>\n" +
	    "  <uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\"></uib-monthpicker>\n" +
	    "  <uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\"></uib-yearpicker>\n" +
	    "</div>");
	}]);
	
	angular.module("template/datepicker/day.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/day.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
	    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
	    "    </tr>\n" +
	    "    <tr>\n" +
	    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
	    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
	    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
	    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default btn-sm\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/month.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/month.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
	    "      <th><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
	    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/popup.html",
	    "<ul class=\"dropdown-menu\" dropdown-nested ng-if=\"isOpen\" style=\"display: block\" ng-style=\"{top: position.top+'px', left: position.left+'px'}\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
	    "	<li ng-transclude></li>\n" +
	    "	<li ng-if=\"showButtonBar\" style=\"padding:10px 9px 2px\">\n" +
	    "		<span class=\"btn-group pull-left\">\n" +
	    "			<button type=\"button\" class=\"btn btn-sm btn-info\" ng-click=\"select('today')\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
	    "			<button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"select(null)\">{{ getText('clear') }}</button>\n" +
	    "		</span>\n" +
	    "		<button type=\"button\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"close()\">{{ getText('close') }}</button>\n" +
	    "	</li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/year.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/year.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
	    "      <th colspan=\"3\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
	    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/modal/backdrop.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/modal/backdrop.html",
	    "<div uib-modal-animation-class=\"fade\"\n" +
	    "     modal-in-class=\"in\"\n" +
	    "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" +
	    "></div>\n" +
	    "");
	}]);
	
	angular.module("template/modal/window.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/modal/window.html",
	    "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\"\n" +
	    "    uib-modal-animation-class=\"fade\"\n" +
	    "    modal-in-class=\"in\"\n" +
	    "    ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\">\n" +
	    "    <div class=\"modal-dialog\" ng-class=\"size ? 'modal-' + size : ''\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/pagination/pager.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/pagination/pager.html",
	    "<ul class=\"pager\">\n" +
	    "  <li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" +
	    "  <li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	
	angular.module("template/pagination/pagination.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/pagination/pagination.html",
	    "<ul class=\"pagination\">\n" +
	    "  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\">{{::getText('first')}}</a></li>\n" +
	    "  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" +
	    "  <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\">{{page.text}}</a></li>\n" +
	    "  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" +
	    "  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\">{{::getText('last')}}</a></li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	
	angular.module("template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tooltip/tooltip-html-popup.html",
	    "<div\n" +
	    "  tooltip-animation-class=\"fade\"\n" +
	    "  uib-tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"tooltip-arrow\"></div>\n" +
	    "  <div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/tooltip/tooltip-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tooltip/tooltip-popup.html",
	    "<div\n" +
	    "  tooltip-animation-class=\"fade\"\n" +
	    "  uib-tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"tooltip-arrow\"></div>\n" +
	    "  <div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tooltip/tooltip-template-popup.html",
	    "<div\n" +
	    "  tooltip-animation-class=\"fade\"\n" +
	    "  uib-tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"tooltip-arrow\"></div>\n" +
	    "  <div class=\"tooltip-inner\"\n" +
	    "    uib-tooltip-template-transclude=\"contentExp()\"\n" +
	    "    tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/popover/popover-html.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/popover/popover-html.html",
	    "<div tooltip-animation-class=\"fade\"\n" +
	    "  uib-tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"arrow\"></div>\n" +
	    "\n" +
	    "  <div class=\"popover-inner\">\n" +
	    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
	    "      <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/popover/popover-template.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/popover/popover-template.html",
	    "<div tooltip-animation-class=\"fade\"\n" +
	    "  uib-tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"arrow\"></div>\n" +
	    "\n" +
	    "  <div class=\"popover-inner\">\n" +
	    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
	    "      <div class=\"popover-content\"\n" +
	    "        uib-tooltip-template-transclude=\"contentExp()\"\n" +
	    "        tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/popover/popover.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/popover/popover.html",
	    "<div tooltip-animation-class=\"fade\"\n" +
	    "  uib-tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"arrow\"></div>\n" +
	    "\n" +
	    "  <div class=\"popover-inner\">\n" +
	    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
	    "      <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/progressbar/bar.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/progressbar/bar.html",
	    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" style=\"min-width: 0;\" ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("template/progressbar/progress.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/progressbar/progress.html",
	    "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
	}]);
	
	angular.module("template/progressbar/progressbar.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/progressbar/progressbar.html",
	    "<div class=\"progress\">\n" +
	    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" style=\"min-width: 0;\" ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/rating/rating.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/rating/rating.html",
	    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\">\n" +
	    "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
	    "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\" aria-valuetext=\"{{r.title}}\"></i>\n" +
	    "</span>\n" +
	    "");
	}]);
	
	angular.module("template/tabs/tab.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tabs/tab.html",
	    "<li ng-class=\"{active: active, disabled: disabled}\">\n" +
	    "  <a href ng-click=\"select()\" uib-tab-heading-transclude>{{heading}}</a>\n" +
	    "</li>\n" +
	    "");
	}]);
	
	angular.module("template/tabs/tabset.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tabs/tabset.html",
	    "<div>\n" +
	    "  <ul class=\"nav nav-{{type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
	    "  <div class=\"tab-content\">\n" +
	    "    <div class=\"tab-pane\" \n" +
	    "         ng-repeat=\"tab in tabs\" \n" +
	    "         ng-class=\"{active: tab.active}\"\n" +
	    "         uib-tab-content-transclude=\"tab\">\n" +
	    "    </div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/timepicker/timepicker.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/timepicker/timepicker.html",
	    "<table>\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
	    "      <td><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td>&nbsp;</td>\n" +
	    "      <td><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td ng-show=\"showMeridian\"></td>\n" +
	    "    </tr>\n" +
	    "    <tr>\n" +
	    "      <td class=\"form-group\" ng-class=\"{'has-error': invalidHours}\">\n" +
	    "        <input style=\"width:50px;\" type=\"text\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\">\n" +
	    "      </td>\n" +
	    "      <td>:</td>\n" +
	    "      <td class=\"form-group\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
	    "        <input style=\"width:50px;\" type=\"text\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\">\n" +
	    "      </td>\n" +
	    "      <td ng-show=\"showMeridian\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" +
	    "    </tr>\n" +
	    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
	    "      <td><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td>&nbsp;</td>\n" +
	    "      <td><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td ng-show=\"showMeridian\"></td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/typeahead/typeahead-match.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/typeahead/typeahead-match.html",
	    "<a href tabindex=\"-1\" ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></a>\n" +
	    "");
	}]);
	
	angular.module("template/typeahead/typeahead-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/typeahead/typeahead-popup.html",
	    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" style=\"display: block;\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
	    "    <li ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.id}}\">\n" +
	    "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
	    "    </li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	!angular.$$csp() && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>');

/***/ },
/* 977 */
/***/ function(module, exports) {

	/**
	 * Checklist-model
	 * AngularJS directive for list of checkboxes
	 * https://github.com/vitalets/checklist-model
	 * License: MIT http://opensource.org/licenses/MIT
	 */
	
	angular.module('checklist-model', [])
	.directive('checklistModel', ['$parse', '$compile', function($parse, $compile) {
	  // contains
	  function contains(arr, item, comparator) {
	    if (angular.isArray(arr)) {
	      for (var i = arr.length; i--;) {
	        if (comparator(arr[i], item)) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  // add
	  function add(arr, item, comparator) {
	    arr = angular.isArray(arr) ? arr : [];
	      if(!contains(arr, item, comparator)) {
	          arr.push(item);
	      }
	    return arr;
	  }  
	
	  // remove
	  function remove(arr, item, comparator) {
	    if (angular.isArray(arr)) {
	      for (var i = arr.length; i--;) {
	        if (comparator(arr[i], item)) {
	          arr.splice(i, 1);
	          break;
	        }
	      }
	    }
	    return arr;
	  }
	
	  // http://stackoverflow.com/a/19228302/1458162
	  function postLinkFn(scope, elem, attrs) {
	     // exclude recursion, but still keep the model
	    var checklistModel = attrs.checklistModel;
	    attrs.$set("checklistModel", null);
	    // compile with `ng-model` pointing to `checked`
	    $compile(elem)(scope);
	    attrs.$set("checklistModel", checklistModel);
	
	    // getter / setter for original model
	    var getter = $parse(checklistModel);
	    var setter = getter.assign;
	    var checklistChange = $parse(attrs.checklistChange);
	
	    // value added to list
	    var value = attrs.checklistValue ? $parse(attrs.checklistValue)(scope.$parent) : attrs.value;
	
	
	    var comparator = angular.equals;
	
	    if (attrs.hasOwnProperty('checklistComparator')){
	      if (attrs.checklistComparator[0] == '.') {
	        var comparatorExpression = attrs.checklistComparator.substring(1);
	        comparator = function (a, b) {
	          return a[comparatorExpression] === b[comparatorExpression];
	        }
	        
	      } else {
	        comparator = $parse(attrs.checklistComparator)(scope.$parent);
	      }
	    }
	
	    // watch UI checked change
	    scope.$watch(attrs.ngModel, function(newValue, oldValue) {
	      if (newValue === oldValue) { 
	        return;
	      } 
	      var current = getter(scope.$parent);
	      if (angular.isFunction(setter)) {
	        if (newValue === true) {
	          setter(scope.$parent, add(current, value, comparator));
	        } else {
	          setter(scope.$parent, remove(current, value, comparator));
	        }
	      }
	
	      if (checklistChange) {
	        checklistChange(scope);
	      }
	    });
	    
	    // declare one function to be used for both $watch functions
	    function setChecked(newArr, oldArr) {
	        scope[attrs.ngModel] = contains(newArr, value, comparator);
	    }
	
	    // watch original model change
	    // use the faster $watchCollection method if it's available
	    if (angular.isFunction(scope.$parent.$watchCollection)) {
	        scope.$parent.$watchCollection(checklistModel, setChecked);
	    } else {
	        scope.$parent.$watch(checklistModel, setChecked, true);
	    }
	  }
	
	  return {
	    restrict: 'A',
	    priority: 1000,
	    terminal: true,
	    scope: true,
	    compile: function(tElement, tAttrs) {
	      if ((tElement[0].tagName !== 'INPUT' || tAttrs.type !== 'checkbox')
	          && (tElement[0].tagName !== 'MD-CHECKBOX')
	          && (!tAttrs.btnCheckbox)) {
	        throw 'checklist-model should be applied to `input[type="checkbox"]` or `md-checkbox`.';
	      }
	
	      if (!tAttrs.checklistValue && !tAttrs.value) {
	        throw 'You should provide `value` or `checklist-value`.';
	      }
	
	      // by default ngModel is 'checked', so we set it if not specified
	      if (!tAttrs.ngModel) {
	        // local scope var storing individual checkbox model
	        tAttrs.$set("ngModel", "checked");
	      }
	
	      return postLinkFn;
	    }
	  };
	}]);
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = "checklist-model";

/***/ },
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */,
/* 2206 */,
/* 2207 */,
/* 2208 */,
/* 2209 */,
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */,
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */,
/* 2227 */,
/* 2228 */,
/* 2229 */,
/* 2230 */,
/* 2231 */,
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */,
/* 2261 */,
/* 2262 */,
/* 2263 */,
/* 2264 */,
/* 2265 */,
/* 2266 */,
/* 2267 */,
/* 2268 */,
/* 2269 */,
/* 2270 */,
/* 2271 */,
/* 2272 */,
/* 2273 */,
/* 2274 */,
/* 2275 */,
/* 2276 */,
/* 2277 */,
/* 2278 */,
/* 2279 */,
/* 2280 */,
/* 2281 */,
/* 2282 */,
/* 2283 */,
/* 2284 */,
/* 2285 */,
/* 2286 */,
/* 2287 */,
/* 2288 */,
/* 2289 */,
/* 2290 */,
/* 2291 */,
/* 2292 */,
/* 2293 */,
/* 2294 */,
/* 2295 */,
/* 2296 */,
/* 2297 */,
/* 2298 */,
/* 2299 */,
/* 2300 */,
/* 2301 */,
/* 2302 */,
/* 2303 */,
/* 2304 */,
/* 2305 */,
/* 2306 */,
/* 2307 */,
/* 2308 */,
/* 2309 */,
/* 2310 */,
/* 2311 */,
/* 2312 */,
/* 2313 */,
/* 2314 */,
/* 2315 */,
/* 2316 */,
/* 2317 */,
/* 2318 */,
/* 2319 */,
/* 2320 */,
/* 2321 */,
/* 2322 */,
/* 2323 */,
/* 2324 */,
/* 2325 */,
/* 2326 */,
/* 2327 */,
/* 2328 */,
/* 2329 */,
/* 2330 */,
/* 2331 */,
/* 2332 */,
/* 2333 */,
/* 2334 */,
/* 2335 */,
/* 2336 */,
/* 2337 */,
/* 2338 */,
/* 2339 */,
/* 2340 */,
/* 2341 */,
/* 2342 */,
/* 2343 */,
/* 2344 */,
/* 2345 */,
/* 2346 */,
/* 2347 */,
/* 2348 */,
/* 2349 */,
/* 2350 */,
/* 2351 */,
/* 2352 */,
/* 2353 */,
/* 2354 */,
/* 2355 */,
/* 2356 */,
/* 2357 */,
/* 2358 */,
/* 2359 */,
/* 2360 */,
/* 2361 */,
/* 2362 */,
/* 2363 */,
/* 2364 */,
/* 2365 */,
/* 2366 */,
/* 2367 */,
/* 2368 */,
/* 2369 */,
/* 2370 */,
/* 2371 */,
/* 2372 */,
/* 2373 */,
/* 2374 */,
/* 2375 */,
/* 2376 */,
/* 2377 */,
/* 2378 */,
/* 2379 */,
/* 2380 */,
/* 2381 */,
/* 2382 */,
/* 2383 */,
/* 2384 */,
/* 2385 */,
/* 2386 */,
/* 2387 */,
/* 2388 */,
/* 2389 */,
/* 2390 */,
/* 2391 */,
/* 2392 */,
/* 2393 */,
/* 2394 */,
/* 2395 */,
/* 2396 */,
/* 2397 */,
/* 2398 */,
/* 2399 */,
/* 2400 */,
/* 2401 */,
/* 2402 */,
/* 2403 */,
/* 2404 */,
/* 2405 */,
/* 2406 */,
/* 2407 */,
/* 2408 */,
/* 2409 */,
/* 2410 */,
/* 2411 */,
/* 2412 */,
/* 2413 */,
/* 2414 */,
/* 2415 */,
/* 2416 */,
/* 2417 */,
/* 2418 */,
/* 2419 */,
/* 2420 */,
/* 2421 */,
/* 2422 */,
/* 2423 */,
/* 2424 */,
/* 2425 */,
/* 2426 */,
/* 2427 */,
/* 2428 */,
/* 2429 */,
/* 2430 */,
/* 2431 */,
/* 2432 */,
/* 2433 */,
/* 2434 */,
/* 2435 */,
/* 2436 */,
/* 2437 */,
/* 2438 */,
/* 2439 */,
/* 2440 */,
/* 2441 */,
/* 2442 */,
/* 2443 */,
/* 2444 */,
/* 2445 */,
/* 2446 */,
/* 2447 */,
/* 2448 */,
/* 2449 */,
/* 2450 */,
/* 2451 */,
/* 2452 */,
/* 2453 */,
/* 2454 */,
/* 2455 */,
/* 2456 */,
/* 2457 */,
/* 2458 */,
/* 2459 */,
/* 2460 */,
/* 2461 */,
/* 2462 */,
/* 2463 */,
/* 2464 */,
/* 2465 */,
/* 2466 */,
/* 2467 */,
/* 2468 */,
/* 2469 */,
/* 2470 */,
/* 2471 */,
/* 2472 */,
/* 2473 */,
/* 2474 */,
/* 2475 */,
/* 2476 */,
/* 2477 */,
/* 2478 */,
/* 2479 */,
/* 2480 */,
/* 2481 */,
/* 2482 */,
/* 2483 */,
/* 2484 */,
/* 2485 */,
/* 2486 */,
/* 2487 */,
/* 2488 */,
/* 2489 */,
/* 2490 */,
/* 2491 */,
/* 2492 */,
/* 2493 */,
/* 2494 */,
/* 2495 */,
/* 2496 */,
/* 2497 */,
/* 2498 */,
/* 2499 */,
/* 2500 */,
/* 2501 */,
/* 2502 */,
/* 2503 */,
/* 2504 */,
/* 2505 */,
/* 2506 */,
/* 2507 */,
/* 2508 */,
/* 2509 */,
/* 2510 */,
/* 2511 */,
/* 2512 */,
/* 2513 */,
/* 2514 */,
/* 2515 */,
/* 2516 */,
/* 2517 */,
/* 2518 */,
/* 2519 */,
/* 2520 */,
/* 2521 */,
/* 2522 */,
/* 2523 */,
/* 2524 */,
/* 2525 */,
/* 2526 */,
/* 2527 */,
/* 2528 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * angular-marked
	 * (c) 2014 J. Harshbarger
	 * Licensed MIT
	 */
	
	/* jshint undef: true, unused: true */
	/* global angular, marked */
	
	'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name index
	   *
	   * @description
	   * AngularJS Markdown using [marked](https://github.com/chjj/marked).
	   *
	   * ## Why?
	   *
	   * I wanted to use [marked](https://github.com/chjj/marked) instead of [showdown](https://github.com/coreyti/showdown) as used in [angular-markdown-directive](https://github.com/btford/angular-markdown-directive) as well as expose the option to globally set defaults.
	   *
	   * ## How?
	   *
	   * - {@link hc.marked.directive:marked As a directive}
	   * - {@link hc.marked.service:marked As a service}
	   * - {@link hc.marked.service:markedProvider Set default options}
	   *
	   * @example
	
	      Convert markdown to html at run time.  For example:
	
	      <example module="app">
	        <file name="example.html">
	          <form ng-controller="MainController">
	            Markdown:<br />
	            <textarea ng-model="my_markdown" cols="60" rows="5" class="span8"></textarea><br />
	            Output:<br />
	            <div marked="my_markdown" />
	          </form>
	        </file>
	        <file  name="example.js">
	          function MainController($scope) {
	            $scope.my_markdown = "*This* **is** [markdown](https://daringfireball.net/projects/markdown/)";
	          }
	          angular.module('app', ['hc.marked']).controller('MainController', MainController);
	        </file>
	      </example>
	
	    *
	    */
	
	    /**
	     * @ngdoc overview
	     * @name hc.marked
	     * @description # angular-marked (core module)
	       # Installation
	      First include angular-marked.js in your HTML:
	
	      ```js
	        <script src="angular-marked.js">
	      ```
	
	      Then load the module in your application by adding it as a dependency:
	
	      ```js
	      angular.module('yourApp', ['hc.marked']);
	      ```
	
	      With that you're ready to get started!
	     */
	
	module.exports = 'hc.marked';
	
	angular.module('hc.marked', [])
	
	    /**
	    * @ngdoc service
	    * @name hc.marked.service:marked
	    * @requires $window
	    * @description
	    * A reference to the [marked](https://github.com/chjj/marked) parser.
	    *
	    * @example
	    <example module="app">
	      <file name="example.html">
	        <div ng-controller="MainController">
	          html: {{html}}
	        </div>
	      </file>
	      <file  name="example.js">
	        function MainController($scope, marked) {
	          $scope.html = marked('#TEST');
	        }
	        angular.module('app', ['hc.marked']).controller('MainController', MainController);
	      </file>
	    </example>
	   **/
	
	   /**
	   * @ngdoc service
	   * @name hc.marked.service:markedProvider
	   * @description
	   * Use `markedProvider` to change the default behavior of the {@link hc.marked.service:marked marked} service.
	   *
	   * @example
	
	    ## Example using [google-code-prettify syntax highlighter](https://code.google.com/p/google-code-prettify/) (must include google-code-prettify.js script).  Also works with [highlight.js Javascript syntax highlighter](http://highlightjs.org/).
	
	    <example module="myAppA">
	      <file name="exampleA.js">
	      angular.module('myAppA', ['hc.marked'])
	        .config(['markedProvider', function(markedProvider) {
	          markedProvider.setOptions({
	            gfm: true,
	            tables: true,
	            highlight: function (code) {
	              return prettyPrintOne(code);
	            }
	          });
	        }]);
	      </file>
	      <file name="exampleA.html">
	        <marked>
	        ```js
	        angular.module('myAppA', ['hc.marked'])
	          .config(['markedProvider', function(markedProvider) {
	            markedProvider.setOptions({
	              gfm: true,
	              tables: true,
	              highlight: function (code) {
	                return prettyPrintOne(code);
	              }
	            });
	          }]);
	        ```
	        </marked>
	      </file>
	    </example>
	
	    ## Example overriding the way custom markdown links are displayed
	
	    <example module="myAppB">
	      <file name="exampleB.js">
	      angular.module('myAppB', ['hc.marked'])
	        .config(['markedProvider', function(markedProvider) {
	          markedProvider.setRenderer({
	            link: function(href, title, text) {
	              return "<a href='" + href + "'" + (title ? " title='" + title + "'" : '') + " target='_blank'>" + text + "</a>";
	            }
	          });
	        }]);
	      </file>
	      <file name="exampleB.html">
	        <marked>
	          This is [an example](http://example.com/ "Title") inline link.
	          [This link](http://example.net/) has no title attribute.
	        </marked>
	      </file>
	    </example>
	  **/
	
	.provider('marked', function () {
	  var self = this;
	
	  /**
	   * @ngdoc method
	   * @name markedProvider#setRenderer
	   * @methodOf hc.marked.service:markedProvider
	   *
	   * @param {object} opts Default renderer options for [marked](https://github.com/chjj/marked#overriding-renderer-methods).
	   */
	
	  self.setRenderer = function (opts) {
	    this.renderer = opts;
	  };
	
	  /**
	   * @ngdoc method
	   * @name markedProvider#setOptions
	   * @methodOf hc.marked.service:markedProvider
	   *
	   * @param {object} opts Default options for [marked](https://github.com/chjj/marked#options-1).
	   */
	
	  self.setOptions = function (opts) {  // Store options for later
	    this.defaults = opts;
	  };
	
	  self.$get = ['$log', '$window', function ($log, $window) {
	    var m;
	
	    try {
	      m = __webpack_require__(2529);
	    } catch (e) {
	      m = $window.marked || marked;
	    }
	
	    if (angular.isUndefined(m)) {
	      $log.error('angular-marked Error: marked not loaded.  See installation instructions.');
	      return;
	    }
	
	    // override rendered markdown html
	    // with custom definitions if defined
	    if (self.renderer) {
	      var r = new m.Renderer();
	      var o = Object.keys(self.renderer);
	      var l = o.length;
	
	      while (l--) {
	        r[o[l]] = self.renderer[o[l]];
	      }
	
	      // add the new renderer to the options if need be
	      self.defaults = self.defaults || {};
	      self.defaults.renderer = r;
	    }
	
	    m.setOptions(self.defaults);
	
	    return m;
	  }];
	})
	
	  // TODO: filter and tests */
	  // app.filter('marked', ['marked', function(marked) {
	  //   return marked;
	  // }]);
	
	  /**
	   * @ngdoc directive
	   * @name hc.marked.directive:marked
	   * @restrict AE
	   * @element any
	   *
	   * @description
	   * Compiles source test into HTML.
	   *
	   * @param {expression=} marked The source text to be compiled.  If blank uses content as the source.
	   * @param {expression=} opts Hash of options that override defaults.
	   * @param {string=} src Expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	   *
	   * @example
	
	     ## A simple block of text
	
	      <example module="hc.marked">
	        <file name="exampleA.html">
	         * <marked>
	         *   ### Markdown directive
	         *
	         *   *It works!*
	         *
	         *   *This* **is** [markdown](https://daringfireball.net/projects/markdown/) in the view.
	         * </marked>
	        </file>
	      </example>
	
	     ## Bind to a scope variable
	
	      <example module="app">
	        <file name="exampleB.html">
	          <form ng-controller="MainController">
	            Markdown:<br />
	            <textarea ng-model="my_markdown" class="span8" cols="60" rows="5"></textarea><br />
	            Output:<br />
	            <blockquote marked="my_markdown"></blockquote>
	          </form>
	        </file>
	        <file  name="exampleB.js">
	          * function MainController($scope) {
	          *     $scope.my_markdown = '*This* **is** [markdown](https://daringfireball.net/projects/markdown/)';
	          *     $scope.my_markdown += ' in a scope variable';
	          * }
	          * angular.module('app', ['hc.marked']).controller('MainController', MainController);
	        </file>
	      </example>
	
	      ## Include a markdown file:
	
	       <example module="hc.marked">
	         <file name="exampleC.html">
	           <div marked src="'include.html'" />
	         </file>
	         * <file name="include.html">
	         * *This* **is** [markdown](https://daringfireball.net/projects/markdown/) in a include file.
	         * </file>
	       </example>
	   */
	
	.directive('marked', ['marked', '$templateRequest', function (marked, $templateRequest) {
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      opts: '=',
	      marked: '=',
	      src: '='
	    },
	    link: function (scope, element, attrs) {
	      set(scope.marked || element.text() || '');
	
	      if (attrs.marked) {
	        scope.$watch('marked', set);
	      }
	
	      if (attrs.src) {
	        scope.$watch('src', function (src) {
	          $templateRequest(src, true).then(function (response) {
	            set(response);
	          });
	        });
	      }
	
	      function unindent (text) {
	        if (!text) return text;
	
	        var lines = text
	          .replace(/\t/g, '  ')
	          .split(/\r?\n/);
	
	        var min = null;
	        var len = lines.length;
	
	        var l, line;
	        for (var i = 0; i < len; i++) {
	          line = lines[i];
	          l = line.match(/^(\s*)/)[0].length;
	          if (l === line.length) { continue; }
	          min = (l < min || min === null) ? l : min;
	        }
	
	        if (min !== null && min > 0) {
	          for (i = 0; i < len; i++) {
	            lines[i] = lines[i].substr(min);
	          }
	        }
	        return lines.join('\n');
	      }
	
	      function set (text) {
	        text = unindent(text || '');
	        element.html(marked(text, scope.opts || null));
	      }
	    }
	  };
	}]);


/***/ },
/* 2529 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2022, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/markedjs/marked
	 */
	
	/**
	 * DO NOT EDIT THIS FILE
	 * The code in this file is generated from files in ./src/
	 */
	
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.marked = {}));
	})(this, (function (exports) { 'use strict';
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    Object.defineProperty(Constructor, "prototype", {
	      writable: false
	    });
	    return Constructor;
	  }
	
	  function _unsupportedIterableToArray(o, minLen) {
	    if (!o) return;
	    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	    var n = Object.prototype.toString.call(o).slice(8, -1);
	    if (n === "Object" && o.constructor) n = o.constructor.name;
	    if (n === "Map" || n === "Set") return Array.from(o);
	    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	  }
	
	  function _arrayLikeToArray(arr, len) {
	    if (len == null || len > arr.length) len = arr.length;
	
	    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	
	    return arr2;
	  }
	
	  function _createForOfIteratorHelperLoose(o, allowArrayLike) {
	    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
	    if (it) return (it = it.call(o)).next.bind(it);
	
	    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
	      if (it) o = it;
	      var i = 0;
	      return function () {
	        if (i >= o.length) return {
	          done: true
	        };
	        return {
	          done: false,
	          value: o[i++]
	        };
	      };
	    }
	
	    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	
	  function getDefaults() {
	    return {
	      baseUrl: null,
	      breaks: false,
	      extensions: null,
	      gfm: true,
	      headerIds: true,
	      headerPrefix: '',
	      highlight: null,
	      langPrefix: 'language-',
	      mangle: true,
	      pedantic: false,
	      renderer: null,
	      sanitize: false,
	      sanitizer: null,
	      silent: false,
	      smartLists: false,
	      smartypants: false,
	      tokenizer: null,
	      walkTokens: null,
	      xhtml: false
	    };
	  }
	  exports.defaults = getDefaults();
	  function changeDefaults(newDefaults) {
	    exports.defaults = newDefaults;
	  }
	
	  /**
	   * Helpers
	   */
	  var escapeTest = /[&<>"']/;
	  var escapeReplace = /[&<>"']/g;
	  var escapeTestNoEncode = /[<>"']|&(?!#?\w+;)/;
	  var escapeReplaceNoEncode = /[<>"']|&(?!#?\w+;)/g;
	  var escapeReplacements = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  var getEscapeReplacement = function getEscapeReplacement(ch) {
	    return escapeReplacements[ch];
	  };
	
	  function escape(html, encode) {
	    if (encode) {
	      if (escapeTest.test(html)) {
	        return html.replace(escapeReplace, getEscapeReplacement);
	      }
	    } else {
	      if (escapeTestNoEncode.test(html)) {
	        return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
	      }
	    }
	
	    return html;
	  }
	  var unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
	  function unescape(html) {
	    // explicitly match decimal, hex, and named HTML entities
	    return html.replace(unescapeTest, function (_, n) {
	      n = n.toLowerCase();
	      if (n === 'colon') return ':';
	
	      if (n.charAt(0) === '#') {
	        return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
	      }
	
	      return '';
	    });
	  }
	  var caret = /(^|[^\[])\^/g;
	  function edit(regex, opt) {
	    regex = regex.source || regex;
	    opt = opt || '';
	    var obj = {
	      replace: function replace(name, val) {
	        val = val.source || val;
	        val = val.replace(caret, '$1');
	        regex = regex.replace(name, val);
	        return obj;
	      },
	      getRegex: function getRegex() {
	        return new RegExp(regex, opt);
	      }
	    };
	    return obj;
	  }
	  var nonWordAndColonTest = /[^\w:]/g;
	  var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
	  function cleanUrl(sanitize, base, href) {
	    if (sanitize) {
	      var prot;
	
	      try {
	        prot = decodeURIComponent(unescape(href)).replace(nonWordAndColonTest, '').toLowerCase();
	      } catch (e) {
	        return null;
	      }
	
	      if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
	        return null;
	      }
	    }
	
	    if (base && !originIndependentUrl.test(href)) {
	      href = resolveUrl(base, href);
	    }
	
	    try {
	      href = encodeURI(href).replace(/%25/g, '%');
	    } catch (e) {
	      return null;
	    }
	
	    return href;
	  }
	  var baseUrls = {};
	  var justDomain = /^[^:]+:\/*[^/]*$/;
	  var protocol = /^([^:]+:)[\s\S]*$/;
	  var domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;
	  function resolveUrl(base, href) {
	    if (!baseUrls[' ' + base]) {
	      // we can ignore everything in base after the last slash of its path component,
	      // but we might need to add _that_
	      // https://tools.ietf.org/html/rfc3986#section-3
	      if (justDomain.test(base)) {
	        baseUrls[' ' + base] = base + '/';
	      } else {
	        baseUrls[' ' + base] = rtrim(base, '/', true);
	      }
	    }
	
	    base = baseUrls[' ' + base];
	    var relativeBase = base.indexOf(':') === -1;
	
	    if (href.substring(0, 2) === '//') {
	      if (relativeBase) {
	        return href;
	      }
	
	      return base.replace(protocol, '$1') + href;
	    } else if (href.charAt(0) === '/') {
	      if (relativeBase) {
	        return href;
	      }
	
	      return base.replace(domain, '$1') + href;
	    } else {
	      return base + href;
	    }
	  }
	  var noopTest = {
	    exec: function noopTest() {}
	  };
	  function merge(obj) {
	    var i = 1,
	        target,
	        key;
	
	    for (; i < arguments.length; i++) {
	      target = arguments[i];
	
	      for (key in target) {
	        if (Object.prototype.hasOwnProperty.call(target, key)) {
	          obj[key] = target[key];
	        }
	      }
	    }
	
	    return obj;
	  }
	  function splitCells(tableRow, count) {
	    // ensure that every cell-delimiting pipe has a space
	    // before it to distinguish it from an escaped pipe
	    var row = tableRow.replace(/\|/g, function (match, offset, str) {
	      var escaped = false,
	          curr = offset;
	
	      while (--curr >= 0 && str[curr] === '\\') {
	        escaped = !escaped;
	      }
	
	      if (escaped) {
	        // odd number of slashes means | is escaped
	        // so we leave it alone
	        return '|';
	      } else {
	        // add space before unescaped |
	        return ' |';
	      }
	    }),
	        cells = row.split(/ \|/);
	    var i = 0; // First/last cell in a row cannot be empty if it has no leading/trailing pipe
	
	    if (!cells[0].trim()) {
	      cells.shift();
	    }
	
	    if (!cells[cells.length - 1].trim()) {
	      cells.pop();
	    }
	
	    if (cells.length > count) {
	      cells.splice(count);
	    } else {
	      while (cells.length < count) {
	        cells.push('');
	      }
	    }
	
	    for (; i < cells.length; i++) {
	      // leading or trailing whitespace is ignored per the gfm spec
	      cells[i] = cells[i].trim().replace(/\\\|/g, '|');
	    }
	
	    return cells;
	  } // Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
	  // /c*$/ is vulnerable to REDOS.
	  // invert: Remove suffix of non-c chars instead. Default falsey.
	
	  function rtrim(str, c, invert) {
	    var l = str.length;
	
	    if (l === 0) {
	      return '';
	    } // Length of suffix matching the invert condition.
	
	
	    var suffLen = 0; // Step left until we fail to match the invert condition.
	
	    while (suffLen < l) {
	      var currChar = str.charAt(l - suffLen - 1);
	
	      if (currChar === c && !invert) {
	        suffLen++;
	      } else if (currChar !== c && invert) {
	        suffLen++;
	      } else {
	        break;
	      }
	    }
	
	    return str.substr(0, l - suffLen);
	  }
	  function findClosingBracket(str, b) {
	    if (str.indexOf(b[1]) === -1) {
	      return -1;
	    }
	
	    var l = str.length;
	    var level = 0,
	        i = 0;
	
	    for (; i < l; i++) {
	      if (str[i] === '\\') {
	        i++;
	      } else if (str[i] === b[0]) {
	        level++;
	      } else if (str[i] === b[1]) {
	        level--;
	
	        if (level < 0) {
	          return i;
	        }
	      }
	    }
	
	    return -1;
	  }
	  function checkSanitizeDeprecation(opt) {
	    if (opt && opt.sanitize && !opt.silent) {
	      console.warn('marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options');
	    }
	  } // copied from https://stackoverflow.com/a/5450113/806777
	
	  function repeatString(pattern, count) {
	    if (count < 1) {
	      return '';
	    }
	
	    var result = '';
	
	    while (count > 1) {
	      if (count & 1) {
	        result += pattern;
	      }
	
	      count >>= 1;
	      pattern += pattern;
	    }
	
	    return result + pattern;
	  }
	
	  function outputLink(cap, link, raw, lexer) {
	    var href = link.href;
	    var title = link.title ? escape(link.title) : null;
	    var text = cap[1].replace(/\\([\[\]])/g, '$1');
	
	    if (cap[0].charAt(0) !== '!') {
	      lexer.state.inLink = true;
	      var token = {
	        type: 'link',
	        raw: raw,
	        href: href,
	        title: title,
	        text: text,
	        tokens: lexer.inlineTokens(text, [])
	      };
	      lexer.state.inLink = false;
	      return token;
	    } else {
	      return {
	        type: 'image',
	        raw: raw,
	        href: href,
	        title: title,
	        text: escape(text)
	      };
	    }
	  }
	
	  function indentCodeCompensation(raw, text) {
	    var matchIndentToCode = raw.match(/^(\s+)(?:```)/);
	
	    if (matchIndentToCode === null) {
	      return text;
	    }
	
	    var indentToCode = matchIndentToCode[1];
	    return text.split('\n').map(function (node) {
	      var matchIndentInNode = node.match(/^\s+/);
	
	      if (matchIndentInNode === null) {
	        return node;
	      }
	
	      var indentInNode = matchIndentInNode[0];
	
	      if (indentInNode.length >= indentToCode.length) {
	        return node.slice(indentToCode.length);
	      }
	
	      return node;
	    }).join('\n');
	  }
	  /**
	   * Tokenizer
	   */
	
	
	  var Tokenizer = /*#__PURE__*/function () {
	    function Tokenizer(options) {
	      this.options = options || exports.defaults;
	    }
	
	    var _proto = Tokenizer.prototype;
	
	    _proto.space = function space(src) {
	      var cap = this.rules.block.newline.exec(src);
	
	      if (cap && cap[0].length > 0) {
	        return {
	          type: 'space',
	          raw: cap[0]
	        };
	      }
	    };
	
	    _proto.code = function code(src) {
	      var cap = this.rules.block.code.exec(src);
	
	      if (cap) {
	        var text = cap[0].replace(/^ {1,4}/gm, '');
	        return {
	          type: 'code',
	          raw: cap[0],
	          codeBlockStyle: 'indented',
	          text: !this.options.pedantic ? rtrim(text, '\n') : text
	        };
	      }
	    };
	
	    _proto.fences = function fences(src) {
	      var cap = this.rules.block.fences.exec(src);
	
	      if (cap) {
	        var raw = cap[0];
	        var text = indentCodeCompensation(raw, cap[3] || '');
	        return {
	          type: 'code',
	          raw: raw,
	          lang: cap[2] ? cap[2].trim() : cap[2],
	          text: text
	        };
	      }
	    };
	
	    _proto.heading = function heading(src) {
	      var cap = this.rules.block.heading.exec(src);
	
	      if (cap) {
	        var text = cap[2].trim(); // remove trailing #s
	
	        if (/#$/.test(text)) {
	          var trimmed = rtrim(text, '#');
	
	          if (this.options.pedantic) {
	            text = trimmed.trim();
	          } else if (!trimmed || / $/.test(trimmed)) {
	            // CommonMark requires space before trailing #s
	            text = trimmed.trim();
	          }
	        }
	
	        var token = {
	          type: 'heading',
	          raw: cap[0],
	          depth: cap[1].length,
	          text: text,
	          tokens: []
	        };
	        this.lexer.inline(token.text, token.tokens);
	        return token;
	      }
	    };
	
	    _proto.hr = function hr(src) {
	      var cap = this.rules.block.hr.exec(src);
	
	      if (cap) {
	        return {
	          type: 'hr',
	          raw: cap[0]
	        };
	      }
	    };
	
	    _proto.blockquote = function blockquote(src) {
	      var cap = this.rules.block.blockquote.exec(src);
	
	      if (cap) {
	        var text = cap[0].replace(/^ *> ?/gm, '');
	        return {
	          type: 'blockquote',
	          raw: cap[0],
	          tokens: this.lexer.blockTokens(text, []),
	          text: text
	        };
	      }
	    };
	
	    _proto.list = function list(src) {
	      var cap = this.rules.block.list.exec(src);
	
	      if (cap) {
	        var raw, istask, ischecked, indent, i, blankLine, endsWithBlankLine, line, nextLine, rawLine, itemContents, endEarly;
	        var bull = cap[1].trim();
	        var isordered = bull.length > 1;
	        var list = {
	          type: 'list',
	          raw: '',
	          ordered: isordered,
	          start: isordered ? +bull.slice(0, -1) : '',
	          loose: false,
	          items: []
	        };
	        bull = isordered ? "\\d{1,9}\\" + bull.slice(-1) : "\\" + bull;
	
	        if (this.options.pedantic) {
	          bull = isordered ? bull : '[*+-]';
	        } // Get next list item
	
	
	        var itemRegex = new RegExp("^( {0,3}" + bull + ")((?: [^\\n]*)?(?:\\n|$))"); // Check if current bullet point can start a new List Item
	
	        while (src) {
	          endEarly = false;
	
	          if (!(cap = itemRegex.exec(src))) {
	            break;
	          }
	
	          if (this.rules.block.hr.test(src)) {
	            // End list if bullet was actually HR (possibly move into itemRegex?)
	            break;
	          }
	
	          raw = cap[0];
	          src = src.substring(raw.length);
	          line = cap[2].split('\n', 1)[0];
	          nextLine = src.split('\n', 1)[0];
	
	          if (this.options.pedantic) {
	            indent = 2;
	            itemContents = line.trimLeft();
	          } else {
	            indent = cap[2].search(/[^ ]/); // Find first non-space char
	
	            indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
	
	            itemContents = line.slice(indent);
	            indent += cap[1].length;
	          }
	
	          blankLine = false;
	
	          if (!line && /^ *$/.test(nextLine)) {
	            // Items begin with at most one blank line
	            raw += nextLine + '\n';
	            src = src.substring(nextLine.length + 1);
	            endEarly = true;
	          }
	
	          if (!endEarly) {
	            var nextBulletRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:[*+-]|\\d{1,9}[.)])"); // Check if following lines should be included in List Item
	
	            while (src) {
	              rawLine = src.split('\n', 1)[0];
	              line = rawLine; // Re-align to follow commonmark nesting rules
	
	              if (this.options.pedantic) {
	                line = line.replace(/^ {1,4}(?=( {4})*[^ ])/g, '  ');
	              } // End list item if found start of new bullet
	
	
	              if (nextBulletRegex.test(line)) {
	                break;
	              }
	
	              if (line.search(/[^ ]/) >= indent || !line.trim()) {
	                // Dedent if possible
	                itemContents += '\n' + line.slice(indent);
	              } else if (!blankLine) {
	                // Until blank line, item doesn't need indentation
	                itemContents += '\n' + line;
	              } else {
	                // Otherwise, improper indentation ends this item
	                break;
	              }
	
	              if (!blankLine && !line.trim()) {
	                // Check if current line is blank
	                blankLine = true;
	              }
	
	              raw += rawLine + '\n';
	              src = src.substring(rawLine.length + 1);
	            }
	          }
	
	          if (!list.loose) {
	            // If the previous item ended with a blank line, the list is loose
	            if (endsWithBlankLine) {
	              list.loose = true;
	            } else if (/\n *\n *$/.test(raw)) {
	              endsWithBlankLine = true;
	            }
	          } // Check for task list items
	
	
	          if (this.options.gfm) {
	            istask = /^\[[ xX]\] /.exec(itemContents);
	
	            if (istask) {
	              ischecked = istask[0] !== '[ ] ';
	              itemContents = itemContents.replace(/^\[[ xX]\] +/, '');
	            }
	          }
	
	          list.items.push({
	            type: 'list_item',
	            raw: raw,
	            task: !!istask,
	            checked: ischecked,
	            loose: false,
	            text: itemContents
	          });
	          list.raw += raw;
	        } // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
	
	
	        list.items[list.items.length - 1].raw = raw.trimRight();
	        list.items[list.items.length - 1].text = itemContents.trimRight();
	        list.raw = list.raw.trimRight();
	        var l = list.items.length; // Item child tokens handled here at end because we needed to have the final item to trim it first
	
	        for (i = 0; i < l; i++) {
	          this.lexer.state.top = false;
	          list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
	          var spacers = list.items[i].tokens.filter(function (t) {
	            return t.type === 'space';
	          });
	          var hasMultipleLineBreaks = spacers.every(function (t) {
	            var chars = t.raw.split('');
	            var lineBreaks = 0;
	
	            for (var _iterator = _createForOfIteratorHelperLoose(chars), _step; !(_step = _iterator()).done;) {
	              var _char = _step.value;
	
	              if (_char === '\n') {
	                lineBreaks += 1;
	              }
	
	              if (lineBreaks > 1) {
	                return true;
	              }
	            }
	
	            return false;
	          });
	
	          if (!list.loose && spacers.length && hasMultipleLineBreaks) {
	            // Having a single line break doesn't mean a list is loose. A single line break is terminating the last list item
	            list.loose = true;
	            list.items[i].loose = true;
	          }
	        }
	
	        return list;
	      }
	    };
	
	    _proto.html = function html(src) {
	      var cap = this.rules.block.html.exec(src);
	
	      if (cap) {
	        var token = {
	          type: 'html',
	          raw: cap[0],
	          pre: !this.options.sanitizer && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
	          text: cap[0]
	        };
	
	        if (this.options.sanitize) {
	          token.type = 'paragraph';
	          token.text = this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]);
	          token.tokens = [];
	          this.lexer.inline(token.text, token.tokens);
	        }
	
	        return token;
	      }
	    };
	
	    _proto.def = function def(src) {
	      var cap = this.rules.block.def.exec(src);
	
	      if (cap) {
	        if (cap[3]) cap[3] = cap[3].substring(1, cap[3].length - 1);
	        var tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
	        return {
	          type: 'def',
	          tag: tag,
	          raw: cap[0],
	          href: cap[2],
	          title: cap[3]
	        };
	      }
	    };
	
	    _proto.table = function table(src) {
	      var cap = this.rules.block.table.exec(src);
	
	      if (cap) {
	        var item = {
	          type: 'table',
	          header: splitCells(cap[1]).map(function (c) {
	            return {
	              text: c
	            };
	          }),
	          align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
	          rows: cap[3] ? cap[3].replace(/\n[ \t]*$/, '').split('\n') : []
	        };
	
	        if (item.header.length === item.align.length) {
	          item.raw = cap[0];
	          var l = item.align.length;
	          var i, j, k, row;
	
	          for (i = 0; i < l; i++) {
	            if (/^ *-+: *$/.test(item.align[i])) {
	              item.align[i] = 'right';
	            } else if (/^ *:-+: *$/.test(item.align[i])) {
	              item.align[i] = 'center';
	            } else if (/^ *:-+ *$/.test(item.align[i])) {
	              item.align[i] = 'left';
	            } else {
	              item.align[i] = null;
	            }
	          }
	
	          l = item.rows.length;
	
	          for (i = 0; i < l; i++) {
	            item.rows[i] = splitCells(item.rows[i], item.header.length).map(function (c) {
	              return {
	                text: c
	              };
	            });
	          } // parse child tokens inside headers and cells
	          // header child tokens
	
	
	          l = item.header.length;
	
	          for (j = 0; j < l; j++) {
	            item.header[j].tokens = [];
	            this.lexer.inlineTokens(item.header[j].text, item.header[j].tokens);
	          } // cell child tokens
	
	
	          l = item.rows.length;
	
	          for (j = 0; j < l; j++) {
	            row = item.rows[j];
	
	            for (k = 0; k < row.length; k++) {
	              row[k].tokens = [];
	              this.lexer.inlineTokens(row[k].text, row[k].tokens);
	            }
	          }
	
	          return item;
	        }
	      }
	    };
	
	    _proto.lheading = function lheading(src) {
	      var cap = this.rules.block.lheading.exec(src);
	
	      if (cap) {
	        var token = {
	          type: 'heading',
	          raw: cap[0],
	          depth: cap[2].charAt(0) === '=' ? 1 : 2,
	          text: cap[1],
	          tokens: []
	        };
	        this.lexer.inline(token.text, token.tokens);
	        return token;
	      }
	    };
	
	    _proto.paragraph = function paragraph(src) {
	      var cap = this.rules.block.paragraph.exec(src);
	
	      if (cap) {
	        var token = {
	          type: 'paragraph',
	          raw: cap[0],
	          text: cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1],
	          tokens: []
	        };
	        this.lexer.inline(token.text, token.tokens);
	        return token;
	      }
	    };
	
	    _proto.text = function text(src) {
	      var cap = this.rules.block.text.exec(src);
	
	      if (cap) {
	        var token = {
	          type: 'text',
	          raw: cap[0],
	          text: cap[0],
	          tokens: []
	        };
	        this.lexer.inline(token.text, token.tokens);
	        return token;
	      }
	    };
	
	    _proto.escape = function escape$1(src) {
	      var cap = this.rules.inline.escape.exec(src);
	
	      if (cap) {
	        return {
	          type: 'escape',
	          raw: cap[0],
	          text: escape(cap[1])
	        };
	      }
	    };
	
	    _proto.tag = function tag(src) {
	      var cap = this.rules.inline.tag.exec(src);
	
	      if (cap) {
	        if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) {
	          this.lexer.state.inLink = true;
	        } else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) {
	          this.lexer.state.inLink = false;
	        }
	
	        if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
	          this.lexer.state.inRawBlock = true;
	        } else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
	          this.lexer.state.inRawBlock = false;
	        }
	
	        return {
	          type: this.options.sanitize ? 'text' : 'html',
	          raw: cap[0],
	          inLink: this.lexer.state.inLink,
	          inRawBlock: this.lexer.state.inRawBlock,
	          text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0]
	        };
	      }
	    };
	
	    _proto.link = function link(src) {
	      var cap = this.rules.inline.link.exec(src);
	
	      if (cap) {
	        var trimmedUrl = cap[2].trim();
	
	        if (!this.options.pedantic && /^</.test(trimmedUrl)) {
	          // commonmark requires matching angle brackets
	          if (!/>$/.test(trimmedUrl)) {
	            return;
	          } // ending angle bracket cannot be escaped
	
	
	          var rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');
	
	          if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) {
	            return;
	          }
	        } else {
	          // find closing parenthesis
	          var lastParenIndex = findClosingBracket(cap[2], '()');
	
	          if (lastParenIndex > -1) {
	            var start = cap[0].indexOf('!') === 0 ? 5 : 4;
	            var linkLen = start + cap[1].length + lastParenIndex;
	            cap[2] = cap[2].substring(0, lastParenIndex);
	            cap[0] = cap[0].substring(0, linkLen).trim();
	            cap[3] = '';
	          }
	        }
	
	        var href = cap[2];
	        var title = '';
	
	        if (this.options.pedantic) {
	          // split pedantic href and title
	          var link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
	
	          if (link) {
	            href = link[1];
	            title = link[3];
	          }
	        } else {
	          title = cap[3] ? cap[3].slice(1, -1) : '';
	        }
	
	        href = href.trim();
	
	        if (/^</.test(href)) {
	          if (this.options.pedantic && !/>$/.test(trimmedUrl)) {
	            // pedantic allows starting angle bracket without ending angle bracket
	            href = href.slice(1);
	          } else {
	            href = href.slice(1, -1);
	          }
	        }
	
	        return outputLink(cap, {
	          href: href ? href.replace(this.rules.inline._escapes, '$1') : href,
	          title: title ? title.replace(this.rules.inline._escapes, '$1') : title
	        }, cap[0], this.lexer);
	      }
	    };
	
	    _proto.reflink = function reflink(src, links) {
	      var cap;
	
	      if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
	        var link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
	        link = links[link.toLowerCase()];
	
	        if (!link || !link.href) {
	          var text = cap[0].charAt(0);
	          return {
	            type: 'text',
	            raw: text,
	            text: text
	          };
	        }
	
	        return outputLink(cap, link, cap[0], this.lexer);
	      }
	    };
	
	    _proto.emStrong = function emStrong(src, maskedSrc, prevChar) {
	      if (prevChar === void 0) {
	        prevChar = '';
	      }
	
	      var match = this.rules.inline.emStrong.lDelim.exec(src);
	      if (!match) return; // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
	
	      if (match[3] && prevChar.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/)) return;
	      var nextChar = match[1] || match[2] || '';
	
	      if (!nextChar || nextChar && (prevChar === '' || this.rules.inline.punctuation.exec(prevChar))) {
	        var lLength = match[0].length - 1;
	        var rDelim,
	            rLength,
	            delimTotal = lLength,
	            midDelimTotal = 0;
	        var endReg = match[0][0] === '*' ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
	        endReg.lastIndex = 0; // Clip maskedSrc to same section of string as src (move to lexer?)
	
	        maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
	
	        while ((match = endReg.exec(maskedSrc)) != null) {
	          rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
	          if (!rDelim) continue; // skip single * in __abc*abc__
	
	          rLength = rDelim.length;
	
	          if (match[3] || match[4]) {
	            // found another Left Delim
	            delimTotal += rLength;
	            continue;
	          } else if (match[5] || match[6]) {
	            // either Left or Right Delim
	            if (lLength % 3 && !((lLength + rLength) % 3)) {
	              midDelimTotal += rLength;
	              continue; // CommonMark Emphasis Rules 9-10
	            }
	          }
	
	          delimTotal -= rLength;
	          if (delimTotal > 0) continue; // Haven't found enough closing delimiters
	          // Remove extra characters. *a*** -> *a*
	
	          rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal); // Create `em` if smallest delimiter has odd char count. *a***
	
	          if (Math.min(lLength, rLength) % 2) {
	            var _text = src.slice(1, lLength + match.index + rLength);
	
	            return {
	              type: 'em',
	              raw: src.slice(0, lLength + match.index + rLength + 1),
	              text: _text,
	              tokens: this.lexer.inlineTokens(_text, [])
	            };
	          } // Create 'strong' if smallest delimiter has even char count. **a***
	
	
	          var text = src.slice(2, lLength + match.index + rLength - 1);
	          return {
	            type: 'strong',
	            raw: src.slice(0, lLength + match.index + rLength + 1),
	            text: text,
	            tokens: this.lexer.inlineTokens(text, [])
	          };
	        }
	      }
	    };
	
	    _proto.codespan = function codespan(src) {
	      var cap = this.rules.inline.code.exec(src);
	
	      if (cap) {
	        var text = cap[2].replace(/\n/g, ' ');
	        var hasNonSpaceChars = /[^ ]/.test(text);
	        var hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
	
	        if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) {
	          text = text.substring(1, text.length - 1);
	        }
	
	        text = escape(text, true);
	        return {
	          type: 'codespan',
	          raw: cap[0],
	          text: text
	        };
	      }
	    };
	
	    _proto.br = function br(src) {
	      var cap = this.rules.inline.br.exec(src);
	
	      if (cap) {
	        return {
	          type: 'br',
	          raw: cap[0]
	        };
	      }
	    };
	
	    _proto.del = function del(src) {
	      var cap = this.rules.inline.del.exec(src);
	
	      if (cap) {
	        return {
	          type: 'del',
	          raw: cap[0],
	          text: cap[2],
	          tokens: this.lexer.inlineTokens(cap[2], [])
	        };
	      }
	    };
	
	    _proto.autolink = function autolink(src, mangle) {
	      var cap = this.rules.inline.autolink.exec(src);
	
	      if (cap) {
	        var text, href;
	
	        if (cap[2] === '@') {
	          text = escape(this.options.mangle ? mangle(cap[1]) : cap[1]);
	          href = 'mailto:' + text;
	        } else {
	          text = escape(cap[1]);
	          href = text;
	        }
	
	        return {
	          type: 'link',
	          raw: cap[0],
	          text: text,
	          href: href,
	          tokens: [{
	            type: 'text',
	            raw: text,
	            text: text
	          }]
	        };
	      }
	    };
	
	    _proto.url = function url(src, mangle) {
	      var cap;
	
	      if (cap = this.rules.inline.url.exec(src)) {
	        var text, href;
	
	        if (cap[2] === '@') {
	          text = escape(this.options.mangle ? mangle(cap[0]) : cap[0]);
	          href = 'mailto:' + text;
	        } else {
	          // do extended autolink path validation
	          var prevCapZero;
	
	          do {
	            prevCapZero = cap[0];
	            cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
	          } while (prevCapZero !== cap[0]);
	
	          text = escape(cap[0]);
	
	          if (cap[1] === 'www.') {
	            href = 'http://' + text;
	          } else {
	            href = text;
	          }
	        }
	
	        return {
	          type: 'link',
	          raw: cap[0],
	          text: text,
	          href: href,
	          tokens: [{
	            type: 'text',
	            raw: text,
	            text: text
	          }]
	        };
	      }
	    };
	
	    _proto.inlineText = function inlineText(src, smartypants) {
	      var cap = this.rules.inline.text.exec(src);
	
	      if (cap) {
	        var text;
	
	        if (this.lexer.state.inRawBlock) {
	          text = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0];
	        } else {
	          text = escape(this.options.smartypants ? smartypants(cap[0]) : cap[0]);
	        }
	
	        return {
	          type: 'text',
	          raw: cap[0],
	          text: text
	        };
	      }
	    };
	
	    return Tokenizer;
	  }();
	
	  /**
	   * Block-Level Grammar
	   */
	
	  var block = {
	    newline: /^(?: *(?:\n|$))+/,
	    code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
	    fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
	    hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
	    heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
	    blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
	    list: /^( {0,3}bull)( [^\n]+?)?(?:\n|$)/,
	    html: '^ {0,3}(?:' // optional indentation
	    + '<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)' // (1)
	    + '|comment[^\\n]*(\\n+|$)' // (2)
	    + '|<\\?[\\s\\S]*?(?:\\?>\\n*|$)' // (3)
	    + '|<![A-Z][\\s\\S]*?(?:>\\n*|$)' // (4)
	    + '|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)' // (5)
	    + '|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (6)
	    + '|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) open tag
	    + '|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) closing tag
	    + ')',
	    def: /^ {0,3}\[(label)\]: *(?:\n *)?<?([^\s>]+)>?(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
	    table: noopTest,
	    lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
	    // regex template, placeholders will be replaced according to different paragraph
	    // interruption rules of commonmark and the original markdown spec:
	    _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
	    text: /^[^\n]+/
	  };
	  block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
	  block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
	  block.def = edit(block.def).replace('label', block._label).replace('title', block._title).getRegex();
	  block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
	  block.listItemStart = edit(/^( *)(bull) */).replace('bull', block.bullet).getRegex();
	  block.list = edit(block.list).replace(/bull/g, block.bullet).replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))').replace('def', '\\n+(?=' + block.def.source + ')').getRegex();
	  block._tag = 'address|article|aside|base|basefont|blockquote|body|caption' + '|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption' + '|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe' + '|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option' + '|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr' + '|track|ul';
	  block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
	  block.html = edit(block.html, 'i').replace('comment', block._comment).replace('tag', block._tag).replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
	  block.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
	  .replace('|table', '').replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
	  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
	  .getRegex();
	  block.blockquote = edit(block.blockquote).replace('paragraph', block.paragraph).getRegex();
	  /**
	   * Normal Block Grammar
	   */
	
	  block.normal = merge({}, block);
	  /**
	   * GFM Block Grammar
	   */
	
	  block.gfm = merge({}, block.normal, {
	    table: '^ *([^\\n ].*\\|.*)\\n' // Header
	    + ' {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?' // Align
	    + '(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)' // Cells
	
	  });
	  block.gfm.table = edit(block.gfm.table).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('blockquote', ' {0,3}>').replace('code', ' {4}[^\\n]').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
	  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // tables can be interrupted by type (6) html blocks
	  .getRegex();
	  block.gfm.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
	  .replace('table', block.gfm.table) // interrupt paragraphs with table
	  .replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
	  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
	  .getRegex();
	  /**
	   * Pedantic grammar (original John Gruber's loose markdown specification)
	   */
	
	  block.pedantic = merge({}, block.normal, {
	    html: edit('^ *(?:comment *(?:\\n|\\s*$)' + '|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)' // closed tag
	    + '|<tag(?:"[^"]*"|\'[^\']*\'|\\s[^\'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))').replace('comment', block._comment).replace(/tag/g, '(?!(?:' + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub' + '|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)' + '\\b)\\w+(?!:|[^\\w\\s@]*@)\\b').getRegex(),
	    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
	    heading: /^(#{1,6})(.*)(?:\n+|$)/,
	    fences: noopTest,
	    // fences not supported
	    paragraph: edit(block.normal._paragraph).replace('hr', block.hr).replace('heading', ' *#{1,6} *[^\n]').replace('lheading', block.lheading).replace('blockquote', ' {0,3}>').replace('|fences', '').replace('|list', '').replace('|html', '').getRegex()
	  });
	  /**
	   * Inline-Level Grammar
	   */
	
	  var inline = {
	    escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
	    autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
	    url: noopTest,
	    tag: '^comment' + '|^</[a-zA-Z][\\w:-]*\\s*>' // self-closing tag
	    + '|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>' // open tag
	    + '|^<\\?[\\s\\S]*?\\?>' // processing instruction, e.g. <?php ?>
	    + '|^<![a-zA-Z]+\\s[\\s\\S]*?>' // declaration, e.g. <!DOCTYPE html>
	    + '|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>',
	    // CDATA section
	    link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
	    reflink: /^!?\[(label)\]\[(ref)\]/,
	    nolink: /^!?\[(ref)\](?:\[\])?/,
	    reflinkSearch: 'reflink|nolink(?!\\()',
	    emStrong: {
	      lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
	      //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
	      //        () Skip orphan delim inside strong    (1) #***                (2) a***#, a***                   (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
	      rDelimAst: /^[^_*]*?\_\_[^_*]*?\*[^_*]*?(?=\_\_)|[punct_](\*+)(?=[\s]|$)|[^punct*_\s](\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|[^punct*_\s](\*+)(?=[^punct*_\s])/,
	      rDelimUnd: /^[^_*]*?\*\*[^_*]*?\_[^_*]*?(?=\*\*)|[punct*](\_+)(?=[\s]|$)|[^punct*_\s](\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/ // ^- Not allowed for _
	
	    },
	    code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
	    br: /^( {2,}|\\)\n(?!\s*$)/,
	    del: noopTest,
	    text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
	    punctuation: /^([\spunctuation])/
	  }; // list of punctuation marks from CommonMark spec
	  // without * and _ to handle the different emphasis markers * and _
	
	  inline._punctuation = '!"#$%&\'()+\\-.,/:;<=>?@\\[\\]`^{|}~';
	  inline.punctuation = edit(inline.punctuation).replace(/punctuation/g, inline._punctuation).getRegex(); // sequences em should skip over [title](link), `code`, <html>
	
	  inline.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
	  inline.escapedEmSt = /\\\*|\\_/g;
	  inline._comment = edit(block._comment).replace('(?:-->|$)', '-->').getRegex();
	  inline.emStrong.lDelim = edit(inline.emStrong.lDelim).replace(/punct/g, inline._punctuation).getRegex();
	  inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, 'g').replace(/punct/g, inline._punctuation).getRegex();
	  inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, 'g').replace(/punct/g, inline._punctuation).getRegex();
	  inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
	  inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
	  inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
	  inline.autolink = edit(inline.autolink).replace('scheme', inline._scheme).replace('email', inline._email).getRegex();
	  inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
	  inline.tag = edit(inline.tag).replace('comment', inline._comment).replace('attribute', inline._attribute).getRegex();
	  inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
	  inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
	  inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
	  inline.link = edit(inline.link).replace('label', inline._label).replace('href', inline._href).replace('title', inline._title).getRegex();
	  inline.reflink = edit(inline.reflink).replace('label', inline._label).replace('ref', block._label).getRegex();
	  inline.nolink = edit(inline.nolink).replace('ref', block._label).getRegex();
	  inline.reflinkSearch = edit(inline.reflinkSearch, 'g').replace('reflink', inline.reflink).replace('nolink', inline.nolink).getRegex();
	  /**
	   * Normal Inline Grammar
	   */
	
	  inline.normal = merge({}, inline);
	  /**
	   * Pedantic Inline Grammar
	   */
	
	  inline.pedantic = merge({}, inline.normal, {
	    strong: {
	      start: /^__|\*\*/,
	      middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
	      endAst: /\*\*(?!\*)/g,
	      endUnd: /__(?!_)/g
	    },
	    em: {
	      start: /^_|\*/,
	      middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
	      endAst: /\*(?!\*)/g,
	      endUnd: /_(?!_)/g
	    },
	    link: edit(/^!?\[(label)\]\((.*?)\)/).replace('label', inline._label).getRegex(),
	    reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace('label', inline._label).getRegex()
	  });
	  /**
	   * GFM Inline Grammar
	   */
	
	  inline.gfm = merge({}, inline.normal, {
	    escape: edit(inline.escape).replace('])', '~|])').getRegex(),
	    _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
	    url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
	    _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
	    del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
	    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
	  });
	  inline.gfm.url = edit(inline.gfm.url, 'i').replace('email', inline.gfm._extended_email).getRegex();
	  /**
	   * GFM + Line Breaks Inline Grammar
	   */
	
	  inline.breaks = merge({}, inline.gfm, {
	    br: edit(inline.br).replace('{2,}', '*').getRegex(),
	    text: edit(inline.gfm.text).replace('\\b_', '\\b_| {2,}\\n').replace(/\{2,\}/g, '*').getRegex()
	  });
	
	  /**
	   * smartypants text replacement
	   */
	
	  function smartypants(text) {
	    return text // em-dashes
	    .replace(/---/g, "\u2014") // en-dashes
	    .replace(/--/g, "\u2013") // opening singles
	    .replace(/(^|[-\u2014/(\[{"\s])'/g, "$1\u2018") // closing singles & apostrophes
	    .replace(/'/g, "\u2019") // opening doubles
	    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1\u201C") // closing doubles
	    .replace(/"/g, "\u201D") // ellipses
	    .replace(/\.{3}/g, "\u2026");
	  }
	  /**
	   * mangle email addresses
	   */
	
	
	  function mangle(text) {
	    var out = '',
	        i,
	        ch;
	    var l = text.length;
	
	    for (i = 0; i < l; i++) {
	      ch = text.charCodeAt(i);
	
	      if (Math.random() > 0.5) {
	        ch = 'x' + ch.toString(16);
	      }
	
	      out += '&#' + ch + ';';
	    }
	
	    return out;
	  }
	  /**
	   * Block Lexer
	   */
	
	
	  var Lexer = /*#__PURE__*/function () {
	    function Lexer(options) {
	      this.tokens = [];
	      this.tokens.links = Object.create(null);
	      this.options = options || exports.defaults;
	      this.options.tokenizer = this.options.tokenizer || new Tokenizer();
	      this.tokenizer = this.options.tokenizer;
	      this.tokenizer.options = this.options;
	      this.tokenizer.lexer = this;
	      this.inlineQueue = [];
	      this.state = {
	        inLink: false,
	        inRawBlock: false,
	        top: true
	      };
	      var rules = {
	        block: block.normal,
	        inline: inline.normal
	      };
	
	      if (this.options.pedantic) {
	        rules.block = block.pedantic;
	        rules.inline = inline.pedantic;
	      } else if (this.options.gfm) {
	        rules.block = block.gfm;
	
	        if (this.options.breaks) {
	          rules.inline = inline.breaks;
	        } else {
	          rules.inline = inline.gfm;
	        }
	      }
	
	      this.tokenizer.rules = rules;
	    }
	    /**
	     * Expose Rules
	     */
	
	
	    /**
	     * Static Lex Method
	     */
	    Lexer.lex = function lex(src, options) {
	      var lexer = new Lexer(options);
	      return lexer.lex(src);
	    }
	    /**
	     * Static Lex Inline Method
	     */
	    ;
	
	    Lexer.lexInline = function lexInline(src, options) {
	      var lexer = new Lexer(options);
	      return lexer.inlineTokens(src);
	    }
	    /**
	     * Preprocessing
	     */
	    ;
	
	    var _proto = Lexer.prototype;
	
	    _proto.lex = function lex(src) {
	      src = src.replace(/\r\n|\r/g, '\n').replace(/\t/g, '    ');
	      this.blockTokens(src, this.tokens);
	      var next;
	
	      while (next = this.inlineQueue.shift()) {
	        this.inlineTokens(next.src, next.tokens);
	      }
	
	      return this.tokens;
	    }
	    /**
	     * Lexing
	     */
	    ;
	
	    _proto.blockTokens = function blockTokens(src, tokens) {
	      var _this = this;
	
	      if (tokens === void 0) {
	        tokens = [];
	      }
	
	      if (this.options.pedantic) {
	        src = src.replace(/^ +$/gm, '');
	      }
	
	      var token, lastToken, cutSrc, lastParagraphClipped;
	
	      while (src) {
	        if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some(function (extTokenizer) {
	          if (token = extTokenizer.call({
	            lexer: _this
	          }, src, tokens)) {
	            src = src.substring(token.raw.length);
	            tokens.push(token);
	            return true;
	          }
	
	          return false;
	        })) {
	          continue;
	        } // newline
	
	
	        if (token = this.tokenizer.space(src)) {
	          src = src.substring(token.raw.length);
	
	          if (token.raw.length === 1 && tokens.length > 0) {
	            // if there's a single \n as a spacer, it's terminating the last line,
	            // so move it there so that we don't get unecessary paragraph tags
	            tokens[tokens.length - 1].raw += '\n';
	          } else {
	            tokens.push(token);
	          }
	
	          continue;
	        } // code
	
	
	        if (token = this.tokenizer.code(src)) {
	          src = src.substring(token.raw.length);
	          lastToken = tokens[tokens.length - 1]; // An indented code block cannot interrupt a paragraph.
	
	          if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
	            lastToken.raw += '\n' + token.raw;
	            lastToken.text += '\n' + token.text;
	            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
	          } else {
	            tokens.push(token);
	          }
	
	          continue;
	        } // fences
	
	
	        if (token = this.tokenizer.fences(src)) {
	          src = src.substring(token.raw.length);
	          tokens.push(token);
	          continue;
	        } // heading
	
	
	        if (token = this.tokenizer.heading(src)) {
	          src = src.substring(token.raw.length);
	          tokens.push(token);
	          continue;
	        } // hr
	
	
	        if (token = this.tokenizer.hr(src)) {
	          src = src.substring(token.raw.length);
	          tokens.push(token);
	          continue;
	        } // blockquote
	
	
	        if (token = this.tokenizer.blockquote(src)) {
	          src = src.substring(token.raw.length);
	          tokens.push(token);
	          continue;
	        } // list
	
	
	        if (token = this.tokenizer.list(src)) {
	          src = src.substring(token.raw.length);
	          tokens.push(token);
	          continue;
	        } // html
	
	
	        if (token = this.tokenizer.html(src)) {
	          src = src.substring(token.raw.length);
	          tokens.push(token);
	          continue;
	        } // def
	
	
	        if (token = this.tokenizer.def(src)) {
	          src = src.substring(token.raw.length);
	          lastToken = tokens[tokens.length - 1];
	
	          if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
	            lastToken.raw += '\n' + token.raw;
	            lastToken.text += '\n' + token.raw;
	            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
	          } else if (!this.tokens.links[token.tag]) {
	            this.tokens.links[token.tag] = {
	              href: token.href,
	              title: token.title
	            };
	          }
	
	          continue;
	        } // table (gfm)
	
	
	        if (token = this.tokenizer.table(src)) {
	          src = src.substring(token.raw.length);
	          tokens.push(token);
	          continue;
	        } // lheading
	
	
	        if (token = this.tokenizer.lheading(src)) {
	          src = src.substring(token.raw.length);
	          tokens.push(token);
	          continue;
	        } // top-level paragraph
	        // prevent paragraph consuming extensions by clipping 'src' to extension start
	
	
	        cutSrc = src;
	
	        if (this.options.extensions && this.options.extensions.startBlock) {
	          (function () {
	            var startIndex = Infinity;
	            var tempSrc = src.slice(1);
	            var tempStart = void 0;
	
	            _this.options.extensions.startBlock.forEach(function (getStartIndex) {
	              tempStart = getStartIndex.call({
	                lexer: this
	              }, tempSrc);
	
	              if (typeof tempStart === 'number' && tempStart >= 0) {
	                startIndex = Math.min(startIndex, tempStart);
	              }
	            });
	
	            if (startIndex < Infinity && startIndex >= 0) {
	              cutSrc = src.substring(0, startIndex + 1);
	            }
	          })();
	        }
	
	        if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
	          lastToken = tokens[tokens.length - 1];
	
	          if (lastParagraphClipped && lastToken.type === 'paragraph') {
	            lastToken.raw += '\n' + token.raw;
	            lastToken.text += '\n' + token.text;
	            this.inlineQueue.pop();
	            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
	          } else {
	            tokens.push(token);
	          }
	
	          lastParagraphClipped = cutSrc.length !== src.length;
	          src = src.substring(token.raw.length);
	          continue;
	        } // text
	
	
	        if (token = this.tokenizer.text(src)) {
	          src = src.substring(token.raw.length);
	          lastToken = tokens[tokens.length - 1];
	
	          if (lastToken && lastToken.type === 'text') {
	            lastToken.raw += '\n' + token.raw;
	            lastToken.text += '\n' + token.text;
	            this.inlineQueue.pop();
	            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
	          } else {
	            tokens.push(token);
	          }
	
	          continue;
	        }
	
	        if (src) {
	          var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
	
	          if (this.options.silent) {
	            console.error(errMsg);
	            break;
	          } else {
	            throw new Error(errMsg);
	          }
	        }
	      }
	
	      this.state.top = true;
	      return tokens;
	    };
	
	    _proto.inline = function inline(src, tokens) {
	      this.inlineQueue.push({
	        src: src,
	        tokens: tokens
	      });
	    }
	    /**
	     * Lexing/Compiling
	     */
	    ;
	
	    _proto.inlineTokens = function inlineTokens(src, tokens) {
	      var _this2 = this;
	
	      if (tokens === void 0) {
	        tokens = [];
	      }
	
	      var token, lastToken, cutSrc; // String with links masked to avoid interference with em and strong
	
	      var maskedSrc = src;
	      var match;
	      var keepPrevChar, prevChar; // Mask out reflinks
	
	      if (this.tokens.links) {
	        var links = Object.keys(this.tokens.links);
	
	        if (links.length > 0) {
	          while ((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) {
	            if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) {
	              maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
	            }
	          }
	        }
	      } // Mask out other blocks
	
	
	      while ((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) {
	        maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
	      } // Mask out escaped em & strong delimiters
	
	
	      while ((match = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null) {
	        maskedSrc = maskedSrc.slice(0, match.index) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
	      }
	
	      while (src) {
	        if (!keepPrevChar) {
	          prevChar = '';
	        }
	
	        keepPrevChar = false; // extensions
	
	        if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some(function (extTokenizer) {
	          if (token = extTokenizer.call({
	            lexer: _this2
	          }, src, tokens)) {
	            src = src.substring(token.raw.length);
	            tokens.push(token);
	            return true;
	          }
	
	          return false;
	        })) {
	          continue;
	        } // escape
	
	
	        if (token = this.tokenizer.escape(src)) {
	          src = src.substring(token.raw.length);
	          tokens.push(token);
	          continue;
	        } // tag
	
	
	        if (token = this.tokenizer.tag(src)) {
	          src = src.substring(token.raw.length);
	          lastToken = tokens[tokens.length - 1];
	
	          if (lastToken && token.type === 'text' && lastToken.type === 'text') {
	            lastToken.raw += token.raw;
	            lastToken.text += token.text;
	          } else {
	            tokens.push(token);
	          }
	
	          continue;
	        } // link
	
	
	        if (token = this.tokenizer.link(src)) {
	          src = src.substring(token.raw.length);
	          tokens.push(token);
	          continue;
	        } // reflink, nolink
	
	
	        if (token = this.tokenizer.reflink(src, this.tokens.links)) {
	          src = src.substring(token.raw.length);
	          lastToken = tokens[tokens.length - 1];
	
	          if (lastToken && token.type === 'text' && lastToken.type === 'text') {
	            lastToken.raw += token.raw;
	            lastToken.text += token.text;
	          } else {
	            tokens.push(token);
	          }
	
	          continue;
	        } // em & strong
	
	
	        if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
	          src = src.substring(token.raw.length);
	          tokens.push(token);
	          continue;
	        } // code
	
	
	        if (token = this.tokenizer.codespan(src)) {
	          src = src.substring(token.raw.length);
	          tokens.push(token);
	          continue;
	        } // br
	
	
	        if (token = this.tokenizer.br(src)) {
	          src = src.substring(token.raw.length);
	          tokens.push(token);
	          continue;
	        } // del (gfm)
	
	
	        if (token = this.tokenizer.del(src)) {
	          src = src.substring(token.raw.length);
	          tokens.push(token);
	          continue;
	        } // autolink
	
	
	        if (token = this.tokenizer.autolink(src, mangle)) {
	          src = src.substring(token.raw.length);
	          tokens.push(token);
	          continue;
	        } // url (gfm)
	
	
	        if (!this.state.inLink && (token = this.tokenizer.url(src, mangle))) {
	          src = src.substring(token.raw.length);
	          tokens.push(token);
	          continue;
	        } // text
	        // prevent inlineText consuming extensions by clipping 'src' to extension start
	
	
	        cutSrc = src;
	
	        if (this.options.extensions && this.options.extensions.startInline) {
	          (function () {
	            var startIndex = Infinity;
	            var tempSrc = src.slice(1);
	            var tempStart = void 0;
	
	            _this2.options.extensions.startInline.forEach(function (getStartIndex) {
	              tempStart = getStartIndex.call({
	                lexer: this
	              }, tempSrc);
	
	              if (typeof tempStart === 'number' && tempStart >= 0) {
	                startIndex = Math.min(startIndex, tempStart);
	              }
	            });
	
	            if (startIndex < Infinity && startIndex >= 0) {
	              cutSrc = src.substring(0, startIndex + 1);
	            }
	          })();
	        }
	
	        if (token = this.tokenizer.inlineText(cutSrc, smartypants)) {
	          src = src.substring(token.raw.length);
	
	          if (token.raw.slice(-1) !== '_') {
	            // Track prevChar before string of ____ started
	            prevChar = token.raw.slice(-1);
	          }
	
	          keepPrevChar = true;
	          lastToken = tokens[tokens.length - 1];
	
	          if (lastToken && lastToken.type === 'text') {
	            lastToken.raw += token.raw;
	            lastToken.text += token.text;
	          } else {
	            tokens.push(token);
	          }
	
	          continue;
	        }
	
	        if (src) {
	          var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
	
	          if (this.options.silent) {
	            console.error(errMsg);
	            break;
	          } else {
	            throw new Error(errMsg);
	          }
	        }
	      }
	
	      return tokens;
	    };
	
	    _createClass(Lexer, null, [{
	      key: "rules",
	      get: function get() {
	        return {
	          block: block,
	          inline: inline
	        };
	      }
	    }]);
	
	    return Lexer;
	  }();
	
	  /**
	   * Renderer
	   */
	
	  var Renderer = /*#__PURE__*/function () {
	    function Renderer(options) {
	      this.options = options || exports.defaults;
	    }
	
	    var _proto = Renderer.prototype;
	
	    _proto.code = function code(_code, infostring, escaped) {
	      var lang = (infostring || '').match(/\S*/)[0];
	
	      if (this.options.highlight) {
	        var out = this.options.highlight(_code, lang);
	
	        if (out != null && out !== _code) {
	          escaped = true;
	          _code = out;
	        }
	      }
	
	      _code = _code.replace(/\n$/, '') + '\n';
	
	      if (!lang) {
	        return '<pre><code>' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
	      }
	
	      return '<pre><code class="' + this.options.langPrefix + escape(lang, true) + '">' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
	    };
	
	    _proto.blockquote = function blockquote(quote) {
	      return '<blockquote>\n' + quote + '</blockquote>\n';
	    };
	
	    _proto.html = function html(_html) {
	      return _html;
	    };
	
	    _proto.heading = function heading(text, level, raw, slugger) {
	      if (this.options.headerIds) {
	        return '<h' + level + ' id="' + this.options.headerPrefix + slugger.slug(raw) + '">' + text + '</h' + level + '>\n';
	      } // ignore IDs
	
	
	      return '<h' + level + '>' + text + '</h' + level + '>\n';
	    };
	
	    _proto.hr = function hr() {
	      return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
	    };
	
	    _proto.list = function list(body, ordered, start) {
	      var type = ordered ? 'ol' : 'ul',
	          startatt = ordered && start !== 1 ? ' start="' + start + '"' : '';
	      return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
	    };
	
	    _proto.listitem = function listitem(text) {
	      return '<li>' + text + '</li>\n';
	    };
	
	    _proto.checkbox = function checkbox(checked) {
	      return '<input ' + (checked ? 'checked="" ' : '') + 'disabled="" type="checkbox"' + (this.options.xhtml ? ' /' : '') + '> ';
	    };
	
	    _proto.paragraph = function paragraph(text) {
	      return '<p>' + text + '</p>\n';
	    };
	
	    _proto.table = function table(header, body) {
	      if (body) body = '<tbody>' + body + '</tbody>';
	      return '<table>\n' + '<thead>\n' + header + '</thead>\n' + body + '</table>\n';
	    };
	
	    _proto.tablerow = function tablerow(content) {
	      return '<tr>\n' + content + '</tr>\n';
	    };
	
	    _proto.tablecell = function tablecell(content, flags) {
	      var type = flags.header ? 'th' : 'td';
	      var tag = flags.align ? '<' + type + ' align="' + flags.align + '">' : '<' + type + '>';
	      return tag + content + '</' + type + '>\n';
	    } // span level renderer
	    ;
	
	    _proto.strong = function strong(text) {
	      return '<strong>' + text + '</strong>';
	    };
	
	    _proto.em = function em(text) {
	      return '<em>' + text + '</em>';
	    };
	
	    _proto.codespan = function codespan(text) {
	      return '<code>' + text + '</code>';
	    };
	
	    _proto.br = function br() {
	      return this.options.xhtml ? '<br/>' : '<br>';
	    };
	
	    _proto.del = function del(text) {
	      return '<del>' + text + '</del>';
	    };
	
	    _proto.link = function link(href, title, text) {
	      href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
	
	      if (href === null) {
	        return text;
	      }
	
	      var out = '<a href="' + escape(href) + '"';
	
	      if (title) {
	        out += ' title="' + title + '"';
	      }
	
	      out += '>' + text + '</a>';
	      return out;
	    };
	
	    _proto.image = function image(href, title, text) {
	      href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
	
	      if (href === null) {
	        return text;
	      }
	
	      var out = '<img src="' + href + '" alt="' + text + '"';
	
	      if (title) {
	        out += ' title="' + title + '"';
	      }
	
	      out += this.options.xhtml ? '/>' : '>';
	      return out;
	    };
	
	    _proto.text = function text(_text) {
	      return _text;
	    };
	
	    return Renderer;
	  }();
	
	  /**
	   * TextRenderer
	   * returns only the textual part of the token
	   */
	  var TextRenderer = /*#__PURE__*/function () {
	    function TextRenderer() {}
	
	    var _proto = TextRenderer.prototype;
	
	    // no need for block level renderers
	    _proto.strong = function strong(text) {
	      return text;
	    };
	
	    _proto.em = function em(text) {
	      return text;
	    };
	
	    _proto.codespan = function codespan(text) {
	      return text;
	    };
	
	    _proto.del = function del(text) {
	      return text;
	    };
	
	    _proto.html = function html(text) {
	      return text;
	    };
	
	    _proto.text = function text(_text) {
	      return _text;
	    };
	
	    _proto.link = function link(href, title, text) {
	      return '' + text;
	    };
	
	    _proto.image = function image(href, title, text) {
	      return '' + text;
	    };
	
	    _proto.br = function br() {
	      return '';
	    };
	
	    return TextRenderer;
	  }();
	
	  /**
	   * Slugger generates header id
	   */
	  var Slugger = /*#__PURE__*/function () {
	    function Slugger() {
	      this.seen = {};
	    }
	
	    var _proto = Slugger.prototype;
	
	    _proto.serialize = function serialize(value) {
	      return value.toLowerCase().trim() // remove html tags
	      .replace(/<[!\/a-z].*?>/ig, '') // remove unwanted chars
	      .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, '').replace(/\s/g, '-');
	    }
	    /**
	     * Finds the next safe (unique) slug to use
	     */
	    ;
	
	    _proto.getNextSafeSlug = function getNextSafeSlug(originalSlug, isDryRun) {
	      var slug = originalSlug;
	      var occurenceAccumulator = 0;
	
	      if (this.seen.hasOwnProperty(slug)) {
	        occurenceAccumulator = this.seen[originalSlug];
	
	        do {
	          occurenceAccumulator++;
	          slug = originalSlug + '-' + occurenceAccumulator;
	        } while (this.seen.hasOwnProperty(slug));
	      }
	
	      if (!isDryRun) {
	        this.seen[originalSlug] = occurenceAccumulator;
	        this.seen[slug] = 0;
	      }
	
	      return slug;
	    }
	    /**
	     * Convert string to unique id
	     * @param {object} options
	     * @param {boolean} options.dryrun Generates the next unique slug without updating the internal accumulator.
	     */
	    ;
	
	    _proto.slug = function slug(value, options) {
	      if (options === void 0) {
	        options = {};
	      }
	
	      var slug = this.serialize(value);
	      return this.getNextSafeSlug(slug, options.dryrun);
	    };
	
	    return Slugger;
	  }();
	
	  /**
	   * Parsing & Compiling
	   */
	
	  var Parser = /*#__PURE__*/function () {
	    function Parser(options) {
	      this.options = options || exports.defaults;
	      this.options.renderer = this.options.renderer || new Renderer();
	      this.renderer = this.options.renderer;
	      this.renderer.options = this.options;
	      this.textRenderer = new TextRenderer();
	      this.slugger = new Slugger();
	    }
	    /**
	     * Static Parse Method
	     */
	
	
	    Parser.parse = function parse(tokens, options) {
	      var parser = new Parser(options);
	      return parser.parse(tokens);
	    }
	    /**
	     * Static Parse Inline Method
	     */
	    ;
	
	    Parser.parseInline = function parseInline(tokens, options) {
	      var parser = new Parser(options);
	      return parser.parseInline(tokens);
	    }
	    /**
	     * Parse Loop
	     */
	    ;
	
	    var _proto = Parser.prototype;
	
	    _proto.parse = function parse(tokens, top) {
	      if (top === void 0) {
	        top = true;
	      }
	
	      var out = '',
	          i,
	          j,
	          k,
	          l2,
	          l3,
	          row,
	          cell,
	          header,
	          body,
	          token,
	          ordered,
	          start,
	          loose,
	          itemBody,
	          item,
	          checked,
	          task,
	          checkbox,
	          ret;
	      var l = tokens.length;
	
	      for (i = 0; i < l; i++) {
	        token = tokens[i]; // Run any renderer extensions
	
	        if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
	          ret = this.options.extensions.renderers[token.type].call({
	            parser: this
	          }, token);
	
	          if (ret !== false || !['space', 'hr', 'heading', 'code', 'table', 'blockquote', 'list', 'html', 'paragraph', 'text'].includes(token.type)) {
	            out += ret || '';
	            continue;
	          }
	        }
	
	        switch (token.type) {
	          case 'space':
	            {
	              continue;
	            }
	
	          case 'hr':
	            {
	              out += this.renderer.hr();
	              continue;
	            }
	
	          case 'heading':
	            {
	              out += this.renderer.heading(this.parseInline(token.tokens), token.depth, unescape(this.parseInline(token.tokens, this.textRenderer)), this.slugger);
	              continue;
	            }
	
	          case 'code':
	            {
	              out += this.renderer.code(token.text, token.lang, token.escaped);
	              continue;
	            }
	
	          case 'table':
	            {
	              header = ''; // header
	
	              cell = '';
	              l2 = token.header.length;
	
	              for (j = 0; j < l2; j++) {
	                cell += this.renderer.tablecell(this.parseInline(token.header[j].tokens), {
	                  header: true,
	                  align: token.align[j]
	                });
	              }
	
	              header += this.renderer.tablerow(cell);
	              body = '';
	              l2 = token.rows.length;
	
	              for (j = 0; j < l2; j++) {
	                row = token.rows[j];
	                cell = '';
	                l3 = row.length;
	
	                for (k = 0; k < l3; k++) {
	                  cell += this.renderer.tablecell(this.parseInline(row[k].tokens), {
	                    header: false,
	                    align: token.align[k]
	                  });
	                }
	
	                body += this.renderer.tablerow(cell);
	              }
	
	              out += this.renderer.table(header, body);
	              continue;
	            }
	
	          case 'blockquote':
	            {
	              body = this.parse(token.tokens);
	              out += this.renderer.blockquote(body);
	              continue;
	            }
	
	          case 'list':
	            {
	              ordered = token.ordered;
	              start = token.start;
	              loose = token.loose;
	              l2 = token.items.length;
	              body = '';
	
	              for (j = 0; j < l2; j++) {
	                item = token.items[j];
	                checked = item.checked;
	                task = item.task;
	                itemBody = '';
	
	                if (item.task) {
	                  checkbox = this.renderer.checkbox(checked);
	
	                  if (loose) {
	                    if (item.tokens.length > 0 && item.tokens[0].type === 'paragraph') {
	                      item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
	
	                      if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') {
	                        item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
	                      }
	                    } else {
	                      item.tokens.unshift({
	                        type: 'text',
	                        text: checkbox
	                      });
	                    }
	                  } else {
	                    itemBody += checkbox;
	                  }
	                }
	
	                itemBody += this.parse(item.tokens, loose);
	                body += this.renderer.listitem(itemBody, task, checked);
	              }
	
	              out += this.renderer.list(body, ordered, start);
	              continue;
	            }
	
	          case 'html':
	            {
	              // TODO parse inline content if parameter markdown=1
	              out += this.renderer.html(token.text);
	              continue;
	            }
	
	          case 'paragraph':
	            {
	              out += this.renderer.paragraph(this.parseInline(token.tokens));
	              continue;
	            }
	
	          case 'text':
	            {
	              body = token.tokens ? this.parseInline(token.tokens) : token.text;
	
	              while (i + 1 < l && tokens[i + 1].type === 'text') {
	                token = tokens[++i];
	                body += '\n' + (token.tokens ? this.parseInline(token.tokens) : token.text);
	              }
	
	              out += top ? this.renderer.paragraph(body) : body;
	              continue;
	            }
	
	          default:
	            {
	              var errMsg = 'Token with "' + token.type + '" type was not found.';
	
	              if (this.options.silent) {
	                console.error(errMsg);
	                return;
	              } else {
	                throw new Error(errMsg);
	              }
	            }
	        }
	      }
	
	      return out;
	    }
	    /**
	     * Parse Inline Tokens
	     */
	    ;
	
	    _proto.parseInline = function parseInline(tokens, renderer) {
	      renderer = renderer || this.renderer;
	      var out = '',
	          i,
	          token,
	          ret;
	      var l = tokens.length;
	
	      for (i = 0; i < l; i++) {
	        token = tokens[i]; // Run any renderer extensions
	
	        if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
	          ret = this.options.extensions.renderers[token.type].call({
	            parser: this
	          }, token);
	
	          if (ret !== false || !['escape', 'html', 'link', 'image', 'strong', 'em', 'codespan', 'br', 'del', 'text'].includes(token.type)) {
	            out += ret || '';
	            continue;
	          }
	        }
	
	        switch (token.type) {
	          case 'escape':
	            {
	              out += renderer.text(token.text);
	              break;
	            }
	
	          case 'html':
	            {
	              out += renderer.html(token.text);
	              break;
	            }
	
	          case 'link':
	            {
	              out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
	              break;
	            }
	
	          case 'image':
	            {
	              out += renderer.image(token.href, token.title, token.text);
	              break;
	            }
	
	          case 'strong':
	            {
	              out += renderer.strong(this.parseInline(token.tokens, renderer));
	              break;
	            }
	
	          case 'em':
	            {
	              out += renderer.em(this.parseInline(token.tokens, renderer));
	              break;
	            }
	
	          case 'codespan':
	            {
	              out += renderer.codespan(token.text);
	              break;
	            }
	
	          case 'br':
	            {
	              out += renderer.br();
	              break;
	            }
	
	          case 'del':
	            {
	              out += renderer.del(this.parseInline(token.tokens, renderer));
	              break;
	            }
	
	          case 'text':
	            {
	              out += renderer.text(token.text);
	              break;
	            }
	
	          default:
	            {
	              var errMsg = 'Token with "' + token.type + '" type was not found.';
	
	              if (this.options.silent) {
	                console.error(errMsg);
	                return;
	              } else {
	                throw new Error(errMsg);
	              }
	            }
	        }
	      }
	
	      return out;
	    };
	
	    return Parser;
	  }();
	
	  /**
	   * Marked
	   */
	
	  function marked(src, opt, callback) {
	    // throw error in case of non string input
	    if (typeof src === 'undefined' || src === null) {
	      throw new Error('marked(): input parameter is undefined or null');
	    }
	
	    if (typeof src !== 'string') {
	      throw new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected');
	    }
	
	    if (typeof opt === 'function') {
	      callback = opt;
	      opt = null;
	    }
	
	    opt = merge({}, marked.defaults, opt || {});
	    checkSanitizeDeprecation(opt);
	
	    if (callback) {
	      var highlight = opt.highlight;
	      var tokens;
	
	      try {
	        tokens = Lexer.lex(src, opt);
	      } catch (e) {
	        return callback(e);
	      }
	
	      var done = function done(err) {
	        var out;
	
	        if (!err) {
	          try {
	            if (opt.walkTokens) {
	              marked.walkTokens(tokens, opt.walkTokens);
	            }
	
	            out = Parser.parse(tokens, opt);
	          } catch (e) {
	            err = e;
	          }
	        }
	
	        opt.highlight = highlight;
	        return err ? callback(err) : callback(null, out);
	      };
	
	      if (!highlight || highlight.length < 3) {
	        return done();
	      }
	
	      delete opt.highlight;
	      if (!tokens.length) return done();
	      var pending = 0;
	      marked.walkTokens(tokens, function (token) {
	        if (token.type === 'code') {
	          pending++;
	          setTimeout(function () {
	            highlight(token.text, token.lang, function (err, code) {
	              if (err) {
	                return done(err);
	              }
	
	              if (code != null && code !== token.text) {
	                token.text = code;
	                token.escaped = true;
	              }
	
	              pending--;
	
	              if (pending === 0) {
	                done();
	              }
	            });
	          }, 0);
	        }
	      });
	
	      if (pending === 0) {
	        done();
	      }
	
	      return;
	    }
	
	    try {
	      var _tokens = Lexer.lex(src, opt);
	
	      if (opt.walkTokens) {
	        marked.walkTokens(_tokens, opt.walkTokens);
	      }
	
	      return Parser.parse(_tokens, opt);
	    } catch (e) {
	      e.message += '\nPlease report this to https://github.com/markedjs/marked.';
	
	      if (opt.silent) {
	        return '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
	      }
	
	      throw e;
	    }
	  }
	  /**
	   * Options
	   */
	
	  marked.options = marked.setOptions = function (opt) {
	    merge(marked.defaults, opt);
	    changeDefaults(marked.defaults);
	    return marked;
	  };
	
	  marked.getDefaults = getDefaults;
	  marked.defaults = exports.defaults;
	  /**
	   * Use Extension
	   */
	
	  marked.use = function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var opts = merge.apply(void 0, [{}].concat(args));
	    var extensions = marked.defaults.extensions || {
	      renderers: {},
	      childTokens: {}
	    };
	    var hasExtensions;
	    args.forEach(function (pack) {
	      // ==-- Parse "addon" extensions --== //
	      if (pack.extensions) {
	        hasExtensions = true;
	        pack.extensions.forEach(function (ext) {
	          if (!ext.name) {
	            throw new Error('extension name required');
	          }
	
	          if (ext.renderer) {
	            // Renderer extensions
	            var prevRenderer = extensions.renderers ? extensions.renderers[ext.name] : null;
	
	            if (prevRenderer) {
	              // Replace extension with func to run new extension but fall back if false
	              extensions.renderers[ext.name] = function () {
	                for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	                  args[_key2] = arguments[_key2];
	                }
	
	                var ret = ext.renderer.apply(this, args);
	
	                if (ret === false) {
	                  ret = prevRenderer.apply(this, args);
	                }
	
	                return ret;
	              };
	            } else {
	              extensions.renderers[ext.name] = ext.renderer;
	            }
	          }
	
	          if (ext.tokenizer) {
	            // Tokenizer Extensions
	            if (!ext.level || ext.level !== 'block' && ext.level !== 'inline') {
	              throw new Error("extension level must be 'block' or 'inline'");
	            }
	
	            if (extensions[ext.level]) {
	              extensions[ext.level].unshift(ext.tokenizer);
	            } else {
	              extensions[ext.level] = [ext.tokenizer];
	            }
	
	            if (ext.start) {
	              // Function to check for start of token
	              if (ext.level === 'block') {
	                if (extensions.startBlock) {
	                  extensions.startBlock.push(ext.start);
	                } else {
	                  extensions.startBlock = [ext.start];
	                }
	              } else if (ext.level === 'inline') {
	                if (extensions.startInline) {
	                  extensions.startInline.push(ext.start);
	                } else {
	                  extensions.startInline = [ext.start];
	                }
	              }
	            }
	          }
	
	          if (ext.childTokens) {
	            // Child tokens to be visited by walkTokens
	            extensions.childTokens[ext.name] = ext.childTokens;
	          }
	        });
	      } // ==-- Parse "overwrite" extensions --== //
	
	
	      if (pack.renderer) {
	        (function () {
	          var renderer = marked.defaults.renderer || new Renderer();
	
	          var _loop = function _loop(prop) {
	            var prevRenderer = renderer[prop]; // Replace renderer with func to run extension, but fall back if false
	
	            renderer[prop] = function () {
	              for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	                args[_key3] = arguments[_key3];
	              }
	
	              var ret = pack.renderer[prop].apply(renderer, args);
	
	              if (ret === false) {
	                ret = prevRenderer.apply(renderer, args);
	              }
	
	              return ret;
	            };
	          };
	
	          for (var prop in pack.renderer) {
	            _loop(prop);
	          }
	
	          opts.renderer = renderer;
	        })();
	      }
	
	      if (pack.tokenizer) {
	        (function () {
	          var tokenizer = marked.defaults.tokenizer || new Tokenizer();
	
	          var _loop2 = function _loop2(prop) {
	            var prevTokenizer = tokenizer[prop]; // Replace tokenizer with func to run extension, but fall back if false
	
	            tokenizer[prop] = function () {
	              for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	                args[_key4] = arguments[_key4];
	              }
	
	              var ret = pack.tokenizer[prop].apply(tokenizer, args);
	
	              if (ret === false) {
	                ret = prevTokenizer.apply(tokenizer, args);
	              }
	
	              return ret;
	            };
	          };
	
	          for (var prop in pack.tokenizer) {
	            _loop2(prop);
	          }
	
	          opts.tokenizer = tokenizer;
	        })();
	      } // ==-- Parse WalkTokens extensions --== //
	
	
	      if (pack.walkTokens) {
	        var _walkTokens = marked.defaults.walkTokens;
	
	        opts.walkTokens = function (token) {
	          pack.walkTokens.call(this, token);
	
	          if (_walkTokens) {
	            _walkTokens.call(this, token);
	          }
	        };
	      }
	
	      if (hasExtensions) {
	        opts.extensions = extensions;
	      }
	
	      marked.setOptions(opts);
	    });
	  };
	  /**
	   * Run callback for every token
	   */
	
	
	  marked.walkTokens = function (tokens, callback) {
	    var _loop3 = function _loop3() {
	      var token = _step.value;
	      callback.call(marked, token);
	
	      switch (token.type) {
	        case 'table':
	          {
	            for (var _iterator2 = _createForOfIteratorHelperLoose(token.header), _step2; !(_step2 = _iterator2()).done;) {
	              var cell = _step2.value;
	              marked.walkTokens(cell.tokens, callback);
	            }
	
	            for (var _iterator3 = _createForOfIteratorHelperLoose(token.rows), _step3; !(_step3 = _iterator3()).done;) {
	              var row = _step3.value;
	
	              for (var _iterator4 = _createForOfIteratorHelperLoose(row), _step4; !(_step4 = _iterator4()).done;) {
	                var _cell = _step4.value;
	                marked.walkTokens(_cell.tokens, callback);
	              }
	            }
	
	            break;
	          }
	
	        case 'list':
	          {
	            marked.walkTokens(token.items, callback);
	            break;
	          }
	
	        default:
	          {
	            if (marked.defaults.extensions && marked.defaults.extensions.childTokens && marked.defaults.extensions.childTokens[token.type]) {
	              // Walk any extensions
	              marked.defaults.extensions.childTokens[token.type].forEach(function (childTokens) {
	                marked.walkTokens(token[childTokens], callback);
	              });
	            } else if (token.tokens) {
	              marked.walkTokens(token.tokens, callback);
	            }
	          }
	      }
	    };
	
	    for (var _iterator = _createForOfIteratorHelperLoose(tokens), _step; !(_step = _iterator()).done;) {
	      _loop3();
	    }
	  };
	  /**
	   * Parse Inline
	   */
	
	
	  marked.parseInline = function (src, opt) {
	    // throw error in case of non string input
	    if (typeof src === 'undefined' || src === null) {
	      throw new Error('marked.parseInline(): input parameter is undefined or null');
	    }
	
	    if (typeof src !== 'string') {
	      throw new Error('marked.parseInline(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected');
	    }
	
	    opt = merge({}, marked.defaults, opt || {});
	    checkSanitizeDeprecation(opt);
	
	    try {
	      var tokens = Lexer.lexInline(src, opt);
	
	      if (opt.walkTokens) {
	        marked.walkTokens(tokens, opt.walkTokens);
	      }
	
	      return Parser.parseInline(tokens, opt);
	    } catch (e) {
	      e.message += '\nPlease report this to https://github.com/markedjs/marked.';
	
	      if (opt.silent) {
	        return '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
	      }
	
	      throw e;
	    }
	  };
	  /**
	   * Expose
	   */
	
	
	  marked.Parser = Parser;
	  marked.parser = Parser.parse;
	  marked.Renderer = Renderer;
	  marked.TextRenderer = TextRenderer;
	  marked.Lexer = Lexer;
	  marked.lexer = Lexer.lex;
	  marked.Tokenizer = Tokenizer;
	  marked.Slugger = Slugger;
	  marked.parse = marked;
	  var options = marked.options;
	  var setOptions = marked.setOptions;
	  var use = marked.use;
	  var walkTokens = marked.walkTokens;
	  var parseInline = marked.parseInline;
	  var parse = marked;
	  var parser = Parser.parse;
	  var lexer = Lexer.lex;
	
	  exports.Lexer = Lexer;
	  exports.Parser = Parser;
	  exports.Renderer = Renderer;
	  exports.Slugger = Slugger;
	  exports.TextRenderer = TextRenderer;
	  exports.Tokenizer = Tokenizer;
	  exports.getDefaults = getDefaults;
	  exports.lexer = lexer;
	  exports.marked = marked;
	  exports.options = options;
	  exports.parse = parse;
	  exports.parseInline = parseInline;
	  exports.parser = parser;
	  exports.setOptions = setOptions;
	  exports.use = use;
	  exports.walkTokens = walkTokens;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 2530 */,
/* 2531 */,
/* 2532 */,
/* 2533 */,
/* 2534 */,
/* 2535 */,
/* 2536 */,
/* 2537 */,
/* 2538 */,
/* 2539 */,
/* 2540 */,
/* 2541 */,
/* 2542 */,
/* 2543 */,
/* 2544 */,
/* 2545 */,
/* 2546 */,
/* 2547 */,
/* 2548 */,
/* 2549 */,
/* 2550 */,
/* 2551 */,
/* 2552 */,
/* 2553 */,
/* 2554 */,
/* 2555 */,
/* 2556 */,
/* 2557 */,
/* 2558 */,
/* 2559 */,
/* 2560 */,
/* 2561 */,
/* 2562 */,
/* 2563 */,
/* 2564 */,
/* 2565 */,
/* 2566 */,
/* 2567 */,
/* 2568 */,
/* 2569 */,
/* 2570 */,
/* 2571 */,
/* 2572 */,
/* 2573 */,
/* 2574 */,
/* 2575 */,
/* 2576 */,
/* 2577 */,
/* 2578 */,
/* 2579 */,
/* 2580 */,
/* 2581 */,
/* 2582 */,
/* 2583 */,
/* 2584 */,
/* 2585 */,
/* 2586 */,
/* 2587 */,
/* 2588 */,
/* 2589 */,
/* 2590 */,
/* 2591 */,
/* 2592 */,
/* 2593 */,
/* 2594 */,
/* 2595 */,
/* 2596 */,
/* 2597 */,
/* 2598 */,
/* 2599 */,
/* 2600 */,
/* 2601 */,
/* 2602 */,
/* 2603 */,
/* 2604 */,
/* 2605 */,
/* 2606 */,
/* 2607 */,
/* 2608 */,
/* 2609 */,
/* 2610 */,
/* 2611 */,
/* 2612 */,
/* 2613 */,
/* 2614 */,
/* 2615 */,
/* 2616 */,
/* 2617 */,
/* 2618 */,
/* 2619 */,
/* 2620 */,
/* 2621 */,
/* 2622 */,
/* 2623 */,
/* 2624 */,
/* 2625 */,
/* 2626 */,
/* 2627 */,
/* 2628 */,
/* 2629 */,
/* 2630 */,
/* 2631 */,
/* 2632 */,
/* 2633 */,
/* 2634 */,
/* 2635 */,
/* 2636 */,
/* 2637 */,
/* 2638 */,
/* 2639 */,
/* 2640 */,
/* 2641 */,
/* 2642 */,
/* 2643 */,
/* 2644 */,
/* 2645 */,
/* 2646 */,
/* 2647 */,
/* 2648 */,
/* 2649 */,
/* 2650 */,
/* 2651 */,
/* 2652 */,
/* 2653 */,
/* 2654 */,
/* 2655 */,
/* 2656 */,
/* 2657 */,
/* 2658 */,
/* 2659 */,
/* 2660 */,
/* 2661 */,
/* 2662 */,
/* 2663 */,
/* 2664 */,
/* 2665 */,
/* 2666 */,
/* 2667 */,
/* 2668 */,
/* 2669 */,
/* 2670 */,
/* 2671 */,
/* 2672 */,
/* 2673 */,
/* 2674 */,
/* 2675 */,
/* 2676 */,
/* 2677 */,
/* 2678 */,
/* 2679 */,
/* 2680 */,
/* 2681 */,
/* 2682 */,
/* 2683 */,
/* 2684 */,
/* 2685 */,
/* 2686 */,
/* 2687 */,
/* 2688 */,
/* 2689 */,
/* 2690 */,
/* 2691 */,
/* 2692 */,
/* 2693 */,
/* 2694 */,
/* 2695 */,
/* 2696 */,
/* 2697 */,
/* 2698 */,
/* 2699 */,
/* 2700 */,
/* 2701 */,
/* 2702 */,
/* 2703 */,
/* 2704 */,
/* 2705 */,
/* 2706 */,
/* 2707 */,
/* 2708 */,
/* 2709 */,
/* 2710 */,
/* 2711 */,
/* 2712 */,
/* 2713 */,
/* 2714 */,
/* 2715 */,
/* 2716 */,
/* 2717 */,
/* 2718 */,
/* 2719 */,
/* 2720 */,
/* 2721 */,
/* 2722 */,
/* 2723 */,
/* 2724 */,
/* 2725 */,
/* 2726 */,
/* 2727 */,
/* 2728 */,
/* 2729 */,
/* 2730 */,
/* 2731 */,
/* 2732 */,
/* 2733 */,
/* 2734 */,
/* 2735 */,
/* 2736 */,
/* 2737 */,
/* 2738 */,
/* 2739 */,
/* 2740 */,
/* 2741 */,
/* 2742 */,
/* 2743 */,
/* 2744 */,
/* 2745 */,
/* 2746 */,
/* 2747 */,
/* 2748 */,
/* 2749 */,
/* 2750 */,
/* 2751 */,
/* 2752 */,
/* 2753 */,
/* 2754 */,
/* 2755 */,
/* 2756 */,
/* 2757 */,
/* 2758 */,
/* 2759 */,
/* 2760 */,
/* 2761 */,
/* 2762 */,
/* 2763 */,
/* 2764 */,
/* 2765 */,
/* 2766 */,
/* 2767 */,
/* 2768 */,
/* 2769 */,
/* 2770 */,
/* 2771 */,
/* 2772 */,
/* 2773 */,
/* 2774 */,
/* 2775 */,
/* 2776 */,
/* 2777 */,
/* 2778 */,
/* 2779 */,
/* 2780 */,
/* 2781 */,
/* 2782 */,
/* 2783 */,
/* 2784 */,
/* 2785 */,
/* 2786 */,
/* 2787 */,
/* 2788 */,
/* 2789 */,
/* 2790 */,
/* 2791 */,
/* 2792 */,
/* 2793 */,
/* 2794 */,
/* 2795 */,
/* 2796 */,
/* 2797 */,
/* 2798 */,
/* 2799 */,
/* 2800 */,
/* 2801 */,
/* 2802 */,
/* 2803 */,
/* 2804 */,
/* 2805 */,
/* 2806 */,
/* 2807 */,
/* 2808 */,
/* 2809 */,
/* 2810 */,
/* 2811 */,
/* 2812 */,
/* 2813 */,
/* 2814 */,
/* 2815 */,
/* 2816 */,
/* 2817 */,
/* 2818 */,
/* 2819 */,
/* 2820 */,
/* 2821 */,
/* 2822 */,
/* 2823 */,
/* 2824 */,
/* 2825 */,
/* 2826 */,
/* 2827 */,
/* 2828 */,
/* 2829 */,
/* 2830 */,
/* 2831 */,
/* 2832 */,
/* 2833 */,
/* 2834 */,
/* 2835 */,
/* 2836 */,
/* 2837 */,
/* 2838 */,
/* 2839 */,
/* 2840 */,
/* 2841 */,
/* 2842 */,
/* 2843 */,
/* 2844 */,
/* 2845 */,
/* 2846 */,
/* 2847 */,
/* 2848 */,
/* 2849 */,
/* 2850 */,
/* 2851 */,
/* 2852 */,
/* 2853 */,
/* 2854 */,
/* 2855 */,
/* 2856 */,
/* 2857 */,
/* 2858 */,
/* 2859 */,
/* 2860 */,
/* 2861 */,
/* 2862 */,
/* 2863 */,
/* 2864 */,
/* 2865 */,
/* 2866 */,
/* 2867 */,
/* 2868 */,
/* 2869 */,
/* 2870 */,
/* 2871 */,
/* 2872 */,
/* 2873 */,
/* 2874 */,
/* 2875 */,
/* 2876 */,
/* 2877 */,
/* 2878 */,
/* 2879 */,
/* 2880 */,
/* 2881 */,
/* 2882 */,
/* 2883 */,
/* 2884 */,
/* 2885 */,
/* 2886 */,
/* 2887 */,
/* 2888 */,
/* 2889 */,
/* 2890 */,
/* 2891 */,
/* 2892 */,
/* 2893 */,
/* 2894 */,
/* 2895 */,
/* 2896 */,
/* 2897 */,
/* 2898 */,
/* 2899 */,
/* 2900 */,
/* 2901 */,
/* 2902 */,
/* 2903 */,
/* 2904 */,
/* 2905 */,
/* 2906 */,
/* 2907 */,
/* 2908 */,
/* 2909 */,
/* 2910 */,
/* 2911 */,
/* 2912 */,
/* 2913 */,
/* 2914 */,
/* 2915 */,
/* 2916 */,
/* 2917 */,
/* 2918 */,
/* 2919 */,
/* 2920 */,
/* 2921 */,
/* 2922 */,
/* 2923 */,
/* 2924 */,
/* 2925 */,
/* 2926 */,
/* 2927 */,
/* 2928 */,
/* 2929 */,
/* 2930 */,
/* 2931 */,
/* 2932 */,
/* 2933 */,
/* 2934 */,
/* 2935 */,
/* 2936 */,
/* 2937 */,
/* 2938 */,
/* 2939 */,
/* 2940 */,
/* 2941 */,
/* 2942 */,
/* 2943 */,
/* 2944 */,
/* 2945 */,
/* 2946 */,
/* 2947 */,
/* 2948 */,
/* 2949 */,
/* 2950 */,
/* 2951 */,
/* 2952 */,
/* 2953 */,
/* 2954 */,
/* 2955 */,
/* 2956 */,
/* 2957 */,
/* 2958 */,
/* 2959 */,
/* 2960 */,
/* 2961 */,
/* 2962 */,
/* 2963 */,
/* 2964 */,
/* 2965 */,
/* 2966 */,
/* 2967 */,
/* 2968 */,
/* 2969 */,
/* 2970 */,
/* 2971 */,
/* 2972 */,
/* 2973 */,
/* 2974 */,
/* 2975 */,
/* 2976 */,
/* 2977 */,
/* 2978 */,
/* 2979 */,
/* 2980 */,
/* 2981 */,
/* 2982 */,
/* 2983 */,
/* 2984 */,
/* 2985 */,
/* 2986 */,
/* 2987 */,
/* 2988 */,
/* 2989 */,
/* 2990 */,
/* 2991 */,
/* 2992 */,
/* 2993 */,
/* 2994 */,
/* 2995 */,
/* 2996 */,
/* 2997 */,
/* 2998 */,
/* 2999 */,
/* 3000 */,
/* 3001 */,
/* 3002 */,
/* 3003 */,
/* 3004 */,
/* 3005 */,
/* 3006 */,
/* 3007 */,
/* 3008 */,
/* 3009 */,
/* 3010 */,
/* 3011 */,
/* 3012 */,
/* 3013 */,
/* 3014 */,
/* 3015 */,
/* 3016 */,
/* 3017 */,
/* 3018 */,
/* 3019 */,
/* 3020 */,
/* 3021 */,
/* 3022 */,
/* 3023 */,
/* 3024 */,
/* 3025 */,
/* 3026 */,
/* 3027 */,
/* 3028 */,
/* 3029 */,
/* 3030 */,
/* 3031 */,
/* 3032 */,
/* 3033 */,
/* 3034 */,
/* 3035 */,
/* 3036 */,
/* 3037 */,
/* 3038 */,
/* 3039 */,
/* 3040 */,
/* 3041 */,
/* 3042 */,
/* 3043 */,
/* 3044 */,
/* 3045 */,
/* 3046 */,
/* 3047 */,
/* 3048 */,
/* 3049 */,
/* 3050 */,
/* 3051 */,
/* 3052 */,
/* 3053 */,
/* 3054 */,
/* 3055 */,
/* 3056 */,
/* 3057 */,
/* 3058 */,
/* 3059 */,
/* 3060 */,
/* 3061 */,
/* 3062 */,
/* 3063 */,
/* 3064 */,
/* 3065 */,
/* 3066 */,
/* 3067 */,
/* 3068 */,
/* 3069 */,
/* 3070 */,
/* 3071 */,
/* 3072 */,
/* 3073 */,
/* 3074 */,
/* 3075 */,
/* 3076 */,
/* 3077 */,
/* 3078 */,
/* 3079 */,
/* 3080 */,
/* 3081 */,
/* 3082 */,
/* 3083 */,
/* 3084 */,
/* 3085 */,
/* 3086 */,
/* 3087 */,
/* 3088 */,
/* 3089 */,
/* 3090 */,
/* 3091 */,
/* 3092 */,
/* 3093 */,
/* 3094 */,
/* 3095 */,
/* 3096 */,
/* 3097 */,
/* 3098 */,
/* 3099 */,
/* 3100 */,
/* 3101 */,
/* 3102 */,
/* 3103 */,
/* 3104 */,
/* 3105 */,
/* 3106 */,
/* 3107 */,
/* 3108 */,
/* 3109 */,
/* 3110 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(3111);
	
	__webpack_require__(3432);
	
	__webpack_require__(3433);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 3111 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3112);
	__webpack_require__(3160);
	__webpack_require__(3161);
	__webpack_require__(3162);
	__webpack_require__(3163);
	__webpack_require__(3165);
	__webpack_require__(3168);
	__webpack_require__(3169);
	__webpack_require__(3170);
	__webpack_require__(3171);
	__webpack_require__(3172);
	__webpack_require__(3173);
	__webpack_require__(3174);
	__webpack_require__(3175);
	__webpack_require__(3176);
	__webpack_require__(3178);
	__webpack_require__(3180);
	__webpack_require__(3182);
	__webpack_require__(3184);
	__webpack_require__(3187);
	__webpack_require__(3188);
	__webpack_require__(3189);
	__webpack_require__(3193);
	__webpack_require__(3195);
	__webpack_require__(3197);
	__webpack_require__(3200);
	__webpack_require__(3201);
	__webpack_require__(3202);
	__webpack_require__(3203);
	__webpack_require__(3205);
	__webpack_require__(3206);
	__webpack_require__(3207);
	__webpack_require__(3208);
	__webpack_require__(3209);
	__webpack_require__(3210);
	__webpack_require__(3211);
	__webpack_require__(3213);
	__webpack_require__(3214);
	__webpack_require__(3215);
	__webpack_require__(3217);
	__webpack_require__(3218);
	__webpack_require__(3219);
	__webpack_require__(3221);
	__webpack_require__(3223);
	__webpack_require__(3224);
	__webpack_require__(3225);
	__webpack_require__(3226);
	__webpack_require__(3227);
	__webpack_require__(3228);
	__webpack_require__(3229);
	__webpack_require__(3230);
	__webpack_require__(3231);
	__webpack_require__(3232);
	__webpack_require__(3233);
	__webpack_require__(3234);
	__webpack_require__(3235);
	__webpack_require__(3240);
	__webpack_require__(3241);
	__webpack_require__(3245);
	__webpack_require__(3246);
	__webpack_require__(3247);
	__webpack_require__(3248);
	__webpack_require__(3250);
	__webpack_require__(3251);
	__webpack_require__(3252);
	__webpack_require__(3253);
	__webpack_require__(3254);
	__webpack_require__(3255);
	__webpack_require__(3256);
	__webpack_require__(3257);
	__webpack_require__(3258);
	__webpack_require__(3259);
	__webpack_require__(3260);
	__webpack_require__(3261);
	__webpack_require__(3262);
	__webpack_require__(3263);
	__webpack_require__(3264);
	__webpack_require__(3266);
	__webpack_require__(3267);
	__webpack_require__(3269);
	__webpack_require__(3270);
	__webpack_require__(3276);
	__webpack_require__(3277);
	__webpack_require__(3279);
	__webpack_require__(3280);
	__webpack_require__(3281);
	__webpack_require__(3285);
	__webpack_require__(3286);
	__webpack_require__(3287);
	__webpack_require__(3288);
	__webpack_require__(3289);
	__webpack_require__(3291);
	__webpack_require__(3292);
	__webpack_require__(3293);
	__webpack_require__(3294);
	__webpack_require__(3297);
	__webpack_require__(3299);
	__webpack_require__(3300);
	__webpack_require__(3301);
	__webpack_require__(3303);
	__webpack_require__(3305);
	__webpack_require__(3307);
	__webpack_require__(3308);
	__webpack_require__(3309);
	__webpack_require__(3311);
	__webpack_require__(3312);
	__webpack_require__(3313);
	__webpack_require__(3314);
	__webpack_require__(3324);
	__webpack_require__(3328);
	__webpack_require__(3329);
	__webpack_require__(3331);
	__webpack_require__(3332);
	__webpack_require__(3336);
	__webpack_require__(3337);
	__webpack_require__(3339);
	__webpack_require__(3340);
	__webpack_require__(3341);
	__webpack_require__(3342);
	__webpack_require__(3343);
	__webpack_require__(3344);
	__webpack_require__(3345);
	__webpack_require__(3346);
	__webpack_require__(3347);
	__webpack_require__(3348);
	__webpack_require__(3349);
	__webpack_require__(3350);
	__webpack_require__(3351);
	__webpack_require__(3352);
	__webpack_require__(3353);
	__webpack_require__(3354);
	__webpack_require__(3355);
	__webpack_require__(3356);
	__webpack_require__(3357);
	__webpack_require__(3359);
	__webpack_require__(3360);
	__webpack_require__(3361);
	__webpack_require__(3362);
	__webpack_require__(3363);
	__webpack_require__(3365);
	__webpack_require__(3366);
	__webpack_require__(3367);
	__webpack_require__(3370);
	__webpack_require__(3371);
	__webpack_require__(3372);
	__webpack_require__(3373);
	__webpack_require__(3374);
	__webpack_require__(3375);
	__webpack_require__(3376);
	__webpack_require__(3377);
	__webpack_require__(3379);
	__webpack_require__(3380);
	__webpack_require__(3382);
	__webpack_require__(3383);
	__webpack_require__(3384);
	__webpack_require__(3385);
	__webpack_require__(3388);
	__webpack_require__(3389);
	__webpack_require__(3391);
	__webpack_require__(3392);
	__webpack_require__(3393);
	__webpack_require__(3394);
	__webpack_require__(3396);
	__webpack_require__(3397);
	__webpack_require__(3398);
	__webpack_require__(3399);
	__webpack_require__(3400);
	__webpack_require__(3401);
	__webpack_require__(3402);
	__webpack_require__(3403);
	__webpack_require__(3404);
	__webpack_require__(3405);
	__webpack_require__(3407);
	__webpack_require__(3408);
	__webpack_require__(3409);
	__webpack_require__(3410);
	__webpack_require__(3411);
	__webpack_require__(3412);
	__webpack_require__(3413);
	__webpack_require__(3414);
	__webpack_require__(3415);
	__webpack_require__(3416);
	__webpack_require__(3417);
	__webpack_require__(3419);
	__webpack_require__(3420);
	__webpack_require__(3421);
	__webpack_require__(3422);
	__webpack_require__(3423);
	__webpack_require__(3424);
	__webpack_require__(3425);
	__webpack_require__(3426);
	__webpack_require__(3427);
	__webpack_require__(3428);
	__webpack_require__(3429);
	__webpack_require__(3430);
	__webpack_require__(3431);
	module.exports = __webpack_require__(3118);


/***/ },
/* 3112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(3113);
	var has = __webpack_require__(3114);
	var DESCRIPTORS = __webpack_require__(3115);
	var $export = __webpack_require__(3117);
	var redefine = __webpack_require__(3127);
	var META = __webpack_require__(3131).KEY;
	var $fails = __webpack_require__(3116);
	var shared = __webpack_require__(3132);
	var setToStringTag = __webpack_require__(3133);
	var uid = __webpack_require__(3128);
	var wks = __webpack_require__(3134);
	var wksExt = __webpack_require__(3135);
	var wksDefine = __webpack_require__(3136);
	var enumKeys = __webpack_require__(3138);
	var isArray = __webpack_require__(3153);
	var anObject = __webpack_require__(3121);
	var isObject = __webpack_require__(3122);
	var toIObject = __webpack_require__(3141);
	var toPrimitive = __webpack_require__(3125);
	var createDesc = __webpack_require__(3126);
	var _create = __webpack_require__(3154);
	var gOPNExt = __webpack_require__(3157);
	var $GOPD = __webpack_require__(3159);
	var $DP = __webpack_require__(3120);
	var $keys = __webpack_require__(3139);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(3158).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(3152).f = $propertyIsEnumerable;
	  __webpack_require__(3151).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(3137)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(3119)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 3113 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 3114 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 3115 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(3116)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 3116 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 3117 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(3113);
	var core = __webpack_require__(3118);
	var hide = __webpack_require__(3119);
	var redefine = __webpack_require__(3127);
	var ctx = __webpack_require__(3129);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 3118 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.5.4' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 3119 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(3120);
	var createDesc = __webpack_require__(3126);
	module.exports = __webpack_require__(3115) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 3120 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(3121);
	var IE8_DOM_DEFINE = __webpack_require__(3123);
	var toPrimitive = __webpack_require__(3125);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(3115) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 3121 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(3122);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 3122 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 3123 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(3115) && !__webpack_require__(3116)(function () {
	  return Object.defineProperty(__webpack_require__(3124)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 3124 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(3122);
	var document = __webpack_require__(3113).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 3125 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(3122);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 3126 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 3127 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(3113);
	var hide = __webpack_require__(3119);
	var has = __webpack_require__(3114);
	var SRC = __webpack_require__(3128)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(3118).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 3128 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 3129 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(3130);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 3130 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 3131 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(3128)('meta');
	var isObject = __webpack_require__(3122);
	var has = __webpack_require__(3114);
	var setDesc = __webpack_require__(3120).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(3116)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 3132 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(3113);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ },
/* 3133 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(3120).f;
	var has = __webpack_require__(3114);
	var TAG = __webpack_require__(3134)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 3134 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(3132)('wks');
	var uid = __webpack_require__(3128);
	var Symbol = __webpack_require__(3113).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 3135 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(3134);


/***/ },
/* 3136 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(3113);
	var core = __webpack_require__(3118);
	var LIBRARY = __webpack_require__(3137);
	var wksExt = __webpack_require__(3135);
	var defineProperty = __webpack_require__(3120).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 3137 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 3138 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(3139);
	var gOPS = __webpack_require__(3151);
	var pIE = __webpack_require__(3152);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 3139 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(3140);
	var enumBugKeys = __webpack_require__(3150);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 3140 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(3114);
	var toIObject = __webpack_require__(3141);
	var arrayIndexOf = __webpack_require__(3145)(false);
	var IE_PROTO = __webpack_require__(3149)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 3141 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(3142);
	var defined = __webpack_require__(3144);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 3142 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(3143);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 3143 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 3144 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 3145 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(3141);
	var toLength = __webpack_require__(3146);
	var toAbsoluteIndex = __webpack_require__(3148);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 3146 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(3147);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 3147 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 3148 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(3147);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 3149 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(3132)('keys');
	var uid = __webpack_require__(3128);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 3150 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 3151 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 3152 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 3153 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(3143);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 3154 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(3121);
	var dPs = __webpack_require__(3155);
	var enumBugKeys = __webpack_require__(3150);
	var IE_PROTO = __webpack_require__(3149)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(3124)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(3156).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 3155 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(3120);
	var anObject = __webpack_require__(3121);
	var getKeys = __webpack_require__(3139);
	
	module.exports = __webpack_require__(3115) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 3156 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(3113).document;
	module.exports = document && document.documentElement;


/***/ },
/* 3157 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(3141);
	var gOPN = __webpack_require__(3158).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 3158 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(3140);
	var hiddenKeys = __webpack_require__(3150).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 3159 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(3152);
	var createDesc = __webpack_require__(3126);
	var toIObject = __webpack_require__(3141);
	var toPrimitive = __webpack_require__(3125);
	var has = __webpack_require__(3114);
	var IE8_DOM_DEFINE = __webpack_require__(3123);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(3115) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 3160 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3117);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(3154) });


/***/ },
/* 3161 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3117);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(3115), 'Object', { defineProperty: __webpack_require__(3120).f });


/***/ },
/* 3162 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3117);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(3115), 'Object', { defineProperties: __webpack_require__(3155) });


/***/ },
/* 3163 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(3141);
	var $getOwnPropertyDescriptor = __webpack_require__(3159).f;
	
	__webpack_require__(3164)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 3164 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(3117);
	var core = __webpack_require__(3118);
	var fails = __webpack_require__(3116);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 3165 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(3166);
	var $getPrototypeOf = __webpack_require__(3167);
	
	__webpack_require__(3164)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 3166 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(3144);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 3167 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(3114);
	var toObject = __webpack_require__(3166);
	var IE_PROTO = __webpack_require__(3149)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 3168 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(3166);
	var $keys = __webpack_require__(3139);
	
	__webpack_require__(3164)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 3169 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(3164)('getOwnPropertyNames', function () {
	  return __webpack_require__(3157).f;
	});


/***/ },
/* 3170 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(3122);
	var meta = __webpack_require__(3131).onFreeze;
	
	__webpack_require__(3164)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 3171 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(3122);
	var meta = __webpack_require__(3131).onFreeze;
	
	__webpack_require__(3164)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 3172 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(3122);
	var meta = __webpack_require__(3131).onFreeze;
	
	__webpack_require__(3164)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 3173 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(3122);
	
	__webpack_require__(3164)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 3174 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(3122);
	
	__webpack_require__(3164)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 3175 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(3122);
	
	__webpack_require__(3164)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 3176 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(3117);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(3177) });


/***/ },
/* 3177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(3139);
	var gOPS = __webpack_require__(3151);
	var pIE = __webpack_require__(3152);
	var toObject = __webpack_require__(3166);
	var IObject = __webpack_require__(3142);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(3116)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ },
/* 3178 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(3117);
	$export($export.S, 'Object', { is: __webpack_require__(3179) });


/***/ },
/* 3179 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 3180 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(3117);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(3181).set });


/***/ },
/* 3181 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(3122);
	var anObject = __webpack_require__(3121);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(3129)(Function.call, __webpack_require__(3159).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 3182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(3183);
	var test = {};
	test[__webpack_require__(3134)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(3127)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 3183 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(3143);
	var TAG = __webpack_require__(3134)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 3184 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(3117);
	
	$export($export.P, 'Function', { bind: __webpack_require__(3185) });


/***/ },
/* 3185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(3130);
	var isObject = __webpack_require__(3122);
	var invoke = __webpack_require__(3186);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 3186 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 3187 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(3120).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(3115) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ },
/* 3188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(3122);
	var getPrototypeOf = __webpack_require__(3167);
	var HAS_INSTANCE = __webpack_require__(3134)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(3120).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ },
/* 3189 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3117);
	var $parseInt = __webpack_require__(3190);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 3190 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(3113).parseInt;
	var $trim = __webpack_require__(3191).trim;
	var ws = __webpack_require__(3192);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 3191 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3117);
	var defined = __webpack_require__(3144);
	var fails = __webpack_require__(3116);
	var spaces = __webpack_require__(3192);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 3192 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 3193 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3117);
	var $parseFloat = __webpack_require__(3194);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 3194 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(3113).parseFloat;
	var $trim = __webpack_require__(3191).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(3192) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 3195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(3113);
	var has = __webpack_require__(3114);
	var cof = __webpack_require__(3143);
	var inheritIfRequired = __webpack_require__(3196);
	var toPrimitive = __webpack_require__(3125);
	var fails = __webpack_require__(3116);
	var gOPN = __webpack_require__(3158).f;
	var gOPD = __webpack_require__(3159).f;
	var dP = __webpack_require__(3120).f;
	var $trim = __webpack_require__(3191).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(3154)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(3115) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(3127)(global, NUMBER, $Number);
	}


/***/ },
/* 3196 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(3122);
	var setPrototypeOf = __webpack_require__(3181).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 3197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var toInteger = __webpack_require__(3147);
	var aNumberValue = __webpack_require__(3198);
	var repeat = __webpack_require__(3199);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(3116)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 3198 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(3143);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 3199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(3147);
	var defined = __webpack_require__(3144);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 3200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var $fails = __webpack_require__(3116);
	var aNumberValue = __webpack_require__(3198);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 3201 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 3202 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(3117);
	var _isFinite = __webpack_require__(3113).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 3203 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(3204) });


/***/ },
/* 3204 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(3122);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 3205 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 3206 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(3117);
	var isInteger = __webpack_require__(3204);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 3207 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 3208 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 3209 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3117);
	var $parseFloat = __webpack_require__(3194);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 3210 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3117);
	var $parseInt = __webpack_require__(3190);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 3211 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(3117);
	var log1p = __webpack_require__(3212);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 3212 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 3213 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(3117);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 3214 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(3117);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 3215 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(3117);
	var sign = __webpack_require__(3216);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 3216 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 3217 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 3218 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(3117);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 3219 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(3117);
	var $expm1 = __webpack_require__(3220);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 3220 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 3221 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Math', { fround: __webpack_require__(3222) });


/***/ },
/* 3222 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(3216);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 3223 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(3117);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 3224 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(3117);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(3116)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 3225 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 3226 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(3212) });


/***/ },
/* 3227 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 3228 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Math', { sign: __webpack_require__(3216) });


/***/ },
/* 3229 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(3117);
	var expm1 = __webpack_require__(3220);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(3116)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 3230 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(3117);
	var expm1 = __webpack_require__(3220);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 3231 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 3232 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3117);
	var toAbsoluteIndex = __webpack_require__(3148);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 3233 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3117);
	var toIObject = __webpack_require__(3141);
	var toLength = __webpack_require__(3146);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 3234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(3191)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 3235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(3236)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(3237)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 3236 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(3147);
	var defined = __webpack_require__(3144);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 3237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(3137);
	var $export = __webpack_require__(3117);
	var redefine = __webpack_require__(3127);
	var hide = __webpack_require__(3119);
	var Iterators = __webpack_require__(3238);
	var $iterCreate = __webpack_require__(3239);
	var setToStringTag = __webpack_require__(3133);
	var getPrototypeOf = __webpack_require__(3167);
	var ITERATOR = __webpack_require__(3134)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 3238 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 3239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(3154);
	var descriptor = __webpack_require__(3126);
	var setToStringTag = __webpack_require__(3133);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(3119)(IteratorPrototype, __webpack_require__(3134)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 3240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var $at = __webpack_require__(3236)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 3241 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(3117);
	var toLength = __webpack_require__(3146);
	var context = __webpack_require__(3242);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(3244)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 3242 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(3243);
	var defined = __webpack_require__(3144);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 3243 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(3122);
	var cof = __webpack_require__(3143);
	var MATCH = __webpack_require__(3134)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 3244 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(3134)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 3245 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(3117);
	var context = __webpack_require__(3242);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(3244)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 3246 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3117);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(3199)
	});


/***/ },
/* 3247 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(3117);
	var toLength = __webpack_require__(3146);
	var context = __webpack_require__(3242);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(3244)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 3248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(3249)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ },
/* 3249 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3117);
	var fails = __webpack_require__(3116);
	var defined = __webpack_require__(3144);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 3250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(3249)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ },
/* 3251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(3249)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ },
/* 3252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(3249)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ },
/* 3253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(3249)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ },
/* 3254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(3249)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ },
/* 3255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(3249)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ },
/* 3256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(3249)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ },
/* 3257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(3249)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ },
/* 3258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(3249)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ },
/* 3259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(3249)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ },
/* 3260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(3249)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ },
/* 3261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(3249)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ },
/* 3262 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 3263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var toObject = __webpack_require__(3166);
	var toPrimitive = __webpack_require__(3125);
	
	$export($export.P + $export.F * __webpack_require__(3116)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 3264 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(3117);
	var toISOString = __webpack_require__(3265);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ },
/* 3265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(3116);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ },
/* 3266 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(3127)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 3267 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(3134)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(3119)(proto, TO_PRIMITIVE, __webpack_require__(3268));


/***/ },
/* 3268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(3121);
	var toPrimitive = __webpack_require__(3125);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ },
/* 3269 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(3153) });


/***/ },
/* 3270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(3129);
	var $export = __webpack_require__(3117);
	var toObject = __webpack_require__(3166);
	var call = __webpack_require__(3271);
	var isArrayIter = __webpack_require__(3272);
	var toLength = __webpack_require__(3146);
	var createProperty = __webpack_require__(3273);
	var getIterFn = __webpack_require__(3274);
	
	$export($export.S + $export.F * !__webpack_require__(3275)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 3271 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(3121);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 3272 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(3238);
	var ITERATOR = __webpack_require__(3134)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 3273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(3120);
	var createDesc = __webpack_require__(3126);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 3274 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(3183);
	var ITERATOR = __webpack_require__(3134)('iterator');
	var Iterators = __webpack_require__(3238);
	module.exports = __webpack_require__(3118).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 3275 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(3134)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 3276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var createProperty = __webpack_require__(3273);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(3116)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 3277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(3117);
	var toIObject = __webpack_require__(3141);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(3142) != Object || !__webpack_require__(3278)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 3278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(3116);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ },
/* 3279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var html = __webpack_require__(3156);
	var cof = __webpack_require__(3143);
	var toAbsoluteIndex = __webpack_require__(3148);
	var toLength = __webpack_require__(3146);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(3116)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 3280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var aFunction = __webpack_require__(3130);
	var toObject = __webpack_require__(3166);
	var fails = __webpack_require__(3116);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(3278)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 3281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var $forEach = __webpack_require__(3282)(0);
	var STRICT = __webpack_require__(3278)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 3282 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(3129);
	var IObject = __webpack_require__(3142);
	var toObject = __webpack_require__(3166);
	var toLength = __webpack_require__(3146);
	var asc = __webpack_require__(3283);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 3283 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(3284);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 3284 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(3122);
	var isArray = __webpack_require__(3153);
	var SPECIES = __webpack_require__(3134)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 3285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var $map = __webpack_require__(3282)(1);
	
	$export($export.P + $export.F * !__webpack_require__(3278)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 3286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var $filter = __webpack_require__(3282)(2);
	
	$export($export.P + $export.F * !__webpack_require__(3278)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 3287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var $some = __webpack_require__(3282)(3);
	
	$export($export.P + $export.F * !__webpack_require__(3278)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 3288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var $every = __webpack_require__(3282)(4);
	
	$export($export.P + $export.F * !__webpack_require__(3278)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 3289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var $reduce = __webpack_require__(3290);
	
	$export($export.P + $export.F * !__webpack_require__(3278)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 3290 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(3130);
	var toObject = __webpack_require__(3166);
	var IObject = __webpack_require__(3142);
	var toLength = __webpack_require__(3146);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 3291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var $reduce = __webpack_require__(3290);
	
	$export($export.P + $export.F * !__webpack_require__(3278)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 3292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var $indexOf = __webpack_require__(3145)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(3278)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 3293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var toIObject = __webpack_require__(3141);
	var toInteger = __webpack_require__(3147);
	var toLength = __webpack_require__(3146);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(3278)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 3294 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(3117);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(3295) });
	
	__webpack_require__(3296)('copyWithin');


/***/ },
/* 3295 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(3166);
	var toAbsoluteIndex = __webpack_require__(3148);
	var toLength = __webpack_require__(3146);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 3296 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(3134)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(3119)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 3297 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(3117);
	
	$export($export.P, 'Array', { fill: __webpack_require__(3298) });
	
	__webpack_require__(3296)('fill');


/***/ },
/* 3298 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(3166);
	var toAbsoluteIndex = __webpack_require__(3148);
	var toLength = __webpack_require__(3146);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 3299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(3117);
	var $find = __webpack_require__(3282)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(3296)(KEY);


/***/ },
/* 3300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(3117);
	var $find = __webpack_require__(3282)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(3296)(KEY);


/***/ },
/* 3301 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3302)('Array');


/***/ },
/* 3302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(3113);
	var dP = __webpack_require__(3120);
	var DESCRIPTORS = __webpack_require__(3115);
	var SPECIES = __webpack_require__(3134)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 3303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(3296);
	var step = __webpack_require__(3304);
	var Iterators = __webpack_require__(3238);
	var toIObject = __webpack_require__(3141);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(3237)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 3304 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 3305 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(3113);
	var inheritIfRequired = __webpack_require__(3196);
	var dP = __webpack_require__(3120).f;
	var gOPN = __webpack_require__(3158).f;
	var isRegExp = __webpack_require__(3243);
	var $flags = __webpack_require__(3306);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(3115) && (!CORRECT_NEW || __webpack_require__(3116)(function () {
	  re2[__webpack_require__(3134)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(3127)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(3302)('RegExp');


/***/ },
/* 3306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(3121);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 3307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(3308);
	var anObject = __webpack_require__(3121);
	var $flags = __webpack_require__(3306);
	var DESCRIPTORS = __webpack_require__(3115);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(3127)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(3116)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ },
/* 3308 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(3115) && /./g.flags != 'g') __webpack_require__(3120).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(3306)
	});


/***/ },
/* 3309 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(3310)('match', 1, function (defined, MATCH, $match) {
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});


/***/ },
/* 3310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide = __webpack_require__(3119);
	var redefine = __webpack_require__(3127);
	var fails = __webpack_require__(3116);
	var defined = __webpack_require__(3144);
	var wks = __webpack_require__(3134);
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	  var fns = exec(defined, SYMBOL, ''[KEY]);
	  var strfn = fns[0];
	  var rxfn = fns[1];
	  if (fails(function () {
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  })) {
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 3311 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(3310)('replace', 2, function (defined, REPLACE, $replace) {
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue) {
	    'use strict';
	    var O = defined(this);
	    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});


/***/ },
/* 3312 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(3310)('search', 1, function (defined, SEARCH, $search) {
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});


/***/ },
/* 3313 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(3310)('split', 2, function (defined, SPLIT, $split) {
	  'use strict';
	  var isRegExp = __webpack_require__(3243);
	  var _split = $split;
	  var $push = [].push;
	  var $SPLIT = 'split';
	  var LENGTH = 'length';
	  var LAST_INDEX = 'lastIndex';
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while (match = separatorCopy.exec(string)) {
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          // eslint-disable-next-line no-loop-func
	          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
	            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
	          });
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    $split = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit) {
	    var O = defined(this);
	    var fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});


/***/ },
/* 3314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(3137);
	var global = __webpack_require__(3113);
	var ctx = __webpack_require__(3129);
	var classof = __webpack_require__(3183);
	var $export = __webpack_require__(3117);
	var isObject = __webpack_require__(3122);
	var aFunction = __webpack_require__(3130);
	var anInstance = __webpack_require__(3315);
	var forOf = __webpack_require__(3316);
	var speciesConstructor = __webpack_require__(3317);
	var task = __webpack_require__(3318).set;
	var microtask = __webpack_require__(3319)();
	var newPromiseCapabilityModule = __webpack_require__(3320);
	var perform = __webpack_require__(3321);
	var promiseResolve = __webpack_require__(3322);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(3134)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(3323)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(3133)($Promise, PROMISE);
	__webpack_require__(3302)(PROMISE);
	Wrapper = __webpack_require__(3118)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(3275)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 3315 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 3316 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(3129);
	var call = __webpack_require__(3271);
	var isArrayIter = __webpack_require__(3272);
	var anObject = __webpack_require__(3121);
	var toLength = __webpack_require__(3146);
	var getIterFn = __webpack_require__(3274);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 3317 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(3121);
	var aFunction = __webpack_require__(3130);
	var SPECIES = __webpack_require__(3134)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 3318 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(3129);
	var invoke = __webpack_require__(3186);
	var html = __webpack_require__(3156);
	var cel = __webpack_require__(3124);
	var global = __webpack_require__(3113);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(3143)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 3319 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(3113);
	var macrotask = __webpack_require__(3318).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(3143)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 3320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(3130);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 3321 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 3322 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(3121);
	var isObject = __webpack_require__(3122);
	var newPromiseCapability = __webpack_require__(3320);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 3323 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(3127);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 3324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(3325);
	var validate = __webpack_require__(3326);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(3327)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 3325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(3120).f;
	var create = __webpack_require__(3154);
	var redefineAll = __webpack_require__(3323);
	var ctx = __webpack_require__(3129);
	var anInstance = __webpack_require__(3315);
	var forOf = __webpack_require__(3316);
	var $iterDefine = __webpack_require__(3237);
	var step = __webpack_require__(3304);
	var setSpecies = __webpack_require__(3302);
	var DESCRIPTORS = __webpack_require__(3115);
	var fastKey = __webpack_require__(3131).fastKey;
	var validate = __webpack_require__(3326);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 3326 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(3122);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 3327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(3113);
	var $export = __webpack_require__(3117);
	var redefine = __webpack_require__(3127);
	var redefineAll = __webpack_require__(3323);
	var meta = __webpack_require__(3131);
	var forOf = __webpack_require__(3316);
	var anInstance = __webpack_require__(3315);
	var isObject = __webpack_require__(3122);
	var fails = __webpack_require__(3116);
	var $iterDetect = __webpack_require__(3275);
	var setToStringTag = __webpack_require__(3133);
	var inheritIfRequired = __webpack_require__(3196);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 3328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(3325);
	var validate = __webpack_require__(3326);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(3327)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 3329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(3282)(0);
	var redefine = __webpack_require__(3127);
	var meta = __webpack_require__(3131);
	var assign = __webpack_require__(3177);
	var weak = __webpack_require__(3330);
	var isObject = __webpack_require__(3122);
	var fails = __webpack_require__(3116);
	var validate = __webpack_require__(3326);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(3327)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 3330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(3323);
	var getWeak = __webpack_require__(3131).getWeak;
	var anObject = __webpack_require__(3121);
	var isObject = __webpack_require__(3122);
	var anInstance = __webpack_require__(3315);
	var forOf = __webpack_require__(3316);
	var createArrayMethod = __webpack_require__(3282);
	var $has = __webpack_require__(3114);
	var validate = __webpack_require__(3326);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 3331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(3330);
	var validate = __webpack_require__(3326);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(3327)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ },
/* 3332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var $typed = __webpack_require__(3333);
	var buffer = __webpack_require__(3334);
	var anObject = __webpack_require__(3121);
	var toAbsoluteIndex = __webpack_require__(3148);
	var toLength = __webpack_require__(3146);
	var isObject = __webpack_require__(3122);
	var ArrayBuffer = __webpack_require__(3113).ArrayBuffer;
	var speciesConstructor = __webpack_require__(3317);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(3116)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var final = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < final) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(3302)(ARRAY_BUFFER);


/***/ },
/* 3333 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(3113);
	var hide = __webpack_require__(3119);
	var uid = __webpack_require__(3128);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ },
/* 3334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(3113);
	var DESCRIPTORS = __webpack_require__(3115);
	var LIBRARY = __webpack_require__(3137);
	var $typed = __webpack_require__(3333);
	var hide = __webpack_require__(3119);
	var redefineAll = __webpack_require__(3323);
	var fails = __webpack_require__(3116);
	var anInstance = __webpack_require__(3315);
	var toInteger = __webpack_require__(3147);
	var toLength = __webpack_require__(3146);
	var toIndex = __webpack_require__(3335);
	var gOPN = __webpack_require__(3158).f;
	var dP = __webpack_require__(3120).f;
	var arrayFill = __webpack_require__(3298);
	var setToStringTag = __webpack_require__(3133);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ },
/* 3335 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(3147);
	var toLength = __webpack_require__(3146);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ },
/* 3336 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3117);
	$export($export.G + $export.W + $export.F * !__webpack_require__(3333).ABV, {
	  DataView: __webpack_require__(3334).DataView
	});


/***/ },
/* 3337 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3338)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 3338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(3115)) {
	  var LIBRARY = __webpack_require__(3137);
	  var global = __webpack_require__(3113);
	  var fails = __webpack_require__(3116);
	  var $export = __webpack_require__(3117);
	  var $typed = __webpack_require__(3333);
	  var $buffer = __webpack_require__(3334);
	  var ctx = __webpack_require__(3129);
	  var anInstance = __webpack_require__(3315);
	  var propertyDesc = __webpack_require__(3126);
	  var hide = __webpack_require__(3119);
	  var redefineAll = __webpack_require__(3323);
	  var toInteger = __webpack_require__(3147);
	  var toLength = __webpack_require__(3146);
	  var toIndex = __webpack_require__(3335);
	  var toAbsoluteIndex = __webpack_require__(3148);
	  var toPrimitive = __webpack_require__(3125);
	  var has = __webpack_require__(3114);
	  var classof = __webpack_require__(3183);
	  var isObject = __webpack_require__(3122);
	  var toObject = __webpack_require__(3166);
	  var isArrayIter = __webpack_require__(3272);
	  var create = __webpack_require__(3154);
	  var getPrototypeOf = __webpack_require__(3167);
	  var gOPN = __webpack_require__(3158).f;
	  var getIterFn = __webpack_require__(3274);
	  var uid = __webpack_require__(3128);
	  var wks = __webpack_require__(3134);
	  var createArrayMethod = __webpack_require__(3282);
	  var createArrayIncludes = __webpack_require__(3145);
	  var speciesConstructor = __webpack_require__(3317);
	  var ArrayIterators = __webpack_require__(3303);
	  var Iterators = __webpack_require__(3238);
	  var $iterDetect = __webpack_require__(3275);
	  var setSpecies = __webpack_require__(3302);
	  var arrayFill = __webpack_require__(3298);
	  var arrayCopyWithin = __webpack_require__(3295);
	  var $DP = __webpack_require__(3120);
	  var $GOPD = __webpack_require__(3159);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ },
/* 3339 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3338)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 3340 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3338)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 3341 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3338)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 3342 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3338)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 3343 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3338)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 3344 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3338)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 3345 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3338)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 3346 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3338)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 3347 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(3117);
	var aFunction = __webpack_require__(3130);
	var anObject = __webpack_require__(3121);
	var rApply = (__webpack_require__(3113).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(3116)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ },
/* 3348 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(3117);
	var create = __webpack_require__(3154);
	var aFunction = __webpack_require__(3130);
	var anObject = __webpack_require__(3121);
	var isObject = __webpack_require__(3122);
	var fails = __webpack_require__(3116);
	var bind = __webpack_require__(3185);
	var rConstruct = (__webpack_require__(3113).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 3349 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(3120);
	var $export = __webpack_require__(3117);
	var anObject = __webpack_require__(3121);
	var toPrimitive = __webpack_require__(3125);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(3116)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 3350 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(3117);
	var gOPD = __webpack_require__(3159).f;
	var anObject = __webpack_require__(3121);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 3351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(3117);
	var anObject = __webpack_require__(3121);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(3239)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ },
/* 3352 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(3159);
	var getPrototypeOf = __webpack_require__(3167);
	var has = __webpack_require__(3114);
	var $export = __webpack_require__(3117);
	var isObject = __webpack_require__(3122);
	var anObject = __webpack_require__(3121);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ },
/* 3353 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(3159);
	var $export = __webpack_require__(3117);
	var anObject = __webpack_require__(3121);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 3354 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(3117);
	var getProto = __webpack_require__(3167);
	var anObject = __webpack_require__(3121);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ },
/* 3355 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ },
/* 3356 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(3117);
	var anObject = __webpack_require__(3121);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ },
/* 3357 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(3358) });


/***/ },
/* 3358 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(3158);
	var gOPS = __webpack_require__(3151);
	var anObject = __webpack_require__(3121);
	var Reflect = __webpack_require__(3113).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 3359 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(3117);
	var anObject = __webpack_require__(3121);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 3360 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(3120);
	var gOPD = __webpack_require__(3159);
	var getPrototypeOf = __webpack_require__(3167);
	var has = __webpack_require__(3114);
	var $export = __webpack_require__(3117);
	var createDesc = __webpack_require__(3126);
	var anObject = __webpack_require__(3121);
	var isObject = __webpack_require__(3122);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ },
/* 3361 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(3117);
	var setProto = __webpack_require__(3181);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 3362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(3117);
	var $includes = __webpack_require__(3145)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(3296)('includes');


/***/ },
/* 3363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(3117);
	var flattenIntoArray = __webpack_require__(3364);
	var toObject = __webpack_require__(3166);
	var toLength = __webpack_require__(3146);
	var aFunction = __webpack_require__(3130);
	var arraySpeciesCreate = __webpack_require__(3283);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(3296)('flatMap');


/***/ },
/* 3364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(3153);
	var isObject = __webpack_require__(3122);
	var toLength = __webpack_require__(3146);
	var ctx = __webpack_require__(3129);
	var IS_CONCAT_SPREADABLE = __webpack_require__(3134)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ },
/* 3365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(3117);
	var flattenIntoArray = __webpack_require__(3364);
	var toObject = __webpack_require__(3166);
	var toLength = __webpack_require__(3146);
	var toInteger = __webpack_require__(3147);
	var arraySpeciesCreate = __webpack_require__(3283);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(3296)('flatten');


/***/ },
/* 3366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(3117);
	var $at = __webpack_require__(3236)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 3367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3117);
	var $pad = __webpack_require__(3368);
	var userAgent = __webpack_require__(3369);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ },
/* 3368 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(3146);
	var repeat = __webpack_require__(3199);
	var defined = __webpack_require__(3144);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 3369 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(3113);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 3370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3117);
	var $pad = __webpack_require__(3368);
	var userAgent = __webpack_require__(3369);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ },
/* 3371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(3191)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ },
/* 3372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(3191)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ },
/* 3373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(3117);
	var defined = __webpack_require__(3144);
	var toLength = __webpack_require__(3146);
	var isRegExp = __webpack_require__(3243);
	var getFlags = __webpack_require__(3306);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(3239)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ },
/* 3374 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3136)('asyncIterator');


/***/ },
/* 3375 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3136)('observable');


/***/ },
/* 3376 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(3117);
	var ownKeys = __webpack_require__(3358);
	var toIObject = __webpack_require__(3141);
	var gOPD = __webpack_require__(3159);
	var createProperty = __webpack_require__(3273);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ },
/* 3377 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(3117);
	var $values = __webpack_require__(3378)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 3378 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(3139);
	var toIObject = __webpack_require__(3141);
	var isEnum = __webpack_require__(3152).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ },
/* 3379 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(3117);
	var $entries = __webpack_require__(3378)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 3380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var toObject = __webpack_require__(3166);
	var aFunction = __webpack_require__(3130);
	var $defineProperty = __webpack_require__(3120);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(3115) && $export($export.P + __webpack_require__(3381), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 3381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(3137) || !__webpack_require__(3116)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(3113)[K];
	});


/***/ },
/* 3382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var toObject = __webpack_require__(3166);
	var aFunction = __webpack_require__(3130);
	var $defineProperty = __webpack_require__(3120);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(3115) && $export($export.P + __webpack_require__(3381), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 3383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var toObject = __webpack_require__(3166);
	var toPrimitive = __webpack_require__(3125);
	var getPrototypeOf = __webpack_require__(3167);
	var getOwnPropertyDescriptor = __webpack_require__(3159).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(3115) && $export($export.P + __webpack_require__(3381), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 3384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3117);
	var toObject = __webpack_require__(3166);
	var toPrimitive = __webpack_require__(3125);
	var getPrototypeOf = __webpack_require__(3167);
	var getOwnPropertyDescriptor = __webpack_require__(3159).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(3115) && $export($export.P + __webpack_require__(3381), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 3385 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(3117);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(3386)('Map') });


/***/ },
/* 3386 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(3183);
	var from = __webpack_require__(3387);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },
/* 3387 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(3316);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 3388 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(3117);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(3386)('Set') });


/***/ },
/* 3389 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(3390)('Map');


/***/ },
/* 3390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(3117);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 3391 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(3390)('Set');


/***/ },
/* 3392 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(3390)('WeakMap');


/***/ },
/* 3393 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(3390)('WeakSet');


/***/ },
/* 3394 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(3395)('Map');


/***/ },
/* 3395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(3117);
	var aFunction = __webpack_require__(3130);
	var ctx = __webpack_require__(3129);
	var forOf = __webpack_require__(3316);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 3396 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(3395)('Set');


/***/ },
/* 3397 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(3395)('WeakMap');


/***/ },
/* 3398 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(3395)('WeakSet');


/***/ },
/* 3399 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(3117);
	
	$export($export.G, { global: __webpack_require__(3113) });


/***/ },
/* 3400 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'System', { global: __webpack_require__(3113) });


/***/ },
/* 3401 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(3117);
	var cof = __webpack_require__(3143);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ },
/* 3402 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ },
/* 3403 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ },
/* 3404 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3117);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ },
/* 3405 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3117);
	var scale = __webpack_require__(3406);
	var fround = __webpack_require__(3222);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ },
/* 3406 */
/***/ function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ },
/* 3407 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ },
/* 3408 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ },
/* 3409 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ },
/* 3410 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ },
/* 3411 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3117);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ },
/* 3412 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Math', { scale: __webpack_require__(3406) });


/***/ },
/* 3413 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ },
/* 3414 */
/***/ function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(3117);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ },
/* 3415 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(3117);
	var core = __webpack_require__(3118);
	var global = __webpack_require__(3113);
	var speciesConstructor = __webpack_require__(3317);
	var promiseResolve = __webpack_require__(3322);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 3416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(3117);
	var newPromiseCapability = __webpack_require__(3320);
	var perform = __webpack_require__(3321);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 3417 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(3418);
	var anObject = __webpack_require__(3121);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ },
/* 3418 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(3324);
	var $export = __webpack_require__(3117);
	var shared = __webpack_require__(3132)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(3329))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ },
/* 3419 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(3418);
	var anObject = __webpack_require__(3121);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ },
/* 3420 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(3418);
	var anObject = __webpack_require__(3121);
	var getPrototypeOf = __webpack_require__(3167);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 3421 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(3328);
	var from = __webpack_require__(3387);
	var metadata = __webpack_require__(3418);
	var anObject = __webpack_require__(3121);
	var getPrototypeOf = __webpack_require__(3167);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 3422 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(3418);
	var anObject = __webpack_require__(3121);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 3423 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(3418);
	var anObject = __webpack_require__(3121);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 3424 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(3418);
	var anObject = __webpack_require__(3121);
	var getPrototypeOf = __webpack_require__(3167);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 3425 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(3418);
	var anObject = __webpack_require__(3121);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 3426 */
/***/ function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(3418);
	var anObject = __webpack_require__(3121);
	var aFunction = __webpack_require__(3130);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ },
/* 3427 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(3117);
	var microtask = __webpack_require__(3319)();
	var process = __webpack_require__(3113).process;
	var isNode = __webpack_require__(3143)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ },
/* 3428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(3117);
	var global = __webpack_require__(3113);
	var core = __webpack_require__(3118);
	var microtask = __webpack_require__(3319)();
	var OBSERVABLE = __webpack_require__(3134)('observable');
	var aFunction = __webpack_require__(3130);
	var anObject = __webpack_require__(3121);
	var anInstance = __webpack_require__(3315);
	var redefineAll = __webpack_require__(3323);
	var hide = __webpack_require__(3119);
	var forOf = __webpack_require__(3316);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(3302)('Observable');


/***/ },
/* 3429 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(3113);
	var $export = __webpack_require__(3117);
	var userAgent = __webpack_require__(3369);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ },
/* 3430 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3117);
	var $task = __webpack_require__(3318);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ },
/* 3431 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(3303);
	var getKeys = __webpack_require__(3139);
	var redefine = __webpack_require__(3127);
	var global = __webpack_require__(3113);
	var hide = __webpack_require__(3119);
	var Iterators = __webpack_require__(3238);
	var wks = __webpack_require__(3134);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 3432 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 3433 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3434);
	module.exports = __webpack_require__(3118).RegExp.escape;


/***/ },
/* 3434 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(3117);
	var $re = __webpack_require__(3435)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ },
/* 3435 */
/***/ function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ },
/* 3436 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3437);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/less-loader/lib/loader.js!./index.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/less-loader/lib/loader.js!./index.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3437 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	exports.i(__webpack_require__(256), "");
	exports.i(__webpack_require__(3438), "");
	exports.i(__webpack_require__(255), "");
	
	// module
	exports.push([module.id, "@-webkit-keyframes in-progress-rotate{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes in-progress-rotate{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}html,body{margin:0;padding:0;background-color:#f0f0f0}html{height:100%}body{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;min-height:100%}.pre-angular-render{position:relative;-webkit-transition:all ease-in-out .1s;transition:all ease-in-out .1s;color:transparent;height:100%}.pre-angular-render:after{content:'';position:absolute;display:block;top:50%;left:50%;width:18px;height:18px;margin-top:-12px;margin-left:-12px;-webkit-border-radius:100%;border-radius:100%;border:solid 3px transparent;-webkit-animation:none;animation:none}.pre-angular-render:hover{color:transparent}.pre-angular-render:after{z-index:2;border-color:#1d2c4c;border-bottom-color:transparent;-webkit-animation:in-progress-rotate .6s infinite linear;animation:in-progress-rotate .6s infinite linear}.pre-angular-render.in-progress{color:transparent}.pre-angular-render.in-progress:hover{color:transparent}.pre-angular-render.in-progress:after{z-index:2;border-color:#1d2c4c;border-bottom-color:transparent;-webkit-animation:in-progress-rotate .6s infinite linear;animation:in-progress-rotate .6s infinite linear}.application-wrapper{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1;-webkit-flex-basis:1600px;-ms-flex-preferred-size:1600px;flex-basis:1600px;max-width:1600px;margin:0 auto;background-color:#fff;overflow-x:hidden}main{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1;-ms-flex-preferred-size:auto}input:-webkit-autofill{background-color:#fff !important}:focus{outline:0;border-color:#1c85e8}.touch label{-webkit-tap-highlight-color:transparent}ul{margin:0}od-comps-map,[od-comps-map]{display:block;height:320px}od-comps-map .leaflet-container,[od-comps-map] .leaflet-container{z-index:1}od-comps-map .price-icon,[od-comps-map] .price-icon{position:absolute;margin-top:-36px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;padding:8px;background-color:#fff;font-size:12px;font-weight:500}od-comps-map .price-icon:after,[od-comps-map] .price-icon:after{top:100%;left:50%;border:solid transparent;content:\"\";height:0;width:0;position:absolute;pointer-events:none;border-top-color:#fff;border-width:6px;margin-left:-6px}od-comps-map .price-icon.subject,[od-comps-map] .price-icon.subject{background-color:#1c85e8;color:#fff;margin-left:-60px;width:120px}od-comps-map .price-icon.subject .ellipsis,[od-comps-map] .price-icon.subject .ellipsis{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}od-comps-map .price-icon.subject:after,[od-comps-map] .price-icon.subject:after{border-top-color:#1c85e8}od-comps-map .price-icon.comp,[od-comps-map] .price-icon.comp{margin-left:-45px;width:90px;-webkit-box-shadow:0 0 5px rgba(0,0,0,0.2);box-shadow:0 0 5px rgba(0,0,0,0.2)}od-comps-map .price-icon .comp-label,[od-comps-map] .price-icon .comp-label{color:#1c85e8;margin-right:6px;font-size:10px;text-transform:uppercase}od-comps-map .price-icon.hover,[od-comps-map] .price-icon.hover{background-color:#318db4;color:#fff}od-comps-map .price-icon.hover:after,[od-comps-map] .price-icon.hover:after{border-top-color:#318db4}od-comps-map .price-icon.hover .comp-label,[od-comps-map] .price-icon.hover .comp-label{color:#fff}od-comps-map .marker-overlay,[od-comps-map] .marker-overlay{position:absolute;margin-top:-8px;padding-top:8px;z-index:0;font-size:12px;text-align:left}od-comps-map .marker-overlay img,[od-comps-map] .marker-overlay img{height:80px;max-width:100px;padding-right:12px;float:left}od-comps-map .marker-overlay .hover-details,[od-comps-map] .marker-overlay .hover-details{-webkit-box-shadow:0 0 2px 1px rgba(192,192,191,0.3);box-shadow:0 0 2px 1px rgba(192,192,191,0.3);visibility:hidden;opacity:0;line-height:150%;background:#fff;color:#595959;overflow:hidden;-webkit-border-radius:3px;border-radius:3px;height:80px;width:310px;margin-top:5px;-webkit-transform:translateY(5px);transform:translateY(5px);-webkit-transition:opacity ease-in-out .3s,-webkit-transform ease-in-out .3s;transition:opacity ease-in-out .3s,-webkit-transform ease-in-out .3s;transition:transform ease-in-out .3s,opacity ease-in-out .3s;transition:transform ease-in-out .3s,opacity ease-in-out .3s,-webkit-transform ease-in-out .3s}od-comps-map .marker-overlay .info,[od-comps-map] .marker-overlay .info{padding:12px;padding-top:.5em}od-comps-map .marker-overlay.hover,[od-comps-map] .marker-overlay.hover{z-index:2000}od-comps-map .marker-overlay.hover .hover-details,[od-comps-map] .marker-overlay.hover .hover-details{visibility:visible;opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}.pika-single button{min-width:0}.pika-single .pika-prev,.pika-single .pika-next{width:20px !important}.pika-single .pika-button{padding:5px !important}.set-close-date-datepicker-pre-sign .is-disabled,.set-close-date-datepicker-post-sign .is-disabled{position:relative}.set-close-date-datepicker-pre-sign .is-disabled::after,.set-close-date-datepicker-post-sign .is-disabled::after{background-color:#fff;bottom:20px;-webkit-box-shadow:0 1px 5px 0 rgba(0,0,0,0.5);box-shadow:0 1px 5px 0 rgba(0,0,0,0.5);color:#9ba1a6;font-family:'Graphik',sans-serif;font-size:16px;left:35px;opacity:0;padding:0 10px;position:absolute;-webkit-transition:opacity .15s;transition:opacity .15s;visibility:hidden;width:200px;z-index:9999}.set-close-date-datepicker-pre-sign .is-disabled:hover::after,.set-close-date-datepicker-post-sign .is-disabled:hover::after{opacity:1;visibility:visible}.pika-single.set-close-date-datepicker-pre-sign .is-disabled::after{content:'This day is unavailable. If you need to close on this day, please contact your Home Advisor.'}.pika-single.set-close-date-datepicker-post-sign .is-disabled::after{content:'This day is unavailable. If you need to close on this day, please contact your Closing Manager.'}.photo-carousel .photo-carousel-container{position:relative;width:100%}.photo-carousel .photo-carousel-item{width:100%;height:100%}.photo-carousel .photo-carousel-control-mixin{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);background-color:rgba(255,255,255,0.5);width:50px;height:50px;opacity:1;color:white;cursor:pointer;-webkit-border-radius:50%;border-radius:50%;-webkit-transition:opacity .25s ease-in-out;transition:opacity .25s ease-in-out}.photo-carousel .photo-carousel-control-mixin .icon{fill:rgba(0,0,0,0.6);position:relative;top:13px;left:-15px}.photo-carousel .photo-carousel-control-mixin:hover{opacity:1}.photo-carousel .photo-carousel-next{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);background-color:rgba(255,255,255,0.5);width:50px;height:50px;opacity:1;color:white;cursor:pointer;-webkit-border-radius:50%;border-radius:50%;-webkit-transition:opacity .25s ease-in-out;transition:opacity .25s ease-in-out;right:10px;text-align:right}.photo-carousel .photo-carousel-next .icon{fill:rgba(0,0,0,0.6);position:relative;top:13px;left:-15px}.photo-carousel .photo-carousel-next:hover{opacity:1}.photo-carousel .photo-carousel-prev{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);background-color:rgba(255,255,255,0.5);width:50px;height:50px;opacity:1;color:white;cursor:pointer;-webkit-border-radius:50%;border-radius:50%;-webkit-transition:opacity .25s ease-in-out;transition:opacity .25s ease-in-out;left:10px}.photo-carousel .photo-carousel-prev .icon{fill:rgba(0,0,0,0.6);position:relative;top:13px;left:-15px}.photo-carousel .photo-carousel-prev:hover{opacity:1}.photo-carousel .photo-carousel-prev .icon{left:15px}.oc-details-map{height:320px}.oc-details-map .leaflet-container{z-index:1}.oc-details-map .price-icon{-webkit-border-radius:14px;border-radius:14px;margin-left:-50px;margin-top:-30px;padding:.3em 14px;width:100px;background-color:#1c85e8;color:#fff;font-weight:400;text-align:center}.oc-details-map .price-icon:after{top:100%;left:50%;border:solid transparent;content:\"\";height:0;width:0;position:absolute;pointer-events:none;border-top-color:#1c85e8;border-width:6px;margin-left:-6px}.oc-details-map .price-icon.hover{background-color:#318db4}.oc-details-map .price-icon.hover:after{border-top-color:#318db4}.oc-details-map .price-icon.subject{background-color:#0d67f8}.oc-details-map .price-icon.subject:after{border-top-color:#0d67f8}.oc-details-map .marker-overlay{position:absolute;margin-top:-8px;padding-top:8px;z-index:0;text-align:left}.oc-details-map .marker-overlay img{height:80px;max-width:100px;padding-right:12px;float:left}.oc-details-map .marker-overlay .hover-details{-webkit-box-shadow:0 0 2px 1px rgba(192,192,191,0.3);box-shadow:0 0 2px 1px rgba(192,192,191,0.3);visibility:hidden;opacity:0;line-height:150%;background:#fff;color:#595959;overflow:hidden;-webkit-border-radius:3px;border-radius:3px;height:80px;width:310px;margin-top:5px;-webkit-transform:translateY(5px);transform:translateY(5px);-webkit-transition:opacity ease-in-out .3s,-webkit-transform ease-in-out .3s;transition:opacity ease-in-out .3s,-webkit-transform ease-in-out .3s;transition:transform ease-in-out .3s,opacity ease-in-out .3s;transition:transform ease-in-out .3s,opacity ease-in-out .3s,-webkit-transform ease-in-out .3s}.oc-details-map .marker-overlay .info{padding:12px;padding-top:.5em}.oc-details-map .marker-overlay.hover{z-index:2000}.oc-details-map .marker-overlay.hover .hover-details{visibility:visible;opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}od-market-analysis-chart{display:block;font-size:14px}od-market-analysis-chart svg:not(:root){overflow:visible}od-market-analysis-chart .axis line,od-market-analysis-chart .axis path{fill:none;stroke:rgba(192,192,191,0.3);shape-rendering:crispEdges}od-market-analysis-chart .grid line{fill:none;stroke:rgba(192,192,191,0.3);shape-rendering:crispEdges}od-market-analysis-chart .grid path{display:none}od-market-analysis-chart path.line,od-market-analysis-chart .legend line{fill:none}od-market-analysis-chart path.line.postal_code,od-market-analysis-chart .legend line.postal_code{stroke:#1c85e8;stroke-width:3px}od-market-analysis-chart path.line.city,od-market-analysis-chart .legend line.city{stroke:#4e6373;stroke-dasharray:6,2}od-market-analysis-chart path.line.market,od-market-analysis-chart .legend line.market{stroke:#9ba1a6;stroke-dasharray:6,2}@-webkit-keyframes bounce{0%,20%,50%,80%,100%{-webkit-transform:translateY(0);transform:translateY(0)}40%{-webkit-transform:translateY(-20px);transform:translateY(-20px)}60%{-webkit-transform:translateY(-10px);transform:translateY(-10px)}}@keyframes bounce{0%,20%,50%,80%,100%{-webkit-transform:translateY(0);transform:translateY(0)}40%{-webkit-transform:translateY(-20px);transform:translateY(-20px)}60%{-webkit-transform:translateY(-10px);transform:translateY(-10px)}}img.tracking-pixel{width:1px;height:1px;border-style:none;position:absolute;top:-1000px;left:-1000px}.background-image,.background-image-top{background-size:cover;background-position:center;background-color:#f5f8fb;background-repeat:no-repeat}.background-image-top{background-position:center top}.od-xhr-progress{position:relative;-webkit-transition:all ease-in-out .1s;transition:all ease-in-out .1s}.od-xhr-progress:after{content:'';position:absolute;display:block;top:50%;left:50%;width:18px;height:18px;margin-top:-12px;margin-left:-12px;-webkit-border-radius:100%;border-radius:100%;border:solid 3px transparent;-webkit-animation:none;animation:none}.od-xhr-progress.in-progress{color:transparent}.od-xhr-progress.in-progress:hover{color:transparent}.od-xhr-progress.in-progress:after{z-index:2;border-color:#fff;border-bottom-color:transparent;-webkit-animation:in-progress-rotate .6s infinite linear;animation:in-progress-rotate .6s infinite linear}.od-xhr-progress.dark{position:relative;-webkit-transition:all ease-in-out .1s;transition:all ease-in-out .1s}.od-xhr-progress.dark:after{content:'';position:absolute;display:block;top:50%;left:50%;width:18px;height:18px;margin-top:-12px;margin-left:-12px;-webkit-border-radius:100%;border-radius:100%;border:solid 3px transparent;-webkit-animation:none;animation:none}.od-xhr-progress.dark.in-progress{color:transparent}.od-xhr-progress.dark.in-progress:hover{color:transparent}.od-xhr-progress.dark.in-progress:after{z-index:2;border-color:#9ba1a6;border-bottom-color:transparent;-webkit-animation:in-progress-rotate .6s infinite linear;animation:in-progress-rotate .6s infinite linear}.inline{display:inline-block !important}.compact{padding:0;margin:0}.pre{white-space:pre-line}.vw100{width:100vw}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}html.js [ng\\:cloak],html.js [ng-cloak],html.js [data-ng-cloak],html.js [x-ng-cloak],html.js .ng-cloak,html.js .x-ng-cloak{display:none !important}@media (min-width:480px){.hidden-xs-up{display:none !important}}@media (min-width:768px){.hidden-sm-up{display:none !important}}@media (min-width:992px){.hidden-md-up{display:none !important}}@media (min-width:1200px){.hidden-lg-up{display:none !important}}@media (max-width:479px){.hidden-xxs-down{display:none !important}}@media (max-width:767px){.hidden-xs-down{display:none !important}}@media (max-width:991px){.hidden-sm-down{display:none !important}}@media (max-width:1199px){.hidden-md-down{display:none !important}}@media (max-width:1200px){.hidden-lg-down{display:none !important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none !important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none !important}}.pager li{display:inline-block}.pager li .button{min-width:140px}.pager li+li{margin-left:5px}.text-space-between{margin-left:-2px;margin-right:-2px}.text-space-between>*{margin-left:2px;margin-right:2px}img.img-circle{-webkit-border-radius:100%;border-radius:100%}img.img-circle.large{width:90px;height:90px}img.img-circle.medium{width:70px;height:70px}img.img-circle.small{width:50px;height:50px}.oc-login-link .ng-enter,.oc-login-link .ng-leave,.oc-login-link .ng-animate{-webkit-transition:none !important;transition:none !important;-webkit-animation:none 0s;animation:none 0s}.cursor-pointer{cursor:pointer}.flex-center-content{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}.flex-right-content{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end}.flex-align-center{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}.flex-align-end{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:end;-webkit-align-items:flex-end;-ms-flex-align:end;align-items:flex-end}.flex-space-between-content{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.flex{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.flex-wrap{-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.flex-grow{-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1}@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}body,input,select{text-rendering:optimizeLegibility;font:400 16px/1.7 'Graphik',sans-serif;color:#525975}div,span,h1,h2,h3,h4,h5,h6,p,q{margin-top:0;margin-bottom:0;-webkit-font-smoothing:antialiased}h1{font:600 44px/1.45 'Publico',serif;color:#1d2c4c}h1.huge-headline{font-size:70px;line-height:70px}@media (max-width:767px){h1.huge-headline{font-size:44px;line-height:44px}}h1.big-headline{font-size:50px}@media (max-width:767px){h1.big-headline{font-size:32px}}h1.medium-headline{font-size:44px}@media (max-width:767px){h1.medium-headline{font-size:32px}}h1.small-headline{font-size:32px}@media (max-width:767px){h1.small-headline{font-size:24px}}h2{font:400 32px/1.45 'Graphik',sans-serif;color:#1d2c4c}h2.medium-headline{font-size:32px}@media (max-width:767px){h2.medium-headline{font-size:28px}}h2.smallcaps-headline{font-size:12px;font-weight:500;color:#1c85e8;text-transform:uppercase}h3{font:500 28px/1.45 'Graphik',sans-serif;color:#1d2c4c}h4{font:500 24px/1.45 'Graphik',sans-serif;color:#1d2c4c}h5{font:500 22px/1.45 'Graphik',sans-serif;color:#1d2c4c}h5.light{font-weight:normal}h6{font:500 18px/1.45 'Graphik',sans-serif;color:#1d2c4c}pre{white-space:pre-wrap}b,strong{font-weight:500}.text-left{text-align:left}.text-center{text-align:center}.text-center-narrow{margin-left:auto;margin-right:auto;max-width:650px;text-align:center}.text-right{text-align:right}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-prewrap{white-space:pre-wrap}.text-muted{color:#9ba1a6}.text-blue{color:#1c85e8}.text-capitalize{text-transform:capitalize}.text-uppercase{text-transform:uppercase}.text-underline{text-decoration:underline}.text-small{font-size:12px}.text-product-medium{font-size:14px}.text-medium{font-size:16px}.text-product-large{font-size:18px}.text-large{font-size:22px}.text-x-small{font-size:10px}.text-no-letter-spacing{letter-spacing:0}.text-highlight{color:#1c85e8}.text-light{font-weight:300}.text-italic{font-style:italic}.text-bold{font-weight:500}.text-bolder{font-weight:600}.text-white{color:#fff}.small{font-size:12px}.no-letter-spacing{letter-spacing:0}.highlight{color:#1c85e8}.extra-bottom-margin{margin-bottom:1em !important}.text-black{color:#595959}.text-dark-gray{color:#70828f}.text-purple{color:#ab80de}.text-green{color:#68e1c7}.text-blue{color:#1c85e8}.text-red{color:#ff7f82}@media (max-width:767px){.text-center-xs-down{text-align:center}}@media (max-width:991px){.text-center-sm-down{text-align:center}}a{color:#1c85e8;text-decoration:none;-webkit-transition:color .15s cubic-bezier(.1, .7, .1, 1);transition:color .15s cubic-bezier(.1, .7, .1, 1);-webkit-tap-highlight-color:transparent}a:hover{-webkit-transition:color .15s cubic-bezier(.1, .7, .1, 1);transition:color .15s cubic-bezier(.1, .7, .1, 1);color:#03476b}a.text-underline{text-decoration:underline}.chapeau{position:relative;padding-bottom:20px;text-transform:uppercase;font-size:12px;font-family:'Graphik',sans-serif;font-weight:500}.chapeau::after{content:'';position:absolute;bottom:0;left:50%;margin-left:-13px;height:2px;width:26px;background:rgba(0,0,0,0.1)}q{display:block}q::before{content:'\\201C'}q::after{content:'\\201D'}.prose h1{margin-top:0;margin-bottom:.3em}.prose h2,.prose h3,.prose h4,.prose h5,.prose h6,.prose p,.prose q{margin-top:0;margin-bottom:.5em}h1.prose{margin-top:0;margin-bottom:.3em}h1.prose,h2.prose,h3.prose,h4.prose,h5.prose,h6.prose,p.prose,q.prose{margin-top:0;margin-bottom:.5em}.section-header{padding-top:4rem;padding-bottom:4rem}.rn-carousel-control{-webkit-border-radius:4px;border-radius:4px;font-size:1rem;top:45%}.rn-carousel-control:hover{background-color:#70828f}.rn-carousel-control .icon{fill:white}.rn-carousel-control.rn-carousel-control-prev{-webkit-transform:rotateZ(180deg);transform:rotateZ(180deg)}.rn-carousel-control.rn-carousel-control-prev::before,.rn-carousel-control.rn-carousel-control-next::before{content:''}.arrow-button{display:block;text-align:center;margin-top:1em}.arrow-button .icon{fill:#fff;-webkit-animation:bounce 1.5s 3;animation:bounce 1.5s 3;-webkit-animation-delay:2.5s;animation-delay:2.5s}aside.left,aside.right{width:33%;-webkit-box-sizing:border-box;box-sizing:border-box;background-color:white;padding-right:48px}aside.left h5,aside.right h5{margin:1em 0 1em}aside.left p,aside.right p{margin:0;margin-bottom:5px}aside.left{float:left;text-align:left}aside.left~*{margin-left:33%}aside.right{float:right;margin-left:3%;text-align:center}aside.right~*{margin-right:33%}@media (max-width:767px){aside.left,aside.right{float:none;width:auto;text-align:center;margin-left:0;margin-right:0;padding:0}aside.left~*{margin-left:0 !important}aside.right~*{margin-right:0 !important}}.card{position:relative}.card .card-arrow-mixin{overflow:visible;min-height:15px}.card .card-arrow-mixin:after{content:\"\";background-color:#fff;width:20px;height:20px;position:absolute;z-index:1}.card .card-arrow-mixin .card-body{z-index:2}.card.card-arrow-bottom{overflow:visible;min-height:15px;margin-bottom:24px;border-bottom:1px solid #dedede}.card.card-arrow-bottom:after{content:\"\";background-color:#fff;width:20px;height:20px;position:absolute;z-index:1}.card.card-arrow-bottom .card-body{z-index:2}.card.card-arrow-bottom .card-body:last-child:not(.no-border){border-bottom:none}.card.card-arrow-bottom:after{-webkit-box-shadow:1px 1px 0 #fff,1px 1px 1px #dedede;box-shadow:1px 1px 0 #fff,1px 1px 1px #dedede;bottom:0;left:50%;-webkit-transform:translateY(9px) translateX(-50%) rotate(45deg);transform:translateY(9px) translateX(-50%) rotate(45deg)}.card.card-arrow-top{overflow:visible;min-height:15px;margin-top:24px;border-top:1px solid #dedede}.card.card-arrow-top:after{content:\"\";background-color:#fff;width:20px;height:20px;position:absolute;z-index:1}.card.card-arrow-top .card-body{z-index:2}.card.card-arrow-top .card-body:first-of-type{border-top:none}.card.card-arrow-top:after{-webkit-box-shadow:-1px -1px 1px #eaebeb;box-shadow:-1px -1px 1px #eaebeb;top:0;left:50%;-webkit-transform:translateY(-9px) translateX(-50%) rotate(45deg);transform:translateY(-9px) translateX(-50%) rotate(45deg)}.oc-details-map .price-icon{font-family:'Graphik',sans-serif;font-size:16px}.oc-details-map .marker-overlay{font-size:12px}.listing-card-carousel .photo-carousel-item{height:240px}live-demo-block ul.nav.nav-tabs>li,[live-demo-block] ul.nav.nav-tabs>li{cursor:pointer;display:inline-block;font-weight:500;position:relative}live-demo-block ul.nav.nav-tabs>li a,[live-demo-block] ul.nav.nav-tabs>li a{color:#525975;font-size:10px;text-transform:uppercase;padding:0 5px 6px 5px}live-demo-block ul.nav.nav-tabs>li a:hover,[live-demo-block] ul.nav.nav-tabs>li a:hover{-webkit-box-shadow:0 2px 0 0 #dedede;box-shadow:0 2px 0 0 #dedede}live-demo-block ul.nav.nav-tabs>li+li,[live-demo-block] ul.nav.nav-tabs>li+li{margin-left:30px}live-demo-block ul.nav.nav-tabs>li.active a,[live-demo-block] ul.nav.nav-tabs>li.active a{-webkit-box-shadow:0 2px 0 0 #1c85e8;box-shadow:0 2px 0 0 #1c85e8}.map-home-info .card{padding-bottom:0}.map-home-info .card .row{padding-top:1.2em;padding-bottom:1.2em;line-height:100%}.map-home-info .card .row+.row,.map-home-info .card .button-row{border-top:solid 1px rgba(192,192,191,0.3)}od-comps-map .price-icon,[od-comps-map] .price-icon{font-family:'Graphik',sans-serif}od-comps-map .price-icon.subject,[od-comps-map] .price-icon.subject{background-color:#1c85e8}od-comps-map .price-icon.subject:after,[od-comps-map] .price-icon.subject:after{border-top-color:#1c85e8}od-listing-filter-form,[od-listing-filter-form]{font-size:14px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}od-listing-filter-form .form,[od-listing-filter-form] .form{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}od-listing-filter-form .filter-row,[od-listing-filter-form] .filter-row{padding:16px 0}od-listing-filter-form .flex-value-container,[od-listing-filter-form] .flex-value-container{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}od-listing-filter-form input,[od-listing-filter-form] input{width:100%;-webkit-box-shadow:none;box-shadow:none;border:1px solid #dedede;-webkit-border-radius:2px;border-radius:2px;font-size:12px}od-listing-filter-form .filter-dropdown,[od-listing-filter-form] .filter-dropdown{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1;font-size:12px}od-listing-status .text-double-letter-spacing{letter-spacing:.2em}od-press{display:block}od-press .od-press-logos{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;white-space:nowrap}od-press .od-press-logos img{display:block;height:20px;margin:0 48px}@media (max-width:1199px){od-press .od-press-logos img{margin:0 30px}}@media (max-width:767px){od-press .od-press-logos img{height:15px;margin:12px 12px;display:inline-block}}@media (max-width:479px){od-press .od-press-logos img{height:10px}}od-press .od-press-logos img.azcentral{height:30px}@media (max-width:767px){od-press .od-press-logos img.azcentral{height:20px}}od-press .od-press-expanded li{text-align:left;margin-bottom:4em}od-press .od-press-expanded hr{width:32px;margin:16px 0;border:none;border-bottom:1px solid rgba(192,192,191,0.3)}od-press .od-press-expanded a q{color:#70828f}od-press .od-press-expanded img{height:24px}od-press .od-press-expanded img#fortune{width:133px}od-press .od-press-expanded img#azcentral{width:72px}od-press .od-press-expanded img#wsj{width:237px}od-search-map,[od-search-map]{display:block}od-search-map button,[od-search-map] button{min-width:0;-webkit-box-shadow:none;box-shadow:none}od-search-map .mapboxgl-ctrl-compass,[od-search-map] .mapboxgl-ctrl-compass{display:none}od-testimonial-block,[od-testimonial-block]{display:block;margin-top:20px;margin-bottom:20px;text-align:center}od-testimonial-block h1.quote,[od-testimonial-block] h1.quote{position:relative;font-family:'Georgia';font-size:60px;color:#1c85e8;margin-bottom:-0.4em}od-testimonial-block .nav-circle,[od-testimonial-block] .nav-circle{display:inline-block;width:4px;height:4px;margin-left:2px;margin-right:2px;-webkit-border-radius:50%;border-radius:50%;border:1px solid #f0f0f0;cursor:pointer}od-testimonial-block .nav-circle.active,[od-testimonial-block] .nav-circle.active{background:#1c85e8;border:1px solid #1c85e8}od-testimonial-block .byline,[od-testimonial-block] .byline{margin-top:2em;margin-bottom:2em}od-testimonial-block od-testimonial,[od-testimonial-block] od-testimonial,od-testimonial-block [od-testimonial],[od-testimonial-block] [od-testimonial]{display:block;width:100%}od-tooltip od-tooltip-hover,[od-tooltip] od-tooltip-hover,od-tooltip [od-tooltip-hover],[od-tooltip] [od-tooltip-hover]{background-color:#fff;-webkit-border-radius:2px;border-radius:2px;border:1px solid #1c85e8;font-size:16px;font:400 12px/1.7 'Graphik',sans-serif;color:#595959;white-space:initial;text-transform:initial}od-tooltip.help-text od-tooltip-hover,[od-tooltip].help-text od-tooltip-hover,od-tooltip.help-text [od-tooltip-hover],[od-tooltip].help-text [od-tooltip-hover]{width:250px;padding:32px;text-align:left;font-size:12px}.od-place-autocomplete{background:#fff;-webkit-border-radius:3px;border-radius:3px;max-width:800px}.od-place-autocomplete ul:after{content:'powered by Google';background:url('https://images.opendoor.com/source/s3/imgdrop-production/powered-by-google.png?service=web') no-repeat center;background-size:104px 16px;font-size:14px;color:transparent;width:98%;display:block}.od-place-autocomplete .inline-error{background-color:#ec7046}.od-place-autocomplete .inline-error a{text-decoration:underline;color:#fff}.od-place-autocomplete .button.submit{position:absolute}.od-place-autocomplete.with-button input{border:1px solid #1c85e8;display:inline-block;width:100%;font-weight:500;font-size:16px;padding:15px 20px;background:none;-webkit-border-radius:3px;border-radius:3px;vertical-align:middle;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden;position:relative;overflow:hidden;-webkit-transition-property:color,-webkit-border-radius;transition-property:color,-webkit-border-radius;transition-property:color,border-radius;transition-property:color,border-radius,-webkit-border-radius;-webkit-transition-duration:.3s;transition-duration:.3s;z-index:1}.od-place-autocomplete.with-button input::-webkit-input-placeholder{color:#1c85e8;opacity:1}.od-place-autocomplete.with-button input:-ms-input-placeholder{color:#1c85e8;opacity:1}.od-place-autocomplete.with-button input::placeholder{color:#1c85e8;opacity:1}.od-place-autocomplete.with-button input:focus{-webkit-border-radius:0;border-radius:0;border:1px solid #fff;-webkit-box-shadow:0 0 10px #f0f0f0;box-shadow:0 0 10px #f0f0f0}.od-place-autocomplete.with-button input:focus::-webkit-input-placeholder{color:#9ba1a6}.od-place-autocomplete.with-button input:focus:-ms-input-placeholder{color:#9ba1a6}.od-place-autocomplete.with-button input:focus::placeholder{color:#9ba1a6}.od-place-autocomplete.with-button ul{width:100%}.od-place-autocomplete.with-button .button.submit{width:100%;height:100%;overflow:hidden;left:0;top:0;text-align:right;vertical-align:middle;color:#1c85e8;-webkit-border-radius:0;border-radius:0;padding-top:17px;font-size:12px}.od-place-autocomplete.with-button a:before{content:\"\";position:absolute;top:0;right:0;bottom:0;opacity:.5;z-index:0;width:100px;height:100px;background:#f5f7f8;border-shadow:0 0 0 #f0f0f0;-webkit-border-radius:100%;border-radius:100%;-webkit-transform:scale(0);transform:scale(0);-webkit-transition-property:opacity,-webkit-transform;transition-property:opacity,-webkit-transform;transition-property:transform,opacity;transition-property:transform,opacity,-webkit-transform;-webkit-transition-duration:.5s;transition-duration:.5s;-webkit-transition-timing-function:ease-out;transition-timing-function:ease-out}.od-place-autocomplete.with-button input:focus+a:before{-webkit-transform:scale(32);transform:scale(32);opacity:1}@media (max-width:478px){.front .od-place-autocomplete{display:none}}[od-scroll-enter]{position:relative;-webkit-transition-property:all;transition-property:all;-webkit-transition-duration:.5s;transition-duration:.5s;-webkit-transition-timing-function:ease-in-out;transition-timing-function:ease-in-out;opacity:0;visibility:hidden}[od-scroll-enter].scrolled{opacity:1;visibility:visible}[od-scroll-enter].fade-in-up{top:20px}[od-scroll-enter].fade-in-up.scrolled{top:0}[od-scroll-enter].fade-in-down{top:-20px}[od-scroll-enter].fade-in-down.scrolled{top:0}[od-scroll-enter].fade-in-left{left:-20px}[od-scroll-enter].fade-in-left.scrolled{left:0}[od-scroll-enter].fade-in-right{right:-20px}[od-scroll-enter].fade-in-right.scrolled{right:0}[od-scroll-enter].zoom-in{-webkit-transform:scale(.8);transform:scale(.8)}[od-scroll-enter].zoom-in.scrolled{-webkit-transform:scale(1);transform:scale(1)}[od-scroll-enter].flip-in-x{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, 90deg);transform:perspective(400px) rotate3d(1, 0, 0, 90deg)}[od-scroll-enter].flip-in-x.scrolled{-webkit-transform:perspective(400px);transform:perspective(400px)}[od-scroll-enter].flip-in-y{-webkit-transform:perspective(400px) rotate3d(0, 1, 0, 90deg);transform:perspective(400px) rotate3d(0, 1, 0, 90deg)}[od-scroll-enter].flip-in-y.scrolled{-webkit-transform:perspective(400px);transform:perspective(400px)}[od-scroll-enter].delay-200ms{-webkit-transition-delay:200ms;transition-delay:200ms}[od-scroll-enter].delay-400ms{-webkit-transition-delay:400ms;transition-delay:400ms}[od-scroll-enter].delay-600ms{-webkit-transition-delay:600ms;transition-delay:600ms}[od-scroll-enter].delay-800ms{-webkit-transition-delay:800ms;transition-delay:800ms}[od-scroll-enter].delay-1s{-webkit-transition-delay:1s;transition-delay:1s}[side-scroll-hint]{position:relative;overflow:hidden}.side-scroll-hint-container{overflow-x:auto}.side-scroll-hint-container::-webkit-scrollbar{height:18px}.side-scroll-hint-container::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 5px #dedede}.side-scroll-hint-container::-webkit-scrollbar-thumb{background-color:#525975;border-top:4px solid transparent;border-bottom:3px solid transparent;background-clip:content-box}.side-scroll-hint{position:absolute;bottom:0;right:0;height:26px;line-height:26px;padding:0 1em;background-color:#1c85e8;color:#fff;cursor:pointer}.static-content .static-content-navigation .card{padding:2em 0 1em}.static-content .static-content-navigation-header{margin:.4em 0;font-weight:500}.static-content .static-content-logo{-webkit-border-radius:50%;border-radius:50%;border:1px solid #fafafa;padding:1em}.static-content ul.static-content-list{margin-top:1.5em}.static-content ul.static-content-list li{border-top:1px solid rgba(0,0,0,0.1);padding:1.5em 0}.static-content .call-to-action{padding-top:2em;padding-bottom:2em;border-top:1px solid #fafafa}od-sticky-container,[od-sticky-container]{display:block;position:relative}od-sticky-container od-sticky-element,[od-sticky-container] od-sticky-element,od-sticky-container [od-sticky-element],[od-sticky-container] [od-sticky-element]{display:block;top:24px}od-sticky-container od-sticky-element.sticky,[od-sticky-container] od-sticky-element.sticky,od-sticky-container [od-sticky-element].sticky,[od-sticky-container] [od-sticky-element].sticky{position:fixed}od-sticky-container od-sticky-element.bottom,[od-sticky-container] od-sticky-element.bottom,od-sticky-container [od-sticky-element].bottom,[od-sticky-container] [od-sticky-element].bottom{position:absolute;top:auto;bottom:0}.table-grid{margin-top:20px}.table-grid .title{color:#9ba1a6;font-weight:500;font-size:16px}.table-grid .row{margin-left:0;margin-right:0;border-bottom:1px solid rgba(192,192,191,0.3);line-height:1.6em}.table-grid .row:first-child{border-top:1px solid rgba(192,192,191,0.3)}.table-grid .row div[class^=\"col-\"]{padding:10px 20px}.table-grid .row div[class^=\"col-\"]:first-child{border-left:1px solid rgba(192,192,191,0.3)}.table-grid .row div[class^=\"col-\"]:last-child{border-right:1px solid rgba(192,192,191,0.3)}.table-grid.bordered div[class^=\"col-\"]{border-left:1px solid rgba(192,192,191,0.3)}@media screen and (max-width:639px){.thumbnail-carousel .thumbnail-photo{height:54px;width:82px}}@media screen and (min-width:640px) and (max-width:959px){.thumbnail-carousel .thumbnail-photo{height:71px;width:107px}}@media (max-height:640px){.thumbnail-carousel{display:none}}.thumbnail-carousel .thumbnail-photo{position:relative;width:161px;height:107px;background-position:center center;background-size:cover;background-repeat:no-repeat;cursor:pointer}.thumbnail-carousel .thumbnail-photo:before{content:\"\";position:absolute;z-index:-1;left:50%;right:50%;bottom:0;background:#fff;height:3px;z-index:10;opacity:0;-webkit-transition-property:left,right,opacity;transition-property:left,right,opacity;-webkit-transition-duration:.3s;transition-duration:.3s;-webkit-transition-timing-function:ease-out;transition-timing-function:ease-out}.thumbnail-carousel .thumbnail-photo:hover:before{left:0;right:0;opacity:.5}.thumbnail-carousel .thumbnail-photo.selected:before{content:\"\";position:absolute;z-index:-1;left:0;right:0;bottom:0;background:#fff;height:3px;z-index:10;opacity:.8;-webkit-transition-property:left,right,opacity;transition-property:left,right,opacity;-webkit-transition-duration:.3s;transition-duration:.3s;-webkit-transition-timing-function:ease-out;transition-timing-function:ease-out}.thumbnail-carousel .thumbnail-photo.selected:hover:before{opacity:1}@media screen and (max-width:639px){.thumbnail-carousel .thumbnail-photo{height:54px;width:82px}}@media screen and (min-width:640px) and (max-width:959px){.thumbnail-carousel .thumbnail-photo{height:71px;width:107px}}.well{background-color:#fafafa;padding:1em}.well>*:last-child{margin-bottom:0 !important}.form-element-mixin{border:1px solid #dedede;-webkit-border-radius:2px;border-radius:2px;background-color:#fff;-webkit-box-sizing:border-box;box-sizing:border-box;padding:10px 12px}.form-element-mixin[disabled]{color:#f0f0f0;background-color:#fafafa}.form-element-mixin[readonly]{color:#9ba1a6;background-color:#fafafa}.form-element-mixin.full-width{width:100%}.form-element-mixin.highlight-errors{-webkit-transition:-webkit-box-shadow cubic-bezier(.1, .7, .1, 1) .5s;transition:-webkit-box-shadow cubic-bezier(.1, .7, .1, 1) .5s;transition:box-shadow cubic-bezier(.1, .7, .1, 1) .5s;transition:box-shadow cubic-bezier(.1, .7, .1, 1) .5s, -webkit-box-shadow cubic-bezier(.1, .7, .1, 1) .5s}.form-element-mixin.highlight-errors.ng-dirty.ng-invalid{border-color:#ff7f82;-webkit-box-shadow:#ff7f82 0 0 5px;box-shadow:#ff7f82 0 0 5px}@media (max-width:767px){.form-element-mixin{font-size:12px}}@media (max-width:479px){.form-element-mixin{padding:10px 5px}}.account section#sign-up{padding:0}.account .login-header{margin-bottom:50px}@media (max-width:991px){.account .login-header{margin-top:30px}}.account .new-account-header{margin-bottom:30px}@media (max-width:991px){.account .new-account-header{margin-top:30px}}.account .new-account-subheader{margin-bottom:50px}.account .input-field{margin-top:10px;margin-bottom:10px}.account .input-field input{width:100%}.account .submit-button{margin-top:30px;margin-bottom:15px}.account .field-label{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.account .field-text{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;margin-bottom:15px}.account .input-section{margin-left:auto;margin-right:auto;width:400px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}@media (max-width:991px){.account .input-section{width:100%}}.account .loading-spinner{position:relative;-webkit-transition:all ease-in-out .1s;transition:all ease-in-out .1s;color:transparent}.account .loading-spinner:after{content:'';position:absolute;display:block;top:50%;left:50%;width:18px;height:18px;margin-top:-12px;margin-left:-12px;-webkit-border-radius:100%;border-radius:100%;border:solid 3px transparent;-webkit-animation:none;animation:none}.account .loading-spinner:hover{color:transparent}.account .loading-spinner:after{z-index:2;border-color:#fff;border-bottom-color:transparent;-webkit-animation:in-progress-rotate .6s infinite linear;animation:in-progress-rotate .6s infinite linear}.account .loading-spinner.in-progress{color:transparent}.account .loading-spinner.in-progress:hover{color:transparent}.account .loading-spinner.in-progress:after{z-index:2;border-color:#fff;border-bottom-color:transparent;-webkit-animation:in-progress-rotate .6s infinite linear;animation:in-progress-rotate .6s infinite linear}.denied input,.denied button{margin:20px 0;width:100%}.denied section.mailing-list{background-color:#fafafa;text-align:center}.denied section.hero .label{font-size:12px;position:relative;left:-35px;width:160px;margin:0 auto 30px}.denied section.hero .label::after{content:'';position:absolute;top:100%;left:50%;border-left:1px solid #1c85e8;height:30px}.denied section.hero img{width:200px;max-width:80%;margin-bottom:1em}.route-listings-home-condition-cover .page{position:relative;width:8.5in;height:11in;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden}.route-listings-home-condition-cover .background-highlight{background-color:#f1f4fd;padding-bottom:30px}.route-listings-home-condition-cover .background-highlight-bottom{background-color:#f1f4fd;height:100%}.route-listings-home-condition-cover .home-summary{text-align:center;padding-bottom:30px}.route-listings-home-condition-cover .header{padding-top:30px;margin-bottom:.2in}.route-listings-home-condition-cover .header .logo{width:120px}.route-listings-home-condition-cover .title{font-family:'Graphik';font-size:37px;letter-spacing:-2px;color:#1d2c4c;padding-bottom:30px}.route-listings-home-condition-cover .main-photo{height:3in;width:5in;margin:auto}.route-listings-home-condition-cover .img{height:100%;width:100%;background-size:cover}.route-listings-home-condition-cover .address{font-family:'Publico';font-weight:bold;font-size:29px;color:#1d2c4c;padding-top:30px}.route-listings-home-condition-cover .home-details{font-size:13px;color:#525975}.route-listings-home-condition-cover .upgrade-highlights{width:75%;padding-left:30px}.route-listings-home-condition-cover .upgrade-item:before{content:'';background-color:black;display:inline-block;position:relative;height:4px;width:4px;-webkit-border-radius:4px;border-radius:4px;margin-right:16px;top:-2px}.route-listings-home-condition-cover .guarantee-section{width:25%;float:right}.route-listings-home-condition-cover .guarantee-img{padding-top:80px;width:100px}.route-listings-home-condition-cover .guarantee-header{color:#1d2c4c;font-size:16px;font-weight:500}.route-listings-home-condition-cover .report-summary{padding-bottom:10px}.route-listings-home-condition-cover .report-summary-header{color:#1d2c4c;padding-bottom:4px}.route-listings-home-condition-cover .condition-item{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;padding-bottom:40px;-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start}.route-listings-home-condition-cover .condition-item .condition-item-img{width:45px}.route-listings-home-condition-cover .condition-item .condition-item-description{padding-left:30px;width:500px}.route-listings-home-condition-cover .condition-item .condition-item-header{margin-top:-10px;font-size:21px;font-weight:500;color:#1c85e8}.route-listings-home-condition-cover .about-opendoor-section{padding-left:60px;padding-right:60px;padding-top:30px}.route-listings-home-condition-cover .about-opendoor-header{color:#1c85e8;font-size:11px;font-weight:500;text-transform:uppercase;padding-bottom:8px}.route-listings-home-condition-cover .divider-dot{font-weight:700}.route-listings-home-condition-cover .upgrade-text{padding-bottom:4px}.route-listings-home-condition-cover .summary-text{font-size:16px;line-height:24px;color:black;padding-bottom:20px;max-width:700px}.route-listings-home-condition-cover .basic-text{font-size:13px;line-height:21px;padding-bottom:4px;color:black}.route-listings-home-condition-cover .page-1-bottom{padding-top:36px;padding-left:60px;padding-right:30px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.route-listings-home-condition-cover .page-2-top{padding-top:50px;padding-left:60px;padding-right:30px}.route-listings-home-condition-cover .page-1-footer{position:absolute;bottom:11in;width:-webkit-calc(7.875in);width:calc(7.875in);border-top:2px solid #e9edf0;padding-top:.3in;padding-bottom:.3in;margin-left:30px;margin-right:30px;text-align:right;color:#000;page-break-after:always}.route-listings-home-condition-cover .page-2-footer{position:absolute;bottom:.3in;width:-webkit-calc(7.875in);width:calc(7.875in);border-top:2px solid #ffffff;padding-top:.3in;margin-left:30px;margin-right:30px;text-align:right;color:#000;page-break-after:avoid}.route-listings-home-condition-cover .footer-label{float:left;font-weight:500}.route-listings-home-condition-cover .contact-us{font-size:18px}.route-listings-poster{font-size:25px}.route-listings-poster .page{positive:relative;width:12in;height:18in;-webkit-box-sizing:border-box;box-sizing:border-box;padding:.5in;overflow:hidden}.route-listings-poster .header{margin-bottom:.32in;text-align:right}.route-listings-poster .header .logo{width:2.5in}.route-listings-poster .main-photo{margin:.27in 0;height:7.4in}.route-listings-poster .title-cont{margin-bottom:.05in}.route-listings-poster .street{margin-right:.32in}.route-listings-poster .city{color:#1d2c4c}.route-listings-poster .img{width:100%;height:100%;background-size:cover}.route-listings-poster .ask-more-info p,.route-listings-poster .price-footnote{font-size:18px}.route-listings-poster .ask-more-info{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.route-listings-poster .attributes-listing-details{margin:2.1in 0 1.75in 0}.route-listings-poster .home-attributes{display:inline-block;color:#000;padding-right:.4in}.route-listings-poster .home-attribute{padding:.05in .16in .05in 0}.route-listings-poster .home-attribute .divider-dot{color:#bdbec8}.route-listings-poster .list-price-remarks-cont{float:right;margin-top:-0.55in;text-align:right}.route-listings-poster .list-price-remarks-cont .list-label{font-size:.6em;font-weight:600;color:#7195a9;text-transform:uppercase}.route-listings-poster .page-1-footer{position:absolute;bottom:.4in;width:-webkit-calc(11in);width:calc(11in);border-top:2px solid #e9edf0;padding-top:.4in;text-align:right;color:#000}.route-listings-poster .footer-label{float:left;font-size:25px}.route-listings-poster .extra-bold{font-weight:600}.route-listings-poster h1{font:300 76px/1.45 'Publico',serif;color:#1d2c4c;font-weight:600}.route-listings-poster h2{font:300 60px/1.45 'Publico',serif;color:#1d2c4c;font-weight:600}.route-listings-poster .h1{font:300 76px/1.45 'Publico',serif;color:#1d2c4c;font-weight:600}.route-listings-poster .h2{font:300 60px/1.45 'Publico',serif;color:#1d2c4c;font-weight:600}.route-listings-poster p{font-size:24px;color:#000}.route-listings-print .page{positive:relative;width:8.48in;height:10.98in;-webkit-box-sizing:border-box;box-sizing:border-box;padding:.3in;overflow:hidden;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-flow:column;-ms-flex-flow:column;flex-flow:column}.route-listings-print .doorsign .page-landscape{background-color:white;positive:relative;width:10.98in;height:8.48in;-webkit-box-sizing:border-box;box-sizing:border-box;padding:.3in;overflow:hidden;text-align:center}.route-listings-print .doorsign .page-landscape .logo{width:auto;height:49px;fill:#4374ad;margin:64px 0 50px 0}.route-listings-print .doorsign .page-landscape .welcome{font-family:'Publico',serif;color:#1b2b3e;line-height:1.22;font-size:70px;font-weight:600;padding:0 120px}.route-listings-print .doorsign .page-landscape .address{font-family:'Publico',serif;color:#1b2b3e;line-height:1.22;font-size:70px;font-weight:600;margin-bottom:61px}.route-listings-print .doorsign .page-landscape .logo-icon{width:36px;height:36px;margin-bottom:27px}.route-listings-print .doorsign .page-landscape .download-text{font-size:30px;letter-spacing:-0.5px;margin-bottom:26px;line-height:1;color:#1b2b3e}.route-listings-print .doorsign .page-landscape .download-url{font-size:25px;font-weight:500;letter-spacing:-0.5px;color:#4374ad;margin-bottom:59px;line-height:1}.route-listings-print .doorsign .page-landscape .download-problems{font-size:20px;letter-spacing:-0.5px;color:#1b2b3e;margin-bottom:19px;line-height:1}.route-listings-print .doorsign .page-landscape .download-problems strong{font-weight:600}.route-listings-print .doorsign .page-landscape .access-info{font-size:14px;letter-spacing:-0.3px;color:rgba(27,44,62,0.7);line-height:1}.route-listings-print .doorsign .page-landscape .access-info span{color:#d1d5d8;font-weight:600;padding:4px}.route-listings-print .header{margin-bottom:26px;text-align:right}.route-listings-print .header .logo{width:1.5in}.route-listings-print .main-photo{margin-top:10px;height:509px}.route-listings-print .title-cont{margin-bottom:.03in}.route-listings-print .street{font-size:60px;line-height:60px}.route-listings-print .city{margin-top:8px;color:#1d2c4c;font-size:19px}.route-listings-print .img{width:100%;height:100%;background-size:cover}.route-listings-print .home-attributes{width:100%;margin:20px 0}.route-listings-print .home-attribute{text-align:center;width:20%;float:left}.route-listings-print .home-attribute .home-attribute-num{font:300 60px/1.45 'Publico',serif;color:#1d2c4c;font-weight:600;font-size:24px}.route-listings-print .home-attribute .home-attribute-text{color:#1d2c4c;font-size:12px}.route-listings-print .more-info{-webkit-box-flex:1;-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;position:relative}.route-listings-print .more-info .list-price-section{width:243px;height:198px;background-color:#dae0e6;position:absolute;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;text-align:center}.route-listings-print .more-info .list-price-section .list-price-wrapper{width:100%}.route-listings-print .more-info .list-price-section .list-price-wrapper .list-price-header{color:#6e8d9c;font-size:8px;letter-spacing:.1px;font-weight:600;padding-bottom:12px}.route-listings-print .more-info .list-price-section .list-price-wrapper .list-price-divider{width:16px;left:-webkit-calc(50% - 8px);left:calc(50% - 8px);position:absolute;border:solid 1px #ffffff}.route-listings-print .more-info .list-price-section .list-price-wrapper .list-price{padding-top:8px;font:300 60px/1.45 'Publico',serif;color:#1d2c4c;font-weight:600;font-size:34px}.route-listings-print .more-info .list-price-section .list-price-wrapper .list-price sup{font-family:'Graphik',sans-serif;font-weight:normal;font-size:17px;color:#6e8d9c}.route-listings-print .more-info .list-price-section .list-price-wrapper .price-footage{color:#1d2c4c;font-size:12px;margin-bottom:25px}.route-listings-print .more-info .list-price-section .list-price-wrapper .price-change{font-size:9px;color:#6e8d9c}.route-listings-print .more-info .description{height:192px;overflow:hidden;position:absolute;left:280px;width:470px;padding:3px 0;font-size:12px;line-height:18px;color:#1d2c4c}.route-listings-print .more-info .markdown-listing-remarks p{margin-bottom:12px}.route-listings-print .more-info .markdown-listing-remarks p:last-of-type{margin-bottom:0}.route-listings-print .image-reel{width:100%}.route-listings-print .image-reel .reel-photo{width:-webkit-calc(33% - 0.2px);width:calc(33% - 0.2px);height:167px;float:left;margin-right:4px}.route-listings-print .image-reel .reel-photo .img{width:100%;height:100%;background-size:cover}.route-listings-print .image-reel .last{margin-right:0;float:right}.route-listings-print .big-photo{margin-top:4px;height:509px}.route-listings-print .other-listings{font-size:12px;color:#1d2c4c;margin-top:18.5px}.route-listings-print .other-listings .highlight{color:#278aca;font-weight:600}.route-listings-print .offer-actions{-webkit-box-flex:1;-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;position:relative;margin:30px 0 15px 0}.route-listings-print .offer-actions .ready-instructions{width:426px;height:100%;position:absolute;border-right:1.3px solid #f0f5f7;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}.route-listings-print .offer-actions .ready-instructions .ready-wrapper .ready-title{font:300 60px/1.45 'Publico',serif;color:#1d2c4c;font-size:29px;font-weight:600;margin-bottom:6px}.route-listings-print .offer-actions .ready-instructions .ready-wrapper .ready-text{font-size:12px;color:#1d2c4c;margin-bottom:18px;letter-spacing:-0.1px;line-height:1.56;padding-right:90px}.route-listings-print .offer-actions .ready-instructions .ready-wrapper .contact-info{color:#278aca;font-size:16px;font-weight:500;letter-spacing:-0.5px}.route-listings-print .offer-actions .ready-instructions .ready-wrapper .contact-info .contact-icon{width:20px;height:20px;stroke:#278aca;fill:none;margin-right:5px}.route-listings-print .offer-actions .ready-instructions .ready-wrapper .contact-info .phone-info{float:left;width:37%}.route-listings-print .offer-actions .ready-instructions .ready-wrapper .contact-info .email-info{float:left;width:63%}.route-listings-print .offer-actions .warranty{left:426px;width:288px;position:absolute;padding-left:45px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;height:100%}.route-listings-print .offer-actions .warranty .guarantee{position:absolute;right:0;top:0;width:56px;height:56px}.route-listings-print .offer-actions .warranty .warranty-wrapper{color:#1d2c4c}.route-listings-print .offer-actions .warranty .warranty-wrapper .warranty-title{font-size:16px;font-weight:500;margin-bottom:9px}.route-listings-print .offer-actions .warranty .warranty-wrapper .warranty-text{font-size:12px;line-height:1.56;letter-spacing:-0.1px}.route-listings-print .page-2-footer{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;padding-top:.3in;bottom:.3in;width:-webkit-calc(7.88in);width:calc(7.88in);border-top:1px solid #f0f5f7;color:#000}.route-listings-print .page-2-footer .footer-wrapper{width:100%}.route-listings-print .page-2-footer .footer-wrapper .opendoor-address{font-size:12px;float:left}.route-listings-print .page-2-footer .footer-wrapper .opendoor-address .equal-opp{width:24px;height:17.3px;fill:#d2e0f2;margin-right:16px}.route-listings-print .page-2-footer .footer-wrapper .opendoor-address span.od-office{font-weight:600}.route-listings-print .page-2-footer .footer-wrapper .extra-bold{font-weight:600}.route-listings-print .page-2-footer .footer-wrapper .footer-label{font-size:17px;float:right;color:#278aca}.route-listings-print h1{font:300 60px/1.45 'Publico',serif;color:#1d2c4c;font-weight:600}.route-listings-print h2{font:300 40px/1.45 'Publico',serif;color:#1d2c4c;font-weight:600}.route-listings-print .h1{font:300 60px/1.45 'Publico',serif;color:#1d2c4c;font-weight:600}.route-listings-print .h2{font:300 40px/1.45 'Publico',serif;color:#1d2c4c;font-weight:600}.route-homes-market{font-size:14px}.route-homes-market .page-title{font-size:18px;padding-left:32px}@media (max-width:767px){.route-homes-market .page-title{display:none}}.route-homes-market .search-footer{background-color:#fff;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;padding:30px 10px;font-size:14px}@media (max-width:767px){.route-homes-market .search-footer{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}}.route-homes-market .search-footer .ccpa-links{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;margin:0 15px}.route-homes-market .search-footer .ccpa-links a{color:#525975;margin:0 15px}.route-homes-market .search-footer .ccpa-links a:hover{color:#1c85e8}@media (max-width:767px){.route-homes-market .search-footer .ccpa-links{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;margin:15px 0}.route-homes-market .search-footer .ccpa-links a{margin:10px 0}}.route-homes-market .search-footer img{margin-top:-3px;height:30px}.route-homes-market .cta-banner{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;background-color:#f5f8fb;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;padding:15px 10px}@media (max-width:767px){.route-homes-market .cta-banner{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}}.route-homes-market .cta-banner .text{font-size:14px;text-align:center}@media (min-width:768px){.route-homes-market .cta-banner .text{margin:2px 20px 0}}@media (max-width:767px){.route-homes-market .cta-banner .text{margin:8px 0}}.route-homes-market .cta-banner a{color:#ffffff;font-size:14px;font-weight:500;text-align:center;background:#1c85e8;display:inline-block;padding:8px 40px !important;border:1px solid #ffffff;-webkit-border-radius:20px;border-radius:20px;overflow:visible;-webkit-transition:all .3s ease;transition:all .3s ease;cursor:pointer}@media (max-width:767px){.route-homes-market .search-bar{z-index:1;position:relative;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;height:56px;background:white}}.route-homes-market .search-bar-info{overflow:hidden}.route-homes-market .search-bar-info>*{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.route-homes-market .search-bar-button{margin:0;margin-right:12px}.route-homes-market .listing-search-header-title{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}.route-homes-market .listing-search-header-title:not(:first-child){margin-left:1em}.route-homes-market .listing-search-header-title:not(:last-child){margin-right:1em}.route-homes-market .listing-search-header-title .sub-header-title{margin-top:4px;line-height:1.45}.route-homes-market .search-bar-filters{position:relative;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;padding:12px 32px}@media (min-width:768px){.route-homes-market .search-bar-filters{width:430px}}@media (min-width:992px){.route-homes-market .search-bar-filters{width:470px}}.route-homes-market .current-filter-info{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}.route-homes-market .save-search-button{opacity:.7;-webkit-transition:all .3s ease;transition:all .3s ease}.route-homes-market .save-search-button.disabled{opacity:.3;color:#525975}.route-homes-market .save-search-button:not(.disabled):hover{opacity:1}.route-homes-market .save-search-button-disabled{opacity:.3}.route-homes-market .search-bar-dropdown-menu{margin-left:-1px;width:200px;margin-top:24px;padding-top:24px;border-top:1px solid rgba(192,192,191,0.3)}.route-homes-market .search-bar-dropdown-menu input{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1;width:100%;margin-right:6px;padding-top:8px;padding-bottom:8px}.route-homes-market .list-map-toggle-button{float:left;min-width:43px;width:43px;height:43px;margin-left:12px;border:1px solid #dedede;background:white;padding:0;overflow:hidden}.route-homes-market .list-map-toggle-button img{width:100%;height:100%}.route-homes-market .delete-saved-search-button{visibility:hidden;margin-right:-14px}.route-homes-market .nav-tab:hover .delete-saved-search-button{visibility:visible}.route-homes-market .delete-saved-search-icon{height:13px;margin-left:2px}.route-homes-market .search-body{height:-webkit-calc(100vh - 85px - 30px);height:calc(100vh - 85px - 30px);width:100%}@media (min-width:768px){.route-homes-market .search-body{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}}.route-homes-market .shared-listing-filter-form-container{position:absolute;left:0;right:0;top:141px;height:-webkit-calc(100vh - 85px - 30px);height:calc(100vh - 85px - 30px);padding:0 16px;background-color:#fff;overflow-y:auto;z-index:3}.route-homes-market .shared-listing-filter-form-container od-listing-filter-form form{padding-bottom:140px}.route-homes-market .shared-listing-filter-form-container .submit-row{position:fixed;bottom:0;left:0;right:0;background-color:#fff;z-index:5}.route-homes-market .listing-filter-form-backdrop{position:absolute;top:0;bottom:0;left:0;right:0;background-color:rgba(75,74,72,0.6);z-index:3}.route-homes-market .listing-filter-form-backdrop.ng-enter{-webkit-transition:.25s linear opacity;transition:.25s linear opacity;opacity:0}.route-homes-market .listing-filter-form-backdrop.ng-enter-active{opacity:1}.route-homes-market .listing-filter-form-backdrop.ng-leave{-webkit-transition:.25s linear opacity;transition:.25s linear opacity;opacity:1}.route-homes-market .listing-filter-form-backdrop.ng-leave-active{opacity:0}.route-homes-market .listing-filter-form{position:absolute;left:0;right:0;height:100%;padding:0 32px;background-color:#fff;overflow-y:auto;z-index:4}@media (min-width:768px){.route-homes-market .listing-filter-form.ng-enter{-webkit-transition:.25s ease-out all;transition:.25s ease-out all;-webkit-transform:translateY(-100%);transform:translateY(-100%)}.route-homes-market .listing-filter-form.ng-enter-active{-webkit-transform:translateY(0);transform:translateY(0)}.route-homes-market .listing-filter-form.ng-leave{-webkit-transition:.25s ease-in all;transition:.25s ease-in all;-webkit-transform:translateY(0);transform:translateY(0)}.route-homes-market .listing-filter-form.ng-leave-active{-webkit-transform:translateY(-100%);transform:translateY(-100%)}}.route-homes-market .map-container{position:relative;-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1;height:-webkit-calc(100vh - 85px - 30px);height:calc(100vh - 85px - 30px)}@media (max-width:767px){.route-homes-market .map-container{position:absolute;left:0;right:0;top:141px;height:-webkit-calc(100vh - 85px - 30px);height:calc(100vh - 85px - 30px)}}.route-homes-market .listing-map-loading{position:relative;-webkit-transition:all ease-in-out .1s;transition:all ease-in-out .1s;z-index:4;position:absolute;top:50%;left:50%;height:80px;width:80px;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);-webkit-border-radius:4px;border-radius:4px;background-color:rgba(3,3,3,0.6);pointer-events:none}.route-homes-market .listing-map-loading:after{content:'';position:absolute;display:block;top:50%;left:50%;width:20px;height:20px;margin-top:-13px;margin-left:-13px;-webkit-border-radius:100%;border-radius:100%;border:solid 3px transparent;-webkit-animation:none;animation:none}.route-homes-market .listing-map-loading.in-progress{color:transparent}.route-homes-market .listing-map-loading.in-progress:hover{color:transparent}.route-homes-market .listing-map-loading.in-progress:after{z-index:2;border-color:#fff;border-bottom-color:transparent;-webkit-animation:in-progress-rotate .6s infinite linear;animation:in-progress-rotate .6s infinite linear}.route-homes-market .personalized-filters-dropdown{z-index:10;position:absolute;top:10px;left:10px;-webkit-border-radius:3px;border-radius:3px;background:white;padding:18px 24px 18px 24px}.route-homes-market .personalized-filters-dropdown .personalized-filter{margin-bottom:12px;cursor:pointer}.route-homes-market .personalized-filters-dropdown .personalized-filter.active{font-weight:500;color:#1c85e8}.route-homes-market .map-filter-control-container{z-index:10;position:absolute;top:10px;right:40px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}.route-homes-market .map-filter-control-container .map-filter-control-button{width:100%;border:2px solid #fff !important;padding:10px 20px;font-weight:500;-webkit-transition:none !important;transition:none !important}.route-homes-market .mapboxgl-ctrl-icon{width:22px;height:22px}.route-homes-market od-search-map{height:100%}.route-homes-market od-search-map .mapboxgl-ctrl-group{-webkit-box-shadow:none !important;box-shadow:none !important}.route-homes-market od-search-map .mapboxgl-ctrl-group>button{border:none !important}.route-homes-market .bottom-popup-selected-listing-mini{z-index:3;position:fixed;bottom:0;left:0;right:0;height:300px}.route-homes-market .bottom-popup-selected-listing-mini{height:150px}.route-homes-market .list-container{z-index:2;position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;height:-webkit-calc(100vh - 85px - 30px);height:calc(100vh - 85px - 30px);display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;overflow:hidden}@media (min-width:768px){.route-homes-market .list-container{width:430px}}@media (min-width:992px){.route-homes-market .list-container{width:470px}}@media (max-width:767px){.route-homes-market .list-container{padding:0}}@media (max-width:767px){.route-homes-market .list-container{padding:0}}.route-homes-market .list-container li+li{margin:.7em 0}.route-homes-market .list-container.ctaBannerShown{padding-top:12px}.route-homes-market .list-container:after{z-index:2;content:'';position:absolute;top:0;left:0;right:0;bottom:0;background-color:white;opacity:0;-webkit-transition:opacity .15s linear;transition:opacity .15s linear;pointer-events:none}.route-homes-market .list-container.loading:after{opacity:.4}.route-homes-market .listings-container{position:relative;overflow:hidden}.route-homes-market .listing-result-list{position:relative;height:-webkit-calc(100vh - 85px - 88px);height:calc(100vh - 85px - 88px);border-top:1px solid rgba(192,192,191,0.3);padding:0 32px 32px;overflow-y:auto;-webkit-overflow-scrolling:touch}.route-homes-market .listing-no-results{margin:2em;text-align:center}.route-homes-show-buy .flow-nav .line-wrapper{width:50%;left:25%}.route-homes-show-buy .flow-nav ul li{width:50%}.route-homes-show-buy .direct-buy-intro{margin:24px 0;font-size:14px}.route-homes-index section#hero{position:relative;padding:130px 0 130px 0;background:#f0f0f0 url('https://images.opendoor.com/source/s3/imgdrop-production/ea1a693373ca42db9287e117ccf86e39.jpg?service=web') center no-repeat;background-size:cover;z-index:2;-webkit-transition:all ease .3s;transition:all ease .3s}@media (max-width:991px){.route-homes-index section#hero{padding:70px 0 60px 0;background:#f5f8fb}}.route-homes-index section#hero .big-headline{line-height:1.2}@media (max-width:991px){.route-homes-index section#hero .big-headline{font-size:32px}}.route-homes-index .playstore{padding-left:40px;margin:0 10px;line-height:1.2;background:#1c85e8 url('https://images.opendoor.com/source/s3/imgdrop-production/play-store-icon-white.svg?service=web') 11% center no-repeat}.route-homes-index .itunes{padding-left:40px;margin:0 10px;line-height:1.2;background:#1c85e8 url('https://images.opendoor.com/source/s3/imgdrop-production/ios-logo-white.svg?service=web') 11% center no-repeat}.route-homes-index #markets{margin-top:-20px;position:relative;z-index:3}.route-homes-index #markets .market-block{position:relative;display:inline-block;width:100%;height:300px;background:#3eb3e6;overflow:hidden;text-align:center;background-size:cover;background-position:center;margin-bottom:12px;-webkit-backface-visibility:hidden;backface-visibility:hidden}.route-homes-index #markets .market-block.coming-soon::after{position:absolute;bottom:10px;right:15px;content:'COMING SOON';font-size:12px;color:#fff;z-index:3}@media (max-width:991px){.route-homes-index #markets .market-block{height:220px}}.route-homes-index #markets .market-block:hover .location{background:rgba(0,0,0,0.35)}.route-homes-index #markets .location{position:absolute;-webkit-box-sizing:border-box;box-sizing:border-box;top:0;left:0;width:100%;height:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;text-align:center;z-index:3;background:rgba(0,0,0,0.2);-webkit-transition:all ease-in-out .3s;transition:all ease-in-out .3s}.route-homes-index #markets .location .city{font-family:'Publico',serif;font-weight:600;font-size:28px;line-height:1;color:#fff}.route-homes-index #markets .location .state{margin-top:10px;font-family:'Graphik',sans-serif;font-weight:500;color:#fff;letter-spacing:3px;text-transform:uppercase}.route-homes-index section.buyer-value-props .glance{position:relative;padding:30px 0;cursor:pointer}.route-homes-index section.buyer-value-props .glance .title{color:#1d2c4c}.route-homes-index section.buyer-value-props .glance.active::after{content:'';position:absolute;width:6px;height:6px;bottom:0;left:50%;margin-left:-3px;-webkit-border-radius:50%;border-radius:50%;background:#1c85e8}.route-homes-index section.buyer-value-props .glance:hover::after{content:'';position:absolute;width:6px;height:6px;bottom:0;left:50%;margin-left:-3px;-webkit-border-radius:50%;border-radius:50%;background:#f0f0f0}.route-homes-index section.buyer-value-props .slide{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;height:auto;-webkit-box-sizing:border-box;box-sizing:border-box;padding-left:20px}@media (max-width:991px){.route-homes-index section.buyer-value-props .slide{padding-left:0;padding-bottom:30px;border-top:1px solid rgba(0,0,0,0.1);border-bottom:1px solid rgba(0,0,0,0.1)}}.route-homes-index section.buyer-value-props .slide-left-side{position:relative;padding:60px;margin-top:50px;height:560px;width:55%;background:#fff;-webkit-box-shadow:0 10px 35px rgba(0,0,0,0.2);box-shadow:0 10px 35px rgba(0,0,0,0.2);z-index:5;-webkit-box-sizing:border-box;box-sizing:border-box}@media (max-width:991px){.route-homes-index section.buyer-value-props .slide-left-side{height:auto;width:100%;padding:0 0 140px 0;-webkit-box-shadow:none;box-shadow:none}}.route-homes-index section.buyer-value-props .slide-left-side-nav{position:absolute;bottom:60px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;cursor:pointer}.route-homes-index section.buyer-value-props .slide-left-side-nav:hover{opacity:.8}@media (max-width:991px){.route-homes-index section.buyer-value-props .slide-left-side-nav{bottom:40px}}.route-homes-index section.buyer-value-props .slide-left-side-nav .next-slide-link{color:#1c85e8;text-transform:uppercase;letter-spacing:2px}.route-homes-index section.buyer-value-props .slide-left-side-nav .nav-counter{width:45px;height:45px;margin-right:15px;-webkit-border-radius:50%;border-radius:50%;border:2px solid #f0f0f0;font-weight:500;line-height:44px;letter-spacing:2px;color:#999;text-align:center}.route-homes-index section.buyer-value-props .slide-right-side{position:relative;width:60%;margin-left:-15%;z-index:3}.route-homes-index section.buyer-value-props .slide-right-side img{display:block;width:100%;height:auto}.route-homes-index section.listings{padding:0 0 60px 0;border-bottom:1px solid rgba(0,0,0,0.1)}@media (max-width:991px){.route-homes-index section.listings .home-col:nth-child(3){display:none}}.route-homes-index .stat-number{color:#1c85e8;font-weight:600;font-size:80px;font-family:'Publico',serif}.route-homes-index .sub-stat{position:relative;margin-bottom:20px;padding-bottom:20px;font-size:20px;color:#525975}.route-homes-index .sub-stat::after{content:'';position:absolute;bottom:0;left:50%;height:2px;width:26px;margin-left:-13px;background:rgba(0,0,0,0.1)}.route-homes-index section.stories{background:-webkit-gradient(linear, left top, left bottom, color-stop(0, #fff), to(#e6e6e6));background:-webkit-linear-gradient(top, #fff 0, #e6e6e6 100%);background:linear-gradient(to bottom, #fff 0, #e6e6e6 100%)}.route-homes-index section.stories .button{margin:0 10px}.inputting-address .ei-chevron-up{line-height:1.45;fill:rgba(192,192,191,0.3);display:block;margin:0 auto .5em}.inputting-address .od-place-autocomplete{margin-top:1em}@media (min-width:768px){.inputting-address .od-place-autocomplete{margin-top:6em}}.inputting-address .od-place-autocomplete input{border:2px solid #1c85e8;-webkit-border-radius:4px;border-radius:4px;display:block;width:96%;margin-left:2%;margin-top:10px;padding:20px 0 20px 20px;font-size:16px}.inputting-address .od-place-autocomplete input::-webkit-input-placeholder{color:#1c85e8;font-size:16px}.inputting-address .od-place-autocomplete input:-moz-placeholder{color:#1c85e8;font-size:16px}.inputting-address .od-place-autocomplete input::-moz-placeholder{color:#1c85e8;font-size:16px}.inputting-address .od-place-autocomplete input::-ms-input-placeholder{color:#1c85e8;font-size:16px}.inputting-address .od-place-autocomplete ul{width:96%;margin-left:2%}.inputting-address .od-place-autocomplete ul li{padding:.6em 2ex}.inputting-address .explanation{text-align:center;font-size:16px;width:100%;margin-top:20px}.lead-route .verifying-address .map{border-bottom:solid 1px rgba(192,192,191,0.3);height:240px}@media (max-width:479px){.lead-route .verifying-address .map{height:160px}}.lead-route .verifying-address .form-question{margin-top:32px}.lead-route .verifying-address-manual h2{margin-bottom:6px}.lead-route .verifying-address-manual .card{margin-top:12px;padding-left:6px;padding-right:6px}.lead-route .verifying-address-manual .row+.row{margin-top:12px}.lead-route .verifying-address-manual form input{width:100%;margin:0}@media (max-width:767px){.lead-route .verifying-address-manual form input{margin-bottom:6px}}@media (max-width:767px){.lead-route .verifying-address-manual .footer{text-align:center}}.lead-route .inputting-details .photos{text-align:center;position:relative}.lead-route .inputting-details .photos .nav{position:absolute;left:50%;top:80px;width:130px;margin-left:-65px;-webkit-border-radius:20px;border-radius:20px;background-color:rgba(3,3,3,0.6);color:#fff;font-weight:500}.lead-route .inputting-details .photos .nav span{display:inline-block;width:70px}.lead-route .inputting-details .photos .nav a{color:#fff}.lead-route .inputting-details .photos img{width:100%;height:inherit;padding:0;vertical-align:bottom}.lead-route .inputting-seller img{width:70%}.lead-route .inputting-seller small{margin-top:15px;color:#9ba1a6}.lead-route .inputting-seller small img{height:12px;width:10px;padding:0;margin:1px 4px -1px 0}.lead-route .inputting-seller small.privacy{display:block;margin-top:15px}@media (max-width:767px){.lead-route .inputting-seller small{display:block;margin-top:0}}.lead-route .inputting-seller .form-question.no-border{border:none}.lead-route .inputting-seller .single-indent{margin:auto;width:30%}@media (max-width:1199px){.lead-route .inputting-seller .single-indent{width:70%}}@media (max-width:991px){.lead-route .inputting-seller .single-indent{width:100%}}.lead-route .inputting-seller .double-indent{padding-left:30px;padding-top:1em}.lead-route .inputting-seller .account-questions input{margin-top:10px}.lead-route .inputting-eligibility .additional-input{margin-left:32px;font-size:14px}.lead-route .contact-info{margin-top:25px}.route-listings-show{overflow:hidden}.route-listings-show .listing section{padding:0;margin:0}.route-listings-show .markdown-listing-remarks p{margin-bottom:1em}.route-listings-show .markdown-listing-remarks p:last-of-type{margin-bottom:0}.route-listings-show .primary-carousel{max-width:-webkit-calc(100vw - 2 * 18px);max-width:calc(100vw - 2 * 18px)}.route-listings-show .primary-carousel .photo-carousel-container{height:40vw;min-height:65vh}@media (max-width:1199px){.route-listings-show .primary-carousel .photo-carousel-container{min-height:55vh}}@media (max-width:991px){.route-listings-show .primary-carousel .photo-carousel-container{min-height:45vh}}@media (max-width:767px){.route-listings-show .primary-carousel .photo-carousel-container{min-height:25vh}}.route-listings-show .listing-address{margin:4em 0}.route-listings-show .listing-address .street{margin-bottom:6px;font-size:32px}.route-listings-show .listing-address .listing-price{margin-bottom:6px}.route-listings-show .listing-address .home-features{font-weight:normal;color:#525975}.route-listings-show .listing-address .main-column{text-align:left}@media (max-width:767px){.route-listings-show .listing-address .main-column{text-align:center}}.route-listings-show .listing-address .main-column .sharing-menu{margin-top:12px}.route-listings-show .listing-address .price-box-container{border-left:1px solid rgba(192,192,191,0.3);text-align:right}@media (max-width:767px){.route-listings-show .listing-address .price-box-container{padding:12px 0 0 0;border-left:none;text-align:center}}.route-listings-show .listing-address .price-box{display:inline-block}.route-listings-show .listing-action{display:inline-block;margin-right:24px;margin-top:24px}.route-listings-show .listing-action a[class^='icon-']{color:#525975;font-size:12px;font-weight:500;-webkit-transition:all .5s ease;transition:all .5s ease}.route-listings-show .listing-action a[class^='icon-']:hover{color:#1c85e8}.route-listings-show .listing-action:last-of-type{margin-right:0}.route-listings-show section:first-of-type{margin-top:2.5em}.route-listings-show section.listing-remark{padding-top:64px}.route-listings-show section.listing-remark .opendoor-guarantee{padding-left:1.5em}@media (max-width:767px){.route-listings-show section.listing-remark .opendoor-guarantee{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;padding:2em 0;margin-top:2em;text-align:center}.route-listings-show section.listing-remark .opendoor-guarantee .guarantee-points{margin:12px 0 0}}@media (min-width:768px){.route-listings-show section.listing-remark .guarantee-point{margin:.5em 0 0}}@media (max-width:767px){.route-listings-show section.listing-remark .logo{display:inline-block;vertical-align:top;margin-right:25px}}@media (min-width:768px){.route-listings-show section.listing-remark .logo{margin-bottom:1em}}@media (max-width:767px){.route-listings-show section.listing-remark .content{display:inline-block}}.route-listings-show section.at-a-glance label,.route-listings-show section.schools label,.route-listings-show section.market-analysis label,.route-listings-show section.comps label,.route-listings-show section.similar-listings label{display:block;padding-bottom:12px;margin-bottom:32px;margin-top:64px;font-weight:500;font-size:12px;border-bottom:1px solid rgba(192,192,191,0.3)}.route-listings-show section.at-a-glance .features-container .feature-label,.route-listings-show section.schools .features-container .feature-label,.route-listings-show section.market-analysis .features-container .feature-label,.route-listings-show section.comps .features-container .feature-label,.route-listings-show section.similar-listings .features-container .feature-label{display:inline-block}.route-listings-show section.at-a-glance .feature-list,.route-listings-show section.schools .feature-list,.route-listings-show section.market-analysis .feature-list,.route-listings-show section.comps .feature-list,.route-listings-show section.similar-listings .feature-list{margin:0;padding:0}.route-listings-show section.at-a-glance .feature-list li,.route-listings-show section.schools .feature-list li,.route-listings-show section.market-analysis .feature-list li,.route-listings-show section.comps .feature-list li,.route-listings-show section.similar-listings .feature-list li{margin-bottom:18px}.route-listings-show section.schools .school-row{margin-bottom:18px}.route-listings-show section.schools span.school-info+span.school-info{margin-left:1em}.route-listings-show section.comps{font-size:14px}.route-listings-show section.comps table{width:100%;border-collapse:collapse}.route-listings-show section.comps table th{font-weight:500}@media (max-width:767px){.route-listings-show section.comps table th{background-color:#fafafa;color:#70828f}}.route-listings-show section.comps table th,.route-listings-show section.comps table td{padding:1em 0}.route-listings-show section.comps table th:first-child,.route-listings-show section.comps table td:first-child{padding-left:12px}.route-listings-show section.comps table th:last-child,.route-listings-show section.comps table td:last-child{padding-right:12px}@media (max-width:767px){.route-listings-show section.comps table th,.route-listings-show section.comps table td{font-size:12px}}.route-listings-show section.comps table tr.hover{background-color:#525975;color:#fff}@media (max-width:767px){.route-listings-show .related-listing+.related-listing{margin-top:1em}}.route-listings-show .more-listings+.more-listings{margin-top:24px}.route-listings-show section.about{padding:5em 0}.route-listings-show section.about .about-header{margin-bottom:24px}.route-listings-show .back-to-map{margin-top:24px}.route-listings-show .request-sms-directions{margin-top:64px;margin-bottom:10px}.route-listings-show .sms-directions-form{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;margin-top:4px;margin-bottom:4px}.route-listings-show .sms-directions-input{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1;width:125px}.route-listings-show .sms-directions-submit{-webkit-box-flex:0;-webkit-flex:0;-ms-flex:0;flex:0;margin-left:.5em}.route-listings-show .buying-options-modal .modal-dialog{padding-bottom:50px}.route-listings-show .buying-options-modal .modal-dialog-header{padding:0}.route-listings-show .buying-options-modal h5{margin:.5em 0 1em}.route-listings-show .buying-options-modal h6{margin:.5em 0}.route-listings-show .buying-options-modal .buyer-col{padding-right:32px}.route-listings-show .buying-options-modal .agent-col{border-left:1px solid rgba(192,192,191,0.3);padding-left:32px}.route-listings-show .buying-options-modal .button{margin:1em 0}.route-listings-show .buying-options-modal-title{font-weight:500}.route-listings-show .price-icon.subject{background-color:#3d4143}.route-listings-show .price-icon.subject:after{border-top-color:#3d4143}@media (max-width:767px){.route-listings-show section.about h5{margin-top:24px}.route-listings-show .buying-options-modal .agent-col{margin-top:32px;border-left:none;padding-left:9px}.route-listings-show .buying-options-modal .buyer-col{padding-right:9px}}.flywheel-box{margin:64px 0;padding:40px;background:#f5f8fb;-webkit-border-radius:4px;border-radius:4px}@media (max-width:992px){.flywheel-box{text-align:center}}.flywheel-illustration{margin:-50px auto 0 auto;display:block;width:100%;height:auto}.button.primary.flywheel-cta{padding:10px 20px;margin-top:24px}@media (max-width:479px){.route-listings-show .buying-options-modal .modal-dialog{padding:32px 32px}}.route-homes-market-chart .page{background-color:#fff;padding-top:30px}.route-repairs .category{margin-bottom:2em}.route-repairs .category h2{margin-bottom:1em}.route-repairs .repair-item{-webkit-box-shadow:0 0 0 1px #dedede;box-shadow:0 0 0 1px #dedede;padding:20px;-webkit-border-radius:4px;border-radius:4px;margin-bottom:24px;-webkit-transition:all .5s cubic-bezier(.1, .7, .1, 1);transition:all .5s cubic-bezier(.1, .7, .1, 1);text-align:center;cursor:pointer}.route-repairs .repair-item .repair-illustration{margin-bottom:6px}.route-repairs .repair-item svg path,.route-repairs .repair-item svg rect,.route-repairs .repair-item svg circle,.route-repairs .repair-item svg ellipse{-webkit-transition:all .5s cubic-bezier(.1, .7, .1, 1);transition:all .5s cubic-bezier(.1, .7, .1, 1);stroke:#dedede}.route-repairs .repair-item:hover{-webkit-box-shadow:0 0 0 2px #f0f0f0;box-shadow:0 0 0 2px #f0f0f0}.route-repairs .repair-item:hover svg path,.route-repairs .repair-item:hover svg rect,.route-repairs .repair-item:hover svg circle,.route-repairs .repair-item:hover svg ellipse{stroke:#f0f0f0}.route-repairs .repair-item.selected{-webkit-box-shadow:0 0 0 2px #1c85e8;box-shadow:0 0 0 2px #1c85e8;color:#1c85e8}.route-repairs .repair-item.selected svg path,.route-repairs .repair-item.selected svg rect,.route-repairs .repair-item.selected svg circle,.route-repairs .repair-item.selected svg ellipse{stroke:#1c85e8}.route-repairs .detail-overlay{background-color:rgba(3,3,3,0.6);height:100vh;width:100vw;position:fixed;top:0;left:0;opacity:0;-webkit-transition:all .5s cubic-bezier(.1, .7, .1, 1);transition:all .5s cubic-bezier(.1, .7, .1, 1);z-index:19;padding-top:24px}.route-repairs .detail-overlay svg{fill:#fff}.route-repairs .detail-overlay.show-details{display:block;opacity:1}.route-repairs .detail-overlay.display-none{display:none}.route-repairs .repair-details ul,.route-repairs .repair-details-desktop ul{list-style:circle;padding-left:24px}.route-repairs .repair-details h5,.route-repairs .repair-details-desktop h5{margin-top:24px}.route-repairs .repair-details{position:fixed;z-index:20;background-color:#fff;height:100vh;top:0;right:-100vw;overflow:scroll;-webkit-transition:all .5s cubic-bezier(.1, .7, .1, 1);transition:all .5s cubic-bezier(.1, .7, .1, 1);padding:0}.route-repairs .repair-details.show-details{right:0}.route-repairs .repair-details-desktop{padding-left:36px;-webkit-transition:all .5s cubic-bezier(.1, .7, .1, 1);transition:all .5s cubic-bezier(.1, .7, .1, 1)}.route-repairs .repair-details-content-desktop,.route-repairs .customer-blurb{border-left:2px solid #1c85e8;padding:0 24px}.route-repairs .customer-blurb{margin-bottom:24px}.route-repairs .repair-details-content{padding:0 24px 24px}.route-repairs .repair-details-content .repair-item-title{background-color:#1c85e8;color:#fff;padding:24px;margin:0 -24px 24px}.route-session .hero{width:120px;height:120px;margin-bottom:2em;padding-top:4em}.route-session input[type=email],.route-session input[type=password]{width:100%}.route-session label{display:block;margin-bottom:2em}header.styleguide-header{background-color:#1c85e8;padding-top:36px;padding-bottom:36px;color:#fff}header.styleguide-header .logo-text{height:25px}header.styleguide-header h1{margin-top:64px;margin-bottom:20px}@media (max-width:479px){header.styleguide-header h1{font-size:32px}}header.styleguide-header p{max-width:40em}header.styleguide-header a{color:#fff}header.styleguide-header a+a{margin-left:30px}.route-style{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;min-height:100vh;overflow-x:hidden}.route-style .fill-screen{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}.route-style .content{padding-right:60px}@media (max-width:767px){.route-style .content{padding-left:0;padding-right:0}}.route-style .module-section .module-link{visibility:hidden}.route-style .module-section:hover .module-link{visibility:visible}.route-style .module-section .icon{font-size:22px;font-weight:300;vertical-align:initial;margin-bottom:0}.route-style .side-nav{background-color:#fafafa;padding-left:0}.route-style .side-nav a{line-height:24px;color:#595959;border-left:2px solid transparent}.route-style .side-nav a.active{border-left:2px solid #1c85e8;font-weight:500}.route-style .side-nav a.expanded{font-weight:500}.route-style .side-nav a.module-group{padding-left:1.5em}.route-style .side-nav a.sub-module{padding-left:2.5em}.styleguide-module-instructions h5:not(:first-child){margin-top:4em}.styleguide-module-instructions p{margin-bottom:1em}.styleguide-module-colors .swatch::before{content:'';padding:15px;display:inline-block;vertical-align:middle;margin:0 5px 5px 0;border:solid 1px rgba(0,0,0,0.2)}.styleguide-module-colors .swatch.c-text::before{content:'Ab';padding:5px;text-align:center;min-width:20px}.styleguide-module-instructions .instruction-block+.instruction-block{margin-top:2.5em}.styleguide-module-od-incrementor od-incrementor{width:200px}.styleguide-module-od-seller-address-input .min-height-container{min-height:300px}.route-vendor-help section.hero{background-color:#1d2c4c}.route-vendor-help .modal-dialog-body .form-group,.route-vendor-help .modal-dialog-body .form-group>*,.route-vendor-help .modal-dialog-body textarea,.route-vendor-help .modal-dialog-body input{width:100%}.route-vendor-help .nav-section{background:#f0f0f0;padding:0}.route-vendor-help ul.nav-tabs{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}.route-vendor-help li.tab{border-bottom:3px solid rgba(0,0,0,0);cursor:pointer;opacity:.5;padding:24px;-webkit-transition:all 250ms ease-in-out;transition:all 250ms ease-in-out}.route-vendor-help li.tab.active{border-bottom:3px solid #1d2c4c;opacity:1}.route-vendor-help li.tab:hover:not(.active){border-bottom:3px solid rgba(0,0,0,0.1);opacity:1}@media (max-width:992px){.route-vendor-help ul.nav-tabs{-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;overflow-x:scroll}.route-vendor-help li.tab{min-width:200px}}.route-vendor-help ul.with-bullets{list-style:unset;padding-left:24px}.route-vendor-help img.full-width{width:100%}.route-vendor-help .video-embed-container{position:relative;padding-bottom:56.25%;height:0;overflow:hidden;max-width:100%}.route-vendor-help .video-embed-container iframe,.route-vendor-help .video-embed-container object,.route-vendor-help .video-embed-container embed{position:absolute;top:0;left:0;width:100%;height:100%}.route-work-orders{max-width:900px}.route-work-orders .dark-blue-bottom-border{border-bottom:2px solid #03476b}.route-work-orders .black-full-border{border:1.5px solid #3d4143}.route-work-orders .black-bottom-border{border-bottom:1.5px solid #3d4143}.route-work-orders .black-top-border{border-top:1.5px solid #3d4143}.route-work-orders .black-right-border{border-right:1.5px solid #3d4143}.route-work-orders .black-side-borders{border-left:1.5px solid #3d4143;border-right:1.5px solid #3d4143}.route-work-orders .work-order-print{page-break-after:always;position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden}.route-work-orders .work-order-web{padding:60px;color:#3b3b3b}.route-work-orders .header{margin-bottom:20px}.route-work-orders .header .row{font-size:14px}.route-work-orders img{display:block;margin:auto}.route-work-orders .small-logo{height:60px;width:auto}.route-work-orders .title{font-size:24px;font-family:Publico}.route-work-orders .top-margin-15{margin-top:15px}.route-work-orders .top-margin-20{margin-top:20px}.route-work-orders .top-padding-10{padding-top:10px}.route-work-orders .bottom-padding-15{padding-bottom:15px}.route-work-orders .left-padding-10{padding-left:10px}.route-work-orders .small-bold-text{font-weight:500;font-size:13px}.route-work-orders .no-margin{margin:0}.alert-danger{color:#ff7f82;font-weight:bold}.alert-warning{background-color:#ec7046;padding:16px}.autocomplete{position:relative;margin:0 auto;color:black;text-shadow:none}.autocomplete input{width:100%}.autocomplete ul{font-size:12px;color:#595959;width:100%;margin:0;padding:8px 0 !important;list-style-type:none;position:absolute;z-index:1;top:100%;margin-top:-1px !important;background-color:white;text-align:left;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;border:solid 1px #dedede}.autocomplete li{padding:.8em 2ex;cursor:pointer;font-size:16px}.autocomplete li:hover{background-color:#dedede !important}.autocomplete li.selected{background-color:#1c85e8;color:white}.box{max-width:772px;margin:0 auto;padding:0 4em;-webkit-box-shadow:0 1px 5px 0 rgba(0,0,0,0.1);box-shadow:0 1px 5px 0 rgba(0,0,0,0.1);-webkit-border-radius:3px;border-radius:3px;background-color:#fff}.box.no-padding{padding:0}.box.light-blue{background-color:#f5f8fb;-webkit-box-shadow:none;box-shadow:none}.box.padded{padding:4em 6em}.box.heavy-shadow{-webkit-box-shadow:0 0 30px 0 rgba(0,0,0,0.15);box-shadow:0 0 30px 0 rgba(0,0,0,0.15)}@media (max-width:479px){.box{padding:0 2em}}button{border:none;background:none}.button{border:none;background:none;cursor:pointer;-webkit-border-radius:3px;border-radius:3px}.button:not(.link){padding:15px 20px;font-size:14px;font-weight:500}.button.primary{background-color:#1c85e8;color:#fff;-webkit-transition:all .3s ease;transition:all .3s ease;display:inline-block}.button.primary:hover:not([disabled]):not(.disabled){background-color:#03476b}.button.primary svg{stroke:#fff}.button.dark{background-color:#1d2c4c;color:#fff;-webkit-transition:all .3s ease;transition:all .3s ease;display:inline-block}.button.dark:hover:not([disabled]):not(.disabled){background-color:#506d7e}.button.dark svg{stroke:#fff}.button.secondary{border:2px solid #f0f0f0;color:#525975;-webkit-transition:all .3s ease;transition:all .3s ease;display:inline-block;background:#fff}.button.secondary:hover:not([disabled]):not(.disabled){border-color:#dedede}.button.secondary svg{stroke:#70828f}.button.icon-text{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}.button.icon-text svg{margin-right:10px;stroke-width:3px}.button.icon-text img{margin-right:10px;width:25px}.button.transparent{border:1px solid #fff;-webkit-transition:all .3s ease;transition:all .3s ease;display:inline-block;color:#fff}.button.transparent:hover:not([disabled]):not(.disabled){border-color:rgba(255,255,255,0.6)}.button.smaller{border:1px solid #f0f0f0;font-size:13px;padding:8px 20px}.button:disabled,.button.disabled{opacity:.4}.button.link{color:#1c85e8}.button-group{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:-6px}.button-group>.button{margin:6px}@media (max-width:767px){.button-group{width:100%}}.small-container{margin-right:auto;margin-left:auto;max-width:720px}@media (max-width:767px){.small-container{max-width:90%}}.regular-container{margin-right:auto;margin-left:auto;max-width:960px}@media (max-width:1199px){.regular-container{max-width:720px}}@media (max-width:767px){.regular-container{max-width:90%}}.medium-container{margin-right:auto;margin-left:auto;max-width:1024px}@media (max-width:1200px){.medium-container{max-width:960px}}@media (max-width:1199px){.medium-container{max-width:720px}}@media (max-width:767px){.medium-container{max-width:90%}}.large-container{margin-right:auto;margin-left:auto;max-width:1280px}@media (max-width:1200px){.large-container{max-width:960px}}@media (max-width:1199px){.large-container{max-width:720px}}@media (max-width:767px){.large-container{max-width:90%}}.inline-error{position:absolute;display:block;background-color:#ec7046;color:#fff;width:100%}.inline-error.ng-hide-remove,.inline-error.ng-hide-add{-webkit-transition:opacity ease-in-out .3s;transition:opacity ease-in-out .3s}.inline-error.ng-hide-remove{opacity:0}.inline-error.ng-hide-remove.ng-hide-remove-active{opacity:1}.inline-error.ng-hide-add{opacity:1}.inline-error.ng-hide-add.ng-hide-add-active{opacity:0}.fixed-footer{position:fixed;width:100%;left:0;bottom:0;padding-top:24px;padding-bottom:24px;background-color:#fff;-webkit-box-shadow:0 11px 10px 9px rgba(75,74,72,0.6);box-shadow:0 11px 10px 9px rgba(75,74,72,0.6);z-index:100}@media (max-width:767px){.fixed-footer{padding-top:12px;padding-bottom:12px}}.container-fluid{margin-right:auto;margin-left:auto;padding-right:18px;padding-left:18px}.container{margin-right:auto;margin-left:auto;padding-right:18px;padding-left:18px}.row{-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-webkit-flex:0 1 auto;-ms-flex:0 1 auto;flex:0 1 auto;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-9px;margin-left:-9px}.row.padded{padding:3rem 0 2rem 0}@media (max-width:767px){.row.padded{padding:1rem 0}}.row.vertical-divider>div{border-right:2px solid #f0f0f0}.row.vertical-divider>div:last-child{border-right:none}@media (max-width:767px){.row.vertical-divider>div{border-right:none}}.row.reverse{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-webkit-flex-direction:row-reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.col.reverse{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-webkit-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}[class^='col-'],[class*=' col-']{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-flex:0;-webkit-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:9px;padding-left:9px;max-width:100%}.col-fill{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.flex-grow{-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1}.col-xs{-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;-webkit-flex-basis:0;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}.col-xs-1{-webkit-flex-basis:8.333333%;-ms-flex-preferred-size:8.333333%;flex-basis:8.333333%;max-width:8.333333%}.col-xs-2{-webkit-flex-basis:16.666667%;-ms-flex-preferred-size:16.666667%;flex-basis:16.666667%;max-width:16.666667%}.col-xs-3{-webkit-flex-basis:25%;-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-xs-4{-webkit-flex-basis:33.333333%;-ms-flex-preferred-size:33.333333%;flex-basis:33.333333%;max-width:33.333333%}.col-xs-5{-webkit-flex-basis:41.666667%;-ms-flex-preferred-size:41.666667%;flex-basis:41.666667%;max-width:41.666667%}.col-xs-6{-webkit-flex-basis:50%;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-xs-7{-webkit-flex-basis:58.333333%;-ms-flex-preferred-size:58.333333%;flex-basis:58.333333%;max-width:58.333333%}.col-xs-8{-webkit-flex-basis:66.666667%;-ms-flex-preferred-size:66.666667%;flex-basis:66.666667%;max-width:66.666667%}.col-xs-9{-webkit-flex-basis:75%;-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-xs-10{-webkit-flex-basis:83.333333%;-ms-flex-preferred-size:83.333333%;flex-basis:83.333333%;max-width:83.333333%}.col-xs-11{-webkit-flex-basis:91.666667%;-ms-flex-preferred-size:91.666667%;flex-basis:91.666667%;max-width:91.666667%}.col-xs-12{-webkit-flex-basis:100%;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.col-xs-offset-0{margin-left:0}.col-xs-offset-1{margin-left:8.333333%}.col-xs-offset-2{margin-left:16.666667%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-4{margin-left:33.333333%}.col-xs-offset-5{margin-left:41.666667%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-7{margin-left:58.333333%}.col-xs-offset-8{margin-left:66.666667%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-10{margin-left:83.333333%}.col-xs-offset-11{margin-left:91.666667%}.start-xs{-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;text-align:left}.center-xs{-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;text-align:center}.end-xs{-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;text-align:right}.top-xs{-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;-ms-grid-row-align:flex-start;align-items:flex-start}.middle-xs{-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.self-middle-xs{-webkit-align-self:center;-ms-flex-item-align:center;align-self:center;text-align:center}.bottom-xs{-webkit-box-align:end;-webkit-align-items:flex-end;-ms-flex-align:end;-ms-grid-row-align:flex-end;align-items:flex-end}.around-xs{-webkit-justify-content:space-around;-ms-flex-pack:distribute;justify-content:space-around}.between-xs{-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.first-xs{-webkit-box-ordinal-group:0;-webkit-order:-1;-ms-flex-order:-1;order:-1}.last-xs{-webkit-box-ordinal-group:2;-webkit-order:1;-ms-flex-order:1;order:1}@media only screen and (min-width:768px){.container{width:732px}.col-sm{-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;-webkit-flex-basis:0;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}.col-sm-1{-webkit-flex-basis:8.333333%;-ms-flex-preferred-size:8.333333%;flex-basis:8.333333%;max-width:8.333333%}.col-sm-2{-webkit-flex-basis:16.666667%;-ms-flex-preferred-size:16.666667%;flex-basis:16.666667%;max-width:16.666667%}.col-sm-3{-webkit-flex-basis:25%;-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-sm-4{-webkit-flex-basis:33.333333%;-ms-flex-preferred-size:33.333333%;flex-basis:33.333333%;max-width:33.333333%}.col-sm-5{-webkit-flex-basis:41.666667%;-ms-flex-preferred-size:41.666667%;flex-basis:41.666667%;max-width:41.666667%}.col-sm-6{-webkit-flex-basis:50%;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-sm-7{-webkit-flex-basis:58.333333%;-ms-flex-preferred-size:58.333333%;flex-basis:58.333333%;max-width:58.333333%}.col-sm-8{-webkit-flex-basis:66.666667%;-ms-flex-preferred-size:66.666667%;flex-basis:66.666667%;max-width:66.666667%}.col-sm-9{-webkit-flex-basis:75%;-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-sm-10{-webkit-flex-basis:83.333333%;-ms-flex-preferred-size:83.333333%;flex-basis:83.333333%;max-width:83.333333%}.col-sm-11{-webkit-flex-basis:91.666667%;-ms-flex-preferred-size:91.666667%;flex-basis:91.666667%;max-width:91.666667%}.col-sm-12{-webkit-flex-basis:100%;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.col-sm-offset-0{margin-left:0}.col-sm-offset-1{margin-left:8.333333%}.col-sm-offset-2{margin-left:16.666667%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-4{margin-left:33.333333%}.col-sm-offset-5{margin-left:41.666667%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-7{margin-left:58.333333%}.col-sm-offset-8{margin-left:66.666667%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-10{margin-left:83.333333%}.col-sm-offset-11{margin-left:91.666667%}.start-sm{-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}.center-sm{-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;text-align:center}.end-sm{-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}.top-sm{-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;-ms-grid-row-align:flex-start;align-items:flex-start}.middle-sm{-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.bottom-sm{-webkit-box-align:end;-webkit-align-items:flex-end;-ms-flex-align:end;-ms-grid-row-align:flex-end;align-items:flex-end}.around-sm{-webkit-justify-content:space-around;-ms-flex-pack:distribute;justify-content:space-around}.between-sm{-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.first-sm{-webkit-box-ordinal-group:0;-webkit-order:-1;-ms-flex-order:-1;order:-1}.last-sm{-webkit-box-ordinal-group:2;-webkit-order:1;-ms-flex-order:1;order:1}}@media only screen and (min-width:992px){.container{width:956px}.col-md{-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;-webkit-flex-basis:0;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}.col-md-1{-webkit-flex-basis:8.333333%;-ms-flex-preferred-size:8.333333%;flex-basis:8.333333%;max-width:8.333333%}.col-md-2{-webkit-flex-basis:16.666667%;-ms-flex-preferred-size:16.666667%;flex-basis:16.666667%;max-width:16.666667%}.col-md-3{-webkit-flex-basis:25%;-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-md-4{-webkit-flex-basis:33.333333%;-ms-flex-preferred-size:33.333333%;flex-basis:33.333333%;max-width:33.333333%}.col-md-5{-webkit-flex-basis:41.666667%;-ms-flex-preferred-size:41.666667%;flex-basis:41.666667%;max-width:41.666667%}.col-md-6{-webkit-flex-basis:50%;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-md-7{-webkit-flex-basis:58.333333%;-ms-flex-preferred-size:58.333333%;flex-basis:58.333333%;max-width:58.333333%}.col-md-8{-webkit-flex-basis:66.666667%;-ms-flex-preferred-size:66.666667%;flex-basis:66.666667%;max-width:66.666667%}.col-md-9{-webkit-flex-basis:75%;-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-md-10{-webkit-flex-basis:83.333333%;-ms-flex-preferred-size:83.333333%;flex-basis:83.333333%;max-width:83.333333%}.col-md-11{-webkit-flex-basis:91.666667%;-ms-flex-preferred-size:91.666667%;flex-basis:91.666667%;max-width:91.666667%}.col-md-12{-webkit-flex-basis:100%;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.col-md-offset-0{margin-left:0}.col-md-offset-1{margin-left:8.333333%}.col-md-offset-2{margin-left:16.666667%}.col-md-offset-3{margin-left:25%}.col-md-offset-4{margin-left:33.333333%}.col-md-offset-5{margin-left:41.666667%}.col-md-offset-6{margin-left:50%}.col-md-offset-7{margin-left:58.333333%}.col-md-offset-8{margin-left:66.666667%}.col-md-offset-9{margin-left:75%}.col-md-offset-10{margin-left:83.333333%}.col-md-offset-11{margin-left:91.666667%}.start-md{-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}.center-md{-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;text-align:center}.end-md{-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}.top-md{-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;-ms-grid-row-align:flex-start;align-items:flex-start}.middle-md{-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.bottom-md{-webkit-box-align:end;-webkit-align-items:flex-end;-ms-flex-align:end;-ms-grid-row-align:flex-end;align-items:flex-end}.around-md{-webkit-justify-content:space-around;-ms-flex-pack:distribute;justify-content:space-around}.between-md{-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.first-md{-webkit-box-ordinal-group:0;-webkit-order:-1;-ms-flex-order:-1;order:-1}.last-md{-webkit-box-ordinal-group:2;-webkit-order:1;-ms-flex-order:1;order:1}}@media only screen and (min-width:1200px){.container{width:1164px}.col-lg{-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;-webkit-flex-basis:0;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}.col-lg-1{-webkit-flex-basis:8.333333%;-ms-flex-preferred-size:8.333333%;flex-basis:8.333333%;max-width:8.333333%}.col-lg-2{-webkit-flex-basis:16.666667%;-ms-flex-preferred-size:16.666667%;flex-basis:16.666667%;max-width:16.666667%}.col-lg-3{-webkit-flex-basis:25%;-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-lg-4{-webkit-flex-basis:33.333333%;-ms-flex-preferred-size:33.333333%;flex-basis:33.333333%;max-width:33.333333%}.col-lg-5{-webkit-flex-basis:41.666667%;-ms-flex-preferred-size:41.666667%;flex-basis:41.666667%;max-width:41.666667%}.col-lg-6{-webkit-flex-basis:50%;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-lg-7{-webkit-flex-basis:58.333333%;-ms-flex-preferred-size:58.333333%;flex-basis:58.333333%;max-width:58.333333%}.col-lg-8{-webkit-flex-basis:66.666667%;-ms-flex-preferred-size:66.666667%;flex-basis:66.666667%;max-width:66.666667%}.col-lg-9{-webkit-flex-basis:75%;-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-lg-10{-webkit-flex-basis:83.333333%;-ms-flex-preferred-size:83.333333%;flex-basis:83.333333%;max-width:83.333333%}.col-lg-11{-webkit-flex-basis:91.666667%;-ms-flex-preferred-size:91.666667%;flex-basis:91.666667%;max-width:91.666667%}.col-lg-12{-webkit-flex-basis:100%;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.col-lg-offset-0{margin-left:0}.col-lg-offset-1{margin-left:8.333333%}.col-lg-offset-2{margin-left:16.666667%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-4{margin-left:33.333333%}.col-lg-offset-5{margin-left:41.666667%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-7{margin-left:58.333333%}.col-lg-offset-8{margin-left:66.666667%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-10{margin-left:83.333333%}.col-lg-offset-11{margin-left:91.666667%}.start-lg{-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}.center-lg{-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;text-align:center}.end-lg{-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}.top-lg{-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;-ms-grid-row-align:flex-start;align-items:flex-start}.middle-lg{-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.bottom-lg{-webkit-box-align:end;-webkit-align-items:flex-end;-ms-flex-align:end;-ms-grid-row-align:flex-end;align-items:flex-end}.around-lg{-webkit-justify-content:space-around;-ms-flex-pack:distribute;justify-content:space-around}.between-lg{-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.first-lg{-webkit-box-ordinal-group:0;-webkit-order:-1;-ms-flex-order:-1;order:-1}.last-lg{-webkit-box-ordinal-group:2;-webkit-order:1;-ms-flex-order:1;order:1}}.flex-static{-webkit-box-flex:0;-webkit-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;-webkit-flex-basis:auto;-ms-flex-preferred-size:auto;flex-basis:auto}.icon{display:inline-block;vertical-align:middle;width:1em;height:1em;margin-bottom:.2em}a .icon{fill:#1c85e8}.icon.question_mark{font-size:12px}.horizontal-illustrated-point-mixin{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}.horizontal-illustrated-point-mixin+.illustrated-point.horizontal{margin-top:5em}.horizontal-illustrated-point-mixin img{margin:0;height:auto;width:80px}.horizontal-illustrated-point-mixin .illustrated-point-description{margin-left:2em;text-align:left}.illustrated-point{text-align:center}.illustrated-point img{height:80px;margin:0 auto 1em}.illustrated-point .illustrated-point-description h1{margin-top:0;margin-bottom:.3em}.illustrated-point .illustrated-point-description h2,.illustrated-point .illustrated-point-description h3,.illustrated-point .illustrated-point-description h4,.illustrated-point .illustrated-point-description h5,.illustrated-point .illustrated-point-description h6,.illustrated-point .illustrated-point-description p,.illustrated-point .illustrated-point-description q{margin-top:0;margin-bottom:.5em}.illustrated-point.horizontal{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}.illustrated-point.horizontal+.illustrated-point.horizontal{margin-top:5em}.illustrated-point.horizontal img{margin:0;height:auto;width:80px}.illustrated-point.horizontal .illustrated-point-description{margin-left:2em;text-align:left}.illustrated-point-group{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-justify-content:space-around;-ms-flex-pack:distribute;justify-content:space-around}@media (min-width:768px){.illustrated-point-group>.illustrated-point{-webkit-flex-basis:100%;-ms-flex-preferred-size:100%;flex-basis:100%}.illustrated-point-group .illustrated-point+.illustrated-point{margin-left:18px}}@media (max-width:767px){.illustrated-point-group{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.illustrated-point-group .illustrated-point{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;align-items:flex-start}.illustrated-point-group .illustrated-point+.illustrated-point.horizontal{margin-top:5em}.illustrated-point-group .illustrated-point img{margin:0;height:auto;width:80px}.illustrated-point-group .illustrated-point .illustrated-point-description{margin-left:2em;text-align:left}.illustrated-point-group .illustrated-point img{width:40px;margin-top:8px}.illustrated-point-group .illustrated-point+.illustrated-point{margin-top:18px}}.fluid-width-img{display:block;width:100%;height:auto}.fluid-height-img{display:block;width:auto;height:100%}img.block{display:block}.impersonator-bar{position:fixed;z-index:100;top:0;left:0;right:0;padding:0;background-color:#ab80de;color:#fff}.impersonator-bar form{float:right}.impersonator-bar span{display:inline-block;margin-top:3px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}@media (max-width:479px){.impersonator-bar span{width:200px}}.impersonator-bar button{color:#fff;background:none;-webkit-box-shadow:none;box-shadow:none}.impersonator-bar button.link:hover{color:#f0f0f0}.impersonator-bar+*{margin-top:1em}.label{background-color:#1c85e8;-webkit-border-radius:2px;border-radius:2px;color:#fff;display:inline-block;-webkit-box-shadow:.2em 0 0 #1c85e8,-0.2em 0 0 #1c85e8;box-shadow:.2em 0 0 #1c85e8,-0.2em 0 0 #1c85e8;padding:.15em .2em;margin-bottom:20px}.label.label-success{background-color:#68e1c7}.label.label-warning{background-color:#ec7046}.label.label-primary{background-color:#1c85e8}.label.label-info{background-color:#ab80de}.label.label-info-dark{background-color:#442970}.layout .wordmark{font-family:'Publico',serif;font-weight:bold;text-transform:uppercase;background:#fff}.full-width{width:100%}@media (min-width:768px){.application-header-xs-down,.application-footer-xs-down{display:none}}@media (max-width:767px){.application-header-xs-down:not(:empty)+.application-header,.application-footer-xs-down:not(:empty)+.application-footer{display:none}}.prevent-scroll{overflow:hidden}.lazy-photo{position:relative;-webkit-transition:all ease-in-out .1s;transition:all ease-in-out .1s;background-color:#dedede;background-size:cover;background-position:center}.lazy-photo:after{content:'';position:absolute;display:block;top:50%;left:50%;width:18px;height:18px;margin-top:-12px;margin-left:-12px;-webkit-border-radius:100%;border-radius:100%;border:solid 3px transparent;-webkit-animation:none;animation:none}.lazy-photo.in-progress{color:transparent}.lazy-photo.in-progress:hover{color:transparent}.lazy-photo.in-progress:after{z-index:2;border-color:#fff;border-bottom-color:transparent;-webkit-animation:in-progress-rotate .6s infinite linear;animation:in-progress-rotate .6s infinite linear}.lazy-photo.in-progress{min-height:40px}.lazy-photo .lazy-photo-loaded-contents{position:relative;-webkit-transition:all ease-in-out .1s;transition:all ease-in-out .1s;background-size:cover;background-position:center;height:100%;width:100%}.lazy-photo .lazy-photo-loaded-contents:after{content:'';position:absolute;display:block;top:50%;left:50%;width:18px;height:18px;margin-top:-12px;margin-left:-12px;-webkit-border-radius:100%;border-radius:100%;border:solid 3px transparent;-webkit-animation:none;animation:none}.lazy-photo .lazy-photo-loaded-contents.in-progress{color:transparent}.lazy-photo .lazy-photo-loaded-contents.in-progress:hover{color:transparent}.lazy-photo .lazy-photo-loaded-contents.in-progress:after{z-index:2;border-color:#70828f;border-bottom-color:transparent;-webkit-animation:in-progress-rotate .6s infinite linear;animation:in-progress-rotate .6s infinite linear}ul{list-style:none;padding-left:0}.icon-list .icon{margin-right:.5em}.icon-list li+li{margin-top:.5em}.bullet-list{list-style:disc;margin-left:17px}.primary-bullet-list{text-align:left}.primary-bullet-list li{display:inline-block;margin-bottom:20px;padding-left:30px;position:relative}.primary-bullet-list li:after{content:'';width:8px;height:8px;-webkit-border-radius:50%;border-radius:50%;background:#506d7e;position:absolute;left:0;top:8px}.loading-spinner{position:relative;-webkit-transition:all ease-in-out .1s;transition:all ease-in-out .1s;color:transparent}.loading-spinner:after{content:'';position:absolute;display:block;top:50%;left:50%;width:18px;height:18px;margin-top:-12px;margin-left:-12px;-webkit-border-radius:100%;border-radius:100%;border:solid 3px transparent;-webkit-animation:none;animation:none}.loading-spinner:hover{color:transparent}.loading-spinner:after{z-index:2;border-color:#fff;border-bottom-color:transparent;-webkit-animation:in-progress-rotate .6s infinite linear;animation:in-progress-rotate .6s infinite linear}.loading-spinner.in-progress{color:transparent}.loading-spinner.in-progress:hover{color:transparent}.loading-spinner.in-progress:after{z-index:2;border-color:#fff;border-bottom-color:transparent;-webkit-animation:in-progress-rotate .6s infinite linear;animation:in-progress-rotate .6s infinite linear}.loading-spinner-medium{position:relative;-webkit-transition:all ease-in-out .1s;transition:all ease-in-out .1s;color:transparent}.loading-spinner-medium:after{content:'';position:absolute;display:block;top:50%;left:50%;width:18px;height:18px;margin-top:-12px;margin-left:-12px;-webkit-border-radius:100%;border-radius:100%;border:solid 3px transparent;-webkit-animation:none;animation:none}.loading-spinner-medium:hover{color:transparent}.loading-spinner-medium:after{z-index:2;border-color:#dedede;border-bottom-color:transparent;-webkit-animation:in-progress-rotate .6s infinite linear;animation:in-progress-rotate .6s infinite linear}.loading-spinner-medium.in-progress{color:transparent}.loading-spinner-medium.in-progress:hover{color:transparent}.loading-spinner-medium.in-progress:after{z-index:2;border-color:#dedede;border-bottom-color:transparent;-webkit-animation:in-progress-rotate .6s infinite linear;animation:in-progress-rotate .6s infinite linear}.loading-spinner-dark{position:relative;-webkit-transition:all ease-in-out .1s;transition:all ease-in-out .1s;color:transparent}.loading-spinner-dark:after{content:'';position:absolute;display:block;top:50%;left:50%;width:18px;height:18px;margin-top:-12px;margin-left:-12px;-webkit-border-radius:100%;border-radius:100%;border:solid 3px transparent;-webkit-animation:none;animation:none}.loading-spinner-dark:hover{color:transparent}.loading-spinner-dark:after{z-index:2;border-color:#1d2c4c;border-bottom-color:transparent;-webkit-animation:in-progress-rotate .6s infinite linear;animation:in-progress-rotate .6s infinite linear}.loading-spinner-dark.in-progress{color:transparent}.loading-spinner-dark.in-progress:hover{color:transparent}.loading-spinner-dark.in-progress:after{z-index:2;border-color:#1d2c4c;border-bottom-color:transparent;-webkit-animation:in-progress-rotate .6s infinite linear;animation:in-progress-rotate .6s infinite linear}.modal{position:fixed;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;top:0;bottom:0;left:0;right:0;background-color:rgba(44,44,43,0.8);z-index:101;overflow:auto}.modal.modal-sm .modal-dialog{max-width:550px}.modal.modal-lg .modal-dialog{max-width:850px}.modal.modal-xl .modal-dialog{max-width:960px}.modal-dialog{position:relative;width:100%;max-width:700px;margin-left:auto;margin-right:auto;background-color:#fff;-webkit-border-radius:3px;border-radius:3px;-webkit-box-shadow:0 0 10px #444;box-shadow:0 0 10px #444;padding:32px 50px;-webkit-box-align:baseline;-webkit-align-items:baseline;-ms-flex-align:baseline;-ms-grid-row-align:baseline;align-items:baseline}.modal-dialog-header{position:relative;padding-bottom:60px}.modal-close-button{position:absolute;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;top:0;right:0;cursor:pointer}.modal-close-button svg{margin-bottom:0;stroke-width:4px;stroke:#70828f;-webkit-transition:stroke .1s ease-in-out;transition:stroke .1s ease-in-out}.modal-close-button:hover svg{stroke:#4e6373}.modal-dialog-body{position:relative}.modal-dialog-body .modal-label{margin-bottom:4px;font-size:14px}.modal-dialog-body .modal-input{margin-bottom:12px;width:100%}.modal-dialog-footer{margin-top:64px;font-size:14px;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.modal-dialog-footer .button{font-size:16px}.nav-tabs{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;height:100%}.nav-tabs .nav-tab{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;padding-left:1.2em;padding-right:1.2em;color:#1c85e8;cursor:pointer}.nav-tabs .nav-tab.active{font-weight:500;color:#595959;-webkit-box-shadow:inset 0 -2px 0 0 #1c85e8;box-shadow:inset 0 -2px 0 0 #1c85e8}ul.nav.nav-pills li{padding:.5em 24px;-webkit-border-radius:3px;border-radius:3px;font-size:14px}ul.nav.nav-pills li.active{background-color:#fafafa;font-weight:500}ul.nav.nav-pills li a svg.icon{margin-top:-1px;margin-right:6px}ul.nav.nav-pills a{display:block;color:#525975}.perk-list li,.perk-list-dark li,.antiperk-list li{padding-left:34px}.perk-list li+li,.perk-list-dark li+li,.antiperk-list li+li{margin-top:20px}.perk-list.small,.perk-list-dark.small,.antiperk-list.small{font-size:12px}.perk-list.small li,.perk-list-dark.small li,.antiperk-list.small li{padding-left:28px;background-position:0 1px}.perk-list li{background:url('https://images.opendoor.com/source/s3/imgdrop-production/checkmark-blue.svg?service=web') 0 3px no-repeat}.perk-list-dark li{background:url('https://images.opendoor.com/source/s3/imgdrop-production/checkmark-navy.svg?service=web') 0 3px no-repeat}.antiperk-list li{background:url('https://images.opendoor.com/source/s3/imgdrop-production/minus-grey.svg?service=web') 0 3px no-repeat}label input[type=radio],label input[type=checkbox]{position:absolute;left:-10000px}input[type=radio][disabled]+span,input[type=checkbox][disabled]+span{cursor:default;opacity:.6}input[type=radio]:hover:not([disabled]):not(:checked)+span,input[type=checkbox]:hover:not([disabled]):not(:checked)+span{color:#595959}.form-block{text-align:left}label.checkbox{display:inline-block;margin-bottom:1em}label.checkbox+label.checkbox{margin-left:2em}.form-block label.checkbox{display:block;margin-bottom:0}.form-block label.checkbox+label.checkbox{margin-left:0;margin-top:1em}@media (max-width:767px){label.checkbox{display:block;margin-bottom:0}label.checkbox+label.checkbox{margin-left:0;margin-top:1em}}label.checkbox input[type=checkbox]+span{display:inline-block;text-indent:30px;text-align:left;color:#70828f}label.checkbox input[type=checkbox]+span:before{content:'';position:absolute;display:inline-block;-webkit-box-sizing:border-box;box-sizing:border-box;width:20px;height:20px;margin-left:-30px;-webkit-border-radius:1px;border-radius:1px;background-color:#1c85e8;background-size:100%;border:10px #fff solid;-webkit-box-shadow:0 0 0 1px rgba(82,89,117,0.3);box-shadow:0 0 0 1px rgba(82,89,117,0.3);-webkit-transition:all .15s cubic-bezier(.1, .7, .1, 1);transition:all .15s cubic-bezier(.1, .7, .1, 1)}label.checkbox input[type=checkbox]:hover:not([disabled]):not(:checked)+span:before{-webkit-box-shadow:0 0 0 1px #9ba1a6;box-shadow:0 0 0 1px #9ba1a6}label.checkbox input[type=checkbox]:checked+span{color:#1c85e8}label.checkbox input[type=checkbox]:checked+span:before{-webkit-box-shadow:0 0 0 1px #1c85e8;box-shadow:0 0 0 1px #1c85e8;border-width:2px}label.radio{display:inline-block;margin-bottom:1em}label.radio+label.radio{margin-left:2em}.form-block label.radio{display:block;margin-bottom:0}.form-block label.radio+label.radio{margin-left:0;margin-top:1em}@media (max-width:767px){label.radio{display:block;margin-bottom:0}label.radio+label.radio{margin-left:0;margin-top:1em}}label.radio input[type=radio]+span{display:inline-block;text-indent:30px;text-align:left;color:#70828f}label.radio input[type=radio]+span:before{content:'';position:absolute;display:inline-block;-webkit-box-sizing:border-box;box-sizing:border-box;width:20px;height:20px;margin-left:-30px;-webkit-border-radius:1px;border-radius:1px;background-color:#1c85e8;background-size:100%;border:10px #fff solid;-webkit-box-shadow:0 0 0 1px rgba(82,89,117,0.3);box-shadow:0 0 0 1px rgba(82,89,117,0.3);-webkit-transition:all .15s cubic-bezier(.1, .7, .1, 1);transition:all .15s cubic-bezier(.1, .7, .1, 1)}label.radio input[type=radio]:hover:not([disabled]):not(:checked)+span:before{-webkit-box-shadow:0 0 0 1px #9ba1a6;box-shadow:0 0 0 1px #9ba1a6}label.radio input[type=radio]:checked+span{color:#1c85e8}label.radio input[type=radio]:checked+span:before{-webkit-box-shadow:0 0 0 1px #1c85e8;box-shadow:0 0 0 1px #1c85e8;border-width:2px}label.radio input[type=radio]+span:before{-webkit-border-radius:50%;border-radius:50%}.checkbox-btn-group,.radio-btn-group{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;margin:12px 0}.checkbox-btn-group label.checkbox-btn input[type=checkbox]+span,.radio-btn-group label.checkbox-btn input[type=checkbox]+span{color:#70828f;text-align:center;padding:12px 12px;border-width:1px 0 1px 1px;border-style:solid;border-color:#dedede;white-space:nowrap;cursor:pointer;-webkit-tap-highlight-color:transparent;-webkit-transition:all .15s cubic-bezier(.1, .7, .1, 1);transition:all .15s cubic-bezier(.1, .7, .1, 1)}.checkbox-btn-group label.checkbox-btn input[type=checkbox]:checked+span,.radio-btn-group label.checkbox-btn input[type=checkbox]:checked+span{background-color:#1c85e8;color:#fff}.checkbox-btn-group label.checkbox-btn:first-child input[type=checkbox]+span,.radio-btn-group label.checkbox-btn:first-child input[type=checkbox]+span{-webkit-border-top-left-radius:3px;border-top-left-radius:3px;-webkit-border-bottom-left-radius:3px;border-bottom-left-radius:3px}.checkbox-btn-group label.checkbox-btn:last-child input[type=checkbox]+span,.radio-btn-group label.checkbox-btn:last-child input[type=checkbox]+span{border-right-width:1px;-webkit-border-top-right-radius:3px;border-top-right-radius:3px;-webkit-border-bottom-right-radius:3px;border-bottom-right-radius:3px}.checkbox-btn-group label.radio-btn input[type=radio]+span,.radio-btn-group label.radio-btn input[type=radio]+span{color:#70828f;text-align:center;padding:12px 12px;border-width:1px 0 1px 1px;border-style:solid;border-color:#dedede;white-space:nowrap;cursor:pointer;-webkit-tap-highlight-color:transparent;-webkit-transition:all .15s cubic-bezier(.1, .7, .1, 1);transition:all .15s cubic-bezier(.1, .7, .1, 1)}.checkbox-btn-group label.radio-btn input[type=radio]:checked+span,.radio-btn-group label.radio-btn input[type=radio]:checked+span{background-color:#1c85e8;color:#fff}.checkbox-btn-group label.radio-btn:first-child input[type=radio]+span,.radio-btn-group label.radio-btn:first-child input[type=radio]+span{-webkit-border-top-left-radius:3px;border-top-left-radius:3px;-webkit-border-bottom-left-radius:3px;border-bottom-left-radius:3px}.checkbox-btn-group label.radio-btn:last-child input[type=radio]+span,.radio-btn-group label.radio-btn:last-child input[type=radio]+span{border-right-width:1px;-webkit-border-top-right-radius:3px;border-top-right-radius:3px;-webkit-border-bottom-right-radius:3px;border-bottom-right-radius:3px}.checkbox-big-btn-group,.radio-big-btn-group{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;margin-right:-16px;margin-bottom:-16px}.checkbox-big-btn-group.one-column,.radio-big-btn-group.one-column{width:400px;margin-right:0}@media (max-width:767px){.checkbox-big-btn-group.one-column,.radio-big-btn-group.one-column{width:100%}}.checkbox-big-btn-group.two-column,.radio-big-btn-group.two-column{width:552px;margin-left:-8px;margin-right:-8px}@media (max-width:767px){.checkbox-big-btn-group.two-column,.radio-big-btn-group.two-column{margin-left:0;margin-right:0;width:100%}}.checkbox-big-btn-group label.checkbox-big-btn,.radio-big-btn-group label.checkbox-big-btn{margin-right:16px;margin-bottom:16px;text-align:center}.checkbox-big-btn-group label.checkbox-big-btn.one-column,.radio-big-btn-group label.checkbox-big-btn.one-column{width:400px;margin-right:0}@media (max-width:767px){.checkbox-big-btn-group label.checkbox-big-btn.one-column,.radio-big-btn-group label.checkbox-big-btn.one-column{width:100%}}.checkbox-big-btn-group label.checkbox-big-btn.two-column,.radio-big-btn-group label.checkbox-big-btn.two-column{width:260px;margin-left:8px;margin-right:8px}@media (max-width:767px){.checkbox-big-btn-group label.checkbox-big-btn.two-column,.radio-big-btn-group label.checkbox-big-btn.two-column{margin-left:0;margin-right:0;width:100%}}.checkbox-big-btn-group label.checkbox-big-btn input[type=checkbox]+span,.radio-big-btn-group label.checkbox-big-btn input[type=checkbox]+span{padding:14px 26px;display:block;color:#595959;border:1px solid #dedede;-webkit-border-radius:1000px;border-radius:1000px;cursor:pointer;-webkit-tap-highlight-color:transparent;-webkit-transition:all .15s cubic-bezier(.1, .7, .1, 1);transition:all .15s cubic-bezier(.1, .7, .1, 1)}.checkbox-big-btn-group label.checkbox-big-btn input[type=checkbox]:checked+span,.radio-big-btn-group label.checkbox-big-btn input[type=checkbox]:checked+span{background-color:#1c85e8;border-color:#1c85e8;color:#fff}.checkbox-big-btn-group label.checkbox-big-btn input[type=checkbox]:not(:checked)+span:hover,.radio-big-btn-group label.checkbox-big-btn input[type=checkbox]:not(:checked)+span:hover{background-color:#fafafa}.checkbox-big-btn-group label.radio-big-btn,.radio-big-btn-group label.radio-big-btn{margin-right:16px;margin-bottom:16px;text-align:center}.checkbox-big-btn-group label.radio-big-btn.one-column,.radio-big-btn-group label.radio-big-btn.one-column{width:400px;margin-right:0}@media (max-width:767px){.checkbox-big-btn-group label.radio-big-btn.one-column,.radio-big-btn-group label.radio-big-btn.one-column{width:100%}}.checkbox-big-btn-group label.radio-big-btn.two-column,.radio-big-btn-group label.radio-big-btn.two-column{width:260px;margin-left:8px;margin-right:8px}@media (max-width:767px){.checkbox-big-btn-group label.radio-big-btn.two-column,.radio-big-btn-group label.radio-big-btn.two-column{margin-left:0;margin-right:0;width:100%}}.checkbox-big-btn-group label.radio-big-btn input[type=radio]+span,.radio-big-btn-group label.radio-big-btn input[type=radio]+span{padding:14px 26px;display:block;color:#595959;border:1px solid #dedede;-webkit-border-radius:1000px;border-radius:1000px;cursor:pointer;-webkit-tap-highlight-color:transparent;-webkit-transition:all .15s cubic-bezier(.1, .7, .1, 1);transition:all .15s cubic-bezier(.1, .7, .1, 1)}.checkbox-big-btn-group label.radio-big-btn input[type=radio]:checked+span,.radio-big-btn-group label.radio-big-btn input[type=radio]:checked+span{background-color:#1c85e8;border-color:#1c85e8;color:#fff}.checkbox-big-btn-group label.radio-big-btn input[type=radio]:not(:checked)+span:hover,.radio-big-btn-group label.radio-big-btn input[type=radio]:not(:checked)+span:hover{background-color:#fafafa}section{padding-top:4rem;padding-bottom:4rem;max-width:1600px;margin-left:auto;margin-right:auto}@media (max-width:767px){section{padding-top:2rem;padding-bottom:2rem}}section.no-padding{padding-top:0;padding-bottom:0}section.less-padding{padding-top:1rem;padding-bottom:1rem}section.padded,section.extra-padding{padding-top:6rem;padding-bottom:5rem}@media (max-width:767px){section.padded,section.extra-padding{padding-top:4rem;padding-bottom:4rem}}section.gradient-top{background:-webkit-gradient(linear, left top, left bottom, color-stop(0, #fafafa), color-stop(30%, #fafafa), to(#fff));background:-webkit-linear-gradient(top, #fafafa 0, #fafafa 30%, #fff 100%);background:linear-gradient(to bottom, #fafafa 0, #fafafa 30%, #fff 100%)}section.gradient-bottom{background:-webkit-gradient(linear, left top, left bottom, color-stop(0, #fff), color-stop(75%, #fafafa), to(#fafafa));background:-webkit-linear-gradient(top, #fff 0, #fafafa 75%, #fafafa 100%);background:linear-gradient(to bottom, #fff 0, #fafafa 75%, #fafafa 100%)}section.gradient-light-blue-bottom{background:-webkit-gradient(linear, left top, left bottom, color-stop(0, #fff), color-stop(75%, #f5f8fb), to(#f5f8fb));background:-webkit-linear-gradient(top, #fff 0, #f5f8fb 75%, #f5f8fb 100%);background:linear-gradient(to bottom, #fff 0, #f5f8fb 75%, #f5f8fb 100%)}section.accent{background-color:#1c85e8;color:#fff}section.dark{background-color:#fafafa}section.white{background-color:#fff}section.dark-blue{background-color:#2f536a;color:#fff}section.dark-blue .text-muted{color:rgba(247,247,247,0.6)}section.box-overhang-bottom{position:relative}section.box-overhang-bottom .box{position:relative;z-index:2}section.box-overhang-bottom:after{content:'';position:absolute;bottom:0;left:0;width:100%;height:30px;background-color:#fff}section.bottom-underlined{position:relative}section.bottom-underlined:after{content:' ';position:absolute;bottom:0;left:10%;width:80%;height:1px;background:rgba(192,192,191,0.3)}@media (max-width:767px){section.bottom-underlined:after{left:0;width:100%}}section .divider{position:relative;margin-top:80px;margin-bottom:60px;border-top:1px solid #f0f0f0}section .separator{display:block;height:2px;width:30px;margin:20px auto;background:rgba(0,0,0,0.2)}section .separator.light{background:rgba(255,255,255,0.2)}select{-webkit-border-radius:2px;border-radius:2px;background-color:#fff;-webkit-box-sizing:border-box;box-sizing:border-box;padding:10px 12px;background:#fff url('https://images.opendoor.com/source/s3/imgdrop-production/icon-triangles.svg?service=web') right 0 center no-repeat;background-size:16% 16%;padding:10px 20px 10px 15px;border:1px solid #dedede;font-size:16px;color:#70828f !important}select[disabled]{color:#f0f0f0;background-color:#fafafa}select[readonly]{color:#9ba1a6;background-color:#fafafa}select.full-width{width:100%}select.highlight-errors{-webkit-transition:-webkit-box-shadow cubic-bezier(.1, .7, .1, 1) .5s;transition:-webkit-box-shadow cubic-bezier(.1, .7, .1, 1) .5s;transition:box-shadow cubic-bezier(.1, .7, .1, 1) .5s;transition:box-shadow cubic-bezier(.1, .7, .1, 1) .5s, -webkit-box-shadow cubic-bezier(.1, .7, .1, 1) .5s}select.highlight-errors.ng-dirty.ng-invalid{border-color:#ff7f82;-webkit-box-shadow:#ff7f82 0 0 5px;box-shadow:#ff7f82 0 0 5px}@media (max-width:767px){select{font-size:12px}}@media (max-width:479px){select{padding:10px 5px}}.no-margin-top{margin-top:0}.no-margin-bottom{margin-bottom:0}.no-margin{margin:0}.small-margin-bottom{margin-bottom:10px}.medium-margin-bottom{margin-bottom:20px}.large-margin-bottom{margin-bottom:40px}.xl-margin-bottom{margin-bottom:60px}.xxl-margin-bottom{margin-bottom:80px}.small-margin-top{margin-top:10px}.medium-margin-top{margin-top:20px}.large-margin-top{margin-top:40px}.xl-margin-top{margin-top:60px}.xxl-margin-top{margin-top:80px}.splash{position:relative;width:100%;max-height:650px;background-position:center;background-size:cover;background-color:#fafafa}.splash:before{content:\"\";display:block;padding-top:44%}.splash h4{text-shadow:0 0 10px #595959,0 0 40px #000;-webkit-font-smoothing:subpixel-antialiased}.splash.splash-highlight{background-color:#1c85e8}.splash .splash-content{position:absolute;top:31%;left:0;right:0}.splash .splash-bottom-content{position:absolute;bottom:10%;left:0;right:0}.splash .customer-name{position:absolute;bottom:15px;right:20px;text-align:right;opacity:.8}th{font-weight:500}table.basic-table{text-align:left;border-collapse:collapse;border:1px solid #dedede}table.basic-table td,table.basic-table th{border-bottom:1px solid #dedede;padding:.5em 1em}table.basic-table th{font:500 12px/1.45 'Publico',serif;color:#9ba1a6;letter-spacing:.1em;text-transform:uppercase}input,textarea{border:1px solid #dedede;-webkit-border-radius:2px;border-radius:2px;background-color:#fff;-webkit-box-sizing:border-box;box-sizing:border-box;padding:10px 12px}input[disabled],textarea[disabled]{color:#f0f0f0;background-color:#fafafa}input[readonly],textarea[readonly]{color:#9ba1a6;background-color:#fafafa}input.full-width,textarea.full-width{width:100%}input.highlight-errors,textarea.highlight-errors{-webkit-transition:-webkit-box-shadow cubic-bezier(.1, .7, .1, 1) .5s;transition:-webkit-box-shadow cubic-bezier(.1, .7, .1, 1) .5s;transition:box-shadow cubic-bezier(.1, .7, .1, 1) .5s;transition:box-shadow cubic-bezier(.1, .7, .1, 1) .5s, -webkit-box-shadow cubic-bezier(.1, .7, .1, 1) .5s}input.highlight-errors.ng-dirty.ng-invalid,textarea.highlight-errors.ng-dirty.ng-invalid{border-color:#ff7f82;-webkit-box-shadow:#ff7f82 0 0 5px;box-shadow:#ff7f82 0 0 5px}@media (max-width:767px){input,textarea{font-size:12px}}@media (max-width:479px){input,textarea{padding:10px 5px}}::-webkit-input-placeholder{color:#70828f}input:disabled::-webkit-input-placeholder,textarea:disabled::-webkit-input-placeholder{color:#dedede}input:focus,textarea:focus{-webkit-box-shadow:0 0 3px #f0f0f0;box-shadow:0 0 3px #f0f0f0}input[type=text],input[type=email],input[type=password],input[type=tel],input[type=currency],input[type=commaNumber],input[type=percent],textarea,select{-webkit-appearance:none;-moz-appearance:none;appearance:none;font-size:16px}@media (max-width:767px){input[type=text],input[type=email],input[type=password],input[type=tel],input[type=currency],input[type=commaNumber],input[type=percent],textarea,select{font-size:12px}}", ""]);
	
	// exports


/***/ },
/* 3438 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".mapboxgl-map {\n    font: 12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif;\n    overflow: hidden;\n    position: relative;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.mapboxgl-map:-webkit-full-screen {\n    width: 100%;\n    height: 100%;\n}\n\n.mapboxgl-canary {\n    background-color: salmon;\n}\n\n.mapboxgl-canvas-container.mapboxgl-interactive,\n.mapboxgl-ctrl-group > button.mapboxgl-ctrl-compass {\n    cursor: -webkit-grab;\n    cursor: -moz-grab;\n    cursor: grab;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.mapboxgl-canvas-container.mapboxgl-interactive:active,\n.mapboxgl-ctrl-group > button.mapboxgl-ctrl-compass:active {\n    cursor: -webkit-grabbing;\n    cursor: -moz-grabbing;\n    cursor: grabbing;\n}\n\n.mapboxgl-canvas-container.mapboxgl-touch-zoom-rotate,\n.mapboxgl-canvas-container.mapboxgl-touch-zoom-rotate .mapboxgl-canvas {\n    touch-action: pan-x pan-y;\n}\n\n.mapboxgl-canvas-container.mapboxgl-touch-drag-pan,\n.mapboxgl-canvas-container.mapboxgl-touch-drag-pan .mapboxgl-canvas {\n    touch-action: pinch-zoom;\n}\n\n.mapboxgl-canvas-container.mapboxgl-touch-zoom-rotate.mapboxgl-touch-drag-pan,\n.mapboxgl-canvas-container.mapboxgl-touch-zoom-rotate.mapboxgl-touch-drag-pan .mapboxgl-canvas {\n    touch-action: none;\n}\n\n.mapboxgl-ctrl-top-left,\n.mapboxgl-ctrl-top-right,\n.mapboxgl-ctrl-bottom-left,\n.mapboxgl-ctrl-bottom-right { position: absolute; pointer-events: none; z-index: 2; }\n.mapboxgl-ctrl-top-left     { top: 0; left: 0; }\n.mapboxgl-ctrl-top-right    { top: 0; right: 0; }\n.mapboxgl-ctrl-bottom-left  { bottom: 0; left: 0; }\n.mapboxgl-ctrl-bottom-right { right: 0; bottom: 0; }\n\n.mapboxgl-ctrl { clear: both; pointer-events: auto; }\n.mapboxgl-ctrl-top-left .mapboxgl-ctrl     { margin: 10px 0 0 10px; float: left; }\n.mapboxgl-ctrl-top-right .mapboxgl-ctrl    { margin: 10px 10px 0 0; float: right; }\n.mapboxgl-ctrl-bottom-left .mapboxgl-ctrl  { margin: 0 0 10px 10px; float: left; }\n.mapboxgl-ctrl-bottom-right .mapboxgl-ctrl { margin: 0 10px 10px 0; float: right; }\n\n.mapboxgl-ctrl-group {\n    border-radius: 4px;\n    overflow: hidden;\n    background: #fff;\n}\n\n.mapboxgl-ctrl-group:not(:empty) {\n    -moz-box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);\n    -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);\n    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);\n}\n\n.mapboxgl-ctrl-group > button {\n    width: 30px;\n    height: 30px;\n    display: block;\n    padding: 0;\n    outline: none;\n    border: 0;\n    box-sizing: border-box;\n    background-color: transparent;\n    cursor: pointer;\n}\n\n.mapboxgl-ctrl-group > button + button {\n    border-top: 1px solid #ddd;\n}\n\n/* https://bugzilla.mozilla.org/show_bug.cgi?id=140562 */\n.mapboxgl-ctrl > button::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n}\n\n.mapboxgl-ctrl > button:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n}\n\n.mapboxgl-ctrl-icon,\n.mapboxgl-ctrl-icon > .mapboxgl-ctrl-compass-arrow {\n    speak: none;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.mapboxgl-ctrl-icon {\n    padding: 5px;\n}\n\n.mapboxgl-ctrl-icon.mapboxgl-ctrl-zoom-out {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath style='fill:%23333333;' d='m 7,9 c -0.554,0 -1,0.446 -1,1 0,0.554 0.446,1 1,1 l 6,0 c 0.554,0 1,-0.446 1,-1 0,-0.554 -0.446,-1 -1,-1 z'/%3E %3C/svg%3E\");\n}\n\n.mapboxgl-ctrl-icon.mapboxgl-ctrl-zoom-in {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath style='fill:%23333333;' d='M 10 6 C 9.446 6 9 6.4459904 9 7 L 9 9 L 7 9 C 6.446 9 6 9.446 6 10 C 6 10.554 6.446 11 7 11 L 9 11 L 9 13 C 9 13.55401 9.446 14 10 14 C 10.554 14 11 13.55401 11 13 L 11 11 L 13 11 C 13.554 11 14 10.554 14 10 C 14 9.446 13.554 9 13 9 L 11 9 L 11 7 C 11 6.4459904 10.554 6 10 6 z'/%3E %3C/svg%3E\");\n}\n\n.mapboxgl-ctrl-icon.mapboxgl-ctrl-geolocate {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' fill='%23333'%3E %3Cpath d='M10 4C9 4 9 5 9 5L9 5.1A5 5 0 0 0 5.1 9L5 9C5 9 4 9 4 10 4 11 5 11 5 11L5.1 11A5 5 0 0 0 9 14.9L9 15C9 15 9 16 10 16 11 16 11 15 11 15L11 14.9A5 5 0 0 0 14.9 11L15 11C15 11 16 11 16 10 16 9 15 9 15 9L14.9 9A5 5 0 0 0 11 5.1L11 5C11 5 11 4 10 4zM10 6.5A3.5 3.5 0 0 1 13.5 10 3.5 3.5 0 0 1 10 13.5 3.5 3.5 0 0 1 6.5 10 3.5 3.5 0 0 1 10 6.5zM10 8.3A1.8 1.8 0 0 0 8.3 10 1.8 1.8 0 0 0 10 11.8 1.8 1.8 0 0 0 11.8 10 1.8 1.8 0 0 0 10 8.3z'/%3E %3C/svg%3E\");\n}\n\n.mapboxgl-ctrl-icon.mapboxgl-ctrl-geolocate:disabled {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' fill='%23aaa'%3E %3Cpath d='M10 4C9 4 9 5 9 5L9 5.1A5 5 0 0 0 5.1 9L5 9C5 9 4 9 4 10 4 11 5 11 5 11L5.1 11A5 5 0 0 0 9 14.9L9 15C9 15 9 16 10 16 11 16 11 15 11 15L11 14.9A5 5 0 0 0 14.9 11L15 11C15 11 16 11 16 10 16 9 15 9 15 9L14.9 9A5 5 0 0 0 11 5.1L11 5C11 5 11 4 10 4zM10 6.5A3.5 3.5 0 0 1 13.5 10 3.5 3.5 0 0 1 10 13.5 3.5 3.5 0 0 1 6.5 10 3.5 3.5 0 0 1 10 6.5zM10 8.3A1.8 1.8 0 0 0 8.3 10 1.8 1.8 0 0 0 10 11.8 1.8 1.8 0 0 0 11.8 10 1.8 1.8 0 0 0 10 8.3z'/%3E %3C/svg%3E\");\n}\n\n.mapboxgl-ctrl-icon.mapboxgl-ctrl-geolocate.mapboxgl-ctrl-geolocate-active {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' fill='%2333b5e5'%3E %3Cpath d='M10 4C9 4 9 5 9 5L9 5.1A5 5 0 0 0 5.1 9L5 9C5 9 4 9 4 10 4 11 5 11 5 11L5.1 11A5 5 0 0 0 9 14.9L9 15C9 15 9 16 10 16 11 16 11 15 11 15L11 14.9A5 5 0 0 0 14.9 11L15 11C15 11 16 11 16 10 16 9 15 9 15 9L14.9 9A5 5 0 0 0 11 5.1L11 5C11 5 11 4 10 4zM10 6.5A3.5 3.5 0 0 1 13.5 10 3.5 3.5 0 0 1 10 13.5 3.5 3.5 0 0 1 6.5 10 3.5 3.5 0 0 1 10 6.5zM10 8.3A1.8 1.8 0 0 0 8.3 10 1.8 1.8 0 0 0 10 11.8 1.8 1.8 0 0 0 11.8 10 1.8 1.8 0 0 0 10 8.3z'/%3E %3C/svg%3E\");\n}\n\n.mapboxgl-ctrl-icon.mapboxgl-ctrl-geolocate.mapboxgl-ctrl-geolocate-active-error {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' fill='%23e58978'%3E %3Cpath d='M10 4C9 4 9 5 9 5L9 5.1A5 5 0 0 0 5.1 9L5 9C5 9 4 9 4 10 4 11 5 11 5 11L5.1 11A5 5 0 0 0 9 14.9L9 15C9 15 9 16 10 16 11 16 11 15 11 15L11 14.9A5 5 0 0 0 14.9 11L15 11C15 11 16 11 16 10 16 9 15 9 15 9L14.9 9A5 5 0 0 0 11 5.1L11 5C11 5 11 4 10 4zM10 6.5A3.5 3.5 0 0 1 13.5 10 3.5 3.5 0 0 1 10 13.5 3.5 3.5 0 0 1 6.5 10 3.5 3.5 0 0 1 10 6.5zM10 8.3A1.8 1.8 0 0 0 8.3 10 1.8 1.8 0 0 0 10 11.8 1.8 1.8 0 0 0 11.8 10 1.8 1.8 0 0 0 10 8.3z'/%3E %3C/svg%3E\");\n}\n\n.mapboxgl-ctrl-icon.mapboxgl-ctrl-geolocate.mapboxgl-ctrl-geolocate-background {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' fill='%2333b5e5'%3E %3Cpath d='M 10,4 C 9,4 9,5 9,5 L 9,5.1 C 7.0357113,5.5006048 5.5006048,7.0357113 5.1,9 L 5,9 c 0,0 -1,0 -1,1 0,1 1,1 1,1 l 0.1,0 c 0.4006048,1.964289 1.9357113,3.499395 3.9,3.9 L 9,15 c 0,0 0,1 1,1 1,0 1,-1 1,-1 l 0,-0.1 c 1.964289,-0.400605 3.499395,-1.935711 3.9,-3.9 l 0.1,0 c 0,0 1,0 1,-1 C 16,9 15,9 15,9 L 14.9,9 C 14.499395,7.0357113 12.964289,5.5006048 11,5.1 L 11,5 c 0,0 0,-1 -1,-1 z m 0,2.5 c 1.932997,0 3.5,1.5670034 3.5,3.5 0,1.932997 -1.567003,3.5 -3.5,3.5 C 8.0670034,13.5 6.5,11.932997 6.5,10 6.5,8.0670034 8.0670034,6.5 10,6.5 Z'/%3E %3C/svg%3E\");\n}\n\n.mapboxgl-ctrl-icon.mapboxgl-ctrl-geolocate.mapboxgl-ctrl-geolocate-background-error {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' fill='%23e54e33'%3E %3Cpath d='M 10,4 C 9,4 9,5 9,5 L 9,5.1 C 7.0357113,5.5006048 5.5006048,7.0357113 5.1,9 L 5,9 c 0,0 -1,0 -1,1 0,1 1,1 1,1 l 0.1,0 c 0.4006048,1.964289 1.9357113,3.499395 3.9,3.9 L 9,15 c 0,0 0,1 1,1 1,0 1,-1 1,-1 l 0,-0.1 c 1.964289,-0.400605 3.499395,-1.935711 3.9,-3.9 l 0.1,0 c 0,0 1,0 1,-1 C 16,9 15,9 15,9 L 14.9,9 C 14.499395,7.0357113 12.964289,5.5006048 11,5.1 L 11,5 c 0,0 0,-1 -1,-1 z m 0,2.5 c 1.932997,0 3.5,1.5670034 3.5,3.5 0,1.932997 -1.567003,3.5 -3.5,3.5 C 8.0670034,13.5 6.5,11.932997 6.5,10 6.5,8.0670034 8.0670034,6.5 10,6.5 Z'/%3E %3C/svg%3E\");\n}\n\n.mapboxgl-ctrl-icon.mapboxgl-ctrl-geolocate.mapboxgl-ctrl-geolocate-waiting {\n    -webkit-animation: mapboxgl-spin 2s infinite linear;\n    -moz-animation: mapboxgl-spin 2s infinite linear;\n    -o-animation: mapboxgl-spin 2s infinite linear;\n    -ms-animation: mapboxgl-spin 2s infinite linear;\n    animation: mapboxgl-spin 2s infinite linear;\n}\n\n@-webkit-keyframes mapboxgl-spin {\n    0% { -webkit-transform: rotate(0deg); }\n    100% { -webkit-transform: rotate(360deg); }\n}\n\n@-moz-keyframes mapboxgl-spin {\n    0% { -moz-transform: rotate(0deg); }\n    100% { -moz-transform: rotate(360deg); }\n}\n\n@-o-keyframes mapboxgl-spin {\n    0% { -o-transform: rotate(0deg); }\n    100% { -o-transform: rotate(360deg); }\n}\n\n@-ms-keyframes mapboxgl-spin {\n    0% { -ms-transform: rotate(0deg); }\n    100% { -ms-transform: rotate(360deg); }\n}\n\n@keyframes mapboxgl-spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.mapboxgl-ctrl-icon.mapboxgl-ctrl-fullscreen {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M 5 4 C 4.5 4 4 4.5 4 5 L 4 6 L 4 9 L 4.5 9 L 5.7773438 7.296875 C 6.7771319 8.0602131 7.835765 8.9565728 8.890625 10 C 7.8257121 11.0633 6.7761791 11.951675 5.78125 12.707031 L 4.5 11 L 4 11 L 4 15 C 4 15.5 4.5 16 5 16 L 9 16 L 9 15.5 L 7.2734375 14.205078 C 8.0428931 13.187886 8.9395441 12.133481 9.9609375 11.068359 C 11.042371 12.14699 11.942093 13.2112 12.707031 14.21875 L 11 15.5 L 11 16 L 14 16 L 15 16 C 15.5 16 16 15.5 16 15 L 16 14 L 16 11 L 15.5 11 L 14.205078 12.726562 C 13.177985 11.949617 12.112718 11.043577 11.037109 10.009766 C 12.151856 8.981061 13.224345 8.0798624 14.228516 7.3046875 L 15.5 9 L 16 9 L 16 5 C 16 4.5 15.5 4 15 4 L 11 4 L 11 4.5 L 12.703125 5.7773438 C 11.932647 6.7864834 11.026693 7.8554712 9.9707031 8.9199219 C 8.9584739 7.8204943 8.0698767 6.7627188 7.3046875 5.7714844 L 9 4.5 L 9 4 L 6 4 L 5 4 z '/%3E %3C/svg%3E\");\n}\n\n.mapboxgl-ctrl-icon.mapboxgl-ctrl-shrink {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath style='fill:%23000000;' d='M 4.2421875 3.4921875 A 0.750075 0.750075 0 0 0 3.71875 4.78125 L 5.9648438 7.0273438 L 4 8.5 L 4 9 L 8 9 C 8.500001 8.9999988 9 8.4999992 9 8 L 9 4 L 8.5 4 L 7.0175781 5.9550781 L 4.78125 3.71875 A 0.750075 0.750075 0 0 0 4.2421875 3.4921875 z M 15.734375 3.4921875 A 0.750075 0.750075 0 0 0 15.21875 3.71875 L 12.984375 5.953125 L 11.5 4 L 11 4 L 11 8 C 11 8.4999992 11.499999 8.9999988 12 9 L 16 9 L 16 8.5 L 14.035156 7.0273438 L 16.28125 4.78125 A 0.750075 0.750075 0 0 0 15.734375 3.4921875 z M 4 11 L 4 11.5 L 5.9648438 12.972656 L 3.71875 15.21875 A 0.75130096 0.75130096 0 1 0 4.78125 16.28125 L 7.0273438 14.035156 L 8.5 16 L 9 16 L 9 12 C 9 11.500001 8.500001 11.000001 8 11 L 4 11 z M 12 11 C 11.499999 11.000001 11 11.500001 11 12 L 11 16 L 11.5 16 L 12.972656 14.035156 L 15.21875 16.28125 A 0.75130096 0.75130096 0 1 0 16.28125 15.21875 L 14.035156 12.972656 L 16 11.5 L 16 11 L 12 11 z '/%3E %3C/svg%3E\");\n}\n\n.mapboxgl-ctrl-icon.mapboxgl-ctrl-compass > .mapboxgl-ctrl-compass-arrow {\n    width: 20px;\n    height: 20px;\n    margin: 5px;\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E %3Cpolygon fill='%23333333' points='6,9 10,1 14,9'/%3E %3Cpolygon fill='%23CCCCCC' points='6,11 10,19 14,11 '/%3E %3C/svg%3E\");\n    background-repeat: no-repeat;\n    display: inline-block;\n}\n\na.mapboxgl-ctrl-logo {\n    width: 85px;\n    height: 21px;\n    margin: 0 0 -3px -3px;\n    display: block;\n    background-repeat: no-repeat;\n    cursor: pointer;\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3C?xml version='1.0' encoding='utf-8'?%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 84.49 21' style='enable-background:new 0 0 84.49 21;' xml:space='preserve'%3E%3Cg%3E %3Cpath class='st0' style='opacity:0.9; fill: %23FFFFFF; enable-background: new;' d='M83.25,14.26c0,0.12-0.09,0.21-0.21,0.21h-1.61c-0.13,0-0.24-0.06-0.3-0.17l-1.44-2.39l-1.44,2.39 c-0.06,0.11-0.18,0.17-0.3,0.17h-1.61c-0.04,0-0.08-0.01-0.12-0.03c-0.09-0.06-0.13-0.19-0.06-0.28l0,0l2.43-3.68L76.2,6.84 c-0.02-0.03-0.03-0.07-0.03-0.12c0-0.12,0.09-0.21,0.21-0.21h1.61c0.13,0,0.24,0.06,0.3,0.17l1.41,2.36l1.4-2.35 c0.06-0.11,0.18-0.17,0.3-0.17H83c0.04,0,0.08,0.01,0.12,0.03c0.09,0.06,0.13,0.19,0.06,0.28l0,0l-2.37,3.63l2.43,3.67 C83.24,14.18,83.25,14.22,83.25,14.26z'/%3E %3Cpath class='st0' style='opacity:0.9; fill: %23FFFFFF; enable-background: new;' d='M66.24,9.59c-0.39-1.88-1.96-3.28-3.84-3.28c-1.03,0-2.03,0.42-2.73,1.18V3.51c0-0.13-0.1-0.23-0.23-0.23h-1.4 c-0.13,0-0.23,0.11-0.23,0.23v10.72c0,0.13,0.1,0.23,0.23,0.23h1.4c0.13,0,0.23-0.11,0.23-0.23V13.5c0.71,0.75,1.7,1.18,2.73,1.18 c1.88,0,3.45-1.41,3.84-3.29C66.37,10.79,66.37,10.18,66.24,9.59L66.24,9.59z M62.08,13c-1.32,0-2.39-1.11-2.41-2.48v-0.06 c0.02-1.38,1.09-2.48,2.41-2.48s2.42,1.12,2.42,2.51S63.41,13,62.08,13z'/%3E %3Cpath class='st0' style='opacity:0.9; fill: %23FFFFFF; enable-background: new;' d='M71.67,6.32c-1.98-0.01-3.72,1.35-4.16,3.29c-0.13,0.59-0.13,1.19,0,1.77c0.44,1.94,2.17,3.32,4.17,3.3 c2.35,0,4.26-1.87,4.26-4.19S74.04,6.32,71.67,6.32z M71.65,13.01c-1.33,0-2.42-1.12-2.42-2.51s1.08-2.52,2.42-2.52 c1.33,0,2.42,1.12,2.42,2.51S72.99,13,71.65,13.01L71.65,13.01z'/%3E %3Cpath class='st1' style='opacity:0.35; enable-background:new;' d='M62.08,7.98c-1.32,0-2.39,1.11-2.41,2.48v0.06C59.68,11.9,60.75,13,62.08,13s2.42-1.12,2.42-2.51 S63.41,7.98,62.08,7.98z M62.08,11.76c-0.63,0-1.14-0.56-1.17-1.25v-0.04c0.01-0.69,0.54-1.25,1.17-1.25 c0.63,0,1.17,0.57,1.17,1.27C63.24,11.2,62.73,11.76,62.08,11.76z'/%3E %3Cpath class='st1' style='opacity:0.35; enable-background:new;' d='M71.65,7.98c-1.33,0-2.42,1.12-2.42,2.51S70.32,13,71.65,13s2.42-1.12,2.42-2.51S72.99,7.98,71.65,7.98z M71.65,11.76c-0.64,0-1.17-0.57-1.17-1.27c0-0.7,0.53-1.26,1.17-1.26s1.17,0.57,1.17,1.27C72.82,11.21,72.29,11.76,71.65,11.76z'/%3E %3Cpath class='st0' style='opacity:0.9; fill: %23FFFFFF; enable-background: new;' d='M45.74,6.53h-1.4c-0.13,0-0.23,0.11-0.23,0.23v0.73c-0.71-0.75-1.7-1.18-2.73-1.18 c-2.17,0-3.94,1.87-3.94,4.19s1.77,4.19,3.94,4.19c1.04,0,2.03-0.43,2.73-1.19v0.73c0,0.13,0.1,0.23,0.23,0.23h1.4 c0.13,0,0.23-0.11,0.23-0.23V6.74c0-0.12-0.09-0.22-0.22-0.22C45.75,6.53,45.75,6.53,45.74,6.53z M44.12,10.53 C44.11,11.9,43.03,13,41.71,13s-2.42-1.12-2.42-2.51s1.08-2.52,2.4-2.52c1.33,0,2.39,1.11,2.41,2.48L44.12,10.53z'/%3E %3Cpath class='st1' style='opacity:0.35; enable-background:new;' d='M41.71,7.98c-1.33,0-2.42,1.12-2.42,2.51S40.37,13,41.71,13s2.39-1.11,2.41-2.48v-0.06 C44.1,9.09,43.03,7.98,41.71,7.98z M40.55,10.49c0-0.7,0.52-1.27,1.17-1.27c0.64,0,1.14,0.56,1.17,1.25v0.04 c-0.01,0.68-0.53,1.24-1.17,1.24C41.08,11.75,40.55,11.19,40.55,10.49z'/%3E %3Cpath class='st0' style='opacity:0.9; fill: %23FFFFFF; enable-background: new;' d='M52.41,6.32c-1.03,0-2.03,0.42-2.73,1.18V6.75c0-0.13-0.1-0.23-0.23-0.23h-1.4c-0.13,0-0.23,0.11-0.23,0.23 v10.72c0,0.13,0.1,0.23,0.23,0.23h1.4c0.13,0,0.23-0.1,0.23-0.23V13.5c0.71,0.75,1.7,1.18,2.74,1.18c2.17,0,3.94-1.87,3.94-4.19 S54.58,6.32,52.41,6.32z M52.08,13.01c-1.32,0-2.39-1.11-2.42-2.48v-0.07c0.02-1.38,1.09-2.49,2.4-2.49c1.32,0,2.41,1.12,2.41,2.51 S53.4,13,52.08,13.01L52.08,13.01z'/%3E %3Cpath class='st1' style='opacity:0.35; enable-background:new;' d='M52.08,7.98c-1.32,0-2.39,1.11-2.42,2.48v0.06c0.03,1.38,1.1,2.48,2.42,2.48s2.41-1.12,2.41-2.51 S53.4,7.98,52.08,7.98z M52.08,11.76c-0.63,0-1.14-0.56-1.17-1.25v-0.04c0.01-0.69,0.54-1.25,1.17-1.25c0.63,0,1.17,0.58,1.17,1.27 S52.72,11.76,52.08,11.76z'/%3E %3Cpath class='st0' style='opacity:0.9; fill: %23FFFFFF; enable-background: new;' d='M36.08,14.24c0,0.13-0.1,0.23-0.23,0.23h-1.41c-0.13,0-0.23-0.11-0.23-0.23V9.68c0-0.98-0.74-1.71-1.62-1.71 c-0.8,0-1.46,0.7-1.59,1.62l0.01,4.66c0,0.13-0.11,0.23-0.23,0.23h-1.41c-0.13,0-0.23-0.11-0.23-0.23V9.68 c0-0.98-0.74-1.71-1.62-1.71c-0.85,0-1.54,0.79-1.6,1.8v4.48c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23V6.74 c0.01-0.13,0.1-0.22,0.23-0.22h1.4c0.13,0,0.22,0.11,0.23,0.22V7.4c0.5-0.68,1.3-1.09,2.16-1.1h0.03c1.09,0,2.09,0.6,2.6,1.55 c0.45-0.95,1.4-1.55,2.44-1.56c1.62,0,2.93,1.25,2.9,2.78L36.08,14.24z'/%3E %3Cpath class='st1' style='opacity:0.35; enable-background:new;' d='M84.34,13.59l-0.07-0.13l-1.96-2.99l1.94-2.95c0.44-0.67,0.26-1.56-0.41-2.02c-0.02,0-0.03,0-0.04-0.01 c-0.23-0.15-0.5-0.22-0.78-0.22h-1.61c-0.56,0-1.08,0.29-1.37,0.78L79.72,6.6l-0.34-0.56C79.09,5.56,78.57,5.27,78,5.27h-1.6 c-0.6,0-1.13,0.37-1.35,0.92c-2.19-1.66-5.28-1.47-7.26,0.45c-0.35,0.34-0.65,0.72-0.89,1.14c-0.9-1.62-2.58-2.72-4.5-2.72 c-0.5,0-1.01,0.07-1.48,0.23V3.51c0-0.82-0.66-1.48-1.47-1.48h-1.4c-0.81,0-1.47,0.66-1.47,1.47v3.75 c-0.95-1.36-2.5-2.18-4.17-2.19c-0.74,0-1.46,0.16-2.12,0.47c-0.24-0.17-0.54-0.26-0.84-0.26h-1.4c-0.45,0-0.87,0.21-1.15,0.56 c-0.02-0.03-0.04-0.05-0.07-0.08c-0.28-0.3-0.68-0.47-1.09-0.47h-1.39c-0.3,0-0.6,0.09-0.84,0.26c-0.67-0.3-1.39-0.46-2.12-0.46 c-1.83,0-3.43,1-4.37,2.5c-0.2-0.46-0.48-0.89-0.83-1.25c-0.8-0.81-1.89-1.25-3.02-1.25h-0.01c-0.89,0.01-1.75,0.33-2.46,0.88 c-0.74-0.57-1.64-0.88-2.57-0.88H28.1c-0.29,0-0.58,0.03-0.86,0.11c-0.28,0.06-0.56,0.16-0.82,0.28c-0.21-0.12-0.45-0.18-0.7-0.18 h-1.4c-0.82,0-1.47,0.66-1.47,1.47v7.5c0,0.82,0.66,1.47,1.47,1.47h1.4c0.82,0,1.48-0.66,1.48-1.48l0,0V9.79 c0.03-0.36,0.23-0.59,0.36-0.59c0.18,0,0.38,0.18,0.38,0.47v4.57c0,0.82,0.66,1.47,1.47,1.47h1.41c0.82,0,1.47-0.66,1.47-1.47 l-0.01-4.57c0.06-0.32,0.25-0.47,0.35-0.47c0.18,0,0.38,0.18,0.38,0.47v4.57c0,0.82,0.66,1.47,1.47,1.47h1.41 c0.82,0,1.47-0.66,1.47-1.47v-0.38c0.96,1.29,2.46,2.06,4.06,2.06c0.74,0,1.46-0.16,2.12-0.47c0.24,0.17,0.54,0.26,0.84,0.26h1.39 c0.3,0,0.6-0.09,0.84-0.26v2.01c0,0.82,0.66,1.47,1.47,1.47h1.4c0.82,0,1.47-0.66,1.47-1.47v-1.77c0.48,0.15,0.99,0.23,1.49,0.22 c1.7,0,3.22-0.87,4.17-2.2v0.52c0,0.82,0.66,1.47,1.47,1.47h1.4c0.3,0,0.6-0.09,0.84-0.26c0.66,0.31,1.39,0.47,2.12,0.47 c1.92,0,3.6-1.1,4.49-2.73c1.54,2.65,4.95,3.53,7.58,1.98c0.18-0.11,0.36-0.22,0.53-0.36c0.22,0.55,0.76,0.91,1.35,0.9H78 c0.56,0,1.08-0.29,1.37-0.78l0.37-0.61l0.37,0.61c0.29,0.48,0.81,0.78,1.38,0.78h1.6c0.81,0,1.46-0.66,1.45-1.46 C84.49,14.02,84.44,13.8,84.34,13.59L84.34,13.59z M35.86,14.47h-1.41c-0.13,0-0.23-0.11-0.23-0.23V9.68 c0-0.98-0.74-1.71-1.62-1.71c-0.8,0-1.46,0.7-1.59,1.62l0.01,4.66c0,0.13-0.1,0.23-0.23,0.23h-1.41c-0.13,0-0.23-0.11-0.23-0.23 V9.68c0-0.98-0.74-1.71-1.62-1.71c-0.85,0-1.54,0.79-1.6,1.8v4.48c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23 V6.74c0.01-0.13,0.11-0.22,0.23-0.22h1.4c0.13,0,0.22,0.11,0.23,0.22V7.4c0.5-0.68,1.3-1.09,2.16-1.1h0.03 c1.09,0,2.09,0.6,2.6,1.55c0.45-0.95,1.4-1.55,2.44-1.56c1.62,0,2.93,1.25,2.9,2.78l0.01,5.16C36.09,14.36,35.98,14.46,35.86,14.47 L35.86,14.47z M45.97,14.24c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23V13.5c-0.7,0.76-1.69,1.18-2.72,1.18 c-2.17,0-3.94-1.87-3.94-4.19s1.77-4.19,3.94-4.19c1.03,0,2.02,0.43,2.73,1.18V6.74c0-0.13,0.1-0.23,0.23-0.23h1.4 c0.12-0.01,0.22,0.08,0.23,0.21c0,0.01,0,0.01,0,0.02v7.51h-0.01V14.24z M52.41,14.67c-1.03,0-2.02-0.43-2.73-1.18v3.97 c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.1-0.23-0.23V6.75c0-0.13,0.1-0.22,0.23-0.22h1.4c0.13,0,0.23,0.11,0.23,0.23v0.73 c0.71-0.76,1.7-1.18,2.73-1.18c2.17,0,3.94,1.86,3.94,4.18S54.58,14.67,52.41,14.67z M66.24,11.39c-0.39,1.87-1.96,3.29-3.84,3.29 c-1.03,0-2.02-0.43-2.73-1.18v0.73c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23V3.51c0-0.13,0.1-0.23,0.23-0.23 h1.4c0.13,0,0.23,0.11,0.23,0.23v3.97c0.71-0.75,1.7-1.18,2.73-1.17c1.88,0,3.45,1.4,3.84,3.28C66.37,10.19,66.37,10.8,66.24,11.39 L66.24,11.39L66.24,11.39z M71.67,14.68c-2,0.01-3.73-1.35-4.17-3.3c-0.13-0.59-0.13-1.19,0-1.77c0.44-1.94,2.17-3.31,4.17-3.3 c2.36,0,4.26,1.87,4.26,4.19S74.03,14.68,71.67,14.68L71.67,14.68z M83.04,14.47h-1.61c-0.13,0-0.24-0.06-0.3-0.17l-1.44-2.39 l-1.44,2.39c-0.06,0.11-0.18,0.17-0.3,0.17h-1.61c-0.04,0-0.08-0.01-0.12-0.03c-0.09-0.06-0.13-0.19-0.06-0.28l0,0l2.43-3.68 L76.2,6.84c-0.02-0.03-0.03-0.07-0.03-0.12c0-0.12,0.09-0.21,0.21-0.21h1.61c0.13,0,0.24,0.06,0.3,0.17l1.41,2.36l1.41-2.36 c0.06-0.11,0.18-0.17,0.3-0.17h1.61c0.04,0,0.08,0.01,0.12,0.03c0.09,0.06,0.13,0.19,0.06,0.28l0,0l-2.38,3.64l2.43,3.67 c0.02,0.03,0.03,0.07,0.03,0.12C83.25,14.38,83.16,14.47,83.04,14.47L83.04,14.47L83.04,14.47z'/%3E %3Cpath class='st0' style='opacity:0.9; fill: %23FFFFFF; enable-background: new;' d='M10.5,1.24c-5.11,0-9.25,4.15-9.25,9.25s4.15,9.25,9.25,9.25s9.25-4.15,9.25-9.25 C19.75,5.38,15.61,1.24,10.5,1.24z M14.89,12.77c-1.93,1.93-4.78,2.31-6.7,2.31c-0.7,0-1.41-0.05-2.1-0.16c0,0-1.02-5.64,2.14-8.81 c0.83-0.83,1.95-1.28,3.13-1.28c1.27,0,2.49,0.51,3.39,1.42C16.59,8.09,16.64,11,14.89,12.77z'/%3E %3Cpath class='st1' style='opacity:0.35; enable-background:new;' d='M10.5-0.01C4.7-0.01,0,4.7,0,10.49s4.7,10.5,10.5,10.5S21,16.29,21,10.49C20.99,4.7,16.3-0.01,10.5-0.01z M10.5,19.74c-5.11,0-9.25-4.15-9.25-9.25s4.14-9.26,9.25-9.26s9.25,4.15,9.25,9.25C19.75,15.61,15.61,19.74,10.5,19.74z'/%3E %3Cpath class='st1' style='opacity:0.35; enable-background:new;' d='M14.74,6.25C12.9,4.41,9.98,4.35,8.23,6.1c-3.16,3.17-2.14,8.81-2.14,8.81s5.64,1.02,8.81-2.14 C16.64,11,16.59,8.09,14.74,6.25z M12.47,10.34l-0.91,1.87l-0.9-1.87L8.8,9.43l1.86-0.9l0.9-1.87l0.91,1.87l1.86,0.9L12.47,10.34z'/%3E %3Cpolygon class='st0' style='opacity:0.9; fill: %23FFFFFF; enable-background: new;' points='14.33,9.43 12.47,10.34 11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 '/%3E%3C/g%3E%3C/svg%3E\");\n}\n\na.mapboxgl-ctrl-logo.mapboxgl-compact {\n    width: 21px;\n    height: 21px;\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 21 21' style='enable-background:new 0 0 21 21;' xml:space='preserve'%3E%3Cg transform='translate(0,0.01)'%3E%3Cpath d='m 10.5,1.24 c -5.11,0 -9.25,4.15 -9.25,9.25 0,5.1 4.15,9.25 9.25,9.25 5.1,0 9.25,-4.15 9.25,-9.25 0,-5.11 -4.14,-9.25 -9.25,-9.25 z m 4.39,11.53 c -1.93,1.93 -4.78,2.31 -6.7,2.31 -0.7,0 -1.41,-0.05 -2.1,-0.16 0,0 -1.02,-5.64 2.14,-8.81 0.83,-0.83 1.95,-1.28 3.13,-1.28 1.27,0 2.49,0.51 3.39,1.42 1.84,1.84 1.89,4.75 0.14,6.52 z' style='opacity:0.9;fill:%23ffffff;enable-background:new' class='st0'/%3E%3Cpath d='M 10.5,-0.01 C 4.7,-0.01 0,4.7 0,10.49 c 0,5.79 4.7,10.5 10.5,10.5 5.8,0 10.5,-4.7 10.5,-10.5 C 20.99,4.7 16.3,-0.01 10.5,-0.01 Z m 0,19.75 c -5.11,0 -9.25,-4.15 -9.25,-9.25 0,-5.1 4.14,-9.26 9.25,-9.26 5.11,0 9.25,4.15 9.25,9.25 0,5.13 -4.14,9.26 -9.25,9.26 z' style='opacity:0.35;enable-background:new' class='st1'/%3E%3Cpath d='M 14.74,6.25 C 12.9,4.41 9.98,4.35 8.23,6.1 5.07,9.27 6.09,14.91 6.09,14.91 c 0,0 5.64,1.02 8.81,-2.14 C 16.64,11 16.59,8.09 14.74,6.25 Z m -2.27,4.09 -0.91,1.87 -0.9,-1.87 -1.86,-0.91 1.86,-0.9 0.9,-1.87 0.91,1.87 1.86,0.9 z' style='opacity:0.35;enable-background:new' class='st1'/%3E%3Cpolygon points='11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 14.33,9.43 12.47,10.34 ' style='opacity:0.9;fill:%23ffffff;enable-background:new' class='st0'/%3E%3C/g%3E%3C/svg%3E\");\n}\n\n.mapboxgl-ctrl.mapboxgl-ctrl-attrib {\n    padding: 0 5px;\n    background-color: rgba(255, 255, 255, 0.5);\n    margin: 0;\n}\n\n@media screen {\n    .mapboxgl-ctrl-attrib.mapboxgl-compact {\n        margin: 10px;\n        position: relative;\n        background-color: #fff;\n        border-radius: 3px 12px 12px 3px;\n    }\n\n    .mapboxgl-ctrl-attrib.mapboxgl-compact:hover {\n        padding: 2px 24px 2px 4px;\n        visibility: visible;\n    }\n\n    .mapboxgl-ctrl-top-left > .mapboxgl-ctrl-attrib.mapboxgl-compact:hover,\n    .mapboxgl-ctrl-bottom-left > .mapboxgl-ctrl-attrib.mapboxgl-compact:hover {\n        padding: 2px 4px 2px 24px;\n        border-radius: 12px 3px 3px 12px;\n    }\n\n    .mapboxgl-ctrl-attrib.mapboxgl-compact .mapboxgl-ctrl-attrib-inner {\n        display: none;\n    }\n\n    .mapboxgl-ctrl-attrib.mapboxgl-compact:hover .mapboxgl-ctrl-attrib-inner {\n        display: block;\n    }\n\n    .mapboxgl-ctrl-attrib.mapboxgl-compact::after {\n        content: '';\n        cursor: pointer;\n        position: absolute;\n        background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill='%23333333' fill-rule='evenodd' d='M4,10a6,6 0 1,0 12,0a6,6 0 1,0 -12,0 M9,7a1,1 0 1,0 2,0a1,1 0 1,0 -2,0 M9,10a1,1 0 1,1 2,0l0,3a1,1 0 1,1 -2,0'/%3E %3C/svg%3E\");\n        background-color: rgba(255, 255, 255, 0.5);\n        width: 24px;\n        height: 24px;\n        box-sizing: border-box;\n        border-radius: 12px;\n    }\n\n    .mapboxgl-ctrl-bottom-right > .mapboxgl-ctrl-attrib.mapboxgl-compact::after {\n        bottom: 0;\n        right: 0;\n    }\n\n    .mapboxgl-ctrl-top-right > .mapboxgl-ctrl-attrib.mapboxgl-compact::after {\n        top: 0;\n        right: 0;\n    }\n\n    .mapboxgl-ctrl-top-left > .mapboxgl-ctrl-attrib.mapboxgl-compact::after {\n        top: 0;\n        left: 0;\n    }\n\n    .mapboxgl-ctrl-bottom-left > .mapboxgl-ctrl-attrib.mapboxgl-compact::after {\n        bottom: 0;\n        left: 0;\n    }\n}\n\n.mapboxgl-ctrl-attrib a {\n    color: rgba(0, 0, 0, 0.75);\n    text-decoration: none;\n}\n\n.mapboxgl-ctrl-attrib a:hover {\n    color: inherit;\n    text-decoration: underline;\n}\n\n/* stylelint-disable-next-line selector-class-pattern */\n.mapboxgl-ctrl-attrib .mapbox-improve-map {\n    font-weight: bold;\n    margin-left: 2px;\n}\n\n.mapboxgl-attrib-empty {\n    display: none;\n}\n\n.mapboxgl-ctrl-scale {\n    background-color: rgba(255, 255, 255, 0.75);\n    font-size: 10px;\n    border-width: medium 2px 2px;\n    border-style: none solid solid;\n    border-color: #333;\n    padding: 0 5px;\n    color: #333;\n    box-sizing: border-box;\n}\n\n.mapboxgl-popup {\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: -webkit-flex;\n    display: flex;\n    will-change: transform;\n    pointer-events: none;\n}\n\n.mapboxgl-popup-anchor-top,\n.mapboxgl-popup-anchor-top-left,\n.mapboxgl-popup-anchor-top-right {\n    -webkit-flex-direction: column;\n    flex-direction: column;\n}\n\n.mapboxgl-popup-anchor-bottom,\n.mapboxgl-popup-anchor-bottom-left,\n.mapboxgl-popup-anchor-bottom-right {\n    -webkit-flex-direction: column-reverse;\n    flex-direction: column-reverse;\n}\n\n.mapboxgl-popup-anchor-left {\n    -webkit-flex-direction: row;\n    flex-direction: row;\n}\n\n.mapboxgl-popup-anchor-right {\n    -webkit-flex-direction: row-reverse;\n    flex-direction: row-reverse;\n}\n\n.mapboxgl-popup-tip {\n    width: 0;\n    height: 0;\n    border: 10px solid transparent;\n    z-index: 1;\n}\n\n.mapboxgl-popup-anchor-top .mapboxgl-popup-tip {\n    -webkit-align-self: center;\n    align-self: center;\n    border-top: none;\n    border-bottom-color: #fff;\n}\n\n.mapboxgl-popup-anchor-top-left .mapboxgl-popup-tip {\n    -webkit-align-self: flex-start;\n    align-self: flex-start;\n    border-top: none;\n    border-left: none;\n    border-bottom-color: #fff;\n}\n\n.mapboxgl-popup-anchor-top-right .mapboxgl-popup-tip {\n    -webkit-align-self: flex-end;\n    align-self: flex-end;\n    border-top: none;\n    border-right: none;\n    border-bottom-color: #fff;\n}\n\n.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip {\n    -webkit-align-self: center;\n    align-self: center;\n    border-bottom: none;\n    border-top-color: #fff;\n}\n\n.mapboxgl-popup-anchor-bottom-left .mapboxgl-popup-tip {\n    -webkit-align-self: flex-start;\n    align-self: flex-start;\n    border-bottom: none;\n    border-left: none;\n    border-top-color: #fff;\n}\n\n.mapboxgl-popup-anchor-bottom-right .mapboxgl-popup-tip {\n    -webkit-align-self: flex-end;\n    align-self: flex-end;\n    border-bottom: none;\n    border-right: none;\n    border-top-color: #fff;\n}\n\n.mapboxgl-popup-anchor-left .mapboxgl-popup-tip {\n    -webkit-align-self: center;\n    align-self: center;\n    border-left: none;\n    border-right-color: #fff;\n}\n\n.mapboxgl-popup-anchor-right .mapboxgl-popup-tip {\n    -webkit-align-self: center;\n    align-self: center;\n    border-right: none;\n    border-left-color: #fff;\n}\n\n.mapboxgl-popup-close-button {\n    position: absolute;\n    right: 0;\n    top: 0;\n    border: 0;\n    border-radius: 0 3px 0 0;\n    cursor: pointer;\n    background-color: transparent;\n}\n\n.mapboxgl-popup-close-button:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n}\n\n.mapboxgl-popup-content {\n    position: relative;\n    background: #fff;\n    border-radius: 3px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n    padding: 10px 10px 15px;\n    pointer-events: auto;\n}\n\n.mapboxgl-popup-anchor-top-left .mapboxgl-popup-content {\n    border-top-left-radius: 0;\n}\n\n.mapboxgl-popup-anchor-top-right .mapboxgl-popup-content {\n    border-top-right-radius: 0;\n}\n\n.mapboxgl-popup-anchor-bottom-left .mapboxgl-popup-content {\n    border-bottom-left-radius: 0;\n}\n\n.mapboxgl-popup-anchor-bottom-right .mapboxgl-popup-content {\n    border-bottom-right-radius: 0;\n}\n\n.mapboxgl-marker {\n    position: absolute;\n    top: 0;\n    left: 0;\n    will-change: transform;\n}\n\n.mapboxgl-user-location-dot {\n    background-color: #1da1f2;\n    width: 15px;\n    height: 15px;\n    border-radius: 50%;\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.25);\n}\n\n.mapboxgl-user-location-dot::before {\n    background-color: #1da1f2;\n    content: '';\n    width: 15px;\n    height: 15px;\n    border-radius: 50%;\n    position: absolute;\n    -webkit-animation: mapboxgl-user-location-dot-pulse 2s infinite;\n    -moz-animation: mapboxgl-user-location-dot-pulse 2s infinite;\n    -ms-animation: mapboxgl-user-location-dot-pulse 2s infinite;\n    animation: mapboxgl-user-location-dot-pulse 2s infinite;\n}\n\n.mapboxgl-user-location-dot::after {\n    border-radius: 50%;\n    border: 2px solid #fff;\n    content: '';\n    height: 19px;\n    left: -2px;\n    position: absolute;\n    top: -2px;\n    width: 19px;\n    box-sizing: border-box;\n}\n\n@-webkit-keyframes mapboxgl-user-location-dot-pulse {\n    0%   { -webkit-transform: scale(1); opacity: 1; }\n    70%  { -webkit-transform: scale(3); opacity: 0; }\n    100% { -webkit-transform: scale(1); opacity: 0; }\n}\n\n@-ms-keyframes mapboxgl-user-location-dot-pulse {\n    0%   { -ms-transform: scale(1); opacity: 1; }\n    70%  { -ms-transform: scale(3); opacity: 0; }\n    100% { -ms-transform: scale(1); opacity: 0; }\n}\n\n@keyframes mapboxgl-user-location-dot-pulse {\n    0%   { transform: scale(1); opacity: 1; }\n    70%  { transform: scale(3); opacity: 0; }\n    100% { transform: scale(1); opacity: 0; }\n}\n\n.mapboxgl-user-location-dot-stale {\n    background-color: #aaa;\n}\n\n.mapboxgl-user-location-dot-stale::after {\n    display: none;\n}\n\n.mapboxgl-crosshair,\n.mapboxgl-crosshair .mapboxgl-interactive,\n.mapboxgl-crosshair .mapboxgl-interactive:active {\n    cursor: crosshair;\n}\n\n.mapboxgl-boxzoom {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 0;\n    height: 0;\n    background: #fff;\n    border: 2px dotted #202020;\n    opacity: 0.5;\n}\n\n@media print {\n    /* stylelint-disable-next-line selector-class-pattern */\n    .mapbox-improve-map {\n        display: none;\n    }\n}\n", ""]);
	
	// exports


/***/ },
/* 3439 */
/***/ function(module, exports) {

	(function(window, angular, undefined) {
	
	  'use strict';
	
	  /* global -ngSwipe */
	
	  var ngSwipe = angular.module('swipe', []);
	
	  ngSwipe.factory('swipe', [ function() {
	
	    var MOVE_BUFFER_RADIUS = 40;
	    var MAX_RATIO = 0.3;
	
	    function getCoordinates(event) {
	      var touches = event.touches && event.touches.length ? event.touches : [event];
	      var e = (event.changedTouches && event.changedTouches[0]) ||
	          (event.originalEvent && event.originalEvent.changedTouches &&
	              event.originalEvent.changedTouches[0]) ||
	          touches[0].originalEvent || touches[0];
	
	      return {
	        x: e.clientX,
	        y: e.clientY
	      };
	    }
	
	    return {
	
	      bind: function(element, eventHandlers) {
	
	        // Absolute total movement
	        var totalX, totalY;
	        // Coordinates of the start position.
	        var startCoords;
	        var lastPos;
	        // Whether a swipe is active.
	        var active = false;
	        // Decide where we are going
	        var isDecided = false;
	        var isVertical = true;
	
	        element.on('touchstart mousedown', function(event) {
	          startCoords = getCoordinates(event);
	          active = true;
	          totalX = 0;
	          totalY = 0;
	          isDecided = false;
	          isVertical = true;
	          lastPos = startCoords;
	          eventHandlers['start'] && eventHandlers['start'](startCoords, event);
	        });
	
	        element.on('touchcancel', function(event) {
	          active = false;
	          eventHandlers['cancel'] && eventHandlers['cancel'](event);
	        });
	
	        element.on('touchmove mousemove', function(event) {
	
	          if (! active) {
	            return;
	          }
	
	          if (! startCoords) {
	            return;
	          }
	
	          var coords = getCoordinates(event);
	
	          totalX += Math.abs(coords.x - lastPos.x);
	          totalY += Math.abs(coords.y - lastPos.y);
	
	          lastPos = coords;
	
	          if (totalX < MOVE_BUFFER_RADIUS && totalY < MOVE_BUFFER_RADIUS) {
	            return;
	          } else {
	            if (! isDecided){
	
	              var deltaX, deltaY, ratio;
	
	              deltaX = Math.abs(coords.x - startCoords.x);
	              deltaY = Math.abs(coords.y - startCoords.y);
	
	              ratio = deltaY / deltaX;
	
	              if (ratio < MAX_RATIO){
	                event.preventDefault();
	                isVertical = false;
	              } else {
	                isVertical = true;
	              }
	
	              isDecided = true;
	            }
	          }
	
	          event.isVertical = isVertical;
	          eventHandlers['move'] && eventHandlers['move'](coords, event);
	        });
	
	        element.on('touchend mouseup', function(event) {
	          if (! active){
	            return;
	          }
	          event.isVertical = isVertical;
	          active = false;
	          eventHandlers['end'] && eventHandlers['end'](getCoordinates(event), event);
	        });
	      }
	    };
	  }]);
	
	  function makeSwipeDirective(directiveName, direction, axis, eventName) {
	    ngSwipe.directive(directiveName, ['$parse', 'swipe', function($parse, swipe) {
	
	      var MAX_OTHER_AXIS_DISTANCE = 75;
	      var MAX_RATIO = 0.3;
	      var MIN_DISTANCE = 30;
	
	      return function(scope, element, attr) {
	
	        var swipeHandler = $parse(attr[directiveName]);
	
	        var startCoords, valid;
	
	        function validSwipe(coords) {
	
	          if (! startCoords || ! valid){
	            return false;
	          }
	
	          var deltaY = (coords.y - startCoords.y) * direction;
	          var deltaX = (coords.x - startCoords.x) * direction;
	
	          if (! axis){  // horizontal swipe
	            return Math.abs(deltaY) < MAX_OTHER_AXIS_DISTANCE &&
	              deltaX > 0 &&
	              deltaX > MIN_DISTANCE &&
	              Math.abs(deltaY) / deltaX < MAX_RATIO;
	          } else {  // vertical swipe
	            return Math.abs(deltaX) < MAX_OTHER_AXIS_DISTANCE &&
	              deltaY > 0 &&
	              deltaY > MIN_DISTANCE &&
	              Math.abs(deltaX) / deltaY < MAX_RATIO;
	          }
	
	        }
	
	        swipe.bind(element, {
	          'start': function(coords, event) {
	            var className = event.target.getAttribute('class');
	            if (axis && (! className || className && className.match('noPreventDefault') === null)) {
	              event.preventDefault();
	            }
	            startCoords = coords;
	            valid = true;
	          },
	          'cancel': function() {
	            valid = false;
	          },
	          'end': function(coords, event) {
	            if (validSwipe(coords)) {
	              scope.$apply(function() {
	                element.triggerHandler(eventName);
	                swipeHandler(scope, { $event: event });
	              });
	            }
	          }
	        });
	      };
	    }]);
	  }
	
	  // avoid conflicts with ngTouch module
	
	  try {
	    angular.module('ngTouch');
	  } catch(err) {
	    makeSwipeDirective('ngSwipeLeft', -1, false, 'swipeleft');
	    makeSwipeDirective('ngSwipeRight', 1, false, 'swiperight');
	  }
	
	  // left is negative x-coordinate, right is positive
	
	  makeSwipeDirective('ngSwipeUp', -1, true, 'swipeup');
	  makeSwipeDirective('ngSwipeDown', 1, true, 'swipedown');
	
	})(window, window.angular);
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = "swipe";

/***/ },
/* 3440 */
/***/ function(module, exports) {

	module.exports = angular.module('ngMeta', [])
	.provider('ngMeta', function() {
	
	  'use strict';
	
	  //Object for storing default tag/values
	  var defaults = {};
	
	  //One-time configuration
	  var config = {
	    useTitleSuffix: false
	  };
	
	  function Meta($rootScope) {
	
	    /**
	     * @ngdoc method
	     * @name ngMeta#setTitle
	     * @description
	     * Sets the title of the page, optionally
	     * appending a title suffix.
	     *
	     * If suffix usage is enabled and the title suffix
	     * parameter is missing, the default title suffix
	     * (if available) is used as a fallback.
	     *
	     * @example
	     * //title and titleSuffix
	     * ngMeta.setTitle('Page name', ' - Site name | Tagline of the site');
	     *
	     * //title only (default titleSuffix may be suffixed,
	     * //depending on useTitleSuffix configuration)
	     * ngMeta.setTitle('Page name');
	     *
	     * @returns {Object} self
	     */
	    var setTitle = function(title, titleSuffix) {
	      if (!$rootScope.ngMeta) {
	        throw new Error('Cannot call setTitle when ngMeta is undefined. Did you forget to call ngMeta.init() in the run block? \nRefer: https://github.com/vinaygopinath/ngMeta#getting-started');
	      }
	
	      $rootScope.ngMeta.title = angular.isDefined(title) ? title : (defaults.title || '');
	      if (config.useTitleSuffix) {
	        $rootScope.ngMeta.title += angular.isDefined(titleSuffix) ? titleSuffix : (defaults.titleSuffix || '');
	      }
	      return this;
	    };
	
	    /**
	     * @ngdoc method
	     * @name ngMeta#setTitleSuffix
	     * @description
	     * Sets the title suffic of the page, while
	     * using the default title.
	     *
	     * @example
	     * //titleSuffix
	     * ngMeta.setTitleSuffix(' - Site name | Tagline of the site');
	     *
	     * @returns {Object} self
	     */
	    var setTitleSuffix = function(titleSuffix) {
	      if (!$rootScope.ngMeta) {
	        throw new Error('Cannot call setTitleSuffix when ngMeta is undefined. Did you forget to call ngMeta.init() in the run block? \nRefer: https://github.com/vinaygopinath/ngMeta#getting-started');
	      }
	
	      $rootScope.ngMeta.title = (defaults.title || '');
	      if (config.useTitleSuffix) {
	        $rootScope.ngMeta.title += angular.isDefined(titleSuffix) ? titleSuffix : (defaults.titleSuffix || '');
	      }
	      return this;
	    };
	
	    /**
	     * @ngdoc method
	     * @name ngMeta#setTag
	     * @description
	     * Sets the value of a meta tag, using
	     * the default value (if available) as
	     * a fallback.
	     *
	     * @example
	     * ngMeta.setTag('og:image', 'http://example.com/a.png');
	     *
	     * @returns {Object} self
	     */
	    var setTag = function(tag, value) {
	      if (!$rootScope.ngMeta) {
	        throw new Error('Cannot call setTag when ngMeta is undefined. Did you forget to call ngMeta.init() in the run block? \nRefer: https://github.com/vinaygopinath/ngMeta#getting-started');
	      }
	      if (tag === 'title' || tag === 'titleSuffix') {
	        throw new Error('Attempt to set \'' + tag + '\' through \'setTag\': \'title\' and \'titleSuffix\' are reserved tag names. Please use \'ngMeta.setTitle\' instead');
	      }
	
	      $rootScope.ngMeta[tag] = angular.isDefined(value) ? value : defaults[tag];
	      return this;
	    };
	
	    /**
	     * @ngdoc method
	     * @name ngMeta#setDefaultTag
	     * @description
	     * Sets the default tag for all routes that are missing a custom
	     * `tag` property in their meta objects.
	     *
	     * @example
	     * ngMeta.setDefaultTag('titleSuffix', ' | Tagline of the site');
	     *
	     * @returns {Object} self
	     */
	    var setDefaultTag = function(tag, value) {
	      if (!$rootScope.ngMeta) {
	        throw new Error('Cannot call setDefaultTag when ngMeta is undefined. Did you forget to call ngMeta.init() in the run block? \nRefer: https://github.com/vinaygopinath/ngMeta#getting-started');
	      }
	
	      defaults[tag] = value;
	
	      if (tag === 'title' || tag === 'titleSuffix') {
	        this.setTitle($rootScope.ngMeta.title, $rootScope.ngMeta.titleSuffix);
	      } else {
	        this.setTag(tag, $rootScope.ngMeta[tag]);
	      }
	
	      return this;
	    };
	
	    /**
	     * @ngdoc method
	     * @name readRouteMeta
	     * @description
	     * Helper function to process meta tags on route/state
	     * change.
	     *
	     * It:
	     * 1. Sets the title (with titleSuffix, as appropriate)
	     * 2. Iterates through all the state/route tags (other than title)
	     *    and sets their values
	     * 3. Iterates through all default tags and sets the ones
	     *    that were not utilized while setting the state/route tags.
	     *
	     * @returns {Object} self
	     */
	    var readRouteMeta = function(meta) {
	      meta = meta || {};
	
	      if (meta.disableUpdate) {
	        return false;
	      }
	
	      setTitle(meta.title, meta.titleSuffix);
	
	      var def = angular.copy(defaults);
	
	      delete meta.title;
	      delete meta.titleSuffix;
	      delete def.title;
	      delete def.titleSuffix;
	
	      var metaKeys = Object.keys(meta);
	      for (var i = 0; i < metaKeys.length; i++) {
	        if (def.hasOwnProperty(metaKeys[i])) {
	          delete def[metaKeys[i]];
	        }
	        setTag(metaKeys[i], meta[metaKeys[i]]);
	      }
	
	      var defaultKeys = Object.keys(def);
	      for (var j = 0; j < defaultKeys.length; j++) {
	        setTag(defaultKeys[j], def[defaultKeys[j]]);
	      }
	    };
	
	    var update = function(event, current) {
	      readRouteMeta(angular.copy(current.meta || (current.data && current.data.meta)));
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name ngMeta#init
	     * @description
	     * Initializes the ngMeta object and sets up
	     * listeners for route/state change broadcasts
	     *
	     * @example
	     * angular.module('yourApp', ['ngRoute', 'ngMeta'])
	     * .config(function($routeProvider, ngMetaProvider) {
	     *   ....
	     * })
	     * .run(function(ngMeta) {
	     *   ngMeta.init();
	     * });
	     */
	    var init = function() {
	      $rootScope.ngMeta = {};
	      $rootScope.$on('$routeChangeSuccess', update);
	      $rootScope.$on('$stateChangeSuccess', update);
	    };
	
	    return {
	      'init': init,
	      'setTitle': setTitle,
	      'setTitleSuffix': setTitleSuffix,
	      'setTag': setTag,
	      'setDefaultTag': setDefaultTag
	    };
	  }
	
	  /* Set defaults */
	
	  /**
	   * @ngdoc method
	   * @name ngMetaProvider#setDefaultTitle
	   * @param {string} titleStr The default title of the page. If a
	   * route/state does not define a `title` param in its meta object, this
	   * value is used instead.
	   *
	   * @description
	   * Sets the default title for all routes that are missing a custom `title`
	   * property in their meta objects.
	   *
	   * @returns {Object} self
	   */
	  this.setDefaultTitle = function(titleStr) {
	    defaults.title = titleStr;
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngMetaProvider#setDefaultTitleSuffix
	   * @param {string} titleSuffix The default title suffix of the page. If a
	   * route/state does not define a `titleSuffix` param in its meta object,
	   * this value is used instead.
	   *
	   * @description
	   * Sets the default title suffix for all routes that are missing a custom
	   * `titleSuffix` property in their meta objects.
	   *
	   * @returns {Object} self
	   */
	  this.setDefaultTitleSuffix = function(titleSuffix) {
	    defaults.titleSuffix = titleSuffix;
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngMetaProvider#setDefaultTag
	   * @param {string} tag The default tag name. The default tag can be
	   * overridden by defining a custom property of the same name in the meta
	   * object of any route.
	   *
	   * @param {string} value The value of the tag.
	   *
	   * @description
	   * Sets the default tag for all routes that are missing a custom
	   * `tag` property in their meta objects.
	   *
	   * @returns {Object} self
	   */
	  this.setDefaultTag = function(tag, value) {
	    defaults[tag] = value;
	    return this;
	  };
	
	  /* One-time config */
	
	  /**
	   * @ngdoc method
	   * @name ngMetaProvider#useTitleSuffix
	   * @param {boolean} bool A boolean indicating the use of title suffix.
	   * Defaults to false.
	   *
	   * @description
	   * Toggles the use of the title suffix throughout the site.
	   *
	   * @returns {Object} self
	   */
	  this.useTitleSuffix = function(bool) {
	    config.useTitleSuffix = !!bool;
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngMetaProvider#mergeNestedStateData
	   * @param {string} mergeNestedStateData [Optional] method to deep merge
	   * meta data for nested views.
	   *
	   * @description
	   * Helper function to Extend $stateProvider.decorator('state') to merge nested
	   * view meta data if using ui-router.
	   *
	   * @returns {Object} data
	   */
	  this.mergeNestedStateData = function(state, parentDecoratorFn) {
	  // original data
	    var originalData = parentDecoratorFn(state) || {};
	
	    // create new merged meta
	    var parentMetaData = state.parent && state.parent.data && state.parent.data.meta;
	
	    //Assign the merged meta if necessary to current state and return
	    if (originalData.meta || parentMetaData) {
	      var mergedMeta = angular.merge({}, parentMetaData, originalData.meta);
	      originalData.meta = mergedMeta;
	    }
	    state.self.data = originalData;
	    return originalData;
	  };
	
	
	  this.$get = ["$rootScope", function($rootScope) {
	    return new Meta($rootScope);
	  }];
	});
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = "ngMeta";

/***/ },
/* 3441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.components', [__webpack_require__(3442), __webpack_require__(3448), __webpack_require__(3452), __webpack_require__(3456), __webpack_require__(3460), __webpack_require__(3464), __webpack_require__(3468), __webpack_require__(3472), __webpack_require__(3476), __webpack_require__(3480), __webpack_require__(3485), __webpack_require__(3489), __webpack_require__(3493), __webpack_require__(3496), __webpack_require__(3498), __webpack_require__(3500), __webpack_require__(3505), __webpack_require__(3507), __webpack_require__(3511), __webpack_require__(3513), __webpack_require__(3517), __webpack_require__(3521), __webpack_require__(3522)]).name;

/***/ },
/* 3442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.components.hvr-charts', [__webpack_require__(3443), __webpack_require__(3447)]).name;

/***/ },
/* 3443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _d = __webpack_require__(608);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _hvrChartHelpers = __webpack_require__(3444);
	
	var _lodash = __webpack_require__(412);
	
	__webpack_require__(3445);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.components.od-hvr-bar-chart', []).component('odHvrBarChart', {
	  bindings: {
	    data: '<'
	  },
	  controller: function () {
	    controller.$inject = ["$element", "$mediaQuery"];
	    function controller($element, $mediaQuery) {
	      _classCallCheck(this, controller);
	
	      this.$element = $element;
	
	      this.elemWidth = 425;
	      this.elemHeight = 325;
	      if (!$mediaQuery('gt-xs')) {
	        this.elemWidth = 300;
	        this.elemHeight = 250;
	      }
	
	      $element.append('\n        <svg\n          width="' + this.elemWidth + '"\n          height="' + this.elemHeight + '"\n          viewbox="0 0 ' + this.elemWidth + ' ' + this.elemHeight + '"\n          preserveaspectratio="xMidYMid meet"\n        >\n        </svg>\n      ');
	
	      this.buildChart($element.find('svg'));
	    }
	
	    _createClass(controller, [{
	      key: 'buildChart',
	      value: function buildChart(chartElement) {
	        if ((0, _lodash.isNil)(this.data)) {
	          return;
	        }
	        var data = this.data;
	
	        var iconUrl = 'https://images.opendoor.com/source/s3/imgdrop-production/hvr-label-your-home.svg?service=web';
	        var iconWidth = 99;
	        var iconHeight = 33;
	        var iconMarginTop = 10;
	
	        var svg_elem = _d2.default.select(chartElement[0]);
	        var margin = { top: 60, right: 20, bottom: 60, left: 40 };
	        var width = this.elemWidth - margin.left - margin.right;
	        var height = this.elemHeight - margin.top - margin.bottom;
	
	        // spacing between bars: 0.5 (almost none) to 1.0 (so much spacing, can't even see the bars!)
	        var x = _d2.default.scale.ordinal().rangeRoundBands([0, width], .40);
	        var y = _d2.default.scale.linear().range([height, 0]);
	
	        var xAxis = _d2.default.svg.axis().scale(x).orient("bottom");
	
	        var yAxis = _d2.default.svg.axis().scale(y).orient("left").ticks(10);
	
	        var svg = svg_elem.attr("width", width + margin.left + margin.right).attr("height", height + margin.top + margin.bottom).append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");
	
	        x.domain(data.freq.map(function (d) {
	          return d.tier;
	        }));
	        y.domain([0, _d2.default.max(data.freq, function (d) {
	          return d.tier_count;
	        })]);
	
	        // Draw the X-axis line
	        svg.append("g").attr("class", "x axis").attr("transform", "translate(0," + height + ")").call(xAxis).selectAll("text").call(_hvrChartHelpers.wrapLabels, x.rangeBand())
	        //  .style("text-anchor", "end")
	        //  .attr("dx", "35px") // <-- X dimension positioning
	        //  .attr("dy", "10px") // <-- spacing between the y labels and the y axis
	        ;
	
	        // Draw the Y-axis line
	        svg.append("g").attr("class", "y axis").call(yAxis.ticks(5)).append("text").attr("class", "text-label-y").attr("transform", "rotate(-90)").attr("y", 6).attr("dy", ".70em").style("text-anchor", "end")
	        //.text("Value ($)") // Label the y-axis
	        ;
	
	        // Draw the Y grid lines
	        svg.append("g").attr("class", "grid").call(_d2.default.svg.axis().scale(y).orient("left").ticks(5).tickSize(-width, 0, 0).tickFormat(""));
	
	        // Draw the bars
	        svg.selectAll("bar").data(data.freq).enter().append("rect").attr("class", function (d) {
	          if (data.subj_tier == d.tier) {
	            return "subj-bar";
	          }
	          return "freq-bars";
	        }).attr("x", function (d) {
	          return x(d.tier);
	        }).attr("width", x.rangeBand()).attr("y", function (d) {
	          return y(d.tier_count);
	        }).attr("height", function (d) {
	          return height - y(d.tier_count);
	        });
	
	        var barWidth = x.rangeBand();
	        var iconPosition = x(data.subj_tier) + (barWidth - iconWidth) / 2.0;
	
	        svg.append("svg:image").attr('x', iconPosition).attr('y', y(data.subj_count) - iconHeight - iconMarginTop).attr('width', iconWidth).attr('height', iconHeight).attr("xlink:href", iconUrl);
	      }
	    }]);
	
	    return controller;
	  }()
	}).name;

/***/ },
/* 3444 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.wrapLabels = wrapLabels;
	
	var _d = __webpack_require__(608);
	
	var _d2 = _interopRequireDefault(_d);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapLabels(text, width) {
	  text.each(function () {
	    var text = _d2.default.select(this),
	        words = text.text().split(/\s+/).reverse(),
	        word,
	        line = [],
	        lineNumber = 0,
	        lineHeight = 1.1,
	        y = text.attr("y"),
	        dy = parseFloat(text.attr("dy")),
	        tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
	    do {
	      word = words.pop();
	      line.push(word);
	      tspan.text(line.join(" "));
	      if (tspan.node().getComputedTextLength() > width) {
	        line.pop();
	        tspan.text(line.join(" "));
	        line = [word];
	        tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
	      }
	    } while (word);
	  });
	}

/***/ },
/* 3445 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3446);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/less-loader/lib/loader.js!./od-hvr-charts.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/less-loader/lib/loader.js!./od-hvr-charts.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3446 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}od-hvr-bar-chart,od-hvr-grouped-bar-chart{display:block;background-color:#fff}od-hvr-bar-chart .x path,od-hvr-grouped-bar-chart .x path,od-hvr-bar-chart .x line,od-hvr-grouped-bar-chart .x line{fill:none;stroke:#f0f0f0;shape-rendering:crispEdges}od-hvr-bar-chart .y path,od-hvr-grouped-bar-chart .y path,od-hvr-bar-chart .y line,od-hvr-grouped-bar-chart .y line{fill:none;stroke:none}od-hvr-bar-chart .axis,od-hvr-grouped-bar-chart .axis{font:12px sans-serif}od-hvr-bar-chart .x .tick,od-hvr-grouped-bar-chart .x .tick{font:12px sans-serif;font-weight:bold;fill:#4e6373}od-hvr-bar-chart .y .tick,od-hvr-grouped-bar-chart .y .tick{font:12px sans-serif;fill:#9ba1a6}od-hvr-bar-chart .freq-bars,od-hvr-grouped-bar-chart .freq-bars{fill:#bddfff}od-hvr-bar-chart .subj-bar,od-hvr-grouped-bar-chart .subj-bar{fill:#1c85e8}od-hvr-bar-chart .tick,od-hvr-grouped-bar-chart .tick{stroke-opacity:0}od-hvr-bar-chart .grid .tick,od-hvr-grouped-bar-chart .grid .tick{stroke:#dedede;stroke-opacity:.7;shape-rendering:crispEdges}od-hvr-bar-chart .grid path,od-hvr-grouped-bar-chart .grid path{stroke-width:1px}", ""]);
	
	// exports


/***/ },
/* 3447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _d = __webpack_require__(608);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _hvrChartHelpers = __webpack_require__(3444);
	
	var _lodash = __webpack_require__(412);
	
	__webpack_require__(3445);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.components.od-hvr-grouped-bar-chart', []).component('odHvrGroupedBarChart', {
	  bindings: {
	    data: '<'
	  },
	  controller: function () {
	    controller.$inject = ["$element", "$mediaQuery"];
	    function controller($element, $mediaQuery) {
	      _classCallCheck(this, controller);
	
	      this.$element = $element;
	
	      this.elemWidth = 520;
	      this.elemHeight = 300;
	      if (!$mediaQuery('gt-md')) {
	        this.elemWidth = 400;
	        this.elemHeight = 250;
	      }
	      if (!$mediaQuery('gt-sm')) {
	        this.elemWidth = 520;
	        this.elemHeight = 350;
	      }
	      if (!$mediaQuery('gt-xs')) {
	        this.elemWidth = 300;
	        this.elemHeight = 250;
	      }
	
	      $element.append('\n        <svg\n          width="' + this.elemWidth + '"\n          height="' + this.elemHeight + '"\n          viewbox="0 0 ' + this.elemWidth + ' ' + this.elemHeight + '"\n          preserveaspectratio="xMidYMid meet"\n        >\n        </svg>\n      ');
	
	      this.buildChart($element.find('svg'));
	    }
	
	    _createClass(controller, [{
	      key: 'buildChart',
	      value: function buildChart(chartElement) {
	        if ((0, _lodash.isNil)(this.data)) {
	          return;
	        }
	        var data = this.data;
	
	        var legendIconUrl = 'https://images.opendoor.com/source/s3/imgdrop-production/hvr-label-neighborhood.svg?service=web';
	        var iconWidth = 227;
	        var iconHeight = 13;
	
	        var dataKeys = _d2.default.keys(data[0]).filter(function (key) {
	          return key !== "label";
	        });
	
	        var svg_elem = _d2.default.select(chartElement[0]);
	        var margin = { top: 60, right: 20, bottom: 60, left: 40 };
	        var width = this.elemWidth - margin.left - margin.right;
	        var height = this.elemHeight - margin.top - margin.bottom;
	
	        // spacing between bars: 0.5 (almost none) to 1.0 (so much spacing, can't even see the bars!)
	        var x0 = _d2.default.scale.ordinal().rangeRoundBands([0, width], .30);
	        var x1 = _d2.default.scale.ordinal();
	        var y = _d2.default.scale.linear().range([height, 0]);
	
	        var xAxis = _d2.default.svg.axis().scale(x0).orient("bottom");
	
	        var yAxis = _d2.default.svg.axis().scale(y).orient("left").ticks(10).tickFormat(_d2.default.format("%"));
	
	        var svg = svg_elem.attr("width", width + margin.left + margin.right).attr("height", height + margin.top + margin.bottom).append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");
	
	        data.forEach(function (d) {
	          d.values = dataKeys.map(function (name) {
	            return { name: name, value: +d[name] };
	          });
	        });
	
	        x0.domain(data.map(function (d) {
	          return d.label;
	        }));
	        x1.domain(dataKeys).rangeRoundBands([0, x0.rangeBand()]);
	        y.domain([0, _d2.default.max(data, function (d) {
	          return _d2.default.max(d.values, function (d) {
	            return d.value;
	          });
	        })]);
	
	        // Draw the X-axis line
	        svg.append("g").attr("class", "x axis").attr("transform", "translate(0," + height + ")").call(xAxis).selectAll("text").call(_hvrChartHelpers.wrapLabels, x0.rangeBand());
	
	        // Draw the Y-axis line
	        svg.append("g").attr("class", "y axis").call(yAxis.ticks(5)).append("text").attr("class", "text-label-y").attr("transform", "rotate(-90)").attr("y", 6).attr("dy", ".70em").style("text-anchor", "end");
	
	        // Draw the Y grid lines
	        svg.append("g").attr("class", "grid").call(_d2.default.svg.axis().scale(y).orient("left").ticks(5).tickSize(-width, 0, 0).tickFormat(""));
	
	        var bar = svg.selectAll("bar").data(data).enter().append("g").attr("class", "rect").attr("transform", function (d) {
	          return 'translate(' + x0(d.label) + ',0)';
	        });
	
	        // TODO: "phoenix" is hardcoded in the response we get, but switch to something like
	        // "market" to be more future-proof. Will also need to update the legend icon below.
	        bar.selectAll("rect").data(function (d) {
	          return d.values;
	        }).enter().append("rect").attr("class", function (d) {
	          if (d.name === "phoenix") {
	            return "freq-bars";
	          } else {
	            return "subj-bar";
	          }
	        }).attr("width", x1.rangeBand() - 5).attr("x", function (d) {
	          return x1(d.name);
	        }).attr("y", function (d) {
	          return y(d.value);
	        }).attr("value", function (d) {
	          return d.name;
	        }).attr("height", function (d) {
	          return height - y(d.value);
	        });
	
	        svg.append("svg:image").attr('x', width - iconWidth).attr('y', -40).attr('width', iconWidth).attr('height', iconHeight).attr("xlink:href", legendIconUrl);
	      }
	    }]);
	
	    return controller;
	  }()
	}).name;

/***/ },
/* 3448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _odBuyerFaqs = __webpack_require__(3449);
	
	var _odBuyerFaqs2 = _interopRequireDefault(_odBuyerFaqs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.components.od-buyer-faqs', []).component('odBuyerFaqs', {
	  template: __webpack_require__(3451)()
	}).name;

/***/ },
/* 3449 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3450);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-buyer-faqs.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-buyer-faqs.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3450 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "od-buyer-faqs .faq-container{margin-bottom:3em}", ""]);
	
	// exports


/***/ },
/* 3451 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<h2 class=\"extra-bottom-margin\">Opendoor Buyer FAQs</h2><div class=\"row\"><div class=\"col-md-5 col-md-offset-1 col-xs-12 text-left\"><div class=\"faq-container\"><h5>Which homes are eligible for the Opendoor Guarantee?</h5><p class=\"text-dark-gray\">All buyers who contract to buy an Opendoor home after June 7th, 2016\nwill be offered the Opendoor Guarantee as part of their purchase contract.</p></div><div class=\"faq-container\"><h5>If I don't love the home I purchased from Opendoor, can I return it?</h5><p class=\"text-dark-gray\">The Opendoor Guarantee includes a 90-day guarantee. If you are unhappy with your home\npurchase, we’ll buy it back per the&nbsp;<a href=\"/property-terms\" target=\"_self\">terms and conditions</a>&nbsp;of our guarantee.</p><br><p class=\"text-dark-gray\">Once you let us know you’re unhappy with your home, we’ll schedule a Home Condition Assessment\nto make sure there hasn't been major damage to the home or other material changes reducing the\nvalue of your home. We'll then buy your home back for the original price less sunk fees,\ntransaction costs (including commissions) and repair costs beyond normal wear and tear.\nFurther details can be found in our&nbsp;<a href=\"/property-terms\" target=\"_self\">terms and conditions</a>.</p></div></div><div class=\"col-md-5 col-xs-12 text-left\"><div class=\"faq-container\"><h5>What is the difference between the Opendoor Guarantee and a home warranty?</h5><p class=\"text-dark-gray\">If you're not satisfied with your purchase within 90 days of closing on your new home,\nsimply let us know and you can return the home under our Opendoor Guarantee, subject\nto&nbsp;<a href=\"/property-terms\" target=\"_self\">terms and conditions</a>&nbsp;. A home warranty can help safeguard against the cost of repairs to major\ncomponents of home systems and select appliances that fail due to normal wear and tear,\nbased on the home warranty policy and coverage details.</p></div><div class=\"faq-container\"><h5>Should I buy a home warranty?</h5><p class=\"text-dark-gray\">Some home owners like to purchase home warranties so they can help minimize out-of-pocket\nexpenses if certain systems or appliances in the home have problems in the future. If\nyou’re interested in a home warranty, including how it works and the types of things they\ntypically cover, please let our Home Advisors know when you make your offer. We’ll work\ntogether to find an option that meets your needs.</p></div><div class=\"faq-container\"><h5>Do you do the inspections yourself?</h5><p class=\"text-dark-gray\">We use independent, state-licensed, third-party inspectors to perform\ninspections on the homes we sell.</p></div></div></div><div class=\"row text-center\"><div class=\"col-xs-12\"><a href=\"https://www.opendoor.com/faq\" class=\"button\">See all FAQs</a></div></div>");;return buf.join("");
	}

/***/ },
/* 3452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(3453);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.component.od-buyer-listing-info', []).component('odBuyerListingInfo', {
	  bindings: {
	    listing: '<'
	  },
	  template: __webpack_require__(3455)()
	}).name;

/***/ },
/* 3453 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3454);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-buyer-listing-info.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-buyer-listing-info.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3454 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}.od-buyer-listing-info .benefits-buying{margin:32px 0;text-align:left;display:inline-block}.od-buyer-listing-info .offer-price-box{max-width:200px;margin-bottom:32px;padding-bottom:32px;border-bottom:1px solid #dedede}", ""]);
	
	// exports


/***/ },
/* 3455 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"od-buyer-listing-info text-left\"><div class=\"offer-price-box\"><h4>{{$ctrl.listing.address | street}}</h4><div class=\"text-small\">{{$ctrl.listing.bedrooms}} bed ·\n{{$ctrl.listing.bathrooms}} bath</div><div class=\"text-small\">{{$ctrl.listing.square_footage | number}} ft² ·\n{{$ctrl.listing.lot_square_footage | number}} lot ft²</div></div><div ng-hide=\"$ctrl.listing.direct_price_cents\" class=\"list-price\"><div class=\"text-small\"><strong>List Price</strong></div><h3 class=\"no-margin no-letter-spacing\"><b>{{$ctrl.listing.price_cents | currency}}</b></h3></div><div ng-show=\"$ctrl.listing.direct_price_cents\" class=\"padded\"><div class=\"text-small\"><strong>List Price</strong></div><h3><b><s>{{$ctrl.listing.price_cents | currency}}</s></b></h3><h3><div class=\"text-small\"><strong>Direct Sale Price:</strong></div><b>{{$ctrl.listing.direct_price_cents | currency}}</b></h3></div><ul class=\"benefits-buying text-small\"><li>Trade-In Available</li><li>Flexible Timeline</li><li ng-if=\"$ctrl.listing.active &amp;&amp; !$ctrl.listing.temporarily_off_market\">All-Day Open House</li></ul><br><div class=\"text-small\">Have questions?<br><div><a ng-href=\"mailto:{{$ctrl.listing.address.market.buyer_contact_email || 'homes@opendoor.com'}}\">{{$ctrl.listing.address.market.buyer_contact_email || 'homes@opendoor.com'}}</a><br><a ng-href=\"{{($ctrl.defaultMarketPhoneNumbers[$ctrl.listing.address.market.identifier] | telhref) || ($ctrl.fallbackNumber | telhref)}}\">{{($ctrl.defaultMarketPhoneNumbers[$ctrl.listing.address.market.identifier] | tel) || ($ctrl.fallbackNumber | tel) }}</a></div></div></div>");;return buf.join("");
	}

/***/ },
/* 3456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tryClipboardCopy = __webpack_require__(552);
	
	var _tryClipboardCopy2 = _interopRequireDefault(_tryClipboardCopy);
	
	__webpack_require__(3457);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.component.od-clipboard-copy', []).component('odClipboardCopy', {
	  bindings: {
	    text: '@',
	    buttonText: '@?',
	    showInputElement: '<?'
	  },
	  template: __webpack_require__(3459)(),
	  controller: function () {
	    controller.$inject = ["$element", "$timeout"];
	    function controller($element, $timeout) {
	      _classCallCheck(this, controller);
	
	      this.$timeout = $timeout;
	
	      this.isHidden = !this.showInputElement;
	      this.isSuccess = false;
	      this.originalButtonText = this.buttonText || 'Click to copy';
	      this.buttonText = this.originalButtonText;
	
	      this.inputEl = $element.find('input')[0];
	    }
	
	    _createClass(controller, [{
	      key: 'copy',
	      value: function copy() {
	        var _this = this;
	
	        this.selectInputText();
	
	        var automaticCopySuccess = (0, _tryClipboardCopy2.default)();
	
	        if (automaticCopySuccess) {
	          this.inputEl.blur();
	          this.buttonText = 'Copied!';
	          this.isSuccess = true;
	          this.$timeout(function () {
	            _this.buttonText = _this.originalButtonText;
	            _this.isSuccess = false;
	          }, 2000);
	        } else {
	          // If automatic copy failed, we can fall back to asking the user to
	          // copy the text manually (via Ctrl/Cmd+C). So we expand the <input>
	          // element containing the text, where the text should already be
	          // selected and ready to be copied, and prompt the user to copy it.
	          this.isHidden = false;
	          this.buttonText = 'Copy the selected text';
	        }
	      }
	    }, {
	      key: 'selectInputText',
	      value: function selectInputText() {
	        this.inputEl.select();
	      }
	    }]);
	
	    return controller;
	  }()
	}).name;

/***/ },
/* 3457 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3458);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-clipboard-copy.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-clipboard-copy.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3458 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}od-clipboard-copy{margin-right:12px}od-clipboard-copy .copy-input{border:none;background-color:#fafafa;border-right:1px solid #dedede;-webkit-border-top-right-radius:0;border-top-right-radius:0;-webkit-border-bottom-right-radius:0;border-bottom-right-radius:0;-webkit-transition:all .15s ease-in-out;transition:all .15s ease-in-out}od-clipboard-copy .copy-input.hidden{max-width:.1px;padding-left:0;padding-right:0;border-right:none}@media (max-width:767px){od-clipboard-copy .copy-input{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}}@media (min-width:768px){od-clipboard-copy .copy-input{max-width:200px}}od-clipboard-copy .copy-button{border:none;-webkit-border-radius:0;border-radius:0}od-clipboard-copy .copy-button.success{color:#1c85e8}od-clipboard-copy .copy-button.success:hover{color:#1c85e8}@media (max-width:767px){od-clipboard-copy .copy-button{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}}@media (max-width:767px){od-clipboard-copy .copy-button{width:auto}od-clipboard-copy .copy-button{padding-left:10px;padding-right:10px}}", ""]);
	
	// exports


/***/ },
/* 3459 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<input type=\"text\" ng-class=\"{ hidden: $ctrl.isHidden}\" ng-click=\"$ctrl.selectInputText()\" value=\"{{$ctrl.text}}\" class=\"copy-input\"><button ng-click=\"$ctrl.copy()\" ng-class=\"{ success: $ctrl.isSuccess }\" class=\"button secondary copy-button\">{{$ctrl.buttonText}}</button>");;return buf.join("");
	}

/***/ },
/* 3460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	var _odCollapsibleQuestion = __webpack_require__(3461);
	
	var _odCollapsibleQuestion2 = _interopRequireDefault(_odCollapsibleQuestion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.components.od-collapsible-question', []).component('odCollapsibleQuestion', {
	  bindings: {
	    question: '@'
	  },
	  transclude: true,
	  template: __webpack_require__(3463)(),
	  controller: function () {
	    controller.$inject = ["$location", "$element"];
	    function controller($location, $element) {
	      _classCallCheck(this, controller);
	
	      this.questionId = (0, _lodash.kebabCase)(this.question);
	      $element[0].id = this.questionId;
	      this.$location = $location;
	
	      if (this.questionId === $location.hash()) {
	        this.collapsed = false;
	      } else {
	        this.collapsed = true;
	      }
	    }
	
	    _createClass(controller, [{
	      key: 'setQuestionId',
	      value: function setQuestionId() {
	        this.$location.hash(this.questionId);
	        this.collapsed = false;
	      }
	    }]);
	
	    return controller;
	  }()
	}).name;

/***/ },
/* 3461 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3462);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-collapsible-question.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-collapsible-question.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3462 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}od-collapsible-question{display:block;border-bottom:1px solid rgba(0,0,0,0.1);padding:25px 0 5px 0}od-collapsible-question.border-top{border-top:1px solid rgba(0,0,0,0.1)}od-collapsible-question .active{padding-bottom:25px}od-collapsible-question .question-header{cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}od-collapsible-question .question{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}od-collapsible-question .permalink{width:30px;height:20px;background:url(\"https://images.opendoor.com/source/s3/imgdrop-production/link-icon.svg?service=web\") left center no-repeat;background-size:auto 15px;-webkit-transition:opacity ease-in-out .1s;transition:opacity ease-in-out .1s;opacity:0;position:absolute;margin-left:-30px}od-collapsible-question .toggle-symbol{width:20px;height:20px;background:url(\"https://images.opendoor.com/source/s3/imgdrop-production/arrow-next.svg?service=web\") center no-repeat;background-size:auto 15px;opacity:.2;-webkit-transition:-webkit-transform ease-in-out .25s;transition:-webkit-transform ease-in-out .25s;transition:transform ease-in-out .25s;transition:transform ease-in-out .25s, -webkit-transform ease-in-out .25s}@media (min-width:992px){od-collapsible-question:hover .permalink{opacity:.5}od-collapsible-question:hover .permalink:hover{opacity:.8}}od-collapsible-question .active .toggle-symbol{-webkit-transform:rotate(90deg);transform:rotate(90deg)}", ""]);
	
	// exports


/***/ },
/* 3463 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div ng-class=\"{&quot;active&quot; : !$ctrl.collapsed}\"><div class=\"question-header\"><od-tooltip ng-click=\"$ctrl.setQuestionId()\"><od-tooltip-target class=\"permalink\"></od-tooltip-target><od-tooltip-hover class=\"dark\">Get Permalink</od-tooltip-hover></od-tooltip><h6 ng-click=\"$ctrl.collapsed = !$ctrl.collapsed\" class=\"question medium-margin-bottom\">{{$ctrl.question}}</h6><div class=\"toggle-symbol\"></div></div><div ng-hide=\"$ctrl.collapsed\" class=\"answer\"><ng-transclude></ng-transclude></div></div>");;return buf.join("");
	}

/***/ },
/* 3464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(3465);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.components.od-facebook-share-button', []).component('odFacebookShareButton', {
	  bindings: {
	    href: '@',
	    title: '@',
	    description: '@',
	    picture: '@',
	    caption: '@',
	    blue: '<?'
	  },
	  template: __webpack_require__(3467)(),
	  controller: function () {
	    controller.$inject = ["Facebook"];
	    function controller(Facebook) {
	      _classCallCheck(this, controller);
	
	      this.Facebook = Facebook;
	      if (typeof this.blue === 'undefined') {
	        this.blue = true;
	      }
	    }
	
	    _createClass(controller, [{
	      key: 'share',
	      value: function share() {
	        this.Facebook.share({
	          href: this.href,
	          title: this.title,
	          description: this.description,
	          picture: this.picture,
	          caption: this.caption
	        });
	      }
	    }]);
	
	    return controller;
	  }()
	}).name;

/***/ },
/* 3465 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3466);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-facebook-share-button.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-facebook-share-button.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3466 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}od-facebook-share-button .facebook-share-button.blue{color:#fff;background-color:#4267b2;border-color:#4267b2}od-facebook-share-button .facebook-share-button.blue:hover:not([disabled]){color:#fff;background-color:#365899;border-color:#365899}", ""]);
	
	// exports


/***/ },
/* 3467 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<button ng-class=\"{ blue: $ctrl.blue }\" ng-click=\"$ctrl.share()\" class=\"button secondary facebook-share-button\">Share on Facebook</button>");;return buf.join("");
	}

/***/ },
/* 3468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _momentTimezone = __webpack_require__(517);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _lodash = __webpack_require__(412);
	
	__webpack_require__(3469);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.components.od-footer', []).component('odFooter', {
	  bindings: {
	    topBorder: '<?'
	  },
	  template: __webpack_require__(3471)(),
	  controller: function () {
	    controller.$inject = ["Segment"];
	    function controller(Segment) {
	      _classCallCheck(this, controller);
	
	      this.showTopBorder = (0, _lodash.isNil)(this.topBorder) ? true : this.topBorder;
	      this.currentYear = (0, _momentTimezone2.default)().year();
	      this.Segment = Segment;
	    }
	
	    _createClass(controller, [{
	      key: 'trackOpendorMortgageLink',
	      value: function trackOpendorMortgageLink() {
	        this.Segment.track('clicked mortgage link', {
	          page: 'homepage', pageLocation: 'footer'
	        });
	      }
	    }]);
	
	    return controller;
	  }()
	}).name;

/***/ },
/* 3469 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3470);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-footer.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-footer.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3470 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}od-footer{display:block;background:#fff}od-footer .footer-container{padding:80px 0 50px 0}od-footer .footer-container.top-border{border-top:1px solid rgba(0,0,0,0.1)}@media only screen and (max-width:991px){od-footer .footer-container{padding:50px 0 30px 0;text-align:center}}@media only screen and (max-width:991px){od-footer .opendoor-logo{height:30px;width:auto;margin-bottom:30px}}od-footer .app-links{margin:70px 0 0 0}@media only screen and (max-width:991px){od-footer .app-links{margin:10px 0 40px 0}}od-footer .app-links p{font-size:14px;margin-bottom:5px;opacity:.5}od-footer .app-links a{display:inline-block;width:100%;font-size:14px;margin:8px 0 0 0;color:#525975}od-footer .app-links a:hover{color:#1c85e8}od-footer .app-links a img{display:inline;margin:0 5px 0 0}od-footer .sitemap li{margin-top:10px}od-footer .sitemap li a{color:#525975;font-size:14px}od-footer .sitemap li a:hover{color:#1c85e8}od-footer .footer-bottom{margin-top:80px}@media only screen and (max-width:991px){od-footer .footer-bottom{margin-top:30px}}od-footer .footer-bottom a{color:#525975;opacity:.6;-webkit-transition:all ease .3s;transition:all ease .3s}od-footer .footer-bottom a:hover{color:#525975;opacity:.3}@media only screen and (max-width:991px){od-footer .social-links{margin-top:30px}}od-footer .social-links a.social-link{display:inline-block;margin-right:15px;opacity:.3}od-footer .social-links a.social-link:hover{opacity:.4}", ""]);
	
	// exports


/***/ },
/* 3471 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<footer class=\"market-footer\"><div ng-class=\"{ &quot;top-border&quot;: $ctrl.showTopBorder }\" class=\"regular-container footer-container\"><div style=\"justify-content: space-between;\" class=\"row footer-top\"><div class=\"col-xs-6 col-sm-4 col-md-3\"><h6 class=\"text-small text-bolder no-margin-top small-margin-bottom\">SELL YOUR HOME</h6><ul class=\"sitemap\"><li><a href=\"/\" target=\"_self\">Request an offer</a></li><li><a href=\"/w/how-it-works\" target=\"_self\">How it works</a></li><li><a href=\"/w/pricing\" target=\"_self\">Pricing</a></li><li><a href=\"/w/trade-in\" target=\"_self\">Trade-in</a></li><li><a href=\"/reviews\" target=\"_self\">Reviews</a></li><li><a href=\"/w/stories\" target=\"_self\">Stories</a></li></ul><h6 class=\"text-small text-bolder medium-margin-top small-margin-bottom\">BUY A HOME</h6><ul class=\"sitemap\"><li><a href=\"/w/homes\" target=\"_self\">Buy</a></li></ul><h6 class=\"text-small text-bolder medium-margin-top small-margin-bottom\">PARTNERS</h6><ul class=\"sitemap\"><li><a href=\"/w/vendor-partnerships\" target=\"_self\">Vendors</a></li><li><a href=\"/w/partner/builder\" target=\"_self\">Builders</a></li></ul></div><div class=\"col-sm-4 col-md-3 hidden-xs-down\"><h6 class=\"text-small text-bolder no-margin-top small-margin-bottom\">TRADE-IN YOUR HOME</h6><ul class=\"sitemap\"><li><a href=\"/w/trade-in\" target=\"_self\">Opendoor trade-in</a></li><li><a href=\"/w/builder\" target=\"_self\">Builder trade-up</a></li></ul><h6 class=\"text-small text-bolder medium-margin-top small-margin-bottom\">AGENTS</h6><ul class=\"sitemap\"><li><a href=\"/w/agents#alp-buy--form\" target=\"_self\">Make an offer</a></li><li><a href=\"/w/agents\" target=\"_self\">Request an offer</a></li></ul><h6 class=\"text-small text-bolder medium-margin-top small-margin-bottom\">RESOURCES</h6><ul class=\"sitemap\"><li><a href=\"/w/blog\" target=\"_self\">Blog</a></li><li><a href=\"/w/resources\" target=\"_self\">Guides</a></li><li><a href=\"/w/faq\" target=\"_self\">FAQ</a></li><li><a href=\"https://help.opendoor.com/\" target=\"_self\">Help center</a></li></ul></div><div class=\"col-xs-6 col-sm-4 col-md-3\"><h6 class=\"text-small text-bolder no-margin-top small-margin-bottom\">ABOUT</h6><ul class=\"sitemap\"><li><a href=\"/w/about\" target=\"_self\">Company</a></li><li><a href=\"/w/careers\" target=\"_self\">Careers</a></li><li><a href=\"/w/press\" target=\"_self\">Press</a></li><li><a href=\"/w/contact-us\" target=\"_self\">Contact</a></li><li><a href=\"/w/stories\" target=\"_self\">Stories</a></li><li><a href=\"/w/resources\" target=\"_self\">Resources</a></li></ul><h6 class=\"text-small text-bolder medium-margin-top small-margin-bottom\">TERMS &amp; PRIVACY</h6><ul class=\"sitemap\"><li><a href=\"/w/safety\" target=\"_self\">Trust &amp; safety</a></li><li><a href=\"/w/terms\" target=\"_self\">Terms of service</a></li><li><a href=\"/w/privacy\" target=\"_self\">Privacy policy</a></li><li><a href=\"/privacyrequest\" target=\"_self\">Do not sell my info</a></li></ul></div><div class=\"col-xs-12 col-sm-12 col-md-3\"><h6 class=\"text-small text-bolder no-margin-top small-margin-bottom\">DOWNLOAD APP</h6><a href=\"https://play.google.com/store/apps/details?id=com.opendoor.buyerapp&amp;hl=en\" style=\"margin-bottom: 10px; display: block;\" target=\"_blank\"><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/3a52f003f27742f3b4384a3168352335.png?service=web\" alt=\"Play store button\" width=\"140\"></a><a href=\"https://itunes.apple.com/us/app/opendoor-homes-all-day-open/id1143708068?mt=8\" style=\"margin-bottom: 10px; display: block;\" target=\"_blank\"><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/03f8e282af254a80ac28358e640319ab.svg?service=web\" alt=\"App store button\" width=\"140\"></a></div></div><div class=\"social-links text-center large-margin-top large-margin-bottom\"><a href=\"https://www.facebook.com/OpendoorHQ\" target=\"_blank\"><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/1ac79b6da72048e5ac4e3770a67d9f51.svg?service=web\" alt=\"Facebook\" height=\"25px\" style=\"margin: 0 10px\"></a><a href=\"https://twitter.com/Opendoor\" target=\"_blank\"><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/f2641428da574ecf908264f2ab31a032.svg?service=web\" alt=\"Twitter\" height=\"25px\" style=\"margin: 0 10px\"></a><a href=\"https://www.linkedin.com/company/opendoor-com/\" target=\"_blank\"><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/eb24a868176f4dc182c1f3de199481e7.svg?service=web\" alt=\"Linkedin\" height=\"25px\" style=\"margin: 0 10px\"></a></div><div style=\"color:#526475;font-size:14px;display:flex; width: 100%;justify-content: space-between;line-height: 40px;\">&copy; {{$ctrl.currentYear}} Opendoor<img src=\"https://images.opendoor.com/source/s3/imgdrop-production/2cfd25967a794adabcc97873553da5ab.png?service=web\" alt=\"Equal Opportunity Housing Logo\" height=\"40px\"></div></div></footer>");;return buf.join("");
	}

/***/ },
/* 3472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _momentTimezone = __webpack_require__(517);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	__webpack_require__(3473);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.components.od-footer-nonmarketing', []).component('odFooterNonmarketing', {
	  template: __webpack_require__(3475)(),
	  controller: function controller() {
	    _classCallCheck(this, controller);
	
	    this.currentYear = (0, _momentTimezone2.default)().year();
	  }
	}).name;

/***/ },
/* 3473 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3474);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-footer-nonmarketing.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-footer-nonmarketing.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3474 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}od-footer-nonmarketing{display:block;background:#fff}od-footer-nonmarketing .nonmarketing{padding-bottom:20px}od-footer-nonmarketing .nonmarketing .dark-text,od-footer-nonmarketing .nonmarketing .dark-text:hover{color:#1d2c4c}@media (max-width:767px){od-footer-nonmarketing .nonmarketing .xs-margin-bottom{margin-bottom:20px}}", ""]);
	
	// exports


/***/ },
/* 3475 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	;var locals_for_with = (locals || {});(function (Date) {
	buf.push("<footer class=\"nonmarketing\"><div class=\"regular-container flex\"><div class=\"row text-center small flex-grow\"><div class=\"xs-margin-bottom col-xs-12 col-sm-1 flex flex-center-content flex-align-center\"><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/2cfd25967a794adabcc97873553da5ab.png?service=web\" alt=\"Equal housing opportunity\" height=\"45\" width=\"43\"></div><div class=\"col-sm-2 flex flex-align-center hidden-xs-down\"><p class=\"dark-text flex-grow\">© " + (jade.escape((jade_interp = new Date().getFullYear()) == null ? '' : jade_interp)) + " Opendoor</p></div><div class=\"col-xs-12 col-sm-9 flex flex-center-content flex-align-center xs-margin-bottom\"><a href=\"/terms\" target=\"_self\" class=\"dark-text\">Terms of Service</a><a href=\"/privacy\" target=\"_self\" class=\"dark-text\">&nbsp;· Privacy Policy</a><a href=\"/privacyrequest\" target=\"_self\" class=\"dark-text\">&nbsp;· Do Not Sell My Info</a></div><div class=\"col-xs-12 flex flex-align-center hidden-sm-up\"><p class=\"dark-text flex-grow\">© " + (jade.escape((jade_interp = new Date().getFullYear()) == null ? '' : jade_interp)) + " Opendoor</p></div></div></div></footer>");}.call(this,"Date" in locals_for_with?locals_for_with.Date:typeof Date!=="undefined"?Date:undefined));;return buf.join("");
	}

/***/ },
/* 3476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	__webpack_require__(3477);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.components.od-header', []).component('odHeader', {
	  bindings: {
	    logoOnly: '<?'
	  },
	  template: __webpack_require__(3479)(),
	  controller: function () {
	    controller.$inject = ["$rootScope", "$scope", "$state", "$mediaQuery", "Lead", "Segment"];
	    function controller($rootScope, $scope, $state, $mediaQuery, Lead, Segment) {
	      _classCallCheck(this, controller);
	
	      this.showLogoOnly = (0, _lodash.isNil)(this.logoOnly) ? false : this.logoOnly;
	      this.session = $rootScope.session;
	      this.$state = $state;
	      this.$mediaQuery = $mediaQuery;
	      this.Segment = Segment;
	      if ((this.session || {}).logged_in) {
	        this.leads = Lead.query();
	      }
	    }
	
	    _createClass(controller, [{
	      key: 'firstName',
	      value: function firstName() {
	        if (this.session && this.session.human && this.session.human.full_name) {
	          return this.session.human.full_name.split(/\s+/)[0];
	        }
	        return '';
	      }
	    }, {
	      key: 'trackOpendorMortgageLink',
	      value: function trackOpendorMortgageLink() {
	        this.Segment.track('clicked mortgage link', {
	          page: 'homepage', pageLocation: 'header'
	        });
	      }
	    }]);
	
	    return controller;
	  }()
	}).name;

/***/ },
/* 3477 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3478);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-header.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-header.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3478 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}od-header{position:relative;display:block;max-width:1600px;margin:0 auto;z-index:15}od-header .market-header{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;padding:0 25px;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;height:85px}od-header img.opendoor-logo{display:block;margin:30px 0}od-header li.primary-nav-item{position:relative;display:inline-block;line-height:25px;list-style:none}od-header li.primary-nav-item+li.primary-nav-item{margin-left:32px}@media (max-width:767px){od-header li.primary-nav-item+li.primary-nav-item{margin-left:12px}}@media (max-width:479px){od-header li.primary-nav-item{margin-left:12px;font-size:14px}}od-header li.primary-nav-item:hover .primary-nav-submenu{top:68px;visibility:visible;opacity:1}od-header li.primary-nav-item.current a.menu-item{color:#1c85e8}od-header li.primary-nav-item.dropdown a.menu-item::after{content:'';position:absolute;top:0;right:-20px;width:20px;height:15px;background:url('https://images.opendoor.com/source/s3/imgdrop-production/dropdown.svg?service=web') center no-repeat;background-size:10px auto;opacity:.7}@media (max-width:767px){od-header li.primary-nav-item.dropdown a.menu-item::after{right:-20px;top:-10px}}@media (max-width:479px){od-header li.primary-nav-item.dropdown a.menu-item::after{right:-30px;top:-10px;margin-right:10px}}od-header li.primary-nav-item.dropdown:hover a.menu-item::after{opacity:1}od-header li.primary-nav-item a.menu-item{position:relative;color:#525975}od-header li.primary-nav-item a.menu-item:hover{color:#1c85e8}od-header .primary-nav-submenu{position:absolute;top:75px;left:50%;visibility:hidden;padding:25px;background:#fff;-webkit-border-radius:3px;border-radius:3px;text-align:left;opacity:0;-webkit-transition:all ease .3s;transition:all ease .3s;-webkit-box-shadow:-5px 0 40px rgba(0,0,0,0.1);box-shadow:-5px 0 40px rgba(0,0,0,0.1)}od-header .primary-nav-submenu.narrow{width:100px;margin:0 0 0 -75px}@media (max-width:767px){od-header .primary-nav-submenu.narrow{margin:0;right:-30px;width:120px}}od-header .primary-nav-submenu.account{left:auto;right:0;text-align:right}od-header .primary-nav-submenu.account hr{margin:12px 0;border:none;border-top:1px solid rgba(0,0,0,0.1)}od-header .primary-nav-submenu.account a{display:inline-block;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}od-header .primary-nav-submenu.account:before{left:80%}@media (max-width:767px){od-header .primary-nav-submenu{left:inherit;right:0}}od-header .primary-nav-submenu:before{content:'';position:absolute;top:-7px;left:50%;width:0;height:0;margin:0 0 0 -10px;border-left:10px solid transparent;border-right:10px solid transparent;border-bottom:10px solid #fff}@media (max-width:767px){od-header .primary-nav-submenu:before{right:10px;left:inherit}}od-header .primary-nav-submenu-item{display:inline-block;padding:0;width:100%}od-header .primary-nav-submenu-item+li.primary-nav-submenu-item{margin-top:10px}od-header .primary-nav-submenu-item:last-child{margin:0}od-header .primary-nav-submenu-item .signin-btn{display:block;margin:0;padding:5px;text-align:center}od-header .primary-nav-submenu-item .signin-btn a{color:#fff}od-header .primary-nav-submenu-item a{font-size:15px;color:#525975}od-header .primary-nav-submenu-item a:hover{color:#1c85e8}@media (max-width:767px){od-header .account-link{margin-left:12px}}", ""]);
	
	// exports


/***/ },
/* 3479 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<header class=\"market-header\"><div><a href=\"/\" target=\"_self\"><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/logo-opendoor.svg?service=web\" alt=\"Opendoor\" height=\"25\" class=\"opendoor-logo\"></a></div><div ng-if=\"!$ctrl.showLogoOnly\"><ul class=\"primary-nav\"><li ng-class=\"{ current: $ctrl.$state.includes(&quot;lead&quot;) || $ctrl.$state.includes(&quot;offer&quot;) }\" class=\"primary-nav-item\"><a href=\"/\" target=\"_self\" class=\"menu-item\">Sell</a></li><li ng-class=\"{ current: $ctrl.$state.includes(&quot;homes&quot;) }\" class=\"primary-nav-item\"><a href=\"/w/homes\" target=\"_self\" class=\"menu-item\">Buy</a></li><li class=\"primary-nav-item\"><a href=\"/buy-and-sell\" target=\"_self\" class=\"menu-item\">Buy & Sell</a></li></ul></div><div ng-if=\"!$ctrl.showLogoOnly\" class=\"market-header-actions\"><ul class=\"account-tab\"><li ng-hide=\"session.human\" class=\"primary-nav-item\"><oc-login-link id=\"login-link\"></oc-login-link></li><li ng-show=\"session.human\" class=\"primary-nav-item\"><span class=\"hidden-xs-down\">Welcome {{' '}}</span><a ui-sref=\"humans.account\">{{$ctrl.firstName()}}</a><ul class=\"menu primary-nav-submenu account\"><li ng-repeat=\"lead in $ctrl.leads.slice(0, 3)\" class=\"primary-nav-submenu-item\"><a href=\"{{lead.url}}\" target=\"_self\">{{lead.address | street}}<span ng-if=\"lead.readable_state\"> ({{ lead.readable_state }})</span></a></li><li ng-show=\"$ctrl.leads.length &gt; 3\" class=\"primary-nav-submenu-item\"><a ui-sref=\"properties\">More</a></li><hr ng-show=\"$ctrl.leads.length\"><li ng-show=\"session.human.has_resale_closing_dashboard\" class=\"primary-nav-submenu-item\"><a href=\"/closing-dashboard\" target=\"_self\">Closing Dash</a></li><hr ng-show=\"session.human.has_resale_closing_dashboard\"><li ng-show=\"session.human.has_partnership_reporting_dashboard\" class=\"primary-nav-submenu-item\"><a href=\"https://partner.opendoor.com/reports\" target=\"_self\">Reporting Dashboard</a></li><li ng-show=\"session.human.has_partnership_referral_dashboard\" class=\"primary-nav-submenu-item\"><a href=\"https://partner.opendoor.com/referral-dashboard\" target=\"_self\">Referral Dashboard</a></li><li ng-show=\"session.human.has_partnership_developer_dashboard\" class=\"primary-nav-submenu-item\"><a href=\"https://partner.opendoor.com/developer\" target=\"_self\">Developer Dashboard</a></li><hr ng-show=\"session.human.is_partner_user\"><li class=\"primary-nav-submenu-item\"><a ui-sref=\"humans.account\">Account</a></li><li class=\"primary-nav-submenu-item\"><oc-login-link></oc-login-link></li></ul></li></ul></div></header>");;return buf.join("");
	}

/***/ },
/* 3480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	var _permit = __webpack_require__(3481);
	
	var _permit2 = _interopRequireDefault(_permit);
	
	__webpack_require__(3482);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.components.od-incrementor', []).component('odIncrementor', {
	  template: __webpack_require__(3484)(),
	  bindings: {
	    value: '=',
	    type: '@?',
	    min: '<?',
	    max: '<?',
	    increment: '<?'
	  },
	  controller: function () {
	    controller.$inject = ["weekdayWorkCalendar"];
	    function controller(weekdayWorkCalendar) {
	      _classCallCheck(this, controller);
	
	      this.TYPES = {
	        'number': {
	          plus: function plus(value, increment) {
	            return value + increment;
	          },
	          minus: function minus(value, increment) {
	            return value - increment;
	          },
	          lessOrEqual: function lessOrEqual(a, b) {
	            return a <= b;
	          }
	        },
	        'currency': {
	          plus: function plus(value, increment) {
	            return value + increment;
	          },
	          minus: function minus(value, increment) {
	            return value - increment;
	          },
	          lessOrEqual: function lessOrEqual(a, b) {
	            return a <= b;
	          }
	        },
	        'date': {
	          plus: function plus(value, increment) {
	            return value.clone().add(increment, 'days');
	          },
	          minus: function minus(value, increment) {
	            return value.clone().subtract(increment, 'days');
	          },
	          lessOrEqual: function lessOrEqual(a, b) {
	            return a.isSameOrBefore(b, 'days');
	          }
	        },
	        'work-date': {
	          plus: function plus(value, increment) {
	            return weekdayWorkCalendar.workdaysAfter(value, increment);
	          },
	          minus: function minus(value, increment) {
	            return weekdayWorkCalendar.workdaysBefore(value, increment);
	          },
	          lessOrEqual: function lessOrEqual(a, b) {
	            return a.isSameOrBefore(b, 'days');
	          }
	        }
	      };
	
	      this.type = (0, _permit2.default)(this.type, (0, _lodash.keys)(this.TYPES)) || 'number';
	      if (!(0, _lodash.isNumber)(this.increment)) {
	        this.increment = 1;
	      }
	    }
	
	    _createClass(controller, [{
	      key: 'minus',
	      value: function minus() {
	        var newValue = this.TYPES[this.type].minus(this.value, this.increment);
	        if ((0, _lodash.isUndefined)(this.min) || this.TYPES[this.type].lessOrEqual(this.min, newValue)) {
	          this.value = newValue;
	        }
	      }
	    }, {
	      key: 'plus',
	      value: function plus() {
	        var newValue = this.TYPES[this.type].plus(this.value, this.increment);
	        if ((0, _lodash.isUndefined)(this.max) || this.TYPES[this.type].lessOrEqual(newValue, this.max)) {
	          this.value = newValue;
	        }
	      }
	    }]);
	
	    return controller;
	  }()
	}).name;

/***/ },
/* 3481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (input, valid_inputs) {
	  return (0, _lodash.head)((0, _lodash.intersection)([input], valid_inputs)) || null;
	};
	
	var _lodash = __webpack_require__(412);

/***/ },
/* 3482 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3483);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-incrementor.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-incrementor.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3483 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}od-incrementor{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end}od-incrementor .minus-icon,od-incrementor .plus-icon{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#dedede;width:28px;height:28px;-webkit-border-radius:50%;border-radius:50%;-webkit-transition:all .15s ease-in-out;transition:all .15s ease-in-out}od-incrementor .minus-icon:hover,od-incrementor .plus-icon:hover{background-color:#1c85e8}od-incrementor .minus-icon{margin-left:1em}od-incrementor .plus-icon{margin-left:.5em}", ""]);
	
	// exports


/***/ },
/* 3484 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<p ng-switch=\"$ctrl.type\"><b ng-switch-when=\"currency\">{{$ctrl.value | currency}}</b><b ng-switch-when=\"date\">{{$ctrl.value | momentToDate | date}}</b><b ng-switch-when=\"work-date\">{{$ctrl.value | momentToDate | date}}</b><b ng-switch-default>{{$ctrl.value}}</b></p><icon name=\"minus-white\" ng-click=\"$ctrl.minus()\" class=\"minus-icon\"></icon><icon name=\"plus-white\" ng-click=\"$ctrl.plus()\" class=\"plus-icon\"></icon>");;return buf.join("");
	}

/***/ },
/* 3485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _odListingCard = __webpack_require__(3486);
	
	var _odListingCard2 = _interopRequireDefault(_odListingCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.components.od-listing-card', []).component('odListingCard', {
	  bindings: {
	    listing: '<'
	  },
	  template: __webpack_require__(3488)()
	}).name;

/***/ },
/* 3486 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3487);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-listing-card.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-listing-card.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3487 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}od-listing-card{display:block;font-size:14px;color:#525975}od-listing-card .listing-overlay-box{position:relative;padding:0;margin:0;width:100%}od-listing-card .listing-overlay-box .listing-overlay{position:absolute;bottom:0;width:100%;background-image:-webkit-gradient(linear, left bottom, left top, from(#000000), to(rgba(0,0,0,0)));background-image:-webkit-linear-gradient(bottom, #000000, rgba(0,0,0,0));background-image:linear-gradient(to top, #000000, rgba(0,0,0,0));color:#fff;text-shadow:0 1px 0 rgba(0,0,0,0.2)}od-listing-card .listing-overlay-box .listing-price{display:inline-block;padding:18px 0 18px 18px;font-size:18px;font-weight:500}od-listing-card .listing-overlay-box .label{float:right;padding:3px 6px;margin:18px 18px 18px 0;-webkit-box-shadow:none;box-shadow:none;font-size:10px;font-weight:500;text-transform:uppercase}od-listing-card .listing-card-info{padding:18px}od-listing-card .listing-card-info .listing-card-address{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-webkit-align-items:baseline;-ms-flex-align:baseline;align-items:baseline;-webkit-box-flex:0;-webkit-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-webkit-flex-shrink:1;-ms-flex-negative:1;flex-shrink:1;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;color:#1d2c4c;font-weight:500}od-listing-card .photo-carousel .photo-carousel-next,od-listing-card .photo-carousel .photo-carousel-prev{width:45px;height:45px}od-listing-card.teaser od-listing-status,od-listing-card.teaser .photo-carousel-prev,od-listing-card.teaser .photo-carousel-next{display:none}od-listing-card.teaser .listing-card-info>*{-webkit-filter:blur(4px);filter:blur(4px)}", ""]);
	
	// exports


/***/ },
/* 3488 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"card listing-card\"><div class=\"listing-overlay-box\"><od-carousel ng-if=\"$ctrl.listing.listing_photos.length\" class=\"photo-carousel listing-card-carousel\"><od-carousel-container class=\"photo-carousel-container\"><div od-carousel-item ng-style=\"{&quot;background-image&quot;: lazyLoad ? &quot;url(&quot; + photo.thumbnail_urls._760x480 + &quot;)&quot; : &quot;none&quot;}\" ng-class=\"{&quot;in-progress&quot;: !lazyLoad &amp;&amp; $parent.lazyLoad}\" ng-repeat=\"photo in $ctrl.listing.listing_photos\" class=\"photo-carousel-item lazy-photo image\"></div></od-carousel-container><div ng-click=\"carouselCtrl.prev($event)\" ng-show=\"carouselCtrl.currentPosition &gt; 0\" class=\"photo-carousel-prev\"><icon name=\"ei-chevron-left\"></icon></div><div ng-click=\"carouselCtrl.next($event)\" ng-show=\"carouselCtrl.currentPosition &lt; carouselCtrl.carouselItems.length - 1\" class=\"photo-carousel-next\"><icon name=\"ei-chevron-right\"></icon></div><div class=\"listing-overlay\"><div class=\"listing-price\">{{$ctrl.listing.price_cents | currency}}</div><span class=\"small\">&nbsp; {{$ctrl.listing.price_cents / $ctrl.listing.square_footage | currency}}/ft²</span><od-listing-status listing=\"$ctrl.listing\" show-active=\"false\"></od-listing-status></div></od-carousel></div><div class=\"card-body listing-card-info\"><div class=\"row\"><div class=\"col-xs-12 listing-card-address\">{{$ctrl.listing | listingDisplayAddress}}, {{$ctrl.listing.address.city}}</div></div><div class=\"row\"><div class=\"col-xs-12 listing-details\">{{$ctrl.listing.bedrooms}} bed\n{{$ctrl.listing.bathrooms}} bath ·\n{{$ctrl.listing.square_footage | number}} ft²</div></div></div></div>");;return buf.join("");
	}

/***/ },
/* 3489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _odListingCardMini = __webpack_require__(3490);
	
	var _odListingCardMini2 = _interopRequireDefault(_odListingCardMini);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.components.od-listing-card-mini', []).component('odListingCardMini', {
	  bindings: {
	    listing: '<'
	  },
	  template: __webpack_require__(3492)()
	}).name;

/***/ },
/* 3490 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3491);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-listing-card-mini.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-listing-card-mini.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3491 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}od-listing-card-mini{display:block;background:white;padding:12px}od-listing-card-mini .listing-card-container{padding:0 9px 0 0;height:150px;position:relative;color:#525975}od-listing-card-mini .listing-card-info{padding:14px 18px}od-listing-card-mini .listing-photo{height:150px;background-position:center;background-size:cover}od-listing-card-mini .listing-card-price{margin-top:.2em;color:#1d2c4c}od-listing-card-mini.teaser od-listing-status{display:none}od-listing-card-mini.teaser .listing-card-info>*{-webkit-filter:blur(4px);filter:blur(4px)}", ""]);
	
	// exports


/***/ },
/* 3492 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"listing-card-mini\"><od-listing-status listing=\"$ctrl.listing\" show-active=\"false\"></od-listing-status><div class=\"listing-card-container\"><div class=\"row\"><div class=\"col-xs-7\"><div ng-style=\"{&quot;background-image&quot;: &quot;url(&quot; + $ctrl.listing.listing_photos[0].thumbnail_urls._760x480 + &quot;)&quot;}\" class=\"listing-photo\"></div></div><div class=\"col-xs-5 end-xs listing-card-info text-left\"><div class=\"row\"><b>{{$ctrl.listing | listingDisplayAddress}}, {{$ctrl.listing.address.city}}</b></div><div class=\"row text-small\">{{$ctrl.listing.bedrooms}} bed\n{{$ctrl.listing.bathrooms}} bath\n{{$ctrl.listing.square_footage | number}} ft²</div><div class=\"row listing-card-price text-bold\">{{$ctrl.listing.price_cents | currency}}</div></div></div></div></div>");;return buf.join("");
	}

/***/ },
/* 3493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	var _filterParams = __webpack_require__(3494);
	
	var _filterParams2 = _interopRequireDefault(_filterParams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PRICE_OPTIONS = (0, _lodash.range)(10000000, 65000000, 5000000);
	var MIN_SQ_FT_OPTIONS = (0, _lodash.range)(1500, 4500, 500);
	
	module.exports = _angular2.default.module('market.components.od-listing-filter-form', []).component('odListingFilterForm', {
	  bindings: {
	    filters: '=?',
	    onFiltersChanged: '&'
	  },
	  template: __webpack_require__(3495)(),
	  controller: function () {
	    controller.$inject = ["Segment", "numberFilter"];
	    function controller(Segment, numberFilter) {
	      _classCallCheck(this, controller);
	
	      this.PRICE_OPTIONS = PRICE_OPTIONS;
	      this.MIN_SQ_FT_SELECT_OPTIONS = (0, _lodash.map)(MIN_SQ_FT_OPTIONS, function (sqFtOption) {
	        return {
	          value: sqFtOption,
	          label: numberFilter(sqFtOption) + ' sq ft'
	        };
	      });
	      this.Segment = Segment;
	    }
	
	    _createClass(controller, [{
	      key: 'applyFilters',
	      value: function applyFilters() {
	        var _this = this;
	
	        // Mark this as a user triggered search
	        this.filters.u = '1';
	        (0, _lodash.forEach)(this.filters, function (value, key) {
	          if (!value || value === '' || value === 'false') {
	            // value of undefined in state params clears that key from state altogether
	            _this.filters[key] = undefined;
	          }
	        });
	        this.onFiltersChanged();
	      }
	    }, {
	      key: 'clearFilters',
	      value: function clearFilters() {
	        var _this2 = this;
	
	        _filterParams2.default.forEach(function (param) {
	          _this2.filters[param] = undefined;
	        });
	        // Mark this as a user triggered search
	        this.filters.u = true;
	        this.filters['active'] = true;
	
	        this.onFiltersChanged();
	
	        this.Segment.track('filters.reset');
	      }
	    }]);
	
	    return controller;
	  }()
	}).name;

/***/ },
/* 3494 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ['active', 'community_pool_only', 'max_price', 'max_sq_ft', 'min_bathrooms', 'min_bedrooms', 'min_parking', 'min_price', 'min_sq_ft', 'pending', 'private_pool', 'sold', 'u', 'upcoming', 'north', 'east', 'south', 'west', 'fha_eligible', 'gated_community'];

/***/ },
/* 3495 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<form class=\"form\"><div class=\"row filter-row middle-xs\"><div class=\"col-xs-3\"><p><b>Price:</b></p></div><div class=\"col-xs-9 flex-value-container\"><select ng-model=\"$ctrl.filters.min_price\" ng-options=\"priceOption as (priceOption | currency) for priceOption in $ctrl.PRICE_OPTIONS\" ng-change=\"$ctrl.applyFilters()\" class=\"filter-dropdown\"><option value=\"\">No Min</option></select><p class=\"no-margin\">&nbsp; to &nbsp;</p><select ng-model=\"$ctrl.filters.max_price\" ng-options=\"priceOption as (priceOption | currency) for priceOption in $ctrl.PRICE_OPTIONS\" ng-change=\"$ctrl.applyFilters()\" class=\"filter-dropdown\"><option value=\"\">No Max</option></select></div></div><div class=\"row filter-row middle-xs\"><div class=\"col-xs-3\"><p><b>Bedrooms:</b></p></div><div class=\"col-xs-9 radio-btn-group\"><label ng-repeat=\"option in [1, 2, 3, 4]\" class=\"radio-btn\"><input name=\"min-beds\" type=\"radio\" ng-model=\"$ctrl.filters.min_bedrooms\" value=\"{{option}}\" ng-change=\"$ctrl.applyFilters()\"><span>{{option}}+</span></label></div></div><div class=\"row filter-row middle-xs\"><div class=\"col-xs-3\"><p><b>Bathrooms:</b></p></div><div class=\"col-xs-9 radio-btn-group\"><label ng-repeat=\"option in [1, 2, 3, 4]\" class=\"radio-btn\"><input name=\"min-baths\" type=\"radio\" ng-model=\"$ctrl.filters.min_bathrooms\" value=\"{{option}}\" ng-change=\"$ctrl.applyFilters()\"><span>{{option}}+</span></label></div></div><div class=\"row filter-row\"><div class=\"col-xs-3\"><p><b>Pool:</b></p></div><div class=\"col-xs-9 form-block\"><label class=\"checkbox\"><input type=\"checkbox\" ng-model=\"$ctrl.filters.community_pool_only\" ng-false-value=\"undefined\" ng-change=\"$ctrl.applyFilters()\"><span class=\"p-size-text\">Community only</span></label><label class=\"checkbox\"><input type=\"checkbox\" ng-model=\"$ctrl.filters.private_pool\" ng-false-value=\"undefined\" ng-change=\"$ctrl.applyFilters()\"><span class=\"p-size-text\">Private</span></label></div></div><div class=\"row filter-row middle-xs\"><div class=\"col-xs-3\"><p><b>Covered Parking:</b></p></div><div class=\"col-xs-9 radio-btn-group\"><label ng-repeat=\"option in [1, 2, 3, 4]\" class=\"radio-btn\"><input name=\"min-parking\" type=\"radio\" ng-model=\"$ctrl.filters.min_parking\" value=\"{{option}}\" ng-change=\"$ctrl.applyFilters()\"><span>{{option}}+</span></label></div></div><div class=\"row filter-row middle-xs\"><div class=\"col-xs-3\"><p><b>Mininum Square Feet:</b></p></div><div class=\"col-xs-4 flex-value-container\"><select ng-model=\"$ctrl.filters.min_sq_ft\" ng-options=\"sqFtOption.value as sqFtOption.label for sqFtOption in $ctrl.MIN_SQ_FT_SELECT_OPTIONS\" ng-change=\"$ctrl.applyFilters()\" class=\"filter-dropdown\"><option value=\"\">No Min</option></select></div></div><div class=\"row filter-row\"><div class=\"col-xs-3\"><p><b>Status:</b></p></div><div class=\"col-xs-9 form-block\"><label class=\"checkbox\"><input type=\"checkbox\" ng-model=\"$ctrl.filters.active\" ng-change=\"$ctrl.applyFilters()\"><span class=\"p-size-text\">For sale</span></label><label class=\"checkbox\"><input type=\"checkbox\" ng-model=\"$ctrl.filters.pending\" ng-change=\"$ctrl.applyFilters()\"><span class=\"p-size-text\">Pending</span></label><label class=\"checkbox\"><input type=\"checkbox\" ng-model=\"$ctrl.filters.sold\" ng-change=\"$ctrl.applyFilters()\"><span class=\"p-size-text\">Sold</span></label></div></div><div class=\"row filter-row middle-xs\"><div class=\"col-xs-6 col-xs-offset-3\"><button ng-click=\"$ctrl.clearFilters()\" class=\"button secondary smaller\">Reset filters</button></div></div></form>");;return buf.join("");
	}

/***/ },
/* 3496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.components.od-listing-status', []).directive('odListingStatus', function () {
	  return {
	    restrict: 'EA',
	    scope: {
	      listing: '=',
	      showActive: '='
	    },
	    template: __webpack_require__(3497)()
	  };
	}).name;

/***/ },
/* 3497 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div ng-if=\"listing.isActive() &amp;&amp; listing.isJustListed()\" class=\"label label-success\"><div class=\"card-label-heading\">Just listed</div></div><div ng-if=\"listing.isActive() &amp;&amp; !listing.isJustListed() &amp;&amp; showActive\" class=\"label label-success\"><div class=\"card-label-heading\">Active</div></div><div ng-if=\"listing.isPending()\" class=\"label label-info-dark\"><div class=\"card-label-heading\">Pending</div></div><div ng-if=\"listing.isSold()\" class=\"label label-info-dark\"><div class=\"card-label-heading\">Sold</div></div>");;return buf.join("");
	}

/***/ },
/* 3498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DELAY = 500;
	
	module.exports = _angular2.default.module('market.components.od-loading-text', []).component('odLoadingText', {
	  bindings: {
	    text: '@?'
	  },
	  template: __webpack_require__(3499)(),
	  controller: function () {
	    controller.$inject = ["$interval"];
	    function controller($interval) {
	      var _this = this;
	
	      _classCallCheck(this, controller);
	
	      this.$interval = $interval;
	
	      this.text = this.text || 'Loading';
	      this.dots = '.';
	
	      var count = 0;
	      var update = function update() {
	        count++;
	        _this.dots = (0, _lodash.repeat)('.', count % 3 + 1);
	      };
	
	      this.intervalPromise = this.$interval(update, DELAY);
	    }
	
	    _createClass(controller, [{
	      key: '$onDestroy',
	      value: function $onDestroy() {
	        this.$interval.cancel(this.intervalPromise);
	      }
	    }]);
	
	    return controller;
	  }()
	}).name;

/***/ },
/* 3499 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<span>{{$ctrl.text}}{{$ctrl.dots}}</span>");;return buf.join("");
	}

/***/ },
/* 3500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lory = __webpack_require__(3501);
	
	var _lodash = __webpack_require__(412);
	
	__webpack_require__(3502);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.components.od-lory-carousel', []).component('odLoryCarousel', {
	  bindings: {
	    photos: '<'
	  },
	  template: __webpack_require__(3504)(),
	  controller: function () {
	    controller.$inject = ["$element", "$timeout", "$mediaQuery"];
	    function controller($element, $timeout, $mediaQuery) {
	      _classCallCheck(this, controller);
	
	      this.$element = $element;
	      this.$timeout = $timeout;
	      this.$mediaQuery = $mediaQuery;
	      this.currentSlideNum = 1;
	      this.totalSlidesNum = 1;
	    }
	
	    _createClass(controller, [{
	      key: '$postLink',
	      value: function $postLink() {
	        var _this = this;
	
	        // Note this is to let Angular complete a run loop to render everything before calling Lory
	        this.$timeout(function () {
	          var numPhotosPerSlide = (0, _lodash.min)([3, _this.photos.length]);
	          if (!_this.$mediaQuery('gt-xs')) {
	            numPhotosPerSlide = 1;
	          }
	          (0, _lory.lory)(_this.$element[0], {
	            rewind: true,
	            rewindOnResize: false,
	            slidesToScroll: numPhotosPerSlide
	          });
	          _this.totalSlidesNum = (0, _lodash.ceil)(_this.photos.length / numPhotosPerSlide);
	
	          _this.$element[0].addEventListener('after.lory.slide', function (event) {
	            _this.$timeout(function () {
	              _this.currentSlideNum = (0, _lodash.ceil)((event.detail.currentSlide + 1) / numPhotosPerSlide);
	            });
	          });
	        });
	      }
	    }]);
	
	    return controller;
	  }()
	}).name;

/***/ },
/* 3501 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else {
			var a = factory();
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(typeof self !== 'undefined' ? self : this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 7);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* globals jQuery */
	
	exports.lory = lory;
	
	var _detectPrefixes = __webpack_require__(1);
	
	var _detectPrefixes2 = _interopRequireDefault(_detectPrefixes);
	
	var _detectSupportsPassive = __webpack_require__(2);
	
	var _detectSupportsPassive2 = _interopRequireDefault(_detectSupportsPassive);
	
	var _dispatchEvent = __webpack_require__(3);
	
	var _dispatchEvent2 = _interopRequireDefault(_dispatchEvent);
	
	var _defaults = __webpack_require__(6);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var slice = Array.prototype.slice;
	
	function lory(slider, opts) {
	    var position = void 0;
	    var slidesWidth = void 0;
	    var frameWidth = void 0;
	    var slides = void 0;
	
	    /**
	     * slider DOM elements
	     */
	    var frame = void 0;
	    var slideContainer = void 0;
	    var prevCtrl = void 0;
	    var nextCtrl = void 0;
	    var prefixes = void 0;
	    var transitionEndCallback = void 0;
	
	    var index = 0;
	    var options = {};
	    var touchEventParams = (0, _detectSupportsPassive2.default)() ? { passive: true } : false;
	
	    /**
	     * if object is jQuery convert to native DOM element
	     */
	    if (typeof jQuery !== 'undefined' && slider instanceof jQuery) {
	        slider = slider[0];
	    }
	
	    /**
	     * private
	     * set active class to element which is the current slide
	     */
	    function setActiveElement(slides, currentIndex) {
	        var _options = options,
	            classNameActiveSlide = _options.classNameActiveSlide;
	
	
	        slides.forEach(function (element, index) {
	            if (element.classList.contains(classNameActiveSlide)) {
	                element.classList.remove(classNameActiveSlide);
	            }
	        });
	
	        slides[currentIndex].classList.add(classNameActiveSlide);
	    }
	
	    /**
	     * private
	     * setupInfinite: function to setup if infinite is set
	     *
	     * @param  {array} slideArray
	     * @return {array} array of updated slideContainer elements
	     */
	    function setupInfinite(slideArray) {
	        var _options2 = options,
	            infinite = _options2.infinite;
	
	
	        var front = slideArray.slice(0, infinite);
	        var back = slideArray.slice(slideArray.length - infinite, slideArray.length);
	
	        front.forEach(function (element) {
	            var cloned = element.cloneNode(true);
	
	            slideContainer.appendChild(cloned);
	        });
	
	        back.reverse().forEach(function (element) {
	            var cloned = element.cloneNode(true);
	
	            slideContainer.insertBefore(cloned, slideContainer.firstChild);
	        });
	
	        slideContainer.addEventListener(prefixes.transitionEnd, onTransitionEnd);
	
	        return slice.call(slideContainer.children);
	    }
	
	    /**
	     * [dispatchSliderEvent description]
	     * @return {[type]} [description]
	     */
	    function dispatchSliderEvent(phase, type, detail) {
	        (0, _dispatchEvent2.default)(slider, phase + '.lory.' + type, detail);
	    }
	
	    /**
	     * translates to a given position in a given time in milliseconds
	     *
	     * @to        {number} number in pixels where to translate to
	     * @duration  {number} time in milliseconds for the transistion
	     * @ease      {string} easing css property
	     */
	    function translate(to, duration, ease) {
	        var style = slideContainer && slideContainer.style;
	
	        if (style) {
	            style[prefixes.transition + 'TimingFunction'] = ease;
	            style[prefixes.transition + 'Duration'] = duration + 'ms';
	            style[prefixes.transform] = 'translateX(' + to + 'px)';
	        }
	    }
	
	    /**
	     * returns an element's width
	     */
	    function elementWidth(element) {
	        return element.getBoundingClientRect().width || element.offsetWidth;
	    }
	
	    /**
	     * slidefunction called by prev, next & touchend
	     *
	     * determine nextIndex and slide to next postion
	     * under restrictions of the defined options
	     *
	     * @direction  {boolean}
	     */
	    function slide(nextIndex, direction) {
	        var _options3 = options,
	            slideSpeed = _options3.slideSpeed,
	            slidesToScroll = _options3.slidesToScroll,
	            infinite = _options3.infinite,
	            rewind = _options3.rewind,
	            rewindPrev = _options3.rewindPrev,
	            rewindSpeed = _options3.rewindSpeed,
	            ease = _options3.ease,
	            classNameActiveSlide = _options3.classNameActiveSlide,
	            _options3$classNameDi = _options3.classNameDisabledNextCtrl,
	            classNameDisabledNextCtrl = _options3$classNameDi === undefined ? 'disabled' : _options3$classNameDi,
	            _options3$classNameDi2 = _options3.classNameDisabledPrevCtrl,
	            classNameDisabledPrevCtrl = _options3$classNameDi2 === undefined ? 'disabled' : _options3$classNameDi2;
	
	
	        var duration = slideSpeed;
	
	        var nextSlide = direction ? index + 1 : index - 1;
	        var maxOffset = Math.round(slidesWidth - frameWidth);
	
	        dispatchSliderEvent('before', 'slide', {
	            index: index,
	            nextSlide: nextSlide
	        });
	
	        /**
	         * Reset control classes
	         */
	        if (prevCtrl) {
	            prevCtrl.classList.remove(classNameDisabledPrevCtrl);
	        }
	        if (nextCtrl) {
	            nextCtrl.classList.remove(classNameDisabledNextCtrl);
	        }
	
	        if (typeof nextIndex !== 'number') {
	            if (direction) {
	                if (infinite && index + infinite * 2 !== slides.length) {
	                    nextIndex = index + (infinite - index % infinite);
	                } else {
	                    nextIndex = index + slidesToScroll;
	                }
	            } else {
	                if (infinite && index % infinite !== 0) {
	                    nextIndex = index - index % infinite;
	                } else {
	                    nextIndex = index - slidesToScroll;
	                }
	            }
	        }
	
	        nextIndex = Math.min(Math.max(nextIndex, 0), slides.length - 1);
	
	        if (infinite && direction === undefined) {
	            nextIndex += infinite;
	        }
	
	        if (rewindPrev && Math.abs(position.x) === 0 && direction === false) {
	            nextIndex = slides.length - 1;
	            duration = rewindSpeed;
	        }
	
	        var nextOffset = Math.min(Math.max(slides[nextIndex].offsetLeft * -1, maxOffset * -1), 0);
	
	        if (rewind && Math.abs(position.x) === maxOffset && direction) {
	            nextOffset = 0;
	            nextIndex = 0;
	            duration = rewindSpeed;
	        }
	
	        /**
	         * translate to the nextOffset by a defined duration and ease function
	         */
	        translate(nextOffset, duration, ease);
	
	        /**
	         * update the position with the next position
	         */
	        position.x = nextOffset;
	
	        /**
	         * update the index with the nextIndex only if
	         * the offset of the nextIndex is in the range of the maxOffset
	         */
	        if (slides[nextIndex].offsetLeft <= maxOffset) {
	            index = nextIndex;
	        }
	
	        if (infinite && (nextIndex === slides.length - infinite || nextIndex === slides.length - slides.length % infinite || nextIndex === 0)) {
	            if (direction) {
	                index = infinite;
	            }
	
	            if (!direction) {
	                index = slides.length - infinite * 2;
	            }
	
	            position.x = slides[index].offsetLeft * -1;
	
	            transitionEndCallback = function transitionEndCallback() {
	                translate(slides[index].offsetLeft * -1, 0, undefined);
	            };
	        }
	
	        if (classNameActiveSlide) {
	            setActiveElement(slice.call(slides), index);
	        }
	
	        /**
	         * update classes for next and prev arrows
	         * based on user settings
	         */
	        if (prevCtrl && !infinite && !rewindPrev && nextIndex === 0) {
	            prevCtrl.classList.add(classNameDisabledPrevCtrl);
	        }
	
	        if (nextCtrl && !infinite && !rewind && nextIndex + 1 === slides.length) {
	            nextCtrl.classList.add(classNameDisabledNextCtrl);
	        }
	
	        dispatchSliderEvent('after', 'slide', {
	            currentSlide: index
	        });
	    }
	
	    /**
	     * public
	     * setup function
	     */
	    function setup() {
	        dispatchSliderEvent('before', 'init');
	
	        prefixes = (0, _detectPrefixes2.default)();
	        options = _extends({}, _defaults2.default, opts);
	
	        var _options4 = options,
	            classNameFrame = _options4.classNameFrame,
	            classNameSlideContainer = _options4.classNameSlideContainer,
	            classNamePrevCtrl = _options4.classNamePrevCtrl,
	            classNameNextCtrl = _options4.classNameNextCtrl,
	            _options4$classNameDi = _options4.classNameDisabledNextCtrl,
	            classNameDisabledNextCtrl = _options4$classNameDi === undefined ? 'disabled' : _options4$classNameDi,
	            _options4$classNameDi2 = _options4.classNameDisabledPrevCtrl,
	            classNameDisabledPrevCtrl = _options4$classNameDi2 === undefined ? 'disabled' : _options4$classNameDi2,
	            enableMouseEvents = _options4.enableMouseEvents,
	            classNameActiveSlide = _options4.classNameActiveSlide,
	            initialIndex = _options4.initialIndex;
	
	
	        index = initialIndex;
	        frame = slider.getElementsByClassName(classNameFrame)[0];
	        slideContainer = frame.getElementsByClassName(classNameSlideContainer)[0];
	        prevCtrl = slider.getElementsByClassName(classNamePrevCtrl)[0];
	        nextCtrl = slider.getElementsByClassName(classNameNextCtrl)[0];
	
	        position = {
	            x: slideContainer.offsetLeft,
	            y: slideContainer.offsetTop
	        };
	
	        if (options.infinite) {
	            slides = setupInfinite(slice.call(slideContainer.children));
	        } else {
	            slides = slice.call(slideContainer.children);
	
	            if (prevCtrl && !options.rewindPrev) {
	                prevCtrl.classList.add(classNameDisabledPrevCtrl);
	            }
	
	            if (nextCtrl && slides.length === 1 && !options.rewind) {
	                nextCtrl.classList.add(classNameDisabledNextCtrl);
	            }
	        }
	
	        reset();
	
	        if (classNameActiveSlide) {
	            setActiveElement(slides, index);
	        }
	
	        if (prevCtrl && nextCtrl) {
	            prevCtrl.addEventListener('click', prev);
	            nextCtrl.addEventListener('click', next);
	        }
	
	        frame.addEventListener('touchstart', onTouchstart, touchEventParams);
	
	        if (enableMouseEvents) {
	            frame.addEventListener('mousedown', onTouchstart);
	            frame.addEventListener('click', onClick);
	        }
	
	        options.window.addEventListener('resize', onResize);
	
	        dispatchSliderEvent('after', 'init');
	    }
	
	    /**
	     * public
	     * reset function: called on resize
	     */
	    function reset() {
	        var _options5 = options,
	            infinite = _options5.infinite,
	            ease = _options5.ease,
	            rewindSpeed = _options5.rewindSpeed,
	            rewindOnResize = _options5.rewindOnResize,
	            classNameActiveSlide = _options5.classNameActiveSlide,
	            initialIndex = _options5.initialIndex;
	
	
	        slidesWidth = elementWidth(slideContainer);
	        frameWidth = elementWidth(frame);
	
	        if (frameWidth === slidesWidth) {
	            slidesWidth = slides.reduce(function (previousValue, slide) {
	                return previousValue + elementWidth(slide);
	            }, 0);
	        }
	
	        if (rewindOnResize) {
	            index = initialIndex;
	        } else {
	            ease = null;
	            rewindSpeed = 0;
	        }
	
	        if (infinite) {
	            translate(slides[index + infinite].offsetLeft * -1, 0, null);
	
	            index = index + infinite;
	            position.x = slides[index].offsetLeft * -1;
	        } else {
	            translate(slides[index].offsetLeft * -1, rewindSpeed, ease);
	            position.x = slides[index].offsetLeft * -1;
	        }
	
	        if (classNameActiveSlide) {
	            setActiveElement(slice.call(slides), index);
	        }
	    }
	
	    /**
	     * public
	     * slideTo: called on clickhandler
	     */
	    function slideTo(index) {
	        slide(index);
	    }
	
	    /**
	     * public
	     * returnIndex function: called on clickhandler
	     */
	    function returnIndex() {
	        return index - options.infinite || 0;
	    }
	
	    /**
	     * public
	     * prev function: called on clickhandler
	     */
	    function prev() {
	        slide(false, false);
	    }
	
	    /**
	     * public
	     * next function: called on clickhandler
	     */
	    function next() {
	        slide(false, true);
	    }
	
	    /**
	     * public
	     * destroy function: called to gracefully destroy the lory instance
	     */
	    function destroy() {
	        dispatchSliderEvent('before', 'destroy');
	
	        // remove event listeners
	        frame.removeEventListener(prefixes.transitionEnd, onTransitionEnd);
	        frame.removeEventListener('touchstart', onTouchstart, touchEventParams);
	        frame.removeEventListener('touchmove', onTouchmove, touchEventParams);
	        frame.removeEventListener('touchend', onTouchend);
	        frame.removeEventListener('mousemove', onTouchmove);
	        frame.removeEventListener('mousedown', onTouchstart);
	        frame.removeEventListener('mouseup', onTouchend);
	        frame.removeEventListener('mouseleave', onTouchend);
	        frame.removeEventListener('click', onClick);
	
	        options.window.removeEventListener('resize', onResize);
	
	        if (prevCtrl) {
	            prevCtrl.removeEventListener('click', prev);
	        }
	
	        if (nextCtrl) {
	            nextCtrl.removeEventListener('click', next);
	        }
	
	        // remove cloned slides if infinite is set
	        if (options.infinite) {
	            Array.apply(null, Array(options.infinite)).forEach(function () {
	                slideContainer.removeChild(slideContainer.firstChild);
	                slideContainer.removeChild(slideContainer.lastChild);
	            });
	        }
	
	        dispatchSliderEvent('after', 'destroy');
	    }
	
	    // event handling
	
	    var touchOffset = void 0;
	    var delta = void 0;
	    var isScrolling = void 0;
	
	    function onTransitionEnd() {
	        if (transitionEndCallback) {
	            transitionEndCallback();
	
	            transitionEndCallback = undefined;
	        }
	    }
	
	    function onTouchstart(event) {
	        var _options6 = options,
	            enableMouseEvents = _options6.enableMouseEvents;
	
	        var touches = event.touches ? event.touches[0] : event;
	
	        if (enableMouseEvents) {
	            frame.addEventListener('mousemove', onTouchmove);
	            frame.addEventListener('mouseup', onTouchend);
	            frame.addEventListener('mouseleave', onTouchend);
	        }
	
	        frame.addEventListener('touchmove', onTouchmove, touchEventParams);
	        frame.addEventListener('touchend', onTouchend);
	
	        var pageX = touches.pageX,
	            pageY = touches.pageY;
	
	
	        touchOffset = {
	            x: pageX,
	            y: pageY,
	            time: Date.now()
	        };
	
	        isScrolling = undefined;
	
	        delta = {};
	
	        dispatchSliderEvent('on', 'touchstart', {
	            event: event
	        });
	    }
	
	    function onTouchmove(event) {
	        var touches = event.touches ? event.touches[0] : event;
	        var pageX = touches.pageX,
	            pageY = touches.pageY;
	
	
	        delta = {
	            x: pageX - touchOffset.x,
	            y: pageY - touchOffset.y
	        };
	
	        if (typeof isScrolling === 'undefined') {
	            isScrolling = !!(isScrolling || Math.abs(delta.x) < Math.abs(delta.y));
	        }
	
	        if (!isScrolling && touchOffset) {
	            translate(position.x + delta.x, 0, null);
	        }
	
	        // may be
	        dispatchSliderEvent('on', 'touchmove', {
	            event: event
	        });
	    }
	
	    function onTouchend(event) {
	        /**
	         * time between touchstart and touchend in milliseconds
	         * @duration {number}
	         */
	        var duration = touchOffset ? Date.now() - touchOffset.time : undefined;
	
	        /**
	         * is valid if:
	         *
	         * -> swipe attempt time is over 300 ms
	         * and
	         * -> swipe distance is greater than 25px
	         * or
	         * -> swipe distance is more then a third of the swipe area
	         *
	         * @isValidSlide {Boolean}
	         */
	        var isValid = Number(duration) < 300 && Math.abs(delta.x) > 25 || Math.abs(delta.x) > frameWidth / 3;
	
	        /**
	         * is out of bounds if:
	         *
	         * -> index is 0 and delta x is greater than 0
	         * or
	         * -> index is the last slide and delta is smaller than 0
	         *
	         * @isOutOfBounds {Boolean}
	         */
	        var isOutOfBounds = !index && delta.x > 0 || index === slides.length - 1 && delta.x < 0;
	
	        var direction = delta.x < 0;
	
	        if (!isScrolling) {
	            if (isValid && !isOutOfBounds) {
	                slide(false, direction);
	            } else {
	                translate(position.x, options.snapBackSpeed);
	            }
	        }
	
	        touchOffset = undefined;
	
	        /**
	         * remove eventlisteners after swipe attempt
	         */
	        frame.removeEventListener('touchmove', onTouchmove);
	        frame.removeEventListener('touchend', onTouchend);
	        frame.removeEventListener('mousemove', onTouchmove);
	        frame.removeEventListener('mouseup', onTouchend);
	        frame.removeEventListener('mouseleave', onTouchend);
	
	        dispatchSliderEvent('on', 'touchend', {
	            event: event
	        });
	    }
	
	    function onClick(event) {
	        if (delta.x) {
	            event.preventDefault();
	        }
	    }
	
	    function onResize(event) {
	        if (frameWidth !== elementWidth(frame)) {
	            reset();
	
	            dispatchSliderEvent('on', 'resize', {
	                event: event
	            });
	        }
	    }
	
	    // trigger initial setup
	    setup();
	
	    // expose public api
	    return {
	        setup: setup,
	        reset: reset,
	        slideTo: slideTo,
	        returnIndex: returnIndex,
	        prev: prev,
	        next: next,
	        destroy: destroy
	    };
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = detectPrefixes;
	/**
	 * Detecting prefixes for saving time and bytes
	 */
	function detectPrefixes() {
	    var transform = void 0;
	    var transition = void 0;
	    var transitionEnd = void 0;
	
	    (function () {
	        var el = document.createElement('_');
	        var style = el.style;
	
	        var prop = void 0;
	
	        if (style[prop = 'webkitTransition'] === '') {
	            transitionEnd = 'webkitTransitionEnd';
	            transition = prop;
	        }
	
	        if (style[prop = 'transition'] === '') {
	            transitionEnd = 'transitionend';
	            transition = prop;
	        }
	
	        if (style[prop = 'webkitTransform'] === '') {
	            transform = prop;
	        }
	
	        if (style[prop = 'msTransform'] === '') {
	            transform = prop;
	        }
	
	        if (style[prop = 'transform'] === '') {
	            transform = prop;
	        }
	
	        document.body.insertBefore(el, null);
	        style[transform] = 'translateX(0)';
	        document.body.removeChild(el);
	    })();
	
	    return {
	        transform: transform,
	        transition: transition,
	        transitionEnd: transitionEnd
	    };
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = detectSupportsPassive;
	function detectSupportsPassive() {
	    var supportsPassive = false;
	
	    try {
	        var opts = Object.defineProperty({}, 'passive', {
	            get: function get() {
	                supportsPassive = true;
	            }
	        });
	
	        window.addEventListener('testPassive', null, opts);
	        window.removeEventListener('testPassive', null, opts);
	    } catch (e) {}
	
	    return supportsPassive;
	}
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = dispatchEvent;
	
	var _customEvent = __webpack_require__(4);
	
	var _customEvent2 = _interopRequireDefault(_customEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * dispatch custom events
	 *
	 * @param  {element} el         slideshow element
	 * @param  {string}  type       custom event name
	 * @param  {object}  detail     custom detail information
	 */
	function dispatchEvent(target, type, detail) {
	    var event = new _customEvent2.default(type, {
	        bubbles: true,
	        cancelable: true,
	        detail: detail
	    });
	
	    target.dispatchEvent(event);
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(global) {
	var NativeCustomEvent = global.CustomEvent;
	
	function useNative () {
	  try {
	    var p = new NativeCustomEvent('cat', { detail: { foo: 'bar' } });
	    return  'cat' === p.type && 'bar' === p.detail.foo;
	  } catch (e) {
	  }
	  return false;
	}
	
	/**
	 * Cross-browser `CustomEvent` constructor.
	 *
	 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
	 *
	 * @public
	 */
	
	module.exports = useNative() ? NativeCustomEvent :
	
	// IE >= 9
	'undefined' !== typeof document && 'function' === typeof document.createEvent ? function CustomEvent (type, params) {
	  var e = document.createEvent('CustomEvent');
	  if (params) {
	    e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
	  } else {
	    e.initCustomEvent(type, false, false, void 0);
	  }
	  return e;
	} :
	
	// IE <= 8
	function CustomEvent (type, params) {
	  var e = document.createEventObject();
	  e.type = type;
	  if (params) {
	    e.bubbles = Boolean(params.bubbles);
	    e.cancelable = Boolean(params.cancelable);
	    e.detail = params.detail;
	  } else {
	    e.bubbles = false;
	    e.cancelable = false;
	    e.detail = void 0;
	  }
	  return e;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
	var g;
	
	// This works in non-strict mode
	g = (function() {
		return this;
	})();
	
	try {
		// This works if eval is allowed (see CSP)
		g = g || Function("return this")() || (1,eval)("this");
	} catch(e) {
		// This works if the window reference is available
		if(typeof window === "object")
			g = window;
	}
	
	// g can still be undefined, but nothing to do about it...
	// We return undefined, instead of nothing here, so it's
	// easier to handle this case. if(!global) { ...}
	
	module.exports = g;
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  /**
	   * slides scrolled at once
	   * @slidesToScroll {Number}
	   */
	  slidesToScroll: 1,
	
	  /**
	   * time in milliseconds for the animation of a valid slide attempt
	   * @slideSpeed {Number}
	   */
	  slideSpeed: 300,
	
	  /**
	   * time in milliseconds for the animation of the rewind after the last slide
	   * @rewindSpeed {Number}
	   */
	  rewindSpeed: 600,
	
	  /**
	   * time for the snapBack of the slider if the slide attempt was not valid
	   * @snapBackSpeed {Number}
	   */
	  snapBackSpeed: 200,
	
	  /**
	   * Basic easing functions: https://developer.mozilla.org/de/docs/Web/CSS/transition-timing-function
	   * cubic bezier easing functions: http://easings.net/de
	   * @ease {String}
	   */
	  ease: 'ease',
	
	  /**
	   * if slider reached the last slide, with next click the slider goes back to the startindex.
	   * use infinite or rewind, not both
	   * @rewind {Boolean}
	   */
	  rewind: false,
	
	  /**
	   * number of visible slides or false
	   * use infinite or rewind, not both
	   * @infinite {number}
	   */
	  infinite: false,
	
	  /**
	   * the slide index to show when the slider is initialized.
	   * @initialIndex {number}
	   */
	  initialIndex: 0,
	
	  /**
	   * class name for slider frame
	   * @classNameFrame {string}
	   */
	  classNameFrame: 'js_frame',
	
	  /**
	   * class name for slides container
	   * @classNameSlideContainer {string}
	   */
	  classNameSlideContainer: 'js_slides',
	
	  /**
	   * class name for slider prev control
	   * @classNamePrevCtrl {string}
	   */
	  classNamePrevCtrl: 'js_prev',
	
	  /**
	   * class name for slider next control
	   * @classNameNextCtrl {string}
	   */
	  classNameNextCtrl: 'js_next',
	
	  /**
	   * class name for current active slide
	   * if emptyString then no class is set
	   * @classNameActiveSlide {string}
	   */
	  classNameActiveSlide: 'active',
	
	  /**
	   * enables mouse events for swiping on desktop devices
	   * @enableMouseEvents {boolean}
	   */
	  enableMouseEvents: false,
	
	  /**
	   * window instance
	   * @window {object}
	   */
	  window: typeof window !== 'undefined' ? window : null,
	
	  /**
	   * If false, slides lory to the first slide on window resize.
	   * @rewindOnResize {boolean}
	   */
	  rewindOnResize: true
	};
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(0);
	
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 3502 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3503);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-lory-carousel.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-lory-carousel.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3503 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}od-lory-carousel .slider{width:100%;height:140px;position:relative;padding-left:40px;padding-right:40px;margin-left:-40px;-webkit-box-sizing:content-box;box-sizing:content-box}@media (max-width:767px){od-lory-carousel .slider{padding-left:25px;padding-right:25px;margin-left:-25px}}od-lory-carousel .frame{position:relative;overflow:hidden;white-space:nowrap}od-lory-carousel .slides{display:inline-block;width:100%}od-lory-carousel .carousel-slide{position:relative;display:inline-block;width:-webkit-calc(33.33333% - 10px);width:calc(33.33333% - 10px);height:140px;border-right:10px solid transparent;background-size:cover;background-position:center;background-repeat:no-repeat}@media (max-width:767px){od-lory-carousel .carousel-slide{width:100%;border-right:none}}od-lory-carousel .prev,od-lory-carousel .next{position:absolute;top:0;height:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;background-color:#fff;cursor:pointer}od-lory-carousel .prev .arrow-icon,od-lory-carousel .next .arrow-icon{width:40px}@media (max-width:767px){od-lory-carousel .prev .arrow-icon,od-lory-carousel .next .arrow-icon{width:25px}}od-lory-carousel .next{right:10px}@media (max-width:767px){od-lory-carousel .next{right:0}}od-lory-carousel .prev{left:0}od-lory-carousel .carousel-progress{margin-top:10px;font-weight:600}", ""]);
	
	// exports


/***/ },
/* 3504 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"slider js_slider\"><div class=\"frame js_frame\"><ul class=\"slides js_slides\"><li ng-repeat=\"photoUrl in $ctrl.photos\" ng-style=\"{ &quot;background-image&quot;: &quot;url(&quot; + photoUrl + &quot;)&quot; }\" class=\"carousel-slide js_slide\"></li></ul></div><div class=\"js_prev prev\"><icon name=\"ei-chevron-left\" class=\"arrow-icon\"></icon></div><div class=\"js_next next\"><icon name=\"ei-chevron-right\" class=\"arrow-icon\"></icon></div></div><div class=\"carousel-progress text-center text-small\">{{ $ctrl.currentSlideNum }} / {{ $ctrl.totalSlidesNum }}</div>");;return buf.join("");
	}

/***/ },
/* 3505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.components.od-brokerage-info', []).component('odBrokerageInfo', {
	  bindings: {
	    brokerage: '<'
	  },
	  template: __webpack_require__(3506)()
	}).name;

/***/ },
/* 3506 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"small-container text-center\"><p>List with a Partner Agent</p><p class=\"text-small\">If you select List with a Partner Agent, {{ $ctrl.brokerage.brokerage_name }} will recommend\na top local agent to work with you.</p></div>");;return buf.join("");
	}

/***/ },
/* 3507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(3508);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.components.od-press-coverage', []).component('odPressCoverage', {
	  template: __webpack_require__(3510)()
	}).name;

/***/ },
/* 3508 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3509);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-press-coverage.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-press-coverage.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3509 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}od-press-coverage .press-post{color:#525975;padding:0 24px}@media (max-width:991px){od-press-coverage .press-post{margin-bottom:36px}}od-press-coverage .press-logo{display:inline-block;height:20px;margin:10px 0 20px 0;opacity:.3}od-press-coverage .az-central{height:40px;margin:0 0 10px 0}", ""]);
	
	// exports


/***/ },
/* 3510 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"regular-container\"><div class=\"row\"><div class=\"col-xs-12 text-center\"><h4>Opendoor in the news</h4></div></div><div class=\"row large-margin-top\"><a href=\"http://blogs.wsj.com/venturecapital/2015/02/26/startup-opendoor-wants-to-buy-houses-that-are-for-sale/\" target=\"_blank\" class=\"col-xs-12 col-sm-4 text-center text-small press-post\"><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/wall-street-journal.svg?service=web\" class=\"press-logo\"><p class=\"text-italic\">\"Allows sellers to request offers in as little as three minutes\nand select their closing date if they like the price.\"</p></a><a href=\"https://www.forbes.com/sites/amyfeldman/2016/11/30/home-shopping-networkers-opendoor-is-upending-the-way-americans-buy-and-sell-homes/#22c35bfd430c/\" target=\"_blank\" class=\"col-xs-12 col-sm-4 text-center text-small press-post\"><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/forbes.svg?service=web\" class=\"press-logo forbes\"><p class=\"text-italic\">\"Opendoor is changing the way Americans buy and sell their homes.\"</p></a><a href=\"http://fortune.com/2016/03/09/opendoor-house-trade-in/\" target=\"_blank\" class=\"col-xs-12 col-sm-4 text-center text-small press-post\"><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/fortune.svg?service=web\" class=\"press-logo\"><p class=\"text-italic\">\"Opendoor mines public and private data to generate a fair offer\nprice within minutes of the seller’s online submission.\"</p></a></div></div>");;return buf.join("");
	}

/***/ },
/* 3511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.component.od-repair-item', []).directive('odRepairItem', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      item: '='
	    },
	    template: __webpack_require__(3512)()
	  };
	}).name;

/***/ },
/* 3512 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<h4 class=\"repair-item-title\">{{ item.name }}</h4><p>{{ item.description }}</p><h5 ng-if=\"item.opendoor_list\">Opendoor will cover:</h5><ul ng-if=\"item.opendoor_list\"><li ng-repeat=\"detail in item.opendoor_list\">{{ detail }}</li></ul><h5 ng-if=\"item.repair_credit_list\">Repair credits will cover:</h5><ul ng-if=\"item.repair_credit_list\"><li ng-repeat=\"detail in item.repair_credit_list\">{{ detail }}</li></ul>");;return buf.join("");
	}

/***/ },
/* 3513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(3514);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.component.od-signin', []).component('odSignin', {
	  template: __webpack_require__(3516)(),
	  bindings: {
	    email: '<?',
	    onLogin: '&?'
	  },
	  controller: function () {
	    controller.$inject = ["$rootScope", "Session"];
	    function controller($rootScope, Session) {
	      _classCallCheck(this, controller);
	
	      this.Session = Session;
	      this.session = $rootScope.session;
	    }
	
	    _createClass(controller, [{
	      key: 'login',
	      value: function login() {
	        var _this = this;
	
	        this.pending = true;
	        delete this.loginError;
	
	        var session = new this.Session({
	          human: {
	            email: this.email,
	            password: this.password,
	            remember_me: this.remember_me
	          }
	        });
	        session.$login().then(function (result) {
	          _this.pending = false;
	          _this.redirect = result.human && result.human.redirect_to || '/';
	          return _this.session.$me();
	        }).then(function (human) {
	          if (_this.onLogin) {
	            _this.onLogin({ human: human, redirect: _this.redirect });
	          } else {
	            window.location.href = _this.redirect;
	          }
	        }).catch(function () {
	          _this.pending = false;
	          _this.loginError = true;
	        });
	      }
	    }]);
	
	    return controller;
	  }()
	}).name;

/***/ },
/* 3514 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3515);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-signin.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-signin.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3515 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}od-signin .login-form{max-width:500px;margin:24px auto}od-signin .form-block{margin-top:24px;padding:0 18px}od-signin input{width:100%;margin-top:10px}", ""]);
	
	// exports


/***/ },
/* 3516 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<form name=\"loginForm\" ng-submit=\"$ctrl.login()\" class=\"login-form\"><div class=\"row\"><div class=\"form-block col-xs-12\"><b>Email address</b><br><input type=\"text\" ng-model=\"$ctrl.email\" placeholder=\"Your email\" ng-disabled=\"$ctrl.pending\" required><p ng-show=\"$ctrl.loginError\" class=\"text-red\">Invalid credentials</p></div></div><div class=\"row\"><div class=\"form-block col-xs-12\"><b>Password</b><br><input type=\"password\" ng-model=\"$ctrl.password\" placeholder=\"Password\" ng-disabled=\"$ctrl.pending\" required></div></div><div class=\"row\"><div class=\"form-block col-xs-12\"><b>Remember Me</b><br><input type=\"checkbox\" ng-model=\"$ctrl.remember_me\" ng-disabled=\"$ctrl.pending\"></div></div><div class=\"row\"><div class=\"form-block col-xs-12\"><button type=\"submit\" ng-disabled=\"loginForm.$invalid || $ctrl.pending\" class=\"button primary full-width\">Sign in</button></div></div><div class=\"row\"><div class=\"form-block col-xs-12\"><p class=\"text-small text-center\"><a href=\"/reset-password/new\" target=\"_self\">Forgot password?</a></p></div></div></form>");;return buf.join("");
	}

/***/ },
/* 3517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _odSignup = __webpack_require__(3518);
	
	var _odSignup2 = _interopRequireDefault(_odSignup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.component.od-signup', []).component('odSignup', {
	  template: __webpack_require__(3520)(),
	  bindings: {
	    signupType: '@', // Likely "buyer" or "seller"
	    onRegistrationComplete: '&',
	    // Override default behavior of button
	    onAlreadyHaveAccount: '&',
	    customerId: '<?',
	    // Pre-fill certain fields if desired
	    fullName: '<?',
	    email: '<?',
	    phoneNumber: '<?'
	  },
	  controller: function () {
	    controller.$inject = ["$rootScope", "$window", "Human", "$transclude", "Analytics"];
	    function controller($rootScope, $window, Human, $transclude, Analytics) {
	      _classCallCheck(this, controller);
	
	      this.$rootScope = $rootScope;
	      this.$window = $window;
	      this.Human = Human;
	      this.errors = {};
	      this.session = this.$rootScope.session;
	      this.Analytics = Analytics;
	
	      if (this.session.human) {
	        this.onRegistrationComplete({ wasLoggedIn: true });
	      }
	
	      this.password = '';
	      this.pending = false;
	    }
	
	    _createClass(controller, [{
	      key: 'register',
	      value: function register() {
	        var _this = this;
	
	        this.pending = true;
	        var newHuman = new this.Human({
	          full_name: this.fullName,
	          email: this.email,
	          primary_phone: this.phoneNumber,
	          password: this.password,
	          signup_type: this.signupType
	        });
	        newHuman.$register().then(function () {
	          _this.Analytics.event('signup', 'submit', 'signup-success');
	          _this.pending = false;
	          // Fetch the latest login information
	          _this.session.$me().then(function () {
	            _this.onRegistrationComplete({ wasLoggedIn: false });
	          });
	        }).catch(function (e) {
	          _this.Analytics.event('signup', 'submit', 'signup-error');
	          _this.pending = false;
	          _this.errors = e.data.errors;
	        });
	      }
	    }]);
	
	    return controller;
	  }()
	}).name;

/***/ },
/* 3518 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3519);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-signup.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-signup.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3519 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}od-signup{display:block}od-signup .registration-form{padding-left:48px;padding-right:48px}od-signup .registration-form input,od-signup .registration-form button{width:100%}od-signup .form-block{margin-top:24px;padding:0 18px}od-signup .login-link{color:#9ba1a6}od-signup .login-link a{color:#1c85e8}", ""]);
	
	// exports


/***/ },
/* 3520 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<form name=\"registrationForm\" ng-submit=\"$ctrl.register()\" class=\"registration-form\"><div class=\"row\"><div class=\"form-block col-md-6 col-xs-12\"><p>Your name</p><input type=\"text\" ng-model=\"$ctrl.fullName\" ng-disabled=\"$ctrl.pending\" required></div><div class=\"form-block col-md-6 col-xs-12\"><p>Email</p><input type=\"text\" ng-model=\"$ctrl.email\" ng-disabled=\"$ctrl.pending\" required><p ng-show=\"$ctrl.errors.email\" class=\"text-red\">Email {{$ctrl.errors.email[0]}}</p></div></div><div class=\"row\"><div class=\"form-block col-md-6 col-xs-12\"><p>Phone</p><input type=\"tel\" ng-model=\"$ctrl.phoneNumber\" ng-disabled=\"$ctrl.pending\" required><p ng-show=\"$ctrl.errors.primary_phone\" class=\"text-red\">Phone {{$ctrl.errors.primary_phone[0]}}</p></div><div class=\"form-block col-md-6 col-xs-12\"><p>Create a password</p><input type=\"password\" ng-model=\"$ctrl.password\" ng-disabled=\"$ctrl.pending\" required><p ng-show=\"$ctrl.errors.password\" class=\"text-red\">Password {{$ctrl.errors.password[0]}}</p></div></div><div class=\"row\"><div class=\"form-block col-md-6 col-xs-12 login-link\">Already have an account?&nbsp;<a ng-if=\"!$ctrl.onAlreadyHaveAccount\" ui-sref=\"humans.login\">Sign in</a><a ng-click=\"$ctrl.onAlreadyHaveAccount()\" ng-if=\"$ctrl.onAlreadyHaveAccount\" ng-href=\"#\">Sign in</a></div><div class=\"form-block col-md-3 col-md-offset-3 col-xs-12\"><button type=\"submit\" ng-disabled=\"registrationForm.$invalid || $ctrl.pending\" ng-class=\"{ 'is-loading': $ctrl.pending }\" class=\"submit cursor-pointer\">Sign up</button></div></div></form>");;return buf.join("");
	}

/***/ },
/* 3521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// The sticky container/element structure lets you define an element that will
	// follow you as you scroll down the page, but which will stop at top/bottom
	// breakpoints.
	//
	// To use it, define two divs: od-sticky-container, and od-sticky-element
	// inside it.  od-sticky-element will assume the width of od-sticky-container,
	// and will start at the top of the container. As you scroll it will follow
	// you, until it hits the bottom of od-sticky-container and stops there (until
	// you scroll back up).
	module.exports = _angular2.default.module('market.components.od-sticky-element', []).directive('odStickyContainer', function () {
	  OdStickyContainer.$inject = ["$element", "$window"];
	  function OdStickyContainer($element, $window) {
	    this.$element = $element;
	    this.$window = $window;
	  }
	
	  OdStickyContainer.prototype.getTop = function () {
	    return this.$element.prop('offsetTop') + Number(this.$element.css('paddingTop'));
	  };
	
	  OdStickyContainer.prototype.getBottom = function () {
	    return this.getTop() + this.$element.prop('offsetHeight');
	  };
	
	  OdStickyContainer.prototype.getWidth = function () {
	    var style = this.$window.getComputedStyle(this.$element[0]);
	    return parseInt(style.width) - parseInt(style.paddingLeft) - parseInt(style.paddingRight);
	  };
	
	  return {
	    restrict: 'EA',
	    controller: OdStickyContainer
	  };
	}).directive('odStickyElement', ["$window", function ($window) {
	  return {
	    restrict: 'EA',
	    require: '^odStickyContainer',
	    link: function link(scope, elem, attrs, odStickyContainer) {
	      // Safari will return auto unless the element is positioned
	      elem.css('position', 'relative');
	      var marginTop = parseInt($window.getComputedStyle(elem[0]).top) || 0;
	      elem.css('position', null);
	      var windowEl = _angular2.default.element($window);
	
	      var throttledOnScroll = (0, _lodash.throttle)(onScroll, 10);
	      var throttledOnWindowResize = (0, _lodash.throttle)(onWindowResize, 100);
	
	      windowEl.on('scroll', throttledOnScroll);
	      windowEl.on('resize', throttledOnWindowResize);
	
	      scope.$on('$destroy', function () {
	        windowEl.off('scroll', throttledOnScroll);
	        windowEl.off('resize', throttledOnWindowResize);
	      });
	
	      // Initialize the sticky element with the correct width
	      setElementWidthToContainerWidth();
	
	      function onWindowResize() {
	        setElementWidthToContainerWidth();
	        recalculateStickyPlacement();
	      }
	
	      function onScroll() {
	        recalculateStickyPlacement();
	      }
	
	      // Set the width of the stickyElement to the width of the container.
	      // We need to do this because we use "position: fixed" in sticky mode.
	      function setElementWidthToContainerWidth() {
	        elem.css('width', odStickyContainer.getWidth() + 'px');
	      }
	
	      // Check scroll position to see whether the sticky element should be
	      // at the top of its container, following the user's scroll, or at
	      // the bottom of the container. Set classes accordingly.
	      function recalculateStickyPlacement() {
	        var scrollY = $window.scrollY + marginTop;
	        if (scrollY < odStickyContainer.getTop()) {
	          elem.addClass('top');
	          elem.removeClass('sticky');
	          elem.removeClass('bottom');
	        } else if (scrollY + elem.prop('offsetHeight') > odStickyContainer.getBottom()) {
	          elem.removeClass('top');
	          elem.removeClass('sticky');
	          elem.addClass('bottom');
	        } else {
	          elem.removeClass('top');
	          elem.addClass('sticky');
	          elem.removeClass('bottom');
	        }
	      }
	    }
	  };
	}]).name;

/***/ },
/* 3522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(3523);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.components.od-story-card-mini', []).component('odStoryCardMini', {
	  template: __webpack_require__(3525)(),
	  transclude: {
	    title: 'odStoryCardMiniTitle',
	    subtitle: 'odStoryCardMiniSubtitle',
	    linkText: 'odStoryCardMiniLinkText'
	  },
	  bindings: {
	    imageSrc: '@',
	    href: '@'
	  }
	}).name;

/***/ },
/* 3523 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3524);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-story-card-mini.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/less-loader/lib/loader.js!./od-story-card-mini.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3524 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}od-story-card-mini{display:block}od-story-card-mini .story-box{background:#fff;-webkit-box-shadow:0 0 15px rgba(0,0,0,0.1);box-shadow:0 0 15px rgba(0,0,0,0.1);-webkit-transition:all ease .3s;transition:all ease .3s;cursor:pointer;-webkit-backface-visibility:hidden;backface-visibility:hidden}od-story-card-mini .story-box:hover{-webkit-box-shadow:0 15px 45px rgba(0,0,0,0.2);box-shadow:0 15px 45px rgba(0,0,0,0.2)}od-story-card-mini .story-box:hover .story-image{-webkit-transform:scale(1.1);transform:scale(1.1)}od-story-card-mini .image-container{overflow:hidden;height:280px}@media (max-width:1199px){od-story-card-mini .image-container{height:220px}}od-story-card-mini .story-image{-webkit-transition:all ease .3s;transition:all ease .3s}od-story-card-mini .story-box-infos{padding:36px}@media (max-width:991px){od-story-card-mini .story-box-infos{padding:30px}}od-story-card-mini .title{color:#1d2c4c;font-size:28px;font-family:'Publico',serif;font-weight:600;line-height:1.3}@media (max-width:991px){od-story-card-mini .title{font-size:20px}}od-story-card-mini .subtitle{margin:18px 0;color:#525975;opacity:.5}", ""]);
	
	// exports


/***/ },
/* 3525 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"story-box text-center\"><div class=\"image-container\"><img src=\"{{$ctrl.imageSrc}}\" class=\"story-image fluid-width-img\"></div><div class=\"story-box-infos\"><p ng-transclude=\"title\" class=\"title\"></p><div ng-transclude=\"subtitle\" class=\"subtitle text-small\"></div><a ng-href=\"{{$ctrl.href}}\" target=\"_self\" ng-transclude=\"linkText\"></a></div></div>");;return buf.join("");
	}

/***/ },
/* 3526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.controllers', [__webpack_require__(3527)]).name;

/***/ },
/* 3527 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module("market.controllers.humans", []).controller("humans.passwords.edit", ["$scope", "Segment", function ($scope, Segment) {
	  var root = document.querySelector("[ng-controller='humans.passwords.edit']");
	  var canReset = !!root && root.getAttribute("data-can-reset") === "true";
	  var pageName = canReset ? "new-password" : "expired-password-token";
	
	  // Track the page view
	  Segment.page("reset-password", pageName);
	  Segment.track("page-view", {
	    path: location.pathname.slice(1),
	    pathname: location.pathname,
	    resource: "web",
	    domain: location.host
	  });
	
	  // Track if the user submitted the form and was redirected back to this
	  // page with an error
	  var errorContainer = !!root && root.querySelector(".error-message");
	  var errorMessage = !!errorContainer && errorContainer.innerHTML;
	  if (errorMessage) {
	    Segment.track("reset-password", { errorMessage: errorMessage });
	  }
	
	  // Track requests for a new reset-password link
	  $scope.trackRequestNewLink = function () {
	    Segment.track("reset-password", { action: "request new link" });
	  };
	
	  // Track new password form submissions
	  $scope.trackSubmitNewPassword = function () {
	    Segment.track("reset-password", { action: "submit new password" });
	  };
	}]).name;

/***/ },
/* 3528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.deprecated', [__webpack_require__(3529), __webpack_require__(3530)]).name;

/***/ },
/* 3529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.directives.neighborhood-map', []).directive('obNeighborhoodMap', function () {
	  return {
	    restrict: 'C',
	    scope: {
	      pinTitle: '@',
	      pinLat: '@',
	      pinLon: '@'
	    },
	    link: function link(scope, elem) {
	      // Public token; meant to be exposed. URL restrictions are in the Mapbox admin panel.
	      L.mapbox.accessToken = 'pk.eyJ1Ijoib3BlbmRvb3IiLCJhIjoiY21tNDNwdmE4MDZsaDJvcG4zYXE4c254NyJ9.5PjzJ7pYIrbodyh1USA5ag'; // eslint-disable-line max-len
	      L.mapbox.config.FORCE_HTTPS = true;
	      var map = L.mapbox.map(elem[0], 'opendoor.lo70f83n', {
	        attributionControl: { compact: true },
	        doubleClickZoom: false,
	        dragging: false,
	        scrollWheelZoom: false,
	        tap: false,
	        touchZoom: false,
	        zoomControl: false
	      });
	
	      if (scope.pinLat && scope.pinLon) {
	        L.marker([scope.pinLat, scope.pinLon], { title: scope.pinTitle, alt: scope.pinTitle }).addTo(map); // eslint-disable-line max-len
	        map.setView([scope.pinLat, scope.pinLon], 16);
	      }
	    }
	  };
	}).name; /* global L:false */

/***/ },
/* 3530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO(azirbel): Do we use this anymore? Can it be deleted?
	
	module.exports = _angular2.default.module('market.directives.od-headline', []).directive('odHeadline', ["$location", "$sce", "Analytics", function odHeadline($location, $sce, Analytics) {
	  var HEADLINES = {
	    sold: '<b>Sold.</b> The minute you’re ready.',
	    cash_today: 'Get a <b>cash offer</b> today.',
	    market_prices: 'We make cash offers at <b>market prices</b>.',
	    worth: 'What is my home worth?',
	    unneeded_realtor: 'You don’t need a realtor.',
	    sans_realtor: 'Sell your house without a realtor.',
	    sans_agent: 'Sell your house without an agent.',
	    sell_today: 'Sell your home <b>today</b>.',
	    best_by_owner: 'The <b>best way</b> to sell by owner.',
	    best_your_house: 'The <b>best way</b> to sell your house.'
	  };
	
	  var DIRECT_HEADLINES = ['sold' //, 'worth', 'sell_today', 'best_by_owner', 'best_your_house'
	  ];
	
	  return {
	    // TODO(azirbel): Make this either a component (EA) or directive (A)
	    // For now, assuming it's a directive
	    restrict: 'C',
	    link: function link(scope, elem) {
	      var x_headline = $location.search().x_headline;
	
	      if (!HEADLINES.hasOwnProperty(x_headline)) x_headline = (0, _lodash.sample)(DIRECT_HEADLINES);
	      if (!HEADLINES.hasOwnProperty(x_headline)) x_headline = (0, _lodash.keys)(HEADLINES)[0];
	
	      elem.html($sce.trustAsHtml(HEADLINES[x_headline]));
	
	      Analytics.register({ x_headline: x_headline });
	    }
	  };
	}]).name;

/***/ },
/* 3531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.directives', [__webpack_require__(3532), __webpack_require__(3533), __webpack_require__(3535), __webpack_require__(3536), __webpack_require__(3537), __webpack_require__(3538)]).name;

/***/ },
/* 3532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function odAnchorScrollOffsetFromAncestors($document) {
	  var el = $document[0].querySelector('*[od-anchor-scroll-offset]');
	  return _angular2.default.element(el).controller('odAnchorScrollOffset') || { getOffset: function getOffset() {
	      return 0;
	    } };
	}
	
	// Define the offset for scrolling based on an element's position (such as a
	// position: fixed nav or subnav).
	module.exports = _angular2.default.module('market.directives.od-anchor-scroll', []).directive('odAnchorScrollOffset', function () {
	  return {
	    restrict: 'A',
	    scope: {},
	    controller: ["$scope", function controller($scope) {
	      this.getOffset = function () {
	        return $scope.offset;
	      };
	    }],
	    link: function link(scope, element, attrs) {
	      var side = attrs.odAnchorScrollOffset || 'bottom';
	      scope.offset = element[0].getBoundingClientRect()[side];
	    }
	  };
	})
	
	// from duScroll.smoothScroll
	.directive('odAnchorScroll', ["$document", function ($document) {
	  return {
	    restrict: 'A',
	    require: '?^odAnchorScrollOffset',
	    link: function link(scope, element, attrs, odAnchorScrollOffset) {
	      if (!attrs.href || attrs.href.indexOf('#') === -1) return;
	
	      if (!odAnchorScrollOffset) odAnchorScrollOffset = odAnchorScrollOffsetFromAncestors($document);
	      var offset = odAnchorScrollOffset.getOffset();
	
	      var id = attrs.href.replace(/.*(?=#[^\s]+$)/, '').substring(1),
	          target = $document[0].getElementById(id);
	
	      element.on('click', function (e) {
	        target = target || $document[0].getElementById(id);
	        if (!target || !target.getBoundingClientRect) return;
	
	        offset = offset || odAnchorScrollOffset.getOffset();
	
	        if (e.stopPropagation) e.stopPropagation();
	        if (e.preventDefault) e.preventDefault();
	
	        $document.scrollTo(_angular2.default.element(target), offset, 300);
	      });
	    }
	  };
	}]).name;

/***/ },
/* 3533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _mailcheck = __webpack_require__(3534);
	
	var _mailcheck2 = _interopRequireDefault(_mailcheck);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.directives.od-mailcheck', []).directive('odMailcheck', function odMailcheck() {
	  if (typeof _mailcheck2.default === 'undefined') {
	    console.warn('od-mailcheck requires the Mailcheck library.');
	    return {};
	  }
	
	  _mailcheck2.default.defaultTopLevelDomains = ["com", "net", "org", "info", "edu"];
	  _mailcheck2.default.defaultDomains = ["yahoo.com", "google.com", "hotmail.com", "gmail.com", "me.com", "aol.com", "mac.com", "live.com", "comcast.net", "googlemail.com", "msn.com", "facebook.com", "verizon.net", "sbcglobal.net", "att.net", "mail.com", "outlook.com", "icloud.com", "cox.net"];
	
	  var BLACKLISTED_TLDS = ['como', 'comp', 'con', 'met', 'ner', 'vom'];
	
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function link(scope, element, attrs, ngModel) {
	      scope.$watch(attrs.ngModel, function (email) {
	        _mailcheck2.default.run({
	          email: email,
	          suggested: function suggested(suggestion) {
	            scope.$eval(attrs.odMailcheck + '=' + JSON.stringify(suggestion.full));
	          },
	          empty: function empty() {
	            scope.$eval(attrs.odMailcheck + '=null');
	          }
	        });
	
	        if (email && ngModel) {
	          var tokens = email.split('.');
	          var tld = tokens[tokens.length - 1];
	          var valid = !(0, _lodash.includes)(BLACKLISTED_TLDS, tld);
	          ngModel.$setValidity('blacklisting-tld', valid);
	        }
	      });
	    }
	  };
	}).name;

/***/ },
/* 3534 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Mailcheck https://github.com/mailcheck/mailcheck
	 * Author
	 * Derrick Ko (@derrickko)
	 *
	 * Released under the MIT License.
	 *
	 * v 1.1.1
	 */
	
	var Mailcheck = {
	  domainThreshold: 2,
	  secondLevelThreshold: 2,
	  topLevelThreshold: 2,
	
	  defaultDomains: ['msn.com', 'bellsouth.net',
	    'telus.net', 'comcast.net', 'optusnet.com.au',
	    'earthlink.net', 'qq.com', 'sky.com', 'icloud.com',
	    'mac.com', 'sympatico.ca', 'googlemail.com',
	    'att.net', 'xtra.co.nz', 'web.de',
	    'cox.net', 'gmail.com', 'ymail.com',
	    'aim.com', 'rogers.com', 'verizon.net',
	    'rocketmail.com', 'google.com', 'optonline.net',
	    'sbcglobal.net', 'aol.com', 'me.com', 'btinternet.com',
	    'charter.net', 'shaw.ca'],
	
	  defaultSecondLevelDomains: ["yahoo", "hotmail", "mail", "live", "outlook", "gmx"],
	
	  defaultTopLevelDomains: ["com", "com.au", "com.tw", "ca", "co.nz", "co.uk", "de",
	    "fr", "it", "ru", "net", "org", "edu", "gov", "jp", "nl", "kr", "se", "eu",
	    "ie", "co.il", "us", "at", "be", "dk", "hk", "es", "gr", "ch", "no", "cz",
	    "in", "net", "net.au", "info", "biz", "mil", "co.jp", "sg", "hu"],
	
	  run: function(opts) {
	    opts.domains = opts.domains || Mailcheck.defaultDomains;
	    opts.secondLevelDomains = opts.secondLevelDomains || Mailcheck.defaultSecondLevelDomains;
	    opts.topLevelDomains = opts.topLevelDomains || Mailcheck.defaultTopLevelDomains;
	    opts.distanceFunction = opts.distanceFunction || Mailcheck.sift3Distance;
	
	    var defaultCallback = function(result){ return result };
	    var suggestedCallback = opts.suggested || defaultCallback;
	    var emptyCallback = opts.empty || defaultCallback;
	
	    var result = Mailcheck.suggest(Mailcheck.encodeEmail(opts.email), opts.domains, opts.secondLevelDomains, opts.topLevelDomains, opts.distanceFunction);
	
	    return result ? suggestedCallback(result) : emptyCallback()
	  },
	
	  suggest: function(email, domains, secondLevelDomains, topLevelDomains, distanceFunction) {
	    email = email.toLowerCase();
	
	    var emailParts = this.splitEmail(email);
	
	    if (secondLevelDomains && topLevelDomains) {
	        // If the email is a valid 2nd-level + top-level, do not suggest anything.
	        if (secondLevelDomains.indexOf(emailParts.secondLevelDomain) !== -1 && topLevelDomains.indexOf(emailParts.topLevelDomain) !== -1) {
	            return false;
	        }
	    }
	
	    var closestDomain = this.findClosestDomain(emailParts.domain, domains, distanceFunction, this.domainThreshold);
	
	    if (closestDomain) {
	      if (closestDomain == emailParts.domain) {
	        // The email address exactly matches one of the supplied domains; do not return a suggestion.
	        return false;
	      } else {
	        // The email address closely matches one of the supplied domains; return a suggestion
	        return { address: emailParts.address, domain: closestDomain, full: emailParts.address + "@" + closestDomain };
	      }
	    }
	
	    // The email address does not closely match one of the supplied domains
	    var closestSecondLevelDomain = this.findClosestDomain(emailParts.secondLevelDomain, secondLevelDomains, distanceFunction, this.secondLevelThreshold);
	    var closestTopLevelDomain    = this.findClosestDomain(emailParts.topLevelDomain, topLevelDomains, distanceFunction, this.topLevelThreshold);
	
	    if (emailParts.domain) {
	      var closestDomain = emailParts.domain;
	      var rtrn = false;
	
	      if(closestSecondLevelDomain && closestSecondLevelDomain != emailParts.secondLevelDomain) {
	        // The email address may have a mispelled second-level domain; return a suggestion
	        closestDomain = closestDomain.replace(emailParts.secondLevelDomain, closestSecondLevelDomain);
	        rtrn = true;
	      }
	
	      if(closestTopLevelDomain && closestTopLevelDomain != emailParts.topLevelDomain) {
	        // The email address may have a mispelled top-level domain; return a suggestion
	        closestDomain = closestDomain.replace(emailParts.topLevelDomain, closestTopLevelDomain);
	        rtrn = true;
	      }
	
	      if (rtrn == true) {
	        return { address: emailParts.address, domain: closestDomain, full: emailParts.address + "@" + closestDomain };
	      }
	    }
	
	    /* The email address exactly matches one of the supplied domains, does not closely
	     * match any domain and does not appear to simply have a mispelled top-level domain,
	     * or is an invalid email address; do not return a suggestion.
	     */
	    return false;
	  },
	
	  findClosestDomain: function(domain, domains, distanceFunction, threshold) {
	    threshold = threshold || this.topLevelThreshold;
	    var dist;
	    var minDist = 99;
	    var closestDomain = null;
	
	    if (!domain || !domains) {
	      return false;
	    }
	    if(!distanceFunction) {
	      distanceFunction = this.sift3Distance;
	    }
	
	    for (var i = 0; i < domains.length; i++) {
	      if (domain === domains[i]) {
	        return domain;
	      }
	      dist = distanceFunction(domain, domains[i]);
	      if (dist < minDist) {
	        minDist = dist;
	        closestDomain = domains[i];
	      }
	    }
	
	    if (minDist <= threshold && closestDomain !== null) {
	      return closestDomain;
	    } else {
	      return false;
	    }
	  },
	
	  sift3Distance: function(s1, s2) {
	    // sift3: http://siderite.blogspot.com/2007/04/super-fast-and-accurate-string-distance.html
	    if (s1 == null || s1.length === 0) {
	      if (s2 == null || s2.length === 0) {
	        return 0;
	      } else {
	        return s2.length;
	      }
	    }
	
	    if (s2 == null || s2.length === 0) {
	      return s1.length;
	    }
	
	    var c = 0;
	    var offset1 = 0;
	    var offset2 = 0;
	    var lcs = 0;
	    var maxOffset = 5;
	
	    while ((c + offset1 < s1.length) && (c + offset2 < s2.length)) {
	      if (s1.charAt(c + offset1) == s2.charAt(c + offset2)) {
	        lcs++;
	      } else {
	        offset1 = 0;
	        offset2 = 0;
	        for (var i = 0; i < maxOffset; i++) {
	          if ((c + i < s1.length) && (s1.charAt(c + i) == s2.charAt(c))) {
	            offset1 = i;
	            break;
	          }
	          if ((c + i < s2.length) && (s1.charAt(c) == s2.charAt(c + i))) {
	            offset2 = i;
	            break;
	          }
	        }
	      }
	      c++;
	    }
	    return (s1.length + s2.length) /2 - lcs;
	  },
	
	  splitEmail: function(email) {
	    var parts = email.trim().split('@');
	
	    if (parts.length < 2) {
	      return false;
	    }
	
	    for (var i = 0; i < parts.length; i++) {
	      if (parts[i] === '') {
	        return false;
	      }
	    }
	
	    var domain = parts.pop();
	    var domainParts = domain.split('.');
	    var sld = '';
	    var tld = '';
	
	    if (domainParts.length == 0) {
	      // The address does not have a top-level domain
	      return false;
	    } else if (domainParts.length == 1) {
	      // The address has only a top-level domain (valid under RFC)
	      tld = domainParts[0];
	    } else {
	      // The address has a domain and a top-level domain
	      sld = domainParts[0];
	      for (var i = 1; i < domainParts.length; i++) {
	        tld += domainParts[i] + '.';
	      }
	      tld = tld.substring(0, tld.length - 1);
	    }
	
	    return {
	      topLevelDomain: tld,
	      secondLevelDomain: sld,
	      domain: domain,
	      address: parts.join('@')
	    }
	  },
	
	  // Encode the email address to prevent XSS but leave in valid
	  // characters, following this official spec:
	  // http://en.wikipedia.org/wiki/Email_address#Syntax
	  encodeEmail: function(email) {
	    var result = encodeURI(email);
	    result = result.replace('%20', ' ').replace('%25', '%').replace('%5E', '^')
	                   .replace('%60', '`').replace('%7B', '{').replace('%7C', '|')
	                   .replace('%7D', '}');
	    return result;
	  }
	};
	
	// Export the mailcheck object if we're in a CommonJS env (e.g. Node).
	// Modeled off of Underscore.js.
	if (typeof module !== 'undefined' && module.exports) {
	    module.exports = Mailcheck;
	}
	
	// Support AMD style definitions
	// Based on jQuery (see http://stackoverflow.com/a/17954882/1322410)
	if (true) {
	  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return Mailcheck;
	  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	if (typeof window !== 'undefined' && window.jQuery) {
	  (function($){
	    $.fn.mailcheck = function(opts) {
	      var self = this;
	      if (opts.suggested) {
	        var oldSuggested = opts.suggested;
	        opts.suggested = function(result) {
	          oldSuggested(self, result);
	        };
	      }
	
	      if (opts.empty) {
	        var oldEmpty = opts.empty;
	        opts.empty = function() {
	          oldEmpty.call(null, self);
	        };
	      }
	
	      opts.email = this.val();
	      Mailcheck.run(opts);
	    }
	  })(jQuery);
	}


/***/ },
/* 3535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.directives.od-map', []).directive('odMap', function () {
	  if (typeof google === 'undefined' || !google.maps) {
	    console.warn('od-map requires Google Maps JavaScript API.');
	    return {};
	  }
	
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attrs) {
	      scope.$watch(attrs.odMap, function (address) {
	        if (!address) return;
	
	        var center = new google.maps.LatLng(address.latitude, address.longitude),
	            map = new google.maps.Map(element[0], {
	          center: center,
	          disableDoubleClickZoom: true,
	          draggable: false,
	          scrollwheel: false,
	          streetViewControl: false,
	          mapTypeControl: false,
	          zoomControl: false,
	          zoom: 15
	        });
	        new google.maps.Marker({ position: center, map: map });
	      });
	    }
	  };
	}).name; /* global google:false */

/***/ },
/* 3536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.directives.od-scroll-enter', []).directive('odScrollEnter', ["$window", "$document", "$animate", "$timeout", function ($window, $document, $animate, $timeout) {
	  var scrollY = function scrollY() {
	    return $window.pageYOffset;
	  };
	
	  // IE support
	  if ($window.pageYOffset === undefined) {
	    scrollY = function scrollY() {
	      return ($document.documentElement || $document.body).scrollTop;
	    };
	  }
	
	  return {
	    restrict: 'A',
	    link: function link(scope, element) {
	      var top = void 0;
	      var throttledCalculateTop = (0, _lodash.throttle)(calculateTop, 100, { leading: false });
	      var throttledScroll = (0, _lodash.throttle)(onScroll, 100, { leading: false });
	      var viewport = _angular2.default.element($window);
	
	      $timeout(calculateTop);
	      $timeout(onScroll);
	
	      viewport.on('resize', throttledCalculateTop);
	      viewport.on('scroll', throttledScroll);
	      scope.$on('$destroy', function () {
	        viewport.off('resize', throttledCalculateTop);
	        viewport.off('scroll', throttledScroll);
	      });
	
	      function calculateTop() {
	        var offsetTopRelativeToBody = element[0].getBoundingClientRect().top + scrollY();
	        top = offsetTopRelativeToBody + element.css('paddingTop');
	      }
	
	      function onScroll() {
	        if (scrollY() + $window.innerHeight > top) {
	          _angular2.default.element($window).off('scroll', throttledScroll);
	          $animate.addClass(element, 'scrolled');
	          if (!scope.$$phase) scope.$digest();
	        }
	      }
	    }
	  };
	}]).name;

/***/ },
/* 3537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.directives.od-splash-map', []).directive('odSplashMap', function () {
	  if (typeof google === 'undefined' || !google.maps) {
	    console.warn('od-splash-map requires Google Maps JavaScript API.');
	    return {};
	  }
	
	  var mapStyles = [{
	    'stylers': [{
	      'color': '#1c85e8'
	    }]
	  }, {
	    'elementType': 'labels',
	    'stylers': [{
	      'visibility': 'off'
	    }]
	  }, {
	    'featureType': 'poi',
	    'stylers': [{
	      'color': '#3291eb'
	    }]
	  }, {
	    'featureType': 'water',
	    'stylers': [{
	      'color': '#0064c2'
	    }]
	  }, {
	    'featureType': 'road',
	    'stylers': [{
	      'color': '#0064c2'
	    }]
	  }];
	
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attrs) {
	      scope.$watch(attrs.odSplashMap, function (address) {
	        if (!address) return;
	
	        var center = new google.maps.LatLng(address.latitude, address.longitude);
	        new google.maps.Map(element[0], {
	          center: center,
	          gestureHandling: 'none',
	          disableDefaultUI: true,
	          disableDoubleClickZoom: true,
	          scrollwheel: false,
	          streetViewControl: false,
	          mapTypeControl: false,
	          zoomControl: false,
	          zoom: 11,
	          styles: mapStyles
	        });
	      });
	    }
	  };
	}).name; /* global google:false */

/***/ },
/* 3538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //
	//    Havin' side scrolling problems? I feel bad for you, son.
	//    This code's got 99 problems but side-scrolling ain't one.
	//
	// It'll create a side-scrolling area within your div, and provide a helpful
	// hint for your less side-scroll-savvy users!
	//
	// Use this directive INSTEAD OF overflow-x:scroll.
	//
	// NOTE: This is some awful UI. Try to not use side-scrolling next time!
	//
	// NOTE 2: This isn't a component. It's a true directive, providing hacks and
	//         doing weird things with JS and HTML.
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.side-scroll-hint', []).directive('sideScrollHint', ["$window", function ($window) {
	  return {
	    restrict: 'A',
	    bindToController: true,
	    controllerAs: 'directiveCtrl',
	    controller: function () {
	      controller.$inject = ["$element"];
	      function controller($element) {
	        _classCallCheck(this, controller);
	
	        var container = $element[0].querySelector('.side-scroll-hint-container');
	        this.scrollContainerEl = _angular2.default.element(container);
	        this.scrollTowardRight = true;
	      }
	
	      _createClass(controller, [{
	        key: 'getElementWidth',
	        value: function getElementWidth(el) {
	          return parseInt($window.getComputedStyle(el).width);
	        }
	      }, {
	        key: 'showMore',
	        value: function showMore() {
	          var _this = this;
	
	          var scrollLeftInitial = this.scrollContainerEl.scrollLeft();
	          this.scrollContainerEl.scrollTo(scrollLeftInitial + 400, 0, 500).then(function () {
	            var scrollLeft = _this.scrollContainerEl.scrollLeft();
	
	            var containerWidth = _this.getElementWidth(_this.scrollContainerEl[0]);
	
	            // We can't calculate this in the construtor because ng-transclude
	            // hasn't finished setup yet, and things aren't rendered yet either
	            var contentWidth = _this.scrollContainerEl[0].scrollWidth;
	
	            // Not sure why the off-by-one error happens
	            if (containerWidth + scrollLeft + 1 >= contentWidth) {
	              _this.scrollTowardRight = false;
	            }
	          });
	        }
	      }, {
	        key: 'backToStart',
	        value: function backToStart() {
	          this.scrollContainerEl.scrollTo(0, 0, 500);
	          this.scrollTowardRight = true;
	        }
	      }]);
	
	      return controller;
	    }(),
	    template: __webpack_require__(3539)(),
	    transclude: true
	  };
	}]).name;

/***/ },
/* 3539 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div ng-show=\"directiveCtrl.scrollTowardRight\" ng-click=\"directiveCtrl.showMore()\" class=\"side-scroll-hint\">More →</div><div ng-hide=\"directiveCtrl.scrollTowardRight\" ng-click=\"directiveCtrl.backToStart()\" class=\"side-scroll-hint\">← Back</div><div class=\"side-scroll-hint-container\"><ng-transclude></ng-transclude></div>");;return buf.join("");
	}

/***/ },
/* 3540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Used in both the styleguide and angular tests.
	
	module.exports = _angular2.default.module('market.mocks', [__webpack_require__(3541)]).name;

/***/ },
/* 3541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _momentTimezone = __webpack_require__(517);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LISTING_MOCK = {
	  "id": 238,
	  "bathrooms": 3,
	  "bedrooms": 4,
	  "display_state": "pending",
	  "price_cents": 21500000,
	  "list_date": "2015-09-14",
	  "lonlat": "POINT (-112.39215776324272 33.598430220476835)",
	  "slug": "12552-N-154th-Ave-Surprise-AZ-85379",
	  "square_footage": 2028,
	  "view_count": 1620,
	  "visit_count": 88,
	  "address": {
	    "id": 23167,
	    "street": "12552 N 154th Ave",
	    "street1": "12552 N 154th Ave",
	    "unit": null,
	    "state": "AZ",
	    "city": "Surprise",
	    "postal_code": "85379",
	    "apn": "50146254",
	    "latitude": "33.598401",
	    "longitude": "-112.392154",
	    "leads_count": 8,
	    "created_at": "2015-08-16T10:32:43.026-07:00",
	    "market": {
	      "id": 1,
	      "active": true,
	      "identifier": "phoenix",
	      "name": "Phoenix"
	    }
	  },
	  "listing_photos": [{
	    "id": 24392,
	    "thumbnail_urls": {
	      "_204x144": "https://d1k0cb7ed4to50.cloudfront.net/KrBdNNmIoHuasxOP3myApaPWDJ0=/204x144/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24392.jpg", // eslint-disable-line max-len
	      "_204x164": "https://d1k0cb7ed4to50.cloudfront.net/GdXHp5CtUZOL0KqzU-93Sf8yZdg=/204x164/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24392.jpg", // eslint-disable-line max-len
	      "_760x480": "https://d1k0cb7ed4to50.cloudfront.net/RjHlK1hfuZJZm8HqvEP1xxsM314=/760x480/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24392.jpg", // eslint-disable-line max-len
	      "_1800x1200": "https://d1k0cb7ed4to50.cloudfront.net/7EGleHQQZrtMd3snobx4Ze0VRu0=/1800x1200/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24392.jpg" // eslint-disable-line max-len
	    },
	    "photo_url": "https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24392.jpg", // eslint-disable-line max-len
	    "position": 0,
	    "picable_type": "Listing",
	    "picable_id": 238
	  }, {
	    "id": 24415,
	    "thumbnail_urls": {
	      "_204x144": "https://d1k0cb7ed4to50.cloudfront.net/bgpbZlaRpIQXTSGDUMBUR_6T314=/204x144/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24415.jpg", // eslint-disable-line max-len
	      "_204x164": "https://d1k0cb7ed4to50.cloudfront.net/pfQ3W7NbKVVgTsHW4krRclGcj7w=/204x164/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24415.jpg", // eslint-disable-line max-len
	      "_760x480": "https://d1k0cb7ed4to50.cloudfront.net/dgmMLRVb5t48RsAczFTw3Eg3BRg=/760x480/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24415.jpg", // eslint-disable-line max-len
	      "_1800x1200": "https://d1k0cb7ed4to50.cloudfront.net/8iveHGsfmUI5qQZA3RluamqnT8I=/1800x1200/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24415.jpg" // eslint-disable-line max-len
	    },
	    "photo_url": "https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24415.jpg", // eslint-disable-line max-len
	    "position": 1,
	    "picable_type": "Listing",
	    "picable_id": 238
	  }, {
	    "id": 24393,
	    "thumbnail_urls": {
	      "_204x144": "https://d1k0cb7ed4to50.cloudfront.net/OJSRrwYjVX3wwUmei6ZYj-CeK3Y=/204x144/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24393.jpg", // eslint-disable-line max-len
	      "_204x164": "https://d1k0cb7ed4to50.cloudfront.net/l-oCqs7N5A9BCUAatnZ6b3l1vEM=/204x164/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24393.jpg", // eslint-disable-line max-len
	      "_760x480": "https://d1k0cb7ed4to50.cloudfront.net/1PnMMzEYlws1wmyh1YbmOOXpIz0=/760x480/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24393.jpg", // eslint-disable-line max-len
	      "_1800x1200": "https://d1k0cb7ed4to50.cloudfront.net/p7t11vcKIlXgxArZPJhueHCXEBc=/1800x1200/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24393.jpg" // eslint-disable-line max-len
	    },
	    "photo_url": "https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24393.jpg", // eslint-disable-line max-len
	    "position": 2,
	    "picable_type": "Listing",
	    "picable_id": 238
	  }]
	};
	
	var upcomingListing = (0, _lodash.cloneDeep)(LISTING_MOCK);
	upcomingListing.display_state = "upcoming";
	upcomingListing.list_date = (0, _momentTimezone2.default)().add(2, 'days').format("YYYY-MM-DD");
	
	module.exports = _angular2.default.module('market.mocks.listing', []).value('listingMock', LISTING_MOCK).value('upcomingListingMock', upcomingListing).name;

/***/ },
/* 3542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.models', [__webpack_require__(3543), __webpack_require__(3544), __webpack_require__(3545), __webpack_require__(3546), __webpack_require__(3547), __webpack_require__(3548), __webpack_require__(3549), __webpack_require__(3550), __webpack_require__(3551)]).name;

/***/ },
/* 3543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.models.agent-referral', []).factory('AgentReferral', ["odResource", function (odResource) {
	  return odResource('/api/v1/agent-referrals');
	}]).name;

/***/ },
/* 3544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.models.home-condition-report', []).factory('HomeConditionReport', ["$resource", function ($resource) {
	  return $resource('/api/v1/home_condition_reports/:id', { id: '@id' });
	}]).name;

/***/ },
/* 3545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.models.lead', []).factory('Lead', ["$resource", function ($resource) {
	  return $resource('/api/v1/leads/:id/:path', { id: '@token' }, {
	    track: {
	      method: 'GET',
	      url: '/track'
	    }
	  });
	}]).name;

/***/ },
/* 3546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _momentTimezone = __webpack_require__(517);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.models.listing', []).factory('Listing', ["$resource", "$http", function ($resource, $http) {
	  var Listing = $resource('/api/v1/listings/:slug/:path', { slug: '@slug', path: '@path' }, {
	    ordered: {
	      isArray: true,
	      method: 'GET',
	      url: '/api/v1/listings/ordered_listings'
	    },
	    visited: {
	      isArray: true,
	      method: 'GET',
	      url: '/api/v1/listings/visited'
	    }
	  });
	
	  Listing.listingCounts = function () {
	    return $http.get('/api/v1/listings/count').then(function (response) {
	      return response.data;
	    }).catch(function () {
	      return { active: 42 };
	    }); // why not?
	  };
	
	  Listing.prototype.directSavingsCents = function () {
	    if (this.direct_price_cents > 0) {
	      return this.price_cents - this.direct_price_cents;
	    }
	    return 0;
	  };
	
	  Listing.prototype.isJustListed = function () {
	    if (!this.list_date) {
	      return false;
	    }
	    return (0, _momentTimezone2.default)(this.list_date).add(7, 'days').isAfter((0, _momentTimezone2.default)().startOf('day'));
	  };
	
	  Listing.prototype.isActive = function () {
	    return this.display_state === 'active';
	  };
	
	  Listing.prototype.isPending = function () {
	    return this.display_state === 'pending';
	  };
	
	  Listing.prototype.isSold = function () {
	    return this.display_state === 'sold';
	  };
	
	  Listing.prototype.isUpcoming = function () {
	    return this.display_state === 'upcoming';
	  };
	
	  Listing.prototype.listsInTheFuture = function () {
	    return this.upcoming_at != null && new Date(this.upcoming_at) > new Date();
	  };
	
	  return Listing;
	}]).name;

/***/ },
/* 3547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.models.listing-geo-json', []).factory('ListingGeoJson', ["$resource", function ($resource) {
	  return $resource('/api/v1/listings/geo', {}, {
	    query: {
	      isArray: false
	    }
	  });
	}]).name;

/***/ },
/* 3548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.models.listing-interest', []).factory('ListingInterest', ["$resource", function ($resource) {
	  return $resource('/api/v1/listings/:listing_slug/interests/:id', {
	    id: '@id',
	    listing_slug: '@listing_slug'
	  }, {
	    update: {
	      method: 'PUT'
	    }
	  });
	}]).name;

/***/ },
/* 3549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.models.listing-offer', []).factory('ListingOffer', ["$resource", function ($resource) {
	  var ListingOffer = $resource('/api/v1/listing_offers/:id', { id: '@id' }, {
	    claimListingOfferByToken: {
	      method: 'POST',
	      url: '/api/v1/listing_offers/claim_listing_offer_by_token'
	    }
	  });
	  return ListingOffer;
	}]).name;

/***/ },
/* 3550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.models.workOrder', []).factory('WorkOrder', ["odResource", function (odResource) {
	  return odResource('/api/v1/work_orders/:path', { reference_number: '@reference_number' }, {
	    get: {
	      url: '/api/v1/work_orders/:reference_number',
	      method: 'GET'
	    },
	    for_home_condition_report: {
	      url: '/api/v1/work_orders/for_home_condition_report',
	      method: 'GET',
	      isArray: true
	    }
	  });
	}]).name;

/***/ },
/* 3551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.models.vendor-question', []).factory('VendorQuestion', ["$resource", function ($resource) {
	  return $resource('/api/v1/vendor_questions/:id', { id: '@id' }, {
	    save: {
	      method: 'POST',
	      toast: {
	        success: 'Message submitted',
	        error: 'Failed to submit message'
	      }
	    }
	  });
	}]).name;

/***/ },
/* 3552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.routes', [__webpack_require__(600), __webpack_require__(3553), __webpack_require__(3554), __webpack_require__(3565), __webpack_require__(3567), __webpack_require__(3568), __webpack_require__(3569), __webpack_require__(3571), __webpack_require__(3572), __webpack_require__(3601), __webpack_require__(3606), __webpack_require__(3608), __webpack_require__(3610), __webpack_require__(3620)]).config(["$stateProvider", "ngMetaProvider", function ($stateProvider, ngMetaProvider) {
	  $stateProvider.decorator('data', ngMetaProvider.mergeNestedStateData);
	  ngMetaProvider.setDefaultTitle('Opendoor');
	  ngMetaProvider.setDefaultTag('description', 'Opendoor makes you a free offer on your home today, so you can sell on your schedule.');
	  ngMetaProvider.useTitleSuffix(true);
	  $stateProvider.state('root', {
	    url: '',
	    abstract: true,
	    views: {
	      '@': { template: '<div ui-view></div>' },
	      'header@': {}, // keep using the default header rendered by rails
	      'header_xs_down@': {}, // keep using the default header rendered by rails
	      'footer@': {}, // keep using the default footer rendered by rails
	      'footer_xs_down@': {} // keep using the default footer rendered by rails
	    },
	    resolve: {
	      // this ensures any controller who accesses $rootScope.session will have a resolved
	      // session before that router is run.
	      resolveCurrentSession: ["$rootScope", function resolveCurrentSession($rootScope) {
	        return $rootScope.session.$promise;
	      }]
	    }
	  });
	}]).name;

/***/ },
/* 3553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.routes.dashboard', [__webpack_require__(600), __webpack_require__(3550)]).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('dashboard', {
	    parent: 'root',
	    url: '/dashboard',
	    abstract: true,
	    template: '<div ui-view></div>'
	  });
	
	  $stateProvider.state('dashboard.work_order', {
	    url: '/work-orders/:referenceNumber',
	    resolve: {
	      workOrder: ["WorkOrder", "$stateParams", function babelWorkOrderResolve(WorkOrder, $stateParams) {
	        return WorkOrder.get({ reference_number: $stateParams.referenceNumber }).$promise.catch(function () {
	          return undefined;
	        });
	      }]
	    },
	    views: {
	      'header@': {
	        template: '<div></div>' // disable the header
	      },
	      'footer@': {
	        template: '<div></div>' // disable the footer
	      },
	      '': {
	        templateUrl: '/templates/market/dashboard/work_orders/show.html',
	        controllerAs: 'work_order_ctrl',
	        controller: function () {
	          controller.$inject = ["$scope", "workOrder"];
	          function controller($scope, workOrder) {
	            _classCallCheck(this, controller);
	
	            this.workOrder = workOrder;
	            this.vendor = this.workOrder ? this.workOrder.vendor : null;
	          }
	
	          _createClass(controller, [{
	            key: 'displayDescription',
	            value: function displayDescription(item) {
	              var desc = item.public_description || item.revised_description || item.description;
	              return (0, _lodash.replace)(desc, item.label + ':', '');
	            }
	          }]);
	
	          return controller;
	        }()
	      }
	    }
	  });
	
	  $stateProvider.state('dashboard.work_orders_for_home_condition_report', {
	    url: '/work_orders_for_home_condition_report/:hcr_id',
	    views: {
	      'header@': {
	        template: '<div></div>' // disable the header
	      },
	      'footer@': {
	        template: '<div></div>' // disable the footer
	      },
	      '': {
	        templateUrl: '/templates/market/dashboard/work_orders/for_home_condition_report.html',
	        controllerAs: 'work_order_hcr_ctrl',
	        controller: function () {
	          controller.$inject = ["$scope", "$stateParams", "WorkOrder"];
	          function controller($scope, $stateParams, WorkOrder) {
	            _classCallCheck(this, controller);
	
	            this.workOrders = WorkOrder.for_home_condition_report({ hcr_id: $stateParams.hcr_id });
	          }
	
	          _createClass(controller, [{
	            key: 'displayDescription',
	            value: function displayDescription(item) {
	              var desc = item.public_description || item.revised_description || item.description;
	              return (0, _lodash.replace)(desc, item.label + ':', '');
	            }
	          }]);
	
	          return controller;
	        }()
	      }
	    }
	  });
	}]).name;

/***/ },
/* 3554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.routes.humans', [__webpack_require__(3555), __webpack_require__(3559), __webpack_require__(3561)]).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('humans', {
	    parent: 'root',
	    abstract: true,
	    views: {
	      '': {
	        template: '<div ui-view></div>'
	      },
	      'footer@': { template: '<div></div>' // disable footer
	      } }
	  });
	}]).name;

/***/ },
/* 3555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(3556);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.routes.humans.account', [__webpack_require__(600)]).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('humans.account', {
	    url: '/account',
	    template: __webpack_require__(3558)(),
	    controllerAs: 'accountCtrl',
	    controller: function () {
	      controller.$inject = ["$rootScope", "$window"];
	      function controller($rootScope, $window) {
	        _classCallCheck(this, controller);
	
	        this.session = $rootScope.session;
	
	        if (!this.session.human || !this.session.human.id) {
	          $window.location.href = '/login';
	        }
	      }
	
	      _createClass(controller, [{
	        key: 'remoteSignOut',
	        value: function remoteSignOut() {
	          var _this = this;
	
	          this.pending = true;
	          this.session.human.$remoteSignOut().then(function () {
	            _this.pending = false;
	            _this.success = true;
	            // Reload the page now that you signed out
	            location.reload();
	          }).catch(function (response) {
	            _this.pending = false;
	            if (response.status === 401) {
	              _this.errors = { current_password: true };
	            } else if (response.status === 422) {
	              _this.errors = response.data;
	            }
	          });
	        }
	      }, {
	        key: 'update',
	        value: function update() {
	          var _this2 = this;
	
	          this.pending = true;
	          delete this.errors;
	          delete this.success;
	
	          this.session.human.$update().then(function () {
	            _this2.pending = false;
	            _this2.success = true;
	          }).catch(function (response) {
	            _this2.pending = false;
	
	            if (response.status === 401) {
	              _this2.errors = { current_password: true };
	            } else if (response.status === 422) {
	              _this2.errors = response.data;
	            }
	          });
	        }
	      }]);
	
	      return controller;
	    }()
	  });
	}]).name;

/***/ },
/* 3556 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3557);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/less-loader/lib/loader.js!./account.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/less-loader/lib/loader.js!./account.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3557 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}.route-account .account-form{max-width:800px;margin:24px auto;padding-left:48px;padding-right:48px}.route-account .form-block{margin-top:24px;padding:0 18px}.route-account input{width:100%}.route-account .submit{width:100px;float:right}", ""]);
	
	// exports


/***/ },
/* 3558 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"route-account\"><section class=\"extra-padding\"><container><div class=\"prose\"><form name=\"accountForm\" ng-submit=\"accountCtrl.update()\" class=\"account-form\"><h2>Edit account</h2><div class=\"row\"><div class=\"form-block col-md-6 col-xs-12\"><p>Your name</p><input type=\"text\" ng-model=\"accountCtrl.session.human.full_name\" ng-disabled=\"accountCtrl.pending\" required></div><div class=\"form-block col-md-6 col-xs-12\"><p>Email</p><input type=\"text\" ng-model=\"accountCtrl.session.human.email\" ng-disabled=\"accountCtrl.pending\" required><p ng-show=\"accountCtrl.errors.email\" class=\"text-red\">Email {{accountCtrl.errors.email[0]}}</p></div></div><div class=\"row\"><div class=\"form-block col-md-6 col-xs-12\"><p>Change password (optional)</p><input type=\"password\" ng-model=\"accountCtrl.session.human.password\" ng-disabled=\"accountCtrl.pending\"><p ng-show=\"accountCtrl.errors.password\" class=\"text-red\">Password {{accountCtrl.errors.password[0]}}</p></div><div class=\"form-block col-md-6 col-xs-12\"><p>Phone</p><input type=\"tel\" ng-model=\"accountCtrl.session.human.primary_phone\" ng-disabled=\"accountCtrl.pending\" required><p ng-show=\"accountCtrl.errors.primary_phone\" class=\"text-red\">Phone {{accountCtrl.errors.primary_phone[0]}}</p></div></div><div class=\"row\"><div class=\"form-block col-md-6 col-xs-12\"><p>Confirm your current password</p><input type=\"password\" ng-model=\"accountCtrl.session.human.current_password\" ng-disabled=\"accountCtrl.pending\" required><p ng-show=\"accountCtrl.success\" class=\"text-green\">Saved successfully</p><p ng-show=\"accountCtrl.errors.current_password\" class=\"text-red\">Invalid password</p></div></div><div class=\"row\"><div class=\"form-block col-xs-12\"><button type=\"submit\" ng-disabled=\"accountForm.$invalid || accountCtrl.pending\" ng-class=\"{ 'is-loading': accountCtrl.pending }\" class=\"submit\">Update</button><a ng-click=\"accountCtrl.remoteSignOut()\" ng-disabled=\"accountCtrl.pending\" ng-class=\"{ 'is-loading': accountCtrl.pending }\" class=\"btn\">Sign out of all devices</a></div></div></form></div></container></section></div>");;return buf.join("");
	}

/***/ },
/* 3559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.routes.humans.login', [__webpack_require__(600)]).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('humans.login', {
	    url: '/login',
	    template: __webpack_require__(3560)()
	  });
	}]).name;

/***/ },
/* 3560 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"route-login\"><section class=\"extra-padding\"><container><div class=\"prose text-center\"><h1>Welcome back</h1></div><od-signin></od-signin></container></section></div>");;return buf.join("");
	}

/***/ },
/* 3561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(3562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.routes.humans.register', [__webpack_require__(600)]).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('humans.register', {
	    url: '/register',
	    template: __webpack_require__(3564)(),
	    controllerAs: 'registerCtrl',
	    controller: function () {
	      controller.$inject = ["$window"];
	      function controller($window) {
	        _classCallCheck(this, controller);
	
	        this.$window = $window;
	      }
	
	      _createClass(controller, [{
	        key: 'redirectToHome',
	        value: function redirectToHome() {
	          this.$window.location = '/';
	        }
	      }]);
	
	      return controller;
	    }()
	  });
	}]).name;

/***/ },
/* 3562 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3563);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/less-loader/lib/loader.js!./register.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/less-loader/lib/loader.js!./register.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3563 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}.route-register od-signup{max-width:800px;margin:24px auto}", ""]);
	
	// exports


/***/ },
/* 3564 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"route-register\"><section class=\"extra-padding\"><container><div class=\"prose text-center\"><h1>Create an Opendoor account</h1><p class=\"text-muted\">And get the most out of Opendoor services</p></div><od-signup on-registration-complete=\"registerCtrl.redirectToHome()\" buyer-type=\"seller\"></od-signup></container></section></div>");;return buf.join("");
	}

/***/ },
/* 3565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ALLOWED_STATISTICS = ['median_close', 'median_dom'];
	var ALLOWED_FORMATS = {
	  'currency_thousands': function currency_thousands(value) {
	    return "$" + (value && value / 1000 + "K");
	  }
	};
	
	// Used by the native app to render a market chart
	module.exports = _angular2.default.module('market.routes.market-chart', [__webpack_require__(600)]).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('market-chart', {
	    parent: 'root',
	    url: '/market-chart/:slug?statistic&format&smoothing',
	    resolve: {
	      listing: ["Listing", "$stateParams", function listing(Listing, $stateParams) {
	        return Listing.get({ slug: $stateParams.slug }).$promise;
	      }]
	    },
	    views: {
	      '': {
	        template: __webpack_require__(3566)(),
	        controller: 'home_market_chart',
	        controllerAs: 'home_market_chart'
	      },
	      'header@': { template: '<div />' }, // disable header
	      'footer@': { template: '<div />' }, // disable footer
	      'header_xs_down@': { template: '<div />' }, // disable the header on mobile
	      'footer_xs_down@': { template: '<div />' // disable the footer on mobile
	      } }
	  });
	}]).controller('home_market_chart', function () {
	  _class.$inject = ["$state", "$stateParams", "listing"];
	  function _class($state, $stateParams, listing) {
	    _classCallCheck(this, _class);
	
	    if (!(0, _lodash.includes)(ALLOWED_STATISTICS, $stateParams.statistic)) {
	      throw 'Invalid statistic provided. Must be one of ' + ALLOWED_STATISTICS.join();
	    }
	    if ($stateParams.format && !(0, _lodash.has)(ALLOWED_FORMATS, $stateParams.format)) {
	      throw 'Invalid format provided. Must not be specified or be one of ' + Object.keys(ALLOWED_FORMATS).join();
	    }
	
	    this.listing = listing;
	    this.smoothing = $stateParams.smoothing;
	    this.statistic = $stateParams.statistic;
	    this.format = $stateParams.format;
	  }
	
	  _createClass(_class, [{
	    key: 'formatY',
	    value: function formatY(_ref) {
	      var value = _ref.value;
	
	      return (0, _lodash.get)(ALLOWED_FORMATS, this.format, _lodash.identity)(value);
	    }
	  }]);
	
	  return _class;
	}()).name;

/***/ },
/* 3566 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"route-homes-market-chart\"><div class=\"page\"><od-market-analysis-chart statistic=\"{{home_market_chart.statistic}}\" postal-code=\"{{home_market_chart.listing.address.postal_code}}\" market=\"{{home_market_chart.listing.address.market.mls_name}}\" market-label=\"{{home_market_chart.listing.address.market.name}}\" format=\"home_market_chart.formatY({ value: value })\" smoothing=\"{{home_market_chart.smoothing}}\"></od-market-analysis-chart></div></div>");;return buf.join("");
	}

/***/ },
/* 3567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.routes.offer-terms', [__webpack_require__(600)]).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('offer-terms', {
	    parent: 'root',
	    url: '/offerterms',
	    templateUrl: '/templates/common/offer_terms.html',
	    data: {
	      meta: {
	        titleSuffix: " | Offer Terms"
	      }
	    }
	  });
	}]).name;

/***/ },
/* 3568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.routes.postcard-terms', [__webpack_require__(600)]).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('postcard-terms', {
	    parent: 'root',
	    url: '/postcardterms',
	    templateUrl: '/templates/market/postcard-terms.html',
	    data: {
	      meta: {
	        titleSuffix: " | Postcard terms of use"
	      }
	    }
	  });
	}]).name;

/***/ },
/* 3569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.routes.properties', [__webpack_require__(600)]).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('properties', {
	    parent: 'root',
	    url: '/properties',
	    template: __webpack_require__(3570)(),
	    resolve: {
	      leads: ["Lead", function leads(Lead) {
	        return Lead.query().$promise;
	      }]
	    },
	    controllerAs: 'propertiesCtrl',
	    controller: function () {
	      controller.$inject = ["$rootScope", "leads"];
	      function controller($rootScope, leads) {
	        _classCallCheck(this, controller);
	
	        this.session = $rootScope.session;
	        this.leads = leads.filter(function (l) {
	          return l.state == 'offered';
	        });
	      }
	
	      _createClass(controller, [{
	        key: 'propertiesUrl',
	        value: function propertiesUrl() {
	          if (this.env === "production") {
	            return 'https://www.opendoor.com/properties';
	          } else {
	            return 'https://demo.simplersell.com/properties';
	          }
	        }
	      }]);
	
	      return controller;
	    }()
	  });
	}]).name;

/***/ },
/* 3570 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"route-properties\"><section class=\"extra-padding\"><div class=\"container\"><div class=\"row center-xs\"><div class=\"col-xs-12 col-sm-6\"><h2>Select a property</h2><ul><li ng-if=\"!propertiesCtrl.leads.length\"><ul><li ng-hide=\"session.human\" class=\"primary-nav-item\"><a href=\"/login?redirectTo={{propertiesCtrl.propertiesUrl()}}\" target=\"_self\">Sign in to see your properties.</a></li><li ng-show=\"session.human\" class=\"primary-nav-item\"><a href=\"/address-entry\" target=\"_self\">Request an offer for your home first.</a></li></ul></li><li ng-repeat=\"lead in propertiesCtrl.leads\"><p class=\"prose\"><a href=\"{{lead.url}}\" target=\"_self\">{{lead.address | street}}<span ng-if=\"lead.readable_state\"> ({{ lead.readable_state }})</span></a></p></li></ul></div></div></div></section></div>");;return buf.join("");
	}

/***/ },
/* 3571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.routes.property-terms', [__webpack_require__(600)]).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('property-terms', {
	    parent: 'root',
	    url: '/property-terms',
	    templateUrl: '/templates/common/property-terms.html',
	    data: {
	      meta: {
	        titleSuffix: ' | Our Property Terms',
	        description: "Read the full terms and conditions for which Opendoor will repurchase a " + "Buyer's eligible property as part of our 90-day satisfaction guarantee.",
	        keywords: 'Opendoor Property Terms'
	      }
	    }
	  });
	}]).name;

/***/ },
/* 3572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _repairs = __webpack_require__(3573);
	
	var _repairs2 = _interopRequireDefault(_repairs);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	(0, _lodash.forEach)(_repairs2.default, function (category) {
	  (0, _lodash.forEach)(category.repair_items, function (item) {
	    item.svg = __webpack_require__(3574)("./" + item.svg + '.svg');
	  });
	});
	
	module.exports = _angular2.default.module('market.routes.repairs', [__webpack_require__(600), __webpack_require__(640)]).config(["$stateProvider", "$sanitizeProvider", function ($stateProvider, $sanitizeProvider) {
	  $stateProvider.state('repairs', {
	    parent: 'root',
	    url: '/repairs',
	    template: __webpack_require__(3600)(),
	    data: {
	      meta: {
	        titleSuffix: " | Common Repair Items"
	      }
	    },
	    controllerAs: 'repairsCtrl',
	    controller: function () {
	      controller.$inject = ["$timeout"];
	      function controller($timeout) {
	        _classCallCheck(this, controller);
	
	        this.repairs = _repairs2.default;
	
	        this.$timeout = $timeout;
	      }
	
	      _createClass(controller, [{
	        key: 'toggleDetails',
	        value: function toggleDetails(item) {
	          var _this = this;
	
	          // Hide details
	          if (item === "" || item === this.selected && this.showDetails) {
	            this.showDetails = false;
	            this.$timeout(function () {
	              _this.overlayIsHidden = true;
	            }, 500);
	
	            // Show details
	          } else {
	            this.selected = item;
	            this.overlayIsHidden = false;
	            // HACK: without a timeout, the opacity snaps to 1 with no transition
	            this.$timeout(function () {
	              _this.showDetails = true;
	            });
	          }
	        }
	      }]);
	
	      return controller;
	    }()
	  });
	
	  $sanitizeProvider.enableSvg(true);
	}]).name;

/***/ },
/* 3573 */
/***/ function(module, exports) {

	module.exports = [
		{
			"name": "Exterior",
			"repair_items": [
				{
					"name": "Door",
					"svg": "door",
					"description": "The door’s hardware should be in working order. The weather stripping should be present.",
					"repair_credit_list": [
						"Non-functional door",
						"Missing weather stripping",
						"Large holes in door requiring a replacement",
						"Malfunctioning locks and track for sliding glass door",
						"Replacing non-fire rated, or compromised garage entry doors"
					]
				},
				{
					"name": "Garage",
					"svg": "garage",
					"description": "Garage door should be operational and opener should be included with home.",
					"opendoor_list": [
						"Remote control replacement"
					],
					"repair_credit_list": [
						"Non functioning garage door or door equipment (including proper safety reversal)",
						"Large dents or similar cosmetic defects",
						"Broken coil spring"
					]
				},
				{
					"name": "Landscaping",
					"svg": "landscaping",
					"description": "Vegetation around property should not interfere with physical property.",
					"repair_credit_list": [
						"Vegetation causing structural defects to property",
						"Any trees/shrubbery that is touching the home or roof"
					]
				},
				{
					"name": "Irrigation",
					"svg": "irrigation",
					"description": "Property should be free from drainage defects (including drainage path directing to home foundation).",
					"repair_credit_list": [
						"Large drainage defects or holes close to foundation.",
						"High grade (ground covering wood framed wall)."
					]
				},
				{
					"name": "Deck",
					"svg": "deck",
					"description": "Decks should be structurally sound and should have infill spacing so they are safe for children.",
					"repair_credit_list": [
						"Structural deck damage",
						"Missing infill spacing (support column)",
						"Water or termite damage",
						"Anything causing structural integrity issues outside of local code"
					]
				},
				{
					"name": "Fencing",
					"svg": "fencing",
					"description": "Property should be free from drainage defects (including drainage path directing to home foundation).",
					"repair_credit_list": [
						"Large cracks",
						"Wood rot",
						"Termites",
						"Missing planks or blocks",
						"Peeling paint",
						"Missing fence where one is required by local code or HOA"
					]
				},
				{
					"name": "Pool Equipment",
					"svg": "pool",
					"description": "Pool equipment (such as filters, lights, pumps, heathers, and chlorination and cleaning system) should be in working order.",
					"repair_credit_list": [
						"Leaking filter",
						"Leaky connections",
						"Broken lights",
						"Broken or leaking pumps",
						"Broken salt chlorination system",
						"Malfunctioning pool pump"
					]
				},
				{
					"name": "Roofing",
					"svg": "roofing",
					"description": "Roof covering protects the interior of the home from water and other elements. Materials are in good working condition.",
					"repair_credit_list": [
						"All broken or slipped tiles or caps.",
						"Any damage to underlayment or evidence of leaks.",
						"Any missing, wind damaged, or incorrectly installed shingles or nail holes.",
						"Any damage, cracks, bubbles, or blisters in sealant.",
						"Anything more than minor ponding water needs to be repaired"
					]
				},
				{
					"name": "Eaves",
					"svg": "eaves",
					"description": "Eaves, sofits, and fascia should be free from water damage and in good repair.",
					"repair_credit_list": [
						"Water damage or peeling paint."
					]
				},
				{
					"name": "Windows",
					"svg": "windows",
					"description": "Windows should exhibit full structural integrity.",
					"repair_credit_list": [
						"Cracked or broken window",
						"Broken thermal seals",
						"Broken window lock"
					]
				}
			]
		},
		{
			"name": "Interior",
			"repair_items": [
				{
					"name": "Kitchen Appliances",
					"svg": "appliances",
					"description": "All appliances should be in working order and free from leaks.",
					"repair_credit_list": [
						"Malfunctioning appliance"
					]
				},
				{
					"name": "Sinks & Faucets",
					"svg": "sinks",
					"description": "Sinks and faucets should flow and be free from leaks. Overflows should be in working order",
					"opendoor_list": [
						"Dirty sinks and faucets"
					],
					"repair_credit_list": [
						"Leaky or broken faucet",
						"Reversed hot & cold",
						"Malfunctioning overflows"
					]
				},
				{
					"name": "Bathtubs & Showers",
					"svg": "showers",
					"description": "Bathtubs and showers be in working order and should be free from leaks.",
					"repair_credit_list": [
						"Leaky or broken fixtures"
					]
				},
				{
					"name": "Walls & Ceiling",
					"svg": "walls",
					"description": "Walls and ceiling should be structurally sound and free from holes, cracks, and water damage.",
					"opendoor_list": [
						"Patch nail holes"
					],
					"repair_credit_list": [
						"Cracks/holes, water damage, peeling paint"
					]
				},
				{
					"name": "Flooring",
					"svg": "flooring",
					"description": "Flooring may show wear from gentle use, but should be free from obvious defects.",
					"opendoor_list": [
						"Dirty carpeting and flooring"
					],
					"repair_credit_list": [
						"Tears in carpeting",
						"Heavily damaged flooring"
					]
				},
				{
					"name": "Odors",
					"svg": "odors",
					"description": "Home should be free from significant odors such as smoke and pet-related odors.",
					"repair_credit_list": [
						"Replacement of carpet when required to deodorize the home",
						"Replacement of paint when required to deodorize the home"
					]
				}
			]
		},
		{
			"name": "Utilities",
			"repair_items": [
				{
					"name": "Smoke Detectors",
					"svg": "smoke",
					"description": "Smoke and carbon monoxide detectors should be in working order and less than 10 years old.",
					"opendoor_list": [
						"Smoke detector batteries",
						"Replace dated but functioning smoke detectors"
					],
					"repair_credit_list": [
						"Missing or broken smoke detector",
						"Broken carbon monoxide detector (only for homes with gas)"
					]
				},
				{
					"name": "Circuit Breakers",
					"svg": "circuit",
					"description": "Circuit breakers should be in working condition. They should be in rooms as required by code.",
					"opendoor_list": [
						"Add breaker outlets to kitchens, baths, and exteriors",
						"Wiring should be correctly installed."
					]
				},
				{
					"name": "Panels",
					"svg": "panel",
					"description": "Not Zinsco/Sylvania GTE or Federal Pacific brands. These are brands known to have defects and recommended by the governent to be replaced.",
					"repair_credit_list": [
						"Replace any defective brand panels"
					]
				},
				{
					"name": "Overcurrent",
					"svg": "overcurrent",
					"description": "Overcurrent protection should be operational.",
					"repair_credit_list": [
						"Repair double taps or damaged breakers"
					]
				},
				{
					"name": "HVAC",
					"svg": "hvac",
					"description": "Thermostat controls should be in working order. Equipment should be clean and free from leaks.",
					"repair_credit_list": [
						"Broken cooling system",
						"Broken cooling distribution system",
						"Unsealed ducting",
						"Unsealed or broken ducts",
						"HVAC units older than 12 years"
					]
				},
				{
					"name": "Water Heater",
					"svg": "heater",
					"description": "Water heater should be in good working condition, free from leaks, and pipes should be insulated.",
					"repair_credit_list": [
						"Leak or corrosion at supply valve and/or lines"
					]
				}
			]
		},
		{
			"name": "Miscellaneous",
			"repair_items": [
				{
					"name": "Pests",
					"svg": "pests",
					"description": "Home should be free from significant pest infestations (termites, roaches and pigeon activity on roof)",
					"repair_credit_list": [
						"Evidence of persistent pest problem, e.g. termites, rodents"
					]
				},
				{
					"name": "Attic",
					"svg": "attic",
					"description": "Trusses should be structurally sound.",
					"opendoor_list": [
						"Trash in attic"
					],
					"repair_credit_list": [
						"Insulation is sufficient to meet local code requirements",
						"Trusses are in good shape and not cracked or damaged"
					]
				},
				{
					"name": "Foundation",
					"svg": "foundation",
					"description": "Foundation, stemwall & retaining wall must all be structurally sound.",
					"repair_credit_list": [
						"Any implied issue with foundation, e.g. sagging floors, large settling cracks on exterior (1/4 - 1/2 inch or more)",
						"Cracks in interior floors / walls, significant settling, horizontal cracks in foundation, etc."
					]
				}
			]
		}
	];

/***/ },
/* 3574 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./appliances.svg": 3575,
		"./attic.svg": 3576,
		"./circuit.svg": 3577,
		"./deck.svg": 3578,
		"./door.svg": 3579,
		"./eaves.svg": 3580,
		"./fencing.svg": 3581,
		"./flooring.svg": 3582,
		"./foundation.svg": 3583,
		"./garage.svg": 3584,
		"./heater.svg": 3585,
		"./hvac.svg": 3586,
		"./irrigation.svg": 3587,
		"./landscaping.svg": 3588,
		"./odors.svg": 3589,
		"./overcurrent.svg": 3590,
		"./panel.svg": 3591,
		"./pests.svg": 3592,
		"./pool.svg": 3593,
		"./roofing.svg": 3594,
		"./showers.svg": 3595,
		"./sinks.svg": 3596,
		"./smoke.svg": 3597,
		"./walls.svg": 3598,
		"./windows.svg": 3599
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 3574;


/***/ },
/* 3575 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxwYXRoIGQ9Ik05IDhWNmMwLTEuMTA1Ljg5LTIgMS45OS0yaDE4LjAyYzEuMSAwIDEuOTkuODg4IDEuOTkgMnYyIi8+PHJlY3QgZmlsbD0iI0ZGRiIgeD0iNiIgeT0iMTEiIHdpZHRoPSIyOCIgaGVpZ2h0PSIyNyIgcng9IjIiLz48cmVjdCBmaWxsPSIjRkZGIiB4PSIxMSIgeT0iMjQiIHdpZHRoPSIxOCIgaGVpZ2h0PSI5IiByeD0iMSIvPjxjaXJjbGUgZmlsbD0iI0ZGRiIgY3g9IjEzIiBjeT0iMTgiIHI9IjIiLz48Y2lyY2xlIGZpbGw9IiNGRkYiIGN4PSIyMCIgY3k9IjE4IiByPSIyIi8+PGNpcmNsZSBmaWxsPSIjRkZGIiBjeD0iMjciIGN5PSIxOCIgcj0iMiIvPjwvZz48L2c+PC9zdmc+\""

/***/ },
/* 3576 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxjaXJjbGUgZmlsbD0iI0ZGRiIgY3g9IjIwIiBjeT0iMjAiIHI9IjE4Ii8+PGNpcmNsZSBmaWxsPSIjRkZGIiBjeD0iMjAiIGN5PSIyMCIgcj0iMTQiLz48cGF0aCBkPSJNMjAgMTF2MThtLTktOWgxOCIvPjwvZz48L2c+PC9zdmc+\""

/***/ },
/* 3577 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxwYXRoIGQ9Ik04IDIwaDRsMi42NS03LjA2N2MuMTkzLS41MTUuNDMzLS40ODguNTMzLjA0NGwyLjYzNCAxNC4wNDZjLjEuNTQuMjY2LjUzMi4zNjYgMGwyLjYzNC0xNC4wNDZjLjEtLjU0LjI2Ni0uNTMyLjM2NiAwbDIuNjM0IDE0LjA0NmMuMS41NC4yNjYuNTMyLjM2NiAwbDIuNjM0LTE0LjA0NmMuMS0uNTQuMjktLjU0Ny40MjQtLjAxMkwyOSAyMGg0Ii8+PGNpcmNsZSBmaWxsPSIjRkZGIiBjeD0iNyIgY3k9IjIwIiByPSIzIi8+PGNpcmNsZSBmaWxsPSIjRkZGIiBjeD0iMzQiIGN5PSIyMCIgcj0iMyIvPjwvZz48L2c+PC9zdmc+\""

/***/ },
/* 3578 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxwYXRoIGQ9Ik0xNSAzM2gxME05IDM4bDMtOG0xOSA4bC0zLThtLTgtMS43NWM0IDAgMTEtMi41IDExLTExLjI1LTYtMi0xNi0yLTIyIC4yNSAwIDguNzUgNyAxMSAxMSAxMXpNMTQuOTIgMkMyMSA4IDEzIDMgMTMgN3M2IDIgMyA1bTYuOTItMTBDMjkgOCAyMSAzIDIxIDdzNiAyIDMgNSIvPjwvZz48L2c+PC9zdmc+\""

/***/ },
/* 3579 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxjaXJjbGUgZmlsbD0iI0ZGRiIgY3g9IjIxIiBjeT0iMjIiIHI9IjEiLz48cGF0aCBkPSJNMzAuMDIzIDMyYy41NTIgMCAxLS45IDEtMS45OTNWNC45OTNjMC0xLjEtLjg5LTEuOTkzLTEuOTkzLTEuOTkzSDEwLjk5M0M5Ljg5MyAzIDkgMy45IDkgNC45OXYyNC4wMmMwIDEuMDk4LjgyIDIuMzI4IDEuODU0IDIuNzUybDEzLjMxNSA1LjQ3NmMxLjAyLjQyIDEuODUtLjEzOCAxLjg1LTEuMjNWMTAuOTkyYzAtMS4xLS44Ni0yLjIzOC0xLjkyLTIuNTRMMTkgNyIvPjwvZz48L2c+PC9zdmc+\""

/***/ },
/* 3580 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxwYXRoIGQ9Ik0zNS43NzcgMi42NzVsLTEwLjkxIDUuMDg3YTEuMDEgMS4wMSAwIDAgMC0uNDggMS4zMzhsLjk0NyAyLjAzYTEuMDAzIDEuMDAzIDAgMCAxLS40OCAxLjM0bC04LjgyIDQuMTEyYTEgMSAwIDAgMC0uNDg1IDEuMzI4bC42NCAxLjM3OGMuMjMzLjUuMDQ0IDEuMTQtLjQzIDEuNDM2TDMgMjguNjc2TTM3IDE1TDEwLjg1MyAzMS40NjNjLS40Ny4yOTctLjg1My45ODgtLjg1MyAxLjUyOFYzOG0yOC0xOEwxNC44NTQgMzQuNDY2Ii8+PC9nPjwvZz48L3N2Zz4=\""

/***/ },
/* 3581 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxwYXRoIGQ9Ik03IDExLjA2M1M5LjI1IDYgMTAgNnMzIDUuMDYzIDMgNS4wNjN2MjMuOTNjMCAuNTU1LS40NSAxLjAwNy0uOTkgMS4wMDdINy45OUExIDEgMCAwIDEgNyAzNC45OTJ2LTIzLjkzem0xMCAwUzE5LjI1IDYgMjAgNnMzIDUuMDYzIDMgNS4wNjN2MjMuOTNjMCAuNTU1LS40NSAxLjAwNy0uOTkgMS4wMDdoLTQuMDJhMSAxIDAgMCAxLS45OS0xLjAwOHYtMjMuOTN6IiBmaWxsPSIjRkZGIi8+PHBhdGggZD0iTTEgMThoMm0tMiA1aDJtLTIgNWgyIi8+PHBhdGggZD0iTTI3IDExLjA2M1MyOS4yNSA2IDMwIDZzMyA1LjA2MyAzIDUuMDYzdjIzLjkzYzAgLjU1NS0uNDUgMS4wMDctLjk5IDEuMDA3aC00LjAyYTEgMSAwIDAgMS0uOTktMS4wMDh2LTIzLjkzeiIgZmlsbD0iI0ZGRiIvPjxwYXRoIGQ9Ik0zNyAxOGgybS0yIDVoMm0tMiA1aDIiLz48L2c+PC9nPjwvc3ZnPg==\""

/***/ },
/* 3582 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxyZWN0IGZpbGw9IiNGRkYiIHg9IjIiIHk9IjIiIHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgcng9IjIiLz48cGF0aCBkPSJNMTQgMnYxMm0xNyA1djE5TTkgMnYxOW0xNyA1djEyTTM4IDkuMDFIMTltMTkgNUgyNm0tMTIgMTJIMm0xOSA1SDIiLz48L2c+PC9nPjwvc3ZnPg==\""

/***/ },
/* 3583 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgMikiIGZpbGw9IiNGRkYiPjxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSIxNCIgaGVpZ2h0PSI3IiByeD0iMSIvPjxyZWN0IHg9IjAiIHk9IjI5IiB3aWR0aD0iMTQiIGhlaWdodD0iNyIgcng9IjEiLz48L2c+PHBhdGggZD0iTTEwIDEydjE1LjVNNiAxMnYxNS41TTE0IDEydjE1LjUiLz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMyAyKSI+PHBhdGggZD0iTTcgMTAuNVYyNk0zIDEwLjVWMjZNMTEgMTAuNVYyNiIvPjxyZWN0IGZpbGw9IiNGRkYiIHg9IjAiIHk9IjAiIHdpZHRoPSIxNCIgaGVpZ2h0PSI3IiByeD0iMSIvPjxyZWN0IGZpbGw9IiNGRkYiIHg9IjAiIHk9IjI5IiB3aWR0aD0iMTQiIGhlaWdodD0iNyIgcng9IjEiLz48L2c+PC9nPjwvZz48L3N2Zz4=\""

/***/ },
/* 3584 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxwYXRoIGQ9Ik05IDVjLTMgMi01IDctNiAxMXYxNWMwIDItMSA2IDMgNnMzLTMuMjYgMy02YzQgMCAxOS0uMjYgMjIgMCAwIDIgMCA2IDMgNnMzLTEgMy02VjE2Yy0xLTQtMy0xMC02LTExSDl6Ii8+PHBhdGggZD0iTTExIDljLTEgMS00IDYtMyA4aDI0YzEtNC00LTgtNC04SDExeiIvPjxjaXJjbGUgZmlsbD0iI0ZGRiIgY3g9IjkiIGN5PSIyNCIgcj0iMiIvPjxjaXJjbGUgZmlsbD0iI0ZGRiIgY3g9IjMxIiBjeT0iMjQiIHI9IjIiLz48L2c+PC9nPjwvc3ZnPg==\""

/***/ },
/* 3585 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9IiNGRkYiPjxwYXRoIGQ9Ik0yNS45OTIgMjMuMjg1Yy4wMDUtLjA5NC4wMDgtLjE4OC4wMDgtLjI4M1Y2Ljk5OEE1IDUgMCAwIDAgMjAuOTk4IDJoLTEuOTk2QTQuOTkzIDQuOTkzIDAgMCAwIDE0IDYuOTk4djE2LjAwNGMwIC4wOTUuMDAzLjE5LjAwOC4yODNhOSA5IDAgMSAwIDExLjk4NCAweiIvPjxwYXRoIGQ9Ik0yMiAyNS40MTZhNSA1IDAgMSAxLTQgMFY5YzAtMS4xMDQuODg4LTIgMi0yIDEuMTA1IDAgMiAuOTAyIDIgMnYxNi40MTZ6Ii8+PC9nPjwvZz48L3N2Zz4=\""

/***/ },
/* 3586 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzIDUpIj48cGF0aCBkPSJNNyAwdjMwIi8+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSI+PHBhdGggZD0iTTE0IDBMNyA3TTAgMGw3IDciLz48L2c+PGcgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMCAyOSkiPjxwYXRoIGQ9Ik0xNCAwTDcgN00wIDBsNyA3Ii8+PC9nPjwvZz48ZyB0cmFuc2Zvcm09InJvdGF0ZSg5MCAxMSAyNCkiPjxwYXRoIGQ9Ik03IDB2MzAiLz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDEpIj48cGF0aCBkPSJNMTQgMEw3IDdNMCAwbDcgNyIvPjwvZz48ZyB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSAwIDI5KSI+PHBhdGggZD0iTTE0IDBMNyA3TTAgMGw3IDciLz48L2c+PC9nPjxwYXRoIGQ9Ik0xNSAyNWw5LjUxNS05LjUxNU0yNSAyNWwtOS41MTUtOS41MTUiLz48L2c+PC9nPjwvc3ZnPg==\""

/***/ },
/* 3587 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9IiNGRkYiPjxwYXRoIGQ9Ik0zMiAxNWMyLjIxIDAgNC0xLjY4IDQtMy43NUMzNiA5LjE4IDMyLjggMyAzMiAzYy0uOCAwLTQgNi4xOC00IDguMjUgMCAyLjA3IDEuNzkgMy43NSA0IDMuNzV6TTggMTdjMS42NTcgMCAzLTEuMjYgMy0yLjgxM0MxMSAxMi42MzQgOC42IDggOCA4Yy0uNiAwLTMgNC42MzQtMyA2LjE4OEM1IDE1Ljc0IDYuMzQzIDE3IDggMTd6bTEyIDIwYzQuNDE4IDAgOC0zLjMyIDgtNy40MThDMjggMjUuNDg0IDIxLjE0MyAxMSAyMCAxMWMtMS4xNDMgMC04IDE0LjQ4NC04IDE4LjU4MkMxMiAzMy42OCAxNS41ODIgMzcgMjAgMzd6Ii8+PC9nPjwvZz48L3N2Zz4=\""

/***/ },
/* 3588 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxwYXRoIGQ9Ik0xMyAzMGwuNzE2IDUuMDEzQzEzLjg3MyAzNi4xMSAxNC45MDIgMzcgMTYuMDEgMzdoNy45OGMxLjExIDAgMi4xMzctLjg4NyAyLjI5NC0xLjk4N0wyNyAzMCIvPjxyZWN0IGZpbGw9IiNGRkYiIHg9IjkiIHk9IjE5IiB3aWR0aD0iMjIiIGhlaWdodD0iNyIgcng9IjEiLz48cGF0aCBkPSJNMjEgMTUuNDd2LTdDMjEtMiAzNiAyIDM1IDVjLTEgMy04IDYtMTEgNW0tNS45My00LjMyN0MxNS0xIDcgMiA2LjA3IDMuNjczIDUuMTQgNS4zNDYgMTAuOTMgMTIuMzI3IDE3IDkiLz48L2c+PC9nPjwvc3ZnPg==\""

/***/ },
/* 3589 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjQwcHgiIGhlaWdodD0iNDBweCIgdmlld0JveD0iMCAwIDQwIDQwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0MS4yICgzNTM5NykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+b2RvcnM8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0ib2RvcnMiIHN0cm9rZT0iI0JEQkZDMSIgc3Ryb2tlLXdpZHRoPSIzIj4KICAgICAgICAgICAgPHBhdGggZD0iTTYuOTM0NTcwMzEsMTQuMDQyMzE1MiBDNi45MzQ1NzAzMSwxNC4wNDIzMTUyIDkuMTc3Njc0ODMsMTAuNzUwNTA4OCAxMy42NTY2NzM2LDEwLjc1MDUwODggQzE4LjEzNTY3MjQsMTAuNzUwNTA4OCAyMS4wMTI1NTY3LDE1Ljg1NTIyNDYgMjUuMDkxMzg3NCwxNS44NTUyMjQ2IEMyOS4xNzAyMTgsMTUuODU1MjI0NiAzMi45Mjg5MTQyLDEzLjMwMDc2NiAzMi45Mjg5MTQyLDEyLjAyNTYzNzQiIGlkPSJQYXRoIj48L3BhdGg+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik02LjkzNDU3MDMxLDIxLjU3MTI0NTkgQzYuOTM0NTcwMzEsMjEuNTcxMjQ1OSA5LjE3NzY3NDgzLDE4LjI3OTQzOTQgMTMuNjU2NjczNiwxOC4yNzk0Mzk0IEMxOC4xMzU2NzI0LDE4LjI3OTQzOTQgMjEuMDEyNTU2NywyMy4zODQxNTUzIDI1LjA5MTM4NzQsMjMuMzg0MTU1MyBDMjkuMTcwMjE4LDIzLjM4NDE1NTMgMzIuOTI4OTE0MiwyMC44Mjk2OTY3IDMyLjkyODkxNDIsMTkuNTU0NTY4IiBpZD0iUGF0aCI+PC9wYXRoPgogICAgICAgICAgICA8cGF0aCBkPSJNNi45MzQ1NzAzMSwyOS4xMDAxNzY2IEM2LjkzNDU3MDMxLDI5LjEwMDE3NjYgOS4xNzc2NzQ4MywyNS44MDgzNzAxIDEzLjY1NjY3MzYsMjUuODA4MzcwMSBDMTguMTM1NjcyNCwyNS44MDgzNzAxIDIxLjAxMjU1NjcsMzAuOTEzMDg1OSAyNS4wOTEzODc0LDMwLjkxMzA4NTkgQzI5LjE3MDIxOCwzMC45MTMwODU5IDMyLjkyODkxNDIsMjguMzU4NjI3MyAzMi45Mjg5MTQyLDI3LjA4MzQ5ODciIGlkPSJQYXRoIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=\""

/***/ },
/* 3590 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxjaXJjbGUgZmlsbD0iI0ZGRiIgY3g9IjciIGN5PSIyMCIgcj0iMyIvPjxwYXRoIGQ9Ik0xMCAyMGg0bTEtMTN2MjZtOC0yNnYyNm01LTIxdjE2bTQtMTJ2OG00LTV2M20tOS0yaC00Ii8+PC9nPjwvZz48L3N2Zz4=\""

/***/ },
/* 3591 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9IiNGRkYiPjxwYXRoIGQ9Ik0yMS45NyA0LjEyQTE2LjE2IDE2LjE2IDAgMCAwIDIwIDRDMTEuMTYzIDQgNCAxMS4xNjMgNCAyMGExNS45NSAxNS45NSAwIDAgMCA0Ljc2NCAxMS4zOW0xMC4yMjMgNC41NzhjLjMzNS4wMi42NzMuMDMyIDEuMDEzLjAzMiA4LjgzNyAwIDE2LTcuMTYzIDE2LTE2YTE1Ljk1IDE1Ljk1IDAgMCAwLTQuNjktMTEuMzE4Ii8+PHBhdGggZD0iTTIxLjY0NyAxOGw0LjU5LTExLjE0OGMuNDI1LTEuMDMyLjE1Mi0xLjIwMy0uNi0uNDAzbC0xMy4yNzMgMTQuMWMtLjc1Ni44MDItLjQ3IDEuNDUuNjMzIDEuNDVoNS4zNTZsLTQuNTkgMTEuMTQ2Yy0uNDI1IDEuMDMyLS4xNTIgMS4yMDMuNi40MDNsMTMuMjczLTE0LjFjLjc1Ni0uODA1LjQ3LTEuNDUtLjYzMy0xLjQ1aC01LjM1NnoiLz48L2c+PC9nPjwvc3ZnPg==\""

/***/ },
/* 3592 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxwYXRoIGQ9Ik0xNy4yNSAyNWMtMiA1LTIgMTMgMyAxM3M1LTggMy0xMyIvPjxlbGxpcHNlIGZpbGw9IiNGRkYiIGN4PSIyMCIgY3k9IjE5IiByeD0iNCIgcnk9IjMiLz48cGF0aCBkPSJNMTMgMThjLTEgMC0zLTEtMy0yczEtNCAxLTRtMTYgNmMxIDAgMy0xIDMtMnMtMS00LTEtNG0tMTIgMWMtMS0yIDAtNiAzLTZzNCA0IDMgNk0xNSAyYy0xIDEtMiAzIDAgNW0xMC01YzEgMSAyIDMgMCA1TTEzIDI2Yy0xIDAtNCAzLTQgNHMyIDYgMiA3bTE2LTExYzEgMCA0IDMgNCA0cy0xIDYtMSA3Ii8+PC9nPjwvZz48L3N2Zz4=\""

/***/ },
/* 3593 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxwYXRoIGQ9Ik0yLjkgMjRjMC0yLjE2NyA2Ljg0LTEuOTMzIDYuODQuMTE4IDAgMi4wNSA2Ljg0IDIuMDIgNi44NC0uMTE3IDAtMi4xNjUgNi44NC0yLjE2NSA2Ljg0IDAgMCAyLjE3IDYuODQzIDIuMTcgNi44NDMgMCAwLTIuMTY1IDYuODQyLTIuMTY1IDYuODQyIDBNMjcgMTlWNWMwLTIgMS0yIDItMnMyIDAgMiAyTTEyIDE5VjVjMC0yIDEtMiAyLTJzMiAwIDIgMm0tMy41IDEwLjVIMjdtLTE0LjUtNkgyN00yLjg5NSAyOS42MjZjMC0yLjE2OCA2Ljg0Mi0xLjkzNCA2Ljg0Mi4xMTcgMCAyLjA1IDYuODM4IDIuMDIgNi44MzgtLjExNyAwLTIuMTY4IDYuODQyLTIuMTY4IDYuODQyIDAgMCAyLjE2NyA2Ljg0MiAyLjE2NyA2Ljg0MiAwIDAtMi4xNjggNi44NC0yLjE2OCA2Ljg0IDBtLTM0LjIwNiA2YzAtMi4xNjggNi44NDItMS45MzQgNi44NDIuMTE3IDAgMi4wNSA2LjgzOCAyLjAyIDYuODM4LS4xMTcgMC0yLjE2OCA2Ljg0Mi0yLjE2OCA2Ljg0MiAwIDAgMi4xNjcgNi44NDIgMi4xNjcgNi44NDIgMCAwLTIuMTY4IDYuODQtMi4xNjggNi44NCAwIi8+PC9nPjwvZz48L3N2Zz4=\""

/***/ },
/* 3594 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxwYXRoIGQ9Ik00IDIzTDE4LjUzOCA5LjM3YTIuMTYgMi4xNiAwIDAgMSAyLjkyNCAwTDM2IDIzbS03LTEyVjUuOTljMC0uNTQ2LjQ1LS45OS45OS0uOTloNC4wMmMuNTQ2IDAgLjk5LjQ0NS45OS45OTZWMTYiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMTYgMjRoOHYxMmgtOHoiLz48cGF0aCBkPSJNOSAyNXYxMS41MU0zMSAyNC41djExLjUxIi8+PC9nPjwvZz48L3N2Zz4=\""

/***/ },
/* 3595 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxwYXRoIGQ9Ik0zNiAzSDIxYy0xLjEwNSAwLTIgLjg4OC0yIDJ2MiIvPjxwYXRoIGQ9Ik0yOCAyMGE5IDkgMCAwIDAtMTggMGgxOHoiIGZpbGw9IiNGRkYiLz48cGF0aCBkPSJNMTAgMjRoMThtLTE3IDQuNVYzMW0wIDR2Mi41bTgtOVYzMW0wIDR2Mi41bTgtOVYzMW0wIDR2Mi41Ii8+PC9nPjwvZz48L3N2Zz4=\""

/***/ },
/* 3596 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxwYXRoIGQ9Ik0zOCAyMUgxOXMtMyAwLTQgMWMtMS4yMDggMS4yMDgtLjgxNCA1LS44MTQgNWEuOTMuOTMgMCAwIDEtLjk0IDFIOS4wMDRBMS4wMDUgMS4wMDUgMCAwIDEgOCAyNy4wMDNWMjBzMC0zIDItNSA1LTIgNS0yaDUuMDFjLjU0NiAwIC45OS0uNDQzLjk5LTEuMDFWOW04IDB2Mi45OWMwIC41NTguNDQ2IDEuMDEuOTk4IDEuMDFIMzgiLz48cmVjdCBmaWxsPSIjRkZGIiB4PSIxNCIgeT0iMSIgd2lkdGg9IjIxIiBoZWlnaHQ9IjQiIHJ4PSIyIi8+PHBhdGggZD0iTTExLjUgMzhhMi41IDIuNSAwIDAgMCAyLjUtMi41YzAtMS4zOC0yLTQuNS0yLjUtNC41UzkgMzQuMTIgOSAzNS41YTIuNSAyLjUgMCAwIDAgMi41IDIuNXoiIGZpbGw9IiNGRkYiLz48L2c+PC9nPjwvc3ZnPg==\""

/***/ },
/* 3597 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxjaXJjbGUgZmlsbD0iI0ZGRiIgY3g9IjIwIiBjeT0iMjAiIHI9IjE3Ii8+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAgMjMpIj48cGF0aCBkPSJNMCAxaDhNNCA1aDRNNyA5aDEiLz48L2c+PGcgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgMzAgMjMpIj48cGF0aCBkPSJNMCAxaDhNNCA1aDRNNyA5aDEiLz48L2c+PHBhdGggZD0iTTcgMjBoMjUuNTA1Ii8+PGNpcmNsZSBmaWxsPSIjRkZGIiBjeD0iMjAiIGN5PSIxMyIgcj0iMSIvPjwvZz48L2c+PC9zdmc+\""

/***/ },
/* 3598 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9IiNGRkYiPjxyZWN0IHg9IjIiIHk9IjIiIHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgcng9IjIiLz48cmVjdCB4PSIxNCIgeT0iNiIgd2lkdGg9IjEwIiBoZWlnaHQ9IjYiIHJ4PSIxIi8+PHJlY3QgeD0iMjQiIHk9IjYiIHdpZHRoPSIxMCIgaGVpZ2h0PSI2IiByeD0iMSIvPjxyZWN0IHg9IjUiIHk9IjIyIiB3aWR0aD0iMTAiIGhlaWdodD0iNiIgcng9IjEiLz48cmVjdCB4PSIxOSIgeT0iMTIiIHdpZHRoPSIxMCIgaGVpZ2h0PSI2IiByeD0iMSIvPjxyZWN0IHg9IjEwIiB5PSIyOCIgd2lkdGg9IjEwIiBoZWlnaHQ9IjYiIHJ4PSIxIi8+PC9nPjwvZz48L3N2Zz4=\""

/***/ },
/* 3599 */
/***/ function(module, exports) {

	module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxwYXRoIGQ9Ik0yOSAyMUgxMk0xMC4wMDQgNEEyIDIgMCAwIDAgOCA2LjAwMnYyNy45OTZDOCAzNS4xMDQgOC44OSAzNiAxMC4wMDQgMzZoMjAuOTkyQTIgMiAwIDAgMCAzMyAzMy45OThWNi4wMDJDMzMgNC44OTYgMzIuMTEgNCAzMC45OTYgNEgxMC4wMDR6TTI0IDIzaDJtLTItMWgyIi8+PC9nPjwvZz48L3N2Zz4=\""

/***/ },
/* 3600 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"route-repairs\"><section class=\"intro\"><div class=\"container\"><div class=\"row center-xs\"><div class=\"col-xs-12\"><h1 class=\"medium-headline\">Common Repair Items</h1><p>Here are some of the most common repair items.</p></div></div></div></section><section><div class=\"regular-container\"><div ng-init=\"repairsCtrl.overlayIsHidden = true\" class=\"row\"><div ng-class=\"{&quot;show-details&quot;: repairsCtrl.showDetails, &quot;display-none&quot;: repairsCtrl.overlayIsHidden}\" ng-click=\"repairsCtrl.toggleDetails(&quot;&quot;)\" class=\"col-xs-12 detail-overlay hidden-md-up\"><div class=\"row\"><div class=\"col-xs-2 text-center\"><icon name=\"ei-close\"></icon></div></div></div><div ng-class=\"{&quot;show-details&quot;: repairsCtrl.showDetails}\" class=\"col-xs-10 hidden-md-up repair-details\"> <div class=\"repair-details-content\"><od-repair-item item=\"repairsCtrl.selected\"></od-repair-item></div></div><div class=\"col-xs-12 col-md-8\"><div ng-repeat=\"category in repairsCtrl.repairs\" class=\"row category\"><div class=\"col-xs-12\"><h2>{{ category.name }}</h2></div><div ng-repeat=\"item in category.repair_items\" ng-click=\"repairsCtrl.toggleDetails(item)\" class=\"col-xs-6 col-md-4\"><div ng-class=\"{&quot;selected&quot;: (repairsCtrl.selected === item &amp;&amp; repairsCtrl.showDetails)}\" class=\"repair-item\"><div ng-bind-html=\"item.svg\" class=\"repair-illustration\"></div><h6>{{ item.name }}</h6></div></div></div></div><div od-sticky-container class=\"col-xs-12 col-md-4 hidden-sm-down\"><div od-sticky-element class=\"repair-details-desktop\"><div class=\"row\"><div class=\"col-xs-12 repair-details-content-desktop\"><p ng-if=\"!repairsCtrl.showDetails\" class=\"text-muted\">Click a repair item to see details.</p><od-repair-item item=\"repairsCtrl.selected\" ng-if=\"repairsCtrl.showDetails\"></od-repair-item></div></div></div></div></div></div></section></div>");;return buf.join("");
	}

/***/ },
/* 3601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.routes.static', [__webpack_require__(3602)]).name;

/***/ },
/* 3602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(3603);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.routes.static.safety', [__webpack_require__(600)]).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('safety', {
	    parent: 'root',
	    url: '/safety',
	    template: __webpack_require__(3605)(),
	    data: {
	      meta: {
	        titleSuffix: " | Trust and safety"
	      }
	    },
	    controllerAs: 'safetyCtrl',
	    controller: function controller() {
	      _classCallCheck(this, controller);
	
	      this.tab = '';
	    }
	  });
	}]).name;

/***/ },
/* 3603 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3604);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(262)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/postcss-loader/index.js!../../../../../node_modules/less-loader/lib/loader.js!./safety.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/postcss-loader/index.js!../../../../../node_modules/less-loader/lib/loader.js!./safety.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3604 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(252)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:'Graphik';font-style:normal;font-weight:400;src:local('Graphik'),local('Graphik-Regular'),url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2')}@font-face{font-family:'Graphik';font-style:bold;font-weight:500;src:local('Graphik'),local('Graphik-Medium'),url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Noto-Mono';font-style:normal;font-weight:400;src:local('Noto-Mono'),local('Noto-Mono-Regular'),url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff')}@font-face{font-family:'Publico';font-style:normal;font-weight:400;src:local('Publico'),local('Publico-Regular'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-weight:500;src:local('Publico'),local('Publico-Medium'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2')}@font-face{font-family:'Publico';font-style:bold;font-weight:600;src:local('Publico'),local('Publico-Bold'),url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2')}.route-static-safety #hero{padding:120px 0;background:#ebd0c0 url('https://images.opendoor.com/source/s3/imgdrop-production/08007b72373d4c82adb864a6c5bde7d9.jpg?service=web') center no-repeat;background-size:cover}@media (max-width:991px){.route-static-safety #hero{padding:60px 0}}@media (max-width:767px){.route-static-safety #hero{padding:40px 0 240px 0;text-align:center;background:#ebd0c0 url('https://images.opendoor.com/source/s3/imgdrop-production/eeb48944d57d4d58aa486791e6f2ae64.jpg?service=web') bottom center no-repeat;background-size:100% auto}}@media (max-width:767px){.route-static-safety .safety-page-headline{font-size:28px}}.route-static-safety .safety-highlight-box{border-top:1px solid #f0f0f0;padding-top:80px;overflow:hidden;margin:0}@media (max-width:767px){.route-static-safety .safety-highlight-box{padding-top:30px}}.route-static-safety .safety-highlight-title{font-weight:400}.route-static-safety .safety-highlight-heading{margin-bottom:15px}.route-static-safety .sub-headline{margin-top:30px}.route-static-safety .content-col-right{padding-left:100px;padding-right:20px}@media (max-width:767px){.route-static-safety .content-col-right{padding:0;text-align:center}}.route-static-safety .content-col-left{padding-right:100px}@media (max-width:767px){.route-static-safety .content-col-left{padding:0;text-align:center}}.route-static-safety .safety-highlight-icon{margin-bottom:20px;width:40px;height:auto;display:block}@media (max-width:767px){.route-static-safety .safety-highlight-icon{margin:0 auto 20px auto !important}}.route-static-safety .text-icon{margin-top:0}.route-static-safety .code-icon{margin-top:100px}.route-static-safety .monitoring-icon{margin-top:70px}.route-static-safety .support-icon{margin-top:100px}.route-static-safety .safety-image{margin:0 auto;display:block}@media (max-width:767px){.route-static-safety .safety-image{display:none}}.route-static-safety .safety-image.phone{margin-bottom:-20px}.route-static-safety .safety-image.short-image{margin-bottom:80px}@media (max-width:1199px){.route-static-safety .safety-image.short-image{width:100%}}.route-static-safety .safety-highlights,.route-static-safety .safety-tips{padding:0}.route-static-safety .safety-tips-box{padding:100px 120px;-webkit-box-sizing:border-box;box-sizing:border-box;display:block;width:100%;position:relative;z-index:9;margin-bottom:-20px;background:#fff;-webkit-box-shadow:0 10px 30px rgba(0,0,0,0.1);box-shadow:0 10px 30px rgba(0,0,0,0.1)}@media (max-width:1199px){.route-static-safety .safety-tips-box{padding:80px}}@media (max-width:767px){.route-static-safety .safety-tips-box{padding:0;margin-bottom:0;-webkit-box-shadow:none;box-shadow:none}}.route-static-safety .safety-tips-header{margin-bottom:80px;background-size:auto 100%;background-repeat:no-repeat;background-position:top right}@media (max-width:767px){.route-static-safety .safety-tips-header{background-size:40px auto;background-position:right 40px;padding-top:40px;margin-bottom:40px;border-top:1px solid #f0f0f0}}.route-static-safety .safety-tips-header p{margin-top:20px;width:50%}@media (max-width:767px){.route-static-safety .safety-tips-header p{margin-top:20px;width:100%}}.route-static-safety .safety-item{padding:40px 0 40px 80px;position:relative;border-top:1px solid #f0f0f0}@media (max-width:991px){.route-static-safety .safety-item{padding:20px 0 20px 40px}}.route-static-safety .safety-legend{padding:20px 0 40px 80px;position:relative}.route-static-safety .safety-item::before{content:'';border:2px solid #506d7e;opacity:.3;width:8px;height:8px;-webkit-border-radius:100%;border-radius:100%;position:absolute;top:47px;left:20px}@media (max-width:991px){.route-static-safety .safety-item::before{top:27px;left:0}}.route-static-safety .premarket-home-btn{padding:40px 80px;background:url('https://images.opendoor.com/source/s3/imgdrop-production/early-access-small-icon.svg?service=web') 15px center no-repeat;position:relative;border-top:1px solid #f0f0f0}.route-static-safety .show-tips-label{position:absolute;color:#1c85e8;right:0;top:40px;cursor:pointer}.route-static-safety .show-tips-label.active{display:none}.route-static-safety .pre-footer-cta{position:relative;margin-bottom:-1px}@media (max-width:991px){.route-static-safety .intro-text{margin:40px 0}}@media (max-width:767px){.route-static-safety .intro-text{margin:0 0 20px 0}}", ""]);
	
	// exports


/***/ },
/* 3605 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"route-static-safety\"><section id=\"hero\"><div class=\"regular-container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-7\"><h1 class=\"big-headline safety-page-headline\">Helping keep you safe on your journey home.</h1><p class=\"sub-headline hidden-xs-down\">We’re creating a better way to buy and sell homes, and we believe that \nmission starts with providing a safe and a delightful experience for \nall of our customers.</p></div></div></div></section><section class=\"intro\"><div class=\"regular-container\"><div class=\"row\"><div class=\"col-sm-12 col-md-6\"><h2 class=\"hidden-xs-down\">It starts with a strong foundation.</h2></div><div class=\"col-sm-12 col-md-6\"><p class=\"intro-text\">We provide a world-class home viewing experience for the tens of \nthousands of buyers who visit Opendoor homes each month. Our \ncommitment to safety begins at the front door and continues \nthroughout the entire home visit.</p></div></div></div></section><section class=\"safety-highlights\"><div class=\"regular-container\"><div class=\"row\"><div class=\"col-xs-12\"><h6 class=\"safety-highlight-heading\">Safety highlights</h6></div></div><div class=\"row safety-highlight-box\"><div class=\"col-xs-12 col-sm-6 content-col-left\"><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/secure-icon.svg?service=web\" height=\"60\" class=\"safety-highlight-icon text-icon\"><h4 class=\"safety-highlight-title\">Secure accounts</h4><p class=\"medium-margin-top large-margin-bottom\">Before we grant access to any home, users create an account \nwith a verified phone number and email address.</p></div><div class=\"col-xs-12 col-sm-6\"><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/4bde579e2f754877a4b8842cdd87664c.jpg?service=web\" width=\"370\" od-scroll-enter class=\"safety-image short-image fade-in-up\"></div></div><div class=\"row safety-highlight-box\"><div class=\"col-xs-12 col-sm-6\"><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/d0ca8353ac6f4820ad0dfb176985b4b2.jpg?service=web\" width=\"280\" od-scroll-enter class=\"safety-image phone fade-in-up\"></div><div class=\"col-xs-12 col-sm-6 content-col-right\"><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/unique-entry-code-icon.svg?service=web\" height=\"60\" class=\"safety-highlight-icon code-icon fade-in-up\"><h4 class=\"safety-highlight-title\">Unique entry codes</h4><p class=\"medium-margin-top large-margin-bottom\"> \nEvery home has a keypad lock, and each visitor gets a unique \ncode for every visit.</p></div></div><div class=\"row safety-highlight-box\"><div class=\"col-xs-12 col-sm-6 content-col-left\"><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/monitoring-system-icon.svg?service=web\" height=\"60\" class=\"safety-highlight-icon monitoring-icon\"><h4 class=\"safety-highlight-title\">Home monitoring system</h4><p class=\"medium-margin-top large-margin-bottom\"> \nOur advanced security technology monitors each home, ensures the \nhome is locked between visits, and helps us rapidly respond to any \nout-of-the-ordinary situation.</p></div><div class=\"col-xs-12 col-sm-6\"><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/70b8a96917cb472097650f93c56fe386.jpg?service=web\" width=\"370\" od-scroll-enter class=\"safety-image short-image fade-in-up\"></div></div><div class=\"row safety-highlight-box\"><div class=\"col-xs-12 col-sm-6\"><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/3867c24bcc014415bb31f44c24c53f6c.jpg?service=web\" width=\"280\" od-scroll-enter class=\"safety-image phone fade-in-up\"></div><div class=\"col-xs-12 col-sm-6 content-col-right\"><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/dedicated-support-icon.svg?service=web\" height=\"60\" class=\"safety-highlight-icon support-icon\"><h4 class=\"safety-highlight-title\">Dedicated support</h4><p class=\"medium-margin-top large-margin-bottom\">Our expert customer support team is available by phone during \nall open house hours.</p></div></div></div></section><section class=\"safety-tips\"><div class=\"regular-container\"><div class=\"safety-tips-box\"><div image-background=\"safey-tips-icon.svg\" class=\"safety-tips-header\"><h2>Safety tips</h2><p>Any time you’re visiting an open house, you’ll want to do a \nfew smart things.</p></div><div class=\"safety-tips-list\"><div class=\"safety-item\">Location is one of the biggest drivers for moving. And it’s always \ngood to be aware of your surroundings. Research the neighborhood \nwhere you’ll be searching to familiarize yourself with its nuances.</div><div class=\"safety-item\">Let your friends and family know which homes you’ll be visiting. It’s a \nsmart move, and who knows, they may want to join you.</div><div class=\"safety-item\">It’s always a good idea to keep your mobile phone with you during \nopen houses. You’ll need yours to access our homes or to get in \ntouch with us for any questions.</div><div class=\"safety-item\">If you see something concerning at one of our homes, first ensure \nyour own safety and then please <a href=\"/contact-us\" target=\"_self\">let us know </a>so that we can address it.</div><div class=\"safety-item\">The <a href=\"https://www.nar.realtor/topics/realtor-safety/56-safety-tips-for-realtors\" target=\"_blank\">National Association of Realtors </a>offers these Safety Tips \nfor agents, and we agree.</div><div class=\"premarket-home-btn\">Are you visiting one of our pre-market homes?<span ng-click=\"safetyCtrl.tab = 'premarket'\" ng-class=\"{ active: safetyCtrl.tab === 'premarket' }\" class=\"show-tips-label\">Show tips</span></div><div ng-show=\"safetyCtrl.tab === 'premarket'\" class=\"premarket-tips\"><div class=\"safety-legend\">Opendoor enables agents and buyers to view homes that are not yet \non MLS. Some of these homes may still be under construction. It’s a \ngreat opportunity to get a sneak peak before a home hits the market. \nConsider these additional safety tips whenever walking around an \nactive construction site:</div><div class=\"safety-item\">Wear close-toed shoes with rubber soles and keep an eye out for stray nails</div><div class=\"safety-item\">Avoid wearing loose clothing, since it can get caught on rough surfaces </div><div class=\"safety-item\">Keep an eye out for any sharp edges, and watch out for wet paint</div><div class=\"safety-item\">Stay clear of anyone working above you (e.g., on a ladder, roof, scaffolding, or catwalk)</div><div class=\"safety-item\">Do not touch any construction tools, or go into any roped-off area </div><div class=\"safety-item\">Assume all wiring is live. If you see any exposed wire, keep your \ndistance and inform someone on the job site immediately</div><div class=\"safety-item\">Don’t bring children under the age of 18</div></div></div></div></div></section><section image-background=\"75455ca1558e46978800151fa5cd86c8.jpg\" class=\"pre-footer-cta text-center\"><div class=\"small-container\"><h2>Still have questions?<br>Feel free to get in touch.</h2><p class=\"sub-headline large-margin-bottom\">If you ever believe that you are in immediate danger,<br>don’t hesitate to dial 9-1-1 for local emergency response.</p><a href=\"/contact-us\" target=\"_self\" class=\"button primary\">Contact us</a></div></section></div>");;return buf.join("");
	}

/***/ },
/* 3606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.routes.ugc-terms', [__webpack_require__(600)]).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('ugc-terms', {
	    parent: 'root',
	    url: '/ugc-terms',
	    template: __webpack_require__(3607)(),
	    data: {
	      meta: {
	        titleSuffix: ' | User Generated Content Terms of Use',
	        description: "Read Opendoor's terms of use for user generated content.",
	        keywords: 'Opendoor User Generated Content Terms of Use'
	      }
	    }
	  });
	}]).name;

/***/ },
/* 3607 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"terms\"><section><div class=\"small-container\"><div class=\"prose\"><div class=\"chapeau text-blue text-center\">Legal informations</div><h2 class=\"text-center\">Opendoor User Generated Content Terms of Use</h2><p>You are reading this page because OpenDoor Labs Inc. \n(“Opendoor,” “Company,” “we,” or “us”) has reached out to you for permission \nto publish your social media content on Opendoor’s websites, \nsocial media channels, and other promotional materials. </p><p>If you want to give us permission to use your social media content, please \nreply with the hashtag #OpendoorPhoto and provide a link to your social \nmedia content. When you do, you are also agreeing to be bound by these Terms of Use. </p><p>These Terms of Use describe Opendoor’s collection and publishing of social media \ncontent, such as photographs, text, moving images, illustrations, audio clips, \nvideo clips, comments, and any other materials and associated metadata or\nlocation information, any profile information that is accessible from third\nparty social media platforms (such as Instagram, Pinterest, and Facebook) \nin accordance with the procedures established by the platform, and \nidentifying information that includes public displays of your name, \nimage, likeness and persona (“User Generated Content”) from social media\nplatforms on Opendoor’s websites, such as <a href=\"https://www.opendoor.com/\">www.opendoor.com </a>and others (the “Site”), social media platforms, promotional materials and\nother communication channels and content (“Opendoor Channels”) for use by\nOpendoor and its affiliates in connection with its business, such as Opendoor’s \nmarketing, promotional, advertising and other activities for\npublicity purposes (“Opendoor Activities”).</p><p>Opendoor reserves the right, at its sole discretion, to change, modify, \nadd or remove portions of these Terms of Use at any time. It is your\nresponsibility to check these Terms of Use each time you\ngrant authorization for us to use your User Generated Content. </p><h5>User Generated Content License</h5><ol><li>You hereby represent and warrant that you (a) are at least 18 years of age; \n(b) own and control all rights, title and interest in the User Generated \nContent you license; (c) you have all rights, permissions and consents \nnecessary to create and publish the User Generated Content, such as the\nright or authorization to use names, images, likeness, voice, and other \nidentifying information of any third party referenced or included in the \nUser Generated Content subject to this license; (c) the creating and posting \nof your User Generated Content does not violate the privacy rights, \npublicity rights, copyrights, contract rights, intellectual property rights \nor any other rights of any person; (d) have all rights necessary to license\nthe User Generated Content to the Licensed Parties; (e) have complied with\nall applicable laws and regulation associated with acquiring, producing, and \npublishing the User Generated Content; (f) the User Generated Content is not\nlibelous, defamatory, obscene, pornographic, abusive, indecent, threatening,\nharassing, hateful, or offensive or otherwise unlawful. </li><br><li>You hereby grant to Opendoor and its related companies, agents, licensees, \nsublicensees, contractors, successors, legal representatives, assigns, and \nthird-party service providers, and their respective partners, marketing or \npublic relations agencies, and other affiliates (the “Licensed Parties”) a \nnon-exclusive, royalty-free, fully paid, worldwide, perpetual, irrevocable and \nfully sublicensable license to use, reproduce, modify, adapt, publish, translate,\ncreate derivative works from, distribute, perform and publicly display your \nUser Generated Content, in whole or in part, on the Site, on Opendoor Channels,\nin any marketing, promotional and advertising activities, on third-party websites \nand apps, and in any media for promotional and publicity purposes. \nNothing in this license transfers your ownership of the User Generated Content \nto the Licensed Parties. Nothing in this license requires the Licensed Parties \nto use or publish your User Generated Content at all, in any specific way, or\non a specific platform. Licensed Parties will reject and remove any \nUser Generated Content which Licensed Parties determine, in their sole discretion,\nto be in violation of any provision of these Terms of Use.</li><br><li>You also grant the Licensed Parties the right to use your username, real name, \nlikeness, persona, description of you, location or other identifying information \nincluding your voice in connection with any use of your \nUser Generated Content by the Licensed Parties.</li><br><li>You hereby release, discharge, indemnify, and agree to hold harmless the\nLicensed Parties and any person acting on their behalf from any liability \nrelated in any way to the Licensed Parties’ use of your User Generated Content.</li><br><li>The User Generated Content you license is deemed non-confidential and the\nLicensed Parties have no obligation to protect the confidentiality of any \ninformation contained in the User Generated Content except pursuant to the\nLicense Parties’ privacy policies. By accessing the Site or Opendoor Channels,\nyou accept and agree to the Licensed Parties’ collection of any personal \ninformation you provide for the Licensed Parties’ use and disclosure in\nconnection with the use of your User Generated Content as described herein. </li></ol><br><h5>Miscellaneous</h5><ol><li>To the extent that your User Generated Content is displayed on the Site, \nany of the Opendoor Channels, or in connection with Opendoor Activities, \nyou also will be subject to additional terms of use, agreements, guidelines,\nor rules determined by Licensed Parties to be applicable to the Site,\nOpendoor Channels, or Opendoor Activities, such as those set forth on the\nOpendoor website at <a href=\"/terms\" target=\"_self\">www.opendoor.com/terms. </a>You hereby acknowledge and agree to be bound by these additional terms of use, \nagreements, guidelines, or rules provided or posted by Opendoor and Licensed Parties.</li><br><li>The Site, Opendoor Channels, or Opendoor Activities may be protected by copyright, \ntrademarks, service marks, and other intellectual property rights which are\ngoverned by U.S. and worldwide copyright laws and treaty provisions, privacy and\npublicity laws, and communication regulations and statutes. You acknowledge and \nagree that you do not acquire any ownership, entitlements, or other rights in\nproprietary information and materials of Opendoor or Licensed Parties by \nauthorizing Licensed Parties’ use of your User Generated Content or otherwise \nusing or accessing the Site or Opendoor Channels.</li><br><li>If a court of law having jurisdiction over this matter finds that any provision\nof these Terms of Use is invalid or unenforceable, you agree that these \nTerms of Use will nonetheless be enforced to the maximum extent to which \nit is found by the court to be legally enforceable.</li><br><li>These Terms of Use will be governed by applicable federal law and the \nlaws of the state of California, without reference to its choice of\nlaw requirements. Nothing herein will be construed a waiver of the\nLicensed Parties’ rights to the User Generated Content under federal\nand state common laws and statutes, such as rights of public domain and fair use.</li></ol></div></div></section></div>");;return buf.join("");
	}

/***/ },
/* 3608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.routes.unsubscribed-customer', [__webpack_require__(600)]).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('unsubscribe', {
	    parent: 'root',
	    url: '/unsubscribed',
	    template: __webpack_require__(3609)()
	  });
	}]).name;

/***/ },
/* 3609 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"route-unsubscribed\"><section class=\"padded\"><div class=\"container text-center\"><div class=\"row\"><div class=\"col-xs-12\"><h2>Sorry to see you go!</h2><br><p>You have been unsubscribed from all emails.</p></div></div></div></section></div>");;return buf.join("");
	}

/***/ },
/* 3610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.routes.vendor_help.index', [__webpack_require__(3551), __webpack_require__(3611), __webpack_require__(3613), __webpack_require__(3615), __webpack_require__(3617)]).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('vendor_help', {
	    parent: 'root',
	    url: '/vendor-help',
	    template: __webpack_require__(3619)(),
	    data: {
	      meta: {
	        titleSuffix: " | Vendor Help Center"
	      }
	    },
	    controller: function () {
	      controller.$inject = ["$location", "$state", "$scope", "$anchorScroll", "ALL_MARKETS", "VendorQuestion"];
	      function controller($location, $state, $scope, $anchorScroll, ALL_MARKETS, VendorQuestion) {
	        _classCallCheck(this, controller);
	
	        this.showVendorHelpModal = false;
	        this.VendorQuestion = VendorQuestion;
	        this.markets = (0, _lodash.flatten)([ALL_MARKETS, 'other']);
	        if ($location.path() === '/vendor-help') {
	          $state.go('vendor_help.prospective');
	        }
	        // for od-collapsible-question, scrolls after components have computed their hashes
	        $scope.$on('$viewContentLoaded', function () {
	          return $anchorScroll();
	        });
	      }
	
	      _createClass(controller, [{
	        key: 'openVendorHelpModal',
	        value: function openVendorHelpModal() {
	          this.question = new this.VendorQuestion();
	          this.showVendorHelpModal = true;
	        }
	      }, {
	        key: 'sendVendorQuestion',
	        value: function sendVendorQuestion() {
	          var _this = this;
	
	          this.question.$save().then(function () {
	            _this.showVendorHelpModal = false;
	            _this.question = new _this.VendorQuestion();
	          });
	        }
	      }]);
	
	      return controller;
	    }(),
	    controllerAs: 'vendor_help'
	  });
	}]).name;

/***/ },
/* 3611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.routes.vendor_help.prospective', []).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('vendor_help.prospective', {
	    url: '/prospective',
	    template: __webpack_require__(3612)()
	  });
	}]).name;

/***/ },
/* 3612 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<h2 class=\"large-margin-bottom\">Getting Started</h2><od-collapsible-question question=\"How do I get set up with Opendoor?\" class=\"border-top\"><p>Welcome to Opendoor! We look forward to partnering with you. Before we do, we need to\ncover a few items. Here’s an overview of the process:</p><ol class=\"medium-margin-top\"><li>Trade Partner Sourcing/Recruiting  </li><li>Trade Partner Document Collection via NetVendor  (W9, VA, insurance, background check, etc.)</li><li>Trade Partner Portal Training  </li><li>Ready for Work</li></ol><p class=\"medium-margin-top\">New Trade Partners are&nbsp;<b>required</b> to enroll through NetVendor for compliance verification. Then, Opendoor will train Trade Partners\non our Trade Partner portal to complete work orders, maintenance orders, and invoicing.</p></od-collapsible-question><od-collapsible-question question=\"What documents do I need to work with Opendoor?\"><p>NetVendor, a 3rd party provider, will collect onboarding documentation and notify Opendoor\nwhen a Trade Partner is compliant and ready for Opendoor training. NetVendor works with us to ensure\nall of our Trade Partners are up to our standards and prompt our payment partner to send registraion \ninformation. </p><ul class=\"with-bullets medium-margin-top\"><li>W-9</li><li>Certificate of Insurance (for each market)</li><li>License (if applicable, for each market)</li><li>Vendor Agreement (VPA)</li><li>Payment Information</li><li>Legal Org Information and Key Contact Information</li><li>Background Checks and Comprehensive Screening</li></ul><p>Following NetVendor registration, onboarding Trade Partners receive a registration email \nfrom Gapify, our payments partner. Registering here allows Trade Partners to link their \npayment account to ensure timely payment. </p></od-collapsible-question><od-collapsible-question question=\"What are the insurance requirements?\"><p>For the table below, Tiers are as follows: </p><ol class=\"medium-margin-top\"><li>Tier 1 = Off Site (Engineer, design, IT, consulting...)</li><li>Tier 2 = Onsite / non-renovation (measurer, sign install, photographer...) </li><li>Tier 3 = Maintenance (Landscape, Pool, Cleaning) & Unlicensed Tradespeople </li><li>Tier 4 = General Contractors / Licensed Trades </li></ol><table class=\"basic-table medium-margin-bottom medium-margin-top\"><tr><td></td><td><b>Tier 4</b></td><td><b>Tier 3</b></td><td><b>Tier 2</b></td><td><b>Tier 1</b></td></tr><tr><td><b>General Liability </b></td><td>$1 million / $2 million aggregate</td><td>$500,000 </td><td>E&O Only</td><td>E&O Only</td></tr><tr><td><b>Auto (Commercial or Personal policy)</b></td><td>$300,000</td><td>$300,000</td><td>$300,000</td><td>N/A</td></tr></table><p>&nbsp;<b>Workers Comp:</b>The greater of (a) $500,000 (or waiver) or (b) the maximum amount prescribed by local \nlaw.  (Note: for sole proprietors, the Worker’s Comp waiver is available through NetVendor)</p><p>These are Opendoor’s insurance requirements. Trade Partners may need to upgrade or change\npolicies to meet our minimum standards.</p><p class=\"medium-margin-top\">Opendoor must be listed as an additional insured for the General Liability portion of\nthe certificate.</p></od-collapsible-question><od-collapsible-question question=\"What do I need to get a Certificate of Insurance?\"><p>NetVendor will reach out on behalf of the Trade Partner to obtain COI from each insurance agent. The\nagent will need to submit a complete COI and submit using the unique document number\nNetVendor provides.</p><ul class=\"with-bullets medium-margin-top\"><li>General Liability as required by tier</li><li>Worker’s Compensation >$500,000</li><li>Commercial Auto Liability as required by tier</li><li>Opendoor listed as addtl. Insured under General Liability</li><li>Description of operations filled out with exact verbiage</li><li>Certificate Holder listed</li></ul><p class=\"medium-margin-top\">Please make sure the certificate you send matches the sample.</p><p class=\"medium-margin-top\"><b>Note to agents:</b> If your client does not have sufficient policy limits, please notify compliance@netvendor.net\nand your client immediately.</p><p class=\"medium-margin-top\"><b>Note to vendors:</b>You can send the sample to your agent. This form is industry standard for insurance\npolicies. NetVendor will send your agent a document # which must be included when they submit.</p><p class=\"medium-margin-top\"><b>Tier 1 Sample COI:</b>Required for Off Site work (Engineer, design, IT, consulting...)</p><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/2023-10-1696957867076-42803.jpg?service=web\" class=\"full-width medium-margin-top\"><p class=\"medium-margin-top\"><b>Tier 2 Sample COI:</b>Required for Onsite / non-renovation work (measurer, sign install, photographer...)</p><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/2023-10-1696957926766-32035.jpg?service=web\" class=\"full-width medium-margin-top\"><p class=\"medium-margin-top\"><b>Tier 3 Sample COI:</b>Required for Maintenance (Landscape, Pool, Cleaning) & Unlicensed Tradespeople</p><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/2023-10-1696957979438-87672.jpg?service=web\" class=\"full-width medium-margin-top\"><p class=\"medium-margin-top\"><b>Tier 4 Sample COI:</b>Required for General Contractors & Licensed Tradespeople</p><img src=\"https://images.opendoor.com/source/s3/imgdrop-production/2023-10-1696958000034-21923.jpg?service=web\" class=\"full-width medium-margin-top\"></od-collapsible-question><od-collapsible-question question=\"How can I expedite the process?\"><ul class=\"with-bullets\"><li>Make sure insurance policies are active and meet requirements.</li><li>Contact insurance agents for GL, WC, Auto and follow-up regularly with them.</li><li>Have business information handy during enrollment.</li></ul></od-collapsible-question><od-collapsible-question question=\"Anything else?\"><ul class=\"with-bullets\"><li>If you operate as multiple entities, you will need to enroll each one.</li><li>NetVendor typically responds within 1-2 business days.</li><li>If you already have a NetVendor account, click on the enrollment link, click log in and\nsubscribe. Please call 503-922-1111 (option 2) if you have any issues.</li></ul></od-collapsible-question><od-collapsible-question question=\"What’s the best way to reach Opendoor?\"><ul class=\"with-bullets\"><li>Opendoor contact: trade-partners@opendoor.com</li><li>NetVendor contact: compliance@netvendor.net</li><li>Opendoor accounts payable contact: accountspayable@opendoor.com</li></ul><p class=\"medium-margin-top\"><b>Tip:</b> You may want to create an opendoor@yourcompany.com email for correspondence.</p></od-collapsible-question><h2 class=\"large-margin-bottom large-margin-top\">Next Steps</h2><od-collapsible-question question=\"How do I log into Opendoor’s system?\" class=\"border-top\"><ol class=\"medium-margin-top\"><li>Email your Opendoor Trade Partner manager with contact information (name, email, phone number) for both your\nlegal entity (e.g. Trade Partner Construction, LLC) and your key point of contact (e.g. your\noffice admin, or owner).\nWe recommend that you create a separate email address (e.g. opendoor@tradepartnerconstruction.com)\nfor your legal entity.</li><li>Opendoor will create an organization for your legal entity. Within that organization, we\nwill create an account for your key point of contact.</li><li>Open the email from Opendoor asking you to reset your password. Click on the link and create\nyour password.</li><li>Once you’ve created your password, go to opendoor.com/vendor to see the&nbsp;<a href=\"https://www.opendoor.com/vendor\">Vendor Portal</a>.</li></ol></od-collapsible-question><od-collapsible-question question=\"How do I add an account to my organization?\"><ol class=\"medium-margin-top\"><li>Email your Opendoor Trade Partner manager with the contact info (name, email, phone number) of the\nperson you’d like to add.</li><li>Opendoor will then notify you once the account has been created.</li><li>Open the email from Opendoor asking you to reset your password. Click on the link and create\nyour password.</li></ol></od-collapsible-question>");;return buf.join("");
	}

/***/ },
/* 3613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.routes.vendor_help.current', []).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('vendor_help.current', {
	    url: '/current',
	    template: __webpack_require__(3614)()
	  });
	}]).name;

/***/ },
/* 3614 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<h2 class=\"large-margin-bottom\">About Work Orders</h2><h3 class=\"large-margin-bottom\">General</h3><od-collapsible-question question=\"What do the different categories like New, Waiting For Allowed Start, Ready To Start, etc. mean?\" class=\"border-top\"><p> \nEach category represents a stage in the progress of a Work Order and requires a specific action\nfrom you or from Opendoor. You can learn more about about each category and what is expected\nfrom you by watching this video below or reading&nbsp;<a href=\"https://cdn.opendoor.com/OpendoorVendorWorkOrderCategories.pdf\">this document</a>.</p><div class=\"video-embed-container medium-margin-top\"><iframe src=\"https://www.youtube.com/embed/I4ZgC3lTXHo\" frameborder=\"0\" allowfullscreen></iframe></div></od-collapsible-question><od-collapsible-question question=\"Where do I find necessary information on a work order?\"><p>Once you click into a specific work order, you’ll see 3 tabs: General, Line Items, and \nPhotos.</p><ul class=\"with-bullets medium-margin-top\"><li><b>General:</b> Contact and property access information, schedule, documents, and notes.</li><li><b>Line Items:</b> Descriptions and pricing for the work.</li><li> <b>Photos:</b> Easily view before and after photos and approve completed work.</li></ul><p class=\"medium-margin-top\">Once work is completed and approved by Opendoor, you can invoice from either the General\ntab or the Line Items tab.</p></od-collapsible-question><od-collapsible-question question=\"What is the best way to communicate with Opendoor?\"><p>The Vendor Portal is the best way to communicate with Opendoor. Please use the functions\nprovided to communicate any changes to schedule, pricing, or scope of work. The Notes section\nof each work order is the best way to communicate directly with your Opendoor contact.</p></od-collapsible-question><od-collapsible-question question=\"How do I let Opendoor know that work has been started?\"><p>Once work has begun on a property, you can mark it as started by clicking a button on the work\norder list page or on the individual work order Line Items tab. If you have workers using the\nOn-Site Portal, they can also click Start Work once they reach the property. Please mark work\norders as started on the day that work actually begins.</p></od-collapsible-question><od-collapsible-question question=\"How do I let Opendoor know that work is complete?\"><ol class=\"medium-margin-top\"><li>Ensure that all line items have After photos, are marked as complete, and are marked as approved.</li><li> \nClick the green Mark as Complete button to let Opendoor know that your work is finished and\nthen Opendoor will complete the Quality Control process.</li></ol></od-collapsible-question><od-collapsible-question question=\"What happens if the work doesn’t pass the Quality Control process?\"><p>If Opendoor is not satisfied with the work, you will see the work order move to “Rework\nNeeded” in the portal. You will also receive an email letting you know. Any items that need\nrework will be clearly indicated and will have a reason for requesting the rework. You are\nexpected to address rework as soon as possible.</p></od-collapsible-question><h3 class=\"large-margin-top large-margin-bottom\">Schedule and Line Items</h3><od-collapsible-question question=\"What do the different dates mean?\" class=\"border-top\"><ul class=\"with-bullets\"><li> <b>Opendoor Target Start Date:</b> Date that Opendoor expects the work to be started on.</li><li><b>Opendoor Target Finish Date:</b> Date that Opendoor expects the work to completed on or before.</li><li><b>Vendor Estimate Start, Finish Dates:</b> These only appear when you’ve communicated a schedule that differs from the Opendoor Target\nStart and Finish Dates.</li><li><b>Actual Dates:</b> Dates that work was actually started or completed on.</li></ul></od-collapsible-question><od-collapsible-question question=\"What if I need to update the schedule?\"><img src=\"{{&quot;912ca08db4cd4005a8fce2a852541c8d.png&quot; | imageUrl}}\" class=\"full-width\"><p>You can communicate schedule changes to Opendoor by using the Update Schedule button on the\nGeneral tab and entering the reason for the change and the updated dates. Timely work\ncompletion is important, but if you believe you will be delayed for any reason, please update\nthe schedule as soon as possible.</p></od-collapsible-question><od-collapsible-question question=\"What if the description or pricing on a line item is incorrect?\"><img src=\"{{&quot;82025730a2d34561bcea189967bdd6e7.png&quot; | imageUrl}}\" class=\"full-width\"><p>This is for when you need to make an adjustment to an existing line item (e.g. increase carpet\nfrom 200 sqft to 250 sqft), rather than adding a new line item (e.g. replace window screens).</p><ol><li>Click on this icon on the right-hand side of the line item.</li><li>Write a reason for the change, new revised description, and incremental cost changes for the line item.\nExample: If the old line item is for 200 sqft of carpet and you’re changing it to 250 sqft,\nyou’d write a reason for the change (need additional 50 sqft of carpet),\nnew revised description (install 250 sqft of carpet) as well as the price of the\nincremental change (the price of the 50 sqft)</li><li>Once you do this, Opendoor will either accept or decline your request.</li></ol></od-collapsible-question><od-collapsible-question question=\"How can I see the history of change requests?\"><p>In the list of line items, you will always see the current state of a given line item, with\nthe most up-to-date pricing and description.</p><img src=\"{{&quot;ee76fdbcb9824d5885569cd1102402a4.png&quot; | imageUrl}}\" class=\"full-width medium-margin-top\"><p class=\"medium-margin-top\">If an item has a history of change requests, it will have a button that looks like a clock on\nthe right. Clicking this button will display the original line item and all changes bringing\nit to the current state.</p></od-collapsible-question><od-collapsible-question question=\"What if I identify work that needs to be done that is not on the work order?\"><img src=\"{{&quot;8250c3e2f19f48b98e31de5d4628411e.png&quot; | imageUrl}}\" class=\"full-width\"><ol><li>Click Add New Line Item.</li><li>Fill out the item as you see fit then click save.</li><li>Once you do this, Opendoor will either accept or decline your request.</li></ol></od-collapsible-question><h3 class=\"large-margin-bottom large-margin-top\">Photos</h3><od-collapsible-question question=\"I’m the sole proprietor. How should I provide After photos?\" class=\"border-top\"><img src=\"{{&quot;a378ea3c932e40cfbfae5076ac86fe70.png&quot; | imageUrl}}\" class=\"full-width\"><ol class=\"medium-margin-top\"><li> \nIf you are already logged in, go to opendoor.com/on-site. If you are not logged in, go to\nopendoor.com/vendor, log in with your email and password, then find the Link to On-Site\nPortal in the top-right menu.</li><li>You’ll have full access to all your work orders, so you’ll be able to upload After photos,\nmark line items as complete, and mark them as approved as you go along.</li></ol></od-collapsible-question><od-collapsible-question question=\"I’m a large vendor who wants to use the On-Site Portal. How should I provide After photos?\"><img src=\"{{&quot;b0be5d2e38aa4b629e259b51c8d182ac.png&quot; | imageUrl}}\" class=\"full-width\"><ol class=\"medium-margin-top\"><li>Assign each line item to an on-site worker, or have a foreperson with access to all your\nwork orders.</li><li>As the work order progresses, have your workers or foreperson take After photos and mark\nitems as complete.</li><li>Have someone with approval privileges (either an on-site worker or someone with access to\nthe Vendor Portal) approve the completion of each item.</li></ol></od-collapsible-question><od-collapsible-question question=\"I’m a large vendor who does not want to use the On-Site Portal. How should I provide After photos?\"><img src=\"{{&quot;1c0bbe540d5440fc81f24d6f989abf2c.png&quot; | imageUrl}}\" class=\"full-width\"><ol class=\"medium-margin-top\"><li>At the office, print out the work order and hand it to your workers.</li><li>As the work order progresses, take photos of your work.</li><li>Back at the office, manually upload those photos into the vendor portal for each line item\nand mark line items as complete and then as approved.</li></ol></od-collapsible-question><od-collapsible-question question=\"Why does Opendoor require After photos?\"><p>In our ongoing effort to streamline our vendor and quality control process, Opendoor requires\nafter photos for each line item completed. We believe this reduces the amount of rework\nneeded at our projects and ensures a quicker turnaround time in processing payment invoices.\nAfter photos to verify work completion are standard in the industry.</p></od-collapsible-question><od-collapsible-question question=\"How can I take a good After photo?\"><p class=\"medium-margin-bottom\">The most effective way to take “After” photos to speed the verification of work completed is\nto take a photo in the same angle and distance from the “Before” photo (either from the\nhome condition repair report or from your crews photo documenting the current condition before\nwork starts).</p><img src=\"{{&quot;44072af5763148148d37da03f2cbb706.png&quot; | imageUrl}}\" class=\"full-width\"><p class=\"medium-margin-top\">This example shows a “Before” and “After” work within the same angle with enough environmental\nfeatures to allow Opendoor to complete its initial quality assurance of the work (i.e. range\nreplacement from white to stainless steel) has been completed.</p></od-collapsible-question><od-collapsible-question question=\"Are Before photos required?\"><p>In many cases, Opendoor will provide Before photos for line items so that you can see exactly\nwhat needs to be addressed. Additional Before photos are appreciated, but not required. \nProviding both Before and After photos makes the work performed clear to all parties.</p></od-collapsible-question><h3 class=\"large-margin-bottom large-margin-top\">Invoicing</h3><od-collapsible-question question=\"How do I submit an invoice?\" class=\"border-top\"><p class=\"medium-margin-bottom\"><b>For Property Vendors</b></p><img src=\"{{&quot;54b0ccfc4a584871a06a7114861c2718.png&quot; | imageUrl}}\" class=\"full-width\"><ol class=\"medium-margin-top\"><li>Click on a work order that’s in the “Invoiceable” stage and scroll to the bottom of the\nGeneral tab.</li><li>Click “Create New Invoice” and verify the amounts displayed by clicking the checkmark on the\nright.</li><li>Upload an invoice with the total amount into the Documents column, as shown above. It should\ninclude the PDF Invoice number from the invoice, as well as an itemized line item for every scope\nitem and cost that was completed.</li><li>Submit by clicking the button that looks like a paper plane.</li></ol><p class=\"large-margin-top medium-margin-bottom\"><b>For Maintenance Vendors</b></p><img src=\"{{&quot;da516959fce8443a97ccc73da97d39f8.png&quot; | imageUrl}}\" class=\"full-width\"><p class=\"medium-margin-top\">Opendoor will accept one invoice for all maintenance work you’ve done for a month for each\nmarket. For example, if you’ve done 10 jobs across Phoenix and Dallas-Ft. Worth for the month\nof August, you’ll submit two invoices (one for each market), as opposed to 10 separate\ninvoices.</p><ol><li>Go to the&nbsp;<a href=\"http://opendoor.com/vendor/invoices\">Invoices tab</a>.</li><li>Click on the “Invoiceable” tab and click on a month you’d like to invoice Opendoor for.</li><li>Ensure that you’ve marked all completed requests as complete.</li><li>Click on “Create Invoice” then submit your invoice.</li></ol><p class=\"large-margin-top\"><b>For property invoices that do not require a work order</b></p><p>Please email propertyinvoices@opendoor.com with your invoice.</p></od-collapsible-question><od-collapsible-question question=\"What are the invoice requirements?\"><img src=\"{{&quot;b909441e4089486880e42b429e612a68.png&quot; | imageUrl}}\" class=\"full-width\"><ol class=\"medium-margin-top\"><li>Unique invoice number (please do not reuse invoice numbers). Our accounts payable system and\nprocessors flag duplicates resulting in delays in processing.</li><li>Include Opendoor’s Name</li><li>Total amount due (including applicable taxes) should reflect current invoice total only.\nPlease do not include running totals or total outstanding balance.</li><li>Include service address (Not required for Maintenance Schedule invoices).</li><li>Include description of the services performed.</li><li>Date(s) that the work covers (for Maintenance Schedules, ONE invoice per Month, submitted at\nthe beginning of the month for the previous month’s work).</li><li>File format should be PDF only with one invoice per file.</li><li>Follow this filename convention, “Vendor name_Date_Invoice Number”.</li><li>For non-work order invoices, please identify the Opendoor individual that requested/is\nresponsible for the service on the bill (i.e., “Attn: Jane Smith”). </li><li>For work order and maintenance schedule invoices, payment is fastest if the invoice amount\nmatches the work order or invoiceable amount for maintenance schedule. If the invoice is\ngreater than the work order, the renovation manager needs to approve. If less, adjust the\ncost in the admin portal by submitting a negative cost item.  </li><li>Vendor name on invoice must match the legal name or DBA identified on the W9. </li></ol></od-collapsible-question><od-collapsible-question question=\"When will I get paid?\"><ul class=\"with-bullets medium-margin-bottom\"><li><b>Work orders</b> (renovation, repairs, etc.): 15 days from invoice submission</li><li><b>All other work</b> (home condition assessments, photos, landscaping, pool cleaning, home cleaning, etc.): 30 days from invoice\nsubmission</li></ul><p><b>Payments are made via ACH or Check. We recommend vendors sign up for ACH as payment will be faster.</b> Vendors select which payment option they prefer when they complete their NetVendor enrollment.\nExisting vendors that wish to set up payment via ACH should send an email to\naccountspayable@opendoor.com with their bank account, routing numbers, and email address to\nreceive remittance notification. </p></od-collapsible-question><od-collapsible-question question=\"I have further questions about getting paid. Who should I ask?\"><p>Please email us at accountspayable@opendoor.com.</p></od-collapsible-question><h2 class=\"large-margin-bottom large-margin-top\">About the On-Site Portal</h2><h3 class=\"large-margin-bottom\">How to Use the On-Site Portal</h3><od-collapsible-question question=\"What is the On-Site Portal?\" class=\"border-top\"><img src=\"{{&quot;fb919227b8b444c9bf65532fb8703bfa.png&quot; | imageUrl}}\" class=\"full-width\"><p class=\"medium-margin-bottom medium-margin-top\">The On-Site Portal is designed to help you communicate Opendoor work orders to the\nmembers of your team who work<b> on-site</b> in Opendoor homes. The On-Site portal does not include prices.</p><p class=\"medium-margin-bottom\">It’s meant to be used on a smartphone or tablet, but can also be used on a computer. The\nOn-Site Portal includes need-to-know information such as:</p><ul class=\"with-bullets medium-margin-bottom\"><li>Addresses</li><li>Property access information</li><li>Schedule</li><li>Work required</li><li>Before photos</li></ul><p class=\"medium-margin-bottom\">Workers using the On-Site Portal can:</p><ul class=\"with-bullets\"><li>Submit After photos</li><li>Mark items as complete</li><li>Send notes about specific items or about general progress</li></ul></od-collapsible-question><od-collapsible-question question=\"Do I have to use the On-Site Portal?\"><p>No. Use of the On-Site Portal is 100% optional. We believe it is the most efficient way to\ncommunicate work to your team and progress to Opendoor, but you are not required to use it.</p></od-collapsible-question><h3 class=\"large-margin-bottom large-margin-top\">General</h3><od-collapsible-question question=\"How do I use the On-Site Portal?\" class=\"border-top\"><img src=\"{{&quot;2e6d33bcdbd6400aa1113c0718a4b332.png&quot; | imageUrl}}\" class=\"full-width\"><ol class=\"medium-margin-top\"><li>Set up accounts for your workers and set the appropriate permissions on the<a href=\"https://opendoor.com/vendor/on-site-workers\"> On-Site Workers tab</a> in the Vendor Portal.</li><li>Assign line items on work orders to your workers.</li><li>Send a link to your workers so that they can access the On-Site Portal.</li><li>Your workers will see what they need to do and submit After Photos as they complete\neach line item.</li><li>Approve each of the photos or let them know that they need to do rework.</li></ol></od-collapsible-question><od-collapsible-question question=\"How do I set up On-Site Portal accounts?\"><img src=\"{{&quot;203404886cf1485fbf3579a5579d5883.png&quot; | imageUrl}}\" class=\"full-width\"><ol class=\"medium-margin-top\"><li>Go to the&nbsp;<a href=\"https://www.opendoor.com/vendor/on-site-workers\">On-Site Workers link</a> at the top of the Vendor Portal.</li><li>Click “Add New Worker”.</li><li>Enter an identifier for the worker, choose the desired permissions, and enter an email if\nyou would like the worker to receive email notifications.</li></ol></od-collapsible-question><od-collapsible-question question=\"What do the different permissions for on-site workers mean?\"><img src=\"{{&quot;fd0ce476e0b04235b06ec29862575f98.png&quot; | imageUrl}}\" class=\"full-width\"><p class=\"medium-margin-top\"><b>“Can view all work orders for an organization” vs. \"Can view only work orders & line items\nassigned specifically to them”</b></p><ul class=\"with-bullets medium-margin-top medium-margin-bottom\"> <li><b>The Former:</b> Typically for people who oversee all your properties, such as a foreperson or a supervisor.  </li><li><b>The Latter:</b> Typically for people who work on a limited number of properties at a time, such as a\ntechnician or a subcontractor.</li><li><b>Note:</b> If you have access to the Vendor Portal, you’ll be able to see every work order assigned to\nyour organization.</li></ul><p class=\"medium-margin-top\"><b>“Can approve completed line items” vs. “Cannot approve line items”</b></p><ul class=\"with-bullets medium-margin-top\"><li><b>The Former:</b> Typically for people who oversee all your properties, such as a foreperson or a supervisor.</li><li><b>The Latter:</b> Typically for people who work on a limited number of properties at a time, such as a\ntechnician or a subcontractor.</li><li><b>Note:</b> If you have access to the Vendor Portal, you’ll be able to approve completed line items.</li></ul></od-collapsible-question><od-collapsible-question question=\"Do I have to set up an On-Site Portal account if I have access to the Vendor Portal?\"><p>No. Anyone with access to the Vendor Portal automatically has access to the On-Site Portal\nwith both “View All” and “Approval” permissions. If you have access to the Vendor Portal,\nyou can get to the On-Site Portal by using the “Link to On-Site Portal” in the menu bar.</p></od-collapsible-question><od-collapsible-question question=\"How do I assign work to on-site workers?\"><img src=\"{{&quot;9d320399cf4d4cb68c2ed18be3d410d3.png&quot; | imageUrl}}\" class=\"full-width\"><p class=\"medium-margin-top\">As you assign line items to workers, you’ll see a summary of worker assignments at the top of\nthe Line Items tab.</p><p class=\"medium-margin-top medium-margin-bottom\"><b>Assigning One-by-One</b></p><img src=\"{{&quot;2e7d4895a0944da190669a5b15903510.png&quot; | imageUrl}}\" class=\"full-width\"><p class=\"medium-margin-top\">You can assign individual line items by using the blue Assign button and selecting a worker\nfrom the menu.</p><p class=\"medium-margin-top medium-margin-bottom\"><b>Assigning Many at a Time</b></p><img src=\"{{&quot;a1352ead005f41c0b482955b0479cb7c.png&quot; | imageUrl}}\" class=\"full-width\"><ul class=\"with-bullets medium-margin-top\"><li><b>Assigning some:</b> Check the checkbox to the left of each line item to be assigned and then choose a worker\nfrom the menu at the bottom.</li><li><b>Assigning all:</b> Check the checkbox at the very top of the list of items to select all items and then choose\na worker from the menu at the bottom.  </li></ul></od-collapsible-question><od-collapsible-question question=\"How do workers log in to the On-Site Portal?\"><ol><li>Copy the link by using the Copy button on the On-Site Workers page or at the top of the Line\nItems tab of a work order that a work order has been assigned to.</li><li>Paste the link into an email or text to your worker.</li><li>After clicking the link, workers will be prompted to enter the identifier that you assigned\nto them.</li><li>Once workers are logged in on a device, they will should not need to log in again on that\ndevice unless they specifically log out.  If they do need to log in again, they will need to\nuse one of the special links again.</li></ol></od-collapsible-question><od-collapsible-question question=\"How can I train my team to use the On-Site Portal?\"><p>The On-Site Portal was designed to be intuitive and easy to use. You can share&nbsp;<a href=\"https://cl.ly/1X0B071h0U2p/on-site%20portal%20tutorial.pdf\">this training guide</a> with your team to train them.</p></od-collapsible-question><od-collapsible-question question=\"What if I do not want my team to use the On-Site Portal?\"><p>That’s completely fine. On the Line Items tab, you’ll find a number of print options so that\nyou can easily print work orders for your team. You can print work orders with or without\nprices. You can print entire work orders or individual assignments. If you are not using the\nOn-Site Portal, you will still need to provide After photos. You can upload the photos and\nmark items complete in the Vendor Portal.</p></od-collapsible-question>");;return buf.join("");
	}

/***/ },
/* 3615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.routes.vendor_help.media', []).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('vendor_help.media', {
	    url: '/media',
	    template: __webpack_require__(3616)()
	  });
	}]).name;

/***/ },
/* 3616 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<h2 class=\"large-margin-bottom\">Vendor Portal</h2><h3>Work Order List</h3><div class=\"video-embed-container medium-margin-top\"><iframe src=\"https://www.youtube.com/embed/I4ZgC3lTXHo\" frameborder=\"0\" allowfullscreen></iframe></div><h3 class=\"medium-margin-bottom large-margin-top\">Individual Work Order Page</h3><div class=\"video-embed-container medium-margin-top\"><iframe src=\"https://www.youtube.com/embed/MvIusYo2VOg\" frameborder=\"0\" allowfullscreen></iframe></div><h3 class=\"medium-margin-bottom large-margin-top\">Overview of Vendor Portal and On-Site Portal</h3><div class=\"video-embed-container medium-margin-top\"><iframe src=\"https://www.youtube.com/embed/pDcGALmyTC8\" frameborder=\"0\" allowfullscreen></iframe></div><h2 class=\"medium-margin-bottom large-margin-top\">On-Site Portal</h2><ul class=\"with-bullets\"><li><a href=\"https://cl.ly/1A2n0v0r0208/on-site%20tutorial.pdf\">On-Site Portal Tutorial for Workers (PDF)</a></li><li><a href=\"https://docs.google.com/presentation/d/1yjmg1cXqvDEqLzceBVEKfdXHua9uGEz3Z7ziADcP_XY/edit#slide=id.g250570815b_0_0\">On-Site Portal for Maintenance Vendors (Slide Deck)</a></li></ul>");;return buf.join("");
	}

/***/ },
/* 3617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.routes.vendor_help.quality', []).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('vendor_help.quality', {
	    url: '/quality',
	    template: __webpack_require__(3618)()
	  });
	}]).name;

/***/ },
/* 3618 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<h2 class=\"large-margin-bottom\">Quality Standards</h2><p>In order to ensure the best possible for experience for Opendoor customers, we must deliver a consistent, high-quality product across all of our markets. This page and the associated documents outline the policies and standards that must be achieved when executing maintenance, repair and renovation work on Opendoor properties.</p><p class=\"text-italic medium-margin-top\">Please note that these policies and standards apply when trade partners perform the work specified. For example: trade partner quality standards for windows will not apply to work orders where no window work was performed.</p><od-collapsible-question question=\"All Projects\" class=\"border-top medium-margin-top\"></od-collapsible-question><ul class=\"with-bullets\"><li><a href=\"https://drive.google.com/file/d/1IUFeCzGFtgayKKF0aurSpKX4vUU8fj-t/view?usp=sharing\">Opendoor Trade Partner Code of Conduct (PDF)</a></li><li><a href=\"https://drive.google.com/file/d/135SAymSGKFBiQRc4XNrQ4n1elhSaWKyL/view?usp=sharing\">Opendoor Trade Partner Code of Conduct - SPANISH (PDF)</a></li><li><a href=\"https://drive.google.com/file/d/1khAAPWfvRPYBMjPcgPnLv7Rr0XnBKWkU/view?usp=sharing\">Opendoor Universal Expectations (PDF)</a></li><li><a href=\"https://drive.google.com/file/d/1eOf2kKH3wj1rMfDPhqrhnofeMNcLknGO/view?usp=sharing\">Opendoor Universal Expectations - SPANISH (PDF)</a></li><li><a href=\"https://drive.google.com/file/d/1VcT64eusQwMVN2vDvyYwGFsVyiaCTSrt/view?usp=sharing\">Opendoor On Premise Checklist (PDF)</a></li><li><a href=\"https://drive.google.com/file/d/1LkN8ek_95FHnZYxcLXkwMvioJZeZI6Sl/view?usp=sharing\">Opendoor On Premise Checklist - SPANISH (PDF)</a></li></ul><od-collapsible-question question=\"Cleaning\" class=\"border-top medium-margin-top\"></od-collapsible-question><ul class=\"with-bullets\"><li><a href=\"https://drive.google.com/file/d/1OuwfMePqOjVGY4zbkf6n_q0ByDpTfuhI/view?usp=drive_link\">Opendoor Cleaning Policy & Standard (PDF)</a></li><li><a href=\"https://drive.google.com/file/d/1aRrVLUwoR6uX83er5GV8sCEIxTTUKKXj/view?usp=sharing\">Opendoor Cleaning Policy & Standard - SPANISH (PDF)</a></li></ul><od-collapsible-question question=\"Landscaping\" class=\"border-top medium-margin-top\"></od-collapsible-question><ul class=\"with-bullets\"><li><a href=\"https://drive.google.com/file/d/1tePjpQYvmPuUOXnltvZoJoZB9JrIDlhg/view?usp=sharing\">Opendoor Landscaping Policy & Standard (PDF)</a></li><li><a href=\"https://drive.google.com/file/d/1i2Eavt7J4f2YfUBbghxCx5L1pjIx457d/view?usp=sharing\">Opendoor Landscaping Policy & Standard - SPANISH (PDF)</a></li></ul><od-collapsible-question question=\"Pools\" class=\"border-top medium-margin-top\"></od-collapsible-question><ul class=\"with-bullets\"><li><a href=\"https://drive.google.com/file/d/1x282ya_rjCZWJukFWbM6mmOhyMfDjWPw/view?usp=sharing\">Opendoor Pool Policy & Standard (PDF)</a></li><li><a href=\"https://drive.google.com/file/d/12UhJzLOwn3kLurNwrlSIpv9noAe7zXBq/view?usp=sharing\">Opendoor Pool Policy & Standard - SPANISH (PDF)</a></li></ul><od-collapsible-question question=\"Snow Removal\" class=\"border-top medium-margin-top\"></od-collapsible-question><ul class=\"with-bullets\"><li><a href=\"https://drive.google.com/file/d/117p0Cu04xywSLZpBrntT9A6duXXUMGb4/view?usp=sharing\">Opendoor Snow Removal Policy & Standard (PDF)</a></li><li><a href=\"https://drive.google.com/file/d/1zz85HqRhFpbwS5vfFgIZySmtV0pUNuu_/view?usp=sharing\">Opendoor Snow Removal Policy & Standard - SPANISH (PDF)</a></li></ul><od-collapsible-question question=\"Interior Paint\" class=\"border-top medium-margin-top\"><p><strong>Do:</strong></p><ul class=\"with-bullets\"><li>Have consistent, even coverage, no scuffs or brush marks present</li><li>Coat to cover on walls, streak and run free. Prime all dark- and/or bright- colored walls and / or when odor policy is in effect</li><li>Use semi-gloss on trim, doors, baseboards, and casings. Use eggshell for walls, and flat for ceilings</li><li>Paint prep includes:<ul class=\"with-bullets\"><li>Caulk all baseboards, trim, showers, tubs, countertops</li><li>Receptacles to be fully masked as part of prep</li><li>Knobs and switch/cover plates are removed prior to painting and reinstalled after complete</li></ul></li><li>All cut-ins sharp and clean (between colors, along ceiling, corners, baseboards and trim)</li><li>All nails, screws, drywall anchors, and brackets are removed from walls and holes are patched to match existing texture prior to painting</li><li>Trim and baseboards touched up where damaged during installation (when new carpet / flooring is installed)</li><li>Clean all switch and outlet cover plates, including removing paint</li></ul><p class=\"medium-margin-top\"><strong>Don’t:</strong></p><ul class=\"with-bullets\"><li>No overspray (e.g., no wall paint on trim, ceilings, window frames, outlets, lighting fixtures)</li><li>No painter tape left behind</li></ul><p class=\"medium-margin-top\"><strong>Touchups and Repairs</strong></p><ul class=\"with-bullets\"><li>If we are just touching up a wall, match the existing paint color.  If that’s not possible and there are many holes in a wall, paint that entire wall a complementary / similar color to neighboring walls</li><li>If we are not repainting, but just filling holes, paint over spackle with a paint color that blends in to the wall’s existing paint color</li></ul></od-collapsible-question><od-collapsible-question question=\"Flooring Installations / Replacements\"><p><strong>Transitions Protocol</strong></p><p>Transitions necessary in the following cases:</p><ul class=\"with-bullets\"><li>Carpet to linoleum</li><li>Laminate vinyl plank to other flooring types</li><li>Hardwood to other flooring types</li><li>Polished concrete to other flooring types</li></ul><p>Transitions likely not needed for the following cases:</p><ul class=\"with-bullets\"><li>Carpet to tile</li><li>Tile to tile</li></ul><p class=\"medium-margin-top\"><strong>Carpet</strong></p><ul class=\"with-bullets\"><li>Use new carpet and pad<ul class=\"with-bullets\"><li>Use existing tack strips if in good condition, though replace all tack strips if odor protocol applies</li></ul></li><li>Clean subfloor after removing carpet if needed. Secure loose or squeaky subfloors if needed.</li><li>Remove doors (after removing carpet and before installing tack strips / padding) if necessary</li><li>Re-use existing transitions if present and in good condition, install appropriate transitions if not (refer to transition protocol)</li><li>Replace closet door guides, if necessary</li><li>All carpet is stretched tightly and covers all areas of the room it is installed in</li><li>When pulling carpet from the middle of the room it should lift minimally</li><li>Carpet is vacuumed after installation</li><li>Leftover carpet rolled up neatly, left in the garage</li></ul><p class=\"medium-margin-top\"><strong>Ceramic Tile</strong></p><ul class=\"with-bullets\"><li>OK to leave baseboards before install, but there must be no gap from the baseboards to new tile. Any gap should be caulked with an appropriate color</li><li>Straight lines</li><li>Evenly laid (no high corners)</li><li>Clean grout lines, no cracks</li><li>Clean grout off all surfaces prior to drying/hardening</li><li>Touch up paint on baseboards where damaged</li><li>Transition strips between every different flooring type that are properly secured</li><li>No hollow tiles</li></ul><p class=\"medium-margin-top\"><strong>Laminate Vinyl Plank and Laminate Plank</strong></p><p>Do:</p><ul class=\"with-bullets\"><li>1/4” round installed, caulked, painted where large gaps exist at baseboards</li><li>Transitions necessary between flooring types</li><li>Straight lines</li><li>Evenly laid (no high corners)</li><li>Touch up paint on baseboards where damaged</li></ul><p>Don’t:</p><ul class=\"with-bullets\"><li>No gaps between planks</li><li>No lesser quality material used than is expressly decided upon in the scope or verbally agreed upon with a project manager</li></ul><p class=\"medium-margin-top\"><strong>Sheet Vinyl</strong></p><ul class=\"with-bullets\"><li>Straight lines</li><li>Evenly laid (no high corners), properly glued or attached to sub floor with no bubbles and no loose seams. Old vinyl should be removed, if applicable</li><li>Touch up paint on baseboards where damaged</li><li>1/4” round installed where large gaps exist at baseboards</li><li>Transition strips as appropriate (please refer to Transitions Protocol)</li><li>No gaps between planks</li></ul></od-collapsible-question><od-collapsible-question question=\"Miscellaneous\"><p><strong>Exterior Body</strong></p><ul class=\"with-bullets\"><li>All exterior openings and joints should be sealed with smooth caulk and/or mortar that is color appropriate</li><li>Rotted wood should be replaced</li><li>Remove any peeling or flaking paint, and paint any exposed wood to match surrounding paint</li><li>All exterior paint should have an even coat</li><li>All exterior surfaces should be clear of dirt, rust, and / or organic growth stains li pressure wash if necessary</li><li>No overspray on brick, roof, or windows</li></ul><p class=\"medium-margin-top\"><strong>Windows</strong></p><ul class=\"with-bullets\"><li>Windows should be aligned, easily opened and closed, and easy to latch and lock</li><li>All curtains and small or metal blinds should be removed</li></ul><p class=\"medium-margin-top\"><strong>Outlets</strong></p><ul class=\"with-bullets\"><li>Coverplates should sit flush against walls</li></ul></od-collapsible-question><od-collapsible-question question=\"Specialist Work\"><p><strong>Pool & Equipment (Pumps, heaters, plaster)</strong></p><ul class=\"with-bullets\"><li>All pumps and heaters should be functional</li><li>Filters should be clean (initial service)</li><li>Plaster clean and free of cracks that would lead to leakage</li><li>Pool should be clean (not green) and free of all debris</li><li>Timers and electrical should be functioning as intended</li><li>Complete with no leaks and plumbing is working properly with correct bonding materials</li><li>All wires should be secure and run in a neat manner, pumps and filters should be on a concrete pad and secured to the pad</li></ul><p class=\"medium-margin-top\"><strong>Roof Work</strong></p><ul class=\"with-bullets\"><li>Photos of the following:</li><ul class=\"with-bullets\"><li>Before, while working, and after photos of repairs and replacements, at the same angle</li><li>Photos of each slope, all flashings and boots, drip edge</li><li>In addition the the above, full roof replacement should provide photos of new soft metals</li><li>Overall photos, close up of repaired areas, and eagle eye / aerial view</li><li>Provide multiple pictures of shingle quality and all roof components (including boots, chimney, and any crickets)</li></ul></ul><p class=\"medium-margin-top\"><strong>HVAC</strong></p><ul class=\"with-bullets\"><li>Photos of the following:</li><ul class=\"with-bullets\"><li>Before / after for all replaced equipment</li><li>Pressure readings</li><li>Temperature gun for temperature differentials </li><li>Clean filters</li><li>Manufacture labels, inside of furnace, heat pump, and condenser</li></ul></ul><p class=\"medium-margin-top\"><strong>Foundation Repair</strong></p><ul class=\"with-bullets\"><li>Breakouts should be poured back flush with adjacent concrete, using the same finish</li><li>Pass on hydrostatic test results post lift</li><li>Final engineering report from foundation vendor</li><li>Foundation warranty</li><li>Photos of all tunnel repairs and interior breakouts</li><li>Post foundation lift measurements with engineer stamp</li></ul><p class=\"medium-margin-top\"><strong>Plumbing Repair</strong></p><ul class=\"with-bullets\"><li>Must pass hydro / pressure tests</li><li>Clean job site after work is done</li><li>Photos of running water and no leaks present</li><li>Before / after photos of each work order item</li><li>Photos of new fixtures where applicable (e.g., washer box and refrigerator line replacement)</li></ul></od-collapsible-question>");;return buf.join("");
	}

/***/ },
/* 3619 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"route-vendor-help\"> <div ng-show=\"vendor_help.showVendorHelpModal\" class=\"modal\"><div class=\"modal-dialog\"><div class=\"modal-dialog-header\"><h5>Submit a question or issue</h5></div><div class=\"modal-dialog-body\"><div class=\"form-group\"><h6 class=\"small-margin-bottom\">Issue or question</h6><textarea ng-model=\"vendor_help.question.question\" placeholder=\"Please be specific and descriptive about the issue you are having\" rows=\"10\"></textarea><div class=\"row medium-margin-top\"><div class=\"col-xs-12 col-md-6 small-margin-top\"><h6 class=\"small-margin-bottom\">Contact email </h6><input ng-model=\"vendor_help.question.email\"></div><div class=\"col-xs-12 col-md-6 small-margin-top\"><h6 class=\"small-margin-bottom\">Metro area you operate in</h6><select ng-model=\"vendor_help.question.market\" ng-options=\"market as (market | pretty | titlecase) for market in vendor_help.markets\" style=\"width: 100%\"><option value=\"\" disabled selected>Select market...</option></select></div><div class=\"col-xs-12 small-margin-top\"><h6 class=\"small-margin-bottom\">URL of page (optional)</h6><input ng-model=\"vendor_help.question.url\"></div></div><div class=\"modal-dialog-footer\"><button ng-click=\"vendor_help.showVendorHelpModal = false\" class=\"button default\">Cancel</button><button ng-click=\"vendor_help.sendVendorQuestion()\" class=\"button primary\">Submit</button></div></div></div></div></div><section class=\"hero text-center padded\"><div class=\"regular-container\"><h1 class=\"text-white\">Trade Partner Help Center</h1><button ng-click=\"vendor_help.openVendorHelpModal()\" class=\"button primary medium-margin-top\">Contact Us</button></div></section><section class=\"nav-section\"><div class=\"regular-container\"><ul class=\"nav-tabs\"><li ui-sref=\".prospective\" ui-sref-active=\"active\" class=\"tab\"><h6>Prospective Trade Partners</h6></li><li ui-sref=\".current\" ui-sref-active=\"active\" class=\"tab\"><h6>Current Trade Partners</h6></li><li ui-sref=\".media\" ui-sref-active=\"active\" class=\"tab\"><h6>All Media</h6></li><li ui-sref=\".quality\" ui-sref-active=\"active\" class=\"tab\"><h6>Quality Standards</h6></li></ul></div></section><section><div class=\"regular-container\"><ui-view></ui-view></div></section></div>");;return buf.join("");
	}

/***/ },
/* 3620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('market.routes.static.verify', [__webpack_require__(600)]).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('verify', {
	    parent: 'root',
	    url: '/verify?code&exp',
	    template: __webpack_require__(3621)(),
	    data: {
	      meta: {
	        titleSuffix: ' | Verify Your Phone Number'
	      }
	    },
	    controllerAs: 'verifyCtrl',
	    controller: ["$stateParams", function controller($stateParams) {
	      _classCallCheck(this, controller);
	
	      var now = new Date().getTime() / 1000;
	      this.confirmationCode = $stateParams.code;
	      this.isExpired = now > $stateParams.exp;
	    }]
	  });
	}]).name;

/***/ },
/* 3621 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<section class=\"text-center-xs-down\"><div class=\"regular-container\"><div ng-switch=\"::verifyCtrl.isExpired\"><span ng-switch-when=\"true\">Your confirmation code has expired. Please re-submit your information in the Opendoor app.</span><span ng-switch-default>Your confirmation code is<b> {{::verifyCtrl.confirmationCode}}</b>. Please enter it into the Opendoor app.</span></div></div></section>");;return buf.join("");
	}

/***/ },
/* 3622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.services', [__webpack_require__(3623), __webpack_require__(3624), __webpack_require__(3625), __webpack_require__(3627), __webpack_require__(3628)]).name;

/***/ },
/* 3623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _momentTimezone = __webpack_require__(517);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FINANCING_OPTIONS = [{
	  label: 'Cash',
	  value: 'cash'
	}, {
	  label: 'Loan',
	  value: 'loan',
	  default: true
	}];
	
	var AGENT_STATUS_OPTIONS = [{
	  label: 'Yes',
	  value: 'yes'
	}, {
	  label: 'No',
	  value: 'no',
	  default: true
	}, {
	  label: "I'm an agent",
	  value: 'agent'
	}];
	
	var CheckoutManager = function () {
	  // NOT injectable - params are passed via the checkoutManager factory
	  function CheckoutManager(rootScope, localStorageService, weekdayWorkCalendar, RESERVATION_PRICE_CENTS) {
	    var _this = this;
	
	    _classCallCheck(this, CheckoutManager);
	
	    this.weekdayWorkCalendar = weekdayWorkCalendar;
	    this.localStorageService = localStorageService;
	    this.RESERVATION_PRICE_CENTS = RESERVATION_PRICE_CENTS;
	
	    this.FINANCING_OPTIONS = FINANCING_OPTIONS;
	    this.AGENT_STATUS_OPTIONS = AGENT_STATUS_OPTIONS;
	
	    this.listing = null;
	    this.totalPriceCents = null;
	
	    this.options = this._loadOptionsFromLocalStorage();
	    this._saveOptionsToLocalStorage();
	
	    // Deep watch options, so no matter where they are changed, the checkout
	    // data and price stay up to date
	    rootScope.$watch(function () {
	      return _this.options;
	    }, function () {
	      _this._saveOptionsToLocalStorage();
	      _this._updateTotalPrice();
	    }, true);
	  }
	
	  _createClass(CheckoutManager, [{
	    key: 'setListing',
	    value: function setListing(listing) {
	      this.listing = listing;
	      this.localStorageService.set('CheckoutManager.listing', this.options);
	      this._updateTotalPrice();
	    }
	  }, {
	    key: '_loadOptionsFromLocalStorage',
	    value: function _loadOptionsFromLocalStorage() {
	      var lsOptions = this.localStorageService.get('CheckoutManager.options') || {};
	      return {
	        financing_type: (0, _lodash.find)(FINANCING_OPTIONS, { value: (0, _lodash.get)(lsOptions, ['financing', 'value']) }) || (0, _lodash.find)(FINANCING_OPTIONS, 'default'),
	        agent_status: (0, _lodash.find)(AGENT_STATUS_OPTIONS, { value: (0, _lodash.get)(lsOptions, ['agent', 'value']) }) || (0, _lodash.find)(AGENT_STATUS_OPTIONS, 'default'),
	        agent_name: lsOptions.agent_name || '',
	        client_name: lsOptions.client_name || ''
	      };
	    }
	  }, {
	    key: '_saveOptionsToLocalStorage',
	    value: function _saveOptionsToLocalStorage() {
	      this.localStorageService.set('CheckoutManager.options', this.options);
	    }
	  }, {
	    key: '_futureWorkday',
	    value: function _futureWorkday(days) {
	      return this.weekdayWorkCalendar.workdaysAfter((0, _momentTimezone2.default)(), days);
	    }
	  }, {
	    key: '_updateTotalPrice',
	    value: function _updateTotalPrice() {
	      this.totalPriceCents = this.listing.price_cents + (0, _lodash.reduce)(this.options, function (acc, option) {
	        return acc + (option.priceCents || 0);
	      }, 0);
	    }
	  }]);
	
	  return CheckoutManager;
	}();
	
	module.exports = _angular2.default.module('common.services.checkout-manager', []).factory('checkoutManager', ["$rootScope", "localStorageService", "weekdayWorkCalendar", "RESERVATION_PRICE_CENTS", function ($rootScope, localStorageService, weekdayWorkCalendar, RESERVATION_PRICE_CENTS) {
	  return new CheckoutManager($rootScope, localStorageService, weekdayWorkCalendar, RESERVATION_PRICE_CENTS);
	}]).name;

/***/ },
/* 3624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global FB:false */
	module.exports = _angular2.default.module('market.services.facebook', []).factory('Facebook', ["FacebookAppId", "$q", function (FacebookAppId, $q) {
	  window.fbAsyncInit = function () {
	    FB.init({
	      appId: FacebookAppId,
	      xfbml: true,
	      version: 'v2.5'
	    });
	  };
	
	  (function (d, s, id) {
	    var js,
	        fjs = d.getElementsByTagName(s)[0];
	    if (d.getElementById(id)) {
	      return;
	    }
	    js = d.createElement(s);js.id = id;
	    js.src = "//connect.facebook.net/en_US/sdk.js";
	    fjs.parentNode.insertBefore(js, fjs);
	  })(document, 'script', 'facebook-jssdk');
	
	  return {
	    // Available sharing options:
	    // {
	    //   href
	    //   title (html page title)
	    //   description
	    //   picture (url)
	    //   caption (short url)
	    // }
	    share: function share(sharingOptions) {
	      var deferred = $q.defer();
	      FB.ui((0, _lodash.merge)({ method: 'share' }, sharingOptions), function (response) {
	        return deferred.resolve(response);
	      });
	      return deferred.promise;
	    }
	  };
	}]).name;

/***/ },
/* 3625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = _angular2.default.module('common.services.login-modal', [__webpack_require__(975)]).factory('loginSignupModal', ["$uibModal", "$rootScope", "$timeout", function ($uibModal, $rootScope, $timeout) {
	  return {
	    show: function show(_signupType, _tab) {
	      if ($rootScope.session.human) {
	        // the $location.search update in market.js was failing inconsistently in this logged-in
	        // shortcut case. Returning a 0s timeout promise fixes it (maybe giving angular a chance
	        // to catch up between updating the human and triggering the location change?)
	        // Not really sure.
	        return $timeout();
	      }
	
	      var instance = $uibModal.open({
	        template: __webpack_require__(3626)(),
	        controller: 'login_modal',
	        controllerAs: 'login_modal',
	        resolve: {
	          tab: function tab() {
	            return _tab;
	          },
	          signupType: function signupType() {
	            return _signupType;
	          }
	        }
	      });
	
	      return instance.result;
	    }
	  };
	}]).controller('login_modal', function () {
	  _class.$inject = ["$rootScope", "$window", "Human", "Session", "Analytics", "$uibModalInstance", "$timeout", "tab", "signupType"];
	  function _class($rootScope, $window, Human, Session, Analytics, $uibModalInstance, $timeout, tab, signupType) {
	    _classCallCheck(this, _class);
	
	    this.$rootScope = $rootScope;
	    this.$window = $window;
	    this.Human = Human;
	    this.Session = Session;
	    this.errors = {};
	    this.loginError = false;
	    this.session = this.$rootScope.session;
	    this.signupType = signupType;
	    this.Analytics = Analytics;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$timeout = $timeout;
	
	    this.password = '';
	    this.pending = false;
	
	    this.$rootScope.inloginSignupModal = true;
	
	    this.showTab(tab || 'signup');
	  }
	
	  _createClass(_class, [{
	    key: 'showTab',
	    value: function showTab(tab_name) {
	      this.tab = tab_name;
	      this.$timeout(function () {
	        // focus first form input
	        document.querySelector('#' + tab_name + '-modal-form input').select();
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$rootScope.inloginSignupModal = false;
	      this.$uibModalInstance.dismiss();
	    }
	  }, {
	    key: 'signup',
	    value: function signup() {
	      var _this = this;
	
	      this.pending = true;
	      var newHuman = new this.Human({
	        signup_type: this.signupType,
	        full_name: this.fullName,
	        email: this.email,
	        primary_phone: this.phoneNumber,
	        password: this.password
	      });
	      newHuman.$register().then(function () {
	        _this.Analytics.event('signup', 'submit', 'signup-success');
	        _this.pending = false;
	        // Fetch the latest login information
	        return _this.session.$me();
	      }).then(function () {
	        _this.$rootScope.inloginSignupModal = false;
	        _this.$uibModalInstance.close();
	      }).catch(function (e) {
	        _this.Analytics.event('signup', 'submit', 'signup-error');
	        _this.pending = false;
	        _this.errors = e.data.errors;
	      });
	    }
	  }, {
	    key: 'login',
	    value: function login() {
	      var _this2 = this;
	
	      this.pending = true;
	      var human = new this.Human({
	        email: this.email,
	        password: this.password
	      });
	      var newSession = new this.Session({
	        human: human
	      });
	      newSession.$login().then(function () {
	        _this2.pending = false;
	        // Fetch the latest login information
	        return _this2.session.$me();
	      }).then(function () {
	        _this2.$rootScope.inloginSignupModal = false;
	        _this2.$uibModalInstance.close();
	      }).catch(function () {
	        _this2.pending = false;
	        _this2.loginError = true;
	      });
	    }
	  }]);
	
	  return _class;
	}()).name;

/***/ },
/* 3626 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(439);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	buf.push("<div class=\"modal\"><div ng-show=\"login_modal.tab === &quot;signup&quot;\" class=\"modal-dialog\"><form id=\"signup-modal-form\" name=\"signupForm\" ng-submit=\"login_modal.signup()\"><div class=\"modal-dialog-header\"><h5>Sign up for Opendoor</h5><div ng-click=\"login_modal.cancel()\" class=\"modal-close-button\"><icon name=\"ei-close\" width=\"15px\"></icon></div></div><div class=\"modal-dialog-body\"><div class=\"row\"><div class=\"form-block col-md-6 col-xs-12\"><div class=\"modal-label\">Full Name</div><input type=\"text\" ng-model=\"login_modal.fullName\" ng-disabled=\"login_modal.pending\" required class=\"modal-input\"></div><div class=\"form-block col-md-6 col-xs-12\"><div class=\"modal-label\">Phone number</div><input type=\"tel\" ng-model=\"login_modal.phoneNumber\" ng-disabled=\"login_modal.pending\" required class=\"modal-input\"><p ng-show=\"login_modal.errors.primary_phone\" class=\"text-red\">Phone {{login_modal.errors.primary_phone[0]}}</p></div></div><div class=\"row\"><div class=\"form-block col-md-6 col-xs-12\"><div class=\"modal-label\">Email</div><input type=\"text\" ng-model=\"login_modal.email\" ng-disabled=\"login_modal.pending\" required class=\"modal-input\"><p ng-show=\"login_modal.errors.email\" class=\"text-red\">Email {{login_modal.errors.email[0]}}</p></div><div class=\"form-block col-md-6 col-xs-12\"><div class=\"modal-label\">Password</div><input type=\"password\" ng-model=\"login_modal.password\" ng-disabled=\"login_modal.pending\" required class=\"modal-input\"><p ng-show=\"login_modal.errors.password\" class=\"text-red\">Password {{login_modal.errors.password[0]}}</p></div></div></div><div class=\"modal-dialog-footer\"><div class=\"row\"><div class=\"col-md-6 col-xs-6 login-link\">Already have an account?&nbsp;<a href=\"#\" ng-click=\"login_modal.showTab(&quot;login&quot;)\">Sign in</a></div><div class=\"col-md-6 col-xs-6 text-right\"><div class=\"button-group\"><button type=\"button\" ng-click=\"login_modal.cancel()\" class=\"button secondary\">Cancel</button><button type=\"submit\" ng-disabled=\"signupForm.$invalid || login_modal.pending\" ng-class=\"{ 'is-loading': login_modal.pending }\" class=\"button primary\">Sign up</button></div></div></div></div></form></div><div ng-show=\"login_modal.tab === &quot;login&quot;\" class=\"modal-dialog\"><form id=\"login-modal-form\" name=\"loginForm\" ng-submit=\"login_modal.login()\"><div class=\"modal-dialog-header\"><h5>Sign in</h5><div ng-click=\"login_modal.cancel()\" class=\"modal-close-button\"><icon name=\"ei-close\" width=\"15px\"></icon></div></div><div class=\"modal-dialog-body\"><div class=\"row\"><div class=\"form-block col-md-6 col-xs-12\"><p>Email</p><input type=\"text\" ng-model=\"login_modal.email\" ng-disabled=\"login_modal.pending\" required><p ng-show=\"login_modal.loginError\" class=\"text-red\">Invalid credentials</p></div><div class=\"form-block col-md-6 col-xs-12\"><p>Password</p><input type=\"password\" ng-model=\"login_modal.password\" ng-disabled=\"login_modal.pending\" required></div></div></div><div class=\"modal-dialog-footer\"><div class=\"row\"><div class=\"col-md-6 col-xs-6 login-link\"><p>Don't have an account?&nbsp;<a href=\"#\" ng-click=\"login_modal.showTab(&quot;signup&quot;)\">Sign up</a></p></div><div class=\"col-md-6 col-xs-6\"><div class=\"button-group\"><button type=\"button\" ng-click=\"login_modal.cancel()\" class=\"button secondary\">Cancel</button><button type=\"submit\" ng-disabled=\"loginForm.$invalid || login_modal.pending\" ng-class=\"{ 'is-loading': login_modal.pending }\" class=\"button primary\">Sign in</button></div></div></div></div></form></div></div>");;return buf.join("");
	}

/***/ },
/* 3627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAX_FLOORS = 3;
	
	// Helper method to translate Dwellings' pool field to the seller input options.
	// For now we have to check for both Private and true until we port the pool
	// field to true / false only.
	function translatePool(pool) {
	  if (pool === 'Private' || pool === true) return 'in_ground';
	  if (pool === 'None' || pool === false) return 'none';
	}
	
	module.exports = _angular2.default.module('market.services.mls-parser', []).factory('MLSParser', function () {
	  return {
	    makePrefills: function makePrefills(rawMlsInfo) {
	      if (!rawMlsInfo) return {};
	      var makeMlsPrefill = function makeMlsPrefill(value) {
	        return value && { value: value, source: 'MLS' };
	      };
	
	      var castInt = function castInt(value) {
	        return parseInt(value, 10) || null;
	      };
	      var castFloat = function castFloat(value) {
	        return parseFloat(value, 10) || null;
	      };
	
	      var floors = castInt(rawMlsInfo.exterior_stories);
	      return (0, _lodash.pickBy)((0, _lodash.mapValues)({
	        'home.bathrooms': castFloat(rawMlsInfo.bathrooms),
	        'home.bedrooms': castInt(rawMlsInfo.bedrooms),
	        'home.exterior_stories': floors <= MAX_FLOORS ? floors : null,
	        'home.garage_spaces': castInt(rawMlsInfo.garage_spaces),
	        'home.pool_type': translatePool(rawMlsInfo.pool),
	        'home.above_grade_sq_ft': castInt(rawMlsInfo.sq_ft),
	        'home.year_built': castInt(rawMlsInfo.year_built)
	      }, makeMlsPrefill));
	    }
	  };
	}).name;

/***/ },
/* 3628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(263);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _angular2.default.module('market.services.unprocessable-entity-modal', []).factory('UnprocessableEntityModal', ["$q", "$rootScope", function ($q, $rootScope) {
	  return {
	    responseError: function responseError(rejection) {
	      if (rejection.status === 422) {
	        var url = '/customers/' + rejection.config.data.token;
	        $rootScope.modal('There was an error saving your progress. ' + 'Please <a href="' + url + '" target="_self">reload the page</a>.');
	      }
	      return $q.reject(rejection);
	    }
	  };
	}]).name;

/***/ }
]);


/** WEBPACK FOOTER **
 ** market.js
 **/